/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 35130:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(19601);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
module.exports = desvg;

/**
 * @name desvg
 * @summary Generate component using passed svg-loader output.
 *
 * @description
 * Generate component using passed svg-loader output.
 *
 * @param {Function} h
 * The helper function (e.g. `React.createElement` or Preact's `h`).
 *
 * @param {Object} svg
 * The svg-loader output.
 *
 * @returns {Object}
 * The generated component.
 *
 * @example
 * import { createElement } from 'react'
 * import svgContent from './icon.svg'
 * import desvg from 'desvg'
 *
 * // Basic usage
 * const Icon = desvg(createElement, svgContent)
 * <Icon fill='currentColor' />
 * //=> <svg fill='currentColor' ...>...</svg>
 */
function desvg(h, svg) {
  var content = svg.content;
  var attributes = svg.attributes;
  return /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);
    }
    _createClass(_class, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate() {
        return false;
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props;
        return h('svg', Object.assign({
          dangerouslySetInnerHTML: {
            __html: content
          }
        }, attributes, props), props && props.children);
      }
    }]);
    return _class;
  }();
}

/***/ }),

/***/ 5813:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var desvg = __webpack_require__(35130);
var h = __webpack_require__(79758).h;
module.exports = desvg.bind(null, h);

/***/ }),

/***/ 49190:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_Ts": () => (/* reexport default from dynamic */ _images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178___default.a)
/* harmony export */ });
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
/* harmony import */ var _images_icons_checkbox_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98892);
/* harmony import */ var _images_icons_checkbox_svg__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_images_icons_checkbox_svg__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _images_icons_list_number_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47238);
/* harmony import */ var _images_icons_list_number_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_number_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _images_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95161);
/* harmony import */ var _images_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_bullet_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _images_icons_table_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20913);
/* harmony import */ var _images_icons_table_svg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_images_icons_table_svg__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _images_icons_smile_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37620);
/* harmony import */ var _images_icons_smile_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_images_icons_smile_svg__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _images_icons_image_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50375);
/* harmony import */ var _images_icons_image_svg__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_images_icons_image_svg__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _images_icons_empty_image_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80648);
/* harmony import */ var _images_icons_empty_image_svg__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_images_icons_empty_image_svg__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _images_icons_file_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7086);
/* harmony import */ var _images_icons_file_svg__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_svg__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _images_icons_pin_btn_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4421);
/* harmony import */ var _images_icons_pin_btn_svg__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pin_btn_svg__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _images_icons_header_small_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70191);
/* harmony import */ var _images_icons_header_small_svg__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_images_icons_header_small_svg__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _images_icons_header_medium_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41701);
/* harmony import */ var _images_icons_header_medium_svg__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_images_icons_header_medium_svg__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _images_icons_header_large_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1305);
/* harmony import */ var _images_icons_header_large_svg__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_images_icons_header_large_svg__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _images_icons_hline_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(28444);
/* harmony import */ var _images_icons_hline_svg__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_images_icons_hline_svg__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _images_icons_link_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60623);
/* harmony import */ var _images_icons_link_svg__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_images_icons_link_svg__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(36520);
/* harmony import */ var _images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_images_icons_plus_svg__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31958);
/* harmony import */ var _images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_images_icons_minus_svg__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _images_icons_bold_svg__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69425);
/* harmony import */ var _images_icons_bold_svg__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_images_icons_bold_svg__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _images_icons_italic_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(34061);
/* harmony import */ var _images_icons_italic_svg__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_images_icons_italic_svg__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _images_icons_underline_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(78555);
/* harmony import */ var _images_icons_underline_svg__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_images_icons_underline_svg__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _images_icons_strikethrough_svg__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(27501);
/* harmony import */ var _images_icons_strikethrough_svg__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_images_icons_strikethrough_svg__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _images_icons_highlight_svg__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(81740);
/* harmony import */ var _images_icons_highlight_svg__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_images_icons_highlight_svg__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _images_icons_trash_svg__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(77242);
/* harmony import */ var _images_icons_trash_svg__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_images_icons_trash_svg__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _images_icons_edit_svg__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(13783);
/* harmony import */ var _images_icons_edit_svg__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_images_icons_edit_svg__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _images_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(61177);
/* harmony import */ var _images_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(83675);
/* harmony import */ var _images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _images_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(19379);
/* harmony import */ var _images_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _images_icons_paragraph_svg__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(36419);
/* harmony import */ var _images_icons_paragraph_svg__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_images_icons_paragraph_svg__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _images_icons_no_color_svg__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(42477);
/* harmony import */ var _images_icons_no_color_svg__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_images_icons_no_color_svg__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _images_icons_no_color_light_svg__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(99562);
/* harmony import */ var _images_icons_no_color_light_svg__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_images_icons_no_color_light_svg__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _images_icons_no_color_dark_svg__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(36771);
/* harmony import */ var _images_icons_no_color_dark_svg__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_images_icons_no_color_dark_svg__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _images_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(35596);
/* harmony import */ var _images_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_left_svg__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _images_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(87163);
/* harmony import */ var _images_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_center_svg__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _images_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(4802);
/* harmony import */ var _images_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_right_svg__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _images_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(36842);
/* harmony import */ var _images_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_images_icons_align_justify_svg__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _images_icons_valign_top_svg__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(10226);
/* harmony import */ var _images_icons_valign_top_svg__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_images_icons_valign_top_svg__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _images_icons_valign_center_svg__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(52725);
/* harmony import */ var _images_icons_valign_center_svg__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_images_icons_valign_center_svg__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _images_icons_valign_bottom_svg__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(59146);
/* harmony import */ var _images_icons_valign_bottom_svg__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_images_icons_valign_bottom_svg__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _images_icons_indent_svg__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(11894);
/* harmony import */ var _images_icons_indent_svg__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_images_icons_indent_svg__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _images_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(7306);
/* harmony import */ var _images_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_images_icons_outdent_svg__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _images_icons_clear_formatting_svg__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(57872);
/* harmony import */ var _images_icons_clear_formatting_svg__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_images_icons_clear_formatting_svg__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _images_icons_list_circle_svg__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(30350);
/* harmony import */ var _images_icons_list_circle_svg__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_circle_svg__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _images_icons_list_rectangle_svg__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(56987);
/* harmony import */ var _images_icons_list_rectangle_svg__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_rectangle_svg__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _images_icons_list_star_svg__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(60965);
/* harmony import */ var _images_icons_list_star_svg__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_star_svg__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _images_icons_list_dart_svg__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(35235);
/* harmony import */ var _images_icons_list_dart_svg__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_dart_svg__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _images_icons_list_rounded_svg__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(74107);
/* harmony import */ var _images_icons_list_rounded_svg__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_rounded_svg__WEBPACK_IMPORTED_MODULE_45__);
/* harmony import */ var _images_icons_list_arrow_svg__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(12479);
/* harmony import */ var _images_icons_list_arrow_svg__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_arrow_svg__WEBPACK_IMPORTED_MODULE_46__);
/* harmony import */ var _images_icons_list_diamond_svg__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(59481);
/* harmony import */ var _images_icons_list_diamond_svg__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_diamond_svg__WEBPACK_IMPORTED_MODULE_47__);
/* harmony import */ var _images_icons_embed_align_left_svg__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(54970);
/* harmony import */ var _images_icons_embed_align_left_svg__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_left_svg__WEBPACK_IMPORTED_MODULE_48__);
/* harmony import */ var _images_icons_embed_align_center_svg__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(55782);
/* harmony import */ var _images_icons_embed_align_center_svg__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_center_svg__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var _images_icons_embed_align_right_svg__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(51093);
/* harmony import */ var _images_icons_embed_align_right_svg__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_right_svg__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var _images_icons_embed_align_fullwidth_svg__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(47529);
/* harmony import */ var _images_icons_embed_align_fullwidth_svg__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_align_fullwidth_svg__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var _images_icons_add_row_svg__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(30245);
/* harmony import */ var _images_icons_add_row_svg__WEBPACK_IMPORTED_MODULE_52___default = /*#__PURE__*/__webpack_require__.n(_images_icons_add_row_svg__WEBPACK_IMPORTED_MODULE_52__);
/* harmony import */ var _images_icons_add_column_svg__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(22032);
/* harmony import */ var _images_icons_add_column_svg__WEBPACK_IMPORTED_MODULE_53___default = /*#__PURE__*/__webpack_require__.n(_images_icons_add_column_svg__WEBPACK_IMPORTED_MODULE_53__);
/* harmony import */ var _images_icons_resize_svg__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(91323);
/* harmony import */ var _images_icons_resize_svg__WEBPACK_IMPORTED_MODULE_54___default = /*#__PURE__*/__webpack_require__.n(_images_icons_resize_svg__WEBPACK_IMPORTED_MODULE_54__);
/* harmony import */ var _images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(66995);
/* harmony import */ var _images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_close_svg__WEBPACK_IMPORTED_MODULE_55__);
/* harmony import */ var _images_icons_quote_svg__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(67308);
/* harmony import */ var _images_icons_quote_svg__WEBPACK_IMPORTED_MODULE_56___default = /*#__PURE__*/__webpack_require__.n(_images_icons_quote_svg__WEBPACK_IMPORTED_MODULE_56__);
/* harmony import */ var _images_icons_audio_svg__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(4817);
/* harmony import */ var _images_icons_audio_svg__WEBPACK_IMPORTED_MODULE_57___default = /*#__PURE__*/__webpack_require__.n(_images_icons_audio_svg__WEBPACK_IMPORTED_MODULE_57__);
/* harmony import */ var _images_icons_document_svg__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(41286);
/* harmony import */ var _images_icons_document_svg__WEBPACK_IMPORTED_MODULE_58___default = /*#__PURE__*/__webpack_require__.n(_images_icons_document_svg__WEBPACK_IMPORTED_MODULE_58__);
/* harmony import */ var _images_icons_image2_svg__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(93034);
/* harmony import */ var _images_icons_image2_svg__WEBPACK_IMPORTED_MODULE_59___default = /*#__PURE__*/__webpack_require__.n(_images_icons_image2_svg__WEBPACK_IMPORTED_MODULE_59__);
/* harmony import */ var _images_icons_video_svg__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(22220);
/* harmony import */ var _images_icons_video_svg__WEBPACK_IMPORTED_MODULE_60___default = /*#__PURE__*/__webpack_require__.n(_images_icons_video_svg__WEBPACK_IMPORTED_MODULE_60__);
/* harmony import */ var _images_icons_more_vertical_svg__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(46605);
/* harmony import */ var _images_icons_more_vertical_svg__WEBPACK_IMPORTED_MODULE_61___default = /*#__PURE__*/__webpack_require__.n(_images_icons_more_vertical_svg__WEBPACK_IMPORTED_MODULE_61__);
/* harmony import */ var _images_icons_file_other_svg__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(51392);
/* harmony import */ var _images_icons_file_other_svg__WEBPACK_IMPORTED_MODULE_62___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_other_svg__WEBPACK_IMPORTED_MODULE_62__);
/* harmony import */ var _images_icons_code_format_svg__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(47778);
/* harmony import */ var _images_icons_code_format_svg__WEBPACK_IMPORTED_MODULE_63___default = /*#__PURE__*/__webpack_require__.n(_images_icons_code_format_svg__WEBPACK_IMPORTED_MODULE_63__);
/* harmony import */ var _images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(47904);
/* harmony import */ var _images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64___default = /*#__PURE__*/__webpack_require__.n(_images_icons_chevron_left_svg__WEBPACK_IMPORTED_MODULE_64__);
/* harmony import */ var _images_icons_chevron_right_svg__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(16186);
/* harmony import */ var _images_icons_chevron_right_svg__WEBPACK_IMPORTED_MODULE_65___default = /*#__PURE__*/__webpack_require__.n(_images_icons_chevron_right_svg__WEBPACK_IMPORTED_MODULE_65__);
/* harmony import */ var _images_icons_search2_svg__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(26350);
/* harmony import */ var _images_icons_search2_svg__WEBPACK_IMPORTED_MODULE_66___default = /*#__PURE__*/__webpack_require__.n(_images_icons_search2_svg__WEBPACK_IMPORTED_MODULE_66__);
/* harmony import */ var _images_icons_maximize_svg__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(29828);
/* harmony import */ var _images_icons_maximize_svg__WEBPACK_IMPORTED_MODULE_67___default = /*#__PURE__*/__webpack_require__.n(_images_icons_maximize_svg__WEBPACK_IMPORTED_MODULE_67__);
/* harmony import */ var _images_icons_minimize_svg__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(63821);
/* harmony import */ var _images_icons_minimize_svg__WEBPACK_IMPORTED_MODULE_68___default = /*#__PURE__*/__webpack_require__.n(_images_icons_minimize_svg__WEBPACK_IMPORTED_MODULE_68__);
/* harmony import */ var _images_icons_pause_svg__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(26143);
/* harmony import */ var _images_icons_pause_svg__WEBPACK_IMPORTED_MODULE_69___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pause_svg__WEBPACK_IMPORTED_MODULE_69__);
/* harmony import */ var _images_icons_play_svg__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(1250);
/* harmony import */ var _images_icons_play_svg__WEBPACK_IMPORTED_MODULE_70___default = /*#__PURE__*/__webpack_require__.n(_images_icons_play_svg__WEBPACK_IMPORTED_MODULE_70__);
/* harmony import */ var _images_icons_audioRec_svg__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(69710);
/* harmony import */ var _images_icons_audioRec_svg__WEBPACK_IMPORTED_MODULE_71___default = /*#__PURE__*/__webpack_require__.n(_images_icons_audioRec_svg__WEBPACK_IMPORTED_MODULE_71__);
/* harmony import */ var _images_icons_videoRec_svg__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(27237);
/* harmony import */ var _images_icons_videoRec_svg__WEBPACK_IMPORTED_MODULE_72___default = /*#__PURE__*/__webpack_require__.n(_images_icons_videoRec_svg__WEBPACK_IMPORTED_MODULE_72__);
/* harmony import */ var _images_icons_pause_big_svg__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(46015);
/* harmony import */ var _images_icons_pause_big_svg__WEBPACK_IMPORTED_MODULE_73___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pause_big_svg__WEBPACK_IMPORTED_MODULE_73__);
/* harmony import */ var _images_icons_play_big_svg__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(69499);
/* harmony import */ var _images_icons_play_big_svg__WEBPACK_IMPORTED_MODULE_74___default = /*#__PURE__*/__webpack_require__.n(_images_icons_play_big_svg__WEBPACK_IMPORTED_MODULE_74__);
/* harmony import */ var _images_icons_volume_1_svg__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(4311);
/* harmony import */ var _images_icons_volume_1_svg__WEBPACK_IMPORTED_MODULE_75___default = /*#__PURE__*/__webpack_require__.n(_images_icons_volume_1_svg__WEBPACK_IMPORTED_MODULE_75__);
/* harmony import */ var _images_icons_volume_2_svg__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(84005);
/* harmony import */ var _images_icons_volume_2_svg__WEBPACK_IMPORTED_MODULE_76___default = /*#__PURE__*/__webpack_require__.n(_images_icons_volume_2_svg__WEBPACK_IMPORTED_MODULE_76__);
/* harmony import */ var _images_icons_volume_x_svg__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(80347);
/* harmony import */ var _images_icons_volume_x_svg__WEBPACK_IMPORTED_MODULE_77___default = /*#__PURE__*/__webpack_require__.n(_images_icons_volume_x_svg__WEBPACK_IMPORTED_MODULE_77__);
/* harmony import */ var _images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(91177);
/* harmony import */ var _images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78___default = /*#__PURE__*/__webpack_require__.n(_images_icons_done_color_svg__WEBPACK_IMPORTED_MODULE_78__);
/* harmony import */ var _images_icons_type_checkbox_svg__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(64631);
/* harmony import */ var _images_icons_type_checkbox_svg__WEBPACK_IMPORTED_MODULE_79___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_checkbox_svg__WEBPACK_IMPORTED_MODULE_79__);
/* harmony import */ var _images_icons_type_currency_svg__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(325);
/* harmony import */ var _images_icons_type_currency_svg__WEBPACK_IMPORTED_MODULE_80___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_currency_svg__WEBPACK_IMPORTED_MODULE_80__);
/* harmony import */ var _images_icons_type_multiselect_svg__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(12154);
/* harmony import */ var _images_icons_type_multiselect_svg__WEBPACK_IMPORTED_MODULE_81___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_multiselect_svg__WEBPACK_IMPORTED_MODULE_81__);
/* harmony import */ var _images_icons_type_number_svg__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(39046);
/* harmony import */ var _images_icons_type_number_svg__WEBPACK_IMPORTED_MODULE_82___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_number_svg__WEBPACK_IMPORTED_MODULE_82__);
/* harmony import */ var _images_icons_type_progress_svg__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(92702);
/* harmony import */ var _images_icons_type_progress_svg__WEBPACK_IMPORTED_MODULE_83___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_progress_svg__WEBPACK_IMPORTED_MODULE_83__);
/* harmony import */ var _images_icons_type_singleselect_svg__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(56486);
/* harmony import */ var _images_icons_type_singleselect_svg__WEBPACK_IMPORTED_MODULE_84___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_singleselect_svg__WEBPACK_IMPORTED_MODULE_84__);
/* harmony import */ var _images_icons_type_text_svg__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(85265);
/* harmony import */ var _images_icons_type_text_svg__WEBPACK_IMPORTED_MODULE_85___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_text_svg__WEBPACK_IMPORTED_MODULE_85__);
/* harmony import */ var _images_icons_type_mention_svg__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(66339);
/* harmony import */ var _images_icons_type_mention_svg__WEBPACK_IMPORTED_MODULE_86___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_mention_svg__WEBPACK_IMPORTED_MODULE_86__);
/* harmony import */ var _images_icons_type_collaborator_svg__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(33753);
/* harmony import */ var _images_icons_type_collaborator_svg__WEBPACK_IMPORTED_MODULE_87___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_collaborator_svg__WEBPACK_IMPORTED_MODULE_87__);
/* harmony import */ var _images_icons_type_date_svg__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(24655);
/* harmony import */ var _images_icons_type_date_svg__WEBPACK_IMPORTED_MODULE_88___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_date_svg__WEBPACK_IMPORTED_MODULE_88__);
/* harmony import */ var _images_icons_type_attachment_svg__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(93858);
/* harmony import */ var _images_icons_type_attachment_svg__WEBPACK_IMPORTED_MODULE_89___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_attachment_svg__WEBPACK_IMPORTED_MODULE_89__);
/* harmony import */ var _images_icons_type_link_svg__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(52124);
/* harmony import */ var _images_icons_type_link_svg__WEBPACK_IMPORTED_MODULE_90___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_link_svg__WEBPACK_IMPORTED_MODULE_90__);
/* harmony import */ var _images_icons_type_rating_svg__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(21685);
/* harmony import */ var _images_icons_type_rating_svg__WEBPACK_IMPORTED_MODULE_91___default = /*#__PURE__*/__webpack_require__.n(_images_icons_type_rating_svg__WEBPACK_IMPORTED_MODULE_91__);
/* harmony import */ var _images_icons_progress_simple_svg__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(49962);
/* harmony import */ var _images_icons_progress_simple_svg__WEBPACK_IMPORTED_MODULE_92___default = /*#__PURE__*/__webpack_require__.n(_images_icons_progress_simple_svg__WEBPACK_IMPORTED_MODULE_92__);
/* harmony import */ var _images_icons_progress_colored_svg__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(14211);
/* harmony import */ var _images_icons_progress_colored_svg__WEBPACK_IMPORTED_MODULE_93___default = /*#__PURE__*/__webpack_require__.n(_images_icons_progress_colored_svg__WEBPACK_IMPORTED_MODULE_93__);
/* harmony import */ var _images_icons_rating_star_light_svg__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(4735);
/* harmony import */ var _images_icons_rating_star_light_svg__WEBPACK_IMPORTED_MODULE_94___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_light_svg__WEBPACK_IMPORTED_MODULE_94__);
/* harmony import */ var _images_icons_rating_star_gray_svg__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(75851);
/* harmony import */ var _images_icons_rating_star_gray_svg__WEBPACK_IMPORTED_MODULE_95___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_gray_svg__WEBPACK_IMPORTED_MODULE_95__);
/* harmony import */ var _images_icons_rating_star_red_svg__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(76936);
/* harmony import */ var _images_icons_rating_star_red_svg__WEBPACK_IMPORTED_MODULE_96___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_red_svg__WEBPACK_IMPORTED_MODULE_96__);
/* harmony import */ var _images_icons_rating_star_blue_svg__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(37322);
/* harmony import */ var _images_icons_rating_star_blue_svg__WEBPACK_IMPORTED_MODULE_97___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_star_blue_svg__WEBPACK_IMPORTED_MODULE_97__);
/* harmony import */ var _images_icons_rating_flag_light_svg__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(98763);
/* harmony import */ var _images_icons_rating_flag_light_svg__WEBPACK_IMPORTED_MODULE_98___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_light_svg__WEBPACK_IMPORTED_MODULE_98__);
/* harmony import */ var _images_icons_rating_flag_gray_svg__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(80764);
/* harmony import */ var _images_icons_rating_flag_gray_svg__WEBPACK_IMPORTED_MODULE_99___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_gray_svg__WEBPACK_IMPORTED_MODULE_99__);
/* harmony import */ var _images_icons_rating_flag_red_svg__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(55009);
/* harmony import */ var _images_icons_rating_flag_red_svg__WEBPACK_IMPORTED_MODULE_100___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_red_svg__WEBPACK_IMPORTED_MODULE_100__);
/* harmony import */ var _images_icons_rating_flag_blue_svg__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(8507);
/* harmony import */ var _images_icons_rating_flag_blue_svg__WEBPACK_IMPORTED_MODULE_101___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_flag_blue_svg__WEBPACK_IMPORTED_MODULE_101__);
/* harmony import */ var _images_icons_rating_heart_light_svg__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(16030);
/* harmony import */ var _images_icons_rating_heart_light_svg__WEBPACK_IMPORTED_MODULE_102___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_light_svg__WEBPACK_IMPORTED_MODULE_102__);
/* harmony import */ var _images_icons_rating_heart_gray_svg__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(85625);
/* harmony import */ var _images_icons_rating_heart_gray_svg__WEBPACK_IMPORTED_MODULE_103___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_gray_svg__WEBPACK_IMPORTED_MODULE_103__);
/* harmony import */ var _images_icons_rating_heart_red_svg__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(61335);
/* harmony import */ var _images_icons_rating_heart_red_svg__WEBPACK_IMPORTED_MODULE_104___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_red_svg__WEBPACK_IMPORTED_MODULE_104__);
/* harmony import */ var _images_icons_rating_heart_blue_svg__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(71138);
/* harmony import */ var _images_icons_rating_heart_blue_svg__WEBPACK_IMPORTED_MODULE_105___default = /*#__PURE__*/__webpack_require__.n(_images_icons_rating_heart_blue_svg__WEBPACK_IMPORTED_MODULE_105__);
/* harmony import */ var _images_icons_cross_svg__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(33597);
/* harmony import */ var _images_icons_cross_svg__WEBPACK_IMPORTED_MODULE_106___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cross_svg__WEBPACK_IMPORTED_MODULE_106__);
/* harmony import */ var _images_icons_alert_svg__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(32577);
/* harmony import */ var _images_icons_alert_svg__WEBPACK_IMPORTED_MODULE_107___default = /*#__PURE__*/__webpack_require__.n(_images_icons_alert_svg__WEBPACK_IMPORTED_MODULE_107__);
/* harmony import */ var _images_icons_download2_svg__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(27317);
/* harmony import */ var _images_icons_download2_svg__WEBPACK_IMPORTED_MODULE_108___default = /*#__PURE__*/__webpack_require__.n(_images_icons_download2_svg__WEBPACK_IMPORTED_MODULE_108__);
/* harmony import */ var _images_icons_note_svg__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(8386);
/* harmony import */ var _images_icons_note_svg__WEBPACK_IMPORTED_MODULE_109___default = /*#__PURE__*/__webpack_require__.n(_images_icons_note_svg__WEBPACK_IMPORTED_MODULE_109__);
/* harmony import */ var _images_icons_folder_svg__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(32472);
/* harmony import */ var _images_icons_folder_svg__WEBPACK_IMPORTED_MODULE_110___default = /*#__PURE__*/__webpack_require__.n(_images_icons_folder_svg__WEBPACK_IMPORTED_MODULE_110__);
/* harmony import */ var _images_icons_workspace_svg__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(7294);
/* harmony import */ var _images_icons_workspace_svg__WEBPACK_IMPORTED_MODULE_111___default = /*#__PURE__*/__webpack_require__.n(_images_icons_workspace_svg__WEBPACK_IMPORTED_MODULE_111__);
/* harmony import */ var _images_icons_shared_svg__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(31665);
/* harmony import */ var _images_icons_shared_svg__WEBPACK_IMPORTED_MODULE_112___default = /*#__PURE__*/__webpack_require__.n(_images_icons_shared_svg__WEBPACK_IMPORTED_MODULE_112__);
/* harmony import */ var _images_icons_favorites_svg__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(84581);
/* harmony import */ var _images_icons_favorites_svg__WEBPACK_IMPORTED_MODULE_113___default = /*#__PURE__*/__webpack_require__.n(_images_icons_favorites_svg__WEBPACK_IMPORTED_MODULE_113__);
/* harmony import */ var _images_icons_todo_svg__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(88536);
/* harmony import */ var _images_icons_todo_svg__WEBPACK_IMPORTED_MODULE_114___default = /*#__PURE__*/__webpack_require__.n(_images_icons_todo_svg__WEBPACK_IMPORTED_MODULE_114__);
/* harmony import */ var _images_icons_syntax_svg__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(18294);
/* harmony import */ var _images_icons_syntax_svg__WEBPACK_IMPORTED_MODULE_115___default = /*#__PURE__*/__webpack_require__.n(_images_icons_syntax_svg__WEBPACK_IMPORTED_MODULE_115__);
/* harmony import */ var _images_icons_templates_svg__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(62171);
/* harmony import */ var _images_icons_templates_svg__WEBPACK_IMPORTED_MODULE_116___default = /*#__PURE__*/__webpack_require__.n(_images_icons_templates_svg__WEBPACK_IMPORTED_MODULE_116__);
/* harmony import */ var _images_icons_question_svg__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(40286);
/* harmony import */ var _images_icons_question_svg__WEBPACK_IMPORTED_MODULE_117___default = /*#__PURE__*/__webpack_require__.n(_images_icons_question_svg__WEBPACK_IMPORTED_MODULE_117__);
/* harmony import */ var _images_icons_sort_ascending_svg__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(17884);
/* harmony import */ var _images_icons_sort_ascending_svg__WEBPACK_IMPORTED_MODULE_118___default = /*#__PURE__*/__webpack_require__.n(_images_icons_sort_ascending_svg__WEBPACK_IMPORTED_MODULE_118__);
/* harmony import */ var _images_icons_sort_descending_svg__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(59681);
/* harmony import */ var _images_icons_sort_descending_svg__WEBPACK_IMPORTED_MODULE_119___default = /*#__PURE__*/__webpack_require__.n(_images_icons_sort_descending_svg__WEBPACK_IMPORTED_MODULE_119__);
/* harmony import */ var _images_icons_mention_svg__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(94384);
/* harmony import */ var _images_icons_mention_svg__WEBPACK_IMPORTED_MODULE_120___default = /*#__PURE__*/__webpack_require__.n(_images_icons_mention_svg__WEBPACK_IMPORTED_MODULE_120__);
/* harmony import */ var _images_icons_tasks_svg__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(12216);
/* harmony import */ var _images_icons_tasks_svg__WEBPACK_IMPORTED_MODULE_121___default = /*#__PURE__*/__webpack_require__.n(_images_icons_tasks_svg__WEBPACK_IMPORTED_MODULE_121__);
/* harmony import */ var _images_icons_outline_svg__WEBPACK_IMPORTED_MODULE_122__ = __webpack_require__(68234);
/* harmony import */ var _images_icons_outline_svg__WEBPACK_IMPORTED_MODULE_122___default = /*#__PURE__*/__webpack_require__.n(_images_icons_outline_svg__WEBPACK_IMPORTED_MODULE_122__);
/* harmony import */ var _images_icons_check_svg__WEBPACK_IMPORTED_MODULE_123__ = __webpack_require__(21855);
/* harmony import */ var _images_icons_check_svg__WEBPACK_IMPORTED_MODULE_123___default = /*#__PURE__*/__webpack_require__.n(_images_icons_check_svg__WEBPACK_IMPORTED_MODULE_123__);
/* harmony import */ var _images_icons_arrow_right_rounded_svg__WEBPACK_IMPORTED_MODULE_124__ = __webpack_require__(61093);
/* harmony import */ var _images_icons_arrow_right_rounded_svg__WEBPACK_IMPORTED_MODULE_124___default = /*#__PURE__*/__webpack_require__.n(_images_icons_arrow_right_rounded_svg__WEBPACK_IMPORTED_MODULE_124__);
/* harmony import */ var _images_icons_bell_svg__WEBPACK_IMPORTED_MODULE_125__ = __webpack_require__(11803);
/* harmony import */ var _images_icons_bell_svg__WEBPACK_IMPORTED_MODULE_125___default = /*#__PURE__*/__webpack_require__.n(_images_icons_bell_svg__WEBPACK_IMPORTED_MODULE_125__);
/* harmony import */ var _images_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_126__ = __webpack_require__(74985);
/* harmony import */ var _images_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_126___default = /*#__PURE__*/__webpack_require__.n(_images_icons_calendar_svg__WEBPACK_IMPORTED_MODULE_126__);
/* harmony import */ var _images_icons_cloud_error_svg__WEBPACK_IMPORTED_MODULE_127__ = __webpack_require__(71185);
/* harmony import */ var _images_icons_cloud_error_svg__WEBPACK_IMPORTED_MODULE_127___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cloud_error_svg__WEBPACK_IMPORTED_MODULE_127__);
/* harmony import */ var _images_icons_embed_svg__WEBPACK_IMPORTED_MODULE_128__ = __webpack_require__(26258);
/* harmony import */ var _images_icons_embed_svg__WEBPACK_IMPORTED_MODULE_128___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_svg__WEBPACK_IMPORTED_MODULE_128__);
/* harmony import */ var _images_icons_google_drive_svg__WEBPACK_IMPORTED_MODULE_129__ = __webpack_require__(55551);
/* harmony import */ var _images_icons_google_drive_svg__WEBPACK_IMPORTED_MODULE_129___default = /*#__PURE__*/__webpack_require__.n(_images_icons_google_drive_svg__WEBPACK_IMPORTED_MODULE_129__);
/* harmony import */ var _images_icons_people_svg__WEBPACK_IMPORTED_MODULE_130__ = __webpack_require__(53686);
/* harmony import */ var _images_icons_people_svg__WEBPACK_IMPORTED_MODULE_130___default = /*#__PURE__*/__webpack_require__.n(_images_icons_people_svg__WEBPACK_IMPORTED_MODULE_130__);
/* harmony import */ var _images_icons_back_button_svg__WEBPACK_IMPORTED_MODULE_131__ = __webpack_require__(86306);
/* harmony import */ var _images_icons_back_button_svg__WEBPACK_IMPORTED_MODULE_131___default = /*#__PURE__*/__webpack_require__.n(_images_icons_back_button_svg__WEBPACK_IMPORTED_MODULE_131__);
/* harmony import */ var _images_icons_menu_more_down_svg__WEBPACK_IMPORTED_MODULE_132__ = __webpack_require__(16357);
/* harmony import */ var _images_icons_menu_more_down_svg__WEBPACK_IMPORTED_MODULE_132___default = /*#__PURE__*/__webpack_require__.n(_images_icons_menu_more_down_svg__WEBPACK_IMPORTED_MODULE_132__);
/* harmony import */ var _images_icons_list_collapse_svg__WEBPACK_IMPORTED_MODULE_133__ = __webpack_require__(98854);
/* harmony import */ var _images_icons_list_collapse_svg__WEBPACK_IMPORTED_MODULE_133___default = /*#__PURE__*/__webpack_require__.n(_images_icons_list_collapse_svg__WEBPACK_IMPORTED_MODULE_133__);
/* harmony import */ var _images_icons_placeholder_icon_svg__WEBPACK_IMPORTED_MODULE_134__ = __webpack_require__(7393);
/* harmony import */ var _images_icons_placeholder_icon_svg__WEBPACK_IMPORTED_MODULE_134___default = /*#__PURE__*/__webpack_require__.n(_images_icons_placeholder_icon_svg__WEBPACK_IMPORTED_MODULE_134__);
/* harmony import */ var _images_icons_bookmark_svg__WEBPACK_IMPORTED_MODULE_135__ = __webpack_require__(22793);
/* harmony import */ var _images_icons_bookmark_svg__WEBPACK_IMPORTED_MODULE_135___default = /*#__PURE__*/__webpack_require__.n(_images_icons_bookmark_svg__WEBPACK_IMPORTED_MODULE_135__);
/* harmony import */ var _images_icons_url_svg__WEBPACK_IMPORTED_MODULE_136__ = __webpack_require__(29672);
/* harmony import */ var _images_icons_url_svg__WEBPACK_IMPORTED_MODULE_136___default = /*#__PURE__*/__webpack_require__.n(_images_icons_url_svg__WEBPACK_IMPORTED_MODULE_136__);
/* harmony import */ var _images_icons_title_svg__WEBPACK_IMPORTED_MODULE_137__ = __webpack_require__(76094);
/* harmony import */ var _images_icons_title_svg__WEBPACK_IMPORTED_MODULE_137___default = /*#__PURE__*/__webpack_require__.n(_images_icons_title_svg__WEBPACK_IMPORTED_MODULE_137__);
/* harmony import */ var _images_icons_embed_b_svg__WEBPACK_IMPORTED_MODULE_138__ = __webpack_require__(99474);
/* harmony import */ var _images_icons_embed_b_svg__WEBPACK_IMPORTED_MODULE_138___default = /*#__PURE__*/__webpack_require__.n(_images_icons_embed_b_svg__WEBPACK_IMPORTED_MODULE_138__);
/* harmony import */ var _images_icons_youtube_svg__WEBPACK_IMPORTED_MODULE_139__ = __webpack_require__(46921);
/* harmony import */ var _images_icons_youtube_svg__WEBPACK_IMPORTED_MODULE_139___default = /*#__PURE__*/__webpack_require__.n(_images_icons_youtube_svg__WEBPACK_IMPORTED_MODULE_139__);
/* harmony import */ var _images_icons_google_maps_svg__WEBPACK_IMPORTED_MODULE_140__ = __webpack_require__(517);
/* harmony import */ var _images_icons_google_maps_svg__WEBPACK_IMPORTED_MODULE_140___default = /*#__PURE__*/__webpack_require__.n(_images_icons_google_maps_svg__WEBPACK_IMPORTED_MODULE_140__);
/* harmony import */ var _images_icons_airtable_svg__WEBPACK_IMPORTED_MODULE_141__ = __webpack_require__(88098);
/* harmony import */ var _images_icons_airtable_svg__WEBPACK_IMPORTED_MODULE_141___default = /*#__PURE__*/__webpack_require__.n(_images_icons_airtable_svg__WEBPACK_IMPORTED_MODULE_141__);
/* harmony import */ var _images_icons_invision_svg__WEBPACK_IMPORTED_MODULE_142__ = __webpack_require__(13669);
/* harmony import */ var _images_icons_invision_svg__WEBPACK_IMPORTED_MODULE_142___default = /*#__PURE__*/__webpack_require__.n(_images_icons_invision_svg__WEBPACK_IMPORTED_MODULE_142__);
/* harmony import */ var _images_icons_figma_svg__WEBPACK_IMPORTED_MODULE_143__ = __webpack_require__(83763);
/* harmony import */ var _images_icons_figma_svg__WEBPACK_IMPORTED_MODULE_143___default = /*#__PURE__*/__webpack_require__.n(_images_icons_figma_svg__WEBPACK_IMPORTED_MODULE_143__);
/* harmony import */ var _images_icons_github_gist_svg__WEBPACK_IMPORTED_MODULE_144__ = __webpack_require__(71492);
/* harmony import */ var _images_icons_github_gist_svg__WEBPACK_IMPORTED_MODULE_144___default = /*#__PURE__*/__webpack_require__.n(_images_icons_github_gist_svg__WEBPACK_IMPORTED_MODULE_144__);
/* harmony import */ var _images_icons_twitter_svg__WEBPACK_IMPORTED_MODULE_145__ = __webpack_require__(35783);
/* harmony import */ var _images_icons_twitter_svg__WEBPACK_IMPORTED_MODULE_145___default = /*#__PURE__*/__webpack_require__.n(_images_icons_twitter_svg__WEBPACK_IMPORTED_MODULE_145__);
/* harmony import */ var _images_icons_typeform_svg__WEBPACK_IMPORTED_MODULE_146__ = __webpack_require__(61615);
/* harmony import */ var _images_icons_typeform_svg__WEBPACK_IMPORTED_MODULE_146___default = /*#__PURE__*/__webpack_require__.n(_images_icons_typeform_svg__WEBPACK_IMPORTED_MODULE_146__);
/* harmony import */ var _images_icons_vimeo_svg__WEBPACK_IMPORTED_MODULE_147__ = __webpack_require__(89713);
/* harmony import */ var _images_icons_vimeo_svg__WEBPACK_IMPORTED_MODULE_147___default = /*#__PURE__*/__webpack_require__.n(_images_icons_vimeo_svg__WEBPACK_IMPORTED_MODULE_147__);
/* harmony import */ var _images_icons_nimbus_svg__WEBPACK_IMPORTED_MODULE_148__ = __webpack_require__(92688);
/* harmony import */ var _images_icons_nimbus_svg__WEBPACK_IMPORTED_MODULE_148___default = /*#__PURE__*/__webpack_require__.n(_images_icons_nimbus_svg__WEBPACK_IMPORTED_MODULE_148__);
/* harmony import */ var _images_icons_upload_svg__WEBPACK_IMPORTED_MODULE_149__ = __webpack_require__(26798);
/* harmony import */ var _images_icons_upload_svg__WEBPACK_IMPORTED_MODULE_149___default = /*#__PURE__*/__webpack_require__.n(_images_icons_upload_svg__WEBPACK_IMPORTED_MODULE_149__);
/* harmony import */ var _images_icons_play_icon_svg__WEBPACK_IMPORTED_MODULE_150__ = __webpack_require__(51195);
/* harmony import */ var _images_icons_play_icon_svg__WEBPACK_IMPORTED_MODULE_150___default = /*#__PURE__*/__webpack_require__.n(_images_icons_play_icon_svg__WEBPACK_IMPORTED_MODULE_150__);
/* harmony import */ var _images_icons_pause_icon_svg__WEBPACK_IMPORTED_MODULE_151__ = __webpack_require__(10231);
/* harmony import */ var _images_icons_pause_icon_svg__WEBPACK_IMPORTED_MODULE_151___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pause_icon_svg__WEBPACK_IMPORTED_MODULE_151__);
/* harmony import */ var _images_icons_record_icon_svg__WEBPACK_IMPORTED_MODULE_152__ = __webpack_require__(14698);
/* harmony import */ var _images_icons_record_icon_svg__WEBPACK_IMPORTED_MODULE_152___default = /*#__PURE__*/__webpack_require__.n(_images_icons_record_icon_svg__WEBPACK_IMPORTED_MODULE_152__);
/* harmony import */ var _images_icons_remove_record_svg__WEBPACK_IMPORTED_MODULE_153__ = __webpack_require__(88170);
/* harmony import */ var _images_icons_remove_record_svg__WEBPACK_IMPORTED_MODULE_153___default = /*#__PURE__*/__webpack_require__.n(_images_icons_remove_record_svg__WEBPACK_IMPORTED_MODULE_153__);
/* harmony import */ var _images_icons_stop_icon_svg__WEBPACK_IMPORTED_MODULE_154__ = __webpack_require__(14345);
/* harmony import */ var _images_icons_stop_icon_svg__WEBPACK_IMPORTED_MODULE_154___default = /*#__PURE__*/__webpack_require__.n(_images_icons_stop_icon_svg__WEBPACK_IMPORTED_MODULE_154__);
/* harmony import */ var _images_icons_screen_only_svg__WEBPACK_IMPORTED_MODULE_155__ = __webpack_require__(30315);
/* harmony import */ var _images_icons_screen_only_svg__WEBPACK_IMPORTED_MODULE_155___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_only_svg__WEBPACK_IMPORTED_MODULE_155__);
/* harmony import */ var _images_icons_cam_only_svg__WEBPACK_IMPORTED_MODULE_156__ = __webpack_require__(21088);
/* harmony import */ var _images_icons_cam_only_svg__WEBPACK_IMPORTED_MODULE_156___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cam_only_svg__WEBPACK_IMPORTED_MODULE_156__);
/* harmony import */ var _images_icons_screen_cam_svg__WEBPACK_IMPORTED_MODULE_157__ = __webpack_require__(80562);
/* harmony import */ var _images_icons_screen_cam_svg__WEBPACK_IMPORTED_MODULE_157___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_cam_svg__WEBPACK_IMPORTED_MODULE_157__);
/* harmony import */ var _images_icons_screen_only_active_svg__WEBPACK_IMPORTED_MODULE_158__ = __webpack_require__(77142);
/* harmony import */ var _images_icons_screen_only_active_svg__WEBPACK_IMPORTED_MODULE_158___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_only_active_svg__WEBPACK_IMPORTED_MODULE_158__);
/* harmony import */ var _images_icons_cam_only_active_svg__WEBPACK_IMPORTED_MODULE_159__ = __webpack_require__(31887);
/* harmony import */ var _images_icons_cam_only_active_svg__WEBPACK_IMPORTED_MODULE_159___default = /*#__PURE__*/__webpack_require__.n(_images_icons_cam_only_active_svg__WEBPACK_IMPORTED_MODULE_159__);
/* harmony import */ var _images_icons_screen_cam_active_svg__WEBPACK_IMPORTED_MODULE_160__ = __webpack_require__(61762);
/* harmony import */ var _images_icons_screen_cam_active_svg__WEBPACK_IMPORTED_MODULE_160___default = /*#__PURE__*/__webpack_require__.n(_images_icons_screen_cam_active_svg__WEBPACK_IMPORTED_MODULE_160__);
/* harmony import */ var _images_icons_soundOn_svg__WEBPACK_IMPORTED_MODULE_161__ = __webpack_require__(10653);
/* harmony import */ var _images_icons_soundOn_svg__WEBPACK_IMPORTED_MODULE_161___default = /*#__PURE__*/__webpack_require__.n(_images_icons_soundOn_svg__WEBPACK_IMPORTED_MODULE_161__);
/* harmony import */ var _images_icons_soundOff_svg__WEBPACK_IMPORTED_MODULE_162__ = __webpack_require__(24570);
/* harmony import */ var _images_icons_soundOff_svg__WEBPACK_IMPORTED_MODULE_162___default = /*#__PURE__*/__webpack_require__.n(_images_icons_soundOff_svg__WEBPACK_IMPORTED_MODULE_162__);
/* harmony import */ var _images_icons_full_width_mode_svg__WEBPACK_IMPORTED_MODULE_163__ = __webpack_require__(89129);
/* harmony import */ var _images_icons_full_width_mode_svg__WEBPACK_IMPORTED_MODULE_163___default = /*#__PURE__*/__webpack_require__.n(_images_icons_full_width_mode_svg__WEBPACK_IMPORTED_MODULE_163__);
/* harmony import */ var _images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164__ = __webpack_require__(88398);
/* harmony import */ var _images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pin_button_svg__WEBPACK_IMPORTED_MODULE_164__);
/* harmony import */ var _images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165__ = __webpack_require__(29300);
/* harmony import */ var _images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165___default = /*#__PURE__*/__webpack_require__.n(_images_icons_unpin_button_svg__WEBPACK_IMPORTED_MODULE_165__);
/* harmony import */ var _images_icons_lock_svg__WEBPACK_IMPORTED_MODULE_166__ = __webpack_require__(72102);
/* harmony import */ var _images_icons_lock_svg__WEBPACK_IMPORTED_MODULE_166___default = /*#__PURE__*/__webpack_require__.n(_images_icons_lock_svg__WEBPACK_IMPORTED_MODULE_166__);
/* harmony import */ var _images_icons_lock_hover_svg__WEBPACK_IMPORTED_MODULE_167__ = __webpack_require__(8941);
/* harmony import */ var _images_icons_lock_hover_svg__WEBPACK_IMPORTED_MODULE_167___default = /*#__PURE__*/__webpack_require__.n(_images_icons_lock_hover_svg__WEBPACK_IMPORTED_MODULE_167__);
/* harmony import */ var _images_icons_create_note_svg__WEBPACK_IMPORTED_MODULE_168__ = __webpack_require__(44744);
/* harmony import */ var _images_icons_create_note_svg__WEBPACK_IMPORTED_MODULE_168___default = /*#__PURE__*/__webpack_require__.n(_images_icons_create_note_svg__WEBPACK_IMPORTED_MODULE_168__);
/* harmony import */ var _images_icons_create_folder_svg__WEBPACK_IMPORTED_MODULE_169__ = __webpack_require__(13532);
/* harmony import */ var _images_icons_create_folder_svg__WEBPACK_IMPORTED_MODULE_169___default = /*#__PURE__*/__webpack_require__.n(_images_icons_create_folder_svg__WEBPACK_IMPORTED_MODULE_169__);
/* harmony import */ var _images_icons_comment_svg__WEBPACK_IMPORTED_MODULE_170__ = __webpack_require__(3641);
/* harmony import */ var _images_icons_comment_svg__WEBPACK_IMPORTED_MODULE_170___default = /*#__PURE__*/__webpack_require__.n(_images_icons_comment_svg__WEBPACK_IMPORTED_MODULE_170__);
/* harmony import */ var _images_icons_hint_svg__WEBPACK_IMPORTED_MODULE_171__ = __webpack_require__(82052);
/* harmony import */ var _images_icons_hint_svg__WEBPACK_IMPORTED_MODULE_171___default = /*#__PURE__*/__webpack_require__.n(_images_icons_hint_svg__WEBPACK_IMPORTED_MODULE_171__);
/* harmony import */ var _images_icons_comment_mobile_svg__WEBPACK_IMPORTED_MODULE_172__ = __webpack_require__(58191);
/* harmony import */ var _images_icons_comment_mobile_svg__WEBPACK_IMPORTED_MODULE_172___default = /*#__PURE__*/__webpack_require__.n(_images_icons_comment_mobile_svg__WEBPACK_IMPORTED_MODULE_172__);
/* harmony import */ var _images_icons_button_svg__WEBPACK_IMPORTED_MODULE_173__ = __webpack_require__(60681);
/* harmony import */ var _images_icons_button_svg__WEBPACK_IMPORTED_MODULE_173___default = /*#__PURE__*/__webpack_require__.n(_images_icons_button_svg__WEBPACK_IMPORTED_MODULE_173__);
/* harmony import */ var _images_icons_empty_svg__WEBPACK_IMPORTED_MODULE_174__ = __webpack_require__(91027);
/* harmony import */ var _images_icons_empty_svg__WEBPACK_IMPORTED_MODULE_174___default = /*#__PURE__*/__webpack_require__.n(_images_icons_empty_svg__WEBPACK_IMPORTED_MODULE_174__);
/* harmony import */ var _images_icons_edit_video_svg__WEBPACK_IMPORTED_MODULE_175__ = __webpack_require__(97393);
/* harmony import */ var _images_icons_edit_video_svg__WEBPACK_IMPORTED_MODULE_175___default = /*#__PURE__*/__webpack_require__.n(_images_icons_edit_video_svg__WEBPACK_IMPORTED_MODULE_175__);
/* harmony import */ var _images_icons_paragraph_2_svg__WEBPACK_IMPORTED_MODULE_176__ = __webpack_require__(69435);
/* harmony import */ var _images_icons_paragraph_2_svg__WEBPACK_IMPORTED_MODULE_176___default = /*#__PURE__*/__webpack_require__.n(_images_icons_paragraph_2_svg__WEBPACK_IMPORTED_MODULE_176__);
/* harmony import */ var _images_icons_add_comment_svg__WEBPACK_IMPORTED_MODULE_177__ = __webpack_require__(44859);
/* harmony import */ var _images_icons_add_comment_svg__WEBPACK_IMPORTED_MODULE_177___default = /*#__PURE__*/__webpack_require__.n(_images_icons_add_comment_svg__WEBPACK_IMPORTED_MODULE_177__);
/* harmony import */ var _images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178__ = __webpack_require__(77445);
/* harmony import */ var _images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178___default = /*#__PURE__*/__webpack_require__.n(_images_icons_watch_again_svg__WEBPACK_IMPORTED_MODULE_178__);
/* harmony import */ var _images_icons_toggle_svg__WEBPACK_IMPORTED_MODULE_179__ = __webpack_require__(33277);
/* harmony import */ var _images_icons_toggle_svg__WEBPACK_IMPORTED_MODULE_179___default = /*#__PURE__*/__webpack_require__.n(_images_icons_toggle_svg__WEBPACK_IMPORTED_MODULE_179__);
/* harmony import */ var _images_icons_checklist_svg__WEBPACK_IMPORTED_MODULE_180__ = __webpack_require__(36598);
/* harmony import */ var _images_icons_checklist_svg__WEBPACK_IMPORTED_MODULE_180___default = /*#__PURE__*/__webpack_require__.n(_images_icons_checklist_svg__WEBPACK_IMPORTED_MODULE_180__);
/* harmony import */ var _images_icons_player_download_svg__WEBPACK_IMPORTED_MODULE_181__ = __webpack_require__(25637);
/* harmony import */ var _images_icons_player_download_svg__WEBPACK_IMPORTED_MODULE_181___default = /*#__PURE__*/__webpack_require__.n(_images_icons_player_download_svg__WEBPACK_IMPORTED_MODULE_181__);
/* harmony import */ var _images_icons_large_header_toggle_svg__WEBPACK_IMPORTED_MODULE_182__ = __webpack_require__(78018);
/* harmony import */ var _images_icons_large_header_toggle_svg__WEBPACK_IMPORTED_MODULE_182___default = /*#__PURE__*/__webpack_require__.n(_images_icons_large_header_toggle_svg__WEBPACK_IMPORTED_MODULE_182__);
/* harmony import */ var _images_icons_medium_header_toggle_svg__WEBPACK_IMPORTED_MODULE_183__ = __webpack_require__(37871);
/* harmony import */ var _images_icons_medium_header_toggle_svg__WEBPACK_IMPORTED_MODULE_183___default = /*#__PURE__*/__webpack_require__.n(_images_icons_medium_header_toggle_svg__WEBPACK_IMPORTED_MODULE_183__);
/* harmony import */ var _images_icons_small_header_toggle_svg__WEBPACK_IMPORTED_MODULE_184__ = __webpack_require__(71571);
/* harmony import */ var _images_icons_small_header_toggle_svg__WEBPACK_IMPORTED_MODULE_184___default = /*#__PURE__*/__webpack_require__.n(_images_icons_small_header_toggle_svg__WEBPACK_IMPORTED_MODULE_184__);
/* harmony import */ var _images_icons_custom_link_svg__WEBPACK_IMPORTED_MODULE_185__ = __webpack_require__(89883);
/* harmony import */ var _images_icons_custom_link_svg__WEBPACK_IMPORTED_MODULE_185___default = /*#__PURE__*/__webpack_require__.n(_images_icons_custom_link_svg__WEBPACK_IMPORTED_MODULE_185__);
/* harmony import */ var _images_icons_columns_svg__WEBPACK_IMPORTED_MODULE_186__ = __webpack_require__(97368);
/* harmony import */ var _images_icons_columns_svg__WEBPACK_IMPORTED_MODULE_186___default = /*#__PURE__*/__webpack_require__.n(_images_icons_columns_svg__WEBPACK_IMPORTED_MODULE_186__);
/* harmony import */ var _images_icons_default_color_icon_svg__WEBPACK_IMPORTED_MODULE_187__ = __webpack_require__(28824);
/* harmony import */ var _images_icons_default_color_icon_svg__WEBPACK_IMPORTED_MODULE_187___default = /*#__PURE__*/__webpack_require__.n(_images_icons_default_color_icon_svg__WEBPACK_IMPORTED_MODULE_187__);
/* harmony import */ var _images_icons_template_icon_svg__WEBPACK_IMPORTED_MODULE_188__ = __webpack_require__(64268);
/* harmony import */ var _images_icons_template_icon_svg__WEBPACK_IMPORTED_MODULE_188___default = /*#__PURE__*/__webpack_require__.n(_images_icons_template_icon_svg__WEBPACK_IMPORTED_MODULE_188__);
/* harmony import */ var _images_icons_invite_svg__WEBPACK_IMPORTED_MODULE_189__ = __webpack_require__(44819);
/* harmony import */ var _images_icons_invite_svg__WEBPACK_IMPORTED_MODULE_189___default = /*#__PURE__*/__webpack_require__.n(_images_icons_invite_svg__WEBPACK_IMPORTED_MODULE_189__);
/* harmony import */ var _images_icons_file_icon_svg__WEBPACK_IMPORTED_MODULE_190__ = __webpack_require__(62012);
/* harmony import */ var _images_icons_file_icon_svg__WEBPACK_IMPORTED_MODULE_190___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_icon_svg__WEBPACK_IMPORTED_MODULE_190__);
/* harmony import */ var _images_icons_link_diag_svg__WEBPACK_IMPORTED_MODULE_191__ = __webpack_require__(4718);
/* harmony import */ var _images_icons_link_diag_svg__WEBPACK_IMPORTED_MODULE_191___default = /*#__PURE__*/__webpack_require__.n(_images_icons_link_diag_svg__WEBPACK_IMPORTED_MODULE_191__);
/* harmony import */ var _images_icons_feedback_svg__WEBPACK_IMPORTED_MODULE_192__ = __webpack_require__(23953);
/* harmony import */ var _images_icons_feedback_svg__WEBPACK_IMPORTED_MODULE_192___default = /*#__PURE__*/__webpack_require__.n(_images_icons_feedback_svg__WEBPACK_IMPORTED_MODULE_192__);
/* harmony import */ var _images_icons_support_svg__WEBPACK_IMPORTED_MODULE_193__ = __webpack_require__(62428);
/* harmony import */ var _images_icons_support_svg__WEBPACK_IMPORTED_MODULE_193___default = /*#__PURE__*/__webpack_require__.n(_images_icons_support_svg__WEBPACK_IMPORTED_MODULE_193__);
/* harmony import */ var _images_icons_learn_svg__WEBPACK_IMPORTED_MODULE_194__ = __webpack_require__(76767);
/* harmony import */ var _images_icons_learn_svg__WEBPACK_IMPORTED_MODULE_194___default = /*#__PURE__*/__webpack_require__.n(_images_icons_learn_svg__WEBPACK_IMPORTED_MODULE_194__);
/* harmony import */ var _images_icons_miro_svg__WEBPACK_IMPORTED_MODULE_195__ = __webpack_require__(26934);
/* harmony import */ var _images_icons_miro_svg__WEBPACK_IMPORTED_MODULE_195___default = /*#__PURE__*/__webpack_require__.n(_images_icons_miro_svg__WEBPACK_IMPORTED_MODULE_195__);
/* harmony import */ var _images_icons_database_svg__WEBPACK_IMPORTED_MODULE_196__ = __webpack_require__(23996);
/* harmony import */ var _images_icons_database_svg__WEBPACK_IMPORTED_MODULE_196___default = /*#__PURE__*/__webpack_require__.n(_images_icons_database_svg__WEBPACK_IMPORTED_MODULE_196__);
/* harmony import */ var _images_icons_filter_svg__WEBPACK_IMPORTED_MODULE_197__ = __webpack_require__(80124);
/* harmony import */ var _images_icons_filter_svg__WEBPACK_IMPORTED_MODULE_197___default = /*#__PURE__*/__webpack_require__.n(_images_icons_filter_svg__WEBPACK_IMPORTED_MODULE_197__);
/* harmony import */ var _images_icons_board_svg__WEBPACK_IMPORTED_MODULE_198__ = __webpack_require__(38096);
/* harmony import */ var _images_icons_board_svg__WEBPACK_IMPORTED_MODULE_198___default = /*#__PURE__*/__webpack_require__.n(_images_icons_board_svg__WEBPACK_IMPORTED_MODULE_198__);
/* harmony import */ var _images_icons_progress_svg__WEBPACK_IMPORTED_MODULE_199__ = __webpack_require__(54958);
/* harmony import */ var _images_icons_progress_svg__WEBPACK_IMPORTED_MODULE_199___default = /*#__PURE__*/__webpack_require__.n(_images_icons_progress_svg__WEBPACK_IMPORTED_MODULE_199__);
/* harmony import */ var _images_icons_comment_new_svg__WEBPACK_IMPORTED_MODULE_200__ = __webpack_require__(7688);
/* harmony import */ var _images_icons_comment_new_svg__WEBPACK_IMPORTED_MODULE_200___default = /*#__PURE__*/__webpack_require__.n(_images_icons_comment_new_svg__WEBPACK_IMPORTED_MODULE_200__);
/* harmony import */ var _images_icons_promt_icon_svg__WEBPACK_IMPORTED_MODULE_201__ = __webpack_require__(38312);
/* harmony import */ var _images_icons_promt_icon_svg__WEBPACK_IMPORTED_MODULE_201___default = /*#__PURE__*/__webpack_require__.n(_images_icons_promt_icon_svg__WEBPACK_IMPORTED_MODULE_201__);
/* harmony import */ var _images_icons_agent_robot_face_svg__WEBPACK_IMPORTED_MODULE_202__ = __webpack_require__(28852);
/* harmony import */ var _images_icons_agent_robot_face_svg__WEBPACK_IMPORTED_MODULE_202___default = /*#__PURE__*/__webpack_require__.n(_images_icons_agent_robot_face_svg__WEBPACK_IMPORTED_MODULE_202__);
/* harmony import */ var _images_icons_sync_svg__WEBPACK_IMPORTED_MODULE_203__ = __webpack_require__(82481);
/* harmony import */ var _images_icons_sync_svg__WEBPACK_IMPORTED_MODULE_203___default = /*#__PURE__*/__webpack_require__.n(_images_icons_sync_svg__WEBPACK_IMPORTED_MODULE_203__);
/* harmony import */ var _images_icons_done_svg__WEBPACK_IMPORTED_MODULE_204__ = __webpack_require__(99635);
/* harmony import */ var _images_icons_done_svg__WEBPACK_IMPORTED_MODULE_204___default = /*#__PURE__*/__webpack_require__.n(_images_icons_done_svg__WEBPACK_IMPORTED_MODULE_204__);
/* harmony import */ var _images_icons_ai_help_svg__WEBPACK_IMPORTED_MODULE_205__ = __webpack_require__(60251);
/* harmony import */ var _images_icons_ai_help_svg__WEBPACK_IMPORTED_MODULE_205___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_help_svg__WEBPACK_IMPORTED_MODULE_205__);
/* harmony import */ var _images_icons_ai_cta_svg__WEBPACK_IMPORTED_MODULE_206__ = __webpack_require__(86766);
/* harmony import */ var _images_icons_ai_cta_svg__WEBPACK_IMPORTED_MODULE_206___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_cta_svg__WEBPACK_IMPORTED_MODULE_206__);
/* harmony import */ var _images_icons_ai_explain_svg__WEBPACK_IMPORTED_MODULE_207__ = __webpack_require__(44461);
/* harmony import */ var _images_icons_ai_explain_svg__WEBPACK_IMPORTED_MODULE_207___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_explain_svg__WEBPACK_IMPORTED_MODULE_207__);
/* harmony import */ var _images_icons_ai_improve_svg__WEBPACK_IMPORTED_MODULE_208__ = __webpack_require__(79058);
/* harmony import */ var _images_icons_ai_improve_svg__WEBPACK_IMPORTED_MODULE_208___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_improve_svg__WEBPACK_IMPORTED_MODULE_208__);
/* harmony import */ var _images_icons_ai_longer_svg__WEBPACK_IMPORTED_MODULE_209__ = __webpack_require__(10812);
/* harmony import */ var _images_icons_ai_longer_svg__WEBPACK_IMPORTED_MODULE_209___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_longer_svg__WEBPACK_IMPORTED_MODULE_209__);
/* harmony import */ var _images_icons_ai_shorter_svg__WEBPACK_IMPORTED_MODULE_210__ = __webpack_require__(67906);
/* harmony import */ var _images_icons_ai_shorter_svg__WEBPACK_IMPORTED_MODULE_210___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_shorter_svg__WEBPACK_IMPORTED_MODULE_210__);
/* harmony import */ var _images_icons_ai_spelling_svg__WEBPACK_IMPORTED_MODULE_211__ = __webpack_require__(89959);
/* harmony import */ var _images_icons_ai_spelling_svg__WEBPACK_IMPORTED_MODULE_211___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_spelling_svg__WEBPACK_IMPORTED_MODULE_211__);
/* harmony import */ var _images_icons_ai_summarize_svg__WEBPACK_IMPORTED_MODULE_212__ = __webpack_require__(65216);
/* harmony import */ var _images_icons_ai_summarize_svg__WEBPACK_IMPORTED_MODULE_212___default = /*#__PURE__*/__webpack_require__.n(_images_icons_ai_summarize_svg__WEBPACK_IMPORTED_MODULE_212__);
/* harmony import */ var _images_icons_replace_svg__WEBPACK_IMPORTED_MODULE_213__ = __webpack_require__(36039);
/* harmony import */ var _images_icons_replace_svg__WEBPACK_IMPORTED_MODULE_213___default = /*#__PURE__*/__webpack_require__.n(_images_icons_replace_svg__WEBPACK_IMPORTED_MODULE_213__);
/* harmony import */ var _images_icons_icon_arrow_up_svg__WEBPACK_IMPORTED_MODULE_214__ = __webpack_require__(79611);
/* harmony import */ var _images_icons_icon_arrow_up_svg__WEBPACK_IMPORTED_MODULE_214___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_arrow_up_svg__WEBPACK_IMPORTED_MODULE_214__);
/* harmony import */ var _images_icons_icon_arrow_down_svg__WEBPACK_IMPORTED_MODULE_215__ = __webpack_require__(91527);
/* harmony import */ var _images_icons_icon_arrow_down_svg__WEBPACK_IMPORTED_MODULE_215___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_arrow_down_svg__WEBPACK_IMPORTED_MODULE_215__);
/* harmony import */ var _images_icons_translate_svg__WEBPACK_IMPORTED_MODULE_216__ = __webpack_require__(60302);
/* harmony import */ var _images_icons_translate_svg__WEBPACK_IMPORTED_MODULE_216___default = /*#__PURE__*/__webpack_require__.n(_images_icons_translate_svg__WEBPACK_IMPORTED_MODULE_216__);
/* harmony import */ var _images_icons_copy_svg__WEBPACK_IMPORTED_MODULE_217__ = __webpack_require__(67012);
/* harmony import */ var _images_icons_copy_svg__WEBPACK_IMPORTED_MODULE_217___default = /*#__PURE__*/__webpack_require__.n(_images_icons_copy_svg__WEBPACK_IMPORTED_MODULE_217__);
/* harmony import */ var _images_icons_icon_cog_svg__WEBPACK_IMPORTED_MODULE_218__ = __webpack_require__(5952);
/* harmony import */ var _images_icons_icon_cog_svg__WEBPACK_IMPORTED_MODULE_218___default = /*#__PURE__*/__webpack_require__.n(_images_icons_icon_cog_svg__WEBPACK_IMPORTED_MODULE_218__);
/* harmony import */ var _images_icons_step_svg__WEBPACK_IMPORTED_MODULE_219__ = __webpack_require__(57551);
/* harmony import */ var _images_icons_step_svg__WEBPACK_IMPORTED_MODULE_219___default = /*#__PURE__*/__webpack_require__.n(_images_icons_step_svg__WEBPACK_IMPORTED_MODULE_219__);
/* harmony import */ var _images_icons_player_transcript_svg__WEBPACK_IMPORTED_MODULE_220__ = __webpack_require__(47137);
/* harmony import */ var _images_icons_player_transcript_svg__WEBPACK_IMPORTED_MODULE_220___default = /*#__PURE__*/__webpack_require__.n(_images_icons_player_transcript_svg__WEBPACK_IMPORTED_MODULE_220__);
/* harmony import */ var _images_icons_file_check_alt_svg__WEBPACK_IMPORTED_MODULE_221__ = __webpack_require__(42020);
/* harmony import */ var _images_icons_file_check_alt_svg__WEBPACK_IMPORTED_MODULE_221___default = /*#__PURE__*/__webpack_require__.n(_images_icons_file_check_alt_svg__WEBPACK_IMPORTED_MODULE_221__);
/* harmony import */ var _images_icons_user_pen_alt_svg__WEBPACK_IMPORTED_MODULE_222__ = __webpack_require__(77586);
/* harmony import */ var _images_icons_user_pen_alt_svg__WEBPACK_IMPORTED_MODULE_222___default = /*#__PURE__*/__webpack_require__.n(_images_icons_user_pen_alt_svg__WEBPACK_IMPORTED_MODULE_222__);
/* harmony import */ var _images_icons_star_svg__WEBPACK_IMPORTED_MODULE_223__ = __webpack_require__(42941);
/* harmony import */ var _images_icons_star_svg__WEBPACK_IMPORTED_MODULE_223___default = /*#__PURE__*/__webpack_require__.n(_images_icons_star_svg__WEBPACK_IMPORTED_MODULE_223__);
/* harmony import */ var _images_icons_undo_svg__WEBPACK_IMPORTED_MODULE_224__ = __webpack_require__(69206);
/* harmony import */ var _images_icons_undo_svg__WEBPACK_IMPORTED_MODULE_224___default = /*#__PURE__*/__webpack_require__.n(_images_icons_undo_svg__WEBPACK_IMPORTED_MODULE_224__);
/* harmony import */ var _images_icons_redo_svg__WEBPACK_IMPORTED_MODULE_225__ = __webpack_require__(20065);
/* harmony import */ var _images_icons_redo_svg__WEBPACK_IMPORTED_MODULE_225___default = /*#__PURE__*/__webpack_require__.n(_images_icons_redo_svg__WEBPACK_IMPORTED_MODULE_225__);
/* harmony import */ var _images_icons_pencil_svg__WEBPACK_IMPORTED_MODULE_226__ = __webpack_require__(68278);
/* harmony import */ var _images_icons_pencil_svg__WEBPACK_IMPORTED_MODULE_226___default = /*#__PURE__*/__webpack_require__.n(_images_icons_pencil_svg__WEBPACK_IMPORTED_MODULE_226__);
/* harmony import */ var _images_icons_eye_open_svg__WEBPACK_IMPORTED_MODULE_227__ = __webpack_require__(75259);
/* harmony import */ var _images_icons_eye_open_svg__WEBPACK_IMPORTED_MODULE_227___default = /*#__PURE__*/__webpack_require__.n(_images_icons_eye_open_svg__WEBPACK_IMPORTED_MODULE_227__);
/* harmony import */ var _images_icons_eye_closed_svg__WEBPACK_IMPORTED_MODULE_228__ = __webpack_require__(47346);
/* harmony import */ var _images_icons_eye_closed_svg__WEBPACK_IMPORTED_MODULE_228___default = /*#__PURE__*/__webpack_require__.n(_images_icons_eye_closed_svg__WEBPACK_IMPORTED_MODULE_228__);
/* harmony import */ var _images_icons_user_plus_svg__WEBPACK_IMPORTED_MODULE_229__ = __webpack_require__(24327);
/* harmony import */ var _images_icons_user_plus_svg__WEBPACK_IMPORTED_MODULE_229___default = /*#__PURE__*/__webpack_require__.n(_images_icons_user_plus_svg__WEBPACK_IMPORTED_MODULE_229__);
/* harmony import */ var _images_icons_checkbox_checked_svg__WEBPACK_IMPORTED_MODULE_230__ = __webpack_require__(41614);
/* harmony import */ var _images_icons_checkbox_checked_svg__WEBPACK_IMPORTED_MODULE_230___default = /*#__PURE__*/__webpack_require__.n(_images_icons_checkbox_checked_svg__WEBPACK_IMPORTED_MODULE_230__);









































































































































































































































/***/ }),

/***/ 12650:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ao": () => (/* binding */ detectBrowser)
/* harmony export */ });
/* unused harmony exports detectPlatform, getBrowserViewport, getMouseWheelEventName, isOffline, modKey, optionKey */
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_1__);


function detectBrowser() {
  if (typeof window === 'undefined') {
    return 'NodeJS';
  }
  var isOpera = !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  }(!window['safari'] || typeof safari !== 'undefined' && safari.pushNotification);
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome;
  if (isOpera) {
    return 'Opera';
  }
  if (isFirefox) {
    return 'Firefox';
  }
  if (isSafari) {
    return 'Safari';
  }
  if (isIE) {
    return 'IE';
  }
  if (isEdge) {
    return 'Edge';
  }
  if (isChrome) {
    return 'Chrome';
  }
  return 'Unkown Browser';
}
function detectPlatform() {
  if (typeof window === 'undefined') {
    return 'NodeJS';
  }
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }
  return os;
}
function getBrowserViewport() {
  return {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight
  };
}
function getMouseWheelEventName() {
  return /Firefox/i.test(navigator.userAgent) ? "DOMMouseScroll" : "mousewheel";
}
function isOffline() {
  return navigator && !navigator.onLine;
}
var modKey = detectPlatform() === 'Mac OS' ? '⌘' : 'ctrl';
var optionKey = detectPlatform() === 'Mac OS' ? '⌥' : 'alt';

/***/ }),

/***/ 53940:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(73210);
var window = __webpack_require__(95732);
var httpResponseHandler = function httpResponseHandler(callback, decodeResponseBody) {
  if (decodeResponseBody === void 0) {
    decodeResponseBody = false;
  }
  return function (err, response, responseBody) {
    // if the XHR failed, return that error
    if (err) {
      callback(err);
      return;
    } // if the HTTP status code is 4xx or 5xx, the request also failed

    if (response.statusCode >= 400 && response.statusCode <= 599) {
      var cause = responseBody;
      if (decodeResponseBody) {
        if (window.TextDecoder) {
          var charset = getCharset(response.headers && response.headers['content-type']);
          try {
            cause = new TextDecoder(charset).decode(responseBody);
          } catch (e) {}
        } else {
          cause = String.fromCharCode.apply(null, new Uint8Array(responseBody));
        }
      }
      callback({
        cause: cause
      });
      return;
    } // otherwise, request succeeded

    callback(null, responseBody);
  };
};
function getCharset(contentTypeHeader) {
  if (contentTypeHeader === void 0) {
    contentTypeHeader = '';
  }
  return contentTypeHeader.toLowerCase().split(';').reduce(function (charset, contentType) {
    var _contentType$split = contentType.split('='),
      type = _contentType$split[0],
      value = _contentType$split[1];
    if (type.trim() === 'charset') {
      return value.trim();
    }
    return charset;
  }, 'utf-8');
}
module.exports = httpResponseHandler;

/***/ }),

/***/ 3173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__(54747);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(73210);
__webpack_require__(47042);
var window = __webpack_require__(95732);
var _extends = __webpack_require__(36413);
var isFunction = __webpack_require__(73562);
createXHR.httpHandler = __webpack_require__(53940);
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */

var parseHeaders = function parseHeaders(headers) {
  var result = {};
  if (!headers) {
    return result;
  }
  headers.trim().split('\n').forEach(function (row) {
    var index = row.indexOf(':');
    var key = row.slice(0, index).trim().toLowerCase();
    var value = row.slice(index + 1).trim();
    if (typeof result[key] === 'undefined') {
      result[key] = value;
    } else if (Array.isArray(result[key])) {
      result[key].push(value);
    } else {
      result[key] = [result[key], value];
    }
  });
  return result;
};
module.exports = createXHR; // Allow use of default import syntax in TypeScript

module.exports["default"] = createXHR;
createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;
forEachArray(["get", "put", "post", "patch", "head", "delete"], function (method) {
  createXHR[method === "delete" ? "del" : method] = function (uri, options, callback) {
    options = initParams(uri, options, callback);
    options.method = method.toUpperCase();
    return _createXHR(options);
  };
});
function forEachArray(array, iterator) {
  for (var i = 0; i < array.length; i++) {
    iterator(array[i]);
  }
}
function isEmpty(obj) {
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) return false;
  }
  return true;
}
function initParams(uri, options, callback) {
  var params = uri;
  if (isFunction(options)) {
    callback = options;
    if (typeof uri === "string") {
      params = {
        uri: uri
      };
    }
  } else {
    params = _extends({}, options, {
      uri: uri
    });
  }
  params.callback = callback;
  return params;
}
function createXHR(uri, options, callback) {
  options = initParams(uri, options, callback);
  return _createXHR(options);
}
function _createXHR(options) {
  if (typeof options.callback === "undefined") {
    throw new Error("callback argument missing");
  }
  var called = false;
  var callback = function cbOnce(err, response, body) {
    if (!called) {
      called = true;
      options.callback(err, response, body);
    }
  };
  function readystatechange() {
    if (xhr.readyState === 4) {
      setTimeout(loadFunc, 0);
    }
  }
  function getBody() {
    // Chrome with requestType=blob throws errors arround when even testing access to responseText
    var body = undefined;
    if (xhr.response) {
      body = xhr.response;
    } else {
      body = xhr.responseText || getXml(xhr);
    }
    if (isJson) {
      try {
        body = JSON.parse(body);
      } catch (e) {}
    }
    return body;
  }
  function errorFunc(evt) {
    clearTimeout(timeoutTimer);
    if (!(evt instanceof Error)) {
      evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
    }
    evt.statusCode = 0;
    return callback(evt, failureResponse);
  } // will load the data & process the response in a special response object

  function loadFunc() {
    if (aborted) return;
    var status;
    clearTimeout(timeoutTimer);
    if (options.useXDR && xhr.status === undefined) {
      //IE8 CORS GET successful response doesn't have a status field, but body is fine
      status = 200;
    } else {
      status = xhr.status === 1223 ? 204 : xhr.status;
    }
    var response = failureResponse;
    var err = null;
    if (status !== 0) {
      response = {
        body: getBody(),
        statusCode: status,
        method: method,
        headers: {},
        url: uri,
        rawRequest: xhr
      };
      if (xhr.getAllResponseHeaders) {
        //remember xhr can in fact be XDR for CORS in IE
        response.headers = parseHeaders(xhr.getAllResponseHeaders());
      }
    } else {
      err = new Error("Internal XMLHttpRequest Error");
    }
    return callback(err, response, response.body);
  }
  var xhr = options.xhr || null;
  if (!xhr) {
    if (options.cors || options.useXDR) {
      xhr = new createXHR.XDomainRequest();
    } else {
      xhr = new createXHR.XMLHttpRequest();
    }
  }
  var key;
  var aborted;
  var uri = xhr.url = options.uri || options.url;
  var method = xhr.method = options.method || "GET";
  var body = options.body || options.data;
  var headers = xhr.headers = options.headers || {};
  var sync = !!options.sync;
  var isJson = false;
  var timeoutTimer;
  var failureResponse = {
    body: undefined,
    headers: {},
    statusCode: 0,
    method: method,
    url: uri,
    rawRequest: xhr
  };
  if ("json" in options && options.json !== false) {
    isJson = true;
    headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user

    if (method !== "GET" && method !== "HEAD") {
      headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user

      body = JSON.stringify(options.json === true ? body : options.json);
    }
  }
  xhr.onreadystatechange = readystatechange;
  xhr.onload = loadFunc;
  xhr.onerror = errorFunc; // IE9 must have onprogress be set to a unique function.

  xhr.onprogress = function () {// IE must die
  };
  xhr.onabort = function () {
    aborted = true;
  };
  xhr.ontimeout = errorFunc;
  xhr.open(method, uri, !sync, options.username, options.password); //has to be after open

  if (!sync) {
    xhr.withCredentials = !!options.withCredentials;
  } // Cannot set timeout with sync request
  // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
  // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent

  if (!sync && options.timeout > 0) {
    timeoutTimer = setTimeout(function () {
      if (aborted) return;
      aborted = true; //IE9 may still call readystatechange

      xhr.abort("timeout");
      var e = new Error("XMLHttpRequest timeout");
      e.code = "ETIMEDOUT";
      errorFunc(e);
    }, options.timeout);
  }
  if (xhr.setRequestHeader) {
    for (key in headers) {
      if (headers.hasOwnProperty(key)) {
        xhr.setRequestHeader(key, headers[key]);
      }
    }
  } else if (options.headers && !isEmpty(options.headers)) {
    throw new Error("Headers cannot be set on an XDomainRequest object");
  }
  if ("responseType" in options) {
    xhr.responseType = options.responseType;
  }
  if ("beforeSend" in options && typeof options.beforeSend === "function") {
    options.beforeSend(xhr);
  } // Microsoft Edge browser sends "undefined" when send is called with undefined value.
  // XMLHttpRequest spec says to pass null as body to indicate no body
  // See https://github.com/naugtur/xhr/issues/100.

  xhr.send(body || null);
  return xhr;
}
function getXml(xhr) {
  // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
  // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
  try {
    if (xhr.responseType === "document") {
      return xhr.responseXML;
    }
    var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
      return xhr.responseXML;
    }
  } catch (e) {}
  return null;
}
function noop() {}

/***/ }),

/***/ 62697:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(69826);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function find(list, predicate, ac) {
  if (ac === undefined) {
    ac = Array.prototype;
  }
  if (list && typeof ac.find === 'function') {
    return ac.find.call(list, predicate);
  }
  for (var i = 0; i < list.length; i++) {
    if (Object.prototype.hasOwnProperty.call(list, i)) {
      var item = list[i];
      if (predicate.call(undefined, item, i, list)) {
        return item;
      }
    }
  }
}

/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */
function freeze(object, oc) {
  if (oc === undefined) {
    oc = Object;
  }
  return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object;
}

/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */
function assign(target, source) {
  if (target === null || _typeof(target) !== 'object') {
    throw new TypeError('target is not an object');
  }
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  }
  return target;
}

/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */
var MIME_TYPE = freeze({
  /**
   * `text/html`, the only mime type that triggers treating an XML document as HTML.
   *
   * @see DOMParser.SupportedType.isHTML
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
   */
  HTML: 'text/html',
  /**
   * Helper method to check a mime type if it indicates an HTML document
   *
   * @param {string} [value]
   * @returns {boolean}
   *
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
  isHTML: function isHTML(value) {
    return value === MIME_TYPE.HTML;
  },
  /**
   * `application/xml`, the standard mime type for XML documents.
   *
   * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
   * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_APPLICATION: 'application/xml',
  /**
   * `text/html`, an alias for `application/xml`.
   *
   * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
   * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_TEXT: 'text/xml',
  /**
   * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
   * but is parsed as an XML document.
   *
   * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
   * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
   */
  XML_XHTML_APPLICATION: 'application/xhtml+xml',
  /**
   * `image/svg+xml`,
   *
   * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
   * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
   * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
   */
  XML_SVG_IMAGE: 'image/svg+xml'
});

/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */
var NAMESPACE = freeze({
  /**
   * The XHTML namespace.
   *
   * @see http://www.w3.org/1999/xhtml
   */
  HTML: 'http://www.w3.org/1999/xhtml',
  /**
   * Checks if `uri` equals `NAMESPACE.HTML`.
   *
   * @param {string} [uri]
   *
   * @see NAMESPACE.HTML
   */
  isHTML: function isHTML(uri) {
    return uri === NAMESPACE.HTML;
  },
  /**
   * The SVG namespace.
   *
   * @see http://www.w3.org/2000/svg
   */
  SVG: 'http://www.w3.org/2000/svg',
  /**
   * The `xml:` namespace.
   *
   * @see http://www.w3.org/XML/1998/namespace
   */
  XML: 'http://www.w3.org/XML/1998/namespace',
  /**
   * The `xmlns:` namespace
   *
   * @see https://www.w3.org/2000/xmlns/
   */
  XMLNS: 'http://www.w3.org/2000/xmlns/'
});
exports.assign = assign;
exports.find = find;
exports.freeze = freeze;
exports.MIME_TYPE = MIME_TYPE;
exports.NAMESPACE = NAMESPACE;

/***/ }),

/***/ 60522:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
__webpack_require__(74916);
__webpack_require__(15306);
var conventions = __webpack_require__(62697);
var dom = __webpack_require__(67102);
var entities = __webpack_require__(85653);
var sax = __webpack_require__(36752);
var DOMImplementation = dom.DOMImplementation;
var NAMESPACE = conventions.NAMESPACE;
var ParseError = sax.ParseError;
var XMLReader = sax.XMLReader;

/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */
function normalizeLineEndings(input) {
  return input.replace(/\r[\n\u0085]/g, '\n').replace(/[\r\u0085\u2028]/g, '\n');
}

/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */

/**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */

/**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */
function DOMParser(options) {
  this.options = options || {
    locator: {}
  };
}
DOMParser.prototype.parseFromString = function (source, mimeType) {
  var options = this.options;
  var sax = new XMLReader();
  var domBuilder = options.domBuilder || new DOMHandler(); //contentHandler and LexicalHandler
  var errorHandler = options.errorHandler;
  var locator = options.locator;
  var defaultNSMap = options.xmlns || {};
  var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
  var entityMap = isHTML ? entities.HTML_ENTITIES : entities.XML_ENTITIES;
  if (locator) {
    domBuilder.setDocumentLocator(locator);
  }
  sax.errorHandler = buildErrorHandler(errorHandler, domBuilder, locator);
  sax.domBuilder = options.domBuilder || domBuilder;
  if (isHTML) {
    defaultNSMap[''] = NAMESPACE.HTML;
  }
  defaultNSMap.xml = defaultNSMap.xml || NAMESPACE.XML;
  var normalize = options.normalizeLineEndings || normalizeLineEndings;
  if (source && typeof source === 'string') {
    sax.parse(normalize(source), defaultNSMap, entityMap);
  } else {
    sax.errorHandler.error('invalid doc source');
  }
  return domBuilder.doc;
};
function buildErrorHandler(errorImpl, domBuilder, locator) {
  if (!errorImpl) {
    if (domBuilder instanceof DOMHandler) {
      return domBuilder;
    }
    errorImpl = domBuilder;
  }
  var errorHandler = {};
  var isCallback = errorImpl instanceof Function;
  locator = locator || {};
  function build(key) {
    var fn = errorImpl[key];
    if (!fn && isCallback) {
      fn = errorImpl.length == 2 ? function (msg) {
        errorImpl(key, msg);
      } : errorImpl;
    }
    errorHandler[key] = fn && function (msg) {
      fn('[xmldom ' + key + ']\t' + msg + _locator(locator));
    } || function () {};
  }
  build('warning');
  build('error');
  build('fatalError');
  return errorHandler;
}

//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */
function DOMHandler() {
  this.cdata = false;
}
function position(locator, node) {
  node.lineNumber = locator.lineNumber;
  node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */
DOMHandler.prototype = {
  startDocument: function startDocument() {
    this.doc = new DOMImplementation().createDocument(null, null, null);
    if (this.locator) {
      this.doc.documentURI = this.locator.systemId;
    }
  },
  startElement: function startElement(namespaceURI, localName, qName, attrs) {
    var doc = this.doc;
    var el = doc.createElementNS(namespaceURI, qName || localName);
    var len = attrs.length;
    appendElement(this, el);
    this.currentElement = el;
    this.locator && position(this.locator, el);
    for (var i = 0; i < len; i++) {
      var namespaceURI = attrs.getURI(i);
      var value = attrs.getValue(i);
      var qName = attrs.getQName(i);
      var attr = doc.createAttributeNS(namespaceURI, qName);
      this.locator && position(attrs.getLocator(i), attr);
      attr.value = attr.nodeValue = value;
      el.setAttributeNode(attr);
    }
  },
  endElement: function endElement(namespaceURI, localName, qName) {
    var current = this.currentElement;
    var tagName = current.tagName;
    this.currentElement = current.parentNode;
  },
  startPrefixMapping: function startPrefixMapping(prefix, uri) {},
  endPrefixMapping: function endPrefixMapping(prefix) {},
  processingInstruction: function processingInstruction(target, data) {
    var ins = this.doc.createProcessingInstruction(target, data);
    this.locator && position(this.locator, ins);
    appendElement(this, ins);
  },
  ignorableWhitespace: function ignorableWhitespace(ch, start, length) {},
  characters: function characters(chars, start, length) {
    chars = _toString.apply(this, arguments);
    //console.log(chars)
    if (chars) {
      if (this.cdata) {
        var charNode = this.doc.createCDATASection(chars);
      } else {
        var charNode = this.doc.createTextNode(chars);
      }
      if (this.currentElement) {
        this.currentElement.appendChild(charNode);
      } else if (/^\s*$/.test(chars)) {
        this.doc.appendChild(charNode);
        //process xml
      }

      this.locator && position(this.locator, charNode);
    }
  },
  skippedEntity: function skippedEntity(name) {},
  endDocument: function endDocument() {
    this.doc.normalize();
  },
  setDocumentLocator: function setDocumentLocator(locator) {
    if (this.locator = locator) {
      // && !('lineNumber' in locator)){
      locator.lineNumber = 0;
    }
  },
  //LexicalHandler
  comment: function comment(chars, start, length) {
    chars = _toString.apply(this, arguments);
    var comm = this.doc.createComment(chars);
    this.locator && position(this.locator, comm);
    appendElement(this, comm);
  },
  startCDATA: function startCDATA() {
    //used in characters() methods
    this.cdata = true;
  },
  endCDATA: function endCDATA() {
    this.cdata = false;
  },
  startDTD: function startDTD(name, publicId, systemId) {
    var impl = this.doc.implementation;
    if (impl && impl.createDocumentType) {
      var dt = impl.createDocumentType(name, publicId, systemId);
      this.locator && position(this.locator, dt);
      appendElement(this, dt);
      this.doc.doctype = dt;
    }
  },
  /**
   * @see org.xml.sax.ErrorHandler
   * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
   */
  warning: function warning(error) {
    console.warn('[xmldom warning]\t' + error, _locator(this.locator));
  },
  error: function error(_error) {
    console.error('[xmldom error]\t' + _error, _locator(this.locator));
  },
  fatalError: function fatalError(error) {
    throw new ParseError(error, this.locator);
  }
};
function _locator(l) {
  if (l) {
    return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']';
  }
}
function _toString(chars, start, length) {
  if (typeof chars == 'string') {
    return chars.substr(start, length);
  } else {
    //java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
    if (chars.length >= start + length || start) {
      return new java.lang.String(chars, start, length) + '';
    }
    return chars;
  }
}

/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function (key) {
  DOMHandler.prototype[key] = function () {
    return null;
  };
});

/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
function appendElement(hander, node) {
  if (!hander.currentElement) {
    hander.doc.appendChild(node);
  } else {
    hander.currentElement.appendChild(node);
  }
} //appendChild and setAttributeNS are preformance key

__webpack_unused_export__ = DOMHandler;
__webpack_unused_export__ = normalizeLineEndings;
exports.DOMParser = DOMParser;

/***/ }),

/***/ 67102:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(69826);
__webpack_require__(57327);
__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(47941);
__webpack_require__(69600);
__webpack_require__(68309);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(15306);
__webpack_require__(47042);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
var conventions = __webpack_require__(62697);
var find = conventions.find;
var NAMESPACE = conventions.NAMESPACE;

/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */
function notEmptyString(input) {
  return input !== '';
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */
function splitOnASCIIWhitespace(input) {
  // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
  return input ? input.split(/[\t\n\f\r ]+/).filter(notEmptyString) : [];
}

/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */
function orderedSetReducer(current, element) {
  if (!current.hasOwnProperty(element)) {
    current[element] = true;
  }
  return current;
}

/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */
function toOrderedSet(input) {
  if (!input) return [];
  var list = splitOnASCIIWhitespace(input);
  return Object.keys(list.reduce(orderedSetReducer, {}));
}

/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */
function arrayIncludes(list) {
  return function (element) {
    return list && list.indexOf(element) !== -1;
  };
}
function copy(src, dest) {
  for (var p in src) {
    if (Object.prototype.hasOwnProperty.call(src, p)) {
      dest[p] = src[p];
    }
  }
}

/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */
function _extends(Class, Super) {
  var pt = Class.prototype;
  if (!(pt instanceof Super)) {
    function t() {}
    ;
    t.prototype = Super.prototype;
    t = new t();
    copy(pt, t);
    Class.prototype = pt = t;
  }
  if (pt.constructor != Class) {
    if (typeof Class != 'function') {
      console.error("unknown Class:" + Class);
    }
    pt.constructor = Class;
  }
}

// Node Types
var NodeType = {};
var ELEMENT_NODE = NodeType.ELEMENT_NODE = 1;
var ATTRIBUTE_NODE = NodeType.ATTRIBUTE_NODE = 2;
var TEXT_NODE = NodeType.TEXT_NODE = 3;
var CDATA_SECTION_NODE = NodeType.CDATA_SECTION_NODE = 4;
var ENTITY_REFERENCE_NODE = NodeType.ENTITY_REFERENCE_NODE = 5;
var ENTITY_NODE = NodeType.ENTITY_NODE = 6;
var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var COMMENT_NODE = NodeType.COMMENT_NODE = 8;
var DOCUMENT_NODE = NodeType.DOCUMENT_NODE = 9;
var DOCUMENT_TYPE_NODE = NodeType.DOCUMENT_TYPE_NODE = 10;
var DOCUMENT_FRAGMENT_NODE = NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var NOTATION_NODE = NodeType.NOTATION_NODE = 12;

// ExceptionCode
var ExceptionCode = {};
var ExceptionMessage = {};
var INDEX_SIZE_ERR = ExceptionCode.INDEX_SIZE_ERR = (ExceptionMessage[1] = "Index size error", 1);
var DOMSTRING_SIZE_ERR = ExceptionCode.DOMSTRING_SIZE_ERR = (ExceptionMessage[2] = "DOMString size error", 2);
var HIERARCHY_REQUEST_ERR = ExceptionCode.HIERARCHY_REQUEST_ERR = (ExceptionMessage[3] = "Hierarchy request error", 3);
var WRONG_DOCUMENT_ERR = ExceptionCode.WRONG_DOCUMENT_ERR = (ExceptionMessage[4] = "Wrong document", 4);
var INVALID_CHARACTER_ERR = ExceptionCode.INVALID_CHARACTER_ERR = (ExceptionMessage[5] = "Invalid character", 5);
var NO_DATA_ALLOWED_ERR = ExceptionCode.NO_DATA_ALLOWED_ERR = (ExceptionMessage[6] = "No data allowed", 6);
var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = (ExceptionMessage[7] = "No modification allowed", 7);
var NOT_FOUND_ERR = ExceptionCode.NOT_FOUND_ERR = (ExceptionMessage[8] = "Not found", 8);
var NOT_SUPPORTED_ERR = ExceptionCode.NOT_SUPPORTED_ERR = (ExceptionMessage[9] = "Not supported", 9);
var INUSE_ATTRIBUTE_ERR = ExceptionCode.INUSE_ATTRIBUTE_ERR = (ExceptionMessage[10] = "Attribute in use", 10);
//level2
var INVALID_STATE_ERR = ExceptionCode.INVALID_STATE_ERR = (ExceptionMessage[11] = "Invalid state", 11);
var SYNTAX_ERR = ExceptionCode.SYNTAX_ERR = (ExceptionMessage[12] = "Syntax error", 12);
var INVALID_MODIFICATION_ERR = ExceptionCode.INVALID_MODIFICATION_ERR = (ExceptionMessage[13] = "Invalid modification", 13);
var NAMESPACE_ERR = ExceptionCode.NAMESPACE_ERR = (ExceptionMessage[14] = "Invalid namespace", 14);
var INVALID_ACCESS_ERR = ExceptionCode.INVALID_ACCESS_ERR = (ExceptionMessage[15] = "Invalid access", 15);

/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */
function DOMException(code, message) {
  if (message instanceof Error) {
    var error = message;
  } else {
    error = this;
    Error.call(this, ExceptionMessage[code]);
    this.message = ExceptionMessage[code];
    if (Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
  }
  error.code = code;
  if (message) this.message = this.message + ": " + message;
  return error;
}
;
DOMException.prototype = Error.prototype;
copy(ExceptionCode, DOMException);

/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */
function NodeList() {}
;
NodeList.prototype = {
  /**
   * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
   * @standard level1
   */
  length: 0,
  /**
   * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
   * @standard level1
   * @param index  unsigned long
   *   Index into the collection.
   * @return Node
   * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
   */
  item: function item(index) {
    return index >= 0 && index < this.length ? this[index] : null;
  },
  toString: function toString(isHTML, nodeFilter) {
    for (var buf = [], i = 0; i < this.length; i++) {
      serializeToString(this[i], buf, isHTML, nodeFilter);
    }
    return buf.join('');
  },
  /**
   * @private
   * @param {function (Node):boolean} predicate
   * @returns {Node[]}
   */
  filter: function filter(predicate) {
    return Array.prototype.filter.call(this, predicate);
  },
  /**
   * @private
   * @param {Node} item
   * @returns {number}
   */
  indexOf: function indexOf(item) {
    return Array.prototype.indexOf.call(this, item);
  }
};
function LiveNodeList(node, refresh) {
  this._node = node;
  this._refresh = refresh;
  _updateLiveList(this);
}
function _updateLiveList(list) {
  var inc = list._node._inc || list._node.ownerDocument._inc;
  if (list._inc !== inc) {
    var ls = list._refresh(list._node);
    __set__(list, 'length', ls.length);
    if (!list.$$length || ls.length < list.$$length) {
      for (var i = ls.length; (i in list); i++) {
        if (Object.prototype.hasOwnProperty.call(list, i)) {
          delete list[i];
        }
      }
    }
    copy(ls, list);
    list._inc = inc;
  }
}
LiveNodeList.prototype.item = function (i) {
  _updateLiveList(this);
  return this[i] || null;
};
_extends(LiveNodeList, NodeList);

/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */
function NamedNodeMap() {}
;
function _findNodeIndex(list, node) {
  var i = list.length;
  while (i--) {
    if (list[i] === node) {
      return i;
    }
  }
}
function _addNamedNode(el, list, newAttr, oldAttr) {
  if (oldAttr) {
    list[_findNodeIndex(list, oldAttr)] = newAttr;
  } else {
    list[list.length++] = newAttr;
  }
  if (el) {
    newAttr.ownerElement = el;
    var doc = el.ownerDocument;
    if (doc) {
      oldAttr && _onRemoveAttribute(doc, el, oldAttr);
      _onAddAttribute(doc, el, newAttr);
    }
  }
}
function _removeNamedNode(el, list, attr) {
  //console.log('remove attr:'+attr)
  var i = _findNodeIndex(list, attr);
  if (i >= 0) {
    var lastIndex = list.length - 1;
    while (i < lastIndex) {
      list[i] = list[++i];
    }
    list.length = lastIndex;
    if (el) {
      var doc = el.ownerDocument;
      if (doc) {
        _onRemoveAttribute(doc, el, attr);
        attr.ownerElement = null;
      }
    }
  } else {
    throw new DOMException(NOT_FOUND_ERR, new Error(el.tagName + '@' + attr));
  }
}
NamedNodeMap.prototype = {
  length: 0,
  item: NodeList.prototype.item,
  getNamedItem: function getNamedItem(key) {
    //		if(key.indexOf(':')>0 || key == 'xmlns'){
    //			return null;
    //		}
    //console.log()
    var i = this.length;
    while (i--) {
      var attr = this[i];
      //console.log(attr.nodeName,key)
      if (attr.nodeName == key) {
        return attr;
      }
    }
  },
  setNamedItem: function setNamedItem(attr) {
    var el = attr.ownerElement;
    if (el && el != this._ownerElement) {
      throw new DOMException(INUSE_ATTRIBUTE_ERR);
    }
    var oldAttr = this.getNamedItem(attr.nodeName);
    _addNamedNode(this._ownerElement, this, attr, oldAttr);
    return oldAttr;
  },
  /* returns Node */
  setNamedItemNS: function setNamedItemNS(attr) {
    // raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
    var el = attr.ownerElement,
      oldAttr;
    if (el && el != this._ownerElement) {
      throw new DOMException(INUSE_ATTRIBUTE_ERR);
    }
    oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
    _addNamedNode(this._ownerElement, this, attr, oldAttr);
    return oldAttr;
  },
  /* returns Node */
  removeNamedItem: function removeNamedItem(key) {
    var attr = this.getNamedItem(key);
    _removeNamedNode(this._ownerElement, this, attr);
    return attr;
  },
  // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR

  //for level2
  removeNamedItemNS: function removeNamedItemNS(namespaceURI, localName) {
    var attr = this.getNamedItemNS(namespaceURI, localName);
    _removeNamedNode(this._ownerElement, this, attr);
    return attr;
  },
  getNamedItemNS: function getNamedItemNS(namespaceURI, localName) {
    var i = this.length;
    while (i--) {
      var node = this[i];
      if (node.localName == localName && node.namespaceURI == namespaceURI) {
        return node;
      }
    }
    return null;
  }
};

/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */
function DOMImplementation() {}
DOMImplementation.prototype = {
  /**
   * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
   * The different implementations fairly diverged in what kind of features were reported.
   * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
   *
   * @deprecated It is deprecated and modern browsers return true in all cases.
   *
   * @param {string} feature
   * @param {string} [version]
   * @returns {boolean} always true
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
   * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
   */
  hasFeature: function hasFeature(feature, version) {
    return true;
  },
  /**
   * Creates an XML Document object of the specified type with its document element.
   *
   * __It behaves slightly different from the description in the living standard__:
   * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
   * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string|null} namespaceURI
   * @param {string} qualifiedName
   * @param {DocumentType=null} doctype
   * @returns {Document}
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocument: function createDocument(namespaceURI, qualifiedName, doctype) {
    var doc = new Document();
    doc.implementation = this;
    doc.childNodes = new NodeList();
    doc.doctype = doctype || null;
    if (doctype) {
      doc.appendChild(doctype);
    }
    if (qualifiedName) {
      var root = doc.createElementNS(namespaceURI, qualifiedName);
      doc.appendChild(root);
    }
    return doc;
  },
  /**
   * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
   *
   * __This behavior is slightly different from the in the specs__:
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string} qualifiedName
   * @param {string} [publicId]
   * @param {string} [systemId]
   * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
   * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocumentType: function createDocumentType(qualifiedName, publicId, systemId) {
    var node = new DocumentType();
    node.name = qualifiedName;
    node.nodeName = qualifiedName;
    node.publicId = publicId || '';
    node.systemId = systemId || '';
    return node;
  }
};

/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */

function Node() {}
;
Node.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  // Modified in DOM Level 2:
  insertBefore: function insertBefore(newChild, refChild) {
    //raises
    return _insertBefore(this, newChild, refChild);
  },
  replaceChild: function replaceChild(newChild, oldChild) {
    //raises
    _insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
    if (oldChild) {
      this.removeChild(oldChild);
    }
  },
  removeChild: function removeChild(oldChild) {
    return _removeChild(this, oldChild);
  },
  appendChild: function appendChild(newChild) {
    return this.insertBefore(newChild, null);
  },
  hasChildNodes: function hasChildNodes() {
    return this.firstChild != null;
  },
  cloneNode: function cloneNode(deep) {
    return _cloneNode(this.ownerDocument || this, this, deep);
  },
  // Modified in DOM Level 2:
  normalize: function normalize() {
    var child = this.firstChild;
    while (child) {
      var next = child.nextSibling;
      if (next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE) {
        this.removeChild(next);
        child.appendData(next.data);
      } else {
        child.normalize();
        child = next;
      }
    }
  },
  // Introduced in DOM Level 2:
  isSupported: function isSupported(feature, version) {
    return this.ownerDocument.implementation.hasFeature(feature, version);
  },
  // Introduced in DOM Level 2:
  hasAttributes: function hasAttributes() {
    return this.attributes.length > 0;
  },
  /**
   * Look up the prefix associated to the given namespace URI, starting from this node.
   * **The default namespace declarations are ignored by this method.**
   * See Namespace Prefix Lookup for details on the algorithm used by this method.
   *
   * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
   *
   * @param {string | null} namespaceURI
   * @returns {string | null}
   * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
   * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
   * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
   * @see https://github.com/xmldom/xmldom/issues/322
   */
  lookupPrefix: function lookupPrefix(namespaceURI) {
    var el = this;
    while (el) {
      var map = el._nsMap;
      //console.dir(map)
      if (map) {
        for (var n in map) {
          if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) {
            return n;
          }
        }
      }
      el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  lookupNamespaceURI: function lookupNamespaceURI(prefix) {
    var el = this;
    while (el) {
      var map = el._nsMap;
      //console.dir(map)
      if (map) {
        if (Object.prototype.hasOwnProperty.call(map, prefix)) {
          return map[prefix];
        }
      }
      el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  isDefaultNamespace: function isDefaultNamespace(namespaceURI) {
    var prefix = this.lookupPrefix(namespaceURI);
    return prefix == null;
  }
};
function _xmlEncoder(c) {
  return c == '<' && '&lt;' || c == '>' && '&gt;' || c == '&' && '&amp;' || c == '"' && '&quot;' || '&#' + c.charCodeAt() + ';';
}
copy(NodeType, Node);
copy(NodeType, Node.prototype);

/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */
function _visitNode(node, callback) {
  if (callback(node)) {
    return true;
  }
  if (node = node.firstChild) {
    do {
      if (_visitNode(node, callback)) {
        return true;
      }
    } while (node = node.nextSibling);
  }
}
function Document() {
  this.ownerDocument = this;
}
function _onAddAttribute(doc, el, newAttr) {
  doc && doc._inc++;
  var ns = newAttr.namespaceURI;
  if (ns === NAMESPACE.XMLNS) {
    //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value;
  }
}
function _onRemoveAttribute(doc, el, newAttr, remove) {
  doc && doc._inc++;
  var ns = newAttr.namespaceURI;
  if (ns === NAMESPACE.XMLNS) {
    //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ''];
  }
}

/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */
function _onUpdateChild(doc, el, newChild) {
  if (doc && doc._inc) {
    doc._inc++;
    //update childNodes
    var cs = el.childNodes;
    if (newChild) {
      cs[cs.length++] = newChild;
    } else {
      var child = el.firstChild;
      var i = 0;
      while (child) {
        cs[i++] = child;
        child = child.nextSibling;
      }
      cs.length = i;
      delete cs[cs.length];
    }
  }
}

/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */
function _removeChild(parentNode, child) {
  var previous = child.previousSibling;
  var next = child.nextSibling;
  if (previous) {
    previous.nextSibling = next;
  } else {
    parentNode.firstChild = next;
  }
  if (next) {
    next.previousSibling = previous;
  } else {
    parentNode.lastChild = previous;
  }
  child.parentNode = null;
  child.previousSibling = null;
  child.nextSibling = null;
  _onUpdateChild(parentNode.ownerDocument, parentNode);
  return child;
}

/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */
function hasValidParentNodeType(node) {
  return node && (node.nodeType === Node.DOCUMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node.ELEMENT_NODE);
}

/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */
function hasInsertableNodeType(node) {
  return node && (isElementNode(node) || isTextNode(node) || isDocTypeNode(node) || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node.COMMENT_NODE || node.nodeType === Node.PROCESSING_INSTRUCTION_NODE);
}

/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */
function isDocTypeNode(node) {
  return node && node.nodeType === Node.DOCUMENT_TYPE_NODE;
}

/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */
function isElementNode(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */
function isTextNode(node) {
  return node && node.nodeType === Node.TEXT_NODE;
}

/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */
function isElementInsertionPossible(doc, child) {
  var parentChildNodes = doc.childNodes || [];
  if (find(parentChildNodes, isElementNode) || isDocTypeNode(child)) {
    return false;
  }
  var docTypeNode = find(parentChildNodes, isDocTypeNode);
  return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}

/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */
function isElementReplacementPossible(doc, child) {
  var parentChildNodes = doc.childNodes || [];
  function hasElementChildThatIsNotChild(node) {
    return isElementNode(node) && node !== child;
  }
  if (find(parentChildNodes, hasElementChildThatIsNotChild)) {
    return false;
  }
  var docTypeNode = find(parentChildNodes, isDocTypeNode);
  return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}

/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */
function assertPreInsertionValidity1to5(parent, node, child) {
  // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
  if (!hasValidParentNodeType(parent)) {
    throw new DOMException(HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
  }
  // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
  // not implemented!
  // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
  if (child && child.parentNode !== parent) {
    throw new DOMException(NOT_FOUND_ERR, 'child not in parent');
  }
  if (
  // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
  !hasInsertableNodeType(node) || isDocTypeNode(node) && parent.nodeType !== Node.DOCUMENT_NODE) {
    throw new DOMException(HIERARCHY_REQUEST_ERR, 'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType);
  }
}

/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */
function assertPreInsertionValidityInDocument(parent, node, child) {
  var parentChildNodes = parent.childNodes || [];
  var nodeChildNodes = node.childNodes || [];

  // DocumentFragment
  if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
    var nodeChildElements = nodeChildNodes.filter(isElementNode);
    // If node has more than one element child or has a Text node child.
    if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
    }
    // Otherwise, if `node` has one element child and either `parent` has an element child,
    // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
    if (nodeChildElements.length === 1 && !isElementInsertionPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
  }
  // Element
  if (isElementNode(node)) {
    // `parent` has an element child, `child` is a doctype,
    // or `child` is non-null and a doctype is following `child`.
    if (!isElementInsertionPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
  }
  // DocumentType
  if (isDocTypeNode(node)) {
    // `parent` has a doctype child,
    if (find(parentChildNodes, isDocTypeNode)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
    }
    var parentElementChild = find(parentChildNodes, isElementNode);
    // `child` is non-null and an element is preceding `child`,
    if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
    }
    // or `child` is null and `parent` has an element child.
    if (!child && parentElementChild) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
    }
  }
}

/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */
function assertPreReplacementValidityInDocument(parent, node, child) {
  var parentChildNodes = parent.childNodes || [];
  var nodeChildNodes = node.childNodes || [];

  // DocumentFragment
  if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
    var nodeChildElements = nodeChildNodes.filter(isElementNode);
    // If `node` has more than one element child or has a Text node child.
    if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
    }
    // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
    if (nodeChildElements.length === 1 && !isElementReplacementPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
  }
  // Element
  if (isElementNode(node)) {
    // `parent` has an element child that is not `child` or a doctype is following `child`.
    if (!isElementReplacementPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
  }
  // DocumentType
  if (isDocTypeNode(node)) {
    function hasDoctypeChildThatIsNotChild(node) {
      return isDocTypeNode(node) && node !== child;
    }

    // `parent` has a doctype child that is not `child`,
    if (find(parentChildNodes, hasDoctypeChildThatIsNotChild)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
    }
    var parentElementChild = find(parentChildNodes, isElementNode);
    // or an element is preceding `child`.
    if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
    }
  }
}

/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */
function _insertBefore(parent, node, child, _inDocumentAssertion) {
  // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
  assertPreInsertionValidity1to5(parent, node, child);

  // If parent is a document, and any of the statements below, switched on the interface node implements,
  // are true, then throw a "HierarchyRequestError" DOMException.
  if (parent.nodeType === Node.DOCUMENT_NODE) {
    (_inDocumentAssertion || assertPreInsertionValidityInDocument)(parent, node, child);
  }
  var cp = node.parentNode;
  if (cp) {
    cp.removeChild(node); //remove and update
  }

  if (node.nodeType === DOCUMENT_FRAGMENT_NODE) {
    var newFirst = node.firstChild;
    if (newFirst == null) {
      return node;
    }
    var newLast = node.lastChild;
  } else {
    newFirst = newLast = node;
  }
  var pre = child ? child.previousSibling : parent.lastChild;
  newFirst.previousSibling = pre;
  newLast.nextSibling = child;
  if (pre) {
    pre.nextSibling = newFirst;
  } else {
    parent.firstChild = newFirst;
  }
  if (child == null) {
    parent.lastChild = newLast;
  } else {
    child.previousSibling = newLast;
  }
  do {
    newFirst.parentNode = parent;
    // Update ownerDocument for each node being inserted
    var targetDoc = parent.ownerDocument || parent;
    _updateOwnerDocument(newFirst, targetDoc);
  } while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
  _onUpdateChild(parent.ownerDocument || parent, parent);
  //console.log(parent.lastChild.nextSibling == null)
  if (node.nodeType == DOCUMENT_FRAGMENT_NODE) {
    node.firstChild = node.lastChild = null;
  }
  return node;
}

/**
 * Recursively updates the ownerDocument property for a node and all its descendants
 * @param {Node} node
 * @param {Document} newOwnerDocument
 * @private
 */
function _updateOwnerDocument(node, newOwnerDocument) {
  if (node.ownerDocument === newOwnerDocument) {
    return;
  }
  node.ownerDocument = newOwnerDocument;

  // Update attributes if this is an element
  if (node.nodeType === ELEMENT_NODE && node.attributes) {
    for (var i = 0; i < node.attributes.length; i++) {
      var attr = node.attributes.item(i);
      if (attr) {
        attr.ownerDocument = newOwnerDocument;
      }
    }
  }

  // Recursively update child nodes
  var child = node.firstChild;
  while (child) {
    _updateOwnerDocument(child, newOwnerDocument);
    child = child.nextSibling;
  }
}

/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */
function _appendSingleChild(parentNode, newChild) {
  if (newChild.parentNode) {
    newChild.parentNode.removeChild(newChild);
  }
  newChild.parentNode = parentNode;
  newChild.previousSibling = parentNode.lastChild;
  newChild.nextSibling = null;
  if (newChild.previousSibling) {
    newChild.previousSibling.nextSibling = newChild;
  } else {
    parentNode.firstChild = newChild;
  }
  parentNode.lastChild = newChild;
  _onUpdateChild(parentNode.ownerDocument, parentNode, newChild);

  // Update ownerDocument for the new child and all its descendants
  var targetDoc = parentNode.ownerDocument || parentNode;
  _updateOwnerDocument(newChild, targetDoc);
  return newChild;
}
Document.prototype = {
  //implementation : null,
  nodeName: '#document',
  nodeType: DOCUMENT_NODE,
  /**
   * The DocumentType node of the document.
   *
   * @readonly
   * @type DocumentType
   */
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function insertBefore(newChild, refChild) {
    //raises
    if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
      var child = newChild.firstChild;
      while (child) {
        var next = child.nextSibling;
        this.insertBefore(child, refChild);
        child = next;
      }
      return newChild;
    }
    _insertBefore(this, newChild, refChild);
    _updateOwnerDocument(newChild, this);
    if (this.documentElement === null && newChild.nodeType === ELEMENT_NODE) {
      this.documentElement = newChild;
    }
    return newChild;
  },
  removeChild: function removeChild(oldChild) {
    if (this.documentElement == oldChild) {
      this.documentElement = null;
    }
    return _removeChild(this, oldChild);
  },
  replaceChild: function replaceChild(newChild, oldChild) {
    //raises
    _insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
    _updateOwnerDocument(newChild, this);
    if (oldChild) {
      this.removeChild(oldChild);
    }
    if (isElementNode(newChild)) {
      this.documentElement = newChild;
    }
  },
  // Introduced in DOM Level 2:
  importNode: function importNode(importedNode, deep) {
    return _importNode(this, importedNode, deep);
  },
  // Introduced in DOM Level 2:
  getElementById: function getElementById(id) {
    var rtv = null;
    _visitNode(this.documentElement, function (node) {
      if (node.nodeType == ELEMENT_NODE) {
        if (node.getAttribute('id') == id) {
          rtv = node;
          return true;
        }
      }
    });
    return rtv;
  },
  /**
   * The `getElementsByClassName` method of `Document` interface returns an array-like object
   * of all child elements which have **all** of the given class name(s).
   *
   * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
   *
   *
   * Warning: This is a live LiveNodeList.
   * Changes in the DOM will reflect in the array as the changes occur.
   * If an element selected by this array no longer qualifies for the selector,
   * it will automatically be removed. Be aware of this for iteration purposes.
   *
   * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
   * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
   */
  getElementsByClassName: function getElementsByClassName(classNames) {
    var classNamesSet = toOrderedSet(classNames);
    return new LiveNodeList(this, function (base) {
      var ls = [];
      if (classNamesSet.length > 0) {
        _visitNode(base.documentElement, function (node) {
          if (node !== base && node.nodeType === ELEMENT_NODE) {
            var nodeClassNames = node.getAttribute('class');
            // can be null if the attribute does not exist
            if (nodeClassNames) {
              // before splitting and iterating just compare them for the most common case
              var matches = classNames === nodeClassNames;
              if (!matches) {
                var nodeClassNamesSet = toOrderedSet(nodeClassNames);
                matches = classNamesSet.every(arrayIncludes(nodeClassNamesSet));
              }
              if (matches) {
                ls.push(node);
              }
            }
          }
        });
      }
      return ls;
    });
  },
  //document factory method:
  createElement: function createElement(tagName) {
    var node = new Element();
    node.ownerDocument = this;
    node.nodeName = tagName;
    node.tagName = tagName;
    node.localName = tagName;
    node.childNodes = new NodeList();
    var attrs = node.attributes = new NamedNodeMap();
    attrs._ownerElement = node;
    return node;
  },
  createDocumentFragment: function createDocumentFragment() {
    var node = new DocumentFragment();
    node.ownerDocument = this;
    node.childNodes = new NodeList();
    return node;
  },
  createTextNode: function createTextNode(data) {
    var node = new Text();
    node.ownerDocument = this;
    node.appendData(data);
    return node;
  },
  createComment: function createComment(data) {
    var node = new Comment();
    node.ownerDocument = this;
    node.appendData(data);
    return node;
  },
  createCDATASection: function createCDATASection(data) {
    var node = new CDATASection();
    node.ownerDocument = this;
    node.appendData(data);
    return node;
  },
  createProcessingInstruction: function createProcessingInstruction(target, data) {
    var node = new ProcessingInstruction();
    node.ownerDocument = this;
    node.tagName = node.nodeName = node.target = target;
    node.nodeValue = node.data = data;
    return node;
  },
  createAttribute: function createAttribute(name) {
    var node = new Attr();
    node.ownerDocument = this;
    node.name = name;
    node.nodeName = name;
    node.localName = name;
    node.specified = true;
    return node;
  },
  createEntityReference: function createEntityReference(name) {
    var node = new EntityReference();
    node.ownerDocument = this;
    node.nodeName = name;
    return node;
  },
  // Introduced in DOM Level 2:
  createElementNS: function createElementNS(namespaceURI, qualifiedName) {
    var node = new Element();
    var pl = qualifiedName.split(':');
    var attrs = node.attributes = new NamedNodeMap();
    node.childNodes = new NodeList();
    node.ownerDocument = this;
    node.nodeName = qualifiedName;
    node.tagName = qualifiedName;
    node.namespaceURI = namespaceURI;
    if (pl.length == 2) {
      node.prefix = pl[0];
      node.localName = pl[1];
    } else {
      //el.prefix = null;
      node.localName = qualifiedName;
    }
    attrs._ownerElement = node;
    return node;
  },
  // Introduced in DOM Level 2:
  createAttributeNS: function createAttributeNS(namespaceURI, qualifiedName) {
    var node = new Attr();
    var pl = qualifiedName.split(':');
    node.ownerDocument = this;
    node.nodeName = qualifiedName;
    node.name = qualifiedName;
    node.namespaceURI = namespaceURI;
    node.specified = true;
    if (pl.length == 2) {
      node.prefix = pl[0];
      node.localName = pl[1];
    } else {
      //el.prefix = null;
      node.localName = qualifiedName;
    }
    return node;
  }
};
_extends(Document, Node);
function Element() {
  this._nsMap = {};
}
;
Element.prototype = {
  nodeType: ELEMENT_NODE,
  hasAttribute: function hasAttribute(name) {
    return this.getAttributeNode(name) != null;
  },
  getAttribute: function getAttribute(name) {
    var attr = this.getAttributeNode(name);
    return attr && attr.value || '';
  },
  getAttributeNode: function getAttributeNode(name) {
    return this.attributes.getNamedItem(name);
  },
  setAttribute: function setAttribute(name, value) {
    var attr = this.ownerDocument.createAttribute(name);
    attr.value = attr.nodeValue = "" + value;
    this.setAttributeNode(attr);
  },
  removeAttribute: function removeAttribute(name) {
    var attr = this.getAttributeNode(name);
    attr && this.removeAttributeNode(attr);
  },
  //four real opeartion method
  appendChild: function appendChild(newChild) {
    if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
      return this.insertBefore(newChild, null);
    } else {
      return _appendSingleChild(this, newChild);
    }
  },
  setAttributeNode: function setAttributeNode(newAttr) {
    return this.attributes.setNamedItem(newAttr);
  },
  setAttributeNodeNS: function setAttributeNodeNS(newAttr) {
    return this.attributes.setNamedItemNS(newAttr);
  },
  removeAttributeNode: function removeAttributeNode(oldAttr) {
    //console.log(this == oldAttr.ownerElement)
    return this.attributes.removeNamedItem(oldAttr.nodeName);
  },
  //get real attribute name,and remove it by removeAttributeNode
  removeAttributeNS: function removeAttributeNS(namespaceURI, localName) {
    var old = this.getAttributeNodeNS(namespaceURI, localName);
    old && this.removeAttributeNode(old);
  },
  hasAttributeNS: function hasAttributeNS(namespaceURI, localName) {
    return this.getAttributeNodeNS(namespaceURI, localName) != null;
  },
  getAttributeNS: function getAttributeNS(namespaceURI, localName) {
    var attr = this.getAttributeNodeNS(namespaceURI, localName);
    return attr && attr.value || '';
  },
  setAttributeNS: function setAttributeNS(namespaceURI, qualifiedName, value) {
    var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
    attr.value = attr.nodeValue = "" + value;
    this.setAttributeNode(attr);
  },
  getAttributeNodeNS: function getAttributeNodeNS(namespaceURI, localName) {
    return this.attributes.getNamedItemNS(namespaceURI, localName);
  },
  getElementsByTagName: function getElementsByTagName(tagName) {
    return new LiveNodeList(this, function (base) {
      var ls = [];
      _visitNode(base, function (node) {
        if (node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) {
          ls.push(node);
        }
      });
      return ls;
    });
  },
  getElementsByTagNameNS: function getElementsByTagNameNS(namespaceURI, localName) {
    return new LiveNodeList(this, function (base) {
      var ls = [];
      _visitNode(base, function (node) {
        if (node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) {
          ls.push(node);
        }
      });
      return ls;
    });
  }
};
Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;
_extends(Element, Node);
function Attr() {}
;
Attr.prototype.nodeType = ATTRIBUTE_NODE;
_extends(Attr, Node);
function CharacterData() {}
;
CharacterData.prototype = {
  data: '',
  substringData: function substringData(offset, count) {
    return this.data.substring(offset, offset + count);
  },
  appendData: function appendData(text) {
    text = this.data + text;
    this.nodeValue = this.data = text;
    this.length = text.length;
  },
  insertData: function insertData(offset, text) {
    this.replaceData(offset, 0, text);
  },
  appendChild: function appendChild(newChild) {
    throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR]);
  },
  deleteData: function deleteData(offset, count) {
    this.replaceData(offset, count, "");
  },
  replaceData: function replaceData(offset, count, text) {
    var start = this.data.substring(0, offset);
    var end = this.data.substring(offset + count);
    text = start + text + end;
    this.nodeValue = this.data = text;
    this.length = text.length;
  }
};
_extends(CharacterData, Node);
function Text() {}
;
Text.prototype = {
  nodeName: "#text",
  nodeType: TEXT_NODE,
  splitText: function splitText(offset) {
    var text = this.data;
    var newText = text.substring(offset);
    text = text.substring(0, offset);
    this.data = this.nodeValue = text;
    this.length = text.length;
    var newNode = this.ownerDocument.createTextNode(newText);
    if (this.parentNode) {
      this.parentNode.insertBefore(newNode, this.nextSibling);
    }
    return newNode;
  }
};
_extends(Text, CharacterData);
function Comment() {}
;
Comment.prototype = {
  nodeName: "#comment",
  nodeType: COMMENT_NODE
};
_extends(Comment, CharacterData);
function CDATASection() {}
;
CDATASection.prototype = {
  nodeName: "#cdata-section",
  nodeType: CDATA_SECTION_NODE
};
_extends(CDATASection, CharacterData);
function DocumentType() {}
;
DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
_extends(DocumentType, Node);
function Notation() {}
;
Notation.prototype.nodeType = NOTATION_NODE;
_extends(Notation, Node);
function Entity() {}
;
Entity.prototype.nodeType = ENTITY_NODE;
_extends(Entity, Node);
function EntityReference() {}
;
EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
_extends(EntityReference, Node);
function DocumentFragment() {}
;
DocumentFragment.prototype.nodeName = "#document-fragment";
DocumentFragment.prototype.nodeType = DOCUMENT_FRAGMENT_NODE;
_extends(DocumentFragment, Node);
function ProcessingInstruction() {}
ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
_extends(ProcessingInstruction, Node);
function XMLSerializer() {}
XMLSerializer.prototype.serializeToString = function (node, isHtml, nodeFilter) {
  return nodeSerializeToString.call(node, isHtml, nodeFilter);
};
Node.prototype.toString = nodeSerializeToString;
function nodeSerializeToString(isHtml, nodeFilter) {
  var buf = [];
  var refNode = this.nodeType == 9 && this.documentElement || this;
  var prefix = refNode.prefix;
  var uri = refNode.namespaceURI;
  if (uri && prefix == null) {
    //console.log(prefix)
    var prefix = refNode.lookupPrefix(uri);
    if (prefix == null) {
      //isHTML = true;
      var visibleNamespaces = [{
        namespace: uri,
        prefix: null
      }
      //{namespace:uri,prefix:''}
      ];
    }
  }

  serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
  //console.log('###',this.nodeType,uri,prefix,buf.join(''))
  return buf.join('');
}
function needNamespaceDefine(node, isHTML, visibleNamespaces) {
  var prefix = node.prefix || '';
  var uri = node.namespaceURI;
  // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
  // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
  // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
  // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
  // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
  // > [...] Furthermore, the attribute value [...] must not be an empty string.
  // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
  if (!uri) {
    return false;
  }
  if (prefix === "xml" && uri === NAMESPACE.XML || uri === NAMESPACE.XMLNS) {
    return false;
  }
  var i = visibleNamespaces.length;
  while (i--) {
    var ns = visibleNamespaces[i];
    // get namespace prefix
    if (ns.prefix === prefix) {
      return ns.namespace !== uri;
    }
  }
  return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */
function addSerializedAttribute(buf, qualifiedName, value) {
  buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, _xmlEncoder), '"');
}
function serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
  if (!visibleNamespaces) {
    visibleNamespaces = [];
  }
  if (nodeFilter) {
    node = nodeFilter(node);
    if (node) {
      if (typeof node == 'string') {
        buf.push(node);
        return;
      }
    } else {
      return;
    }
    //buf.sort.apply(attrs, attributeSorter);
  }

  switch (node.nodeType) {
    case ELEMENT_NODE:
      var attrs = node.attributes;
      var len = attrs.length;
      var child = node.firstChild;
      var nodeName = node.tagName;
      isHTML = NAMESPACE.isHTML(node.namespaceURI) || isHTML;
      var prefixedNodeName = nodeName;
      if (!isHTML && !node.prefix && node.namespaceURI) {
        var defaultNS;
        // lookup current default ns from `xmlns` attribute
        for (var ai = 0; ai < attrs.length; ai++) {
          if (attrs.item(ai).name === 'xmlns') {
            defaultNS = attrs.item(ai).value;
            break;
          }
        }
        if (!defaultNS) {
          // lookup current default ns in visibleNamespaces
          for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
            var namespace = visibleNamespaces[nsi];
            if (namespace.prefix === '' && namespace.namespace === node.namespaceURI) {
              defaultNS = namespace.namespace;
              break;
            }
          }
        }
        if (defaultNS !== node.namespaceURI) {
          for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
            var namespace = visibleNamespaces[nsi];
            if (namespace.namespace === node.namespaceURI) {
              if (namespace.prefix) {
                prefixedNodeName = namespace.prefix + ':' + nodeName;
              }
              break;
            }
          }
        }
      }
      buf.push('<', prefixedNodeName);
      for (var i = 0; i < len; i++) {
        // add namespaces for attributes
        var attr = attrs.item(i);
        if (attr.prefix == 'xmlns') {
          visibleNamespaces.push({
            prefix: attr.localName,
            namespace: attr.value
          });
        } else if (attr.nodeName == 'xmlns') {
          visibleNamespaces.push({
            prefix: '',
            namespace: attr.value
          });
        }
      }
      for (var i = 0; i < len; i++) {
        var attr = attrs.item(i);
        if (needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
          var prefix = attr.prefix || '';
          var uri = attr.namespaceURI;
          addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
          visibleNamespaces.push({
            prefix: prefix,
            namespace: uri
          });
        }
        serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
      }

      // add namespace for current node
      if (nodeName === prefixedNodeName && needNamespaceDefine(node, isHTML, visibleNamespaces)) {
        var prefix = node.prefix || '';
        var uri = node.namespaceURI;
        addSerializedAttribute(buf, prefix ? 'xmlns:' + prefix : "xmlns", uri);
        visibleNamespaces.push({
          prefix: prefix,
          namespace: uri
        });
      }
      if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
        buf.push('>');
        //if is cdata child node
        if (isHTML && /^script$/i.test(nodeName)) {
          while (child) {
            if (child.data) {
              buf.push(child.data);
            } else {
              serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
            }
            child = child.nextSibling;
          }
        } else {
          while (child) {
            serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
            child = child.nextSibling;
          }
        }
        buf.push('</', prefixedNodeName, '>');
      } else {
        buf.push('/>');
      }
      // remove added visible namespaces
      //visibleNamespaces.length = startVisibleNamespaces;
      return;
    case DOCUMENT_NODE:
    case DOCUMENT_FRAGMENT_NODE:
      var child = node.firstChild;
      while (child) {
        serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
        child = child.nextSibling;
      }
      return;
    case ATTRIBUTE_NODE:
      return addSerializedAttribute(buf, node.name, node.value);
    case TEXT_NODE:
      /**
       * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
       * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
       * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
       * `&amp;` and `&lt;` respectively.
       * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
       * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
       * when that string is not marking the end of a CDATA section.
       *
       * In the content of elements, character data is any string of characters
       * which does not contain the start-delimiter of any markup
       * and does not include the CDATA-section-close delimiter, `]]>`.
       *
       * @see https://www.w3.org/TR/xml/#NT-CharData
       * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
       */
      return buf.push(node.data.replace(/[<&>]/g, _xmlEncoder));
    case CDATA_SECTION_NODE:
      return buf.push('<![CDATA[', node.data, ']]>');
    case COMMENT_NODE:
      return buf.push("<!--", node.data, "-->");
    case DOCUMENT_TYPE_NODE:
      var pubid = node.publicId;
      var sysid = node.systemId;
      buf.push('<!DOCTYPE ', node.name);
      if (pubid) {
        buf.push(' PUBLIC ', pubid);
        if (sysid && sysid != '.') {
          buf.push(' ', sysid);
        }
        buf.push('>');
      } else if (sysid && sysid != '.') {
        buf.push(' SYSTEM ', sysid, '>');
      } else {
        var sub = node.internalSubset;
        if (sub) {
          buf.push(" [", sub, "]");
        }
        buf.push(">");
      }
      return;
    case PROCESSING_INSTRUCTION_NODE:
      return buf.push("<?", node.target, " ", node.data, "?>");
    case ENTITY_REFERENCE_NODE:
      return buf.push('&', node.nodeName, ';');
    //case ENTITY_NODE:
    //case NOTATION_NODE:
    default:
      buf.push('??', node.nodeName);
  }
}
function _importNode(doc, node, deep) {
  var node2;
  switch (node.nodeType) {
    case ELEMENT_NODE:
      node2 = node.cloneNode(false);
      node2.ownerDocument = doc;
    //var attrs = node2.attributes;
    //var len = attrs.length;
    //for(var i=0;i<len;i++){
    //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
    //}
    case DOCUMENT_FRAGMENT_NODE:
      break;
    case ATTRIBUTE_NODE:
      deep = true;
      break;
    //case ENTITY_REFERENCE_NODE:
    //case PROCESSING_INSTRUCTION_NODE:
    ////case TEXT_NODE:
    //case CDATA_SECTION_NODE:
    //case COMMENT_NODE:
    //	deep = false;
    //	break;
    //case DOCUMENT_NODE:
    //case DOCUMENT_TYPE_NODE:
    //cannot be imported.
    //case ENTITY_NODE:
    //case NOTATION_NODE：
    //can not hit in level3
    //default:throw e;
  }

  if (!node2) {
    node2 = node.cloneNode(false); //false
  }

  node2.ownerDocument = doc;
  node2.parentNode = null;
  if (deep) {
    var child = node.firstChild;
    while (child) {
      node2.appendChild(_importNode(doc, child, deep));
      child = child.nextSibling;
    }
  }
  return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function _cloneNode(doc, node, deep) {
  var node2 = new node.constructor();
  for (var n in node) {
    if (Object.prototype.hasOwnProperty.call(node, n)) {
      var v = node[n];
      if (_typeof(v) != "object") {
        if (v != node2[n]) {
          node2[n] = v;
        }
      }
    }
  }
  if (node.childNodes) {
    node2.childNodes = new NodeList();
  }
  node2.ownerDocument = doc;
  switch (node2.nodeType) {
    case ELEMENT_NODE:
      var attrs = node.attributes;
      var attrs2 = node2.attributes = new NamedNodeMap();
      var len = attrs.length;
      attrs2._ownerElement = node2;
      for (var i = 0; i < len; i++) {
        node2.setAttributeNode(_cloneNode(doc, attrs.item(i), true));
      }
      break;
      ;
    case ATTRIBUTE_NODE:
      deep = true;
  }
  if (deep) {
    var child = node.firstChild;
    while (child) {
      node2.appendChild(_cloneNode(doc, child, deep));
      child = child.nextSibling;
    }
  }
  return node2;
}
function __set__(object, key, value) {
  object[key] = value;
}
//do dynamic
try {
  if (Object.defineProperty) {
    Object.defineProperty(LiveNodeList.prototype, 'length', {
      get: function get() {
        _updateLiveList(this);
        return this.$$length;
      }
    });
    Object.defineProperty(Node.prototype, 'textContent', {
      get: function get() {
        return getTextContent(this);
      },
      set: function set(data) {
        switch (this.nodeType) {
          case ELEMENT_NODE:
          case DOCUMENT_FRAGMENT_NODE:
            while (this.firstChild) {
              this.removeChild(this.firstChild);
            }
            if (data || String(data)) {
              this.appendChild(this.ownerDocument.createTextNode(data));
            }
            break;
          default:
            this.data = data;
            this.value = data;
            this.nodeValue = data;
        }
      }
    });
    function getTextContent(node) {
      switch (node.nodeType) {
        case ELEMENT_NODE:
        case DOCUMENT_FRAGMENT_NODE:
          var buf = [];
          node = node.firstChild;
          while (node) {
            if (node.nodeType !== 7 && node.nodeType !== 8) {
              buf.push(getTextContent(node));
            }
            node = node.nextSibling;
          }
          return buf.join('');
        default:
          return node.nodeValue;
      }
    }
    __set__ = function __set__(object, key, value) {
      //console.log(value)
      object['$$' + key] = value;
    };
  }
} catch (e) {//ie8
}

//if(typeof require == 'function'){
exports.DocumentType = DocumentType;
exports.DOMException = DOMException;
exports.DOMImplementation = DOMImplementation;
exports.Element = Element;
exports.Node = Node;
exports.NodeList = NodeList;
exports.XMLSerializer = XMLSerializer;
//}

/***/ }),

/***/ 85653:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var freeze = __webpack_require__(62697).freeze;

/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */
exports.XML_ENTITIES = freeze({
  amp: '&',
  apos: "'",
  gt: '>',
  lt: '<',
  quot: '"'
});

/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */
exports.HTML_ENTITIES = freeze({
  Aacute: "\xC1",
  aacute: "\xE1",
  Abreve: "\u0102",
  abreve: "\u0103",
  ac: "\u223E",
  acd: "\u223F",
  acE: "\u223E\u0333",
  Acirc: "\xC2",
  acirc: "\xE2",
  acute: "\xB4",
  Acy: "\u0410",
  acy: "\u0430",
  AElig: "\xC6",
  aelig: "\xE6",
  af: "\u2061",
  Afr: "\uD835\uDD04",
  afr: "\uD835\uDD1E",
  Agrave: "\xC0",
  agrave: "\xE0",
  alefsym: "\u2135",
  aleph: "\u2135",
  Alpha: "\u0391",
  alpha: "\u03B1",
  Amacr: "\u0100",
  amacr: "\u0101",
  amalg: "\u2A3F",
  AMP: "&",
  amp: "&",
  And: "\u2A53",
  and: "\u2227",
  andand: "\u2A55",
  andd: "\u2A5C",
  andslope: "\u2A58",
  andv: "\u2A5A",
  ang: "\u2220",
  ange: "\u29A4",
  angle: "\u2220",
  angmsd: "\u2221",
  angmsdaa: "\u29A8",
  angmsdab: "\u29A9",
  angmsdac: "\u29AA",
  angmsdad: "\u29AB",
  angmsdae: "\u29AC",
  angmsdaf: "\u29AD",
  angmsdag: "\u29AE",
  angmsdah: "\u29AF",
  angrt: "\u221F",
  angrtvb: "\u22BE",
  angrtvbd: "\u299D",
  angsph: "\u2222",
  angst: "\xC5",
  angzarr: "\u237C",
  Aogon: "\u0104",
  aogon: "\u0105",
  Aopf: "\uD835\uDD38",
  aopf: "\uD835\uDD52",
  ap: "\u2248",
  apacir: "\u2A6F",
  apE: "\u2A70",
  ape: "\u224A",
  apid: "\u224B",
  apos: "'",
  ApplyFunction: "\u2061",
  approx: "\u2248",
  approxeq: "\u224A",
  Aring: "\xC5",
  aring: "\xE5",
  Ascr: "\uD835\uDC9C",
  ascr: "\uD835\uDCB6",
  Assign: "\u2254",
  ast: "*",
  asymp: "\u2248",
  asympeq: "\u224D",
  Atilde: "\xC3",
  atilde: "\xE3",
  Auml: "\xC4",
  auml: "\xE4",
  awconint: "\u2233",
  awint: "\u2A11",
  backcong: "\u224C",
  backepsilon: "\u03F6",
  backprime: "\u2035",
  backsim: "\u223D",
  backsimeq: "\u22CD",
  Backslash: "\u2216",
  Barv: "\u2AE7",
  barvee: "\u22BD",
  Barwed: "\u2306",
  barwed: "\u2305",
  barwedge: "\u2305",
  bbrk: "\u23B5",
  bbrktbrk: "\u23B6",
  bcong: "\u224C",
  Bcy: "\u0411",
  bcy: "\u0431",
  bdquo: "\u201E",
  becaus: "\u2235",
  Because: "\u2235",
  because: "\u2235",
  bemptyv: "\u29B0",
  bepsi: "\u03F6",
  bernou: "\u212C",
  Bernoullis: "\u212C",
  Beta: "\u0392",
  beta: "\u03B2",
  beth: "\u2136",
  between: "\u226C",
  Bfr: "\uD835\uDD05",
  bfr: "\uD835\uDD1F",
  bigcap: "\u22C2",
  bigcirc: "\u25EF",
  bigcup: "\u22C3",
  bigodot: "\u2A00",
  bigoplus: "\u2A01",
  bigotimes: "\u2A02",
  bigsqcup: "\u2A06",
  bigstar: "\u2605",
  bigtriangledown: "\u25BD",
  bigtriangleup: "\u25B3",
  biguplus: "\u2A04",
  bigvee: "\u22C1",
  bigwedge: "\u22C0",
  bkarow: "\u290D",
  blacklozenge: "\u29EB",
  blacksquare: "\u25AA",
  blacktriangle: "\u25B4",
  blacktriangledown: "\u25BE",
  blacktriangleleft: "\u25C2",
  blacktriangleright: "\u25B8",
  blank: "\u2423",
  blk12: "\u2592",
  blk14: "\u2591",
  blk34: "\u2593",
  block: "\u2588",
  bne: "=\u20E5",
  bnequiv: "\u2261\u20E5",
  bNot: "\u2AED",
  bnot: "\u2310",
  Bopf: "\uD835\uDD39",
  bopf: "\uD835\uDD53",
  bot: "\u22A5",
  bottom: "\u22A5",
  bowtie: "\u22C8",
  boxbox: "\u29C9",
  boxDL: "\u2557",
  boxDl: "\u2556",
  boxdL: "\u2555",
  boxdl: "\u2510",
  boxDR: "\u2554",
  boxDr: "\u2553",
  boxdR: "\u2552",
  boxdr: "\u250C",
  boxH: "\u2550",
  boxh: "\u2500",
  boxHD: "\u2566",
  boxHd: "\u2564",
  boxhD: "\u2565",
  boxhd: "\u252C",
  boxHU: "\u2569",
  boxHu: "\u2567",
  boxhU: "\u2568",
  boxhu: "\u2534",
  boxminus: "\u229F",
  boxplus: "\u229E",
  boxtimes: "\u22A0",
  boxUL: "\u255D",
  boxUl: "\u255C",
  boxuL: "\u255B",
  boxul: "\u2518",
  boxUR: "\u255A",
  boxUr: "\u2559",
  boxuR: "\u2558",
  boxur: "\u2514",
  boxV: "\u2551",
  boxv: "\u2502",
  boxVH: "\u256C",
  boxVh: "\u256B",
  boxvH: "\u256A",
  boxvh: "\u253C",
  boxVL: "\u2563",
  boxVl: "\u2562",
  boxvL: "\u2561",
  boxvl: "\u2524",
  boxVR: "\u2560",
  boxVr: "\u255F",
  boxvR: "\u255E",
  boxvr: "\u251C",
  bprime: "\u2035",
  Breve: "\u02D8",
  breve: "\u02D8",
  brvbar: "\xA6",
  Bscr: "\u212C",
  bscr: "\uD835\uDCB7",
  bsemi: "\u204F",
  bsim: "\u223D",
  bsime: "\u22CD",
  bsol: "\\",
  bsolb: "\u29C5",
  bsolhsub: "\u27C8",
  bull: "\u2022",
  bullet: "\u2022",
  bump: "\u224E",
  bumpE: "\u2AAE",
  bumpe: "\u224F",
  Bumpeq: "\u224E",
  bumpeq: "\u224F",
  Cacute: "\u0106",
  cacute: "\u0107",
  Cap: "\u22D2",
  cap: "\u2229",
  capand: "\u2A44",
  capbrcup: "\u2A49",
  capcap: "\u2A4B",
  capcup: "\u2A47",
  capdot: "\u2A40",
  CapitalDifferentialD: "\u2145",
  caps: "\u2229\uFE00",
  caret: "\u2041",
  caron: "\u02C7",
  Cayleys: "\u212D",
  ccaps: "\u2A4D",
  Ccaron: "\u010C",
  ccaron: "\u010D",
  Ccedil: "\xC7",
  ccedil: "\xE7",
  Ccirc: "\u0108",
  ccirc: "\u0109",
  Cconint: "\u2230",
  ccups: "\u2A4C",
  ccupssm: "\u2A50",
  Cdot: "\u010A",
  cdot: "\u010B",
  cedil: "\xB8",
  Cedilla: "\xB8",
  cemptyv: "\u29B2",
  cent: "\xA2",
  CenterDot: "\xB7",
  centerdot: "\xB7",
  Cfr: "\u212D",
  cfr: "\uD835\uDD20",
  CHcy: "\u0427",
  chcy: "\u0447",
  check: "\u2713",
  checkmark: "\u2713",
  Chi: "\u03A7",
  chi: "\u03C7",
  cir: "\u25CB",
  circ: "\u02C6",
  circeq: "\u2257",
  circlearrowleft: "\u21BA",
  circlearrowright: "\u21BB",
  circledast: "\u229B",
  circledcirc: "\u229A",
  circleddash: "\u229D",
  CircleDot: "\u2299",
  circledR: "\xAE",
  circledS: "\u24C8",
  CircleMinus: "\u2296",
  CirclePlus: "\u2295",
  CircleTimes: "\u2297",
  cirE: "\u29C3",
  cire: "\u2257",
  cirfnint: "\u2A10",
  cirmid: "\u2AEF",
  cirscir: "\u29C2",
  ClockwiseContourIntegral: "\u2232",
  CloseCurlyDoubleQuote: "\u201D",
  CloseCurlyQuote: "\u2019",
  clubs: "\u2663",
  clubsuit: "\u2663",
  Colon: "\u2237",
  colon: ":",
  Colone: "\u2A74",
  colone: "\u2254",
  coloneq: "\u2254",
  comma: ",",
  commat: "@",
  comp: "\u2201",
  compfn: "\u2218",
  complement: "\u2201",
  complexes: "\u2102",
  cong: "\u2245",
  congdot: "\u2A6D",
  Congruent: "\u2261",
  Conint: "\u222F",
  conint: "\u222E",
  ContourIntegral: "\u222E",
  Copf: "\u2102",
  copf: "\uD835\uDD54",
  coprod: "\u2210",
  Coproduct: "\u2210",
  COPY: "\xA9",
  copy: "\xA9",
  copysr: "\u2117",
  CounterClockwiseContourIntegral: "\u2233",
  crarr: "\u21B5",
  Cross: "\u2A2F",
  cross: "\u2717",
  Cscr: "\uD835\uDC9E",
  cscr: "\uD835\uDCB8",
  csub: "\u2ACF",
  csube: "\u2AD1",
  csup: "\u2AD0",
  csupe: "\u2AD2",
  ctdot: "\u22EF",
  cudarrl: "\u2938",
  cudarrr: "\u2935",
  cuepr: "\u22DE",
  cuesc: "\u22DF",
  cularr: "\u21B6",
  cularrp: "\u293D",
  Cup: "\u22D3",
  cup: "\u222A",
  cupbrcap: "\u2A48",
  CupCap: "\u224D",
  cupcap: "\u2A46",
  cupcup: "\u2A4A",
  cupdot: "\u228D",
  cupor: "\u2A45",
  cups: "\u222A\uFE00",
  curarr: "\u21B7",
  curarrm: "\u293C",
  curlyeqprec: "\u22DE",
  curlyeqsucc: "\u22DF",
  curlyvee: "\u22CE",
  curlywedge: "\u22CF",
  curren: "\xA4",
  curvearrowleft: "\u21B6",
  curvearrowright: "\u21B7",
  cuvee: "\u22CE",
  cuwed: "\u22CF",
  cwconint: "\u2232",
  cwint: "\u2231",
  cylcty: "\u232D",
  Dagger: "\u2021",
  dagger: "\u2020",
  daleth: "\u2138",
  Darr: "\u21A1",
  dArr: "\u21D3",
  darr: "\u2193",
  dash: "\u2010",
  Dashv: "\u2AE4",
  dashv: "\u22A3",
  dbkarow: "\u290F",
  dblac: "\u02DD",
  Dcaron: "\u010E",
  dcaron: "\u010F",
  Dcy: "\u0414",
  dcy: "\u0434",
  DD: "\u2145",
  dd: "\u2146",
  ddagger: "\u2021",
  ddarr: "\u21CA",
  DDotrahd: "\u2911",
  ddotseq: "\u2A77",
  deg: "\xB0",
  Del: "\u2207",
  Delta: "\u0394",
  delta: "\u03B4",
  demptyv: "\u29B1",
  dfisht: "\u297F",
  Dfr: "\uD835\uDD07",
  dfr: "\uD835\uDD21",
  dHar: "\u2965",
  dharl: "\u21C3",
  dharr: "\u21C2",
  DiacriticalAcute: "\xB4",
  DiacriticalDot: "\u02D9",
  DiacriticalDoubleAcute: "\u02DD",
  DiacriticalGrave: "`",
  DiacriticalTilde: "\u02DC",
  diam: "\u22C4",
  Diamond: "\u22C4",
  diamond: "\u22C4",
  diamondsuit: "\u2666",
  diams: "\u2666",
  die: "\xA8",
  DifferentialD: "\u2146",
  digamma: "\u03DD",
  disin: "\u22F2",
  div: "\xF7",
  divide: "\xF7",
  divideontimes: "\u22C7",
  divonx: "\u22C7",
  DJcy: "\u0402",
  djcy: "\u0452",
  dlcorn: "\u231E",
  dlcrop: "\u230D",
  dollar: "$",
  Dopf: "\uD835\uDD3B",
  dopf: "\uD835\uDD55",
  Dot: "\xA8",
  dot: "\u02D9",
  DotDot: "\u20DC",
  doteq: "\u2250",
  doteqdot: "\u2251",
  DotEqual: "\u2250",
  dotminus: "\u2238",
  dotplus: "\u2214",
  dotsquare: "\u22A1",
  doublebarwedge: "\u2306",
  DoubleContourIntegral: "\u222F",
  DoubleDot: "\xA8",
  DoubleDownArrow: "\u21D3",
  DoubleLeftArrow: "\u21D0",
  DoubleLeftRightArrow: "\u21D4",
  DoubleLeftTee: "\u2AE4",
  DoubleLongLeftArrow: "\u27F8",
  DoubleLongLeftRightArrow: "\u27FA",
  DoubleLongRightArrow: "\u27F9",
  DoubleRightArrow: "\u21D2",
  DoubleRightTee: "\u22A8",
  DoubleUpArrow: "\u21D1",
  DoubleUpDownArrow: "\u21D5",
  DoubleVerticalBar: "\u2225",
  DownArrow: "\u2193",
  Downarrow: "\u21D3",
  downarrow: "\u2193",
  DownArrowBar: "\u2913",
  DownArrowUpArrow: "\u21F5",
  DownBreve: "\u0311",
  downdownarrows: "\u21CA",
  downharpoonleft: "\u21C3",
  downharpoonright: "\u21C2",
  DownLeftRightVector: "\u2950",
  DownLeftTeeVector: "\u295E",
  DownLeftVector: "\u21BD",
  DownLeftVectorBar: "\u2956",
  DownRightTeeVector: "\u295F",
  DownRightVector: "\u21C1",
  DownRightVectorBar: "\u2957",
  DownTee: "\u22A4",
  DownTeeArrow: "\u21A7",
  drbkarow: "\u2910",
  drcorn: "\u231F",
  drcrop: "\u230C",
  Dscr: "\uD835\uDC9F",
  dscr: "\uD835\uDCB9",
  DScy: "\u0405",
  dscy: "\u0455",
  dsol: "\u29F6",
  Dstrok: "\u0110",
  dstrok: "\u0111",
  dtdot: "\u22F1",
  dtri: "\u25BF",
  dtrif: "\u25BE",
  duarr: "\u21F5",
  duhar: "\u296F",
  dwangle: "\u29A6",
  DZcy: "\u040F",
  dzcy: "\u045F",
  dzigrarr: "\u27FF",
  Eacute: "\xC9",
  eacute: "\xE9",
  easter: "\u2A6E",
  Ecaron: "\u011A",
  ecaron: "\u011B",
  ecir: "\u2256",
  Ecirc: "\xCA",
  ecirc: "\xEA",
  ecolon: "\u2255",
  Ecy: "\u042D",
  ecy: "\u044D",
  eDDot: "\u2A77",
  Edot: "\u0116",
  eDot: "\u2251",
  edot: "\u0117",
  ee: "\u2147",
  efDot: "\u2252",
  Efr: "\uD835\uDD08",
  efr: "\uD835\uDD22",
  eg: "\u2A9A",
  Egrave: "\xC8",
  egrave: "\xE8",
  egs: "\u2A96",
  egsdot: "\u2A98",
  el: "\u2A99",
  Element: "\u2208",
  elinters: "\u23E7",
  ell: "\u2113",
  els: "\u2A95",
  elsdot: "\u2A97",
  Emacr: "\u0112",
  emacr: "\u0113",
  empty: "\u2205",
  emptyset: "\u2205",
  EmptySmallSquare: "\u25FB",
  emptyv: "\u2205",
  EmptyVerySmallSquare: "\u25AB",
  emsp: "\u2003",
  emsp13: "\u2004",
  emsp14: "\u2005",
  ENG: "\u014A",
  eng: "\u014B",
  ensp: "\u2002",
  Eogon: "\u0118",
  eogon: "\u0119",
  Eopf: "\uD835\uDD3C",
  eopf: "\uD835\uDD56",
  epar: "\u22D5",
  eparsl: "\u29E3",
  eplus: "\u2A71",
  epsi: "\u03B5",
  Epsilon: "\u0395",
  epsilon: "\u03B5",
  epsiv: "\u03F5",
  eqcirc: "\u2256",
  eqcolon: "\u2255",
  eqsim: "\u2242",
  eqslantgtr: "\u2A96",
  eqslantless: "\u2A95",
  Equal: "\u2A75",
  equals: "=",
  EqualTilde: "\u2242",
  equest: "\u225F",
  Equilibrium: "\u21CC",
  equiv: "\u2261",
  equivDD: "\u2A78",
  eqvparsl: "\u29E5",
  erarr: "\u2971",
  erDot: "\u2253",
  Escr: "\u2130",
  escr: "\u212F",
  esdot: "\u2250",
  Esim: "\u2A73",
  esim: "\u2242",
  Eta: "\u0397",
  eta: "\u03B7",
  ETH: "\xD0",
  eth: "\xF0",
  Euml: "\xCB",
  euml: "\xEB",
  euro: "\u20AC",
  excl: "!",
  exist: "\u2203",
  Exists: "\u2203",
  expectation: "\u2130",
  ExponentialE: "\u2147",
  exponentiale: "\u2147",
  fallingdotseq: "\u2252",
  Fcy: "\u0424",
  fcy: "\u0444",
  female: "\u2640",
  ffilig: "\uFB03",
  fflig: "\uFB00",
  ffllig: "\uFB04",
  Ffr: "\uD835\uDD09",
  ffr: "\uD835\uDD23",
  filig: "\uFB01",
  FilledSmallSquare: "\u25FC",
  FilledVerySmallSquare: "\u25AA",
  fjlig: "fj",
  flat: "\u266D",
  fllig: "\uFB02",
  fltns: "\u25B1",
  fnof: "\u0192",
  Fopf: "\uD835\uDD3D",
  fopf: "\uD835\uDD57",
  ForAll: "\u2200",
  forall: "\u2200",
  fork: "\u22D4",
  forkv: "\u2AD9",
  Fouriertrf: "\u2131",
  fpartint: "\u2A0D",
  frac12: "\xBD",
  frac13: "\u2153",
  frac14: "\xBC",
  frac15: "\u2155",
  frac16: "\u2159",
  frac18: "\u215B",
  frac23: "\u2154",
  frac25: "\u2156",
  frac34: "\xBE",
  frac35: "\u2157",
  frac38: "\u215C",
  frac45: "\u2158",
  frac56: "\u215A",
  frac58: "\u215D",
  frac78: "\u215E",
  frasl: "\u2044",
  frown: "\u2322",
  Fscr: "\u2131",
  fscr: "\uD835\uDCBB",
  gacute: "\u01F5",
  Gamma: "\u0393",
  gamma: "\u03B3",
  Gammad: "\u03DC",
  gammad: "\u03DD",
  gap: "\u2A86",
  Gbreve: "\u011E",
  gbreve: "\u011F",
  Gcedil: "\u0122",
  Gcirc: "\u011C",
  gcirc: "\u011D",
  Gcy: "\u0413",
  gcy: "\u0433",
  Gdot: "\u0120",
  gdot: "\u0121",
  gE: "\u2267",
  ge: "\u2265",
  gEl: "\u2A8C",
  gel: "\u22DB",
  geq: "\u2265",
  geqq: "\u2267",
  geqslant: "\u2A7E",
  ges: "\u2A7E",
  gescc: "\u2AA9",
  gesdot: "\u2A80",
  gesdoto: "\u2A82",
  gesdotol: "\u2A84",
  gesl: "\u22DB\uFE00",
  gesles: "\u2A94",
  Gfr: "\uD835\uDD0A",
  gfr: "\uD835\uDD24",
  Gg: "\u22D9",
  gg: "\u226B",
  ggg: "\u22D9",
  gimel: "\u2137",
  GJcy: "\u0403",
  gjcy: "\u0453",
  gl: "\u2277",
  gla: "\u2AA5",
  glE: "\u2A92",
  glj: "\u2AA4",
  gnap: "\u2A8A",
  gnapprox: "\u2A8A",
  gnE: "\u2269",
  gne: "\u2A88",
  gneq: "\u2A88",
  gneqq: "\u2269",
  gnsim: "\u22E7",
  Gopf: "\uD835\uDD3E",
  gopf: "\uD835\uDD58",
  grave: "`",
  GreaterEqual: "\u2265",
  GreaterEqualLess: "\u22DB",
  GreaterFullEqual: "\u2267",
  GreaterGreater: "\u2AA2",
  GreaterLess: "\u2277",
  GreaterSlantEqual: "\u2A7E",
  GreaterTilde: "\u2273",
  Gscr: "\uD835\uDCA2",
  gscr: "\u210A",
  gsim: "\u2273",
  gsime: "\u2A8E",
  gsiml: "\u2A90",
  Gt: "\u226B",
  GT: ">",
  gt: ">",
  gtcc: "\u2AA7",
  gtcir: "\u2A7A",
  gtdot: "\u22D7",
  gtlPar: "\u2995",
  gtquest: "\u2A7C",
  gtrapprox: "\u2A86",
  gtrarr: "\u2978",
  gtrdot: "\u22D7",
  gtreqless: "\u22DB",
  gtreqqless: "\u2A8C",
  gtrless: "\u2277",
  gtrsim: "\u2273",
  gvertneqq: "\u2269\uFE00",
  gvnE: "\u2269\uFE00",
  Hacek: "\u02C7",
  hairsp: "\u200A",
  half: "\xBD",
  hamilt: "\u210B",
  HARDcy: "\u042A",
  hardcy: "\u044A",
  hArr: "\u21D4",
  harr: "\u2194",
  harrcir: "\u2948",
  harrw: "\u21AD",
  Hat: "^",
  hbar: "\u210F",
  Hcirc: "\u0124",
  hcirc: "\u0125",
  hearts: "\u2665",
  heartsuit: "\u2665",
  hellip: "\u2026",
  hercon: "\u22B9",
  Hfr: "\u210C",
  hfr: "\uD835\uDD25",
  HilbertSpace: "\u210B",
  hksearow: "\u2925",
  hkswarow: "\u2926",
  hoarr: "\u21FF",
  homtht: "\u223B",
  hookleftarrow: "\u21A9",
  hookrightarrow: "\u21AA",
  Hopf: "\u210D",
  hopf: "\uD835\uDD59",
  horbar: "\u2015",
  HorizontalLine: "\u2500",
  Hscr: "\u210B",
  hscr: "\uD835\uDCBD",
  hslash: "\u210F",
  Hstrok: "\u0126",
  hstrok: "\u0127",
  HumpDownHump: "\u224E",
  HumpEqual: "\u224F",
  hybull: "\u2043",
  hyphen: "\u2010",
  Iacute: "\xCD",
  iacute: "\xED",
  ic: "\u2063",
  Icirc: "\xCE",
  icirc: "\xEE",
  Icy: "\u0418",
  icy: "\u0438",
  Idot: "\u0130",
  IEcy: "\u0415",
  iecy: "\u0435",
  iexcl: "\xA1",
  iff: "\u21D4",
  Ifr: "\u2111",
  ifr: "\uD835\uDD26",
  Igrave: "\xCC",
  igrave: "\xEC",
  ii: "\u2148",
  iiiint: "\u2A0C",
  iiint: "\u222D",
  iinfin: "\u29DC",
  iiota: "\u2129",
  IJlig: "\u0132",
  ijlig: "\u0133",
  Im: "\u2111",
  Imacr: "\u012A",
  imacr: "\u012B",
  image: "\u2111",
  ImaginaryI: "\u2148",
  imagline: "\u2110",
  imagpart: "\u2111",
  imath: "\u0131",
  imof: "\u22B7",
  imped: "\u01B5",
  Implies: "\u21D2",
  in: "\u2208",
  incare: "\u2105",
  infin: "\u221E",
  infintie: "\u29DD",
  inodot: "\u0131",
  Int: "\u222C",
  int: "\u222B",
  intcal: "\u22BA",
  integers: "\u2124",
  Integral: "\u222B",
  intercal: "\u22BA",
  Intersection: "\u22C2",
  intlarhk: "\u2A17",
  intprod: "\u2A3C",
  InvisibleComma: "\u2063",
  InvisibleTimes: "\u2062",
  IOcy: "\u0401",
  iocy: "\u0451",
  Iogon: "\u012E",
  iogon: "\u012F",
  Iopf: "\uD835\uDD40",
  iopf: "\uD835\uDD5A",
  Iota: "\u0399",
  iota: "\u03B9",
  iprod: "\u2A3C",
  iquest: "\xBF",
  Iscr: "\u2110",
  iscr: "\uD835\uDCBE",
  isin: "\u2208",
  isindot: "\u22F5",
  isinE: "\u22F9",
  isins: "\u22F4",
  isinsv: "\u22F3",
  isinv: "\u2208",
  it: "\u2062",
  Itilde: "\u0128",
  itilde: "\u0129",
  Iukcy: "\u0406",
  iukcy: "\u0456",
  Iuml: "\xCF",
  iuml: "\xEF",
  Jcirc: "\u0134",
  jcirc: "\u0135",
  Jcy: "\u0419",
  jcy: "\u0439",
  Jfr: "\uD835\uDD0D",
  jfr: "\uD835\uDD27",
  jmath: "\u0237",
  Jopf: "\uD835\uDD41",
  jopf: "\uD835\uDD5B",
  Jscr: "\uD835\uDCA5",
  jscr: "\uD835\uDCBF",
  Jsercy: "\u0408",
  jsercy: "\u0458",
  Jukcy: "\u0404",
  jukcy: "\u0454",
  Kappa: "\u039A",
  kappa: "\u03BA",
  kappav: "\u03F0",
  Kcedil: "\u0136",
  kcedil: "\u0137",
  Kcy: "\u041A",
  kcy: "\u043A",
  Kfr: "\uD835\uDD0E",
  kfr: "\uD835\uDD28",
  kgreen: "\u0138",
  KHcy: "\u0425",
  khcy: "\u0445",
  KJcy: "\u040C",
  kjcy: "\u045C",
  Kopf: "\uD835\uDD42",
  kopf: "\uD835\uDD5C",
  Kscr: "\uD835\uDCA6",
  kscr: "\uD835\uDCC0",
  lAarr: "\u21DA",
  Lacute: "\u0139",
  lacute: "\u013A",
  laemptyv: "\u29B4",
  lagran: "\u2112",
  Lambda: "\u039B",
  lambda: "\u03BB",
  Lang: "\u27EA",
  lang: "\u27E8",
  langd: "\u2991",
  langle: "\u27E8",
  lap: "\u2A85",
  Laplacetrf: "\u2112",
  laquo: "\xAB",
  Larr: "\u219E",
  lArr: "\u21D0",
  larr: "\u2190",
  larrb: "\u21E4",
  larrbfs: "\u291F",
  larrfs: "\u291D",
  larrhk: "\u21A9",
  larrlp: "\u21AB",
  larrpl: "\u2939",
  larrsim: "\u2973",
  larrtl: "\u21A2",
  lat: "\u2AAB",
  lAtail: "\u291B",
  latail: "\u2919",
  late: "\u2AAD",
  lates: "\u2AAD\uFE00",
  lBarr: "\u290E",
  lbarr: "\u290C",
  lbbrk: "\u2772",
  lbrace: "{",
  lbrack: "[",
  lbrke: "\u298B",
  lbrksld: "\u298F",
  lbrkslu: "\u298D",
  Lcaron: "\u013D",
  lcaron: "\u013E",
  Lcedil: "\u013B",
  lcedil: "\u013C",
  lceil: "\u2308",
  lcub: "{",
  Lcy: "\u041B",
  lcy: "\u043B",
  ldca: "\u2936",
  ldquo: "\u201C",
  ldquor: "\u201E",
  ldrdhar: "\u2967",
  ldrushar: "\u294B",
  ldsh: "\u21B2",
  lE: "\u2266",
  le: "\u2264",
  LeftAngleBracket: "\u27E8",
  LeftArrow: "\u2190",
  Leftarrow: "\u21D0",
  leftarrow: "\u2190",
  LeftArrowBar: "\u21E4",
  LeftArrowRightArrow: "\u21C6",
  leftarrowtail: "\u21A2",
  LeftCeiling: "\u2308",
  LeftDoubleBracket: "\u27E6",
  LeftDownTeeVector: "\u2961",
  LeftDownVector: "\u21C3",
  LeftDownVectorBar: "\u2959",
  LeftFloor: "\u230A",
  leftharpoondown: "\u21BD",
  leftharpoonup: "\u21BC",
  leftleftarrows: "\u21C7",
  LeftRightArrow: "\u2194",
  Leftrightarrow: "\u21D4",
  leftrightarrow: "\u2194",
  leftrightarrows: "\u21C6",
  leftrightharpoons: "\u21CB",
  leftrightsquigarrow: "\u21AD",
  LeftRightVector: "\u294E",
  LeftTee: "\u22A3",
  LeftTeeArrow: "\u21A4",
  LeftTeeVector: "\u295A",
  leftthreetimes: "\u22CB",
  LeftTriangle: "\u22B2",
  LeftTriangleBar: "\u29CF",
  LeftTriangleEqual: "\u22B4",
  LeftUpDownVector: "\u2951",
  LeftUpTeeVector: "\u2960",
  LeftUpVector: "\u21BF",
  LeftUpVectorBar: "\u2958",
  LeftVector: "\u21BC",
  LeftVectorBar: "\u2952",
  lEg: "\u2A8B",
  leg: "\u22DA",
  leq: "\u2264",
  leqq: "\u2266",
  leqslant: "\u2A7D",
  les: "\u2A7D",
  lescc: "\u2AA8",
  lesdot: "\u2A7F",
  lesdoto: "\u2A81",
  lesdotor: "\u2A83",
  lesg: "\u22DA\uFE00",
  lesges: "\u2A93",
  lessapprox: "\u2A85",
  lessdot: "\u22D6",
  lesseqgtr: "\u22DA",
  lesseqqgtr: "\u2A8B",
  LessEqualGreater: "\u22DA",
  LessFullEqual: "\u2266",
  LessGreater: "\u2276",
  lessgtr: "\u2276",
  LessLess: "\u2AA1",
  lesssim: "\u2272",
  LessSlantEqual: "\u2A7D",
  LessTilde: "\u2272",
  lfisht: "\u297C",
  lfloor: "\u230A",
  Lfr: "\uD835\uDD0F",
  lfr: "\uD835\uDD29",
  lg: "\u2276",
  lgE: "\u2A91",
  lHar: "\u2962",
  lhard: "\u21BD",
  lharu: "\u21BC",
  lharul: "\u296A",
  lhblk: "\u2584",
  LJcy: "\u0409",
  ljcy: "\u0459",
  Ll: "\u22D8",
  ll: "\u226A",
  llarr: "\u21C7",
  llcorner: "\u231E",
  Lleftarrow: "\u21DA",
  llhard: "\u296B",
  lltri: "\u25FA",
  Lmidot: "\u013F",
  lmidot: "\u0140",
  lmoust: "\u23B0",
  lmoustache: "\u23B0",
  lnap: "\u2A89",
  lnapprox: "\u2A89",
  lnE: "\u2268",
  lne: "\u2A87",
  lneq: "\u2A87",
  lneqq: "\u2268",
  lnsim: "\u22E6",
  loang: "\u27EC",
  loarr: "\u21FD",
  lobrk: "\u27E6",
  LongLeftArrow: "\u27F5",
  Longleftarrow: "\u27F8",
  longleftarrow: "\u27F5",
  LongLeftRightArrow: "\u27F7",
  Longleftrightarrow: "\u27FA",
  longleftrightarrow: "\u27F7",
  longmapsto: "\u27FC",
  LongRightArrow: "\u27F6",
  Longrightarrow: "\u27F9",
  longrightarrow: "\u27F6",
  looparrowleft: "\u21AB",
  looparrowright: "\u21AC",
  lopar: "\u2985",
  Lopf: "\uD835\uDD43",
  lopf: "\uD835\uDD5D",
  loplus: "\u2A2D",
  lotimes: "\u2A34",
  lowast: "\u2217",
  lowbar: "_",
  LowerLeftArrow: "\u2199",
  LowerRightArrow: "\u2198",
  loz: "\u25CA",
  lozenge: "\u25CA",
  lozf: "\u29EB",
  lpar: "(",
  lparlt: "\u2993",
  lrarr: "\u21C6",
  lrcorner: "\u231F",
  lrhar: "\u21CB",
  lrhard: "\u296D",
  lrm: "\u200E",
  lrtri: "\u22BF",
  lsaquo: "\u2039",
  Lscr: "\u2112",
  lscr: "\uD835\uDCC1",
  Lsh: "\u21B0",
  lsh: "\u21B0",
  lsim: "\u2272",
  lsime: "\u2A8D",
  lsimg: "\u2A8F",
  lsqb: "[",
  lsquo: "\u2018",
  lsquor: "\u201A",
  Lstrok: "\u0141",
  lstrok: "\u0142",
  Lt: "\u226A",
  LT: "<",
  lt: "<",
  ltcc: "\u2AA6",
  ltcir: "\u2A79",
  ltdot: "\u22D6",
  lthree: "\u22CB",
  ltimes: "\u22C9",
  ltlarr: "\u2976",
  ltquest: "\u2A7B",
  ltri: "\u25C3",
  ltrie: "\u22B4",
  ltrif: "\u25C2",
  ltrPar: "\u2996",
  lurdshar: "\u294A",
  luruhar: "\u2966",
  lvertneqq: "\u2268\uFE00",
  lvnE: "\u2268\uFE00",
  macr: "\xAF",
  male: "\u2642",
  malt: "\u2720",
  maltese: "\u2720",
  Map: "\u2905",
  map: "\u21A6",
  mapsto: "\u21A6",
  mapstodown: "\u21A7",
  mapstoleft: "\u21A4",
  mapstoup: "\u21A5",
  marker: "\u25AE",
  mcomma: "\u2A29",
  Mcy: "\u041C",
  mcy: "\u043C",
  mdash: "\u2014",
  mDDot: "\u223A",
  measuredangle: "\u2221",
  MediumSpace: "\u205F",
  Mellintrf: "\u2133",
  Mfr: "\uD835\uDD10",
  mfr: "\uD835\uDD2A",
  mho: "\u2127",
  micro: "\xB5",
  mid: "\u2223",
  midast: "*",
  midcir: "\u2AF0",
  middot: "\xB7",
  minus: "\u2212",
  minusb: "\u229F",
  minusd: "\u2238",
  minusdu: "\u2A2A",
  MinusPlus: "\u2213",
  mlcp: "\u2ADB",
  mldr: "\u2026",
  mnplus: "\u2213",
  models: "\u22A7",
  Mopf: "\uD835\uDD44",
  mopf: "\uD835\uDD5E",
  mp: "\u2213",
  Mscr: "\u2133",
  mscr: "\uD835\uDCC2",
  mstpos: "\u223E",
  Mu: "\u039C",
  mu: "\u03BC",
  multimap: "\u22B8",
  mumap: "\u22B8",
  nabla: "\u2207",
  Nacute: "\u0143",
  nacute: "\u0144",
  nang: "\u2220\u20D2",
  nap: "\u2249",
  napE: "\u2A70\u0338",
  napid: "\u224B\u0338",
  napos: "\u0149",
  napprox: "\u2249",
  natur: "\u266E",
  natural: "\u266E",
  naturals: "\u2115",
  nbsp: "\xA0",
  nbump: "\u224E\u0338",
  nbumpe: "\u224F\u0338",
  ncap: "\u2A43",
  Ncaron: "\u0147",
  ncaron: "\u0148",
  Ncedil: "\u0145",
  ncedil: "\u0146",
  ncong: "\u2247",
  ncongdot: "\u2A6D\u0338",
  ncup: "\u2A42",
  Ncy: "\u041D",
  ncy: "\u043D",
  ndash: "\u2013",
  ne: "\u2260",
  nearhk: "\u2924",
  neArr: "\u21D7",
  nearr: "\u2197",
  nearrow: "\u2197",
  nedot: "\u2250\u0338",
  NegativeMediumSpace: "\u200B",
  NegativeThickSpace: "\u200B",
  NegativeThinSpace: "\u200B",
  NegativeVeryThinSpace: "\u200B",
  nequiv: "\u2262",
  nesear: "\u2928",
  nesim: "\u2242\u0338",
  NestedGreaterGreater: "\u226B",
  NestedLessLess: "\u226A",
  NewLine: "\n",
  nexist: "\u2204",
  nexists: "\u2204",
  Nfr: "\uD835\uDD11",
  nfr: "\uD835\uDD2B",
  ngE: "\u2267\u0338",
  nge: "\u2271",
  ngeq: "\u2271",
  ngeqq: "\u2267\u0338",
  ngeqslant: "\u2A7E\u0338",
  nges: "\u2A7E\u0338",
  nGg: "\u22D9\u0338",
  ngsim: "\u2275",
  nGt: "\u226B\u20D2",
  ngt: "\u226F",
  ngtr: "\u226F",
  nGtv: "\u226B\u0338",
  nhArr: "\u21CE",
  nharr: "\u21AE",
  nhpar: "\u2AF2",
  ni: "\u220B",
  nis: "\u22FC",
  nisd: "\u22FA",
  niv: "\u220B",
  NJcy: "\u040A",
  njcy: "\u045A",
  nlArr: "\u21CD",
  nlarr: "\u219A",
  nldr: "\u2025",
  nlE: "\u2266\u0338",
  nle: "\u2270",
  nLeftarrow: "\u21CD",
  nleftarrow: "\u219A",
  nLeftrightarrow: "\u21CE",
  nleftrightarrow: "\u21AE",
  nleq: "\u2270",
  nleqq: "\u2266\u0338",
  nleqslant: "\u2A7D\u0338",
  nles: "\u2A7D\u0338",
  nless: "\u226E",
  nLl: "\u22D8\u0338",
  nlsim: "\u2274",
  nLt: "\u226A\u20D2",
  nlt: "\u226E",
  nltri: "\u22EA",
  nltrie: "\u22EC",
  nLtv: "\u226A\u0338",
  nmid: "\u2224",
  NoBreak: "\u2060",
  NonBreakingSpace: "\xA0",
  Nopf: "\u2115",
  nopf: "\uD835\uDD5F",
  Not: "\u2AEC",
  not: "\xAC",
  NotCongruent: "\u2262",
  NotCupCap: "\u226D",
  NotDoubleVerticalBar: "\u2226",
  NotElement: "\u2209",
  NotEqual: "\u2260",
  NotEqualTilde: "\u2242\u0338",
  NotExists: "\u2204",
  NotGreater: "\u226F",
  NotGreaterEqual: "\u2271",
  NotGreaterFullEqual: "\u2267\u0338",
  NotGreaterGreater: "\u226B\u0338",
  NotGreaterLess: "\u2279",
  NotGreaterSlantEqual: "\u2A7E\u0338",
  NotGreaterTilde: "\u2275",
  NotHumpDownHump: "\u224E\u0338",
  NotHumpEqual: "\u224F\u0338",
  notin: "\u2209",
  notindot: "\u22F5\u0338",
  notinE: "\u22F9\u0338",
  notinva: "\u2209",
  notinvb: "\u22F7",
  notinvc: "\u22F6",
  NotLeftTriangle: "\u22EA",
  NotLeftTriangleBar: "\u29CF\u0338",
  NotLeftTriangleEqual: "\u22EC",
  NotLess: "\u226E",
  NotLessEqual: "\u2270",
  NotLessGreater: "\u2278",
  NotLessLess: "\u226A\u0338",
  NotLessSlantEqual: "\u2A7D\u0338",
  NotLessTilde: "\u2274",
  NotNestedGreaterGreater: "\u2AA2\u0338",
  NotNestedLessLess: "\u2AA1\u0338",
  notni: "\u220C",
  notniva: "\u220C",
  notnivb: "\u22FE",
  notnivc: "\u22FD",
  NotPrecedes: "\u2280",
  NotPrecedesEqual: "\u2AAF\u0338",
  NotPrecedesSlantEqual: "\u22E0",
  NotReverseElement: "\u220C",
  NotRightTriangle: "\u22EB",
  NotRightTriangleBar: "\u29D0\u0338",
  NotRightTriangleEqual: "\u22ED",
  NotSquareSubset: "\u228F\u0338",
  NotSquareSubsetEqual: "\u22E2",
  NotSquareSuperset: "\u2290\u0338",
  NotSquareSupersetEqual: "\u22E3",
  NotSubset: "\u2282\u20D2",
  NotSubsetEqual: "\u2288",
  NotSucceeds: "\u2281",
  NotSucceedsEqual: "\u2AB0\u0338",
  NotSucceedsSlantEqual: "\u22E1",
  NotSucceedsTilde: "\u227F\u0338",
  NotSuperset: "\u2283\u20D2",
  NotSupersetEqual: "\u2289",
  NotTilde: "\u2241",
  NotTildeEqual: "\u2244",
  NotTildeFullEqual: "\u2247",
  NotTildeTilde: "\u2249",
  NotVerticalBar: "\u2224",
  npar: "\u2226",
  nparallel: "\u2226",
  nparsl: "\u2AFD\u20E5",
  npart: "\u2202\u0338",
  npolint: "\u2A14",
  npr: "\u2280",
  nprcue: "\u22E0",
  npre: "\u2AAF\u0338",
  nprec: "\u2280",
  npreceq: "\u2AAF\u0338",
  nrArr: "\u21CF",
  nrarr: "\u219B",
  nrarrc: "\u2933\u0338",
  nrarrw: "\u219D\u0338",
  nRightarrow: "\u21CF",
  nrightarrow: "\u219B",
  nrtri: "\u22EB",
  nrtrie: "\u22ED",
  nsc: "\u2281",
  nsccue: "\u22E1",
  nsce: "\u2AB0\u0338",
  Nscr: "\uD835\uDCA9",
  nscr: "\uD835\uDCC3",
  nshortmid: "\u2224",
  nshortparallel: "\u2226",
  nsim: "\u2241",
  nsime: "\u2244",
  nsimeq: "\u2244",
  nsmid: "\u2224",
  nspar: "\u2226",
  nsqsube: "\u22E2",
  nsqsupe: "\u22E3",
  nsub: "\u2284",
  nsubE: "\u2AC5\u0338",
  nsube: "\u2288",
  nsubset: "\u2282\u20D2",
  nsubseteq: "\u2288",
  nsubseteqq: "\u2AC5\u0338",
  nsucc: "\u2281",
  nsucceq: "\u2AB0\u0338",
  nsup: "\u2285",
  nsupE: "\u2AC6\u0338",
  nsupe: "\u2289",
  nsupset: "\u2283\u20D2",
  nsupseteq: "\u2289",
  nsupseteqq: "\u2AC6\u0338",
  ntgl: "\u2279",
  Ntilde: "\xD1",
  ntilde: "\xF1",
  ntlg: "\u2278",
  ntriangleleft: "\u22EA",
  ntrianglelefteq: "\u22EC",
  ntriangleright: "\u22EB",
  ntrianglerighteq: "\u22ED",
  Nu: "\u039D",
  nu: "\u03BD",
  num: "#",
  numero: "\u2116",
  numsp: "\u2007",
  nvap: "\u224D\u20D2",
  nVDash: "\u22AF",
  nVdash: "\u22AE",
  nvDash: "\u22AD",
  nvdash: "\u22AC",
  nvge: "\u2265\u20D2",
  nvgt: ">\u20D2",
  nvHarr: "\u2904",
  nvinfin: "\u29DE",
  nvlArr: "\u2902",
  nvle: "\u2264\u20D2",
  nvlt: "<\u20D2",
  nvltrie: "\u22B4\u20D2",
  nvrArr: "\u2903",
  nvrtrie: "\u22B5\u20D2",
  nvsim: "\u223C\u20D2",
  nwarhk: "\u2923",
  nwArr: "\u21D6",
  nwarr: "\u2196",
  nwarrow: "\u2196",
  nwnear: "\u2927",
  Oacute: "\xD3",
  oacute: "\xF3",
  oast: "\u229B",
  ocir: "\u229A",
  Ocirc: "\xD4",
  ocirc: "\xF4",
  Ocy: "\u041E",
  ocy: "\u043E",
  odash: "\u229D",
  Odblac: "\u0150",
  odblac: "\u0151",
  odiv: "\u2A38",
  odot: "\u2299",
  odsold: "\u29BC",
  OElig: "\u0152",
  oelig: "\u0153",
  ofcir: "\u29BF",
  Ofr: "\uD835\uDD12",
  ofr: "\uD835\uDD2C",
  ogon: "\u02DB",
  Ograve: "\xD2",
  ograve: "\xF2",
  ogt: "\u29C1",
  ohbar: "\u29B5",
  ohm: "\u03A9",
  oint: "\u222E",
  olarr: "\u21BA",
  olcir: "\u29BE",
  olcross: "\u29BB",
  oline: "\u203E",
  olt: "\u29C0",
  Omacr: "\u014C",
  omacr: "\u014D",
  Omega: "\u03A9",
  omega: "\u03C9",
  Omicron: "\u039F",
  omicron: "\u03BF",
  omid: "\u29B6",
  ominus: "\u2296",
  Oopf: "\uD835\uDD46",
  oopf: "\uD835\uDD60",
  opar: "\u29B7",
  OpenCurlyDoubleQuote: "\u201C",
  OpenCurlyQuote: "\u2018",
  operp: "\u29B9",
  oplus: "\u2295",
  Or: "\u2A54",
  or: "\u2228",
  orarr: "\u21BB",
  ord: "\u2A5D",
  order: "\u2134",
  orderof: "\u2134",
  ordf: "\xAA",
  ordm: "\xBA",
  origof: "\u22B6",
  oror: "\u2A56",
  orslope: "\u2A57",
  orv: "\u2A5B",
  oS: "\u24C8",
  Oscr: "\uD835\uDCAA",
  oscr: "\u2134",
  Oslash: "\xD8",
  oslash: "\xF8",
  osol: "\u2298",
  Otilde: "\xD5",
  otilde: "\xF5",
  Otimes: "\u2A37",
  otimes: "\u2297",
  otimesas: "\u2A36",
  Ouml: "\xD6",
  ouml: "\xF6",
  ovbar: "\u233D",
  OverBar: "\u203E",
  OverBrace: "\u23DE",
  OverBracket: "\u23B4",
  OverParenthesis: "\u23DC",
  par: "\u2225",
  para: "\xB6",
  parallel: "\u2225",
  parsim: "\u2AF3",
  parsl: "\u2AFD",
  part: "\u2202",
  PartialD: "\u2202",
  Pcy: "\u041F",
  pcy: "\u043F",
  percnt: "%",
  period: ".",
  permil: "\u2030",
  perp: "\u22A5",
  pertenk: "\u2031",
  Pfr: "\uD835\uDD13",
  pfr: "\uD835\uDD2D",
  Phi: "\u03A6",
  phi: "\u03C6",
  phiv: "\u03D5",
  phmmat: "\u2133",
  phone: "\u260E",
  Pi: "\u03A0",
  pi: "\u03C0",
  pitchfork: "\u22D4",
  piv: "\u03D6",
  planck: "\u210F",
  planckh: "\u210E",
  plankv: "\u210F",
  plus: "+",
  plusacir: "\u2A23",
  plusb: "\u229E",
  pluscir: "\u2A22",
  plusdo: "\u2214",
  plusdu: "\u2A25",
  pluse: "\u2A72",
  PlusMinus: "\xB1",
  plusmn: "\xB1",
  plussim: "\u2A26",
  plustwo: "\u2A27",
  pm: "\xB1",
  Poincareplane: "\u210C",
  pointint: "\u2A15",
  Popf: "\u2119",
  popf: "\uD835\uDD61",
  pound: "\xA3",
  Pr: "\u2ABB",
  pr: "\u227A",
  prap: "\u2AB7",
  prcue: "\u227C",
  prE: "\u2AB3",
  pre: "\u2AAF",
  prec: "\u227A",
  precapprox: "\u2AB7",
  preccurlyeq: "\u227C",
  Precedes: "\u227A",
  PrecedesEqual: "\u2AAF",
  PrecedesSlantEqual: "\u227C",
  PrecedesTilde: "\u227E",
  preceq: "\u2AAF",
  precnapprox: "\u2AB9",
  precneqq: "\u2AB5",
  precnsim: "\u22E8",
  precsim: "\u227E",
  Prime: "\u2033",
  prime: "\u2032",
  primes: "\u2119",
  prnap: "\u2AB9",
  prnE: "\u2AB5",
  prnsim: "\u22E8",
  prod: "\u220F",
  Product: "\u220F",
  profalar: "\u232E",
  profline: "\u2312",
  profsurf: "\u2313",
  prop: "\u221D",
  Proportion: "\u2237",
  Proportional: "\u221D",
  propto: "\u221D",
  prsim: "\u227E",
  prurel: "\u22B0",
  Pscr: "\uD835\uDCAB",
  pscr: "\uD835\uDCC5",
  Psi: "\u03A8",
  psi: "\u03C8",
  puncsp: "\u2008",
  Qfr: "\uD835\uDD14",
  qfr: "\uD835\uDD2E",
  qint: "\u2A0C",
  Qopf: "\u211A",
  qopf: "\uD835\uDD62",
  qprime: "\u2057",
  Qscr: "\uD835\uDCAC",
  qscr: "\uD835\uDCC6",
  quaternions: "\u210D",
  quatint: "\u2A16",
  quest: "?",
  questeq: "\u225F",
  QUOT: "\"",
  quot: "\"",
  rAarr: "\u21DB",
  race: "\u223D\u0331",
  Racute: "\u0154",
  racute: "\u0155",
  radic: "\u221A",
  raemptyv: "\u29B3",
  Rang: "\u27EB",
  rang: "\u27E9",
  rangd: "\u2992",
  range: "\u29A5",
  rangle: "\u27E9",
  raquo: "\xBB",
  Rarr: "\u21A0",
  rArr: "\u21D2",
  rarr: "\u2192",
  rarrap: "\u2975",
  rarrb: "\u21E5",
  rarrbfs: "\u2920",
  rarrc: "\u2933",
  rarrfs: "\u291E",
  rarrhk: "\u21AA",
  rarrlp: "\u21AC",
  rarrpl: "\u2945",
  rarrsim: "\u2974",
  Rarrtl: "\u2916",
  rarrtl: "\u21A3",
  rarrw: "\u219D",
  rAtail: "\u291C",
  ratail: "\u291A",
  ratio: "\u2236",
  rationals: "\u211A",
  RBarr: "\u2910",
  rBarr: "\u290F",
  rbarr: "\u290D",
  rbbrk: "\u2773",
  rbrace: "}",
  rbrack: "]",
  rbrke: "\u298C",
  rbrksld: "\u298E",
  rbrkslu: "\u2990",
  Rcaron: "\u0158",
  rcaron: "\u0159",
  Rcedil: "\u0156",
  rcedil: "\u0157",
  rceil: "\u2309",
  rcub: "}",
  Rcy: "\u0420",
  rcy: "\u0440",
  rdca: "\u2937",
  rdldhar: "\u2969",
  rdquo: "\u201D",
  rdquor: "\u201D",
  rdsh: "\u21B3",
  Re: "\u211C",
  real: "\u211C",
  realine: "\u211B",
  realpart: "\u211C",
  reals: "\u211D",
  rect: "\u25AD",
  REG: "\xAE",
  reg: "\xAE",
  ReverseElement: "\u220B",
  ReverseEquilibrium: "\u21CB",
  ReverseUpEquilibrium: "\u296F",
  rfisht: "\u297D",
  rfloor: "\u230B",
  Rfr: "\u211C",
  rfr: "\uD835\uDD2F",
  rHar: "\u2964",
  rhard: "\u21C1",
  rharu: "\u21C0",
  rharul: "\u296C",
  Rho: "\u03A1",
  rho: "\u03C1",
  rhov: "\u03F1",
  RightAngleBracket: "\u27E9",
  RightArrow: "\u2192",
  Rightarrow: "\u21D2",
  rightarrow: "\u2192",
  RightArrowBar: "\u21E5",
  RightArrowLeftArrow: "\u21C4",
  rightarrowtail: "\u21A3",
  RightCeiling: "\u2309",
  RightDoubleBracket: "\u27E7",
  RightDownTeeVector: "\u295D",
  RightDownVector: "\u21C2",
  RightDownVectorBar: "\u2955",
  RightFloor: "\u230B",
  rightharpoondown: "\u21C1",
  rightharpoonup: "\u21C0",
  rightleftarrows: "\u21C4",
  rightleftharpoons: "\u21CC",
  rightrightarrows: "\u21C9",
  rightsquigarrow: "\u219D",
  RightTee: "\u22A2",
  RightTeeArrow: "\u21A6",
  RightTeeVector: "\u295B",
  rightthreetimes: "\u22CC",
  RightTriangle: "\u22B3",
  RightTriangleBar: "\u29D0",
  RightTriangleEqual: "\u22B5",
  RightUpDownVector: "\u294F",
  RightUpTeeVector: "\u295C",
  RightUpVector: "\u21BE",
  RightUpVectorBar: "\u2954",
  RightVector: "\u21C0",
  RightVectorBar: "\u2953",
  ring: "\u02DA",
  risingdotseq: "\u2253",
  rlarr: "\u21C4",
  rlhar: "\u21CC",
  rlm: "\u200F",
  rmoust: "\u23B1",
  rmoustache: "\u23B1",
  rnmid: "\u2AEE",
  roang: "\u27ED",
  roarr: "\u21FE",
  robrk: "\u27E7",
  ropar: "\u2986",
  Ropf: "\u211D",
  ropf: "\uD835\uDD63",
  roplus: "\u2A2E",
  rotimes: "\u2A35",
  RoundImplies: "\u2970",
  rpar: ")",
  rpargt: "\u2994",
  rppolint: "\u2A12",
  rrarr: "\u21C9",
  Rrightarrow: "\u21DB",
  rsaquo: "\u203A",
  Rscr: "\u211B",
  rscr: "\uD835\uDCC7",
  Rsh: "\u21B1",
  rsh: "\u21B1",
  rsqb: "]",
  rsquo: "\u2019",
  rsquor: "\u2019",
  rthree: "\u22CC",
  rtimes: "\u22CA",
  rtri: "\u25B9",
  rtrie: "\u22B5",
  rtrif: "\u25B8",
  rtriltri: "\u29CE",
  RuleDelayed: "\u29F4",
  ruluhar: "\u2968",
  rx: "\u211E",
  Sacute: "\u015A",
  sacute: "\u015B",
  sbquo: "\u201A",
  Sc: "\u2ABC",
  sc: "\u227B",
  scap: "\u2AB8",
  Scaron: "\u0160",
  scaron: "\u0161",
  sccue: "\u227D",
  scE: "\u2AB4",
  sce: "\u2AB0",
  Scedil: "\u015E",
  scedil: "\u015F",
  Scirc: "\u015C",
  scirc: "\u015D",
  scnap: "\u2ABA",
  scnE: "\u2AB6",
  scnsim: "\u22E9",
  scpolint: "\u2A13",
  scsim: "\u227F",
  Scy: "\u0421",
  scy: "\u0441",
  sdot: "\u22C5",
  sdotb: "\u22A1",
  sdote: "\u2A66",
  searhk: "\u2925",
  seArr: "\u21D8",
  searr: "\u2198",
  searrow: "\u2198",
  sect: "\xA7",
  semi: ";",
  seswar: "\u2929",
  setminus: "\u2216",
  setmn: "\u2216",
  sext: "\u2736",
  Sfr: "\uD835\uDD16",
  sfr: "\uD835\uDD30",
  sfrown: "\u2322",
  sharp: "\u266F",
  SHCHcy: "\u0429",
  shchcy: "\u0449",
  SHcy: "\u0428",
  shcy: "\u0448",
  ShortDownArrow: "\u2193",
  ShortLeftArrow: "\u2190",
  shortmid: "\u2223",
  shortparallel: "\u2225",
  ShortRightArrow: "\u2192",
  ShortUpArrow: "\u2191",
  shy: "\xAD",
  Sigma: "\u03A3",
  sigma: "\u03C3",
  sigmaf: "\u03C2",
  sigmav: "\u03C2",
  sim: "\u223C",
  simdot: "\u2A6A",
  sime: "\u2243",
  simeq: "\u2243",
  simg: "\u2A9E",
  simgE: "\u2AA0",
  siml: "\u2A9D",
  simlE: "\u2A9F",
  simne: "\u2246",
  simplus: "\u2A24",
  simrarr: "\u2972",
  slarr: "\u2190",
  SmallCircle: "\u2218",
  smallsetminus: "\u2216",
  smashp: "\u2A33",
  smeparsl: "\u29E4",
  smid: "\u2223",
  smile: "\u2323",
  smt: "\u2AAA",
  smte: "\u2AAC",
  smtes: "\u2AAC\uFE00",
  SOFTcy: "\u042C",
  softcy: "\u044C",
  sol: "/",
  solb: "\u29C4",
  solbar: "\u233F",
  Sopf: "\uD835\uDD4A",
  sopf: "\uD835\uDD64",
  spades: "\u2660",
  spadesuit: "\u2660",
  spar: "\u2225",
  sqcap: "\u2293",
  sqcaps: "\u2293\uFE00",
  sqcup: "\u2294",
  sqcups: "\u2294\uFE00",
  Sqrt: "\u221A",
  sqsub: "\u228F",
  sqsube: "\u2291",
  sqsubset: "\u228F",
  sqsubseteq: "\u2291",
  sqsup: "\u2290",
  sqsupe: "\u2292",
  sqsupset: "\u2290",
  sqsupseteq: "\u2292",
  squ: "\u25A1",
  Square: "\u25A1",
  square: "\u25A1",
  SquareIntersection: "\u2293",
  SquareSubset: "\u228F",
  SquareSubsetEqual: "\u2291",
  SquareSuperset: "\u2290",
  SquareSupersetEqual: "\u2292",
  SquareUnion: "\u2294",
  squarf: "\u25AA",
  squf: "\u25AA",
  srarr: "\u2192",
  Sscr: "\uD835\uDCAE",
  sscr: "\uD835\uDCC8",
  ssetmn: "\u2216",
  ssmile: "\u2323",
  sstarf: "\u22C6",
  Star: "\u22C6",
  star: "\u2606",
  starf: "\u2605",
  straightepsilon: "\u03F5",
  straightphi: "\u03D5",
  strns: "\xAF",
  Sub: "\u22D0",
  sub: "\u2282",
  subdot: "\u2ABD",
  subE: "\u2AC5",
  sube: "\u2286",
  subedot: "\u2AC3",
  submult: "\u2AC1",
  subnE: "\u2ACB",
  subne: "\u228A",
  subplus: "\u2ABF",
  subrarr: "\u2979",
  Subset: "\u22D0",
  subset: "\u2282",
  subseteq: "\u2286",
  subseteqq: "\u2AC5",
  SubsetEqual: "\u2286",
  subsetneq: "\u228A",
  subsetneqq: "\u2ACB",
  subsim: "\u2AC7",
  subsub: "\u2AD5",
  subsup: "\u2AD3",
  succ: "\u227B",
  succapprox: "\u2AB8",
  succcurlyeq: "\u227D",
  Succeeds: "\u227B",
  SucceedsEqual: "\u2AB0",
  SucceedsSlantEqual: "\u227D",
  SucceedsTilde: "\u227F",
  succeq: "\u2AB0",
  succnapprox: "\u2ABA",
  succneqq: "\u2AB6",
  succnsim: "\u22E9",
  succsim: "\u227F",
  SuchThat: "\u220B",
  Sum: "\u2211",
  sum: "\u2211",
  sung: "\u266A",
  Sup: "\u22D1",
  sup: "\u2283",
  sup1: "\xB9",
  sup2: "\xB2",
  sup3: "\xB3",
  supdot: "\u2ABE",
  supdsub: "\u2AD8",
  supE: "\u2AC6",
  supe: "\u2287",
  supedot: "\u2AC4",
  Superset: "\u2283",
  SupersetEqual: "\u2287",
  suphsol: "\u27C9",
  suphsub: "\u2AD7",
  suplarr: "\u297B",
  supmult: "\u2AC2",
  supnE: "\u2ACC",
  supne: "\u228B",
  supplus: "\u2AC0",
  Supset: "\u22D1",
  supset: "\u2283",
  supseteq: "\u2287",
  supseteqq: "\u2AC6",
  supsetneq: "\u228B",
  supsetneqq: "\u2ACC",
  supsim: "\u2AC8",
  supsub: "\u2AD4",
  supsup: "\u2AD6",
  swarhk: "\u2926",
  swArr: "\u21D9",
  swarr: "\u2199",
  swarrow: "\u2199",
  swnwar: "\u292A",
  szlig: "\xDF",
  Tab: "\t",
  target: "\u2316",
  Tau: "\u03A4",
  tau: "\u03C4",
  tbrk: "\u23B4",
  Tcaron: "\u0164",
  tcaron: "\u0165",
  Tcedil: "\u0162",
  tcedil: "\u0163",
  Tcy: "\u0422",
  tcy: "\u0442",
  tdot: "\u20DB",
  telrec: "\u2315",
  Tfr: "\uD835\uDD17",
  tfr: "\uD835\uDD31",
  there4: "\u2234",
  Therefore: "\u2234",
  therefore: "\u2234",
  Theta: "\u0398",
  theta: "\u03B8",
  thetasym: "\u03D1",
  thetav: "\u03D1",
  thickapprox: "\u2248",
  thicksim: "\u223C",
  ThickSpace: "\u205F\u200A",
  thinsp: "\u2009",
  ThinSpace: "\u2009",
  thkap: "\u2248",
  thksim: "\u223C",
  THORN: "\xDE",
  thorn: "\xFE",
  Tilde: "\u223C",
  tilde: "\u02DC",
  TildeEqual: "\u2243",
  TildeFullEqual: "\u2245",
  TildeTilde: "\u2248",
  times: "\xD7",
  timesb: "\u22A0",
  timesbar: "\u2A31",
  timesd: "\u2A30",
  tint: "\u222D",
  toea: "\u2928",
  top: "\u22A4",
  topbot: "\u2336",
  topcir: "\u2AF1",
  Topf: "\uD835\uDD4B",
  topf: "\uD835\uDD65",
  topfork: "\u2ADA",
  tosa: "\u2929",
  tprime: "\u2034",
  TRADE: "\u2122",
  trade: "\u2122",
  triangle: "\u25B5",
  triangledown: "\u25BF",
  triangleleft: "\u25C3",
  trianglelefteq: "\u22B4",
  triangleq: "\u225C",
  triangleright: "\u25B9",
  trianglerighteq: "\u22B5",
  tridot: "\u25EC",
  trie: "\u225C",
  triminus: "\u2A3A",
  TripleDot: "\u20DB",
  triplus: "\u2A39",
  trisb: "\u29CD",
  tritime: "\u2A3B",
  trpezium: "\u23E2",
  Tscr: "\uD835\uDCAF",
  tscr: "\uD835\uDCC9",
  TScy: "\u0426",
  tscy: "\u0446",
  TSHcy: "\u040B",
  tshcy: "\u045B",
  Tstrok: "\u0166",
  tstrok: "\u0167",
  twixt: "\u226C",
  twoheadleftarrow: "\u219E",
  twoheadrightarrow: "\u21A0",
  Uacute: "\xDA",
  uacute: "\xFA",
  Uarr: "\u219F",
  uArr: "\u21D1",
  uarr: "\u2191",
  Uarrocir: "\u2949",
  Ubrcy: "\u040E",
  ubrcy: "\u045E",
  Ubreve: "\u016C",
  ubreve: "\u016D",
  Ucirc: "\xDB",
  ucirc: "\xFB",
  Ucy: "\u0423",
  ucy: "\u0443",
  udarr: "\u21C5",
  Udblac: "\u0170",
  udblac: "\u0171",
  udhar: "\u296E",
  ufisht: "\u297E",
  Ufr: "\uD835\uDD18",
  ufr: "\uD835\uDD32",
  Ugrave: "\xD9",
  ugrave: "\xF9",
  uHar: "\u2963",
  uharl: "\u21BF",
  uharr: "\u21BE",
  uhblk: "\u2580",
  ulcorn: "\u231C",
  ulcorner: "\u231C",
  ulcrop: "\u230F",
  ultri: "\u25F8",
  Umacr: "\u016A",
  umacr: "\u016B",
  uml: "\xA8",
  UnderBar: "_",
  UnderBrace: "\u23DF",
  UnderBracket: "\u23B5",
  UnderParenthesis: "\u23DD",
  Union: "\u22C3",
  UnionPlus: "\u228E",
  Uogon: "\u0172",
  uogon: "\u0173",
  Uopf: "\uD835\uDD4C",
  uopf: "\uD835\uDD66",
  UpArrow: "\u2191",
  Uparrow: "\u21D1",
  uparrow: "\u2191",
  UpArrowBar: "\u2912",
  UpArrowDownArrow: "\u21C5",
  UpDownArrow: "\u2195",
  Updownarrow: "\u21D5",
  updownarrow: "\u2195",
  UpEquilibrium: "\u296E",
  upharpoonleft: "\u21BF",
  upharpoonright: "\u21BE",
  uplus: "\u228E",
  UpperLeftArrow: "\u2196",
  UpperRightArrow: "\u2197",
  Upsi: "\u03D2",
  upsi: "\u03C5",
  upsih: "\u03D2",
  Upsilon: "\u03A5",
  upsilon: "\u03C5",
  UpTee: "\u22A5",
  UpTeeArrow: "\u21A5",
  upuparrows: "\u21C8",
  urcorn: "\u231D",
  urcorner: "\u231D",
  urcrop: "\u230E",
  Uring: "\u016E",
  uring: "\u016F",
  urtri: "\u25F9",
  Uscr: "\uD835\uDCB0",
  uscr: "\uD835\uDCCA",
  utdot: "\u22F0",
  Utilde: "\u0168",
  utilde: "\u0169",
  utri: "\u25B5",
  utrif: "\u25B4",
  uuarr: "\u21C8",
  Uuml: "\xDC",
  uuml: "\xFC",
  uwangle: "\u29A7",
  vangrt: "\u299C",
  varepsilon: "\u03F5",
  varkappa: "\u03F0",
  varnothing: "\u2205",
  varphi: "\u03D5",
  varpi: "\u03D6",
  varpropto: "\u221D",
  vArr: "\u21D5",
  varr: "\u2195",
  varrho: "\u03F1",
  varsigma: "\u03C2",
  varsubsetneq: "\u228A\uFE00",
  varsubsetneqq: "\u2ACB\uFE00",
  varsupsetneq: "\u228B\uFE00",
  varsupsetneqq: "\u2ACC\uFE00",
  vartheta: "\u03D1",
  vartriangleleft: "\u22B2",
  vartriangleright: "\u22B3",
  Vbar: "\u2AEB",
  vBar: "\u2AE8",
  vBarv: "\u2AE9",
  Vcy: "\u0412",
  vcy: "\u0432",
  VDash: "\u22AB",
  Vdash: "\u22A9",
  vDash: "\u22A8",
  vdash: "\u22A2",
  Vdashl: "\u2AE6",
  Vee: "\u22C1",
  vee: "\u2228",
  veebar: "\u22BB",
  veeeq: "\u225A",
  vellip: "\u22EE",
  Verbar: "\u2016",
  verbar: "|",
  Vert: "\u2016",
  vert: "|",
  VerticalBar: "\u2223",
  VerticalLine: "|",
  VerticalSeparator: "\u2758",
  VerticalTilde: "\u2240",
  VeryThinSpace: "\u200A",
  Vfr: "\uD835\uDD19",
  vfr: "\uD835\uDD33",
  vltri: "\u22B2",
  vnsub: "\u2282\u20D2",
  vnsup: "\u2283\u20D2",
  Vopf: "\uD835\uDD4D",
  vopf: "\uD835\uDD67",
  vprop: "\u221D",
  vrtri: "\u22B3",
  Vscr: "\uD835\uDCB1",
  vscr: "\uD835\uDCCB",
  vsubnE: "\u2ACB\uFE00",
  vsubne: "\u228A\uFE00",
  vsupnE: "\u2ACC\uFE00",
  vsupne: "\u228B\uFE00",
  Vvdash: "\u22AA",
  vzigzag: "\u299A",
  Wcirc: "\u0174",
  wcirc: "\u0175",
  wedbar: "\u2A5F",
  Wedge: "\u22C0",
  wedge: "\u2227",
  wedgeq: "\u2259",
  weierp: "\u2118",
  Wfr: "\uD835\uDD1A",
  wfr: "\uD835\uDD34",
  Wopf: "\uD835\uDD4E",
  wopf: "\uD835\uDD68",
  wp: "\u2118",
  wr: "\u2240",
  wreath: "\u2240",
  Wscr: "\uD835\uDCB2",
  wscr: "\uD835\uDCCC",
  xcap: "\u22C2",
  xcirc: "\u25EF",
  xcup: "\u22C3",
  xdtri: "\u25BD",
  Xfr: "\uD835\uDD1B",
  xfr: "\uD835\uDD35",
  xhArr: "\u27FA",
  xharr: "\u27F7",
  Xi: "\u039E",
  xi: "\u03BE",
  xlArr: "\u27F8",
  xlarr: "\u27F5",
  xmap: "\u27FC",
  xnis: "\u22FB",
  xodot: "\u2A00",
  Xopf: "\uD835\uDD4F",
  xopf: "\uD835\uDD69",
  xoplus: "\u2A01",
  xotime: "\u2A02",
  xrArr: "\u27F9",
  xrarr: "\u27F6",
  Xscr: "\uD835\uDCB3",
  xscr: "\uD835\uDCCD",
  xsqcup: "\u2A06",
  xuplus: "\u2A04",
  xutri: "\u25B3",
  xvee: "\u22C1",
  xwedge: "\u22C0",
  Yacute: "\xDD",
  yacute: "\xFD",
  YAcy: "\u042F",
  yacy: "\u044F",
  Ycirc: "\u0176",
  ycirc: "\u0177",
  Ycy: "\u042B",
  ycy: "\u044B",
  yen: "\xA5",
  Yfr: "\uD835\uDD1C",
  yfr: "\uD835\uDD36",
  YIcy: "\u0407",
  yicy: "\u0457",
  Yopf: "\uD835\uDD50",
  yopf: "\uD835\uDD6A",
  Yscr: "\uD835\uDCB4",
  yscr: "\uD835\uDCCE",
  YUcy: "\u042E",
  yucy: "\u044E",
  Yuml: "\u0178",
  yuml: "\xFF",
  Zacute: "\u0179",
  zacute: "\u017A",
  Zcaron: "\u017D",
  zcaron: "\u017E",
  Zcy: "\u0417",
  zcy: "\u0437",
  Zdot: "\u017B",
  zdot: "\u017C",
  zeetrf: "\u2128",
  ZeroWidthSpace: "\u200B",
  Zeta: "\u0396",
  zeta: "\u03B6",
  Zfr: "\u2128",
  zfr: "\uD835\uDD37",
  ZHcy: "\u0416",
  zhcy: "\u0436",
  zigrarr: "\u21DD",
  Zopf: "\u2124",
  zopf: "\uD835\uDD6B",
  Zscr: "\uD835\uDCB5",
  zscr: "\uD835\uDCCF",
  zwj: "\u200D",
  zwnj: "\u200C"
});

/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */
exports.entityMap = exports.HTML_ENTITIES;

/***/ }),

/***/ 23399:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
var dom = __webpack_require__(67102);
__webpack_unused_export__ = dom.DOMImplementation;
__webpack_unused_export__ = dom.XMLSerializer;
exports.DOMParser = __webpack_require__(60522).DOMParser;

/***/ }),

/***/ 36752:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

__webpack_require__(24603);
__webpack_require__(74916);
__webpack_require__(39714);
__webpack_require__(47042);
__webpack_require__(68309);
__webpack_require__(15306);
__webpack_require__(4723);
var NAMESPACE = __webpack_require__(62697).NAMESPACE;

//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/; //\u10000-\uEFFFF
var nameChar = new RegExp("[\\-\\.0-9" + nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var tagNamePattern = new RegExp('^' + nameStartChar.source + nameChar.source + '*(?:\:' + nameStartChar.source + nameChar.source + '*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')

//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var S_TAG = 0; //tag name offerring
var S_ATTR = 1; //attr name offerring
var S_ATTR_SPACE = 2; //attr name end and space offer
var S_EQ = 3; //=space?
var S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var S_ATTR_END = 5; //attr value end and no space(quot end)
var S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var S_TAG_CLOSE = 7; //closed el<el />

/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */
function ParseError(message, locator) {
  this.message = message;
  this.locator = locator;
  if (Error.captureStackTrace) Error.captureStackTrace(this, ParseError);
}
ParseError.prototype = new Error();
ParseError.prototype.name = ParseError.name;
function XMLReader() {}
XMLReader.prototype = {
  parse: function parse(source, defaultNSMap, entityMap) {
    var domBuilder = this.domBuilder;
    domBuilder.startDocument();
    _copy(defaultNSMap, defaultNSMap = {});
    _parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
    domBuilder.endDocument();
  }
};
function _parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
  function fixedFromCharCode(code) {
    // String.prototype.fromCharCode does not supports
    // > 2 bytes unicode chars directly
    if (code > 0xffff) {
      code -= 0x10000;
      var surrogate1 = 0xd800 + (code >> 10),
        surrogate2 = 0xdc00 + (code & 0x3ff);
      return String.fromCharCode(surrogate1, surrogate2);
    } else {
      return String.fromCharCode(code);
    }
  }
  function entityReplacer(a) {
    var k = a.slice(1, -1);
    if (Object.hasOwnProperty.call(entityMap, k)) {
      return entityMap[k];
    } else if (k.charAt(0) === '#') {
      return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')));
    } else {
      errorHandler.error('entity not found:' + a);
      return a;
    }
  }
  function appendText(end) {
    //has some bugs
    if (end > start) {
      var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
      locator && position(start);
      domBuilder.characters(xt, 0, end - start);
      start = end;
    }
  }
  function position(p, m) {
    while (p >= lineEnd && (m = linePattern.exec(source))) {
      lineStart = m.index;
      lineEnd = lineStart + m[0].length;
      locator.lineNumber++;
      //console.log('line++:',locator,startPos,endPos)
    }

    locator.columnNumber = p - lineStart + 1;
  }
  var lineStart = 0;
  var lineEnd = 0;
  var linePattern = /.*(?:\r\n?|\n)|.*$/g;
  var locator = domBuilder.locator;
  var parseStack = [{
    currentNSMap: defaultNSMapCopy
  }];
  var closeMap = {};
  var start = 0;
  while (true) {
    try {
      var tagStart = source.indexOf('<', start);
      if (tagStart < 0) {
        if (!source.substr(start).match(/^\s*$/)) {
          var doc = domBuilder.doc;
          var text = doc.createTextNode(source.substr(start));
          doc.appendChild(text);
          domBuilder.currentElement = text;
        }
        return;
      }
      if (tagStart > start) {
        appendText(tagStart);
      }
      switch (source.charAt(tagStart + 1)) {
        case '/':
          var end = source.indexOf('>', tagStart + 3);
          var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
          var config = parseStack.pop();
          if (end < 0) {
            tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
            errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
            end = tagStart + 1 + tagName.length;
          } else if (tagName.match(/\s</)) {
            tagName = tagName.replace(/[\s<].*/, '');
            errorHandler.error("end tag name: " + tagName + ' maybe not complete');
            end = tagStart + 1 + tagName.length;
          }
          var localNSMap = config.localNSMap;
          var endMatch = config.tagName == tagName;
          var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
          if (endIgnoreCaseMach) {
            domBuilder.endElement(config.uri, config.localName, tagName);
            if (localNSMap) {
              for (var prefix in localNSMap) {
                if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
                  domBuilder.endPrefixMapping(prefix);
                }
              }
            }
            if (!endMatch) {
              errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName); // No known test case
            }
          } else {
            parseStack.push(config);
          }
          end++;
          break;
        // end elment
        case '?':
          // <?...?>
          locator && position(tagStart);
          end = parseInstruction(source, tagStart, domBuilder);
          break;
        case '!':
          // <!doctype,<![CDATA,<!--
          locator && position(tagStart);
          end = parseDCC(source, tagStart, domBuilder, errorHandler);
          break;
        default:
          locator && position(tagStart);
          var el = new ElementAttributes();
          var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
          //elStartEnd
          var end = parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
          var len = el.length;
          if (!el.closed && fixSelfClosed(source, end, el.tagName, closeMap)) {
            el.closed = true;
            if (!entityMap.nbsp) {
              errorHandler.warning('unclosed xml attribute');
            }
          }
          if (locator && len) {
            var locator2 = copyLocator(locator, {});
            //try{//attribute position fixed
            for (var i = 0; i < len; i++) {
              var a = el[i];
              position(a.offset);
              a.locator = copyLocator(locator, {});
            }
            domBuilder.locator = locator2;
            if (appendElement(el, domBuilder, currentNSMap)) {
              parseStack.push(el);
            }
            domBuilder.locator = locator;
          } else {
            if (appendElement(el, domBuilder, currentNSMap)) {
              parseStack.push(el);
            }
          }
          if (NAMESPACE.isHTML(el.uri) && !el.closed) {
            end = parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
          } else {
            end++;
          }
      }
    } catch (e) {
      if (e instanceof ParseError) {
        throw e;
      }
      errorHandler.error('element parse error: ' + e);
      end = -1;
    }
    if (end > start) {
      start = end;
    } else {
      //TODO: 这里有可能sax回退，有位置错误风险
      appendText(Math.max(tagStart, start) + 1);
    }
  }
}
function copyLocator(f, t) {
  t.lineNumber = f.lineNumber;
  t.columnNumber = f.columnNumber;
  return t;
}

/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */
function parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
  /**
   * @param {string} qname
   * @param {string} value
   * @param {number} startIndex
   */
  function addAttribute(qname, value, startIndex) {
    if (el.attributeNames.hasOwnProperty(qname)) {
      errorHandler.fatalError('Attribute ' + qname + ' redefined');
    }
    el.addValue(qname,
    // @see https://www.w3.org/TR/xml/#AVNormalize
    // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
    // - recursive replacement of (DTD) entity references
    // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
    value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer), startIndex);
  }
  var attrName;
  var value;
  var p = ++start;
  var s = S_TAG; //status
  while (true) {
    var c = source.charAt(p);
    switch (c) {
      case '=':
        if (s === S_ATTR) {
          //attrName
          attrName = source.slice(start, p);
          s = S_EQ;
        } else if (s === S_ATTR_SPACE) {
          s = S_EQ;
        } else {
          //fatalError: equal must after attrName or space after attrName
          throw new Error('attribute equal must after attrName'); // No known test case
        }

        break;
      case '\'':
      case '"':
        if (s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
        ) {
          //equal
          if (s === S_ATTR) {
            errorHandler.warning('attribute value must after "="');
            attrName = source.slice(start, p);
          }
          start = p + 1;
          p = source.indexOf(c, start);
          if (p > 0) {
            value = source.slice(start, p);
            addAttribute(attrName, value, start - 1);
            s = S_ATTR_END;
          } else {
            //fatalError: no end quot match
            throw new Error('attribute value no end \'' + c + '\' match');
          }
        } else if (s == S_ATTR_NOQUOT_VALUE) {
          value = source.slice(start, p);
          addAttribute(attrName, value, start);
          errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
          start = p + 1;
          s = S_ATTR_END;
        } else {
          //fatalError: no equal before
          throw new Error('attribute value must after "="'); // No known test case
        }

        break;
      case '/':
        switch (s) {
          case S_TAG:
            el.setTagName(source.slice(start, p));
          case S_ATTR_END:
          case S_TAG_SPACE:
          case S_TAG_CLOSE:
            s = S_TAG_CLOSE;
            el.closed = true;
          case S_ATTR_NOQUOT_VALUE:
          case S_ATTR:
            break;
          case S_ATTR_SPACE:
            el.closed = true;
            break;
          //case S_EQ:
          default:
            throw new Error("attribute invalid close char('/')");
          // No known test case
        }

        break;
      case '':
        //end document
        errorHandler.error('unexpected end of input');
        if (s == S_TAG) {
          el.setTagName(source.slice(start, p));
        }
        return p;
      case '>':
        switch (s) {
          case S_TAG:
            el.setTagName(source.slice(start, p));
          case S_ATTR_END:
          case S_TAG_SPACE:
          case S_TAG_CLOSE:
            break;
          //normal
          case S_ATTR_NOQUOT_VALUE: //Compatible state
          case S_ATTR:
            value = source.slice(start, p);
            if (value.slice(-1) === '/') {
              el.closed = true;
              value = value.slice(0, -1);
            }
          case S_ATTR_SPACE:
            if (s === S_ATTR_SPACE) {
              value = attrName;
            }
            if (s == S_ATTR_NOQUOT_VALUE) {
              errorHandler.warning('attribute "' + value + '" missed quot(")!');
              addAttribute(attrName, value, start);
            } else {
              if (!NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)) {
                errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
              }
              addAttribute(value, value, start);
            }
            break;
          case S_EQ:
            throw new Error('attribute value missed!!');
        }
        //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
        return p;
      /*xml space '\x20' | #x9 | #xD | #xA; */
      case "\x80":
        c = ' ';
      default:
        if (c <= ' ') {
          //space
          switch (s) {
            case S_TAG:
              el.setTagName(source.slice(start, p)); //tagName
              s = S_TAG_SPACE;
              break;
            case S_ATTR:
              attrName = source.slice(start, p);
              s = S_ATTR_SPACE;
              break;
            case S_ATTR_NOQUOT_VALUE:
              var value = source.slice(start, p);
              errorHandler.warning('attribute "' + value + '" missed quot(")!!');
              addAttribute(attrName, value, start);
            case S_ATTR_END:
              s = S_TAG_SPACE;
              break;
            //case S_TAG_SPACE:
            //case S_EQ:
            //case S_ATTR_SPACE:
            //	void();break;
            //case S_TAG_CLOSE:
            //ignore warning
          }
        } else {
          //not space
          //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
          //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
          switch (s) {
            //case S_TAG:void();break;
            //case S_ATTR:void();break;
            //case S_ATTR_NOQUOT_VALUE:void();break;
            case S_ATTR_SPACE:
              var tagName = el.tagName;
              if (!NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
                errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
              }
              addAttribute(attrName, attrName, start);
              start = p;
              s = S_ATTR;
              break;
            case S_ATTR_END:
              errorHandler.warning('attribute space is required"' + attrName + '"!!');
            case S_TAG_SPACE:
              s = S_ATTR;
              start = p;
              break;
            case S_EQ:
              s = S_ATTR_NOQUOT_VALUE;
              start = p;
              break;
            case S_TAG_CLOSE:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
        }
    } //end outer switch
    //console.log('p++',p)
    p++;
  }
}
/**
 * @return true if has new namespace define
 */
function appendElement(el, domBuilder, currentNSMap) {
  var tagName = el.tagName;
  var localNSMap = null;
  //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
  var i = el.length;
  while (i--) {
    var a = el[i];
    var qName = a.qName;
    var value = a.value;
    var nsp = qName.indexOf(':');
    if (nsp > 0) {
      var prefix = a.prefix = qName.slice(0, nsp);
      var localName = qName.slice(nsp + 1);
      var nsPrefix = prefix === 'xmlns' && localName;
    } else {
      localName = qName;
      prefix = null;
      nsPrefix = qName === 'xmlns' && '';
    }
    //can not set prefix,because prefix !== ''
    a.localName = localName;
    //prefix == null for no ns prefix attribute
    if (nsPrefix !== false) {
      //hack!!
      if (localNSMap == null) {
        localNSMap = {};
        //console.log(currentNSMap,0)
        _copy(currentNSMap, currentNSMap = {});
        //console.log(currentNSMap,1)
      }

      currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
      a.uri = NAMESPACE.XMLNS;
      domBuilder.startPrefixMapping(nsPrefix, value);
    }
  }
  var i = el.length;
  while (i--) {
    a = el[i];
    var prefix = a.prefix;
    if (prefix) {
      //no prefix attribute has no namespace
      if (prefix === 'xml') {
        a.uri = NAMESPACE.XML;
      }
      if (prefix !== 'xmlns') {
        a.uri = currentNSMap[prefix || ''];

        //{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
      }
    }
  }

  var nsp = tagName.indexOf(':');
  if (nsp > 0) {
    prefix = el.prefix = tagName.slice(0, nsp);
    localName = el.localName = tagName.slice(nsp + 1);
  } else {
    prefix = null; //important!!
    localName = el.localName = tagName;
  }
  //no prefix element has default namespace
  var ns = el.uri = currentNSMap[prefix || ''];
  domBuilder.startElement(ns, localName, tagName, el);
  //endPrefixMapping and startPrefixMapping have not any help for dom builder
  //localNSMap = null
  if (el.closed) {
    domBuilder.endElement(ns, localName, tagName);
    if (localNSMap) {
      for (prefix in localNSMap) {
        if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
          domBuilder.endPrefixMapping(prefix);
        }
      }
    }
  } else {
    el.currentNSMap = currentNSMap;
    el.localNSMap = localNSMap;
    //parseStack.push(el);
    return true;
  }
}
function parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
  if (/^(?:script|textarea)$/i.test(tagName)) {
    var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
    var text = source.substring(elStartEnd + 1, elEndStart);
    if (/[&<]/.test(text)) {
      if (/^script$/i.test(tagName)) {
        //if(!/\]\]>/.test(text)){
        //lexHandler.startCDATA();
        domBuilder.characters(text, 0, text.length);
        //lexHandler.endCDATA();
        return elEndStart;
        //}
      } //}else{//text area
      text = text.replace(/&#?\w+;/g, entityReplacer);
      domBuilder.characters(text, 0, text.length);
      return elEndStart;
      //}
    }
  }

  return elStartEnd + 1;
}
function fixSelfClosed(source, elStartEnd, tagName, closeMap) {
  //if(tagName in closeMap){
  var pos = closeMap[tagName];
  if (pos == null) {
    //console.log(tagName)
    pos = source.lastIndexOf('</' + tagName + '>');
    if (pos < elStartEnd) {
      //忘记闭合
      pos = source.lastIndexOf('</' + tagName);
    }
    closeMap[tagName] = pos;
  }
  return pos < elStartEnd;
  //}
}

function _copy(source, target) {
  for (var n in source) {
    if (Object.prototype.hasOwnProperty.call(source, n)) {
      target[n] = source[n];
    }
  }
}
function parseDCC(source, start, domBuilder, errorHandler) {
  //sure start with '<!'
  var next = source.charAt(start + 2);
  switch (next) {
    case '-':
      if (source.charAt(start + 3) === '-') {
        var end = source.indexOf('-->', start + 4);
        //append comment source.substring(4,end)//<!--
        if (end > start) {
          domBuilder.comment(source, start + 4, end - start - 4);
          return end + 3;
        } else {
          errorHandler.error("Unclosed comment");
          return -1;
        }
      } else {
        //error
        return -1;
      }
    default:
      if (source.substr(start + 3, 6) == 'CDATA[') {
        var end = source.indexOf(']]>', start + 9);
        domBuilder.startCDATA();
        domBuilder.characters(source, start + 9, end - start - 9);
        domBuilder.endCDATA();
        return end + 3;
      }
      //<!DOCTYPE
      //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
      var matchs = split(source, start);
      var len = matchs.length;
      if (len > 1 && /!doctype/i.test(matchs[0][0])) {
        var name = matchs[1][0];
        var pubid = false;
        var sysid = false;
        if (len > 3) {
          if (/^public$/i.test(matchs[2][0])) {
            pubid = matchs[3][0];
            sysid = len > 4 && matchs[4][0];
          } else if (/^system$/i.test(matchs[2][0])) {
            sysid = matchs[3][0];
          }
        }
        var lastMatch = matchs[len - 1];
        domBuilder.startDTD(name, pubid, sysid);
        domBuilder.endDTD();
        return lastMatch.index + lastMatch[0].length;
      }
  }
  return -1;
}
function parseInstruction(source, start, domBuilder) {
  var end = source.indexOf('?>', start);
  if (end) {
    var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    if (match) {
      var len = match[0].length;
      domBuilder.processingInstruction(match[1], match[2]);
      return end + 2;
    } else {
      //error
      return -1;
    }
  }
  return -1;
}
function ElementAttributes() {
  this.attributeNames = {};
}
ElementAttributes.prototype = {
  setTagName: function setTagName(tagName) {
    if (!tagNamePattern.test(tagName)) {
      throw new Error('invalid tagName:' + tagName);
    }
    this.tagName = tagName;
  },
  addValue: function addValue(qName, value, offset) {
    if (!tagNamePattern.test(qName)) {
      throw new Error('invalid attribute:' + qName);
    }
    this.attributeNames[qName] = this.length;
    this[this.length++] = {
      qName: qName,
      value: value,
      offset: offset
    };
  },
  length: 0,
  getLocalName: function getLocalName(i) {
    return this[i].localName;
  },
  getLocator: function getLocator(i) {
    return this[i].locator;
  },
  getQName: function getQName(i) {
    return this[i].qName;
  },
  getURI: function getURI(i) {
    return this[i].uri;
  },
  getValue: function getValue(i) {
    return this[i].value;
  }
  //	,getIndex:function(uri, localName)){
  //		if(localName){
  //
  //		}else{
  //			var qName = uri
  //		}
  //	},
  //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
  //	getType:function(uri,localName){}
  //	getType:function(i){},
};

function split(source, start) {
  var match;
  var buf = [];
  var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  reg.lastIndex = start;
  reg.exec(source); //skip <
  while (match = reg.exec(source)) {
    buf.push(match);
    if (match[1]) return buf;
  }
}
exports.XMLReader = XMLReader;
exports.ParseError = ParseError;

/***/ }),

/***/ 41285:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(69600);
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;
  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}

// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0;

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  var i;
  for (i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 0xFF;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }
  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 0xFF;
  }
  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}
function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
  }
  return parts.join('');
}

/***/ }),

/***/ 13423:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(66992);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(18264);
__webpack_require__(96649);
__webpack_require__(96078);
__webpack_require__(43290);
__webpack_require__(47042);
__webpack_require__(92222);
__webpack_require__(39714);
__webpack_require__(73210);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(26699);
__webpack_require__(32023);
__webpack_require__(9653);
__webpack_require__(83753);
__webpack_require__(50545);
__webpack_require__(23123);
__webpack_require__(68309);
__webpack_require__(32165);
__webpack_require__(78783);
__webpack_require__(33948);
var base64 = __webpack_require__(41285);
var ieee754 = __webpack_require__(88617);
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
: null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') {
  console.error('This browser lacks typed array (Uint8Array) support which is required by ' + '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');
}
function typedArraySupport() {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1);
    var proto = {
      foo: function foo() {
        return 42;
      }
    };
    Object.setPrototypeOf(proto, Uint8Array.prototype);
    Object.setPrototypeOf(arr, proto);
    return arr.foo() === 42;
  } catch (e) {
    return false;
  }
}
Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function get() {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.buffer;
  }
});
Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function get() {
    if (!Buffer.isBuffer(this)) return undefined;
    return this.byteOffset;
  }
});
function createBuffer(length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"');
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length);
  Object.setPrototypeOf(buf, Buffer.prototype);
  return buf;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError('The "string" argument must be of type string. Received type number');
    }
    return allocUnsafe(arg);
  }
  return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation

function from(value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset);
  }
  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value);
  }
  if (value == null) {
    throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + _typeof(value));
  }
  if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length);
  }
  if (typeof value === 'number') {
    throw new TypeError('The "value" argument must not be of type number. Received type number');
  }
  var valueOf = value.valueOf && value.valueOf();
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length);
  }
  var b = fromObject(value);
  if (b) return b;
  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
  }
  throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' + 'or Array-like Object. Received type ' + _typeof(value));
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length);
};

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number');
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"');
  }
}
function alloc(size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
  }
  return createBuffer(size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
  assertSize(size);
  return createBuffer(size < 0 ? 0 : checked(size) | 0);
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size);
};
function fromString(string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }
  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding);
  }
  var length = byteLength(string, encoding) | 0;
  var buf = createBuffer(length);
  var actual = buf.write(string, encoding);
  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
  }
  return buf;
}
function fromArrayLike(array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  var buf = createBuffer(length);
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255;
  }
  return buf;
}
function fromArrayView(arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView);
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
  }
  return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds');
  }
  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds');
  }
  var buf;
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array);
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset);
  } else {
    buf = new Uint8Array(array, byteOffset, length);
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype);
  return buf;
}
function fromObject(obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    var buf = createBuffer(len);
    if (buf.length === 0) {
      return buf;
    }
    obj.copy(buf, 0, 0, len);
    return buf;
  }
  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0);
    }
    return fromArrayLike(obj);
  }
  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data);
  }
}
function checked(length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes');
  }
  return length | 0;
}
function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
  return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
};

Buffer.compare = function compare(a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
  }
  if (a === b) return 0;
  var x = a.length;
  var y = b.length;
  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};
Buffer.concat = function concat(list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }
  if (list.length === 0) {
    return Buffer.alloc(0);
  }
  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }
  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos);
      } else {
        Uint8Array.prototype.set.call(buffer, buf, pos);
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    } else {
      buf.copy(buffer, pos);
    }
    pos += buf.length;
  }
  return buffer;
};
function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' + 'Received type ' + _typeof(string));
  }
  var len = string.length;
  var mustMatch = arguments.length > 2 && arguments[2] === true;
  if (!mustMatch && len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
        }

        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }
  if (end === undefined || end > this.length) {
    end = this.length;
  }
  if (end <= 0) {
    return '';
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;
  if (end <= start) {
    return '';
  }
  if (!encoding) encoding = 'utf8';
  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);
      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);
      case 'ascii':
        return asciiSlice(this, start, end);
      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);
      case 'base64':
        return base64Slice(this, start, end);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};
Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};
Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};
Buffer.prototype.toString = function toString() {
  var length = this.length;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
  if (this.length > max) str += ' ... ';
  return '<Buffer ' + str + '>';
};
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
}
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength);
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. ' + 'Received type ' + _typeof(target));
  }
  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }
  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }
  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }
  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;
  if (this === target) return 0;
  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);
  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);
  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }
  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }
  throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;
  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }
  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }
  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }
  return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }
  var strLen = string.length;
  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (numberIsNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}
function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0;
    if (isFinite(length)) {
      length = length >>> 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }
  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;
  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }
  if (!encoding) encoding = 'utf8';
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);
      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);
      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length);
      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);
      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};
Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};
function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}
function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];
  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;
      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }
    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }
    res.push(codePoint);
    i += bytesPerSequence;
  }
  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}
function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}
function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);
  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}
function hexSlice(buf, start, end) {
  var len = buf.length;
  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;
  var out = '';
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]];
  }
  return out;
}
function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}
Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;
  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }
  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }
  if (end < start) end = start;
  var newBuf = this.subarray(start, end);
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype);
  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }
  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }
  return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);
  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;
  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  offset = offset >>> 0;
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  byteLength = byteLength >>> 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }
  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset + 3] = value >>> 24;
  this[offset + 2] = value >>> 16;
  this[offset + 1] = value >>> 8;
  this[offset] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);
    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }
  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }
  return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  this[offset] = value >>> 8;
  this[offset + 1] = value & 0xff;
  return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  this[offset] = value & 0xff;
  this[offset + 1] = value >>> 8;
  this[offset + 2] = value >>> 16;
  this[offset + 3] = value >>> 24;
  return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  this[offset] = value >>> 24;
  this[offset + 1] = value >>> 16;
  this[offset + 2] = value >>> 8;
  this[offset + 3] = value & 0xff;
  return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
  value = +value;
  offset = offset >>> 0;
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }
  var len = end - start;
  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
  }
  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (encoding === 'utf8' && code < 128 || encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code;
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  } else if (typeof val === 'boolean') {
    val = Number(val);
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }
  if (end <= start) {
    return this;
  }
  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;
  if (!val) val = 0;
  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
    var len = bytes.length;
    if (len === 0) {
      throw new TypeError('The value "' + val + '" is invalid for argument "value"');
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }
  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0];
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}
function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];
  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;
        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }
    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }
  return bytes;
}
function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}
function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;
    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }
  return byteArray;
}
function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
  return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
  // For IE11 support
  return obj !== obj; // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function () {
  var alphabet = '0123456789abcdef';
  var table = new Array(256);
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16;
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j];
    }
  }
  return table;
}();

/***/ }),

/***/ 27266:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;__webpack_require__(74916);
__webpack_require__(23123);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(60285);
__webpack_require__(41637);
__webpack_require__(15306);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(32165);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(this, function () {
  return function download(data, strFileName, strMimeType) {
    var self = window,
      // this script is only for browsers anyway...
      defaultMime = "application/octet-stream",
      // this default mime also triggers iframe downloads
      mimeType = strMimeType || defaultMime,
      payload = data,
      url = !strFileName && !strMimeType && payload,
      anchor = document.createElement("a"),
      toString = function toString(a) {
        return String(a);
      },
      myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
      fileName = strFileName || "download",
      blob,
      reader;
    myBlob = myBlob.call ? myBlob.bind(self) : Blob;
    if (String(this) === "true") {
      //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
      payload = [payload, mimeType];
      mimeType = payload[0];
      payload = payload[1];
    }
    if (url && url.length < 2048) {
      // if no filename and no mime, assume a url was passed as the only argument
      fileName = url.split("/").pop().split("?")[0];
      anchor.href = url; // assign href prop to temp anchor
      if (anchor.href.indexOf(url) !== -1) {
        // if the browser determines that it's a potentially valid url path:
        var ajax = new XMLHttpRequest();
        ajax.open("GET", url, true);
        ajax.responseType = 'blob';
        ajax.onload = function (e) {
          download(e.target.response, fileName, defaultMime);
        };
        setTimeout(function () {
          ajax.send();
        }, 0); // allows setting custom ajax headers using the return:
        return ajax;
      } // end if valid url?
    } // end if url?

    //go ahead and download dataURLs right away
    if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
      if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
        payload = dataUrlToBlob(payload);
        mimeType = payload.type || defaultMime;
      } else {
        return navigator.msSaveBlob ?
        // IE10 can't do a[download], only Blobs:
        navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
      }
    } else {
      //not data url, is it a string with special needs?
      if (/([\x80-\xff])/.test(payload)) {
        var i = 0,
          tempUiArr = new Uint8Array(payload.length),
          mx = tempUiArr.length;
        for (i; i < mx; ++i) {
          tempUiArr[i] = payload.charCodeAt(i);
        }
        payload = new myBlob([tempUiArr], {
          type: mimeType
        });
      }
    }
    blob = payload instanceof myBlob ? payload : new myBlob([payload], {
      type: mimeType
    });
    function dataUrlToBlob(strUrl) {
      var parts = strUrl.split(/[:;,]/),
        type = parts[1],
        decoder = parts[2] == "base64" ? atob : decodeURIComponent,
        binData = decoder(parts.pop()),
        mx = binData.length,
        i = 0,
        uiArr = new Uint8Array(mx);
      for (i; i < mx; ++i) {
        uiArr[i] = binData.charCodeAt(i);
      }
      return new myBlob([uiArr], {
        type: type
      });
    }
    function saver(url, winMode) {
      if ('download' in anchor) {
        //html5 A[download]
        anchor.href = url;
        anchor.setAttribute("download", fileName);
        anchor.className = "download-js-link";
        anchor.innerHTML = "downloading...";
        anchor.style.display = "none";
        document.body.appendChild(anchor);
        setTimeout(function () {
          anchor.click();
          document.body.removeChild(anchor);
          if (winMode === true) {
            setTimeout(function () {
              self.URL.revokeObjectURL(anchor.href);
            }, 250);
          }
        }, 66);
        return true;
      }

      // handle non-a[download] safari as best we can:
      if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
        if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
        if (!window.open(url)) {
          // popup blocked, offer direct download:
          if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
            location.href = url;
          }
        }
        return true;
      }

      //do iframe dataURL download (old ch+FF):
      var f = document.createElement("iframe");
      document.body.appendChild(f);
      if (!winMode && /^data:/.test(url)) {
        // force a mime that will download:
        url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
      }
      f.src = url;
      setTimeout(function () {
        document.body.removeChild(f);
      }, 333);
    } //end saver

    if (navigator.msSaveBlob) {
      // IE10+ : (has Blob, but not a[download] or URL)
      return navigator.msSaveBlob(blob, fileName);
    }
    if (self.URL) {
      // simple fast and modern way using Blob and URL:
      saver(self.URL.createObjectURL(blob), true);
    } else {
      // handle non-Blob()+non-URL browsers:
      if (typeof blob === "string" || blob.constructor === toString) {
        try {
          return saver("data:" + mimeType + ";base64," + self.btoa(blob));
        } catch (y) {
          return saver("data:" + mimeType + "," + encodeURIComponent(blob));
        }
      }

      // Blob but not URL support:
      reader = new FileReader();
      reader.onload = function (e) {
        saver(this.result);
      };
      reader.readAsDataURL(blob);
    }
    return true;
  }; /* end download() */
});

/***/ }),

/***/ 56374:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var topLevel = typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : {};
var minDoc = __webpack_require__(25893);
var doccy;
if (typeof document !== 'undefined') {
  doccy = document;
} else {
  doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
  if (!doccy) {
    doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
  }
}
module.exports = doccy;

/***/ }),

/***/ 95732:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var win;
if (typeof window !== "undefined") {
  win = window;
} else if (typeof __webpack_require__.g !== "undefined") {
  win = __webpack_require__.g;
} else if (typeof self !== "undefined") {
  win = self;
} else {
  win = {};
}
module.exports = win;

/***/ }),

/***/ 88617:
/***/ ((__unused_webpack_module, exports) => {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];
  i += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
  buffer[offset + i - d] |= s * 128;
};

/***/ }),

/***/ 73562:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
module.exports = isFunction;
var toString = Object.prototype.toString;
function isFunction(fn) {
  if (!fn) {
    return false;
  }
  var string = toString.call(fn);
  return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}
;

/***/ }),

/***/ 28199:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_require__(21249);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(23123);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(27852);
__webpack_require__(47042);
__webpack_unused_export__ = ({
  value: true
});

/**
 * Constants.
 */

var IS_MAC = typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
var MODIFIERS = {
  alt: 'altKey',
  control: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};
var ALIASES = {
  add: '+',
  break: 'pause',
  cmd: 'meta',
  command: 'meta',
  ctl: 'control',
  ctrl: 'control',
  del: 'delete',
  down: 'arrowdown',
  esc: 'escape',
  ins: 'insert',
  left: 'arrowleft',
  mod: IS_MAC ? 'meta' : 'control',
  opt: 'alt',
  option: 'alt',
  return: 'enter',
  right: 'arrowright',
  space: ' ',
  spacebar: ' ',
  up: 'arrowup',
  win: 'meta',
  windows: 'meta'
};
var CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  ' ': 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  '\'': 222
};
for (var f = 1; f < 20; f++) {
  CODES['f' + f] = 111 + f;
}

/**
 * Is hotkey?
 */

function isHotkey(hotkey, options, event) {
  if (options && !('byKey' in options)) {
    event = options;
    options = null;
  }
  if (!Array.isArray(hotkey)) {
    hotkey = [hotkey];
  }
  var array = hotkey.map(function (string) {
    return parseHotkey(string, options);
  });
  var check = function check(e) {
    return array.some(function (object) {
      return compareHotkey(object, e);
    });
  };
  var ret = event == null ? check : check(event);
  return ret;
}
function isCodeHotkey(hotkey, event) {
  return isHotkey(hotkey, event);
}
function isKeyHotkey(hotkey, event) {
  return isHotkey(hotkey, {
    byKey: true
  }, event);
}

/**
 * Parse.
 */

function parseHotkey(hotkey, options) {
  var byKey = options && options.byKey;
  var ret = {};

  // Special case to handle the `+` key since we use it as a separator.
  hotkey = hotkey.replace('++', '+add');
  var values = hotkey.split('+');
  var length = values.length;

  // Ensure that all the modifiers are set to false unless the hotkey has them.

  for (var k in MODIFIERS) {
    ret[MODIFIERS[k]] = false;
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;
      var optional = value.endsWith('?') && value.length > 1;
      if (optional) {
        value = value.slice(0, -1);
      }
      var name = toKeyName(value);
      var modifier = MODIFIERS[name];
      if (length === 1 || !modifier) {
        if (byKey) {
          ret.key = name;
        } else {
          ret.which = toKeyCode(value);
        }
      }
      if (modifier) {
        ret[modifier] = optional ? null : true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return ret;
}

/**
 * Compare.
 */

function compareHotkey(object, event) {
  for (var key in object) {
    var expected = object[key];
    var actual = void 0;
    if (expected == null) {
      continue;
    }
    if (key === 'key' && event.key != null) {
      actual = event.key.toLowerCase();
    } else if (key === 'which') {
      actual = expected === 91 && event.which === 93 ? 91 : event.which;
    } else {
      actual = event[key];
    }
    if (actual == null && expected === false) {
      continue;
    }
    if (actual !== expected) {
      return false;
    }
  }
  return true;
}

/**
 * Utils.
 */

function toKeyCode(name) {
  name = toKeyName(name);
  var code = CODES[name] || name.toUpperCase().charCodeAt(0);
  return code;
}
function toKeyName(name) {
  name = name.toLowerCase();
  name = ALIASES[name] || name;
  return name;
}

/**
 * Export.
 */

exports.ZP = isHotkey;
__webpack_unused_export__ = isHotkey;
__webpack_unused_export__ = isCodeHotkey;
__webpack_unused_export__ = isKeyHotkey;
__webpack_unused_export__ = parseHotkey;
__webpack_unused_export__ = compareHotkey;
__webpack_unused_export__ = toKeyCode;
__webpack_unused_export__ = toKeyName;

/***/ }),

/***/ 19820:
/***/ ((module, exports, __webpack_require__) => {

__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === _typeof(searchInput)) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
    if (hasKeyCode) searchInput = hasKeyCode;
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput];

  // Everything else (cast to string)
  var search = String(searchInput);

  // check codes
  var foundNamedKey = codes[search.toLowerCase()];
  if (foundNamedKey) return foundNamedKey;

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()];
  if (foundNamedKey) return foundNamedKey;

  // weird character?
  if (search.length === 1) return search.charCodeAt(0);
  return undefined;
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === _typeof(event)) {
    var keyCode = event.which || event.keyCode || event.charCode;
    if (keyCode === null || keyCode === undefined) {
      return false;
    }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()];
      if (foundNamedKey) {
        return foundNamedKey === keyCode;
      }

      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()];
      if (foundNamedKey) {
        return foundNamedKey === keyCode;
      }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
};
exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
};

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
};

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) {
  codes[String.fromCharCode(i)] = i - 32;
}

// numbers
for (var i = 48; i < 58; i++) {
  codes[i - 48] = i;
}

// function keys
for (i = 1; i < 13; i++) {
  codes['f' + i] = i + 111;
}

// numpad keys
for (i = 0; i < 10; i++) {
  codes['numpad ' + i] = i + 96;
}

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {}; // title for backward compat

// Create reverse mapping
for (i in codes) {
  names[codes[i]] = i;
}

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias];
}

/***/ }),

/***/ 37733:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
__webpack_require__(54747);
__webpack_require__(41539);
__webpack_require__(39714);
__webpack_require__(74916);
__webpack_require__(66992);
__webpack_require__(33948);
__webpack_require__(24603);
__webpack_require__(15306);
__webpack_require__(40561);
__webpack_require__(82526);
__webpack_require__(47941);
__webpack_require__(68309);
__webpack_require__(21249);
__webpack_require__(18264);
__webpack_require__(41817);
__webpack_require__(32165);
__webpack_require__(78783);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  asyncTag = '[object AsyncFunction]',
  boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  nullTag = '[object Null]',
  objectTag = '[object Object]',
  promiseTag = '[object Promise]',
  proxyTag = '[object Proxy]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]',
  undefinedTag = '[object Undefined]',
  weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof __webpack_require__.g === "undefined" ? "undefined" : _typeof(__webpack_require__.g)) == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = ( false ? 0 : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 0 : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
  funcProto = Function.prototype,
  objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
  _Symbol = root.Symbol,
  Uint8Array = root.Uint8Array,
  propertyIsEnumerable = objectProto.propertyIsEnumerable,
  splice = arrayProto.splice,
  symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
  nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
  nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
  Map = getNative(root, 'Map'),
  Promise = getNative(root, 'Promise'),
  Set = getNative(root, 'Set'),
  WeakMap = getNative(root, 'WeakMap'),
  nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
  mapCtorString = toSource(Map),
  promiseCtorString = toSource(Promise),
  setCtorString = toSource(Set),
  weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
    isArg = !isArr && isArguments(value),
    isBuff = !isArr && !isArg && isBuffer(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
    othIsArr = isArray(other),
    objTag = objIsArr ? arrayTag : getTag(object),
    othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
    othIsObj = othTag == objectTag,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag:
      var convert = mapToArray;
    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
    tag = value[symToStringTag];
  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof(value) == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}
module.exports = isEqual;

/***/ }),

/***/ 47376:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
__webpack_require__(66992);
__webpack_require__(82472);
__webpack_require__(92990);
__webpack_require__(18927);
__webpack_require__(33105);
__webpack_require__(35035);
__webpack_require__(74345);
__webpack_require__(7174);
__webpack_require__(32846);
__webpack_require__(44731);
__webpack_require__(77209);
__webpack_require__(96319);
__webpack_require__(58867);
__webpack_require__(37789);
__webpack_require__(33739);
__webpack_require__(29368);
__webpack_require__(14483);
__webpack_require__(12056);
__webpack_require__(3462);
__webpack_require__(30678);
__webpack_require__(27462);
__webpack_require__(33824);
__webpack_require__(55021);
__webpack_require__(12974);
__webpack_require__(15016);
var getUint64 = __webpack_require__(80545).getUint64;
var parseSidx = function parseSidx(data) {
  var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
    result = {
      version: data[0],
      flags: new Uint8Array(data.subarray(1, 4)),
      references: [],
      referenceId: view.getUint32(4),
      timescale: view.getUint32(8)
    },
    i = 12;
  if (result.version === 0) {
    result.earliestPresentationTime = view.getUint32(i);
    result.firstOffset = view.getUint32(i + 4);
    i += 8;
  } else {
    // read 64 bits
    result.earliestPresentationTime = getUint64(data.subarray(i));
    result.firstOffset = getUint64(data.subarray(i + 8));
    i += 16;
  }
  i += 2; // reserved

  var referenceCount = view.getUint16(i);
  i += 2; // start of references

  for (; referenceCount > 0; i += 12, referenceCount--) {
    result.references.push({
      referenceType: (data[i] & 0x80) >>> 7,
      referencedSize: view.getUint32(i) & 0x7FFFFFFF,
      subsegmentDuration: view.getUint32(i + 4),
      startsWithSap: !!(data[i + 8] & 0x80),
      sapType: (data[i + 8] & 0x70) >>> 4,
      sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
    });
  }
  return result;
};
module.exports = parseSidx;

/***/ }),

/***/ 52953:
/***/ ((module) => {

/**
 * mux.js
 *
 * Copyright (c) Brightcove
 * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
 */
var ONE_SECOND_IN_TS = 90000,
  // 90kHz clock
  secondsToVideoTs,
  secondsToAudioTs,
  videoTsToSeconds,
  audioTsToSeconds,
  audioTsToVideoTs,
  videoTsToAudioTs,
  metadataTsToSeconds;
secondsToVideoTs = function secondsToVideoTs(seconds) {
  return seconds * ONE_SECOND_IN_TS;
};
secondsToAudioTs = function secondsToAudioTs(seconds, sampleRate) {
  return seconds * sampleRate;
};
videoTsToSeconds = function videoTsToSeconds(timestamp) {
  return timestamp / ONE_SECOND_IN_TS;
};
audioTsToSeconds = function audioTsToSeconds(timestamp, sampleRate) {
  return timestamp / sampleRate;
};
audioTsToVideoTs = function audioTsToVideoTs(timestamp, sampleRate) {
  return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
};
videoTsToAudioTs = function videoTsToAudioTs(timestamp, sampleRate) {
  return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
};

/**
 * Adjust ID3 tag or caption timing information by the timeline pts values
 * (if keepOriginalTimestamps is false) and convert to seconds
 */
metadataTsToSeconds = function metadataTsToSeconds(timestamp, timelineStartPts, keepOriginalTimestamps) {
  return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
};
module.exports = {
  ONE_SECOND_IN_TS: ONE_SECOND_IN_TS,
  secondsToVideoTs: secondsToVideoTs,
  secondsToAudioTs: secondsToAudioTs,
  videoTsToSeconds: videoTsToSeconds,
  audioTsToSeconds: audioTsToSeconds,
  audioTsToVideoTs: audioTsToVideoTs,
  videoTsToAudioTs: videoTsToAudioTs,
  metadataTsToSeconds: metadataTsToSeconds
};

/***/ }),

/***/ 80545:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(41539);
__webpack_require__(44363);
__webpack_require__(9653);
var MAX_UINT32 = Math.pow(2, 32);
var getUint64 = function getUint64(uint8) {
  var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
  var value;
  if (dv.getBigUint64) {
    value = dv.getBigUint64(0);
    if (value < Number.MAX_SAFE_INTEGER) {
      return Number(value);
    }
    return value;
  }
  return dv.getUint32(0) * MAX_UINT32 + dv.getUint32(4);
};
module.exports = {
  getUint64: getUint64,
  MAX_UINT32: MAX_UINT32
};

/***/ }),

/***/ 79758:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sY": () => (/* binding */ S),
/* harmony export */   "h": () => (/* binding */ v),
/* harmony export */   "wA": () => (/* binding */ _),
/* harmony export */   "YM": () => (/* binding */ l)
/* harmony export */ });
/* unused harmony exports hydrate, createElement, Fragment, createRef, isValidElement, cloneElement, createContext, toChildArray */
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2707);
/* harmony import */ var core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60086);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40561);
/* harmony import */ var core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__);









var n,
  l,
  u,
  i,
  t,
  o,
  r,
  f,
  e = {},
  c = [],
  s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function a(n, l) {
  for (var u in l) {
    n[u] = l[u];
  }
  return n;
}
function h(n) {
  var l = n.parentNode;
  l && l.removeChild(n);
}
function v(l, u, i) {
  var t,
    o,
    r,
    f = {};
  for (r in u) {
    "key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
  }
  if (arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for (r in l.defaultProps) {
    void 0 === f[r] && (f[r] = l.defaultProps[r]);
  }
  return y(l, f, t, o, null);
}
function y(n, i, t, o, r) {
  var f = {
    type: n,
    props: i,
    key: t,
    ref: o,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: null == r ? ++u : r
  };
  return null != l.vnode && l.vnode(f), f;
}
function p() {
  return {
    current: null
  };
}
function d(n) {
  return n.children;
}
function _(n, l) {
  this.props = n, this.context = l;
}
function k(n, l) {
  if (null == l) return n.__ ? k(n.__, n.__.__k.indexOf(n) + 1) : null;
  for (var u; l < n.__k.length; l++) {
    if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
  }
  return "function" == typeof n.type ? k(n) : null;
}
function b(n) {
  var l, u;
  if (null != (n = n.__) && null != n.__c) {
    for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) {
      if (null != (u = n.__k[l]) && null != u.__e) {
        n.__e = n.__c.base = u.__e;
        break;
      }
    }
    return b(n);
  }
}
function m(n) {
  (!n.__d && (n.__d = !0) && t.push(n) && !g.__r++ || r !== l.debounceRendering) && ((r = l.debounceRendering) || o)(g);
}
function g() {
  for (var n; g.__r = t.length;) {
    n = t.sort(function (n, l) {
      return n.__v.__b - l.__v.__b;
    }), t = [], n.some(function (n) {
      var l, u, i, t, o, r;
      n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = a({}, t)).__v = t.__v + 1, j(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [o] : null, u, null == o ? k(t) : o, t.__h), z(u, t), t.__e != o && b(t)));
    });
  }
}
function w(n, l, u, i, t, o, r, f, s, a) {
  var h,
    v,
    p,
    _,
    b,
    m,
    g,
    w = i && i.__k || c,
    A = w.length;
  for (u.__k = [], h = 0; h < l.length; h++) {
    if (null != (_ = u.__k[h] = null == (_ = l[h]) || "boolean" == typeof _ ? null : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _ ? y(null, _, null, null, _) : Array.isArray(_) ? y(d, {
      children: _
    }, null, null, null) : _.__b > 0 ? y(_.type, _.props, _.key, null, _.__v) : _)) {
      if (_.__ = u, _.__b = u.__b + 1, null === (p = w[h]) || p && _.key == p.key && _.type === p.type) w[h] = void 0;else for (v = 0; v < A; v++) {
        if ((p = w[v]) && _.key == p.key && _.type === p.type) {
          w[v] = void 0;
          break;
        }
        p = null;
      }
      j(n, _, p = p || e, t, o, r, f, s, a), b = _.__e, (v = _.ref) && p.ref != v && (g || (g = []), p.ref && g.push(p.ref, null, _), g.push(v, _.__c || b, _)), null != b ? (null == m && (m = b), "function" == typeof _.type && null != _.__k && _.__k === p.__k ? _.__d = s = x(_, s, n) : s = P(n, _, p, w, b, s), a || "option" !== u.type ? "function" == typeof u.type && (u.__d = s) : n.value = "") : s && p.__e == s && s.parentNode != n && (s = k(p));
    }
  }
  for (u.__e = m, h = A; h--;) {
    null != w[h] && ("function" == typeof u.type && null != w[h].__e && w[h].__e == u.__d && (u.__d = k(i, h + 1)), N(w[h], w[h]));
  }
  if (g) for (h = 0; h < g.length; h++) {
    M(g[h], g[++h], g[++h]);
  }
}
function x(n, l, u) {
  var i, t;
  for (i = 0; i < n.__k.length; i++) {
    (t = n.__k[i]) && (t.__ = n, l = "function" == typeof t.type ? x(t, l, u) : P(u, t, t, n.__k, t.__e, l));
  }
  return l;
}
function A(n, l) {
  return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function (n) {
    A(n, l);
  }) : l.push(n)), l;
}
function P(n, l, u, i, t, o) {
  var r, f, e;
  if (void 0 !== l.__d) r = l.__d, l.__d = void 0;else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;else {
    for (f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2) {
      if (f == t) break n;
    }
    n.insertBefore(t, o), r = o;
  }
  return void 0 !== r ? r : t.nextSibling;
}
function C(n, l, u, i, t) {
  var o;
  for (o in u) {
    "children" === o || "key" === o || o in l || H(n, o, null, u[o], i);
  }
  for (o in l) {
    t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || H(n, o, l[o], u[o], i);
  }
}
function $(n, l, u) {
  "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || s.test(l) ? u : u + "px";
}
function H(n, l, u, i, t) {
  var o;
  n: if ("style" === l) {
    if ("string" == typeof u) n.style.cssText = u;else {
      if ("string" == typeof i && (n.style.cssText = i = ""), i) for (l in i) {
        u && l in u || $(n.style, l, "");
      }
      if (u) for (l in u) {
        i && u[l] === i[l] || $(n.style, l, u[l]);
      }
    }
  } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? T : I, o) : n.removeEventListener(l, o ? T : I, o);else if ("dangerouslySetInnerHTML" !== l) {
    if (t) l = l.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
      n[l] = null == u ? "" : u;
      break n;
    } catch (n) {}
    "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
  }
}
function I(n) {
  this.l[n.type + !1](l.event ? l.event(n) : n);
}
function T(n) {
  this.l[n.type + !0](l.event ? l.event(n) : n);
}
function j(n, u, i, t, o, r, f, e, c) {
  var s,
    h,
    v,
    y,
    p,
    k,
    b,
    m,
    g,
    x,
    A,
    P = u.type;
  if (void 0 !== u.constructor) return null;
  null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [e]), (s = l.__b) && s(u);
  try {
    n: if ("function" == typeof P) {
      if (m = u.props, g = (s = P.contextType) && t[s.__c], x = s ? g ? g.props.value : s.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in P && P.prototype.render ? u.__c = h = new P(m, x) : (u.__c = h = new _(m, x), h.constructor = P, h.render = O), g && g.sub(h), h.props = m, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != P.getDerivedStateFromProps && (h.__s == h.state && (h.__s = a({}, h.__s)), a(h.__s, P.getDerivedStateFromProps(m, h.__s))), y = h.props, p = h.state, v) null == P.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);else {
        if (null == P.getDerivedStateFromProps && m !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, x) || u.__v === i.__v) {
          h.props = m, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function (n) {
            n && (n.__ = u);
          }), h.__h.length && f.push(h);
          break n;
        }
        null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, x), null != h.componentDidUpdate && h.__h.push(function () {
          h.componentDidUpdate(y, p, k);
        });
      }
      h.context = x, h.props = m, h.state = h.__s, (s = l.__r) && s(u), h.__d = !1, h.__v = u, h.__P = n, s = h.render(h.props, h.state, h.context), h.state = h.__s, null != h.getChildContext && (t = a(a({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, p)), A = null != s && s.type === d && null == s.key ? s.props.children : s, w(n, Array.isArray(A) ? A : [A], u, i, t, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
    } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = L(i.__e, u, i, t, o, r, f, c);
    (s = l.diffed) && s(u);
  } catch (n) {
    u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), l.__e(n, u, i);
  }
}
function z(n, u) {
  l.__c && l.__c(u, n), n.some(function (u) {
    try {
      n = u.__h, u.__h = [], n.some(function (n) {
        n.call(u);
      });
    } catch (n) {
      l.__e(n, u.__v);
    }
  });
}
function L(l, u, i, t, o, r, f, c) {
  var s,
    a,
    v,
    y = i.props,
    p = u.props,
    d = u.type,
    _ = 0;
  if ("svg" === d && (o = !0), null != r) for (; _ < r.length; _++) {
    if ((s = r[_]) && (s === l || (d ? s.localName == d : 3 == s.nodeType))) {
      l = s, r[_] = null;
      break;
    }
  }
  if (null == l) {
    if (null === d) return document.createTextNode(p);
    l = o ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), r = null, c = !1;
  }
  if (null === d) y === p || c && l.data === p || (l.data = p);else {
    if (r = r && n.call(l.childNodes), a = (y = i.props || e).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !c) {
      if (null != r) for (y = {}, _ = 0; _ < l.attributes.length; _++) {
        y[l.attributes[_].name] = l.attributes[_].value;
      }
      (v || a) && (v && (a && v.__html == a.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
    }
    if (C(l, p, y, o, c), v) u.__k = [];else if (_ = u.props.children, w(l, Array.isArray(_) ? _ : [_], u, i, t, o && "foreignObject" !== d, r, f, r ? r[0] : i.__k && k(i, 0), c), null != r) for (_ = r.length; _--;) {
      null != r[_] && h(r[_]);
    }
    c || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_) && H(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && H(l, "checked", _, y.checked, !1));
  }
  return l;
}
function M(n, u, i) {
  try {
    "function" == typeof n ? n(u) : n.current = u;
  } catch (n) {
    l.__e(n, i);
  }
}
function N(n, u, i) {
  var t, o;
  if (l.unmount && l.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || M(t, null, u)), null != (t = n.__c)) {
    if (t.componentWillUnmount) try {
      t.componentWillUnmount();
    } catch (n) {
      l.__e(n, u);
    }
    t.base = t.__P = null;
  }
  if (t = n.__k) for (o = 0; o < t.length; o++) {
    t[o] && N(t[o], u, "function" != typeof n.type);
  }
  i || null == n.__e || h(n.__e), n.__e = n.__d = void 0;
}
function O(n, l, u) {
  return this.constructor(n, u);
}
function S(u, i, t) {
  var o, r, f;
  l.__ && l.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], j(i, u = (!o && t || i).__k = v(d, null, [u]), r || e, e, void 0 !== i.ownerSVGElement, !o && t ? [t] : r ? null : i.firstChild ? n.call(i.childNodes) : null, f, !o && t ? t : r ? r.__e : i.firstChild, o), z(f, u);
}
function q(n, l) {
  S(n, l, q);
}
function B(l, u, i) {
  var t,
    o,
    r,
    f = a({}, l.props);
  for (r in u) {
    "key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
  }
  return arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : i), y(l.type, f, t || l.key, o || l.ref, null);
}
function D(n, l) {
  var u = {
    __c: l = "__cC" + f++,
    __: n,
    Consumer: function Consumer(n, l) {
      return n.children(l);
    },
    Provider: function Provider(n) {
      var u, i;
      return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function () {
        return i;
      }, this.shouldComponentUpdate = function (n) {
        this.props.value !== n.value && u.some(m);
      }, this.sub = function (n) {
        u.push(n);
        var l = n.componentWillUnmount;
        n.componentWillUnmount = function () {
          u.splice(u.indexOf(n), 1), l && l.call(n);
        };
      }), n.children;
    }
  };
  return u.Provider.__ = u.Consumer.contextType = u;
}
n = c.slice, l = {
  __e: function __e(n, l) {
    for (var u, i, t; l = l.__;) {
      if ((u = l.__c) && !u.__) try {
        if ((i = u.constructor) && null != i.getDerivedStateFromError && (u.setState(i.getDerivedStateFromError(n)), t = u.__d), null != u.componentDidCatch && (u.componentDidCatch(n), t = u.__d), t) return u.__E = u;
      } catch (l) {
        n = l;
      }
    }
    throw n;
  }
}, u = 0, i = function i(n) {
  return null != n && void 0 === n.constructor;
}, _.prototype.setState = function (n, l) {
  var u;
  u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = a({}, this.state), "function" == typeof n && (n = n(a({}, u), this.props)), n && a(u, n), null != n && this.__v && (l && this.__h.push(l), m(this));
}, _.prototype.forceUpdate = function (n) {
  this.__v && (this.__e = !0, n && this.__h.push(n), m(this));
}, _.prototype.render = d, t = [], o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, g.__r = 0, f = 0;


/***/ }),

/***/ 8065:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eJ": () => (/* binding */ l),
/* harmony export */   "d4": () => (/* binding */ y),
/* harmony export */   "sO": () => (/* binding */ s)
/* harmony export */ });
/* unused harmony exports useReducer, useLayoutEffect, useImperativeHandle, useMemo, useCallback, useContext, useDebugValue, useErrorBoundary */
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60086);
/* harmony import */ var core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_sub_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var preact__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79758);





var t,
  u,
  r,
  o = 0,
  i = [],
  c = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__b */ .YM.__b,
  f = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__r */ .YM.__r,
  e = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.diffed */ .YM.diffed,
  a = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__c */ .YM.__c,
  v = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.unmount */ .YM.unmount;
function m(t, r) {
  preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__h */ .YM.__h && preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__h */ .YM.__h(u, t, o || r), o = 0;
  var i = u.__H || (u.__H = {
    __: [],
    __h: []
  });
  return t >= i.__.length && i.__.push({}), i.__[t];
}
function l(n) {
  return o = 1, p(w, n);
}
function p(n, r, o) {
  var i = m(t++, 2);
  return i.t = n, i.__c || (i.__ = [o ? o(r) : w(void 0, r), function (n) {
    var t = i.t(i.__[0], n);
    i.__[0] !== t && (i.__ = [t, i.__[1]], i.__c.setState({}));
  }], i.__c = u), i.__;
}
function y(r, o) {
  var i = m(t++, 3);
  !preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__s */ .YM.__s && k(i.__H, o) && (i.__ = r, i.__H = o, u.__H.__h.push(i));
}
function h(r, o) {
  var i = m(t++, 4);
  !n.__s && k(i.__H, o) && (i.__ = r, i.__H = o, u.__h.push(i));
}
function s(n) {
  return o = 5, d(function () {
    return {
      current: n
    };
  }, []);
}
function _(n, t, u) {
  o = 6, h(function () {
    "function" == typeof n ? n(t()) : n && (n.current = t());
  }, null == u ? u : u.concat(n));
}
function d(n, u) {
  var r = m(t++, 7);
  return k(r.__H, u) && (r.__ = n(), r.__H = u, r.__h = n), r.__;
}
function A(n, t) {
  return o = 8, d(function () {
    return n;
  }, t);
}
function F(n) {
  var r = u.context[n.__c],
    o = m(t++, 9);
  return o.c = n, r ? (null == o.__ && (o.__ = !0, r.sub(u)), r.props.value) : n.__;
}
function T(t, u) {
  n.useDebugValue && n.useDebugValue(u ? u(t) : t);
}
function q(n) {
  var r = m(t++, 10),
    o = l();
  return r.__ = n, u.componentDidCatch || (u.componentDidCatch = function (n) {
    r.__ && r.__(n), o[1](n);
  }), [o[0], function () {
    o[1](void 0);
  }];
}
function x() {
  i.forEach(function (t) {
    if (t.__P) try {
      t.__H.__h.forEach(g), t.__H.__h.forEach(j), t.__H.__h = [];
    } catch (u) {
      t.__H.__h = [], preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__e */ .YM.__e(u, t.__v);
    }
  }), i = [];
}
preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__b */ .YM.__b = function (n) {
  u = null, c && c(n);
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__r */ .YM.__r = function (n) {
  f && f(n), t = 0;
  var r = (u = n.__c).__H;
  r && (r.__h.forEach(g), r.__h.forEach(j), r.__h = []);
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.diffed */ .YM.diffed = function (t) {
  e && e(t);
  var o = t.__c;
  o && o.__H && o.__H.__h.length && (1 !== i.push(o) && r === preact__WEBPACK_IMPORTED_MODULE_4__/* .options.requestAnimationFrame */ .YM.requestAnimationFrame || ((r = preact__WEBPACK_IMPORTED_MODULE_4__/* .options.requestAnimationFrame */ .YM.requestAnimationFrame) || function (n) {
    var t,
      u = function u() {
        clearTimeout(r), b && cancelAnimationFrame(t), setTimeout(n);
      },
      r = setTimeout(u, 100);
    b && (t = requestAnimationFrame(u));
  })(x)), u = void 0;
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__c */ .YM.__c = function (t, u) {
  u.some(function (t) {
    try {
      t.__h.forEach(g), t.__h = t.__h.filter(function (n) {
        return !n.__ || j(n);
      });
    } catch (r) {
      u.some(function (n) {
        n.__h && (n.__h = []);
      }), u = [], preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__e */ .YM.__e(r, t.__v);
    }
  }), a && a(t, u);
}, preact__WEBPACK_IMPORTED_MODULE_4__/* .options.unmount */ .YM.unmount = function (t) {
  v && v(t);
  var u = t.__c;
  if (u && u.__H) try {
    u.__H.__.forEach(g);
  } catch (t) {
    preact__WEBPACK_IMPORTED_MODULE_4__/* .options.__e */ .YM.__e(t, u.__v);
  }
};
var b = "function" == typeof requestAnimationFrame;
function g(n) {
  var t = u;
  "function" == typeof n.__c && n.__c(), u = t;
}
function j(n) {
  var t = u;
  n.__c = n.__(), u = t;
}
function k(n, t) {
  return !n || n.length !== t.length || t.some(function (t, u) {
    return t !== n[u];
  });
}
function w(n, t) {
  return "function" == typeof t ? t(n) : t;
}


/***/ }),

/***/ 87751:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
__webpack_require__(72443);
__webpack_require__(39341);
__webpack_require__(73706);
__webpack_require__(10408);
__webpack_require__(30489);
__webpack_require__(68309);
__webpack_require__(54747);
__webpack_require__(47042);
__webpack_require__(65743);
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };
  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }
        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }
    var previousPromise;
    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }
      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }
  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };
  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }
      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }
      context.method = method;
      context.arg = arg;
      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }
          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }
        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
          if (record.arg === ContinueSentinel) {
            continue;
          }
          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;
      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);
          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }
        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }
    var info = record.arg;
    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }
    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);
  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function () {
    return this;
  });
  define(Gp, "toString", function () {
    return "[object Generator]";
  });
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    if (1 in locs) {
      entry.catchLoc = locs[1];
    }
    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }
    this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }
  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }
  exports.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }
      if (typeof iterable.next === "function") {
        return iterable;
      }
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }
            next.value = undefined;
            next.done = true;
            return next;
          };
        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return {
      next: doneResult
    };
  }
  exports.values = values;
  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }
  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);
      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }
      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;
        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }
        return !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;
        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }
      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;
      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }
      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }
      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }
      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };
      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }
      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;
}(
// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
( false ? 0 : _typeof(module)) === "object" ? module.exports : {});
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

/***/ }),

/***/ 48119:
/***/ ((module) => {

module.exports = SafeParseTuple;
function SafeParseTuple(obj, reviver) {
  var json;
  var error = null;
  try {
    json = JSON.parse(obj, reviver);
  } catch (err) {
    error = err;
  }
  return [error, json];
}

/***/ }),

/***/ 39724:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
__webpack_require__(73210);
__webpack_require__(74916);
__webpack_require__(15306);
__webpack_require__(69600);
__webpack_require__(23123);
__webpack_require__(82526);
__webpack_require__(41817);
__webpack_require__(41539);
__webpack_require__(32165);
__webpack_require__(66992);
__webpack_require__(78783);
__webpack_require__(33948);
// see https://tools.ietf.org/html/rfc1808

(function (root) {
  var URL_REGEX = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
  var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
  var URLToolkit = {
    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
    // E.g
    // With opts.alwaysNormalize = false (default, spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
    // With opts.alwaysNormalize = true (not spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
    buildAbsoluteURL: function buildAbsoluteURL(baseURL, relativeURL, opts) {
      opts = opts || {};
      // remove any remaining space and CRLF
      baseURL = baseURL.trim();
      relativeURL = relativeURL.trim();
      if (!relativeURL) {
        // 2a) If the embedded URL is entirely empty, it inherits the
        // entire base URL (i.e., is set equal to the base URL)
        // and we are done.
        if (!opts.alwaysNormalize) {
          return baseURL;
        }
        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
        if (!basePartsForNormalise) {
          throw new Error('Error trying to parse base URL.');
        }
        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
        return URLToolkit.buildURLFromParts(basePartsForNormalise);
      }
      var relativeParts = URLToolkit.parseURL(relativeURL);
      if (!relativeParts) {
        throw new Error('Error trying to parse relative URL.');
      }
      if (relativeParts.scheme) {
        // 2b) If the embedded URL starts with a scheme name, it is
        // interpreted as an absolute URL and we are done.
        if (!opts.alwaysNormalize) {
          return relativeURL;
        }
        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
        return URLToolkit.buildURLFromParts(relativeParts);
      }
      var baseParts = URLToolkit.parseURL(baseURL);
      if (!baseParts) {
        throw new Error('Error trying to parse base URL.');
      }
      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
        baseParts.netLoc = pathParts[1];
        baseParts.path = pathParts[2];
      }
      if (baseParts.netLoc && !baseParts.path) {
        baseParts.path = '/';
      }
      var builtParts = {
        // 2c) Otherwise, the embedded URL inherits the scheme of
        // the base URL.
        scheme: baseParts.scheme,
        netLoc: relativeParts.netLoc,
        path: null,
        params: relativeParts.params,
        query: relativeParts.query,
        fragment: relativeParts.fragment
      };
      if (!relativeParts.netLoc) {
        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
        // (if any) of the base URL.
        builtParts.netLoc = baseParts.netLoc;
        // 4) If the embedded URL path is preceded by a slash "/", the
        // path is not relative and we skip to Step 7.
        if (relativeParts.path[0] !== '/') {
          if (!relativeParts.path) {
            // 5) If the embedded URL path is empty (and not preceded by a
            // slash), then the embedded URL inherits the base URL path
            builtParts.path = baseParts.path;
            // 5a) if the embedded URL's <params> is non-empty, we skip to
            // step 7; otherwise, it inherits the <params> of the base
            // URL (if any) and
            if (!relativeParts.params) {
              builtParts.params = baseParts.params;
              // 5b) if the embedded URL's <query> is non-empty, we skip to
              // step 7; otherwise, it inherits the <query> of the base
              // URL (if any) and we skip to step 7.
              if (!relativeParts.query) {
                builtParts.query = baseParts.query;
              }
            }
          } else {
            // 6) The last segment of the base URL's path (anything
            // following the rightmost slash "/", or the entire path if no
            // slash is present) is removed and the embedded URL's path is
            // appended in its place.
            var baseURLPath = baseParts.path;
            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
            builtParts.path = URLToolkit.normalizePath(newPath);
          }
        }
      }
      if (builtParts.path === null) {
        builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
      }
      return URLToolkit.buildURLFromParts(builtParts);
    },
    parseURL: function parseURL(url) {
      var parts = URL_REGEX.exec(url);
      if (!parts) {
        return null;
      }
      return {
        scheme: parts[1] || '',
        netLoc: parts[2] || '',
        path: parts[3] || '',
        params: parts[4] || '',
        query: parts[5] || '',
        fragment: parts[6] || ''
      };
    },
    normalizePath: function normalizePath(path) {
      // The following operations are
      // then applied, in order, to the new path:
      // 6a) All occurrences of "./", where "." is a complete path
      // segment, are removed.
      // 6b) If the path ends with "." as a complete path segment,
      // that "." is removed.
      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
      // 6c) All occurrences of "<segment>/../", where <segment> is a
      // complete path segment not equal to "..", are removed.
      // Removal of these path segments is performed iteratively,
      // removing the leftmost matching pattern on each iteration,
      // until no matching pattern remains.
      // 6d) If the path ends with "<segment>/..", where <segment> is a
      // complete path segment not equal to "..", that
      // "<segment>/.." is removed.
      while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length) {}
      return path.split('').reverse().join('');
    },
    buildURLFromParts: function buildURLFromParts(parts) {
      return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
    }
  };
  if (( false ? 0 : _typeof(exports)) === 'object' && ( false ? 0 : _typeof(module)) === 'object') module.exports = URLToolkit;else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return URLToolkit;
  }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {}
})(this);

/***/ }),

/***/ 99227:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Default exports for Node. Export the extended versions of VTTCue and
// VTTRegion in Node since we likely want the capability to convert back and
// forth between JSON. If we don't then it's not that big of a deal since we're
// off browser.

var window = __webpack_require__(95732);
var vttjs = module.exports = {
  WebVTT: __webpack_require__(6123),
  VTTCue: __webpack_require__(26456),
  VTTRegion: __webpack_require__(55787)
};
window.vttjs = vttjs;
window.WebVTT = vttjs.WebVTT;
var cueShim = vttjs.VTTCue;
var regionShim = vttjs.VTTRegion;
var nativeVTTCue = window.VTTCue;
var nativeVTTRegion = window.VTTRegion;
vttjs.shim = function () {
  window.VTTCue = cueShim;
  window.VTTRegion = regionShim;
};
vttjs.restore = function () {
  window.VTTCue = nativeVTTCue;
  window.VTTRegion = nativeVTTRegion;
};
if (!window.VTTCue) {
  vttjs.shim();
}

/***/ }),

/***/ 6123:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(68309);
__webpack_require__(74916);
__webpack_require__(4723);
__webpack_require__(15306);
__webpack_require__(66992);
__webpack_require__(41539);
__webpack_require__(33948);
__webpack_require__(23123);
__webpack_require__(73210);
__webpack_require__(54747);
__webpack_require__(47042);
__webpack_require__(69600);
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */
/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */
var document = __webpack_require__(56374);
var _objCreate = Object.create || function () {
  function F() {}
  return function (o) {
    if (arguments.length !== 1) {
      throw new Error('Object.create shim only accepts one parameter.');
    }
    F.prototype = o;
    return new F();
  };
}();

// Creates a new ParserError object from an errorData object. The errorData
// object should have default code and message properties. The default message
// property can be overriden by passing in a message parameter.
// See ParsingError.Errors below for acceptable errors.
function ParsingError(errorData, message) {
  this.name = "ParsingError";
  this.code = errorData.code;
  this.message = message || errorData.message;
}
ParsingError.prototype = _objCreate(Error.prototype);
ParsingError.prototype.constructor = ParsingError;

// ParsingError metadata for acceptable ParsingErrors.
ParsingError.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};

// Try to parse input as a time stamp.
function parseTimeStamp(input) {
  function computeSeconds(h, m, s, f) {
    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
  }
  var m = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
  if (!m) {
    return null;
  }
  if (m[3]) {
    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
  } else if (m[1] > 59) {
    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[1], m[2], 0, m[4]);
  } else {
    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
    return computeSeconds(0, m[1], m[2], m[4]);
  }
}

// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function Settings() {
  this.values = _objCreate(null);
}
Settings.prototype = {
  // Only accept the first assignment to any key.
  set: function set(k, v) {
    if (!this.get(k) && v !== "") {
      this.values[k] = v;
    }
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function get(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  },
  // Check whether we have a value for a key.
  has: function has(k) {
    return k in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function alt(k, v, a) {
    for (var n = 0; n < a.length; ++n) {
      if (v === a[n]) {
        this.set(k, v);
        break;
      }
    }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function integer(k, v) {
    if (/^-?\d+$/.test(v)) {
      // integer
      this.set(k, parseInt(v, 10));
    }
  },
  // Accept a setting if its a valid percentage.
  percent: function percent(k, v) {
    var m;
    if (m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
      v = parseFloat(v);
      if (v >= 0 && v <= 100) {
        this.set(k, v);
        return true;
      }
    }
    return false;
  }
};

// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
  var groups = groupDelim ? input.split(groupDelim) : [input];
  for (var i in groups) {
    if (typeof groups[i] !== "string") {
      continue;
    }
    var kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    var k = kv[0].trim();
    var v = kv[1].trim();
    callback(k, v);
  }
}
function parseCue(input, cue, regionList) {
  // Remember the original input if we need to throw an error.
  var oInput = input;
  // 4.1 WebVTT timestamp
  function consumeTimeStamp() {
    var ts = parseTimeStamp(input);
    if (ts === null) {
      throw new ParsingError(ParsingError.Errors.BadTimeStamp, "Malformed timestamp: " + oInput);
    }
    // Remove time stamp from input.
    input = input.replace(/^[^\sa-zA-Z-]+/, "");
    return ts;
  }

  // 4.4.2 WebVTT cue settings
  function consumeCueSettings(input, cue) {
    var settings = new Settings();
    parseOptions(input, function (k, v) {
      switch (k) {
        case "region":
          // Find the last region we parsed with the same region id.
          for (var i = regionList.length - 1; i >= 0; i--) {
            if (regionList[i].id === v) {
              settings.set(k, regionList[i].region);
              break;
            }
          }
          break;
        case "vertical":
          settings.alt(k, v, ["rl", "lr"]);
          break;
        case "line":
          var vals = v.split(","),
            vals0 = vals[0];
          settings.integer(k, vals0);
          settings.percent(k, vals0) ? settings.set("snapToLines", false) : null;
          settings.alt(k, vals0, ["auto"]);
          if (vals.length === 2) {
            settings.alt("lineAlign", vals[1], ["start", "center", "end"]);
          }
          break;
        case "position":
          vals = v.split(",");
          settings.percent(k, vals[0]);
          if (vals.length === 2) {
            settings.alt("positionAlign", vals[1], ["start", "center", "end"]);
          }
          break;
        case "size":
          settings.percent(k, v);
          break;
        case "align":
          settings.alt(k, v, ["start", "center", "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/);

    // Apply default values for any missing fields.
    cue.region = settings.get("region", null);
    cue.vertical = settings.get("vertical", "");
    try {
      cue.line = settings.get("line", "auto");
    } catch (e) {}
    cue.lineAlign = settings.get("lineAlign", "start");
    cue.snapToLines = settings.get("snapToLines", true);
    cue.size = settings.get("size", 100);
    // Safari still uses the old middle value and won't accept center
    try {
      cue.align = settings.get("align", "center");
    } catch (e) {
      cue.align = settings.get("align", "middle");
    }
    try {
      cue.position = settings.get("position", "auto");
    } catch (e) {
      cue.position = settings.get("position", {
        start: 0,
        left: 0,
        center: 50,
        middle: 50,
        end: 100,
        right: 100
      }, cue.align);
    }
    cue.positionAlign = settings.get("positionAlign", {
      start: "start",
      left: "start",
      center: "center",
      middle: "center",
      end: "end",
      right: "end"
    }, cue.align);
  }
  function skipWhitespace() {
    input = input.replace(/^\s+/, "");
  }

  // 4.1 WebVTT cue timings.
  skipWhitespace();
  cue.startTime = consumeTimeStamp(); // (1) collect cue start time
  skipWhitespace();
  if (input.substr(0, 3) !== "-->") {
    // (3) next characters must match "-->"
    throw new ParsingError(ParsingError.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
  }
  input = input.substr(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp(); // (5) collect cue end time

  // 4.1 WebVTT cue settings list.
  skipWhitespace();
  consumeCueSettings(input, cue);
}

// When evaluating this file as part of a Webpack bundle for server
// side rendering, `document` is an empty object.
var TEXTAREA_ELEMENT = document.createElement && document.createElement("textarea");
var TAG_NAME = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
};

// 5.1 default text color
// 5.2 default text background color is equivalent to text color with bg_ prefix
var DEFAULT_COLOR_CLASS = {
  white: 'rgba(255,255,255,1)',
  lime: 'rgba(0,255,0,1)',
  cyan: 'rgba(0,255,255,1)',
  red: 'rgba(255,0,0,1)',
  yellow: 'rgba(255,255,0,1)',
  magenta: 'rgba(255,0,255,1)',
  blue: 'rgba(0,0,255,1)',
  black: 'rgba(0,0,0,1)'
};
var TAG_ANNOTATION = {
  v: "title",
  lang: "lang"
};
var NEEDS_PARENT = {
  rt: "ruby"
};

// Parse content into a document fragment.
function parseContent(window, input) {
  function nextToken() {
    // Check for end-of-string.
    if (!input) {
      return null;
    }

    // Consume 'n' characters from the input.
    function consume(result) {
      input = input.substr(result.length);
      return result;
    }
    var m = input.match(/^([^<]*)(<[^>]*>?)?/);
    // If there is some text before the next tag, return it, otherwise return
    // the tag.
    return consume(m[1] ? m[1] : m[2]);
  }
  function unescape(s) {
    TEXTAREA_ELEMENT.innerHTML = s;
    s = TEXTAREA_ELEMENT.textContent;
    TEXTAREA_ELEMENT.textContent = "";
    return s;
  }
  function shouldAdd(current, element) {
    return !NEEDS_PARENT[element.localName] || NEEDS_PARENT[element.localName] === current.localName;
  }

  // Create an element for this tag.
  function createElement(type, annotation) {
    var tagName = TAG_NAME[type];
    if (!tagName) {
      return null;
    }
    var element = window.document.createElement(tagName);
    var name = TAG_ANNOTATION[type];
    if (name && annotation) {
      element[name] = annotation.trim();
    }
    return element;
  }
  var rootDiv = window.document.createElement("div"),
    current = rootDiv,
    t,
    tagStack = [];
  while ((t = nextToken()) !== null) {
    if (t[0] === '<') {
      if (t[1] === "/") {
        // If the closing tag matches, move back up to the parent node.
        if (tagStack.length && tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
          tagStack.pop();
          current = current.parentNode;
        }
        // Otherwise just ignore the end tag.
        continue;
      }
      var ts = parseTimeStamp(t.substr(1, t.length - 2));
      var node;
      if (ts) {
        // Timestamps are lead nodes as well.
        node = window.document.createProcessingInstruction("timestamp", ts);
        current.appendChild(node);
        continue;
      }
      var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      // If we can't parse the tag, skip to the next tag.
      if (!m) {
        continue;
      }
      // Try to construct an element, and ignore the tag if we couldn't.
      node = createElement(m[1], m[3]);
      if (!node) {
        continue;
      }
      // Determine if the tag should be added based on the context of where it
      // is placed in the cuetext.
      if (!shouldAdd(current, node)) {
        continue;
      }
      // Set the class list (as a list of classes, separated by space).
      if (m[2]) {
        var classes = m[2].split('.');
        classes.forEach(function (cl) {
          var bgColor = /^bg_/.test(cl);
          // slice out `bg_` if it's a background color
          var colorName = bgColor ? cl.slice(3) : cl;
          if (DEFAULT_COLOR_CLASS.hasOwnProperty(colorName)) {
            var propName = bgColor ? 'background-color' : 'color';
            var propValue = DEFAULT_COLOR_CLASS[colorName];
            node.style[propName] = propValue;
          }
        });
        node.className = classes.join(' ');
      }
      // Append the node to the current node, and enter the scope of the new
      // node.
      tagStack.push(m[1]);
      current.appendChild(node);
      current = node;
      continue;
    }

    // Text nodes are leaf nodes.
    current.appendChild(window.document.createTextNode(unescape(t)));
  }
  return rootDiv;
}

// This is a list of all the Unicode characters that have a strong
// right-to-left category. What this means is that these characters are
// written right-to-left for sure. It was generated by pulling all the strong
// right-to-left characters out of the Unicode data table. That table can
// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
var strongRTLRanges = [[0x5be, 0x5be], [0x5c0, 0x5c0], [0x5c3, 0x5c3], [0x5c6, 0x5c6], [0x5d0, 0x5ea], [0x5f0, 0x5f4], [0x608, 0x608], [0x60b, 0x60b], [0x60d, 0x60d], [0x61b, 0x61b], [0x61e, 0x64a], [0x66d, 0x66f], [0x671, 0x6d5], [0x6e5, 0x6e6], [0x6ee, 0x6ef], [0x6fa, 0x70d], [0x70f, 0x710], [0x712, 0x72f], [0x74d, 0x7a5], [0x7b1, 0x7b1], [0x7c0, 0x7ea], [0x7f4, 0x7f5], [0x7fa, 0x7fa], [0x800, 0x815], [0x81a, 0x81a], [0x824, 0x824], [0x828, 0x828], [0x830, 0x83e], [0x840, 0x858], [0x85e, 0x85e], [0x8a0, 0x8a0], [0x8a2, 0x8ac], [0x200f, 0x200f], [0xfb1d, 0xfb1d], [0xfb1f, 0xfb28], [0xfb2a, 0xfb36], [0xfb38, 0xfb3c], [0xfb3e, 0xfb3e], [0xfb40, 0xfb41], [0xfb43, 0xfb44], [0xfb46, 0xfbc1], [0xfbd3, 0xfd3d], [0xfd50, 0xfd8f], [0xfd92, 0xfdc7], [0xfdf0, 0xfdfc], [0xfe70, 0xfe74], [0xfe76, 0xfefc], [0x10800, 0x10805], [0x10808, 0x10808], [0x1080a, 0x10835], [0x10837, 0x10838], [0x1083c, 0x1083c], [0x1083f, 0x10855], [0x10857, 0x1085f], [0x10900, 0x1091b], [0x10920, 0x10939], [0x1093f, 0x1093f], [0x10980, 0x109b7], [0x109be, 0x109bf], [0x10a00, 0x10a00], [0x10a10, 0x10a13], [0x10a15, 0x10a17], [0x10a19, 0x10a33], [0x10a40, 0x10a47], [0x10a50, 0x10a58], [0x10a60, 0x10a7f], [0x10b00, 0x10b35], [0x10b40, 0x10b55], [0x10b58, 0x10b72], [0x10b78, 0x10b7f], [0x10c00, 0x10c48], [0x1ee00, 0x1ee03], [0x1ee05, 0x1ee1f], [0x1ee21, 0x1ee22], [0x1ee24, 0x1ee24], [0x1ee27, 0x1ee27], [0x1ee29, 0x1ee32], [0x1ee34, 0x1ee37], [0x1ee39, 0x1ee39], [0x1ee3b, 0x1ee3b], [0x1ee42, 0x1ee42], [0x1ee47, 0x1ee47], [0x1ee49, 0x1ee49], [0x1ee4b, 0x1ee4b], [0x1ee4d, 0x1ee4f], [0x1ee51, 0x1ee52], [0x1ee54, 0x1ee54], [0x1ee57, 0x1ee57], [0x1ee59, 0x1ee59], [0x1ee5b, 0x1ee5b], [0x1ee5d, 0x1ee5d], [0x1ee5f, 0x1ee5f], [0x1ee61, 0x1ee62], [0x1ee64, 0x1ee64], [0x1ee67, 0x1ee6a], [0x1ee6c, 0x1ee72], [0x1ee74, 0x1ee77], [0x1ee79, 0x1ee7c], [0x1ee7e, 0x1ee7e], [0x1ee80, 0x1ee89], [0x1ee8b, 0x1ee9b], [0x1eea1, 0x1eea3], [0x1eea5, 0x1eea9], [0x1eeab, 0x1eebb], [0x10fffd, 0x10fffd]];
function isStrongRTLChar(charCode) {
  for (var i = 0; i < strongRTLRanges.length; i++) {
    var currentRange = strongRTLRanges[i];
    if (charCode >= currentRange[0] && charCode <= currentRange[1]) {
      return true;
    }
  }
  return false;
}
function determineBidi(cueDiv) {
  var nodeStack = [],
    text = "",
    charCode;
  if (!cueDiv || !cueDiv.childNodes) {
    return "ltr";
  }
  function pushNodes(nodeStack, node) {
    for (var i = node.childNodes.length - 1; i >= 0; i--) {
      nodeStack.push(node.childNodes[i]);
    }
  }
  function nextTextNode(nodeStack) {
    if (!nodeStack || !nodeStack.length) {
      return null;
    }
    var node = nodeStack.pop(),
      text = node.textContent || node.innerText;
    if (text) {
      // TODO: This should match all unicode type B characters (paragraph
      // separator characters). See issue #115.
      var m = text.match(/^.*(\n|\r)/);
      if (m) {
        nodeStack.length = 0;
        return m[0];
      }
      return text;
    }
    if (node.tagName === "ruby") {
      return nextTextNode(nodeStack);
    }
    if (node.childNodes) {
      pushNodes(nodeStack, node);
      return nextTextNode(nodeStack);
    }
  }
  pushNodes(nodeStack, cueDiv);
  while (text = nextTextNode(nodeStack)) {
    for (var i = 0; i < text.length; i++) {
      charCode = text.charCodeAt(i);
      if (isStrongRTLChar(charCode)) {
        return "rtl";
      }
    }
  }
  return "ltr";
}
function computeLinePos(cue) {
  if (typeof cue.line === "number" && (cue.snapToLines || cue.line >= 0 && cue.line <= 100)) {
    return cue.line;
  }
  if (!cue.track || !cue.track.textTrackList || !cue.track.textTrackList.mediaElement) {
    return -1;
  }
  var track = cue.track,
    trackList = track.textTrackList,
    count = 0;
  for (var i = 0; i < trackList.length && trackList[i] !== track; i++) {
    if (trackList[i].mode === "showing") {
      count++;
    }
  }
  return ++count * -1;
}
function StyleBox() {}

// Apply styles to a div. If there is no div passed then it defaults to the
// div on 'this'.
StyleBox.prototype.applyStyles = function (styles, div) {
  div = div || this.div;
  for (var prop in styles) {
    if (styles.hasOwnProperty(prop)) {
      div.style[prop] = styles[prop];
    }
  }
};
StyleBox.prototype.formatStyle = function (val, unit) {
  return val === 0 ? 0 : val + unit;
};

// Constructs the computed display state of the cue (a div). Places the div
// into the overlay which should be a block level element (usually a div).
function CueStyleBox(window, cue, styleOptions) {
  StyleBox.call(this);
  this.cue = cue;

  // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
  // have inline positioning and will function as the cue background box.
  this.cueDiv = parseContent(window, cue.text);
  var styles = {
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline",
    writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext"
  };
  this.applyStyles(styles, this.cueDiv);

  // Create an absolutely positioned div that will be used to position the cue
  // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
  // mirrors of them except middle instead of center on Safari.
  this.div = window.document.createElement("div");
  styles = {
    direction: determineBidi(this.cueDiv),
    writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: cue.align === "middle" ? "center" : cue.align,
    font: styleOptions.font,
    whiteSpace: "pre-line",
    position: "absolute"
  };
  this.applyStyles(styles);
  this.div.appendChild(this.cueDiv);

  // Calculate the distance from the reference edge of the viewport to the text
  // position of the cue box. The reference edge will be resolved later when
  // the box orientation styles are applied.
  var textPos = 0;
  switch (cue.positionAlign) {
    case "start":
    case "line-left":
      textPos = cue.position;
      break;
    case "center":
      textPos = cue.position - cue.size / 2;
      break;
    case "end":
    case "line-right":
      textPos = cue.position - cue.size;
      break;
  }

  // Horizontal box orientation; textPos is the distance from the left edge of the
  // area to the left edge of the box and cue.size is the distance extending to
  // the right from there.
  if (cue.vertical === "") {
    this.applyStyles({
      left: this.formatStyle(textPos, "%"),
      width: this.formatStyle(cue.size, "%")
    });
    // Vertical box orientation; textPos is the distance from the top edge of the
    // area to the top edge of the box and cue.size is the height extending
    // downwards from there.
  } else {
    this.applyStyles({
      top: this.formatStyle(textPos, "%"),
      height: this.formatStyle(cue.size, "%")
    });
  }
  this.move = function (box) {
    this.applyStyles({
      top: this.formatStyle(box.top, "px"),
      bottom: this.formatStyle(box.bottom, "px"),
      left: this.formatStyle(box.left, "px"),
      right: this.formatStyle(box.right, "px"),
      height: this.formatStyle(box.height, "px"),
      width: this.formatStyle(box.width, "px")
    });
  };
}
CueStyleBox.prototype = _objCreate(StyleBox.prototype);
CueStyleBox.prototype.constructor = CueStyleBox;

// Represents the co-ordinates of an Element in a way that we can easily
// compute things with such as if it overlaps or intersects with another Element.
// Can initialize it with either a StyleBox or another BoxPosition.
function BoxPosition(obj) {
  // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
  // was passed in and we need to copy the results of 'getBoundingClientRect'
  // as the object returned is readonly. All co-ordinate values are in reference
  // to the viewport origin (top left).
  var lh, height, width, top;
  if (obj.div) {
    height = obj.div.offsetHeight;
    width = obj.div.offsetWidth;
    top = obj.div.offsetTop;
    var rects = (rects = obj.div.childNodes) && (rects = rects[0]) && rects.getClientRects && rects.getClientRects();
    obj = obj.div.getBoundingClientRect();
    // In certain cases the outter div will be slightly larger then the sum of
    // the inner div's lines. This could be due to bold text, etc, on some platforms.
    // In this case we should get the average line height and use that. This will
    // result in the desired behaviour.
    lh = rects ? Math.max(rects[0] && rects[0].height || 0, obj.height / rects.length) : 0;
  }
  this.left = obj.left;
  this.right = obj.right;
  this.top = obj.top || top;
  this.height = obj.height || height;
  this.bottom = obj.bottom || top + (obj.height || height);
  this.width = obj.width || width;
  this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
}

// Move the box along a particular axis. Optionally pass in an amount to move
// the box. If no amount is passed then the default is the line height of the
// box.
BoxPosition.prototype.move = function (axis, toMove) {
  toMove = toMove !== undefined ? toMove : this.lineHeight;
  switch (axis) {
    case "+x":
      this.left += toMove;
      this.right += toMove;
      break;
    case "-x":
      this.left -= toMove;
      this.right -= toMove;
      break;
    case "+y":
      this.top += toMove;
      this.bottom += toMove;
      break;
    case "-y":
      this.top -= toMove;
      this.bottom -= toMove;
      break;
  }
};

// Check if this box overlaps another box, b2.
BoxPosition.prototype.overlaps = function (b2) {
  return this.left < b2.right && this.right > b2.left && this.top < b2.bottom && this.bottom > b2.top;
};

// Check if this box overlaps any other boxes in boxes.
BoxPosition.prototype.overlapsAny = function (boxes) {
  for (var i = 0; i < boxes.length; i++) {
    if (this.overlaps(boxes[i])) {
      return true;
    }
  }
  return false;
};

// Check if this box is within another box.
BoxPosition.prototype.within = function (container) {
  return this.top >= container.top && this.bottom <= container.bottom && this.left >= container.left && this.right <= container.right;
};

// Check if this box is entirely within the container or it is overlapping
// on the edge opposite of the axis direction passed. For example, if "+x" is
// passed and the box is overlapping on the left edge of the container, then
// return true.
BoxPosition.prototype.overlapsOppositeAxis = function (container, axis) {
  switch (axis) {
    case "+x":
      return this.left < container.left;
    case "-x":
      return this.right > container.right;
    case "+y":
      return this.top < container.top;
    case "-y":
      return this.bottom > container.bottom;
  }
};

// Find the percentage of the area that this box is overlapping with another
// box.
BoxPosition.prototype.intersectPercentage = function (b2) {
  var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)),
    y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)),
    intersectArea = x * y;
  return intersectArea / (this.height * this.width);
};

// Convert the positions from this box to CSS compatible positions using
// the reference container's positions. This has to be done because this
// box's positions are in reference to the viewport origin, whereas, CSS
// values are in referecne to their respective edges.
BoxPosition.prototype.toCSSCompatValues = function (reference) {
  return {
    top: this.top - reference.top,
    bottom: reference.bottom - this.bottom,
    left: this.left - reference.left,
    right: reference.right - this.right,
    height: this.height,
    width: this.width
  };
};

// Get an object that represents the box's position without anything extra.
// Can pass a StyleBox, HTMLElement, or another BoxPositon.
BoxPosition.getSimpleBoxPosition = function (obj) {
  var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
  var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
  var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
  obj = obj.div ? obj.div.getBoundingClientRect() : obj.tagName ? obj.getBoundingClientRect() : obj;
  var ret = {
    left: obj.left,
    right: obj.right,
    top: obj.top || top,
    height: obj.height || height,
    bottom: obj.bottom || top + (obj.height || height),
    width: obj.width || width
  };
  return ret;
};

// Move a StyleBox to its specified, or next best, position. The containerBox
// is the box that contains the StyleBox, such as a div. boxPositions are
// a list of other boxes that the styleBox can't overlap with.
function moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
  // Find the best position for a cue box, b, on the video. The axis parameter
  // is a list of axis, the order of which, it will move the box along. For example:
  // Passing ["+x", "-x"] will move the box first along the x axis in the positive
  // direction. If it doesn't find a good position for it there it will then move
  // it along the x axis in the negative direction.
  function findBestPosition(b, axis) {
    var bestPosition,
      specifiedPosition = new BoxPosition(b),
      percentage = 1; // Highest possible so the first thing we get is better.

    for (var i = 0; i < axis.length; i++) {
      while (b.overlapsOppositeAxis(containerBox, axis[i]) || b.within(containerBox) && b.overlapsAny(boxPositions)) {
        b.move(axis[i]);
      }
      // We found a spot where we aren't overlapping anything. This is our
      // best position.
      if (b.within(containerBox)) {
        return b;
      }
      var p = b.intersectPercentage(containerBox);
      // If we're outside the container box less then we were on our last try
      // then remember this position as the best position.
      if (percentage > p) {
        bestPosition = new BoxPosition(b);
        percentage = p;
      }
      // Reset the box position to the specified position.
      b = new BoxPosition(specifiedPosition);
    }
    return bestPosition || specifiedPosition;
  }
  var boxPosition = new BoxPosition(styleBox),
    cue = styleBox.cue,
    linePos = computeLinePos(cue),
    axis = [];

  // If we have a line number to align the cue to.
  if (cue.snapToLines) {
    var size;
    switch (cue.vertical) {
      case "":
        axis = ["+y", "-y"];
        size = "height";
        break;
      case "rl":
        axis = ["+x", "-x"];
        size = "width";
        break;
      case "lr":
        axis = ["-x", "+x"];
        size = "width";
        break;
    }
    var step = boxPosition.lineHeight,
      position = step * Math.round(linePos),
      maxPosition = containerBox[size] + step,
      initialAxis = axis[0];

    // If the specified intial position is greater then the max position then
    // clamp the box to the amount of steps it would take for the box to
    // reach the max position.
    if (Math.abs(position) > maxPosition) {
      position = position < 0 ? -1 : 1;
      position *= Math.ceil(maxPosition / step) * step;
    }

    // If computed line position returns negative then line numbers are
    // relative to the bottom of the video instead of the top. Therefore, we
    // need to increase our initial position by the length or width of the
    // video, depending on the writing direction, and reverse our axis directions.
    if (linePos < 0) {
      position += cue.vertical === "" ? containerBox.height : containerBox.width;
      axis = axis.reverse();
    }

    // Move the box to the specified position. This may not be its best
    // position.
    boxPosition.move(initialAxis, position);
  } else {
    // If we have a percentage line value for the cue.
    var calculatedPercentage = boxPosition.lineHeight / containerBox.height * 100;
    switch (cue.lineAlign) {
      case "center":
        linePos -= calculatedPercentage / 2;
        break;
      case "end":
        linePos -= calculatedPercentage;
        break;
    }

    // Apply initial line position to the cue box.
    switch (cue.vertical) {
      case "":
        styleBox.applyStyles({
          top: styleBox.formatStyle(linePos, "%")
        });
        break;
      case "rl":
        styleBox.applyStyles({
          left: styleBox.formatStyle(linePos, "%")
        });
        break;
      case "lr":
        styleBox.applyStyles({
          right: styleBox.formatStyle(linePos, "%")
        });
        break;
    }
    axis = ["+y", "-x", "+x", "-y"];

    // Get the box position again after we've applied the specified positioning
    // to it.
    boxPosition = new BoxPosition(styleBox);
  }
  var bestPosition = findBestPosition(boxPosition, axis);
  styleBox.move(bestPosition.toCSSCompatValues(containerBox));
}
function WebVTT() {
  // Nothing
}

// Helper to allow strings to be decoded instead of the default binary utf8 data.
WebVTT.StringDecoder = function () {
  return {
    decode: function decode(data) {
      if (!data) {
        return "";
      }
      if (typeof data !== "string") {
        throw new Error("Error - expected string data.");
      }
      return decodeURIComponent(encodeURIComponent(data));
    }
  };
};
WebVTT.convertCueToDOMTree = function (window, cuetext) {
  if (!window || !cuetext) {
    return null;
  }
  return parseContent(window, cuetext);
};
var FONT_SIZE_PERCENT = 0.05;
var FONT_STYLE = "sans-serif";
var CUE_BACKGROUND_PADDING = "1.5%";

// Runs the processing model over the cues and regions passed to it.
// @param overlay A block level element (usually a div) that the computed cues
//                and regions will be placed into.
WebVTT.processCues = function (window, cues, overlay) {
  if (!window || !cues || !overlay) {
    return null;
  }

  // Remove all previous children.
  while (overlay.firstChild) {
    overlay.removeChild(overlay.firstChild);
  }
  var paddedOverlay = window.document.createElement("div");
  paddedOverlay.style.position = "absolute";
  paddedOverlay.style.left = "0";
  paddedOverlay.style.right = "0";
  paddedOverlay.style.top = "0";
  paddedOverlay.style.bottom = "0";
  paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
  overlay.appendChild(paddedOverlay);

  // Determine if we need to compute the display states of the cues. This could
  // be the case if a cue's state has been changed since the last computation or
  // if it has not been computed yet.
  function shouldCompute(cues) {
    for (var i = 0; i < cues.length; i++) {
      if (cues[i].hasBeenReset || !cues[i].displayState) {
        return true;
      }
    }
    return false;
  }

  // We don't need to recompute the cues' display states. Just reuse them.
  if (!shouldCompute(cues)) {
    for (var i = 0; i < cues.length; i++) {
      paddedOverlay.appendChild(cues[i].displayState);
    }
    return;
  }
  var boxPositions = [],
    containerBox = BoxPosition.getSimpleBoxPosition(paddedOverlay),
    fontSize = Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100;
  var styleOptions = {
    font: fontSize + "px " + FONT_STYLE
  };
  (function () {
    var styleBox, cue;
    for (var i = 0; i < cues.length; i++) {
      cue = cues[i];

      // Compute the intial position and styles of the cue div.
      styleBox = new CueStyleBox(window, cue, styleOptions);
      paddedOverlay.appendChild(styleBox.div);

      // Move the cue div to it's correct line position.
      moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);

      // Remember the computed div so that we don't have to recompute it later
      // if we don't have too.
      cue.displayState = styleBox.div;
      boxPositions.push(BoxPosition.getSimpleBoxPosition(styleBox));
    }
  })();
};
WebVTT.Parser = function (window, vttjs, decoder) {
  if (!decoder) {
    decoder = vttjs;
    vttjs = {};
  }
  if (!vttjs) {
    vttjs = {};
  }
  this.window = window;
  this.vttjs = vttjs;
  this.state = "INITIAL";
  this.buffer = "";
  this.decoder = decoder || new TextDecoder("utf8");
  this.regionList = [];
};
WebVTT.Parser.prototype = {
  // If the error is a ParsingError then report it to the consumer if
  // possible. If it's not a ParsingError then throw it like normal.
  reportOrThrowError: function reportOrThrowError(e) {
    if (e instanceof ParsingError) {
      this.onparsingerror && this.onparsingerror(e);
    } else {
      throw e;
    }
  },
  parse: function parse(data) {
    var self = this;

    // If there is no data then we won't decode it, but will just try to parse
    // whatever is in buffer already. This may occur in circumstances, for
    // example when flush() is called.
    if (data) {
      // Try to decode the data that we received.
      self.buffer += self.decoder.decode(data, {
        stream: true
      });
    }
    function collectNextLine() {
      var buffer = self.buffer;
      var pos = 0;
      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
        ++pos;
      }
      var line = buffer.substr(0, pos);
      // Advance the buffer early in case we fail below.
      if (buffer[pos] === '\r') {
        ++pos;
      }
      if (buffer[pos] === '\n') {
        ++pos;
      }
      self.buffer = buffer.substr(pos);
      return line;
    }

    // 3.4 WebVTT region and WebVTT region settings syntax
    function parseRegion(input) {
      var settings = new Settings();
      parseOptions(input, function (k, v) {
        switch (k) {
          case "id":
            settings.set(k, v);
            break;
          case "width":
            settings.percent(k, v);
            break;
          case "lines":
            settings.integer(k, v);
            break;
          case "regionanchor":
          case "viewportanchor":
            var xy = v.split(',');
            if (xy.length !== 2) {
              break;
            }
            // We have to make sure both x and y parse, so use a temporary
            // settings object here.
            var anchor = new Settings();
            anchor.percent("x", xy[0]);
            anchor.percent("y", xy[1]);
            if (!anchor.has("x") || !anchor.has("y")) {
              break;
            }
            settings.set(k + "X", anchor.get("x"));
            settings.set(k + "Y", anchor.get("y"));
            break;
          case "scroll":
            settings.alt(k, v, ["up"]);
            break;
        }
      }, /=/, /\s/);

      // Create the region, using default values for any values that were not
      // specified.
      if (settings.has("id")) {
        var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
        region.width = settings.get("width", 100);
        region.lines = settings.get("lines", 3);
        region.regionAnchorX = settings.get("regionanchorX", 0);
        region.regionAnchorY = settings.get("regionanchorY", 100);
        region.viewportAnchorX = settings.get("viewportanchorX", 0);
        region.viewportAnchorY = settings.get("viewportanchorY", 100);
        region.scroll = settings.get("scroll", "");
        // Register the region.
        self.onregion && self.onregion(region);
        // Remember the VTTRegion for later in case we parse any VTTCues that
        // reference it.
        self.regionList.push({
          id: settings.get("id"),
          region: region
        });
      }
    }

    // draft-pantos-http-live-streaming-20
    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
    // 3.5 WebVTT
    function parseTimestampMap(input) {
      var settings = new Settings();
      parseOptions(input, function (k, v) {
        switch (k) {
          case "MPEGT":
            settings.integer(k + 'S', v);
            break;
          case "LOCA":
            settings.set(k + 'L', parseTimeStamp(v));
            break;
        }
      }, /[^\d]:/, /,/);
      self.ontimestampmap && self.ontimestampmap({
        "MPEGTS": settings.get("MPEGTS"),
        "LOCAL": settings.get("LOCAL")
      });
    }

    // 3.2 WebVTT metadata header syntax
    function parseHeader(input) {
      if (input.match(/X-TIMESTAMP-MAP/)) {
        // This line contains HLS X-TIMESTAMP-MAP metadata
        parseOptions(input, function (k, v) {
          switch (k) {
            case "X-TIMESTAMP-MAP":
              parseTimestampMap(v);
              break;
          }
        }, /=/);
      } else {
        parseOptions(input, function (k, v) {
          switch (k) {
            case "Region":
              // 3.3 WebVTT region metadata header syntax
              parseRegion(v);
              break;
          }
        }, /:/);
      }
    }

    // 5.1 WebVTT file parsing.
    try {
      var line;
      if (self.state === "INITIAL") {
        // We can't start parsing until we have the first line.
        if (!/\r\n|\n/.test(self.buffer)) {
          return this;
        }
        line = collectNextLine();
        var m = line.match(/^WEBVTT([ \t].*)?$/);
        if (!m || !m[0]) {
          throw new ParsingError(ParsingError.Errors.BadSignature);
        }
        self.state = "HEADER";
      }
      var alreadyCollectedLine = false;
      while (self.buffer) {
        // We can't parse a line until we have the full line.
        if (!/\r\n|\n/.test(self.buffer)) {
          return this;
        }
        if (!alreadyCollectedLine) {
          line = collectNextLine();
        } else {
          alreadyCollectedLine = false;
        }
        switch (self.state) {
          case "HEADER":
            // 13-18 - Allow a header (metadata) under the WEBVTT line.
            if (/:/.test(line)) {
              parseHeader(line);
            } else if (!line) {
              // An empty line terminates the header and starts the body (cues).
              self.state = "ID";
            }
            continue;
          case "NOTE":
            // Ignore NOTE blocks.
            if (!line) {
              self.state = "ID";
            }
            continue;
          case "ID":
            // Check for the start of NOTE blocks.
            if (/^NOTE($|[ \t])/.test(line)) {
              self.state = "NOTE";
              break;
            }
            // 19-29 - Allow any number of line terminators, then initialize new cue values.
            if (!line) {
              continue;
            }
            self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
            // Safari still uses the old middle value and won't accept center
            try {
              self.cue.align = "center";
            } catch (e) {
              self.cue.align = "middle";
            }
            self.state = "CUE";
            // 30-39 - Check if self line contains an optional identifier or timing data.
            if (line.indexOf("-->") === -1) {
              self.cue.id = line;
              continue;
            }
          // Process line as start of a cue.
          /*falls through*/
          case "CUE":
            // 40 - Collect cue timings and settings.
            try {
              parseCue(line, self.cue, self.regionList);
            } catch (e) {
              self.reportOrThrowError(e);
              // In case of an error ignore rest of the cue.
              self.cue = null;
              self.state = "BADCUE";
              continue;
            }
            self.state = "CUETEXT";
            continue;
          case "CUETEXT":
            var hasSubstring = line.indexOf("-->") !== -1;
            // 34 - If we have an empty line then report the cue.
            // 35 - If we have the special substring '-->' then report the cue,
            // but do not collect the line as we need to process the current
            // one as a new cue.
            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
              // We are done parsing self cue.
              self.oncue && self.oncue(self.cue);
              self.cue = null;
              self.state = "ID";
              continue;
            }
            if (self.cue.text) {
              self.cue.text += "\n";
            }
            self.cue.text += line.replace(/\u2028/g, '\n').replace(/u2029/g, '\n');
            continue;
          case "BADCUE":
            // BADCUE
            // 54-62 - Collect and discard the remaining cue.
            if (!line) {
              self.state = "ID";
            }
            continue;
        }
      }
    } catch (e) {
      self.reportOrThrowError(e);

      // If we are currently parsing a cue, report what we have.
      if (self.state === "CUETEXT" && self.cue && self.oncue) {
        self.oncue(self.cue);
      }
      self.cue = null;
      // Enter BADWEBVTT state if header was not parsed correctly otherwise
      // another exception occurred so enter BADCUE state.
      self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function flush() {
    var self = this;
    try {
      // Finish decoding the stream.
      self.buffer += self.decoder.decode();
      // Synthesize the end of the current cue or region.
      if (self.cue || self.state === "HEADER") {
        self.buffer += "\n\n";
        self.parse();
      }
      // If we've flushed, parsed, and we're still on the INITIAL state then
      // that means we don't have enough of the stream to parse the first
      // line.
      if (self.state === "INITIAL") {
        throw new ParsingError(ParsingError.Errors.BadSignature);
      }
    } catch (e) {
      self.reportOrThrowError(e);
    }
    self.onflush && self.onflush();
    return this;
  }
};
module.exports = WebVTT;

/***/ }),

/***/ 26456:
/***/ ((module) => {

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var autoKeyword = "auto";
var directionSetting = {
  "": 1,
  "lr": 1,
  "rl": 1
};
var alignSetting = {
  "start": 1,
  "center": 1,
  "end": 1,
  "left": 1,
  "right": 1,
  "auto": 1,
  "line-left": 1,
  "line-right": 1
};
function findDirectionSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var dir = directionSetting[value.toLowerCase()];
  return dir ? value.toLowerCase() : false;
}
function findAlignSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var align = alignSetting[value.toLowerCase()];
  return align ? value.toLowerCase() : false;
}
function VTTCue(startTime, endTime, text) {
  /**
   * Shim implementation specific properties. These properties are not in
   * the spec.
   */

  // Lets us know when the VTTCue's data has changed in such a way that we need
  // to recompute its display state. This lets us compute its display state
  // lazily.
  this.hasBeenReset = false;

  /**
   * VTTCue and TextTrackCue properties
   * http://dev.w3.org/html5/webvtt/#vttcue-interface
   */

  var _id = "";
  var _pauseOnExit = false;
  var _startTime = startTime;
  var _endTime = endTime;
  var _text = text;
  var _region = null;
  var _vertical = "";
  var _snapToLines = true;
  var _line = "auto";
  var _lineAlign = "start";
  var _position = "auto";
  var _positionAlign = "auto";
  var _size = 100;
  var _align = "center";
  Object.defineProperties(this, {
    "id": {
      enumerable: true,
      get: function get() {
        return _id;
      },
      set: function set(value) {
        _id = "" + value;
      }
    },
    "pauseOnExit": {
      enumerable: true,
      get: function get() {
        return _pauseOnExit;
      },
      set: function set(value) {
        _pauseOnExit = !!value;
      }
    },
    "startTime": {
      enumerable: true,
      get: function get() {
        return _startTime;
      },
      set: function set(value) {
        if (typeof value !== "number") {
          throw new TypeError("Start time must be set to a number.");
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    },
    "endTime": {
      enumerable: true,
      get: function get() {
        return _endTime;
      },
      set: function set(value) {
        if (typeof value !== "number") {
          throw new TypeError("End time must be set to a number.");
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    },
    "text": {
      enumerable: true,
      get: function get() {
        return _text;
      },
      set: function set(value) {
        _text = "" + value;
        this.hasBeenReset = true;
      }
    },
    "region": {
      enumerable: true,
      get: function get() {
        return _region;
      },
      set: function set(value) {
        _region = value;
        this.hasBeenReset = true;
      }
    },
    "vertical": {
      enumerable: true,
      get: function get() {
        return _vertical;
      },
      set: function set(value) {
        var setting = findDirectionSetting(value);
        // Have to check for false because the setting an be an empty string.
        if (setting === false) {
          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    },
    "snapToLines": {
      enumerable: true,
      get: function get() {
        return _snapToLines;
      },
      set: function set(value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    },
    "line": {
      enumerable: true,
      get: function get() {
        return _line;
      },
      set: function set(value) {
        if (typeof value !== "number" && value !== autoKeyword) {
          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
        }
        _line = value;
        this.hasBeenReset = true;
      }
    },
    "lineAlign": {
      enumerable: true,
      get: function get() {
        return _lineAlign;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          console.warn("lineAlign: an invalid or illegal string was specified.");
        } else {
          _lineAlign = setting;
          this.hasBeenReset = true;
        }
      }
    },
    "position": {
      enumerable: true,
      get: function get() {
        return _position;
      },
      set: function set(value) {
        if (value < 0 || value > 100) {
          throw new Error("Position must be between 0 and 100.");
        }
        _position = value;
        this.hasBeenReset = true;
      }
    },
    "positionAlign": {
      enumerable: true,
      get: function get() {
        return _positionAlign;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          console.warn("positionAlign: an invalid or illegal string was specified.");
        } else {
          _positionAlign = setting;
          this.hasBeenReset = true;
        }
      }
    },
    "size": {
      enumerable: true,
      get: function get() {
        return _size;
      },
      set: function set(value) {
        if (value < 0 || value > 100) {
          throw new Error("Size must be between 0 and 100.");
        }
        _size = value;
        this.hasBeenReset = true;
      }
    },
    "align": {
      enumerable: true,
      get: function get() {
        return _align;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }
  });

  /**
   * Other <track> spec defined properties
   */

  // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
  this.displayState = undefined;
}

/**
 * VTTCue methods
 */

VTTCue.prototype.getCueAsHTML = function () {
  // Assume WebVTT.convertCueToDOMTree is on the global.
  return WebVTT.convertCueToDOMTree(window, this.text);
};
module.exports = VTTCue;

/***/ }),

/***/ 55787:
/***/ ((module) => {

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var scrollSetting = {
  "": true,
  "up": true
};
function findScrollSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var scroll = scrollSetting[value.toLowerCase()];
  return scroll ? value.toLowerCase() : false;
}
function isValidPercentValue(value) {
  return typeof value === "number" && value >= 0 && value <= 100;
}

// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
function VTTRegion() {
  var _width = 100;
  var _lines = 3;
  var _regionAnchorX = 0;
  var _regionAnchorY = 100;
  var _viewportAnchorX = 0;
  var _viewportAnchorY = 100;
  var _scroll = "";
  Object.defineProperties(this, {
    "width": {
      enumerable: true,
      get: function get() {
        return _width;
      },
      set: function set(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("Width must be between 0 and 100.");
        }
        _width = value;
      }
    },
    "lines": {
      enumerable: true,
      get: function get() {
        return _lines;
      },
      set: function set(value) {
        if (typeof value !== "number") {
          throw new TypeError("Lines must be set to a number.");
        }
        _lines = value;
      }
    },
    "regionAnchorY": {
      enumerable: true,
      get: function get() {
        return _regionAnchorY;
      },
      set: function set(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("RegionAnchorX must be between 0 and 100.");
        }
        _regionAnchorY = value;
      }
    },
    "regionAnchorX": {
      enumerable: true,
      get: function get() {
        return _regionAnchorX;
      },
      set: function set(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("RegionAnchorY must be between 0 and 100.");
        }
        _regionAnchorX = value;
      }
    },
    "viewportAnchorY": {
      enumerable: true,
      get: function get() {
        return _viewportAnchorY;
      },
      set: function set(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        }
        _viewportAnchorY = value;
      }
    },
    "viewportAnchorX": {
      enumerable: true,
      get: function get() {
        return _viewportAnchorX;
      },
      set: function set(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        }
        _viewportAnchorX = value;
      }
    },
    "scroll": {
      enumerable: true,
      get: function get() {
        return _scroll;
      },
      set: function set(value) {
        var setting = findScrollSetting(value);
        // Have to check for false as an empty string is a legal value.
        if (setting === false) {
          console.warn("Scroll: an invalid or illegal string was specified.");
        } else {
          _scroll = setting;
        }
      }
    }
  });
}
module.exports = VTTRegion;

/***/ }),

/***/ 19662:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var tryToString = __webpack_require__(66330);

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 39483:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isConstructor = __webpack_require__(4411);
var tryToString = __webpack_require__(66330);

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 96077:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);

module.exports = function (argument) {
  if (typeof argument === 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ 51223:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);
var create = __webpack_require__(70030);
var definePropertyModule = __webpack_require__(3070);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 31530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = __webpack_require__(28710).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 25787:
/***/ ((module) => {

module.exports = function (it, Constructor, name) {
  if (it instanceof Constructor) return it;
  throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
};


/***/ }),

/***/ 19670:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ 24019:
/***/ ((module) => {

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined';


/***/ }),

/***/ 90260:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(24019);
var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var has = __webpack_require__(86656);
var classof = __webpack_require__(70648);
var tryToString = __webpack_require__(66330);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var defineProperty = __webpack_require__(3070).f;
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var wellKnownSymbol = __webpack_require__(5112);
var uid = __webpack_require__(69711);

var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var isPrototypeOf = ObjectPrototype.isPrototypeOf;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = uid('TYPED_ARRAY_CONSTRUCTOR');
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || has(TypedArrayConstructorsList, klass)
    || has(BigIntArrayConstructorsList, klass);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return has(TypedArrayConstructorsList, klass)
    || has(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf.call(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && has(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) { /* empty */ }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    redefine(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && has(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return redefine(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      redefine(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) createNonEnumerableProperty(Prototype, TYPED_ARRAY_CONSTRUCTOR, Constructor);
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !has(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQIRED = true;
  defineProperty(TypedArrayPrototype, TO_STRING_TAG, { get: function () {
    return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
  } });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_CONSTRUCTOR: TYPED_ARRAY_CONSTRUCTOR,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ 13331:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var DESCRIPTORS = __webpack_require__(19781);
var NATIVE_ARRAY_BUFFER = __webpack_require__(24019);
var FunctionName = __webpack_require__(76530);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefineAll = __webpack_require__(12248);
var fails = __webpack_require__(47293);
var anInstance = __webpack_require__(25787);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var toIndex = __webpack_require__(57067);
var IEEE754 = __webpack_require__(11179);
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var getOwnPropertyNames = __webpack_require__(8006).f;
var defineProperty = __webpack_require__(3070).f;
var arrayFill = __webpack_require__(21285);
var setToStringTag = __webpack_require__(58003);
var InternalStateModule = __webpack_require__(29909);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var $DataView = global[DATA_VIEW];
var $DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var RangeError = global.RangeError;

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key) {
  defineProperty(Constructor[PROTOTYPE], key, { get: function () { return getInternalState(this)[key]; } });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = bytes.slice(start, start + count);
  return isLittleEndian ? pack : pack.reverse();
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    setInternalState(this, {
      bytes: arrayFill.call(new Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) this.byteLength = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = getInternalState(buffer).byteLength;
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    setInternalState(this, {
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength');
    addGetter($DataView, 'buffer');
    addGetter($DataView, 'byteLength');
    addGetter($DataView, 'byteOffset');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
  /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new NativeArrayBuffer(toIndex(length));
    };
    var ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE] = NativeArrayBuffer[PROTOTYPE];
    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }
    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf($DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf($DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataViewPrototype.setInt8;
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) redefineAll($DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),

/***/ 1048:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toObject = __webpack_require__(47908);
var toAbsoluteIndex = __webpack_require__(51400);
var toLength = __webpack_require__(17466);

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ 21285:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toObject = __webpack_require__(47908);
var toAbsoluteIndex = __webpack_require__(51400);
var toLength = __webpack_require__(17466);

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ 18533:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $forEach = __webpack_require__(42092).forEach;
var arrayMethodIsStrict = __webpack_require__(9341);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 97745:
/***/ ((module) => {

module.exports = function (Constructor, list) {
  var index = 0;
  var length = list.length;
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),

/***/ 48457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(49974);
var toObject = __webpack_require__(47908);
var callWithSafeIterationClosing = __webpack_require__(53411);
var isArrayIteratorMethod = __webpack_require__(97659);
var isConstructor = __webpack_require__(4411);
var toLength = __webpack_require__(17466);
var createProperty = __webpack_require__(86135);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = IS_CONSTRUCTOR ? new this(length) : Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ 41318:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIndexedObject = __webpack_require__(45656);
var toLength = __webpack_require__(17466);
var toAbsoluteIndex = __webpack_require__(51400);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 42092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var bind = __webpack_require__(49974);
var IndexedObject = __webpack_require__(68361);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var arraySpeciesCreate = __webpack_require__(65417);

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 86583:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__(45656);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var arrayMethodIsStrict = __webpack_require__(9341);

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ 81194:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 9341:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(47293);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ 53671:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);
var toObject = __webpack_require__(47908);
var IndexedObject = __webpack_require__(68361);
var toLength = __webpack_require__(17466);

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ 94362:
/***/ ((module) => {

// TODO: use something more complex like timsort?
var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    mergeSort(array.slice(0, middle), comparefn),
    mergeSort(array.slice(middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;
  var result = [];

  while (lindex < llength || rindex < rlength) {
    if (lindex < llength && rindex < rlength) {
      result.push(comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]);
    } else {
      result.push(lindex < llength ? left[lindex++] : right[rindex++]);
    }
  } return result;
};

module.exports = mergeSort;


/***/ }),

/***/ 77475:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(43157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(70111);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 65417:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arraySpeciesConstructor = __webpack_require__(77475);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 53411:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var iteratorClose = __webpack_require__(99212);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 17072:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 84326:
/***/ ((module) => {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 70648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var isCallable = __webpack_require__(60614);
var classofRaw = __webpack_require__(84326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 95631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineProperty = __webpack_require__(3070).f;
var create = __webpack_require__(70030);
var redefineAll = __webpack_require__(12248);
var bind = __webpack_require__(49974);
var anInstance = __webpack_require__(25787);
var iterate = __webpack_require__(20408);
var defineIterator = __webpack_require__(70654);
var setSpecies = __webpack_require__(96340);
var DESCRIPTORS = __webpack_require__(19781);
var fastKey = __webpack_require__(62423).fastKey;
var InternalStateModule = __webpack_require__(29909);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ 29320:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var redefineAll = __webpack_require__(12248);
var getWeakData = __webpack_require__(62423).getWeakData;
var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var anInstance = __webpack_require__(25787);
var iterate = __webpack_require__(20408);
var ArrayIterationModule = __webpack_require__(42092);
var $has = __webpack_require__(86656);
var InternalStateModule = __webpack_require__(29909);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),

/***/ 77710:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var redefine = __webpack_require__(31320);
var InternalMetadataModule = __webpack_require__(62423);
var iterate = __webpack_require__(20408);
var anInstance = __webpack_require__(25787);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var fails = __webpack_require__(47293);
var checkCorrectnessOfIteration = __webpack_require__(17072);
var setToStringTag = __webpack_require__(58003);
var inheritIfRequired = __webpack_require__(79587);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ 99920:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);
var ownKeys = __webpack_require__(53887);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ 84964:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ 49920:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 14230:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);

var quot = /"/g;

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + toString(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ 24994:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IteratorPrototype = __webpack_require__(13383).IteratorPrototype;
var create = __webpack_require__(70030);
var createPropertyDescriptor = __webpack_require__(79114);
var setToStringTag = __webpack_require__(58003);
var Iterators = __webpack_require__(97497);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 68880:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(79114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 79114:
/***/ ((module) => {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 86135:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPropertyKey = __webpack_require__(34948);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(79114);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 38709:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(19670);
var ordinaryToPrimitive = __webpack_require__(92140);

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};


/***/ }),

/***/ 70654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var IS_PURE = __webpack_require__(31913);
var FunctionName = __webpack_require__(76530);
var isCallable = __webpack_require__(60614);
var createIteratorConstructor = __webpack_require__(24994);
var getPrototypeOf = __webpack_require__(79518);
var setPrototypeOf = __webpack_require__(27674);
var setToStringTag = __webpack_require__(58003);
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(97497);
var IteratorsCore = __webpack_require__(13383);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return nativeIterator.call(this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 97235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var path = __webpack_require__(40857);
var has = __webpack_require__(86656);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineProperty = __webpack_require__(3070).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 19781:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 80317:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isObject = __webpack_require__(70111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 48324:
/***/ ((module) => {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 98509:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(80317);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 68886:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__(88113);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ 30256:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var UA = __webpack_require__(88113);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ 88113:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(35005);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ 7392:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var userAgent = __webpack_require__(88113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ 98008:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__(88113);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ 80748:
/***/ ((module) => {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 82109:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var createNonEnumerableProperty = __webpack_require__(68880);
var redefine = __webpack_require__(31320);
var setGlobal = __webpack_require__(83505);
var copyConstructorProperties = __webpack_require__(99920);
var isForced = __webpack_require__(54705);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 47293:
/***/ ((module) => {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 27007:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(74916);
var redefine = __webpack_require__(31320);
var regexpExec = __webpack_require__(22261);
var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var createNonEnumerableProperty = __webpack_require__(68880);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 76677:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ 49974:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aCallable(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 27065:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(19662);
var isObject = __webpack_require__(70111);

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aCallable(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ 76530:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var has = __webpack_require__(86656);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = has(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 35005:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 71246:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(70648);
var getMethod = __webpack_require__(58173);
var Iterators = __webpack_require__(97497);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 18554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);
var anObject = __webpack_require__(19670);
var getIteratorMethod = __webpack_require__(71246);

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(iteratorMethod.call(argument));
  throw TypeError(String(argument) + ' is not iterable');
};


/***/ }),

/***/ 58173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__(19662);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ 10647:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toObject = __webpack_require__(47908);

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ 17854:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 86656:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toObject = __webpack_require__(47908);

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ ((module) => {

module.exports = {};


/***/ }),

/***/ 60490:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(35005);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 64664:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var fails = __webpack_require__(47293);
var createElement = __webpack_require__(80317);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 11179:
/***/ ((module) => {

// IEEE754 conversions based on https://github.com/feross/ieee754
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = new Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    if (number * (c = pow(2, -exponent)) < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  for (; mantissaLength >= 8; buffer[index++] = mantissa & 255, mantissa /= 256, mantissaLength -= 8);
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  for (; exponentLength > 0; buffer[index++] = exponent & 255, exponent /= 256, exponentLength -= 8);
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  for (; nBits > 0; exponent = exponent * 256 + buffer[index], index--, nBits -= 8);
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  for (; nBits > 0; mantissa = mantissa * 256 + buffer[index], index--, nBits -= 8);
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};


/***/ }),

/***/ 68361:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var classof = __webpack_require__(84326);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ 79587:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var setPrototypeOf = __webpack_require__(27674);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 42788:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var store = __webpack_require__(5465);

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 62423:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var hiddenKeys = __webpack_require__(3501);
var isObject = __webpack_require__(70111);
var has = __webpack_require__(86656);
var defineProperty = __webpack_require__(3070).f;
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternalModule = __webpack_require__(1156);
var uid = __webpack_require__(69711);
var FREEZING = __webpack_require__(76677);

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = [].splice;
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice.call(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ 29909:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_WEAK_MAP = __webpack_require__(68536);
var global = __webpack_require__(17854);
var isObject = __webpack_require__(70111);
var createNonEnumerableProperty = __webpack_require__(68880);
var objectHas = __webpack_require__(86656);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 97659:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(97497);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 43157:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(84326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ 60614:
/***/ ((module) => {

// `isCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument === 'function';
};


/***/ }),

/***/ 4411:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var isCallable = __webpack_require__(60614);
var classof = __webpack_require__(70648);
var getBuiltIn = __webpack_require__(35005);
var inspectSource = __webpack_require__(42788);

var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = constructorRegExp.exec;
var INCORRECT_TO_STRING = !constructorRegExp.exec(function () { /* empty */ });

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(Object, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec.call(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 45032:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);

module.exports = function (descriptor) {
  return descriptor !== undefined && (has(descriptor, 'value') || has(descriptor, 'writable'));
};


/***/ }),

/***/ 54705:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var isCallable = __webpack_require__(60614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 18730:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ 70111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 31913:
/***/ ((module) => {

module.exports = false;


/***/ }),

/***/ 47850:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);
var classof = __webpack_require__(84326);
var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ 52190:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var getBuiltIn = __webpack_require__(35005);
var USE_SYMBOL_AS_UID = __webpack_require__(43307);

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && Object(it) instanceof $Symbol;
};


/***/ }),

/***/ 20408:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var isArrayIteratorMethod = __webpack_require__(97659);
var toLength = __webpack_require__(17466);
var bind = __webpack_require__(49974);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);
var iteratorClose = __webpack_require__(99212);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError(String(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ 99212:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var getMethod = __webpack_require__(58173);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = innerResult.call(iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 13383:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(47293);
var isCallable = __webpack_require__(60614);
var create = __webpack_require__(70030);
var getPrototypeOf = __webpack_require__(79518);
var redefine = __webpack_require__(31320);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 97497:
/***/ ((module) => {

module.exports = {};


/***/ }),

/***/ 30133:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(47293);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 590:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(31913);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ 68536:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var inspectSource = __webpack_require__(42788);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ 3929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isRegExp = __webpack_require__(47850);

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ 21574:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(19781);
var fails = __webpack_require__(47293);
var objectKeys = __webpack_require__(81956);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var propertyIsEnumerableModule = __webpack_require__(55296);
var toObject = __webpack_require__(47908);
var IndexedObject = __webpack_require__(68361);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 70030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(19670);
var defineProperties = __webpack_require__(36048);
var enumBugKeys = __webpack_require__(80748);
var hiddenKeys = __webpack_require__(3501);
var html = __webpack_require__(60490);
var documentCreateElement = __webpack_require__(80317);
var sharedKey = __webpack_require__(6200);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ 36048:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var definePropertyModule = __webpack_require__(3070);
var anObject = __webpack_require__(19670);
var objectKeys = __webpack_require__(81956);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ 3070:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var IE8_DOM_DEFINE = __webpack_require__(64664);
var anObject = __webpack_require__(19670);
var toPropertyKey = __webpack_require__(34948);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 31236:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var propertyIsEnumerableModule = __webpack_require__(55296);
var createPropertyDescriptor = __webpack_require__(79114);
var toIndexedObject = __webpack_require__(45656);
var toPropertyKey = __webpack_require__(34948);
var has = __webpack_require__(86656);
var IE8_DOM_DEFINE = __webpack_require__(64664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1156:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__(45656);
var $getOwnPropertyNames = __webpack_require__(8006).f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 8006:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var internalObjectKeys = __webpack_require__(16324);
var enumBugKeys = __webpack_require__(80748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 25181:
/***/ ((__unused_webpack_module, exports) => {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 79518:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);
var isCallable = __webpack_require__(60614);
var toObject = __webpack_require__(47908);
var sharedKey = __webpack_require__(6200);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(49920);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (has(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 16324:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var has = __webpack_require__(86656);
var toIndexedObject = __webpack_require__(45656);
var indexOf = __webpack_require__(41318).indexOf;
var hiddenKeys = __webpack_require__(3501);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 81956:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var internalObjectKeys = __webpack_require__(16324);
var enumBugKeys = __webpack_require__(80748);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 55296:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 27674:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__(19670);
var aPossiblePrototype = __webpack_require__(96077);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 90288:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var classof = __webpack_require__(70648);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 92140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = fn.call(input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 53887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__(35005);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var anObject = __webpack_require__(19670);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 40857:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);

module.exports = global;


/***/ }),

/***/ 12248:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var redefine = __webpack_require__(31320);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ 31320:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var isCallable = __webpack_require__(60614);
var has = __webpack_require__(86656);
var createNonEnumerableProperty = __webpack_require__(68880);
var setGlobal = __webpack_require__(83505);
var inspectSource = __webpack_require__(42788);
var InternalStateModule = __webpack_require__(29909);
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(76530).CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!has(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ 97651:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var isCallable = __webpack_require__(60614);
var classof = __webpack_require__(84326);
var regexpExec = __webpack_require__(22261);

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = exec.call(R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return regexpExec.call(R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ 22261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var toString = __webpack_require__(41340);
var regexpFlags = __webpack_require__(67066);
var stickyHelpers = __webpack_require__(52999);
var shared = __webpack_require__(72309);
var create = __webpack_require__(70030);
var getInternalState = __webpack_require__(29909).get;
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(38173);

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = str.slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str.charAt(re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 67066:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__(19670);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 52999:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

exports.UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ 9441:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ 38173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 84488:
/***/ ((module) => {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 83505:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);

module.exports = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 96340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(35005);
var definePropertyModule = __webpack_require__(3070);
var wellKnownSymbol = __webpack_require__(5112);
var DESCRIPTORS = __webpack_require__(19781);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 58003:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(3070).f;
var has = __webpack_require__(86656);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 6200:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var shared = __webpack_require__(72309);
var uid = __webpack_require__(69711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var setGlobal = __webpack_require__(83505);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ 72309:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var IS_PURE = __webpack_require__(31913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 36707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__(19670);
var aConstructor = __webpack_require__(39483);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 43429:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__(47293);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ 28710:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);

// `String.prototype.codePointAt` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 33197:
/***/ ((module) => {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line max-statements -- TODO
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

module.exports = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};


/***/ }),

/***/ 38415:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toInteger = __webpack_require__(99958);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ 76091:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var PROPER_FUNCTION_NAME = __webpack_require__(76530).PROPER;
var fails = __webpack_require__(47293);
var whitespaces = __webpack_require__(81361);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ 53111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);
var whitespaces = __webpack_require__(81361);

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 50863:
/***/ ((module) => {

var valueOf = 1.0.valueOf;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = function (value) {
  return valueOf.call(value);
};


/***/ }),

/***/ 51400:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 57067:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length or index');
  return length;
};


/***/ }),

/***/ 45656:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(68361);
var requireObjectCoercible = __webpack_require__(84488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 99958:
/***/ ((module) => {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ 17466:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 47908:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__(84488);

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 84590:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPositiveInteger = __webpack_require__(73002);

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ 73002:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__(99958);

module.exports = function (it) {
  var result = toInteger(it);
  if (result < 0) throw RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ 57593:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var getMethod = __webpack_require__(58173);
var ordinaryToPrimitive = __webpack_require__(92140);
var wellKnownSymbol = __webpack_require__(5112);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 34948:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPrimitive = __webpack_require__(57593);
var isSymbol = __webpack_require__(52190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};


/***/ }),

/***/ 51694:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 41340:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__(70648);

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ 66330:
/***/ ((module) => {

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 19843:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var DESCRIPTORS = __webpack_require__(19781);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(63832);
var ArrayBufferViewCore = __webpack_require__(90260);
var ArrayBufferModule = __webpack_require__(13331);
var anInstance = __webpack_require__(25787);
var createPropertyDescriptor = __webpack_require__(79114);
var createNonEnumerableProperty = __webpack_require__(68880);
var isInteger = __webpack_require__(18730);
var toLength = __webpack_require__(17466);
var toIndex = __webpack_require__(57067);
var toOffset = __webpack_require__(84590);
var toPropertyKey = __webpack_require__(34948);
var has = __webpack_require__(86656);
var classof = __webpack_require__(70648);
var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var create = __webpack_require__(70030);
var setPrototypeOf = __webpack_require__(27674);
var getOwnPropertyNames = __webpack_require__(8006).f;
var typedArrayFrom = __webpack_require__(97321);
var forEach = __webpack_require__(42092).forEach;
var setSpecies = __webpack_require__(96340);
var definePropertyModule = __webpack_require__(3070);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var InternalStateModule = __webpack_require__(29909);
var inheritIfRequired = __webpack_require__(79587);

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round = Math.round;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor(C))(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  nativeDefineProperty(it, key, { get: function () {
    return getInternalState(this)[key];
  } });
};

var isArrayBuffer = function (it) {
  var klass;
  return it instanceof ArrayBuffer || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isInteger(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && has(descriptor, 'value')
    && !has(descriptor, 'get')
    && !has(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!has(descriptor, 'writable') || descriptor.writable)
    && (!has(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+$/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructor, CONSTRUCTOR_NAME);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructor, CONSTRUCTOR_NAME);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return typedArrayFrom.call(TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_CONSTRUCTOR, TypedArrayConstructor);

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({
      global: true, forced: TypedArrayConstructor != NativeTypedArrayConstructor, sham: !NATIVE_ARRAY_BUFFER_VIEWS
    }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ 63832:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable no-new -- required for testing */
var global = __webpack_require__(17854);
var fails = __webpack_require__(47293);
var checkCorrectnessOfIteration = __webpack_require__(17072);
var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(90260).NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});


/***/ }),

/***/ 43074:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayFromConstructorAndList = __webpack_require__(97745);
var typedArraySpeciesConstructor = __webpack_require__(66304);

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};


/***/ }),

/***/ 97321:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aConstructor = __webpack_require__(39483);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);
var isArrayIteratorMethod = __webpack_require__(97659);
var bind = __webpack_require__(49974);
var aTypedArrayConstructor = __webpack_require__(90260).aTypedArrayConstructor;

module.exports = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = next.call(iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2], 2);
  }
  length = toLength(O.length);
  result = new (aTypedArrayConstructor(C))(length);
  for (i = 0; length > i; i++) {
    result[i] = mapping ? mapfn(O[i], i) : O[i];
  }
  return result;
};


/***/ }),

/***/ 66304:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ArrayBufferViewCore = __webpack_require__(90260);
var speciesConstructor = __webpack_require__(36707);

var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore.TYPED_ARRAY_CONSTRUCTOR;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
module.exports = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, originalArray[TYPED_ARRAY_CONSTRUCTOR]));
};


/***/ }),

/***/ 69711:
/***/ ((module) => {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ 43307:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(30133);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 6061:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__(5112);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 5112:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var shared = __webpack_require__(72309);
var has = __webpack_require__(86656);
var uid = __webpack_require__(69711);
var NATIVE_SYMBOL = __webpack_require__(30133);
var USE_SYMBOL_AS_UID = __webpack_require__(43307);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 81361:
/***/ ((module) => {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 18264:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var arrayBufferModule = __webpack_require__(13331);
var setSpecies = __webpack_require__(96340);

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({ global: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
  ArrayBuffer: ArrayBuffer
});

setSpecies(ARRAY_BUFFER);


/***/ }),

/***/ 92222:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var isArray = __webpack_require__(43157);
var isObject = __webpack_require__(70111);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var createProperty = __webpack_require__(86135);
var arraySpeciesCreate = __webpack_require__(65417);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 50545:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var copyWithin = __webpack_require__(1048);
var addToUnscopables = __webpack_require__(51223);

// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$({ target: 'Array', proto: true }, {
  copyWithin: copyWithin
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('copyWithin');


/***/ }),

/***/ 43290:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fill = __webpack_require__(21285);
var addToUnscopables = __webpack_require__(51223);

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ 57327:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $filter = __webpack_require__(42092).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 69826:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $find = __webpack_require__(42092).find;
var addToUnscopables = __webpack_require__(51223);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ 91038:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var from = __webpack_require__(48457);
var checkCorrectnessOfIteration = __webpack_require__(17072);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 26699:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $includes = __webpack_require__(41318).includes;
var addToUnscopables = __webpack_require__(51223);

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 66992:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIndexedObject = __webpack_require__(45656);
var addToUnscopables = __webpack_require__(51223);
var Iterators = __webpack_require__(97497);
var InternalStateModule = __webpack_require__(29909);
var defineIterator = __webpack_require__(70654);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 69600:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var IndexedObject = __webpack_require__(68361);
var toIndexedObject = __webpack_require__(45656);
var arrayMethodIsStrict = __webpack_require__(9341);

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ 21249:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $map = __webpack_require__(42092).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 47042:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var isArray = __webpack_require__(43157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(70111);
var toAbsoluteIndex = __webpack_require__(51400);
var toLength = __webpack_require__(17466);
var toIndexedObject = __webpack_require__(45656);
var createProperty = __webpack_require__(86135);
var wellKnownSymbol = __webpack_require__(5112);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 2707:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var aCallable = __webpack_require__(19662);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var fails = __webpack_require__(47293);
var internalSort = __webpack_require__(94362);
var arrayMethodIsStrict = __webpack_require__(9341);
var FF = __webpack_require__(68886);
var IE_OR_EDGE = __webpack_require__(30256);
var V8 = __webpack_require__(7392);
var WEBKIT = __webpack_require__(98008);

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort.call(array) : nativeSort.call(array, comparefn);

    var items = [];
    var arrayLength = toLength(array.length);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) items.push(array[index]);
    }

    items = internalSort(items, getSortCompare(comparefn));
    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});


/***/ }),

/***/ 40561:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var toAbsoluteIndex = __webpack_require__(51400);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var toObject = __webpack_require__(47908);
var arraySpeciesCreate = __webpack_require__(65417);
var createProperty = __webpack_require__(86135);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ 96078:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var redefine = __webpack_require__(31320);
var dateToPrimitive = __webpack_require__(38709);
var wellKnownSymbol = __webpack_require__(5112);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!(TO_PRIMITIVE in DatePrototype)) {
  redefine(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),

/***/ 68309:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var FUNCTION_NAME_EXISTS = __webpack_require__(76530).EXISTS;
var defineProperty = __webpack_require__(3070).f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 35837:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true }, {
  globalThis: global
});


/***/ }),

/***/ 73706:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var setToStringTag = __webpack_require__(58003);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 51532:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__(77710);
var collectionStrong = __webpack_require__(95631);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 10408:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var setToStringTag = __webpack_require__(58003);

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ 9653:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var redefine = __webpack_require__(31320);
var has = __webpack_require__(86656);
var classof = __webpack_require__(84326);
var inheritIfRequired = __webpack_require__(79587);
var isSymbol = __webpack_require__(52190);
var toPrimitive = __webpack_require__(57593);
var fails = __webpack_require__(47293);
var create = __webpack_require__(70030);
var getOwnPropertyNames = __webpack_require__(8006).f;
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var defineProperty = __webpack_require__(3070).f;
var trim = __webpack_require__(53111).trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  if (isSymbol(argument)) throw TypeError('Cannot convert a Symbol value to a number');
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ 44363:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$({ target: 'Number', stat: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


/***/ }),

/***/ 56977:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var toInteger = __webpack_require__(99958);
var thisNumberValue = __webpack_require__(50863);
var repeat = __webpack_require__(38415);
var fails = __webpack_require__(47293);

var nativeToFixed = 1.0.toFixed;
var floor = Math.floor;

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String(data[index]);
      s = s === '' ? t : s + repeat.call('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = nativeToFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat.call('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat.call('0', fractDigits - k) + result
        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ 19601:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var assign = __webpack_require__(21574);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ 43371:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var FREEZING = __webpack_require__(76677);
var fails = __webpack_require__(47293);
var isObject = __webpack_require__(70111);
var onFreeze = __webpack_require__(62423).onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ 38880:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var toIndexedObject = __webpack_require__(45656);
var nativeGetOwnPropertyDescriptor = __webpack_require__(31236).f;
var DESCRIPTORS = __webpack_require__(19781);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 49337:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var ownKeys = __webpack_require__(53887);
var toIndexedObject = __webpack_require__(45656);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var createProperty = __webpack_require__(86135);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ 36210:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var getOwnPropertyNames = __webpack_require__(1156).f;

// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: getOwnPropertyNames
});


/***/ }),

/***/ 30489:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var toObject = __webpack_require__(47908);
var nativeGetPrototypeOf = __webpack_require__(79518);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(49920);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ 47941:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var toObject = __webpack_require__(47908);
var nativeKeys = __webpack_require__(81956);
var fails = __webpack_require__(47293);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 41539:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var TO_STRING_TAG_SUPPORT = __webpack_require__(51694);
var redefine = __webpack_require__(31320);
var toString = __webpack_require__(90288);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 12419:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var aConstructor = __webpack_require__(39483);
var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var create = __webpack_require__(70030);
var bind = __webpack_require__(27065);
var fails = __webpack_require__(47293);

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ 74819:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__(82109);
var isObject = __webpack_require__(70111);
var anObject = __webpack_require__(19670);
var isDataDescriptor = __webpack_require__(45032);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var getPrototypeOf = __webpack_require__(79518);

// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
  if (descriptor) return isDataDescriptor(descriptor)
    ? descriptor.value
    : descriptor.get === undefined ? undefined : descriptor.get.call(receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});


/***/ }),

/***/ 24603:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var inheritIfRequired = __webpack_require__(79587);
var createNonEnumerableProperty = __webpack_require__(68880);
var defineProperty = __webpack_require__(3070).f;
var getOwnPropertyNames = __webpack_require__(8006).f;
var isRegExp = __webpack_require__(47850);
var toString = __webpack_require__(41340);
var getFlags = __webpack_require__(67066);
var stickyHelpers = __webpack_require__(52999);
var redefine = __webpack_require__(31320);
var fails = __webpack_require__(47293);
var has = __webpack_require__(86656);
var enforceInternalState = __webpack_require__(29909).enforce;
var setSpecies = __webpack_require__(96340);
var wellKnownSymbol = __webpack_require__(5112);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(38173);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      result += chr + string.charAt(++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      chr = chr + string.charAt(++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (IS_NCG.test(string.slice(index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || has(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named.push([groupname, groupid]);
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || pattern instanceof RegExpWrapper) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags.call(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && flags.indexOf('s') > -1;
      if (dotAll) flags = flags.replace(/s/g, '');
    }

    rawFlags = flags;

    if (UNSUPPORTED_Y && 'sticky' in re1) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ 74916:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var exec = __webpack_require__(22261);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 92087:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__(19781);
var objectDefinePropertyModule = __webpack_require__(3070);
var regExpFlags = __webpack_require__(67066);
var fails = __webpack_require__(47293);

var FORCED = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  return Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags').get.call({ dotAll: true, sticky: true }) !== 'sy';
});

// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (FORCED) objectDefinePropertyModule.f(RegExp.prototype, 'flags', {
  configurable: true,
  get: regExpFlags
});


/***/ }),

/***/ 39714:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var PROPER_FUNCTION_NAME = __webpack_require__(76530).PROPER;
var redefine = __webpack_require__(31320);
var anObject = __webpack_require__(19670);
var $toString = __webpack_require__(41340);
var fails = __webpack_require__(47293);
var flags = __webpack_require__(67066);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ 70189:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__(77710);
var collectionStrong = __webpack_require__(95631);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ 27852:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var getOwnPropertyDescriptor = __webpack_require__(31236).f;
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var correctIsRegExpLogic = __webpack_require__(84964);
var IS_PURE = __webpack_require__(31913);

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var $endsWith = ''.endsWith;
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ 32023:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(84488);
var toString = __webpack_require__(41340);
var correctIsRegExpLogic = __webpack_require__(84964);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~toString(requireObjectCoercible(this))
      .indexOf(toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 78783:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = __webpack_require__(28710).charAt;
var toString = __webpack_require__(41340);
var InternalStateModule = __webpack_require__(29909);
var defineIterator = __webpack_require__(70654);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 4723:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var anObject = __webpack_require__(19670);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);
var getMethod = __webpack_require__(58173);
var advanceStringIndex = __webpack_require__(31530);
var regExpExec = __webpack_require__(97651);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 15306:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var fails = __webpack_require__(47293);
var anObject = __webpack_require__(19670);
var isCallable = __webpack_require__(60614);
var toInteger = __webpack_require__(99958);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);
var advanceStringIndex = __webpack_require__(31530);
var getMethod = __webpack_require__(58173);
var getSubstitution = __webpack_require__(10647);
var regExpExec = __webpack_require__(97651);
var wellKnownSymbol = __webpack_require__(5112);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue === 'string' &&
        replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
        replaceValue.indexOf('$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = toString(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ 23123:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var isRegExp = __webpack_require__(47850);
var anObject = __webpack_require__(19670);
var requireObjectCoercible = __webpack_require__(84488);
var speciesConstructor = __webpack_require__(36707);
var advanceStringIndex = __webpack_require__(31530);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var getMethod = __webpack_require__(58173);
var callRegExpExec = __webpack_require__(97651);
var regexpExec = __webpack_require__(22261);
var stickyHelpers = __webpack_require__(52999);
var fails = __webpack_require__(47293);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? splitter.call(separator, O, limit)
        : internalSplit.call(toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? S.slice(q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ 60086:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});


/***/ }),

/***/ 73210:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var $trim = __webpack_require__(53111).trim;
var forcedStringTrimMethod = __webpack_require__(76091);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ 72443:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ 41817:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var has = __webpack_require__(86656);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var defineProperty = __webpack_require__(3070).f;
var copyConstructorProperties = __webpack_require__(99920);

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var nativeSymbol = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = nativeSymbol ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 32165:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 82526:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var getBuiltIn = __webpack_require__(35005);
var IS_PURE = __webpack_require__(31913);
var DESCRIPTORS = __webpack_require__(19781);
var NATIVE_SYMBOL = __webpack_require__(30133);
var fails = __webpack_require__(47293);
var has = __webpack_require__(86656);
var isArray = __webpack_require__(43157);
var isCallable = __webpack_require__(60614);
var isObject = __webpack_require__(70111);
var isSymbol = __webpack_require__(52190);
var anObject = __webpack_require__(19670);
var toObject = __webpack_require__(47908);
var toIndexedObject = __webpack_require__(45656);
var toPropertyKey = __webpack_require__(34948);
var $toString = __webpack_require__(41340);
var createPropertyDescriptor = __webpack_require__(79114);
var nativeObjectCreate = __webpack_require__(70030);
var objectKeys = __webpack_require__(81956);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternal = __webpack_require__(1156);
var getOwnPropertySymbolsModule = __webpack_require__(25181);
var getOwnPropertyDescriptorModule = __webpack_require__(31236);
var definePropertyModule = __webpack_require__(3070);
var propertyIsEnumerableModule = __webpack_require__(55296);
var redefine = __webpack_require__(31320);
var shared = __webpack_require__(72309);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);
var uid = __webpack_require__(69711);
var wellKnownSymbol = __webpack_require__(5112);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineWellKnownSymbol = __webpack_require__(97235);
var setToStringTag = __webpack_require__(58003);
var InternalStateModule = __webpack_require__(29909);
var $forEach = __webpack_require__(42092).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (isCallable($replacer)) value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  var valueOf = $Symbol[PROTOTYPE].valueOf;
  redefine($Symbol[PROTOTYPE], TO_PRIMITIVE, function () {
    return valueOf.apply(this, arguments);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 96649:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');


/***/ }),

/***/ 39341:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');


/***/ }),

/***/ 92990:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $copyWithin = __webpack_require__(1048);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return $copyWithin.call(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


/***/ }),

/***/ 18927:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $every = __webpack_require__(42092).every;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 33105:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $fill = __webpack_require__(21285);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  return $fill.apply(aTypedArray(this), arguments);
});


/***/ }),

/***/ 35035:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $filter = __webpack_require__(42092).filter;
var fromSpeciesAndList = __webpack_require__(43074);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});


/***/ }),

/***/ 7174:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $findIndex = __webpack_require__(42092).findIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 74345:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $find = __webpack_require__(42092).find;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 32846:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $forEach = __webpack_require__(42092).forEach;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 44731:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $includes = __webpack_require__(41318).includes;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 77209:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $indexOf = __webpack_require__(41318).indexOf;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 65125:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int32', function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 96319:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var PROPER_FUNCTION_NAME = __webpack_require__(76530).PROPER;
var ArrayBufferViewCore = __webpack_require__(90260);
var ArrayIterators = __webpack_require__(66992);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = global.Uint8Array;
var arrayValues = ArrayIterators.values;
var arrayKeys = ArrayIterators.keys;
var arrayEntries = ArrayIterators.entries;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var nativeTypedArrayIterator = Uint8Array && Uint8Array.prototype[ITERATOR];

var PROPER_ARRAY_VALUES_NAME = !!nativeTypedArrayIterator && nativeTypedArrayIterator.name === 'values';

var typedArrayValues = function values() {
  return arrayValues.call(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries.call(aTypedArray(this));
});
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys.call(aTypedArray(this));
});
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, PROPER_FUNCTION_NAME && !PROPER_ARRAY_VALUES_NAME);


/***/ }),

/***/ 58867:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = [].join;

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('join', function join(separator) {
  return $join.apply(aTypedArray(this), arguments);
});


/***/ }),

/***/ 37789:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $lastIndexOf = __webpack_require__(86583);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
// eslint-disable-next-line no-unused-vars -- required for `.length`
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  return $lastIndexOf.apply(aTypedArray(this), arguments);
});


/***/ }),

/***/ 33739:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $map = __webpack_require__(42092).map;
var typedArraySpeciesConstructor = __webpack_require__(66304);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});


/***/ }),

/***/ 14483:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $reduceRight = __webpack_require__(53671).right;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRicht` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  return $reduceRight(aTypedArray(this), callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 29368:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $reduce = __webpack_require__(53671).left;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  return $reduce(aTypedArray(this), callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 12056:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});


/***/ }),

/***/ 3462:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var toLength = __webpack_require__(17466);
var toOffset = __webpack_require__(84590);
var toObject = __webpack_require__(47908);
var fails = __webpack_require__(47293);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).set({});
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var length = this.length;
  var src = toObject(arrayLike);
  var len = toLength(src.length);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, FORCED);


/***/ }),

/***/ 30678:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var typedArraySpeciesConstructor = __webpack_require__(66304);
var fails = __webpack_require__(47293);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $slice = [].slice;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = $slice.call(aTypedArray(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);


/***/ }),

/***/ 27462:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var $some = __webpack_require__(42092).some;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ 33824:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var global = __webpack_require__(17854);
var fails = __webpack_require__(47293);
var aCallable = __webpack_require__(19662);
var toLength = __webpack_require__(17466);
var internalSort = __webpack_require__(94362);
var FF = __webpack_require__(68886);
var IE_OR_EDGE = __webpack_require__(30256);
var V8 = __webpack_require__(7392);
var WEBKIT = __webpack_require__(98008);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = global.Uint16Array;
var nativeSort = Uint16Array && Uint16Array.prototype.sort;

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !fails(function () {
  var array = new Uint16Array(2);
  array.sort(null);
  array.sort({});
});

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  array.sort(function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  var array = this;
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort.call(array, comparefn);

  aTypedArray(array);
  var arrayLength = toLength(array.length);
  var items = Array(arrayLength);
  var index;

  for (index = 0; index < arrayLength; index++) {
    items[index] = array[index];
  }

  items = internalSort(array, getSortCompare(comparefn));

  for (index = 0; index < arrayLength; index++) {
    array[index] = items[index];
  }

  return array;
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);


/***/ }),

/***/ 55021:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__(90260);
var toLength = __webpack_require__(17466);
var toAbsoluteIndex = __webpack_require__(51400);
var typedArraySpeciesConstructor = __webpack_require__(66304);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});


/***/ }),

/***/ 12974:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var ArrayBufferViewCore = __webpack_require__(90260);
var fails = __webpack_require__(47293);

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;
var $slice = [].slice;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return $toLocaleString.apply(TO_LOCALE_STRING_BUG ? $slice.call(aTypedArray(this)) : aTypedArray(this), arguments);
}, FORCED);


/***/ }),

/***/ 15016:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var exportTypedArrayMethod = __webpack_require__(90260).exportTypedArrayMethod;
var fails = __webpack_require__(47293);
var global = __webpack_require__(17854);

var Uint8Array = global.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var arrayJoin = [].join;

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return arrayJoin.call(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ }),

/***/ 8255:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint16', function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 29135:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint32', function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 82472:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__(19843);

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ 4129:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(17854);
var redefineAll = __webpack_require__(12248);
var InternalMetadataModule = __webpack_require__(62423);
var collection = __webpack_require__(77710);
var collectionWeak = __webpack_require__(29320);
var isObject = __webpack_require__(70111);
var enforceIternalState = __webpack_require__(29909).enforce;
var NATIVE_WEAK_MAP = __webpack_require__(68536);

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),

/***/ 65743:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove from `core-js@4`
__webpack_require__(35837);


/***/ }),

/***/ 54747:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var DOMIterables = __webpack_require__(48324);
var DOMTokenListPrototype = __webpack_require__(98509);
var forEach = __webpack_require__(18533);
var createNonEnumerableProperty = __webpack_require__(68880);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 33948:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__(17854);
var DOMIterables = __webpack_require__(48324);
var DOMTokenListPrototype = __webpack_require__(98509);
var ArrayIteratorMethods = __webpack_require__(66992);
var createNonEnumerableProperty = __webpack_require__(68880);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ 41637:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(66992);
var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var USE_NATIVE_URL = __webpack_require__(590);
var redefine = __webpack_require__(31320);
var redefineAll = __webpack_require__(12248);
var setToStringTag = __webpack_require__(58003);
var createIteratorConstructor = __webpack_require__(24994);
var InternalStateModule = __webpack_require__(29909);
var anInstance = __webpack_require__(25787);
var isCallable = __webpack_require__(60614);
var hasOwn = __webpack_require__(86656);
var bind = __webpack_require__(49974);
var classof = __webpack_require__(70648);
var anObject = __webpack_require__(19670);
var isObject = __webpack_require__(70111);
var $toString = __webpack_require__(41340);
var create = __webpack_require__(70030);
var createPropertyDescriptor = __webpack_require__(79114);
var getIterator = __webpack_require__(18554);
var getIteratorMethod = __webpack_require__(71246);
var wellKnownSymbol = __webpack_require__(5112);

var nativeFetch = getBuiltIn('fetch');
var NativeRequest = getBuiltIn('Request');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (iteratorMethod) {
        iterator = getIterator(init, iteratorMethod);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: $toString(first.value), value: $toString(second.value) });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: $toString(init[key]) });
    } else {
      parseSearchParams(
        entries,
        typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : $toString(init)
      );
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: $toString(name), value: $toString(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headers.has('content-type')) {
          headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, String(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestConstructor, 'Request');
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ 60285:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(78783);
var $ = __webpack_require__(82109);
var DESCRIPTORS = __webpack_require__(19781);
var USE_NATIVE_URL = __webpack_require__(590);
var global = __webpack_require__(17854);
var defineProperties = __webpack_require__(36048);
var redefine = __webpack_require__(31320);
var anInstance = __webpack_require__(25787);
var has = __webpack_require__(86656);
var assign = __webpack_require__(21574);
var arrayFrom = __webpack_require__(48457);
var codeAt = __webpack_require__(28710).codeAt;
var toASCII = __webpack_require__(33197);
var $toString = __webpack_require__(41340);
var setToStringTag = __webpack_require__(58003);
var URLSearchParamsModule = __webpack_require__(41637);
var InternalStateModule = __webpack_require__(29909);

var NativeURL = global.URL;
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor = Math.floor;
var pow = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
/* eslint-disable no-control-regex -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable no-control-regex -- safe */
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return input.charAt(pointer);
  };

  if (chr() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(chr())) return;
        while (DIGIT.test(chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !has(set, chr) ? chr : encodeURIComponent(chr);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements -- TODO
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, chr, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    chr = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (chr && ALPHA.test(chr)) {
          buffer += chr.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (chr && (ALPHANUMERIC.test(chr) || chr == '+' || chr == '-' || chr == '.')) {
          buffer += chr.toLowerCase();
        } else if (chr == ':') {
          if (stateOverride && (
            (isSpecial(url) != has(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && chr == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (chr == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (chr == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (chr == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (chr == '/' || (chr == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (chr == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (chr == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (chr == '/' || chr == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (chr == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (chr != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (chr != '/' && chr != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (chr == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += chr;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (chr == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (chr == '[') seenBracket = true;
          else if (chr == ']') seenBracket = false;
          buffer += chr;
        } break;

      case PORT:
        if (DIGIT.test(chr)) {
          buffer += chr;
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (chr == '/' || chr == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (chr == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (chr == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (chr == '/' || chr == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += chr;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (chr != '/' && chr != '\\') continue;
        } else if (!stateOverride && chr == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          state = PATH;
          if (chr != '/') continue;
        } break;

      case PATH:
        if (
          chr == EOF || chr == '/' ||
          (chr == '\\' && isSpecial(url)) ||
          (!stateOverride && (chr == '?' || chr == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (chr != '/' && !(chr == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (chr != '/' && !(chr == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(chr, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (chr == '?') {
          url.query = '';
          state = QUERY;
        } else if (chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          if (chr == "'" && isSpecial(url)) url.query += '%27';
          else if (chr == '#') url.query += '%23';
          else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = $toString(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, $toString(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URLConstructor(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = $toString(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, $toString(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom($toString(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom($toString(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, $toString(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, $toString(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = $toString(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, $toString(pathname), PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = $toString(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = $toString(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ 83753:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(82109);

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return URL.prototype.toString.call(this);
  }
});


/***/ }),

/***/ 22032:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M8 4l4 4-4 4V4zM4 .889C4 .398 4.448 0 5 0s1 .398 1 .889V15.11c0 .491-.448.889-1 .889s-1-.398-1-.889V.89z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44859:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic_stroke\" d=\"M9.9094 12.3334H9.75603L9.61808 12.4004C8.82771 12.7844 7.93998 13 6.99998 13C3.68627 13 0.99998 10.3137 0.99998 7.00004C0.99998 3.68633 3.68627 1.00004 6.99998 1.00004C10.3137 1.00004 13 3.68633 13 7.00004C13 7.94004 12.7843 8.82777 12.4003 9.61815L12.3333 9.75609V9.90946V12.3334H9.9094Z\" stroke-width=\"1.33333\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 30245:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M4 8h8l-4 4-4-4zM.889 6C.398 6 0 5.552 0 5s.398-1 .889-1H15.11c.491 0 .889.448.889 1s-.398 1-.889 1H.89z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 28852:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.66539 2.97174C8.91134 2.76785 9.06826 2.45833 9.06826 2.11176C9.06826 1.49775 8.57569 1 7.96808 1C7.36047 1 6.8679 1.49775 6.8679 2.11176C6.8679 2.48731 7.05217 2.81937 7.33432 3.02064V4.29412H4.29183C3.18914 4.29412 2.29523 5.19744 2.29523 6.31175V12.9824C2.29523 14.0967 3.18914 15 4.29183 15H11.7079C12.8106 15 13.7045 14.0967 13.7045 12.9824V6.31175C13.7045 5.19744 12.8106 4.29412 11.7079 4.29412H8.66539V2.97174ZM11.7079 5.63921H4.29183C3.92427 5.63921 3.6263 5.94032 3.6263 6.31175V12.9824C3.6263 13.3538 3.92427 13.6549 4.29183 13.6549H11.7079C12.0754 13.6549 12.3734 13.3538 12.3734 12.9824V6.31175C12.3734 5.94032 12.0754 5.63921 11.7079 5.63921ZM15.3345 6.09216C15.702 6.09216 16 6.39327 16 6.76471V10.8824C16 11.2538 15.702 11.5549 15.3345 11.5549C14.9669 11.5549 14.6689 11.2538 14.6689 10.8824V6.76471C14.6689 6.39327 14.9669 6.09216 15.3345 6.09216ZM1.33107 6.76471C1.33107 6.39327 1.0331 6.09216 0.665535 6.09216C0.29797 6.09216 0 6.39327 0 6.76471L0 10.8824C0 11.2538 0.29797 11.5549 0.665535 11.5549C1.0331 11.5549 1.33107 11.2538 1.33107 10.8824V6.76471ZM5.94991 10.4294C6.50125 10.4294 6.94821 9.97775 6.94821 9.4206C6.94821 8.86344 6.50125 8.41178 5.94991 8.41178C5.39856 8.41178 4.95161 8.86344 4.95161 9.4206C4.95161 9.97775 5.39856 10.4294 5.94991 10.4294ZM10.7418 9.4206C10.7418 9.97775 10.2948 10.4294 9.74346 10.4294C9.19211 10.4294 8.74515 9.97775 8.74515 9.4206C8.74515 8.86344 9.19211 8.41178 9.74346 8.41178C10.2948 8.41178 10.7418 8.86344 10.7418 9.4206Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 86766:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1.66683 6.99998C1.66683 4.05446 4.05464 1.66665 7.00016 1.66665C9.94568 1.66665 12.3335 4.05446 12.3335 6.99998C12.3335 9.9455 9.94568 12.3333 7.00016 12.3333C4.05464 12.3333 1.66683 9.9455 1.66683 6.99998ZM7.00016 0.333313C3.31826 0.333313 0.333496 3.31808 0.333496 6.99998C0.333496 10.6819 3.31826 13.6666 7.00016 13.6666C10.6821 13.6666 13.6668 10.6819 13.6668 6.99998C13.6668 3.31808 10.6821 0.333313 7.00016 0.333313ZM10.5123 5.42677C10.748 5.14392 10.7098 4.72354 10.427 4.48783C10.1441 4.25212 9.72372 4.29034 9.48802 4.57319L6.55081 8.09784L4.72099 6.79083C4.42138 6.57682 4.00501 6.64622 3.79101 6.94583C3.577 7.24543 3.6464 7.6618 3.946 7.87581L6.78285 9.90212L10.5123 5.42677Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44461:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M12.3335 7.00001C12.3335 4.05449 9.94568 1.66668 7.00016 1.66668C4.05464 1.66668 1.66683 4.05449 1.66683 7.00001C1.66683 9.94553 4.05464 12.3333 7.00016 12.3333C9.94568 12.3333 12.3335 9.94553 12.3335 7.00001ZM13.6668 7.00001C13.6668 10.6819 10.6821 13.6667 7.00016 13.6667C3.31826 13.6667 0.333496 10.6819 0.333496 7.00001C0.333496 3.31811 3.31826 0.333344 7.00016 0.333344C10.6821 0.333344 13.6668 3.31811 13.6668 7.00001ZM5.99844 4.73459C5.7869 4.97257 5.66683 5.30872 5.66683 5.66668C5.66683 6.03487 5.36835 6.33334 5.00016 6.33334C4.63197 6.33334 4.3335 6.03487 4.3335 5.66668C4.3335 5.02463 4.54676 4.36079 5.00189 3.84877C5.46793 3.32448 6.15259 3.00001 7.00016 3.00001C7.74335 3.00001 8.41196 3.19655 8.906 3.61763C9.41141 4.0484 9.66683 4.65811 9.66683 5.33334C9.66683 5.76319 9.57758 6.17871 9.34926 6.57034C9.12475 6.95544 8.79108 7.27397 8.36996 7.55471C7.89842 7.86907 7.74592 8.05285 7.69682 8.13467C7.67159 8.17672 7.66683 8.18467 7.66683 8.33334C7.66683 8.70153 7.36835 9.00001 7.00016 9.00001C6.63197 9.00001 6.3335 8.70153 6.3335 8.33334L6.33349 8.32243C6.3334 8.13632 6.33325 7.81577 6.5535 7.44868C6.7544 7.11384 7.10191 6.79761 7.63036 6.44531C7.93768 6.24043 8.10401 6.05896 8.19739 5.8988C8.28696 5.74516 8.3335 5.57017 8.3335 5.33334C8.3335 5.00858 8.2201 4.78495 8.0411 4.63239C7.85073 4.47014 7.51934 4.33334 7.00016 4.33334C6.5144 4.33334 6.19907 4.50888 5.99844 4.73459ZM7.66683 10.3333C7.66683 10.7015 7.36835 11 7.00016 11C6.63197 11 6.3335 10.7015 6.3335 10.3333C6.3335 9.96515 6.63197 9.66668 7.00016 9.66668C7.36835 9.66668 7.66683 9.96515 7.66683 10.3333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60251:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"10","height":"13","viewBox":"0 0 10 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333984 1.24984C0.333984 0.927673 0.595152 0.666504 0.917318 0.666504C0.917839 0.666504 0.91836 0.666505 0.918881 0.666506L3.25065 0.666504C3.98774 0.666504 4.55348 1.04063 4.9667 1.3139L5.01555 1.34617C5.4755 1.64945 5.7833 1.83317 6.16732 1.83317C6.602 1.83317 7.22352 1.6008 7.80228 1.31142C8.0773 1.17391 8.3191 1.03578 8.4922 0.931926C8.57848 0.880156 8.64703 0.837302 8.69333 0.807833C8.71647 0.793109 8.73401 0.781755 8.74539 0.774335L8.75775 0.766235L8.76054 0.764392C8.93952 0.645138 9.16961 0.634042 9.35924 0.735529C9.54891 0.83704 9.66732 1.03471 9.66732 1.24984V6.49984C9.66732 6.69488 9.56984 6.87701 9.40756 6.9852L9.08399 6.49984C9.40756 6.9852 9.40765 6.98514 9.40756 6.9852L9.4051 6.98683L9.40011 6.99014L9.3827 7.00155C9.36788 7.01122 9.34668 7.02493 9.31969 7.04211C9.26574 7.07644 9.18845 7.12473 9.09244 7.18233C8.90095 7.29723 8.63234 7.45076 8.32403 7.60492C7.73612 7.89887 6.8993 8.24984 6.16732 8.24984C5.4082 8.24984 4.81694 7.87335 4.38107 7.59581L4.34897 7.57538C3.86321 7.2664 3.55209 7.08317 3.18583 7.08317H1.50065V11.7498C1.50065 12.072 1.23948 12.3332 0.917318 12.3332C0.595152 12.3332 0.333984 12.072 0.333984 11.7498V1.24984Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 79058:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6.05558 1.55357C6.36687 0.658012 7.6334 0.658002 7.9447 1.55357L9.04496 4.71887L12.3953 4.78714C13.3433 4.80646 13.7346 6.011 12.9791 6.58381L10.3087 8.60835L11.2791 11.8158C11.5537 12.7233 10.529 13.4678 9.75078 12.9262L7.00014 11.0122L4.24949 12.9262C3.47126 13.4678 2.4466 12.7234 2.72116 11.8158L3.69155 8.60835L1.02117 6.58381C0.265637 6.01101 0.657009 4.80646 1.60494 4.78714L4.95532 4.71887L6.05558 1.55357ZM7.00014 2.89714L6.13858 5.37574C6.00125 5.77081 5.63256 6.03868 5.21439 6.0472L2.59086 6.10066L4.68191 7.68599C5.01521 7.93867 5.15604 8.3721 5.03492 8.77244L4.27506 11.2841L6.42896 9.78526C6.77227 9.54636 7.228 9.54636 7.57132 9.78526L9.72522 11.2841L8.96535 8.77244C8.84424 8.3721 8.98507 7.93867 9.31836 7.68599L11.4094 6.10066L8.78589 6.0472C8.36772 6.03868 7.99903 5.77081 7.8617 5.37574L7.00014 2.89714Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10812:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0.666667C0 0.298477 0.298477 0 0.666667 0H11.3333C11.7015 0 12 0.298477 12 0.666667C12 1.03486 11.7015 1.33333 11.3333 1.33333H0.666667C0.298477 1.33333 0 1.03486 0 0.666667ZM0 3.33333C0 2.96514 0.298477 2.66667 0.666667 2.66667H7.33333C7.70152 2.66667 8 2.96514 8 3.33333C8 3.70152 7.70152 4 7.33333 4H0.666667C0.298477 4 0 3.70152 0 3.33333ZM0.666667 5.33333C0.298477 5.33333 0 5.63181 0 6C0 6.36819 0.298477 6.66667 0.666667 6.66667H11.3333C11.7015 6.66667 12 6.36819 12 6C12 5.63181 11.7015 5.33333 11.3333 5.33333H0.666667ZM0 8.66667C0 8.29848 0.298477 8 0.666667 8H7.33333C7.70152 8 8 8.29848 8 8.66667C8 9.03486 7.70152 9.33333 7.33333 9.33333H0.666667C0.298477 9.33333 0 9.03486 0 8.66667ZM0.666667 10.6667C0.298477 10.6667 0 10.9651 0 11.3333C0 11.7015 0.298477 12 0.666667 12H11.3333C11.7015 12 12 11.7015 12 11.3333C12 10.9651 11.7015 10.6667 11.3333 10.6667H0.666667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 67906:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333496 0.99998C0.333496 0.63179 0.631973 0.333313 1.00016 0.333313H13.0002C13.3684 0.333313 13.6668 0.63179 13.6668 0.99998C13.6668 1.36817 13.3684 1.66665 13.0002 1.66665H1.00016C0.631973 1.66665 0.333496 1.36817 0.333496 0.99998ZM0.333496 4.99998C0.333496 4.63179 0.631973 4.33331 1.00016 4.33331H13.0002C13.3684 4.33331 13.6668 4.63179 13.6668 4.99998C13.6668 5.36817 13.3684 5.66665 13.0002 5.66665H1.00016C0.631973 5.66665 0.333496 5.36817 0.333496 4.99998ZM1.00016 8.33331C0.631973 8.33331 0.333496 8.63179 0.333496 8.99998C0.333496 9.36817 0.631973 9.66665 1.00016 9.66665H13.0002C13.3684 9.66665 13.6668 9.36817 13.6668 8.99998C13.6668 8.63179 13.3684 8.33331 13.0002 8.33331H1.00016Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89959:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"12","viewBox":"0 0 14 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.66651 0.666687C3.96417 0.666687 4.22576 0.864005 4.30753 1.15021L6.9742 10.4835C7.07535 10.8376 6.87035 11.2066 6.51633 11.3077C6.1623 11.4089 5.79331 11.2039 5.69216 10.8498L5.06744 8.6633C5.04521 8.66554 5.02266 8.66669 4.99985 8.66669H2.33318C2.31036 8.66669 2.28781 8.66554 2.26559 8.6633L1.64086 10.8498C1.53971 11.2039 1.17072 11.4089 0.816699 11.3077C0.462675 11.2066 0.257681 10.8376 0.35883 10.4835L3.0255 1.15021C3.10727 0.864005 3.36886 0.666687 3.66651 0.666687ZM2.64557 7.33335H4.68745L3.66651 3.76006L2.64557 7.33335ZM8.33318 1.33335C8.33318 0.965164 8.63166 0.666687 8.99985 0.666687H12.9998C13.2239 0.666687 13.433 0.779276 13.5564 0.96636C13.6798 1.15344 13.7009 1.38999 13.6126 1.59597L10.0109 10H12.9998C13.368 10 13.6665 10.2985 13.6665 10.6667C13.6665 11.0349 13.368 11.3334 12.9998 11.3334H8.99985C8.77575 11.3334 8.56665 11.2208 8.44329 11.0337C8.31992 10.8466 8.29881 10.61 8.38708 10.4041L11.9888 2.00002H8.99985C8.63166 2.00002 8.33318 1.70154 8.33318 1.33335ZM6.99985 6.00002C6.99985 5.63183 7.29832 5.33335 7.66651 5.33335H8.33318C8.70137 5.33335 8.99985 5.63183 8.99985 6.00002C8.99985 6.36821 8.70137 6.66669 8.33318 6.66669H7.66651C7.29832 6.66669 6.99985 6.36821 6.99985 6.00002Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 65216:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.195287 0.195262C0.455636 -0.0650874 0.877746 -0.0650874 1.1381 0.195262L2.46574 1.52291C2.51433 1.57023 2.55433 1.62356 2.58549 1.68078C2.6819 1.85741 2.69246 2.06845 2.61717 2.25261C2.59251 2.31292 2.55865 2.37035 2.51558 2.42275L1.18727 4.08313C0.957264 4.37064 0.537736 4.41725 0.250228 4.18725C-0.0372801 3.95724 -0.0838944 3.53771 0.146112 3.2502L1.10669 2.04948L0.195287 1.13807C-0.0650629 0.877722 -0.0650629 0.455612 0.195287 0.195262ZM4.00002 2C4.00002 1.63181 4.2985 1.33333 4.66669 1.33333H11.3334C11.7015 1.33333 12 1.63181 12 2C12 2.36819 11.7015 2.66667 11.3334 2.66667H4.66669C4.2985 2.66667 4.00002 2.36819 4.00002 2ZM4.00002 6C4.00002 5.63181 4.2985 5.33333 4.66669 5.33333H11.3334C11.7015 5.33333 12 5.63181 12 6C12 6.36819 11.7015 6.66667 11.3334 6.66667H4.66669C4.2985 6.66667 4.00002 6.36819 4.00002 6ZM4.66669 9.33333C4.2985 9.33333 4.00002 9.63181 4.00002 10C4.00002 10.3682 4.2985 10.6667 4.66669 10.6667H11.3334C11.7015 10.6667 12 10.3682 12 10C12 9.63181 11.7015 9.33333 11.3334 9.33333H4.66669Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88098:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"9","viewBox":"0 0 11 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.49633 0.250001C5.29741 0.250001 5.09758 0.286163 4.90966 0.358065L0.815374 1.91133C0.584833 1.99879 0.590791 2.29313 0.820874 2.38059L4.93762 3.87667C5.29828 4.0108 5.70171 4.0108 6.06237 3.87667L10.1791 2.38059C10.4097 2.29818 10.4097 1.99879 10.1846 1.91133L6.07933 0.358065C5.89487 0.28651 5.6966 0.249758 5.49633 0.250001ZM10.725 2.81074C10.6901 2.81095 10.6555 2.81738 10.6232 2.82967L6.03441 4.45988C5.98307 4.47917 5.93912 4.51201 5.90812 4.55422C5.87712 4.59643 5.86046 4.64613 5.86025 4.69703V8.43765C5.86068 8.4786 5.87197 8.51884 5.89315 8.55489C5.91432 8.59095 5.94475 8.62173 5.98179 8.64458C6.01884 8.66743 6.06139 8.68166 6.10577 8.68605C6.15016 8.69043 6.19504 8.68484 6.23654 8.66976L10.8258 7.03408C10.8773 7.01655 10.9216 6.9849 10.9528 6.94345C10.9839 6.902 11.0004 6.85275 11 6.80239V3.06177C10.9995 2.99515 10.9703 2.93141 10.9188 2.88446C10.8673 2.83751 10.7976 2.81116 10.725 2.81116V2.81074ZM0.309833 2.82714C0.269139 2.82582 0.228587 2.83223 0.190726 2.84598C0.152864 2.85973 0.118514 2.88052 0.0898333 2.90703C0.0394166 2.95371 0 3.01005 0 3.07733V6.59047C0 6.77632 0.236042 6.90036 0.416166 6.81753L3.28991 5.55356L3.43062 5.49175L4.79141 4.88793C5.005 4.79543 4.9885 4.50613 4.76345 4.42876L0.404708 2.84522C0.374619 2.83368 0.34244 2.8274 0.309833 2.82672V2.82714Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 32577:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill=\"#F24242\" d=\"M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM7 10h2v2H7v-2zm0-6h2v5H7V4z\"/>         <path d=\"M0 0h16v16H0z\" opacity=\".486\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 87163:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm3 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1zm-2 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm2 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1zm-2 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36842:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm-1 5a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 35596:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm-1 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4802:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm6 4a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H10a1 1 0 0 1-1-1zm-5 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm5 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H10a1 1 0 0 1-1-1zm-5 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 19379:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M4 7h8l-4 4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61177:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path fill=\"#AEB7B8\" d=\"M10 4v8L6 8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61093:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"5","height":"6","viewBox":"0 0 5 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M0 4.82578V1.17422C0 0.319867 1.00212 -0.141041 1.65079 0.414964L3.78087 2.24074C4.24648 2.63984 4.24648 3.36016 3.78087 3.75926L1.65079 5.58504C1.00212 6.14104 0 5.68013 0 4.82578Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 83675:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path fill=\"#AEB7B8\" d=\"M6 4v8l4-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4817:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M18.662 2.059l-4.611 1.536A3 3 0 0 0 12 6.442v8.35c-.849-.507-1.894-.792-3-.792-1.3 0-2.515.394-3.428 1.079C4.658 15.764 4 16.786 4 18c0 1.214.658 2.236 1.572 2.921C6.485 21.606 7.7 22 9 22c1.3 0 2.515-.394 3.428-1.079C13.342 20.236 14 19.214 14 18v-7.279l3.949-1.316A3 3 0 0 0 20 6.559V3.023a.979.979 0 0 0-.126-.509.992.992 0 0 0-1.212-.455zM14 8.613l3.316-1.106A.999.999 0 0 0 18 6.559V4.387l-3.316 1.106a1 1 0 0 0-.684.949v2.171zm-2.772 8.066c.535.401.772.878.772 1.321 0 .443-.237.921-.772 1.321C10.694 19.722 9.909 20 9 20c-.909 0-1.694-.278-2.228-.679C6.237 18.921 6 18.443 6 18c0-.443.237-.92.772-1.321C7.306 16.278 8.091 16 9 16c.909 0 1.694.278 2.228.679z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69710:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" d=\"M8.0002 2.66665C7.26382 2.66665 6.66687 3.2636 6.66687 3.99998V6.66665C6.66687 7.40303 7.26382 7.99998 8.0002 7.99998C8.73658 7.99998 9.33354 7.40303 9.33354 6.66665V3.99998C9.33354 3.2636 8.73658 2.66665 8.0002 2.66665ZM5.33354 3.99998C5.33354 2.52722 6.52744 1.33331 8.0002 1.33331C9.47296 1.33331 10.6669 2.52722 10.6669 3.99998V6.66665C10.6669 8.13941 9.47296 9.33331 8.0002 9.33331C6.52744 9.33331 5.33354 8.13941 5.33354 6.66665V3.99998ZM4.0002 5.99998C4.0002 5.63179 3.70173 5.33331 3.33354 5.33331C2.96535 5.33331 2.66687 5.63179 2.66687 5.99998V6.66665C2.66687 9.38682 4.70331 11.6314 7.33479 11.9589C7.33396 11.9725 7.33354 11.9862 7.33354 12V13.3333H6.66687C6.29868 13.3333 6.0002 13.6318 6.0002 14C6.0002 14.3682 6.29868 14.6666 6.66687 14.6666H9.33354C9.70173 14.6666 10.0002 14.3682 10.0002 14C10.0002 13.6318 9.70173 13.3333 9.33354 13.3333H8.66687V12C8.66687 11.9862 8.66645 11.9725 8.66562 11.9589C11.2971 11.6314 13.3335 9.38682 13.3335 6.66665V5.99998C13.3335 5.63179 13.0351 5.33331 12.6669 5.33331C12.2987 5.33331 12.0002 5.63179 12.0002 5.99998V6.66665C12.0002 8.87579 10.2093 10.6666 8.0002 10.6666C5.79106 10.6666 4.0002 8.87579 4.0002 6.66665V5.99998Z\" fill=\"#5C6061\" />     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 86306:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.193851 6.46999C0.19432 6.47046 0.194791 6.47093 0.195262 6.4714C0.195376 6.47152 0.19549 6.47163 0.195605 6.47175L5.5286 11.8047C5.78895 12.0651 6.21106 12.0651 6.4714 11.8047C6.73175 11.5444 6.73175 11.1223 6.4714 10.8619L2.27614 6.66667H11.3333C11.7015 6.66667 12 6.36819 12 6C12 5.63181 11.7015 5.33333 11.3333 5.33333H2.27614L6.4714 1.13807C6.73175 0.877722 6.73175 0.455612 6.4714 0.195262C6.21106 -0.0650875 5.78895 -0.0650875 5.5286 0.195262L0.195262 5.5286L0.193851 5.53001C0.0740375 5.65054 0 5.81662 0 6C0 6.09039 0.0179904 6.17659 0.0505859 6.25519C0.052061 6.25875 0.0535685 6.26231 0.0551082 6.26585C0.0872743 6.3399 0.133522 6.4093 0.193851 6.46999Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 11803:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.333 3.333a.667.667 0 1 1 1.334 0c0 .167.061.32.163.437l.009.01.035.042.132.16c.113.136.268.329.438.551.348.454.735.998.964 1.44.253.488.488 1.186.665 1.792a21.283 21.283 0 0 1 .273 1.03l.002.01a.663.663 0 0 0 .18.333l1 1 .53.529H2.942l.528-.529 1-1a.663.663 0 0 0 .181-.332l.002-.01a9.955 9.955 0 0 1 .069-.28c.048-.19.117-.455.204-.751.177-.606.412-1.304.665-1.791.23-.443.616-.987.964-1.441a21.281 21.281 0 0 1 .57-.71l.035-.042.009-.01V3.77a.664.664 0 0 0 .163-.437zm5.272 4.996l.866.866.529.529c.84.84.245 2.276-.943 2.276h-2.39a2.667 2.667 0 0 1-5.334 0h-2.39C1.755 12 1.16 10.564 2 9.724l.529-.529.866-.866.035-.14c.05-.202.125-.482.217-.798.181-.62.446-1.422.761-2.031.286-.552.733-1.174 1.09-1.639.181-.236.346-.44.466-.586l.053-.065a2 2 0 0 1 3.966 0l.053.065c.12.145.285.35.466.586.357.465.804 1.087 1.09 1.639.315.609.58 1.41.761 2.031a22.717 22.717 0 0 1 .252.938zM8 13.333A1.333 1.333 0 0 1 6.667 12h2.666c0 .736-.597 1.333-1.333 1.333z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 38096:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.33337 2.66663C6.59699 2.66663 6.00004 3.26358 6.00004 3.99996V12C6.00004 12.7363 6.59699 13.3333 7.33337 13.3333H8.66671C9.40309 13.3333 10 12.7363 10 12V3.99996C10 3.26358 9.40309 2.66663 8.66671 2.66663H7.33337ZM7.33337 3.99996L8.66671 3.99996V12H7.33337V3.99996Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.33337 4.66663C1.33337 3.93025 1.93033 3.33329 2.66671 3.33329H4.00004C4.73642 3.33329 5.33337 3.93025 5.33337 4.66663V11.3333C5.33337 12.0697 4.73642 12.6666 4.00004 12.6666H2.66671C1.93033 12.6666 1.33337 12.0697 1.33337 11.3333V4.66663ZM4.00004 4.66663L2.66671 4.66663V11.3333H4.00004V4.66663Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.6667 4.66663C10.6667 3.93025 11.2637 3.33329 12 3.33329H13.3334C14.0698 3.33329 14.6667 3.93025 14.6667 4.66663V11.3333C14.6667 12.0697 14.0698 12.6666 13.3334 12.6666H12C11.2637 12.6666 10.6667 12.0697 10.6667 11.3333V4.66663ZM13.3334 4.66663L12 4.66663V11.3333H13.3334V4.66663Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69425:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 2.5H4.5v19H14a5.5 5.5 0 0 0 2.532-10.384A5.5 5.5 0 0 0 12 2.5H6zm6 8a2.5 2.5 0 1 0 0-5H7.5v5H12zm-4.5 3v5H14a2.5 2.5 0 1 0 0-5H7.5z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 22793:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"22","height":"28","viewBox":"0 0 22 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.33337 0.666504C2.12404 0.666504 0.333374 2.45717 0.333374 4.6665V25.9998C0.333374 26.3345 0.457374 26.6412 0.661374 26.8758C0.714707 26.9372 0.774707 26.9945 0.840041 27.0465C1.05071 27.2118 1.31071 27.3158 1.59604 27.3318C1.63204 27.3332 1.66937 27.3332 1.70537 27.3332C2.02404 27.3238 2.31471 27.2025 2.54004 27.0078L11 19.7558L19.46 27.0078C19.6854 27.2025 19.976 27.3238 20.2947 27.3332C20.3307 27.3332 20.368 27.3332 20.404 27.3318C20.6894 27.3158 20.9494 27.2118 21.16 27.0465C21.468 26.8025 21.6667 26.4238 21.6667 25.9998V4.6665C21.6667 2.45717 19.876 0.666504 17.6667 0.666504H4.33337ZM3.00004 4.6665C3.00004 3.9305 3.59737 3.33317 4.33337 3.33317H17.6667C18.4027 3.33317 19 3.9305 19 4.6665V23.1012L11.8734 16.9918C11.64 16.7892 11.3347 16.6665 11 16.6665C10.6654 16.6665 10.36 16.7892 10.1267 16.9918L3.00004 23.1012V4.6665Z\" fill=\"#AEB7B8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60681:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333344 3.66665C0.333344 1.8257 1.82573 0.333313 3.66668 0.333313H10.3333C12.1743 0.333313 13.6667 1.8257 13.6667 3.66665V6.33335C13.6667 8.1743 12.1743 9.66668 10.3333 9.66668H3.66668C1.82573 9.66668 0.333344 8.1743 0.333344 6.33335V3.66665ZM1.71514 4.10621C1.72692 4.15875 1.74077 4.2105 1.75659 4.26139C2.00982 5.07552 2.76921 5.66665 3.66668 5.66665H10.3333C11.2871 5.66665 12.085 4.99897 12.285 4.10551C12.3167 3.96428 12.3333 3.81741 12.3333 3.66665C12.3333 2.56208 11.4379 1.66665 10.3333 1.66665H3.66668C2.56211 1.66665 1.66668 2.56208 1.66668 3.66665C1.66668 3.81766 1.68341 3.96477 1.71514 4.10621Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 74985:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"currentColor\" d=\"M5.333 2c.368 0 .667.298.667.667v.666h4v-.666a.667.667 0 0 1 1.333 0v.666H12a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.333a2 2 0 0 1 2-2h.667v-.666c0-.369.298-.667.666-.667zM10 4.667v.666a.667.667 0 0 0 1.333 0v-.666H12c.368 0 .667.298.667.666v1.334H3.333V5.333c0-.368.299-.666.667-.666h.667v.666a.667.667 0 0 0 1.333 0v-.666h4zM3.333 8v4c0 .368.299.667.667.667h8a.667.667 0 0 0 .667-.667V8H3.333z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 31887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#00A1B7\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.5 23C32.5 27.9706 28.4706 32 23.5 32C18.5294 32 14.5 27.9706 14.5 23C14.5 18.0294 18.5294 14 23.5 14C28.4706 14 32.5 18.0294 32.5 23ZM25.8625 20.6375C25.8625 21.9423 24.8048 23 23.5 23C22.1952 23 21.1375 21.9423 21.1375 20.6375C21.1375 19.3327 22.1952 18.275 23.5 18.275C24.8048 18.275 25.8625 19.3327 25.8625 20.6375ZM26.8718 27.0538C27.3662 26.8479 27.5539 26.2508 27.224 25.829C26.3592 24.7233 25.0126 24.0125 23.5 24.0125C21.9874 24.0125 20.6408 24.7233 19.776 25.829C19.4461 26.2508 19.6338 26.8479 20.1281 27.0538C21.1662 27.4862 22.3052 27.725 23.5 27.725C24.6947 27.725 25.8337 27.4862 26.8718 27.0538Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 21088:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#A5B3BD\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.5 23C32.5 27.9706 28.4706 32 23.5 32C18.5294 32 14.5 27.9706 14.5 23C14.5 18.0294 18.5294 14 23.5 14C28.4706 14 32.5 18.0294 32.5 23ZM25.8625 20.6375C25.8625 21.9423 24.8048 23 23.5 23C22.1952 23 21.1375 21.9423 21.1375 20.6375C21.1375 19.3327 22.1952 18.275 23.5 18.275C24.8048 18.275 25.8625 19.3327 25.8625 20.6375ZM26.8718 27.0538C27.3662 26.8479 27.5539 26.2508 27.224 25.829C26.3592 24.7233 25.0126 24.0125 23.5 24.0125C21.9874 24.0125 20.6408 24.7233 19.776 25.829C19.4461 26.2508 19.6338 26.8479 20.1281 27.0538C21.1662 27.4862 22.3052 27.725 23.5 27.725C24.6947 27.725 25.8337 27.4862 26.8718 27.0538Z\" fill=\"#A5B3BD\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 21855:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"10","viewBox":"0 0 14 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.2304 0.914805C13.4908 1.17515 13.4908 1.59726 13.2304 1.85761L5.68792 9.4001C5.42758 9.66045 5.00547 9.66045 4.74512 9.4001L0.528599 5.1836C0.268249 4.92325 0.268248 4.50114 0.528597 4.24079C0.788946 3.98044 1.21106 3.98044 1.47141 4.24079L5.21652 7.98589L12.2876 0.914806C12.5479 0.654456 12.9701 0.654456 13.2304 0.914805Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 41614:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg","style":"color: #00a1b7;"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 0C0.895431 0 0 0.89543 0 2V16C0 17.1046 0.89543 18 2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.895431 17.1046 0 16 0H2ZM14.2682 6.64018C14.6218 6.21591 14.5645 5.58534 14.1402 5.23178C13.7159 4.87821 13.0853 4.93554 12.7318 5.35982L8.32597 10.6468L5.58124 8.68627C5.13182 8.36526 4.50727 8.46935 4.18627 8.91877C3.86526 9.36818 3.96935 9.99273 4.41876 10.3137L7.91876 12.8137L8.67403 13.3532L9.26822 12.6402L14.2682 6.64018Z\" fill=\"currentColor\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 98892:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6zM5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6zm12.268 3.64a1 1 0 1 0-1.536-1.28l-4.406 5.287-2.745-1.96a1 1 0 1 0-1.162 1.627l3.5 2.5.755.54.594-.714 5-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36598:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M9.70711 3.70711C10.0976 3.31658 10.0976 2.68342 9.70711 2.29289C9.31658 1.90237 8.68342 1.90237 8.29289 2.29289L5 5.58579L3.70711 4.29289C3.31658 3.90237 2.68342 3.90237 2.29289 4.29289C1.90237 4.68342 1.90237 5.31658 2.29289 5.70711L4.29289 7.70711C4.68342 8.09763 5.31658 8.09763 5.70711 7.70711L9.70711 3.70711Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H12Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H3Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3 19C2.44772 19 2 18.5523 2 18C2 17.4477 2.44772 17 3 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H3Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47904:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" fill-rule=\"nonzero\" d=\"M6 9.414l5 5L12.414 13l-5-5 5-5L11 1.586 4.586 8 6 9.414z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 16186:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" fill-rule=\"nonzero\" d=\"M11 9.414l-5 5L4.586 13l5-5-5-5L6 1.586 12.414 8 11 9.414z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 57872:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 3a1 1 0 0 1 1-1h14a1 1 0 0 1 0 2h-6v6.877l-2-1.913V4H5a1 1 0 0 1-1-1zm.265 3.322a1 1 0 0 1 1.413-.057l13 12a1 1 0 0 1-1.356 1.47L13 15.745V21a1 1 0 0 1-2 0v-7.101L4.322 7.735a1 1 0 0 1-.057-1.413z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71185:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"30","height":"24","viewBox":"0 0 30 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25 24C8.50282 24 8.75298 23.9886 9 23.9664V24H22.5V23.9588C22.7463 23.986 22.9965 24 23.25 24C26.9779 24 30 20.9779 30 17.25C30 13.7314 27.3077 10.8416 23.8708 10.5282C23.9557 10.0315 24 9.52091 24 9C24 4.02944 19.9706 0 15 0C10.4404 0 6.67276 3.39066 6.08089 7.78812C2.57683 8.7405 0 11.9443 0 15.75C0 20.3063 3.69365 24 8.25 24ZM9.43934 7.93934C10.0251 7.35355 10.9749 7.35355 11.5607 7.93934L15 11.3787L18.4393 7.93934C19.0251 7.35355 19.9749 7.35355 20.5607 7.93934C21.1464 8.52513 21.1464 9.47487 20.5607 10.0607L17.1213 13.5L20.5607 16.9393C21.1464 17.5251 21.1464 18.4749 20.5607 19.0607C19.9749 19.6464 19.0251 19.6464 18.4393 19.0607L15 15.6213L11.5607 19.0607C10.9749 19.6464 10.0251 19.6464 9.43934 19.0607C8.85355 18.4749 8.85355 17.5251 9.43934 16.9393L12.8787 13.5L9.43934 10.0607C8.85355 9.47487 8.85355 8.52513 9.43934 7.93934Z\" fill=\"#C8C8C8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47778:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M14.961 5.275a1 1 0 0 0-1.922-.55l-4 14a1.001 1.001 0 0 0 1.922.55l4-14zm-7.336.944a1 1 0 0 1 .156 1.406L4.28 12l3.5 4.375a1 1 0 0 1-1.562 1.25L2.232 12.64A.986.986 0 0 1 2 12a1 1 0 0 1 .232-.64l3.987-4.985a1 1 0 0 1 1.406-.156zm8.75 0a1 1 0 0 1 1.406.156l3.987 4.985a1.003 1.003 0 0 1 0 1.28l-3.987 4.985a1 1 0 0 1-1.562-1.25L19.72 12l-3.5-4.375a1 1 0 0 1 .156-1.406z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 97368:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M0.666667 0.333374C0.298477 0.333374 0 0.631851 0 1.00004C0 1.36823 0.298477 1.66671 0.666667 1.66671H4.66667C5.03486 1.66671 5.33333 1.36823 5.33333 1.00004C5.33333 0.631851 5.03486 0.333374 4.66667 0.333374H0.666667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M0.666667 3.00004C0.298477 3.00004 0 3.29852 0 3.66671C0 4.0349 0.298477 4.33337 0.666667 4.33337H4.66667C5.03486 4.33337 5.33333 4.0349 5.33333 3.66671C5.33333 3.29852 5.03486 3.00004 4.66667 3.00004H0.666667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M0 6.33337C0 5.96518 0.298477 5.66671 0.666667 5.66671H4.66667C5.03486 5.66671 5.33333 5.96518 5.33333 6.33337C5.33333 6.70156 5.03486 7.00004 4.66667 7.00004H0.666667C0.298477 7.00004 0 6.70156 0 6.33337Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M0.666667 8.33337C0.298477 8.33337 0 8.63185 0 9.00004C0 9.36823 0.298477 9.66671 0.666667 9.66671H4.66667C5.03486 9.66671 5.33333 9.36823 5.33333 9.00004C5.33333 8.63185 5.03486 8.33337 4.66667 8.33337H0.666667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M6.66667 1.00004C6.66667 0.631851 6.96514 0.333374 7.33333 0.333374H11.3333C11.7015 0.333374 12 0.631851 12 1.00004C12 1.36823 11.7015 1.66671 11.3333 1.66671H7.33333C6.96514 1.66671 6.66667 1.36823 6.66667 1.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M7.33333 3.00004C6.96514 3.00004 6.66667 3.29852 6.66667 3.66671C6.66667 4.0349 6.96514 4.33337 7.33333 4.33337H11.3333C11.7015 4.33337 12 4.0349 12 3.66671C12 3.29852 11.7015 3.00004 11.3333 3.00004H7.33333Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M6.66667 6.33337C6.66667 5.96518 6.96514 5.66671 7.33333 5.66671H11.3333C11.7015 5.66671 12 5.96518 12 6.33337C12 6.70156 11.7015 7.00004 11.3333 7.00004H7.33333C6.96514 7.00004 6.66667 6.70156 6.66667 6.33337Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M7.33333 8.33337C6.96514 8.33337 6.66667 8.63185 6.66667 9.00004C6.66667 9.36823 6.96514 9.66671 7.33333 9.66671H11.3333C11.7015 9.66671 12 9.36823 12 9.00004C12 8.63185 11.7015 8.33337 11.3333 8.33337H7.33333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 58191:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.3999 1.5C5.25777 1.5 1.8999 4.85786 1.8999 9C1.8999 13.1421 5.25777 16.5 9.3999 16.5C10.5734 16.5 11.6839 16.2305 12.673 15.75H16.1499V12.2731C16.6304 11.284 16.8999 10.1735 16.8999 9C16.8999 4.85786 13.542 1.5 9.3999 1.5Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7688:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.333313 7C0.333313 3.3181 3.31808 0.333336 6.99998 0.333336C10.6819 0.333336 13.6666 3.3181 13.6666 7C13.6666 8.0431 13.4271 9.03024 13 9.90942V13H9.9094C9.03022 13.4271 8.04308 13.6667 6.99998 13.6667C3.31808 13.6667 0.333313 10.6819 0.333313 7Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 3641:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic_stroke\" d=\"M14.3641 18H14.1341L13.9272 18.1005C12.7416 18.6765 11.41 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 11.41 18.6765 12.7416 18.1005 13.9272L18 14.1341V14.3641V18H14.3641Z\" stroke-width=\"2\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 67012:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.33317 2C6.2286 2 5.33317 2.89543 5.33317 4V4.66667H4.6665C3.56193 4.66667 2.6665 5.5621 2.6665 6.66667V12C2.6665 13.1046 3.56193 14 4.6665 14H8.6665C9.77107 14 10.6665 13.1046 10.6665 12V11.3333H11.3332C12.4377 11.3333 13.3332 10.4379 13.3332 9.33333V4C13.3332 2.89543 12.4377 2 11.3332 2H7.33317ZM10.6665 10V6.66667C10.6665 5.5621 9.77107 4.66667 8.6665 4.66667H6.6665V4C6.6665 3.63181 6.96498 3.33333 7.33317 3.33333H11.3332C11.7014 3.33333 11.9998 3.63181 11.9998 4V9.33333C11.9998 9.70152 11.7014 10 11.3332 10H10.6665ZM3.99984 6.66667C3.99984 6.29848 4.29831 6 4.6665 6H8.6665C9.03469 6 9.33317 6.29848 9.33317 6.66667V12C9.33317 12.3682 9.03469 12.6667 8.6665 12.6667H4.6665C4.29831 12.6667 3.99984 12.3682 3.99984 12V6.66667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 13532:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 2C0 0.895431 0.895431 0 2 0H4C4.62951 0 5.22229 0.296388 5.6 0.8L7 2.66667H10C11.1046 2.66667 12 3.5621 12 4.66667V6.35176C12.055 6.40102 12.1089 6.45207 12.1618 6.5049C13.7239 8.067 13.7239 10.5997 12.1618 12.1618C10.5997 13.7239 8.067 13.7239 6.50491 12.1618C6.45207 12.1089 6.40103 12.055 6.35177 12H2C0.89543 12 0 11.1046 0 10V2ZM10.6667 5.56111C9.25957 5.06486 7.63034 5.37946 6.50491 6.5049C5.37947 7.63034 5.06487 9.25957 5.56111 10.6667H2C1.63181 10.6667 1.33333 10.3682 1.33333 10V4H10C10.3682 4 10.6667 4.29848 10.6667 4.66667V5.56111ZM4.53333 1.6L5.33333 2.66667H1.33333V2C1.33333 1.63181 1.63181 1.33333 2 1.33333H4C4.20984 1.33333 4.40743 1.43213 4.53333 1.6ZM6.67441 9.33112C6.67441 8.96293 6.97288 8.66445 7.34107 8.66445H8.66897V7.33655C8.66897 6.96836 8.96744 6.66988 9.33563 6.66988C9.70382 6.66988 10.0023 6.96836 10.0023 7.33655V8.66445H11.3302C11.6984 8.66445 11.9969 8.96293 11.9969 9.33112C11.9969 9.69931 11.6984 9.99778 11.3302 9.99778H10.0023V11.3257C10.0023 11.6939 9.70382 11.9923 9.33563 11.9923C8.96744 11.9923 8.66897 11.6939 8.66897 11.3257V9.99778H7.34107C6.97288 9.99778 6.67441 9.69931 6.67441 9.33112Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44744:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"13","height":"16","viewBox":"0 0 13 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.166672 2.51702C0.166672 1.41245 1.0621 0.517017 2.16667 0.517017H8.83334C9.93791 0.517017 10.8333 1.41245 10.8333 2.51702V8.20221C11.6517 8.93464 12.1667 9.99902 12.1667 11.1837C12.1667 13.3928 10.3758 15.1837 8.16667 15.1837C6.98201 15.1837 5.91762 14.6687 5.1852 13.8504H2.16667C1.0621 13.8504 0.166672 12.9549 0.166672 11.8504V2.51702ZM4.39428 12.517C4.24688 12.1 4.16667 11.6512 4.16667 11.1837C4.16667 8.97455 5.95753 7.18368 8.16667 7.18368C8.63419 7.18368 9.08297 7.26389 9.50001 7.41129V2.51702C9.50001 2.14883 9.20153 1.85035 8.83334 1.85035H2.16667C1.79848 1.85035 1.50001 2.14883 1.50001 2.51702V11.8504C1.50001 12.2185 1.79848 12.517 2.16667 12.517H4.39428ZM2.83334 3.85035C2.83334 3.48216 3.13182 3.18368 3.50001 3.18368H7.50001C7.86819 3.18368 8.16667 3.48216 8.16667 3.85035C8.16667 4.21854 7.86819 4.51702 7.50001 4.51702H3.50001C3.13182 4.51702 2.83334 4.21854 2.83334 3.85035ZM3.50001 5.85035C3.13182 5.85035 2.83334 6.14883 2.83334 6.51702C2.83334 6.88521 3.13182 7.18368 3.50001 7.18368H4.83334C5.20153 7.18368 5.50001 6.88521 5.50001 6.51702C5.50001 6.14883 5.20153 5.85035 4.83334 5.85035H3.50001ZM8.83334 9.18368C8.83334 8.81549 8.53486 8.51702 8.16667 8.51702C7.79848 8.51702 7.50001 8.81549 7.50001 9.18368V10.517H6.16667C5.79848 10.517 5.50001 10.8155 5.50001 11.1837C5.50001 11.5519 5.79848 11.8504 6.16667 11.8504H7.50001V13.1837C7.50001 13.5519 7.79848 13.8504 8.16667 13.8504C8.53486 13.8504 8.83334 13.5519 8.83334 13.1837V11.8504H10.1667C10.5349 11.8504 10.8333 11.5519 10.8333 11.1837C10.8333 10.8155 10.5349 10.517 10.1667 10.517H8.83334V9.18368Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 33597:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h12v12H0z\"/>         <path class=\"graphic\" fill=\"#FFFFFF\" d=\"M6.707 6l2.98 2.98.353.353-.707.707-.353-.353L6 6.707l-2.98 2.98-.353.353-.707-.707.353-.353L5.293 6l-2.98-2.98-.353-.353.707-.707.353.353L6 5.293l2.98-2.98.353-.353.707.707-.353.353L6.707 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89883:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 1.33333C1.63181 1.33333 1.33333 1.63181 1.33333 2V3.33333C1.33333 3.70152 1.03486 4 0.666667 4C0.298477 4 0 3.70152 0 3.33333V2C0 0.895431 0.895431 0 2 0H3.33333C3.70152 0 4 0.298477 4 0.666667C4 1.03486 3.70152 1.33333 3.33333 1.33333H2ZM8 0.666667C8 0.298477 8.29848 0 8.66667 0H10C11.1046 0 12 0.895431 12 2V3.33333C12 3.70152 11.7015 4 11.3333 4C10.9651 4 10.6667 3.70152 10.6667 3.33333V2C10.6667 1.63181 10.3682 1.33333 10 1.33333H8.66667C8.29848 1.33333 8 1.03486 8 0.666667ZM0.666667 8C1.03486 8 1.33333 8.29848 1.33333 8.66667V10C1.33333 10.3682 1.63181 10.6667 2 10.6667H3.33333C3.70152 10.6667 4 10.9651 4 11.3333C4 11.7015 3.70152 12 3.33333 12H2C0.895431 12 0 11.1046 0 10V8.66667C0 8.29848 0.298477 8 0.666667 8ZM11.3333 8C11.7015 8 12 8.29848 12 8.66667V10C12 11.1046 11.1046 12 10 12H8.66667C8.29848 12 8 11.7015 8 11.3333C8 10.9651 8.29848 10.6667 8.66667 10.6667H10C10.3682 10.6667 10.6667 10.3682 10.6667 10V8.66667C10.6667 8.29848 10.9651 8 11.3333 8Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 23996:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M3.33329 11.3334C2.9651 11.3334 2.66663 11.6319 2.66663 12C2.66663 12.3682 2.9651 12.6667 3.33329 12.6667H4.66663C5.03482 12.6667 5.33329 12.3682 5.33329 12C5.33329 11.6319 5.03482 11.3334 4.66663 11.3334H3.33329Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.66663 8.00004C2.66663 7.63185 2.9651 7.33337 3.33329 7.33337H4.66663C5.03482 7.33337 5.33329 7.63185 5.33329 8.00004C5.33329 8.36823 5.03482 8.66671 4.66663 8.66671H3.33329C2.9651 8.66671 2.66663 8.36823 2.66663 8.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8.66663 12C8.66663 11.6319 8.9651 11.3334 9.33329 11.3334C9.70148 11.3334 9.99996 11.6319 9.99996 12C9.99996 12.3682 9.70148 12.6667 9.33329 12.6667C8.9651 12.6667 8.66663 12.3682 8.66663 12Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M11.3333 11.3334C10.9651 11.3334 10.6666 11.6319 10.6666 12C10.6666 12.3682 10.9651 12.6667 11.3333 12.6667H12C12.3681 12.6667 12.6666 12.3682 12.6666 12C12.6666 11.6319 12.3681 11.3334 12 11.3334H11.3333Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M9.33329 7.33337C8.9651 7.33337 8.66663 7.63185 8.66663 8.00004C8.66663 8.36823 8.9651 8.66671 9.33329 8.66671C9.70148 8.66671 9.99996 8.36823 9.99996 8.00004C9.99996 7.63185 9.70148 7.33337 9.33329 7.33337Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M10.6666 8.00004C10.6666 7.63185 10.9651 7.33337 11.3333 7.33337H12C12.3681 7.33337 12.6666 7.63185 12.6666 8.00004C12.6666 8.36823 12.3681 8.66671 12 8.66671H11.3333C10.9651 8.66671 10.6666 8.36823 10.6666 8.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8.66663 4.00004C8.66663 3.63185 8.9651 3.33337 9.33329 3.33337C9.70148 3.33337 9.99996 3.63185 9.99996 4.00004C9.99996 4.36823 9.70148 4.66671 9.33329 4.66671C8.9651 4.66671 8.66663 4.36823 8.66663 4.00004Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M11.3333 3.33337C10.9651 3.33337 10.6666 3.63185 10.6666 4.00004C10.6666 4.36823 10.9651 4.66671 11.3333 4.66671H12C12.3681 4.66671 12.6666 4.36823 12.6666 4.00004C12.6666 3.63185 12.3681 3.33337 12 3.33337H11.3333Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3.33329 3.33337C2.9651 3.33337 2.66663 3.63185 2.66663 4.00004C2.66663 4.36823 2.9651 4.66671 3.33329 4.66671H4.66663C5.03482 4.66671 5.33329 4.36823 5.33329 4.00004C5.33329 3.63185 5.03482 3.33337 4.66663 3.33337H3.33329Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.666626 3.33337C0.666626 2.2288 1.56206 1.33337 2.66663 1.33337H13.3333C14.4379 1.33337 15.3333 2.2288 15.3333 3.33337V12.6667C15.3333 13.7713 14.4379 14.6667 13.3333 14.6667H2.66663C1.56206 14.6667 0.666626 13.7713 0.666626 12.6667V3.33337ZM1.99996 10.6667V12.6667C1.99996 13.0349 2.29844 13.3334 2.66663 13.3334H5.99996V10.6667H1.99996ZM5.99996 9.33337H1.99996V6.66671H5.99996V9.33337ZM7.33329 13.3334H13.3333C13.7015 13.3334 14 13.0349 14 12.6667V10.6667H7.33329V13.3334ZM14 9.33337H7.33329V6.66671H14V9.33337ZM7.33329 5.33337H14V3.33337C14 2.96518 13.7015 2.66671 13.3333 2.66671L7.33329 2.66671V5.33337ZM1.99996 5.33337H5.99996V2.66671H2.66663C2.29844 2.66671 1.99996 2.96518 1.99996 3.33337V5.33337Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 28824:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"22","height":"23","viewBox":"0 0 22 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect x=\"0.5\" y=\"1\" width=\"21\" height=\"21\" rx=\"1.5\" fill=\"url(#paint0_linear_7154_6246)\"/>   <path d=\"M11.3164 6.4082L7.49316 17.5H5.18164L9.99805 4.70312H11.4746L11.3164 6.4082ZM14.5156 17.5L10.6836 6.4082L10.5166 4.70312H12.002L16.8359 17.5H14.5156ZM14.3311 12.7539V14.5029H7.37012V12.7539H14.3311Z\" fill=\"url(#paint1_linear_7154_6246)\"/>   <rect class=\"graphic_stroke\" x=\"0.5\" y=\"1\" width=\"21\" height=\"21\" rx=\"1.5\" stroke=\"#505050\"/>   <defs>   <linearGradient id=\"paint0_linear_7154_6246\" x1=\"22\" y1=\"4.77778\" x2=\"4.18548e-07\" y2=\"4.77778\" gradientUnits=\"userSpaceOnUse\">   <stop offset=\"0.411458\" stop-color=\"#505050\"/>   <stop offset=\"0.494792\"/>   <stop offset=\"0.494892\" stop-color=\"white\"/>   </linearGradient>   <linearGradient id=\"paint1_linear_7154_6246\" x1=\"2.38462\" y1=\"9\" x2=\"20\" y2=\"9\" gradientUnits=\"userSpaceOnUse\">   <stop offset=\"0.411458\" stop-color=\"#505050\"/>   <stop offset=\"0.494792\"/>   <stop offset=\"0.494892\" stop-color=\"white\"/>   </linearGradient>   </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 41286:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9h-5a1 1 0 0 1-1-1V4zm8 5.008V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h5.992L20 9.008zM14 8V5.414L16.586 8H14zm-6 9a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm1-5a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2H9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91177:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path fill=\"#00A1B7\" d=\"M7.493 11.87a.997.997 0 0 1-1.105-.079L2.4 8.8a1 1 0 1 1 1.2-1.6l3.306 2.48 6.387-6.387a1 1 0 0 1 1.414 1.414l-6.99 6.99a.993.993 0 0 1-.224.173z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 99635:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7.493 11.87a.997.997 0 0 1-1.105-.079L2.4 8.8a1 1 0 1 1 1.2-1.6l3.306 2.48 6.387-6.387a1 1 0 0 1 1.414 1.414l-6.99 6.99a.993.993 0 0 1-.224.173z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 27317:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.0002 1.33331C8.36839 1.33331 8.66687 1.63179 8.66687 1.99998L8.66688 9.72383L12.1955 6.19524C12.4558 5.93489 12.8779 5.93489 13.1383 6.19524C13.3986 6.45559 13.3986 6.8777 13.1383 7.13805L8.47386 11.8025C8.46681 11.8096 8.4596 11.8165 8.45223 11.8233C8.39454 11.8766 8.32973 11.9179 8.26102 11.947C8.18149 11.9809 8.09403 11.9997 8.00221 12L8.00021 12L7.99405 12C7.90806 11.9992 7.82595 11.9821 7.75066 11.9517C7.66991 11.9192 7.59424 11.8702 7.5288 11.8047L2.86213 7.13805C2.60178 6.8777 2.60178 6.45559 2.86213 6.19524C3.12248 5.93489 3.54459 5.93489 3.80494 6.19524L7.33355 9.72385L7.33354 1.99998C7.33354 1.63179 7.63201 1.33331 8.0002 1.33331ZM3.33354 13.3333C2.96535 13.3333 2.66687 13.6318 2.66687 14C2.66687 14.3682 2.96535 14.6666 3.33354 14.6666L12.6669 14.6666C13.0351 14.6666 13.3335 14.3682 13.3335 14C13.3335 13.6318 13.0351 13.3333 12.6669 13.3333L3.33354 13.3333Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 97393:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<mask id=\"path-1-outside-1\" maskUnits=\"userSpaceOnUse\" x=\"0.323242\" y=\"0.25\" width=\"14\" height=\"14\" fill=\"black\">   <rect fill=\"white\" x=\"0.323242\" y=\"0.25\" width=\"14\" height=\"14\"/>   <path d=\"M1.32324 10.6322V12.6043C1.32324 12.786 1.46596 12.9287 1.64761 12.9287H3.61974C3.70407 12.9287 3.78841 12.8963 3.8468 12.8314L10.9309 5.75376L8.49818 3.32103L1.42055 10.3987C1.35568 10.4635 1.32324 10.5414 1.32324 10.6322ZM12.8122 3.87245C12.8724 3.81243 12.9201 3.74114 12.9526 3.66266C12.9852 3.58419 13.0019 3.50006 13.0019 3.41509C13.0019 3.33013 12.9852 3.246 12.9526 3.16752C12.9201 3.08905 12.8724 3.01776 12.8122 2.95774L11.2942 1.43972C11.2342 1.37958 11.1629 1.33186 11.0844 1.29931C11.0059 1.26676 10.9218 1.25 10.8368 1.25C10.7519 1.25 10.6677 1.26676 10.5893 1.29931C10.5108 1.33186 10.4395 1.37958 10.3795 1.43972L9.19232 2.62689L11.625 5.05962L12.8122 3.87245Z\"/>   </mask>   <path class=\"graphic\" d=\"M3.8468 12.8314L3.14001 12.124C3.1275 12.1365 3.11533 12.1493 3.1035 12.1624L3.8468 12.8314ZM10.9309 5.75376L11.6377 6.46119C11.8254 6.27368 11.9308 6.01928 11.9309 5.75399C11.931 5.48869 11.8256 5.23425 11.638 5.04665L10.9309 5.75376ZM8.49818 3.32103L9.20528 2.61392C9.01775 2.42639 8.76339 2.32103 8.49818 2.32103C8.23296 2.32103 7.97861 2.42639 7.79107 2.61392L8.49818 3.32103ZM1.42055 10.3987L2.12766 11.1058L1.42055 10.3987ZM12.8122 2.95774L12.1051 3.66485L12.1058 3.66557L12.8122 2.95774ZM11.2942 1.43972L10.5864 2.1461L10.5871 2.14682L11.2942 1.43972ZM10.8368 1.25V0.25V1.25ZM10.3795 1.43972L11.0866 2.14682L11.0873 2.1461L10.3795 1.43972ZM9.19232 2.62689L8.48521 1.91978C8.09469 2.31031 8.09469 2.94347 8.48521 3.334L9.19232 2.62689ZM11.625 5.05962L10.9179 5.76673C11.1055 5.95426 11.3598 6.05962 11.625 6.05962C11.8903 6.05962 12.1446 5.95426 12.3322 5.76673L11.625 5.05962ZM0.323242 10.6322V12.6043H2.32324V10.6322H0.323242ZM0.323242 12.6043C0.323242 13.3383 0.913678 13.9287 1.64761 13.9287V11.9287C2.01825 11.9287 2.32324 12.2337 2.32324 12.6043H0.323242ZM1.64761 13.9287H3.61974V11.9287H1.64761V13.9287ZM3.61974 13.9287C3.95128 13.9287 4.31908 13.8015 4.59009 13.5003L3.1035 12.1624C3.25774 11.991 3.45687 11.9287 3.61974 11.9287V13.9287ZM4.55358 13.5388L11.6377 6.46119L10.2241 5.04633L3.14001 12.124L4.55358 13.5388ZM11.638 5.04665L9.20528 2.61392L7.79107 4.02814L10.2238 6.46087L11.638 5.04665ZM7.79107 2.61392L0.713445 9.69155L2.12766 11.1058L9.20528 4.02814L7.79107 2.61392ZM0.713445 9.69155C0.463178 9.94181 0.323242 10.2731 0.323242 10.6322H2.32324C2.32324 10.7086 2.30901 10.7982 2.27065 10.8903C2.23237 10.9822 2.17941 11.054 2.12766 11.1058L0.713445 9.69155ZM13.5186 4.58028C13.6718 4.42738 13.7934 4.24576 13.8763 4.04582L12.0289 3.27951C12.0468 3.23653 12.0729 3.19749 12.1058 3.16462L13.5186 4.58028ZM13.8763 4.04582C13.9592 3.84588 14.0019 3.63155 14.0019 3.41509H12.0019C12.0019 3.36856 12.0111 3.32249 12.0289 3.27951L13.8763 4.04582ZM14.0019 3.41509C14.0019 3.19864 13.9592 2.9843 13.8763 2.78437L12.0289 3.55068C12.0111 3.5077 12.0019 3.46163 12.0019 3.41509H14.0019ZM13.8763 2.78437C13.7934 2.58443 13.6718 2.40281 13.5186 2.24991L12.1058 3.66557C12.0729 3.6327 12.0468 3.59366 12.0289 3.55068L13.8763 2.78437ZM13.5193 2.25063L12.0013 0.73261L10.5871 2.14682L12.1051 3.66485L13.5193 2.25063ZM12.002 0.733335C11.8491 0.58012 11.6675 0.458565 11.4676 0.375628L10.7013 2.22299C10.6583 2.20517 10.6192 2.17903 10.5864 2.1461L12.002 0.733335ZM11.4676 0.375628C11.2676 0.29269 11.0533 0.25 10.8368 0.25V2.25C10.7903 2.25 10.7442 2.24082 10.7013 2.22299L11.4676 0.375628ZM10.8368 0.25C10.6204 0.25 10.4061 0.29269 10.2061 0.375628L10.9724 2.22299C10.9294 2.24082 10.8834 2.25 10.8368 2.25V0.25ZM10.2061 0.375628C10.0062 0.458565 9.82456 0.58012 9.67166 0.733335L11.0873 2.1461C11.0545 2.17903 11.0154 2.20517 10.9724 2.22299L10.2061 0.375628ZM9.67238 0.73261L8.48521 1.91978L9.89942 3.334L11.0866 2.14682L9.67238 0.73261ZM8.48521 3.334L10.9179 5.76673L12.3322 4.35251L9.89942 1.91978L8.48521 3.334ZM12.3322 5.76673L13.5193 4.57955L12.1051 3.16534L10.9179 4.35251L12.3322 5.76673Z\" fill=\"#161616\" mask=\"url(#path-1-outside-1)\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 13783:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" fill-rule=\"nonzero\" d=\"M5.544 13.474L2.5 10.451l9.086-8.865a2 2 0 0 1 2.828 2.828l-8.87 9.06zM2 11l3 3H2z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 55782:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 3a1 1 0 0 1 1 1v1h5a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-5v1a1 1 0 0 1-2 0v-1H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h5V4a1 1 0 0 1 1-1zm0 14h6a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47529:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-2 0v-1.171A2.983 2.983 0 0 1 18 19H6c-.351 0-.687-.06-1-.171V20a1 1 0 0 1-2 0V4a1 1 0 0 1 2 0v1.171A2.983 2.983 0 0 1 6 5h12c.351 0 .687.06 1 .171V4a1 1 0 0 1 1-1zM5 8v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 54970:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a1 1 0 0 0-2 0v16a1 1 0 0 0 2 0V4zm5 1a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3h-8zM9 8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 51093:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M21 4a1 1 0 0 0-2 0v16a1 1 0 0 0 2 0V4zM6 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6zM5 8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 99474:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect class=\"graphic\" width=\"11\" height=\"11\" rx=\"1\" fill=\"#5C6061\"/>   <path class=\"graphic_stroke_bg\" d=\"M4.5 3L2 5.5L4.5 8\" stroke=\"white\"/>   <path class=\"graphic_stroke_bg\" d=\"M6.5 3L9 5.5L6.5 8\" stroke=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26258:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"8","viewBox":"0 0 14 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.18725 1.08312C4.41726 0.795615 4.37064 0.376087 4.08313 0.146081C3.79563 -0.0839249 3.3761 -0.0373104 3.14609 0.250198L0.487778 3.57309C0.450835 3.61733 0.420376 3.66551 0.396556 3.71628C0.354065 3.80646 0.333253 3.90345 0.333313 4C0.333253 4.09654 0.354066 4.19353 0.396557 4.28371C0.420375 4.33447 0.450831 4.38266 0.48777 4.42689L3.14609 7.74979C3.3761 8.0373 3.79563 8.08391 4.08313 7.85391C4.37064 7.6239 4.41726 7.20437 4.18725 6.91686L1.85376 4L4.18725 1.08312ZM10.8539 0.250197C10.6239 -0.0373106 10.2044 -0.0839248 9.91687 0.146081C9.62937 0.376088 9.58275 0.795616 9.81276 1.08312L12.1463 3.99999L9.81276 6.91686C9.58275 7.20437 9.62937 7.6239 9.91687 7.85391C10.2044 8.08391 10.6239 8.0373 10.8539 7.74979L13.5123 4.42677C13.5485 4.38342 13.5785 4.33628 13.6021 4.28663C13.6455 4.19563 13.6668 4.09758 13.6667 3.99999C13.6668 3.90241 13.6455 3.80436 13.6021 3.71336C13.5785 3.66371 13.5485 3.61656 13.5123 3.57321L10.8539 0.250197Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80648:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"28","viewBox":"0 0 36 28"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h36v28H0z\"/>         <rect class=\"graphic\" width=\"32\" height=\"26\" x=\"2\" y=\"1\" fill=\"#9DA5A6\" rx=\"2\"/>         <rect class=\"grachic-background\" width=\"30\" height=\"24\" x=\"3\" y=\"2\" fill=\"#FFF\" rx=\"1\"/>         <path class=\"graphic\" fill=\"#9DA5A6\" fill-rule=\"nonzero\" d=\"M18.75 18.833l-2.395 3.222a1 1 0 1 1-1.605-1.193l.907-1.22a2.006 2.006 0 0 1-.064-.055s-3.02-2.673-3.024-2.668L7.744 22.29a1 1 0 0 1-1.488-1.336l4.826-5.372a2.013 2.013 0 0 1 2.825-.169l2.945 2.618.296-.395.928-1.248a1.01 1.01 0 0 1 .077-.092l3.45-4.6a1.88 1.88 0 0 1 2.812-.25l6.264 5.796a1 1 0 1 1-1.358 1.468l-6.186-5.723-4.385 5.846zM10 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91027:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47346:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M1.58755 6.14294C1.87625 5.91558 2.29436 5.96478 2.52245 6.25257L2.52342 6.2538C2.52359 6.25401 2.52376 6.25424 2 6.66669L1.47625 7.07915C1.24845 6.78989 1.29828 6.37073 1.58755 6.14294Z\" fill=\"currentColor\"></path> \t<path d=\"M9.47877 9.87784C9.01604 9.95562 8.52288 10 8 10C7.47713 10 6.98397 9.95562 6.52124 9.87784L5.96579 11.5442C5.84936 11.8935 5.47181 12.0822 5.12252 11.9658C4.77322 11.8494 4.58445 11.4718 4.70088 11.1225L5.22344 9.55486C4.60376 9.34849 4.05847 9.08881 3.59023 8.81654L2.5547 10.3698C2.35047 10.6762 1.93656 10.759 1.6302 10.5547C1.32385 10.3505 1.24107 9.93658 1.4453 9.63023L2.49117 8.06143C2.26463 7.87906 2.0757 7.70812 1.92497 7.56196C1.78355 7.42483 1.67517 7.30893 1.60034 7.22504C1.56291 7.18308 1.53382 7.14905 1.51313 7.12431C1.50278 7.11194 1.49453 7.10188 1.48838 7.0943L1.48074 7.08481L1.4781 7.08149L1.47707 7.0802L1.47625 7.07915C1.47605 7.0789 1.47625 7.07915 2 6.66669L2.52342 6.2538L2.52391 6.25439L2.53595 6.26897C2.54793 6.28329 2.56776 6.30656 2.59537 6.33751C2.65062 6.39946 2.73677 6.49189 2.85316 6.60476C3.08633 6.83086 3.43844 7.13659 3.90413 7.44322C4.83433 8.0557 6.20884 8.66669 8 8.66669C9.79117 8.66669 11.1657 8.0557 12.0959 7.44322C12.5616 7.13659 12.9137 6.83086 13.1468 6.60476C13.2632 6.49189 13.3494 6.39946 13.4046 6.33751C13.4322 6.30656 13.4521 6.28329 13.4641 6.26897L13.4761 6.25439L13.4766 6.2538L13.4775 6.25261C13.7056 5.96479 14.1237 5.91557 14.4125 6.14294C14.7017 6.37073 14.7516 6.78989 14.5238 7.07915L14.031 6.69109C14.5238 7.07916 14.524 7.07891 14.5238 7.07915L14.5229 7.0802L14.5219 7.08149L14.5193 7.08481L14.5116 7.0943C14.5055 7.10188 14.4972 7.11194 14.4869 7.12431C14.4662 7.14905 14.4371 7.18308 14.3997 7.22504C14.3248 7.30893 14.2165 7.42483 14.075 7.56196C13.9243 7.70812 13.7354 7.87906 13.5088 8.06143L14.5547 9.63023C14.7589 9.93658 14.6762 10.3505 14.3698 10.5547C14.0635 10.759 13.6495 10.6762 13.4453 10.3698L12.4098 8.81654C11.9415 9.08881 11.3963 9.34849 10.7766 9.55486L11.2991 11.1225C11.4156 11.4718 11.2268 11.8494 10.8775 11.9658C10.5282 12.0822 10.1506 11.8935 10.0342 11.5442L9.47877 9.87784Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 75259:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"16","viewBox":"0 0 17 16","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.50004 5.3335C7.02728 5.3335 5.83338 6.5274 5.83338 8.00016C5.83338 9.47292 7.02728 10.6668 8.50004 10.6668C9.9728 10.6668 11.1667 9.47292 11.1667 8.00016C11.1667 6.5274 9.9728 5.3335 8.50004 5.3335ZM7.16671 8.00016C7.16671 7.26378 7.76366 6.66683 8.50004 6.66683C9.23642 6.66683 9.83338 7.26378 9.83338 8.00016C9.83338 8.73654 9.23642 9.3335 8.50004 9.3335C7.76366 9.3335 7.16671 8.73654 7.16671 8.00016Z\" fill=\"currentColor\"></path> \t<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.0545 7.63C15.0546 7.63019 15.0547 7.63036 14.5 8.00016C15.0547 8.36996 15.0546 8.37013 15.0545 8.37032L15.0534 8.37195L15.0511 8.37539L15.0435 8.38655C15.0372 8.39586 15.0283 8.40888 15.0169 8.42535C14.994 8.45829 14.961 8.50509 14.9184 8.56377C14.8332 8.68107 14.7093 8.84625 14.5505 9.04338C14.2337 9.43662 13.7739 9.96229 13.2022 10.49C12.082 11.5241 10.4231 12.6668 8.50004 12.6668C6.57701 12.6668 4.91814 11.5241 3.79786 10.49C3.22614 9.96229 2.7664 9.43662 2.44962 9.04338C2.29082 8.84625 2.16688 8.68107 2.0817 8.56377C2.03909 8.50509 2.0061 8.45829 1.98322 8.42535C1.97179 8.40888 1.96287 8.39586 1.95654 8.38655L1.94898 8.37539L1.94667 8.37195L1.94588 8.37077C1.94576 8.37059 1.94534 8.36996 2.50004 8.00016C1.94534 7.63036 1.94546 7.63019 1.94558 7.63L1.94667 7.62838L1.94898 7.62494L1.95654 7.61377C1.96287 7.60446 1.97179 7.59145 1.98322 7.57498C2.0061 7.54204 2.03909 7.49524 2.0817 7.43656C2.16688 7.31926 2.29082 7.15408 2.44962 6.95694C2.7664 6.5637 3.22614 6.03803 3.79786 5.51029C4.91814 4.47619 6.57701 3.3335 8.50004 3.3335C10.4231 3.3335 12.082 4.47619 13.2022 5.51029C13.7739 6.03803 14.2337 6.5637 14.5505 6.95694C14.7093 7.15408 14.8332 7.31926 14.9184 7.43656C14.961 7.49524 14.994 7.54204 15.0169 7.57498C15.0283 7.59145 15.0372 7.60446 15.0435 7.61377L15.0511 7.62494L15.0534 7.62838L15.0545 7.63ZM3.48796 8.20694C3.42779 8.13225 3.37342 8.06295 3.32512 8.00016C3.37342 7.93738 3.42779 7.86807 3.48796 7.79338C3.77535 7.43662 4.19061 6.96229 4.70223 6.49003C5.74862 5.52414 7.08975 4.66683 8.50004 4.66683C9.91034 4.66683 11.2515 5.52414 12.2979 6.49003C12.8095 6.96229 13.2247 7.43662 13.5121 7.79338C13.5723 7.86807 13.6267 7.93738 13.675 8.00016C13.6267 8.06295 13.5723 8.13225 13.5121 8.20694C13.2247 8.5637 12.8095 9.03803 12.2979 9.51029C11.2515 10.4762 9.91034 11.3335 8.50004 11.3335C7.08975 11.3335 5.74862 10.4762 4.70223 9.51029C4.19061 9.03803 3.77535 8.5637 3.48796 8.20694Z\" fill=\"currentColor\"></path> \t<path d=\"M14.5 8.00016L15.0545 7.63C15.2038 7.85394 15.2038 8.14639 15.0545 8.37032L14.5 8.00016Z\" fill=\"currentColor\" fill-opacity=\"0.54\"></path><path d=\"M1.94558 7.63L2.50004 8.00016L1.94534 8.36996C1.79605 8.14603 1.79629 7.85394 1.94558 7.63Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 84581:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M5 2.667c-1.971 0-3.667 1.648-3.667 3.791 0 1.909.526 3.003 1.986 4.524.166.173.36.35.578.533.384.32.844.651 1.364.991a28.457 28.457 0 0 0 2.435 1.42c.19.098.417.098.608 0l.213-.111a30.197 30.197 0 0 0 2.222-1.308c.52-.34.98-.673 1.364-.992.219-.182.412-.36.578-.533 1.46-1.52 1.986-2.615 1.986-4.524 0-2.143-1.696-3.791-3.667-3.791-1.035 0-2.156.456-3 1.12-.844-.664-1.965-1.12-3-1.12zm3.49 2.466C9.116 4.493 10.146 4 11 4c1.243 0 2.333 1.06 2.333 2.458 0 1.53-.374 2.31-1.614 3.601a5.78 5.78 0 0 1-.47.431c-.34.283-.76.586-1.24.9A27.154 27.154 0 0 1 8 12.58a29.668 29.668 0 0 1-2.01-1.19c-.48-.314-.9-.617-1.24-.9a5.78 5.78 0 0 1-.47-.43C3.042 8.767 2.668 7.986 2.668 6.457 2.667 5.06 3.757 4 5 4c.854 0 1.884.494 2.51 1.133a.665.665 0 0 0 .49.2.665.665 0 0 0 .49-.2z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 23953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M14 4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V9.33333C2 10.4379 2.89543 11.3333 4 11.3333V13.3333C4 13.5896 4.1469 13.8232 4.37787 13.9342C4.60885 14.0452 4.88302 14.014 5.08313 13.8539L8.05124 11.4794C8.16945 11.3849 8.31633 11.3333 8.46771 11.3333H12C13.1046 11.3333 14 10.4379 14 9.33333V4ZM12 3.33333C12.3682 3.33333 12.6667 3.63181 12.6667 4V9.33333C12.6667 9.70152 12.3682 10 12 10H8.46771C8.01357 10 7.57294 10.1546 7.21832 10.4383L5.33333 11.9463V10.6667C5.33333 10.2985 5.03486 10 4.66667 10H4C3.63181 10 3.33333 9.70152 3.33333 9.33333V4C3.33333 3.63181 3.63181 3.33333 4 3.33333H12Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 83763:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4 4C4 5.10457 4.89543 6 6 6H8V2H6C4.89543 2 4 2.89543 4 4Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8 2V6H10C11.1046 6 12 5.10457 12 4C12 2.89543 11.1046 2 10 2H8Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M4 8C4 6.89543 4.89543 6 6 6H8V10H6C4.89543 10 4 9.10457 4 8Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M4 12C4 10.8954 4.89543 10 6 10H8V12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M8 8C8 6.89543 8.89543 6 10 6C11.1046 6 12 6.89543 12 8C12 9.10457 11.1046 10 10 10C8.89543 10 8 9.10457 8 8Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 42020:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g id=\"file-check-alt-svgrepo-com 1\"> <path id=\"Vector\" d=\"M10.0002 12.6667L11.3335 14L14.0002 11.3333M8.66683 2H5.46683C4.7201 2 4.34672 2 4.06151 2.14533C3.81062 2.27315 3.60665 2.47713 3.47882 2.72801C3.3335 3.01323 3.3335 3.3866 3.3335 4.13333V11.8667C3.3335 12.6134 3.3335 12.9868 3.47882 13.272C3.60665 13.5229 3.81062 13.7269 4.06151 13.8547C4.34672 14 4.7201 14 5.46683 14H7.66683M8.66683 2L12.6668 6M8.66683 2V4.93333C8.66683 5.3067 8.66683 5.49339 8.7395 5.63599C8.80343 5.76143 8.90536 5.86342 9.03083 5.92734C9.17343 6 9.3601 6 9.7335 6H12.6668M12.6668 6V8.93333M6.00016 11.3333H7.66683M6.00016 8.66667H10.0002M6.00016 6H6.66683\" stroke=\"#737373\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 62012:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.33329 11.3334C5.33329 10.9652 5.63177 10.6667 5.99996 10.6667H9.99996C10.3681 10.6667 10.6666 10.9652 10.6666 11.3334C10.6666 11.7016 10.3681 12 9.99996 12H5.99996C5.63177 12 5.33329 11.7016 5.33329 11.3334Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M5.99996 8.00004C5.63177 8.00004 5.33329 8.29852 5.33329 8.66671C5.33329 9.0349 5.63177 9.33337 5.99996 9.33337H9.99996C10.3681 9.33337 10.6666 9.0349 10.6666 8.66671C10.6666 8.29852 10.3681 8.00004 9.99996 8.00004H5.99996Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.3333 6.00531V12.6667C13.3333 13.7713 12.4379 14.6667 11.3333 14.6667H4.66663C3.56206 14.6667 2.66663 13.7713 2.66663 12.6667V3.33337C2.66663 2.2288 3.56206 1.33337 4.66663 1.33337H8.66139L13.3333 6.00531ZM7.99996 2.66671H4.66663C4.29844 2.66671 3.99996 2.96518 3.99996 3.33337V12.6667C3.99996 13.0349 4.29844 13.3334 4.66663 13.3334H11.3333C11.7015 13.3334 12 13.0349 12 12.6667V6.66671H8.66663C8.29844 6.66671 7.99996 6.36823 7.99996 6.00004V2.66671ZM9.33329 5.33337V3.60952L11.0571 5.33337H9.33329Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 51392:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 5a1 1 0 0 1 1-1h1v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-.586l3.707 3.707a1 1 0 0 1 .293.707V19a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5zm6-1h-2v2h2V4zM7 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9.828a3 3 0 0 0-.879-2.121l-4.828-4.828A3 3 0 0 0 12.172 2H7zm3 12a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-1-3a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7086:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M11.522 4.72a4.433 4.433 0 0 1 6.269 6.269l-4.924 4.925-.886.885a2.745 2.745 0 1 1-3.882-3.882l4.595-4.595a1 1 0 1 1 1.414 1.415L9.513 14.33a.746.746 0 0 0 1.054 1.054l.219-.22a.015.015 0 0 0 .004-.003l5.587-5.587a2.433 2.433 0 0 0-3.44-3.44l-.487.486-5.443 5.443a3.667 3.667 0 0 0 0 5.186l.454.454a3.667 3.667 0 0 0 5.186 0l4.714-4.714a1 1 0 1 1 1.414 1.414l-4.714 4.714a5.667 5.667 0 0 1-8.014 0l-.454-.454a5.667 5.667 0 0 1 0-8.014l5.443-5.443.486-.487z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80124:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.25 4.5C2.25 4.08579 2.58579 3.75 3 3.75H15C15.4142 3.75 15.75 4.08579 15.75 4.5C15.75 4.91421 15.4142 5.25 15 5.25H3C2.58579 5.25 2.25 4.91421 2.25 4.5ZM5.25 9C5.25 8.58579 5.58579 8.25 6 8.25H12C12.4142 8.25 12.75 8.58579 12.75 9C12.75 9.41421 12.4142 9.75 12 9.75H6C5.58579 9.75 5.25 9.41421 5.25 9ZM8.25 12.75C7.83579 12.75 7.5 13.0858 7.5 13.5C7.5 13.9142 7.83579 14.25 8.25 14.25H10.5C10.9142 14.25 11.25 13.9142 11.25 13.5C11.25 13.0858 10.9142 12.75 10.5 12.75H8.25Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 32472:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.667a2 2 0 0 0-2-2H9L7.6 2.8A2 2 0 0 0 6 2H4zm3.333 2.667l-.8-1.067A.667.667 0 0 0 6 3.333H4A.667.667 0 0 0 3.333 4v.667h4zm-4 7.333V6H12c.368 0 .667.298.667.667V12a.667.667 0 0 1-.667.667H4A.667.667 0 0 1 3.333 12z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89129:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 0C5.55228 0 6 0.447715 6 1V2H14V1C14 0.447715 14.4477 0 15 0C15.5523 0 16 0.447715 16 1V2H17C18.6569 2 20 3.34315 20 5V13C20 14.6569 18.6569 16 17 16H16V17C16 17.5523 15.5523 18 15 18C14.4477 18 14 17.5523 14 17V16H6V17C6 17.5523 5.55228 18 5 18C4.44772 18 4 17.5523 4 17V16H3C1.34315 16 0 14.6569 0 13V5C0 3.34315 1.34315 2 3 2H4V1C4 0.447715 4.44772 0 5 0ZM17 14C17.5523 14 18 13.5523 18 13V5C18 4.44772 17.5523 4 17 4H3C2.44772 4 2 4.44772 2 5V13C2 13.5523 2.44772 14 3 14H17Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71492:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"9","viewBox":"0 0 11 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.40109 4.92674C6.97185 4.92674 6.62391 5.36322 6.62391 5.89976C6.62391 6.43738 6.97185 6.87386 7.40109 6.87386C7.83033 6.87386 8.17826 6.43738 8.17826 5.89976C8.17766 5.36322 7.83033 4.92674 7.40109 4.92674ZM10.1068 2.39387C10.1959 2.19645 10.1995 1.0747 9.72723 0C9.72723 0 8.64456 0.107632 7.00652 1.125C6.66277 1.03846 6.08109 0.996274 5.5006 0.996274C4.91891 0.996274 4.33783 1.03846 3.99408 1.125C2.35543 0.107632 1.27277 0 1.27277 0C0.801087 1.0747 0.80587 2.19645 0.89375 2.39387C0.338967 2.93906 0 3.59405 0 4.48756C0 8.37422 3.56484 8.43642 4.46397 8.43642L5.5006 8.4375L6.53603 8.43642C7.43636 8.43642 11 8.37422 11 4.48756C11 3.59405 10.6616 2.93906 10.1068 2.39387ZM5.51674 7.95884H5.48326C3.22886 7.95884 1.47245 7.71599 1.47245 5.73317C1.47245 5.25775 1.65777 4.81749 2.09837 4.45186C2.8319 3.84231 4.07418 4.16466 5.48326 4.16466H5.51674C6.92581 4.16466 8.1687 3.84231 8.90283 4.45186C9.34223 4.81749 9.52755 5.25775 9.52755 5.73317C9.52755 7.71599 7.77174 7.95884 5.51674 7.95884ZM3.59951 4.92674C3.17027 4.92674 2.82234 5.36322 2.82234 5.89976C2.82234 6.43738 3.17027 6.87386 3.59951 6.87386C4.02935 6.87386 4.37728 6.43738 4.37728 5.89976C4.37728 5.36322 4.02935 4.92674 3.59951 4.92674Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 55551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 0.666656H4L8 7.33332H11.6667L8 0.666656ZM5.66667 4.99999L3.66667 1.66666L0 7.99999L2 11.3333L5.66667 4.99999ZM12 7.99999H4.66667L2.66667 11.3333H10.3333L12 7.99999Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 517:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"12","viewBox":"0 0 11 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.23684 2.78571C7.23684 3.08571 7.35263 3.34286 7.57263 3.55179C7.78684 3.76071 8.05895 3.85714 8.39474 3.85714C8.71316 3.85714 8.97368 3.76071 9.21105 3.55179C9.43684 3.34286 9.55263 3.08571 9.55263 2.78571C9.55263 2.50179 9.43684 2.25 9.19947 2.03036C8.97368 1.81607 8.68421 1.71429 8.39474 1.71429C8.07632 1.71429 7.81579 1.81607 7.58421 2.03036C7.35842 2.25 7.23684 2.50179 7.23684 2.78571ZM11 2.78571C11 3.32143 10.7742 3.95893 10.34 4.69286C9.90579 5.43214 9.47158 6.03214 9.03737 6.50357L8.39474 7.20536C8.18632 7.00714 7.94316 6.74464 7.65368 6.42857C7.36421 6.10714 6.97632 5.55536 6.50158 4.76786C6.02105 3.98036 5.78947 3.32143 5.78947 2.78571C5.78947 2.11607 6.03263 1.54821 6.54211 1.07679C7.04579 0.610714 7.65947 0.375 8.39474 0.375C9.10684 0.375 9.72632 0.610714 10.23 1.07679C10.7395 1.54821 11 2.11607 11 2.78571ZM10.4211 6.57857V10.5536C10.4211 10.8214 10.3053 11.0893 10.0679 11.2982C9.8421 11.5179 9.55263 11.625 9.26316 11.625H1.15789C0.868421 11.625 0.578947 11.5179 0.353158 11.2982C0.115789 11.0893 0 10.8214 0 10.5536V3.05357C0 2.78571 0.115789 2.51786 0.353158 2.30893C0.578947 2.08929 0.868421 1.98214 1.15789 1.98214H4.74737C4.67789 2.31964 4.63158 2.5875 4.63158 2.78571C4.63158 3.42321 4.88632 4.17321 5.37263 5.03571C5.86474 5.89286 6.27579 6.53571 6.60579 6.91607C6.94737 7.3125 7.25421 7.65 7.54368 7.93393L8.39474 8.78571L9.26316 7.93393C9.99842 7.07143 10.3863 6.61071 10.4211 6.57857ZM3.47368 8.14286V8.8875H4.77632C4.63158 9.48214 4.19737 9.76607 3.47368 9.76607C3.07421 9.76607 2.73842 9.63214 2.47211 9.36429C2.20419 9.10924 2.05638 8.76637 2.06105 8.41071C2.06105 8.04107 2.2 7.725 2.47211 7.45714C2.73842 7.18929 3.07421 7.05536 3.47368 7.05536C3.85579 7.05536 4.16263 7.1625 4.39421 7.38214L5.01947 6.83036C4.58526 6.46071 4.08158 6.26786 3.50263 6.26786H3.47368C2.84263 6.26786 2.29842 6.4875 1.84684 6.90536C1.39526 7.32321 1.15789 7.82679 1.15789 8.41071C1.15789 8.99464 1.39526 9.49821 1.84684 9.91607C2.29842 10.3339 2.84263 10.5536 3.47368 10.5536C4.14526 10.5536 4.68368 10.3554 5.08895 9.96964C5.5 9.58393 5.69684 9.08036 5.69684 8.45893C5.69684 8.30893 5.69105 8.20179 5.67368 8.14286H3.47368Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 1305:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 5a1 1 0 0 0-2 0v14a1 1 0 0 0 2 0v-6h4v6a1 1 0 0 0 2 0V5a1 1 0 0 0-2 0v6H6V5zm9 7a1 1 0 0 1 1 1v5h3a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 41701:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a1 1 0 0 1 1 1v6h4V5a1 1 0 0 1 2 0v14a1 1 0 0 1-2 0v-6H6v6a1 1 0 0 1-2 0V5a1 1 0 0 1 1-1zm16.371 8.071a.997.997 0 0 0-1.18.341L18 15.333l-2.193-2.924-.041-.052a.99.99 0 0 0-.711-.356 1.019 1.019 0 0 0-.698.233.99.99 0 0 0-.356.711l-.001.067V19a1 1 0 0 0 2 0v-3l1.186 1.581a.997.997 0 0 0 1.628 0L20 16v3a1 1 0 0 0 2 0v-5.985a.997.997 0 0 0-.629-.944z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 70191:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 5a1 1 0 0 0-2 0v14a1 1 0 0 0 2 0v-6h4v6a1 1 0 0 0 2 0V5a1 1 0 0 0-2 0v6H6V5zm11 7a1 1 0 0 0 0 2h.003a3 3 0 1 1-2.559 4.572 1 1 0 0 1 1.703-1.049A1 1 0 1 0 17 16h-.003a3 3 0 1 1 1.988-5.25 1.001 1.001 0 0 1-1.324 1.5A.994.994 0 0 0 17 12z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 81740:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M14.701 3.279a3 3 0 1 1 4.76 3.653L10.96 18.01a3 3 0 0 1-3.252 1.045L7 20h12a1 1 0 0 1 0 2H5a1 1 0 0 1-.794-1.609l1.891-2.52a3.002 3.002 0 0 1 .102-3.512l6.373-8.305L11.7 5.4 9.3 8.6a1 1 0 1 1-1.6-1.2l2.997-3.996.003-.004a1 1 0 0 1 1.4-.2l.002.001 1.687 1.266.912-1.188zM7.786 15.576l6.386-8.322 1.6 1.2-6.399 8.34a1 1 0 0 1-1.376.204l-.034-.026a1 1 0 0 1-.177-1.396zm10.089-9.862l-.885 1.153-1.6-1.2.898-1.17a1 1 0 1 1 1.587 1.217z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 82052:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M7.33337 5.33337C7.33337 4.96518 7.63185 4.66671 8.00004 4.66671C8.36823 4.66671 8.66671 4.96518 8.66671 5.33337V8.66671C8.66671 9.0349 8.36823 9.33337 8.00004 9.33337C7.63185 9.33337 7.33337 9.0349 7.33337 8.66671V5.33337Z\" fill=\"black\"/>     <path class=\"graphic\" d=\"M8.00004 10.6667C7.63185 10.6667 7.33337 10.9652 7.33337 11.3334C7.33337 11.7016 7.63185 12 8.00004 12C8.36823 12 8.66671 11.7016 8.66671 11.3334C8.66671 10.9652 8.36823 10.6667 8.00004 10.6667Z\" fill=\"black\"/>     <path class=\"graphic\" d=\"M1.33337 8.00004C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00004C14.6667 4.31814 11.6819 1.33337 8.00004 1.33337C4.31814 1.33337 1.33337 4.31814 1.33337 8.00004ZM8.00004 13.3334C5.05452 13.3334 2.66671 10.9456 2.66671 8.00004C2.66671 5.05452 5.05452 2.66671 8.00004 2.66671C10.9456 2.66671 13.3334 5.05452 13.3334 8.00004C13.3334 10.9456 10.9456 13.3334 8.00004 13.3334Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 28444:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 0.666626C8.36819 0.666626 8.66667 0.965103 8.66667 1.33329V3.33329H10.3831C10.6982 3.33329 10.8374 3.73008 10.5913 3.92692L8.20823 5.83337C8.08649 5.93077 7.91351 5.93077 7.79177 5.83337L5.4087 3.92692C5.16265 3.73008 5.30183 3.33329 5.61693 3.33329H7.33333V1.33329C7.33333 0.965103 7.63181 0.666626 8 0.666626ZM2 7.99996C2 7.63177 2.29848 7.33329 2.66667 7.33329H13.3333C13.7015 7.33329 14 7.63177 14 7.99996C14 8.36815 13.7015 8.66663 13.3333 8.66663H2.66667C2.29848 8.66663 2 8.36815 2 7.99996ZM7.33333 12.6666H5.61693C5.30183 12.6666 5.16265 12.2698 5.4087 12.073L7.79177 10.1665C7.91351 10.0692 8.08649 10.0692 8.20823 10.1665L10.5913 12.073C10.8374 12.2698 10.6982 12.6666 10.3831 12.6666H8.66667V14.6666C8.66667 15.0348 8.36819 15.3333 8 15.3333C7.63181 15.3333 7.33333 15.0348 7.33333 14.6666V12.6666Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91527:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.8047 7.5286C14.0651 7.78895 14.0651 8.21106 13.8047 8.4714L8.66588 13.3658C8.66579 13.3676 8.6657 13.3694 8.6656 13.3712L13.8047 8.4714L8.47141 13.8047C8.3428 13.9333 8.17471 13.9984 8.00615 14C8.0041 14 8.00205 14 8 14C7.98934 14 7.97867 13.9997 7.96802 13.9992C7.80822 13.9916 7.65063 13.9268 7.5286 13.8047L2.19526 8.4714C1.93491 8.21106 1.93491 7.78895 2.19526 7.5286C2.45561 7.26825 2.87772 7.26825 3.13807 7.5286L7.33333 11.7239V2.66667C7.33333 2.29848 7.63181 2 8 2C8.36819 2 8.66667 2.29848 8.66667 2.66667V11.7239L12.8619 7.5286C13.1223 7.26825 13.5444 7.26825 13.8047 7.5286Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 79611:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.19526 8.4714C1.93491 8.21106 1.93491 7.78895 2.19526 7.5286L7.33412 2.6342C7.33421 2.63239 7.3343 2.63057 7.33441 2.62876L2.19526 7.5286L7.5286 2.19526C7.65721 2.06665 7.82529 2.00157 7.99385 2.00003C7.9959 2.00001 7.99795 2 8 2C8.01066 2 8.02133 2.00025 8.03198 2.00076C8.19178 2.00839 8.34937 2.07322 8.4714 2.19526L13.8047 7.5286C14.0651 7.78895 14.0651 8.21106 13.8047 8.4714C13.5444 8.73175 13.1223 8.73175 12.8619 8.4714L8.66667 4.27614V13.3333C8.66667 13.7015 8.36819 14 8 14C7.63181 14 7.33333 13.7015 7.33333 13.3333V4.27614L3.13807 8.4714C2.87772 8.73175 2.45561 8.73175 2.19526 8.4714Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 66995:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M8 6.586l5.293-5.293a1 1 0 0 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 1 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 1 1 1.414-1.414L8 6.586z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 5952:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6.25914 3.9476C6.53567 3.83076 6.76197 3.65513 6.94152 3.49539C7.05669 3.39292 7.18212 3.26868 7.28932 3.16249C7.33767 3.1146 7.38234 3.07035 7.42066 3.03346C7.72916 2.73646 7.87696 2.66683 7.99967 2.66683C8.09746 2.66683 8.24753 2.7344 8.57809 3.04753C8.61723 3.0846 8.66154 3.12761 8.70899 3.17367C8.82054 3.28196 8.94953 3.40718 9.0694 3.51161C9.24876 3.66788 9.47719 3.84252 9.75208 3.95248C10.0252 4.06172 10.3022 4.09263 10.5326 4.10266C10.6773 4.10897 10.8469 4.10721 10.9899 4.10573C11.0559 4.10505 11.1163 4.10443 11.1659 4.10468C11.5669 4.10673 11.7009 4.15861 11.7791 4.23709C11.8336 4.2919 11.8827 4.39992 11.8812 4.81614C11.8811 4.85816 11.8804 4.90545 11.8797 4.9563C11.8776 5.10852 11.8751 5.29266 11.8843 5.46209C11.8973 5.70032 11.9346 5.98124 12.0522 6.25963C12.1691 6.53616 12.3447 6.76246 12.5044 6.94201C12.6069 7.05718 12.7312 7.1826 12.8373 7.28981C12.8852 7.33817 12.9295 7.38282 12.9664 7.42115C13.2634 7.72964 13.333 7.87744 13.333 8.00016C13.333 8.12288 13.2634 8.27068 12.9664 8.57917C12.9295 8.61749 12.8853 8.66211 12.8374 8.71044C12.7312 8.81765 12.6069 8.94315 12.5044 9.05832C12.3447 9.23787 12.1691 9.46416 12.0522 9.7407C11.9346 10.019 11.8975 10.2999 11.8848 10.5379C11.8757 10.7075 11.8785 10.8916 11.8808 11.0437C11.8815 11.0943 11.8822 11.1414 11.8824 11.1832C11.8844 11.5993 11.8355 11.7065 11.7818 11.7605C11.7048 11.8379 11.5913 11.8842 11.202 11.883C11.1589 11.8828 11.1104 11.8818 11.0574 11.8806C10.7252 11.8735 10.2154 11.8625 9.75208 12.0478C9.47719 12.1578 9.24876 12.3324 9.0694 12.4887C8.94954 12.5931 8.82065 12.7183 8.7091 12.8265C8.66166 12.8726 8.61722 12.9157 8.57809 12.9528C8.24753 13.2659 8.09746 13.3335 7.99967 13.3335C7.87696 13.3335 7.72916 13.2639 7.42066 12.9669C7.38233 12.93 7.33768 12.8857 7.28932 12.8378C7.18212 12.7316 7.05669 12.6074 6.94152 12.5049C6.76197 12.3452 6.53567 12.1696 6.25914 12.0527C5.98025 11.9349 5.69878 11.896 5.45919 11.8814C5.29079 11.8711 5.1072 11.8721 4.95473 11.8729C4.90179 11.8732 4.85257 11.8735 4.80906 11.8732C4.39175 11.871 4.27756 11.8208 4.2176 11.7605C4.16384 11.7065 4.11491 11.5993 4.11692 11.1832C4.11712 11.1414 4.11783 11.0943 4.11859 11.0437C4.12089 10.8916 4.12366 10.7075 4.11458 10.5379C4.10184 10.2999 4.0647 10.019 3.94711 9.7407C3.83027 9.46416 3.65464 9.23787 3.4949 9.05832C3.39244 8.94315 3.2682 8.81773 3.16201 8.71053C3.11411 8.66217 3.06987 8.6175 3.03297 8.57917C2.73598 8.27068 2.66634 8.12288 2.66634 8.00016C2.66634 7.87744 2.73598 7.72964 3.03297 7.42115C3.06987 7.38283 3.11409 7.33818 3.16198 7.28983C3.26817 7.18263 3.39243 7.05718 3.4949 6.94201C3.65464 6.76246 3.83027 6.53616 3.94711 6.25963C4.0647 5.98131 4.10184 5.70046 4.11458 5.46243C4.12366 5.29287 4.12089 5.10878 4.11859 4.95661C4.11783 4.90602 4.11712 4.8589 4.11692 4.81708C4.11491 4.401 4.16384 4.29387 4.2176 4.2398C4.27756 4.17949 4.39175 4.12935 4.80906 4.1271C4.85256 4.12686 4.90175 4.12713 4.9547 4.12741C5.10717 4.12822 5.29078 4.1292 5.45919 4.11894C5.69878 4.10435 5.98025 4.06543 6.25914 3.9476ZM7.99967 1.3335C7.29479 1.3335 6.80122 1.779 6.49593 2.07292C6.42621 2.14003 6.36692 2.19895 6.31221 2.25331C6.22285 2.34211 6.14569 2.41878 6.05525 2.49924C5.92187 2.61791 5.8223 2.68471 5.74021 2.71939C5.65706 2.75452 5.54391 2.77798 5.37814 2.78807C5.25649 2.79548 5.14266 2.79485 5.00772 2.7941C4.94469 2.79375 4.87705 2.79338 4.80186 2.79378C4.40926 2.79591 3.75807 2.81093 3.2721 3.29969C2.78803 3.78653 2.78174 4.43795 2.7836 4.82353C2.78395 4.89557 2.78493 4.9606 2.78585 5.02124C2.7879 5.15689 2.78961 5.2705 2.78316 5.39117C2.77446 5.55369 2.752 5.66237 2.7189 5.7407C2.68422 5.82279 2.61742 5.92236 2.49875 6.05574C2.41829 6.14618 2.34162 6.22333 2.25282 6.3127C2.19846 6.36741 2.13953 6.42671 2.07243 6.49641C1.77852 6.80171 1.33301 7.29528 1.33301 8.00016C1.33301 8.70505 1.77852 9.19862 2.07243 9.50391C2.13954 9.57362 2.19845 9.63291 2.25282 9.68762C2.34161 9.77698 2.4183 9.85415 2.49875 9.94458C2.61742 10.078 2.68422 10.1775 2.7189 10.2596C2.752 10.338 2.77446 10.4466 2.78316 10.6092C2.78961 10.7298 2.7879 10.8434 2.78585 10.9791C2.78493 11.0397 2.78395 11.1048 2.7836 11.1768C2.78174 11.5624 2.78803 12.2138 3.2721 12.7006C3.75807 13.1894 4.40926 13.2044 4.80186 13.2065C4.87704 13.2069 4.94468 13.2066 5.0077 13.2062C5.14265 13.2055 5.25649 13.2048 5.37814 13.2123C5.54391 13.2223 5.65706 13.2458 5.74021 13.2809C5.8223 13.3156 5.92187 13.3824 6.05525 13.5011C6.14569 13.5815 6.22285 13.6582 6.31222 13.747C6.36692 13.8014 6.42623 13.8603 6.49593 13.9274C6.80122 14.2213 7.29479 14.6668 7.99967 14.6668C8.68889 14.6668 9.1945 14.2055 9.49503 13.9208C9.56141 13.8579 9.61946 13.8014 9.67338 13.749C9.76921 13.6558 9.85202 13.5753 9.94526 13.494C10.0825 13.3745 10.1778 13.3136 10.2473 13.2858C10.4395 13.2089 10.6402 13.211 10.9824 13.2146C11.0486 13.2153 11.1201 13.216 11.1978 13.2163C11.6011 13.2175 12.2317 13.199 12.7273 12.7006C13.2113 12.2138 13.2176 11.5624 13.2157 11.1768C13.2154 11.1049 13.2144 11.0399 13.2135 10.9793C13.2115 10.8437 13.2097 10.7298 13.2162 10.6092C13.2249 10.4466 13.2473 10.338 13.2804 10.2596C13.3151 10.1775 13.3819 10.078 13.5006 9.94458C13.5811 9.85415 13.6577 9.77699 13.7465 9.68762C13.8009 9.63292 13.8598 9.57361 13.9269 9.50391C14.2208 9.19862 14.6663 8.70505 14.6663 8.00016C14.6663 7.29528 14.2208 6.80171 13.9269 6.49641C13.8598 6.42671 13.8009 6.36744 13.7466 6.31273C13.6578 6.22336 13.5811 6.14618 13.5006 6.05574C13.3819 5.92236 13.3151 5.82279 13.2804 5.7407C13.2471 5.66177 13.2245 5.55253 13.2156 5.3896C13.2091 5.26881 13.2106 5.15517 13.2125 5.01961C13.2134 4.95873 13.2143 4.89324 13.2145 4.82089C13.2159 4.43443 13.2085 3.78304 12.7239 3.29631C12.2302 2.80046 11.5826 2.77346 11.1728 2.77136C11.0752 2.77086 10.9931 2.77189 10.9181 2.77283C10.8023 2.77427 10.7035 2.77551 10.5906 2.77059C10.4236 2.76332 10.3185 2.743 10.2473 2.71451C10.1778 2.68674 10.0825 2.62586 9.94526 2.5063C9.85201 2.42506 9.76924 2.34455 9.67339 2.25133C9.61947 2.19889 9.56141 2.14242 9.49503 2.07954C9.1945 1.79486 8.68889 1.3335 7.99967 1.3335ZM9.33301 8.00016C9.33301 7.26378 8.73605 6.66683 7.99967 6.66683C7.2633 6.66683 6.66634 7.26378 6.66634 8.00016C6.66634 8.73654 7.2633 9.3335 7.99967 9.3335C8.73605 9.3335 9.33301 8.73654 9.33301 8.00016ZM10.6663 8.00016C10.6663 9.47292 9.47243 10.6668 7.99967 10.6668C6.52692 10.6668 5.33301 9.47292 5.33301 8.00016C5.33301 6.5274 6.52692 5.3335 7.99967 5.3335C9.47243 5.3335 10.6663 6.5274 10.6663 8.00016Z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 50375:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5zM4 7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7zm6 3a2 2 0 1 1-3.999.001A2 2 0 0 1 10 10zm4.747 2.341a.998.998 0 0 0-1.494 0L10 16l-1.626-1.832a.5.5 0 0 0-.748 0L6 16h12l-3.253-3.659z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 93034:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"28","viewBox":"0 0 36 28"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h36v28H0z\"/>         <rect width=\"32\" height=\"26\" x=\"2\" y=\"1\" fill=\"#9DA5A6\" rx=\"2\"/>         <rect width=\"30\" height=\"24\" x=\"3\" y=\"2\" fill=\"#FFF\" rx=\"1\"/>         <path fill=\"#9DA5A6\" fill-rule=\"nonzero\" d=\"M18.75 18.833l-2.395 3.222a1 1 0 1 1-1.605-1.193l.907-1.22a2.006 2.006 0 0 1-.064-.055s-3.02-2.673-3.024-2.668L7.744 22.29a1 1 0 0 1-1.488-1.336l4.826-5.372a2.013 2.013 0 0 1 2.825-.169l2.945 2.618.296-.395.928-1.248a1.01 1.01 0 0 1 .077-.092l3.45-4.6a1.88 1.88 0 0 1 2.812-.25l6.264 5.796a1 1 0 1 1-1.358 1.468l-6.186-5.723-4.385 5.846zM10 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 11894:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 3a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2H4zm6 4a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H10zm-1 5a1 1 0 0 1 1-1h10a1 1 0 0 1 0 2H10a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H10zm-7 5a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm.89-11.887a.5.5 0 0 0-.89.312v7.15a.5.5 0 0 0 .89.312l2.86-3.575a.5.5 0 0 0 0-.624L3.89 8.113z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 13669:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M10.0018 0.312501H0.996942C0.445872 0.312501 0 0.730505 0 1.24713V9.68979C0 10.2058 0.445872 10.625 0.996942 10.625H10.0024C10.5529 10.625 11 10.2064 11 9.68979V1.24713C11 1.1243 10.9742 1.00267 10.924 0.8892C10.8738 0.77573 10.8003 0.672646 10.7076 0.585843C10.6149 0.499039 10.5048 0.430218 10.3837 0.383316C10.2626 0.336414 10.1329 0.31235 10.0018 0.312501ZM3.67584 2.31766C4.04098 2.31766 4.3474 2.5883 4.3474 2.93578C4.3474 3.28899 4.04098 3.55505 3.67584 3.55505V3.56766C3.30642 3.56766 3.00917 3.28899 3.00917 2.94381C3.00917 2.5969 3.30642 2.31766 3.67584 2.31766ZM8.1737 8.25344C7.49358 8.25344 7.16391 7.87385 7.16391 7.35551C7.16391 7.20642 7.1841 7.04989 7.23364 6.88991L7.55657 5.79702C7.59816 5.67775 7.60917 5.56479 7.60917 5.46388C7.60917 5.11124 7.37982 4.89966 7.01529 4.89966C6.54985 4.89966 6.24465 5.21101 6.08563 5.81594L5.45382 8.19323H4.34618L4.54618 7.4461C4.21957 7.94668 3.76881 8.25573 3.21101 8.25573C2.537 8.25573 2.22202 7.89335 2.22202 7.34748C2.2247 7.191 2.24437 7.03519 2.28073 6.88245L2.78593 4.95241H2.00428L2.24159 4.13245H4.12232L3.37859 6.88704C3.32966 7.06422 3.31132 7.20757 3.31132 7.31021C3.31132 7.48624 3.40183 7.53727 3.54679 7.56938C3.63609 7.58658 4.33884 7.57569 4.71988 6.78039L5.20795 4.95241H4.41651L4.65566 4.14736H6.36024L6.14067 5.07454C6.4367 4.55906 7.02875 4.06422 7.61223 4.06422C8.23119 4.06422 8.74679 4.48165 8.74679 5.27466C8.74679 5.50401 8.70826 5.73108 8.6367 5.95126L8.31865 7.01663C8.29246 7.10882 8.27708 7.20342 8.27278 7.29874C8.27278 7.48567 8.35596 7.57626 8.49786 7.57626C8.64343 7.57626 8.83609 7.47248 9.04771 6.90424L9.48073 7.06021C9.22752 7.90482 8.7578 8.25344 8.1737 8.25344Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 44819:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M13.0043 5.41667C13.0043 7.94797 10.5043 10 8.83768 10C7.17101 10 4.67101 7.94797 4.67101 5.41667C4.67101 2.88536 6.53649 0.833336 8.83768 0.833336C11.1389 0.833336 13.0043 2.88536 13.0043 5.41667ZM11.3377 5.41667C11.3377 3.6528 10.0725 2.5 8.83768 2.5C7.60289 2.5 6.33768 3.6528 6.33768 5.41667C6.33768 6.12695 6.69657 6.87065 7.30508 7.47629C7.95128 8.11947 8.59479 8.33333 8.83768 8.33333C9.08056 8.33333 9.72407 8.11947 10.3703 7.47629C10.9788 6.87065 11.3377 6.12695 11.3377 5.41667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M9.68229 10.8333C9.92306 10.8333 10.162 10.8494 10.3977 10.8808C10.4721 10.7956 10.5499 10.7123 10.6311 10.6311C12.5838 8.67851 15.7496 8.67851 17.7022 10.6311C19.6548 12.5838 19.6548 15.7496 17.7022 17.7022C15.7496 19.6548 12.5838 19.6548 10.6311 17.7022C10.5651 17.6362 10.5013 17.5687 10.4397 17.5H3.83676C2.98192 17.5 2.34692 16.7084 2.53236 15.8739L2.78398 14.7416C2.9294 14.0873 3.20515 13.4689 3.59478 12.9234C4.53166 11.6118 6.04429 10.8333 7.65614 10.8333H9.68229ZM7.65614 12.5C6.58254 12.5 5.57503 13.0185 4.95101 13.8921C4.69148 14.2554 4.50781 14.6673 4.41095 15.1032L4.2487 15.8333H9.45139C9.07176 14.7569 9.07176 13.5764 9.45139 12.5H7.65614ZM17.357 14.1667C17.357 13.7064 16.9839 13.3333 16.5237 13.3333H15V11.8096C15 11.3494 14.6269 10.9763 14.1667 10.9763C13.7064 10.9763 13.3333 11.3494 13.3333 11.8096V13.3333H11.8096C11.3494 13.3333 10.9763 13.7064 10.9763 14.1667C10.9763 14.6269 11.3494 15 11.8096 15H13.3333V16.5237C13.3333 16.9839 13.7064 17.357 14.1667 17.357C14.6269 17.357 15 16.9839 15 16.5237V15H16.5237C16.9839 15 17.357 14.6269 17.357 14.1667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 34061:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12.753 4L9.198 20H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-1.753l3.555-16H17a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2h1.753z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 78018:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6 0C6.55228 0 7 0.447715 7 1V7H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9H7V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V1C5 0.447715 5.44772 0 6 0Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M15 9C15.5523 9 16 9.44771 16 10V14H18C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16H15C14.4477 16 14 15.5523 14 15V10C14 9.44771 14.4477 9 15 9Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.31204 9.6109C2.15191 9.81056 1.84807 9.81056 1.68794 9.6109L0.11556 7.65025C-0.0944184 7.38842 0.0919813 7 0.427607 7H3.57237C3.908 7 4.0944 7.38842 3.88442 7.65025L2.31204 9.6109Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 76767:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M8.3238 2.75064C8.12245 2.63878 7.87763 2.63878 7.67628 2.75064L1.68792 6.07751C1.64715 6.09915 1.6089 6.12489 1.57372 6.15419C1.54546 6.17769 1.51934 6.20337 1.49556 6.23091C1.3945 6.34777 1.33337 6.50012 1.33337 6.66675V11.3334C1.33337 11.7016 1.63185 12.0001 2.00004 12.0001C2.36823 12.0001 2.66671 11.7016 2.66671 11.3334V7.79976L4.66671 8.91087V11.3334C4.66629 11.3439 4.66671 11.3546 4.66671 11.3655C4.66671 12.286 6.15909 13.3655 8.00004 13.3655C9.84099 13.3655 11.3334 12.286 11.3334 11.3655C11.3334 11.3546 11.3332 11.3439 11.3328 11.3334L11.3334 8.91087L14.3238 7.24952C14.5354 7.13194 14.6667 6.90886 14.6667 6.66675C14.6667 6.42464 14.5354 6.20156 14.3238 6.08398L8.3238 2.75064ZM8.00004 9.23744L3.37279 6.66675L8.00004 4.09605L12.6273 6.66675L8.00004 9.23744Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.22881 8.9428C3.44776 9.72384 3.44776 10.9902 4.22881 11.7712C5.00986 12.5523 6.27619 12.5523 7.05724 11.7712L8.47145 10.357C8.7318 10.0967 9.15391 10.0967 9.41426 10.357C9.67461 10.6174 9.67461 11.0395 9.41426 11.2998L8.00005 12.714C6.6983 14.0158 4.58775 14.0158 3.286 12.714C1.98426 11.4123 1.98426 9.30173 3.286 7.99999L4.70022 6.58577C4.96057 6.32542 5.38268 6.32542 5.64303 6.58577C5.90337 6.84612 5.90337 7.26823 5.64303 7.52858L4.22881 8.9428ZM6.11443 9.8856C5.85408 9.62526 5.85408 9.20315 6.11443 8.9428L8.94286 6.11437C9.20321 5.85402 9.62532 5.85402 9.88567 6.11437C10.146 6.37472 10.146 6.79683 9.88567 7.05718L7.05724 9.8856C6.79689 10.146 6.37478 10.146 6.11443 9.8856ZM6.58583 4.70016C6.32548 4.96051 6.32548 5.38261 6.58583 5.64296C6.84618 5.90331 7.26829 5.90331 7.52864 5.64296L8.94286 4.22875C9.72391 3.4477 10.9902 3.4477 11.7713 4.22875C12.5523 5.0098 12.5523 6.27613 11.7713 7.05718L10.3571 8.47139C10.0967 8.73174 10.0967 9.15385 10.3571 9.4142C10.6174 9.67455 11.0395 9.67455 11.2999 9.4142L12.7141 7.99999C14.0158 6.69824 14.0158 4.58769 12.7141 3.28594C11.4123 1.98419 9.3018 1.98419 8.00005 3.28594L6.58583 4.70016Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60623:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7 9a3 3 0 1 0 0 6h3a1 1 0 0 1 0 2H7A5 5 0 0 1 7 7h3a1 1 0 0 1 0 2H7zm1 3a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm6-5a1 1 0 0 0 0 2h3a3 3 0 1 1 0 6h-3a1 1 0 0 0 0 2h3a5 5 0 0 0 0-10h-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 12479:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M11.293 3.293a1 1 0 0 1 1.414 0L20.05 11h.008l-7.35-7.708 8 8c.193.193.29.445.293.698V12l-.001.048a.997.997 0 0 1-.292.66l-8 8a1 1 0 0 1-1.414-1.415L17.586 13H4a1 1 0 1 1 0-2h13.586l-6.293-6.293a1 1 0 0 1 0-1.414z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 95161:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4-2a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H8zm0 6a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2H8zm-1 7a1 1 0 0 1 1-1h12a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1zm-2-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 30350:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <circle class=\"graphic\" cx=\"12\" cy=\"12\" r=\"10\" fill=\"#5C6061\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 98854:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"8","height":"5","viewBox":"0 0 8 5","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1.44948 0L6.55052 0C7.12009 0 7.42736 0.668079 7.05669 1.10053L4.50617 4.07613C4.24011 4.38654 3.75989 4.38654 3.49383 4.07613L0.943309 1.10053C0.572639 0.668079 0.879912 0 1.44948 0Z\" fill=\"#AEB7B8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 35235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M21.12 11.069L3.459 4.158c-.91-.357-1.74.672-1.196 1.486l3.867 5.801c.224.336.224.774 0 1.11l-3.867 5.801c-.543.814.285 1.843 1.196 1.486l17.661-6.911c.848-.331.848-1.531 0-1.862z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 59481:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3.414 10.586l7.172-7.172a2 2 0 0 1 2.828 0l7.172 7.172a2 2 0 0 1 0 2.828l-7.172 7.172a2 2 0 0 1-2.828 0l-7.172-7.172a2 2 0 0 1 0-2.828z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47238:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4.5 4a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V5.707l-.146.147a.502.502 0 0 1-.708-.708l1-1A.502.502 0 0 1 4.5 4zM9 5h11a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2zm0 6h11a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2zm-1 7a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm-3.933-1.75a.5.5 0 1 1-.866-.5 1.5 1.5 0 1 1 2.417 1.75A1.5 1.5 0 1 1 3 18.5a.5.5 0 0 1 1 0 .5.5 0 1 0 .5-.5.5.5 0 0 1 0-1 .5.5 0 1 0-.433-.75zM4.5 10.5a.5.5 0 0 0-.495.428.5.5 0 1 1-.99-.141A1.501 1.501 0 0 1 6 11c0 .427-.179.813-.465 1.085L4.666 13H5.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.362-.845l1.692-1.779.011-.01A.5.5 0 0 0 4.5 10.5z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 56987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 74107:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2a8 8 0 1 1 0-16 8 8 0 0 1 0 16z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60965:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 8941:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4V6H13C14.6569 6 16 7.34315 16 9V17C16 18.6569 14.6569 20 13 20H3C1.34315 20 0 18.6569 0 17V9C0 7.34315 1.34315 6 3 6H4V4ZM10 4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4V6H10V4ZM3 8C2.44772 8 2 8.44772 2 9V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 17.5523 14 17V9C14 8.44772 13.5523 8 13 8H3ZM10 12C10 12.7403 9.5978 13.3866 9 13.7324V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V13.7324C6.4022 13.3866 6 12.7403 6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12Z\" fill=\"rgb(0, 161, 183)\" fill-opacity=\"0.6\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 72102:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4V6H13C14.6569 6 16 7.34315 16 9V17C16 18.6569 14.6569 20 13 20H3C1.34315 20 0 18.6569 0 17V9C0 7.34315 1.34315 6 3 6H4V4ZM10 4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4V6H10V4ZM3 8C2.44772 8 2 8.44772 2 9V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 17.5523 14 17V9C14 8.44772 13.5523 8 13 8H3ZM10 12C10 12.7403 9.5978 13.3866 9 13.7324V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V13.7324C6.4022 13.3866 6 12.7403 6 12C6 10.8954 6.89543 10 8 10C9.10457 10 10 10.8954 10 12Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 29828:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 1C0 0.447715 0.447715 0 1 0H4C4.55228 0 5 0.447715 5 1C5 1.55228 4.55228 2 4 2H2V4C2 4.55228 1.55228 5 1 5C0.447715 5 0 4.55228 0 4V1ZM9 1C9 0.447715 9.44771 0 10 0H13C13.5523 0 14 0.447715 14 1V4C14 4.55228 13.5523 5 13 5C12.4477 5 12 4.55228 12 4V2H10C9.44771 2 9 1.55228 9 1ZM1 9C1.55228 9 2 9.44771 2 10V12H4C4.55228 12 5 12.4477 5 13C5 13.5523 4.55228 14 4 14H1C0.447715 14 0 13.5523 0 13V10C0 9.44771 0.447715 9 1 9ZM13 9C13.5523 9 14 9.44771 14 10V13C14 13.5523 13.5523 14 13 14H10C9.44771 14 9 13.5523 9 13C9 12.4477 9.44771 12 10 12H12V10C12 9.44771 12.4477 9 13 9Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 37871:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"21","height":"16","viewBox":"0 0 21 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6 0C6.55228 0 7 0.447715 7 1V7H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9H7V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V1C5 0.447715 5.44772 0 6 0Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M14.6838 9.05132C15.0921 8.9152 15.5417 9.05566 15.8 9.4L17.5 11.6667L19.2 9.4C19.4583 9.05566 19.9079 8.9152 20.3162 9.05132C20.7246 9.18743 21 9.56957 21 10V15C21 15.5523 20.5523 16 20 16C19.4477 16 19 15.5523 19 15V13L18.3 13.9333C18.1111 14.1851 17.8148 14.3333 17.5 14.3333C17.1852 14.3333 16.8889 14.1851 16.7 13.9333L16 13V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15V10C14 9.56957 14.2754 9.18743 14.6838 9.05132Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.31204 9.6109C2.15191 9.81056 1.84807 9.81056 1.68794 9.6109L0.11556 7.65025C-0.0944184 7.38842 0.0919813 7 0.427607 7H3.57237C3.908 7 4.0944 7.38842 3.88442 7.65025L2.31204 9.6109Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 94384:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 4a8 8 0 1 0 3.555 15.169 1 1 0 1 1 .89 1.791A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v.571c0 1.297-.317 2.395-.948 3.193A3.199 3.199 0 0 1 18.5 17c-1.216 0-2.192-.685-2.801-1.636A5 5 0 1 1 15 8a1 1 0 0 1 2 0v5c0 1.222.85 2 1.5 2a1.2 1.2 0 0 0 .984-.478c.273-.345.516-.961.516-1.951V12a8 8 0 0 0-8-8zm3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 16357:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"8","viewBox":"0 0 14 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4714 0.861888C13.7318 1.12224 13.7318 1.54435 13.4714 1.8047L7.47142 7.8047C7.21108 8.06505 6.78897 8.06505 6.52862 7.8047L0.528615 1.8047C0.268266 1.54435 0.268266 1.12224 0.528615 0.861888C0.788965 0.601539 1.21107 0.601539 1.47143 0.861888L7.00002 6.39048L12.5286 0.861888C12.789 0.601539 13.2111 0.601539 13.4714 0.861888Z\" fill=\"#AEB7B8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 63821:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 0C4.55228 0 5 0.447715 5 1V4C5 4.55228 4.55228 5 4 5H1C0.447715 5 0 4.55228 0 4C0 3.44772 0.447715 3 1 3H3V1C3 0.447715 3.44772 0 4 0ZM10.5 0C11.0523 0 11.5 0.447715 11.5 1V3H13.5C14.0523 3 14.5 3.44772 14.5 4C14.5 4.55228 14.0523 5 13.5 5H10.5C9.94771 5 9.5 4.55228 9.5 4V1C9.5 0.447715 9.94771 0 10.5 0ZM0 10C0 9.44771 0.447715 9 1 9H4C4.55228 9 5 9.44771 5 10V13C5 13.5523 4.55228 14 4 14C3.44772 14 3 13.5523 3 13V11H1C0.447715 11 0 10.5523 0 10ZM9.5 10C9.5 9.44771 9.94771 9 10.5 9H13.5C14.0523 9 14.5 9.44771 14.5 10C14.5 10.5523 14.0523 11 13.5 11H11.5V13C11.5 13.5523 11.0523 14 10.5 14C9.94771 14 9.5 13.5523 9.5 13V10Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 31958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M2 8c0-.368.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.334H2.667A.667.667 0 0 1 2 8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26934:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M2 2H4L7.5 5.5L5.5 2H7.5L11 4.5L9 2H11L14 4L11 14H9L11 4.5L7.5 14H5.5L7.5 5.5L4 14H2L4 6L2 2Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 46605:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 92688:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect class=\"graphic\" width=\"11\" height=\"11\" rx=\"1\" fill=\"#5C6061\"/>   <path class=\"graphic_stroke_bg graphic_bg\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.27444 4.09162C4.4421 4.48418 4.57964 4.91014 4.88142 5.92473L4.88391 5.93307C5.18869 6.95775 5.32589 7.38581 5.50938 7.83045C5.63543 8.13585 5.76037 8.37659 5.897 8.56076C6.09828 8.83209 6.33766 8.99992 6.63376 8.99992C7.02753 8.99992 7.35911 8.8112 7.58923 8.47347C7.77042 8.20748 7.8816 7.86402 7.9424 7.44739C8.03504 6.81257 8.01171 6.00699 7.90265 5.02681C7.77939 3.9186 7.57845 3.02221 7.29363 2.33322C7.17562 2.04777 6.8691 1.92134 6.60896 2.05083C6.34884 2.18033 6.23362 2.5167 6.35163 2.80217C6.58752 3.37277 6.76436 4.16166 6.8759 5.16433C6.97415 6.0476 6.99484 6.76203 6.92103 7.26793C6.88444 7.51871 6.82674 7.69695 6.76077 7.79378C6.74119 7.82253 6.72453 7.84052 6.70449 7.85119C6.70276 7.84895 6.701 7.84659 6.69919 7.84415C6.62859 7.74897 6.54412 7.58625 6.45164 7.36215C6.29005 6.97058 6.15885 6.56128 5.86723 5.58084L5.86475 5.57252C5.54809 4.50793 5.40402 4.06171 5.21111 3.60996C5.07642 3.29453 4.94181 3.05136 4.79023 2.87167C4.55843 2.59684 4.26896 2.4538 3.94268 2.53586C3.59719 2.62276 3.353 2.90101 3.20629 3.30131C3.09221 3.61263 3.02918 4.01532 3.00803 4.5188C2.96864 5.45512 3.07431 6.78482 3.32264 8.52041C3.36694 8.83005 3.63161 9.04166 3.91379 8.99305C4.19597 8.94444 4.3888 8.65399 4.3445 8.34432C4.10605 6.6778 4.00579 5.4159 4.04132 4.57113C4.05521 4.24081 4.08973 3.98467 4.13918 3.80852C4.18103 3.88469 4.22654 3.97944 4.27444 4.09162Z\" stroke=\"white\" stroke-width=\"0.2\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36771:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M0.500061 6C0.500061 2.96243 2.96249 0.5 6.00006 0.5C9.03763 0.5 11.5001 2.96243 11.5001 6C11.5001 9.03757 9.03763 11.5 6.00006 11.5C2.96249 11.5 0.500061 9.03757 0.500061 6Z\" stroke=\"#AEB7B8\"/>   <path d=\"M6.00002 6.00002C8.34317 3.65686 8.37091 3.62912 10.2427 1.75736C7.89952 -0.585793 4.10052 -0.585793 1.75736 1.75736C-0.585795 4.10052 -0.585795 7.89952 1.75736 10.2427C3.62912 8.37092 3.65686 8.34317 6.00002 6.00002Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 99562:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z\" stroke=\"#EDEDED\"/>   <path d=\"M6.00004 5.99998C3.65689 8.34314 3.62915 8.37088 1.75739 10.2426C4.10054 12.5858 7.89955 12.5858 10.2427 10.2426C12.5859 7.89948 12.5859 4.10048 10.2427 1.75732C8.37094 3.62908 8.3432 3.65683 6.00004 5.99998Z\" fill=\"#404B4C\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 42477:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g class=\"graphic_stroke\" fill=\"none\" fill-rule=\"nonzero\" stroke=\"#5C6061\" stroke-width=\"1.333\">         <circle cx=\"8\" cy=\"8\" r=\"7.333\"/>         <path stroke-linecap=\"square\" d=\"M3.333 12.667l9.334-9.334\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 8386:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4.667 1.333a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2H4.667zm-.667 2c0-.368.299-.666.667-.666h6.666c.368 0 .667.298.667.666v9.334a.667.667 0 0 1-.667.666H4.667A.667.667 0 0 1 4 12.667V3.333zM6 4a.667.667 0 0 0 0 1.333h4A.667.667 0 0 0 10 4H6zm-.667 3.333c0-.368.299-.666.667-.666h4A.667.667 0 0 1 10 8H6a.667.667 0 0 1-.667-.667zm.667 2a.667.667 0 0 0 0 1.334h2.667a.667.667 0 0 0 0-1.334H6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7306:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path class=\"graphic\" fill=\"#5C6061\" fill-rule=\"evenodd\" d=\"M4 3a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4zm6 4a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H10zm-1 5a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H10a1 1 0 0 1-1-1zm1 3a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H10zm-7 5a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm3.11-4.113a.5.5 0 0 0 .89-.312v-7.15a.5.5 0 0 0-.89-.312l-2.86 3.575a.5.5 0 0 0 0 .624l2.86 3.575z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 68234:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4C14 2.89543 13.1046 2 12 2H4ZM12 3.33333H4C3.63181 3.33333 3.33333 3.63181 3.33333 4V12C3.33333 12.3682 3.63181 12.6667 4 12.6667H12C12.3682 12.6667 12.6667 12.3682 12.6667 12V4C12.6667 3.63181 12.3682 3.33333 12 3.33333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69435:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"7","height":"14","viewBox":"0 0 7 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.80346 4.98904C1.78031 4.97102 1.75769 4.95282 1.73564 4.93441C1.50696 4.74347 1.31117 4.51221 1.17845 4.21436C1.04746 3.92039 0.995605 3.60128 0.995605 3.25826C0.995605 1.78514 2.19097 0.590942 3.66552 0.590942C5.14007 0.590942 6.33543 1.78514 6.33543 3.25826C6.33543 3.62654 6.03659 3.92509 5.66796 3.92509C5.29932 3.92509 5.00048 3.62654 5.00048 3.25826C5.00048 2.5217 4.4028 1.9246 3.66552 1.9246C2.92824 1.9246 2.33056 2.5217 2.33056 3.25826C2.33056 3.46766 2.36215 3.59146 2.39802 3.67197C2.43217 3.7486 2.48668 3.82338 2.59174 3.9111C2.80358 4.08798 3.10896 4.23895 3.61983 4.49152C3.7236 4.54282 3.83596 4.59836 3.95762 4.65912C3.95976 4.66018 3.9619 4.66124 3.96404 4.66231C4.06208 4.71129 4.16009 4.75942 4.25727 4.80713C4.76491 5.0564 5.24972 5.29446 5.59539 5.58308C5.82407 5.77402 6.01986 6.00527 6.15259 6.30312C6.28358 6.59709 6.33543 6.9162 6.33543 7.25922C6.33543 7.91312 6.14432 8.73277 5.70168 9.32347C5.64876 9.3941 5.59078 9.46328 5.52759 9.5294C5.55073 9.54741 5.57335 9.56561 5.5954 9.58402C5.82408 9.77496 6.01986 10.0062 6.15259 10.3041C6.28358 10.598 6.33543 10.9172 6.33543 11.2602C6.33543 12.7333 5.14007 13.9275 3.66552 13.9275C2.19097 13.9275 0.995605 12.7333 0.995605 11.2602C0.995605 10.8919 1.29445 10.5933 1.66308 10.5933C2.03172 10.5933 2.33056 10.8919 2.33056 11.2602C2.33056 11.9967 2.92824 12.5938 3.66552 12.5938C4.4028 12.5938 5.00048 11.9967 5.00048 11.2602C5.00048 11.0508 4.96889 10.927 4.93302 10.8465C4.89887 10.7698 4.84436 10.6951 4.7393 10.6073C4.52746 10.4305 4.22208 10.2795 3.71121 10.0269C3.60831 9.97605 3.49675 9.92089 3.37627 9.86074L3.36701 9.85613C3.26899 9.80717 3.17099 9.75905 3.07382 9.71134C2.56617 9.46207 2.08132 9.224 1.73564 8.93537C1.50697 8.74443 1.31118 8.51317 1.17845 8.21532C1.04746 7.92135 0.995605 7.60224 0.995605 7.25922C0.995605 6.60532 1.18671 5.78567 1.62936 5.19496C1.68228 5.12434 1.74026 5.05515 1.80346 4.98904ZM3.36256 5.85295C3.14984 5.74768 3.02999 5.75981 2.96932 5.77677C2.89844 5.79659 2.80352 5.85344 2.69803 5.99421C2.47319 6.29426 2.33056 6.80828 2.33056 7.25922C2.33056 7.46862 2.36215 7.59242 2.39802 7.67293C2.43217 7.74955 2.48668 7.82433 2.59174 7.91205C2.80356 8.08892 3.10891 8.23988 3.6197 8.49241L3.62032 8.49272C3.72447 8.54421 3.83717 8.59993 3.95935 8.66094L3.96403 8.66326L3.97073 8.6666C4.18204 8.77067 4.30126 8.75857 4.36172 8.74167C4.4326 8.72185 4.52752 8.665 4.63301 8.52422C4.85785 8.22418 5.00048 7.71016 5.00048 7.25922C5.00048 7.04982 4.96889 6.92602 4.93302 6.84552C4.89888 6.7689 4.84436 6.69412 4.7393 6.6064C4.52749 6.42954 4.22216 6.27859 3.71141 6.02607C3.60665 5.97428 3.4931 5.91814 3.37009 5.8567C3.36906 5.8562 3.36804 5.85569 3.36701 5.85518C3.36553 5.85443 3.36404 5.85369 3.36256 5.85295Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36419:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M4 9a6 6 0 0 1 6-6h9a1 1 0 0 1 0 2h-3.057v15a.943.943 0 1 1-1.886 0V5h-2.114v15a.943.943 0 1 1-1.886 0v-5H10a6 6 0 0 1-6-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 46015:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<circle cx=\"27\" cy=\"27\" r=\"27\" fill=\"black\" fill-opacity=\"0.32\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 19.5C24 17.8431 22.6569 16.5 21 16.5C19.3431 16.5 18 17.8431 18 19.5V34.5C18 36.1569 19.3431 37.5 21 37.5C22.6569 37.5 24 36.1569 24 34.5V19.5ZM36 19.5C36 17.8431 34.6569 16.5 33 16.5C31.3431 16.5 30 17.8431 30 19.5V34.5C30 36.1569 31.3431 37.5 33 37.5C34.6569 37.5 36 36.1569 36 34.5V19.5Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10231:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.3189 32C25.1555 32 32.3189 24.8366 32.3189 16C32.3189 7.16344 25.1555 0 16.3189 0C7.48235 0 0.318909 7.16344 0.318909 16C0.318909 24.8366 7.48235 32 16.3189 32Z\" fill=\"#00A1B7\"/> <rect class=\"player2\" x=\"18.3189\" y=\"11\" width=\"2\" height=\"10\" rx=\"1\" fill=\"white\"/> <rect class=\"player2\" x=\"12.3189\" y=\"11\" width=\"2\" height=\"10\" rx=\"1\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14C3.10457 14 4 13.1046 4 12V2ZM12 2C12 0.89543 11.1046 0 10 0C8.89543 0 8 0.89543 8 2V12C8 13.1046 8.89543 14 10 14C11.1046 14 12 13.1046 12 12V2Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 68278:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M16.6472 3.83988C15.6711 2.86334 14.0884 2.86326 13.1123 3.8397L11.8314 5.12111C11.8262 5.12606 11.821 5.13109 11.8159 5.13621C11.8107 5.14139 11.8056 5.14663 11.8006 5.15192L2.74401 14.2117C2.58776 14.368 2.49999 14.58 2.5 14.8011L2.50013 17.2764C2.50014 17.4974 2.58793 17.7094 2.74419 17.8658C2.90046 18.0221 3.11239 18.1099 3.33336 18.1099L5.80776 18.11C6.02873 18.11 6.24064 18.0222 6.39688 17.8659L16.7652 7.49389C17.7413 6.51746 17.7412 4.93426 16.7651 3.95773L16.6472 3.83988ZM12.4055 6.90432L13.7019 8.2007L5.46254 16.443L4.16645 16.443L4.16639 15.1464L12.4055 6.90432ZM14.8802 7.02198L13.5838 5.7256L14.2907 5.01848C14.6161 4.693 15.1436 4.69303 15.469 5.01854L15.5868 5.13639C15.9122 5.4619 15.9122 5.98963 15.5869 6.31511L14.8802 7.02198Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 53686:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.00001 3.99999C8.00001 4.56822 7.71289 5.16318 7.22609 5.64769C6.70912 6.16223 6.19432 6.33333 6.00001 6.33333C5.8057 6.33333 5.2909 6.16223 4.77393 5.64769C4.28713 5.16318 4.00001 4.56822 4.00001 3.99999C4.00001 2.5889 5.01218 1.66666 6.00001 1.66666C6.98784 1.66666 8.00001 2.5889 8.00001 3.99999ZM9.33334 3.99999C9.33334 6.02504 7.33334 7.66666 6.00001 7.66666C4.66668 7.66666 2.66668 6.02504 2.66668 3.99999C2.66668 1.97495 4.15906 0.333328 6.00001 0.333328C7.84096 0.333328 9.33334 1.97495 9.33334 3.99999ZM5.05478 9.66666H6.6757C7.55016 9.66666 8.38096 10.0488 8.95005 10.7127C9.27003 11.086 9.4932 11.5324 9.59986 12.0123L9.67119 12.3333H2.32883L2.45863 11.7492C2.53612 11.4005 2.68306 11.071 2.89068 10.7803C3.38989 10.0814 4.1959 9.66666 5.05478 9.66666ZM1.8057 10.0054C2.5552 8.95607 3.7653 8.33333 5.05478 8.33333H6.6757C7.93939 8.33333 9.13999 8.88552 9.96239 9.84499C10.4248 10.3845 10.7473 11.0295 10.9014 11.7231L11.0774 12.5147C11.2087 13.1059 10.7589 13.6667 10.1533 13.6667H1.99928C1.31541 13.6667 0.807406 13.0334 0.95576 12.3658L1.15705 11.46C1.27339 10.9365 1.49399 10.4418 1.8057 10.0054Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4421:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M6 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm6 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88398:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g clip-path=\"url(#clip0)\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"#00A1B7\"/> <path d=\"M12.0834 9.16663C10.9622 9.16663 10.4864 10.5939 11.3834 11.2666L11.85 11.6166C11.9969 11.7268 12.0834 11.8997 12.0834 12.0833V14.4166C12.0834 14.6002 11.9969 14.7731 11.85 14.8833L11.3834 15.2333C10.4864 15.906 10.9622 17.3333 12.0834 17.3333H14.4167V20.25C14.4167 20.5721 14.6779 20.8333 15 20.8333C15.3222 20.8333 15.5834 20.5721 15.5834 20.25V17.3333H17.9167C19.0379 17.3333 19.5136 15.906 18.6167 15.2333L18.15 14.8833C18.0031 14.7731 17.9167 14.6002 17.9167 14.4166V12.0833C17.9167 11.8997 18.0031 11.7268 18.15 11.6166L18.6167 11.2666C19.5136 10.5939 19.0379 9.16663 17.9167 9.16663H12.0834ZM12.0834 10.3333H17.9167L17.45 10.6833C17.0094 11.0138 16.75 11.5325 16.75 12.0833V14.4166C16.75 14.9675 17.0094 15.4861 17.45 15.8166L17.9167 16.1666H12.0834L12.55 15.8166C12.9907 15.4861 13.25 14.9675 13.25 14.4166V12.0833C13.25 11.5325 12.9907 11.0138 12.55 10.6833L12.0834 10.3333Z\" fill=\"#F5F8FA\"/> </g> <defs> <clipPath id=\"clip0\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"white\"/> </clipPath> </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7393:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.33333 0.666667C1.33333 1.03486 1.03486 1.33333 0.666667 1.33333C0.298477 1.33333 0 1.03486 0 0.666667C0 0.298477 0.298477 0 0.666667 0C1.03486 0 1.33333 0.298477 1.33333 0.666667ZM4 0.666667C4 1.03486 3.70152 1.33333 3.33333 1.33333C2.96514 1.33333 2.66667 1.03486 2.66667 0.666667C2.66667 0.298477 2.96514 0 3.33333 0C3.70152 0 4 0.298477 4 0.666667ZM9.33333 0.666667C9.33333 1.03486 9.03486 1.33333 8.66667 1.33333C8.29848 1.33333 8 1.03486 8 0.666667C8 0.298477 8.29848 0 8.66667 0C9.03486 0 9.33333 0.298477 9.33333 0.666667ZM6 1.33333C6.36819 1.33333 6.66667 1.03486 6.66667 0.666667C6.66667 0.298477 6.36819 0 6 0C5.63181 0 5.33333 0.298477 5.33333 0.666667C5.33333 1.03486 5.63181 1.33333 6 1.33333ZM0.666667 6.66667C1.03486 6.66667 1.33333 6.36819 1.33333 6C1.33333 5.63181 1.03486 5.33333 0.666667 5.33333C0.298477 5.33333 0 5.63181 0 6C0 6.36819 0.298477 6.66667 0.666667 6.66667ZM1.33333 3.33333C1.33333 3.70152 1.03486 4 0.666667 4C0.298477 4 0 3.70152 0 3.33333C0 2.96514 0.298477 2.66667 0.666667 2.66667C1.03486 2.66667 1.33333 2.96514 1.33333 3.33333ZM0.666667 12C1.03486 12 1.33333 11.7015 1.33333 11.3333C1.33333 10.9651 1.03486 10.6667 0.666667 10.6667C0.298477 10.6667 0 10.9651 0 11.3333C0 11.7015 0.298477 12 0.666667 12ZM1.33333 8.66667C1.33333 9.03486 1.03486 9.33333 0.666667 9.33333C0.298477 9.33333 0 9.03486 0 8.66667C0 8.29848 0.298477 8 0.666667 8C1.03486 8 1.33333 8.29848 1.33333 8.66667ZM3.33333 12C3.70152 12 4 11.7015 4 11.3333C4 10.9651 3.70152 10.6667 3.33333 10.6667C2.96514 10.6667 2.66667 10.9651 2.66667 11.3333C2.66667 11.7015 2.96514 12 3.33333 12ZM9.33333 11.3333C9.33333 11.7015 9.03486 12 8.66667 12C8.29848 12 8 11.7015 8 11.3333C8 10.9651 8.29848 10.6667 8.66667 10.6667C9.03486 10.6667 9.33333 10.9651 9.33333 11.3333ZM11.3333 12C11.7015 12 12 11.7015 12 11.3333C12 10.9651 11.7015 10.6667 11.3333 10.6667C10.9651 10.6667 10.6667 10.9651 10.6667 11.3333C10.6667 11.7015 10.9651 12 11.3333 12ZM6.66667 11.3333C6.66667 11.7015 6.36819 12 6 12C5.63181 12 5.33333 11.7015 5.33333 11.3333C5.33333 10.9651 5.63181 10.6667 6 10.6667C6.36819 10.6667 6.66667 10.9651 6.66667 11.3333ZM11.3333 9.33333C11.7015 9.33333 12 9.03486 12 8.66667C12 8.29848 11.7015 8 11.3333 8C10.9651 8 10.6667 8.29848 10.6667 8.66667C10.6667 9.03486 10.9651 9.33333 11.3333 9.33333ZM12 6C12 6.36819 11.7015 6.66667 11.3333 6.66667C10.9651 6.66667 10.6667 6.36819 10.6667 6C10.6667 5.63181 10.9651 5.33333 11.3333 5.33333C11.7015 5.33333 12 5.63181 12 6ZM11.3333 1.33333C11.7015 1.33333 12 1.03486 12 0.666667C12 0.298477 11.7015 0 11.3333 0C10.9651 0 10.6667 0.298477 10.6667 0.666667C10.6667 1.03486 10.9651 1.33333 11.3333 1.33333ZM12 3.33333C12 3.70152 11.7015 4 11.3333 4C10.9651 4 10.6667 3.70152 10.6667 3.33333C10.6667 2.96514 10.9651 2.66667 11.3333 2.66667C11.7015 2.66667 12 2.96514 12 3.33333ZM2.66667 3.33333C2.66667 2.96514 2.96514 2.66667 3.33333 2.66667H8.66667C9.03486 2.66667 9.33333 2.96514 9.33333 3.33333C9.33333 3.70152 9.03486 4 8.66667 4H6.66667V8.66667C6.66667 9.03486 6.36819 9.33333 6 9.33333C5.63181 9.33333 5.33333 9.03486 5.33333 8.66667V4H3.33333C2.96514 4 2.66667 3.70152 2.66667 3.33333Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69499:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"22","viewBox":"0 0 19 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M18.1667 9.55666C19.2778 10.1982 19.2778 11.8019 18.1667 12.4434L3.16666 21.1037C2.05554 21.7452 0.666656 20.9433 0.666656 19.6603L0.666657 2.33978C0.666657 1.05678 2.05555 0.254901 3.16666 0.896401L18.1667 9.55666Z\" fill=\"#00BCD4\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 51195:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.3189 32C25.1555 32 32.3189 24.8366 32.3189 16C32.3189 7.16344 25.1555 0 16.3189 0C7.48235 0 0.318909 7.16344 0.318909 16C0.318909 24.8366 7.48235 32 16.3189 32Z\" fill=\"#00A1B7\"/> <path class=\"player2\" d=\"M23.0538 15.5606C23.4073 15.7559 23.4073 16.2441 23.0538 16.4394L13.1141 21.9313C12.7607 22.1265 12.3189 21.8825 12.3189 21.4919L12.3189 10.5081C12.3189 10.1175 12.7607 9.87346 13.1141 10.0687L23.0538 15.5606Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 1250:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"14","viewBox":"0 0 11 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1.53688 0.978013C0.871153 0.55437 0 1.03258 0 1.82167V12.1783C0 12.9674 0.87115 13.4456 1.53688 13.022L9.67424 7.84366C10.2917 7.45071 10.2917 6.54929 9.67425 6.15634L1.53688 0.978013Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 25637:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M8 0C8.55228 0 9 0.447714 9 0.999999L9.00001 12.5858L14.2929 7.29289C14.6834 6.90237 15.3166 6.90237 15.7071 7.29289C16.0976 7.68342 16.0976 8.31658 15.7071 8.70711L8.71049 15.7037C8.69991 15.7144 8.68909 15.7249 8.67804 15.735C8.59151 15.815 8.49429 15.8768 8.39122 15.9206C8.27192 15.9713 8.14074 15.9996 8.00301 16L8.00002 16L7.99078 16C7.86178 15.9988 7.73861 15.9732 7.62569 15.9276C7.50456 15.8788 7.39106 15.8053 7.29289 15.7071L0.292893 8.70711C-0.0976311 8.31658 -0.0976311 7.68342 0.292893 7.29289C0.683417 6.90237 1.31658 6.90237 1.70711 7.29289L7.00001 12.5858L7 1C7 0.447716 7.44771 0 8 0Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M1 18C0.447715 18 7.45058e-09 18.4477 7.45058e-09 19C7.45058e-09 19.5523 0.447715 20 1 20L15 20C15.5523 20 16 19.5523 16 19C16 18.4477 15.5523 18 15 18L1 18Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 47137:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M12.2292 3.14583C12.2292 2.6856 11.8562 2.3125 11.3959 2.3125C10.9357 2.3125 10.5626 2.6856 10.5626 3.14583L10.5626 18.1458C10.5626 18.6061 10.9357 18.9792 11.3959 18.9792C11.8562 18.9792 12.2292 18.6061 12.2292 18.1458V3.14583Z\" fill=\"white\"/>   <path d=\"M8.89592 3.97917H4.72925C3.34854 3.97917 2.22925 5.09845 2.22925 6.47917V14.8125C2.22925 16.1932 3.34854 17.3125 4.72925 17.3125H8.89592C9.35615 17.3125 9.72925 16.9394 9.72925 16.4792C9.72925 16.0189 9.35615 15.6458 8.89592 15.6458H4.72925C4.26901 15.6458 3.89591 15.2727 3.89591 14.8125V6.47917C3.89591 6.01893 4.26901 5.64583 4.72925 5.64583H8.89592C9.35615 5.64583 9.72925 5.27274 9.72925 4.8125C9.72925 4.35226 9.35615 3.97917 8.89592 3.97917Z\" fill=\"white\"/>   <path d=\"M16.3959 15.6458H13.8959C13.4357 15.6458 13.0626 16.0189 13.0626 16.4792C13.0626 16.9394 13.4357 17.3125 13.8959 17.3125H16.3959C17.7766 17.3125 18.8959 16.1932 18.8959 14.8125V6.47917C18.8959 5.09845 17.7766 3.97917 16.3959 3.97917H13.8959C13.4357 3.97917 13.0626 4.35226 13.0626 4.8125C13.0626 5.27274 13.4357 5.64583 13.8959 5.64583H16.3959C16.8562 5.64583 17.2292 6.01893 17.2292 6.47917V14.8125C17.2292 15.2727 16.8562 15.6458 16.3959 15.6458Z\" fill=\"white\"/>   <path d=\"M13.8959 7.3125C13.4357 7.3125 13.0626 7.6856 13.0626 8.14583C13.0626 8.60607 13.4357 8.97917 13.8959 8.97917H15.5626C16.0228 8.97917 16.3959 8.60607 16.3959 8.14583C16.3959 7.6856 16.0228 7.3125 15.5626 7.3125H13.8959Z\" fill=\"white\"/>   <path d=\"M13.0626 13.1458C13.0626 12.6856 13.4357 12.3125 13.8959 12.3125H15.5626C16.0228 12.3125 16.3959 12.6856 16.3959 13.1458C16.3959 13.6061 16.0228 13.9792 15.5626 13.9792H13.8959C13.4357 13.9792 13.0626 13.6061 13.0626 13.1458Z\" fill=\"white\"/>   <path d=\"M13.8959 9.8125C13.4357 9.8125 13.0626 10.1856 13.0626 10.6458C13.0626 11.1061 13.4357 11.4792 13.8959 11.4792H15.5626C16.0228 11.4792 16.3959 11.1061 16.3959 10.6458C16.3959 10.1856 16.0228 9.8125 15.5626 9.8125H13.8959Z\" fill=\"white\"/>   <path d=\"M8.9625 10.4661C9.22917 10.62 9.22917 11.005 8.9625 11.1589L6.4125 12.6312C6.14583 12.7851 5.8125 12.5927 5.8125 12.2847V9.34026C5.8125 9.03234 6.14583 8.83989 6.4125 8.99385L8.9625 10.4661Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36520:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M9 7h4a1 1 0 0 1 0 2H9v4a1 1 0 0 1-2 0V9H3a1 1 0 1 1 0-2h4V3a1 1 0 1 1 2 0v4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 14211:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"10","viewBox":"0 0 21 10"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill=\"#ED5454\" d=\"M3 0h1v10H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z\"/>         <path fill=\"#8BC34A\" d=\"M18 0h-1v10h1a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3z\"/>         <path fill=\"#FDA639\" d=\"M4 0h13v10H4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 49962:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"10","viewBox":"0 0 21 10"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <rect width=\"21\" height=\"10\" fill=\"#F5F5F5\" rx=\"3\"/>         <path fill=\"#8BC34A\" d=\"M3 0h13v10H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 54958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 2C2.89543 2 2 2.89543 2 4V6C2 7.10457 2.89543 8 4 8H20C21.1046 8 22 7.10457 22 6V4C22 2.89543 21.1046 2 20 2H4ZM8 4H20V6H8V4Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 11C2 9.89543 2.89543 9 4 9H20C21.1046 9 22 9.89543 22 11V13C22 14.1046 21.1046 15 20 15H4C2.89543 15 2 14.1046 2 13V11ZM20 11H12V13H20V11Z\" fill=\"black\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 18C2 16.8954 2.89543 16 4 16H20C21.1046 16 22 16.8954 22 18V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V18ZM16 18H20V20H16V18Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 38312:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M11.375 4.37437L10.5059 5.24354L8.75586 3.49354L9.62503 2.62437C9.87003 2.37937 10.185 2.2627 10.5 2.2627C10.815 2.2627 11.13 2.37937 11.375 2.62437C11.8592 3.10854 11.8592 3.8902 11.375 4.37437Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M10.0967 5.65788L3.79086 11.9579C3.30669 12.442 2.52503 12.442 2.04086 11.9579C1.55669 11.4737 1.55669 10.692 2.04086 10.2079L8.34672 3.90788L10.0967 5.65788Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M5.80511 2.04197L6.04427 1.23113C6.06761 1.1553 6.04427 1.07363 5.99177 1.0153C5.93927 0.956966 5.84594 0.933633 5.77011 0.956966L4.95928 1.19613L4.14845 0.956966C4.07261 0.933633 3.99095 0.956966 3.93261 1.00947C3.87428 1.0678 3.85678 1.14947 3.88011 1.2253L4.11345 2.04197L3.87428 2.8528C3.85095 2.92863 3.87428 3.0103 3.92678 3.06863C3.98511 3.12697 4.06678 3.14447 4.14261 3.12113L4.95928 2.8878L5.77011 3.12697C5.79345 3.1328 5.81095 3.13863 5.83427 3.13863C5.89261 3.13863 5.94511 3.1153 5.99177 3.07447C6.05011 3.01613 6.06761 2.93447 6.04427 2.85863L5.80511 2.04197Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M3.47113 5.54197L3.71029 4.73113C3.73363 4.65529 3.71029 4.57363 3.65779 4.5153C3.59946 4.45697 3.51779 4.43947 3.44196 4.4628L2.62529 4.69613L1.81446 4.45697C1.73862 4.43363 1.65696 4.45697 1.59863 4.50947C1.54029 4.5678 1.52279 4.64947 1.54613 4.7253L1.77946 5.54197L1.54029 6.35279C1.51696 6.42863 1.54029 6.51029 1.59279 6.56863C1.65113 6.62696 1.73279 6.64446 1.80862 6.62113L2.61946 6.38196L3.43029 6.62113C3.44779 6.62696 3.47113 6.62696 3.49446 6.62696C3.55279 6.62696 3.60529 6.60363 3.65196 6.56279C3.71029 6.50446 3.72779 6.42279 3.70446 6.34696L3.47113 5.54197Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12.2202 8.45834L12.4593 7.6475C12.4827 7.57167 12.4593 7.49 12.4068 7.43167C12.3485 7.37334 12.2668 7.35584 12.191 7.37917L11.3802 7.61834L10.5693 7.37917C10.4935 7.35584 10.4118 7.37917 10.3535 7.43167C10.2952 7.49 10.2777 7.57167 10.301 7.6475L10.5402 8.45834L10.301 9.26917C10.2777 9.34501 10.301 9.42667 10.3535 9.485C10.4118 9.54334 10.4935 9.56084 10.5693 9.5375L11.3802 9.29834L12.191 9.5375C12.2085 9.54334 12.2318 9.54334 12.2552 9.54334C12.3135 9.54334 12.366 9.52 12.4127 9.47917C12.471 9.42084 12.4885 9.33917 12.4652 9.26334L12.2202 8.45834Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 40286:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphics\" fill=\"#AEB7B8\" fill-rule=\"evenodd\" d=\"M13.333 8A5.333 5.333 0 1 1 2.667 8a5.333 5.333 0 0 1 10.666 0zm1.334 0A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0zM6.998 5.735a1.406 1.406 0 0 0-.331.932.667.667 0 0 1-1.334 0c0-.642.214-1.306.669-1.818C6.468 4.324 7.152 4 8 4c1.687 0 2.667 1.357 2.667 2.667 0 .417-.106.781-.372 1.116-.232.292-.565.532-.925.772-.472.314-.624.498-.673.58-.026.042-.03.05-.03.198a.667.667 0 0 1-1.334 0v-.01c0-.187 0-.507.22-.874.201-.335.549-.651 1.077-1.004.369-.246.535-.383.621-.491.052-.065.082-.125.082-.287 0-.69-.495-1.334-1.333-1.334-.486 0-.801.176-1.002.402zm1.669 5.598a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 67308:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7.608 13.954a9.589 9.589 0 0 1-1.255 1.265 7.536 7.536 0 0 1-1.765 1.118 1 1 0 1 0 .824 1.822 9.455 9.455 0 0 0 2.235-1.416C9.639 15.051 11 12.969 11 10a4 4 0 1 0-3.392 3.954zm8.745 1.265a9.589 9.589 0 0 0 1.255-1.265A4 4 0 1 1 21 10c0 2.969-1.361 5.051-3.353 6.743a9.455 9.455 0 0 1-2.235 1.416.999.999 0 1 1-.824-1.822 7.536 7.536 0 0 0 1.765-1.118z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 8507:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#00a1b7\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80764:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#AEB7B8\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 98763:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#e8e8e8\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 55009:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#ed5454\" d=\"M4 12V3a1 1 0 0 1 1-1h4c1.264 0 2.233.641 2.942 1.11l.084.055C12.814 3.685 13.342 4 14 4c.745 0 1.811-.398 2.803-.894a18.198 18.198 0 0 0 1.617-.921l.021-.014.005-.003A.998.998 0 0 1 20 3v9a1 1 0 0 1-.445.832L19 12l.555.832-.005.003-.008.006-.03.019-.108.07a20.529 20.529 0 0 1-1.707.964C16.689 14.398 15.255 15 14 15c-1.301 0-2.315-.645-3.062-1.121l-.055-.035C10.05 13.314 9.517 13 8.889 13H6v8a1 1 0 0 1-2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71138:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#00a1b7\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 85625:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#AEB7B8\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 16030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#e8e8e8\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61335:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#ed5454\" fill-rule=\"evenodd\" d=\"M12 5.683C10.842 4.777 9.185 4 7.5 4 4.724 4 2 6.296 2 9.688c0 1.52.245 2.73.773 3.83.52 1.084 1.285 1.996 2.206 2.956 1.036 1.08 2.713 2.192 4.056 3.004a47.811 47.811 0 0 0 2.454 1.383l.04.021.01.006.005.002L12 20l-.456.89c.286.146.626.147.912 0L12 20l.456.89.004-.002.011-.006.04-.02.15-.079c.128-.068.313-.166.54-.29.453-.248 1.078-.6 1.764-1.015 1.343-.812 3.02-1.925 4.056-3.004.921-.96 1.685-1.872 2.206-2.955.528-1.101.773-2.31.773-3.832C22 6.297 19.276 4 16.5 4c-1.685 0-3.342.777-4.5 1.683z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 37322:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#00a1b7\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 75851:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#AEB7B8\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4735:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#e8e8e8\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 76936:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<path fill=\"#fda639\" fill-rule=\"evenodd\" d=\"M10.548 3.807c.467-1.343 2.367-1.343 2.834 0l1.65 4.748 5.026.103c1.422.029 2.009 1.836.875 2.695l-4.005 3.037 1.455 4.81c.412 1.362-1.125 2.479-2.292 1.666l-4.126-2.87-4.126 2.87c-1.167.813-2.704-.304-2.293-1.665l1.456-4.811-4.006-3.037c-1.133-.86-.546-2.666.876-2.695l5.026-.103 1.65-4.748z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 14698:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0002 32C24.8368 32 32.0002 24.8366 32.0002 16C32.0002 7.16344 24.8368 0 16.0002 0C7.16369 0 0.000244141 7.16344 0.000244141 16C0.000244141 24.8366 7.16369 32 16.0002 32Z\" fill=\"#00A1B7\"/> <rect x=\"11.0002\" y=\"11\" width=\"10\" height=\"10\" rx=\"5\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 20065:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.58963 3.36764C4.85564 3.10011 5.28727 3.10011 5.55328 3.36764C5.81876 3.63464 5.81876 4.06716 5.55328 4.33416L4.65667 5.23596H10.5572C12.8277 5.23596 14.6667 7.0869 14.6667 9.36814C14.6667 11.6494 12.8277 13.5003 10.5572 13.5003H5.75717C5.3802 13.5003 5.07622 13.1932 5.07622 12.8164C5.07622 12.4396 5.3802 12.1325 5.75717 12.1325H10.5572C12.0737 12.1325 13.3048 10.8958 13.3048 9.36814C13.3048 7.84052 12.0737 6.60377 10.5572 6.60377H4.65667L5.55328 7.50557C5.81876 7.77258 5.81876 8.20506 5.55328 8.47207C5.28727 8.73961 4.85564 8.73961 4.58963 8.47207L2.53249 6.40312C2.267 6.13612 2.267 5.70361 2.53249 5.43661L4.58963 3.36764Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88170:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z\" fill=\"#00A1B7\"/> <path d=\"M15.3333 9.33337C14.2288 9.33337 13.3333 10.2288 13.3333 11.3334V12H11.3333C10.9651 12 10.6667 12.2985 10.6667 12.6667C10.6667 13.0349 10.9651 13.3334 11.3333 13.3334V20.6667C11.3333 21.7713 12.2288 22.6667 13.3333 22.6667H18.6667C19.7712 22.6667 20.6667 21.7713 20.6667 20.6667V13.3334C21.0348 13.3334 21.3333 13.0349 21.3333 12.6667C21.3333 12.2985 21.0348 12 20.6667 12H18.6667V11.3334C18.6667 10.2288 17.7712 9.33337 16.6667 9.33337H15.3333ZM17.3333 12H14.6667V11.3334C14.6667 10.9652 14.9651 10.6667 15.3333 10.6667H16.6667C17.0348 10.6667 17.3333 10.9652 17.3333 11.3334V12ZM12.6667 13.3334L19.3333 13.3334V20.6667C19.3333 21.0349 19.0348 21.3334 18.6667 21.3334H13.3333C12.9651 21.3334 12.6667 21.0349 12.6667 20.6667V13.3334ZM15.3333 15.3334V19.3334C15.3333 19.7016 15.0348 20 14.6667 20C14.2985 20 14 19.7016 14 19.3334V15.3334C14 14.9652 14.2985 14.6667 14.6667 14.6667C15.0348 14.6667 15.3333 14.9652 15.3333 15.3334ZM17.3333 14.6667C16.9651 14.6667 16.6667 14.9652 16.6667 15.3334V19.3334C16.6667 19.7016 16.9651 20 17.3333 20C17.7015 20 18 19.7016 18 19.3334V15.3334C18 14.9652 17.7015 14.6667 17.3333 14.6667Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 36039:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4.66683 4C4.29864 4 4.00016 4.29848 4.00016 4.66667C4.00016 5.03486 4.29864 5.33333 4.66683 5.33333H9.3335C10.5761 5.33333 11.6201 6.18318 11.9162 7.33333H11.0819C10.728 7.33333 10.537 7.7762 10.7674 8.06287L12.1007 9.72221C12.3983 10.0926 12.9354 10.0926 13.233 9.72221L14.5663 8.06287C14.7966 7.7762 14.6057 7.33333 14.2518 7.33333H13.2782C12.9608 5.44152 11.3155 4 9.3335 4H4.66683Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12.0002 11.3333C12.0002 11.7015 11.7017 12 11.3335 12H6.66683C4.68483 12 3.03952 10.5585 2.72213 8.66667H1.74857C1.39463 8.66667 1.20369 8.2238 1.43403 7.93713L2.76732 6.27779C3.06493 5.9074 3.60207 5.9074 3.89967 6.27779L5.23296 7.93713C5.4633 8.2238 5.27236 8.66667 4.91842 8.66667H4.08417C4.3802 9.81682 5.42427 10.6667 6.66683 10.6667H11.3335C11.7017 10.6667 12.0002 10.9651 12.0002 11.3333Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 91323:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M12 6v6H6zM4 4h6l-6 6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61762:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164Z\" fill=\"#00A1B7\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#00A1B7\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 33C19.5 37.9706 15.4706 42 10.5 42C5.52944 42 1.5 37.9706 1.5 33C1.5 28.0294 5.52944 24 10.5 24C15.4706 24 19.5 28.0294 19.5 33ZM12.8625 30.6375C12.8625 31.9423 11.8048 33 10.5 33C9.19523 33 8.1375 31.9423 8.1375 30.6375C8.1375 29.3327 9.19523 28.275 10.5 28.275C11.8048 28.275 12.8625 29.3327 12.8625 30.6375ZM13.8718 37.0538C14.3662 36.8479 14.5539 36.2508 14.224 35.829C13.3592 34.7233 12.0126 34.0125 10.5 34.0125C8.98738 34.0125 7.64079 34.7233 6.77596 35.829C6.44606 36.2508 6.6338 36.8479 7.12812 37.0538C8.16623 37.4862 9.30522 37.725 10.5 37.725C11.6947 37.725 12.8337 37.4862 13.8718 37.0538Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80562:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164Z\" fill=\"#A5B3BD\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#A5B3BD\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 33C19.5 37.9706 15.4706 42 10.5 42C5.52944 42 1.5 37.9706 1.5 33C1.5 28.0294 5.52944 24 10.5 24C15.4706 24 19.5 28.0294 19.5 33ZM12.8625 30.6375C12.8625 31.9423 11.8048 33 10.5 33C9.19523 33 8.1375 31.9423 8.1375 30.6375C8.1375 29.3327 9.19523 28.275 10.5 28.275C11.8048 28.275 12.8625 29.3327 12.8625 30.6375ZM13.8718 37.0538C14.3662 36.8479 14.5539 36.2508 14.224 35.829C13.3592 34.7233 12.0126 34.0125 10.5 34.0125C8.98738 34.0125 7.64079 34.7233 6.77596 35.829C6.44606 36.2508 6.6338 36.8479 7.12812 37.0538C8.16623 37.4862 9.30522 37.725 10.5 37.725C11.6947 37.725 12.8337 37.4862 13.8718 37.0538Z\" fill=\"#A5B3BD\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77142:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#00A1B7\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 30315:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"47","height":"46","viewBox":"0 0 47 46","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.1583 11.3914C44.1583 9.56889 42.6808 8.09143 40.8583 8.09143H33.275C32.557 8.09143 31.975 8.67346 31.975 9.39143C31.975 10.1094 32.557 10.6914 33.275 10.6914H40.8583C41.2449 10.6914 41.5583 11.0048 41.5583 11.3914V16.0998C41.5583 16.8177 42.1403 17.3998 42.8583 17.3998C43.5763 17.3998 44.1583 16.8177 44.1583 16.0998V11.3914ZM15.4083 9.39143C15.4083 8.67346 14.8263 8.09143 14.1083 8.09143H6.52497C4.70243 8.09143 3.22498 9.56889 3.22498 11.3914V16.0998C3.22498 16.8177 3.807 17.3998 4.52497 17.3998C5.24295 17.3998 5.82497 16.8177 5.82497 16.0998V11.3914C5.82497 11.0048 6.13837 10.6914 6.52497 10.6914H14.1083C14.8263 10.6914 15.4083 10.1094 15.4083 9.39143ZM42.8583 28.2164C42.1403 28.2164 41.5583 28.7985 41.5583 29.5164V34.2248C41.5583 34.6114 41.2449 34.9248 40.8583 34.9248H33.275C32.557 34.9248 31.975 35.5068 31.975 36.2248C31.975 36.9427 32.557 37.5248 33.275 37.5248H40.8583C42.6808 37.5248 44.1583 36.0473 44.1583 34.2248V29.5164C44.1583 28.7985 43.5763 28.2164 42.8583 28.2164ZM4.52497 28.2164C3.807 28.2164 3.22498 28.7985 3.22498 29.5164V34.2248C3.22498 36.0473 4.70243 37.5248 6.52497 37.5248H14.1083C14.8263 37.5248 15.4083 36.9427 15.4083 36.2248C15.4083 35.5068 14.8263 34.9248 14.1083 34.9248H6.52497C6.13838 34.9248 5.82497 34.6114 5.82497 34.2248V29.5164C5.82497 28.7985 5.24295 28.2164 4.52497 28.2164Z\" fill=\"#A5B3BD\"/> <path d=\"M29.5833 23C29.5833 21.8 28.1274 21.0236 25.2157 19.4706C22.5888 18.0696 21.2753 17.3691 20.3043 17.9517L20.3043 17.9517C19.3333 18.5343 19.3333 20.0229 19.3333 23C19.3333 25.9772 19.3333 27.4658 20.3043 28.0484C21.2753 28.631 22.5888 27.9305 25.2157 26.5295C28.1274 24.9765 29.5833 24.2 29.5833 23Z\" fill=\"#A5B3BD\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26350:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <circle cx=\"9.5\" cy=\"6.5\" r=\"5\" stroke=\"#5C6061\"/>         <path class=\"graphic\" stroke=\"#5C6061\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"M5 11l-2.5 2.5\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 31665:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M10.667 3.333a1.333 1.333 0 1 0 0 2.667 1.333 1.333 0 0 0 0-2.667zM8 4.667a2.667 2.667 0 1 1 .487 1.537l-1.356.775c.13.314.202.659.202 1.021 0 .362-.072.707-.202 1.021l1.356.775a2.667 2.667 0 1 1-.474 1.265l-1.694-.968a2.667 2.667 0 1 1 0-4.187l1.695-.967A2.712 2.712 0 0 1 8 4.667zm-3.333 2a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666zm4.666 4.666a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 71571:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"17","viewBox":"0 0 19 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M6 0C6.55228 0 7 0.447715 7 1V7H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V9H7V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V1C5 0.447715 5.44772 0 6 0Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M16.4592 11C16.3183 11 16.1852 11.0647 16.0981 11.1755C16.0819 11.1962 16.0697 11.2148 16.0612 11.23C16.0942 11.3176 16.134 11.3773 16.1718 11.4124C16.1919 11.4311 16.2178 11.4492 16.2583 11.4646C16.2998 11.4803 16.3751 11.5 16.5 11.5C17.1025 11.5 17.6161 11.654 18.0266 11.942C18.4313 12.2259 18.6665 12.5912 18.8005 12.904C19.1429 13.7037 18.7843 14.4426 18.5198 14.8273C17.5437 16.2471 15.5124 16.4183 14.3124 15.1819L14.2824 15.151C13.8978 14.7547 13.9072 14.1216 14.3035 13.737C14.6998 13.3523 15.3329 13.3618 15.7176 13.7581L15.7476 13.789C16.0682 14.1193 16.6109 14.0736 16.8717 13.6942C16.8916 13.6653 16.907 13.6392 16.9184 13.6169C16.9059 13.6016 16.8924 13.5894 16.878 13.5793C16.8514 13.5606 16.7533 13.5 16.5 13.5C15.7988 13.5 15.2293 13.2667 14.8105 12.8776C14.4138 12.5091 14.2197 12.0641 14.1223 11.7345C13.9022 10.9897 14.2163 10.3334 14.5255 9.93987C14.9917 9.34648 15.7046 9 16.4592 9H16.5432C16.8963 9 17.2459 9.07108 17.571 9.20902L18.0156 9.3976C18.524 9.61329 18.7613 10.2003 18.5456 10.7087C18.3299 11.2172 17.7429 11.4545 17.2344 11.2388L16.7899 11.0502C16.7119 11.0171 16.628 11 16.5432 11H16.4592Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.31204 9.6109C2.15191 9.81056 1.84807 9.81056 1.68794 9.6109L0.11556 7.65025C-0.0944184 7.38842 0.0919813 7 0.427607 7H3.57237C3.908 7 4.0944 7.38842 3.88442 7.65025L2.31204 9.6109Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 37620:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#AEB7B8\" d=\"M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0 1A6 6 0 1 1 8 2a6 6 0 0 1 0 12zM6 9h4c0 1.333-.667 2-2 2s-2-.667-2-2zm4-1c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8zM6 8c-.552 0-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5S6.552 8 6 8z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 17884:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphic\" fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M2.667 3.333a.667.667 0 0 0 0 1.334H8a.667.667 0 1 0 0-1.334H2.667zM2 8c0-.368.298-.667.667-.667h8a.667.667 0 1 1 0 1.334h-8A.667.667 0 0 1 2 8zm0 4c0-.368.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.334H2.667A.667.667 0 0 1 2 12z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 59681:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<path class=\"graphic\" fill=\"#FFF\" fill-rule=\"evenodd\" d=\"M2 4c0-.368.298-.667.667-.667h10.666a.667.667 0 1 1 0 1.334H2.667A.667.667 0 0 1 2 4zm0 4c0-.368.298-.667.667-.667h8a.667.667 0 1 1 0 1.334h-8A.667.667 0 0 1 2 8zm.667 3.333a.667.667 0 1 0 0 1.334H8a.667.667 0 1 0 0-1.334H2.667z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 24570:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"19","height":"14","viewBox":"0 0 19 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" d=\"M1.13867 8.89784C0.437787 7.7297 0.437786 6.27037 1.13867 5.10223C1.36726 4.72125 1.75537 4.46355 2.19521 4.40072L4.5262 4.06772C4.82768 4.02465 5.09654 3.85521 5.26546 3.60182L5.63256 3.05118C5.9233 2.61507 6.06869 2.39699 6.23034 2.20094C6.80071 1.50925 7.54656 0.983633 8.38979 0.679139C8.62879 0.592836 8.88304 0.529272 9.39155 0.402145L10.0046 0.248883C10.3447 0.163862 10.5147 0.121352 10.6486 0.163014C10.7648 0.199186 10.8638 0.276507 10.9271 0.38048C11 0.500235 11 0.675509 11 1.02606V12.974C11 13.3246 11 13.4998 10.9271 13.6196C10.8638 13.7236 10.7648 13.8009 10.6486 13.8371C10.5147 13.8787 10.3447 13.8362 10.0046 13.7512L9.39155 13.5979C8.88304 13.4708 8.62879 13.4072 8.38979 13.3209C7.54656 13.0164 6.80071 12.4908 6.23034 11.7991C6.06868 11.6031 5.92331 11.385 5.63256 10.9489L5.26546 10.3983C5.09654 10.1449 4.82768 9.97542 4.5262 9.93235L2.19521 9.59935C1.75537 9.53652 1.36726 9.27883 1.13867 8.89784Z\" fill=\"#00A1B7\"/> <path class=\"player\" d=\"M18.7071 4.29293C19.0976 4.68345 19.0976 5.31662 18.7071 5.70714L17.4142 7.00004L18.7071 8.29293C19.0976 8.68345 19.0976 9.31662 18.7071 9.70714C18.3166 10.0977 17.6834 10.0977 17.2929 9.70714L16 8.41425L14.7071 9.70714C14.3166 10.0977 13.6834 10.0977 13.2929 9.70714C12.9024 9.31662 12.9024 8.68345 13.2929 8.29293L14.5858 7.00004L13.2929 5.70714C12.9024 5.31662 12.9024 4.68345 13.2929 4.29293C13.6834 3.90241 14.3166 3.90241 14.7071 4.29293L16 5.58582L17.2929 4.29293C17.6834 3.90241 18.3166 3.90241 18.7071 4.29293Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10653:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"player\" d=\"M1.13867 8.89784C0.437787 7.7297 0.437786 6.27037 1.13867 5.10223C1.36726 4.72125 1.75537 4.46355 2.19521 4.40072L4.5262 4.06772C4.82768 4.02465 5.09654 3.85521 5.26546 3.60182L5.63256 3.05118C5.92331 2.61505 6.06868 2.39699 6.23034 2.20094C6.80071 1.50925 7.54656 0.983633 8.38979 0.679139C8.62879 0.592835 8.88304 0.529272 9.39155 0.402145L10.0046 0.248883C10.3447 0.163862 10.5147 0.121352 10.6486 0.163014C10.7648 0.199186 10.8638 0.276507 10.9271 0.38048C11 0.500235 11 0.675509 11 1.02606V12.974C11 13.3246 11 13.4998 10.9271 13.6196C10.8638 13.7236 10.7648 13.8009 10.6486 13.8371C10.5147 13.8787 10.3447 13.8362 10.0046 13.7512L9.39155 13.5979C8.88304 13.4708 8.62879 13.4072 8.38979 13.3209C7.54656 13.0164 6.80071 12.4908 6.23034 11.7991C6.06868 11.6031 5.92331 11.385 5.63256 10.9489L5.26546 10.3983C5.09654 10.1449 4.82768 9.97542 4.5262 9.93235L2.19521 9.59935C1.75537 9.53652 1.36726 9.27883 1.13867 8.89784Z\" fill=\"#00A1B7\"/> <path class=\"player\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.0052 2.93417C13.2981 2.64128 13.773 2.64128 14.0658 2.93417C15.1386 4.00696 15.744 5.46025 15.7499 6.97738C15.7559 8.49452 15.1621 9.95254 14.0978 11.0337C13.8072 11.3289 13.3323 11.3327 13.0371 11.0421C12.7419 10.7515 12.7382 10.2767 13.0288 9.98147C13.8154 9.18232 14.2544 8.10465 14.25 6.98329C14.2455 5.86193 13.7981 4.78776 13.0052 3.99483C12.7123 3.70194 12.7123 3.22707 13.0052 2.93417Z\" fill=\"#00A1B7\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 42941:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M8.81935 3.19213C9.20847 2.07268 10.7916 2.07267 11.1808 3.19213L12.5561 7.14875L16.7441 7.2341C17.929 7.25824 18.4182 8.76392 17.4738 9.47993L14.1358 12.0106L15.3488 16.02C15.692 17.1543 14.4112 18.0849 13.4384 17.408L10.0001 15.0154L6.56175 17.408C5.58895 18.0849 4.30813 17.1544 4.65132 16.02L5.86431 12.0106L2.52634 9.47993C1.58192 8.76393 2.07114 7.25824 3.25605 7.2341L7.44402 7.14875L8.81935 3.19213ZM10.0001 4.87159L8.9231 7.96984C8.75144 8.46368 8.29058 8.79851 7.76786 8.80917L4.48845 8.876L7.10227 10.8577C7.51889 11.1735 7.69493 11.7153 7.54353 12.2157L6.5937 15.3553L9.28608 13.4817C9.71522 13.1831 10.2849 13.1831 10.714 13.4817L13.4064 15.3553L12.4566 12.2157C12.3052 11.7153 12.4812 11.1735 12.8978 10.8577L15.5116 8.876L12.2322 8.80917C11.7095 8.79851 11.2487 8.46368 11.077 7.96984L10.0001 4.87159Z\" fill=\"black\" fill-opacity=\"0.54\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 57551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.10057 3.88063C3.22336 3.98697 3.22336 4.17746 3.10057 4.2838L1.77458 5.43214C1.60187 5.58171 1.33334 5.45903 1.33334 5.23056V2.93387C1.33334 2.7054 1.60187 2.58272 1.77458 2.73229L3.10057 3.88063ZM6.66667 3.41555C6.29848 3.41555 6 3.71402 6 4.08221C6 4.4504 6.29848 4.74888 6.66667 4.74888H14C14.3682 4.74888 14.6667 4.4504 14.6667 4.08221C14.6667 3.71402 14.3682 3.41555 14 3.41555H6.66667ZM6.66667 7.41555C6.29848 7.41555 6 7.71402 6 8.08221C6 8.4504 6.29848 8.74888 6.66667 8.74888H14C14.3682 8.74888 14.6667 8.4504 14.6667 8.08221C14.6667 7.71402 14.3682 7.41555 14 7.41555H6.66667ZM6 12.0822C6 11.714 6.29848 11.4155 6.66667 11.4155H14C14.3682 11.4155 14.6667 11.714 14.6667 12.0822C14.6667 12.4504 14.3682 12.7489 14 12.7489H6.66667C6.29848 12.7489 6 12.4504 6 12.0822Z\" fill=\"#737373\"/>   <path class=\"graphic\" d=\"M5 2.66669C5.18409 2.66669 5.33333 2.81593 5.33333 3.00002V5.00002C5.33333 5.18412 5.18409 5.33335 5 5.33335C4.81591 5.33335 4.66667 5.18412 4.66667 5.00002V3.80476L4.56904 3.90239C4.43886 4.03256 4.22781 4.03256 4.09763 3.90239C3.96746 3.77221 3.96746 3.56116 4.09763 3.43098L4.7643 2.76432C4.82462 2.704 4.90795 2.66669 5 2.66669Z\" fill=\"#737373\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 14345:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.0002 32C24.8368 32 32.0002 24.8366 32.0002 16C32.0002 7.16344 24.8368 0 16.0002 0C7.16369 0 0.000244141 7.16344 0.000244141 16C0.000244141 24.8366 7.16369 32 16.0002 32Z\" fill=\"#00A1B7\"/> <rect x=\"11.0002\" y=\"11\" width=\"10\" height=\"10\" rx=\"1\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 27501:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12.073 4.245c-2.44 0-4.145 1.665-4.145 3.409 0 .866.421 1.713 1.144 2.346H6.526a4.867 4.867 0 0 1-.598-2.346c0-3.127 2.902-5.409 6.145-5.409 2.685 0 5.082 1.533 5.877 3.821a1 1 0 0 1-1.889.656c-.471-1.355-2.011-2.477-3.988-2.477zm-.345 8.809a.955.955 0 0 0 .132.008c2.44 0 4.145 1.666 4.145 3.409 0 1.744-1.705 3.409-4.145 3.409-1.164 0-2.196-.395-2.936-1.007a3.354 3.354 0 0 1-1.052-1.47 1 1 0 1 0-1.889.656 5.36 5.36 0 0 0 1.666 2.355c1.112.92 2.599 1.466 4.211 1.466 3.243 0 6.145-2.282 6.145-5.409 0-1.354-.544-2.55-1.426-3.471H19a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2h6.146c.192.026.386.044.582.054z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 62428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4.00004 6C4.00004 3.79086 5.7909 2 8.00004 2C10.2092 2 12 3.79086 12 6V6.66667C12.7364 6.66667 13.3334 7.26362 13.3334 8V9.33333C13.3334 9.84269 13.0478 10.2853 12.628 10.5099C12.3825 12.1088 11.001 13.3333 9.33337 13.3333H9.155C8.92446 13.7319 8.49356 14 8.00004 14C7.26366 14 6.66671 13.403 6.66671 12.6667C6.66671 11.9303 7.26366 11.3333 8.00004 11.3333C8.49356 11.3333 8.92446 11.6015 9.155 12H9.33337C10.2076 12 10.9508 11.4391 11.2228 10.6575C10.9072 10.6048 10.6667 10.3305 10.6667 10V6C10.6667 4.52724 9.4728 3.33333 8.00004 3.33333C6.52728 3.33333 5.33337 4.52724 5.33337 6V10C5.33337 10.3682 5.0349 10.6667 4.66671 10.6667H4.00004C3.26366 10.6667 2.66671 10.0697 2.66671 9.33333V8C2.66671 7.26362 3.26366 6.66667 4.00004 6.66667V6Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 82481:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.68824 3.06668C5.51046 3.20002 5.51046 3.46668 5.68824 3.60002L7.46602 4.93335C7.68576 5.09816 7.99935 4.94136 7.99935 4.66668V4.00002C10.2085 4.00002 11.9993 5.79088 11.9993 8.00002C11.9993 8.75518 11.7907 9.45958 11.4283 10.061C11.2383 10.3764 11.3399 10.7861 11.6553 10.9761C11.9706 11.1661 12.3803 11.0645 12.5704 10.7491C13.0544 9.94584 13.3327 9.00441 13.3327 8.00002C13.3327 5.0545 10.9449 2.66668 7.99935 2.66668V2.00002C7.99935 1.72533 7.68576 1.56854 7.46602 1.73335L5.68824 3.06668ZM4.29082 5.08961C4.60952 5.27397 4.71843 5.68179 4.53407 6.0005C4.19412 6.58817 3.99935 7.27033 3.99935 8.00002C3.99935 10.2092 5.79021 12 7.99935 12V11.3333C7.99935 11.0587 8.31294 10.9019 8.53268 11.0667L10.3105 12.4C10.4882 12.5333 10.4882 12.8 10.3105 12.9333L8.53268 14.2667C8.31294 14.4315 7.99935 14.2747 7.99935 14V13.3333C5.05383 13.3333 2.66602 10.9455 2.66602 8.00002C2.66602 7.02969 2.92575 6.11801 3.37993 5.33286C3.56429 5.01416 3.97211 4.90525 4.29082 5.08961Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 18294:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.97429 3.51649C10.0754 3.16247 9.87045 2.79348 9.51642 2.69233C9.1624 2.59118 8.79341 2.79617 8.69226 3.15019L6.02559 12.4835C5.92444 12.8376 6.12944 13.2065 6.48346 13.3077C6.83749 13.4088 7.20648 13.2038 7.30763 12.8498L9.97429 3.51649ZM5.08307 4.1461C5.37058 4.3761 5.4172 4.79563 5.18719 5.08314L2.85369 8.00001L5.18719 10.9169C5.4172 11.2044 5.37058 11.6239 5.08307 11.8539C4.79557 12.0839 4.37604 12.0373 4.14603 11.7498L1.48772 8.42691C1.45077 8.38268 1.42032 8.33449 1.3965 8.28373C1.354 8.19355 1.33319 8.09656 1.33325 8.00001C1.33319 7.90346 1.354 7.80647 1.39649 7.71629C1.42031 7.66553 1.45077 7.61734 1.48772 7.57311L4.14603 4.25021C4.37604 3.9627 4.79556 3.91609 5.08307 4.1461ZM10.9168 4.1461C11.2043 3.91609 11.6238 3.9627 11.8539 4.25021L14.5123 7.57322C14.5485 7.61657 14.5784 7.66372 14.602 7.71337C14.6454 7.80438 14.6667 7.90242 14.6666 8.00001C14.6667 8.0976 14.6454 8.19564 14.602 8.28665C14.5784 8.33629 14.5485 8.38344 14.5123 8.42679L11.8539 11.7498C11.6238 12.0373 11.2043 12.0839 10.9168 11.8539C10.6293 11.6239 10.5827 11.2044 10.8127 10.9169L13.1462 8.00001L10.8127 5.08314C10.5827 4.79563 10.6293 4.3761 10.9168 4.1461Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 20913:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7zm3-1a1 1 0 0 0-1 1v4h7V6H5zm6 7H4v4a1 1 0 0 0 1 1h6v-5zm2 0h7v4a1 1 0 0 1-1 1h-6v-5zm7-2V7a1 1 0 0 0-1-1h-6v5h7z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 12216:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5zm0 2h4v4H5V5zm0 8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5zm0 2h4v4H5v-4zm8-6a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1zm1-5a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-6zm-1 11a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1zm1 3a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 64268:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H7.5C8.42047 2.5 9.16667 3.24619 9.16667 4.16667V7.5C9.16667 8.42047 8.42047 9.16667 7.5 9.16667H4.16667C3.24619 9.16667 2.5 8.42047 2.5 7.5V4.16667ZM7.5 4.16667H4.16667V7.5H7.5V4.16667Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M2.5 12.5C2.5 11.5795 3.24619 10.8333 4.16667 10.8333H7.5C8.42047 10.8333 9.16667 11.5795 9.16667 12.5V15.8333C9.16667 16.7538 8.42047 17.5 7.5 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V12.5ZM7.5 12.5H4.16667V15.8333H7.5V12.5Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M12.5 2.5C11.5795 2.5 10.8333 3.24619 10.8333 4.16667V15.8333C10.8333 16.7538 11.5795 17.5 12.5 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5H12.5ZM12.5 4.16667H15.8333V15.8333H12.5V4.16667Z\" fill=\"black\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 62171:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"31","height":"35","viewBox":"0 0 31 35","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 23.9C0 23.4029 0.402944 23 0.9 23H26.9272C27.4242 23 27.8272 23.4029 27.8272 23.9V24.2C27.8272 24.6971 27.4242 25.1 26.9272 25.1H0.9C0.402943 25.1 0 24.6971 0 24.2V23.9ZM0 28.4C0 27.9029 0.402944 27.5 0.9 27.5H26.9272C27.4242 27.5 27.8272 27.9029 27.8272 28.4V28.7C27.8272 29.1971 27.4242 29.6 26.9272 29.6H0.9C0.402943 29.6 0 29.1971 0 28.7V28.4ZM0.9 32C0.402944 32 0 32.4029 0 32.9V33.2C0 33.6971 0.402944 34.1 0.900001 34.1H19.063C19.56 34.1 19.963 33.6971 19.963 33.2V32.9C19.963 32.4029 19.56 32 19.063 32H0.9Z\" fill=\"#E8E8E8\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z\" fill=\"#E8E8E8\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.3152 4.88556L16.9452 16.0355L30.9733 7.36356L19.3152 4.88556Z\" fill=\"#E8E8E8\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 76094:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.65527 10V2.71289H8.30225V0.840332H0.691406V2.71289H3.33203V10H5.65527Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 88536:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h16v16H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3.333 2C2.597 2 2 2.597 2 3.333V6c0 .736.597 1.333 1.333 1.333H6c.737 0 1.333-.597 1.333-1.333V3.333C7.333 2.597 6.737 2 6 2H3.333zm0 1.333H6V6H3.333V3.333zm0 5.334C2.597 8.667 2 9.264 2 10v2.667C2 13.403 2.597 14 3.333 14H6c.737 0 1.333-.597 1.333-1.333V10c0-.736-.596-1.333-1.333-1.333H3.333zm0 1.333H6v2.667H3.333V10zm5.334-4c0-.368.298-.667.666-.667h4a.667.667 0 0 1 0 1.334h-4A.667.667 0 0 1 8.667 6zm.666-3.333a.667.667 0 0 0 0 1.333h4a.667.667 0 0 0 0-1.333h-4zM8.667 10c0-.368.298-.667.666-.667h4a.667.667 0 0 1 0 1.334h-4A.667.667 0 0 1 8.667 10zm.666 2a.667.667 0 0 0 0 1.333h4a.667.667 0 0 0 0-1.333h-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 33277:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.195287 0.195262C0.455636 -0.0650874 0.877746 -0.0650874 1.1381 0.195262L2.46574 1.52291C2.51433 1.57023 2.55433 1.62356 2.58549 1.68078C2.6819 1.85741 2.69246 2.06845 2.61717 2.25261C2.59251 2.31292 2.55865 2.37035 2.51558 2.42275L1.18727 4.08313C0.957264 4.37064 0.537736 4.41725 0.250228 4.18725C-0.0372801 3.95724 -0.0838944 3.53771 0.146112 3.2502L1.10669 2.04948L0.195287 1.13807C-0.0650629 0.877722 -0.0650629 0.455612 0.195287 0.195262ZM4.00002 2C4.00002 1.63181 4.2985 1.33333 4.66669 1.33333H11.3334C11.7015 1.33333 12 1.63181 12 2C12 2.36819 11.7015 2.66667 11.3334 2.66667H4.66669C4.2985 2.66667 4.00002 2.36819 4.00002 2ZM4.00002 6C4.00002 5.63181 4.2985 5.33333 4.66669 5.33333H11.3334C11.7015 5.33333 12 5.63181 12 6C12 6.36819 11.7015 6.66667 11.3334 6.66667H4.66669C4.2985 6.66667 4.00002 6.36819 4.00002 6ZM4.66669 9.33333C4.2985 9.33333 4.00002 9.63181 4.00002 10C4.00002 10.3682 4.2985 10.6667 4.66669 10.6667H11.3334C11.7015 10.6667 12 10.3682 12 10C12 9.63181 11.7015 9.33333 11.3334 9.33333H4.66669Z\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 60302:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g clip-path=\"url(#clip0_304_117572)\">   <path class=\"graphic\" d=\"M4.18988 0.418762C3.95588 -0.140238 3.04388 -0.140238 2.80888 0.418762L0.0598756 6.95176C-0.102124 7.33476 0.0758756 7.77776 0.457876 7.93976C0.835876 8.10176 1.27888 7.92276 1.43988 7.53876L2.08888 5.99976H4.91188L5.55988 7.53876C5.68088 7.82676 5.95788 7.99876 6.24988 7.99876C6.34788 7.99876 6.44688 7.97976 6.54187 7.93976C6.92387 7.77776 7.10188 7.33476 6.93988 6.95176L4.18988 0.418762ZM2.71988 4.49976L3.49988 2.64676L4.27988 4.49976H2.71988Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M9.75 3.5C11.267 3.5 12.5 4.733 12.5 6.25C12.5 6.664 12.836 7 13.25 7C13.664 7 14 6.664 14 6.25C14 3.907 12.094 2 9.75 2C9.336 2 9 2.336 9 2.75C9 3.164 9.336 3.5 9.75 3.5Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M6.25 12.5C4.733 12.5 3.5 11.267 3.5 9.75C3.5 9.336 3.164 9 2.75 9C2.336 9 2 9.336 2 9.75C2 12.093 3.906 14 6.25 14C6.664 14 7 13.664 7 13.25C7 12.836 6.664 12.5 6.25 12.5Z\" fill=\"black\"/>   <path class=\"graphic\" d=\"M15.5207 14.551L14.0487 13.979C13.9227 13.93 13.8067 13.867 13.6887 13.807C14.3577 13.021 14.8017 12.056 14.9437 11H15.2497C15.6637 11 15.9997 10.664 15.9997 10.25C15.9997 9.836 15.6637 9.5 15.2497 9.5H13.2497V8.75C13.2497 8.336 12.9137 8 12.4997 8C12.0857 8 11.7497 8.336 11.7497 8.75V9.5H9.74966C9.33566 9.5 8.99966 9.836 8.99966 10.25C8.99966 10.664 9.33566 11 9.74966 11H10.0557C10.1977 12.056 10.6417 13.02 11.3107 13.807C11.1927 13.867 11.0767 13.93 10.9507 13.979L9.47866 14.551C9.09166 14.701 8.90066 15.136 9.05066 15.522C9.16666 15.818 9.45066 16 9.75066 16C9.84166 16 9.93366 15.984 10.0217 15.949L11.4937 15.377C11.8547 15.237 12.1847 15.051 12.4997 14.847C12.8147 15.051 13.1447 15.236 13.5057 15.377L14.9777 15.949C15.0667 15.984 15.1587 16 15.2487 16C15.5487 16 15.8327 15.818 15.9477 15.522C16.0987 15.136 15.9077 14.701 15.5207 14.551ZM13.4227 11C13.2887 11.713 12.9687 12.364 12.4997 12.895C12.0297 12.364 11.7107 11.713 11.5767 11H13.4227Z\" fill=\"black\"/>   </g>   <defs>   <clipPath id=\"clip0_304_117572\">   <rect width=\"16\" height=\"16\" fill=\"white\"/>   </clipPath>   </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77242:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M11 2a3 3 0 0 0-3 3v1H5a1 1 0 0 0 0 2v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a1 1 0 0 0 0-2h-3V5a3 3 0 0 0-3-3h-2zm3 4V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1h4zM8 8H7v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8H8zm3 3v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 2 0zm3-1a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 35783:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M9.82143 0.3125H1.17857C0.527902 0.3125 0 0.807408 0 1.41741V9.52009C0 10.1301 0.527902 10.625 1.17857 10.625H9.82143C10.4721 10.625 11 10.1301 11 9.52009V1.41741C11 0.807408 10.4721 0.3125 9.82143 0.3125ZM8.62076 3.96791C8.62567 4.03237 8.62567 4.09912 8.62567 4.16357C8.62567 6.15932 7.00513 8.45891 4.04397 8.45891C3.13058 8.45891 2.28348 8.21031 1.57143 7.78216C1.70156 7.79597 1.82679 7.80057 1.95938 7.80057C2.71317 7.80057 3.40558 7.56117 3.95804 7.15604C3.25089 7.14223 2.6567 6.70717 2.4529 6.10868C2.70089 6.14321 2.92433 6.14321 3.17969 6.08105C2.44308 5.94064 1.89062 5.33294 1.89062 4.59863V4.58022C2.10424 4.69301 2.35469 4.76207 2.61741 4.77128C2.39653 4.63354 2.21546 4.44668 2.09036 4.22737C1.96526 4.00807 1.90001 3.76314 1.90045 3.51444C1.90045 3.23361 1.97902 2.9758 2.11897 2.75251C2.91205 3.66867 4.1029 4.26716 5.43862 4.33161C5.21027 3.30727 6.0279 2.47628 7.01004 2.47628C7.47411 2.47628 7.89152 2.65813 8.18616 2.95278C8.54955 2.88832 8.89821 2.76172 9.20759 2.58908C9.08728 2.93896 8.83438 3.23361 8.50045 3.42006C8.82455 3.38783 9.13884 3.30266 9.42857 3.18527C9.21004 3.48682 8.93504 3.75384 8.62076 3.96791Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 93858:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M11.522 4.72a4.433 4.433 0 0 1 6.269 6.269l-4.924 4.925-.886.885a2.745 2.745 0 1 1-3.882-3.882l4.595-4.595a1 1 0 1 1 1.414 1.415L9.513 14.33a.746.746 0 0 0 1.054 1.054l.219-.22a.015.015 0 0 0 .004-.003l5.587-5.587a2.433 2.433 0 0 0-3.44-3.44l-.487.486-5.443 5.443a3.667 3.667 0 0 0 0 5.186l.454.454a3.667 3.667 0 0 0 5.186 0l4.714-4.714a1 1 0 1 1 1.414 1.414l-4.714 4.714a5.667 5.667 0 0 1-8.014 0l-.454-.454a5.667 5.667 0 0 1 0-8.014l5.443-5.443.486-.487z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 64631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6zM5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6zm12.268 3.64a1 1 0 1 0-1.536-1.28l-4.406 5.287-2.745-1.96a1 1 0 1 0-1.162 1.627l3.5 2.5.755.54.594-.714 5-6z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 33753:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M15 7.5c0 .852-.431 1.745-1.161 2.472C13.064 10.743 12.291 11 12 11c-.291 0-1.064-.257-1.839-1.028C9.431 9.245 9 8.352 9 7.5 9 5.383 10.518 4 12 4s3 1.383 3 3.5zm2 0c0 3.038-3 5.5-5 5.5s-5-2.462-5-5.5S9.239 2 12 2s5 2.462 5 5.5zM10.582 16h2.432a4.494 4.494 0 0 1 4.386 3.518l.107.482H6.493l.195-.876A3.993 3.993 0 0 1 10.582 16zm-4.873.508A5.988 5.988 0 0 1 10.582 14h2.432a6.495 6.495 0 0 1 6.338 5.085l.264 1.187A1.42 1.42 0 0 1 18.23 22H5.999a1.603 1.603 0 0 1-1.565-1.951l.302-1.359a5.973 5.973 0 0 1 .973-2.182z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 325:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M11 17.887v-4.99c-2.268-.436-4-2.212-4-4.397s1.732-3.961 4-4.397V3a1 1 0 0 1 2 0v1.073c1.839.296 3.38 1.472 3.945 3.099a1 1 0 1 1-1.89.656c-.283-.815-1.063-1.463-2.055-1.715v4.99c2.268.436 4 2.212 4 4.397s-1.732 3.961-4 4.397V21a1 1 0 0 1-2 0v-1.073a5.34 5.34 0 0 1-2.558-1.138 4.453 4.453 0 0 1-1.387-1.961 1 1 0 0 1 1.89-.656c.139.4.404.772.771 1.076.36.297.8.516 1.284.64zm2-.046c1.182-.362 2-1.295 2-2.341 0-1.046-.818-1.979-2-2.34v4.68zm-2-7V6.159C9.818 6.521 9 7.454 9 8.5c0 1.046.818 1.979 2 2.34z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 24655:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M8 3a1 1 0 0 1 1 1v1h6V4a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h1V4a1 1 0 0 1 1-1zm7 4v1a1 1 0 0 0 2 0V7h1a1 1 0 0 1 1 1v2H5V8a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V7h6zM5 12v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6H5z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 52124:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M7 9a3 3 0 1 0 0 6h3a1 1 0 0 1 0 2H7A5 5 0 0 1 7 7h3a1 1 0 0 1 0 2H7zm1 3a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H9a1 1 0 0 1-1-1zm6-5a1 1 0 0 0 0 2h3a3 3 0 1 1 0 6h-3a1 1 0 0 0 0 2h3a5 5 0 0 0 0-10h-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 66339:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M12 4a8 8 0 1 0 3.555 15.169 1 1 0 1 1 .89 1.791A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v.571c0 1.297-.317 2.395-.948 3.193A3.199 3.199 0 0 1 18.5 17c-1.216 0-2.192-.685-2.801-1.636A5 5 0 1 1 15 8a1 1 0 0 1 2 0v5c0 1.222.85 2 1.5 2a1.2 1.2 0 0 0 .984-.478c.273-.345.516-.961.516-1.951V12a8 8 0 0 0-8-8zm3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 12154:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M7 5h10a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4zM3 7a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8H7a4 4 0 0 1-4-4zm4 8h10a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4zm-4 2a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8H7a4 4 0 0 1-4-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 39046:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M17.243 3.03a1 1 0 0 1 .727 1.212L17.031 8H20a1 1 0 0 1 0 2h-3.47l-1 4H18a1 1 0 0 1 0 2h-2.97l-1.06 4.242a1 1 0 0 1-1.94-.485L12.97 16H9.03l-1.06 4.242a1 1 0 0 1-1.94-.485L6.97 16H4a1 1 0 1 1 0-2h3.47l1-4H6a1 1 0 1 1 0-2h2.97l1.06-4.242a1 1 0 1 1 1.94.484L11.03 8h3.94l1.06-4.242a1 1 0 0 1 1.213-.728zM10.531 10l-1 4h3.938l1-4h-3.938z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 92702:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M20.707 3.293a1 1 0 0 1 0 1.414l-16 16a1 1 0 1 1-1.414-1.414l16-16a1 1 0 0 1 1.414 0zM6.5 5C5.835 5 5 5.717 5 7s.835 2 1.5 2S8 8.283 8 7s-.835-2-1.5-2zM3 7c0-2.03 1.404-4 3.5-4S10 4.97 10 7c0 2.03-1.404 4-3.5 4S3 9.03 3 7zm13 10c0-1.283.835-2 1.5-2s1.5.717 1.5 2-.835 2-1.5 2-1.5-.717-1.5-2zm1.5-4c-2.096 0-3.5 1.97-3.5 4 0 2.03 1.404 4 3.5 4s3.5-1.97 3.5-4c0-2.03-1.404-4-3.5-4z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 21685:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M8.933 8.578l1.65-4.748c.466-1.343 2.368-1.343 2.834 0l1.65 4.748 5.025.103c1.422.029 2.01 1.836.876 2.695l-4.005 3.036 1.455 4.81c.414 1.362-1.125 2.48-2.292 1.667L12 18.018l-4.126 2.871c-1.167.813-2.706-.305-2.292-1.665l1.455-4.812-4.005-3.036c-1.134-.86-.546-2.666.876-2.695l5.025-.103zM12 5.846l-1.293 3.72a1.5 1.5 0 0 1-1.386 1.005l-3.935.08 3.139 2.38a1.5 1.5 0 0 1 .527 1.628l-1.14 3.767 3.232-2.249a1.502 1.502 0 0 1 1.713 0l3.23 2.249-1.139-3.765a1.5 1.5 0 0 1 .529-1.632l3.137-2.378-3.936-.08a1.5 1.5 0 0 1-1.386-1.007L12 5.846z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 56486:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M7 8h10a4 4 0 1 1 0 8H7a4 4 0 1 1 0-8zm0 2a2 2 0 1 0 0 4h10a2 2 0 1 0 0-4H7z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 85265:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2h-5v15a1 1 0 1 1-2 0V5H4a1 1 0 0 1-1-1zm14 9h3a1 1 0 1 1 0 2h-2v5a1 1 0 1 1-2 0v-5h-2a1 1 0 1 1 0-2h3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 61615:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"10","viewBox":"0 0 11 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5.28098 9.83974C4.07416 9.80988 3.00875 9.4217 2.05904 8.74237C1.41465 8.28102 0.865071 7.73756 0.472974 7.06869C0.0856979 6.40727 -0.0637489 5.70257 0.0246336 4.95157C0.103374 4.28419 0.416731 3.71833 0.902031 3.23907C1.24271 2.90314 1.6107 2.5896 1.97708 2.27756C2.39007 1.92371 2.8127 1.57882 3.23694 1.23543C3.56797 0.966682 3.91989 0.729291 4.3152 0.550127C4.82782 0.318708 5.37097 0.232112 5.93662 0.253015C7.00525 0.293327 7.94853 0.65016 8.79861 1.23692C9.47192 1.70125 10.0456 2.25666 10.4538 2.94196C11.0291 3.90795 11.156 4.9247 10.8057 5.98325C10.6402 6.48043 10.3333 6.90893 9.95883 7.29115C9.28873 7.97645 8.54792 8.58859 7.73641 9.12608C7.25593 9.44409 6.73046 9.677 6.14552 9.77107C5.86109 9.81586 5.57184 9.83079 5.2858 9.85915C5.2842 9.85169 5.28259 9.84572 5.28098 9.83974ZM5.16207 7.35983C5.36937 7.35983 5.5622 7.35535 5.75343 7.36132C5.8386 7.3643 5.85306 7.33594 5.85306 7.26427C5.85145 6.16988 5.85145 5.074 5.85145 3.97961C5.85145 3.94826 5.85145 3.9169 5.85145 3.8751C6.31747 3.8751 6.77063 3.8751 7.22218 3.8751C7.22218 3.66608 7.22218 3.469 7.22218 3.27192C6.07321 3.27192 4.93227 3.27192 3.78169 3.27192C3.78169 3.4466 3.78491 3.61531 3.78009 3.78402C3.77687 3.85718 3.79776 3.88256 3.88133 3.88107C4.27021 3.87659 4.65748 3.87958 5.04637 3.87958C5.16046 3.87958 5.16046 3.87958 5.16046 3.9826C5.16046 5.07251 5.16046 6.16242 5.16046 7.25233C5.16207 7.28368 5.16207 7.31653 5.16207 7.35983Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 78555:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M8 3a1 1 0 0 0-2 0v9a6 6 0 1 0 12 0V3a1 1 0 0 0-2 0v9a4 4 0 0 1-8 0V3zM7 20a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2H7z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 69206:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.58963 3.36764C4.85564 3.10011 5.28727 3.10011 5.55328 3.36764C5.81876 3.63464 5.81876 4.06716 5.55328 4.33416L4.65667 5.23596H10.5572C12.8277 5.23596 14.6667 7.0869 14.6667 9.36814C14.6667 11.6494 12.8277 13.5003 10.5572 13.5003H5.75717C5.3802 13.5003 5.07622 13.1932 5.07622 12.8164C5.07622 12.4396 5.3802 12.1325 5.75717 12.1325H10.5572C12.0737 12.1325 13.3048 10.8958 13.3048 9.36814C13.3048 7.84052 12.0737 6.60377 10.5572 6.60377H4.65667L5.55328 7.50557C5.81876 7.77258 5.81876 8.20506 5.55328 8.47207C5.28727 8.73961 4.85564 8.73961 4.58963 8.47207L2.53249 6.40312C2.267 6.13612 2.267 5.70361 2.53249 5.43661L4.58963 3.36764Z\" fill=\"currentColor\"></path>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 29300:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<g clip-path=\"url(#clip0)\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"#00A1B7\"/> <path d=\"M12.0833 9.16663C10.9621 9.16663 10.4864 10.5939 11.3833 11.2666L11.85 11.6166C11.9969 11.7268 12.0833 11.8997 12.0833 12.0833V14.4166C12.0833 14.6002 11.9969 14.7731 11.85 14.8833L11.3833 15.2333C10.4864 15.906 10.9621 17.3333 12.0833 17.3333H14.4167V20.25C14.4167 20.5721 14.6778 20.8333 15 20.8333C15.3222 20.8333 15.5833 20.5721 15.5833 20.25V17.3333H17.9167C19.0378 17.3333 19.5136 15.906 18.6167 15.2333L18.15 14.8833C18.0031 14.7731 17.9167 14.6002 17.9167 14.4166V12.0833C17.9167 11.8997 18.0031 11.7268 18.15 11.6166L18.6167 11.2666C19.5136 10.5939 19.0378 9.16663 17.9167 9.16663H12.0833Z\" fill=\"#F5F8FA\"/> </g> <defs> <clipPath id=\"clip0\"> <path d=\"M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z\" fill=\"white\"/> </clipPath> </defs>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 26798:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<circle class=\"graphic_stroke\" cx=\"18\" cy=\"18\" r=\"17\" stroke=\"#5C6061\" stroke-width=\"2\"/>   <path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 8.625C18.5178 8.625 18.9375 9.04473 18.9375 9.5625L18.9375 20.4242L23.8996 15.4621C24.2657 15.096 24.8593 15.096 25.2254 15.4621C25.5915 15.8282 25.5915 16.4218 25.2254 16.7879L18.6661 23.3472C18.6562 23.3573 18.646 23.367 18.6357 23.3766C18.5545 23.4515 18.4634 23.5095 18.3668 23.5505C18.2549 23.5981 18.1319 23.6246 18.0028 23.625L18 23.625L17.9914 23.625C17.8704 23.6239 17.755 23.5999 17.6491 23.5571C17.5355 23.5113 17.4291 23.4424 17.3371 23.3504L10.7746 16.7879C10.4085 16.4218 10.4085 15.8282 10.7746 15.4621C11.1407 15.096 11.7343 15.096 12.1004 15.4621L17.0625 20.4242L17.0625 9.5625C17.0625 9.04473 17.4822 8.625 18 8.625ZM11.4375 25.5C10.9197 25.5 10.5 25.9197 10.5 26.4375C10.5 26.9553 10.9197 27.375 11.4375 27.375L24.5625 27.375C25.0803 27.375 25.5 26.9553 25.5 26.4375C25.5 25.9197 25.0803 25.5 24.5625 25.5L11.4375 25.5Z\" fill=\"black\" fill-opacity=\"0.6\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 29672:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect class=\"graphic_stroke\" x=\"1\" y=\"1\" width=\"11\" height=\"11\" rx=\"1\" stroke=\"#5C6061\"/>   <path class=\"graphic_stroke\" d=\"M5.5 4L3 6.5L5.5 9\" stroke=\"#5C6061\"/>   <path class=\"graphic_stroke\" d=\"M7.5 4L10 6.5L7.5 9\" stroke=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77586:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M2.66675 14C2.66675 11.4227 4.75609 9.33333 7.33341 9.33333C7.55975 9.33333 7.78235 9.34947 8.00008 9.3806M10.0001 4.66667C10.0001 6.13943 8.80615 7.33333 7.33341 7.33333C5.86065 7.33333 4.66675 6.13943 4.66675 4.66667C4.66675 3.19391 5.86065 2 7.33341 2C8.80615 2 10.0001 3.19391 10.0001 4.66667Z\" stroke=\"#737373\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.9236 9.30999L13.5424 9.92871C13.8841 10.2704 13.8841 10.8244 13.5424 11.1661L13.0164 11.6921L11.1603 9.83592L11.6862 9.30999C12.0279 8.96828 12.5819 8.96828 12.9236 9.30999ZM10.8509 10.1453L8.48041 12.5158C8.33946 12.6567 8.25086 12.8416 8.22928 13.0397L8.11436 14.0949C8.074 14.4655 8.38683 14.7783 8.75742 14.738L9.81258 14.6231C10.0108 14.6015 10.1956 14.5129 10.3366 14.3719L12.7071 12.0014L10.8509 10.1453Z\" fill=\"#737373\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 24327:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M10.4035 4.33268C10.4035 6.35773 8.40347 7.99935 7.07014 7.99935C5.73681 7.99935 3.73681 6.35773 3.73681 4.33268C3.73681 2.30764 5.22919 0.666016 7.07014 0.666016C8.91109 0.666016 10.4035 2.30764 10.4035 4.33268ZM9.07014 4.33268C9.07014 2.92159 8.05797 1.99935 7.07014 1.99935C6.08231 1.99935 5.07014 2.92159 5.07014 4.33268C5.07014 4.9009 5.35726 5.49586 5.84406 5.98038C6.36103 6.49492 6.87583 6.66602 7.07014 6.66602C7.26445 6.66602 7.77925 6.49492 8.29622 5.98038C8.78302 5.49586 9.07014 4.9009 9.07014 4.33268Z\" fill=\"currentColor\"/>   <path class=\"graphic\" d=\"M7.74583 8.66602C7.93845 8.66602 8.1296 8.67884 8.31817 8.70399C8.37771 8.63583 8.43996 8.5692 8.50491 8.50425C10.067 6.94216 12.5997 6.94216 14.1618 8.50425C15.7239 10.0663 15.7239 12.599 14.1618 14.1611C12.5997 15.7232 10.067 15.7232 8.50491 14.1611C8.45207 14.1083 8.40102 14.0543 8.35176 13.9993H3.06941C2.38554 13.9993 1.87754 13.3661 2.02589 12.6985L2.22718 11.7927C2.34352 11.2692 2.56412 10.7744 2.87583 10.3381C3.62532 9.28876 4.83543 8.66602 6.12491 8.66602H7.74583ZM6.12491 9.99935C5.26603 9.99935 4.46002 10.4141 3.96081 11.113C3.75319 11.4037 3.60625 11.7332 3.52876 12.0819L3.39896 12.666H7.56111C7.25741 11.8049 7.25741 10.8605 7.56111 9.99935H6.12491ZM13.8856 11.3327C13.8856 10.9645 13.5871 10.666 13.219 10.666H12V9.44707C12 9.07888 11.7015 8.7804 11.3333 8.7804C10.9651 8.7804 10.6667 9.07888 10.6667 9.44707V10.666H9.44771C9.07952 10.666 8.78105 10.9645 8.78105 11.3327C8.78105 11.7009 9.07952 11.9994 9.44771 11.9994H10.6667V13.2183C10.6667 13.5865 10.9651 13.885 11.3333 13.885C11.7015 13.885 12 13.5865 12 13.2183V11.9994H13.219C13.5871 11.9994 13.8856 11.7009 13.8856 11.3327Z\" fill=\"currentColor\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 59146:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 3a1 1 0 0 1 1 1v9h2.575a.5.5 0 0 1 .312.89l-3.575 2.86a.5.5 0 0 1-.624 0l-3.575-2.86a.5.5 0 0 1 .312-.89H11V4a1 1 0 0 1 1-1zM3 20a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 52725:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M12 1a1 1 0 0 1 1 1v3h2.575a.5.5 0 0 1 .312.89l-3.575 2.86a.5.5 0 0 1-.624 0L8.113 5.89A.5.5 0 0 1 8.425 5H11V2a1 1 0 0 1 1-1zM3 12a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm8 7H8.425a.5.5 0 0 1-.312-.89l3.575-2.86a.5.5 0 0 1 .624 0l3.575 2.86a.5.5 0 0 1-.312.89H13v3a1 1 0 0 1-2 0v-3z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 10226:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1zm10 7h2.575a.5.5 0 0 0 .312-.89l-3.575-2.86a.5.5 0 0 0-.624 0l-3.575 2.86a.5.5 0 0 0 .312.89H11v9a1 1 0 0 0 2 0v-9z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 22220:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <path d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" fill=\"#5C6061\" d=\"M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5zM4 7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7zm6.757 2.454a.5.5 0 0 0-.757.429v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858l-3.528-2.117z\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 27237:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"</svg> <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">     <g fill=\"none\" fill-rule=\"evenodd\">         <path fill-rule=\"nonzero\" d=\"M0 0h24v24H0z\"/>         <path class=\"graphic\" d=\"M14.667 4C14.667 3.73036 14.5045 3.48727 14.2554 3.38408C14.0063 3.28089 13.7195 3.33793 13.5289 3.52859L10.667 6.39052V5.33333C10.667 4.22876 9.77152 3.33333 8.66695 3.33333H3.33362C2.22905 3.33333 1.33362 4.22876 1.33362 5.33333V10.6667C1.33362 11.7712 2.22905 12.6667 3.33362 12.6667H8.66695C9.77152 12.6667 10.667 11.7712 10.667 10.6667V9.60948L13.5289 12.4714C13.7195 12.6621 14.0063 12.7191 14.2554 12.6159C14.5045 12.5127 14.667 12.2696 14.667 12V4ZM9.33362 5.33333V10.6667C9.33362 11.0349 9.03514 11.3333 8.66695 11.3333H3.33362C2.96543 11.3333 2.66695 11.0349 2.66695 10.6667V5.33333C2.66695 4.96514 2.96543 4.66667 3.33362 4.66667H8.66695C9.03514 4.66667 9.33362 4.96514 9.33362 5.33333ZM13.3336 10.3905L10.9431 8L13.3336 5.60947V10.3905Z\" fill=\"#5C6061\"/>     </g>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 89713:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M9.9 0.3125H1.1C0.493527 0.3125 0 0.775181 0 1.34375V9.59375C0 10.1623 0.493527 10.625 1.1 10.625H9.9C10.5065 10.625 11 10.1623 11 9.59375V1.34375C11 0.775181 10.5065 0.3125 9.9 0.3125ZM9.2567 3.73772C9.22232 4.46282 8.68214 5.45724 7.63616 6.71638C6.5558 8.03306 5.63996 8.69141 4.89353 8.69141C4.42946 8.69141 4.03906 8.29088 3.71741 7.48751C3.09129 5.33984 2.82366 4.08071 2.30804 4.08071C2.24911 4.08071 2.0404 4.1981 1.68437 4.43059L1.31116 3.97942C2.22701 3.2244 3.10112 2.38651 3.64866 2.34047C4.26741 2.28523 4.64799 2.68115 4.7904 3.53055C5.29866 6.55064 5.52455 7.00642 6.45022 5.63909C6.7817 5.14648 6.96094 4.77128 6.98549 4.51346C7.07143 3.74923 6.34955 3.80218 5.86094 3.99784C6.25134 2.79855 6.99777 2.21617 8.10022 2.2484C8.91786 2.26911 9.30335 2.76632 9.2567 3.73772Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 4311:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M5 11.0415L8.5 13.0622C9.16667 13.4471 10 12.966 10 12.1962L10 1.80386C10 1.03406 9.16667 0.552935 8.5 0.937835L5 2.95856V3H1C0.447715 3 0 3.44772 0 4V10C0 10.5523 0.447715 11 1 11H5V11.0415Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M14 7C14 8.10457 13.1046 9 12 9V5C13.1046 5 14 5.89543 14 7Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 84005:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M4.92822 3H1C0.447715 3 0 3.44772 0 4V10C0 10.5523 0.447715 11 1 11H4.92818L8.5 13.0622C9.16667 13.4471 10 12.966 10 12.1962L10 1.80386C10 1.03406 9.16667 0.552935 8.5 0.937835L4.92822 3Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5V9Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11V13C15.3137 13 18 10.3137 18 7C18 3.68629 15.3137 1 12 1V3Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 80347:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"17","height":"14","viewBox":"0 0 17 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M1 3H4.92822L8.5 0.937835C9.16667 0.552935 10 1.03406 10 1.80386L10 12.1962C10 12.966 9.16667 13.4471 8.5 13.0622L4.92818 11H1C0.447715 11 0 10.5523 0 10V4C0 3.44772 0.447715 3 1 3Z\" fill=\"white\"/>   <path class=\"graphic\" d=\"M16.7071 4.29289C16.3166 3.90237 15.6834 3.90237 15.2929 4.29289L14 5.58579L12.7071 4.29289C12.3166 3.90237 11.6834 3.90237 11.2929 4.29289C10.9024 4.68342 10.9024 5.31658 11.2929 5.70711L12.5858 7L11.2929 8.29289C10.9024 8.68342 10.9024 9.31658 11.2929 9.70711C11.6834 10.0976 12.3166 10.0976 12.7071 9.70711L14 8.41421L15.2929 9.70711C15.6834 10.0976 16.3166 10.0976 16.7071 9.70711C17.0976 9.31658 17.0976 8.68342 16.7071 8.29289L15.4142 7L16.7071 5.70711C17.0976 5.31658 17.0976 4.68342 16.7071 4.29289Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 77445:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.68885 3.06662C5.51107 3.19995 5.51107 3.46662 5.68885 3.59995L7.46663 4.93329C7.68637 5.0981 7.99996 4.9413 7.99996 4.66662V3.99995C10.2091 3.99995 12 5.79081 12 7.99995C12 10.2091 10.2091 12 7.99996 12C5.79082 12 3.99996 10.2091 3.99996 7.99995C3.99996 7.63176 3.70148 7.33329 3.33329 7.33329C2.9651 7.33329 2.66663 7.63176 2.66663 7.99995C2.66663 10.9455 5.05444 13.3333 7.99996 13.3333C10.9455 13.3333 13.3333 10.9455 13.3333 7.99995C13.3333 5.05444 10.9455 2.66662 7.99996 2.66662V1.99995C7.99996 1.72527 7.68637 1.56848 7.46663 1.73329L5.68885 3.06662Z\" fill=\"white\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 7294:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 1.33333C4.89543 1.33333 4 2.22876 4 3.33333C4 4.4379 4.89543 5.33333 6 5.33333C7.10457 5.33333 8 4.4379 8 3.33333C8 2.22876 7.10457 1.33333 6 1.33333ZM2.66667 3.33333C2.66667 1.49238 4.15905 0 6 0C7.84095 0 9.33333 1.49238 9.33333 3.33333C9.33333 3.8157 9.23087 4.27414 9.04653 4.68807C10.7086 4.87662 12 6.2875 12 8C12 9.84095 10.5076 11.3333 8.66667 11.3333C7.57627 11.3333 6.60815 10.8098 6 10.0003C5.39185 10.8098 4.42373 11.3333 3.33333 11.3333C1.49238 11.3333 0 9.84095 0 8C0 6.2875 1.2914 4.87662 2.95347 4.68807C2.76913 4.27414 2.66667 3.8157 2.66667 3.33333ZM5.33333 8C5.33333 6.89543 4.4379 6 3.33333 6C2.22876 6 1.33333 6.89543 1.33333 8C1.33333 9.10457 2.22876 10 3.33333 10C4.4379 10 5.33333 9.10457 5.33333 8ZM6.66667 8C6.66667 9.10457 7.5621 10 8.66667 10C9.77124 10 10.6667 9.10457 10.6667 8C10.6667 6.89543 9.77124 6 8.66667 6C7.5621 6 6.66667 6.89543 6.66667 8Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 46921:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


module.exports = {"attributes":{"width":"11","height":"8","viewBox":"0 0 11 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path class=\"graphic\" d=\"M10.7762 1.2108C10.6498 0.739231 10.2788 0.367144 9.80781 0.240184C8.94712 0.00385134 5.50381 4.17513e-06 5.50381 4.17513e-06C5.50381 4.17513e-06 2.06104 -0.00384321 1.1998 0.222047C0.738129 0.347908 0.356699 0.728239 0.229189 1.19926C0.00219935 2.05995 8.0526e-07 3.84508 8.0526e-07 3.84508C8.0526e-07 3.84508 -0.00219763 5.63901 0.223143 6.49091C0.349554 6.96193 0.720541 7.33401 1.19211 7.46097C2.06159 7.69731 5.49556 7.70115 5.49556 7.70115C5.49556 7.70115 8.93888 7.705 9.79957 7.47966C10.27 7.35325 10.6427 6.98171 10.7707 6.5107C10.9983 5.65056 10.9999 3.86597 10.9999 3.86597C10.9999 3.86597 11.0109 2.07149 10.7762 1.2108ZM4.40239 5.49886L4.40514 2.2012L7.26696 3.85278L4.40239 5.49886Z\" fill=\"#5C6061\"/>"}
var desvg = __webpack_require__(5813)
module.exports = desvg(module.exports)


/***/ }),

/***/ 8523:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"ctaButtonPadding":"14px"};

/***/ }),

/***/ 95306:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 42742:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 83473:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 53893:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 57167:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 39727:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 80049:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 36663:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 10962:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 82102:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25893:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 36413:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(19601);
function _extends() {
  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ VideoViewer),
  "getVideoTypes": () => (/* binding */ getVideoTypes)
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(73210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(87751);
// EXTERNAL MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module = __webpack_require__(79758);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/util/browser.js
var browser = __webpack_require__(12650);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__(40561);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(24603);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__(43371);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-names.js
var es_object_get_own_property_names = __webpack_require__(36210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(4129);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__(51532);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__(43290);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(70189);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__(56977);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(2707);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.to-json.js
var web_url_to_json = __webpack_require__(83753);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint8-array.js
var es_typed_array_uint8_array = __webpack_require__(82472);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.copy-within.js
var es_typed_array_copy_within = __webpack_require__(92990);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.every.js
var es_typed_array_every = __webpack_require__(18927);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.fill.js
var es_typed_array_fill = __webpack_require__(33105);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.filter.js
var es_typed_array_filter = __webpack_require__(35035);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find.js
var es_typed_array_find = __webpack_require__(74345);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.find-index.js
var es_typed_array_find_index = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.for-each.js
var es_typed_array_for_each = __webpack_require__(32846);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.includes.js
var es_typed_array_includes = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.index-of.js
var es_typed_array_index_of = __webpack_require__(77209);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.iterator.js
var es_typed_array_iterator = __webpack_require__(96319);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.join.js
var es_typed_array_join = __webpack_require__(58867);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.last-index-of.js
var es_typed_array_last_index_of = __webpack_require__(37789);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.map.js
var es_typed_array_map = __webpack_require__(33739);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce.js
var es_typed_array_reduce = __webpack_require__(29368);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reduce-right.js
var es_typed_array_reduce_right = __webpack_require__(14483);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.reverse.js
var es_typed_array_reverse = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.set.js
var es_typed_array_set = __webpack_require__(3462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.slice.js
var es_typed_array_slice = __webpack_require__(30678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.some.js
var es_typed_array_some = __webpack_require__(27462);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.sort.js
var es_typed_array_sort = __webpack_require__(33824);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.subarray.js
var es_typed_array_subarray = __webpack_require__(55021);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-locale-string.js
var es_typed_array_to_locale_string = __webpack_require__(12974);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.to-string.js
var es_typed_array_to_string = __webpack_require__(15016);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.constructor.js
var es_array_buffer_constructor = __webpack_require__(18264);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(60285);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(41637);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.max-safe-integer.js
var es_number_max_safe_integer = __webpack_require__(44363);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.flags.js
var es_regexp_flags = __webpack_require__(92087);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.global-this.js
var esnext_global_this = __webpack_require__(65743);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint32-array.js
var es_typed_array_uint32_array = __webpack_require__(29135);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.int32-array.js
var es_typed_array_int32_array = __webpack_require__(65125);
// EXTERNAL MODULE: ./node_modules/global/window.js
var global_window = __webpack_require__(95732);
var window_default = /*#__PURE__*/__webpack_require__.n(global_window);
// EXTERNAL MODULE: ./node_modules/global/document.js
var global_document = __webpack_require__(56374);
var document_default = /*#__PURE__*/__webpack_require__.n(global_document);
;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/extends.js

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }
    return n;
  }, _extends.apply(null, arguments);
}

// EXTERNAL MODULE: ./node_modules/keycode/index.js
var keycode = __webpack_require__(19820);
var keycode_default = /*#__PURE__*/__webpack_require__.n(keycode);
;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

// EXTERNAL MODULE: ./node_modules/safe-json-parse/tuple.js
var tuple = __webpack_require__(48119);
var tuple_default = /*#__PURE__*/__webpack_require__.n(tuple);
// EXTERNAL MODULE: ./node_modules/@videojs/xhr/lib/index.js
var lib = __webpack_require__(3173);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/videojs-vtt.js/lib/browser-index.js
var browser_index = __webpack_require__(99227);
var browser_index_default = /*#__PURE__*/__webpack_require__.n(browser_index);
;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/construct.js



function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

// EXTERNAL MODULE: ./node_modules/url-toolkit/src/url-toolkit.js
var url_toolkit = __webpack_require__(39724);
var url_toolkit_default = /*#__PURE__*/__webpack_require__.n(url_toolkit);
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/resolve-url.js









var DEFAULT_LOCATION = 'http://example.com';
var resolveUrl = function resolveUrl(baseUrl, relativeUrl) {
  // return early if we don't need to resolve
  if (/^[a-z]+:/i.test(relativeUrl)) {
    return relativeUrl;
  } // if baseUrl is a data URI, ignore it and resolve everything relative to window.location

  if (/^data:/.test(baseUrl)) {
    baseUrl = (window_default()).location && (window_default()).location.href || '';
  } // IE11 supports URL but not the URL constructor
  // feature detect the behavior we want

  var nativeURL = typeof (window_default()).URL === 'function';
  var protocolLess = /^\/\//.test(baseUrl); // remove location if window.location isn't available (i.e. we're in node)
  // and if baseUrl isn't an absolute url

  var removeLocation = !(window_default()).location && !/\/\//i.test(baseUrl); // if the base URL is relative then combine with the current location

  if (nativeURL) {
    baseUrl = new (window_default()).URL(baseUrl, (window_default()).location || DEFAULT_LOCATION);
  } else if (!/\/\//i.test(baseUrl)) {
    baseUrl = url_toolkit_default().buildAbsoluteURL((window_default()).location && (window_default()).location.href || '', baseUrl);
  }
  if (nativeURL) {
    var newUrl = new URL(relativeUrl, baseUrl); // if we're a protocol-less url, remove the protocol
    // and if we're location-less, remove the location
    // otherwise, return the url unmodified

    if (removeLocation) {
      return newUrl.href.slice(DEFAULT_LOCATION.length);
    } else if (protocolLess) {
      return newUrl.href.slice(newUrl.protocol.length);
    }
    return newUrl.href;
  }
  return url_toolkit_default().buildAbsoluteURL(baseUrl, relativeUrl);
};
/* harmony default export */ const resolve_url = (resolveUrl);
;// CONCATENATED MODULE: ./node_modules/m3u8-parser/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function setPrototypeOf_setPrototypeOf(t, e) {
  return setPrototypeOf_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, setPrototypeOf_setPrototypeOf(t, e);
}

;// CONCATENATED MODULE: ./node_modules/m3u8-parser/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function inheritsLoose_inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf_setPrototypeOf(t, o);
}

;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/stream.js


/**
 * @file stream.js
 */

/**
 * A lightweight readable stream implemention that handles event dispatching.
 *
 * @class Stream
 */
var Stream = /*#__PURE__*/function () {
  function Stream() {
    this.listeners = {};
  }
  /**
   * Add a listener for a specified event type.
   *
   * @param {string} type the event name
   * @param {Function} listener the callback to be invoked when an event of
   * the specified type occurs
   */

  var _proto = Stream.prototype;
  _proto.on = function on(type, listener) {
    if (!this.listeners[type]) {
      this.listeners[type] = [];
    }
    this.listeners[type].push(listener);
  }
  /**
   * Remove a listener for a specified event type.
   *
   * @param {string} type the event name
   * @param {Function} listener  a function previously registered for this
   * type of event through `on`
   * @return {boolean} if we could turn it off or not
   */;

  _proto.off = function off(type, listener) {
    if (!this.listeners[type]) {
      return false;
    }
    var index = this.listeners[type].indexOf(listener); // TODO: which is better?
    // In Video.js we slice listener functions
    // on trigger so that it does not mess up the order
    // while we loop through.
    //
    // Here we slice on off so that the loop in trigger
    // can continue using it's old reference to loop without
    // messing up the order.

    this.listeners[type] = this.listeners[type].slice(0);
    this.listeners[type].splice(index, 1);
    return index > -1;
  }
  /**
   * Trigger an event of the specified type on this stream. Any additional
   * arguments to this function are passed as parameters to event listeners.
   *
   * @param {string} type the event name
   */;

  _proto.trigger = function trigger(type) {
    var callbacks = this.listeners[type];
    if (!callbacks) {
      return;
    } // Slicing the arguments on every invocation of this method
    // can add a significant amount of overhead. Avoid the
    // intermediate object creation for the common case of a
    // single callback argument

    if (arguments.length === 2) {
      var length = callbacks.length;
      for (var i = 0; i < length; ++i) {
        callbacks[i].call(this, arguments[1]);
      }
    } else {
      var args = Array.prototype.slice.call(arguments, 1);
      var _length = callbacks.length;
      for (var _i = 0; _i < _length; ++_i) {
        callbacks[_i].apply(this, args);
      }
    }
  }
  /**
   * Destroys the stream and cleans up.
   */;

  _proto.dispose = function dispose() {
    this.listeners = {};
  }
  /**
   * Forwards all `data` events on this stream to the destination stream. The
   * destination stream should provide a method `push` to receive the data
   * events as they arrive.
   *
   * @param {Stream} destination the stream that will receive all `data` events
   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
   */;

  _proto.pipe = function pipe(destination) {
    this.on('data', function (data) {
      destination.push(data);
    });
  };
  return Stream;
}();

;// CONCATENATED MODULE: ./node_modules/m3u8-parser/node_modules/@babel/runtime/helpers/esm/extends.js

function extends_extends() {
  return extends_extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }
    return n;
  }, extends_extends.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/m3u8-parser/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function assertThisInitialized_assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/decode-b64-to-uint8-array.js
/* provided dependency */ var Buffer = __webpack_require__(13423)["Buffer"];




























var atob = function atob(s) {
  return (window_default()).atob ? window_default().atob(s) : Buffer.from(s, 'base64').toString('binary');
};
function decodeB64ToUint8Array(b64Text) {
  var decodedString = atob(b64Text);
  var array = new Uint8Array(decodedString.length);
  for (var i = 0; i < decodedString.length; i++) {
    array[i] = decodedString.charCodeAt(i);
  }
  return array;
}
;// CONCATENATED MODULE: ./node_modules/m3u8-parser/dist/m3u8-parser.es.js







































/*! @name m3u8-parser @version 4.8.0 @license Apache-2.0 */






/**
 * A stream that buffers string input and generates a `data` event for each
 * line.
 *
 * @class LineStream
 * @extends Stream
 */

var LineStream = /*#__PURE__*/function (_Stream) {
  inheritsLoose_inheritsLoose(LineStream, _Stream);
  function LineStream() {
    var _this;
    _this = _Stream.call(this) || this;
    _this.buffer = '';
    return _this;
  }
  /**
   * Add new data to be parsed.
   *
   * @param {string} data the text to process
   */

  var _proto = LineStream.prototype;
  _proto.push = function push(data) {
    var nextNewline;
    this.buffer += data;
    nextNewline = this.buffer.indexOf('\n');
    for (; nextNewline > -1; nextNewline = this.buffer.indexOf('\n')) {
      this.trigger('data', this.buffer.substring(0, nextNewline));
      this.buffer = this.buffer.substring(nextNewline + 1);
    }
  };
  return LineStream;
}(Stream);
var TAB = String.fromCharCode(0x09);
var parseByterange = function parseByterange(byterangeString) {
  // optionally match and capture 0+ digits before `@`
  // optionally match and capture 0+ digits after `@`
  var match = /([0-9.]*)?@?([0-9.]*)?/.exec(byterangeString || '');
  var result = {};
  if (match[1]) {
    result.length = parseInt(match[1], 10);
  }
  if (match[2]) {
    result.offset = parseInt(match[2], 10);
  }
  return result;
};
/**
 * "forgiving" attribute list psuedo-grammar:
 * attributes -> keyvalue (',' keyvalue)*
 * keyvalue   -> key '=' value
 * key        -> [^=]*
 * value      -> '"' [^"]* '"' | [^,]*
 */

var attributeSeparator = function attributeSeparator() {
  var key = '[^=]*';
  var value = '"[^"]*"|[^,]*';
  var keyvalue = '(?:' + key + ')=(?:' + value + ')';
  return new RegExp('(?:^|,)(' + keyvalue + ')');
};
/**
 * Parse attributes from a line given the separator
 *
 * @param {string} attributes the attribute line to parse
 */

var parseAttributes = function parseAttributes(attributes) {
  // split the string using attributes as the separator
  var attrs = attributes.split(attributeSeparator());
  var result = {};
  var i = attrs.length;
  var attr;
  while (i--) {
    // filter out unmatched portions of the string
    if (attrs[i] === '') {
      continue;
    } // split the key and value

    attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1); // trim whitespace and remove optional quotes around the value

    attr[0] = attr[0].replace(/^\s+|\s+$/g, '');
    attr[1] = attr[1].replace(/^\s+|\s+$/g, '');
    attr[1] = attr[1].replace(/^['"](.*)['"]$/g, '$1');
    result[attr[0]] = attr[1];
  }
  return result;
};
/**
 * A line-level M3U8 parser event stream. It expects to receive input one
 * line at a time and performs a context-free parse of its contents. A stream
 * interpretation of a manifest can be useful if the manifest is expected to
 * be too large to fit comfortably into memory or the entirety of the input
 * is not immediately available. Otherwise, it's probably much easier to work
 * with a regular `Parser` object.
 *
 * Produces `data` events with an object that captures the parser's
 * interpretation of the input. That object has a property `tag` that is one
 * of `uri`, `comment`, or `tag`. URIs only have a single additional
 * property, `line`, which captures the entirety of the input without
 * interpretation. Comments similarly have a single additional property
 * `text` which is the input without the leading `#`.
 *
 * Tags always have a property `tagType` which is the lower-cased version of
 * the M3U8 directive without the `#EXT` or `#EXT-X-` prefix. For instance,
 * `#EXT-X-MEDIA-SEQUENCE` becomes `media-sequence` when parsed. Unrecognized
 * tags are given the tag type `unknown` and a single additional property
 * `data` with the remainder of the input.
 *
 * @class ParseStream
 * @extends Stream
 */

var ParseStream = /*#__PURE__*/function (_Stream) {
  inheritsLoose_inheritsLoose(ParseStream, _Stream);
  function ParseStream() {
    var _this;
    _this = _Stream.call(this) || this;
    _this.customParsers = [];
    _this.tagMappers = [];
    return _this;
  }
  /**
   * Parses an additional line of input.
   *
   * @param {string} line a single line of an M3U8 file to parse
   */

  var _proto = ParseStream.prototype;
  _proto.push = function push(line) {
    var _this2 = this;
    var match;
    var event; // strip whitespace

    line = line.trim();
    if (line.length === 0) {
      // ignore empty lines
      return;
    } // URIs

    if (line[0] !== '#') {
      this.trigger('data', {
        type: 'uri',
        uri: line
      });
      return;
    } // map tags

    var newLines = this.tagMappers.reduce(function (acc, mapper) {
      var mappedLine = mapper(line); // skip if unchanged

      if (mappedLine === line) {
        return acc;
      }
      return acc.concat([mappedLine]);
    }, [line]);
    newLines.forEach(function (newLine) {
      for (var i = 0; i < _this2.customParsers.length; i++) {
        if (_this2.customParsers[i].call(_this2, newLine)) {
          return;
        }
      } // Comments

      if (newLine.indexOf('#EXT') !== 0) {
        _this2.trigger('data', {
          type: 'comment',
          text: newLine.slice(1)
        });
        return;
      } // strip off any carriage returns here so the regex matching
      // doesn't have to account for them.

      newLine = newLine.replace('\r', ''); // Tags

      match = /^#EXTM3U/.exec(newLine);
      if (match) {
        _this2.trigger('data', {
          type: 'tag',
          tagType: 'm3u'
        });
        return;
      }
      match = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'inf'
        };
        if (match[1]) {
          event.duration = parseFloat(match[1]);
        }
        if (match[2]) {
          event.title = match[2];
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'targetduration'
        };
        if (match[1]) {
          event.duration = parseInt(match[1], 10);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'version'
        };
        if (match[1]) {
          event.version = parseInt(match[1], 10);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'media-sequence'
        };
        if (match[1]) {
          event.number = parseInt(match[1], 10);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'discontinuity-sequence'
        };
        if (match[1]) {
          event.number = parseInt(match[1], 10);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'playlist-type'
        };
        if (match[1]) {
          event.playlistType = match[1];
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(newLine);
      if (match) {
        event = extends_extends(parseByterange(match[1]), {
          type: 'tag',
          tagType: 'byterange'
        });
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'allow-cache'
        };
        if (match[1]) {
          event.allowed = !/NO/.test(match[1]);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-MAP:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'map'
        };
        if (match[1]) {
          var attributes = parseAttributes(match[1]);
          if (attributes.URI) {
            event.uri = attributes.URI;
          }
          if (attributes.BYTERANGE) {
            event.byterange = parseByterange(attributes.BYTERANGE);
          }
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-STREAM-INF:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'stream-inf'
        };
        if (match[1]) {
          event.attributes = parseAttributes(match[1]);
          if (event.attributes.RESOLUTION) {
            var split = event.attributes.RESOLUTION.split('x');
            var resolution = {};
            if (split[0]) {
              resolution.width = parseInt(split[0], 10);
            }
            if (split[1]) {
              resolution.height = parseInt(split[1], 10);
            }
            event.attributes.RESOLUTION = resolution;
          }
          if (event.attributes.BANDWIDTH) {
            event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
          }
          if (event.attributes['FRAME-RATE']) {
            event.attributes['FRAME-RATE'] = parseFloat(event.attributes['FRAME-RATE']);
          }
          if (event.attributes['PROGRAM-ID']) {
            event.attributes['PROGRAM-ID'] = parseInt(event.attributes['PROGRAM-ID'], 10);
          }
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-MEDIA:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'media'
        };
        if (match[1]) {
          event.attributes = parseAttributes(match[1]);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-ENDLIST/.exec(newLine);
      if (match) {
        _this2.trigger('data', {
          type: 'tag',
          tagType: 'endlist'
        });
        return;
      }
      match = /^#EXT-X-DISCONTINUITY/.exec(newLine);
      if (match) {
        _this2.trigger('data', {
          type: 'tag',
          tagType: 'discontinuity'
        });
        return;
      }
      match = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'program-date-time'
        };
        if (match[1]) {
          event.dateTimeString = match[1];
          event.dateTimeObject = new Date(match[1]);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-KEY:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'key'
        };
        if (match[1]) {
          event.attributes = parseAttributes(match[1]); // parse the IV string into a Uint32Array

          if (event.attributes.IV) {
            if (event.attributes.IV.substring(0, 2).toLowerCase() === '0x') {
              event.attributes.IV = event.attributes.IV.substring(2);
            }
            event.attributes.IV = event.attributes.IV.match(/.{8}/g);
            event.attributes.IV[0] = parseInt(event.attributes.IV[0], 16);
            event.attributes.IV[1] = parseInt(event.attributes.IV[1], 16);
            event.attributes.IV[2] = parseInt(event.attributes.IV[2], 16);
            event.attributes.IV[3] = parseInt(event.attributes.IV[3], 16);
            event.attributes.IV = new Uint32Array(event.attributes.IV);
          }
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-START:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'start'
        };
        if (match[1]) {
          event.attributes = parseAttributes(match[1]);
          event.attributes['TIME-OFFSET'] = parseFloat(event.attributes['TIME-OFFSET']);
          event.attributes.PRECISE = /YES/.test(event.attributes.PRECISE);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'cue-out-cont'
        };
        if (match[1]) {
          event.data = match[1];
        } else {
          event.data = '';
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'cue-out'
        };
        if (match[1]) {
          event.data = match[1];
        } else {
          event.data = '';
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-CUE-IN:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: 'tag',
          tagType: 'cue-in'
        };
        if (match[1]) {
          event.data = match[1];
        } else {
          event.data = '';
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-SKIP:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'skip'
        };
        event.attributes = parseAttributes(match[1]);
        if (event.attributes.hasOwnProperty('SKIPPED-SEGMENTS')) {
          event.attributes['SKIPPED-SEGMENTS'] = parseInt(event.attributes['SKIPPED-SEGMENTS'], 10);
        }
        if (event.attributes.hasOwnProperty('RECENTLY-REMOVED-DATERANGES')) {
          event.attributes['RECENTLY-REMOVED-DATERANGES'] = event.attributes['RECENTLY-REMOVED-DATERANGES'].split(TAB);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-PART:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'part'
        };
        event.attributes = parseAttributes(match[1]);
        ['DURATION'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseFloat(event.attributes[key]);
          }
        });
        ['INDEPENDENT', 'GAP'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = /YES/.test(event.attributes[key]);
          }
        });
        if (event.attributes.hasOwnProperty('BYTERANGE')) {
          event.attributes.byterange = parseByterange(event.attributes.BYTERANGE);
        }
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'server-control'
        };
        event.attributes = parseAttributes(match[1]);
        ['CAN-SKIP-UNTIL', 'PART-HOLD-BACK', 'HOLD-BACK'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseFloat(event.attributes[key]);
          }
        });
        ['CAN-SKIP-DATERANGES', 'CAN-BLOCK-RELOAD'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = /YES/.test(event.attributes[key]);
          }
        });
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-PART-INF:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'part-inf'
        };
        event.attributes = parseAttributes(match[1]);
        ['PART-TARGET'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseFloat(event.attributes[key]);
          }
        });
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'preload-hint'
        };
        event.attributes = parseAttributes(match[1]);
        ['BYTERANGE-START', 'BYTERANGE-LENGTH'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseInt(event.attributes[key], 10);
            var subkey = key === 'BYTERANGE-LENGTH' ? 'length' : 'offset';
            event.attributes.byterange = event.attributes.byterange || {};
            event.attributes.byterange[subkey] = event.attributes[key]; // only keep the parsed byterange object.

            delete event.attributes[key];
          }
        });
        _this2.trigger('data', event);
        return;
      }
      match = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: 'tag',
          tagType: 'rendition-report'
        };
        event.attributes = parseAttributes(match[1]);
        ['LAST-MSN', 'LAST-PART'].forEach(function (key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseInt(event.attributes[key], 10);
          }
        });
        _this2.trigger('data', event);
        return;
      } // unknown tag type

      _this2.trigger('data', {
        type: 'tag',
        data: newLine.slice(4)
      });
    });
  }
  /**
   * Add a parser for custom headers
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */;

  _proto.addParser = function addParser(_ref) {
    var _this3 = this;
    var expression = _ref.expression,
      customType = _ref.customType,
      dataParser = _ref.dataParser,
      segment = _ref.segment;
    if (typeof dataParser !== 'function') {
      dataParser = function dataParser(line) {
        return line;
      };
    }
    this.customParsers.push(function (line) {
      var match = expression.exec(line);
      if (match) {
        _this3.trigger('data', {
          type: 'custom',
          data: dataParser(line),
          customType: customType,
          segment: segment
        });
        return true;
      }
    });
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */;

  _proto.addTagMapper = function addTagMapper(_ref2) {
    var expression = _ref2.expression,
      map = _ref2.map;
    var mapFn = function mapFn(line) {
      if (expression.test(line)) {
        return map(line);
      }
      return line;
    };
    this.tagMappers.push(mapFn);
  };
  return ParseStream;
}(Stream);
var camelCase = function camelCase(str) {
  return str.toLowerCase().replace(/-(\w)/g, function (a) {
    return a[1].toUpperCase();
  });
};
var camelCaseKeys = function camelCaseKeys(attributes) {
  var result = {};
  Object.keys(attributes).forEach(function (key) {
    result[camelCase(key)] = attributes[key];
  });
  return result;
}; // set SERVER-CONTROL hold back based upon targetDuration and partTargetDuration
// we need this helper because defaults are based upon targetDuration and
// partTargetDuration being set, but they may not be if SERVER-CONTROL appears before
// target durations are set.

var setHoldBack = function setHoldBack(manifest) {
  var serverControl = manifest.serverControl,
    targetDuration = manifest.targetDuration,
    partTargetDuration = manifest.partTargetDuration;
  if (!serverControl) {
    return;
  }
  var tag = '#EXT-X-SERVER-CONTROL';
  var hb = 'holdBack';
  var phb = 'partHoldBack';
  var minTargetDuration = targetDuration && targetDuration * 3;
  var minPartDuration = partTargetDuration && partTargetDuration * 2;
  if (targetDuration && !serverControl.hasOwnProperty(hb)) {
    serverControl[hb] = minTargetDuration;
    this.trigger('info', {
      message: tag + " defaulting HOLD-BACK to targetDuration * 3 (" + minTargetDuration + ")."
    });
  }
  if (minTargetDuration && serverControl[hb] < minTargetDuration) {
    this.trigger('warn', {
      message: tag + " clamping HOLD-BACK (" + serverControl[hb] + ") to targetDuration * 3 (" + minTargetDuration + ")"
    });
    serverControl[hb] = minTargetDuration;
  } // default no part hold back to part target duration * 3

  if (partTargetDuration && !serverControl.hasOwnProperty(phb)) {
    serverControl[phb] = partTargetDuration * 3;
    this.trigger('info', {
      message: tag + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + serverControl[phb] + ")."
    });
  } // if part hold back is too small default it to part target duration * 2

  if (partTargetDuration && serverControl[phb] < minPartDuration) {
    this.trigger('warn', {
      message: tag + " clamping PART-HOLD-BACK (" + serverControl[phb] + ") to partTargetDuration * 2 (" + minPartDuration + ")."
    });
    serverControl[phb] = minPartDuration;
  }
};
/**
 * A parser for M3U8 files. The current interpretation of the input is
 * exposed as a property `manifest` on parser objects. It's just two lines to
 * create and parse a manifest once you have the contents available as a string:
 *
 * ```js
 * var parser = new m3u8.Parser();
 * parser.push(xhr.responseText);
 * ```
 *
 * New input can later be applied to update the manifest object by calling
 * `push` again.
 *
 * The parser attempts to create a usable manifest object even if the
 * underlying input is somewhat nonsensical. It emits `info` and `warning`
 * events during the parse if it encounters input that seems invalid or
 * requires some property of the manifest object to be defaulted.
 *
 * @class Parser
 * @extends Stream
 */

var Parser = /*#__PURE__*/function (_Stream) {
  inheritsLoose_inheritsLoose(Parser, _Stream);
  function Parser() {
    var _this;
    _this = _Stream.call(this) || this;
    _this.lineStream = new LineStream();
    _this.parseStream = new ParseStream();
    _this.lineStream.pipe(_this.parseStream);
    /* eslint-disable consistent-this */

    var self = assertThisInitialized_assertThisInitialized(_this);
    /* eslint-enable consistent-this */

    var uris = [];
    var currentUri = {}; // if specified, the active EXT-X-MAP definition

    var currentMap; // if specified, the active decryption key

    var _key;
    var hasParts = false;
    var noop = function noop() {};
    var defaultMediaGroups = {
      'AUDIO': {},
      'VIDEO': {},
      'CLOSED-CAPTIONS': {},
      'SUBTITLES': {}
    }; // This is the Widevine UUID from DASH IF IOP. The same exact string is
    // used in MPDs with Widevine encrypted streams.

    var widevineUuid = 'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed'; // group segments into numbered timelines delineated by discontinuities

    var currentTimeline = 0; // the manifest is empty until the parse stream begins delivering data

    _this.manifest = {
      allowCache: true,
      discontinuityStarts: [],
      segments: []
    }; // keep track of the last seen segment's byte range end, as segments are not required
    // to provide the offset, in which case it defaults to the next byte after the
    // previous segment

    var lastByterangeEnd = 0; // keep track of the last seen part's byte range end.

    var lastPartByterangeEnd = 0;
    _this.on('end', function () {
      // only add preloadSegment if we don't yet have a uri for it.
      // and we actually have parts/preloadHints
      if (currentUri.uri || !currentUri.parts && !currentUri.preloadHints) {
        return;
      }
      if (!currentUri.map && currentMap) {
        currentUri.map = currentMap;
      }
      if (!currentUri.key && _key) {
        currentUri.key = _key;
      }
      if (!currentUri.timeline && typeof currentTimeline === 'number') {
        currentUri.timeline = currentTimeline;
      }
      _this.manifest.preloadSegment = currentUri;
    }); // update the manifest with the m3u8 entry from the parse stream

    _this.parseStream.on('data', function (entry) {
      var mediaGroup;
      var rendition;
      ({
        tag: function tag() {
          // switch based on the tag type
          (({
            version: function version() {
              if (entry.version) {
                this.manifest.version = entry.version;
              }
            },
            'allow-cache': function allowCache() {
              this.manifest.allowCache = entry.allowed;
              if (!('allowed' in entry)) {
                this.trigger('info', {
                  message: 'defaulting allowCache to YES'
                });
                this.manifest.allowCache = true;
              }
            },
            byterange: function byterange() {
              var byterange = {};
              if ('length' in entry) {
                currentUri.byterange = byterange;
                byterange.length = entry.length;
                if (!('offset' in entry)) {
                  /*
                   * From the latest spec (as of this writing):
                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.2
                   *
                   * Same text since EXT-X-BYTERANGE's introduction in draft 7:
                   * https://tools.ietf.org/html/draft-pantos-http-live-streaming-07#section-3.3.1)
                   *
                   * "If o [offset] is not present, the sub-range begins at the next byte
                   * following the sub-range of the previous media segment."
                   */
                  entry.offset = lastByterangeEnd;
                }
              }
              if ('offset' in entry) {
                currentUri.byterange = byterange;
                byterange.offset = entry.offset;
              }
              lastByterangeEnd = byterange.offset + byterange.length;
            },
            endlist: function endlist() {
              this.manifest.endList = true;
            },
            inf: function inf() {
              if (!('mediaSequence' in this.manifest)) {
                this.manifest.mediaSequence = 0;
                this.trigger('info', {
                  message: 'defaulting media sequence to zero'
                });
              }
              if (!('discontinuitySequence' in this.manifest)) {
                this.manifest.discontinuitySequence = 0;
                this.trigger('info', {
                  message: 'defaulting discontinuity sequence to zero'
                });
              }
              if (entry.duration > 0) {
                currentUri.duration = entry.duration;
              }
              if (entry.duration === 0) {
                currentUri.duration = 0.01;
                this.trigger('info', {
                  message: 'updating zero segment duration to a small value'
                });
              }
              this.manifest.segments = uris;
            },
            key: function key() {
              if (!entry.attributes) {
                this.trigger('warn', {
                  message: 'ignoring key declaration without attribute list'
                });
                return;
              } // clear the active encryption key

              if (entry.attributes.METHOD === 'NONE') {
                _key = null;
                return;
              }
              if (!entry.attributes.URI) {
                this.trigger('warn', {
                  message: 'ignoring key declaration without URI'
                });
                return;
              }
              if (entry.attributes.KEYFORMAT === 'com.apple.streamingkeydelivery') {
                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.

                this.manifest.contentProtection['com.apple.fps.1_0'] = {
                  attributes: entry.attributes
                };
                return;
              }
              if (entry.attributes.KEYFORMAT === 'com.microsoft.playready') {
                this.manifest.contentProtection = this.manifest.contentProtection || {}; // TODO: add full support for this.

                this.manifest.contentProtection['com.microsoft.playready'] = {
                  uri: entry.attributes.URI
                };
                return;
              } // check if the content is encrypted for Widevine
              // Widevine/HLS spec: https://storage.googleapis.com/wvdocs/Widevine_DRM_HLS.pdf

              if (entry.attributes.KEYFORMAT === widevineUuid) {
                var VALID_METHODS = ['SAMPLE-AES', 'SAMPLE-AES-CTR', 'SAMPLE-AES-CENC'];
                if (VALID_METHODS.indexOf(entry.attributes.METHOD) === -1) {
                  this.trigger('warn', {
                    message: 'invalid key method provided for Widevine'
                  });
                  return;
                }
                if (entry.attributes.METHOD === 'SAMPLE-AES-CENC') {
                  this.trigger('warn', {
                    message: 'SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead'
                  });
                }
                if (entry.attributes.URI.substring(0, 23) !== 'data:text/plain;base64,') {
                  this.trigger('warn', {
                    message: 'invalid key URI provided for Widevine'
                  });
                  return;
                }
                if (!(entry.attributes.KEYID && entry.attributes.KEYID.substring(0, 2) === '0x')) {
                  this.trigger('warn', {
                    message: 'invalid key ID provided for Widevine'
                  });
                  return;
                } // if Widevine key attributes are valid, store them as `contentProtection`
                // on the manifest to emulate Widevine tag structure in a DASH mpd

                this.manifest.contentProtection = this.manifest.contentProtection || {};
                this.manifest.contentProtection['com.widevine.alpha'] = {
                  attributes: {
                    schemeIdUri: entry.attributes.KEYFORMAT,
                    // remove '0x' from the key id string
                    keyId: entry.attributes.KEYID.substring(2)
                  },
                  // decode the base64-encoded PSSH box
                  pssh: decodeB64ToUint8Array(entry.attributes.URI.split(',')[1])
                };
                return;
              }
              if (!entry.attributes.METHOD) {
                this.trigger('warn', {
                  message: 'defaulting key method to AES-128'
                });
              } // setup an encryption key for upcoming segments

              _key = {
                method: entry.attributes.METHOD || 'AES-128',
                uri: entry.attributes.URI
              };
              if (typeof entry.attributes.IV !== 'undefined') {
                _key.iv = entry.attributes.IV;
              }
            },
            'media-sequence': function mediaSequence() {
              if (!isFinite(entry.number)) {
                this.trigger('warn', {
                  message: 'ignoring invalid media sequence: ' + entry.number
                });
                return;
              }
              this.manifest.mediaSequence = entry.number;
            },
            'discontinuity-sequence': function discontinuitySequence() {
              if (!isFinite(entry.number)) {
                this.trigger('warn', {
                  message: 'ignoring invalid discontinuity sequence: ' + entry.number
                });
                return;
              }
              this.manifest.discontinuitySequence = entry.number;
              currentTimeline = entry.number;
            },
            'playlist-type': function playlistType() {
              if (!/VOD|EVENT/.test(entry.playlistType)) {
                this.trigger('warn', {
                  message: 'ignoring unknown playlist type: ' + entry.playlist
                });
                return;
              }
              this.manifest.playlistType = entry.playlistType;
            },
            map: function map() {
              currentMap = {};
              if (entry.uri) {
                currentMap.uri = entry.uri;
              }
              if (entry.byterange) {
                currentMap.byterange = entry.byterange;
              }
              if (_key) {
                currentMap.key = _key;
              }
            },
            'stream-inf': function streamInf() {
              this.manifest.playlists = uris;
              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
              if (!entry.attributes) {
                this.trigger('warn', {
                  message: 'ignoring empty stream-inf attributes'
                });
                return;
              }
              if (!currentUri.attributes) {
                currentUri.attributes = {};
              }
              extends_extends(currentUri.attributes, entry.attributes);
            },
            media: function media() {
              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
              if (!(entry.attributes && entry.attributes.TYPE && entry.attributes['GROUP-ID'] && entry.attributes.NAME)) {
                this.trigger('warn', {
                  message: 'ignoring incomplete or missing media group'
                });
                return;
              } // find the media group, creating defaults as necessary

              var mediaGroupType = this.manifest.mediaGroups[entry.attributes.TYPE];
              mediaGroupType[entry.attributes['GROUP-ID']] = mediaGroupType[entry.attributes['GROUP-ID']] || {};
              mediaGroup = mediaGroupType[entry.attributes['GROUP-ID']]; // collect the rendition metadata

              rendition = {
                default: /yes/i.test(entry.attributes.DEFAULT)
              };
              if (rendition.default) {
                rendition.autoselect = true;
              } else {
                rendition.autoselect = /yes/i.test(entry.attributes.AUTOSELECT);
              }
              if (entry.attributes.LANGUAGE) {
                rendition.language = entry.attributes.LANGUAGE;
              }
              if (entry.attributes.URI) {
                rendition.uri = entry.attributes.URI;
              }
              if (entry.attributes['INSTREAM-ID']) {
                rendition.instreamId = entry.attributes['INSTREAM-ID'];
              }
              if (entry.attributes.CHARACTERISTICS) {
                rendition.characteristics = entry.attributes.CHARACTERISTICS;
              }
              if (entry.attributes.FORCED) {
                rendition.forced = /yes/i.test(entry.attributes.FORCED);
              } // insert the new rendition

              mediaGroup[entry.attributes.NAME] = rendition;
            },
            discontinuity: function discontinuity() {
              currentTimeline += 1;
              currentUri.discontinuity = true;
              this.manifest.discontinuityStarts.push(uris.length);
            },
            'program-date-time': function programDateTime() {
              if (typeof this.manifest.dateTimeString === 'undefined') {
                // PROGRAM-DATE-TIME is a media-segment tag, but for backwards
                // compatibility, we add the first occurence of the PROGRAM-DATE-TIME tag
                // to the manifest object
                // TODO: Consider removing this in future major version
                this.manifest.dateTimeString = entry.dateTimeString;
                this.manifest.dateTimeObject = entry.dateTimeObject;
              }
              currentUri.dateTimeString = entry.dateTimeString;
              currentUri.dateTimeObject = entry.dateTimeObject;
            },
            targetduration: function targetduration() {
              if (!isFinite(entry.duration) || entry.duration < 0) {
                this.trigger('warn', {
                  message: 'ignoring invalid target duration: ' + entry.duration
                });
                return;
              }
              this.manifest.targetDuration = entry.duration;
              setHoldBack.call(this, this.manifest);
            },
            start: function start() {
              if (!entry.attributes || isNaN(entry.attributes['TIME-OFFSET'])) {
                this.trigger('warn', {
                  message: 'ignoring start declaration without appropriate attribute list'
                });
                return;
              }
              this.manifest.start = {
                timeOffset: entry.attributes['TIME-OFFSET'],
                precise: entry.attributes.PRECISE
              };
            },
            'cue-out': function cueOut() {
              currentUri.cueOut = entry.data;
            },
            'cue-out-cont': function cueOutCont() {
              currentUri.cueOutCont = entry.data;
            },
            'cue-in': function cueIn() {
              currentUri.cueIn = entry.data;
            },
            'skip': function skip() {
              this.manifest.skip = camelCaseKeys(entry.attributes);
              this.warnOnMissingAttributes_('#EXT-X-SKIP', entry.attributes, ['SKIPPED-SEGMENTS']);
            },
            'part': function part() {
              var _this2 = this;
              hasParts = true; // parts are always specifed before a segment

              var segmentIndex = this.manifest.segments.length;
              var part = camelCaseKeys(entry.attributes);
              currentUri.parts = currentUri.parts || [];
              currentUri.parts.push(part);
              if (part.byterange) {
                if (!part.byterange.hasOwnProperty('offset')) {
                  part.byterange.offset = lastPartByterangeEnd;
                }
                lastPartByterangeEnd = part.byterange.offset + part.byterange.length;
              }
              var partIndex = currentUri.parts.length - 1;
              this.warnOnMissingAttributes_("#EXT-X-PART #" + partIndex + " for segment #" + segmentIndex, entry.attributes, ['URI', 'DURATION']);
              if (this.manifest.renditionReports) {
                this.manifest.renditionReports.forEach(function (r, i) {
                  if (!r.hasOwnProperty('lastPart')) {
                    _this2.trigger('warn', {
                      message: "#EXT-X-RENDITION-REPORT #" + i + " lacks required attribute(s): LAST-PART"
                    });
                  }
                });
              }
            },
            'server-control': function serverControl() {
              var attrs = this.manifest.serverControl = camelCaseKeys(entry.attributes);
              if (!attrs.hasOwnProperty('canBlockReload')) {
                attrs.canBlockReload = false;
                this.trigger('info', {
                  message: '#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false'
                });
              }
              setHoldBack.call(this, this.manifest);
              if (attrs.canSkipDateranges && !attrs.hasOwnProperty('canSkipUntil')) {
                this.trigger('warn', {
                  message: '#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set'
                });
              }
            },
            'preload-hint': function preloadHint() {
              // parts are always specifed before a segment
              var segmentIndex = this.manifest.segments.length;
              var hint = camelCaseKeys(entry.attributes);
              var isPart = hint.type && hint.type === 'PART';
              currentUri.preloadHints = currentUri.preloadHints || [];
              currentUri.preloadHints.push(hint);
              if (hint.byterange) {
                if (!hint.byterange.hasOwnProperty('offset')) {
                  // use last part byterange end or zero if not a part.
                  hint.byterange.offset = isPart ? lastPartByterangeEnd : 0;
                  if (isPart) {
                    lastPartByterangeEnd = hint.byterange.offset + hint.byterange.length;
                  }
                }
              }
              var index = currentUri.preloadHints.length - 1;
              this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex, entry.attributes, ['TYPE', 'URI']);
              if (!hint.type) {
                return;
              } // search through all preload hints except for the current one for
              // a duplicate type.

              for (var i = 0; i < currentUri.preloadHints.length - 1; i++) {
                var otherHint = currentUri.preloadHints[i];
                if (!otherHint.type) {
                  continue;
                }
                if (otherHint.type === hint.type) {
                  this.trigger('warn', {
                    message: "#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex + " has the same TYPE " + hint.type + " as preload hint #" + i
                  });
                }
              }
            },
            'rendition-report': function renditionReport() {
              var report = camelCaseKeys(entry.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [];
              this.manifest.renditionReports.push(report);
              var index = this.manifest.renditionReports.length - 1;
              var required = ['LAST-MSN', 'URI'];
              if (hasParts) {
                required.push('LAST-PART');
              }
              this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + index, entry.attributes, required);
            },
            'part-inf': function partInf() {
              this.manifest.partInf = camelCaseKeys(entry.attributes);
              this.warnOnMissingAttributes_('#EXT-X-PART-INF', entry.attributes, ['PART-TARGET']);
              if (this.manifest.partInf.partTarget) {
                this.manifest.partTargetDuration = this.manifest.partInf.partTarget;
              }
              setHoldBack.call(this, this.manifest);
            }
          })[entry.tagType] || noop).call(self);
        },
        uri: function uri() {
          currentUri.uri = entry.uri;
          uris.push(currentUri); // if no explicit duration was declared, use the target duration

          if (this.manifest.targetDuration && !('duration' in currentUri)) {
            this.trigger('warn', {
              message: 'defaulting segment duration to the target duration'
            });
            currentUri.duration = this.manifest.targetDuration;
          } // annotate with encryption information, if necessary

          if (_key) {
            currentUri.key = _key;
          }
          currentUri.timeline = currentTimeline; // annotate with initialization segment information, if necessary

          if (currentMap) {
            currentUri.map = currentMap;
          } // reset the last byterange end as it needs to be 0 between parts

          lastPartByterangeEnd = 0; // prepare for the next URI

          currentUri = {};
        },
        comment: function comment() {// comments are not important for playback
        },
        custom: function custom() {
          // if this is segment-level data attach the output to the segment
          if (entry.segment) {
            currentUri.custom = currentUri.custom || {};
            currentUri.custom[entry.customType] = entry.data; // if this is manifest-level data attach to the top level manifest object
          } else {
            this.manifest.custom = this.manifest.custom || {};
            this.manifest.custom[entry.customType] = entry.data;
          }
        }
      })[entry.type].call(self);
    });
    return _this;
  }
  var _proto = Parser.prototype;
  _proto.warnOnMissingAttributes_ = function warnOnMissingAttributes_(identifier, attributes, required) {
    var missing = [];
    required.forEach(function (key) {
      if (!attributes.hasOwnProperty(key)) {
        missing.push(key);
      }
    });
    if (missing.length) {
      this.trigger('warn', {
        message: identifier + " lacks required attribute(s): " + missing.join(', ')
      });
    }
  }
  /**
   * Parse the input string and update the manifest object.
   *
   * @param {string} chunk a potentially incomplete portion of the manifest
   */;

  _proto.push = function push(chunk) {
    this.lineStream.push(chunk);
  }
  /**
   * Flush any remaining input. This can be handy if the last line of an M3U8
   * manifest did not contain a trailing newline but the file has been
   * completely received.
   */;

  _proto.end = function end() {
    // flush any buffered input
    this.lineStream.push('\n');
    this.trigger('end');
  }
  /**
   * Add an additional parser for non-standard tags
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.type         the type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */;

  _proto.addParser = function addParser(options) {
    this.parseStream.addParser(options);
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */;

  _proto.addTagMapper = function addTagMapper(options) {
    this.parseStream.addTagMapper(options);
  };
  return Parser;
}(Stream);

;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/codecs.js











var regexs = {
  // to determine mime types
  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
  // to determine if a codec is audio or video
  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
  text: /^(stpp.ttml.im1t)/,
  // mux.js support regex
  muxerVideo: /^(avc0?1)/,
  muxerAudio: /^(mp4a)/,
  // match nothing as muxer does not support text right now.
  // there cannot never be a character before the start of a string
  // so this matches nothing.
  muxerText: /a^/
};
var mediaTypes = ['video', 'audio', 'text'];
var upperMediaTypes = ['Video', 'Audio', 'Text'];
/**
 * Replace the old apple-style `avc1.<dd>.<dd>` codec string with the standard
 * `avc1.<hhhhhh>`
 *
 * @param {string} codec
 *        Codec string to translate
 * @return {string}
 *         The translated codec string
 */

var translateLegacyCodec = function translateLegacyCodec(codec) {
  if (!codec) {
    return codec;
  }
  return codec.replace(/avc1\.(\d+)\.(\d+)/i, function (orig, profile, avcLevel) {
    var profileHex = ('00' + Number(profile).toString(16)).slice(-2);
    var avcLevelHex = ('00' + Number(avcLevel).toString(16)).slice(-2);
    return 'avc1.' + profileHex + '00' + avcLevelHex;
  });
};
/**
 * Replace the old apple-style `avc1.<dd>.<dd>` codec strings with the standard
 * `avc1.<hhhhhh>`
 *
 * @param {string[]} codecs
 *        An array of codec strings to translate
 * @return {string[]}
 *         The translated array of codec strings
 */

var translateLegacyCodecs = function translateLegacyCodecs(codecs) {
  return codecs.map(translateLegacyCodec);
};
/**
 * Replace codecs in the codec string with the old apple-style `avc1.<dd>.<dd>` to the
 * standard `avc1.<hhhhhh>`.
 *
 * @param {string} codecString
 *        The codec string
 * @return {string}
 *         The codec string with old apple-style codecs replaced
 *
 * @private
 */

var mapLegacyAvcCodecs = function mapLegacyAvcCodecs(codecString) {
  return codecString.replace(/avc1\.(\d+)\.(\d+)/i, function (match) {
    return translateLegacyCodecs([match])[0];
  });
};
/**
 * @typedef {Object} ParsedCodecInfo
 * @property {number} codecCount
 *           Number of codecs parsed
 * @property {string} [videoCodec]
 *           Parsed video codec (if found)
 * @property {string} [videoObjectTypeIndicator]
 *           Video object type indicator (if found)
 * @property {string|null} audioProfile
 *           Audio profile
 */

/**
 * Parses a codec string to retrieve the number of codecs specified, the video codec and
 * object type indicator, and the audio profile.
 *
 * @param {string} [codecString]
 *        The codec string to parse
 * @return {ParsedCodecInfo}
 *         Parsed codec info
 */

var parseCodecs = function parseCodecs(codecString) {
  if (codecString === void 0) {
    codecString = '';
  }
  var codecs = codecString.split(',');
  var result = [];
  codecs.forEach(function (codec) {
    codec = codec.trim();
    var codecType;
    mediaTypes.forEach(function (name) {
      var match = regexs[name].exec(codec.toLowerCase());
      if (!match || match.length <= 1) {
        return;
      }
      codecType = name; // maintain codec case

      var type = codec.substring(0, match[1].length);
      var details = codec.replace(type, '');
      result.push({
        type: type,
        details: details,
        mediaType: name
      });
    });
    if (!codecType) {
      result.push({
        type: codec,
        details: '',
        mediaType: 'unknown'
      });
    }
  });
  return result;
};
/**
 * Returns a ParsedCodecInfo object for the default alternate audio playlist if there is
 * a default alternate audio playlist for the provided audio group.
 *
 * @param {Object} master
 *        The master playlist
 * @param {string} audioGroupId
 *        ID of the audio group for which to find the default codec info
 * @return {ParsedCodecInfo}
 *         Parsed codec info
 */

var codecsFromDefault = function codecsFromDefault(master, audioGroupId) {
  if (!master.mediaGroups.AUDIO || !audioGroupId) {
    return null;
  }
  var audioGroup = master.mediaGroups.AUDIO[audioGroupId];
  if (!audioGroup) {
    return null;
  }
  for (var name in audioGroup) {
    var audioType = audioGroup[name];
    if (audioType.default && audioType.playlists) {
      // codec should be the same for all playlists within the audio type
      return parseCodecs(audioType.playlists[0].attributes.CODECS);
    }
  }
  return null;
};
var isVideoCodec = function isVideoCodec(codec) {
  if (codec === void 0) {
    codec = '';
  }
  return regexs.video.test(codec.trim().toLowerCase());
};
var isAudioCodec = function isAudioCodec(codec) {
  if (codec === void 0) {
    codec = '';
  }
  return regexs.audio.test(codec.trim().toLowerCase());
};
var isTextCodec = function isTextCodec(codec) {
  if (codec === void 0) {
    codec = '';
  }
  return regexs.text.test(codec.trim().toLowerCase());
};
var getMimeForCodec = function getMimeForCodec(codecString) {
  if (!codecString || typeof codecString !== 'string') {
    return;
  }
  var codecs = codecString.toLowerCase().split(',').map(function (c) {
    return translateLegacyCodec(c.trim());
  }); // default to video type

  var type = 'video'; // only change to audio type if the only codec we have is
  // audio

  if (codecs.length === 1 && isAudioCodec(codecs[0])) {
    type = 'audio';
  } else if (codecs.length === 1 && isTextCodec(codecs[0])) {
    // text uses application/<container> for now
    type = 'application';
  } // default the container to mp4

  var container = 'mp4'; // every codec must be able to go into the container
  // for that container to be the correct one

  if (codecs.every(function (c) {
    return regexs.mp4.test(c);
  })) {
    container = 'mp4';
  } else if (codecs.every(function (c) {
    return regexs.webm.test(c);
  })) {
    container = 'webm';
  } else if (codecs.every(function (c) {
    return regexs.ogg.test(c);
  })) {
    container = 'ogg';
  }
  return type + "/" + container + ";codecs=\"" + codecString + "\"";
};
var browserSupportsCodec = function browserSupportsCodec(codecString) {
  if (codecString === void 0) {
    codecString = '';
  }
  return (window_default()).MediaSource && (window_default()).MediaSource.isTypeSupported && window_default().MediaSource.isTypeSupported(getMimeForCodec(codecString)) || false;
};
var muxerSupportsCodec = function muxerSupportsCodec(codecString) {
  if (codecString === void 0) {
    codecString = '';
  }
  return codecString.toLowerCase().split(',').every(function (codec) {
    codec = codec.trim(); // any match is supported.

    for (var i = 0; i < upperMediaTypes.length; i++) {
      var type = upperMediaTypes[i];
      if (regexs["muxer" + type].test(codec)) {
        return true;
      }
    }
    return false;
  });
};
var DEFAULT_AUDIO_CODEC = 'mp4a.40.2';
var DEFAULT_VIDEO_CODEC = 'avc1.4d400d';
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/media-types.js
var MPEGURL_REGEX = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
var DASH_REGEX = /^application\/dash\+xml/i;
/**
 * Returns a string that describes the type of source based on a video source object's
 * media type.
 *
 * @see {@link https://dev.w3.org/html5/pf-summary/video.html#dom-source-type|Source Type}
 *
 * @param {string} type
 *        Video source object media type
 * @return {('hls'|'dash'|'vhs-json'|null)}
 *         VHS source type string
 */

var simpleTypeFromSourceType = function simpleTypeFromSourceType(type) {
  if (MPEGURL_REGEX.test(type)) {
    return 'hls';
  }
  if (DASH_REGEX.test(type)) {
    return 'dash';
  } // Denotes the special case of a manifest object passed to http-streaming instead of a
  // source URL.
  //
  // See https://en.wikipedia.org/wiki/Media_type for details on specifying media types.
  //
  // In this case, vnd stands for vendor, video.js for the organization, VHS for this
  // project, and the +json suffix identifies the structure of the media type.

  if (type === 'application/vnd.videojs.vhs+json') {
    return 'vhs-json';
  }
  return null;
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.typed-array.uint16-array.js
var es_typed_array_uint16_array = __webpack_require__(8255);
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/byte-helpers.js

































 // const log2 = Math.log2 ? Math.log2 : (x) => (Math.log(x) / Math.log(2));

var repeat = function repeat(str, len) {
  var acc = '';
  while (len--) {
    acc += str;
  }
  return acc;
}; // count the number of bits it would take to represent a number
// we used to do this with log2 but BigInt does not support builtin math
// Math.ceil(log2(x));

var countBits = function countBits(x) {
  return x.toString(2).length;
}; // count the number of whole bytes it would take to represent a number

var countBytes = function countBytes(x) {
  return Math.ceil(countBits(x) / 8);
};
var byte_helpers_padStart = function padStart(b, len, str) {
  if (str === void 0) {
    str = ' ';
  }
  return (repeat(str, len) + b.toString()).slice(-len);
};
var isArrayBufferView = function isArrayBufferView(obj) {
  if (ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(obj);
  }
  return obj && obj.buffer instanceof ArrayBuffer;
};
var isTypedArray = function isTypedArray(obj) {
  return isArrayBufferView(obj);
};
var byte_helpers_toUint8 = function toUint8(bytes) {
  if (bytes instanceof Uint8Array) {
    return bytes;
  }
  if (!Array.isArray(bytes) && !isTypedArray(bytes) && !(bytes instanceof ArrayBuffer)) {
    // any non-number or NaN leads to empty uint8array
    // eslint-disable-next-line
    if (typeof bytes !== 'number' || typeof bytes === 'number' && bytes !== bytes) {
      bytes = 0;
    } else {
      bytes = [bytes];
    }
  }
  return new Uint8Array(bytes && bytes.buffer || bytes, bytes && bytes.byteOffset || 0, bytes && bytes.byteLength || 0);
};
var byte_helpers_toHexString = function toHexString(bytes) {
  bytes = byte_helpers_toUint8(bytes);
  var str = '';
  for (var i = 0; i < bytes.length; i++) {
    str += byte_helpers_padStart(bytes[i].toString(16), 2, '0');
  }
  return str;
};
var byte_helpers_toBinaryString = function toBinaryString(bytes) {
  bytes = byte_helpers_toUint8(bytes);
  var str = '';
  for (var i = 0; i < bytes.length; i++) {
    str += byte_helpers_padStart(bytes[i].toString(2), 8, '0');
  }
  return str;
};
var BigInt = (window_default()).BigInt || Number;
var BYTE_TABLE = [BigInt('0x1'), BigInt('0x100'), BigInt('0x10000'), BigInt('0x1000000'), BigInt('0x100000000'), BigInt('0x10000000000'), BigInt('0x1000000000000'), BigInt('0x100000000000000'), BigInt('0x10000000000000000')];
var ENDIANNESS = function () {
  var a = new Uint16Array([0xFFCC]);
  var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
  if (b[0] === 0xFF) {
    return 'big';
  }
  if (b[0] === 0xCC) {
    return 'little';
  }
  return 'unknown';
}();
var IS_BIG_ENDIAN = ENDIANNESS === 'big';
var IS_LITTLE_ENDIAN = ENDIANNESS === 'little';
var byte_helpers_bytesToNumber = function bytesToNumber(bytes, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$signed = _ref.signed,
    signed = _ref$signed === void 0 ? false : _ref$signed,
    _ref$le = _ref.le,
    le = _ref$le === void 0 ? false : _ref$le;
  bytes = byte_helpers_toUint8(bytes);
  var fn = le ? 'reduce' : 'reduceRight';
  var obj = bytes[fn] ? bytes[fn] : Array.prototype[fn];
  var number = obj.call(bytes, function (total, byte, i) {
    var exponent = le ? i : Math.abs(i + 1 - bytes.length);
    return total + BigInt(byte) * BYTE_TABLE[exponent];
  }, BigInt(0));
  if (signed) {
    var max = BYTE_TABLE[bytes.length] / BigInt(2) - BigInt(1);
    number = BigInt(number);
    if (number > max) {
      number -= max;
      number -= max;
      number -= BigInt(2);
    }
  }
  return Number(number);
};
var numberToBytes = function numberToBytes(number, _temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    _ref2$le = _ref2.le,
    le = _ref2$le === void 0 ? false : _ref2$le;

  // eslint-disable-next-line
  if (typeof number !== 'bigint' && typeof number !== 'number' || typeof number === 'number' && number !== number) {
    number = 0;
  }
  number = BigInt(number);
  var byteCount = countBytes(number);
  var bytes = new Uint8Array(new ArrayBuffer(byteCount));
  for (var i = 0; i < byteCount; i++) {
    var byteIndex = le ? i : Math.abs(i + 1 - bytes.length);
    bytes[byteIndex] = Number(number / BYTE_TABLE[i] & BigInt(0xFF));
    if (number < 0) {
      bytes[byteIndex] = Math.abs(~bytes[byteIndex]);
      bytes[byteIndex] -= i === 0 ? 1 : 2;
    }
  }
  return bytes;
};
var byte_helpers_bytesToString = function bytesToString(bytes) {
  if (!bytes) {
    return '';
  } // TODO: should toUint8 handle cases where we only have 8 bytes
  // but report more since this is a Uint16+ Array?

  bytes = Array.prototype.slice.call(bytes);
  var string = String.fromCharCode.apply(null, byte_helpers_toUint8(bytes));
  try {
    return decodeURIComponent(escape(string));
  } catch (e) {// if decodeURIComponent/escape fails, we are dealing with partial
    // or full non string data. Just return the potentially garbled string.
  }
  return string;
};
var stringToBytes = function stringToBytes(string, stringIsBytes) {
  if (typeof string !== 'string' && string && typeof string.toString === 'function') {
    string = string.toString();
  }
  if (typeof string !== 'string') {
    return new Uint8Array();
  } // If the string already is bytes, we don't have to do this
  // otherwise we do this so that we split multi length characters
  // into individual bytes

  if (!stringIsBytes) {
    string = unescape(encodeURIComponent(string));
  }
  var view = new Uint8Array(string.length);
  for (var i = 0; i < string.length; i++) {
    view[i] = string.charCodeAt(i);
  }
  return view;
};
var concatTypedArrays = function concatTypedArrays() {
  for (var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++) {
    buffers[_key] = arguments[_key];
  }
  buffers = buffers.filter(function (b) {
    return b && (b.byteLength || b.length) && typeof b !== 'string';
  });
  if (buffers.length <= 1) {
    // for 0 length we will return empty uint8
    // for 1 length we return the first uint8
    return byte_helpers_toUint8(buffers[0]);
  }
  var totalLen = buffers.reduce(function (total, buf, i) {
    return total + (buf.byteLength || buf.length);
  }, 0);
  var tempBuffer = new Uint8Array(totalLen);
  var offset = 0;
  buffers.forEach(function (buf) {
    buf = byte_helpers_toUint8(buf);
    tempBuffer.set(buf, offset);
    offset += buf.byteLength;
  });
  return tempBuffer;
};
/**
 * Check if the bytes "b" are contained within bytes "a".
 *
 * @param {Uint8Array|Array} a
 *        Bytes to check in
 *
 * @param {Uint8Array|Array} b
 *        Bytes to check for
 *
 * @param {Object} options
 *        options
 *
 * @param {Array|Uint8Array} [offset=0]
 *        offset to use when looking at bytes in a
 *
 * @param {Array|Uint8Array} [mask=[]]
 *        mask to use on bytes before comparison.
 *
 * @return {boolean}
 *         If all bytes in b are inside of a, taking into account
 *         bit masks.
 */

var byte_helpers_bytesMatch = function bytesMatch(a, b, _temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3,
    _ref3$offset = _ref3.offset,
    offset = _ref3$offset === void 0 ? 0 : _ref3$offset,
    _ref3$mask = _ref3.mask,
    mask = _ref3$mask === void 0 ? [] : _ref3$mask;
  a = byte_helpers_toUint8(a);
  b = byte_helpers_toUint8(b); // ie 11 does not support uint8 every

  var fn = b.every ? b.every : Array.prototype.every;
  return b.length && a.length - offset >= b.length &&
  // ie 11 doesn't support every on uin8
  fn.call(b, function (bByte, i) {
    var aByte = mask[i] ? mask[i] & a[offset + i] : a[offset + i];
    return bByte === aByte;
  });
};
var sliceBytes = function sliceBytes(src, start, end) {
  if (Uint8Array.prototype.slice) {
    return Uint8Array.prototype.slice.call(src, start, end);
  }
  return new Uint8Array(Array.prototype.slice.call(src, start, end));
};
var reverseBytes = function reverseBytes(src) {
  if (src.reverse) {
    return src.reverse();
  }
  return Array.prototype.reverse.call(src);
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/media-groups.js

/**
 * Loops through all supported media groups in master and calls the provided
 * callback for each group
 *
 * @param {Object} master
 *        The parsed master manifest object
 * @param {string[]} groups
 *        The media groups to call the callback for
 * @param {Function} callback
 *        Callback to call for each media group
 */
var forEachMediaGroup = function forEachMediaGroup(master, groups, callback) {
  groups.forEach(function (mediaType) {
    for (var groupKey in master.mediaGroups[mediaType]) {
      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
        callback(mediaProperties, mediaType, groupKey, labelKey);
      }
    }
  });
};
// EXTERNAL MODULE: ./node_modules/@xmldom/xmldom/lib/index.js
var xmldom_lib = __webpack_require__(23399);
;// CONCATENATED MODULE: ./node_modules/mpd-parser/dist/mpd-parser.es.js






















function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
/*! @name mpd-parser @version 0.22.1 @license Apache-2.0 */





var version = "0.22.1";
var isObject = function isObject(obj) {
  return !!obj && _typeof(obj) === 'object';
};
var merge = function merge() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  return objects.reduce(function (result, source) {
    if (_typeof(source) !== 'object') {
      return result;
    }
    Object.keys(source).forEach(function (key) {
      if (Array.isArray(result[key]) && Array.isArray(source[key])) {
        result[key] = result[key].concat(source[key]);
      } else if (isObject(result[key]) && isObject(source[key])) {
        result[key] = merge(result[key], source[key]);
      } else {
        result[key] = source[key];
      }
    });
    return result;
  }, {});
};
var values = function values(o) {
  return Object.keys(o).map(function (k) {
    return o[k];
  });
};
var range = function range(start, end) {
  var result = [];
  for (var i = start; i < end; i++) {
    result.push(i);
  }
  return result;
};
var flatten = function flatten(lists) {
  return lists.reduce(function (x, y) {
    return x.concat(y);
  }, []);
};
var from = function from(list) {
  if (!list.length) {
    return [];
  }
  var result = [];
  for (var i = 0; i < list.length; i++) {
    result.push(list[i]);
  }
  return result;
};
var findIndexes = function findIndexes(l, key) {
  return l.reduce(function (a, e, i) {
    if (e[key]) {
      a.push(i);
    }
    return a;
  }, []);
};
/**
 * Returns the first index that satisfies the matching function, or -1 if not found.
 *
 * Only necessary because of IE11 support.
 *
 * @param {Array} list - the list to search through
 * @param {Function} matchingFunction - the matching function
 *
 * @return {number} the matching index or -1 if not found
 */

var findIndex = function findIndex(list, matchingFunction) {
  for (var i = 0; i < list.length; i++) {
    if (matchingFunction(list[i])) {
      return i;
    }
  }
  return -1;
};
/**
 * Returns a union of the included lists provided each element can be identified by a key.
 *
 * @param {Array} list - list of lists to get the union of
 * @param {Function} keyFunction - the function to use as a key for each element
 *
 * @return {Array} the union of the arrays
 */

var union = function union(lists, keyFunction) {
  return values(lists.reduce(function (acc, list) {
    list.forEach(function (el) {
      acc[keyFunction(el)] = el;
    });
    return acc;
  }, {}));
};
var errors = {
  INVALID_NUMBER_OF_PERIOD: 'INVALID_NUMBER_OF_PERIOD',
  DASH_EMPTY_MANIFEST: 'DASH_EMPTY_MANIFEST',
  DASH_INVALID_XML: 'DASH_INVALID_XML',
  NO_BASE_URL: 'NO_BASE_URL',
  MISSING_SEGMENT_INFORMATION: 'MISSING_SEGMENT_INFORMATION',
  SEGMENT_TIME_UNSPECIFIED: 'SEGMENT_TIME_UNSPECIFIED',
  UNSUPPORTED_UTC_TIMING_SCHEME: 'UNSUPPORTED_UTC_TIMING_SCHEME'
};

/**
 * @typedef {Object} SingleUri
 * @property {string} uri - relative location of segment
 * @property {string} resolvedUri - resolved location of segment
 * @property {Object} byterange - Object containing information on how to make byte range
 *   requests following byte-range-spec per RFC2616.
 * @property {String} byterange.length - length of range request
 * @property {String} byterange.offset - byte offset of range request
 *
 * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.35.1
 */

/**
 * Converts a URLType node (5.3.9.2.3 Table 13) to a segment object
 * that conforms to how m3u8-parser is structured
 *
 * @see https://github.com/videojs/m3u8-parser
 *
 * @param {string} baseUrl - baseUrl provided by <BaseUrl> nodes
 * @param {string} source - source url for segment
 * @param {string} range - optional range used for range calls,
 *   follows  RFC 2616, Clause 14.35.1
 * @return {SingleUri} full segment information transformed into a format similar
 *   to m3u8-parser
 */

var urlTypeToSegment = function urlTypeToSegment(_ref) {
  var _ref$baseUrl = _ref.baseUrl,
    baseUrl = _ref$baseUrl === void 0 ? '' : _ref$baseUrl,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? '' : _ref$source,
    _ref$range = _ref.range,
    range = _ref$range === void 0 ? '' : _ref$range,
    _ref$indexRange = _ref.indexRange,
    indexRange = _ref$indexRange === void 0 ? '' : _ref$indexRange;
  var segment = {
    uri: source,
    resolvedUri: resolve_url(baseUrl || '', source)
  };
  if (range || indexRange) {
    var rangeStr = range ? range : indexRange;
    var ranges = rangeStr.split('-'); // default to parsing this as a BigInt if possible

    var startRange = (window_default()).BigInt ? window_default().BigInt(ranges[0]) : parseInt(ranges[0], 10);
    var endRange = (window_default()).BigInt ? window_default().BigInt(ranges[1]) : parseInt(ranges[1], 10); // convert back to a number if less than MAX_SAFE_INTEGER

    if (startRange < Number.MAX_SAFE_INTEGER && typeof startRange === 'bigint') {
      startRange = Number(startRange);
    }
    if (endRange < Number.MAX_SAFE_INTEGER && typeof endRange === 'bigint') {
      endRange = Number(endRange);
    }
    var length;
    if (typeof endRange === 'bigint' || typeof startRange === 'bigint') {
      length = window_default().BigInt(endRange) - window_default().BigInt(startRange) + window_default().BigInt(1);
    } else {
      length = endRange - startRange + 1;
    }
    if (typeof length === 'bigint' && length < Number.MAX_SAFE_INTEGER) {
      length = Number(length);
    } // byterange should be inclusive according to
    // RFC 2616, Clause 14.35.1

    segment.byterange = {
      length: length,
      offset: startRange
    };
  }
  return segment;
};
var byteRangeToString = function byteRangeToString(byterange) {
  // `endRange` is one less than `offset + length` because the HTTP range
  // header uses inclusive ranges
  var endRange;
  if (typeof byterange.offset === 'bigint' || typeof byterange.length === 'bigint') {
    endRange = window_default().BigInt(byterange.offset) + window_default().BigInt(byterange.length) - window_default().BigInt(1);
  } else {
    endRange = byterange.offset + byterange.length - 1;
  }
  return byterange.offset + "-" + endRange;
};

/**
 * parse the end number attribue that can be a string
 * number, or undefined.
 *
 * @param {string|number|undefined} endNumber
 *        The end number attribute.
 *
 * @return {number|null}
 *          The result of parsing the end number.
 */

var parseEndNumber = function parseEndNumber(endNumber) {
  if (endNumber && typeof endNumber !== 'number') {
    endNumber = parseInt(endNumber, 10);
  }
  if (isNaN(endNumber)) {
    return null;
  }
  return endNumber;
};
/**
 * Functions for calculating the range of available segments in static and dynamic
 * manifests.
 */

var segmentRange = {
  /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  static: function _static(attributes) {
    var duration = attributes.duration,
      _attributes$timescale = attributes.timescale,
      timescale = _attributes$timescale === void 0 ? 1 : _attributes$timescale,
      sourceDuration = attributes.sourceDuration,
      periodDuration = attributes.periodDuration;
    var endNumber = parseEndNumber(attributes.endNumber);
    var segmentDuration = duration / timescale;
    if (typeof endNumber === 'number') {
      return {
        start: 0,
        end: endNumber
      };
    }
    if (typeof periodDuration === 'number') {
      return {
        start: 0,
        end: periodDuration / segmentDuration
      };
    }
    return {
      start: 0,
      end: sourceDuration / segmentDuration
    };
  },
  /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  dynamic: function dynamic(attributes) {
    var NOW = attributes.NOW,
      clientOffset = attributes.clientOffset,
      availabilityStartTime = attributes.availabilityStartTime,
      _attributes$timescale2 = attributes.timescale,
      timescale = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2,
      duration = attributes.duration,
      _attributes$periodSta = attributes.periodStart,
      periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta,
      _attributes$minimumUp = attributes.minimumUpdatePeriod,
      minimumUpdatePeriod = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp,
      _attributes$timeShift = attributes.timeShiftBufferDepth,
      timeShiftBufferDepth = _attributes$timeShift === void 0 ? Infinity : _attributes$timeShift;
    var endNumber = parseEndNumber(attributes.endNumber); // clientOffset is passed in at the top level of mpd-parser and is an offset calculated
    // after retrieving UTC server time.

    var now = (NOW + clientOffset) / 1000; // WC stands for Wall Clock.
    // Convert the period start time to EPOCH.

    var periodStartWC = availabilityStartTime + periodStart; // Period end in EPOCH is manifest's retrieval time + time until next update.

    var periodEndWC = now + minimumUpdatePeriod;
    var periodDuration = periodEndWC - periodStartWC;
    var segmentCount = Math.ceil(periodDuration * timescale / duration);
    var availableStart = Math.floor((now - periodStartWC - timeShiftBufferDepth) * timescale / duration);
    var availableEnd = Math.floor((now - periodStartWC) * timescale / duration);
    return {
      start: Math.max(0, availableStart),
      end: typeof endNumber === 'number' ? endNumber : Math.min(segmentCount, availableEnd)
    };
  }
};
/**
 * Maps a range of numbers to objects with information needed to build the corresponding
 * segment list
 *
 * @name toSegmentsCallback
 * @function
 * @param {number} number
 *        Number of the segment
 * @param {number} index
 *        Index of the number in the range list
 * @return {{ number: Number, duration: Number, timeline: Number, time: Number }}
 *         Object with segment timing and duration info
 */

/**
 * Returns a callback for Array.prototype.map for mapping a range of numbers to
 * information needed to build the segment list.
 *
 * @param {Object} attributes
 *        Inherited MPD attributes
 * @return {toSegmentsCallback}
 *         Callback map function
 */

var toSegments = function toSegments(attributes) {
  return function (number) {
    var duration = attributes.duration,
      _attributes$timescale3 = attributes.timescale,
      timescale = _attributes$timescale3 === void 0 ? 1 : _attributes$timescale3,
      periodStart = attributes.periodStart,
      _attributes$startNumb = attributes.startNumber,
      startNumber = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb;
    return {
      number: startNumber + number,
      duration: duration / timescale,
      timeline: periodStart,
      time: number * duration
    };
  };
};
/**
 * Returns a list of objects containing segment timing and duration info used for
 * building the list of segments. This uses the @duration attribute specified
 * in the MPD manifest to derive the range of segments.
 *
 * @param {Object} attributes
 *        Inherited MPD attributes
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */

var parseByDuration = function parseByDuration(attributes) {
  var type = attributes.type,
    duration = attributes.duration,
    _attributes$timescale4 = attributes.timescale,
    timescale = _attributes$timescale4 === void 0 ? 1 : _attributes$timescale4,
    periodDuration = attributes.periodDuration,
    sourceDuration = attributes.sourceDuration;
  var _segmentRange$type = segmentRange[type](attributes),
    start = _segmentRange$type.start,
    end = _segmentRange$type.end;
  var segments = range(start, end).map(toSegments(attributes));
  if (type === 'static') {
    var index = segments.length - 1; // section is either a period or the full source

    var sectionDuration = typeof periodDuration === 'number' ? periodDuration : sourceDuration; // final segment may be less than full segment duration

    segments[index].duration = sectionDuration - duration / timescale * index;
  }
  return segments;
};

/**
 * Translates SegmentBase into a set of segments.
 * (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
 * node should be translated into segment.
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @return {Object.<Array>} list of segments
 */

var segmentsFromBase = function segmentsFromBase(attributes) {
  var baseUrl = attributes.baseUrl,
    _attributes$initializ = attributes.initialization,
    initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ,
    sourceDuration = attributes.sourceDuration,
    _attributes$indexRang = attributes.indexRange,
    indexRange = _attributes$indexRang === void 0 ? '' : _attributes$indexRang,
    periodStart = attributes.periodStart,
    presentationTime = attributes.presentationTime,
    _attributes$number = attributes.number,
    number = _attributes$number === void 0 ? 0 : _attributes$number,
    duration = attributes.duration; // base url is required for SegmentBase to work, per spec (Section 5.3.9.2.1)

  if (!baseUrl) {
    throw new Error(errors.NO_BASE_URL);
  }
  var initSegment = urlTypeToSegment({
    baseUrl: baseUrl,
    source: initialization.sourceURL,
    range: initialization.range
  });
  var segment = urlTypeToSegment({
    baseUrl: baseUrl,
    source: baseUrl,
    indexRange: indexRange
  });
  segment.map = initSegment; // If there is a duration, use it, otherwise use the given duration of the source
  // (since SegmentBase is only for one total segment)

  if (duration) {
    var segmentTimeInfo = parseByDuration(attributes);
    if (segmentTimeInfo.length) {
      segment.duration = segmentTimeInfo[0].duration;
      segment.timeline = segmentTimeInfo[0].timeline;
    }
  } else if (sourceDuration) {
    segment.duration = sourceDuration;
    segment.timeline = periodStart;
  } // If presentation time is provided, these segments are being generated by SIDX
  // references, and should use the time provided. For the general case of SegmentBase,
  // there should only be one segment in the period, so its presentation time is the same
  // as its period start.

  segment.presentationTime = presentationTime || periodStart;
  segment.number = number;
  return [segment];
};
/**
 * Given a playlist, a sidx box, and a baseUrl, update the segment list of the playlist
 * according to the sidx information given.
 *
 * playlist.sidx has metadadata about the sidx where-as the sidx param
 * is the parsed sidx box itself.
 *
 * @param {Object} playlist the playlist to update the sidx information for
 * @param {Object} sidx the parsed sidx box
 * @return {Object} the playlist object with the updated sidx information
 */

var addSidxSegmentsToPlaylist$1 = function addSidxSegmentsToPlaylist(playlist, sidx, baseUrl) {
  // Retain init segment information
  var initSegment = playlist.sidx.map ? playlist.sidx.map : null; // Retain source duration from initial main manifest parsing

  var sourceDuration = playlist.sidx.duration; // Retain source timeline

  var timeline = playlist.timeline || 0;
  var sidxByteRange = playlist.sidx.byterange;
  var sidxEnd = sidxByteRange.offset + sidxByteRange.length; // Retain timescale of the parsed sidx

  var timescale = sidx.timescale; // referenceType 1 refers to other sidx boxes

  var mediaReferences = sidx.references.filter(function (r) {
    return r.referenceType !== 1;
  });
  var segments = [];
  var type = playlist.endList ? 'static' : 'dynamic';
  var periodStart = playlist.sidx.timeline;
  var presentationTime = periodStart;
  var number = playlist.mediaSequence || 0; // firstOffset is the offset from the end of the sidx box

  var startIndex; // eslint-disable-next-line

  if (typeof sidx.firstOffset === 'bigint') {
    startIndex = window_default().BigInt(sidxEnd) + sidx.firstOffset;
  } else {
    startIndex = sidxEnd + sidx.firstOffset;
  }
  for (var i = 0; i < mediaReferences.length; i++) {
    var reference = sidx.references[i]; // size of the referenced (sub)segment

    var size = reference.referencedSize; // duration of the referenced (sub)segment, in  the  timescale
    // this will be converted to seconds when generating segments

    var duration = reference.subsegmentDuration; // should be an inclusive range

    var endIndex = void 0; // eslint-disable-next-line

    if (typeof startIndex === 'bigint') {
      endIndex = startIndex + window_default().BigInt(size) - window_default().BigInt(1);
    } else {
      endIndex = startIndex + size - 1;
    }
    var indexRange = startIndex + "-" + endIndex;
    var attributes = {
      baseUrl: baseUrl,
      timescale: timescale,
      timeline: timeline,
      periodStart: periodStart,
      presentationTime: presentationTime,
      number: number,
      duration: duration,
      sourceDuration: sourceDuration,
      indexRange: indexRange,
      type: type
    };
    var segment = segmentsFromBase(attributes)[0];
    if (initSegment) {
      segment.map = initSegment;
    }
    segments.push(segment);
    if (typeof startIndex === 'bigint') {
      startIndex += window_default().BigInt(size);
    } else {
      startIndex += size;
    }
    presentationTime += duration / timescale;
    number++;
  }
  playlist.segments = segments;
  return playlist;
};
var SUPPORTED_MEDIA_TYPES = ['AUDIO', 'SUBTITLES']; // allow one 60fps frame as leniency (arbitrarily chosen)

var TIME_FUDGE = 1 / 60;
/**
 * Given a list of timelineStarts, combines, dedupes, and sorts them.
 *
 * @param {TimelineStart[]} timelineStarts - list of timeline starts
 *
 * @return {TimelineStart[]} the combined and deduped timeline starts
 */

var getUniqueTimelineStarts = function getUniqueTimelineStarts(timelineStarts) {
  return union(timelineStarts, function (_ref) {
    var timeline = _ref.timeline;
    return timeline;
  }).sort(function (a, b) {
    return a.timeline > b.timeline ? 1 : -1;
  });
};
/**
 * Finds the playlist with the matching NAME attribute.
 *
 * @param {Array} playlists - playlists to search through
 * @param {string} name - the NAME attribute to search for
 *
 * @return {Object|null} the matching playlist object, or null
 */

var findPlaylistWithName = function findPlaylistWithName(playlists, name) {
  for (var i = 0; i < playlists.length; i++) {
    if (playlists[i].attributes.NAME === name) {
      return playlists[i];
    }
  }
  return null;
};
/**
 * Gets a flattened array of media group playlists.
 *
 * @param {Object} manifest - the main manifest object
 *
 * @return {Array} the media group playlists
 */

var getMediaGroupPlaylists = function getMediaGroupPlaylists(manifest) {
  var mediaGroupPlaylists = [];
  forEachMediaGroup(manifest, SUPPORTED_MEDIA_TYPES, function (properties, type, group, label) {
    mediaGroupPlaylists = mediaGroupPlaylists.concat(properties.playlists || []);
  });
  return mediaGroupPlaylists;
};
/**
 * Updates the playlist's media sequence numbers.
 *
 * @param {Object} config - options object
 * @param {Object} config.playlist - the playlist to update
 * @param {number} config.mediaSequence - the mediaSequence number to start with
 */

var updateMediaSequenceForPlaylist = function updateMediaSequenceForPlaylist(_ref2) {
  var playlist = _ref2.playlist,
    mediaSequence = _ref2.mediaSequence;
  playlist.mediaSequence = mediaSequence;
  playlist.segments.forEach(function (segment, index) {
    segment.number = playlist.mediaSequence + index;
  });
};
/**
 * Updates the media and discontinuity sequence numbers of newPlaylists given oldPlaylists
 * and a complete list of timeline starts.
 *
 * If no matching playlist is found, only the discontinuity sequence number of the playlist
 * will be updated.
 *
 * Since early available timelines are not supported, at least one segment must be present.
 *
 * @param {Object} config - options object
 * @param {Object[]} oldPlaylists - the old playlists to use as a reference
 * @param {Object[]} newPlaylists - the new playlists to update
 * @param {Object} timelineStarts - all timelineStarts seen in the stream to this point
 */

var updateSequenceNumbers = function updateSequenceNumbers(_ref3) {
  var oldPlaylists = _ref3.oldPlaylists,
    newPlaylists = _ref3.newPlaylists,
    timelineStarts = _ref3.timelineStarts;
  newPlaylists.forEach(function (playlist) {
    playlist.discontinuitySequence = findIndex(timelineStarts, function (_ref4) {
      var timeline = _ref4.timeline;
      return timeline === playlist.timeline;
    }); // Playlists NAMEs come from DASH Representation IDs, which are mandatory
    // (see ISO_23009-1-2012 5.3.5.2).
    //
    // If the same Representation existed in a prior Period, it will retain the same NAME.

    var oldPlaylist = findPlaylistWithName(oldPlaylists, playlist.attributes.NAME);
    if (!oldPlaylist) {
      // Since this is a new playlist, the media sequence values can start from 0 without
      // consequence.
      return;
    } // TODO better support for live SIDX
    //
    // As of this writing, mpd-parser does not support multiperiod SIDX (in live or VOD).
    // This is evident by a playlist only having a single SIDX reference. In a multiperiod
    // playlist there would need to be multiple SIDX references. In addition, live SIDX is
    // not supported when the SIDX properties change on refreshes.
    //
    // In the future, if support needs to be added, the merging logic here can be called
    // after SIDX references are resolved. For now, exit early to prevent exceptions being
    // thrown due to undefined references.

    if (playlist.sidx) {
      return;
    } // Since we don't yet support early available timelines, we don't need to support
    // playlists with no segments.

    var firstNewSegment = playlist.segments[0];
    var oldMatchingSegmentIndex = findIndex(oldPlaylist.segments, function (oldSegment) {
      return Math.abs(oldSegment.presentationTime - firstNewSegment.presentationTime) < TIME_FUDGE;
    }); // No matching segment from the old playlist means the entire playlist was refreshed.
    // In this case the media sequence should account for this update, and the new segments
    // should be marked as discontinuous from the prior content, since the last prior
    // timeline was removed.

    if (oldMatchingSegmentIndex === -1) {
      updateMediaSequenceForPlaylist({
        playlist: playlist,
        mediaSequence: oldPlaylist.mediaSequence + oldPlaylist.segments.length
      });
      playlist.segments[0].discontinuity = true;
      playlist.discontinuityStarts.unshift(0); // No matching segment does not necessarily mean there's missing content.
      //
      // If the new playlist's timeline is the same as the last seen segment's timeline,
      // then a discontinuity can be added to identify that there's potentially missing
      // content. If there's no missing content, the discontinuity should still be rather
      // harmless. It's possible that if segment durations are accurate enough, that the
      // existence of a gap can be determined using the presentation times and durations,
      // but if the segment timing info is off, it may introduce more problems than simply
      // adding the discontinuity.
      //
      // If the new playlist's timeline is different from the last seen segment's timeline,
      // then a discontinuity can be added to identify that this is the first seen segment
      // of a new timeline. However, the logic at the start of this function that
      // determined the disconinuity sequence by timeline index is now off by one (the
      // discontinuity of the newest timeline hasn't yet fallen off the manifest...since
      // we added it), so the disconinuity sequence must be decremented.
      //
      // A period may also have a duration of zero, so the case of no segments is handled
      // here even though we don't yet support early available periods.

      if (!oldPlaylist.segments.length && playlist.timeline > oldPlaylist.timeline || oldPlaylist.segments.length && playlist.timeline > oldPlaylist.segments[oldPlaylist.segments.length - 1].timeline) {
        playlist.discontinuitySequence--;
      }
      return;
    } // If the first segment matched with a prior segment on a discontinuity (it's matching
    // on the first segment of a period), then the discontinuitySequence shouldn't be the
    // timeline's matching one, but instead should be the one prior, and the first segment
    // of the new manifest should be marked with a discontinuity.
    //
    // The reason for this special case is that discontinuity sequence shows how many
    // discontinuities have fallen off of the playlist, and discontinuities are marked on
    // the first segment of a new "timeline." Because of this, while DASH will retain that
    // Period while the "timeline" exists, HLS keeps track of it via the discontinuity
    // sequence, and that first segment is an indicator, but can be removed before that
    // timeline is gone.

    var oldMatchingSegment = oldPlaylist.segments[oldMatchingSegmentIndex];
    if (oldMatchingSegment.discontinuity && !firstNewSegment.discontinuity) {
      firstNewSegment.discontinuity = true;
      playlist.discontinuityStarts.unshift(0);
      playlist.discontinuitySequence--;
    }
    updateMediaSequenceForPlaylist({
      playlist: playlist,
      mediaSequence: oldPlaylist.segments[oldMatchingSegmentIndex].number
    });
  });
};
/**
 * Given an old parsed manifest object and a new parsed manifest object, updates the
 * sequence and timing values within the new manifest to ensure that it lines up with the
 * old.
 *
 * @param {Array} oldManifest - the old main manifest object
 * @param {Array} newManifest - the new main manifest object
 *
 * @return {Object} the updated new manifest object
 */

var positionManifestOnTimeline = function positionManifestOnTimeline(_ref5) {
  var oldManifest = _ref5.oldManifest,
    newManifest = _ref5.newManifest;
  // Starting from v4.1.2 of the IOP, section 4.4.3.3 states:
  //
  // "MPD@availabilityStartTime and Period@start shall not be changed over MPD updates."
  //
  // This was added from https://github.com/Dash-Industry-Forum/DASH-IF-IOP/issues/160
  //
  // Because of this change, and the difficulty of supporting periods with changing start
  // times, periods with changing start times are not supported. This makes the logic much
  // simpler, since periods with the same start time can be considerred the same period
  // across refreshes.
  //
  // To give an example as to the difficulty of handling periods where the start time may
  // change, if a single period manifest is refreshed with another manifest with a single
  // period, and both the start and end times are increased, then the only way to determine
  // if it's a new period or an old one that has changed is to look through the segments of
  // each playlist and determine the presentation time bounds to find a match. In addition,
  // if the period start changed to exceed the old period end, then there would be no
  // match, and it would not be possible to determine whether the refreshed period is a new
  // one or the old one.
  var oldPlaylists = oldManifest.playlists.concat(getMediaGroupPlaylists(oldManifest));
  var newPlaylists = newManifest.playlists.concat(getMediaGroupPlaylists(newManifest)); // Save all seen timelineStarts to the new manifest. Although this potentially means that
  // there's a "memory leak" in that it will never stop growing, in reality, only a couple
  // of properties are saved for each seen Period. Even long running live streams won't
  // generate too many Periods, unless the stream is watched for decades. In the future,
  // this can be optimized by mapping to discontinuity sequence numbers for each timeline,
  // but it may not become an issue, and the additional info can be useful for debugging.

  newManifest.timelineStarts = getUniqueTimelineStarts([oldManifest.timelineStarts, newManifest.timelineStarts]);
  updateSequenceNumbers({
    oldPlaylists: oldPlaylists,
    newPlaylists: newPlaylists,
    timelineStarts: newManifest.timelineStarts
  });
  return newManifest;
};
var generateSidxKey = function generateSidxKey(sidx) {
  return sidx && sidx.uri + '-' + byteRangeToString(sidx.byterange);
};
var mergeDiscontiguousPlaylists = function mergeDiscontiguousPlaylists(playlists) {
  var mergedPlaylists = values(playlists.reduce(function (acc, playlist) {
    // assuming playlist IDs are the same across periods
    // TODO: handle multiperiod where representation sets are not the same
    // across periods
    var name = playlist.attributes.id + (playlist.attributes.lang || '');
    if (!acc[name]) {
      // First Period
      acc[name] = playlist;
      acc[name].attributes.timelineStarts = [];
    } else {
      // Subsequent Periods
      if (playlist.segments) {
        var _acc$name$segments;

        // first segment of subsequent periods signal a discontinuity
        if (playlist.segments[0]) {
          playlist.segments[0].discontinuity = true;
        }
        (_acc$name$segments = acc[name].segments).push.apply(_acc$name$segments, playlist.segments);
      } // bubble up contentProtection, this assumes all DRM content
      // has the same contentProtection

      if (playlist.attributes.contentProtection) {
        acc[name].attributes.contentProtection = playlist.attributes.contentProtection;
      }
    }
    acc[name].attributes.timelineStarts.push({
      // Although they represent the same number, it's important to have both to make it
      // compatible with HLS potentially having a similar attribute.
      start: playlist.attributes.periodStart,
      timeline: playlist.attributes.periodStart
    });
    return acc;
  }, {}));
  return mergedPlaylists.map(function (playlist) {
    playlist.discontinuityStarts = findIndexes(playlist.segments || [], 'discontinuity');
    return playlist;
  });
};
var addSidxSegmentsToPlaylist = function addSidxSegmentsToPlaylist(playlist, sidxMapping) {
  var sidxKey = generateSidxKey(playlist.sidx);
  var sidxMatch = sidxKey && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx;
  if (sidxMatch) {
    addSidxSegmentsToPlaylist$1(playlist, sidxMatch, playlist.sidx.resolvedUri);
  }
  return playlist;
};
var addSidxSegmentsToPlaylists = function addSidxSegmentsToPlaylists(playlists, sidxMapping) {
  if (sidxMapping === void 0) {
    sidxMapping = {};
  }
  if (!Object.keys(sidxMapping).length) {
    return playlists;
  }
  for (var i in playlists) {
    playlists[i] = addSidxSegmentsToPlaylist(playlists[i], sidxMapping);
  }
  return playlists;
};
var formatAudioPlaylist = function formatAudioPlaylist(_ref, isAudioOnly) {
  var _attributes;
  var attributes = _ref.attributes,
    segments = _ref.segments,
    sidx = _ref.sidx,
    mediaSequence = _ref.mediaSequence,
    discontinuitySequence = _ref.discontinuitySequence,
    discontinuityStarts = _ref.discontinuityStarts;
  var playlist = {
    attributes: (_attributes = {
      NAME: attributes.id,
      BANDWIDTH: attributes.bandwidth,
      CODECS: attributes.codecs
    }, _attributes['PROGRAM-ID'] = 1, _attributes),
    uri: '',
    endList: attributes.type === 'static',
    timeline: attributes.periodStart,
    resolvedUri: '',
    targetDuration: attributes.duration,
    discontinuitySequence: discontinuitySequence,
    discontinuityStarts: discontinuityStarts,
    timelineStarts: attributes.timelineStarts,
    mediaSequence: mediaSequence,
    segments: segments
  };
  if (attributes.contentProtection) {
    playlist.contentProtection = attributes.contentProtection;
  }
  if (sidx) {
    playlist.sidx = sidx;
  }
  if (isAudioOnly) {
    playlist.attributes.AUDIO = 'audio';
    playlist.attributes.SUBTITLES = 'subs';
  }
  return playlist;
};
var formatVttPlaylist = function formatVttPlaylist(_ref2) {
  var _m3u8Attributes;
  var attributes = _ref2.attributes,
    segments = _ref2.segments,
    mediaSequence = _ref2.mediaSequence,
    discontinuityStarts = _ref2.discontinuityStarts,
    discontinuitySequence = _ref2.discontinuitySequence;
  if (typeof segments === 'undefined') {
    // vtt tracks may use single file in BaseURL
    segments = [{
      uri: attributes.baseUrl,
      timeline: attributes.periodStart,
      resolvedUri: attributes.baseUrl || '',
      duration: attributes.sourceDuration,
      number: 0
    }]; // targetDuration should be the same duration as the only segment

    attributes.duration = attributes.sourceDuration;
  }
  var m3u8Attributes = (_m3u8Attributes = {
    NAME: attributes.id,
    BANDWIDTH: attributes.bandwidth
  }, _m3u8Attributes['PROGRAM-ID'] = 1, _m3u8Attributes);
  if (attributes.codecs) {
    m3u8Attributes.CODECS = attributes.codecs;
  }
  return {
    attributes: m3u8Attributes,
    uri: '',
    endList: attributes.type === 'static',
    timeline: attributes.periodStart,
    resolvedUri: attributes.baseUrl || '',
    targetDuration: attributes.duration,
    timelineStarts: attributes.timelineStarts,
    discontinuityStarts: discontinuityStarts,
    discontinuitySequence: discontinuitySequence,
    mediaSequence: mediaSequence,
    segments: segments
  };
};
var organizeAudioPlaylists = function organizeAudioPlaylists(playlists, sidxMapping, isAudioOnly) {
  if (sidxMapping === void 0) {
    sidxMapping = {};
  }
  if (isAudioOnly === void 0) {
    isAudioOnly = false;
  }
  var mainPlaylist;
  var formattedPlaylists = playlists.reduce(function (a, playlist) {
    var role = playlist.attributes.role && playlist.attributes.role.value || '';
    var language = playlist.attributes.lang || '';
    var label = playlist.attributes.label || 'main';
    if (language && !playlist.attributes.label) {
      var roleLabel = role ? " (" + role + ")" : '';
      label = "" + playlist.attributes.lang + roleLabel;
    }
    if (!a[label]) {
      a[label] = {
        language: language,
        autoselect: true,
        default: role === 'main',
        playlists: [],
        uri: ''
      };
    }
    var formatted = addSidxSegmentsToPlaylist(formatAudioPlaylist(playlist, isAudioOnly), sidxMapping);
    a[label].playlists.push(formatted);
    if (typeof mainPlaylist === 'undefined' && role === 'main') {
      mainPlaylist = playlist;
      mainPlaylist.default = true;
    }
    return a;
  }, {}); // if no playlists have role "main", mark the first as main

  if (!mainPlaylist) {
    var firstLabel = Object.keys(formattedPlaylists)[0];
    formattedPlaylists[firstLabel].default = true;
  }
  return formattedPlaylists;
};
var organizeVttPlaylists = function organizeVttPlaylists(playlists, sidxMapping) {
  if (sidxMapping === void 0) {
    sidxMapping = {};
  }
  return playlists.reduce(function (a, playlist) {
    var label = playlist.attributes.lang || 'text';
    if (!a[label]) {
      a[label] = {
        language: label,
        default: false,
        autoselect: false,
        playlists: [],
        uri: ''
      };
    }
    a[label].playlists.push(addSidxSegmentsToPlaylist(formatVttPlaylist(playlist), sidxMapping));
    return a;
  }, {});
};
var organizeCaptionServices = function organizeCaptionServices(captionServices) {
  return captionServices.reduce(function (svcObj, svc) {
    if (!svc) {
      return svcObj;
    }
    svc.forEach(function (service) {
      var channel = service.channel,
        language = service.language;
      svcObj[language] = {
        autoselect: false,
        default: false,
        instreamId: channel,
        language: language
      };
      if (service.hasOwnProperty('aspectRatio')) {
        svcObj[language].aspectRatio = service.aspectRatio;
      }
      if (service.hasOwnProperty('easyReader')) {
        svcObj[language].easyReader = service.easyReader;
      }
      if (service.hasOwnProperty('3D')) {
        svcObj[language]['3D'] = service['3D'];
      }
    });
    return svcObj;
  }, {});
};
var formatVideoPlaylist = function formatVideoPlaylist(_ref3) {
  var _attributes2;
  var attributes = _ref3.attributes,
    segments = _ref3.segments,
    sidx = _ref3.sidx,
    discontinuityStarts = _ref3.discontinuityStarts;
  var playlist = {
    attributes: (_attributes2 = {
      NAME: attributes.id,
      AUDIO: 'audio',
      SUBTITLES: 'subs',
      RESOLUTION: {
        width: attributes.width,
        height: attributes.height
      },
      CODECS: attributes.codecs,
      BANDWIDTH: attributes.bandwidth
    }, _attributes2['PROGRAM-ID'] = 1, _attributes2),
    uri: '',
    endList: attributes.type === 'static',
    timeline: attributes.periodStart,
    resolvedUri: '',
    targetDuration: attributes.duration,
    discontinuityStarts: discontinuityStarts,
    timelineStarts: attributes.timelineStarts,
    segments: segments
  };
  if (attributes.frameRate) {
    playlist.attributes['FRAME-RATE'] = attributes.frameRate;
  }
  if (attributes.contentProtection) {
    playlist.contentProtection = attributes.contentProtection;
  }
  if (sidx) {
    playlist.sidx = sidx;
  }
  return playlist;
};
var videoOnly = function videoOnly(_ref4) {
  var attributes = _ref4.attributes;
  return attributes.mimeType === 'video/mp4' || attributes.mimeType === 'video/webm' || attributes.contentType === 'video';
};
var audioOnly = function audioOnly(_ref5) {
  var attributes = _ref5.attributes;
  return attributes.mimeType === 'audio/mp4' || attributes.mimeType === 'audio/webm' || attributes.contentType === 'audio';
};
var vttOnly = function vttOnly(_ref6) {
  var attributes = _ref6.attributes;
  return attributes.mimeType === 'text/vtt' || attributes.contentType === 'text';
};
/**
 * Contains start and timeline properties denoting a timeline start. For DASH, these will
 * be the same number.
 *
 * @typedef {Object} TimelineStart
 * @property {number} start - the start time of the timeline
 * @property {number} timeline - the timeline number
 */

/**
 * Adds appropriate media and discontinuity sequence values to the segments and playlists.
 *
 * Throughout mpd-parser, the `number` attribute is used in relation to `startNumber`, a
 * DASH specific attribute used in constructing segment URI's from templates. However, from
 * an HLS perspective, the `number` attribute on a segment would be its `mediaSequence`
 * value, which should start at the original media sequence value (or 0) and increment by 1
 * for each segment thereafter. Since DASH's `startNumber` values are independent per
 * period, it doesn't make sense to use it for `number`. Instead, assume everything starts
 * from a 0 mediaSequence value and increment from there.
 *
 * Note that VHS currently doesn't use the `number` property, but it can be helpful for
 * debugging and making sense of the manifest.
 *
 * For live playlists, to account for values increasing in manifests when periods are
 * removed on refreshes, merging logic should be used to update the numbers to their
 * appropriate values (to ensure they're sequential and increasing).
 *
 * @param {Object[]} playlists - the playlists to update
 * @param {TimelineStart[]} timelineStarts - the timeline starts for the manifest
 */

var addMediaSequenceValues = function addMediaSequenceValues(playlists, timelineStarts) {
  // increment all segments sequentially
  playlists.forEach(function (playlist) {
    playlist.mediaSequence = 0;
    playlist.discontinuitySequence = findIndex(timelineStarts, function (_ref7) {
      var timeline = _ref7.timeline;
      return timeline === playlist.timeline;
    });
    if (!playlist.segments) {
      return;
    }
    playlist.segments.forEach(function (segment, index) {
      segment.number = index;
    });
  });
};
/**
 * Given a media group object, flattens all playlists within the media group into a single
 * array.
 *
 * @param {Object} mediaGroupObject - the media group object
 *
 * @return {Object[]}
 *         The media group playlists
 */

var flattenMediaGroupPlaylists = function flattenMediaGroupPlaylists(mediaGroupObject) {
  if (!mediaGroupObject) {
    return [];
  }
  return Object.keys(mediaGroupObject).reduce(function (acc, label) {
    var labelContents = mediaGroupObject[label];
    return acc.concat(labelContents.playlists);
  }, []);
};
var toM3u8 = function toM3u8(_ref8) {
  var _mediaGroups;
  var dashPlaylists = _ref8.dashPlaylists,
    locations = _ref8.locations,
    _ref8$sidxMapping = _ref8.sidxMapping,
    sidxMapping = _ref8$sidxMapping === void 0 ? {} : _ref8$sidxMapping,
    previousManifest = _ref8.previousManifest;
  if (!dashPlaylists.length) {
    return {};
  } // grab all main manifest attributes

  var _dashPlaylists$0$attr = dashPlaylists[0].attributes,
    duration = _dashPlaylists$0$attr.sourceDuration,
    type = _dashPlaylists$0$attr.type,
    suggestedPresentationDelay = _dashPlaylists$0$attr.suggestedPresentationDelay,
    minimumUpdatePeriod = _dashPlaylists$0$attr.minimumUpdatePeriod;
  var videoPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(videoOnly)).map(formatVideoPlaylist);
  var audioPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(audioOnly));
  var vttPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(vttOnly));
  var captions = dashPlaylists.map(function (playlist) {
    return playlist.attributes.captionServices;
  }).filter(Boolean);
  var manifest = {
    allowCache: true,
    discontinuityStarts: [],
    segments: [],
    endList: true,
    mediaGroups: (_mediaGroups = {
      AUDIO: {},
      VIDEO: {}
    }, _mediaGroups['CLOSED-CAPTIONS'] = {}, _mediaGroups.SUBTITLES = {}, _mediaGroups),
    uri: '',
    duration: duration,
    playlists: addSidxSegmentsToPlaylists(videoPlaylists, sidxMapping)
  };
  if (minimumUpdatePeriod >= 0) {
    manifest.minimumUpdatePeriod = minimumUpdatePeriod * 1000;
  }
  if (locations) {
    manifest.locations = locations;
  }
  if (type === 'dynamic') {
    manifest.suggestedPresentationDelay = suggestedPresentationDelay;
  }
  var isAudioOnly = manifest.playlists.length === 0;
  var organizedAudioGroup = audioPlaylists.length ? organizeAudioPlaylists(audioPlaylists, sidxMapping, isAudioOnly) : null;
  var organizedVttGroup = vttPlaylists.length ? organizeVttPlaylists(vttPlaylists, sidxMapping) : null;
  var formattedPlaylists = videoPlaylists.concat(flattenMediaGroupPlaylists(organizedAudioGroup), flattenMediaGroupPlaylists(organizedVttGroup));
  var playlistTimelineStarts = formattedPlaylists.map(function (_ref9) {
    var timelineStarts = _ref9.timelineStarts;
    return timelineStarts;
  });
  manifest.timelineStarts = getUniqueTimelineStarts(playlistTimelineStarts);
  addMediaSequenceValues(formattedPlaylists, manifest.timelineStarts);
  if (organizedAudioGroup) {
    manifest.mediaGroups.AUDIO.audio = organizedAudioGroup;
  }
  if (organizedVttGroup) {
    manifest.mediaGroups.SUBTITLES.subs = organizedVttGroup;
  }
  if (captions.length) {
    manifest.mediaGroups['CLOSED-CAPTIONS'].cc = organizeCaptionServices(captions);
  }
  if (previousManifest) {
    return positionManifestOnTimeline({
      oldManifest: previousManifest,
      newManifest: manifest
    });
  }
  return manifest;
};

/**
 * Calculates the R (repetition) value for a live stream (for the final segment
 * in a manifest where the r value is negative 1)
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {number} time
 *        current time (typically the total time up until the final segment)
 * @param {number} duration
 *        duration property for the given <S />
 *
 * @return {number}
 *        R value to reach the end of the given period
 */
var getLiveRValue = function getLiveRValue(attributes, time, duration) {
  var NOW = attributes.NOW,
    clientOffset = attributes.clientOffset,
    availabilityStartTime = attributes.availabilityStartTime,
    _attributes$timescale = attributes.timescale,
    timescale = _attributes$timescale === void 0 ? 1 : _attributes$timescale,
    _attributes$periodSta = attributes.periodStart,
    periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta,
    _attributes$minimumUp = attributes.minimumUpdatePeriod,
    minimumUpdatePeriod = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp;
  var now = (NOW + clientOffset) / 1000;
  var periodStartWC = availabilityStartTime + periodStart;
  var periodEndWC = now + minimumUpdatePeriod;
  var periodDuration = periodEndWC - periodStartWC;
  return Math.ceil((periodDuration * timescale - time) / duration);
};
/**
 * Uses information provided by SegmentTemplate.SegmentTimeline to determine segment
 * timing and duration
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */

var parseByTimeline = function parseByTimeline(attributes, segmentTimeline) {
  var type = attributes.type,
    _attributes$minimumUp2 = attributes.minimumUpdatePeriod,
    minimumUpdatePeriod = _attributes$minimumUp2 === void 0 ? 0 : _attributes$minimumUp2,
    _attributes$media = attributes.media,
    media = _attributes$media === void 0 ? '' : _attributes$media,
    sourceDuration = attributes.sourceDuration,
    _attributes$timescale2 = attributes.timescale,
    timescale = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2,
    _attributes$startNumb = attributes.startNumber,
    startNumber = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb,
    timeline = attributes.periodStart;
  var segments = [];
  var time = -1;
  for (var sIndex = 0; sIndex < segmentTimeline.length; sIndex++) {
    var S = segmentTimeline[sIndex];
    var duration = S.d;
    var repeat = S.r || 0;
    var segmentTime = S.t || 0;
    if (time < 0) {
      // first segment
      time = segmentTime;
    }
    if (segmentTime && segmentTime > time) {
      // discontinuity
      // TODO: How to handle this type of discontinuity
      // timeline++ here would treat it like HLS discontuity and content would
      // get appended without gap
      // E.G.
      //  <S t="0" d="1" />
      //  <S d="1" />
      //  <S d="1" />
      //  <S t="5" d="1" />
      // would have $Time$ values of [0, 1, 2, 5]
      // should this be appened at time positions [0, 1, 2, 3],(#EXT-X-DISCONTINUITY)
      // or [0, 1, 2, gap, gap, 5]? (#EXT-X-GAP)
      // does the value of sourceDuration consider this when calculating arbitrary
      // negative @r repeat value?
      // E.G. Same elements as above with this added at the end
      //  <S d="1" r="-1" />
      //  with a sourceDuration of 10
      // Would the 2 gaps be included in the time duration calculations resulting in
      // 8 segments with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9] or 10 segments
      // with $Time$ values of [0, 1, 2, 5, 6, 7, 8, 9, 10, 11] ?
      time = segmentTime;
    }
    var count = void 0;
    if (repeat < 0) {
      var nextS = sIndex + 1;
      if (nextS === segmentTimeline.length) {
        // last segment
        if (type === 'dynamic' && minimumUpdatePeriod > 0 && media.indexOf('$Number$') > 0) {
          count = getLiveRValue(attributes, time, duration);
        } else {
          // TODO: This may be incorrect depending on conclusion of TODO above
          count = (sourceDuration * timescale - time) / duration;
        }
      } else {
        count = (segmentTimeline[nextS].t - time) / duration;
      }
    } else {
      count = repeat + 1;
    }
    var end = startNumber + segments.length + count;
    var number = startNumber + segments.length;
    while (number < end) {
      segments.push({
        number: number,
        duration: duration / timescale,
        time: time,
        timeline: timeline
      });
      time += duration;
      number++;
    }
  }
  return segments;
};
var identifierPattern = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g;
/**
 * Replaces template identifiers with corresponding values. To be used as the callback
 * for String.prototype.replace
 *
 * @name replaceCallback
 * @function
 * @param {string} match
 *        Entire match of identifier
 * @param {string} identifier
 *        Name of matched identifier
 * @param {string} format
 *        Format tag string. Its presence indicates that padding is expected
 * @param {string} width
 *        Desired length of the replaced value. Values less than this width shall be left
 *        zero padded
 * @return {string}
 *         Replacement for the matched identifier
 */

/**
 * Returns a function to be used as a callback for String.prototype.replace to replace
 * template identifiers
 *
 * @param {Obect} values
 *        Object containing values that shall be used to replace known identifiers
 * @param {number} values.RepresentationID
 *        Value of the Representation@id attribute
 * @param {number} values.Number
 *        Number of the corresponding segment
 * @param {number} values.Bandwidth
 *        Value of the Representation@bandwidth attribute.
 * @param {number} values.Time
 *        Timestamp value of the corresponding segment
 * @return {replaceCallback}
 *         Callback to be used with String.prototype.replace to replace identifiers
 */

var identifierReplacement = function identifierReplacement(values) {
  return function (match, identifier, format, width) {
    if (match === '$$') {
      // escape sequence
      return '$';
    }
    if (typeof values[identifier] === 'undefined') {
      return match;
    }
    var value = '' + values[identifier];
    if (identifier === 'RepresentationID') {
      // Format tag shall not be present with RepresentationID
      return value;
    }
    if (!format) {
      width = 1;
    } else {
      width = parseInt(width, 10);
    }
    if (value.length >= width) {
      return value;
    }
    return "" + new Array(width - value.length + 1).join('0') + value;
  };
};
/**
 * Constructs a segment url from a template string
 *
 * @param {string} url
 *        Template string to construct url from
 * @param {Obect} values
 *        Object containing values that shall be used to replace known identifiers
 * @param {number} values.RepresentationID
 *        Value of the Representation@id attribute
 * @param {number} values.Number
 *        Number of the corresponding segment
 * @param {number} values.Bandwidth
 *        Value of the Representation@bandwidth attribute.
 * @param {number} values.Time
 *        Timestamp value of the corresponding segment
 * @return {string}
 *         Segment url with identifiers replaced
 */

var constructTemplateUrl = function constructTemplateUrl(url, values) {
  return url.replace(identifierPattern, identifierReplacement(values));
};
/**
 * Generates a list of objects containing timing and duration information about each
 * segment needed to generate segment uris and the complete segment object
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {{number: number, duration: number, time: number, timeline: number}[]}
 *         List of Objects with segment timing and duration info
 */

var parseTemplateInfo = function parseTemplateInfo(attributes, segmentTimeline) {
  if (!attributes.duration && !segmentTimeline) {
    // if neither @duration or SegmentTimeline are present, then there shall be exactly
    // one media segment
    return [{
      number: attributes.startNumber || 1,
      duration: attributes.sourceDuration,
      time: 0,
      timeline: attributes.periodStart
    }];
  }
  if (attributes.duration) {
    return parseByDuration(attributes);
  }
  return parseByTimeline(attributes, segmentTimeline);
};
/**
 * Generates a list of segments using information provided by the SegmentTemplate element
 *
 * @param {Object} attributes
 *        Object containing all inherited attributes from parent elements with attribute
 *        names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {Object[]}
 *         List of segment objects
 */

var segmentsFromTemplate = function segmentsFromTemplate(attributes, segmentTimeline) {
  var templateValues = {
    RepresentationID: attributes.id,
    Bandwidth: attributes.bandwidth || 0
  };
  var _attributes$initializ = attributes.initialization,
    initialization = _attributes$initializ === void 0 ? {
      sourceURL: '',
      range: ''
    } : _attributes$initializ;
  var mapSegment = urlTypeToSegment({
    baseUrl: attributes.baseUrl,
    source: constructTemplateUrl(initialization.sourceURL, templateValues),
    range: initialization.range
  });
  var segments = parseTemplateInfo(attributes, segmentTimeline);
  return segments.map(function (segment) {
    templateValues.Number = segment.number;
    templateValues.Time = segment.time;
    var uri = constructTemplateUrl(attributes.media || '', templateValues); // See DASH spec section 5.3.9.2.2
    // - if timescale isn't present on any level, default to 1.

    var timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0

    var presentationTimeOffset = attributes.presentationTimeOffset || 0;
    var presentationTime =
    // Even if the @t attribute is not specified for the segment, segment.time is
    // calculated in mpd-parser prior to this, so it's assumed to be available.
    attributes.periodStart + (segment.time - presentationTimeOffset) / timescale;
    var map = {
      uri: uri,
      timeline: segment.timeline,
      duration: segment.duration,
      resolvedUri: resolve_url(attributes.baseUrl || '', uri),
      map: mapSegment,
      number: segment.number,
      presentationTime: presentationTime
    };
    return map;
  });
};

/**
 * Converts a <SegmentUrl> (of type URLType from the DASH spec 5.3.9.2 Table 14)
 * to an object that matches the output of a segment in videojs/mpd-parser
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @param {Object} segmentUrl
 *   <SegmentURL> node to translate into a segment object
 * @return {Object} translated segment object
 */

var SegmentURLToSegmentObject = function SegmentURLToSegmentObject(attributes, segmentUrl) {
  var baseUrl = attributes.baseUrl,
    _attributes$initializ = attributes.initialization,
    initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ;
  var initSegment = urlTypeToSegment({
    baseUrl: baseUrl,
    source: initialization.sourceURL,
    range: initialization.range
  });
  var segment = urlTypeToSegment({
    baseUrl: baseUrl,
    source: segmentUrl.media,
    range: segmentUrl.mediaRange
  });
  segment.map = initSegment;
  return segment;
};
/**
 * Generates a list of segments using information provided by the SegmentList element
 * SegmentList (DASH SPEC Section 5.3.9.3.2) contains a set of <SegmentURL> nodes.  Each
 * node should be translated into segment.
 *
 * @param {Object} attributes
 *   Object containing all inherited attributes from parent elements with attribute
 *   names as keys
 * @param {Object[]|undefined} segmentTimeline
 *        List of objects representing the attributes of each S element contained within
 *        the SegmentTimeline element
 * @return {Object.<Array>} list of segments
 */

var segmentsFromList = function segmentsFromList(attributes, segmentTimeline) {
  var duration = attributes.duration,
    _attributes$segmentUr = attributes.segmentUrls,
    segmentUrls = _attributes$segmentUr === void 0 ? [] : _attributes$segmentUr,
    periodStart = attributes.periodStart; // Per spec (5.3.9.2.1) no way to determine segment duration OR
  // if both SegmentTimeline and @duration are defined, it is outside of spec.

  if (!duration && !segmentTimeline || duration && segmentTimeline) {
    throw new Error(errors.SEGMENT_TIME_UNSPECIFIED);
  }
  var segmentUrlMap = segmentUrls.map(function (segmentUrlObject) {
    return SegmentURLToSegmentObject(attributes, segmentUrlObject);
  });
  var segmentTimeInfo;
  if (duration) {
    segmentTimeInfo = parseByDuration(attributes);
  }
  if (segmentTimeline) {
    segmentTimeInfo = parseByTimeline(attributes, segmentTimeline);
  }
  var segments = segmentTimeInfo.map(function (segmentTime, index) {
    if (segmentUrlMap[index]) {
      var segment = segmentUrlMap[index]; // See DASH spec section 5.3.9.2.2
      // - if timescale isn't present on any level, default to 1.

      var timescale = attributes.timescale || 1; // - if presentationTimeOffset isn't present on any level, default to 0

      var presentationTimeOffset = attributes.presentationTimeOffset || 0;
      segment.timeline = segmentTime.timeline;
      segment.duration = segmentTime.duration;
      segment.number = segmentTime.number;
      segment.presentationTime = periodStart + (segmentTime.time - presentationTimeOffset) / timescale;
      return segment;
    } // Since we're mapping we should get rid of any blank segments (in case
    // the given SegmentTimeline is handling for more elements than we have
    // SegmentURLs for).
  }).filter(function (segment) {
    return segment;
  });
  return segments;
};
var generateSegments = function generateSegments(_ref) {
  var attributes = _ref.attributes,
    segmentInfo = _ref.segmentInfo;
  var segmentAttributes;
  var segmentsFn;
  if (segmentInfo.template) {
    segmentsFn = segmentsFromTemplate;
    segmentAttributes = merge(attributes, segmentInfo.template);
  } else if (segmentInfo.base) {
    segmentsFn = segmentsFromBase;
    segmentAttributes = merge(attributes, segmentInfo.base);
  } else if (segmentInfo.list) {
    segmentsFn = segmentsFromList;
    segmentAttributes = merge(attributes, segmentInfo.list);
  }
  var segmentsInfo = {
    attributes: attributes
  };
  if (!segmentsFn) {
    return segmentsInfo;
  }
  var segments = segmentsFn(segmentAttributes, segmentInfo.segmentTimeline); // The @duration attribute will be used to determin the playlist's targetDuration which
  // must be in seconds. Since we've generated the segment list, we no longer need
  // @duration to be in @timescale units, so we can convert it here.

  if (segmentAttributes.duration) {
    var _segmentAttributes = segmentAttributes,
      duration = _segmentAttributes.duration,
      _segmentAttributes$ti = _segmentAttributes.timescale,
      timescale = _segmentAttributes$ti === void 0 ? 1 : _segmentAttributes$ti;
    segmentAttributes.duration = duration / timescale;
  } else if (segments.length) {
    // if there is no @duration attribute, use the largest segment duration as
    // as target duration
    segmentAttributes.duration = segments.reduce(function (max, segment) {
      return Math.max(max, Math.ceil(segment.duration));
    }, 0);
  } else {
    segmentAttributes.duration = 0;
  }
  segmentsInfo.attributes = segmentAttributes;
  segmentsInfo.segments = segments; // This is a sidx box without actual segment information

  if (segmentInfo.base && segmentAttributes.indexRange) {
    segmentsInfo.sidx = segments[0];
    segmentsInfo.segments = [];
  }
  return segmentsInfo;
};
var toPlaylists = function toPlaylists(representations) {
  return representations.map(generateSegments);
};
var findChildren = function findChildren(element, name) {
  return from(element.childNodes).filter(function (_ref) {
    var tagName = _ref.tagName;
    return tagName === name;
  });
};
var getContent = function getContent(element) {
  return element.textContent.trim();
};

/**
 * Converts the provided string that may contain a division operation to a number.
 *
 * @param {string} value - the provided string value
 *
 * @return {number} the parsed string value
 */
var parseDivisionValue = function parseDivisionValue(value) {
  return parseFloat(value.split('/').reduce(function (prev, current) {
    return prev / current;
  }));
};
var parseDuration = function parseDuration(str) {
  var SECONDS_IN_YEAR = 365 * 24 * 60 * 60;
  var SECONDS_IN_MONTH = 30 * 24 * 60 * 60;
  var SECONDS_IN_DAY = 24 * 60 * 60;
  var SECONDS_IN_HOUR = 60 * 60;
  var SECONDS_IN_MIN = 60; // P10Y10M10DT10H10M10.1S

  var durationRegex = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/;
  var match = durationRegex.exec(str);
  if (!match) {
    return 0;
  }
  var _match$slice = match.slice(1),
    year = _match$slice[0],
    month = _match$slice[1],
    day = _match$slice[2],
    hour = _match$slice[3],
    minute = _match$slice[4],
    second = _match$slice[5];
  return parseFloat(year || 0) * SECONDS_IN_YEAR + parseFloat(month || 0) * SECONDS_IN_MONTH + parseFloat(day || 0) * SECONDS_IN_DAY + parseFloat(hour || 0) * SECONDS_IN_HOUR + parseFloat(minute || 0) * SECONDS_IN_MIN + parseFloat(second || 0);
};
var parseDate = function parseDate(str) {
  // Date format without timezone according to ISO 8601
  // YYY-MM-DDThh:mm:ss.ssssss
  var dateRegex = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/; // If the date string does not specifiy a timezone, we must specifiy UTC. This is
  // expressed by ending with 'Z'

  if (dateRegex.test(str)) {
    str += 'Z';
  }
  return Date.parse(str);
};
var parsers = {
  /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  mediaPresentationDuration: function mediaPresentationDuration(value) {
    return parseDuration(value);
  },
  /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */
  availabilityStartTime: function availabilityStartTime(value) {
    return parseDate(value) / 1000;
  },
  /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  minimumUpdatePeriod: function minimumUpdatePeriod(value) {
    return parseDuration(value);
  },
  /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  suggestedPresentationDelay: function suggestedPresentationDelay(value) {
    return parseDuration(value);
  },
  /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */
  type: function type(value) {
    return value;
  },
  /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  timeShiftBufferDepth: function timeShiftBufferDepth(value) {
    return parseDuration(value);
  },
  /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  start: function start(value) {
    return parseDuration(value);
  },
  /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */
  width: function width(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */
  height: function height(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */
  bandwidth: function bandwidth(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */
  frameRate: function frameRate(value) {
    return parseDivisionValue(value);
  },
  /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  startNumber: function startNumber(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */
  timescale: function timescale(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */
  presentationTimeOffset: function presentationTimeOffset(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  duration: function duration(value) {
    var parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue)) {
      return parseDuration(value);
    }
    return parsedValue;
  },
  /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  d: function d(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */
  t: function t(value) {
    return parseInt(value, 10);
  },
  /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  r: function r(value) {
    return parseInt(value, 10);
  },
  /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */
  DEFAULT: function DEFAULT(value) {
    return value;
  }
};
/**
 * Gets all the attributes and values of the provided node, parses attributes with known
 * types, and returns an object with attribute names mapped to values.
 *
 * @param {Node} el
 *        The node to parse attributes from
 * @return {Object}
 *         Object with all attributes of el parsed
 */

var mpd_parser_es_parseAttributes = function parseAttributes(el) {
  if (!(el && el.attributes)) {
    return {};
  }
  return from(el.attributes).reduce(function (a, e) {
    var parseFn = parsers[e.name] || parsers.DEFAULT;
    a[e.name] = parseFn(e.value);
    return a;
  }, {});
};
var keySystemsMap = {
  'urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b': 'org.w3.clearkey',
  'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed': 'com.widevine.alpha',
  'urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95': 'com.microsoft.playready',
  'urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb': 'com.adobe.primetime'
};
/**
 * Builds a list of urls that is the product of the reference urls and BaseURL values
 *
 * @param {string[]} referenceUrls
 *        List of reference urls to resolve to
 * @param {Node[]} baseUrlElements
 *        List of BaseURL nodes from the mpd
 * @return {string[]}
 *         List of resolved urls
 */

var buildBaseUrls = function buildBaseUrls(referenceUrls, baseUrlElements) {
  if (!baseUrlElements.length) {
    return referenceUrls;
  }
  return flatten(referenceUrls.map(function (reference) {
    return baseUrlElements.map(function (baseUrlElement) {
      return resolve_url(reference, getContent(baseUrlElement));
    });
  }));
};
/**
 * Contains all Segment information for its containing AdaptationSet
 *
 * @typedef {Object} SegmentInformation
 * @property {Object|undefined} template
 *           Contains the attributes for the SegmentTemplate node
 * @property {Object[]|undefined} segmentTimeline
 *           Contains a list of atrributes for each S node within the SegmentTimeline node
 * @property {Object|undefined} list
 *           Contains the attributes for the SegmentList node
 * @property {Object|undefined} base
 *           Contains the attributes for the SegmentBase node
 */

/**
 * Returns all available Segment information contained within the AdaptationSet node
 *
 * @param {Node} adaptationSet
 *        The AdaptationSet node to get Segment information from
 * @return {SegmentInformation}
 *         The Segment information contained within the provided AdaptationSet
 */

var getSegmentInformation = function getSegmentInformation(adaptationSet) {
  var segmentTemplate = findChildren(adaptationSet, 'SegmentTemplate')[0];
  var segmentList = findChildren(adaptationSet, 'SegmentList')[0];
  var segmentUrls = segmentList && findChildren(segmentList, 'SegmentURL').map(function (s) {
    return merge({
      tag: 'SegmentURL'
    }, mpd_parser_es_parseAttributes(s));
  });
  var segmentBase = findChildren(adaptationSet, 'SegmentBase')[0];
  var segmentTimelineParentNode = segmentList || segmentTemplate;
  var segmentTimeline = segmentTimelineParentNode && findChildren(segmentTimelineParentNode, 'SegmentTimeline')[0];
  var segmentInitializationParentNode = segmentList || segmentBase || segmentTemplate;
  var segmentInitialization = segmentInitializationParentNode && findChildren(segmentInitializationParentNode, 'Initialization')[0]; // SegmentTemplate is handled slightly differently, since it can have both
  // @initialization and an <Initialization> node.  @initialization can be templated,
  // while the node can have a url and range specified.  If the <SegmentTemplate> has
  // both @initialization and an <Initialization> subelement we opt to override with
  // the node, as this interaction is not defined in the spec.

  var template = segmentTemplate && mpd_parser_es_parseAttributes(segmentTemplate);
  if (template && segmentInitialization) {
    template.initialization = segmentInitialization && mpd_parser_es_parseAttributes(segmentInitialization);
  } else if (template && template.initialization) {
    // If it is @initialization we convert it to an object since this is the format that
    // later functions will rely on for the initialization segment.  This is only valid
    // for <SegmentTemplate>
    template.initialization = {
      sourceURL: template.initialization
    };
  }
  var segmentInfo = {
    template: template,
    segmentTimeline: segmentTimeline && findChildren(segmentTimeline, 'S').map(function (s) {
      return mpd_parser_es_parseAttributes(s);
    }),
    list: segmentList && merge(mpd_parser_es_parseAttributes(segmentList), {
      segmentUrls: segmentUrls,
      initialization: mpd_parser_es_parseAttributes(segmentInitialization)
    }),
    base: segmentBase && merge(mpd_parser_es_parseAttributes(segmentBase), {
      initialization: mpd_parser_es_parseAttributes(segmentInitialization)
    })
  };
  Object.keys(segmentInfo).forEach(function (key) {
    if (!segmentInfo[key]) {
      delete segmentInfo[key];
    }
  });
  return segmentInfo;
};
/**
 * Contains Segment information and attributes needed to construct a Playlist object
 * from a Representation
 *
 * @typedef {Object} RepresentationInformation
 * @property {SegmentInformation} segmentInfo
 *           Segment information for this Representation
 * @property {Object} attributes
 *           Inherited attributes for this Representation
 */

/**
 * Maps a Representation node to an object containing Segment information and attributes
 *
 * @name inheritBaseUrlsCallback
 * @function
 * @param {Node} representation
 *        Representation node from the mpd
 * @return {RepresentationInformation}
 *         Representation information needed to construct a Playlist object
 */

/**
 * Returns a callback for Array.prototype.map for mapping Representation nodes to
 * Segment information and attributes using inherited BaseURL nodes.
 *
 * @param {Object} adaptationSetAttributes
 *        Contains attributes inherited by the AdaptationSet
 * @param {string[]} adaptationSetBaseUrls
 *        Contains list of resolved base urls inherited by the AdaptationSet
 * @param {SegmentInformation} adaptationSetSegmentInfo
 *        Contains Segment information for the AdaptationSet
 * @return {inheritBaseUrlsCallback}
 *         Callback map function
 */

var inheritBaseUrls = function inheritBaseUrls(adaptationSetAttributes, adaptationSetBaseUrls, adaptationSetSegmentInfo) {
  return function (representation) {
    var repBaseUrlElements = findChildren(representation, 'BaseURL');
    var repBaseUrls = buildBaseUrls(adaptationSetBaseUrls, repBaseUrlElements);
    var attributes = merge(adaptationSetAttributes, mpd_parser_es_parseAttributes(representation));
    var representationSegmentInfo = getSegmentInformation(representation);
    return repBaseUrls.map(function (baseUrl) {
      return {
        segmentInfo: merge(adaptationSetSegmentInfo, representationSegmentInfo),
        attributes: merge(attributes, {
          baseUrl: baseUrl
        })
      };
    });
  };
};
/**
 * Tranforms a series of content protection nodes to
 * an object containing pssh data by key system
 *
 * @param {Node[]} contentProtectionNodes
 *        Content protection nodes
 * @return {Object}
 *        Object containing pssh data by key system
 */

var generateKeySystemInformation = function generateKeySystemInformation(contentProtectionNodes) {
  return contentProtectionNodes.reduce(function (acc, node) {
    var attributes = mpd_parser_es_parseAttributes(node); // Although it could be argued that according to the UUID RFC spec the UUID string (a-f chars) should be generated
    // as a lowercase string it also mentions it should be treated as case-insensitive on input. Since the key system
    // UUIDs in the keySystemsMap are hardcoded as lowercase in the codebase there isn't any reason not to do
    // .toLowerCase() on the input UUID string from the manifest (at least I could not think of one).

    if (attributes.schemeIdUri) {
      attributes.schemeIdUri = attributes.schemeIdUri.toLowerCase();
    }
    var keySystem = keySystemsMap[attributes.schemeIdUri];
    if (keySystem) {
      acc[keySystem] = {
        attributes: attributes
      };
      var psshNode = findChildren(node, 'cenc:pssh')[0];
      if (psshNode) {
        var pssh = getContent(psshNode);
        acc[keySystem].pssh = pssh && decodeB64ToUint8Array(pssh);
      }
    }
    return acc;
  }, {});
}; // defined in ANSI_SCTE 214-1 2016

var parseCaptionServiceMetadata = function parseCaptionServiceMetadata(service) {
  // 608 captions
  if (service.schemeIdUri === 'urn:scte:dash:cc:cea-608:2015') {
    var values = typeof service.value !== 'string' ? [] : service.value.split(';');
    return values.map(function (value) {
      var channel;
      var language; // default language to value

      language = value;
      if (/^CC\d=/.test(value)) {
        var _value$split = value.split('=');
        channel = _value$split[0];
        language = _value$split[1];
      } else if (/^CC\d$/.test(value)) {
        channel = value;
      }
      return {
        channel: channel,
        language: language
      };
    });
  } else if (service.schemeIdUri === 'urn:scte:dash:cc:cea-708:2015') {
    var _values = typeof service.value !== 'string' ? [] : service.value.split(';');
    return _values.map(function (value) {
      var flags = {
        // service or channel number 1-63
        'channel': undefined,
        // language is a 3ALPHA per ISO 639.2/B
        // field is required
        'language': undefined,
        // BIT 1/0 or ?
        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
        'aspectRatio': 1,
        // BIT 1/0
        // easy reader flag indicated the text is tailed to the needs of beginning readers
        // default 0, or off
        'easyReader': 0,
        // BIT 1/0
        // If 3d metadata is present (CEA-708.1) then 1
        // default 0
        '3D': 0
      };
      if (/=/.test(value)) {
        var _value$split2 = value.split('='),
          channel = _value$split2[0],
          _value$split2$ = _value$split2[1],
          opts = _value$split2$ === void 0 ? '' : _value$split2$;
        flags.channel = channel;
        flags.language = value;
        opts.split(',').forEach(function (opt) {
          var _opt$split = opt.split(':'),
            name = _opt$split[0],
            val = _opt$split[1];
          if (name === 'lang') {
            flags.language = val; // er for easyReadery
          } else if (name === 'er') {
            flags.easyReader = Number(val); // war for wide aspect ratio
          } else if (name === 'war') {
            flags.aspectRatio = Number(val);
          } else if (name === '3D') {
            flags['3D'] = Number(val);
          }
        });
      } else {
        flags.language = value;
      }
      if (flags.channel) {
        flags.channel = 'SERVICE' + flags.channel;
      }
      return flags;
    });
  }
};
/**
 * Maps an AdaptationSet node to a list of Representation information objects
 *
 * @name toRepresentationsCallback
 * @function
 * @param {Node} adaptationSet
 *        AdaptationSet node from the mpd
 * @return {RepresentationInformation[]}
 *         List of objects containing Representaion information
 */

/**
 * Returns a callback for Array.prototype.map for mapping AdaptationSet nodes to a list of
 * Representation information objects
 *
 * @param {Object} periodAttributes
 *        Contains attributes inherited by the Period
 * @param {string[]} periodBaseUrls
 *        Contains list of resolved base urls inherited by the Period
 * @param {string[]} periodSegmentInfo
 *        Contains Segment Information at the period level
 * @return {toRepresentationsCallback}
 *         Callback map function
 */

var toRepresentations = function toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo) {
  return function (adaptationSet) {
    var adaptationSetAttributes = mpd_parser_es_parseAttributes(adaptationSet);
    var adaptationSetBaseUrls = buildBaseUrls(periodBaseUrls, findChildren(adaptationSet, 'BaseURL'));
    var role = findChildren(adaptationSet, 'Role')[0];
    var roleAttributes = {
      role: mpd_parser_es_parseAttributes(role)
    };
    var attrs = merge(periodAttributes, adaptationSetAttributes, roleAttributes);
    var accessibility = findChildren(adaptationSet, 'Accessibility')[0];
    var captionServices = parseCaptionServiceMetadata(mpd_parser_es_parseAttributes(accessibility));
    if (captionServices) {
      attrs = merge(attrs, {
        captionServices: captionServices
      });
    }
    var label = findChildren(adaptationSet, 'Label')[0];
    if (label && label.childNodes.length) {
      var labelVal = label.childNodes[0].nodeValue.trim();
      attrs = merge(attrs, {
        label: labelVal
      });
    }
    var contentProtection = generateKeySystemInformation(findChildren(adaptationSet, 'ContentProtection'));
    if (Object.keys(contentProtection).length) {
      attrs = merge(attrs, {
        contentProtection: contentProtection
      });
    }
    var segmentInfo = getSegmentInformation(adaptationSet);
    var representations = findChildren(adaptationSet, 'Representation');
    var adaptationSetSegmentInfo = merge(periodSegmentInfo, segmentInfo);
    return flatten(representations.map(inheritBaseUrls(attrs, adaptationSetBaseUrls, adaptationSetSegmentInfo)));
  };
};
/**
 * Contains all period information for mapping nodes onto adaptation sets.
 *
 * @typedef {Object} PeriodInformation
 * @property {Node} period.node
 *           Period node from the mpd
 * @property {Object} period.attributes
 *           Parsed period attributes from node plus any added
 */

/**
 * Maps a PeriodInformation object to a list of Representation information objects for all
 * AdaptationSet nodes contained within the Period.
 *
 * @name toAdaptationSetsCallback
 * @function
 * @param {PeriodInformation} period
 *        Period object containing necessary period information
 * @param {number} periodStart
 *        Start time of the Period within the mpd
 * @return {RepresentationInformation[]}
 *         List of objects containing Representaion information
 */

/**
 * Returns a callback for Array.prototype.map for mapping Period nodes to a list of
 * Representation information objects
 *
 * @param {Object} mpdAttributes
 *        Contains attributes inherited by the mpd
 * @param {string[]} mpdBaseUrls
 *        Contains list of resolved base urls inherited by the mpd
 * @return {toAdaptationSetsCallback}
 *         Callback map function
 */

var toAdaptationSets = function toAdaptationSets(mpdAttributes, mpdBaseUrls) {
  return function (period, index) {
    var periodBaseUrls = buildBaseUrls(mpdBaseUrls, findChildren(period.node, 'BaseURL'));
    var periodAttributes = merge(mpdAttributes, {
      periodStart: period.attributes.start
    });
    if (typeof period.attributes.duration === 'number') {
      periodAttributes.periodDuration = period.attributes.duration;
    }
    var adaptationSets = findChildren(period.node, 'AdaptationSet');
    var periodSegmentInfo = getSegmentInformation(period.node);
    return flatten(adaptationSets.map(toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo)));
  };
};
/**
 * Gets Period@start property for a given period.
 *
 * @param {Object} options
 *        Options object
 * @param {Object} options.attributes
 *        Period attributes
 * @param {Object} [options.priorPeriodAttributes]
 *        Prior period attributes (if prior period is available)
 * @param {string} options.mpdType
 *        The MPD@type these periods came from
 * @return {number|null}
 *         The period start, or null if it's an early available period or error
 */

var getPeriodStart = function getPeriodStart(_ref) {
  var attributes = _ref.attributes,
    priorPeriodAttributes = _ref.priorPeriodAttributes,
    mpdType = _ref.mpdType;

  // Summary of period start time calculation from DASH spec section 5.3.2.1
  //
  // A period's start is the first period's start + time elapsed after playing all
  // prior periods to this one. Periods continue one after the other in time (without
  // gaps) until the end of the presentation.
  //
  // The value of Period@start should be:
  // 1. if Period@start is present: value of Period@start
  // 2. if previous period exists and it has @duration: previous Period@start +
  //    previous Period@duration
  // 3. if this is first period and MPD@type is 'static': 0
  // 4. in all other cases, consider the period an "early available period" (note: not
  //    currently supported)
  // (1)
  if (typeof attributes.start === 'number') {
    return attributes.start;
  } // (2)

  if (priorPeriodAttributes && typeof priorPeriodAttributes.start === 'number' && typeof priorPeriodAttributes.duration === 'number') {
    return priorPeriodAttributes.start + priorPeriodAttributes.duration;
  } // (3)

  if (!priorPeriodAttributes && mpdType === 'static') {
    return 0;
  } // (4)
  // There is currently no logic for calculating the Period@start value if there is
  // no Period@start or prior Period@start and Period@duration available. This is not made
  // explicit by the DASH interop guidelines or the DASH spec, however, since there's
  // nothing about any other resolution strategies, it's implied. Thus, this case should
  // be considered an early available period, or error, and null should suffice for both
  // of those cases.

  return null;
};
/**
 * Traverses the mpd xml tree to generate a list of Representation information objects
 * that have inherited attributes from parent nodes
 *
 * @param {Node} mpd
 *        The root node of the mpd
 * @param {Object} options
 *        Available options for inheritAttributes
 * @param {string} options.manifestUri
 *        The uri source of the mpd
 * @param {number} options.NOW
 *        Current time per DASH IOP.  Default is current time in ms since epoch
 * @param {number} options.clientOffset
 *        Client time difference from NOW (in milliseconds)
 * @return {RepresentationInformation[]}
 *         List of objects containing Representation information
 */

var inheritAttributes = function inheritAttributes(mpd, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$manifestUri = _options.manifestUri,
    manifestUri = _options$manifestUri === void 0 ? '' : _options$manifestUri,
    _options$NOW = _options.NOW,
    NOW = _options$NOW === void 0 ? Date.now() : _options$NOW,
    _options$clientOffset = _options.clientOffset,
    clientOffset = _options$clientOffset === void 0 ? 0 : _options$clientOffset;
  var periodNodes = findChildren(mpd, 'Period');
  if (!periodNodes.length) {
    throw new Error(errors.INVALID_NUMBER_OF_PERIOD);
  }
  var locations = findChildren(mpd, 'Location');
  var mpdAttributes = mpd_parser_es_parseAttributes(mpd);
  var mpdBaseUrls = buildBaseUrls([manifestUri], findChildren(mpd, 'BaseURL')); // See DASH spec section 5.3.1.2, Semantics of MPD element. Default type to 'static'.

  mpdAttributes.type = mpdAttributes.type || 'static';
  mpdAttributes.sourceDuration = mpdAttributes.mediaPresentationDuration || 0;
  mpdAttributes.NOW = NOW;
  mpdAttributes.clientOffset = clientOffset;
  if (locations.length) {
    mpdAttributes.locations = locations.map(getContent);
  }
  var periods = []; // Since toAdaptationSets acts on individual periods right now, the simplest approach to
  // adding properties that require looking at prior periods is to parse attributes and add
  // missing ones before toAdaptationSets is called. If more such properties are added, it
  // may be better to refactor toAdaptationSets.

  periodNodes.forEach(function (node, index) {
    var attributes = mpd_parser_es_parseAttributes(node); // Use the last modified prior period, as it may contain added information necessary
    // for this period.

    var priorPeriod = periods[index - 1];
    attributes.start = getPeriodStart({
      attributes: attributes,
      priorPeriodAttributes: priorPeriod ? priorPeriod.attributes : null,
      mpdType: mpdAttributes.type
    });
    periods.push({
      node: node,
      attributes: attributes
    });
  });
  return {
    locations: mpdAttributes.locations,
    representationInfo: flatten(periods.map(toAdaptationSets(mpdAttributes, mpdBaseUrls)))
  };
};
var stringToMpdXml = function stringToMpdXml(manifestString) {
  if (manifestString === '') {
    throw new Error(errors.DASH_EMPTY_MANIFEST);
  }
  var parser = new xmldom_lib.DOMParser();
  var xml;
  var mpd;
  try {
    xml = parser.parseFromString(manifestString, 'application/xml');
    mpd = xml && xml.documentElement.tagName === 'MPD' ? xml.documentElement : null;
  } catch (e) {// ie 11 throwsw on invalid xml
  }
  if (!mpd || mpd && mpd.getElementsByTagName('parsererror').length > 0) {
    throw new Error(errors.DASH_INVALID_XML);
  }
  return mpd;
};

/**
 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
 *
 * @param {string} mpd
 *        XML string of the MPD manifest
 * @return {Object|null}
 *         Attributes of UTCTiming node specified in the manifest. Null if none found
 */

var parseUTCTimingScheme = function parseUTCTimingScheme(mpd) {
  var UTCTimingNode = findChildren(mpd, 'UTCTiming')[0];
  if (!UTCTimingNode) {
    return null;
  }
  var attributes = mpd_parser_es_parseAttributes(UTCTimingNode);
  switch (attributes.schemeIdUri) {
    case 'urn:mpeg:dash:utc:http-head:2014':
    case 'urn:mpeg:dash:utc:http-head:2012':
      attributes.method = 'HEAD';
      break;
    case 'urn:mpeg:dash:utc:http-xsdate:2014':
    case 'urn:mpeg:dash:utc:http-iso:2014':
    case 'urn:mpeg:dash:utc:http-xsdate:2012':
    case 'urn:mpeg:dash:utc:http-iso:2012':
      attributes.method = 'GET';
      break;
    case 'urn:mpeg:dash:utc:direct:2014':
    case 'urn:mpeg:dash:utc:direct:2012':
      attributes.method = 'DIRECT';
      attributes.value = Date.parse(attributes.value);
      break;
    case 'urn:mpeg:dash:utc:http-ntp:2014':
    case 'urn:mpeg:dash:utc:ntp:2014':
    case 'urn:mpeg:dash:utc:sntp:2014':
    default:
      throw new Error(errors.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return attributes;
};
var VERSION = (/* unused pure expression or super */ null && (version));
/*
 * Given a DASH manifest string and options, parses the DASH manifest into an object in the
 * form outputed by m3u8-parser and accepted by videojs/http-streaming.
 *
 * For live DASH manifests, if `previousManifest` is provided in options, then the newly
 * parsed DASH manifest will have its media sequence and discontinuity sequence values
 * updated to reflect its position relative to the prior manifest.
 *
 * @param {string} manifestString - the DASH manifest as a string
 * @param {options} [options] - any options
 *
 * @return {Object} the manifest object
 */

var parse = function parse(manifestString, options) {
  if (options === void 0) {
    options = {};
  }
  var parsedManifestInfo = inheritAttributes(stringToMpdXml(manifestString), options);
  var playlists = toPlaylists(parsedManifestInfo.representationInfo);
  return toM3u8({
    dashPlaylists: playlists,
    locations: parsedManifestInfo.locations,
    sidxMapping: options.sidxMapping,
    previousManifest: options.previousManifest
  });
};
/**
 * Parses the manifest for a UTCTiming node, returning the nodes attributes if found
 *
 * @param {string} manifestString
 *        XML string of the MPD manifest
 * @return {Object|null}
 *         Attributes of UTCTiming node specified in the manifest. Null if none found
 */

var parseUTCTiming = function parseUTCTiming(manifestString) {
  return parseUTCTimingScheme(stringToMpdXml(manifestString));
};

// EXTERNAL MODULE: ./node_modules/mux.js/lib/tools/parse-sidx.js
var parse_sidx = __webpack_require__(47376);
var parse_sidx_default = /*#__PURE__*/__webpack_require__.n(parse_sidx);
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/id3-helpers.js

var ID3 = byte_helpers_toUint8([0x49, 0x44, 0x33]);
var getId3Size = function getId3Size(bytes, offset) {
  if (offset === void 0) {
    offset = 0;
  }
  bytes = byte_helpers_toUint8(bytes);
  var flags = bytes[offset + 5];
  var returnSize = bytes[offset + 6] << 21 | bytes[offset + 7] << 14 | bytes[offset + 8] << 7 | bytes[offset + 9];
  var footerPresent = (flags & 16) >> 4;
  if (footerPresent) {
    return returnSize + 20;
  }
  return returnSize + 10;
};
var getId3Offset = function getId3Offset(bytes, offset) {
  if (offset === void 0) {
    offset = 0;
  }
  bytes = byte_helpers_toUint8(bytes);
  if (bytes.length - offset < 10 || !byte_helpers_bytesMatch(bytes, ID3, {
    offset: offset
  })) {
    return offset;
  }
  offset += getId3Size(bytes, offset); // recursive check for id3 tags as some files
  // have multiple ID3 tag sections even though
  // they should not.

  return getId3Offset(bytes, offset);
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/codec-helpers.js





 // https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
// https://developer.mozilla.org/en-US/docs/Web/Media/Formats/codecs_parameter#AV1

var codec_helpers_getAv1Codec = function getAv1Codec(bytes) {
  var codec = '';
  var profile = bytes[1] >>> 3;
  var level = bytes[1] & 0x1F;
  var tier = bytes[2] >>> 7;
  var highBitDepth = (bytes[2] & 0x40) >> 6;
  var twelveBit = (bytes[2] & 0x20) >> 5;
  var monochrome = (bytes[2] & 0x10) >> 4;
  var chromaSubsamplingX = (bytes[2] & 0x08) >> 3;
  var chromaSubsamplingY = (bytes[2] & 0x04) >> 2;
  var chromaSamplePosition = bytes[2] & 0x03;
  codec += profile + "." + padStart(level, 2, '0');
  if (tier === 0) {
    codec += 'M';
  } else if (tier === 1) {
    codec += 'H';
  }
  var bitDepth;
  if (profile === 2 && highBitDepth) {
    bitDepth = twelveBit ? 12 : 10;
  } else {
    bitDepth = highBitDepth ? 10 : 8;
  }
  codec += "." + padStart(bitDepth, 2, '0'); // TODO: can we parse color range??

  codec += "." + monochrome;
  codec += "." + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition;
  return codec;
};
var codec_helpers_getAvcCodec = function getAvcCodec(bytes) {
  var profileId = toHexString(bytes[1]);
  var constraintFlags = toHexString(bytes[2] & 0xFC);
  var levelId = toHexString(bytes[3]);
  return "" + profileId + constraintFlags + levelId;
};
var codec_helpers_getHvcCodec = function getHvcCodec(bytes) {
  var codec = '';
  var profileSpace = bytes[1] >> 6;
  var profileId = bytes[1] & 0x1F;
  var tierFlag = (bytes[1] & 0x20) >> 5;
  var profileCompat = bytes.subarray(2, 6);
  var constraintIds = bytes.subarray(6, 12);
  var levelId = bytes[12];
  if (profileSpace === 1) {
    codec += 'A';
  } else if (profileSpace === 2) {
    codec += 'B';
  } else if (profileSpace === 3) {
    codec += 'C';
  }
  codec += profileId + "."; // ffmpeg does this in big endian

  var profileCompatVal = parseInt(toBinaryString(profileCompat).split('').reverse().join(''), 2); // apple does this in little endian...

  if (profileCompatVal > 255) {
    profileCompatVal = parseInt(toBinaryString(profileCompat), 2);
  }
  codec += profileCompatVal.toString(16) + ".";
  if (tierFlag === 0) {
    codec += 'L';
  } else {
    codec += 'H';
  }
  codec += levelId;
  var constraints = '';
  for (var i = 0; i < constraintIds.length; i++) {
    var v = constraintIds[i];
    if (v) {
      if (constraints) {
        constraints += '.';
      }
      constraints += v.toString(16);
    }
  }
  if (constraints) {
    codec += "." + constraints;
  }
  return codec;
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/opus-helpers.js



























var OPUS_HEAD = new Uint8Array([
// O, p, u, s
0x4f, 0x70, 0x75, 0x73,
// H, e, a, d
0x48, 0x65, 0x61, 0x64]); // https://wiki.xiph.org/OggOpus
// https://vfrmaniac.fushizen.eu/contents/opus_in_isobmff.html
// https://opus-codec.org/docs/opusfile_api-0.7/structOpusHead.html

var opus_helpers_parseOpusHead = function parseOpusHead(bytes) {
  var view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  var version = view.getUint8(0); // version 0, from mp4, does not use littleEndian.

  var littleEndian = version !== 0;
  var config = {
    version: version,
    channels: view.getUint8(1),
    preSkip: view.getUint16(2, littleEndian),
    sampleRate: view.getUint32(4, littleEndian),
    outputGain: view.getUint16(8, littleEndian),
    channelMappingFamily: view.getUint8(10)
  };
  if (config.channelMappingFamily > 0 && bytes.length > 10) {
    config.streamCount = view.getUint8(11);
    config.twoChannelStreamCount = view.getUint8(12);
    config.channelMapping = [];
    for (var c = 0; c < config.channels; c++) {
      config.channelMapping.push(view.getUint8(13 + c));
    }
  }
  return config;
};
var setOpusHead = function setOpusHead(config) {
  var size = config.channelMappingFamily <= 0 ? 11 : 12 + config.channels;
  var view = new DataView(new ArrayBuffer(size));
  var littleEndian = config.version !== 0;
  view.setUint8(0, config.version);
  view.setUint8(1, config.channels);
  view.setUint16(2, config.preSkip, littleEndian);
  view.setUint32(4, config.sampleRate, littleEndian);
  view.setUint16(8, config.outputGain, littleEndian);
  view.setUint8(10, config.channelMappingFamily);
  if (config.channelMappingFamily > 0) {
    view.setUint8(11, config.streamCount);
    config.channelMapping.foreach(function (cm, i) {
      view.setUint8(12 + i, cm);
    });
  }
  return new Uint8Array(view.buffer);
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/mp4-helpers.js










var normalizePath = function normalizePath(path) {
  if (typeof path === 'string') {
    return stringToBytes(path);
  }
  if (typeof path === 'number') {
    return path;
  }
  return path;
};
var normalizePaths = function normalizePaths(paths) {
  if (!Array.isArray(paths)) {
    return [normalizePath(paths)];
  }
  return paths.map(function (p) {
    return normalizePath(p);
  });
};
var DESCRIPTORS;
var parseDescriptors = function parseDescriptors(bytes) {
  bytes = byte_helpers_toUint8(bytes);
  var results = [];
  var i = 0;
  while (bytes.length > i) {
    var tag = bytes[i];
    var size = 0;
    var headerSize = 0; // tag

    headerSize++;
    var byte = bytes[headerSize]; // first byte

    headerSize++;
    while (byte & 0x80) {
      size = (byte & 0x7F) << 7;
      byte = bytes[headerSize];
      headerSize++;
    }
    size += byte & 0x7F;
    for (var z = 0; z < DESCRIPTORS.length; z++) {
      var _DESCRIPTORS$z = DESCRIPTORS[z],
        id = _DESCRIPTORS$z.id,
        parser = _DESCRIPTORS$z.parser;
      if (tag === id) {
        results.push(parser(bytes.subarray(headerSize, headerSize + size)));
        break;
      }
    }
    i += size + headerSize;
  }
  return results;
};
DESCRIPTORS = [{
  id: 0x03,
  parser: function parser(bytes) {
    var desc = {
      tag: 0x03,
      id: bytes[0] << 8 | bytes[1],
      flags: bytes[2],
      size: 3,
      dependsOnEsId: 0,
      ocrEsId: 0,
      descriptors: [],
      url: ''
    }; // depends on es id

    if (desc.flags & 0x80) {
      desc.dependsOnEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
      desc.size += 2;
    } // url

    if (desc.flags & 0x40) {
      var len = bytes[desc.size];
      desc.url = byte_helpers_bytesToString(bytes.subarray(desc.size + 1, desc.size + 1 + len));
      desc.size += len;
    } // ocr es id

    if (desc.flags & 0x20) {
      desc.ocrEsId = bytes[desc.size] << 8 | bytes[desc.size + 1];
      desc.size += 2;
    }
    desc.descriptors = parseDescriptors(bytes.subarray(desc.size)) || [];
    return desc;
  }
}, {
  id: 0x04,
  parser: function parser(bytes) {
    // DecoderConfigDescriptor
    var desc = {
      tag: 0x04,
      oti: bytes[0],
      streamType: bytes[1],
      bufferSize: bytes[2] << 16 | bytes[3] << 8 | bytes[4],
      maxBitrate: bytes[5] << 24 | bytes[6] << 16 | bytes[7] << 8 | bytes[8],
      avgBitrate: bytes[9] << 24 | bytes[10] << 16 | bytes[11] << 8 | bytes[12],
      descriptors: parseDescriptors(bytes.subarray(13))
    };
    return desc;
  }
}, {
  id: 0x05,
  parser: function parser(bytes) {
    // DecoderSpecificInfo
    return {
      tag: 0x05,
      bytes: bytes
    };
  }
}, {
  id: 0x06,
  parser: function parser(bytes) {
    // SLConfigDescriptor
    return {
      tag: 0x06,
      bytes: bytes
    };
  }
}];
/**
 * find any number of boxes by name given a path to it in an iso bmff
 * such as mp4.
 *
 * @param {TypedArray} bytes
 *        bytes for the iso bmff to search for boxes in
 *
 * @param {Uint8Array[]|string[]|string|Uint8Array} name
 *        An array of paths or a single path representing the name
 *        of boxes to search through in bytes. Paths may be
 *        uint8 (character codes) or strings.
 *
 * @param {boolean} [complete=false]
 *        Should we search only for complete boxes on the final path.
 *        This is very useful when you do not want to get back partial boxes
 *        in the case of streaming files.
 *
 * @return {Uint8Array[]}
 *         An array of the end paths that we found.
 */

var findBox = function findBox(bytes, paths, complete) {
  if (complete === void 0) {
    complete = false;
  }
  paths = normalizePaths(paths);
  bytes = byte_helpers_toUint8(bytes);
  var results = [];
  if (!paths.length) {
    // short-circuit the search for empty paths
    return results;
  }
  var i = 0;
  while (i < bytes.length) {
    var size = (bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]) >>> 0;
    var type = bytes.subarray(i + 4, i + 8); // invalid box format.

    if (size === 0) {
      break;
    }
    var end = i + size;
    if (end > bytes.length) {
      // this box is bigger than the number of bytes we have
      // and complete is set, we cannot find any more boxes.
      if (complete) {
        break;
      }
      end = bytes.length;
    }
    var data = bytes.subarray(i + 8, end);
    if (byte_helpers_bytesMatch(type, paths[0])) {
      if (paths.length === 1) {
        // this is the end of the path and we've found the box we were
        // looking for
        results.push(data);
      } else {
        // recursively search for the next box along the path
        results.push.apply(results, findBox(data, paths.slice(1), complete));
      }
    }
    i = end;
  } // we've finished searching all of bytes

  return results;
};
/**
 * Search for a single matching box by name in an iso bmff format like
 * mp4. This function is useful for finding codec boxes which
 * can be placed arbitrarily in sample descriptions depending
 * on the version of the file or file type.
 *
 * @param {TypedArray} bytes
 *        bytes for the iso bmff to search for boxes in
 *
 * @param {string|Uint8Array} name
 *        The name of the box to find.
 *
 * @return {Uint8Array[]}
 *         a subarray of bytes representing the name boxed we found.
 */

var findNamedBox = function findNamedBox(bytes, name) {
  name = normalizePath(name);
  if (!name.length) {
    // short-circuit the search for empty paths
    return bytes.subarray(bytes.length);
  }
  var i = 0;
  while (i < bytes.length) {
    if (bytesMatch(bytes.subarray(i, i + name.length), name)) {
      var size = (bytes[i - 4] << 24 | bytes[i - 3] << 16 | bytes[i - 2] << 8 | bytes[i - 1]) >>> 0;
      var end = size > 1 ? i + size : bytes.byteLength;
      return bytes.subarray(i + 4, end);
    }
    i++;
  } // we've finished searching all of bytes

  return bytes.subarray(bytes.length);
};
var parseSamples = function parseSamples(data, entrySize, parseEntry) {
  if (entrySize === void 0) {
    entrySize = 4;
  }
  if (parseEntry === void 0) {
    parseEntry = function parseEntry(d) {
      return bytesToNumber(d);
    };
  }
  var entries = [];
  if (!data || !data.length) {
    return entries;
  }
  var entryCount = bytesToNumber(data.subarray(4, 8));
  for (var i = 8; entryCount; i += entrySize, entryCount--) {
    entries.push(parseEntry(data.subarray(i, i + entrySize)));
  }
  return entries;
};
var buildFrameTable = function buildFrameTable(stbl, timescale) {
  var keySamples = parseSamples(findBox(stbl, ['stss'])[0]);
  var chunkOffsets = parseSamples(findBox(stbl, ['stco'])[0]);
  var timeToSamples = parseSamples(findBox(stbl, ['stts'])[0], 8, function (entry) {
    return {
      sampleCount: bytesToNumber(entry.subarray(0, 4)),
      sampleDelta: bytesToNumber(entry.subarray(4, 8))
    };
  });
  var samplesToChunks = parseSamples(findBox(stbl, ['stsc'])[0], 12, function (entry) {
    return {
      firstChunk: bytesToNumber(entry.subarray(0, 4)),
      samplesPerChunk: bytesToNumber(entry.subarray(4, 8)),
      sampleDescriptionIndex: bytesToNumber(entry.subarray(8, 12))
    };
  });
  var stsz = findBox(stbl, ['stsz'])[0]; // stsz starts with a 4 byte sampleSize which we don't need

  var sampleSizes = parseSamples(stsz && stsz.length && stsz.subarray(4) || null);
  var frames = [];
  for (var chunkIndex = 0; chunkIndex < chunkOffsets.length; chunkIndex++) {
    var samplesInChunk = void 0;
    for (var i = 0; i < samplesToChunks.length; i++) {
      var sampleToChunk = samplesToChunks[i];
      var isThisOne = chunkIndex + 1 >= sampleToChunk.firstChunk && (i + 1 >= samplesToChunks.length || chunkIndex + 1 < samplesToChunks[i + 1].firstChunk);
      if (isThisOne) {
        samplesInChunk = sampleToChunk.samplesPerChunk;
        break;
      }
    }
    var chunkOffset = chunkOffsets[chunkIndex];
    for (var _i = 0; _i < samplesInChunk; _i++) {
      var frameEnd = sampleSizes[frames.length]; // if we don't have key samples every frame is a keyframe

      var keyframe = !keySamples.length;
      if (keySamples.length && keySamples.indexOf(frames.length + 1) !== -1) {
        keyframe = true;
      }
      var frame = {
        keyframe: keyframe,
        start: chunkOffset,
        end: chunkOffset + frameEnd
      };
      for (var k = 0; k < timeToSamples.length; k++) {
        var _timeToSamples$k = timeToSamples[k],
          sampleCount = _timeToSamples$k.sampleCount,
          sampleDelta = _timeToSamples$k.sampleDelta;
        if (frames.length <= sampleCount) {
          // ms to ns
          var lastTimestamp = frames.length ? frames[frames.length - 1].timestamp : 0;
          frame.timestamp = lastTimestamp + sampleDelta / timescale * 1000;
          frame.duration = sampleDelta;
          break;
        }
      }
      frames.push(frame);
      chunkOffset += frameEnd;
    }
  }
  return frames;
};
var addSampleDescription = function addSampleDescription(track, bytes) {
  var codec = bytesToString(bytes.subarray(0, 4));
  if (track.type === 'video') {
    track.info = track.info || {};
    track.info.width = bytes[28] << 8 | bytes[29];
    track.info.height = bytes[30] << 8 | bytes[31];
  } else if (track.type === 'audio') {
    track.info = track.info || {};
    track.info.channels = bytes[20] << 8 | bytes[21];
    track.info.bitDepth = bytes[22] << 8 | bytes[23];
    track.info.sampleRate = bytes[28] << 8 | bytes[29];
  }
  if (codec === 'avc1') {
    var avcC = findNamedBox(bytes, 'avcC'); // AVCDecoderConfigurationRecord

    codec += "." + getAvcCodec(avcC);
    track.info.avcC = avcC; // TODO: do we need to parse all this?

    /* {
      configurationVersion: avcC[0],
      profile: avcC[1],
      profileCompatibility: avcC[2],
      level: avcC[3],
      lengthSizeMinusOne: avcC[4] & 0x3
    };
     let spsNalUnitCount = avcC[5] & 0x1F;
    const spsNalUnits = track.info.avc.spsNalUnits = [];
     // past spsNalUnitCount
    let offset = 6;
     while (spsNalUnitCount--) {
      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
       spsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
       offset += nalLen + 2;
    }
    let ppsNalUnitCount = avcC[offset];
    const ppsNalUnits = track.info.avc.ppsNalUnits = [];
     // past ppsNalUnitCount
    offset += 1;
     while (ppsNalUnitCount--) {
      const nalLen = avcC[offset] << 8 | avcC[offset + 1];
       ppsNalUnits.push(avcC.subarray(offset + 2, offset + 2 + nalLen));
       offset += nalLen + 2;
    }*/
    // HEVCDecoderConfigurationRecord
  } else if (codec === 'hvc1' || codec === 'hev1') {
    codec += "." + getHvcCodec(findNamedBox(bytes, 'hvcC'));
  } else if (codec === 'mp4a' || codec === 'mp4v') {
    var esds = findNamedBox(bytes, 'esds');
    var esDescriptor = parseDescriptors(esds.subarray(4))[0];
    var decoderConfig = esDescriptor && esDescriptor.descriptors.filter(function (_ref) {
      var tag = _ref.tag;
      return tag === 0x04;
    })[0];
    if (decoderConfig) {
      // most codecs do not have a further '.'
      // such as 0xa5 for ac-3 and 0xa6 for e-ac-3
      codec += '.' + toHexString(decoderConfig.oti);
      if (decoderConfig.oti === 0x40) {
        codec += '.' + (decoderConfig.descriptors[0].bytes[0] >> 3).toString();
      } else if (decoderConfig.oti === 0x20) {
        codec += '.' + decoderConfig.descriptors[0].bytes[4].toString();
      } else if (decoderConfig.oti === 0xdd) {
        codec = 'vorbis';
      }
    } else if (track.type === 'audio') {
      codec += '.40.2';
    } else {
      codec += '.20.9';
    }
  } else if (codec === 'av01') {
    // AV1DecoderConfigurationRecord
    codec += "." + getAv1Codec(findNamedBox(bytes, 'av1C'));
  } else if (codec === 'vp09') {
    // VPCodecConfigurationRecord
    var vpcC = findNamedBox(bytes, 'vpcC'); // https://www.webmproject.org/vp9/mp4/

    var profile = vpcC[0];
    var level = vpcC[1];
    var bitDepth = vpcC[2] >> 4;
    var chromaSubsampling = (vpcC[2] & 0x0F) >> 1;
    var videoFullRangeFlag = (vpcC[2] & 0x0F) >> 3;
    var colourPrimaries = vpcC[3];
    var transferCharacteristics = vpcC[4];
    var matrixCoefficients = vpcC[5];
    codec += "." + padStart(profile, 2, '0');
    codec += "." + padStart(level, 2, '0');
    codec += "." + padStart(bitDepth, 2, '0');
    codec += "." + padStart(chromaSubsampling, 2, '0');
    codec += "." + padStart(colourPrimaries, 2, '0');
    codec += "." + padStart(transferCharacteristics, 2, '0');
    codec += "." + padStart(matrixCoefficients, 2, '0');
    codec += "." + padStart(videoFullRangeFlag, 2, '0');
  } else if (codec === 'theo') {
    codec = 'theora';
  } else if (codec === 'spex') {
    codec = 'speex';
  } else if (codec === '.mp3') {
    codec = 'mp4a.40.34';
  } else if (codec === 'msVo') {
    codec = 'vorbis';
  } else if (codec === 'Opus') {
    codec = 'opus';
    var dOps = findNamedBox(bytes, 'dOps');
    track.info.opus = parseOpusHead(dOps); // TODO: should this go into the webm code??
    // Firefox requires a codecDelay for opus playback
    // see https://bugzilla.mozilla.org/show_bug.cgi?id=1276238

    track.info.codecDelay = 6500000;
  } else {
    codec = codec.toLowerCase();
  }
  /* eslint-enable */
  // flac, ac-3, ec-3, opus

  track.codec = codec;
};
var parseTracks = function parseTracks(bytes, frameTable) {
  if (frameTable === void 0) {
    frameTable = true;
  }
  bytes = toUint8(bytes);
  var traks = findBox(bytes, ['moov', 'trak'], true);
  var tracks = [];
  traks.forEach(function (trak) {
    var track = {
      bytes: trak
    };
    var mdia = findBox(trak, ['mdia'])[0];
    var hdlr = findBox(mdia, ['hdlr'])[0];
    var trakType = bytesToString(hdlr.subarray(8, 12));
    if (trakType === 'soun') {
      track.type = 'audio';
    } else if (trakType === 'vide') {
      track.type = 'video';
    } else {
      track.type = trakType;
    }
    var tkhd = findBox(trak, ['tkhd'])[0];
    if (tkhd) {
      var view = new DataView(tkhd.buffer, tkhd.byteOffset, tkhd.byteLength);
      var tkhdVersion = view.getUint8(0);
      track.number = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
    }
    var mdhd = findBox(mdia, ['mdhd'])[0];
    if (mdhd) {
      // mdhd is a FullBox, meaning it will have its own version as the first byte
      var version = mdhd[0];
      var index = version === 0 ? 12 : 20;
      track.timescale = (mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3]) >>> 0;
    }
    var stbl = findBox(mdia, ['minf', 'stbl'])[0];
    var stsd = findBox(stbl, ['stsd'])[0];
    var descriptionCount = bytesToNumber(stsd.subarray(4, 8));
    var offset = 8; // add codec and codec info

    while (descriptionCount--) {
      var len = bytesToNumber(stsd.subarray(offset, offset + 4));
      var sampleDescriptor = stsd.subarray(offset + 4, offset + 4 + len);
      addSampleDescription(track, sampleDescriptor);
      offset += 4 + len;
    }
    if (frameTable) {
      track.frameTable = buildFrameTable(stbl, track.timescale);
    } // codec has no sub parameters

    tracks.push(track);
  });
  return tracks;
};
var parseMediaInfo = function parseMediaInfo(bytes) {
  var mvhd = findBox(bytes, ['moov', 'mvhd'], true)[0];
  if (!mvhd || !mvhd.length) {
    return;
  }
  var info = {}; // ms to ns
  // mvhd v1 has 8 byte duration and other fields too

  if (mvhd[0] === 1) {
    info.timestampScale = bytesToNumber(mvhd.subarray(20, 24));
    info.duration = bytesToNumber(mvhd.subarray(24, 32));
  } else {
    info.timestampScale = bytesToNumber(mvhd.subarray(12, 16));
    info.duration = bytesToNumber(mvhd.subarray(16, 20));
  }
  info.bytes = mvhd;
  return info;
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/ebml-helpers.js










 // relevant specs for this parser:
// https://matroska-org.github.io/libebml/specs.html
// https://www.matroska.org/technical/elements.html
// https://www.webmproject.org/docs/container/

var EBML_TAGS = {
  EBML: byte_helpers_toUint8([0x1A, 0x45, 0xDF, 0xA3]),
  DocType: byte_helpers_toUint8([0x42, 0x82]),
  Segment: byte_helpers_toUint8([0x18, 0x53, 0x80, 0x67]),
  SegmentInfo: byte_helpers_toUint8([0x15, 0x49, 0xA9, 0x66]),
  Tracks: byte_helpers_toUint8([0x16, 0x54, 0xAE, 0x6B]),
  Track: byte_helpers_toUint8([0xAE]),
  TrackNumber: byte_helpers_toUint8([0xd7]),
  DefaultDuration: byte_helpers_toUint8([0x23, 0xe3, 0x83]),
  TrackEntry: byte_helpers_toUint8([0xAE]),
  TrackType: byte_helpers_toUint8([0x83]),
  FlagDefault: byte_helpers_toUint8([0x88]),
  CodecID: byte_helpers_toUint8([0x86]),
  CodecPrivate: byte_helpers_toUint8([0x63, 0xA2]),
  VideoTrack: byte_helpers_toUint8([0xe0]),
  AudioTrack: byte_helpers_toUint8([0xe1]),
  // Not used yet, but will be used for live webm/mkv
  // see https://www.matroska.org/technical/basics.html#block-structure
  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
  Cluster: byte_helpers_toUint8([0x1F, 0x43, 0xB6, 0x75]),
  Timestamp: byte_helpers_toUint8([0xE7]),
  TimestampScale: byte_helpers_toUint8([0x2A, 0xD7, 0xB1]),
  BlockGroup: byte_helpers_toUint8([0xA0]),
  BlockDuration: byte_helpers_toUint8([0x9B]),
  Block: byte_helpers_toUint8([0xA1]),
  SimpleBlock: byte_helpers_toUint8([0xA3])
};
/**
 * This is a simple table to determine the length
 * of things in ebml. The length is one based (starts at 1,
 * rather than zero) and for every zero bit before a one bit
 * we add one to length. We also need this table because in some
 * case we have to xor all the length bits from another value.
 */

var LENGTH_TABLE = [128, 64, 32, 16, 8, 4, 2, 1];
var getLength = function getLength(byte) {
  var len = 1;
  for (var i = 0; i < LENGTH_TABLE.length; i++) {
    if (byte & LENGTH_TABLE[i]) {
      break;
    }
    len++;
  }
  return len;
}; // length in ebml is stored in the first 4 to 8 bits
// of the first byte. 4 for the id length and 8 for the
// data size length. Length is measured by converting the number to binary
// then 1 + the number of zeros before a 1 is encountered starting
// from the left.

var getvint = function getvint(bytes, offset, removeLength, signed) {
  if (removeLength === void 0) {
    removeLength = true;
  }
  if (signed === void 0) {
    signed = false;
  }
  var length = getLength(bytes[offset]);
  var valueBytes = bytes.subarray(offset, offset + length); // NOTE that we do **not** subarray here because we need to copy these bytes
  // as they will be modified below to remove the dataSizeLen bits and we do not
  // want to modify the original data. normally we could just call slice on
  // uint8array but ie 11 does not support that...

  if (removeLength) {
    valueBytes = Array.prototype.slice.call(bytes, offset, offset + length);
    valueBytes[0] ^= LENGTH_TABLE[length - 1];
  }
  return {
    length: length,
    value: byte_helpers_bytesToNumber(valueBytes, {
      signed: signed
    }),
    bytes: valueBytes
  };
};
var ebml_helpers_normalizePath = function normalizePath(path) {
  if (typeof path === 'string') {
    return path.match(/.{1,2}/g).map(function (p) {
      return normalizePath(p);
    });
  }
  if (typeof path === 'number') {
    return numberToBytes(path);
  }
  return path;
};
var ebml_helpers_normalizePaths = function normalizePaths(paths) {
  if (!Array.isArray(paths)) {
    return [ebml_helpers_normalizePath(paths)];
  }
  return paths.map(function (p) {
    return ebml_helpers_normalizePath(p);
  });
};
var getInfinityDataSize = function getInfinityDataSize(id, bytes, offset) {
  if (offset >= bytes.length) {
    return bytes.length;
  }
  var innerid = getvint(bytes, offset, false);
  if (byte_helpers_bytesMatch(id.bytes, innerid.bytes)) {
    return offset;
  }
  var dataHeader = getvint(bytes, offset + innerid.length);
  return getInfinityDataSize(id, bytes, offset + dataHeader.length + dataHeader.value + innerid.length);
};
/**
 * Notes on the EBLM format.
 *
 * EBLM uses "vints" tags. Every vint tag contains
 * two parts
 *
 * 1. The length from the first byte. You get this by
 *    converting the byte to binary and counting the zeros
 *    before a 1. Then you add 1 to that. Examples
 *    00011111 = length 4 because there are 3 zeros before a 1.
 *    00100000 = length 3 because there are 2 zeros before a 1.
 *    00000011 = length 7 because there are 6 zeros before a 1.
 *
 * 2. The bits used for length are removed from the first byte
 *    Then all the bytes are merged into a value. NOTE: this
 *    is not the case for id ebml tags as there id includes
 *    length bits.
 *
 */

var findEbml = function findEbml(bytes, paths) {
  paths = ebml_helpers_normalizePaths(paths);
  bytes = byte_helpers_toUint8(bytes);
  var results = [];
  if (!paths.length) {
    return results;
  }
  var i = 0;
  while (i < bytes.length) {
    var id = getvint(bytes, i, false);
    var dataHeader = getvint(bytes, i + id.length);
    var dataStart = i + id.length + dataHeader.length; // dataSize is unknown or this is a live stream

    if (dataHeader.value === 0x7f) {
      dataHeader.value = getInfinityDataSize(id, bytes, dataStart);
      if (dataHeader.value !== bytes.length) {
        dataHeader.value -= dataStart;
      }
    }
    var dataEnd = dataStart + dataHeader.value > bytes.length ? bytes.length : dataStart + dataHeader.value;
    var data = bytes.subarray(dataStart, dataEnd);
    if (byte_helpers_bytesMatch(paths[0], id.bytes)) {
      if (paths.length === 1) {
        // this is the end of the paths and we've found the tag we were
        // looking for
        results.push(data);
      } else {
        // recursively search for the next tag inside of the data
        // of this one
        results = results.concat(findEbml(data, paths.slice(1)));
      }
    }
    var totalLength = id.length + dataHeader.length + data.length; // move past this tag entirely, we are not looking for it

    i += totalLength;
  }
  return results;
}; // see https://www.matroska.org/technical/basics.html#block-structure

var decodeBlock = function decodeBlock(block, type, timestampScale, clusterTimestamp) {
  var duration;
  if (type === 'group') {
    duration = findEbml(block, [EBML_TAGS.BlockDuration])[0];
    if (duration) {
      duration = bytesToNumber(duration);
      duration = 1 / timestampScale * duration * timestampScale / 1000;
    }
    block = findEbml(block, [EBML_TAGS.Block])[0];
    type = 'block'; // treat data as a block after this point
  }

  var dv = new DataView(block.buffer, block.byteOffset, block.byteLength);
  var trackNumber = getvint(block, 0);
  var timestamp = dv.getInt16(trackNumber.length, false);
  var flags = block[trackNumber.length + 2];
  var data = block.subarray(trackNumber.length + 3); // pts/dts in seconds

  var ptsdts = 1 / timestampScale * (clusterTimestamp + timestamp) * timestampScale / 1000; // return the frame

  var parsed = {
    duration: duration,
    trackNumber: trackNumber.value,
    keyframe: type === 'simple' && flags >> 7 === 1,
    invisible: (flags & 0x08) >> 3 === 1,
    lacing: (flags & 0x06) >> 1,
    discardable: type === 'simple' && (flags & 0x01) === 1,
    frames: [],
    pts: ptsdts,
    dts: ptsdts,
    timestamp: timestamp
  };
  if (!parsed.lacing) {
    parsed.frames.push(data);
    return parsed;
  }
  var numberOfFrames = data[0] + 1;
  var frameSizes = [];
  var offset = 1; // Fixed

  if (parsed.lacing === 2) {
    var sizeOfFrame = (data.length - offset) / numberOfFrames;
    for (var i = 0; i < numberOfFrames; i++) {
      frameSizes.push(sizeOfFrame);
    }
  } // xiph

  if (parsed.lacing === 1) {
    for (var _i = 0; _i < numberOfFrames - 1; _i++) {
      var size = 0;
      do {
        size += data[offset];
        offset++;
      } while (data[offset - 1] === 0xFF);
      frameSizes.push(size);
    }
  } // ebml

  if (parsed.lacing === 3) {
    // first vint is unsinged
    // after that vints are singed and
    // based on a compounding size
    var _size = 0;
    for (var _i2 = 0; _i2 < numberOfFrames - 1; _i2++) {
      var vint = _i2 === 0 ? getvint(data, offset) : getvint(data, offset, true, true);
      _size += vint.value;
      frameSizes.push(_size);
      offset += vint.length;
    }
  }
  frameSizes.forEach(function (size) {
    parsed.frames.push(data.subarray(offset, offset + size));
    offset += size;
  });
  return parsed;
}; // VP9 Codec Feature Metadata (CodecPrivate)
// https://www.webmproject.org/docs/container/

var parseVp9Private = function parseVp9Private(bytes) {
  var i = 0;
  var params = {};
  while (i < bytes.length) {
    var id = bytes[i] & 0x7f;
    var len = bytes[i + 1];
    var val = void 0;
    if (len === 1) {
      val = bytes[i + 2];
    } else {
      val = bytes.subarray(i + 2, i + 2 + len);
    }
    if (id === 1) {
      params.profile = val;
    } else if (id === 2) {
      params.level = val;
    } else if (id === 3) {
      params.bitDepth = val;
    } else if (id === 4) {
      params.chromaSubsampling = val;
    } else {
      params[id] = val;
    }
    i += 2 + len;
  }
  return params;
};
var ebml_helpers_parseTracks = function parseTracks(bytes) {
  bytes = toUint8(bytes);
  var decodedTracks = [];
  var tracks = findEbml(bytes, [EBML_TAGS.Segment, EBML_TAGS.Tracks, EBML_TAGS.Track]);
  if (!tracks.length) {
    tracks = findEbml(bytes, [EBML_TAGS.Tracks, EBML_TAGS.Track]);
  }
  if (!tracks.length) {
    tracks = findEbml(bytes, [EBML_TAGS.Track]);
  }
  if (!tracks.length) {
    return decodedTracks;
  }
  tracks.forEach(function (track) {
    var trackType = findEbml(track, EBML_TAGS.TrackType)[0];
    if (!trackType || !trackType.length) {
      return;
    } // 1 is video, 2 is audio, 17 is subtitle
    // other values are unimportant in this context

    if (trackType[0] === 1) {
      trackType = 'video';
    } else if (trackType[0] === 2) {
      trackType = 'audio';
    } else if (trackType[0] === 17) {
      trackType = 'subtitle';
    } else {
      return;
    } // todo parse language

    var decodedTrack = {
      rawCodec: bytesToString(findEbml(track, [EBML_TAGS.CodecID])[0]),
      type: trackType,
      codecPrivate: findEbml(track, [EBML_TAGS.CodecPrivate])[0],
      number: bytesToNumber(findEbml(track, [EBML_TAGS.TrackNumber])[0]),
      defaultDuration: bytesToNumber(findEbml(track, [EBML_TAGS.DefaultDuration])[0]),
      default: findEbml(track, [EBML_TAGS.FlagDefault])[0],
      rawData: track
    };
    var codec = '';
    if (/V_MPEG4\/ISO\/AVC/.test(decodedTrack.rawCodec)) {
      codec = "avc1." + getAvcCodec(decodedTrack.codecPrivate);
    } else if (/V_MPEGH\/ISO\/HEVC/.test(decodedTrack.rawCodec)) {
      codec = "hev1." + getHvcCodec(decodedTrack.codecPrivate);
    } else if (/V_MPEG4\/ISO\/ASP/.test(decodedTrack.rawCodec)) {
      if (decodedTrack.codecPrivate) {
        codec = 'mp4v.20.' + decodedTrack.codecPrivate[4].toString();
      } else {
        codec = 'mp4v.20.9';
      }
    } else if (/^V_THEORA/.test(decodedTrack.rawCodec)) {
      codec = 'theora';
    } else if (/^V_VP8/.test(decodedTrack.rawCodec)) {
      codec = 'vp8';
    } else if (/^V_VP9/.test(decodedTrack.rawCodec)) {
      if (decodedTrack.codecPrivate) {
        var _parseVp9Private = parseVp9Private(decodedTrack.codecPrivate),
          profile = _parseVp9Private.profile,
          level = _parseVp9Private.level,
          bitDepth = _parseVp9Private.bitDepth,
          chromaSubsampling = _parseVp9Private.chromaSubsampling;
        codec = 'vp09.';
        codec += padStart(profile, 2, '0') + ".";
        codec += padStart(level, 2, '0') + ".";
        codec += padStart(bitDepth, 2, '0') + ".";
        codec += "" + padStart(chromaSubsampling, 2, '0'); // Video -> Colour -> Ebml name

        var matrixCoefficients = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xB1]])[0] || [];
        var videoFullRangeFlag = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xB9]])[0] || [];
        var transferCharacteristics = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xBA]])[0] || [];
        var colourPrimaries = findEbml(track, [0xE0, [0x55, 0xB0], [0x55, 0xBB]])[0] || []; // if we find any optional codec parameter specify them all.

        if (matrixCoefficients.length || videoFullRangeFlag.length || transferCharacteristics.length || colourPrimaries.length) {
          codec += "." + padStart(colourPrimaries[0], 2, '0');
          codec += "." + padStart(transferCharacteristics[0], 2, '0');
          codec += "." + padStart(matrixCoefficients[0], 2, '0');
          codec += "." + padStart(videoFullRangeFlag[0], 2, '0');
        }
      } else {
        codec = 'vp9';
      }
    } else if (/^V_AV1/.test(decodedTrack.rawCodec)) {
      codec = "av01." + getAv1Codec(decodedTrack.codecPrivate);
    } else if (/A_ALAC/.test(decodedTrack.rawCodec)) {
      codec = 'alac';
    } else if (/A_MPEG\/L2/.test(decodedTrack.rawCodec)) {
      codec = 'mp2';
    } else if (/A_MPEG\/L3/.test(decodedTrack.rawCodec)) {
      codec = 'mp3';
    } else if (/^A_AAC/.test(decodedTrack.rawCodec)) {
      if (decodedTrack.codecPrivate) {
        codec = 'mp4a.40.' + (decodedTrack.codecPrivate[0] >>> 3).toString();
      } else {
        codec = 'mp4a.40.2';
      }
    } else if (/^A_AC3/.test(decodedTrack.rawCodec)) {
      codec = 'ac-3';
    } else if (/^A_PCM/.test(decodedTrack.rawCodec)) {
      codec = 'pcm';
    } else if (/^A_MS\/ACM/.test(decodedTrack.rawCodec)) {
      codec = 'speex';
    } else if (/^A_EAC3/.test(decodedTrack.rawCodec)) {
      codec = 'ec-3';
    } else if (/^A_VORBIS/.test(decodedTrack.rawCodec)) {
      codec = 'vorbis';
    } else if (/^A_FLAC/.test(decodedTrack.rawCodec)) {
      codec = 'flac';
    } else if (/^A_OPUS/.test(decodedTrack.rawCodec)) {
      codec = 'opus';
    }
    decodedTrack.codec = codec;
    decodedTracks.push(decodedTrack);
  });
  return decodedTracks.sort(function (a, b) {
    return a.number - b.number;
  });
};
var parseData = function parseData(data, tracks) {
  var allBlocks = [];
  var segment = findEbml(data, [EBML_TAGS.Segment])[0];
  var timestampScale = findEbml(segment, [EBML_TAGS.SegmentInfo, EBML_TAGS.TimestampScale])[0]; // in nanoseconds, defaults to 1ms

  if (timestampScale && timestampScale.length) {
    timestampScale = bytesToNumber(timestampScale);
  } else {
    timestampScale = 1000000;
  }
  var clusters = findEbml(segment, [EBML_TAGS.Cluster]);
  if (!tracks) {
    tracks = ebml_helpers_parseTracks(segment);
  }
  clusters.forEach(function (cluster, ci) {
    var simpleBlocks = findEbml(cluster, [EBML_TAGS.SimpleBlock]).map(function (b) {
      return {
        type: 'simple',
        data: b
      };
    });
    var blockGroups = findEbml(cluster, [EBML_TAGS.BlockGroup]).map(function (b) {
      return {
        type: 'group',
        data: b
      };
    });
    var timestamp = findEbml(cluster, [EBML_TAGS.Timestamp])[0] || 0;
    if (timestamp && timestamp.length) {
      timestamp = bytesToNumber(timestamp);
    } // get all blocks then sort them into the correct order

    var blocks = simpleBlocks.concat(blockGroups).sort(function (a, b) {
      return a.data.byteOffset - b.data.byteOffset;
    });
    blocks.forEach(function (block, bi) {
      var decoded = decodeBlock(block.data, block.type, timestampScale, timestamp);
      allBlocks.push(decoded);
    });
  });
  return {
    tracks: tracks,
    blocks: allBlocks
  };
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/nal-helpers.js




























var NAL_TYPE_ONE = byte_helpers_toUint8([0x00, 0x00, 0x00, 0x01]);
var NAL_TYPE_TWO = byte_helpers_toUint8([0x00, 0x00, 0x01]);
var EMULATION_PREVENTION = byte_helpers_toUint8([0x00, 0x00, 0x03]);
/**
 * Expunge any "Emulation Prevention" bytes from a "Raw Byte
 * Sequence Payload"
 *
 * @param data {Uint8Array} the bytes of a RBSP from a NAL
 * unit
 * @return {Uint8Array} the RBSP without any Emulation
 * Prevention Bytes
 */

var discardEmulationPreventionBytes = function discardEmulationPreventionBytes(bytes) {
  var positions = [];
  var i = 1; // Find all `Emulation Prevention Bytes`

  while (i < bytes.length - 2) {
    if (byte_helpers_bytesMatch(bytes.subarray(i, i + 3), EMULATION_PREVENTION)) {
      positions.push(i + 2);
      i++;
    }
    i++;
  } // If no Emulation Prevention Bytes were found just return the original
  // array

  if (positions.length === 0) {
    return bytes;
  } // Create a new array to hold the NAL unit data

  var newLength = bytes.length - positions.length;
  var newData = new Uint8Array(newLength);
  var sourceIndex = 0;
  for (i = 0; i < newLength; sourceIndex++, i++) {
    if (sourceIndex === positions[0]) {
      // Skip this byte
      sourceIndex++; // Remove this position index

      positions.shift();
    }
    newData[i] = bytes[sourceIndex];
  }
  return newData;
};
var findNal = function findNal(bytes, dataType, types, nalLimit) {
  if (nalLimit === void 0) {
    nalLimit = Infinity;
  }
  bytes = byte_helpers_toUint8(bytes);
  types = [].concat(types);
  var i = 0;
  var nalStart;
  var nalsFound = 0; // keep searching until:
  // we reach the end of bytes
  // we reach the maximum number of nals they want to seach
  // NOTE: that we disregard nalLimit when we have found the start
  // of the nal we want so that we can find the end of the nal we want.

  while (i < bytes.length && (nalsFound < nalLimit || nalStart)) {
    var nalOffset = void 0;
    if (byte_helpers_bytesMatch(bytes.subarray(i), NAL_TYPE_ONE)) {
      nalOffset = 4;
    } else if (byte_helpers_bytesMatch(bytes.subarray(i), NAL_TYPE_TWO)) {
      nalOffset = 3;
    } // we are unsynced,
    // find the next nal unit

    if (!nalOffset) {
      i++;
      continue;
    }
    nalsFound++;
    if (nalStart) {
      return discardEmulationPreventionBytes(bytes.subarray(nalStart, i));
    }
    var nalType = void 0;
    if (dataType === 'h264') {
      nalType = bytes[i + nalOffset] & 0x1f;
    } else if (dataType === 'h265') {
      nalType = bytes[i + nalOffset] >> 1 & 0x3f;
    }
    if (types.indexOf(nalType) !== -1) {
      nalStart = i + nalOffset;
    } // nal header is 1 length for h264, and 2 for h265

    i += nalOffset + (dataType === 'h264' ? 1 : 2);
  }
  return bytes.subarray(0, 0);
};
var findH264Nal = function findH264Nal(bytes, type, nalLimit) {
  return findNal(bytes, 'h264', type, nalLimit);
};
var findH265Nal = function findH265Nal(bytes, type, nalLimit) {
  return findNal(bytes, 'h265', type, nalLimit);
};
;// CONCATENATED MODULE: ./node_modules/@videojs/vhs-utils/es/containers.js









var CONSTANTS = {
  // "webm" string literal in hex
  'webm': byte_helpers_toUint8([0x77, 0x65, 0x62, 0x6d]),
  // "matroska" string literal in hex
  'matroska': byte_helpers_toUint8([0x6d, 0x61, 0x74, 0x72, 0x6f, 0x73, 0x6b, 0x61]),
  // "fLaC" string literal in hex
  'flac': byte_helpers_toUint8([0x66, 0x4c, 0x61, 0x43]),
  // "OggS" string literal in hex
  'ogg': byte_helpers_toUint8([0x4f, 0x67, 0x67, 0x53]),
  // ac-3 sync byte, also works for ec-3 as that is simply a codec
  // of ac-3
  'ac3': byte_helpers_toUint8([0x0b, 0x77]),
  // "RIFF" string literal in hex used for wav and avi
  'riff': byte_helpers_toUint8([0x52, 0x49, 0x46, 0x46]),
  // "AVI" string literal in hex
  'avi': byte_helpers_toUint8([0x41, 0x56, 0x49]),
  // "WAVE" string literal in hex
  'wav': byte_helpers_toUint8([0x57, 0x41, 0x56, 0x45]),
  // "ftyp3g" string literal in hex
  '3gp': byte_helpers_toUint8([0x66, 0x74, 0x79, 0x70, 0x33, 0x67]),
  // "ftyp" string literal in hex
  'mp4': byte_helpers_toUint8([0x66, 0x74, 0x79, 0x70]),
  // "styp" string literal in hex
  'fmp4': byte_helpers_toUint8([0x73, 0x74, 0x79, 0x70]),
  // "ftypqt" string literal in hex
  'mov': byte_helpers_toUint8([0x66, 0x74, 0x79, 0x70, 0x71, 0x74]),
  // moov string literal in hex
  'moov': byte_helpers_toUint8([0x6D, 0x6F, 0x6F, 0x76]),
  // moof string literal in hex
  'moof': byte_helpers_toUint8([0x6D, 0x6F, 0x6F, 0x66])
};
var _isLikely = {
  aac: function aac(bytes) {
    var offset = getId3Offset(bytes);
    return byte_helpers_bytesMatch(bytes, [0xFF, 0x10], {
      offset: offset,
      mask: [0xFF, 0x16]
    });
  },
  mp3: function mp3(bytes) {
    var offset = getId3Offset(bytes);
    return byte_helpers_bytesMatch(bytes, [0xFF, 0x02], {
      offset: offset,
      mask: [0xFF, 0x06]
    });
  },
  webm: function webm(bytes) {
    var docType = findEbml(bytes, [EBML_TAGS.EBML, EBML_TAGS.DocType])[0]; // check if DocType EBML tag is webm

    return byte_helpers_bytesMatch(docType, CONSTANTS.webm);
  },
  mkv: function mkv(bytes) {
    var docType = findEbml(bytes, [EBML_TAGS.EBML, EBML_TAGS.DocType])[0]; // check if DocType EBML tag is matroska

    return byte_helpers_bytesMatch(docType, CONSTANTS.matroska);
  },
  mp4: function mp4(bytes) {
    // if this file is another base media file format, it is not mp4
    if (_isLikely['3gp'](bytes) || _isLikely.mov(bytes)) {
      return false;
    } // if this file starts with a ftyp or styp box its mp4

    if (byte_helpers_bytesMatch(bytes, CONSTANTS.mp4, {
      offset: 4
    }) || byte_helpers_bytesMatch(bytes, CONSTANTS.fmp4, {
      offset: 4
    })) {
      return true;
    } // if this file starts with a moof/moov box its mp4

    if (byte_helpers_bytesMatch(bytes, CONSTANTS.moof, {
      offset: 4
    }) || byte_helpers_bytesMatch(bytes, CONSTANTS.moov, {
      offset: 4
    })) {
      return true;
    }
  },
  mov: function mov(bytes) {
    return byte_helpers_bytesMatch(bytes, CONSTANTS.mov, {
      offset: 4
    });
  },
  '3gp': function gp(bytes) {
    return byte_helpers_bytesMatch(bytes, CONSTANTS['3gp'], {
      offset: 4
    });
  },
  ac3: function ac3(bytes) {
    var offset = getId3Offset(bytes);
    return byte_helpers_bytesMatch(bytes, CONSTANTS.ac3, {
      offset: offset
    });
  },
  ts: function ts(bytes) {
    if (bytes.length < 189 && bytes.length >= 1) {
      return bytes[0] === 0x47;
    }
    var i = 0; // check the first 376 bytes for two matching sync bytes

    while (i + 188 < bytes.length && i < 188) {
      if (bytes[i] === 0x47 && bytes[i + 188] === 0x47) {
        return true;
      }
      i += 1;
    }
    return false;
  },
  flac: function flac(bytes) {
    var offset = getId3Offset(bytes);
    return byte_helpers_bytesMatch(bytes, CONSTANTS.flac, {
      offset: offset
    });
  },
  ogg: function ogg(bytes) {
    return byte_helpers_bytesMatch(bytes, CONSTANTS.ogg);
  },
  avi: function avi(bytes) {
    return byte_helpers_bytesMatch(bytes, CONSTANTS.riff) && byte_helpers_bytesMatch(bytes, CONSTANTS.avi, {
      offset: 8
    });
  },
  wav: function wav(bytes) {
    return byte_helpers_bytesMatch(bytes, CONSTANTS.riff) && byte_helpers_bytesMatch(bytes, CONSTANTS.wav, {
      offset: 8
    });
  },
  'h264': function h264(bytes) {
    // find seq_parameter_set_rbsp
    return findH264Nal(bytes, 7, 3).length;
  },
  'h265': function h265(bytes) {
    // find video_parameter_set_rbsp or seq_parameter_set_rbsp
    return findH265Nal(bytes, [32, 33], 3).length;
  }
}; // get all the isLikely functions
// but make sure 'ts' is above h264 and h265
// but below everything else as it is the least specific

var isLikelyTypes = Object.keys(_isLikely) // remove ts, h264, h265
.filter(function (t) {
  return t !== 'ts' && t !== 'h264' && t !== 'h265';
}) // add it back to the bottom
.concat(['ts', 'h264', 'h265']); // make sure we are dealing with uint8 data.

isLikelyTypes.forEach(function (type) {
  var isLikelyFn = _isLikely[type];
  _isLikely[type] = function (bytes) {
    return isLikelyFn(byte_helpers_toUint8(bytes));
  };
}); // export after wrapping

var isLikely = _isLikely; // A useful list of file signatures can be found here
// https://en.wikipedia.org/wiki/List_of_file_signatures

var detectContainerForBytes = function detectContainerForBytes(bytes) {
  bytes = byte_helpers_toUint8(bytes);
  for (var i = 0; i < isLikelyTypes.length; i++) {
    var type = isLikelyTypes[i];
    if (isLikely[type](bytes)) {
      return type;
    }
  }
  return '';
}; // fmp4 is not a container

var isLikelyFmp4MediaSegment = function isLikelyFmp4MediaSegment(bytes) {
  return findBox(bytes, ['moof']).length > 0;
};
// EXTERNAL MODULE: ./node_modules/mux.js/lib/utils/clock.js
var clock = __webpack_require__(52953);
;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js


function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}

;// CONCATENATED MODULE: ./node_modules/video.js/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js









function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

;// CONCATENATED MODULE: ./node_modules/video.js/dist/video.es.js
function video_es_typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){video_es_typeof=function _typeof(obj){return typeof obj;};}else{video_es_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return video_es_typeof(obj);}/**
 * @license
 * Video.js 7.21.7 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */var version$5="7.21.7";/**
 * An Object that contains lifecycle hooks as keys which point to an array
 * of functions that are run when a lifecycle is triggered
 *
 * @private
 */var hooks_={};/**
 * Get a list of hooks for a specific lifecycle
 *
 * @param  {string} type
 *         the lifecyle to get hooks from
 *
 * @param  {Function|Function[]} [fn]
 *         Optionally add a hook (or hooks) to the lifecycle that your are getting.
 *
 * @return {Array}
 *         an array of hooks, or an empty array if there are none.
 */var hooks=function hooks(type,fn){hooks_[type]=hooks_[type]||[];if(fn){hooks_[type]=hooks_[type].concat(fn);}return hooks_[type];};/**
 * Add a function hook to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */var hook=function hook(type,fn){hooks(type,fn);};/**
 * Remove a hook from a specific videojs lifecycle.
 *
 * @param  {string} type
 *         the lifecycle that the function hooked to
 *
 * @param  {Function} fn
 *         The hooked function to remove
 *
 * @return {boolean}
 *         The function that was removed or undef
 */var removeHook=function removeHook(type,fn){var index=hooks(type).indexOf(fn);if(index<=-1){return false;}hooks_[type]=hooks_[type].slice();hooks_[type].splice(index,1);return true;};/**
 * Add a function hook that will only run once to a specific videojs lifecycle.
 *
 * @param {string} type
 *        the lifecycle to hook the function to.
 *
 * @param {Function|Function[]}
 *        The function or array of functions to attach.
 */var hookOnce=function hookOnce(type,fn){hooks(type,[].concat(fn).map(function(original){var wrapper=function wrapper(){removeHook(type,wrapper);return original.apply(void 0,arguments);};return wrapper;}));};/**
 * @file fullscreen-api.js
 * @module fullscreen-api
 * @private
 */ /**
 * Store the browser-specific methods for the fullscreen API.
 *
 * @type {Object}
 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
 */var FullscreenApi={prefixed:true};// browser API methods
var apiMap=[['requestFullscreen','exitFullscreen','fullscreenElement','fullscreenEnabled','fullscreenchange','fullscreenerror','fullscreen'],// WebKit
['webkitRequestFullscreen','webkitExitFullscreen','webkitFullscreenElement','webkitFullscreenEnabled','webkitfullscreenchange','webkitfullscreenerror','-webkit-full-screen'],// Mozilla
['mozRequestFullScreen','mozCancelFullScreen','mozFullScreenElement','mozFullScreenEnabled','mozfullscreenchange','mozfullscreenerror','-moz-full-screen'],// Microsoft
['msRequestFullscreen','msExitFullscreen','msFullscreenElement','msFullscreenEnabled','MSFullscreenChange','MSFullscreenError','-ms-fullscreen']];var specApi=apiMap[0];var browserApi;// determine the supported set of functions
for(var i=0;i<apiMap.length;i++){// check for exitFullscreen function
if(apiMap[i][1]in (document_default())){browserApi=apiMap[i];break;}}// map the browser API names to the spec API names
if(browserApi){for(var _i=0;_i<browserApi.length;_i++){FullscreenApi[specApi[_i]]=browserApi[_i];}FullscreenApi.prefixed=browserApi[0]!==specApi[0];}/**
 * @file create-logger.js
 * @module create-logger
 */var video_es_history=[];/**
 * Log messages to the console and history based on the type of message
 *
 * @private
 * @param  {string} type
 *         The name of the console method to use.
 *
 * @param  {Array} args
 *         The arguments to be passed to the matching console method.
 */var LogByTypeFactory=function LogByTypeFactory(name,log){return function(type,level,args){var lvl=log.levels[level];var lvlRegExp=new RegExp("^("+lvl+")$");if(type!=='log'){// Add the type to the front of the message when it's not "log".
args.unshift(type.toUpperCase()+':');}// Add console prefix after adding to history.
args.unshift(name+':');// Add a clone of the args at this point to history.
if(video_es_history){video_es_history.push([].concat(args));// only store 1000 history entries
var splice=video_es_history.length-1000;video_es_history.splice(0,splice>0?splice:0);}// If there's no console then don't try to output messages, but they will
// still be stored in history.
if(!(window_default()).console){return;}// Was setting these once outside of this function, but containing them
// in the function makes it easier to test cases where console doesn't exist
// when the module is executed.
var fn=(window_default()).console[type];if(!fn&&type==='debug'){// Certain browsers don't have support for console.debug. For those, we
// should default to the closest comparable log.
fn=(window_default()).console.info||(window_default()).console.log;}// Bail out if there's no console or if this type is not allowed by the
// current logging level.
if(!fn||!lvl||!lvlRegExp.test(type)){return;}fn[Array.isArray(args)?'apply':'call']((window_default()).console,args);};};function createLogger$1(name){// This is the private tracking variable for logging level.
var level='info';// the curried logByType bound to the specific log and history
var logByType;/**
   * Logs plain debug messages. Similar to `console.log`.
   *
   * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
   * of our JSDoc template, we cannot properly document this as both a function
   * and a namespace, so its function signature is documented here.
   *
   * #### Arguments
   * ##### *args
   * Mixed[]
   *
   * Any combination of values that could be passed to `console.log()`.
   *
   * #### Return Value
   *
   * `undefined`
   *
   * @namespace
   * @param    {Mixed[]} args
   *           One or more messages or objects that should be logged.
   */var log=function log(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}logByType('log',level,args);};// This is the logByType helper that the logging methods below use
logByType=LogByTypeFactory(name,log);/**
   * Create a new sublogger which chains the old name to the new name.
   *
   * For example, doing `videojs.log.createLogger('player')` and then using that logger will log the following:
   * ```js
   *  mylogger('foo');
   *  // > VIDEOJS: player: foo
   * ```
   *
   * @param {string} name
   *        The name to add call the new logger
   * @return {Object}
   */log.createLogger=function(subname){return createLogger$1(name+': '+subname);};/**
   * Enumeration of available logging levels, where the keys are the level names
   * and the values are `|`-separated strings containing logging methods allowed
   * in that logging level. These strings are used to create a regular expression
   * matching the function name being called.
   *
   * Levels provided by Video.js are:
   *
   * - `off`: Matches no calls. Any value that can be cast to `false` will have
   *   this effect. The most restrictive.
   * - `all`: Matches only Video.js-provided functions (`debug`, `log`,
   *   `log.warn`, and `log.error`).
   * - `debug`: Matches `log.debug`, `log`, `log.warn`, and `log.error` calls.
   * - `info` (default): Matches `log`, `log.warn`, and `log.error` calls.
   * - `warn`: Matches `log.warn` and `log.error` calls.
   * - `error`: Matches only `log.error` calls.
   *
   * @type {Object}
   */log.levels={all:'debug|log|warn|error',off:'',debug:'debug|log|warn|error',info:'log|warn|error',warn:'warn|error',error:'error',DEFAULT:level};/**
   * Get or set the current logging level.
   *
   * If a string matching a key from {@link module:log.levels} is provided, acts
   * as a setter.
   *
   * @param  {string} [lvl]
   *         Pass a valid level to set a new logging level.
   *
   * @return {string}
   *         The current logging level.
   */log.level=function(lvl){if(typeof lvl==='string'){if(!log.levels.hasOwnProperty(lvl)){throw new Error("\""+lvl+"\" in not a valid log level");}level=lvl;}return level;};/**
   * Returns an array containing everything that has been logged to the history.
   *
   * This array is a shallow clone of the internal history record. However, its
   * contents are _not_ cloned; so, mutating objects inside this array will
   * mutate them in history.
   *
   * @return {Array}
   */log.history=function(){return video_es_history?[].concat(video_es_history):[];};/**
   * Allows you to filter the history by the given logger name
   *
   * @param {string} fname
   *        The name to filter by
   *
   * @return {Array}
   *         The filtered list to return
   */log.history.filter=function(fname){return(video_es_history||[]).filter(function(historyItem){// if the first item in each historyItem includes `fname`, then it's a match
return new RegExp(".*"+fname+".*").test(historyItem[0]);});};/**
   * Clears the internal history tracking, but does not prevent further history
   * tracking.
   */log.history.clear=function(){if(video_es_history){video_es_history.length=0;}};/**
   * Disable history tracking if it is currently enabled.
   */log.history.disable=function(){if(video_es_history!==null){video_es_history.length=0;video_es_history=null;}};/**
   * Enable history tracking if it is currently disabled.
   */log.history.enable=function(){if(video_es_history===null){video_es_history=[];}};/**
   * Logs error messages. Similar to `console.error`.
   *
   * @param {Mixed[]} args
   *        One or more messages or objects that should be logged as an error
   */log.error=function(){for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return logByType('error',level,args);};/**
   * Logs warning messages. Similar to `console.warn`.
   *
   * @param {Mixed[]} args
   *        One or more messages or objects that should be logged as a warning.
   */log.warn=function(){for(var _len3=arguments.length,args=new Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return logByType('warn',level,args);};/**
   * Logs debug messages. Similar to `console.debug`, but may also act as a comparable
   * log if `console.debug` is not available
   *
   * @param {Mixed[]} args
   *        One or more messages or objects that should be logged as debug.
   */log.debug=function(){for(var _len4=arguments.length,args=new Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}return logByType('debug',level,args);};return log;}/**
 * @file log.js
 * @module log
 */var log$1=createLogger$1('VIDEOJS');var createLogger=log$1.createLogger;/**
 * @file obj.js
 * @module obj
 */ /**
 * @callback obj:EachCallback
 *
 * @param {Mixed} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 */ /**
 * @callback obj:ReduceCallback
 *
 * @param {Mixed} accum
 *        The value that is accumulating over the reduce loop.
 *
 * @param {Mixed} value
 *        The current key for the object that is being iterated over.
 *
 * @param {string} key
 *        The current key-value for object that is being iterated over
 *
 * @return {Mixed}
 *         The new accumulated value.
 */var video_es_toString=Object.prototype.toString;/**
 * Get the keys of an Object
 *
 * @param {Object}
 *        The Object to get the keys from
 *
 * @return {string[]}
 *         An array of the keys from the object. Returns an empty array if the
 *         object passed in was invalid or had no keys.
 *
 * @private
 */var keys=function keys(object){return video_es_isObject(object)?Object.keys(object):[];};/**
 * Array-like iteration for objects.
 *
 * @param {Object} object
 *        The object to iterate over
 *
 * @param {obj:EachCallback} fn
 *        The callback function which is called for each key in the object.
 */function each(object,fn){keys(object).forEach(function(key){return fn(object[key],key);});}/**
 * Array-like reduce for objects.
 *
 * @param {Object} object
 *        The Object that you want to reduce.
 *
 * @param {Function} fn
 *         A callback function which is called for each key in the object. It
 *         receives the accumulated value and the per-iteration value and key
 *         as arguments.
 *
 * @param {Mixed} [initial = 0]
 *        Starting value
 *
 * @return {Mixed}
 *         The final accumulated value.
 */function reduce(object,fn,initial){if(initial===void 0){initial=0;}return keys(object).reduce(function(accum,key){return fn(accum,object[key],key);},initial);}/**
 * Object.assign-style object shallow merge/extend.
 *
 * @param  {Object} target
 * @param  {Object} ...sources
 * @return {Object}
 */function video_es_assign(target){for(var _len=arguments.length,sources=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){sources[_key-1]=arguments[_key];}if(Object.assign){return _extends.apply(void 0,[target].concat(sources));}sources.forEach(function(source){if(!source){return;}each(source,function(value,key){target[key]=value;});});return target;}/**
 * Returns whether a value is an object of any kind - including DOM nodes,
 * arrays, regular expressions, etc. Not functions, though.
 *
 * This avoids the gotcha where using `typeof` on a `null` value
 * results in `'object'`.
 *
 * @param  {Object} value
 * @return {boolean}
 */function video_es_isObject(value){return!!value&&video_es_typeof(value)==='object';}/**
 * Returns whether an object appears to be a "plain" object - that is, a
 * direct instance of `Object`.
 *
 * @param  {Object} value
 * @return {boolean}
 */function isPlain(value){return video_es_isObject(value)&&video_es_toString.call(value)==='[object Object]'&&value.constructor===Object;}/**
 * @file computed-style.js
 * @module computed-style
 */ /**
 * A safe getComputedStyle.
 *
 * This is needed because in Firefox, if the player is loaded in an iframe with
 * `display:none`, then `getComputedStyle` returns `null`, so, we do a
 * null-check to make sure that the player doesn't break in these cases.
 *
 * @function
 * @param    {Element} el
 *           The element you want the computed style of
 *
 * @param    {string} prop
 *           The property name you want
 *
 * @see      https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */function computedStyle(el,prop){if(!el||!prop){return'';}if(typeof (window_default()).getComputedStyle==='function'){var computedStyleValue;try{computedStyleValue=window_default().getComputedStyle(el);}catch(e){return'';}return computedStyleValue?computedStyleValue.getPropertyValue(prop)||computedStyleValue[prop]:'';}return'';}/**
 * @file browser.js
 * @module browser
 */var USER_AGENT=(window_default()).navigator&&(window_default()).navigator.userAgent||'';var webkitVersionMap=/AppleWebKit\/([\d.]+)/i.exec(USER_AGENT);var appleWebkitVersion=webkitVersionMap?parseFloat(webkitVersionMap.pop()):null;/**
 * Whether or not this device is an iPod.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_IPOD=/iPod/i.test(USER_AGENT);/**
 * The detected iOS version - or `null`.
 *
 * @static
 * @const
 * @type {string|null}
 */var IOS_VERSION=function(){var match=USER_AGENT.match(/OS (\d+)_/i);if(match&&match[1]){return match[1];}return null;}();/**
 * Whether or not this is an Android device.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_ANDROID=/Android/i.test(USER_AGENT);/**
 * The detected Android version - or `null`.
 *
 * @static
 * @const
 * @type {number|string|null}
 */var ANDROID_VERSION=function(){// This matches Android Major.Minor.Patch versions
// ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
var match=USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);if(!match){return null;}var major=match[1]&&parseFloat(match[1]);var minor=match[2]&&parseFloat(match[2]);if(major&&minor){return parseFloat(match[1]+'.'+match[2]);}else if(major){return major;}return null;}();/**
 * Whether or not this is a native Android browser.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_NATIVE_ANDROID=IS_ANDROID&&ANDROID_VERSION<5&&appleWebkitVersion<537;/**
 * Whether or not this is Mozilla Firefox.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_FIREFOX=/Firefox/i.test(USER_AGENT);/**
 * Whether or not this is Microsoft Edge.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_EDGE=/Edg/i.test(USER_AGENT);/**
 * Whether or not this is Google Chrome.
 *
 * This will also be `true` for Chrome on iOS, which will have different support
 * as it is actually Safari under the hood.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_CHROME=!IS_EDGE&&(/Chrome/i.test(USER_AGENT)||/CriOS/i.test(USER_AGENT));/**
 * The detected Google Chrome version - or `null`.
 *
 * @static
 * @const
 * @type {number|null}
 */var CHROME_VERSION=function(){var match=USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);if(match&&match[2]){return parseFloat(match[2]);}return null;}();/**
 * The detected Internet Explorer version - or `null`.
 *
 * @static
 * @const
 * @type {number|null}
 */var IE_VERSION=function(){var result=/MSIE\s(\d+)\.\d/.exec(USER_AGENT);var version=result&&parseFloat(result[1]);if(!version&&/Trident\/7.0/i.test(USER_AGENT)&&/rv:11.0/.test(USER_AGENT)){// IE 11 has a different user agent string than other IE versions
version=11.0;}return version;}();/**
 * Whether or not this is desktop Safari.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_SAFARI=/Safari/i.test(USER_AGENT)&&!IS_CHROME&&!IS_ANDROID&&!IS_EDGE;/**
 * Whether or not this is a Windows machine.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_WINDOWS=/Windows/i.test(USER_AGENT);/**
 * Whether or not this device is touch-enabled.
 *
 * @static
 * @const
 * @type {Boolean}
 */var TOUCH_ENABLED=Boolean(isReal()&&('ontouchstart'in (window_default())||(window_default()).navigator.maxTouchPoints||(window_default()).DocumentTouch&&(window_default()).document instanceof (window_default()).DocumentTouch));/**
 * Whether or not this device is an iPad.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_IPAD=/iPad/i.test(USER_AGENT)||IS_SAFARI&&TOUCH_ENABLED&&!/iPhone/i.test(USER_AGENT);/**
 * Whether or not this device is an iPhone.
 *
 * @static
 * @const
 * @type {Boolean}
 */ // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
var IS_IPHONE=/iPhone/i.test(USER_AGENT)&&!IS_IPAD;/**
 * Whether or not this is an iOS device.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_IOS=IS_IPHONE||IS_IPAD||IS_IPOD;/**
 * Whether or not this is any flavor of Safari - including iOS.
 *
 * @static
 * @const
 * @type {Boolean}
 */var IS_ANY_SAFARI=(IS_SAFARI||IS_IOS)&&!IS_CHROME;var video_es_browser=/*#__PURE__*/Object.freeze({__proto__:null,IS_IPOD:IS_IPOD,IOS_VERSION:IOS_VERSION,IS_ANDROID:IS_ANDROID,ANDROID_VERSION:ANDROID_VERSION,IS_NATIVE_ANDROID:IS_NATIVE_ANDROID,IS_FIREFOX:IS_FIREFOX,IS_EDGE:IS_EDGE,IS_CHROME:IS_CHROME,CHROME_VERSION:CHROME_VERSION,IE_VERSION:IE_VERSION,IS_SAFARI:IS_SAFARI,IS_WINDOWS:IS_WINDOWS,TOUCH_ENABLED:TOUCH_ENABLED,IS_IPAD:IS_IPAD,IS_IPHONE:IS_IPHONE,IS_IOS:IS_IOS,IS_ANY_SAFARI:IS_ANY_SAFARI});/**
 * @file dom.js
 * @module dom
 */ /**
 * Detect if a value is a string with any non-whitespace characters.
 *
 * @private
 * @param  {string} str
 *         The string to check
 *
 * @return {boolean}
 *         Will be `true` if the string is non-blank, `false` otherwise.
 *
 */function isNonBlankString(str){// we use str.trim as it will trim any whitespace characters
// from the front or back of non-whitespace characters. aka
// Any string that contains non-whitespace characters will
// still contain them after `trim` but whitespace only strings
// will have a length of 0, failing this check.
return typeof str==='string'&&Boolean(str.trim());}/**
 * Throws an error if the passed string has whitespace. This is used by
 * class methods to be relatively consistent with the classList API.
 *
 * @private
 * @param  {string} str
 *         The string to check for whitespace.
 *
 * @throws {Error}
 *         Throws an error if there is whitespace in the string.
 */function throwIfWhitespace(str){// str.indexOf instead of regex because str.indexOf is faster performance wise.
if(str.indexOf(' ')>=0){throw new Error('class has illegal whitespace characters');}}/**
 * Produce a regular expression for matching a className within an elements className.
 *
 * @private
 * @param  {string} className
 *         The className to generate the RegExp for.
 *
 * @return {RegExp}
 *         The RegExp that will check for a specific `className` in an elements
 *         className.
 */function classRegExp(className){return new RegExp('(^|\\s)'+className+'($|\\s)');}/**
 * Whether the current DOM interface appears to be real (i.e. not simulated).
 *
 * @return {boolean}
 *         Will be `true` if the DOM appears to be real, `false` otherwise.
 */function isReal(){// Both document and window will never be undefined thanks to `global`.
return (document_default())===(window_default()).document;}/**
 * Determines, via duck typing, whether or not a value is a DOM element.
 *
 * @param  {Mixed} value
 *         The value to check.
 *
 * @return {boolean}
 *         Will be `true` if the value is a DOM element, `false` otherwise.
 */function isEl(value){return video_es_isObject(value)&&value.nodeType===1;}/**
 * Determines if the current DOM is embedded in an iframe.
 *
 * @return {boolean}
 *         Will be `true` if the DOM is embedded in an iframe, `false`
 *         otherwise.
 */function isInFrame(){// We need a try/catch here because Safari will throw errors when attempting
// to get either `parent` or `self`
try{return (window_default()).parent!==(window_default()).self;}catch(x){return true;}}/**
 * Creates functions to query the DOM using a given method.
 *
 * @private
 * @param   {string} method
 *          The method to create the query with.
 *
 * @return  {Function}
 *          The query method
 */function createQuerier(method){return function(selector,context){if(!isNonBlankString(selector)){return (document_default())[method](null);}if(isNonBlankString(context)){context=document_default().querySelector(context);}var ctx=isEl(context)?context:(document_default());return ctx[method]&&ctx[method](selector);};}/**
 * Creates an element and applies properties, attributes, and inserts content.
 *
 * @param  {string} [tagName='div']
 *         Name of tag to be created.
 *
 * @param  {Object} [properties={}]
 *         Element properties to be applied.
 *
 * @param  {Object} [attributes={}]
 *         Element attributes to be applied.
 *
 * @param {module:dom~ContentDescriptor} content
 *        A content descriptor object.
 *
 * @return {Element}
 *         The element that was created.
 */function createEl(tagName,properties,attributes,content){if(tagName===void 0){tagName='div';}if(properties===void 0){properties={};}if(attributes===void 0){attributes={};}var el=document_default().createElement(tagName);Object.getOwnPropertyNames(properties).forEach(function(propName){var val=properties[propName];// See #2176
// We originally were accepting both properties and attributes in the
// same object, but that doesn't work so well.
if(propName.indexOf('aria-')!==-1||propName==='role'||propName==='type'){log$1.warn('Setting attributes in the second argument of createEl()\n'+'has been deprecated. Use the third argument instead.\n'+("createEl(type, properties, attributes). Attempting to set "+propName+" to "+val+"."));el.setAttribute(propName,val);// Handle textContent since it's not supported everywhere and we have a
// method for it.
}else if(propName==='textContent'){textContent(el,val);}else if(el[propName]!==val||propName==='tabIndex'){el[propName]=val;}});Object.getOwnPropertyNames(attributes).forEach(function(attrName){el.setAttribute(attrName,attributes[attrName]);});if(content){appendContent(el,content);}return el;}/**
 * Injects text into an element, replacing any existing contents entirely.
 *
 * @param  {Element} el
 *         The element to add text content into
 *
 * @param  {string} text
 *         The text content to add.
 *
 * @return {Element}
 *         The element with added text content.
 */function textContent(el,text){if(typeof el.textContent==='undefined'){el.innerText=text;}else{el.textContent=text;}return el;}/**
 * Insert an element as the first child node of another
 *
 * @param {Element} child
 *        Element to insert
 *
 * @param {Element} parent
 *        Element to insert child into
 */function prependTo(child,parent){if(parent.firstChild){parent.insertBefore(child,parent.firstChild);}else{parent.appendChild(child);}}/**
 * Check if an element has a class name.
 *
 * @param  {Element} element
 *         Element to check
 *
 * @param  {string} classToCheck
 *         Class name to check for
 *
 * @return {boolean}
 *         Will be `true` if the element has a class, `false` otherwise.
 *
 * @throws {Error}
 *         Throws an error if `classToCheck` has white space.
 */function hasClass(element,classToCheck){throwIfWhitespace(classToCheck);if(element.classList){return element.classList.contains(classToCheck);}return classRegExp(classToCheck).test(element.className);}/**
 * Add a class name to an element.
 *
 * @param  {Element} element
 *         Element to add class name to.
 *
 * @param  {string} classToAdd
 *         Class name to add.
 *
 * @return {Element}
 *         The DOM element with the added class name.
 */function addClass(element,classToAdd){if(element.classList){element.classList.add(classToAdd);// Don't need to `throwIfWhitespace` here because `hasElClass` will do it
// in the case of classList not being supported.
}else if(!hasClass(element,classToAdd)){element.className=(element.className+' '+classToAdd).trim();}return element;}/**
 * Remove a class name from an element.
 *
 * @param  {Element} element
 *         Element to remove a class name from.
 *
 * @param  {string} classToRemove
 *         Class name to remove
 *
 * @return {Element}
 *         The DOM element with class name removed.
 */function removeClass(element,classToRemove){// Protect in case the player gets disposed
if(!element){log$1.warn("removeClass was called with an element that doesn't exist");return null;}if(element.classList){element.classList.remove(classToRemove);}else{throwIfWhitespace(classToRemove);element.className=element.className.split(/\s+/).filter(function(c){return c!==classToRemove;}).join(' ');}return element;}/**
 * The callback definition for toggleClass.
 *
 * @callback module:dom~PredicateCallback
 * @param    {Element} element
 *           The DOM element of the Component.
 *
 * @param    {string} classToToggle
 *           The `className` that wants to be toggled
 *
 * @return   {boolean|undefined}
 *           If `true` is returned, the `classToToggle` will be added to the
 *           `element`. If `false`, the `classToToggle` will be removed from
 *           the `element`. If `undefined`, the callback will be ignored.
 */ /**
 * Adds or removes a class name to/from an element depending on an optional
 * condition or the presence/absence of the class name.
 *
 * @param  {Element} element
 *         The element to toggle a class name on.
 *
 * @param  {string} classToToggle
 *         The class that should be toggled.
 *
 * @param  {boolean|module:dom~PredicateCallback} [predicate]
 *         See the return value for {@link module:dom~PredicateCallback}
 *
 * @return {Element}
 *         The element with a class that has been toggled.
 */function toggleClass(element,classToToggle,predicate){// This CANNOT use `classList` internally because IE11 does not support the
// second parameter to the `classList.toggle()` method! Which is fine because
// `classList` will be used by the add/remove functions.
var has=hasClass(element,classToToggle);if(typeof predicate==='function'){predicate=predicate(element,classToToggle);}if(typeof predicate!=='boolean'){predicate=!has;}// If the necessary class operation matches the current state of the
// element, no action is required.
if(predicate===has){return;}if(predicate){addClass(element,classToToggle);}else{removeClass(element,classToToggle);}return element;}/**
 * Apply attributes to an HTML element.
 *
 * @param {Element} el
 *        Element to add attributes to.
 *
 * @param {Object} [attributes]
 *        Attributes to be applied.
 */function setAttributes(el,attributes){Object.getOwnPropertyNames(attributes).forEach(function(attrName){var attrValue=attributes[attrName];if(attrValue===null||typeof attrValue==='undefined'||attrValue===false){el.removeAttribute(attrName);}else{el.setAttribute(attrName,attrValue===true?'':attrValue);}});}/**
 * Get an element's attribute values, as defined on the HTML tag.
 *
 * Attributes are not the same as properties. They're defined on the tag
 * or with setAttribute.
 *
 * @param  {Element} tag
 *         Element from which to get tag attributes.
 *
 * @return {Object}
 *         All attributes of the element. Boolean attributes will be `true` or
 *         `false`, others will be strings.
 */function getAttributes(tag){var obj={};// known boolean attributes
// we can check for matching boolean properties, but not all browsers
// and not all tags know about these attributes, so, we still want to check them manually
var knownBooleans=','+'autoplay,controls,playsinline,loop,muted,default,defaultMuted'+',';if(tag&&tag.attributes&&tag.attributes.length>0){var attrs=tag.attributes;for(var i=attrs.length-1;i>=0;i--){var attrName=attrs[i].name;var attrVal=attrs[i].value;// check for known booleans
// the matching element property will return a value for typeof
if(typeof tag[attrName]==='boolean'||knownBooleans.indexOf(','+attrName+',')!==-1){// the value of an included boolean attribute is typically an empty
// string ('') which would equal false if we just check for a false value.
// we also don't want support bad code like autoplay='false'
attrVal=attrVal!==null?true:false;}obj[attrName]=attrVal;}}return obj;}/**
 * Get the value of an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to get the value of.
 *
 * @return {string}
 *         The value of the attribute.
 */function getAttribute(el,attribute){return el.getAttribute(attribute);}/**
 * Set the value of an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to set.
 *
 * @param {string} value
 *        Value to set the attribute to.
 */function setAttribute(el,attribute,value){el.setAttribute(attribute,value);}/**
 * Remove an element's attribute.
 *
 * @param {Element} el
 *        A DOM element.
 *
 * @param {string} attribute
 *        Attribute to remove.
 */function removeAttribute(el,attribute){el.removeAttribute(attribute);}/**
 * Attempt to block the ability to select text.
 */function blockTextSelection(){document_default().body.focus();(document_default()).onselectstart=function(){return false;};}/**
 * Turn off text selection blocking.
 */function unblockTextSelection(){(document_default()).onselectstart=function(){return true;};}/**
 * Identical to the native `getBoundingClientRect` function, but ensures that
 * the method is supported at all (it is in all browsers we claim to support)
 * and that the element is in the DOM before continuing.
 *
 * This wrapper function also shims properties which are not provided by some
 * older browsers (namely, IE8).
 *
 * Additionally, some browsers do not support adding properties to a
 * `ClientRect`/`DOMRect` object; so, we shallow-copy it with the standard
 * properties (except `x` and `y` which are not widely supported). This helps
 * avoid implementations where keys are non-enumerable.
 *
 * @param  {Element} el
 *         Element whose `ClientRect` we want to calculate.
 *
 * @return {Object|undefined}
 *         Always returns a plain object - or `undefined` if it cannot.
 */function getBoundingClientRect(el){if(el&&el.getBoundingClientRect&&el.parentNode){var rect=el.getBoundingClientRect();var result={};['bottom','height','left','right','top','width'].forEach(function(k){if(rect[k]!==undefined){result[k]=rect[k];}});if(!result.height){result.height=parseFloat(computedStyle(el,'height'));}if(!result.width){result.width=parseFloat(computedStyle(el,'width'));}return result;}}/**
 * Represents the position of a DOM element on the page.
 *
 * @typedef  {Object} module:dom~Position
 *
 * @property {number} left
 *           Pixels to the left.
 *
 * @property {number} top
 *           Pixels from the top.
 */ /**
 * Get the position of an element in the DOM.
 *
 * Uses `getBoundingClientRect` technique from John Resig.
 *
 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @param  {Element} el
 *         Element from which to get offset.
 *
 * @return {module:dom~Position}
 *         The position of the element that was passed in.
 */function findPosition(el){if(!el||el&&!el.offsetParent){return{left:0,top:0,width:0,height:0};}var width=el.offsetWidth;var height=el.offsetHeight;var left=0;var top=0;while(el.offsetParent&&el!==(document_default())[FullscreenApi.fullscreenElement]){left+=el.offsetLeft;top+=el.offsetTop;el=el.offsetParent;}return{left:left,top:top,width:width,height:height};}/**
 * Represents x and y coordinates for a DOM element or mouse pointer.
 *
 * @typedef  {Object} module:dom~Coordinates
 *
 * @property {number} x
 *           x coordinate in pixels
 *
 * @property {number} y
 *           y coordinate in pixels
 */ /**
 * Get the pointer position within an element.
 *
 * The base on the coordinates are the bottom left of the element.
 *
 * @param  {Element} el
 *         Element on which to get the pointer position on.
 *
 * @param  {EventTarget~Event} event
 *         Event object.
 *
 * @return {module:dom~Coordinates}
 *         A coordinates object corresponding to the mouse position.
 *
 */function getPointerPosition(el,event){var translated={x:0,y:0};if(IS_IOS){var item=el;while(item&&item.nodeName.toLowerCase()!=='html'){var transform=computedStyle(item,'transform');if(/^matrix/.test(transform)){var values=transform.slice(7,-1).split(/,\s/).map(Number);translated.x+=values[4];translated.y+=values[5];}else if(/^matrix3d/.test(transform)){var _values=transform.slice(9,-1).split(/,\s/).map(Number);translated.x+=_values[12];translated.y+=_values[13];}item=item.parentNode;}}var position={};var boxTarget=findPosition(event.target);var box=findPosition(el);var boxW=box.width;var boxH=box.height;var offsetY=event.offsetY-(box.top-boxTarget.top);var offsetX=event.offsetX-(box.left-boxTarget.left);if(event.changedTouches){offsetX=event.changedTouches[0].pageX-box.left;offsetY=event.changedTouches[0].pageY+box.top;if(IS_IOS){offsetX-=translated.x;offsetY-=translated.y;}}position.y=1-Math.max(0,Math.min(1,offsetY/boxH));position.x=Math.max(0,Math.min(1,offsetX/boxW));return position;}/**
 * Determines, via duck typing, whether or not a value is a text node.
 *
 * @param  {Mixed} value
 *         Check if this value is a text node.
 *
 * @return {boolean}
 *         Will be `true` if the value is a text node, `false` otherwise.
 */function isTextNode(value){return video_es_isObject(value)&&value.nodeType===3;}/**
 * Empties the contents of an element.
 *
 * @param  {Element} el
 *         The element to empty children from
 *
 * @return {Element}
 *         The element with no children
 */function emptyEl(el){while(el.firstChild){el.removeChild(el.firstChild);}return el;}/**
 * This is a mixed value that describes content to be injected into the DOM
 * via some method. It can be of the following types:
 *
 * Type       | Description
 * -----------|-------------
 * `string`   | The value will be normalized into a text node.
 * `Element`  | The value will be accepted as-is.
 * `TextNode` | The value will be accepted as-is.
 * `Array`    | A one-dimensional array of strings, elements, text nodes, or functions. These functions should return a string, element, or text node (any other return value, like an array, will be ignored).
 * `Function` | A function, which is expected to return a string, element, text node, or array - any of the other possible values described above. This means that a content descriptor could be a function that returns an array of functions, but those second-level functions must return strings, elements, or text nodes.
 *
 * @typedef {string|Element|TextNode|Array|Function} module:dom~ContentDescriptor
 */ /**
 * Normalizes content for eventual insertion into the DOM.
 *
 * This allows a wide range of content definition methods, but helps protect
 * from falling into the trap of simply writing to `innerHTML`, which could
 * be an XSS concern.
 *
 * The content for an element can be passed in multiple types and
 * combinations, whose behavior is as follows:
 *
 * @param {module:dom~ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Array}
 *         All of the content that was passed in, normalized to an array of
 *         elements or text nodes.
 */function normalizeContent(content){// First, invoke content if it is a function. If it produces an array,
// that needs to happen before normalization.
if(typeof content==='function'){content=content();}// Next up, normalize to an array, so one or many items can be normalized,
// filtered, and returned.
return(Array.isArray(content)?content:[content]).map(function(value){// First, invoke value if it is a function to produce a new value,
// which will be subsequently normalized to a Node of some kind.
if(typeof value==='function'){value=value();}if(isEl(value)||isTextNode(value)){return value;}if(typeof value==='string'&&/\S/.test(value)){return document_default().createTextNode(value);}}).filter(function(value){return value;});}/**
 * Normalizes and appends content to an element.
 *
 * @param  {Element} el
 *         Element to append normalized content to.
 *
 * @param {module:dom~ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Element}
 *         The element with appended normalized content.
 */function appendContent(el,content){normalizeContent(content).forEach(function(node){return el.appendChild(node);});return el;}/**
 * Normalizes and inserts content into an element; this is identical to
 * `appendContent()`, except it empties the element first.
 *
 * @param {Element} el
 *        Element to insert normalized content into.
 *
 * @param {module:dom~ContentDescriptor} content
 *        A content descriptor value.
 *
 * @return {Element}
 *         The element with inserted normalized content.
 */function insertContent(el,content){return appendContent(emptyEl(el),content);}/**
 * Check if an event was a single left click.
 *
 * @param  {EventTarget~Event} event
 *         Event object.
 *
 * @return {boolean}
 *         Will be `true` if a single left click, `false` otherwise.
 */function isSingleLeftClick(event){// Note: if you create something draggable, be sure to
// call it on both `mousedown` and `mousemove` event,
// otherwise `mousedown` should be enough for a button
if(event.button===undefined&&event.buttons===undefined){// Why do we need `buttons` ?
// Because, middle mouse sometimes have this:
// e.button === 0 and e.buttons === 4
// Furthermore, we want to prevent combination click, something like
// HOLD middlemouse then left click, that would be
// e.button === 0, e.buttons === 5
// just `button` is not gonna work
// Alright, then what this block does ?
// this is for chrome `simulate mobile devices`
// I want to support this as well
return true;}if(event.button===0&&event.buttons===undefined){// Touch screen, sometimes on some specific device, `buttons`
// doesn't have anything (safari on ios, blackberry...)
return true;}// `mouseup` event on a single left click has
// `button` and `buttons` equal to 0
if(event.type==='mouseup'&&event.button===0&&event.buttons===0){return true;}if(event.button!==0||event.buttons!==1){// This is the reason we have those if else block above
// if any special case we can catch and let it slide
// we do it above, when get to here, this definitely
// is-not-left-click
return false;}return true;}/**
 * Finds a single DOM element matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param  {string} selector
 *         A valid CSS selector, which will be passed to `querySelector`.
 *
 * @param  {Element|String} [context=document]
 *         A DOM element within which to query. Can also be a selector
 *         string in which case the first matching element will be used
 *         as context. If missing (or no element matches selector), falls
 *         back to `document`.
 *
 * @return {Element|null}
 *         The element that was found or null.
 */var $=createQuerier('querySelector');/**
 * Finds a all DOM elements matching `selector` within the optional
 * `context` of another DOM element (defaulting to `document`).
 *
 * @param  {string} selector
 *         A valid CSS selector, which will be passed to `querySelectorAll`.
 *
 * @param  {Element|String} [context=document]
 *         A DOM element within which to query. Can also be a selector
 *         string in which case the first matching element will be used
 *         as context. If missing (or no element matches selector), falls
 *         back to `document`.
 *
 * @return {NodeList}
 *         A element list of elements that were found. Will be empty if none
 *         were found.
 *
 */var $$=createQuerier('querySelectorAll');var Dom=/*#__PURE__*/Object.freeze({__proto__:null,isReal:isReal,isEl:isEl,isInFrame:isInFrame,createEl:createEl,textContent:textContent,prependTo:prependTo,hasClass:hasClass,addClass:addClass,removeClass:removeClass,toggleClass:toggleClass,setAttributes:setAttributes,getAttributes:getAttributes,getAttribute:getAttribute,setAttribute:setAttribute,removeAttribute:removeAttribute,blockTextSelection:blockTextSelection,unblockTextSelection:unblockTextSelection,getBoundingClientRect:getBoundingClientRect,findPosition:findPosition,getPointerPosition:getPointerPosition,isTextNode:isTextNode,emptyEl:emptyEl,normalizeContent:normalizeContent,appendContent:appendContent,insertContent:insertContent,isSingleLeftClick:isSingleLeftClick,$:$,$$:$$});/**
 * @file setup.js - Functions for setting up a player without
 * user interaction based on the data-setup `attribute` of the video tag.
 *
 * @module setup
 */var _windowLoaded=false;var videojs$1;/**
 * Set up any tags that have a data-setup `attribute` when the player is started.
 */var autoSetup=function autoSetup(){if(videojs$1.options.autoSetup===false){return;}var vids=Array.prototype.slice.call(document_default().getElementsByTagName('video'));var audios=Array.prototype.slice.call(document_default().getElementsByTagName('audio'));var divs=Array.prototype.slice.call(document_default().getElementsByTagName('video-js'));var mediaEls=vids.concat(audios,divs);// Check if any media elements exist
if(mediaEls&&mediaEls.length>0){for(var i=0,e=mediaEls.length;i<e;i++){var mediaEl=mediaEls[i];// Check if element exists, has getAttribute func.
if(mediaEl&&mediaEl.getAttribute){// Make sure this player hasn't already been set up.
if(mediaEl.player===undefined){var options=mediaEl.getAttribute('data-setup');// Check if data-setup attr exists.
// We only auto-setup if they've added the data-setup attr.
if(options!==null){// Create new video.js instance.
videojs$1(mediaEl);}}// If getAttribute isn't defined, we need to wait for the DOM.
}else{autoSetupTimeout(1);break;}}// No videos were found, so keep looping unless page is finished loading.
}else if(!_windowLoaded){autoSetupTimeout(1);}};/**
 * Wait until the page is loaded before running autoSetup. This will be called in
 * autoSetup if `hasLoaded` returns false.
 *
 * @param {number} wait
 *        How long to wait in ms
 *
 * @param {module:videojs} [vjs]
 *        The videojs library function
 */function autoSetupTimeout(wait,vjs){// Protect against breakage in non-browser environments
if(!isReal()){return;}if(vjs){videojs$1=vjs;}window_default().setTimeout(autoSetup,wait);}/**
 * Used to set the internal tracking of window loaded state to true.
 *
 * @private
 */function setWindowLoaded(){_windowLoaded=true;window_default().removeEventListener('load',setWindowLoaded);}if(isReal()){if((document_default()).readyState==='complete'){setWindowLoaded();}else{/**
     * Listen for the load event on window, and set _windowLoaded to true.
     *
     * We use a standard event listener here to avoid incrementing the GUID
     * before any players are created.
     *
     * @listens load
     */window_default().addEventListener('load',setWindowLoaded);}}/**
 * @file stylesheet.js
 * @module stylesheet
 */ /**
 * Create a DOM syle element given a className for it.
 *
 * @param {string} className
 *        The className to add to the created style element.
 *
 * @return {Element}
 *         The element that was created.
 */var createStyleElement=function createStyleElement(className){var style=document_default().createElement('style');style.className=className;return style;};/**
 * Add text to a DOM element.
 *
 * @param {Element} el
 *        The Element to add text content to.
 *
 * @param {string} content
 *        The text to add to the element.
 */var setTextContent=function setTextContent(el,content){if(el.styleSheet){el.styleSheet.cssText=content;}else{el.textContent=content;}};/**
 * @file guid.js
 * @module guid
 */ // Default value for GUIDs. This allows us to reset the GUID counter in tests.
//
// The initial GUID is 3 because some users have come to rely on the first
// default player ID ending up as `vjs_video_3`.
//
// See: https://github.com/videojs/video.js/pull/6216
var _initialGuid=3;/**
 * Unique ID for an element or function
 *
 * @type {Number}
 */var _guid=_initialGuid;/**
 * Get a unique auto-incrementing ID by number that has not been returned before.
 *
 * @return {number}
 *         A new unique ID.
 */function newGUID(){return _guid++;}/**
 * @file dom-data.js
 * @module dom-data
 */var FakeWeakMap;if(!(window_default()).WeakMap){FakeWeakMap=/*#__PURE__*/function(){function FakeWeakMap(){this.vdata='vdata'+Math.floor((window_default()).performance&&window_default().performance.now()||Date.now());this.data={};}var _proto=FakeWeakMap.prototype;_proto.set=function set(key,value){var access=key[this.vdata]||newGUID();if(!key[this.vdata]){key[this.vdata]=access;}this.data[access]=value;return this;};_proto.get=function get(key){var access=key[this.vdata];// we have data, return it
if(access){return this.data[access];}// we don't have data, return nothing.
// return undefined explicitly as that's the contract for this method
log$1('We have no data for this element',key);return undefined;};_proto.has=function has(key){var access=key[this.vdata];return access in this.data;};_proto["delete"]=function _delete(key){var access=key[this.vdata];if(access){delete this.data[access];delete key[this.vdata];}};return FakeWeakMap;}();}/**
 * Element Data Store.
 *
 * Allows for binding data to an element without putting it directly on the
 * element. Ex. Event listeners are stored here.
 * (also from jsninja.com, slightly modified and updated for closure compiler)
 *
 * @type {Object}
 * @private
 */var DomData=(window_default()).WeakMap?new WeakMap():new FakeWeakMap();/**
 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
 * robust as jquery's, so there's probably some differences.
 *
 * @file events.js
 * @module events
 */ /**
 * Clean up the listener cache and dispatchers
 *
 * @param {Element|Object} elem
 *        Element to clean up
 *
 * @param {string} type
 *        Type of event to clean up
 */function _cleanUpEvents(elem,type){if(!DomData.has(elem)){return;}var data=DomData.get(elem);// Remove the events of a particular type if there are none left
if(data.handlers[type].length===0){delete data.handlers[type];// data.handlers[type] = null;
// Setting to null was causing an error with data.handlers
// Remove the meta-handler from the element
if(elem.removeEventListener){elem.removeEventListener(type,data.dispatcher,false);}else if(elem.detachEvent){elem.detachEvent('on'+type,data.dispatcher);}}// Remove the events object if there are no types left
if(Object.getOwnPropertyNames(data.handlers).length<=0){delete data.handlers;delete data.dispatcher;delete data.disabled;}// Finally remove the element data if there is no data left
if(Object.getOwnPropertyNames(data).length===0){DomData["delete"](elem);}}/**
 * Loops through an array of event types and calls the requested method for each type.
 *
 * @param {Function} fn
 *        The event method we want to use.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string} type
 *        Type of event to bind to.
 *
 * @param {EventTarget~EventListener} callback
 *        Event listener.
 */function _handleMultipleEvents(fn,elem,types,callback){types.forEach(function(type){// Call the event method for each one of the types
fn(elem,type,callback);});}/**
 * Fix a native event to have standard property values
 *
 * @param {Object} event
 *        Event object to fix.
 *
 * @return {Object}
 *         Fixed event object.
 */function fixEvent(event){if(event.fixed_){return event;}function returnTrue(){return true;}function returnFalse(){return false;}// Test if fixing up is needed
// Used to check if !event.stopPropagation instead of isPropagationStopped
// But native events return true for stopPropagation, but don't have
// other expected methods like isPropagationStopped. Seems to be a problem
// with the Javascript Ninja code. So we're just overriding all events now.
if(!event||!event.isPropagationStopped||!event.isImmediatePropagationStopped){var old=event||(window_default()).event;event={};// Clone the old object so that we can modify the values event = {};
// IE8 Doesn't like when you mess with native event properties
// Firefox returns false for event.hasOwnProperty('type') and other props
//  which makes copying more difficult.
// TODO: Probably best to create a whitelist of event props
for(var key in old){// Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
// Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
// and webkitMovementX/Y
// Lighthouse complains if Event.path is copied
if(key!=='layerX'&&key!=='layerY'&&key!=='keyLocation'&&key!=='webkitMovementX'&&key!=='webkitMovementY'&&key!=='path'){// Chrome 32+ warns if you try to copy deprecated returnValue, but
// we still want to if preventDefault isn't supported (IE8).
if(!(key==='returnValue'&&old.preventDefault)){event[key]=old[key];}}}// The event occurred on this element
if(!event.target){event.target=event.srcElement||(document_default());}// Handle which other element the event is related to
if(!event.relatedTarget){event.relatedTarget=event.fromElement===event.target?event.toElement:event.fromElement;}// Stop the default browser action
event.preventDefault=function(){if(old.preventDefault){old.preventDefault();}event.returnValue=false;old.returnValue=false;event.defaultPrevented=true;};event.defaultPrevented=false;// Stop the event from bubbling
event.stopPropagation=function(){if(old.stopPropagation){old.stopPropagation();}event.cancelBubble=true;old.cancelBubble=true;event.isPropagationStopped=returnTrue;};event.isPropagationStopped=returnFalse;// Stop the event from bubbling and executing other handlers
event.stopImmediatePropagation=function(){if(old.stopImmediatePropagation){old.stopImmediatePropagation();}event.isImmediatePropagationStopped=returnTrue;event.stopPropagation();};event.isImmediatePropagationStopped=returnFalse;// Handle mouse position
if(event.clientX!==null&&event.clientX!==undefined){var doc=(document_default()).documentElement;var body=(document_default()).body;event.pageX=event.clientX+(doc&&doc.scrollLeft||body&&body.scrollLeft||0)-(doc&&doc.clientLeft||body&&body.clientLeft||0);event.pageY=event.clientY+(doc&&doc.scrollTop||body&&body.scrollTop||0)-(doc&&doc.clientTop||body&&body.clientTop||0);}// Handle key presses
event.which=event.charCode||event.keyCode;// Fix button for mouse clicks:
// 0 == left; 1 == middle; 2 == right
if(event.button!==null&&event.button!==undefined){// The following is disabled because it does not pass videojs-standard
// and... yikes.
/* eslint-disable */event.button=event.button&1?0:event.button&4?1:event.button&2?2:0;/* eslint-enable */}}event.fixed_=true;// Returns fixed-up instance
return event;}/**
 * Whether passive event listeners are supported
 */var _supportsPassive;var supportsPassive=function supportsPassive(){if(typeof _supportsPassive!=='boolean'){_supportsPassive=false;try{var opts=Object.defineProperty({},'passive',{get:function get(){_supportsPassive=true;}});window_default().addEventListener('test',null,opts);window_default().removeEventListener('test',null,opts);}catch(e){// disregard
}}return _supportsPassive;};/**
 * Touch events Chrome expects to be passive
 */var passiveEvents=['touchstart','touchmove'];/**
 * Add an event listener to element
 * It stores the handler function in a separate cache object
 * and adds a generic handler to the element's event,
 * along with a unique id (guid) to the element.
 *
 * @param {Element|Object} elem
 *        Element or object to bind listeners to
 *
 * @param {string|string[]} type
 *        Type of event to bind to.
 *
 * @param {EventTarget~EventListener} fn
 *        Event listener.
 */function on(elem,type,fn){if(Array.isArray(type)){return _handleMultipleEvents(on,elem,type,fn);}if(!DomData.has(elem)){DomData.set(elem,{});}var data=DomData.get(elem);// We need a place to store all our handler data
if(!data.handlers){data.handlers={};}if(!data.handlers[type]){data.handlers[type]=[];}if(!fn.guid){fn.guid=newGUID();}data.handlers[type].push(fn);if(!data.dispatcher){data.disabled=false;data.dispatcher=function(event,hash){if(data.disabled){return;}event=fixEvent(event);var handlers=data.handlers[event.type];if(handlers){// Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
var handlersCopy=handlers.slice(0);for(var m=0,n=handlersCopy.length;m<n;m++){if(event.isImmediatePropagationStopped()){break;}else{try{handlersCopy[m].call(elem,event,hash);}catch(e){log$1.error(e);}}}}};}if(data.handlers[type].length===1){if(elem.addEventListener){var options=false;if(supportsPassive()&&passiveEvents.indexOf(type)>-1){options={passive:true};}elem.addEventListener(type,data.dispatcher,options);}else if(elem.attachEvent){elem.attachEvent('on'+type,data.dispatcher);}}}/**
 * Removes event listeners from an element
 *
 * @param {Element|Object} elem
 *        Object to remove listeners from.
 *
 * @param {string|string[]} [type]
 *        Type of listener to remove. Don't include to remove all events from element.
 *
 * @param {EventTarget~EventListener} [fn]
 *        Specific listener to remove. Don't include to remove listeners for an event
 *        type.
 */function off(elem,type,fn){// Don't want to add a cache object through getElData if not needed
if(!DomData.has(elem)){return;}var data=DomData.get(elem);// If no events exist, nothing to unbind
if(!data.handlers){return;}if(Array.isArray(type)){return _handleMultipleEvents(off,elem,type,fn);}// Utility function
var removeType=function removeType(el,t){data.handlers[t]=[];_cleanUpEvents(el,t);};// Are we removing all bound events?
if(type===undefined){for(var t in data.handlers){if(Object.prototype.hasOwnProperty.call(data.handlers||{},t)){removeType(elem,t);}}return;}var handlers=data.handlers[type];// If no handlers exist, nothing to unbind
if(!handlers){return;}// If no listener was provided, remove all listeners for type
if(!fn){removeType(elem,type);return;}// We're only removing a single handler
if(fn.guid){for(var n=0;n<handlers.length;n++){if(handlers[n].guid===fn.guid){handlers.splice(n--,1);}}}_cleanUpEvents(elem,type);}/**
 * Trigger an event for an element
 *
 * @param {Element|Object} elem
 *        Element to trigger an event on
 *
 * @param {EventTarget~Event|string} event
 *        A string (the type) or an event object with a type attribute
 *
 * @param {Object} [hash]
 *        data hash to pass along with the event
 *
 * @return {boolean|undefined}
 *         Returns the opposite of `defaultPrevented` if default was
 *         prevented. Otherwise, returns `undefined`
 */function trigger(elem,event,hash){// Fetches element data and a reference to the parent (for bubbling).
// Don't want to add a data object to cache for every parent,
// so checking hasElData first.
var elemData=DomData.has(elem)?DomData.get(elem):{};var parent=elem.parentNode||elem.ownerDocument;// type = event.type || event,
// handler;
// If an event name was passed as a string, creates an event out of it
if(typeof event==='string'){event={type:event,target:elem};}else if(!event.target){event.target=elem;}// Normalizes the event properties.
event=fixEvent(event);// If the passed element has a dispatcher, executes the established handlers.
if(elemData.dispatcher){elemData.dispatcher.call(elem,event,hash);}// Unless explicitly stopped or the event does not bubble (e.g. media events)
// recursively calls this function to bubble the event up the DOM.
if(parent&&!event.isPropagationStopped()&&event.bubbles===true){trigger.call(null,parent,event,hash);// If at the top of the DOM, triggers the default action unless disabled.
}else if(!parent&&!event.defaultPrevented&&event.target&&event.target[event.type]){if(!DomData.has(event.target)){DomData.set(event.target,{});}var targetData=DomData.get(event.target);// Checks if the target has a default action for this event.
if(event.target[event.type]){// Temporarily disables event dispatching on the target as we have already executed the handler.
targetData.disabled=true;// Executes the default action.
if(typeof event.target[event.type]==='function'){event.target[event.type]();}// Re-enables event dispatching.
targetData.disabled=false;}}// Inform the triggerer if the default was prevented by returning false
return!event.defaultPrevented;}/**
 * Trigger a listener only once for an event.
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event listener function
 */function one(elem,type,fn){if(Array.isArray(type)){return _handleMultipleEvents(one,elem,type,fn);}var func=function func(){off(elem,type,func);fn.apply(this,arguments);};// copy the guid to the new function so it can removed using the original function's ID
func.guid=fn.guid=fn.guid||newGUID();on(elem,type,func);}/**
 * Trigger a listener only once and then turn if off for all
 * configured events
 *
 * @param {Element|Object} elem
 *        Element or object to bind to.
 *
 * @param {string|string[]} type
 *        Name/type of event
 *
 * @param {Event~EventListener} fn
 *        Event listener function
 */function any(elem,type,fn){var func=function func(){off(elem,type,func);fn.apply(this,arguments);};// copy the guid to the new function so it can removed using the original function's ID
func.guid=fn.guid=fn.guid||newGUID();// multiple ons, but one off for everything
on(elem,type,func);}var Events=/*#__PURE__*/Object.freeze({__proto__:null,fixEvent:fixEvent,on:on,off:off,trigger:trigger,one:one,any:any});/**
 * @file fn.js
 * @module fn
 */var UPDATE_REFRESH_INTERVAL=30;/**
 * Bind (a.k.a proxy or context). A simple method for changing the context of
 * a function.
 *
 * It also stores a unique id on the function so it can be easily removed from
 * events.
 *
 * @function
 * @param    {Mixed} context
 *           The object to bind as scope.
 *
 * @param    {Function} fn
 *           The function to be bound to a scope.
 *
 * @param    {number} [uid]
 *           An optional unique ID for the function to be set
 *
 * @return   {Function}
 *           The new function that will be bound into the context given
 */var bind=function bind(context,fn,uid){// Make sure the function has a unique ID
if(!fn.guid){fn.guid=newGUID();}// Create the new function that changes the context
var bound=fn.bind(context);// Allow for the ability to individualize this function
// Needed in the case where multiple objects might share the same prototype
// IF both items add an event listener with the same function, then you try to remove just one
// it will remove both because they both have the same guid.
// when using this, you need to use the bind method when you remove the listener as well.
// currently used in text tracks
bound.guid=uid?uid+'_'+fn.guid:fn.guid;return bound;};/**
 * Wraps the given function, `fn`, with a new function that only invokes `fn`
 * at most once per every `wait` milliseconds.
 *
 * @function
 * @param    {Function} fn
 *           The function to be throttled.
 *
 * @param    {number}   wait
 *           The number of milliseconds by which to throttle.
 *
 * @return   {Function}
 */var throttle=function throttle(fn,wait){var last=window_default().performance.now();var throttled=function throttled(){var now=window_default().performance.now();if(now-last>=wait){fn.apply(void 0,arguments);last=now;}};return throttled;};/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked.
 *
 * Inspired by lodash and underscore implementations.
 *
 * @function
 * @param    {Function} func
 *           The function to wrap with debounce behavior.
 *
 * @param    {number} wait
 *           The number of milliseconds to wait after the last invocation.
 *
 * @param    {boolean} [immediate]
 *           Whether or not to invoke the function immediately upon creation.
 *
 * @param    {Object} [context=window]
 *           The "context" in which the debounced function should debounce. For
 *           example, if this function should be tied to a Video.js player,
 *           the player can be passed here. Alternatively, defaults to the
 *           global `window` object.
 *
 * @return   {Function}
 *           A debounced function.
 */var debounce=function debounce(func,wait,immediate,context){if(context===void 0){context=(window_default());}var timeout;var cancel=function cancel(){context.clearTimeout(timeout);timeout=null;};/* eslint-disable consistent-this */var debounced=function debounced(){var self=this;var args=arguments;var _later=function later(){timeout=null;_later=null;if(!immediate){func.apply(self,args);}};if(!timeout&&immediate){func.apply(self,args);}context.clearTimeout(timeout);timeout=context.setTimeout(_later,wait);};/* eslint-enable consistent-this */debounced.cancel=cancel;return debounced;};/**
 * @file src/js/event-target.js
 */ /**
 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
 * adds shorthand functions that wrap around lengthy functions. For example:
 * the `on` function is a wrapper around `addEventListener`.
 *
 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
 * @class EventTarget
 */var EventTarget$2=function EventTarget(){};/**
 * A Custom DOM event.
 *
 * @typedef {Object} EventTarget~Event
 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
 */ /**
 * All event listeners should follow the following format.
 *
 * @callback EventTarget~EventListener
 * @this {EventTarget}
 *
 * @param {EventTarget~Event} event
 *        the event that triggered this function
 *
 * @param {Object} [hash]
 *        hash of data sent during the event
 */ /**
 * An object containing event names as keys and booleans as values.
 *
 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
 *         will have extra functionality. See that function for more information.
 *
 * @property EventTarget.prototype.allowedEvents_
 * @private
 */EventTarget$2.prototype.allowedEvents_={};/**
 * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
 * function that will get called when an event with a certain name gets triggered.
 *
 * @param {string|string[]} type
 *        An event name or an array of event names.
 *
 * @param {EventTarget~EventListener} fn
 *        The function to call with `EventTarget`s
 */EventTarget$2.prototype.on=function(type,fn){// Remove the addEventListener alias before calling Events.on
// so we don't get into an infinite type loop
var ael=this.addEventListener;this.addEventListener=function(){};on(this,type,fn);this.addEventListener=ael;};/**
 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#on}
 */EventTarget$2.prototype.addEventListener=EventTarget$2.prototype.on;/**
 * Removes an `event listener` for a specific event from an instance of `EventTarget`.
 * This makes it so that the `event listener` will no longer get called when the
 * named event happens.
 *
 * @param {string|string[]} type
 *        An event name or an array of event names.
 *
 * @param {EventTarget~EventListener} fn
 *        The function to remove.
 */EventTarget$2.prototype.off=function(type,fn){off(this,type,fn);};/**
 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#off}
 */EventTarget$2.prototype.removeEventListener=EventTarget$2.prototype.off;/**
 * This function will add an `event listener` that gets triggered only once. After the
 * first trigger it will get removed. This is like adding an `event listener`
 * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
 *
 * @param {string|string[]} type
 *        An event name or an array of event names.
 *
 * @param {EventTarget~EventListener} fn
 *        The function to be called once for each event name.
 */EventTarget$2.prototype.one=function(type,fn){// Remove the addEventListener aliasing Events.on
// so we don't get into an infinite type loop
var ael=this.addEventListener;this.addEventListener=function(){};one(this,type,fn);this.addEventListener=ael;};EventTarget$2.prototype.any=function(type,fn){// Remove the addEventListener aliasing Events.on
// so we don't get into an infinite type loop
var ael=this.addEventListener;this.addEventListener=function(){};any(this,type,fn);this.addEventListener=ael;};/**
 * This function causes an event to happen. This will then cause any `event listeners`
 * that are waiting for that event, to get called. If there are no `event listeners`
 * for an event then nothing will happen.
 *
 * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
 * Trigger will also call the `on` + `uppercaseEventName` function.
 *
 * Example:
 * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
 * `onClick` if it exists.
 *
 * @param {string|EventTarget~Event|Object} event
 *        The name of the event, an `Event`, or an object with a key of type set to
 *        an event name.
 */EventTarget$2.prototype.trigger=function(event){var type=event.type||event;// deprecation
// In a future version we should default target to `this`
// similar to how we default the target to `elem` in
// `Events.trigger`. Right now the default `target` will be
// `document` due to the `Event.fixEvent` call.
if(typeof event==='string'){event={type:type};}event=fixEvent(event);if(this.allowedEvents_[type]&&this['on'+type]){this['on'+type](event);}trigger(this,event);};/**
 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
 * the standard DOM API.
 *
 * @function
 * @see {@link EventTarget#trigger}
 */EventTarget$2.prototype.dispatchEvent=EventTarget$2.prototype.trigger;var EVENT_MAP;EventTarget$2.prototype.queueTrigger=function(event){var _this=this;// only set up EVENT_MAP if it'll be used
if(!EVENT_MAP){EVENT_MAP=new Map();}var type=event.type||event;var map=EVENT_MAP.get(this);if(!map){map=new Map();EVENT_MAP.set(this,map);}var oldTimeout=map.get(type);map["delete"](type);window_default().clearTimeout(oldTimeout);var timeout=window_default().setTimeout(function(){map["delete"](type);// if we cleared out all timeouts for the current target, delete its map
if(map.size===0){map=null;EVENT_MAP["delete"](_this);}_this.trigger(event);},0);map.set(type,timeout);};/**
 * @file mixins/evented.js
 * @module evented
 */var objName=function objName(obj){if(typeof obj.name==='function'){return obj.name();}if(typeof obj.name==='string'){return obj.name;}if(obj.name_){return obj.name_;}if(obj.constructor&&obj.constructor.name){return obj.constructor.name;}return video_es_typeof(obj);};/**
 * Returns whether or not an object has had the evented mixin applied.
 *
 * @param  {Object} object
 *         An object to test.
 *
 * @return {boolean}
 *         Whether or not the object appears to be evented.
 */var isEvented=function isEvented(object){return object instanceof EventTarget$2||!!object.eventBusEl_&&['on','one','off','trigger'].every(function(k){return typeof object[k]==='function';});};/**
 * Adds a callback to run after the evented mixin applied.
 *
 * @param  {Object} object
 *         An object to Add
 * @param  {Function} callback
 *         The callback to run.
 */var addEventedCallback=function addEventedCallback(target,callback){if(isEvented(target)){callback();}else{if(!target.eventedCallbacks){target.eventedCallbacks=[];}target.eventedCallbacks.push(callback);}};/**
 * Whether a value is a valid event type - non-empty string or array.
 *
 * @private
 * @param  {string|Array} type
 *         The type value to test.
 *
 * @return {boolean}
 *         Whether or not the type is a valid event type.
 */var isValidEventType=function isValidEventType(type){return(// The regex here verifies that the `type` contains at least one non-
// whitespace character.
typeof type==='string'&&/\S/.test(type)||Array.isArray(type)&&!!type.length);};/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the target does not appear to be a valid event target.
 *
 * @param  {Object} target
 *         The object to test.
 *
 * @param  {Object} obj
 *         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */var validateTarget=function validateTarget(target,obj,fnName){if(!target||!target.nodeName&&!isEvented(target)){throw new Error("Invalid target for "+objName(obj)+"#"+fnName+"; must be a DOM node or evented object.");}};/**
 * Validates a value to determine if it is a valid event target. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the type does not appear to be a valid event type.
 *
 * @param  {string|Array} type
 *         The type to test.
 *
 * @param  {Object} obj
*         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */var validateEventType=function validateEventType(type,obj,fnName){if(!isValidEventType(type)){throw new Error("Invalid event type for "+objName(obj)+"#"+fnName+"; must be a non-empty string or array.");}};/**
 * Validates a value to determine if it is a valid listener. Throws if not.
 *
 * @private
 * @throws {Error}
 *         If the listener is not a function.
 *
 * @param  {Function} listener
 *         The listener to test.
 *
 * @param  {Object} obj
 *         The evented object we are validating for
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 */var validateListener=function validateListener(listener,obj,fnName){if(typeof listener!=='function'){throw new Error("Invalid listener for "+objName(obj)+"#"+fnName+"; must be a function.");}};/**
 * Takes an array of arguments given to `on()` or `one()`, validates them, and
 * normalizes them into an object.
 *
 * @private
 * @param  {Object} self
 *         The evented object on which `on()` or `one()` was called. This
 *         object will be bound as the `this` value for the listener.
 *
 * @param  {Array} args
 *         An array of arguments passed to `on()` or `one()`.
 *
 * @param  {string} fnName
 *         The name of the evented mixin function that called this.
 *
 * @return {Object}
 *         An object containing useful values for `on()` or `one()` calls.
 */var normalizeListenArgs=function normalizeListenArgs(self,args,fnName){// If the number of arguments is less than 3, the target is always the
// evented object itself.
var isTargetingSelf=args.length<3||args[0]===self||args[0]===self.eventBusEl_;var target;var type;var listener;if(isTargetingSelf){target=self.eventBusEl_;// Deal with cases where we got 3 arguments, but we are still listening to
// the evented object itself.
if(args.length>=3){args.shift();}type=args[0];listener=args[1];}else{target=args[0];type=args[1];listener=args[2];}validateTarget(target,self,fnName);validateEventType(type,self,fnName);validateListener(listener,self,fnName);listener=bind(self,listener);return{isTargetingSelf:isTargetingSelf,target:target,type:type,listener:listener};};/**
 * Adds the listener to the event type(s) on the target, normalizing for
 * the type of target.
 *
 * @private
 * @param  {Element|Object} target
 *         A DOM node or evented object.
 *
 * @param  {string} method
 *         The event binding method to use ("on" or "one").
 *
 * @param  {string|Array} type
 *         One or more event type(s).
 *
 * @param  {Function} listener
 *         A listener function.
 */var listen=function listen(target,method,type,listener){validateTarget(target,target,method);if(target.nodeName){Events[method](target,type,listener);}else{target[method](type,listener);}};/**
 * Contains methods that provide event capabilities to an object which is passed
 * to {@link module:evented|evented}.
 *
 * @mixin EventedMixin
 */var EventedMixin={/**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */on:function on(){var _this=this;for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var _normalizeListenArgs=normalizeListenArgs(this,args,'on'),isTargetingSelf=_normalizeListenArgs.isTargetingSelf,target=_normalizeListenArgs.target,type=_normalizeListenArgs.type,listener=_normalizeListenArgs.listener;listen(target,'on',type,listener);// If this object is listening to another evented object.
if(!isTargetingSelf){// If this object is disposed, remove the listener.
var removeListenerOnDispose=function removeListenerOnDispose(){return _this.off(target,type,listener);};// Use the same function ID as the listener so we can remove it later it
// using the ID of the original listener.
removeListenerOnDispose.guid=listener.guid;// Add a listener to the target's dispose event as well. This ensures
// that if the target is disposed BEFORE this object, we remove the
// removal listener that was just added. Otherwise, we create a memory leak.
var removeRemoverOnTargetDispose=function removeRemoverOnTargetDispose(){return _this.off('dispose',removeListenerOnDispose);};// Use the same function ID as the listener so we can remove it later
// it using the ID of the original listener.
removeRemoverOnTargetDispose.guid=listener.guid;listen(this,'on','dispose',removeListenerOnDispose);listen(target,'on','dispose',removeRemoverOnTargetDispose);}},/**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */one:function one(){var _this2=this;for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}var _normalizeListenArgs2=normalizeListenArgs(this,args,'one'),isTargetingSelf=_normalizeListenArgs2.isTargetingSelf,target=_normalizeListenArgs2.target,type=_normalizeListenArgs2.type,listener=_normalizeListenArgs2.listener;// Targeting this evented object.
if(isTargetingSelf){listen(target,'one',type,listener);// Targeting another evented object.
}else{// TODO: This wrapper is incorrect! It should only
//       remove the wrapper for the event type that called it.
//       Instead all listners are removed on the first trigger!
//       see https://github.com/videojs/video.js/issues/5962
var wrapper=function wrapper(){_this2.off(target,type,wrapper);for(var _len3=arguments.length,largs=new Array(_len3),_key3=0;_key3<_len3;_key3++){largs[_key3]=arguments[_key3];}listener.apply(null,largs);};// Use the same function ID as the listener so we can remove it later
// it using the ID of the original listener.
wrapper.guid=listener.guid;listen(target,'one',type,wrapper);}},/**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */any:function any(){var _this3=this;for(var _len4=arguments.length,args=new Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}var _normalizeListenArgs3=normalizeListenArgs(this,args,'any'),isTargetingSelf=_normalizeListenArgs3.isTargetingSelf,target=_normalizeListenArgs3.target,type=_normalizeListenArgs3.type,listener=_normalizeListenArgs3.listener;// Targeting this evented object.
if(isTargetingSelf){listen(target,'any',type,listener);// Targeting another evented object.
}else{var wrapper=function wrapper(){_this3.off(target,type,wrapper);for(var _len5=arguments.length,largs=new Array(_len5),_key5=0;_key5<_len5;_key5++){largs[_key5]=arguments[_key5];}listener.apply(null,largs);};// Use the same function ID as the listener so we can remove it later
// it using the ID of the original listener.
wrapper.guid=listener.guid;listen(target,'any',type,wrapper);}},/**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */off:function off$1(targetOrType,typeOrListener,listener){// Targeting this evented object.
if(!targetOrType||isValidEventType(targetOrType)){off(this.eventBusEl_,targetOrType,typeOrListener);// Targeting another evented object.
}else{var target=targetOrType;var type=typeOrListener;// Fail fast and in a meaningful way!
validateTarget(target,this,'off');validateEventType(type,this,'off');validateListener(listener,this,'off');// Ensure there's at least a guid, even if the function hasn't been used
listener=bind(this,listener);// Remove the dispose listener on this evented object, which was given
// the same guid as the event listener in on().
this.off('dispose',listener);if(target.nodeName){off(target,type,listener);off(target,'dispose',listener);}else if(isEvented(target)){target.off(type,listener);target.off('dispose',listener);}}},/**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */trigger:function trigger$1(event,hash){validateTarget(this.eventBusEl_,this,'trigger');var type=event&&typeof event!=='string'?event.type:event;if(!isValidEventType(type)){var error="Invalid event type for "+objName(this)+"#trigger; "+'must be a non-empty string or object with a type key that has a non-empty value.';if(event){(this.log||log$1).error(error);}else{throw new Error(error);}}return trigger(this.eventBusEl_,event,hash);}};/**
 * Applies {@link module:evented~EventedMixin|EventedMixin} to a target object.
 *
 * @param  {Object} target
 *         The object to which to add event methods.
 *
 * @param  {Object} [options={}]
 *         Options for customizing the mixin behavior.
 *
 * @param  {string} [options.eventBusKey]
 *         By default, adds a `eventBusEl_` DOM element to the target object,
 *         which is used as an event bus. If the target object already has a
 *         DOM element that should be used, pass its key here.
 *
 * @return {Object}
 *         The target object.
 */function evented(target,options){if(options===void 0){options={};}var _options=options,eventBusKey=_options.eventBusKey;// Set or create the eventBusEl_.
if(eventBusKey){if(!target[eventBusKey].nodeName){throw new Error("The eventBusKey \""+eventBusKey+"\" does not refer to an element.");}target.eventBusEl_=target[eventBusKey];}else{target.eventBusEl_=createEl('span',{className:'vjs-event-bus'});}video_es_assign(target,EventedMixin);if(target.eventedCallbacks){target.eventedCallbacks.forEach(function(callback){callback();});}// When any evented object is disposed, it removes all its listeners.
target.on('dispose',function(){target.off();[target,target.el_,target.eventBusEl_].forEach(function(val){if(val&&DomData.has(val)){DomData["delete"](val);}});window_default().setTimeout(function(){target.eventBusEl_=null;},0);});return target;}/**
 * @file mixins/stateful.js
 * @module stateful
 */ /**
 * Contains methods that provide statefulness to an object which is passed
 * to {@link module:stateful}.
 *
 * @mixin StatefulMixin
 */var StatefulMixin={/**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */state:{},/**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */setState:function setState(stateUpdates){var _this=this;// Support providing the `stateUpdates` state as a function.
if(typeof stateUpdates==='function'){stateUpdates=stateUpdates();}var changes;each(stateUpdates,function(value,key){// Record the change if the value is different from what's in the
// current state.
if(_this.state[key]!==value){changes=changes||{};changes[key]={from:_this.state[key],to:value};}_this.state[key]=value;});// Only trigger "statechange" if there were changes AND we have a trigger
// function. This allows us to not require that the target object be an
// evented object.
if(changes&&isEvented(this)){/**
       * An event triggered on an object that is both
       * {@link module:stateful|stateful} and {@link module:evented|evented}
       * indicating that its state has changed.
       *
       * @event    module:stateful~StatefulMixin#statechanged
       * @type     {Object}
       * @property {Object} changes
       *           A hash containing the properties that were changed and
       *           the values they were changed `from` and `to`.
       */this.trigger({changes:changes,type:'statechanged'});}return changes;}};/**
 * Applies {@link module:stateful~StatefulMixin|StatefulMixin} to a target
 * object.
 *
 * If the target object is {@link module:evented|evented} and has a
 * `handleStateChanged` method, that method will be automatically bound to the
 * `statechanged` event on itself.
 *
 * @param   {Object} target
 *          The object to be made stateful.
 *
 * @param   {Object} [defaultState]
 *          A default set of properties to populate the newly-stateful object's
 *          `state` property.
 *
 * @return {Object}
 *          Returns the `target`.
 */function stateful(target,defaultState){video_es_assign(target,StatefulMixin);// This happens after the mixing-in because we need to replace the `state`
// added in that step.
target.state=video_es_assign({},target.state,defaultState);// Auto-bind the `handleStateChanged` method of the target object if it exists.
if(typeof target.handleStateChanged==='function'&&isEvented(target)){target.on('statechanged',target.handleStateChanged);}return target;}/**
 * @file string-cases.js
 * @module to-lower-case
 */ /**
 * Lowercase the first letter of a string.
 *
 * @param {string} string
 *        String to be lowercased
 *
 * @return {string}
 *         The string with a lowercased first letter
 */var toLowerCase=function toLowerCase(string){if(typeof string!=='string'){return string;}return string.replace(/./,function(w){return w.toLowerCase();});};/**
 * Uppercase the first letter of a string.
 *
 * @param {string} string
 *        String to be uppercased
 *
 * @return {string}
 *         The string with an uppercased first letter
 */var toTitleCase$1=function toTitleCase(string){if(typeof string!=='string'){return string;}return string.replace(/./,function(w){return w.toUpperCase();});};/**
 * Compares the TitleCase versions of the two strings for equality.
 *
 * @param {string} str1
 *        The first string to compare
 *
 * @param {string} str2
 *        The second string to compare
 *
 * @return {boolean}
 *         Whether the TitleCase versions of the strings are equal
 */var titleCaseEquals=function titleCaseEquals(str1,str2){return toTitleCase$1(str1)===toTitleCase$1(str2);};/**
 * @file merge-options.js
 * @module merge-options
 */ /**
 * Merge two objects recursively.
 *
 * Performs a deep merge like
 * {@link https://lodash.com/docs/4.17.10#merge|lodash.merge}, but only merges
 * plain objects (not arrays, elements, or anything else).
 *
 * Non-plain object values will be copied directly from the right-most
 * argument.
 *
 * @static
 * @param   {Object[]} sources
 *          One or more objects to merge into a new object.
 *
 * @return {Object}
 *          A new object that is the merged result of all sources.
 */function mergeOptions$3(){var result={};for(var _len=arguments.length,sources=new Array(_len),_key=0;_key<_len;_key++){sources[_key]=arguments[_key];}sources.forEach(function(source){if(!source){return;}each(source,function(value,key){if(!isPlain(value)){result[key]=value;return;}if(!isPlain(result[key])){result[key]={};}result[key]=mergeOptions$3(result[key],value);});});return result;}var MapSham=/*#__PURE__*/function(){function MapSham(){this.map_={};}var _proto=MapSham.prototype;_proto.has=function has(key){return key in this.map_;};_proto["delete"]=function _delete(key){var has=this.has(key);delete this.map_[key];return has;};_proto.set=function set(key,value){this.map_[key]=value;return this;};_proto.forEach=function forEach(callback,thisArg){for(var key in this.map_){callback.call(thisArg,this.map_[key],key,this);}};return MapSham;}();var Map$1=(window_default()).Map?(window_default()).Map:MapSham;var SetSham=/*#__PURE__*/function(){function SetSham(){this.set_={};}var _proto=SetSham.prototype;_proto.has=function has(key){return key in this.set_;};_proto["delete"]=function _delete(key){var has=this.has(key);delete this.set_[key];return has;};_proto.add=function add(key){this.set_[key]=1;return this;};_proto.forEach=function forEach(callback,thisArg){for(var key in this.set_){callback.call(thisArg,key,key,this);}};return SetSham;}();var Set$1=(window_default()).Set?(window_default()).Set:SetSham;/**
 * Player Component - Base class for all UI objects
 *
 * @file component.js
 */ /**
 * Base class for all UI Components.
 * Components are UI objects which represent both a javascript object and an element
 * in the DOM. They can be children of other components, and can have
 * children themselves.
 *
 * Components can also use methods from {@link EventTarget}
 */var Component$1=/*#__PURE__*/function(){/**
   * A callback that is called when a component is ready. Does not have any
   * paramters and any callback value will be ignored.
   *
   * @callback Component~ReadyCallback
   * @this Component
   */ /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of component options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to intialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   * @param {Component~ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */function Component(player,options,ready){var _this=this;// The component might be the player itself and we can't pass `this` to super
if(!player&&this.play){this.player_=player=this;// eslint-disable-line
}else{this.player_=player;}this.isDisposed_=false;// Hold the reference to the parent component via `addChild` method
this.parentComponent_=null;// Make a copy of prototype.options_ to protect against overriding defaults
this.options_=mergeOptions$3({},this.options_);// Updated options with supplied options
options=this.options_=mergeOptions$3(this.options_,options);// Get ID from options or options element if one is supplied
this.id_=options.id||options.el&&options.el.id;// If there was no ID from the options, generate one
if(!this.id_){// Don't require the player ID function in the case of mock players
var id=player&&player.id&&player.id()||'no_player';this.id_=id+"_component_"+newGUID();}this.name_=options.name||null;// Create element if one wasn't provided in options
if(options.el){this.el_=options.el;}else if(options.createEl!==false){this.el_=this.createEl();}if(options.className&&this.el_){options.className.split(' ').forEach(function(c){return _this.addClass(c);});}// if evented is anything except false, we want to mixin in evented
if(options.evented!==false){// Make this an evented object and use `el_`, if available, as its event bus
evented(this,{eventBusKey:this.el_?'el_':null});this.handleLanguagechange=this.handleLanguagechange.bind(this);this.on(this.player_,'languagechange',this.handleLanguagechange);}stateful(this,this.constructor.defaultState);this.children_=[];this.childIndex_={};this.childNameIndex_={};this.setTimeoutIds_=new Set$1();this.setIntervalIds_=new Set$1();this.rafIds_=new Set$1();this.namedRafs_=new Map$1();this.clearingTimersOnDispose_=false;// Add any child components in options
if(options.initChildren!==false){this.initChildren();}// Don't want to trigger ready here or it will go before init is actually
// finished for all children that run this constructor
this.ready(ready);if(options.reportTouchActivity!==false){this.enableTouchActivity();}}/**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   *
   * @param {Object} options
   * @param {Element} options.originalEl element with which to replace player element
   */var _proto=Component.prototype;_proto.dispose=function dispose(options){if(options===void 0){options={};}// Bail out if the component has already been disposed.
if(this.isDisposed_){return;}if(this.readyQueue_){this.readyQueue_.length=0;}/**
     * Triggered when a `Component` is disposed.
     *
     * @event Component#dispose
     * @type {EventTarget~Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the dispose event does not
     *           bubble up
     */this.trigger({type:'dispose',bubbles:false});this.isDisposed_=true;// Dispose all children.
if(this.children_){for(var i=this.children_.length-1;i>=0;i--){if(this.children_[i].dispose){this.children_[i].dispose();}}}// Delete child references
this.children_=null;this.childIndex_=null;this.childNameIndex_=null;this.parentComponent_=null;if(this.el_){// Remove element from DOM
if(this.el_.parentNode){if(options.restoreEl){this.el_.parentNode.replaceChild(options.restoreEl,this.el_);}else{this.el_.parentNode.removeChild(this.el_);}}this.el_=null;}// remove reference to the player after disposing of the element
this.player_=null;}/**
   * Determine whether or not this component has been disposed.
   *
   * @return {boolean}
   *         If the component has been disposed, will be `true`. Otherwise, `false`.
   */;_proto.isDisposed=function isDisposed(){return Boolean(this.isDisposed_);}/**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return {Player}
   *         The player that this `Component` has attached to.
   */;_proto.player=function player(){return this.player_;}/**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:mergeOptions}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   */;_proto.options=function options(obj){if(!obj){return this.options_;}this.options_=mergeOptions$3(this.options_,obj);return this.options_;}/**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */;_proto.el=function el(){return this.el_;}/**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */;_proto.createEl=function createEl$1(tagName,properties,attributes){return createEl(tagName,properties,attributes);}/**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */;_proto.localize=function localize(string,tokens,defaultValue){if(defaultValue===void 0){defaultValue=string;}var code=this.player_.language&&this.player_.language();var languages=this.player_.languages&&this.player_.languages();var language=languages&&languages[code];var primaryCode=code&&code.split('-')[0];var primaryLang=languages&&languages[primaryCode];var localizedString=defaultValue;if(language&&language[string]){localizedString=language[string];}else if(primaryLang&&primaryLang[string]){localizedString=primaryLang[string];}if(tokens){localizedString=localizedString.replace(/\{(\d+)\}/g,function(match,index){var value=tokens[index-1];var ret=value;if(typeof value==='undefined'){ret=match;}return ret;});}return localizedString;}/**
   * Handles language change for the player in components. Should be overriden by sub-components.
   *
   * @abstract
   */;_proto.handleLanguagechange=function handleLanguagechange(){}/**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */;_proto.contentEl=function contentEl(){return this.contentEl_||this.el_;}/**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */;_proto.id=function id(){return this.id_;}/**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */;_proto.name=function name(){return this.name_;}/**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */;_proto.children=function children(){return this.children_;}/**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */;_proto.getChildById=function getChildById(id){return this.childIndex_[id];}/**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */;_proto.getChild=function getChild(name){if(!name){return;}return this.childNameIndex_[name];}/**
   * Returns the descendant `Component` following the givent
   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
   * try to get 'foo' on the current component, 'bar' on the 'foo'
   * component and 'baz' on the 'bar' component and return undefined
   * if any of those don't exist.
   *
   * @param {...string[]|...string} names
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The descendant `Component` following the given descendant
   *         `names` or undefined.
   */;_proto.getDescendant=function getDescendant(){for(var _len=arguments.length,names=new Array(_len),_key=0;_key<_len;_key++){names[_key]=arguments[_key];}// flatten array argument into the main array
names=names.reduce(function(acc,n){return acc.concat(n);},[]);var currentChild=this;for(var i=0;i<names.length;i++){currentChild=currentChild.getChild(names[i]);if(!currentChild||!currentChild.getChild){return;}}return currentChild;}/**
   * Add a child `Component` inside the current `Component`.
   *
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */;_proto.addChild=function addChild(child,options,index){if(options===void 0){options={};}if(index===void 0){index=this.children_.length;}var component;var componentName;// If child is a string, create component with options
if(typeof child==='string'){componentName=toTitleCase$1(child);var componentClassName=options.componentClass||componentName;// Set name through options
options.name=componentName;// Create a new object & element for this controls set
// If there's no .player_, this is a player
var ComponentClass=Component.getComponent(componentClassName);if(!ComponentClass){throw new Error("Component "+componentClassName+" does not exist");}// data stored directly on the videojs object may be
// misidentified as a component to retain
// backwards-compatibility with 4.x. check to make sure the
// component class can be instantiated.
if(typeof ComponentClass!=='function'){return null;}component=new ComponentClass(this.player_||this,options);// child is a component instance
}else{component=child;}if(component.parentComponent_){component.parentComponent_.removeChild(component);}this.children_.splice(index,0,component);component.parentComponent_=this;if(typeof component.id==='function'){this.childIndex_[component.id()]=component;}// If a name wasn't used to create the component, check if we can use the
// name function of the component
componentName=componentName||component.name&&toTitleCase$1(component.name());if(componentName){this.childNameIndex_[componentName]=component;this.childNameIndex_[toLowerCase(componentName)]=component;}// Add the UI object's element to the container div (box)
// Having an element is not required
if(typeof component.el==='function'&&component.el()){// If inserting before a component, insert before that component's element
var refNode=null;if(this.children_[index+1]){// Most children are components, but the video tech is an HTML element
if(this.children_[index+1].el_){refNode=this.children_[index+1].el_;}else if(isEl(this.children_[index+1])){refNode=this.children_[index+1];}}this.contentEl().insertBefore(component.el(),refNode);}// Return so it can stored on parent object if desired.
return component;}/**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {Component} component
   *        The child `Component` to remove.
   */;_proto.removeChild=function removeChild(component){if(typeof component==='string'){component=this.getChild(component);}if(!component||!this.children_){return;}var childFound=false;for(var i=this.children_.length-1;i>=0;i--){if(this.children_[i]===component){childFound=true;this.children_.splice(i,1);break;}}if(!childFound){return;}component.parentComponent_=null;this.childIndex_[component.id()]=null;this.childNameIndex_[toTitleCase$1(component.name())]=null;this.childNameIndex_[toLowerCase(component.name())]=null;var compEl=component.el();if(compEl&&compEl.parentNode===this.contentEl()){this.contentEl().removeChild(component.el());}}/**
   * Add and initialize default child `Component`s based upon options.
   */;_proto.initChildren=function initChildren(){var _this2=this;var children=this.options_.children;if(children){// `this` is `parent`
var parentOptions=this.options_;var handleAdd=function handleAdd(child){var name=child.name;var opts=child.opts;// Allow options for children to be set at the parent options
// e.g. videojs(id, { controlBar: false });
// instead of videojs(id, { children: { controlBar: false });
if(parentOptions[name]!==undefined){opts=parentOptions[name];}// Allow for disabling default components
// e.g. options['children']['posterImage'] = false
if(opts===false){return;}// Allow options to be passed as a simple boolean if no configuration
// is necessary.
if(opts===true){opts={};}// We also want to pass the original player options
// to each component as well so they don't need to
// reach back into the player for options later.
opts.playerOptions=_this2.options_.playerOptions;// Create and add the child component.
// Add a direct reference to the child by name on the parent instance.
// If two of the same component are used, different names should be supplied
// for each
var newChild=_this2.addChild(name,opts);if(newChild){_this2[name]=newChild;}};// Allow for an array of children details to passed in the options
var workingChildren;var Tech=Component.getComponent('Tech');if(Array.isArray(children)){workingChildren=children;}else{workingChildren=Object.keys(children);}workingChildren// children that are in this.options_ but also in workingChildren  would
// give us extra children we do not want. So, we want to filter them out.
.concat(Object.keys(this.options_).filter(function(child){return!workingChildren.some(function(wchild){if(typeof wchild==='string'){return child===wchild;}return child===wchild.name;});})).map(function(child){var name;var opts;if(typeof child==='string'){name=child;opts=children[name]||_this2.options_[name]||{};}else{name=child.name;opts=child;}return{name:name,opts:opts};}).filter(function(child){// we have to make sure that child.name isn't in the techOrder since
// techs are registerd as Components but can't aren't compatible
// See https://github.com/videojs/video.js/issues/2772
var c=Component.getComponent(child.opts.componentClass||toTitleCase$1(child.name));return c&&!Tech.isTech(c);}).forEach(handleAdd);}}/**
   * Builds the default DOM class name. Should be overriden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */;_proto.buildCSSClass=function buildCSSClass(){// Child classes can include a function that does:
// return 'CLASS NAME' + this._super();
return'';}/**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @return {Component}
   *         Returns itself; method can be chained.
   */;_proto.ready=function ready(fn,sync){if(sync===void 0){sync=false;}if(!fn){return;}if(!this.isReady_){this.readyQueue_=this.readyQueue_||[];this.readyQueue_.push(fn);return;}if(sync){fn.call(this);}else{// Call the function asynchronously by default for consistency
this.setTimeout(fn,1);}}/**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */;_proto.triggerReady=function triggerReady(){this.isReady_=true;// Ensure ready is triggered asynchronously
this.setTimeout(function(){var readyQueue=this.readyQueue_;// Reset Ready Queue
this.readyQueue_=[];if(readyQueue&&readyQueue.length>0){readyQueue.forEach(function(fn){fn.call(this);},this);}// Allow for using event listeners also
/**
       * Triggered when a `Component` is ready.
       *
       * @event Component#ready
       * @type {EventTarget~Event}
       */this.trigger('ready');},1);}/**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */;_proto.$=function $$1(selector,context){return $(selector,context||this.contentEl());}/**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */;_proto.$$=function $$$1(selector,context){return $$(selector,context||this.contentEl());}/**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */;_proto.hasClass=function hasClass$1(classToCheck){return hasClass(this.el_,classToCheck);}/**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {string} classToAdd
   *        CSS class name to add
   */;_proto.addClass=function addClass$1(classToAdd){addClass(this.el_,classToAdd);}/**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {string} classToRemove
   *        CSS class name to remove
   */;_proto.removeClass=function removeClass$1(classToRemove){removeClass(this.el_,classToRemove);}/**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove based on (@link Component#hasClass}
   *
   * @param  {boolean|Dom~predicate} [predicate]
   *         An {@link Dom~predicate} function or a boolean
   */;_proto.toggleClass=function toggleClass$1(classToToggle,predicate){toggleClass(this.el_,classToToggle,predicate);}/**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */;_proto.show=function show(){this.removeClass('vjs-hidden');}/**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */;_proto.hide=function hide(){this.addClass('vjs-hidden');}/**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */;_proto.lockShowing=function lockShowing(){this.addClass('vjs-lock-showing');}/**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */;_proto.unlockShowing=function unlockShowing(){this.removeClass('vjs-lock-showing');}/**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attibute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */;_proto.getAttribute=function getAttribute$1(attribute){return getAttribute(this.el_,attribute);}/**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */;_proto.setAttribute=function setAttribute$1(attribute,value){setAttribute(this.el_,attribute,value);}/**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */;_proto.removeAttribute=function removeAttribute$1(attribute){removeAttribute(this.el_,attribute);}/**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|string}
   *         The width when getting, zero if there is no width. Can be a string
   *           postpixed with '%' or 'px'.
   */;_proto.width=function width(num,skipListeners){return this.dimension('width',num,skipListeners);}/**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|string}
   *         The width when getting, zero if there is no width. Can be a string
   *         postpixed with '%' or 'px'.
   */;_proto.height=function height(num,skipListeners){return this.dimension('height',num,skipListeners);}/**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */;_proto.dimensions=function dimensions(width,height){// Skip componentresize listeners on width for optimization
this.width(width,true);this.height(height);}/**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number}
   *         The dimension when getting or 0 if unset
   */;_proto.dimension=function dimension(widthOrHeight,num,skipListeners){if(num!==undefined){// Set to zero if null or literally NaN (NaN !== NaN)
if(num===null||num!==num){num=0;}// Check if using css width/height (% or px) and adjust
if((''+num).indexOf('%')!==-1||(''+num).indexOf('px')!==-1){this.el_.style[widthOrHeight]=num;}else if(num==='auto'){this.el_.style[widthOrHeight]='';}else{this.el_.style[widthOrHeight]=num+'px';}// skipListeners allows us to avoid triggering the resize event when setting both width and height
if(!skipListeners){/**
         * Triggered when a component is resized.
         *
         * @event Component#componentresize
         * @type {EventTarget~Event}
         */this.trigger('componentresize');}return;}// Not setting a value, so getting it
// Make sure element exists
if(!this.el_){return 0;}// Get dimension value from style
var val=this.el_.style[widthOrHeight];var pxIndex=val.indexOf('px');if(pxIndex!==-1){// Return the pixel value with no 'px'
return parseInt(val.slice(0,pxIndex),10);}// No px so using % or no style was set, so falling back to offsetWidth/height
// If component has display:none, offset will return 0
// TODO: handle display:none and no dimension style using px
return parseInt(this.el_['offset'+toTitleCase$1(widthOrHeight)],10);}/**
   * Get the computed width or the height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */;_proto.currentDimension=function currentDimension(widthOrHeight){var computedWidthOrHeight=0;if(widthOrHeight!=='width'&&widthOrHeight!=='height'){throw new Error('currentDimension only accepts width or height value');}computedWidthOrHeight=computedStyle(this.el_,widthOrHeight);// remove 'px' from variable and parse as integer
computedWidthOrHeight=parseFloat(computedWidthOrHeight);// if the computed value is still 0, it's possible that the browser is lying
// and we want to check the offset values.
// This code also runs wherever getComputedStyle doesn't exist.
if(computedWidthOrHeight===0||isNaN(computedWidthOrHeight)){var rule="offset"+toTitleCase$1(widthOrHeight);computedWidthOrHeight=this.el_[rule];}return computedWidthOrHeight;}/**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */ /**
   * Get an object that contains computed width and height values of the
   * component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {Component~DimensionObject}
   *         The computed dimensions of the component's element.
   */;_proto.currentDimensions=function currentDimensions(){return{width:this.currentDimension('width'),height:this.currentDimension('height')};}/**
   * Get the computed width of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed width of the component's element.
   */;_proto.currentWidth=function currentWidth(){return this.currentDimension('width');}/**
   * Get the computed height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed height of the component's element.
   */;_proto.currentHeight=function currentHeight(){return this.currentDimension('height');}/**
   * Set the focus to this component
   */;_proto.focus=function focus(){this.el_.focus();}/**
   * Remove the focus from this component
   */;_proto.blur=function blur(){this.el_.blur();}/**
   * When this Component receives a `keydown` event which it does not process,
   *  it passes the event to the Player for handling.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   */;_proto.handleKeyDown=function handleKeyDown(event){if(this.player_){// We only stop propagation here because we want unhandled events to fall
// back to the browser. Exclude Tab for focus trapping.
if(!keycode_default().isEventKey(event,'Tab')){event.stopPropagation();}this.player_.handleKeyDown(event);}}/**
   * Many components used to have a `handleKeyPress` method, which was poorly
   * named because it listened to a `keydown` event. This method name now
   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
   * will not see their method calls stop working.
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to be called.
   */;_proto.handleKeyPress=function handleKeyPress(event){this.handleKeyDown(event);}/**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @private
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */;_proto.emitTapEvents=function emitTapEvents(){// Track the start time so we can determine how long the touch lasted
var touchStart=0;var firstTouch=null;// Maximum movement allowed during a touch event to still be considered a tap
// Other popular libs use anywhere from 2 (hammer.js) to 15,
// so 10 seems like a nice, round number.
var tapMovementThreshold=10;// The maximum length a touch can be while still being considered a tap
var touchTimeThreshold=200;var couldBeTap;this.on('touchstart',function(event){// If more than one finger, don't consider treating this as a click
if(event.touches.length===1){// Copy pageX/pageY from the object
firstTouch={pageX:event.touches[0].pageX,pageY:event.touches[0].pageY};// Record start time so we can detect a tap vs. "touch and hold"
touchStart=window_default().performance.now();// Reset couldBeTap tracking
couldBeTap=true;}});this.on('touchmove',function(event){// If more than one finger, don't consider treating this as a click
if(event.touches.length>1){couldBeTap=false;}else if(firstTouch){// Some devices will throw touchmoves for all but the slightest of taps.
// So, if we moved only a small distance, this could still be a tap
var xdiff=event.touches[0].pageX-firstTouch.pageX;var ydiff=event.touches[0].pageY-firstTouch.pageY;var touchDistance=Math.sqrt(xdiff*xdiff+ydiff*ydiff);if(touchDistance>tapMovementThreshold){couldBeTap=false;}}});var noTap=function noTap(){couldBeTap=false;};// TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
this.on('touchleave',noTap);this.on('touchcancel',noTap);// When the touch ends, measure how long it took and trigger the appropriate
// event
this.on('touchend',function(event){firstTouch=null;// Proceed only if the touchmove/leave/cancel event didn't happen
if(couldBeTap===true){// Measure how long the touch lasted
var touchTime=window_default().performance.now()-touchStart;// Make sure the touch was less than the threshold to be considered a tap
if(touchTime<touchTimeThreshold){// Don't let browser turn this into a click
event.preventDefault();/**
           * Triggered when a `Component` is tapped.
           *
           * @event Component#tap
           * @type {EventTarget~Event}
           */this.trigger('tap');// It may be good to copy the touchend event object and change the
// type to tap, if the other event properties aren't exact after
// Events.fixEvent runs (e.g. event.target)
}}});}/**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */;_proto.enableTouchActivity=function enableTouchActivity(){// Don't continue if the root player doesn't support reporting user activity
if(!this.player()||!this.player().reportUserActivity){return;}// listener for reporting that the user is active
var report=bind(this.player(),this.player().reportUserActivity);var touchHolding;this.on('touchstart',function(){report();// For as long as the they are touching the device or have their mouse down,
// we consider them active even if they're not moving their finger or mouse.
// So we want to continue to update that they are active
this.clearInterval(touchHolding);// report at the same interval as activityCheck
touchHolding=this.setInterval(report,250);});var touchEnd=function touchEnd(event){report();// stop the interval that maintains activity if the touch is holding
this.clearInterval(touchHolding);};this.on('touchmove',report);this.on('touchend',touchEnd);this.on('touchcancel',touchEnd);}/**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */ /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */;_proto.setTimeout=function setTimeout(fn,timeout){var _this3=this;// declare as variables so they are properly available in timeout function
// eslint-disable-next-line
var timeoutId;fn=bind(this,fn);this.clearTimersOnDispose_();timeoutId=window_default().setTimeout(function(){if(_this3.setTimeoutIds_.has(timeoutId)){_this3.setTimeoutIds_["delete"](timeoutId);}fn();},timeout);this.setTimeoutIds_.add(timeoutId);return timeoutId;}/**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */;_proto.clearTimeout=function clearTimeout(timeoutId){if(this.setTimeoutIds_.has(timeoutId)){this.setTimeoutIds_["delete"](timeoutId);window_default().clearTimeout(timeoutId);}return timeoutId;}/**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */;_proto.setInterval=function setInterval(fn,interval){fn=bind(this,fn);this.clearTimersOnDispose_();var intervalId=window_default().setInterval(fn,interval);this.setIntervalIds_.add(intervalId);return intervalId;}/**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an inteval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */;_proto.clearInterval=function clearInterval(intervalId){if(this.setIntervalIds_.has(intervalId)){this.setIntervalIds_["delete"](intervalId);window_default().clearInterval(intervalId);}return intervalId;}/**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */;_proto.requestAnimationFrame=function requestAnimationFrame(fn){var _this4=this;// Fall back to using a timer.
if(!this.supportsRaf_){return this.setTimeout(fn,1000/60);}this.clearTimersOnDispose_();// declare as variables so they are properly available in rAF function
// eslint-disable-next-line
var id;fn=bind(this,fn);id=window_default().requestAnimationFrame(function(){if(_this4.rafIds_.has(id)){_this4.rafIds_["delete"](id);}fn();});this.rafIds_.add(id);return id;}/**
   * Request an animation frame, but only one named animation
   * frame will be queued. Another will never be added until
   * the previous one finishes.
   *
   * @param {string} name
   *        The name to give this requestAnimationFrame
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   */;_proto.requestNamedAnimationFrame=function requestNamedAnimationFrame(name,fn){var _this5=this;if(this.namedRafs_.has(name)){return;}this.clearTimersOnDispose_();fn=bind(this,fn);var id=this.requestAnimationFrame(function(){fn();if(_this5.namedRafs_.has(name)){_this5.namedRafs_["delete"](name);}});this.namedRafs_.set(name,id);return name;}/**
   * Cancels a current named animation frame if it exists.
   *
   * @param {string} name
   *        The name of the requestAnimationFrame to cancel.
   */;_proto.cancelNamedAnimationFrame=function cancelNamedAnimationFrame(name){if(!this.namedRafs_.has(name)){return;}this.cancelAnimationFrame(this.namedRafs_.get(name));this.namedRafs_["delete"](name);}/**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */;_proto.cancelAnimationFrame=function cancelAnimationFrame(id){// Fall back to using a timer.
if(!this.supportsRaf_){return this.clearTimeout(id);}if(this.rafIds_.has(id)){this.rafIds_["delete"](id);window_default().cancelAnimationFrame(id);}return id;}/**
   * A function to setup `requestAnimationFrame`, `setTimeout`,
   * and `setInterval`, clearing on dispose.
   *
   * > Previously each timer added and removed dispose listeners on it's own.
   * For better performance it was decided to batch them all, and use `Set`s
   * to track outstanding timer ids.
   *
   * @private
   */;_proto.clearTimersOnDispose_=function clearTimersOnDispose_(){var _this6=this;if(this.clearingTimersOnDispose_){return;}this.clearingTimersOnDispose_=true;this.one('dispose',function(){[['namedRafs_','cancelNamedAnimationFrame'],['rafIds_','cancelAnimationFrame'],['setTimeoutIds_','clearTimeout'],['setIntervalIds_','clearInterval']].forEach(function(_ref){var idName=_ref[0],cancelName=_ref[1];// for a `Set` key will actually be the value again
// so forEach((val, val) =>` but for maps we want to use
// the key.
_this6[idName].forEach(function(val,key){return _this6[cancelName](key);});});_this6.clearingTimersOnDispose_=false;});}/**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */;Component.registerComponent=function registerComponent(name,ComponentToRegister){if(typeof name!=='string'||!name){throw new Error("Illegal component name, \""+name+"\"; must be a non-empty string.");}var Tech=Component.getComponent('Tech');// We need to make sure this check is only done if Tech has been registered.
var isTech=Tech&&Tech.isTech(ComponentToRegister);var isComp=Component===ComponentToRegister||Component.prototype.isPrototypeOf(ComponentToRegister.prototype);if(isTech||!isComp){var reason;if(isTech){reason='techs must be registered using Tech.registerTech()';}else{reason='must be a Component subclass';}throw new Error("Illegal component, \""+name+"\"; "+reason+".");}name=toTitleCase$1(name);if(!Component.components_){Component.components_={};}var Player=Component.getComponent('Player');if(name==='Player'&&Player&&Player.players){var players=Player.players;var playerNames=Object.keys(players);// If we have players that were disposed, then their name will still be
// in Players.players. So, we must loop through and verify that the value
// for each item is not null. This allows registration of the Player component
// after all players have been disposed or before any were created.
if(players&&playerNames.length>0&&playerNames.map(function(pname){return players[pname];}).every(Boolean)){throw new Error('Can not register Player component after player has been created.');}}Component.components_[name]=ComponentToRegister;Component.components_[toLowerCase(name)]=ComponentToRegister;return ComponentToRegister;}/**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {Component}
   *         The `Component` that got registered under the given name.
   */;Component.getComponent=function getComponent(name){if(!name||!Component.components_){return;}return Component.components_[name];};return Component;}();/**
 * Whether or not this component supports `requestAnimationFrame`.
 *
 * This is exposed primarily for testing purposes.
 *
 * @private
 * @type {Boolean}
 */Component$1.prototype.supportsRaf_=typeof (window_default()).requestAnimationFrame==='function'&&typeof (window_default()).cancelAnimationFrame==='function';Component$1.registerComponent('Component',Component$1);/**
 * @file time-ranges.js
 * @module time-ranges
 */ /**
 * Returns the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @typedef    {Function} TimeRangeIndex
 *
 * @param      {number} [index=0]
 *             The range number to return the time for.
 *
 * @return     {number}
 *             The time offset at the specified index.
 *
 * @deprecated The index argument must be provided.
 *             In the future, leaving it out will throw an error.
 */ /**
 * An object that contains ranges of time.
 *
 * @typedef  {Object} TimeRange
 *
 * @property {number} length
 *           The number of time ranges represented by this object.
 *
 * @property {module:time-ranges~TimeRangeIndex} start
 *           Returns the time offset at which a specified time range begins.
 *
 * @property {module:time-ranges~TimeRangeIndex} end
 *           Returns the time offset at which a specified time range ends.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
 */ /**
 * Check if any of the time ranges are over the maximum index.
 *
 * @private
 * @param   {string} fnName
 *          The function name to use for logging
 *
 * @param   {number} index
 *          The index to check
 *
 * @param   {number} maxIndex
 *          The maximum possible index
 *
 * @throws  {Error} if the timeRanges provided are over the maxIndex
 */function rangeCheck(fnName,index,maxIndex){if(typeof index!=='number'||index<0||index>maxIndex){throw new Error("Failed to execute '"+fnName+"' on 'TimeRanges': The index provided ("+index+") is non-numeric or out of bounds (0-"+maxIndex+").");}}/**
 * Get the time for the specified index at the start or end
 * of a TimeRange object.
 *
 * @private
 * @param      {string} fnName
 *             The function name to use for logging
 *
 * @param      {string} valueIndex
 *             The property that should be used to get the time. should be
 *             'start' or 'end'
 *
 * @param      {Array} ranges
 *             An array of time ranges
 *
 * @param      {Array} [rangeIndex=0]
 *             The index to start the search at
 *
 * @return     {number}
 *             The time that offset at the specified index.
 *
 * @deprecated rangeIndex must be set to a value, in the future this will throw an error.
 * @throws     {Error} if rangeIndex is more than the length of ranges
 */function getRange(fnName,valueIndex,ranges,rangeIndex){rangeCheck(fnName,rangeIndex,ranges.length-1);return ranges[rangeIndex][valueIndex];}/**
 * Create a time range object given ranges of time.
 *
 * @private
 * @param   {Array} [ranges]
 *          An array of time ranges.
 */function createTimeRangesObj(ranges){var timeRangesObj;if(ranges===undefined||ranges.length===0){timeRangesObj={length:0,start:function start(){throw new Error('This TimeRanges object is empty');},end:function end(){throw new Error('This TimeRanges object is empty');}};}else{timeRangesObj={length:ranges.length,start:getRange.bind(null,'start',0,ranges),end:getRange.bind(null,'end',1,ranges)};}if((window_default()).Symbol&&(window_default()).Symbol.iterator){timeRangesObj[(window_default()).Symbol.iterator]=function(){return(ranges||[]).values();};}return timeRangesObj;}/**
 * Create a `TimeRange` object which mimics an
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|HTML5 TimeRanges instance}.
 *
 * @param {number|Array[]} start
 *        The start of a single range (a number) or an array of ranges (an
 *        array of arrays of two numbers each).
 *
 * @param {number} end
 *        The end of a single range. Cannot be used with the array form of
 *        the `start` argument.
 */function createTimeRanges(start,end){if(Array.isArray(start)){return createTimeRangesObj(start);}else if(start===undefined||end===undefined){return createTimeRangesObj();}return createTimeRangesObj([[start,end]]);}/**
 * @file buffer.js
 * @module buffer
 */ /**
 * Compute the percentage of the media that has been buffered.
 *
 * @param {TimeRange} buffered
 *        The current `TimeRange` object representing buffered time ranges
 *
 * @param {number} duration
 *        Total duration of the media
 *
 * @return {number}
 *         Percent buffered of the total duration in decimal form.
 */function bufferedPercent(buffered,duration){var bufferedDuration=0;var start;var end;if(!duration){return 0;}if(!buffered||!buffered.length){buffered=createTimeRanges(0,0);}for(var i=0;i<buffered.length;i++){start=buffered.start(i);end=buffered.end(i);// buffered end can be bigger than duration by a very small fraction
if(end>duration){end=duration;}bufferedDuration+=end-start;}return bufferedDuration/duration;}/**
 * @file media-error.js
 */ /**
 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
 *
 * @param {number|string|Object|MediaError} value
 *        This can be of multiple types:
 *        - number: should be a standard error code
 *        - string: an error message (the code will be 0)
 *        - Object: arbitrary properties
 *        - `MediaError` (native): used to populate a video.js `MediaError` object
 *        - `MediaError` (video.js): will return itself if it's already a
 *          video.js `MediaError` object.
 *
 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
 *
 * @class MediaError
 */function MediaError(value){// Allow redundant calls to this constructor to avoid having `instanceof`
// checks peppered around the code.
if(value instanceof MediaError){return value;}if(typeof value==='number'){this.code=value;}else if(typeof value==='string'){// default code is zero, so this is a custom error
this.message=value;}else if(video_es_isObject(value)){// We assign the `code` property manually because native `MediaError` objects
// do not expose it as an own/enumerable property of the object.
if(typeof value.code==='number'){this.code=value.code;}video_es_assign(this,value);}if(!this.message){this.message=MediaError.defaultMessages[this.code]||'';}}/**
 * The error code that refers two one of the defined `MediaError` types
 *
 * @type {Number}
 */MediaError.prototype.code=0;/**
 * An optional message that to show with the error. Message is not part of the HTML5
 * video spec but allows for more informative custom errors.
 *
 * @type {String}
 */MediaError.prototype.message='';/**
 * An optional status code that can be set by plugins to allow even more detail about
 * the error. For example a plugin might provide a specific HTTP status code and an
 * error message for that code. Then when the plugin gets that error this class will
 * know how to display an error message for it. This allows a custom message to show
 * up on the `Player` error overlay.
 *
 * @type {Array}
 */MediaError.prototype.status=null;/**
 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
 * specification listed under {@link MediaError} for more information.
 *
 * @enum {array}
 * @readonly
 * @property {string} 0 - MEDIA_ERR_CUSTOM
 * @property {string} 1 - MEDIA_ERR_ABORTED
 * @property {string} 2 - MEDIA_ERR_NETWORK
 * @property {string} 3 - MEDIA_ERR_DECODE
 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
 */MediaError.errorTypes=['MEDIA_ERR_CUSTOM','MEDIA_ERR_ABORTED','MEDIA_ERR_NETWORK','MEDIA_ERR_DECODE','MEDIA_ERR_SRC_NOT_SUPPORTED','MEDIA_ERR_ENCRYPTED'];/**
 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
 *
 * @type {Array}
 * @constant
 */MediaError.defaultMessages={1:'You aborted the media playback',2:'A network error caused the media download to fail part-way.',3:'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',4:'The media could not be loaded, either because the server or network failed or because the format is not supported.',5:'The media is encrypted and we do not have the keys to decrypt it.'};// Add types as properties on MediaError
// e.g. MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
for(var errNum=0;errNum<MediaError.errorTypes.length;errNum++){MediaError[MediaError.errorTypes[errNum]]=errNum;// values should be accessible on both the class and instance
MediaError.prototype[MediaError.errorTypes[errNum]]=errNum;}// jsdocs for instance/static members added above
/**
 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
 *
 * @param  {Object}  value
 *         An object that may or may not be `Promise`-like.
 *
 * @return {boolean}
 *         Whether or not the object is `Promise`-like.
 */function isPromise(value){return value!==undefined&&value!==null&&typeof value.then==='function';}/**
 * Silence a Promise-like object.
 *
 * This is useful for avoiding non-harmful, but potentially confusing "uncaught
 * play promise" rejection error messages.
 *
 * @param  {Object} value
 *         An object that may or may not be `Promise`-like.
 */function silencePromise(value){if(isPromise(value)){value.then(null,function(e){});}}/**
 * @file text-track-list-converter.js Utilities for capturing text track state and
 * re-creating tracks based on a capture.
 *
 * @module text-track-list-converter
 */ /**
 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
 * represents the {@link TextTrack}'s state.
 *
 * @param {TextTrack} track
 *        The text track to query.
 *
 * @return {Object}
 *         A serializable javascript representation of the TextTrack.
 * @private
 */var trackToJson_=function trackToJson_(track){var ret=['kind','label','language','id','inBandMetadataTrackDispatchType','mode','src'].reduce(function(acc,prop,i){if(track[prop]){acc[prop]=track[prop];}return acc;},{cues:track.cues&&Array.prototype.map.call(track.cues,function(cue){return{startTime:cue.startTime,endTime:cue.endTime,text:cue.text,id:cue.id};})});return ret;};/**
 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
 * state of all {@link TextTrack}s currently configured. The return array is compatible with
 * {@link text-track-list-converter:jsonToTextTracks}.
 *
 * @param {Tech} tech
 *        The tech object to query
 *
 * @return {Array}
 *         A serializable javascript representation of the {@link Tech}s
 *         {@link TextTrackList}.
 */var textTracksToJson=function textTracksToJson(tech){var trackEls=tech.$$('track');var trackObjs=Array.prototype.map.call(trackEls,function(t){return t.track;});var tracks=Array.prototype.map.call(trackEls,function(trackEl){var json=trackToJson_(trackEl.track);if(trackEl.src){json.src=trackEl.src;}return json;});return tracks.concat(Array.prototype.filter.call(tech.textTracks(),function(track){return trackObjs.indexOf(track)===-1;}).map(trackToJson_));};/**
 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
 * object {@link TextTrack} representations.
 *
 * @param {Array} json
 *        An array of `TextTrack` representation objects, like those that would be
 *        produced by `textTracksToJson`.
 *
 * @param {Tech} tech
 *        The `Tech` to create the `TextTrack`s on.
 */var jsonToTextTracks=function jsonToTextTracks(json,tech){json.forEach(function(track){var addedTrack=tech.addRemoteTextTrack(track).track;if(!track.src&&track.cues){track.cues.forEach(function(cue){return addedTrack.addCue(cue);});}});return tech.textTracks();};var textTrackConverter={textTracksToJson:textTracksToJson,jsonToTextTracks:jsonToTextTracks,trackToJson_:trackToJson_};var MODAL_CLASS_NAME='vjs-modal-dialog';/**
 * The `ModalDialog` displays over the video and its controls, which blocks
 * interaction with the player until it is closed.
 *
 * Modal dialogs include a "Close" button and will close when that button
 * is activated - or when ESC is pressed anywhere.
 *
 * @extends Component
 */var ModalDialog=/*#__PURE__*/function(_Component){_inheritsLoose(ModalDialog,_Component);/**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Mixed} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.pauseOnOpen=true]
   *        If `true`, playback will will be paused if playing when
   *        the modal opens, and resumed when it closes.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */function ModalDialog(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.handleKeyDown_=function(e){return _this.handleKeyDown(e);};_this.close_=function(e){return _this.close(e);};_this.opened_=_this.hasBeenOpened_=_this.hasBeenFilled_=false;_this.closeable(!_this.options_.uncloseable);_this.content(_this.options_.content);// Make sure the contentEl is defined AFTER any children are initialized
// because we only want the contents of the modal in the contentEl
// (not the UI elements like the close button).
_this.contentEl_=createEl('div',{className:MODAL_CLASS_NAME+"-content"},{role:'document'});_this.descEl_=createEl('p',{className:MODAL_CLASS_NAME+"-description vjs-control-text",id:_this.el().getAttribute('aria-describedby')});textContent(_this.descEl_,_this.description());_this.el_.appendChild(_this.descEl_);_this.el_.appendChild(_this.contentEl_);return _this;}/**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */var _proto=ModalDialog.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:this.buildCSSClass(),tabIndex:-1},{'aria-describedby':this.id()+"_description",'aria-hidden':'true','aria-label':this.label(),'role':'dialog'});};_proto.dispose=function dispose(){this.contentEl_=null;this.descEl_=null;this.previouslyActiveEl_=null;_Component.prototype.dispose.call(this);}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */;_proto.buildCSSClass=function buildCSSClass(){return MODAL_CLASS_NAME+" vjs-hidden "+_Component.prototype.buildCSSClass.call(this);}/**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */;_proto.label=function label(){return this.localize(this.options_.label||'Modal Window');}/**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */;_proto.description=function description(){var desc=this.options_.description||this.localize('This is a modal window.');// Append a universal closeability message if the modal is closeable.
if(this.closeable()){desc+=' '+this.localize('This modal can be closed by pressing the Escape key or activating the close button.');}return desc;}/**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */;_proto.open=function open(){if(!this.opened_){var player=this.player();/**
        * Fired just before a `ModalDialog` is opened.
        *
        * @event ModalDialog#beforemodalopen
        * @type {EventTarget~Event}
        */this.trigger('beforemodalopen');this.opened_=true;// Fill content if the modal has never opened before and
// never been filled.
if(this.options_.fillAlways||!this.hasBeenOpened_&&!this.hasBeenFilled_){this.fill();}// If the player was playing, pause it and take note of its previously
// playing state.
this.wasPlaying_=!player.paused();if(this.options_.pauseOnOpen&&this.wasPlaying_){player.pause();}this.on('keydown',this.handleKeyDown_);// Hide controls and note if they were enabled.
this.hadControls_=player.controls();player.controls(false);this.show();this.conditionalFocus_();this.el().setAttribute('aria-hidden','false');/**
        * Fired just after a `ModalDialog` is opened.
        *
        * @event ModalDialog#modalopen
        * @type {EventTarget~Event}
        */this.trigger('modalopen');this.hasBeenOpened_=true;}}/**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */;_proto.opened=function opened(value){if(typeof value==='boolean'){this[value?'open':'close']();}return this.opened_;}/**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */;_proto.close=function close(){if(!this.opened_){return;}var player=this.player();/**
      * Fired just before a `ModalDialog` is closed.
      *
      * @event ModalDialog#beforemodalclose
      * @type {EventTarget~Event}
      */this.trigger('beforemodalclose');this.opened_=false;if(this.wasPlaying_&&this.options_.pauseOnOpen){player.play();}this.off('keydown',this.handleKeyDown_);if(this.hadControls_){player.controls(true);}this.hide();this.el().setAttribute('aria-hidden','true');/**
      * Fired just after a `ModalDialog` is closed.
      *
      * @event ModalDialog#modalclose
      * @type {EventTarget~Event}
      */this.trigger('modalclose');this.conditionalBlur_();if(this.options_.temporary){this.dispose();}}/**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */;_proto.closeable=function closeable(value){if(typeof value==='boolean'){var closeable=this.closeable_=!!value;var close=this.getChild('closeButton');// If this is being made closeable and has no close button, add one.
if(closeable&&!close){// The close button should be a child of the modal - not its
// content element, so temporarily change the content element.
var temp=this.contentEl_;this.contentEl_=this.el_;close=this.addChild('closeButton',{controlText:'Close Modal Dialog'});this.contentEl_=temp;this.on(close,'close',this.close_);}// If this is being made uncloseable and has a close button, remove it.
if(!closeable&&close){this.off(close,'close',this.close_);this.removeChild(close);close.dispose();}}return this.closeable_;}/**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */;_proto.fill=function fill(){this.fillWith(this.content());}/**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param {Mixed} [content]
   *        The same rules apply to this as apply to the `content` option.
   */;_proto.fillWith=function fillWith(content){var contentEl=this.contentEl();var parentEl=contentEl.parentNode;var nextSiblingEl=contentEl.nextSibling;/**
      * Fired just before a `ModalDialog` is filled with content.
      *
      * @event ModalDialog#beforemodalfill
      * @type {EventTarget~Event}
      */this.trigger('beforemodalfill');this.hasBeenFilled_=true;// Detach the content element from the DOM before performing
// manipulation to avoid modifying the live DOM multiple times.
parentEl.removeChild(contentEl);this.empty();insertContent(contentEl,content);/**
     * Fired just after a `ModalDialog` is filled with content.
     *
     * @event ModalDialog#modalfill
     * @type {EventTarget~Event}
     */this.trigger('modalfill');// Re-inject the re-filled content element.
if(nextSiblingEl){parentEl.insertBefore(contentEl,nextSiblingEl);}else{parentEl.appendChild(contentEl);}// make sure that the close button is last in the dialog DOM
var closeButton=this.getChild('closeButton');if(closeButton){parentEl.appendChild(closeButton.el_);}}/**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */;_proto.empty=function empty(){/**
    * Fired just before a `ModalDialog` is emptied.
    *
    * @event ModalDialog#beforemodalempty
    * @type {EventTarget~Event}
    */this.trigger('beforemodalempty');emptyEl(this.contentEl());/**
    * Fired just after a `ModalDialog` is emptied.
    *
    * @event ModalDialog#modalempty
    * @type {EventTarget~Event}
    */this.trigger('modalempty');}/**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  {Mixed} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return {Mixed}
   *         The current content of the modal dialog
   */;_proto.content=function content(value){if(typeof value!=='undefined'){this.content_=value;}return this.content_;}/**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */;_proto.conditionalFocus_=function conditionalFocus_(){var activeEl=(document_default()).activeElement;var playerEl=this.player_.el_;this.previouslyActiveEl_=null;if(playerEl.contains(activeEl)||playerEl===activeEl){this.previouslyActiveEl_=activeEl;this.focus();}}/**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */;_proto.conditionalBlur_=function conditionalBlur_(){if(this.previouslyActiveEl_){this.previouslyActiveEl_.focus();this.previouslyActiveEl_=null;}}/**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Do not allow keydowns to reach out of the modal dialog.
event.stopPropagation();if(keycode_default().isEventKey(event,'Escape')&&this.closeable()){event.preventDefault();this.close();return;}// exit early if it isn't a tab key
if(!keycode_default().isEventKey(event,'Tab')){return;}var focusableEls=this.focusableEls_();var activeEl=this.el_.querySelector(':focus');var focusIndex;for(var i=0;i<focusableEls.length;i++){if(activeEl===focusableEls[i]){focusIndex=i;break;}}if((document_default()).activeElement===this.el_){focusIndex=0;}if(event.shiftKey&&focusIndex===0){focusableEls[focusableEls.length-1].focus();event.preventDefault();}else if(!event.shiftKey&&focusIndex===focusableEls.length-1){focusableEls[0].focus();event.preventDefault();}}/**
   * get all focusable elements
   *
   * @private
   */;_proto.focusableEls_=function focusableEls_(){var allChildren=this.el_.querySelectorAll('*');return Array.prototype.filter.call(allChildren,function(child){return(child instanceof (window_default()).HTMLAnchorElement||child instanceof (window_default()).HTMLAreaElement)&&child.hasAttribute('href')||(child instanceof (window_default()).HTMLInputElement||child instanceof (window_default()).HTMLSelectElement||child instanceof (window_default()).HTMLTextAreaElement||child instanceof (window_default()).HTMLButtonElement)&&!child.hasAttribute('disabled')||child instanceof (window_default()).HTMLIFrameElement||child instanceof (window_default()).HTMLObjectElement||child instanceof (window_default()).HTMLEmbedElement||child.hasAttribute('tabindex')&&child.getAttribute('tabindex')!==-1||child.hasAttribute('contenteditable');});};return ModalDialog;}(Component$1);/**
 * Default options for `ModalDialog` default options.
 *
 * @type {Object}
 * @private
 */ModalDialog.prototype.options_={pauseOnOpen:true,temporary:true};Component$1.registerComponent('ModalDialog',ModalDialog);/**
 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
 * {@link VideoTrackList}
 *
 * @extends EventTarget
 */var TrackList=/*#__PURE__*/function(_EventTarget){_inheritsLoose(TrackList,_EventTarget);/**
   * Create an instance of this class
   *
   * @param {Track[]} tracks
   *        A list of tracks to initialize the list with.
   *
   * @abstract
   */function TrackList(tracks){var _this;if(tracks===void 0){tracks=[];}_this=_EventTarget.call(this)||this;_this.tracks_=[];/**
     * @memberof TrackList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */Object.defineProperty(_assertThisInitialized(_this),'length',{get:function get(){return this.tracks_.length;}});for(var i=0;i<tracks.length;i++){_this.addTrack(tracks[i]);}return _this;}/**
   * Add a {@link Track} to the `TrackList`
   *
   * @param {Track} track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */var _proto=TrackList.prototype;_proto.addTrack=function addTrack(track){var _this2=this;var index=this.tracks_.length;if(!(''+index in this)){Object.defineProperty(this,index,{get:function get(){return this.tracks_[index];}});}// Do not add duplicate tracks
if(this.tracks_.indexOf(track)===-1){this.tracks_.push(track);/**
       * Triggered when a track is added to a track list.
       *
       * @event TrackList#addtrack
       * @type {EventTarget~Event}
       * @property {Track} track
       *           A reference to track that was added.
       */this.trigger({track:track,type:'addtrack',target:this});}/**
     * Triggered when a track label is changed.
     *
     * @event TrackList#addtrack
     * @type {EventTarget~Event}
     * @property {Track} track
     *           A reference to track that was added.
     */track.labelchange_=function(){_this2.trigger({track:track,type:'labelchange',target:_this2});};if(isEvented(track)){track.addEventListener('labelchange',track.labelchange_);}}/**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param {Track} rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */;_proto.removeTrack=function removeTrack(rtrack){var track;for(var i=0,l=this.length;i<l;i++){if(this[i]===rtrack){track=this[i];if(track.off){track.off();}this.tracks_.splice(i,1);break;}}if(!track){return;}/**
     * Triggered when a track is removed from track list.
     *
     * @event TrackList#removetrack
     * @type {EventTarget~Event}
     * @property {Track} track
     *           A reference to track that was removed.
     */this.trigger({track:track,type:'removetrack',target:this});}/**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {string} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */;_proto.getTrackById=function getTrackById(id){var result=null;for(var i=0,l=this.length;i<l;i++){var track=this[i];if(track.id===id){result=track;break;}}return result;};return TrackList;}(EventTarget$2);/**
 * Triggered when a different track is selected/enabled.
 *
 * @event TrackList#change
 * @type {EventTarget~Event}
 */ /**
 * Events that can be called with on + eventName. See {@link EventHandler}.
 *
 * @property {Object} TrackList#allowedEvents_
 * @private
 */TrackList.prototype.allowedEvents_={change:'change',addtrack:'addtrack',removetrack:'removetrack',labelchange:'labelchange'};// emulate attribute EventHandler support to allow for feature detection
for(var video_es_event in TrackList.prototype.allowedEvents_){TrackList.prototype['on'+video_es_event]=null;}/**
 * Anywhere we call this function we diverge from the spec
 * as we only support one enabled audiotrack at a time
 *
 * @param {AudioTrackList} list
 *        list to work on
 *
 * @param {AudioTrack} track
 *        The track to skip
 *
 * @private
 */var disableOthers$1=function disableOthers(list,track){for(var i=0;i<list.length;i++){if(!Object.keys(list[i]).length||track.id===list[i].id){continue;}// another audio track is enabled, disable it
list[i].enabled=false;}};/**
 * The current list of {@link AudioTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
 * @extends TrackList
 */var AudioTrackList=/*#__PURE__*/function(_TrackList){_inheritsLoose(AudioTrackList,_TrackList);/**
   * Create an instance of this class.
   *
   * @param {AudioTrack[]} [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */function AudioTrackList(tracks){var _this;if(tracks===void 0){tracks=[];}// make sure only 1 track is enabled
// sorted from last index to first index
for(var i=tracks.length-1;i>=0;i--){if(tracks[i].enabled){disableOthers$1(tracks,tracks[i]);break;}}_this=_TrackList.call(this,tracks)||this;_this.changing_=false;return _this;}/**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param {AudioTrack} track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */var _proto=AudioTrackList.prototype;_proto.addTrack=function addTrack(track){var _this2=this;if(track.enabled){disableOthers$1(this,track);}_TrackList.prototype.addTrack.call(this,track);// native tracks don't have this
if(!track.addEventListener){return;}track.enabledChange_=function(){// when we are disabling other tracks (since we don't support
// more than one track at a time) we will set changing_
// to true so that we don't trigger additional change events
if(_this2.changing_){return;}_this2.changing_=true;disableOthers$1(_this2,track);_this2.changing_=false;_this2.trigger('change');};/**
     * @listens AudioTrack#enabledchange
     * @fires TrackList#change
     */track.addEventListener('enabledchange',track.enabledChange_);};_proto.removeTrack=function removeTrack(rtrack){_TrackList.prototype.removeTrack.call(this,rtrack);if(rtrack.removeEventListener&&rtrack.enabledChange_){rtrack.removeEventListener('enabledchange',rtrack.enabledChange_);rtrack.enabledChange_=null;}};return AudioTrackList;}(TrackList);/**
 * Un-select all other {@link VideoTrack}s that are selected.
 *
 * @param {VideoTrackList} list
 *        list to work on
 *
 * @param {VideoTrack} track
 *        The track to skip
 *
 * @private
 */var disableOthers=function disableOthers(list,track){for(var i=0;i<list.length;i++){if(!Object.keys(list[i]).length||track.id===list[i].id){continue;}// another video track is enabled, disable it
list[i].selected=false;}};/**
 * The current list of {@link VideoTrack} for a video.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
 * @extends TrackList
 */var VideoTrackList=/*#__PURE__*/function(_TrackList){_inheritsLoose(VideoTrackList,_TrackList);/**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */function VideoTrackList(tracks){var _this;if(tracks===void 0){tracks=[];}// make sure only 1 track is enabled
// sorted from last index to first index
for(var i=tracks.length-1;i>=0;i--){if(tracks[i].selected){disableOthers(tracks,tracks[i]);break;}}_this=_TrackList.call(this,tracks)||this;_this.changing_=false;/**
     * @member {number} VideoTrackList#selectedIndex
     *         The current index of the selected {@link VideoTrack`}.
     */Object.defineProperty(_assertThisInitialized(_this),'selectedIndex',{get:function get(){for(var _i=0;_i<this.length;_i++){if(this[_i].selected){return _i;}}return-1;},set:function set(){}});return _this;}/**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param {VideoTrack} track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */var _proto=VideoTrackList.prototype;_proto.addTrack=function addTrack(track){var _this2=this;if(track.selected){disableOthers(this,track);}_TrackList.prototype.addTrack.call(this,track);// native tracks don't have this
if(!track.addEventListener){return;}track.selectedChange_=function(){if(_this2.changing_){return;}_this2.changing_=true;disableOthers(_this2,track);_this2.changing_=false;_this2.trigger('change');};/**
     * @listens VideoTrack#selectedchange
     * @fires TrackList#change
     */track.addEventListener('selectedchange',track.selectedChange_);};_proto.removeTrack=function removeTrack(rtrack){_TrackList.prototype.removeTrack.call(this,rtrack);if(rtrack.removeEventListener&&rtrack.selectedChange_){rtrack.removeEventListener('selectedchange',rtrack.selectedChange_);rtrack.selectedChange_=null;}};return VideoTrackList;}(TrackList);/**
 * The current list of {@link TextTrack} for a media file.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
 * @extends TrackList
 */var TextTrackList=/*#__PURE__*/function(_TrackList){_inheritsLoose(TextTrackList,_TrackList);function TextTrackList(){return _TrackList.apply(this,arguments)||this;}var _proto=TextTrackList.prototype;/**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param {TextTrack} track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */_proto.addTrack=function addTrack(track){var _this=this;_TrackList.prototype.addTrack.call(this,track);if(!this.queueChange_){this.queueChange_=function(){return _this.queueTrigger('change');};}if(!this.triggerSelectedlanguagechange){this.triggerSelectedlanguagechange_=function(){return _this.trigger('selectedlanguagechange');};}/**
     * @listens TextTrack#modechange
     * @fires TrackList#change
     */track.addEventListener('modechange',this.queueChange_);var nonLanguageTextTrackKind=['metadata','chapters'];if(nonLanguageTextTrackKind.indexOf(track.kind)===-1){track.addEventListener('modechange',this.triggerSelectedlanguagechange_);}};_proto.removeTrack=function removeTrack(rtrack){_TrackList.prototype.removeTrack.call(this,rtrack);// manually remove the event handlers we added
if(rtrack.removeEventListener){if(this.queueChange_){rtrack.removeEventListener('modechange',this.queueChange_);}if(this.selectedlanguagechange_){rtrack.removeEventListener('modechange',this.triggerSelectedlanguagechange_);}}};return TextTrackList;}(TrackList);/**
 * @file html-track-element-list.js
 */ /**
 * The current list of {@link HtmlTrackElement}s.
 */var HtmlTrackElementList=/*#__PURE__*/function(){/**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */function HtmlTrackElementList(trackElements){if(trackElements===void 0){trackElements=[];}this.trackElements_=[];/**
     * @memberof HtmlTrackElementList
     * @member {number} length
     *         The current number of `Track`s in the this Trackist.
     * @instance
     */Object.defineProperty(this,'length',{get:function get(){return this.trackElements_.length;}});for(var i=0,length=trackElements.length;i<length;i++){this.addTrackElement_(trackElements[i]);}}/**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */var _proto=HtmlTrackElementList.prototype;_proto.addTrackElement_=function addTrackElement_(trackElement){var index=this.trackElements_.length;if(!(''+index in this)){Object.defineProperty(this,index,{get:function get(){return this.trackElements_[index];}});}// Do not add duplicate elements
if(this.trackElements_.indexOf(trackElement)===-1){this.trackElements_.push(trackElement);}}/**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */;_proto.getTrackElementByTrack_=function getTrackElementByTrack_(track){var trackElement_;for(var i=0,length=this.trackElements_.length;i<length;i++){if(track===this.trackElements_[i].track){trackElement_=this.trackElements_[i];break;}}return trackElement_;}/**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */;_proto.removeTrackElement_=function removeTrackElement_(trackElement){for(var i=0,length=this.trackElements_.length;i<length;i++){if(trackElement===this.trackElements_[i]){if(this.trackElements_[i].track&&typeof this.trackElements_[i].track.off==='function'){this.trackElements_[i].track.off();}if(typeof this.trackElements_[i].off==='function'){this.trackElements_[i].off();}this.trackElements_.splice(i,1);break;}}};return HtmlTrackElementList;}();/**
 * @file text-track-cue-list.js
 */ /**
 * @typedef {Object} TextTrackCueList~TextTrackCue
 *
 * @property {string} id
 *           The unique id for this text track cue
 *
 * @property {number} startTime
 *           The start time for this text track cue
 *
 * @property {number} endTime
 *           The end time for this text track cue
 *
 * @property {boolean} pauseOnExit
 *           Pause when the end time is reached if true.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
 */ /**
 * A List of TextTrackCues.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
 */var TextTrackCueList=/*#__PURE__*/function(){/**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */function TextTrackCueList(cues){TextTrackCueList.prototype.setCues_.call(this,cues);/**
     * @memberof TextTrackCueList
     * @member {number} length
     *         The current number of `TextTrackCue`s in the TextTrackCueList.
     * @instance
     */Object.defineProperty(this,'length',{get:function get(){return this.length_;}});}/**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */var _proto=TextTrackCueList.prototype;_proto.setCues_=function setCues_(cues){var oldLength=this.length||0;var i=0;var l=cues.length;this.cues_=cues;this.length_=cues.length;var defineProp=function defineProp(index){if(!(''+index in this)){Object.defineProperty(this,''+index,{get:function get(){return this.cues_[index];}});}};if(oldLength<l){i=oldLength;for(;i<l;i++){defineProp.call(this,i);}}}/**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */;_proto.getCueById=function getCueById(id){var result=null;for(var i=0,l=this.length;i<l;i++){var cue=this[i];if(cue.id===id){result=cue;break;}}return result;};return TextTrackCueList;}();/**
 * @file track-kinds.js
 */ /**
 * All possible `VideoTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
 * @typedef VideoTrack~Kind
 * @enum
 */var VideoTrackKind={alternative:'alternative',captions:'captions',main:'main',sign:'sign',subtitles:'subtitles',commentary:'commentary'};/**
 * All possible `AudioTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
 * @typedef AudioTrack~Kind
 * @enum
 */var AudioTrackKind={'alternative':'alternative','descriptions':'descriptions','main':'main','main-desc':'main-desc','translation':'translation','commentary':'commentary'};/**
 * All possible `TextTrackKind`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
 * @typedef TextTrack~Kind
 * @enum
 */var TextTrackKind={subtitles:'subtitles',captions:'captions',descriptions:'descriptions',chapters:'chapters',metadata:'metadata'};/**
 * All possible `TextTrackMode`s
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
 * @typedef TextTrack~Mode
 * @enum
 */var TextTrackMode={disabled:'disabled',hidden:'hidden',showing:'showing'};/**
 * A Track class that contains all of the common functionality for {@link AudioTrack},
 * {@link VideoTrack}, and {@link TextTrack}.
 *
 * > Note: This class should not be used directly
 *
 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
 * @extends EventTarget
 * @abstract
 */var Track=/*#__PURE__*/function(_EventTarget){_inheritsLoose(Track,_EventTarget);/**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */function Track(options){var _this;if(options===void 0){options={};}_this=_EventTarget.call(this)||this;var trackProps={id:options.id||'vjs_track_'+newGUID(),kind:options.kind||'',language:options.language||''};var label=options.label||'';/**
     * @memberof Track
     * @member {string} id
     *         The id of this track. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */ /**
     * @memberof Track
     * @member {string} kind
     *         The kind of track that this is. Cannot be changed after creation.
     * @instance
     *
     * @readonly
     */ /**
     * @memberof Track
     * @member {string} language
     *         The two letter language code for this track. Cannot be changed after
     *         creation.
     * @instance
     *
     * @readonly
     */var _loop=function _loop(key){Object.defineProperty(_assertThisInitialized(_this),key,{get:function get(){return trackProps[key];},set:function set(){}});};for(var key in trackProps){_loop(key);}/**
     * @memberof Track
     * @member {string} label
     *         The label of this track. Cannot be changed after creation.
     * @instance
     *
     * @fires Track#labelchange
     */Object.defineProperty(_assertThisInitialized(_this),'label',{get:function get(){return label;},set:function set(newLabel){if(newLabel!==label){label=newLabel;/**
           * An event that fires when label changes on this track.
           *
           * > Note: This is not part of the spec!
           *
           * @event Track#labelchange
           * @type {EventTarget~Event}
           */this.trigger('labelchange');}}});return _this;}return Track;}(EventTarget$2);/**
 * @file url.js
 * @module url
 */ /**
 * @typedef {Object} url:URLObject
 *
 * @property {string} protocol
 *           The protocol of the url that was parsed.
 *
 * @property {string} hostname
 *           The hostname of the url that was parsed.
 *
 * @property {string} port
 *           The port of the url that was parsed.
 *
 * @property {string} pathname
 *           The pathname of the url that was parsed.
 *
 * @property {string} search
 *           The search query of the url that was parsed.
 *
 * @property {string} hash
 *           The hash of the url that was parsed.
 *
 * @property {string} host
 *           The host of the url that was parsed.
 */ /**
 * Resolve and parse the elements of a URL.
 *
 * @function
 * @param    {String} url
 *           The url to parse
 *
 * @return   {url:URLObject}
 *           An object of url details
 */var parseUrl=function parseUrl(url){// This entire method can be replace with URL once we are able to drop IE11
var props=['protocol','hostname','port','pathname','search','hash','host'];// add the url to an anchor and let the browser parse the URL
var a=document_default().createElement('a');a.href=url;// Copy the specific URL properties to a new object
// This is also needed for IE because the anchor loses its
// properties when it's removed from the dom
var details={};for(var i=0;i<props.length;i++){details[props[i]]=a[props[i]];}// IE adds the port to the host property unlike everyone else. If
// a port identifier is added for standard ports, strip it.
if(details.protocol==='http:'){details.host=details.host.replace(/:80$/,'');}if(details.protocol==='https:'){details.host=details.host.replace(/:443$/,'');}if(!details.protocol){details.protocol=(window_default()).location.protocol;}/* istanbul ignore if */if(!details.host){details.host=(window_default()).location.host;}return details;};/**
 * Get absolute version of relative URL. Used to tell Flash the correct URL.
 *
 * @function
 * @param    {string} url
 *           URL to make absolute
 *
 * @return   {string}
 *           Absolute URL
 *
 * @see      http://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue
 */var getAbsoluteURL=function getAbsoluteURL(url){// Check if absolute URL
if(!url.match(/^https?:\/\//)){// Convert to absolute URL. Flash hosted off-site needs an absolute URL.
// add the url to an anchor and let the browser parse the URL
var a=document_default().createElement('a');a.href=url;url=a.href;}return url;};/**
 * Returns the extension of the passed file name. It will return an empty string
 * if passed an invalid path.
 *
 * @function
 * @param    {string} path
 *           The fileName path like '/path/to/file.mp4'
 *
 * @return  {string}
 *           The extension in lower case or an empty string if no
 *           extension could be found.
 */var getFileExtension=function getFileExtension(path){if(typeof path==='string'){var splitPathRe=/^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/;var pathParts=splitPathRe.exec(path);if(pathParts){return pathParts.pop().toLowerCase();}}return'';};/**
 * Returns whether the url passed is a cross domain request or not.
 *
 * @function
 * @param    {string} url
 *           The url to check.
 *
 * @param    {Object} [winLoc]
 *           the domain to check the url against, defaults to window.location
 *
 * @param    {string} [winLoc.protocol]
 *           The window location protocol defaults to window.location.protocol
 *
 * @param    {string} [winLoc.host]
 *           The window location host defaults to window.location.host
 *
 * @return   {boolean}
 *           Whether it is a cross domain request or not.
 */var isCrossOrigin=function isCrossOrigin(url,winLoc){if(winLoc===void 0){winLoc=(window_default()).location;}var urlInfo=parseUrl(url);// IE8 protocol relative urls will return ':' for protocol
var srcProtocol=urlInfo.protocol===':'?winLoc.protocol:urlInfo.protocol;// Check if url is for another domain/origin
// IE8 doesn't know location.origin, so we won't rely on it here
var crossOrigin=srcProtocol+urlInfo.host!==winLoc.protocol+winLoc.host;return crossOrigin;};var Url=/*#__PURE__*/Object.freeze({__proto__:null,parseUrl:parseUrl,getAbsoluteURL:getAbsoluteURL,getFileExtension:getFileExtension,isCrossOrigin:isCrossOrigin});/**
 * Takes a webvtt file contents and parses it into cues
 *
 * @param {string} srcContent
 *        webVTT file contents
 *
 * @param {TextTrack} track
 *        TextTrack to add cues to. Cues come from the srcContent.
 *
 * @private
 */var parseCues=function parseCues(srcContent,track){var parser=new (window_default()).WebVTT.Parser((window_default()),(window_default()).vttjs,window_default().WebVTT.StringDecoder());var errors=[];parser.oncue=function(cue){track.addCue(cue);};parser.onparsingerror=function(error){errors.push(error);};parser.onflush=function(){track.trigger({type:'loadeddata',target:track});};parser.parse(srcContent);if(errors.length>0){if((window_default()).console&&(window_default()).console.groupCollapsed){window_default().console.groupCollapsed("Text Track parsing errors for "+track.src);}errors.forEach(function(error){return log$1.error(error);});if((window_default()).console&&(window_default()).console.groupEnd){window_default().console.groupEnd();}}parser.flush();};/**
 * Load a `TextTrack` from a specified url.
 *
 * @param {string} src
 *        Url to load track from.
 *
 * @param {TextTrack} track
 *        Track to add cues to. Comes from the content at the end of `url`.
 *
 * @private
 */var loadTrack=function loadTrack(src,track){var opts={uri:src};var crossOrigin=isCrossOrigin(src);if(crossOrigin){opts.cors=crossOrigin;}var withCredentials=track.tech_.crossOrigin()==='use-credentials';if(withCredentials){opts.withCredentials=withCredentials;}lib_default()(opts,bind(this,function(err,response,responseBody){if(err){return log$1.error(err,response);}track.loaded_=true;// Make sure that vttjs has loaded, otherwise, wait till it finished loading
// NOTE: this is only used for the alt/video.novtt.js build
if(typeof (window_default()).WebVTT!=='function'){if(track.tech_){// to prevent use before define eslint error, we define loadHandler
// as a let here
track.tech_.any(['vttjsloaded','vttjserror'],function(event){if(event.type==='vttjserror'){log$1.error("vttjs failed to load, stopping trying to process "+track.src);return;}return parseCues(responseBody,track);});}}else{parseCues(responseBody,track);}}));};/**
 * A representation of a single `TextTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
 * @extends Track
 */var TextTrack=/*#__PURE__*/function(_Track){_inheritsLoose(TextTrack,_Track);/**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */function TextTrack(options){var _this;if(options===void 0){options={};}if(!options.tech){throw new Error('A tech was not provided.');}var settings=mergeOptions$3(options,{kind:TextTrackKind[options.kind]||'subtitles',language:options.language||options.srclang||''});var mode=TextTrackMode[settings.mode]||'disabled';var default_=settings["default"];if(settings.kind==='metadata'||settings.kind==='chapters'){mode='hidden';}_this=_Track.call(this,settings)||this;_this.tech_=settings.tech;_this.cues_=[];_this.activeCues_=[];_this.preload_=_this.tech_.preloadTextTracks!==false;var cues=new TextTrackCueList(_this.cues_);var activeCues=new TextTrackCueList(_this.activeCues_);var changed=false;_this.timeupdateHandler=bind(_assertThisInitialized(_this),function(event){if(event===void 0){event={};}if(this.tech_.isDisposed()){return;}if(!this.tech_.isReady_){if(event.type!=='timeupdate'){this.rvf_=this.tech_.requestVideoFrameCallback(this.timeupdateHandler);}return;}// Accessing this.activeCues for the side-effects of updating itself
// due to its nature as a getter function. Do not remove or cues will
// stop updating!
// Use the setter to prevent deletion from uglify (pure_getters rule)
this.activeCues=this.activeCues;if(changed){this.trigger('cuechange');changed=false;}if(event.type!=='timeupdate'){this.rvf_=this.tech_.requestVideoFrameCallback(this.timeupdateHandler);}});var disposeHandler=function disposeHandler(){_this.stopTracking();};_this.tech_.one('dispose',disposeHandler);if(mode!=='disabled'){_this.startTracking();}Object.defineProperties(_assertThisInitialized(_this),{/**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */"default":{get:function get(){return default_;},set:function set(){}},/**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */mode:{get:function get(){return mode;},set:function set(newMode){if(!TextTrackMode[newMode]){return;}if(mode===newMode){return;}mode=newMode;if(!this.preload_&&mode!=='disabled'&&this.cues.length===0){// On-demand load.
loadTrack(this.src,this);}this.stopTracking();if(mode!=='disabled'){this.startTracking();}/**
           * An event that fires when mode changes on this track. This allows
           * the TextTrackList that holds this track to act accordingly.
           *
           * > Note: This is not part of the spec!
           *
           * @event TextTrack#modechange
           * @type {EventTarget~Event}
           */this.trigger('modechange');}},/**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */cues:{get:function get(){if(!this.loaded_){return null;}return cues;},set:function set(){}},/**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */activeCues:{get:function get(){if(!this.loaded_){return null;}// nothing to do
if(this.cues.length===0){return activeCues;}var ct=this.tech_.currentTime();var active=[];for(var i=0,l=this.cues.length;i<l;i++){var cue=this.cues[i];if(cue.startTime<=ct&&cue.endTime>=ct){active.push(cue);}else if(cue.startTime===cue.endTime&&cue.startTime<=ct&&cue.startTime+0.5>=ct){active.push(cue);}}changed=false;if(active.length!==this.activeCues_.length){changed=true;}else{for(var _i=0;_i<active.length;_i++){if(this.activeCues_.indexOf(active[_i])===-1){changed=true;}}}this.activeCues_=active;activeCues.setCues_(this.activeCues_);return activeCues;},// /!\ Keep this setter empty (see the timeupdate handler above)
set:function set(){}}});if(settings.src){_this.src=settings.src;if(!_this.preload_){// Tracks will load on-demand.
// Act like we're loaded for other purposes.
_this.loaded_=true;}if(_this.preload_||settings.kind!=='subtitles'&&settings.kind!=='captions'){loadTrack(_this.src,_assertThisInitialized(_this));}}else{_this.loaded_=true;}return _this;}var _proto=TextTrack.prototype;_proto.startTracking=function startTracking(){// More precise cues based on requestVideoFrameCallback with a requestAnimationFram fallback
this.rvf_=this.tech_.requestVideoFrameCallback(this.timeupdateHandler);// Also listen to timeupdate in case rVFC/rAF stops (window in background, audio in video el)
this.tech_.on('timeupdate',this.timeupdateHandler);};_proto.stopTracking=function stopTracking(){if(this.rvf_){this.tech_.cancelVideoFrameCallback(this.rvf_);this.rvf_=undefined;}this.tech_.off('timeupdate',this.timeupdateHandler);}/**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */;_proto.addCue=function addCue(originalCue){var cue=originalCue;// Testing if the cue is a VTTCue in a way that survives minification
if(!('getCueAsHTML'in cue)){cue=new (window_default()).vttjs.VTTCue(originalCue.startTime,originalCue.endTime,originalCue.text);for(var prop in originalCue){if(!(prop in cue)){cue[prop]=originalCue[prop];}}// make sure that `id` is copied over
cue.id=originalCue.id;cue.originalCue_=originalCue;}var tracks=this.tech_.textTracks();for(var i=0;i<tracks.length;i++){if(tracks[i]!==this){tracks[i].removeCue(cue);}}this.cues_.push(cue);this.cues.setCues_(this.cues_);}/**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */;_proto.removeCue=function removeCue(_removeCue){var i=this.cues_.length;while(i--){var cue=this.cues_[i];if(cue===_removeCue||cue.originalCue_&&cue.originalCue_===_removeCue){this.cues_.splice(i,1);this.cues.setCues_(this.cues_);break;}}};return TextTrack;}(Track);/**
 * cuechange - One or more cues in the track have become active or stopped being active.
 */TextTrack.prototype.allowedEvents_={cuechange:'cuechange'};/**
 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
 * only one `AudioTrack` in the list will be enabled at a time.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
 * @extends Track
 */var AudioTrack=/*#__PURE__*/function(_Track){_inheritsLoose(AudioTrack,_Track);/**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */function AudioTrack(options){var _this;if(options===void 0){options={};}var settings=mergeOptions$3(options,{kind:AudioTrackKind[options.kind]||''});_this=_Track.call(this,settings)||this;var enabled=false;/**
     * @memberof AudioTrack
     * @member {boolean} enabled
     *         If this `AudioTrack` is enabled or not. When setting this will
     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */Object.defineProperty(_assertThisInitialized(_this),'enabled',{get:function get(){return enabled;},set:function set(newEnabled){// an invalid or unchanged value
if(typeof newEnabled!=='boolean'||newEnabled===enabled){return;}enabled=newEnabled;/**
         * An event that fires when enabled changes on this track. This allows
         * the AudioTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event AudioTrack#enabledchange
         * @type {EventTarget~Event}
         */this.trigger('enabledchange');}});// if the user sets this track to selected then
// set selected to that true value otherwise
// we keep it false
if(settings.enabled){_this.enabled=settings.enabled;}_this.loaded_=true;return _this;}return AudioTrack;}(Track);/**
 * A representation of a single `VideoTrack`.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
 * @extends Track
 */var VideoTrack=/*#__PURE__*/function(_Track){_inheritsLoose(VideoTrack,_Track);/**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */function VideoTrack(options){var _this;if(options===void 0){options={};}var settings=mergeOptions$3(options,{kind:VideoTrackKind[options.kind]||''});_this=_Track.call(this,settings)||this;var selected=false;/**
     * @memberof VideoTrack
     * @member {boolean} selected
     *         If this `VideoTrack` is selected or not. When setting this will
     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
     * @instance
     *
     * @fires VideoTrack#selectedchange
     */Object.defineProperty(_assertThisInitialized(_this),'selected',{get:function get(){return selected;},set:function set(newSelected){// an invalid or unchanged value
if(typeof newSelected!=='boolean'||newSelected===selected){return;}selected=newSelected;/**
         * An event that fires when selected changes on this track. This allows
         * the VideoTrackList that holds this track to act accordingly.
         *
         * > Note: This is not part of the spec! Native tracks will do
         *         this internally without an event.
         *
         * @event VideoTrack#selectedchange
         * @type {EventTarget~Event}
         */this.trigger('selectedchange');}});// if the user sets this track to selected then
// set selected to that true value otherwise
// we keep it false
if(settings.selected){_this.selected=settings.selected;}return _this;}return VideoTrack;}(Track);/**
 * @memberof HTMLTrackElement
 * @typedef {HTMLTrackElement~ReadyState}
 * @enum {number}
 */var NONE=0;var LOADING=1;var LOADED=2;var ERROR=3;/**
 * A single track represented in the DOM.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
 * @extends EventTarget
 */var HTMLTrackElement=/*#__PURE__*/function(_EventTarget){_inheritsLoose(HTMLTrackElement,_EventTarget);/**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */function HTMLTrackElement(options){var _this;if(options===void 0){options={};}_this=_EventTarget.call(this)||this;var readyState;var track=new TextTrack(options);_this.kind=track.kind;_this.src=track.src;_this.srclang=track.language;_this.label=track.label;_this["default"]=track["default"];Object.defineProperties(_assertThisInitialized(_this),{/**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */readyState:{get:function get(){return readyState;}},/**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */track:{get:function get(){return track;}}});readyState=NONE;/**
     * @listens TextTrack#loadeddata
     * @fires HTMLTrackElement#load
     */track.addEventListener('loadeddata',function(){readyState=LOADED;_this.trigger({type:'load',target:_assertThisInitialized(_this)});});return _this;}return HTMLTrackElement;}(EventTarget$2);HTMLTrackElement.prototype.allowedEvents_={load:'load'};HTMLTrackElement.NONE=NONE;HTMLTrackElement.LOADING=LOADING;HTMLTrackElement.LOADED=LOADED;HTMLTrackElement.ERROR=ERROR;/*
 * This file contains all track properties that are used in
 * player.js, tech.js, html5.js and possibly other techs in the future.
 */var NORMAL={audio:{ListClass:AudioTrackList,TrackClass:AudioTrack,capitalName:'Audio'},video:{ListClass:VideoTrackList,TrackClass:VideoTrack,capitalName:'Video'},text:{ListClass:TextTrackList,TrackClass:TextTrack,capitalName:'Text'}};Object.keys(NORMAL).forEach(function(type){NORMAL[type].getterName=type+"Tracks";NORMAL[type].privateName=type+"Tracks_";});var REMOTE={remoteText:{ListClass:TextTrackList,TrackClass:TextTrack,capitalName:'RemoteText',getterName:'remoteTextTracks',privateName:'remoteTextTracks_'},remoteTextEl:{ListClass:HtmlTrackElementList,TrackClass:HTMLTrackElement,capitalName:'RemoteTextTrackEls',getterName:'remoteTextTrackEls',privateName:'remoteTextTrackEls_'}};var ALL=_extends({},NORMAL,REMOTE);REMOTE.names=Object.keys(REMOTE);NORMAL.names=Object.keys(NORMAL);ALL.names=[].concat(REMOTE.names).concat(NORMAL.names);/**
 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
 * that just contains the src url alone.
 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
   * `var SourceString = 'http://example.com/some-video.mp4';`
 *
 * @typedef {Object|string} Tech~SourceObject
 *
 * @property {string} src
 *           The url to the source
 *
 * @property {string} type
 *           The mime type of the source
 */ /**
 * A function used by {@link Tech} to create a new {@link TextTrack}.
 *
 * @private
 *
 * @param {Tech} self
 *        An instance of the Tech class.
 *
 * @param {string} kind
 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
 *
 * @param {string} [label]
 *        Label to identify the text track
 *
 * @param {string} [language]
 *        Two letter language abbreviation
 *
 * @param {Object} [options={}]
 *        An object with additional text track options
 *
 * @return {TextTrack}
 *          The text track that was created.
 */function createTrackHelper(self,kind,label,language,options){if(options===void 0){options={};}var tracks=self.textTracks();options.kind=kind;if(label){options.label=label;}if(language){options.language=language;}options.tech=self;var track=new ALL.text.TrackClass(options);tracks.addTrack(track);return track;}/**
 * This is the base class for media playback technology controllers, such as
 * {@link HTML5}
 *
 * @extends Component
 */var Tech=/*#__PURE__*/function(_Component){_inheritsLoose(Tech,_Component);/**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Component~ReadyCallback} ready
  *        Callback function to call when the `HTML5` Tech is ready.
  */function Tech(options,ready){var _this;if(options===void 0){options={};}if(ready===void 0){ready=function ready(){};}// we don't want the tech to report user activity automatically.
// This is done manually in addControlsListeners
options.reportTouchActivity=false;_this=_Component.call(this,null,options,ready)||this;_this.onDurationChange_=function(e){return _this.onDurationChange(e);};_this.trackProgress_=function(e){return _this.trackProgress(e);};_this.trackCurrentTime_=function(e){return _this.trackCurrentTime(e);};_this.stopTrackingCurrentTime_=function(e){return _this.stopTrackingCurrentTime(e);};_this.disposeSourceHandler_=function(e){return _this.disposeSourceHandler(e);};_this.queuedHanders_=new Set();// keep track of whether the current source has played at all to
// implement a very limited played()
_this.hasStarted_=false;_this.on('playing',function(){this.hasStarted_=true;});_this.on('loadstart',function(){this.hasStarted_=false;});ALL.names.forEach(function(name){var props=ALL[name];if(options&&options[props.getterName]){_this[props.privateName]=options[props.getterName];}});// Manually track progress in cases where the browser/tech doesn't report it.
if(!_this.featuresProgressEvents){_this.manualProgressOn();}// Manually track timeupdates in cases where the browser/tech doesn't report it.
if(!_this.featuresTimeupdateEvents){_this.manualTimeUpdatesOn();}['Text','Audio','Video'].forEach(function(track){if(options["native"+track+"Tracks"]===false){_this["featuresNative"+track+"Tracks"]=false;}});if(options.nativeCaptions===false||options.nativeTextTracks===false){_this.featuresNativeTextTracks=false;}else if(options.nativeCaptions===true||options.nativeTextTracks===true){_this.featuresNativeTextTracks=true;}if(!_this.featuresNativeTextTracks){_this.emulateTextTracks();}_this.preloadTextTracks=options.preloadTextTracks!==false;_this.autoRemoteTextTracks_=new ALL.text.ListClass();_this.initTrackListeners();// Turn on component tap events only if not using native controls
if(!options.nativeControlsForTouch){_this.emitTapEvents();}if(_this.constructor){_this.name_=_this.constructor.name||'Unknown Tech';}return _this;}/**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */var _proto=Tech.prototype;_proto.triggerSourceset=function triggerSourceset(src){var _this2=this;if(!this.isReady_){// on initial ready we have to trigger source set
// 1ms after ready so that player can watch for it.
this.one('ready',function(){return _this2.setTimeout(function(){return _this2.triggerSourceset(src);},1);});}/**
     * Fired when the source is set on the tech causing the media element
     * to reload.
     *
     * @see {@link Player#event:sourceset}
     * @event Tech#sourceset
     * @type {EventTarget~Event}
     */this.trigger({src:src,type:'sourceset'});}/* Fallbacks for unsupported event types
  ================================================================================ */ /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */;_proto.manualProgressOn=function manualProgressOn(){this.on('durationchange',this.onDurationChange_);this.manualProgress=true;// Trigger progress watching when a source begins loading
this.one('ready',this.trackProgress_);}/**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */;_proto.manualProgressOff=function manualProgressOff(){this.manualProgress=false;this.stopTrackingProgress();this.off('durationchange',this.onDurationChange_);}/**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {EventTarget~Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */;_proto.trackProgress=function trackProgress(event){this.stopTrackingProgress();this.progressInterval=this.setInterval(bind(this,function(){// Don't trigger unless buffered amount is greater than last time
var numBufferedPercent=this.bufferedPercent();if(this.bufferedPercent_!==numBufferedPercent){/**
         * See {@link Player#progress}
         *
         * @event Tech#progress
         * @type {EventTarget~Event}
         */this.trigger('progress');}this.bufferedPercent_=numBufferedPercent;if(numBufferedPercent===1){this.stopTrackingProgress();}}),500);}/**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {EventTarget~Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */;_proto.onDurationChange=function onDurationChange(event){this.duration_=this.duration();}/**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return {TimeRange}
   *         The time range object that was created.
   */;_proto.buffered=function buffered(){return createTimeRanges(0,0);}/**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */;_proto.bufferedPercent=function bufferedPercent$1(){return bufferedPercent(this.buffered(),this.duration_);}/**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */;_proto.stopTrackingProgress=function stopTrackingProgress(){this.clearInterval(this.progressInterval);}/**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */;_proto.manualTimeUpdatesOn=function manualTimeUpdatesOn(){this.manualTimeUpdates=true;this.on('play',this.trackCurrentTime_);this.on('pause',this.stopTrackingCurrentTime_);}/**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */;_proto.manualTimeUpdatesOff=function manualTimeUpdatesOff(){this.manualTimeUpdates=false;this.stopTrackingCurrentTime();this.off('play',this.trackCurrentTime_);this.off('pause',this.stopTrackingCurrentTime_);}/**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */;_proto.trackCurrentTime=function trackCurrentTime(){if(this.currentTimeInterval){this.stopTrackingCurrentTime();}this.currentTimeInterval=this.setInterval(function(){/**
       * Triggered at an interval of 250ms to indicated that time is passing in the video.
       *
       * @event Tech#timeupdate
       * @type {EventTarget~Event}
       */this.trigger({type:'timeupdate',target:this,manuallyTriggered:true});// 42 = 24 fps // 250 is what Webkit uses // FF uses 15
},250);}/**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */;_proto.stopTrackingCurrentTime=function stopTrackingCurrentTime(){this.clearInterval(this.currentTimeInterval);// #1002 - if the video ends right before the next timeupdate would happen,
// the progress bar won't make it all the way to the end
this.trigger({type:'timeupdate',target:this,manuallyTriggered:true});}/**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */;_proto.dispose=function dispose(){// clear out all tracks because we can't reuse them between techs
this.clearTracks(NORMAL.names);// Turn off any manual progress or timeupdate tracking
if(this.manualProgress){this.manualProgressOff();}if(this.manualTimeUpdates){this.manualTimeUpdatesOff();}_Component.prototype.dispose.call(this);}/**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */;_proto.clearTracks=function clearTracks(types){var _this3=this;types=[].concat(types);// clear out all tracks because we can't reuse them between techs
types.forEach(function(type){var list=_this3[type+"Tracks"]()||[];var i=list.length;while(i--){var track=list[i];if(type==='text'){_this3.removeRemoteTextTrack(track);}list.removeTrack(track);}});}/**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */;_proto.cleanupAutoTextTracks=function cleanupAutoTextTracks(){var list=this.autoRemoteTextTracks_||[];var i=list.length;while(i--){var track=list[i];this.removeRemoteTextTrack(track);}}/**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */;_proto.reset=function reset(){}/**
   * Get the value of `crossOrigin` from the tech.
   *
   * @abstract
   *
   * @see {Html5#crossOrigin}
   */;_proto.crossOrigin=function crossOrigin(){}/**
   * Set the value of `crossOrigin` on the tech.
   *
   * @abstract
   *
   * @param {string} crossOrigin the crossOrigin value
   * @see {Html5#setCrossOrigin}
   */;_proto.setCrossOrigin=function setCrossOrigin(){}/**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */;_proto.error=function error(err){if(err!==undefined){this.error_=new MediaError(err);this.trigger('error');}return this.error_;}/**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks whether the source has played at all or not.
   *
   * @return {TimeRange}
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */;_proto.played=function played(){if(this.hasStarted_){return createTimeRanges(0,0);}return createTimeRanges();}/**
   * Start playback
   *
   * @abstract
   *
   * @see {Html5#play}
   */;_proto.play=function play(){}/**
   * Set whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#setScrubbing}
   */;_proto.setScrubbing=function setScrubbing(){}/**
   * Get whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#scrubbing}
   */;_proto.scrubbing=function scrubbing(){}/**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @fires Tech#timeupdate
   */;_proto.setCurrentTime=function setCurrentTime(){// improve the accuracy of manual timeupdates
if(this.manualTimeUpdates){/**
       * A manual `timeupdate` event.
       *
       * @event Tech#timeupdate
       * @type {EventTarget~Event}
       */this.trigger({type:'timeupdate',target:this,manuallyTriggered:true});}}/**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */;_proto.initTrackListeners=function initTrackListeners(){var _this4=this;/**
      * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
      *
      * @event Tech#audiotrackchange
      * @type {EventTarget~Event}
      */ /**
      * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
      *
      * @event Tech#videotrackchange
      * @type {EventTarget~Event}
      */ /**
      * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
      *
      * @event Tech#texttrackchange
      * @type {EventTarget~Event}
      */NORMAL.names.forEach(function(name){var props=NORMAL[name];var trackListChanges=function trackListChanges(){_this4.trigger(name+"trackchange");};var tracks=_this4[props.getterName]();tracks.addEventListener('removetrack',trackListChanges);tracks.addEventListener('addtrack',trackListChanges);_this4.on('dispose',function(){tracks.removeEventListener('removetrack',trackListChanges);tracks.removeEventListener('addtrack',trackListChanges);});});}/**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */;_proto.addWebVttScript_=function addWebVttScript_(){var _this5=this;if((window_default()).WebVTT){return;}// Initially, Tech.el_ is a child of a dummy-div wait until the Component system
// signals that the Tech is ready at which point Tech.el_ is part of the DOM
// before inserting the WebVTT script
if(document_default().body.contains(this.el())){// load via require if available and vtt.js script location was not passed in
// as an option. novtt builds will turn the above require call into an empty object
// which will cause this if check to always fail.
if(!this.options_['vtt.js']&&isPlain((browser_index_default()))&&Object.keys((browser_index_default())).length>0){this.trigger('vttjsloaded');return;}// load vtt.js via the script location option or the cdn of no location was
// passed in
var script=document_default().createElement('script');script.src=this.options_['vtt.js']||'https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js';script.onload=function(){/**
         * Fired when vtt.js is loaded.
         *
         * @event Tech#vttjsloaded
         * @type {EventTarget~Event}
         */_this5.trigger('vttjsloaded');};script.onerror=function(){/**
         * Fired when vtt.js was not loaded due to an error
         *
         * @event Tech#vttjsloaded
         * @type {EventTarget~Event}
         */_this5.trigger('vttjserror');};this.on('dispose',function(){script.onload=null;script.onerror=null;});// but have not loaded yet and we set it to true before the inject so that
// we don't overwrite the injected window.WebVTT if it loads right away
(window_default()).WebVTT=true;this.el().parentNode.appendChild(script);}else{this.ready(this.addWebVttScript_);}}/**
   * Emulate texttracks
   *
   */;_proto.emulateTextTracks=function emulateTextTracks(){var _this6=this;var tracks=this.textTracks();var remoteTracks=this.remoteTextTracks();var handleAddTrack=function handleAddTrack(e){return tracks.addTrack(e.track);};var handleRemoveTrack=function handleRemoveTrack(e){return tracks.removeTrack(e.track);};remoteTracks.on('addtrack',handleAddTrack);remoteTracks.on('removetrack',handleRemoveTrack);this.addWebVttScript_();var updateDisplay=function updateDisplay(){return _this6.trigger('texttrackchange');};var textTracksChanges=function textTracksChanges(){updateDisplay();for(var i=0;i<tracks.length;i++){var track=tracks[i];track.removeEventListener('cuechange',updateDisplay);if(track.mode==='showing'){track.addEventListener('cuechange',updateDisplay);}}};textTracksChanges();tracks.addEventListener('change',textTracksChanges);tracks.addEventListener('addtrack',textTracksChanges);tracks.addEventListener('removetrack',textTracksChanges);this.on('dispose',function(){remoteTracks.off('addtrack',handleAddTrack);remoteTracks.off('removetrack',handleRemoveTrack);tracks.removeEventListener('change',textTracksChanges);tracks.removeEventListener('addtrack',textTracksChanges);tracks.removeEventListener('removetrack',textTracksChanges);for(var i=0;i<tracks.length;i++){var track=tracks[i];track.removeEventListener('cuechange',updateDisplay);}});}/**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */;_proto.addTextTrack=function addTextTrack(kind,label,language){if(!kind){throw new Error('TextTrack kind is required but was not provided');}return createTrackHelper(this,kind,label,language);}/**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */;_proto.createRemoteTextTrack=function createRemoteTextTrack(options){var track=mergeOptions$3(options,{tech:this});return new REMOTE.remoteTextEl.TrackClass(track);}/**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=true]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   * @deprecated The default functionality for this function will be equivalent
   *             to "manualCleanup=false" in the future. The manualCleanup parameter will
   *             also be removed.
   */;_proto.addRemoteTextTrack=function addRemoteTextTrack(options,manualCleanup){var _this7=this;if(options===void 0){options={};}var htmlTrackElement=this.createRemoteTextTrack(options);if(manualCleanup!==true&&manualCleanup!==false){// deprecation warning
log$1.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js');manualCleanup=true;}// store HTMLTrackElement and TextTrack to remote list
this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);this.remoteTextTracks().addTrack(htmlTrackElement.track);if(manualCleanup!==true){// create the TextTrackList if it doesn't exist
this.ready(function(){return _this7.autoRemoteTextTracks_.addTrack(htmlTrackElement.track);});}return htmlTrackElement;}/**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */;_proto.removeRemoteTextTrack=function removeRemoteTextTrack(track){var trackElement=this.remoteTextTrackEls().getTrackElementByTrack_(track);// remove HTMLTrackElement and TextTrack from remote list
this.remoteTextTrackEls().removeTrackElement_(trackElement);this.remoteTextTracks().removeTrack(track);this.autoRemoteTextTracks_.removeTrack(track);}/**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */;_proto.getVideoPlaybackQuality=function getVideoPlaybackQuality(){return{};}/**
   * Attempt to create a floating video window always on top of other windows
   * so that users may continue consuming media while they interact with other
   * content sites, or applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise|undefined}
   *         A promise with a Picture-in-Picture window if the browser supports
   *         Promises (or one was passed in as an option). It returns undefined
   *         otherwise.
   *
   * @abstract
   */;_proto.requestPictureInPicture=function requestPictureInPicture(){var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){return PromiseClass.reject();}}/**
   * A method to check for the value of the 'disablePictureInPicture' <video> property.
   * Defaults to true, as it should be considered disabled if the tech does not support pip
   *
   * @abstract
   */;_proto.disablePictureInPicture=function disablePictureInPicture(){return true;}/**
   * A method to set or unset the 'disablePictureInPicture' <video> property.
   *
   * @abstract
   */;_proto.setDisablePictureInPicture=function setDisablePictureInPicture(){}/**
   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
   *
   * @param {function} cb
   * @return {number} request id
   */;_proto.requestVideoFrameCallback=function requestVideoFrameCallback(cb){var _this8=this;var id=newGUID();if(!this.isReady_||this.paused()){this.queuedHanders_.add(id);this.one('playing',function(){if(_this8.queuedHanders_.has(id)){_this8.queuedHanders_["delete"](id);cb();}});}else{this.requestNamedAnimationFrame(id,cb);}return id;}/**
   * A fallback implementation of cancelVideoFrameCallback
   *
   * @param {number} id id of callback to be cancelled
   */;_proto.cancelVideoFrameCallback=function cancelVideoFrameCallback(id){if(this.queuedHanders_.has(id)){this.queuedHanders_["delete"](id);}else{this.cancelNamedAnimationFrame(id);}}/**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */;_proto.setPoster=function setPoster(){}/**
   * A method to check for the presence of the 'playsinline' <video> attribute.
   *
   * @abstract
   */;_proto.playsinline=function playsinline(){}/**
   * A method to set or unset the 'playsinline' <video> attribute.
   *
   * @abstract
   */;_proto.setPlaysinline=function setPlaysinline(){}/**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   *
   * @abstract
   */;_proto.overrideNativeAudioTracks=function overrideNativeAudioTracks(){}/**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   *
   * @abstract
   */;_proto.overrideNativeVideoTracks=function overrideNativeVideoTracks(){}/*
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */;_proto.canPlayType=function canPlayType(){return'';}/**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */;Tech.canPlayType=function canPlayType(){return'';}/**
   * Check if the tech can support the given source
   *
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */;Tech.canPlaySource=function canPlaySource(srcObj,options){return Tech.canPlayType(srcObj.type);}/*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */;Tech.isTech=function isTech(component){return component.prototype instanceof Tech||component instanceof Tech||component===Tech;}/**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */;Tech.registerTech=function registerTech(name,tech){if(!Tech.techs_){Tech.techs_={};}if(!Tech.isTech(tech)){throw new Error("Tech "+name+" must be a Tech");}if(!Tech.canPlayType){throw new Error('Techs must have a static canPlayType method on them');}if(!Tech.canPlaySource){throw new Error('Techs must have a static canPlaySource method on them');}name=toTitleCase$1(name);Tech.techs_[name]=tech;Tech.techs_[toLowerCase(name)]=tech;if(name!=='Tech'){// camel case the techName for use in techOrder
Tech.defaultTechOrder_.push(name);}return tech;}/**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requested.
   */;Tech.getTech=function getTech(name){if(!name){return;}if(Tech.techs_&&Tech.techs_[name]){return Tech.techs_[name];}name=toTitleCase$1(name);if((window_default())&&(window_default()).videojs&&(window_default()).videojs[name]){log$1.warn("The "+name+" tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)");return (window_default()).videojs[name];}};return Tech;}(Component$1);/**
 * Get the {@link VideoTrackList}
 *
 * @returns {VideoTrackList}
 * @method Tech.prototype.videoTracks
 */ /**
 * Get the {@link AudioTrackList}
 *
 * @returns {AudioTrackList}
 * @method Tech.prototype.audioTracks
 */ /**
 * Get the {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.textTracks
 */ /**
 * Get the remote element {@link TextTrackList}
 *
 * @returns {TextTrackList}
 * @method Tech.prototype.remoteTextTracks
 */ /**
 * Get the remote element {@link HtmlTrackElementList}
 *
 * @returns {HtmlTrackElementList}
 * @method Tech.prototype.remoteTextTrackEls
 */ALL.names.forEach(function(name){var props=ALL[name];Tech.prototype[props.getterName]=function(){this[props.privateName]=this[props.privateName]||new props.ListClass();return this[props.privateName];};});/**
 * List of associated text tracks
 *
 * @type {TextTrackList}
 * @private
 * @property Tech#textTracks_
 */ /**
 * List of associated audio tracks.
 *
 * @type {AudioTrackList}
 * @private
 * @property Tech#audioTracks_
 */ /**
 * List of associated video tracks.
 *
 * @type {VideoTrackList}
 * @private
 * @property Tech#videoTracks_
 */ /**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresVolumeControl=true;/**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {bolean}
 * @default
 */Tech.prototype.featuresMuteControl=true;/**
 * Boolean indicating whether the `Tech` supports fullscreen resize control.
 * Resizing plugins using request fullscreen reloads the plugin
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresFullscreenResize=false;/**
 * Boolean indicating whether the `Tech` supports changing the speed at which the video
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresPlaybackRate=false;/**
 * Boolean indicating whether the `Tech` supports the `progress` event. This is currently
 * not triggered by video-js-swf. This will be used to determine if
 * {@link Tech#manualProgressOn} should be called.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresProgressEvents=false;/**
 * Boolean indicating whether the `Tech` supports the `sourceset` event.
 *
 * A tech should set this to `true` and then use {@link Tech#triggerSourceset}
 * to trigger a {@link Tech#event:sourceset} at the earliest time after getting
 * a new source.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresSourceset=false;/**
 * Boolean indicating whether the `Tech` supports the `timeupdate` event. This is currently
 * not triggered by video-js-swf. This will be used to determine if
 * {@link Tech#manualTimeUpdates} should be called.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresTimeupdateEvents=false;/**
 * Boolean indicating whether the `Tech` supports the native `TextTrack`s.
 * This will help us integrate with native `TextTrack`s if the browser supports them.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresNativeTextTracks=false;/**
 * Boolean indicating whether the `Tech` supports `requestVideoFrameCallback`.
 *
 * @type {boolean}
 * @default
 */Tech.prototype.featuresVideoFrameCallback=false;/**
 * A functional mixin for techs that want to use the Source Handler pattern.
 * Source handlers are scripts for handling specific formats.
 * The source handler pattern is used for adaptive formats (HLS, DASH) that
 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
 * Example: `Tech.withSourceHandlers.call(MyTech);`
 *
 * @param {Tech} _Tech
 *        The tech to add source handler functions to.
 *
 * @mixes Tech~SourceHandlerAdditions
 */Tech.withSourceHandlers=function(_Tech){/**
   * Register a source handler
   *
   * @param {Function} handler
   *        The source handler class
   *
   * @param {number} [index]
   *        Register it at the following index
   */_Tech.registerSourceHandler=function(handler,index){var handlers=_Tech.sourceHandlers;if(!handlers){handlers=_Tech.sourceHandlers=[];}if(index===undefined){// add to the end of the list
index=handlers.length;}handlers.splice(index,0,handler);};/**
   * Check if the tech can support the given type. Also checks the
   * Techs sourceHandlers.
   *
   * @param {string} type
   *         The mimetype to check.
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */_Tech.canPlayType=function(type){var handlers=_Tech.sourceHandlers||[];var can;for(var i=0;i<handlers.length;i++){can=handlers[i].canPlayType(type);if(can){return can;}}return'';};/**
   * Returns the first source handler that supports the source.
   *
   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
   *
   * @param {Tech~SourceObject} source
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {SourceHandler|null}
   *          The first source handler that supports the source or null if
   *          no SourceHandler supports the source
   */_Tech.selectSourceHandler=function(source,options){var handlers=_Tech.sourceHandlers||[];var can;for(var i=0;i<handlers.length;i++){can=handlers[i].canHandleSource(source,options);if(can){return handlers[i];}}return null;};/**
   * Check if the tech can support the given source.
   *
   * @param {Tech~SourceObject} srcObj
   *        The source object
   *
   * @param {Object} options
   *        The options passed to the tech
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */_Tech.canPlaySource=function(srcObj,options){var sh=_Tech.selectSourceHandler(srcObj,options);if(sh){return sh.canHandleSource(srcObj,options);}return'';};/**
   * When using a source handler, prefer its implementation of
   * any function normally provided by the tech.
   */var deferrable=['seekable','seeking','duration'];/**
   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
   * function if it exists, with a fallback to the Techs seekable function.
   *
   * @method _Tech.seekable
   */ /**
   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
   * function if it exists, otherwise it will fallback to the techs duration function.
   *
   * @method _Tech.duration
   */deferrable.forEach(function(fnName){var originalFn=this[fnName];if(typeof originalFn!=='function'){return;}this[fnName]=function(){if(this.sourceHandler_&&this.sourceHandler_[fnName]){return this.sourceHandler_[fnName].apply(this.sourceHandler_,arguments);}return originalFn.apply(this,arguments);};},_Tech.prototype);/**
   * Create a function for setting the source using a source object
   * and source handlers.
   * Should never be called unless a source handler was found.
   *
   * @param {Tech~SourceObject} source
   *        A source object with src and type keys
   */_Tech.prototype.setSource=function(source){var sh=_Tech.selectSourceHandler(source,this.options_);if(!sh){// Fall back to a native source hander when unsupported sources are
// deliberately set
if(_Tech.nativeSourceHandler){sh=_Tech.nativeSourceHandler;}else{log$1.error('No source handler found for the current source.');}}// Dispose any existing source handler
this.disposeSourceHandler();this.off('dispose',this.disposeSourceHandler_);if(sh!==_Tech.nativeSourceHandler){this.currentSource_=source;}this.sourceHandler_=sh.handleSource(source,this,this.options_);this.one('dispose',this.disposeSourceHandler_);};/**
   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
   *
   * @listens Tech#dispose
   */_Tech.prototype.disposeSourceHandler=function(){// if we have a source and get another one
// then we are loading something new
// than clear all of our current tracks
if(this.currentSource_){this.clearTracks(['audio','video']);this.currentSource_=null;}// always clean up auto-text tracks
this.cleanupAutoTextTracks();if(this.sourceHandler_){if(this.sourceHandler_.dispose){this.sourceHandler_.dispose();}this.sourceHandler_=null;}};};// The base Tech class needs to be registered as a Component. It is the only
// Tech that can be registered as a Component.
Component$1.registerComponent('Tech',Tech);Tech.registerTech('Tech',Tech);/**
 * A list of techs that should be added to techOrder on Players
 *
 * @private
 */Tech.defaultTechOrder_=[];/**
 * @file middleware.js
 * @module middleware
 */var middlewares={};var middlewareInstances={};var TERMINATOR={};/**
 * A middleware object is a plain JavaScript object that has methods that
 * match the {@link Tech} methods found in the lists of allowed
 * {@link module:middleware.allowedGetters|getters},
 * {@link module:middleware.allowedSetters|setters}, and
 * {@link module:middleware.allowedMediators|mediators}.
 *
 * @typedef {Object} MiddlewareObject
 */ /**
 * A middleware factory function that should return a
 * {@link module:middleware~MiddlewareObject|MiddlewareObject}.
 *
 * This factory will be called for each player when needed, with the player
 * passed in as an argument.
 *
 * @callback MiddlewareFactory
 * @param {Player} player
 *        A Video.js player.
 */ /**
 * Define a middleware that the player should use by way of a factory function
 * that returns a middleware object.
 *
 * @param  {string} type
 *         The MIME type to match or `"*"` for all MIME types.
 *
 * @param  {MiddlewareFactory} middleware
 *         A middleware factory function that will be executed for
 *         matching types.
 */function use(type,middleware){middlewares[type]=middlewares[type]||[];middlewares[type].push(middleware);}/**
 * Asynchronously sets a source using middleware by recursing through any
 * matching middlewares and calling `setSource` on each, passing along the
 * previous returned value each time.
 *
 * @param  {Player} player
 *         A {@link Player} instance.
 *
 * @param  {Tech~SourceObject} src
 *         A source object.
 *
 * @param  {Function}
 *         The next middleware to run.
 */function setSource(player,src,next){player.setTimeout(function(){return setSourceHelper(src,middlewares[src.type],next,player);},1);}/**
 * When the tech is set, passes the tech to each middleware's `setTech` method.
 *
 * @param {Object[]} middleware
 *        An array of middleware instances.
 *
 * @param {Tech} tech
 *        A Video.js tech.
 */function setTech(middleware,tech){middleware.forEach(function(mw){return mw.setTech&&mw.setTech(tech);});}/**
 * Calls a getter on the tech first, through each middleware
 * from right to left to the player.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @return {Mixed}
 *         The final value from the tech after middleware has intercepted it.
 */function get(middleware,tech,method){return middleware.reduceRight(middlewareIterator(method),tech[method]());}/**
 * Takes the argument given to the player and calls the setter method on each
 * middleware from left to right to the tech.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @param  {Mixed} arg
 *         The value to set on the tech.
 *
 * @return {Mixed}
 *         The return value of the `method` of the `tech`.
 */function set(middleware,tech,method,arg){return tech[method](middleware.reduce(middlewareIterator(method),arg));}/**
 * Takes the argument given to the player and calls the `call` version of the
 * method on each middleware from left to right.
 *
 * Then, call the passed in method on the tech and return the result unchanged
 * back to the player, through middleware, this time from right to left.
 *
 * @param  {Object[]} middleware
 *         An array of middleware instances.
 *
 * @param  {Tech} tech
 *         The current tech.
 *
 * @param  {string} method
 *         A method name.
 *
 * @param  {Mixed} arg
 *         The value to set on the tech.
 *
 * @return {Mixed}
 *         The return value of the `method` of the `tech`, regardless of the
 *         return values of middlewares.
 */function mediate(middleware,tech,method,arg){if(arg===void 0){arg=null;}var callMethod='call'+toTitleCase$1(method);var middlewareValue=middleware.reduce(middlewareIterator(callMethod),arg);var terminated=middlewareValue===TERMINATOR;// deprecated. The `null` return value should instead return TERMINATOR to
// prevent confusion if a techs method actually returns null.
var returnValue=terminated?null:tech[method](middlewareValue);executeRight(middleware,method,returnValue,terminated);return returnValue;}/**
 * Enumeration of allowed getters where the keys are method names.
 *
 * @type {Object}
 */var allowedGetters={buffered:1,currentTime:1,duration:1,muted:1,played:1,paused:1,seekable:1,volume:1,ended:1};/**
 * Enumeration of allowed setters where the keys are method names.
 *
 * @type {Object}
 */var allowedSetters={setCurrentTime:1,setMuted:1,setVolume:1};/**
 * Enumeration of allowed mediators where the keys are method names.
 *
 * @type {Object}
 */var allowedMediators={play:1,pause:1};function middlewareIterator(method){return function(value,mw){// if the previous middleware terminated, pass along the termination
if(value===TERMINATOR){return TERMINATOR;}if(mw[method]){return mw[method](value);}return value;};}function executeRight(mws,method,value,terminated){for(var i=mws.length-1;i>=0;i--){var mw=mws[i];if(mw[method]){mw[method](terminated,value);}}}/**
 * Clear the middleware cache for a player.
 *
 * @param  {Player} player
 *         A {@link Player} instance.
 */function clearCacheForPlayer(player){middlewareInstances[player.id()]=null;}/**
 * {
 *  [playerId]: [[mwFactory, mwInstance], ...]
 * }
 *
 * @private
 */function getOrCreateFactory(player,mwFactory){var mws=middlewareInstances[player.id()];var mw=null;if(mws===undefined||mws===null){mw=mwFactory(player);middlewareInstances[player.id()]=[[mwFactory,mw]];return mw;}for(var i=0;i<mws.length;i++){var _mws$i=mws[i],mwf=_mws$i[0],mwi=_mws$i[1];if(mwf!==mwFactory){continue;}mw=mwi;}if(mw===null){mw=mwFactory(player);mws.push([mwFactory,mw]);}return mw;}function setSourceHelper(src,middleware,next,player,acc,lastRun){if(src===void 0){src={};}if(middleware===void 0){middleware=[];}if(acc===void 0){acc=[];}if(lastRun===void 0){lastRun=false;}var _middleware=middleware,mwFactory=_middleware[0],mwrest=_middleware.slice(1);// if mwFactory is a string, then we're at a fork in the road
if(typeof mwFactory==='string'){setSourceHelper(src,middlewares[mwFactory],next,player,acc,lastRun);// if we have an mwFactory, call it with the player to get the mw,
// then call the mw's setSource method
}else if(mwFactory){var mw=getOrCreateFactory(player,mwFactory);// if setSource isn't present, implicitly select this middleware
if(!mw.setSource){acc.push(mw);return setSourceHelper(src,mwrest,next,player,acc,lastRun);}mw.setSource(video_es_assign({},src),function(err,_src){// something happened, try the next middleware on the current level
// make sure to use the old src
if(err){return setSourceHelper(src,mwrest,next,player,acc,lastRun);}// we've succeeded, now we need to go deeper
acc.push(mw);// if it's the same type, continue down the current chain
// otherwise, we want to go down the new chain
setSourceHelper(_src,src.type===_src.type?mwrest:middlewares[_src.type],next,player,acc,lastRun);});}else if(mwrest.length){setSourceHelper(src,mwrest,next,player,acc,lastRun);}else if(lastRun){next(src,acc);}else{setSourceHelper(src,middlewares['*'],next,player,acc,true);}}/**
 * Mimetypes
 *
 * @see https://www.iana.org/assignments/media-types/media-types.xhtml
 * @typedef Mimetypes~Kind
 * @enum
 */var MimetypesKind={opus:'video/ogg',ogv:'video/ogg',mp4:'video/mp4',mov:'video/mp4',m4v:'video/mp4',mkv:'video/x-matroska',m4a:'audio/mp4',mp3:'audio/mpeg',aac:'audio/aac',caf:'audio/x-caf',flac:'audio/flac',oga:'audio/ogg',wav:'audio/wav',m3u8:'application/x-mpegURL',mpd:'application/dash+xml',jpg:'image/jpeg',jpeg:'image/jpeg',gif:'image/gif',png:'image/png',svg:'image/svg+xml',webp:'image/webp'};/**
 * Get the mimetype of a given src url if possible
 *
 * @param {string} src
 *        The url to the src
 *
 * @return {string}
 *         return the mimetype if it was known or empty string otherwise
 */var getMimetype=function getMimetype(src){if(src===void 0){src='';}var ext=getFileExtension(src);var mimetype=MimetypesKind[ext.toLowerCase()];return mimetype||'';};/**
 * Find the mime type of a given source string if possible. Uses the player
 * source cache.
 *
 * @param {Player} player
 *        The player object
 *
 * @param {string} src
 *        The source string
 *
 * @return {string}
 *         The type that was found
 */var findMimetype=function findMimetype(player,src){if(!src){return'';}// 1. check for the type in the `source` cache
if(player.cache_.source.src===src&&player.cache_.source.type){return player.cache_.source.type;}// 2. see if we have this source in our `currentSources` cache
var matchingSources=player.cache_.sources.filter(function(s){return s.src===src;});if(matchingSources.length){return matchingSources[0].type;}// 3. look for the src url in source elements and use the type there
var sources=player.$$('source');for(var i=0;i<sources.length;i++){var s=sources[i];if(s.type&&s.src&&s.src===src){return s.type;}}// 4. finally fallback to our list of mime types based on src url extension
return getMimetype(src);};/**
 * @module filter-source
 */ /**
 * Filter out single bad source objects or multiple source objects in an
 * array. Also flattens nested source object arrays into a 1 dimensional
 * array of source objects.
 *
 * @param {Tech~SourceObject|Tech~SourceObject[]} src
 *        The src object to filter
 *
 * @return {Tech~SourceObject[]}
 *         An array of sourceobjects containing only valid sources
 *
 * @private
 */var filterSource=function filterSource(src){// traverse array
if(Array.isArray(src)){var newsrc=[];src.forEach(function(srcobj){srcobj=filterSource(srcobj);if(Array.isArray(srcobj)){newsrc=newsrc.concat(srcobj);}else if(video_es_isObject(srcobj)){newsrc.push(srcobj);}});src=newsrc;}else if(typeof src==='string'&&src.trim()){// convert string into object
src=[fixSource({src:src})];}else if(video_es_isObject(src)&&typeof src.src==='string'&&src.src&&src.src.trim()){// src is already valid
src=[fixSource(src)];}else{// invalid source, turn it into an empty array
src=[];}return src;};/**
 * Checks src mimetype, adding it when possible
 *
 * @param {Tech~SourceObject} src
 *        The src object to check
 * @return {Tech~SourceObject}
 *        src Object with known type
 */function fixSource(src){if(!src.type){var mimetype=getMimetype(src.src);if(mimetype){src.type=mimetype;}}return src;}/**
 * The `MediaLoader` is the `Component` that decides which playback technology to load
 * when a player is initialized.
 *
 * @extends Component
 */var MediaLoader=/*#__PURE__*/function(_Component){_inheritsLoose(MediaLoader,_Component);/**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function that is run when this component is ready.
   */function MediaLoader(player,options,ready){var _this;// MediaLoader has no element
var options_=mergeOptions$3({createEl:false},options);_this=_Component.call(this,player,options_,ready)||this;// If there are no sources when the player is initialized,
// load the first supported playback technology.
if(!options.playerOptions.sources||options.playerOptions.sources.length===0){for(var i=0,j=options.playerOptions.techOrder;i<j.length;i++){var techName=toTitleCase$1(j[i]);var tech=Tech.getTech(techName);// Support old behavior of techs being registered as components.
// Remove once that deprecated behavior is removed.
if(!techName){tech=Component$1.getComponent(techName);}// Check if the browser supports this technology
if(tech&&tech.isSupported()){player.loadTech_(techName);break;}}}else{// Loop through playback technologies (e.g. HTML5) and check for support.
// Then load the best source.
// A few assumptions here:
//   All playback technologies respect preload false.
player.src(options.playerOptions.sources);}return _this;}return MediaLoader;}(Component$1);Component$1.registerComponent('MediaLoader',MediaLoader);/**
 * Component which is clickable or keyboard actionable, but is not a
 * native HTML button.
 *
 * @extends Component
 */var ClickableComponent=/*#__PURE__*/function(_Component){_inheritsLoose(ClickableComponent,_Component);/**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of component options.
   *
   * @param  {function} [options.clickHandler]
   *         The function to call when the button is clicked / activated
   *
   * @param  {string} [options.controlText]
   *         The text to set on the button
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   */function ClickableComponent(player,options){var _this;_this=_Component.call(this,player,options)||this;if(_this.options_.controlText){_this.controlText(_this.options_.controlText);}_this.handleMouseOver_=function(e){return _this.handleMouseOver(e);};_this.handleMouseOut_=function(e){return _this.handleMouseOut(e);};_this.handleClick_=function(e){return _this.handleClick(e);};_this.handleKeyDown_=function(e){return _this.handleKeyDown(e);};_this.emitTapEvents();_this.enable();return _this;}/**
   * Create the `ClickableComponent`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */var _proto=ClickableComponent.prototype;_proto.createEl=function createEl$1(tag,props,attributes){if(tag===void 0){tag='div';}if(props===void 0){props={};}if(attributes===void 0){attributes={};}props=video_es_assign({className:this.buildCSSClass(),tabIndex:0},props);if(tag==='button'){log$1.error("Creating a ClickableComponent with an HTML element of "+tag+" is not supported; use a Button instead.");}// Add ARIA attributes for clickable element which is not a native HTML button
attributes=video_es_assign({role:'button'},attributes);this.tabIndex_=props.tabIndex;var el=createEl(tag,props,attributes);el.appendChild(createEl('span',{className:'vjs-icon-placeholder'},{'aria-hidden':true}));this.createControlTextEl(el);return el;};_proto.dispose=function dispose(){// remove controlTextEl_ on dispose
this.controlTextEl_=null;_Component.prototype.dispose.call(this);}/**
   * Create a control text element on this `ClickableComponent`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */;_proto.createControlTextEl=function createControlTextEl(el){this.controlTextEl_=createEl('span',{className:'vjs-control-text'},{// let the screen reader user know that the text of the element may change
'aria-live':'polite'});if(el){el.appendChild(this.controlTextEl_);}this.controlText(this.controlText_,el);return this.controlTextEl_;}/**
   * Get or set the localize text to use for the controls on the `ClickableComponent`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */;_proto.controlText=function controlText(text,el){if(el===void 0){el=this.el();}if(text===undefined){return this.controlText_||'Need Text';}var localizedText=this.localize(text);this.controlText_=text;textContent(this.controlTextEl_,localizedText);if(!this.nonIconControl&&!this.player_.options_.noUITitleAttributes){// Set title attribute if only an icon is shown
el.setAttribute('title',localizedText);}}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */;_proto.buildCSSClass=function buildCSSClass(){return"vjs-control vjs-button "+_Component.prototype.buildCSSClass.call(this);}/**
   * Enable this `ClickableComponent`
   */;_proto.enable=function enable(){if(!this.enabled_){this.enabled_=true;this.removeClass('vjs-disabled');this.el_.setAttribute('aria-disabled','false');if(typeof this.tabIndex_!=='undefined'){this.el_.setAttribute('tabIndex',this.tabIndex_);}this.on(['tap','click'],this.handleClick_);this.on('keydown',this.handleKeyDown_);}}/**
   * Disable this `ClickableComponent`
   */;_proto.disable=function disable(){this.enabled_=false;this.addClass('vjs-disabled');this.el_.setAttribute('aria-disabled','true');if(typeof this.tabIndex_!=='undefined'){this.el_.removeAttribute('tabIndex');}this.off('mouseover',this.handleMouseOver_);this.off('mouseout',this.handleMouseOut_);this.off(['tap','click'],this.handleClick_);this.off('keydown',this.handleKeyDown_);}/**
   * Handles language change in ClickableComponent for the player in components
   *
   *
   */;_proto.handleLanguagechange=function handleLanguagechange(){this.controlText(this.controlText_);}/**
   * Event handler that is called when a `ClickableComponent` receives a
   * `click` or `tap` event.
   *
   * @param {EventTarget~Event} event
   *        The `tap` or `click` event that caused this function to be called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */;_proto.handleClick=function handleClick(event){if(this.options_.clickHandler){this.options_.clickHandler.call(this,arguments);}}/**
   * Event handler that is called when a `ClickableComponent` receives a
   * `keydown` event.
   *
   * By default, if the key is Space or Enter, it will trigger a `click` event.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Support Space or Enter key operation to fire a click event. Also,
// prevent the event from propagating through the DOM and triggering
// Player hotkeys.
if(keycode_default().isEventKey(event,'Space')||keycode_default().isEventKey(event,'Enter')){event.preventDefault();event.stopPropagation();this.trigger('click');}else{// Pass keypress handling up for unsupported keys
_Component.prototype.handleKeyDown.call(this,event);}};return ClickableComponent;}(Component$1);Component$1.registerComponent('ClickableComponent',ClickableComponent);/**
 * A `ClickableComponent` that handles showing the poster image for the player.
 *
 * @extends ClickableComponent
 */var PosterImage=/*#__PURE__*/function(_ClickableComponent){_inheritsLoose(PosterImage,_ClickableComponent);/**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function PosterImage(player,options){var _this;_this=_ClickableComponent.call(this,player,options)||this;_this.update();_this.update_=function(e){return _this.update(e);};player.on('posterchange',_this.update_);return _this;}/**
   * Clean up and dispose of the `PosterImage`.
   */var _proto=PosterImage.prototype;_proto.dispose=function dispose(){this.player().off('posterchange',this.update_);_ClickableComponent.prototype.dispose.call(this);}/**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */;_proto.createEl=function createEl$1(){var el=createEl('div',{className:'vjs-poster',// Don't want poster to be tabbable.
tabIndex:-1});return el;}/**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {EventTarget~Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */;_proto.update=function update(event){var url=this.player().poster();this.setSrc(url);// If there's no poster source we should display:none on this component
// so it's not still clickable or right-clickable
if(url){this.show();}else{this.hide();}}/**
   * Set the source of the `PosterImage` depending on the display method.
   *
   * @param {string} url
   *        The URL to the source for the `PosterImage`.
   */;_proto.setSrc=function setSrc(url){var backgroundImage='';// Any falsy value should stay as an empty string, otherwise
// this will throw an extra error
if(url){backgroundImage="url(\""+url+"\")";}this.el_.style.backgroundImage=backgroundImage;}/**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {EventTarget~Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */;_proto.handleClick=function handleClick(event){// We don't want a click to trigger playback when controls are disabled
if(!this.player_.controls()){return;}var sourceIsEncrypted=this.player_.usingPlugin('eme')&&this.player_.eme.sessions&&this.player_.eme.sessions.length>0;if(this.player_.tech(true)&&// We've observed a bug in IE and Edge when playing back DRM content where
// calling .focus() on the video element causes the video to go black,
// so we avoid it in that specific case
!((IE_VERSION||IS_EDGE)&&sourceIsEncrypted)){this.player_.tech(true).focus();}if(this.player_.paused()){silencePromise(this.player_.play());}else{this.player_.pause();}};return PosterImage;}(ClickableComponent);Component$1.registerComponent('PosterImage',PosterImage);var darkGray='#222';var lightGray='#ccc';var fontMap={monospace:'monospace',sansSerif:'sans-serif',serif:'serif',monospaceSansSerif:'"Andale Mono", "Lucida Console", monospace',monospaceSerif:'"Courier New", monospace',proportionalSansSerif:'sans-serif',proportionalSerif:'serif',casual:'"Comic Sans MS", Impact, fantasy',script:'"Monotype Corsiva", cursive',smallcaps:'"Andale Mono", "Lucida Console", monospace, sans-serif'};/**
 * Construct an rgba color from a given hex color code.
 *
 * @param {number} color
 *        Hex number for color, like #f0e or #f604e2.
 *
 * @param {number} opacity
 *        Value for opacity, 0.0 - 1.0.
 *
 * @return {string}
 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
 */function constructColor(color,opacity){var hex;if(color.length===4){// color looks like "#f0e"
hex=color[1]+color[1]+color[2]+color[2]+color[3]+color[3];}else if(color.length===7){// color looks like "#f604e2"
hex=color.slice(1);}else{throw new Error('Invalid color code provided, '+color+'; must be formatted as e.g. #f0e or #f604e2.');}return'rgba('+parseInt(hex.slice(0,2),16)+','+parseInt(hex.slice(2,4),16)+','+parseInt(hex.slice(4,6),16)+','+opacity+')';}/**
 * Try to update the style of a DOM element. Some style changes will throw an error,
 * particularly in IE8. Those should be noops.
 *
 * @param {Element} el
 *        The DOM element to be styled.
 *
 * @param {string} style
 *        The CSS property on the element that should be styled.
 *
 * @param {string} rule
 *        The style rule that should be applied to the property.
 *
 * @private
 */function tryUpdateStyle(el,style,rule){try{el.style[style]=rule;}catch(e){// Satisfies linter.
return;}}/**
 * The component for displaying text track cues.
 *
 * @extends Component
 */var TextTrackDisplay=/*#__PURE__*/function(_Component){_inheritsLoose(TextTrackDisplay,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */function TextTrackDisplay(player,options,ready){var _this;_this=_Component.call(this,player,options,ready)||this;var updateDisplayHandler=function updateDisplayHandler(e){return _this.updateDisplay(e);};player.on('loadstart',function(e){return _this.toggleDisplay(e);});player.on('texttrackchange',updateDisplayHandler);player.on('loadedmetadata',function(e){return _this.preselectTrack(e);});// This used to be called during player init, but was causing an error
// if a track should show by default and the display hadn't loaded yet.
// Should probably be moved to an external track loader when we support
// tracks that don't need a display.
player.ready(bind(_assertThisInitialized(_this),function(){if(player.tech_&&player.tech_.featuresNativeTextTracks){this.hide();return;}player.on('fullscreenchange',updateDisplayHandler);player.on('playerresize',updateDisplayHandler);window_default().addEventListener('orientationchange',updateDisplayHandler);player.on('dispose',function(){return window_default().removeEventListener('orientationchange',updateDisplayHandler);});var tracks=this.options_.playerOptions.tracks||[];for(var i=0;i<tracks.length;i++){this.player_.addRemoteTextTrack(tracks[i],true);}this.preselectTrack();}));return _this;}/**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */var _proto=TextTrackDisplay.prototype;_proto.preselectTrack=function preselectTrack(){var modes={captions:1,subtitles:1};var trackList=this.player_.textTracks();var userPref=this.player_.cache_.selectedLanguage;var firstDesc;var firstCaptions;var preferredTrack;for(var i=0;i<trackList.length;i++){var track=trackList[i];if(userPref&&userPref.enabled&&userPref.language&&userPref.language===track.language&&track.kind in modes){// Always choose the track that matches both language and kind
if(track.kind===userPref.kind){preferredTrack=track;// or choose the first track that matches language
}else if(!preferredTrack){preferredTrack=track;}// clear everything if offTextTrackMenuItem was clicked
}else if(userPref&&!userPref.enabled){preferredTrack=null;firstDesc=null;firstCaptions=null;}else if(track["default"]){if(track.kind==='descriptions'&&!firstDesc){firstDesc=track;}else if(track.kind in modes&&!firstCaptions){firstCaptions=track;}}}// The preferredTrack matches the user preference and takes
// precedence over all the other tracks.
// So, display the preferredTrack before the first default track
// and the subtitles/captions track before the descriptions track
if(preferredTrack){preferredTrack.mode='showing';}else if(firstCaptions){firstCaptions.mode='showing';}else if(firstDesc){firstDesc.mode='showing';}}/**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */;_proto.toggleDisplay=function toggleDisplay(){if(this.player_.tech_&&this.player_.tech_.featuresNativeTextTracks){this.hide();}else{this.show();}}/**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-text-track-display'},{'translate':'yes','aria-live':'off','aria-atomic':'true'});}/**
   * Clear all displayed {@link TextTrack}s.
   */;_proto.clearDisplay=function clearDisplay(){if(typeof (window_default()).WebVTT==='function'){window_default().WebVTT.processCues((window_default()),[],this.el_);}}/**
   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
   * a {@link Player#fullscreenchange} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   */;_proto.updateDisplay=function updateDisplay(){var tracks=this.player_.textTracks();var allowMultipleShowingTracks=this.options_.allowMultipleShowingTracks;this.clearDisplay();if(allowMultipleShowingTracks){var showingTracks=[];for(var _i=0;_i<tracks.length;++_i){var track=tracks[_i];if(track.mode!=='showing'){continue;}showingTracks.push(track);}this.updateForTrack(showingTracks);return;}//  Track display prioritization model: if multiple tracks are 'showing',
//  display the first 'subtitles' or 'captions' track which is 'showing',
//  otherwise display the first 'descriptions' track which is 'showing'
var descriptionsTrack=null;var captionsSubtitlesTrack=null;var i=tracks.length;while(i--){var _track=tracks[i];if(_track.mode==='showing'){if(_track.kind==='descriptions'){descriptionsTrack=_track;}else{captionsSubtitlesTrack=_track;}}}if(captionsSubtitlesTrack){if(this.getAttribute('aria-live')!=='off'){this.setAttribute('aria-live','off');}this.updateForTrack(captionsSubtitlesTrack);}else if(descriptionsTrack){if(this.getAttribute('aria-live')!=='assertive'){this.setAttribute('aria-live','assertive');}this.updateForTrack(descriptionsTrack);}}/**
   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
   *
   * @param {TextTrack} track
   *        Text track object containing active cues to style.
   */;_proto.updateDisplayState=function updateDisplayState(track){var overrides=this.player_.textTrackSettings.getValues();var cues=track.activeCues;var i=cues.length;while(i--){var cue=cues[i];if(!cue){continue;}var cueDiv=cue.displayState;if(overrides.color){cueDiv.firstChild.style.color=overrides.color;}if(overrides.textOpacity){tryUpdateStyle(cueDiv.firstChild,'color',constructColor(overrides.color||'#fff',overrides.textOpacity));}if(overrides.backgroundColor){cueDiv.firstChild.style.backgroundColor=overrides.backgroundColor;}if(overrides.backgroundOpacity){tryUpdateStyle(cueDiv.firstChild,'backgroundColor',constructColor(overrides.backgroundColor||'#000',overrides.backgroundOpacity));}if(overrides.windowColor){if(overrides.windowOpacity){tryUpdateStyle(cueDiv,'backgroundColor',constructColor(overrides.windowColor,overrides.windowOpacity));}else{cueDiv.style.backgroundColor=overrides.windowColor;}}if(overrides.edgeStyle){if(overrides.edgeStyle==='dropshadow'){cueDiv.firstChild.style.textShadow="2px 2px 3px "+darkGray+", 2px 2px 4px "+darkGray+", 2px 2px 5px "+darkGray;}else if(overrides.edgeStyle==='raised'){cueDiv.firstChild.style.textShadow="1px 1px "+darkGray+", 2px 2px "+darkGray+", 3px 3px "+darkGray;}else if(overrides.edgeStyle==='depressed'){cueDiv.firstChild.style.textShadow="1px 1px "+lightGray+", 0 1px "+lightGray+", -1px -1px "+darkGray+", 0 -1px "+darkGray;}else if(overrides.edgeStyle==='uniform'){cueDiv.firstChild.style.textShadow="0 0 4px "+darkGray+", 0 0 4px "+darkGray+", 0 0 4px "+darkGray+", 0 0 4px "+darkGray;}}if(overrides.fontPercent&&overrides.fontPercent!==1){var fontSize=window_default().parseFloat(cueDiv.style.fontSize);cueDiv.style.fontSize=fontSize*overrides.fontPercent+'px';cueDiv.style.height='auto';cueDiv.style.top='auto';}if(overrides.fontFamily&&overrides.fontFamily!=='default'){if(overrides.fontFamily==='small-caps'){cueDiv.firstChild.style.fontVariant='small-caps';}else{cueDiv.firstChild.style.fontFamily=fontMap[overrides.fontFamily];}}}}/**
   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack|TextTrack[]} tracks
   *        Text track object or text track array to be added to the list.
   */;_proto.updateForTrack=function updateForTrack(tracks){if(!Array.isArray(tracks)){tracks=[tracks];}if(typeof (window_default()).WebVTT!=='function'||tracks.every(function(track){return!track.activeCues;})){return;}var cues=[];// push all active track cues
for(var i=0;i<tracks.length;++i){var track=tracks[i];for(var j=0;j<track.activeCues.length;++j){cues.push(track.activeCues[j]);}}// removes all cues before it processes new ones
window_default().WebVTT.processCues((window_default()),cues,this.el_);// add unique class to each language text track & add settings styling if necessary
for(var _i2=0;_i2<tracks.length;++_i2){var _track2=tracks[_i2];for(var _j=0;_j<_track2.activeCues.length;++_j){var cueEl=_track2.activeCues[_j].displayState;addClass(cueEl,'vjs-text-track-cue');addClass(cueEl,'vjs-text-track-cue-'+(_track2.language?_track2.language:_i2));if(_track2.language){setAttribute(cueEl,'lang',_track2.language);}}if(this.player_.textTrackSettings){this.updateDisplayState(_track2);}}};return TextTrackDisplay;}(Component$1);Component$1.registerComponent('TextTrackDisplay',TextTrackDisplay);/**
 * A loading spinner for use during waiting/loading events.
 *
 * @extends Component
 */var LoadingSpinner=/*#__PURE__*/function(_Component){_inheritsLoose(LoadingSpinner,_Component);function LoadingSpinner(){return _Component.apply(this,arguments)||this;}var _proto=LoadingSpinner.prototype;/**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */_proto.createEl=function createEl$1(){var isAudio=this.player_.isAudio();var playerType=this.localize(isAudio?'Audio Player':'Video Player');var controlText=createEl('span',{className:'vjs-control-text',textContent:this.localize('{1} is loading.',[playerType])});var el=_Component.prototype.createEl.call(this,'div',{className:'vjs-loading-spinner',dir:'ltr'});el.appendChild(controlText);return el;};return LoadingSpinner;}(Component$1);Component$1.registerComponent('LoadingSpinner',LoadingSpinner);/**
 * Base class for all buttons.
 *
 * @extends ClickableComponent
 */var Button=/*#__PURE__*/function(_ClickableComponent){_inheritsLoose(Button,_ClickableComponent);function Button(){return _ClickableComponent.apply(this,arguments)||this;}var _proto=Button.prototype;/**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */_proto.createEl=function createEl$1(tag,props,attributes){if(props===void 0){props={};}if(attributes===void 0){attributes={};}tag='button';props=video_es_assign({className:this.buildCSSClass()},props);// Add attributes for button element
attributes=video_es_assign({// Necessary since the default button type is "submit"
type:'button'},attributes);var el=createEl(tag,props,attributes);el.appendChild(createEl('span',{className:'vjs-icon-placeholder'},{'aria-hidden':true}));this.createControlTextEl(el);return el;}/**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */;_proto.addChild=function addChild(child,options){if(options===void 0){options={};}var className=this.constructor.name;log$1.warn("Adding an actionable (user controllable) child to a Button ("+className+") is not supported; use a ClickableComponent instead.");// Avoid the error message generated by ClickableComponent's addChild method
return Component$1.prototype.addChild.call(this,child,options);}/**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */;_proto.enable=function enable(){_ClickableComponent.prototype.enable.call(this);this.el_.removeAttribute('disabled');}/**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */;_proto.disable=function disable(){_ClickableComponent.prototype.disable.call(this);this.el_.setAttribute('disabled','disabled');}/**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Ignore Space or Enter key operation, which is handled by the browser for
// a button - though not for its super class, ClickableComponent. Also,
// prevent the event from propagating through the DOM and triggering Player
// hotkeys. We do not preventDefault here because we _want_ the browser to
// handle it.
if(keycode_default().isEventKey(event,'Space')||keycode_default().isEventKey(event,'Enter')){event.stopPropagation();return;}// Pass keypress handling up for unsupported keys
_ClickableComponent.prototype.handleKeyDown.call(this,event);};return Button;}(ClickableComponent);Component$1.registerComponent('Button',Button);/**
 * The initial play button that shows before the video has played. The hiding of the
 * `BigPlayButton` get done via CSS and `Player` states.
 *
 * @extends Button
 */var BigPlayButton=/*#__PURE__*/function(_Button){_inheritsLoose(BigPlayButton,_Button);function BigPlayButton(player,options){var _this;_this=_Button.call(this,player,options)||this;_this.mouseused_=false;_this.on('mousedown',function(e){return _this.handleMouseDown(e);});return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */var _proto=BigPlayButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return'vjs-big-play-button';}/**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){var playPromise=this.player_.play();// exit early if clicked via the mouse
if(this.mouseused_&&event.clientX&&event.clientY){var sourceIsEncrypted=this.player_.usingPlugin('eme')&&this.player_.eme.sessions&&this.player_.eme.sessions.length>0;silencePromise(playPromise);if(this.player_.tech(true)&&// We've observed a bug in IE and Edge when playing back DRM content where
// calling .focus() on the video element causes the video to go black,
// so we avoid it in that specific case
!((IE_VERSION||IS_EDGE)&&sourceIsEncrypted)){this.player_.tech(true).focus();}return;}var cb=this.player_.getChild('controlBar');var playToggle=cb&&cb.getChild('playToggle');if(!playToggle){this.player_.tech(true).focus();return;}var playFocus=function playFocus(){return playToggle.focus();};if(isPromise(playPromise)){playPromise.then(playFocus,function(){});}else{this.setTimeout(playFocus,1);}};_proto.handleKeyDown=function handleKeyDown(event){this.mouseused_=false;_Button.prototype.handleKeyDown.call(this,event);};_proto.handleMouseDown=function handleMouseDown(event){this.mouseused_=true;};return BigPlayButton;}(Button);/**
 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 */BigPlayButton.prototype.controlText_='Play Video';Component$1.registerComponent('BigPlayButton',BigPlayButton);/**
 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
 * it gets clicked.
 *
 * @extends Button
 */var CloseButton=/*#__PURE__*/function(_Button){_inheritsLoose(CloseButton,_Button);/**
  * Creates an instance of the this class.
  *
  * @param  {Player} player
  *         The `Player` that this class should be attached to.
  *
  * @param  {Object} [options]
  *         The key/value store of player options.
  */function CloseButton(player,options){var _this;_this=_Button.call(this,player,options)||this;_this.controlText(options&&options.controlText||_this.localize('Close'));return _this;}/**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */var _proto=CloseButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-close-button "+_Button.prototype.buildCSSClass.call(this);}/**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when
   * this will be triggered
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */;_proto.handleClick=function handleClick(event){/**
     * Triggered when the a `CloseButton` is clicked.
     *
     * @event CloseButton#close
     * @type {EventTarget~Event}
     *
     * @property {boolean} [bubbles=false]
     *           set to false so that the close event does not
     *           bubble up to parents if there is no listener
     */this.trigger({type:'close',bubbles:false});}/**
   * Event handler that is called when a `CloseButton` receives a
   * `keydown` event.
   *
   * By default, if the key is Esc, it will trigger a `click` event.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Esc button will trigger `click` event
if(keycode_default().isEventKey(event,'Esc')){event.preventDefault();event.stopPropagation();this.trigger('click');}else{// Pass keypress handling up for unsupported keys
_Button.prototype.handleKeyDown.call(this,event);}};return CloseButton;}(Button);Component$1.registerComponent('CloseButton',CloseButton);/**
 * Button to toggle between play and pause.
 *
 * @extends Button
 */var PlayToggle=/*#__PURE__*/function(_Button){_inheritsLoose(PlayToggle,_Button);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function PlayToggle(player,options){var _this;if(options===void 0){options={};}_this=_Button.call(this,player,options)||this;// show or hide replay icon
options.replay=options.replay===undefined||options.replay;_this.on(player,'play',function(e){return _this.handlePlay(e);});_this.on(player,'pause',function(e){return _this.handlePause(e);});if(options.replay){_this.on(player,'ended',function(e){return _this.handleEnded(e);});}return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=PlayToggle.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-play-control "+_Button.prototype.buildCSSClass.call(this);}/**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){if(this.player_.paused()){silencePromise(this.player_.play());}else{this.player_.pause();}}/**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */;_proto.handleSeeked=function handleSeeked(event){this.removeClass('vjs-ended');if(this.player_.paused()){this.handlePause(event);}else{this.handlePlay(event);}}/**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */;_proto.handlePlay=function handlePlay(event){this.removeClass('vjs-ended');this.removeClass('vjs-paused');this.addClass('vjs-playing');// change the button text to "Pause"
this.controlText('Pause');}/**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */;_proto.handlePause=function handlePause(event){this.removeClass('vjs-playing');this.addClass('vjs-paused');// change the button text to "Play"
this.controlText('Play');}/**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */;_proto.handleEnded=function handleEnded(event){var _this2=this;this.removeClass('vjs-playing');this.addClass('vjs-ended');// change the button text to "Replay"
this.controlText('Replay');// on the next seek remove the replay button
this.one(this.player_,'seeked',function(e){return _this2.handleSeeked(e);});};return PlayToggle;}(Button);/**
 * The text that should display over the `PlayToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */PlayToggle.prototype.controlText_='Play';Component$1.registerComponent('PlayToggle',PlayToggle);/**
 * @file format-time.js
 * @module format-time
 */ /**
 * Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in
 * seconds) will force a number of leading zeros to cover the length of the
 * guide.
 *
 * @private
 * @param  {number} seconds
 *         Number of seconds to be turned into a string
 *
 * @param  {number} guide
 *         Number (in seconds) to model the string after
 *
 * @return {string}
 *         Time formatted as H:MM:SS or M:SS
 */var defaultImplementation=function defaultImplementation(seconds,guide){seconds=seconds<0?0:seconds;var s=Math.floor(seconds%60);var m=Math.floor(seconds/60%60);var h=Math.floor(seconds/3600);var gm=Math.floor(guide/60%60);var gh=Math.floor(guide/3600);// handle invalid times
if(isNaN(seconds)||seconds===Infinity){// '-' is false for all relational operators (e.g. <, >=) so this setting
// will add the minimum number of fields specified by the guide
h=m=s='-';}// Check if we need to show hours
h=h>0||gh>0?h+':':'';// If hours are showing, we may need to add a leading zero.
// Always show at least one digit of minutes.
m=((h||gm>=10)&&m<10?'0'+m:m)+':';// Check if leading zero is need for seconds
s=s<10?'0'+s:s;return h+m+s;};// Internal pointer to the current implementation.
var implementation=defaultImplementation;/**
 * Replaces the default formatTime implementation with a custom implementation.
 *
 * @param {Function} customImplementation
 *        A function which will be used in place of the default formatTime
 *        implementation. Will receive the current time in seconds and the
 *        guide (in seconds) as arguments.
 */function setFormatTime(customImplementation){implementation=customImplementation;}/**
 * Resets formatTime to the default implementation.
 */function resetFormatTime(){implementation=defaultImplementation;}/**
 * Delegates to either the default time formatting function or a custom
 * function supplied via `setFormatTime`.
 *
 * Formats seconds as a time string (H:MM:SS or M:SS). Supplying a
 * guide (in seconds) will force a number of leading zeros to cover the
 * length of the guide.
 *
 * @static
 * @example  formatTime(125, 600) === "02:05"
 * @param    {number} seconds
 *           Number of seconds to be turned into a string
 *
 * @param    {number} guide
 *           Number (in seconds) to model the string after
 *
 * @return   {string}
 *           Time formatted as H:MM:SS or M:SS
 */function formatTime(seconds,guide){if(guide===void 0){guide=seconds;}return implementation(seconds,guide);}/**
 * Displays time information about the video
 *
 * @extends Component
 */var TimeDisplay=/*#__PURE__*/function(_Component){_inheritsLoose(TimeDisplay,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function TimeDisplay(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.on(player,['timeupdate','ended'],function(e){return _this.updateContent(e);});_this.updateTextNode_();return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=TimeDisplay.prototype;_proto.createEl=function createEl$1(){var className=this.buildCSSClass();var el=_Component.prototype.createEl.call(this,'div',{className:className+" vjs-time-control vjs-control"});var span=createEl('span',{className:'vjs-control-text',textContent:this.localize(this.labelText_)+"\xA0"},{role:'presentation'});el.appendChild(span);this.contentEl_=createEl('span',{className:className+"-display"},{// tell screen readers not to automatically read the time as it changes
'aria-live':'off',// span elements have no implicit role, but some screen readers (notably VoiceOver)
// treat them as a break between items in the DOM when using arrow keys
// (or left-to-right swipes on iOS) to read contents of a page. Using
// role='presentation' causes VoiceOver to NOT treat this span as a break.
'role':'presentation'});el.appendChild(this.contentEl_);return el;};_proto.dispose=function dispose(){this.contentEl_=null;this.textNode_=null;_Component.prototype.dispose.call(this);}/**
   * Updates the time display text node with a new time
   *
   * @param {number} [time=0] the time to update to
   *
   * @private
   */;_proto.updateTextNode_=function updateTextNode_(time){var _this2=this;if(time===void 0){time=0;}time=formatTime(time);if(this.formattedTime_===time){return;}this.formattedTime_=time;this.requestNamedAnimationFrame('TimeDisplay#updateTextNode_',function(){if(!_this2.contentEl_){return;}var oldNode=_this2.textNode_;if(oldNode&&_this2.contentEl_.firstChild!==oldNode){oldNode=null;log$1.warn('TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.');}_this2.textNode_=document_default().createTextNode(_this2.formattedTime_);if(!_this2.textNode_){return;}if(oldNode){_this2.contentEl_.replaceChild(_this2.textNode_,oldNode);}else{_this2.contentEl_.appendChild(_this2.textNode_);}});}/**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */;_proto.updateContent=function updateContent(event){};return TimeDisplay;}(Component$1);/**
 * The text that is added to the `TimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */TimeDisplay.prototype.labelText_='Time';/**
 * The text that should display over the `TimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */TimeDisplay.prototype.controlText_='Time';Component$1.registerComponent('TimeDisplay',TimeDisplay);/**
 * Displays the current time
 *
 * @extends Component
 */var CurrentTimeDisplay=/*#__PURE__*/function(_TimeDisplay){_inheritsLoose(CurrentTimeDisplay,_TimeDisplay);function CurrentTimeDisplay(){return _TimeDisplay.apply(this,arguments)||this;}var _proto=CurrentTimeDisplay.prototype;/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */_proto.buildCSSClass=function buildCSSClass(){return'vjs-current-time';}/**
   * Update current time display
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */;_proto.updateContent=function updateContent(event){// Allows for smooth scrubbing, when player can't keep up.
var time;if(this.player_.ended()){time=this.player_.duration();}else{time=this.player_.scrubbing()?this.player_.getCache().currentTime:this.player_.currentTime();}this.updateTextNode_(time);};return CurrentTimeDisplay;}(TimeDisplay);/**
 * The text that is added to the `CurrentTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */CurrentTimeDisplay.prototype.labelText_='Current Time';/**
 * The text that should display over the `CurrentTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */CurrentTimeDisplay.prototype.controlText_='Current Time';Component$1.registerComponent('CurrentTimeDisplay',CurrentTimeDisplay);/**
 * Displays the duration
 *
 * @extends Component
 */var DurationDisplay=/*#__PURE__*/function(_TimeDisplay){_inheritsLoose(DurationDisplay,_TimeDisplay);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function DurationDisplay(player,options){var _this;_this=_TimeDisplay.call(this,player,options)||this;var updateContent=function updateContent(e){return _this.updateContent(e);};// we do not want to/need to throttle duration changes,
// as they should always display the changed duration as
// it has changed
_this.on(player,'durationchange',updateContent);// Listen to loadstart because the player duration is reset when a new media element is loaded,
// but the durationchange on the user agent will not fire.
// @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
_this.on(player,'loadstart',updateContent);// Also listen for timeupdate (in the parent) and loadedmetadata because removing those
// listeners could have broken dependent applications/libraries. These
// can likely be removed for 7.0.
_this.on(player,'loadedmetadata',updateContent);return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=DurationDisplay.prototype;_proto.buildCSSClass=function buildCSSClass(){return'vjs-duration';}/**
   * Update duration time display.
   *
   * @param {EventTarget~Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */;_proto.updateContent=function updateContent(event){var duration=this.player_.duration();this.updateTextNode_(duration);};return DurationDisplay;}(TimeDisplay);/**
 * The text that is added to the `DurationDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */DurationDisplay.prototype.labelText_='Duration';/**
 * The text that should display over the `DurationDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */DurationDisplay.prototype.controlText_='Duration';Component$1.registerComponent('DurationDisplay',DurationDisplay);/**
 * The separator between the current time and duration.
 * Can be hidden if it's not needed in the design.
 *
 * @extends Component
 */var TimeDivider=/*#__PURE__*/function(_Component){_inheritsLoose(TimeDivider,_Component);function TimeDivider(){return _Component.apply(this,arguments)||this;}var _proto=TimeDivider.prototype;/**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */_proto.createEl=function createEl(){var el=_Component.prototype.createEl.call(this,'div',{className:'vjs-time-control vjs-time-divider'},{// this element and its contents can be hidden from assistive techs since
// it is made extraneous by the announcement of the control text
// for the current time and duration displays
'aria-hidden':true});var div=_Component.prototype.createEl.call(this,'div');var span=_Component.prototype.createEl.call(this,'span',{textContent:'/'});div.appendChild(span);el.appendChild(div);return el;};return TimeDivider;}(Component$1);Component$1.registerComponent('TimeDivider',TimeDivider);/**
 * Displays the time left in the video
 *
 * @extends Component
 */var RemainingTimeDisplay=/*#__PURE__*/function(_TimeDisplay){_inheritsLoose(RemainingTimeDisplay,_TimeDisplay);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function RemainingTimeDisplay(player,options){var _this;_this=_TimeDisplay.call(this,player,options)||this;_this.on(player,'durationchange',function(e){return _this.updateContent(e);});return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=RemainingTimeDisplay.prototype;_proto.buildCSSClass=function buildCSSClass(){return'vjs-remaining-time';}/**
   * Create the `Component`'s DOM element with the "minus" characted prepend to the time
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl$1(){var el=_TimeDisplay.prototype.createEl.call(this);if(this.options_.displayNegative!==false){el.insertBefore(createEl('span',{},{'aria-hidden':true},'-'),this.contentEl_);}return el;}/**
   * Update remaining time display.
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */;_proto.updateContent=function updateContent(event){if(typeof this.player_.duration()!=='number'){return;}var time;// @deprecated We should only use remainingTimeDisplay
// as of video.js 7
if(this.player_.ended()){time=0;}else if(this.player_.remainingTimeDisplay){time=this.player_.remainingTimeDisplay();}else{time=this.player_.remainingTime();}this.updateTextNode_(time);};return RemainingTimeDisplay;}(TimeDisplay);/**
 * The text that is added to the `RemainingTimeDisplay` for screen reader users.
 *
 * @type {string}
 * @private
 */RemainingTimeDisplay.prototype.labelText_='Remaining Time';/**
 * The text that should display over the `RemainingTimeDisplay`s controls. Added to for localization.
 *
 * @type {string}
 * @private
 *
 * @deprecated in v7; controlText_ is not used in non-active display Components
 */RemainingTimeDisplay.prototype.controlText_='Remaining Time';Component$1.registerComponent('RemainingTimeDisplay',RemainingTimeDisplay);/**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */var LiveDisplay=/*#__PURE__*/function(_Component){_inheritsLoose(LiveDisplay,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function LiveDisplay(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.updateShowing();_this.on(_this.player(),'durationchange',function(e){return _this.updateShowing(e);});return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=LiveDisplay.prototype;_proto.createEl=function createEl$1(){var el=_Component.prototype.createEl.call(this,'div',{className:'vjs-live-control vjs-control'});this.contentEl_=createEl('div',{className:'vjs-live-display'},{'aria-live':'off'});this.contentEl_.appendChild(createEl('span',{className:'vjs-control-text',textContent:this.localize('Stream Type')+"\xA0"}));this.contentEl_.appendChild(document_default().createTextNode(this.localize('LIVE')));el.appendChild(this.contentEl_);return el;};_proto.dispose=function dispose(){this.contentEl_=null;_Component.prototype.dispose.call(this);}/**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */;_proto.updateShowing=function updateShowing(event){if(this.player().duration()===Infinity){this.show();}else{this.hide();}};return LiveDisplay;}(Component$1);Component$1.registerComponent('LiveDisplay',LiveDisplay);/**
 * Displays the live indicator when duration is Infinity.
 *
 * @extends Component
 */var SeekToLive=/*#__PURE__*/function(_Button){_inheritsLoose(SeekToLive,_Button);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function SeekToLive(player,options){var _this;_this=_Button.call(this,player,options)||this;_this.updateLiveEdgeStatus();if(_this.player_.liveTracker){_this.updateLiveEdgeStatusHandler_=function(e){return _this.updateLiveEdgeStatus(e);};_this.on(_this.player_.liveTracker,'liveedgechange',_this.updateLiveEdgeStatusHandler_);}return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=SeekToLive.prototype;_proto.createEl=function createEl$1(){var el=_Button.prototype.createEl.call(this,'button',{className:'vjs-seek-to-live-control vjs-control'});this.textEl_=createEl('span',{className:'vjs-seek-to-live-text',textContent:this.localize('LIVE')},{'aria-hidden':'true'});el.appendChild(this.textEl_);return el;}/**
   * Update the state of this button if we are at the live edge
   * or not
   */;_proto.updateLiveEdgeStatus=function updateLiveEdgeStatus(){// default to live edge
if(!this.player_.liveTracker||this.player_.liveTracker.atLiveEdge()){this.setAttribute('aria-disabled',true);this.addClass('vjs-at-live-edge');this.controlText('Seek to live, currently playing live');}else{this.setAttribute('aria-disabled',false);this.removeClass('vjs-at-live-edge');this.controlText('Seek to live, currently behind live');}}/**
   * On click bring us as near to the live point as possible.
   * This requires that we wait for the next `live-seekable-change`
   * event which will happen every segment length seconds.
   */;_proto.handleClick=function handleClick(){this.player_.liveTracker.seekToLiveEdge();}/**
   * Dispose of the element and stop tracking
   */;_proto.dispose=function dispose(){if(this.player_.liveTracker){this.off(this.player_.liveTracker,'liveedgechange',this.updateLiveEdgeStatusHandler_);}this.textEl_=null;_Button.prototype.dispose.call(this);};return SeekToLive;}(Button);SeekToLive.prototype.controlText_='Seek to live, currently playing live';Component$1.registerComponent('SeekToLive',SeekToLive);/**
 * Keep a number between a min and a max value
 *
 * @param {number} number
 *        The number to clamp
 *
 * @param {number} min
 *        The minimum value
 * @param {number} max
 *        The maximum value
 *
 * @return {number}
 *         the clamped number
 */var clamp=function clamp(number,min,max){number=Number(number);return Math.min(max,Math.max(min,isNaN(number)?min:number));};/**
 * The base functionality for a slider. Can be vertical or horizontal.
 * For instance the volume bar or the seek bar on a video is a slider.
 *
 * @extends Component
 */var Slider=/*#__PURE__*/function(_Component){_inheritsLoose(Slider,_Component);/**
  * Create an instance of this class
  *
  * @param {Player} player
  *        The `Player` that this class should be attached to.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  */function Slider(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.handleMouseDown_=function(e){return _this.handleMouseDown(e);};_this.handleMouseUp_=function(e){return _this.handleMouseUp(e);};_this.handleKeyDown_=function(e){return _this.handleKeyDown(e);};_this.handleClick_=function(e){return _this.handleClick(e);};_this.handleMouseMove_=function(e){return _this.handleMouseMove(e);};_this.update_=function(e){return _this.update(e);};// Set property names to bar to match with the child Slider class is looking for
_this.bar=_this.getChild(_this.options_.barName);// Set a horizontal or vertical class on the slider depending on the slider type
_this.vertical(!!_this.options_.vertical);_this.enable();return _this;}/**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */var _proto=Slider.prototype;_proto.enabled=function enabled(){return this.enabled_;}/**
   * Enable controls for this slider if they are disabled
   */;_proto.enable=function enable(){if(this.enabled()){return;}this.on('mousedown',this.handleMouseDown_);this.on('touchstart',this.handleMouseDown_);this.on('keydown',this.handleKeyDown_);this.on('click',this.handleClick_);// TODO: deprecated, controlsvisible does not seem to be fired
this.on(this.player_,'controlsvisible',this.update);if(this.playerEvent){this.on(this.player_,this.playerEvent,this.update);}this.removeClass('disabled');this.setAttribute('tabindex',0);this.enabled_=true;}/**
   * Disable controls for this slider if they are enabled
   */;_proto.disable=function disable(){if(!this.enabled()){return;}var doc=this.bar.el_.ownerDocument;this.off('mousedown',this.handleMouseDown_);this.off('touchstart',this.handleMouseDown_);this.off('keydown',this.handleKeyDown_);this.off('click',this.handleClick_);this.off(this.player_,'controlsvisible',this.update_);this.off(doc,'mousemove',this.handleMouseMove_);this.off(doc,'mouseup',this.handleMouseUp_);this.off(doc,'touchmove',this.handleMouseMove_);this.off(doc,'touchend',this.handleMouseUp_);this.removeAttribute('tabindex');this.addClass('disabled');if(this.playerEvent){this.off(this.player_,this.playerEvent,this.update);}this.enabled_=false;}/**
   * Create the `Slider`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */;_proto.createEl=function createEl(type,props,attributes){if(props===void 0){props={};}if(attributes===void 0){attributes={};}// Add the slider element class to all sub classes
props.className=props.className+' vjs-slider';props=video_es_assign({tabIndex:0},props);attributes=video_es_assign({'role':'slider','aria-valuenow':0,'aria-valuemin':0,'aria-valuemax':100,'tabIndex':0},attributes);return _Component.prototype.createEl.call(this,type,props,attributes);}/**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */;_proto.handleMouseDown=function handleMouseDown(event){var doc=this.bar.el_.ownerDocument;if(event.type==='mousedown'){event.preventDefault();}// Do not call preventDefault() on touchstart in Chrome
// to avoid console warnings. Use a 'touch-action: none' style
// instead to prevent unintented scrolling.
// https://developers.google.com/web/updates/2017/01/scrolling-intervention
if(event.type==='touchstart'&&!IS_CHROME){event.preventDefault();}blockTextSelection();this.addClass('vjs-sliding');/**
     * Triggered when the slider is in an active state
     *
     * @event Slider#slideractive
     * @type {EventTarget~Event}
     */this.trigger('slideractive');this.on(doc,'mousemove',this.handleMouseMove_);this.on(doc,'mouseup',this.handleMouseUp_);this.on(doc,'touchmove',this.handleMouseMove_);this.on(doc,'touchend',this.handleMouseUp_);this.handleMouseMove(event,true);}/**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {EventTarget~Event} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
   *
   * @listens mousemove
   * @listens touchmove
   */;_proto.handleMouseMove=function handleMouseMove(event){}/**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {EventTarget~Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */;_proto.handleMouseUp=function handleMouseUp(){var doc=this.bar.el_.ownerDocument;unblockTextSelection();this.removeClass('vjs-sliding');/**
     * Triggered when the slider is no longer in an active state.
     *
     * @event Slider#sliderinactive
     * @type {EventTarget~Event}
     */this.trigger('sliderinactive');this.off(doc,'mousemove',this.handleMouseMove_);this.off(doc,'mouseup',this.handleMouseUp_);this.off(doc,'touchmove',this.handleMouseMove_);this.off(doc,'touchend',this.handleMouseUp_);this.update();}/**
   * Update the progress bar of the `Slider`.
   *
   * @return {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */;_proto.update=function update(){var _this2=this;// In VolumeBar init we have a setTimeout for update that pops and update
// to the end of the execution stack. The player is destroyed before then
// update will cause an error
// If there's no bar...
if(!this.el_||!this.bar){return;}// clamp progress between 0 and 1
// and only round to four decimal places, as we round to two below
var progress=this.getProgress();if(progress===this.progress_){return progress;}this.progress_=progress;this.requestNamedAnimationFrame('Slider#update',function(){// Set the new bar width or height
var sizeKey=_this2.vertical()?'height':'width';// Convert to a percentage for css value
_this2.bar.el().style[sizeKey]=(progress*100).toFixed(2)+'%';});return progress;}/**
   * Get the percentage of the bar that should be filled
   * but clamped and rounded.
   *
   * @return {number}
   *         percentage filled that the slider is
   */;_proto.getProgress=function getProgress(){return Number(clamp(this.getPercent(),0,1).toFixed(4));}/**
   * Calculate distance for slider
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - position.x for vertical `Slider`s
   *         - position.y for horizontal `Slider`s
   */;_proto.calculateDistance=function calculateDistance(event){var position=getPointerPosition(this.el_,event);if(this.vertical()){return position.y;}return position.x;}/**
   * Handle a `keydown` event on the `Slider`. Watches for left, rigth, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {EventTarget~Event} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Left and Down Arrows
if(keycode_default().isEventKey(event,'Left')||keycode_default().isEventKey(event,'Down')){event.preventDefault();event.stopPropagation();this.stepBack();// Up and Right Arrows
}else if(keycode_default().isEventKey(event,'Right')||keycode_default().isEventKey(event,'Up')){event.preventDefault();event.stopPropagation();this.stepForward();}else{// Pass keydown handling up for unsupported keys
_Component.prototype.handleKeyDown.call(this,event);}}/**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */;_proto.handleClick=function handleClick(event){event.stopPropagation();event.preventDefault();}/**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */;_proto.vertical=function vertical(bool){if(bool===undefined){return this.vertical_||false;}this.vertical_=!!bool;if(this.vertical_){this.addClass('vjs-slider-vertical');}else{this.addClass('vjs-slider-horizontal');}};return Slider;}(Component$1);Component$1.registerComponent('Slider',Slider);var percentify=function percentify(time,end){return clamp(time/end*100,0,100).toFixed(2)+'%';};/**
 * Shows loading progress
 *
 * @extends Component
 */var LoadProgressBar=/*#__PURE__*/function(_Component){_inheritsLoose(LoadProgressBar,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function LoadProgressBar(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.partEls_=[];_this.on(player,'progress',function(e){return _this.update(e);});return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=LoadProgressBar.prototype;_proto.createEl=function createEl$1(){var el=_Component.prototype.createEl.call(this,'div',{className:'vjs-load-progress'});var wrapper=createEl('span',{className:'vjs-control-text'});var loadedText=createEl('span',{textContent:this.localize('Loaded')});var separator=document_default().createTextNode(': ');this.percentageEl_=createEl('span',{className:'vjs-control-text-loaded-percentage',textContent:'0%'});el.appendChild(wrapper);wrapper.appendChild(loadedText);wrapper.appendChild(separator);wrapper.appendChild(this.percentageEl_);return el;};_proto.dispose=function dispose(){this.partEls_=null;this.percentageEl_=null;_Component.prototype.dispose.call(this);}/**
   * Update progress bar
   *
   * @param {EventTarget~Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */;_proto.update=function update(event){var _this2=this;this.requestNamedAnimationFrame('LoadProgressBar#update',function(){var liveTracker=_this2.player_.liveTracker;var buffered=_this2.player_.buffered();var duration=liveTracker&&liveTracker.isLive()?liveTracker.seekableEnd():_this2.player_.duration();var bufferedEnd=_this2.player_.bufferedEnd();var children=_this2.partEls_;var percent=percentify(bufferedEnd,duration);if(_this2.percent_!==percent){// update the width of the progress bar
_this2.el_.style.width=percent;// update the control-text
textContent(_this2.percentageEl_,percent);_this2.percent_=percent;}// add child elements to represent the individual buffered time ranges
for(var i=0;i<buffered.length;i++){var start=buffered.start(i);var end=buffered.end(i);var part=children[i];if(!part){part=_this2.el_.appendChild(createEl());children[i]=part;}//  only update if changed
if(part.dataset.start===start&&part.dataset.end===end){continue;}part.dataset.start=start;part.dataset.end=end;// set the percent based on the width of the progress bar (bufferedEnd)
part.style.left=percentify(start,bufferedEnd);part.style.width=percentify(end-start,bufferedEnd);}// remove unused buffered range elements
for(var _i=children.length;_i>buffered.length;_i--){_this2.el_.removeChild(children[_i-1]);}children.length=buffered.length;});};return LoadProgressBar;}(Component$1);Component$1.registerComponent('LoadProgressBar',LoadProgressBar);/**
 * Time tooltips display a time above the progress bar.
 *
 * @extends Component
 */var TimeTooltip=/*#__PURE__*/function(_Component){_inheritsLoose(TimeTooltip,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function TimeTooltip(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.update=throttle(bind(_assertThisInitialized(_this),_this.update),UPDATE_REFRESH_INTERVAL);return _this;}/**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=TimeTooltip.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-time-tooltip'},{'aria-hidden':'true'});}/**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */;_proto.update=function update(seekBarRect,seekBarPoint,content){var tooltipRect=findPosition(this.el_);var playerRect=getBoundingClientRect(this.player_.el());var seekBarPointPx=seekBarRect.width*seekBarPoint;// do nothing if either rect isn't available
// for example, if the player isn't in the DOM for testing
if(!playerRect||!tooltipRect){return;}// This is the space left of the `seekBarPoint` available within the bounds
// of the player. We calculate any gap between the left edge of the player
// and the left edge of the `SeekBar` and add the number of pixels in the
// `SeekBar` before hitting the `seekBarPoint`
var spaceLeftOfPoint=seekBarRect.left-playerRect.left+seekBarPointPx;// This is the space right of the `seekBarPoint` available within the bounds
// of the player. We calculate the number of pixels from the `seekBarPoint`
// to the right edge of the `SeekBar` and add to that any gap between the
// right edge of the `SeekBar` and the player.
var spaceRightOfPoint=seekBarRect.width-seekBarPointPx+(playerRect.right-seekBarRect.right);// This is the number of pixels by which the tooltip will need to be pulled
// further to the right to center it over the `seekBarPoint`.
var pullTooltipBy=tooltipRect.width/2;// Adjust the `pullTooltipBy` distance to the left or right depending on
// the results of the space calculations above.
if(spaceLeftOfPoint<pullTooltipBy){pullTooltipBy+=pullTooltipBy-spaceLeftOfPoint;}else if(spaceRightOfPoint<pullTooltipBy){pullTooltipBy=spaceRightOfPoint;}// Due to the imprecision of decimal/ratio based calculations and varying
// rounding behaviors, there are cases where the spacing adjustment is off
// by a pixel or two. This adds insurance to these calculations.
if(pullTooltipBy<0){pullTooltipBy=0;}else if(pullTooltipBy>tooltipRect.width){pullTooltipBy=tooltipRect.width;}// prevent small width fluctuations within 0.4px from
// changing the value below.
// This really helps for live to prevent the play
// progress time tooltip from jittering
pullTooltipBy=Math.round(pullTooltipBy);this.el_.style.right="-"+pullTooltipBy+"px";this.write(content);}/**
   * Write the time to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted time for the tooltip.
   */;_proto.write=function write(content){textContent(this.el_,content);}/**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {number} time
   *        The time to update the tooltip to, not used during live playback
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */;_proto.updateTime=function updateTime(seekBarRect,seekBarPoint,time,cb){var _this2=this;this.requestNamedAnimationFrame('TimeTooltip#updateTime',function(){var content;var duration=_this2.player_.duration();if(_this2.player_.liveTracker&&_this2.player_.liveTracker.isLive()){var liveWindow=_this2.player_.liveTracker.liveWindow();var secondsBehind=liveWindow-seekBarPoint*liveWindow;content=(secondsBehind<1?'':'-')+formatTime(secondsBehind,liveWindow);}else{content=formatTime(time,duration);}_this2.update(seekBarRect,seekBarPoint,content);if(cb){cb();}});};return TimeTooltip;}(Component$1);Component$1.registerComponent('TimeTooltip',TimeTooltip);/**
 * Used by {@link SeekBar} to display media playback progress as part of the
 * {@link ProgressControl}.
 *
 * @extends Component
 */var PlayProgressBar=/*#__PURE__*/function(_Component){_inheritsLoose(PlayProgressBar,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function PlayProgressBar(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.update=throttle(bind(_assertThisInitialized(_this),_this.update),UPDATE_REFRESH_INTERVAL);return _this;}/**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=PlayProgressBar.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-play-progress vjs-slider-bar'},{'aria-hidden':'true'});}/**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */;_proto.update=function update(seekBarRect,seekBarPoint){var timeTooltip=this.getChild('timeTooltip');if(!timeTooltip){return;}var time=this.player_.scrubbing()?this.player_.getCache().currentTime:this.player_.currentTime();timeTooltip.updateTime(seekBarRect,seekBarPoint,time);};return PlayProgressBar;}(Component$1);/**
 * Default options for {@link PlayProgressBar}.
 *
 * @type {Object}
 * @private
 */PlayProgressBar.prototype.options_={children:[]};// Time tooltips should not be added to a player on mobile devices
if(!IS_IOS&&!IS_ANDROID){PlayProgressBar.prototype.options_.children.push('timeTooltip');}Component$1.registerComponent('PlayProgressBar',PlayProgressBar);/**
 * The {@link MouseTimeDisplay} component tracks mouse movement over the
 * {@link ProgressControl}. It displays an indicator and a {@link TimeTooltip}
 * indicating the time which is represented by a given point in the
 * {@link ProgressControl}.
 *
 * @extends Component
 */var MouseTimeDisplay=/*#__PURE__*/function(_Component){_inheritsLoose(MouseTimeDisplay,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function MouseTimeDisplay(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.update=throttle(bind(_assertThisInitialized(_this),_this.update),UPDATE_REFRESH_INTERVAL);return _this;}/**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=MouseTimeDisplay.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-mouse-display'});}/**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */;_proto.update=function update(seekBarRect,seekBarPoint){var _this2=this;var time=seekBarPoint*this.player_.duration();this.getChild('timeTooltip').updateTime(seekBarRect,seekBarPoint,time,function(){_this2.el_.style.left=seekBarRect.width*seekBarPoint+"px";});};return MouseTimeDisplay;}(Component$1);/**
 * Default options for `MouseTimeDisplay`
 *
 * @type {Object}
 * @private
 */MouseTimeDisplay.prototype.options_={children:['timeTooltip']};Component$1.registerComponent('MouseTimeDisplay',MouseTimeDisplay);var STEP_SECONDS=5;// The multiplier of STEP_SECONDS that PgUp/PgDown move the timeline.
var PAGE_KEY_MULTIPLIER=12;/**
 * Seek bar and container for the progress bars. Uses {@link PlayProgressBar}
 * as its `bar`.
 *
 * @extends Slider
 */var SeekBar=/*#__PURE__*/function(_Slider){_inheritsLoose(SeekBar,_Slider);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function SeekBar(player,options){var _this;_this=_Slider.call(this,player,options)||this;_this.setEventHandlers_();return _this;}/**
   * Sets the event handlers
   *
   * @private
   */var _proto=SeekBar.prototype;_proto.setEventHandlers_=function setEventHandlers_(){var _this2=this;this.update_=bind(this,this.update);this.update=throttle(this.update_,UPDATE_REFRESH_INTERVAL);this.on(this.player_,['ended','durationchange','timeupdate'],this.update);if(this.player_.liveTracker){this.on(this.player_.liveTracker,'liveedgechange',this.update);}// when playing, let's ensure we smoothly update the play progress bar
// via an interval
this.updateInterval=null;this.enableIntervalHandler_=function(e){return _this2.enableInterval_(e);};this.disableIntervalHandler_=function(e){return _this2.disableInterval_(e);};this.on(this.player_,['playing'],this.enableIntervalHandler_);this.on(this.player_,['ended','pause','waiting'],this.disableIntervalHandler_);// we don't need to update the play progress if the document is hidden,
// also, this causes the CPU to spike and eventually crash the page on IE11.
if('hidden'in (document_default())&&'visibilityState'in (document_default())){this.on((document_default()),'visibilitychange',this.toggleVisibility_);}};_proto.toggleVisibility_=function toggleVisibility_(e){if((document_default()).visibilityState==='hidden'){this.cancelNamedAnimationFrame('SeekBar#update');this.cancelNamedAnimationFrame('Slider#update');this.disableInterval_(e);}else{if(!this.player_.ended()&&!this.player_.paused()){this.enableInterval_();}// we just switched back to the page and someone may be looking, so, update ASAP
this.update();}};_proto.enableInterval_=function enableInterval_(){if(this.updateInterval){return;}this.updateInterval=this.setInterval(this.update,UPDATE_REFRESH_INTERVAL);};_proto.disableInterval_=function disableInterval_(e){if(this.player_.liveTracker&&this.player_.liveTracker.isLive()&&e&&e.type!=='ended'){return;}if(!this.updateInterval){return;}this.clearInterval(this.updateInterval);this.updateInterval=null;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl(){return _Slider.prototype.createEl.call(this,'div',{className:'vjs-progress-holder'},{'aria-label':this.localize('Progress Bar')});}/**
   * This function updates the play progress bar and accessibility
   * attributes to whatever is passed in.
   *
   * @param {EventTarget~Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @return {number}
   *          The current percent at a number from 0-1
   */;_proto.update=function update(event){var _this3=this;// ignore updates while the tab is hidden
if((document_default()).visibilityState==='hidden'){return;}var percent=_Slider.prototype.update.call(this);this.requestNamedAnimationFrame('SeekBar#update',function(){var currentTime=_this3.player_.ended()?_this3.player_.duration():_this3.getCurrentTime_();var liveTracker=_this3.player_.liveTracker;var duration=_this3.player_.duration();if(liveTracker&&liveTracker.isLive()){duration=_this3.player_.liveTracker.liveCurrentTime();}if(_this3.percent_!==percent){// machine readable value of progress bar (percentage complete)
_this3.el_.setAttribute('aria-valuenow',(percent*100).toFixed(2));_this3.percent_=percent;}if(_this3.currentTime_!==currentTime||_this3.duration_!==duration){// human readable value of progress bar (time complete)
_this3.el_.setAttribute('aria-valuetext',_this3.localize('progress bar timing: currentTime={1} duration={2}',[formatTime(currentTime,duration),formatTime(duration,duration)],'{1} of {2}'));_this3.currentTime_=currentTime;_this3.duration_=duration;}// update the progress bar time tooltip with the current time
if(_this3.bar){_this3.bar.update(getBoundingClientRect(_this3.el()),_this3.getProgress());}});return percent;}/**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */;_proto.userSeek_=function userSeek_(ct){if(this.player_.liveTracker&&this.player_.liveTracker.isLive()){this.player_.liveTracker.nextSeekedFromUser();}this.player_.currentTime(ct);}/**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */;_proto.getCurrentTime_=function getCurrentTime_(){return this.player_.scrubbing()?this.player_.getCache().currentTime:this.player_.currentTime();}/**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */;_proto.getPercent=function getPercent(){var currentTime=this.getCurrentTime_();var percent;var liveTracker=this.player_.liveTracker;if(liveTracker&&liveTracker.isLive()){percent=(currentTime-liveTracker.seekableStart())/liveTracker.liveWindow();// prevent the percent from changing at the live edge
if(liveTracker.atLiveEdge()){percent=1;}}else{percent=currentTime/this.player_.duration();}return percent;}/**
   * Handle mouse down on seek bar
   *
   * @param {EventTarget~Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */;_proto.handleMouseDown=function handleMouseDown(event){if(!isSingleLeftClick(event)){return;}// Stop event propagation to prevent double fire in progress-control.js
event.stopPropagation();this.videoWasPlaying=!this.player_.paused();this.player_.pause();_Slider.prototype.handleMouseDown.call(this,event);}/**
   * Handle mouse move on seek bar
   *
   * @param {EventTarget~Event} event
   *        The `mousemove` event that caused this to run.
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
   *
   * @listens mousemove
   */;_proto.handleMouseMove=function handleMouseMove(event,mouseDown){if(mouseDown===void 0){mouseDown=false;}if(!isSingleLeftClick(event)){return;}if(!mouseDown&&!this.player_.scrubbing()){this.player_.scrubbing(true);}var newTime;var distance=this.calculateDistance(event);var liveTracker=this.player_.liveTracker;if(!liveTracker||!liveTracker.isLive()){newTime=distance*this.player_.duration();// Don't let video end while scrubbing.
if(newTime===this.player_.duration()){newTime=newTime-0.1;}}else{if(distance>=0.99){liveTracker.seekToLiveEdge();return;}var seekableStart=liveTracker.seekableStart();var seekableEnd=liveTracker.liveCurrentTime();newTime=seekableStart+distance*liveTracker.liveWindow();// Don't let video end while scrubbing.
if(newTime>=seekableEnd){newTime=seekableEnd;}// Compensate for precision differences so that currentTime is not less
// than seekable start
if(newTime<=seekableStart){newTime=seekableStart+0.1;}// On android seekableEnd can be Infinity sometimes,
// this will cause newTime to be Infinity, which is
// not a valid currentTime.
if(newTime===Infinity){return;}}// Set new time (tell player to seek to new time)
this.userSeek_(newTime);};_proto.enable=function enable(){_Slider.prototype.enable.call(this);var mouseTimeDisplay=this.getChild('mouseTimeDisplay');if(!mouseTimeDisplay){return;}mouseTimeDisplay.show();};_proto.disable=function disable(){_Slider.prototype.disable.call(this);var mouseTimeDisplay=this.getChild('mouseTimeDisplay');if(!mouseTimeDisplay){return;}mouseTimeDisplay.hide();}/**
   * Handle mouse up on seek bar
   *
   * @param {EventTarget~Event} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */;_proto.handleMouseUp=function handleMouseUp(event){_Slider.prototype.handleMouseUp.call(this,event);// Stop event propagation to prevent double fire in progress-control.js
if(event){event.stopPropagation();}this.player_.scrubbing(false);/**
     * Trigger timeupdate because we're done seeking and the time has changed.
     * This is particularly useful for if the player is paused to time the time displays.
     *
     * @event Tech#timeupdate
     * @type {EventTarget~Event}
     */this.player_.trigger({type:'timeupdate',target:this,manuallyTriggered:true});if(this.videoWasPlaying){silencePromise(this.player_.play());}else{// We're done seeking and the time has changed.
// If the player is paused, make sure we display the correct time on the seek bar.
this.update_();}}/**
   * Move more quickly fast forward for keyboard-only users
   */;_proto.stepForward=function stepForward(){this.userSeek_(this.player_.currentTime()+STEP_SECONDS);}/**
   * Move more quickly rewind for keyboard-only users
   */;_proto.stepBack=function stepBack(){this.userSeek_(this.player_.currentTime()-STEP_SECONDS);}/**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called
   *
   */;_proto.handleAction=function handleAction(event){if(this.player_.paused()){this.player_.play();}else{this.player_.pause();}}/**
   * Called when this SeekBar has focus and a key gets pressed down.
   * Supports the following keys:
   *
   *   Space or Enter key fire a click event
   *   Home key moves to start of the timeline
   *   End key moves to end of the timeline
   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
   *   PageDown key moves back a larger step than ArrowDown
   *   PageUp key moves forward a large step
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){var liveTracker=this.player_.liveTracker;if(keycode_default().isEventKey(event,'Space')||keycode_default().isEventKey(event,'Enter')){event.preventDefault();event.stopPropagation();this.handleAction(event);}else if(keycode_default().isEventKey(event,'Home')){event.preventDefault();event.stopPropagation();this.userSeek_(0);}else if(keycode_default().isEventKey(event,'End')){event.preventDefault();event.stopPropagation();if(liveTracker&&liveTracker.isLive()){this.userSeek_(liveTracker.liveCurrentTime());}else{this.userSeek_(this.player_.duration());}}else if(/^[0-9]$/.test(keycode_default()(event))){event.preventDefault();event.stopPropagation();var gotoFraction=((keycode_default()).codes[keycode_default()(event)]-(keycode_default()).codes[0])*10.0/100.0;if(liveTracker&&liveTracker.isLive()){this.userSeek_(liveTracker.seekableStart()+liveTracker.liveWindow()*gotoFraction);}else{this.userSeek_(this.player_.duration()*gotoFraction);}}else if(keycode_default().isEventKey(event,'PgDn')){event.preventDefault();event.stopPropagation();this.userSeek_(this.player_.currentTime()-STEP_SECONDS*PAGE_KEY_MULTIPLIER);}else if(keycode_default().isEventKey(event,'PgUp')){event.preventDefault();event.stopPropagation();this.userSeek_(this.player_.currentTime()+STEP_SECONDS*PAGE_KEY_MULTIPLIER);}else{// Pass keydown handling up for unsupported keys
_Slider.prototype.handleKeyDown.call(this,event);}};_proto.dispose=function dispose(){this.disableInterval_();this.off(this.player_,['ended','durationchange','timeupdate'],this.update);if(this.player_.liveTracker){this.off(this.player_.liveTracker,'liveedgechange',this.update);}this.off(this.player_,['playing'],this.enableIntervalHandler_);this.off(this.player_,['ended','pause','waiting'],this.disableIntervalHandler_);// we don't need to update the play progress if the document is hidden,
// also, this causes the CPU to spike and eventually crash the page on IE11.
if('hidden'in (document_default())&&'visibilityState'in (document_default())){this.off((document_default()),'visibilitychange',this.toggleVisibility_);}_Slider.prototype.dispose.call(this);};return SeekBar;}(Slider);/**
 * Default options for the `SeekBar`
 *
 * @type {Object}
 * @private
 */SeekBar.prototype.options_={children:['loadProgressBar','playProgressBar'],barName:'playProgressBar'};// MouseTimeDisplay tooltips should not be added to a player on mobile devices
if(!IS_IOS&&!IS_ANDROID){SeekBar.prototype.options_.children.splice(1,0,'mouseTimeDisplay');}Component$1.registerComponent('SeekBar',SeekBar);/**
 * The Progress Control component contains the seek bar, load progress,
 * and play progress.
 *
 * @extends Component
 */var ProgressControl=/*#__PURE__*/function(_Component){_inheritsLoose(ProgressControl,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function ProgressControl(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.handleMouseMove=throttle(bind(_assertThisInitialized(_this),_this.handleMouseMove),UPDATE_REFRESH_INTERVAL);_this.throttledHandleMouseSeek=throttle(bind(_assertThisInitialized(_this),_this.handleMouseSeek),UPDATE_REFRESH_INTERVAL);_this.handleMouseUpHandler_=function(e){return _this.handleMouseUp(e);};_this.handleMouseDownHandler_=function(e){return _this.handleMouseDown(e);};_this.enable();return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=ProgressControl.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-progress-control vjs-control'});}/**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {EventTarget~Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */;_proto.handleMouseMove=function handleMouseMove(event){var seekBar=this.getChild('seekBar');if(!seekBar){return;}var playProgressBar=seekBar.getChild('playProgressBar');var mouseTimeDisplay=seekBar.getChild('mouseTimeDisplay');if(!playProgressBar&&!mouseTimeDisplay){return;}var seekBarEl=seekBar.el();var seekBarRect=findPosition(seekBarEl);var seekBarPoint=getPointerPosition(seekBarEl,event).x;// The default skin has a gap on either side of the `SeekBar`. This means
// that it's possible to trigger this behavior outside the boundaries of
// the `SeekBar`. This ensures we stay within it at all times.
seekBarPoint=clamp(seekBarPoint,0,1);if(mouseTimeDisplay){mouseTimeDisplay.update(seekBarRect,seekBarPoint);}if(playProgressBar){playProgressBar.update(seekBarRect,seekBar.getProgress());}}/**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {EventTarget~Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */ /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */;_proto.handleMouseSeek=function handleMouseSeek(event){var seekBar=this.getChild('seekBar');if(seekBar){seekBar.handleMouseMove(event);}}/**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */;_proto.enabled=function enabled(){return this.enabled_;}/**
   * Disable all controls on the progress control and its children
   */;_proto.disable=function disable(){this.children().forEach(function(child){return child.disable&&child.disable();});if(!this.enabled()){return;}this.off(['mousedown','touchstart'],this.handleMouseDownHandler_);this.off(this.el_,'mousemove',this.handleMouseMove);this.removeListenersAddedOnMousedownAndTouchstart();this.addClass('disabled');this.enabled_=false;// Restore normal playback state if controls are disabled while scrubbing
if(this.player_.scrubbing()){var seekBar=this.getChild('seekBar');this.player_.scrubbing(false);if(seekBar.videoWasPlaying){silencePromise(this.player_.play());}}}/**
   * Enable all controls on the progress control and its children
   */;_proto.enable=function enable(){this.children().forEach(function(child){return child.enable&&child.enable();});if(this.enabled()){return;}this.on(['mousedown','touchstart'],this.handleMouseDownHandler_);this.on(this.el_,'mousemove',this.handleMouseMove);this.removeClass('disabled');this.enabled_=true;}/**
   * Cleanup listeners after the user finishes interacting with the progress controls
   */;_proto.removeListenersAddedOnMousedownAndTouchstart=function removeListenersAddedOnMousedownAndTouchstart(){var doc=this.el_.ownerDocument;this.off(doc,'mousemove',this.throttledHandleMouseSeek);this.off(doc,'touchmove',this.throttledHandleMouseSeek);this.off(doc,'mouseup',this.handleMouseUpHandler_);this.off(doc,'touchend',this.handleMouseUpHandler_);}/**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */;_proto.handleMouseDown=function handleMouseDown(event){var doc=this.el_.ownerDocument;var seekBar=this.getChild('seekBar');if(seekBar){seekBar.handleMouseDown(event);}this.on(doc,'mousemove',this.throttledHandleMouseSeek);this.on(doc,'touchmove',this.throttledHandleMouseSeek);this.on(doc,'mouseup',this.handleMouseUpHandler_);this.on(doc,'touchend',this.handleMouseUpHandler_);}/**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {EventTarget~Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */;_proto.handleMouseUp=function handleMouseUp(event){var seekBar=this.getChild('seekBar');if(seekBar){seekBar.handleMouseUp(event);}this.removeListenersAddedOnMousedownAndTouchstart();};return ProgressControl;}(Component$1);/**
 * Default options for `ProgressControl`
 *
 * @type {Object}
 * @private
 */ProgressControl.prototype.options_={children:['seekBar']};Component$1.registerComponent('ProgressControl',ProgressControl);/**
 * Toggle Picture-in-Picture mode
 *
 * @extends Button
 */var PictureInPictureToggle=/*#__PURE__*/function(_Button){_inheritsLoose(PictureInPictureToggle,_Button);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */function PictureInPictureToggle(player,options){var _this;_this=_Button.call(this,player,options)||this;_this.on(player,['enterpictureinpicture','leavepictureinpicture'],function(e){return _this.handlePictureInPictureChange(e);});_this.on(player,['disablepictureinpicturechanged','loadedmetadata'],function(e){return _this.handlePictureInPictureEnabledChange(e);});_this.on(player,['loadedmetadata','audioonlymodechange','audiopostermodechange'],function(){// This audio detection will not detect HLS or DASH audio-only streams because there was no reliable way to detect them at the time
var isSourceAudio=player.currentType().substring(0,5)==='audio';if(isSourceAudio||player.audioPosterMode()||player.audioOnlyMode()){if(player.isInPictureInPicture()){player.exitPictureInPicture();}_this.hide();}else{_this.show();}});// TODO: Deactivate button on player emptied event.
_this.disable();return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=PictureInPictureToggle.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-picture-in-picture-control "+_Button.prototype.buildCSSClass.call(this);}/**
   * Enables or disables button based on document.pictureInPictureEnabled property value
   * or on value returned by player.disablePictureInPicture() method.
   */;_proto.handlePictureInPictureEnabledChange=function handlePictureInPictureEnabledChange(){if((document_default()).pictureInPictureEnabled&&this.player_.disablePictureInPicture()===false){this.enable();}else{this.disable();}}/**
   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
   *        called.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */;_proto.handlePictureInPictureChange=function handlePictureInPictureChange(event){if(this.player_.isInPictureInPicture()){this.controlText('Exit Picture-in-Picture');}else{this.controlText('Picture-in-Picture');}this.handlePictureInPictureEnabledChange();}/**
   * This gets called when an `PictureInPictureToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){if(!this.player_.isInPictureInPicture()){this.player_.requestPictureInPicture();}else{this.player_.exitPictureInPicture();}};return PictureInPictureToggle;}(Button);/**
 * The text that should display over the `PictureInPictureToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */PictureInPictureToggle.prototype.controlText_='Picture-in-Picture';Component$1.registerComponent('PictureInPictureToggle',PictureInPictureToggle);/**
 * Toggle fullscreen video
 *
 * @extends Button
 */var FullscreenToggle=/*#__PURE__*/function(_Button){_inheritsLoose(FullscreenToggle,_Button);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function FullscreenToggle(player,options){var _this;_this=_Button.call(this,player,options)||this;_this.on(player,'fullscreenchange',function(e){return _this.handleFullscreenChange(e);});if((document_default())[player.fsApi_.fullscreenEnabled]===false){_this.disable();}return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=FullscreenToggle.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-fullscreen-control "+_Button.prototype.buildCSSClass.call(this);}/**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */;_proto.handleFullscreenChange=function handleFullscreenChange(event){if(this.player_.isFullscreen()){this.controlText('Non-Fullscreen');}else{this.controlText('Fullscreen');}}/**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){if(!this.player_.isFullscreen()){this.player_.requestFullscreen();}else{this.player_.exitFullscreen();}};return FullscreenToggle;}(Button);/**
 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */FullscreenToggle.prototype.controlText_='Fullscreen';Component$1.registerComponent('FullscreenToggle',FullscreenToggle);/**
 * Check if volume control is supported and if it isn't hide the
 * `Component` that was passed  using the `vjs-hidden` class.
 *
 * @param {Component} self
 *        The component that should be hidden if volume is unsupported
 *
 * @param {Player} player
 *        A reference to the player
 *
 * @private
 */var checkVolumeSupport=function checkVolumeSupport(self,player){// hide volume controls when they're not supported by the current tech
if(player.tech_&&!player.tech_.featuresVolumeControl){self.addClass('vjs-hidden');}self.on(player,'loadstart',function(){if(!player.tech_.featuresVolumeControl){self.addClass('vjs-hidden');}else{self.removeClass('vjs-hidden');}});};/**
 * Shows volume level
 *
 * @extends Component
 */var VolumeLevel=/*#__PURE__*/function(_Component){_inheritsLoose(VolumeLevel,_Component);function VolumeLevel(){return _Component.apply(this,arguments)||this;}var _proto=VolumeLevel.prototype;/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */_proto.createEl=function createEl(){var el=_Component.prototype.createEl.call(this,'div',{className:'vjs-volume-level'});el.appendChild(_Component.prototype.createEl.call(this,'span',{className:'vjs-control-text'}));return el;};return VolumeLevel;}(Component$1);Component$1.registerComponent('VolumeLevel',VolumeLevel);/**
 * Volume level tooltips display a volume above or side by side the volume bar.
 *
 * @extends Component
 */var VolumeLevelTooltip=/*#__PURE__*/function(_Component){_inheritsLoose(VolumeLevelTooltip,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function VolumeLevelTooltip(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.update=throttle(bind(_assertThisInitialized(_this),_this.update),UPDATE_REFRESH_INTERVAL);return _this;}/**
   * Create the volume tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=VolumeLevelTooltip.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-volume-tooltip'},{'aria-hidden':'true'});}/**
   * Updates the position of the tooltip relative to the `VolumeBar` and
   * its content text.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */;_proto.update=function update(rangeBarRect,rangeBarPoint,vertical,content){if(!vertical){var tooltipRect=getBoundingClientRect(this.el_);var playerRect=getBoundingClientRect(this.player_.el());var volumeBarPointPx=rangeBarRect.width*rangeBarPoint;if(!playerRect||!tooltipRect){return;}var spaceLeftOfPoint=rangeBarRect.left-playerRect.left+volumeBarPointPx;var spaceRightOfPoint=rangeBarRect.width-volumeBarPointPx+(playerRect.right-rangeBarRect.right);var pullTooltipBy=tooltipRect.width/2;if(spaceLeftOfPoint<pullTooltipBy){pullTooltipBy+=pullTooltipBy-spaceLeftOfPoint;}else if(spaceRightOfPoint<pullTooltipBy){pullTooltipBy=spaceRightOfPoint;}if(pullTooltipBy<0){pullTooltipBy=0;}else if(pullTooltipBy>tooltipRect.width){pullTooltipBy=tooltipRect.width;}this.el_.style.right="-"+pullTooltipBy+"px";}this.write(content+"%");}/**
   * Write the volume to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted volume for the tooltip.
   */;_proto.write=function write(content){textContent(this.el_,content);}/**
   * Updates the position of the volume tooltip relative to the `VolumeBar`.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   * @param {number} volume
   *        The volume level to update the tooltip to
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */;_proto.updateVolume=function updateVolume(rangeBarRect,rangeBarPoint,vertical,volume,cb){var _this2=this;this.requestNamedAnimationFrame('VolumeLevelTooltip#updateVolume',function(){_this2.update(rangeBarRect,rangeBarPoint,vertical,volume.toFixed(0));if(cb){cb();}});};return VolumeLevelTooltip;}(Component$1);Component$1.registerComponent('VolumeLevelTooltip',VolumeLevelTooltip);/**
 * The {@link MouseVolumeLevelDisplay} component tracks mouse movement over the
 * {@link VolumeControl}. It displays an indicator and a {@link VolumeLevelTooltip}
 * indicating the volume level which is represented by a given point in the
 * {@link VolumeBar}.
 *
 * @extends Component
 */var MouseVolumeLevelDisplay=/*#__PURE__*/function(_Component){_inheritsLoose(MouseVolumeLevelDisplay,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function MouseVolumeLevelDisplay(player,options){var _this;_this=_Component.call(this,player,options)||this;_this.update=throttle(bind(_assertThisInitialized(_this),_this.update),UPDATE_REFRESH_INTERVAL);return _this;}/**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=MouseVolumeLevelDisplay.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-mouse-display'});}/**
   * Enquires updates to its own DOM as well as the DOM of its
   * {@link VolumeLevelTooltip} child.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */;_proto.update=function update(rangeBarRect,rangeBarPoint,vertical){var _this2=this;var volume=100*rangeBarPoint;this.getChild('volumeLevelTooltip').updateVolume(rangeBarRect,rangeBarPoint,vertical,volume,function(){if(vertical){_this2.el_.style.bottom=rangeBarRect.height*rangeBarPoint+"px";}else{_this2.el_.style.left=rangeBarRect.width*rangeBarPoint+"px";}});};return MouseVolumeLevelDisplay;}(Component$1);/**
 * Default options for `MouseVolumeLevelDisplay`
 *
 * @type {Object}
 * @private
 */MouseVolumeLevelDisplay.prototype.options_={children:['volumeLevelTooltip']};Component$1.registerComponent('MouseVolumeLevelDisplay',MouseVolumeLevelDisplay);/**
 * The bar that contains the volume level and can be clicked on to adjust the level
 *
 * @extends Slider
 */var VolumeBar=/*#__PURE__*/function(_Slider){_inheritsLoose(VolumeBar,_Slider);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function VolumeBar(player,options){var _this;_this=_Slider.call(this,player,options)||this;_this.on('slideractive',function(e){return _this.updateLastVolume_(e);});_this.on(player,'volumechange',function(e){return _this.updateARIAAttributes(e);});player.ready(function(){return _this.updateARIAAttributes();});return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=VolumeBar.prototype;_proto.createEl=function createEl(){return _Slider.prototype.createEl.call(this,'div',{className:'vjs-volume-bar vjs-slider-bar'},{'aria-label':this.localize('Volume Level'),'aria-live':'polite'});}/**
   * Handle mouse down on volume bar
   *
   * @param {EventTarget~Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */;_proto.handleMouseDown=function handleMouseDown(event){if(!isSingleLeftClick(event)){return;}_Slider.prototype.handleMouseDown.call(this,event);}/**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */;_proto.handleMouseMove=function handleMouseMove(event){var mouseVolumeLevelDisplay=this.getChild('mouseVolumeLevelDisplay');if(mouseVolumeLevelDisplay){var volumeBarEl=this.el();var volumeBarRect=getBoundingClientRect(volumeBarEl);var vertical=this.vertical();var volumeBarPoint=getPointerPosition(volumeBarEl,event);volumeBarPoint=vertical?volumeBarPoint.y:volumeBarPoint.x;// The default skin has a gap on either side of the `VolumeBar`. This means
// that it's possible to trigger this behavior outside the boundaries of
// the `VolumeBar`. This ensures we stay within it at all times.
volumeBarPoint=clamp(volumeBarPoint,0,1);mouseVolumeLevelDisplay.update(volumeBarRect,volumeBarPoint,vertical);}if(!isSingleLeftClick(event)){return;}this.checkMuted();this.player_.volume(this.calculateDistance(event));}/**
   * If the player is muted unmute it.
   */;_proto.checkMuted=function checkMuted(){if(this.player_.muted()){this.player_.muted(false);}}/**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */;_proto.getPercent=function getPercent(){if(this.player_.muted()){return 0;}return this.player_.volume();}/**
   * Increase volume level for keyboard users
   */;_proto.stepForward=function stepForward(){this.checkMuted();this.player_.volume(this.player_.volume()+0.1);}/**
   * Decrease volume level for keyboard users
   */;_proto.stepBack=function stepBack(){this.checkMuted();this.player_.volume(this.player_.volume()-0.1);}/**
   * Update ARIA accessibility attributes
   *
   * @param {EventTarget~Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */;_proto.updateARIAAttributes=function updateARIAAttributes(event){var ariaValue=this.player_.muted()?0:this.volumeAsPercentage_();this.el_.setAttribute('aria-valuenow',ariaValue);this.el_.setAttribute('aria-valuetext',ariaValue+'%');}/**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */;_proto.volumeAsPercentage_=function volumeAsPercentage_(){return Math.round(this.player_.volume()*100);}/**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */;_proto.updateLastVolume_=function updateLastVolume_(){var _this2=this;var volumeBeforeDrag=this.player_.volume();this.one('sliderinactive',function(){if(_this2.player_.volume()===0){_this2.player_.lastVolume_(volumeBeforeDrag);}});};return VolumeBar;}(Slider);/**
 * Default options for the `VolumeBar`
 *
 * @type {Object}
 * @private
 */VolumeBar.prototype.options_={children:['volumeLevel'],barName:'volumeLevel'};// MouseVolumeLevelDisplay tooltip should not be added to a player on mobile devices
if(!IS_IOS&&!IS_ANDROID){VolumeBar.prototype.options_.children.splice(0,0,'mouseVolumeLevelDisplay');}/**
 * Call the update event for this Slider when this event happens on the player.
 *
 * @type {string}
 */VolumeBar.prototype.playerEvent='volumechange';Component$1.registerComponent('VolumeBar',VolumeBar);/**
 * The component for controlling the volume level
 *
 * @extends Component
 */var VolumeControl=/*#__PURE__*/function(_Component){_inheritsLoose(VolumeControl,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function VolumeControl(player,options){var _this;if(options===void 0){options={};}options.vertical=options.vertical||false;// Pass the vertical option down to the VolumeBar if
// the VolumeBar is turned on.
if(typeof options.volumeBar==='undefined'||isPlain(options.volumeBar)){options.volumeBar=options.volumeBar||{};options.volumeBar.vertical=options.vertical;}_this=_Component.call(this,player,options)||this;// hide this control if volume support is missing
checkVolumeSupport(_assertThisInitialized(_this),player);_this.throttledHandleMouseMove=throttle(bind(_assertThisInitialized(_this),_this.handleMouseMove),UPDATE_REFRESH_INTERVAL);_this.handleMouseUpHandler_=function(e){return _this.handleMouseUp(e);};_this.on('mousedown',function(e){return _this.handleMouseDown(e);});_this.on('touchstart',function(e){return _this.handleMouseDown(e);});_this.on('mousemove',function(e){return _this.handleMouseMove(e);});// while the slider is active (the mouse has been pressed down and
// is dragging) or in focus we do not want to hide the VolumeBar
_this.on(_this.volumeBar,['focus','slideractive'],function(){_this.volumeBar.addClass('vjs-slider-active');_this.addClass('vjs-slider-active');_this.trigger('slideractive');});_this.on(_this.volumeBar,['blur','sliderinactive'],function(){_this.volumeBar.removeClass('vjs-slider-active');_this.removeClass('vjs-slider-active');_this.trigger('sliderinactive');});return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=VolumeControl.prototype;_proto.createEl=function createEl(){var orientationClass='vjs-volume-horizontal';if(this.options_.vertical){orientationClass='vjs-volume-vertical';}return _Component.prototype.createEl.call(this,'div',{className:"vjs-volume-control vjs-control "+orientationClass});}/**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */;_proto.handleMouseDown=function handleMouseDown(event){var doc=this.el_.ownerDocument;this.on(doc,'mousemove',this.throttledHandleMouseMove);this.on(doc,'touchmove',this.throttledHandleMouseMove);this.on(doc,'mouseup',this.handleMouseUpHandler_);this.on(doc,'touchend',this.handleMouseUpHandler_);}/**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */;_proto.handleMouseUp=function handleMouseUp(event){var doc=this.el_.ownerDocument;this.off(doc,'mousemove',this.throttledHandleMouseMove);this.off(doc,'touchmove',this.throttledHandleMouseMove);this.off(doc,'mouseup',this.handleMouseUpHandler_);this.off(doc,'touchend',this.handleMouseUpHandler_);}/**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */;_proto.handleMouseMove=function handleMouseMove(event){this.volumeBar.handleMouseMove(event);};return VolumeControl;}(Component$1);/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */VolumeControl.prototype.options_={children:['volumeBar']};Component$1.registerComponent('VolumeControl',VolumeControl);/**
 * Check if muting volume is supported and if it isn't hide the mute toggle
 * button.
 *
 * @param {Component} self
 *        A reference to the mute toggle button
 *
 * @param {Player} player
 *        A reference to the player
 *
 * @private
 */var checkMuteSupport=function checkMuteSupport(self,player){// hide mute toggle button if it's not supported by the current tech
if(player.tech_&&!player.tech_.featuresMuteControl){self.addClass('vjs-hidden');}self.on(player,'loadstart',function(){if(!player.tech_.featuresMuteControl){self.addClass('vjs-hidden');}else{self.removeClass('vjs-hidden');}});};/**
 * A button component for muting the audio.
 *
 * @extends Button
 */var MuteToggle=/*#__PURE__*/function(_Button){_inheritsLoose(MuteToggle,_Button);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function MuteToggle(player,options){var _this;_this=_Button.call(this,player,options)||this;// hide this control if volume support is missing
checkMuteSupport(_assertThisInitialized(_this),player);_this.on(player,['loadstart','volumechange'],function(e){return _this.update(e);});return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=MuteToggle.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-mute-control "+_Button.prototype.buildCSSClass.call(this);}/**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){var vol=this.player_.volume();var lastVolume=this.player_.lastVolume_();if(vol===0){var volumeToSet=lastVolume<0.1?0.1:lastVolume;this.player_.volume(volumeToSet);this.player_.muted(false);}else{this.player_.muted(this.player_.muted()?false:true);}}/**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */;_proto.update=function update(event){this.updateIcon_();this.updateControlText_();}/**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */;_proto.updateIcon_=function updateIcon_(){var vol=this.player_.volume();var level=3;// in iOS when a player is loaded with muted attribute
// and volume is changed with a native mute button
// we want to make sure muted state is updated
if(IS_IOS&&this.player_.tech_&&this.player_.tech_.el_){this.player_.muted(this.player_.tech_.el_.muted);}if(vol===0||this.player_.muted()){level=0;}else if(vol<0.33){level=1;}else if(vol<0.67){level=2;}// TODO improve muted icon classes
for(var i=0;i<4;i++){removeClass(this.el_,"vjs-vol-"+i);}addClass(this.el_,"vjs-vol-"+level);}/**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */;_proto.updateControlText_=function updateControlText_(){var soundOff=this.player_.muted()||this.player_.volume()===0;var text=soundOff?'Unmute':'Mute';if(this.controlText()!==text){this.controlText(text);}};return MuteToggle;}(Button);/**
 * The text that should display over the `MuteToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */MuteToggle.prototype.controlText_='Mute';Component$1.registerComponent('MuteToggle',MuteToggle);/**
 * A Component to contain the MuteToggle and VolumeControl so that
 * they can work together.
 *
 * @extends Component
 */var VolumePanel=/*#__PURE__*/function(_Component){_inheritsLoose(VolumePanel,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function VolumePanel(player,options){var _this;if(options===void 0){options={};}if(typeof options.inline!=='undefined'){options.inline=options.inline;}else{options.inline=true;}// pass the inline option down to the VolumeControl as vertical if
// the VolumeControl is on.
if(typeof options.volumeControl==='undefined'||isPlain(options.volumeControl)){options.volumeControl=options.volumeControl||{};options.volumeControl.vertical=!options.inline;}_this=_Component.call(this,player,options)||this;// this handler is used by mouse handler methods below
_this.handleKeyPressHandler_=function(e){return _this.handleKeyPress(e);};_this.on(player,['loadstart'],function(e){return _this.volumePanelState_(e);});_this.on(_this.muteToggle,'keyup',function(e){return _this.handleKeyPress(e);});_this.on(_this.volumeControl,'keyup',function(e){return _this.handleVolumeControlKeyUp(e);});_this.on('keydown',function(e){return _this.handleKeyPress(e);});_this.on('mouseover',function(e){return _this.handleMouseOver(e);});_this.on('mouseout',function(e){return _this.handleMouseOut(e);});// while the slider is active (the mouse has been pressed down and
// is dragging) we do not want to hide the VolumeBar
_this.on(_this.volumeControl,['slideractive'],_this.sliderActive_);_this.on(_this.volumeControl,['sliderinactive'],_this.sliderInactive_);return _this;}/**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */var _proto=VolumePanel.prototype;_proto.sliderActive_=function sliderActive_(){this.addClass('vjs-slider-active');}/**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */;_proto.sliderInactive_=function sliderInactive_(){this.removeClass('vjs-slider-active');}/**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */;_proto.volumePanelState_=function volumePanelState_(){// hide volume panel if neither volume control or mute toggle
// are displayed
if(this.volumeControl.hasClass('vjs-hidden')&&this.muteToggle.hasClass('vjs-hidden')){this.addClass('vjs-hidden');}// if only mute toggle is visible we don't want
// volume panel expanding when hovered or active
if(this.volumeControl.hasClass('vjs-hidden')&&!this.muteToggle.hasClass('vjs-hidden')){this.addClass('vjs-mute-toggle-only');}}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl(){var orientationClass='vjs-volume-panel-horizontal';if(!this.options_.inline){orientationClass='vjs-volume-panel-vertical';}return _Component.prototype.createEl.call(this,'div',{className:"vjs-volume-panel vjs-control "+orientationClass});}/**
   * Dispose of the `volume-panel` and all child components.
   */;_proto.dispose=function dispose(){this.handleMouseOut();_Component.prototype.dispose.call(this);}/**
   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
   * the volume panel and sets focus on `MuteToggle`.
   *
   * @param {EventTarget~Event} event
   *        The `keyup` event that caused this function to be called.
   *
   * @listens keyup
   */;_proto.handleVolumeControlKeyUp=function handleVolumeControlKeyUp(event){if(keycode_default().isEventKey(event,'Esc')){this.muteToggle.focus();}}/**
   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
   * Turns on listening for `mouseover` event. When they happen it
   * calls `this.handleMouseOver`.
   *
   * @param {EventTarget~Event} event
   *        The `mouseover` event that caused this function to be called.
   *
   * @listens mouseover
   */;_proto.handleMouseOver=function handleMouseOver(event){this.addClass('vjs-hover');on((document_default()),'keyup',this.handleKeyPressHandler_);}/**
   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
   * Turns on listening for `mouseout` event. When they happen it
   * calls `this.handleMouseOut`.
   *
   * @param {EventTarget~Event} event
   *        The `mouseout` event that caused this function to be called.
   *
   * @listens mouseout
   */;_proto.handleMouseOut=function handleMouseOut(event){this.removeClass('vjs-hover');off((document_default()),'keyup',this.handleKeyPressHandler_);}/**
   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
   * looking for ESC, which hides the `VolumeControl`.
   *
   * @param {EventTarget~Event} event
   *        The keypress that triggered this event.
   *
   * @listens keydown | keyup
   */;_proto.handleKeyPress=function handleKeyPress(event){if(keycode_default().isEventKey(event,'Esc')){this.handleMouseOut();}};return VolumePanel;}(Component$1);/**
 * Default options for the `VolumeControl`
 *
 * @type {Object}
 * @private
 */VolumePanel.prototype.options_={children:['muteToggle','volumeControl']};Component$1.registerComponent('VolumePanel',VolumePanel);/**
 * The Menu component is used to build popup menus, including subtitle and
 * captions selection menus.
 *
 * @extends Component
 */var Menu=/*#__PURE__*/function(_Component){_inheritsLoose(Menu,_Component);/**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */function Menu(player,options){var _this;_this=_Component.call(this,player,options)||this;if(options){_this.menuButton_=options.menuButton;}_this.focusedChild_=-1;_this.on('keydown',function(e){return _this.handleKeyDown(e);});// All the menu item instances share the same blur handler provided by the menu container.
_this.boundHandleBlur_=function(e){return _this.handleBlur(e);};_this.boundHandleTapClick_=function(e){return _this.handleTapClick(e);};return _this;}/**
   * Add event listeners to the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to add listeners to.
   *
   */var _proto=Menu.prototype;_proto.addEventListenerForItem=function addEventListenerForItem(component){if(!(component instanceof Component$1)){return;}this.on(component,'blur',this.boundHandleBlur_);this.on(component,['tap','click'],this.boundHandleTapClick_);}/**
   * Remove event listeners from the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to remove listeners.
   *
   */;_proto.removeEventListenerForItem=function removeEventListenerForItem(component){if(!(component instanceof Component$1)){return;}this.off(component,'blur',this.boundHandleBlur_);this.off(component,['tap','click'],this.boundHandleTapClick_);}/**
   * This method will be called indirectly when the component has been added
   * before the component adds to the new menu instance by `addItem`.
   * In this case, the original menu instance will remove the component
   * by calling `removeChild`.
   *
   * @param {Object} component
   *        The instance of the `MenuItem`
   */;_proto.removeChild=function removeChild(component){if(typeof component==='string'){component=this.getChild(component);}this.removeEventListenerForItem(component);_Component.prototype.removeChild.call(this,component);}/**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */;_proto.addItem=function addItem(component){var childComponent=this.addChild(component);if(childComponent){this.addEventListenerForItem(childComponent);}}/**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */;_proto.createEl=function createEl$1(){var contentElType=this.options_.contentElType||'ul';this.contentEl_=createEl(contentElType,{className:'vjs-menu-content'});this.contentEl_.setAttribute('role','menu');var el=_Component.prototype.createEl.call(this,'div',{append:this.contentEl_,className:'vjs-menu'});el.appendChild(this.contentEl_);// Prevent clicks from bubbling up. Needed for Menu Buttons,
// where a click on the parent is significant
on(el,'click',function(event){event.preventDefault();event.stopImmediatePropagation();});return el;};_proto.dispose=function dispose(){this.contentEl_=null;this.boundHandleBlur_=null;this.boundHandleTapClick_=null;_Component.prototype.dispose.call(this);}/**
   * Called when a `MenuItem` loses focus.
   *
   * @param {EventTarget~Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */;_proto.handleBlur=function handleBlur(event){var relatedTarget=event.relatedTarget||(document_default()).activeElement;// Close menu popup when a user clicks outside the menu
if(!this.children().some(function(element){return element.el()===relatedTarget;})){var btn=this.menuButton_;if(btn&&btn.buttonPressed_&&relatedTarget!==btn.el().firstChild){btn.unpressButton();}}}/**
   * Called when a `MenuItem` gets clicked or tapped.
   *
   * @param {EventTarget~Event} event
   *        The `click` or `tap` event that caused this function to be called.
   *
   * @listens click,tap
   */;_proto.handleTapClick=function handleTapClick(event){// Unpress the associated MenuButton, and move focus back to it
if(this.menuButton_){this.menuButton_.unpressButton();var childComponents=this.children();if(!Array.isArray(childComponents)){return;}var foundComponent=childComponents.filter(function(component){return component.el()===event.target;})[0];if(!foundComponent){return;}// don't focus menu button if item is a caption settings item
// because focus will move elsewhere
if(foundComponent.name()!=='CaptionSettingsMenuItem'){this.menuButton_.focus();}}}/**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {EventTarget~Event} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Left and Down Arrows
if(keycode_default().isEventKey(event,'Left')||keycode_default().isEventKey(event,'Down')){event.preventDefault();event.stopPropagation();this.stepForward();// Up and Right Arrows
}else if(keycode_default().isEventKey(event,'Right')||keycode_default().isEventKey(event,'Up')){event.preventDefault();event.stopPropagation();this.stepBack();}}/**
   * Move to next (lower) menu item for keyboard users.
   */;_proto.stepForward=function stepForward(){var stepChild=0;if(this.focusedChild_!==undefined){stepChild=this.focusedChild_+1;}this.focus(stepChild);}/**
   * Move to previous (higher) menu item for keyboard users.
   */;_proto.stepBack=function stepBack(){var stepChild=0;if(this.focusedChild_!==undefined){stepChild=this.focusedChild_-1;}this.focus(stepChild);}/**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */;_proto.focus=function focus(item){if(item===void 0){item=0;}var children=this.children().slice();var haveTitle=children.length&&children[0].hasClass('vjs-menu-title');if(haveTitle){children.shift();}if(children.length>0){if(item<0){item=0;}else if(item>=children.length){item=children.length-1;}this.focusedChild_=item;children[item].el_.focus();}};return Menu;}(Component$1);Component$1.registerComponent('Menu',Menu);/**
 * A `MenuButton` class for any popup {@link Menu}.
 *
 * @extends Component
 */var MenuButton=/*#__PURE__*/function(_Component){_inheritsLoose(MenuButton,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function MenuButton(player,options){var _this;if(options===void 0){options={};}_this=_Component.call(this,player,options)||this;_this.menuButton_=new Button(player,options);_this.menuButton_.controlText(_this.controlText_);_this.menuButton_.el_.setAttribute('aria-haspopup','true');// Add buildCSSClass values to the button, not the wrapper
var buttonClass=Button.prototype.buildCSSClass();_this.menuButton_.el_.className=_this.buildCSSClass()+' '+buttonClass;_this.menuButton_.removeClass('vjs-control');_this.addChild(_this.menuButton_);_this.update();_this.enabled_=true;var handleClick=function handleClick(e){return _this.handleClick(e);};_this.handleMenuKeyUp_=function(e){return _this.handleMenuKeyUp(e);};_this.on(_this.menuButton_,'tap',handleClick);_this.on(_this.menuButton_,'click',handleClick);_this.on(_this.menuButton_,'keydown',function(e){return _this.handleKeyDown(e);});_this.on(_this.menuButton_,'mouseenter',function(){_this.addClass('vjs-hover');_this.menu.show();on((document_default()),'keyup',_this.handleMenuKeyUp_);});_this.on('mouseleave',function(e){return _this.handleMouseLeave(e);});_this.on('keydown',function(e){return _this.handleSubmenuKeyDown(e);});return _this;}/**
   * Update the menu based on the current state of its items.
   */var _proto=MenuButton.prototype;_proto.update=function update(){var menu=this.createMenu();if(this.menu){this.menu.dispose();this.removeChild(this.menu);}this.menu=menu;this.addChild(menu);/**
     * Track the state of the menu button
     *
     * @type {Boolean}
     * @private
     */this.buttonPressed_=false;this.menuButton_.el_.setAttribute('aria-expanded','false');if(this.items&&this.items.length<=this.hideThreshold_){this.hide();this.menu.contentEl_.removeAttribute('role');}else{this.show();this.menu.contentEl_.setAttribute('role','menu');}}/**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */;_proto.createMenu=function createMenu(){var menu=new Menu(this.player_,{menuButton:this});/**
     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
     * it here because every time we run `createMenu` we need to reset the value.
     *
     * @protected
     * @type {Number}
     */this.hideThreshold_=0;// Add a title list item to the top
if(this.options_.title){var titleEl=createEl('li',{className:'vjs-menu-title',textContent:toTitleCase$1(this.options_.title),tabIndex:-1});var titleComponent=new Component$1(this.player_,{el:titleEl});menu.addItem(titleComponent);}this.items=this.createItems();if(this.items){// Add menu items to the menu
for(var i=0;i<this.items.length;i++){menu.addItem(this.items[i]);}}return menu;}/**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */;_proto.createItems=function createItems(){}/**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:this.buildWrapperCSSClass()},{});}/**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */;_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){var menuButtonClass='vjs-menu-button';// If the inline option is passed, we want to use different styles altogether.
if(this.options_.inline===true){menuButtonClass+='-inline';}else{menuButtonClass+='-popup';}// TODO: Fix the CSS so that this isn't necessary
var buttonClass=Button.prototype.buildCSSClass();return"vjs-menu-button "+menuButtonClass+" "+buttonClass+" "+_Component.prototype.buildCSSClass.call(this);}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */;_proto.buildCSSClass=function buildCSSClass(){var menuButtonClass='vjs-menu-button';// If the inline option is passed, we want to use different styles altogether.
if(this.options_.inline===true){menuButtonClass+='-inline';}else{menuButtonClass+='-popup';}return"vjs-menu-button "+menuButtonClass+" "+_Component.prototype.buildCSSClass.call(this);}/**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */;_proto.controlText=function controlText(text,el){if(el===void 0){el=this.menuButton_.el();}return this.menuButton_.controlText(text,el);}/**
   * Dispose of the `menu-button` and all child components.
   */;_proto.dispose=function dispose(){this.handleMouseLeave();_Component.prototype.dispose.call(this);}/**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){if(this.buttonPressed_){this.unpressButton();}else{this.pressButton();}}/**
   * Handle `mouseleave` for `MenuButton`.
   *
   * @param {EventTarget~Event} event
   *        The `mouseleave` event that caused this function to be called.
   *
   * @listens mouseleave
   */;_proto.handleMouseLeave=function handleMouseLeave(event){this.removeClass('vjs-hover');off((document_default()),'keyup',this.handleMenuKeyUp_);}/**
   * Set the focus to the actual button, not to this element
   */;_proto.focus=function focus(){this.menuButton_.focus();}/**
   * Remove the focus from the actual button, not this element
   */;_proto.blur=function blur(){this.menuButton_.blur();}/**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){// Escape or Tab unpress the 'button'
if(keycode_default().isEventKey(event,'Esc')||keycode_default().isEventKey(event,'Tab')){if(this.buttonPressed_){this.unpressButton();}// Don't preventDefault for Tab key - we still want to lose focus
if(!keycode_default().isEventKey(event,'Tab')){event.preventDefault();// Set focus back to the menu button's button
this.menuButton_.focus();}// Up Arrow or Down Arrow also 'press' the button to open the menu
}else if(keycode_default().isEventKey(event,'Up')||keycode_default().isEventKey(event,'Down')){if(!this.buttonPressed_){event.preventDefault();this.pressButton();}}}/**
   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
   * the constructor.
   *
   * @param {EventTarget~Event} event
   *        Key press event
   *
   * @listens keyup
   */;_proto.handleMenuKeyUp=function handleMenuKeyUp(event){// Escape hides popup menu
if(keycode_default().isEventKey(event,'Esc')||keycode_default().isEventKey(event,'Tab')){this.removeClass('vjs-hover');}}/**
   * This method name now delegates to `handleSubmenuKeyDown`. This means
   * anyone calling `handleSubmenuKeyPress` will not see their method calls
   * stop working.
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to be called.
   */;_proto.handleSubmenuKeyPress=function handleSubmenuKeyPress(event){this.handleSubmenuKeyDown(event);}/**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {EventTarget~Event} event
   *        Key press event
   *
   * @listens keydown
   */;_proto.handleSubmenuKeyDown=function handleSubmenuKeyDown(event){// Escape or Tab unpress the 'button'
if(keycode_default().isEventKey(event,'Esc')||keycode_default().isEventKey(event,'Tab')){if(this.buttonPressed_){this.unpressButton();}// Don't preventDefault for Tab key - we still want to lose focus
if(!keycode_default().isEventKey(event,'Tab')){event.preventDefault();// Set focus back to the menu button's button
this.menuButton_.focus();}}}/**
   * Put the current `MenuButton` into a pressed state.
   */;_proto.pressButton=function pressButton(){if(this.enabled_){this.buttonPressed_=true;this.menu.show();this.menu.lockShowing();this.menuButton_.el_.setAttribute('aria-expanded','true');// set the focus into the submenu, except on iOS where it is resulting in
// undesired scrolling behavior when the player is in an iframe
if(IS_IOS&&isInFrame()){// Return early so that the menu isn't focused
return;}this.menu.focus();}}/**
   * Take the current `MenuButton` out of a pressed state.
   */;_proto.unpressButton=function unpressButton(){if(this.enabled_){this.buttonPressed_=false;this.menu.unlockShowing();this.menu.hide();this.menuButton_.el_.setAttribute('aria-expanded','false');}}/**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */;_proto.disable=function disable(){this.unpressButton();this.enabled_=false;this.addClass('vjs-disabled');this.menuButton_.disable();}/**
   * Enable the `MenuButton`. Allow it to be clicked.
   */;_proto.enable=function enable(){this.enabled_=true;this.removeClass('vjs-disabled');this.menuButton_.enable();};return MenuButton;}(Component$1);Component$1.registerComponent('MenuButton',MenuButton);/**
 * The base class for buttons that toggle specific  track types (e.g. subtitles).
 *
 * @extends MenuButton
 */var TrackButton=/*#__PURE__*/function(_MenuButton){_inheritsLoose(TrackButton,_MenuButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function TrackButton(player,options){var _this;var tracks=options.tracks;_this=_MenuButton.call(this,player,options)||this;if(_this.items.length<=1){_this.hide();}if(!tracks){return _assertThisInitialized(_this);}var updateHandler=bind(_assertThisInitialized(_this),_this.update);tracks.addEventListener('removetrack',updateHandler);tracks.addEventListener('addtrack',updateHandler);tracks.addEventListener('labelchange',updateHandler);_this.player_.on('ready',updateHandler);_this.player_.on('dispose',function(){tracks.removeEventListener('removetrack',updateHandler);tracks.removeEventListener('addtrack',updateHandler);tracks.removeEventListener('labelchange',updateHandler);});return _this;}return TrackButton;}(MenuButton);Component$1.registerComponent('TrackButton',TrackButton);/**
 * @file menu-keys.js
 */ /**
  * All keys used for operation of a menu (`MenuButton`, `Menu`, and `MenuItem`)
  * Note that 'Enter' and 'Space' are not included here (otherwise they would
  * prevent the `MenuButton` and `MenuItem` from being keyboard-clickable)
  * @typedef MenuKeys
  * @array
  */var MenuKeys=['Tab','Esc','Up','Down','Right','Left'];/**
 * The component for a menu item. `<li>`
 *
 * @extends ClickableComponent
 */var MenuItem=/*#__PURE__*/function(_ClickableComponent){_inheritsLoose(MenuItem,_ClickableComponent);/**
   * Creates an instance of the this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */function MenuItem(player,options){var _this;_this=_ClickableComponent.call(this,player,options)||this;_this.selectable=options.selectable;_this.isSelected_=options.selected||false;_this.multiSelectable=options.multiSelectable;_this.selected(_this.isSelected_);if(_this.selectable){if(_this.multiSelectable){_this.el_.setAttribute('role','menuitemcheckbox');}else{_this.el_.setAttribute('role','menuitemradio');}}else{_this.el_.setAttribute('role','menuitem');}return _this;}/**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */var _proto=MenuItem.prototype;_proto.createEl=function createEl$1(type,props,attrs){// The control is textual, not just an icon
this.nonIconControl=true;var el=_ClickableComponent.prototype.createEl.call(this,'li',video_es_assign({className:'vjs-menu-item',tabIndex:-1},props),attrs);// swap icon with menu item text.
el.replaceChild(createEl('span',{className:'vjs-menu-item-text',textContent:this.localize(this.options_.label)}),el.querySelector('.vjs-icon-placeholder'));return el;}/**
   * Ignore keys which are used by the menu, but pass any other ones up. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){if(!MenuKeys.some(function(key){return keycode_default().isEventKey(event,key);})){// Pass keydown handling up for unused keys
_ClickableComponent.prototype.handleKeyDown.call(this,event);}}/**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){this.selected(true);}/**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */;_proto.selected=function selected(_selected){if(this.selectable){if(_selected){this.addClass('vjs-selected');this.el_.setAttribute('aria-checked','true');// aria-checked isn't fully supported by browsers/screen readers,
// so indicate selected state to screen reader in the control text.
this.controlText(', selected');this.isSelected_=true;}else{this.removeClass('vjs-selected');this.el_.setAttribute('aria-checked','false');// Indicate un-selected state to screen reader
this.controlText('');this.isSelected_=false;}}};return MenuItem;}(ClickableComponent);Component$1.registerComponent('MenuItem',MenuItem);/**
 * The specific menu item type for selecting a language within a text track kind
 *
 * @extends MenuItem
 */var TextTrackMenuItem=/*#__PURE__*/function(_MenuItem){_inheritsLoose(TextTrackMenuItem,_MenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function TextTrackMenuItem(player,options){var _this;var track=options.track;var tracks=player.textTracks();// Modify options for parent MenuItem class's init.
options.label=track.label||track.language||'Unknown';options.selected=track.mode==='showing';_this=_MenuItem.call(this,player,options)||this;_this.track=track;// Determine the relevant kind(s) of tracks for this component and filter
// out empty kinds.
_this.kinds=(options.kinds||[options.kind||_this.track.kind]).filter(Boolean);var changeHandler=function changeHandler(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this.handleTracksChange.apply(_assertThisInitialized(_this),args);};var selectedLanguageChangeHandler=function selectedLanguageChangeHandler(){for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}_this.handleSelectedLanguageChange.apply(_assertThisInitialized(_this),args);};player.on(['loadstart','texttrackchange'],changeHandler);tracks.addEventListener('change',changeHandler);tracks.addEventListener('selectedlanguagechange',selectedLanguageChangeHandler);_this.on('dispose',function(){player.off(['loadstart','texttrackchange'],changeHandler);tracks.removeEventListener('change',changeHandler);tracks.removeEventListener('selectedlanguagechange',selectedLanguageChangeHandler);});// iOS7 doesn't dispatch change events to TextTrackLists when an
// associated track's mode changes. Without something like
// Object.observe() (also not present on iOS7), it's not
// possible to detect changes to the mode attribute and polyfill
// the change event. As a poor substitute, we manually dispatch
// change events whenever the controls modify the mode.
if(tracks.onchange===undefined){var event;_this.on(['tap','click'],function(){if(video_es_typeof((window_default()).Event)!=='object'){// Android 2.3 throws an Illegal Constructor error for window.Event
try{event=new (window_default()).Event('change');}catch(err){// continue regardless of error
}}if(!event){event=document_default().createEvent('Event');event.initEvent('change',true,true);}tracks.dispatchEvent(event);});}// set the default state based on current tracks
_this.handleTracksChange();return _this;}/**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */var _proto=TextTrackMenuItem.prototype;_proto.handleClick=function handleClick(event){var referenceTrack=this.track;var tracks=this.player_.textTracks();_MenuItem.prototype.handleClick.call(this,event);if(!tracks){return;}for(var i=0;i<tracks.length;i++){var track=tracks[i];// If the track from the text tracks list is not of the right kind,
// skip it. We do not want to affect tracks of incompatible kind(s).
if(this.kinds.indexOf(track.kind)===-1){continue;}// If this text track is the component's track and it is not showing,
// set it to showing.
if(track===referenceTrack){if(track.mode!=='showing'){track.mode='showing';}// If this text track is not the component's track and it is not
// disabled, set it to disabled.
}else if(track.mode!=='disabled'){track.mode='disabled';}}}/**
   * Handle text track list change
   *
   * @param {EventTarget~Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */;_proto.handleTracksChange=function handleTracksChange(event){var shouldBeSelected=this.track.mode==='showing';// Prevent redundant selected() calls because they may cause
// screen readers to read the appended control text unnecessarily
if(shouldBeSelected!==this.isSelected_){this.selected(shouldBeSelected);}};_proto.handleSelectedLanguageChange=function handleSelectedLanguageChange(event){if(this.track.mode==='showing'){var selectedLanguage=this.player_.cache_.selectedLanguage;// Don't replace the kind of track across the same language
if(selectedLanguage&&selectedLanguage.enabled&&selectedLanguage.language===this.track.language&&selectedLanguage.kind!==this.track.kind){return;}this.player_.cache_.selectedLanguage={enabled:true,language:this.track.language,kind:this.track.kind};}};_proto.dispose=function dispose(){// remove reference to track object on dispose
this.track=null;_MenuItem.prototype.dispose.call(this);};return TextTrackMenuItem;}(MenuItem);Component$1.registerComponent('TextTrackMenuItem',TextTrackMenuItem);/**
 * A special menu item for turning of a specific type of text track
 *
 * @extends TextTrackMenuItem
 */var OffTextTrackMenuItem=/*#__PURE__*/function(_TextTrackMenuItem){_inheritsLoose(OffTextTrackMenuItem,_TextTrackMenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function OffTextTrackMenuItem(player,options){// Create pseudo track info
// Requires options['kind']
options.track={player:player,// it is no longer necessary to store `kind` or `kinds` on the track itself
// since they are now stored in the `kinds` property of all instances of
// TextTrackMenuItem, but this will remain for backwards compatibility
kind:options.kind,kinds:options.kinds,"default":false,mode:'disabled'};if(!options.kinds){options.kinds=[options.kind];}if(options.label){options.track.label=options.label;}else{options.track.label=options.kinds.join(' and ')+' off';}// MenuItem is selectable
options.selectable=true;// MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
options.multiSelectable=false;return _TextTrackMenuItem.call(this,player,options)||this;}/**
   * Handle text track change
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run
   */var _proto=OffTextTrackMenuItem.prototype;_proto.handleTracksChange=function handleTracksChange(event){var tracks=this.player().textTracks();var shouldBeSelected=true;for(var i=0,l=tracks.length;i<l;i++){var track=tracks[i];if(this.options_.kinds.indexOf(track.kind)>-1&&track.mode==='showing'){shouldBeSelected=false;break;}}// Prevent redundant selected() calls because they may cause
// screen readers to read the appended control text unnecessarily
if(shouldBeSelected!==this.isSelected_){this.selected(shouldBeSelected);}};_proto.handleSelectedLanguageChange=function handleSelectedLanguageChange(event){var tracks=this.player().textTracks();var allHidden=true;for(var i=0,l=tracks.length;i<l;i++){var track=tracks[i];if(['captions','descriptions','subtitles'].indexOf(track.kind)>-1&&track.mode==='showing'){allHidden=false;break;}}if(allHidden){this.player_.cache_.selectedLanguage={enabled:false};}};return OffTextTrackMenuItem;}(TextTrackMenuItem);Component$1.registerComponent('OffTextTrackMenuItem',OffTextTrackMenuItem);/**
 * The base class for buttons that toggle specific text track types (e.g. subtitles)
 *
 * @extends MenuButton
 */var TextTrackButton=/*#__PURE__*/function(_TrackButton){_inheritsLoose(TextTrackButton,_TrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function TextTrackButton(player,options){if(options===void 0){options={};}options.tracks=player.textTracks();return _TrackButton.call(this,player,options)||this;}/**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */var _proto=TextTrackButton.prototype;_proto.createItems=function createItems(items,TrackMenuItem){if(items===void 0){items=[];}if(TrackMenuItem===void 0){TrackMenuItem=TextTrackMenuItem;}// Label is an override for the [track] off label
// USed to localise captions/subtitles
var label;if(this.label_){label=this.label_+" off";}// Add an OFF menu item to turn all tracks off
items.push(new OffTextTrackMenuItem(this.player_,{kinds:this.kinds_,kind:this.kind_,label:label}));this.hideThreshold_+=1;var tracks=this.player_.textTracks();if(!Array.isArray(this.kinds_)){this.kinds_=[this.kind_];}for(var i=0;i<tracks.length;i++){var track=tracks[i];// only add tracks that are of an appropriate kind and have a label
if(this.kinds_.indexOf(track.kind)>-1){var item=new TrackMenuItem(this.player_,{track:track,kinds:this.kinds_,kind:this.kind_,// MenuItem is selectable
selectable:true,// MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
multiSelectable:false});item.addClass("vjs-"+track.kind+"-menu-item");items.push(item);}}return items;};return TextTrackButton;}(TrackButton);Component$1.registerComponent('TextTrackButton',TextTrackButton);/**
 * The chapter track menu item
 *
 * @extends MenuItem
 */var ChaptersTrackMenuItem=/*#__PURE__*/function(_MenuItem){_inheritsLoose(ChaptersTrackMenuItem,_MenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function ChaptersTrackMenuItem(player,options){var _this;var track=options.track;var cue=options.cue;var currentTime=player.currentTime();// Modify options for parent MenuItem class's init.
options.selectable=true;options.multiSelectable=false;options.label=cue.text;options.selected=cue.startTime<=currentTime&&currentTime<cue.endTime;_this=_MenuItem.call(this,player,options)||this;_this.track=track;_this.cue=cue;return _this;}/**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */var _proto=ChaptersTrackMenuItem.prototype;_proto.handleClick=function handleClick(event){_MenuItem.prototype.handleClick.call(this);this.player_.currentTime(this.cue.startTime);};return ChaptersTrackMenuItem;}(MenuItem);Component$1.registerComponent('ChaptersTrackMenuItem',ChaptersTrackMenuItem);/**
 * The button component for toggling and selecting chapters
 * Chapters act much differently than other text tracks
 * Cues are navigation vs. other tracks of alternative languages
 *
 * @extends TextTrackButton
 */var ChaptersButton=/*#__PURE__*/function(_TextTrackButton){_inheritsLoose(ChaptersButton,_TextTrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this function is ready.
   */function ChaptersButton(player,options,ready){var _this;_this=_TextTrackButton.call(this,player,options,ready)||this;_this.selectCurrentItem_=function(){_this.items.forEach(function(item){item.selected(_this.track_.activeCues[0]===item.cue);});};return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=ChaptersButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-chapters-button "+_TextTrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-chapters-button "+_TextTrackButton.prototype.buildWrapperCSSClass.call(this);}/**
   * Update the menu based on the current state of its items.
   *
   * @param {EventTarget~Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */;_proto.update=function update(event){if(event&&event.track&&event.track.kind!=='chapters'){return;}var track=this.findChaptersTrack();if(track!==this.track_){this.setTrack(track);_TextTrackButton.prototype.update.call(this);}else if(!this.items||track&&track.cues&&track.cues.length!==this.items.length){// Update the menu initially or if the number of cues has changed since set
_TextTrackButton.prototype.update.call(this);}}/**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */;_proto.setTrack=function setTrack(track){if(this.track_===track){return;}if(!this.updateHandler_){this.updateHandler_=this.update.bind(this);}// here this.track_ refers to the old track instance
if(this.track_){var remoteTextTrackEl=this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);if(remoteTextTrackEl){remoteTextTrackEl.removeEventListener('load',this.updateHandler_);}this.track_.removeEventListener('cuechange',this.selectCurrentItem_);this.track_=null;}this.track_=track;// here this.track_ refers to the new track instance
if(this.track_){this.track_.mode='hidden';var _remoteTextTrackEl=this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);if(_remoteTextTrackEl){_remoteTextTrackEl.addEventListener('load',this.updateHandler_);}this.track_.addEventListener('cuechange',this.selectCurrentItem_);}}/**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */;_proto.findChaptersTrack=function findChaptersTrack(){var tracks=this.player_.textTracks()||[];for(var i=tracks.length-1;i>=0;i--){// We will always choose the last track as our chaptersTrack
var track=tracks[i];if(track.kind===this.kind_){return track;}}}/**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */;_proto.getMenuCaption=function getMenuCaption(){if(this.track_&&this.track_.label){return this.track_.label;}return this.localize(toTitleCase$1(this.kind_));}/**
   * Create menu from chapter track
   *
   * @return {Menu}
   *         New menu for the chapter buttons
   */;_proto.createMenu=function createMenu(){this.options_.title=this.getMenuCaption();return _TextTrackButton.prototype.createMenu.call(this);}/**
   * Create a menu item for each text track
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items
   */;_proto.createItems=function createItems(){var items=[];if(!this.track_){return items;}var cues=this.track_.cues;if(!cues){return items;}for(var i=0,l=cues.length;i<l;i++){var cue=cues[i];var mi=new ChaptersTrackMenuItem(this.player_,{track:this.track_,cue:cue});items.push(mi);}return items;};return ChaptersButton;}(TextTrackButton);/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */ChaptersButton.prototype.kind_='chapters';/**
 * The text that should display over the `ChaptersButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */ChaptersButton.prototype.controlText_='Chapters';Component$1.registerComponent('ChaptersButton',ChaptersButton);/**
 * The button component for toggling and selecting descriptions
 *
 * @extends TextTrackButton
 */var DescriptionsButton=/*#__PURE__*/function(_TextTrackButton){_inheritsLoose(DescriptionsButton,_TextTrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this component is ready.
   */function DescriptionsButton(player,options,ready){var _this;_this=_TextTrackButton.call(this,player,options,ready)||this;var tracks=player.textTracks();var changeHandler=bind(_assertThisInitialized(_this),_this.handleTracksChange);tracks.addEventListener('change',changeHandler);_this.on('dispose',function(){tracks.removeEventListener('change',changeHandler);});return _this;}/**
   * Handle text track change
   *
   * @param {EventTarget~Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */var _proto=DescriptionsButton.prototype;_proto.handleTracksChange=function handleTracksChange(event){var tracks=this.player().textTracks();var disabled=false;// Check whether a track of a different kind is showing
for(var i=0,l=tracks.length;i<l;i++){var track=tracks[i];if(track.kind!==this.kind_&&track.mode==='showing'){disabled=true;break;}}// If another track is showing, disable this menu button
if(disabled){this.disable();}else{this.enable();}}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */;_proto.buildCSSClass=function buildCSSClass(){return"vjs-descriptions-button "+_TextTrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-descriptions-button "+_TextTrackButton.prototype.buildWrapperCSSClass.call(this);};return DescriptionsButton;}(TextTrackButton);/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */DescriptionsButton.prototype.kind_='descriptions';/**
 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */DescriptionsButton.prototype.controlText_='Descriptions';Component$1.registerComponent('DescriptionsButton',DescriptionsButton);/**
 * The button component for toggling and selecting subtitles
 *
 * @extends TextTrackButton
 */var SubtitlesButton=/*#__PURE__*/function(_TextTrackButton){_inheritsLoose(SubtitlesButton,_TextTrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this component is ready.
   */function SubtitlesButton(player,options,ready){return _TextTrackButton.call(this,player,options,ready)||this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=SubtitlesButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-subtitles-button "+_TextTrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-subtitles-button "+_TextTrackButton.prototype.buildWrapperCSSClass.call(this);};return SubtitlesButton;}(TextTrackButton);/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */SubtitlesButton.prototype.kind_='subtitles';/**
 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */SubtitlesButton.prototype.controlText_='Subtitles';Component$1.registerComponent('SubtitlesButton',SubtitlesButton);/**
 * The menu item for caption track settings menu
 *
 * @extends TextTrackMenuItem
 */var CaptionSettingsMenuItem=/*#__PURE__*/function(_TextTrackMenuItem){_inheritsLoose(CaptionSettingsMenuItem,_TextTrackMenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function CaptionSettingsMenuItem(player,options){var _this;options.track={player:player,kind:options.kind,label:options.kind+' settings',selectable:false,"default":false,mode:'disabled'};// CaptionSettingsMenuItem has no concept of 'selected'
options.selectable=false;options.name='CaptionSettingsMenuItem';_this=_TextTrackMenuItem.call(this,player,options)||this;_this.addClass('vjs-texttrack-settings');_this.controlText(', opens '+options.kind+' settings dialog');return _this;}/**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */var _proto=CaptionSettingsMenuItem.prototype;_proto.handleClick=function handleClick(event){this.player().getChild('textTrackSettings').open();};return CaptionSettingsMenuItem;}(TextTrackMenuItem);Component$1.registerComponent('CaptionSettingsMenuItem',CaptionSettingsMenuItem);/**
 * The button component for toggling and selecting captions
 *
 * @extends TextTrackButton
 */var CaptionsButton=/*#__PURE__*/function(_TextTrackButton){_inheritsLoose(CaptionsButton,_TextTrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Component~ReadyCallback} [ready]
   *        The function to call when this component is ready.
   */function CaptionsButton(player,options,ready){return _TextTrackButton.call(this,player,options,ready)||this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=CaptionsButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-captions-button "+_TextTrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-captions-button "+_TextTrackButton.prototype.buildWrapperCSSClass.call(this);}/**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */;_proto.createItems=function createItems(){var items=[];if(!(this.player().tech_&&this.player().tech_.featuresNativeTextTracks)&&this.player().getChild('textTrackSettings')){items.push(new CaptionSettingsMenuItem(this.player_,{kind:this.kind_}));this.hideThreshold_+=1;}return _TextTrackButton.prototype.createItems.call(this,items);};return CaptionsButton;}(TextTrackButton);/**
 * `kind` of TextTrack to look for to associate it with this menu.
 *
 * @type {string}
 * @private
 */CaptionsButton.prototype.kind_='captions';/**
 * The text that should display over the `CaptionsButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */CaptionsButton.prototype.controlText_='Captions';Component$1.registerComponent('CaptionsButton',CaptionsButton);/**
 * SubsCapsMenuItem has an [cc] icon to distinguish captions from subtitles
 * in the SubsCapsMenu.
 *
 * @extends TextTrackMenuItem
 */var SubsCapsMenuItem=/*#__PURE__*/function(_TextTrackMenuItem){_inheritsLoose(SubsCapsMenuItem,_TextTrackMenuItem);function SubsCapsMenuItem(){return _TextTrackMenuItem.apply(this,arguments)||this;}var _proto=SubsCapsMenuItem.prototype;_proto.createEl=function createEl$1(type,props,attrs){var el=_TextTrackMenuItem.prototype.createEl.call(this,type,props,attrs);var parentSpan=el.querySelector('.vjs-menu-item-text');if(this.options_.track.kind==='captions'){parentSpan.appendChild(createEl('span',{className:'vjs-icon-placeholder'},{'aria-hidden':true}));parentSpan.appendChild(createEl('span',{className:'vjs-control-text',// space added as the text will visually flow with the
// label
textContent:" "+this.localize('Captions')}));}return el;};return SubsCapsMenuItem;}(TextTrackMenuItem);Component$1.registerComponent('SubsCapsMenuItem',SubsCapsMenuItem);/**
 * The button component for toggling and selecting captions and/or subtitles
 *
 * @extends TextTrackButton
 */var SubsCapsButton=/*#__PURE__*/function(_TextTrackButton){_inheritsLoose(SubsCapsButton,_TextTrackButton);function SubsCapsButton(player,options){var _this;if(options===void 0){options={};}_this=_TextTrackButton.call(this,player,options)||this;// Although North America uses "captions" in most cases for
// "captions and subtitles" other locales use "subtitles"
_this.label_='subtitles';if(['en','en-us','en-ca','fr-ca'].indexOf(_this.player_.language_)>-1){_this.label_='captions';}_this.menuButton_.controlText(toTitleCase$1(_this.label_));return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=SubsCapsButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-subs-caps-button "+_TextTrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-subs-caps-button "+_TextTrackButton.prototype.buildWrapperCSSClass.call(this);}/**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */;_proto.createItems=function createItems(){var items=[];if(!(this.player().tech_&&this.player().tech_.featuresNativeTextTracks)&&this.player().getChild('textTrackSettings')){items.push(new CaptionSettingsMenuItem(this.player_,{kind:this.label_}));this.hideThreshold_+=1;}items=_TextTrackButton.prototype.createItems.call(this,items,SubsCapsMenuItem);return items;};return SubsCapsButton;}(TextTrackButton);/**
 * `kind`s of TextTrack to look for to associate it with this menu.
 *
 * @type {array}
 * @private
 */SubsCapsButton.prototype.kinds_=['captions','subtitles'];/**
 * The text that should display over the `SubsCapsButton`s controls.
 *
 *
 * @type {string}
 * @private
 */SubsCapsButton.prototype.controlText_='Subtitles';Component$1.registerComponent('SubsCapsButton',SubsCapsButton);/**
 * An {@link AudioTrack} {@link MenuItem}
 *
 * @extends MenuItem
 */var AudioTrackMenuItem=/*#__PURE__*/function(_MenuItem){_inheritsLoose(AudioTrackMenuItem,_MenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function AudioTrackMenuItem(player,options){var _this;var track=options.track;var tracks=player.audioTracks();// Modify options for parent MenuItem class's init.
options.label=track.label||track.language||'Unknown';options.selected=track.enabled;_this=_MenuItem.call(this,player,options)||this;_this.track=track;_this.addClass("vjs-"+track.kind+"-menu-item");var changeHandler=function changeHandler(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this.handleTracksChange.apply(_assertThisInitialized(_this),args);};tracks.addEventListener('change',changeHandler);_this.on('dispose',function(){tracks.removeEventListener('change',changeHandler);});return _this;}var _proto=AudioTrackMenuItem.prototype;_proto.createEl=function createEl$1(type,props,attrs){var el=_MenuItem.prototype.createEl.call(this,type,props,attrs);var parentSpan=el.querySelector('.vjs-menu-item-text');if(this.options_.track.kind==='main-desc'){parentSpan.appendChild(createEl('span',{className:'vjs-icon-placeholder'},{'aria-hidden':true}));parentSpan.appendChild(createEl('span',{className:'vjs-control-text',textContent:' '+this.localize('Descriptions')}));}return el;}/**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){_MenuItem.prototype.handleClick.call(this,event);// the audio track list will automatically toggle other tracks
// off for us.
this.track.enabled=true;// when native audio tracks are used, we want to make sure that other tracks are turned off
if(this.player_.tech_.featuresNativeAudioTracks){var tracks=this.player_.audioTracks();for(var i=0;i<tracks.length;i++){var track=tracks[i];// skip the current track since we enabled it above
if(track===this.track){continue;}track.enabled=track===this.track;}}}/**
   * Handle any {@link AudioTrack} change.
   *
   * @param {EventTarget~Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */;_proto.handleTracksChange=function handleTracksChange(event){this.selected(this.track.enabled);};return AudioTrackMenuItem;}(MenuItem);Component$1.registerComponent('AudioTrackMenuItem',AudioTrackMenuItem);/**
 * The base class for buttons that toggle specific {@link AudioTrack} types.
 *
 * @extends TrackButton
 */var AudioTrackButton=/*#__PURE__*/function(_TrackButton){_inheritsLoose(AudioTrackButton,_TrackButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */function AudioTrackButton(player,options){if(options===void 0){options={};}options.tracks=player.audioTracks();return _TrackButton.call(this,player,options)||this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */var _proto=AudioTrackButton.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-audio-button "+_TrackButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-audio-button "+_TrackButton.prototype.buildWrapperCSSClass.call(this);}/**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */;_proto.createItems=function createItems(items){if(items===void 0){items=[];}// if there's only one audio track, there no point in showing it
this.hideThreshold_=1;var tracks=this.player_.audioTracks();for(var i=0;i<tracks.length;i++){var track=tracks[i];items.push(new AudioTrackMenuItem(this.player_,{track:track,// MenuItem is selectable
selectable:true,// MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
multiSelectable:false}));}return items;};return AudioTrackButton;}(TrackButton);/**
 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */AudioTrackButton.prototype.controlText_='Audio Track';Component$1.registerComponent('AudioTrackButton',AudioTrackButton);/**
 * The specific menu item type for selecting a playback rate.
 *
 * @extends MenuItem
 */var PlaybackRateMenuItem=/*#__PURE__*/function(_MenuItem){_inheritsLoose(PlaybackRateMenuItem,_MenuItem);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function PlaybackRateMenuItem(player,options){var _this;var label=options.rate;var rate=parseFloat(label,10);// Modify options for parent MenuItem class's init.
options.label=label;options.selected=rate===player.playbackRate();options.selectable=true;options.multiSelectable=false;_this=_MenuItem.call(this,player,options)||this;_this.label=label;_this.rate=rate;_this.on(player,'ratechange',function(e){return _this.update(e);});return _this;}/**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */var _proto=PlaybackRateMenuItem.prototype;_proto.handleClick=function handleClick(event){_MenuItem.prototype.handleClick.call(this);this.player().playbackRate(this.rate);}/**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {EventTarget~Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */;_proto.update=function update(event){this.selected(this.player().playbackRate()===this.rate);};return PlaybackRateMenuItem;}(MenuItem);/**
 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */PlaybackRateMenuItem.prototype.contentElType='button';Component$1.registerComponent('PlaybackRateMenuItem',PlaybackRateMenuItem);/**
 * The component for controlling the playback rate.
 *
 * @extends MenuButton
 */var PlaybackRateMenuButton=/*#__PURE__*/function(_MenuButton){_inheritsLoose(PlaybackRateMenuButton,_MenuButton);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */function PlaybackRateMenuButton(player,options){var _this;_this=_MenuButton.call(this,player,options)||this;_this.menuButton_.el_.setAttribute('aria-describedby',_this.labelElId_);_this.updateVisibility();_this.updateLabel();_this.on(player,'loadstart',function(e){return _this.updateVisibility(e);});_this.on(player,'ratechange',function(e){return _this.updateLabel(e);});_this.on(player,'playbackrateschange',function(e){return _this.handlePlaybackRateschange(e);});return _this;}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */var _proto=PlaybackRateMenuButton.prototype;_proto.createEl=function createEl$1(){var el=_MenuButton.prototype.createEl.call(this);this.labelElId_='vjs-playback-rate-value-label-'+this.id_;this.labelEl_=createEl('div',{className:'vjs-playback-rate-value',id:this.labelElId_,textContent:'1x'});el.appendChild(this.labelEl_);return el;};_proto.dispose=function dispose(){this.labelEl_=null;_MenuButton.prototype.dispose.call(this);}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */;_proto.buildCSSClass=function buildCSSClass(){return"vjs-playback-rate "+_MenuButton.prototype.buildCSSClass.call(this);};_proto.buildWrapperCSSClass=function buildWrapperCSSClass(){return"vjs-playback-rate "+_MenuButton.prototype.buildWrapperCSSClass.call(this);}/**
   * Create the list of menu items. Specific to each subclass.
   *
   */;_proto.createItems=function createItems(){var rates=this.playbackRates();var items=[];for(var i=rates.length-1;i>=0;i--){items.push(new PlaybackRateMenuItem(this.player(),{rate:rates[i]+'x'}));}return items;}/**
   * Updates ARIA accessibility attributes
   */;_proto.updateARIAAttributes=function updateARIAAttributes(){// Current playback rate
this.el().setAttribute('aria-valuenow',this.player().playbackRate());}/**
   * This gets called when an `PlaybackRateMenuButton` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {EventTarget~Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */;_proto.handleClick=function handleClick(event){// select next rate option
var currentRate=this.player().playbackRate();var rates=this.playbackRates();var currentIndex=rates.indexOf(currentRate);// this get the next rate and it will select first one if the last one currently selected
var newIndex=(currentIndex+1)%rates.length;this.player().playbackRate(rates[newIndex]);}/**
   * On playbackrateschange, update the menu to account for the new items.
   *
   * @listens Player#playbackrateschange
   */;_proto.handlePlaybackRateschange=function handlePlaybackRateschange(event){this.update();}/**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */;_proto.playbackRates=function playbackRates(){var player=this.player();return player.playbackRates&&player.playbackRates()||[];}/**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */;_proto.playbackRateSupported=function playbackRateSupported(){return this.player().tech_&&this.player().tech_.featuresPlaybackRate&&this.playbackRates()&&this.playbackRates().length>0;}/**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */;_proto.updateVisibility=function updateVisibility(event){if(this.playbackRateSupported()){this.removeClass('vjs-hidden');}else{this.addClass('vjs-hidden');}}/**
   * Update button label when rate changed
   *
   * @param {EventTarget~Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */;_proto.updateLabel=function updateLabel(event){if(this.playbackRateSupported()){this.labelEl_.textContent=this.player().playbackRate()+'x';}};return PlaybackRateMenuButton;}(MenuButton);/**
 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */PlaybackRateMenuButton.prototype.controlText_='Playback Rate';Component$1.registerComponent('PlaybackRateMenuButton',PlaybackRateMenuButton);/**
 * Just an empty spacer element that can be used as an append point for plugins, etc.
 * Also can be used to create space between elements when necessary.
 *
 * @extends Component
 */var Spacer=/*#__PURE__*/function(_Component){_inheritsLoose(Spacer,_Component);function Spacer(){return _Component.apply(this,arguments)||this;}var _proto=Spacer.prototype;/**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */_proto.buildCSSClass=function buildCSSClass(){return"vjs-spacer "+_Component.prototype.buildCSSClass.call(this);}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl(tag,props,attributes){if(tag===void 0){tag='div';}if(props===void 0){props={};}if(attributes===void 0){attributes={};}if(!props.className){props.className=this.buildCSSClass();}return _Component.prototype.createEl.call(this,tag,props,attributes);};return Spacer;}(Component$1);Component$1.registerComponent('Spacer',Spacer);/**
 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
 *
 * @extends Spacer
 */var CustomControlSpacer=/*#__PURE__*/function(_Spacer){_inheritsLoose(CustomControlSpacer,_Spacer);function CustomControlSpacer(){return _Spacer.apply(this,arguments)||this;}var _proto=CustomControlSpacer.prototype;/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */_proto.buildCSSClass=function buildCSSClass(){return"vjs-custom-control-spacer "+_Spacer.prototype.buildCSSClass.call(this);}/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */;_proto.createEl=function createEl(){return _Spacer.prototype.createEl.call(this,'div',{className:this.buildCSSClass(),// No-flex/table-cell mode requires there be some content
// in the cell to fill the remaining space of the table.
textContent:"\xA0"});};return CustomControlSpacer;}(Spacer);Component$1.registerComponent('CustomControlSpacer',CustomControlSpacer);/**
 * Container of main controls.
 *
 * @extends Component
 */var ControlBar=/*#__PURE__*/function(_Component){_inheritsLoose(ControlBar,_Component);function ControlBar(){return _Component.apply(this,arguments)||this;}var _proto=ControlBar.prototype;/**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'div',{className:'vjs-control-bar',dir:'ltr'});};return ControlBar;}(Component$1);/**
 * Default options for `ControlBar`
 *
 * @type {Object}
 * @private
 */ControlBar.prototype.options_={children:['playToggle','volumePanel','currentTimeDisplay','timeDivider','durationDisplay','progressControl','liveDisplay','seekToLive','remainingTimeDisplay','customControlSpacer','playbackRateMenuButton','chaptersButton','descriptionsButton','subsCapsButton','audioTrackButton','fullscreenToggle']};if('exitPictureInPicture'in (document_default())){ControlBar.prototype.options_.children.splice(ControlBar.prototype.options_.children.length-1,0,'pictureInPictureToggle');}Component$1.registerComponent('ControlBar',ControlBar);/**
 * A display that indicates an error has occurred. This means that the video
 * is unplayable.
 *
 * @extends ModalDialog
 */var ErrorDisplay=/*#__PURE__*/function(_ModalDialog){_inheritsLoose(ErrorDisplay,_ModalDialog);/**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */function ErrorDisplay(player,options){var _this;_this=_ModalDialog.call(this,player,options)||this;_this.on(player,'error',function(e){return _this.open(e);});return _this;}/**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */var _proto=ErrorDisplay.prototype;_proto.buildCSSClass=function buildCSSClass(){return"vjs-error-display "+_ModalDialog.prototype.buildCSSClass.call(this);}/**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */;_proto.content=function content(){var error=this.player().error();return error?this.localize(error.message):'';};return ErrorDisplay;}(ModalDialog);/**
 * The default options for an `ErrorDisplay`.
 *
 * @private
 */ErrorDisplay.prototype.options_=_extends({},ModalDialog.prototype.options_,{pauseOnOpen:false,fillAlways:true,temporary:false,uncloseable:true});Component$1.registerComponent('ErrorDisplay',ErrorDisplay);var LOCAL_STORAGE_KEY$1='vjs-text-track-settings';var COLOR_BLACK=['#000','Black'];var COLOR_BLUE=['#00F','Blue'];var COLOR_CYAN=['#0FF','Cyan'];var COLOR_GREEN=['#0F0','Green'];var COLOR_MAGENTA=['#F0F','Magenta'];var COLOR_RED=['#F00','Red'];var COLOR_WHITE=['#FFF','White'];var COLOR_YELLOW=['#FF0','Yellow'];var OPACITY_OPAQUE=['1','Opaque'];var OPACITY_SEMI=['0.5','Semi-Transparent'];var OPACITY_TRANS=['0','Transparent'];// Configuration for the various <select> elements in the DOM of this component.
//
// Possible keys include:
//
// `default`:
//   The default option index. Only needs to be provided if not zero.
// `parser`:
//   A function which is used to parse the value from the selected option in
//   a customized way.
// `selector`:
//   The selector used to find the associated <select> element.
var selectConfigs={backgroundColor:{selector:'.vjs-bg-color > select',id:'captions-background-color-%s',label:'Color',options:[COLOR_BLACK,COLOR_WHITE,COLOR_RED,COLOR_GREEN,COLOR_BLUE,COLOR_YELLOW,COLOR_MAGENTA,COLOR_CYAN]},backgroundOpacity:{selector:'.vjs-bg-opacity > select',id:'captions-background-opacity-%s',label:'Transparency',options:[OPACITY_OPAQUE,OPACITY_SEMI,OPACITY_TRANS]},color:{selector:'.vjs-fg-color > select',id:'captions-foreground-color-%s',label:'Color',options:[COLOR_WHITE,COLOR_BLACK,COLOR_RED,COLOR_GREEN,COLOR_BLUE,COLOR_YELLOW,COLOR_MAGENTA,COLOR_CYAN]},edgeStyle:{selector:'.vjs-edge-style > select',id:'%s',label:'Text Edge Style',options:[['none','None'],['raised','Raised'],['depressed','Depressed'],['uniform','Uniform'],['dropshadow','Dropshadow']]},fontFamily:{selector:'.vjs-font-family > select',id:'captions-font-family-%s',label:'Font Family',options:[['proportionalSansSerif','Proportional Sans-Serif'],['monospaceSansSerif','Monospace Sans-Serif'],['proportionalSerif','Proportional Serif'],['monospaceSerif','Monospace Serif'],['casual','Casual'],['script','Script'],['small-caps','Small Caps']]},fontPercent:{selector:'.vjs-font-percent > select',id:'captions-font-size-%s',label:'Font Size',options:[['0.50','50%'],['0.75','75%'],['1.00','100%'],['1.25','125%'],['1.50','150%'],['1.75','175%'],['2.00','200%'],['3.00','300%'],['4.00','400%']],"default":2,parser:function parser(v){return v==='1.00'?null:Number(v);}},textOpacity:{selector:'.vjs-text-opacity > select',id:'captions-foreground-opacity-%s',label:'Transparency',options:[OPACITY_OPAQUE,OPACITY_SEMI]},// Options for this object are defined below.
windowColor:{selector:'.vjs-window-color > select',id:'captions-window-color-%s',label:'Color'},// Options for this object are defined below.
windowOpacity:{selector:'.vjs-window-opacity > select',id:'captions-window-opacity-%s',label:'Transparency',options:[OPACITY_TRANS,OPACITY_SEMI,OPACITY_OPAQUE]}};selectConfigs.windowColor.options=selectConfigs.backgroundColor.options;/**
 * Get the actual value of an option.
 *
 * @param  {string} value
 *         The value to get
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {Mixed}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */function parseOptionValue(value,parser){if(parser){value=parser(value);}if(value&&value!=='none'){return value;}}/**
 * Gets the value of the selected <option> element within a <select> element.
 *
 * @param  {Element} el
 *         the element to look in
 *
 * @param  {Function} [parser]
 *         Optional function to adjust the value.
 *
 * @return {Mixed}
 *         - Will be `undefined` if no value exists
 *         - Will be `undefined` if the given value is "none".
 *         - Will be the actual value otherwise.
 *
 * @private
 */function getSelectedOptionValue(el,parser){var value=el.options[el.options.selectedIndex].value;return parseOptionValue(value,parser);}/**
 * Sets the selected <option> element within a <select> element based on a
 * given value.
 *
 * @param {Element} el
 *        The element to look in.
 *
 * @param {string} value
 *        the property to look on.
 *
 * @param {Function} [parser]
 *        Optional function to adjust the value before comparing.
 *
 * @private
 */function setSelectedOption(el,value,parser){if(!value){return;}for(var i=0;i<el.options.length;i++){if(parseOptionValue(el.options[i].value,parser)===value){el.selectedIndex=i;break;}}}/**
 * Manipulate Text Tracks settings.
 *
 * @extends ModalDialog
 */var TextTrackSettings=/*#__PURE__*/function(_ModalDialog){_inheritsLoose(TextTrackSettings,_ModalDialog);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */function TextTrackSettings(player,options){var _this;options.temporary=false;_this=_ModalDialog.call(this,player,options)||this;_this.updateDisplay=_this.updateDisplay.bind(_assertThisInitialized(_this));// fill the modal and pretend we have opened it
_this.fill();_this.hasBeenOpened_=_this.hasBeenFilled_=true;_this.endDialog=createEl('p',{className:'vjs-control-text',textContent:_this.localize('End of dialog window.')});_this.el().appendChild(_this.endDialog);_this.setDefaults();// Grab `persistTextTrackSettings` from the player options if not passed in child options
if(options.persistTextTrackSettings===undefined){_this.options_.persistTextTrackSettings=_this.options_.playerOptions.persistTextTrackSettings;}_this.on(_this.$('.vjs-done-button'),'click',function(){_this.saveSettings();_this.close();});_this.on(_this.$('.vjs-default-button'),'click',function(){_this.setDefaults();_this.updateDisplay();});each(selectConfigs,function(config){_this.on(_this.$(config.selector),'change',_this.updateDisplay);});if(_this.options_.persistTextTrackSettings){_this.restoreSettings();}return _this;}var _proto=TextTrackSettings.prototype;_proto.dispose=function dispose(){this.endDialog=null;_ModalDialog.prototype.dispose.call(this);}/**
   * Create a <select> element with configured options.
   *
   * @param {string} key
   *        Configuration key to use during creation.
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */;_proto.createElSelect_=function createElSelect_(key,legendId,type){var _this2=this;if(legendId===void 0){legendId='';}if(type===void 0){type='label';}var config=selectConfigs[key];var id=config.id.replace('%s',this.id_);var selectLabelledbyIds=[legendId,id].join(' ').trim();return["<"+type+" id=\""+id+"\" class=\""+(type==='label'?'vjs-label':'')+"\">",this.localize(config.label),"</"+type+">","<select aria-labelledby=\""+selectLabelledbyIds+"\">"].concat(config.options.map(function(o){var optionId=id+'-'+o[1].replace(/\W+/g,'');return["<option id=\""+optionId+"\" value=\""+o[0]+"\" ","aria-labelledby=\""+selectLabelledbyIds+" "+optionId+"\">",_this2.localize(o[1]),'</option>'].join('');})).concat('</select>').join('');}/**
   * Create foreground color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */;_proto.createElFgColor_=function createElFgColor_(){var legendId="captions-text-legend-"+this.id_;return['<fieldset class="vjs-fg-color vjs-track-setting">',"<legend id=\""+legendId+"\">",this.localize('Text'),'</legend>',this.createElSelect_('color',legendId),'<span class="vjs-text-opacity vjs-opacity">',this.createElSelect_('textOpacity',legendId),'</span>','</fieldset>'].join('');}/**
   * Create background color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */;_proto.createElBgColor_=function createElBgColor_(){var legendId="captions-background-"+this.id_;return['<fieldset class="vjs-bg-color vjs-track-setting">',"<legend id=\""+legendId+"\">",this.localize('Background'),'</legend>',this.createElSelect_('backgroundColor',legendId),'<span class="vjs-bg-opacity vjs-opacity">',this.createElSelect_('backgroundOpacity',legendId),'</span>','</fieldset>'].join('');}/**
   * Create window color element for the component
   *
   * @return {string}
   *         An HTML string.
   *
   * @private
   */;_proto.createElWinColor_=function createElWinColor_(){var legendId="captions-window-"+this.id_;return['<fieldset class="vjs-window-color vjs-track-setting">',"<legend id=\""+legendId+"\">",this.localize('Window'),'</legend>',this.createElSelect_('windowColor',legendId),'<span class="vjs-window-opacity vjs-opacity">',this.createElSelect_('windowOpacity',legendId),'</span>','</fieldset>'].join('');}/**
   * Create color elements for the component
   *
   * @return {Element}
   *         The element that was created
   *
   * @private
   */;_proto.createElColors_=function createElColors_(){return createEl('div',{className:'vjs-track-settings-colors',innerHTML:[this.createElFgColor_(),this.createElBgColor_(),this.createElWinColor_()].join('')});}/**
   * Create font elements for the component
   *
   * @return {Element}
   *         The element that was created.
   *
   * @private
   */;_proto.createElFont_=function createElFont_(){return createEl('div',{className:'vjs-track-settings-font',innerHTML:['<fieldset class="vjs-font-percent vjs-track-setting">',this.createElSelect_('fontPercent','','legend'),'</fieldset>','<fieldset class="vjs-edge-style vjs-track-setting">',this.createElSelect_('edgeStyle','','legend'),'</fieldset>','<fieldset class="vjs-font-family vjs-track-setting">',this.createElSelect_('fontFamily','','legend'),'</fieldset>'].join('')});}/**
   * Create controls for the component
   *
   * @return {Element}
   *         The element that was created.
   *
   * @private
   */;_proto.createElControls_=function createElControls_(){var defaultsDescription=this.localize('restore all settings to the default values');return createEl('div',{className:'vjs-track-settings-controls',innerHTML:["<button type=\"button\" class=\"vjs-default-button\" title=\""+defaultsDescription+"\">",this.localize('Reset'),"<span class=\"vjs-control-text\"> "+defaultsDescription+"</span>",'</button>',"<button type=\"button\" class=\"vjs-done-button\">"+this.localize('Done')+"</button>"].join('')});};_proto.content=function content(){return[this.createElColors_(),this.createElFont_(),this.createElControls_()];};_proto.label=function label(){return this.localize('Caption Settings Dialog');};_proto.description=function description(){return this.localize('Beginning of dialog window. Escape will cancel and close the window.');};_proto.buildCSSClass=function buildCSSClass(){return _ModalDialog.prototype.buildCSSClass.call(this)+' vjs-text-track-settings';}/**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */;_proto.getValues=function getValues(){var _this3=this;return reduce(selectConfigs,function(accum,config,key){var value=getSelectedOptionValue(_this3.$(config.selector),config.parser);if(value!==undefined){accum[key]=value;}return accum;},{});}/**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */;_proto.setValues=function setValues(values){var _this4=this;each(selectConfigs,function(config,key){setSelectedOption(_this4.$(config.selector),values[key],config.parser);});}/**
   * Sets all `<select>` elements to their default values.
   */;_proto.setDefaults=function setDefaults(){var _this5=this;each(selectConfigs,function(config){var index=config.hasOwnProperty('default')?config["default"]:0;_this5.$(config.selector).selectedIndex=index;});}/**
   * Restore texttrack settings from localStorage
   */;_proto.restoreSettings=function restoreSettings(){var values;try{values=JSON.parse(window_default().localStorage.getItem(LOCAL_STORAGE_KEY$1));}catch(err){log$1.warn(err);}if(values){this.setValues(values);}}/**
   * Save text track settings to localStorage
   */;_proto.saveSettings=function saveSettings(){if(!this.options_.persistTextTrackSettings){return;}var values=this.getValues();try{if(Object.keys(values).length){window_default().localStorage.setItem(LOCAL_STORAGE_KEY$1,JSON.stringify(values));}else{window_default().localStorage.removeItem(LOCAL_STORAGE_KEY$1);}}catch(err){log$1.warn(err);}}/**
   * Update display of text track settings
   */;_proto.updateDisplay=function updateDisplay(){var ttDisplay=this.player_.getChild('textTrackDisplay');if(ttDisplay){ttDisplay.updateDisplay();}}/**
   * conditionally blur the element and refocus the captions button
   *
   * @private
   */;_proto.conditionalBlur_=function conditionalBlur_(){this.previouslyActiveEl_=null;var cb=this.player_.controlBar;var subsCapsBtn=cb&&cb.subsCapsButton;var ccBtn=cb&&cb.captionsButton;if(subsCapsBtn){subsCapsBtn.focus();}else if(ccBtn){ccBtn.focus();}};return TextTrackSettings;}(ModalDialog);Component$1.registerComponent('TextTrackSettings',TextTrackSettings);/**
 * A Resize Manager. It is in charge of triggering `playerresize` on the player in the right conditions.
 *
 * It'll either create an iframe and use a debounced resize handler on it or use the new {@link https://wicg.github.io/ResizeObserver/|ResizeObserver}.
 *
 * If the ResizeObserver is available natively, it will be used. A polyfill can be passed in as an option.
 * If a `playerresize` event is not needed, the ResizeManager component can be removed from the player, see the example below.
 * @example <caption>How to disable the resize manager</caption>
 * const player = videojs('#vid', {
 *   resizeManager: false
 * });
 *
 * @see {@link https://wicg.github.io/ResizeObserver/|ResizeObserver specification}
 *
 * @extends Component
 */var ResizeManager=/*#__PURE__*/function(_Component){_inheritsLoose(ResizeManager,_Component);/**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */function ResizeManager(player,options){var _this;var RESIZE_OBSERVER_AVAILABLE=options.ResizeObserver||(window_default()).ResizeObserver;// if `null` was passed, we want to disable the ResizeObserver
if(options.ResizeObserver===null){RESIZE_OBSERVER_AVAILABLE=false;}// Only create an element when ResizeObserver isn't available
var options_=mergeOptions$3({createEl:!RESIZE_OBSERVER_AVAILABLE,reportTouchActivity:false},options);_this=_Component.call(this,player,options_)||this;_this.ResizeObserver=options.ResizeObserver||(window_default()).ResizeObserver;_this.loadListener_=null;_this.resizeObserver_=null;_this.debouncedHandler_=debounce(function(){_this.resizeHandler();},100,false,_assertThisInitialized(_this));if(RESIZE_OBSERVER_AVAILABLE){_this.resizeObserver_=new _this.ResizeObserver(_this.debouncedHandler_);_this.resizeObserver_.observe(player.el());}else{_this.loadListener_=function(){if(!_this.el_||!_this.el_.contentWindow){return;}var debouncedHandler_=_this.debouncedHandler_;var unloadListener_=_this.unloadListener_=function(){off(this,'resize',debouncedHandler_);off(this,'unload',unloadListener_);unloadListener_=null;};// safari and edge can unload the iframe before resizemanager dispose
// we have to dispose of event handlers correctly before that happens
on(_this.el_.contentWindow,'unload',unloadListener_);on(_this.el_.contentWindow,'resize',debouncedHandler_);};_this.one('load',_this.loadListener_);}return _this;}var _proto=ResizeManager.prototype;_proto.createEl=function createEl(){return _Component.prototype.createEl.call(this,'iframe',{className:'vjs-resize-manager',tabIndex:-1,title:this.localize('No content')},{'aria-hidden':'true'});}/**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */;_proto.resizeHandler=function resizeHandler(){/**
     * Called when the player size has changed
     *
     * @event Player#playerresize
     * @type {EventTarget~Event}
     */ // make sure player is still around to trigger
// prevents this from causing an error after dispose
if(!this.player_||!this.player_.trigger){return;}this.player_.trigger('playerresize');};_proto.dispose=function dispose(){if(this.debouncedHandler_){this.debouncedHandler_.cancel();}if(this.resizeObserver_){if(this.player_.el()){this.resizeObserver_.unobserve(this.player_.el());}this.resizeObserver_.disconnect();}if(this.loadListener_){this.off('load',this.loadListener_);}if(this.el_&&this.el_.contentWindow&&this.unloadListener_){this.unloadListener_.call(this.el_.contentWindow);}this.ResizeObserver=null;this.resizeObserver=null;this.debouncedHandler_=null;this.loadListener_=null;_Component.prototype.dispose.call(this);};return ResizeManager;}(Component$1);Component$1.registerComponent('ResizeManager',ResizeManager);var defaults={trackingThreshold:20,liveTolerance:15};/*
  track when we are at the live edge, and other helpers for live playback */ /**
 * A class for checking live current time and determining when the player
 * is at or behind the live edge.
 */var LiveTracker=/*#__PURE__*/function(_Component){_inheritsLoose(LiveTracker,_Component);/**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {number} [options.trackingThreshold=20]
   *        Number of seconds of live window (seekableEnd - seekableStart) that
   *        media needs to have before the liveui will be shown.
   *
   * @param {number} [options.liveTolerance=15]
   *        Number of seconds behind live that we have to be
   *        before we will be considered non-live. Note that this will only
   *        be used when playing at the live edge. This allows large seekable end
   *        changes to not effect wether we are live or not.
   */function LiveTracker(player,options){var _this;// LiveTracker does not need an element
var options_=mergeOptions$3(defaults,options,{createEl:false});_this=_Component.call(this,player,options_)||this;_this.handleVisibilityChange_=function(e){return _this.handleVisibilityChange(e);};_this.trackLiveHandler_=function(){return _this.trackLive_();};_this.handlePlay_=function(e){return _this.handlePlay(e);};_this.handleFirstTimeupdate_=function(e){return _this.handleFirstTimeupdate(e);};_this.handleSeeked_=function(e){return _this.handleSeeked(e);};_this.seekToLiveEdge_=function(e){return _this.seekToLiveEdge(e);};_this.reset_();_this.on(_this.player_,'durationchange',function(e){return _this.handleDurationchange(e);});// we should try to toggle tracking on canplay as native playback engines, like Safari
// may not have the proper values for things like seekableEnd until then
_this.on(_this.player_,'canplay',function(){return _this.toggleTracking();});// we don't need to track live playback if the document is hidden,
// also, tracking when the document is hidden can
// cause the CPU to spike and eventually crash the page on IE11.
if(IE_VERSION&&'hidden'in (document_default())&&'visibilityState'in (document_default())){_this.on((document_default()),'visibilitychange',_this.handleVisibilityChange_);}return _this;}/**
   * toggle tracking based on document visiblility
   */var _proto=LiveTracker.prototype;_proto.handleVisibilityChange=function handleVisibilityChange(){if(this.player_.duration()!==Infinity){return;}if((document_default()).hidden){this.stopTracking();}else{this.startTracking();}}/**
   * all the functionality for tracking when seek end changes
   * and for tracking how far past seek end we should be
   */;_proto.trackLive_=function trackLive_(){var seekable=this.player_.seekable();// skip undefined seekable
if(!seekable||!seekable.length){return;}var newTime=Number(window_default().performance.now().toFixed(4));var deltaTime=this.lastTime_===-1?0:(newTime-this.lastTime_)/1000;this.lastTime_=newTime;this.pastSeekEnd_=this.pastSeekEnd()+deltaTime;var liveCurrentTime=this.liveCurrentTime();var currentTime=this.player_.currentTime();// we are behind live if any are true
// 1. the player is paused
// 2. the user seeked to a location 2 seconds away from live
// 3. the difference between live and current time is greater
//    liveTolerance which defaults to 15s
var isBehind=this.player_.paused()||this.seekedBehindLive_||Math.abs(liveCurrentTime-currentTime)>this.options_.liveTolerance;// we cannot be behind if
// 1. until we have not seen a timeupdate yet
// 2. liveCurrentTime is Infinity, which happens on Android and Native Safari
if(!this.timeupdateSeen_||liveCurrentTime===Infinity){isBehind=false;}if(isBehind!==this.behindLiveEdge_){this.behindLiveEdge_=isBehind;this.trigger('liveedgechange');}}/**
   * handle a durationchange event on the player
   * and start/stop tracking accordingly.
   */;_proto.handleDurationchange=function handleDurationchange(){this.toggleTracking();}/**
   * start/stop tracking
   */;_proto.toggleTracking=function toggleTracking(){if(this.player_.duration()===Infinity&&this.liveWindow()>=this.options_.trackingThreshold){if(this.player_.options_.liveui){this.player_.addClass('vjs-liveui');}this.startTracking();}else{this.player_.removeClass('vjs-liveui');this.stopTracking();}}/**
   * start tracking live playback
   */;_proto.startTracking=function startTracking(){if(this.isTracking()){return;}// If we haven't seen a timeupdate, we need to check whether playback
// began before this component started tracking. This can happen commonly
// when using autoplay.
if(!this.timeupdateSeen_){this.timeupdateSeen_=this.player_.hasStarted();}this.trackingInterval_=this.setInterval(this.trackLiveHandler_,UPDATE_REFRESH_INTERVAL);this.trackLive_();this.on(this.player_,['play','pause'],this.trackLiveHandler_);if(!this.timeupdateSeen_){this.one(this.player_,'play',this.handlePlay_);this.one(this.player_,'timeupdate',this.handleFirstTimeupdate_);}else{this.on(this.player_,'seeked',this.handleSeeked_);}}/**
   * handle the first timeupdate on the player if it wasn't already playing
   * when live tracker started tracking.
   */;_proto.handleFirstTimeupdate=function handleFirstTimeupdate(){this.timeupdateSeen_=true;this.on(this.player_,'seeked',this.handleSeeked_);}/**
   * Keep track of what time a seek starts, and listen for seeked
   * to find where a seek ends.
   */;_proto.handleSeeked=function handleSeeked(){var timeDiff=Math.abs(this.liveCurrentTime()-this.player_.currentTime());this.seekedBehindLive_=this.nextSeekedFromUser_&&timeDiff>2;this.nextSeekedFromUser_=false;this.trackLive_();}/**
   * handle the first play on the player, and make sure that we seek
   * right to the live edge.
   */;_proto.handlePlay=function handlePlay(){this.one(this.player_,'timeupdate',this.seekToLiveEdge_);}/**
   * Stop tracking, and set all internal variables to
   * their initial value.
   */;_proto.reset_=function reset_(){this.lastTime_=-1;this.pastSeekEnd_=0;this.lastSeekEnd_=-1;this.behindLiveEdge_=true;this.timeupdateSeen_=false;this.seekedBehindLive_=false;this.nextSeekedFromUser_=false;this.clearInterval(this.trackingInterval_);this.trackingInterval_=null;this.off(this.player_,['play','pause'],this.trackLiveHandler_);this.off(this.player_,'seeked',this.handleSeeked_);this.off(this.player_,'play',this.handlePlay_);this.off(this.player_,'timeupdate',this.handleFirstTimeupdate_);this.off(this.player_,'timeupdate',this.seekToLiveEdge_);}/**
   * The next seeked event is from the user. Meaning that any seek
   * > 2s behind live will be considered behind live for real and
   * liveTolerance will be ignored.
   */;_proto.nextSeekedFromUser=function nextSeekedFromUser(){this.nextSeekedFromUser_=true;}/**
   * stop tracking live playback
   */;_proto.stopTracking=function stopTracking(){if(!this.isTracking()){return;}this.reset_();this.trigger('liveedgechange');}/**
   * A helper to get the player seekable end
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The furthest seekable end or Infinity.
   */;_proto.seekableEnd=function seekableEnd(){var seekable=this.player_.seekable();var seekableEnds=[];var i=seekable?seekable.length:0;while(i--){seekableEnds.push(seekable.end(i));}// grab the furthest seekable end after sorting, or if there are none
// default to Infinity
return seekableEnds.length?seekableEnds.sort()[seekableEnds.length-1]:Infinity;}/**
   * A helper to get the player seekable start
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The earliest seekable start or 0.
   */;_proto.seekableStart=function seekableStart(){var seekable=this.player_.seekable();var seekableStarts=[];var i=seekable?seekable.length:0;while(i--){seekableStarts.push(seekable.start(i));}// grab the first seekable start after sorting, or if there are none
// default to 0
return seekableStarts.length?seekableStarts.sort()[0]:0;}/**
   * Get the live time window aka
   * the amount of time between seekable start and
   * live current time.
   *
   * @return {number}
   *         The amount of seconds that are seekable in
   *         the live video.
   */;_proto.liveWindow=function liveWindow(){var liveCurrentTime=this.liveCurrentTime();// if liveCurrenTime is Infinity then we don't have a liveWindow at all
if(liveCurrentTime===Infinity){return 0;}return liveCurrentTime-this.seekableStart();}/**
   * Determines if the player is live, only checks if this component
   * is tracking live playback or not
   *
   * @return {boolean}
   *         Wether liveTracker is tracking
   */;_proto.isLive=function isLive(){return this.isTracking();}/**
   * Determines if currentTime is at the live edge and won't fall behind
   * on each seekableendchange
   *
   * @return {boolean}
   *         Wether playback is at the live edge
   */;_proto.atLiveEdge=function atLiveEdge(){return!this.behindLiveEdge();}/**
   * get what we expect the live current time to be
   *
   * @return {number}
   *         The expected live current time
   */;_proto.liveCurrentTime=function liveCurrentTime(){return this.pastSeekEnd()+this.seekableEnd();}/**
   * The number of seconds that have occured after seekable end
   * changed. This will be reset to 0 once seekable end changes.
   *
   * @return {number}
   *         Seconds past the current seekable end
   */;_proto.pastSeekEnd=function pastSeekEnd(){var seekableEnd=this.seekableEnd();if(this.lastSeekEnd_!==-1&&seekableEnd!==this.lastSeekEnd_){this.pastSeekEnd_=0;}this.lastSeekEnd_=seekableEnd;return this.pastSeekEnd_;}/**
   * If we are currently behind the live edge, aka currentTime will be
   * behind on a seekableendchange
   *
   * @return {boolean}
   *         If we are behind the live edge
   */;_proto.behindLiveEdge=function behindLiveEdge(){return this.behindLiveEdge_;}/**
   * Wether live tracker is currently tracking or not.
   */;_proto.isTracking=function isTracking(){return typeof this.trackingInterval_==='number';}/**
   * Seek to the live edge if we are behind the live edge
   */;_proto.seekToLiveEdge=function seekToLiveEdge(){this.seekedBehindLive_=false;if(this.atLiveEdge()){return;}this.nextSeekedFromUser_=false;this.player_.currentTime(this.liveCurrentTime());}/**
   * Dispose of liveTracker
   */;_proto.dispose=function dispose(){this.off((document_default()),'visibilitychange',this.handleVisibilityChange_);this.stopTracking();_Component.prototype.dispose.call(this);};return LiveTracker;}(Component$1);Component$1.registerComponent('LiveTracker',LiveTracker);/**
 * This function is used to fire a sourceset when there is something
 * similar to `mediaEl.load()` being called. It will try to find the source via
 * the `src` attribute and then the `<source>` elements. It will then fire `sourceset`
 * with the source that was found or empty string if we cannot know. If it cannot
 * find a source then `sourceset` will not be fired.
 *
 * @param {Html5} tech
 *        The tech object that sourceset was setup on
 *
 * @return {boolean}
 *         returns false if the sourceset was not fired and true otherwise.
 */var sourcesetLoad=function sourcesetLoad(tech){var el=tech.el();// if `el.src` is set, that source will be loaded.
if(el.hasAttribute('src')){tech.triggerSourceset(el.src);return true;}/**
   * Since there isn't a src property on the media element, source elements will be used for
   * implementing the source selection algorithm. This happens asynchronously and
   * for most cases were there is more than one source we cannot tell what source will
   * be loaded, without re-implementing the source selection algorithm. At this time we are not
   * going to do that. There are three special cases that we do handle here though:
   *
   * 1. If there are no sources, do not fire `sourceset`.
   * 2. If there is only one `<source>` with a `src` property/attribute that is our `src`
   * 3. If there is more than one `<source>` but all of them have the same `src` url.
   *    That will be our src.
   */var sources=tech.$$('source');var srcUrls=[];var src='';// if there are no sources, do not fire sourceset
if(!sources.length){return false;}// only count valid/non-duplicate source elements
for(var i=0;i<sources.length;i++){var url=sources[i].src;if(url&&srcUrls.indexOf(url)===-1){srcUrls.push(url);}}// there were no valid sources
if(!srcUrls.length){return false;}// there is only one valid source element url
// use that
if(srcUrls.length===1){src=srcUrls[0];}tech.triggerSourceset(src);return true;};/**
 * our implementation of an `innerHTML` descriptor for browsers
 * that do not have one.
 */var innerHTMLDescriptorPolyfill=Object.defineProperty({},'innerHTML',{get:function get(){return this.cloneNode(true).innerHTML;},set:function set(v){// make a dummy node to use innerHTML on
var dummy=document_default().createElement(this.nodeName.toLowerCase());// set innerHTML to the value provided
dummy.innerHTML=v;// make a document fragment to hold the nodes from dummy
var docFrag=document_default().createDocumentFragment();// copy all of the nodes created by the innerHTML on dummy
// to the document fragment
while(dummy.childNodes.length){docFrag.appendChild(dummy.childNodes[0]);}// remove content
this.innerText='';// now we add all of that html in one by appending the
// document fragment. This is how innerHTML does it.
window_default().Element.prototype.appendChild.call(this,docFrag);// then return the result that innerHTML's setter would
return this.innerHTML;}});/**
 * Get a property descriptor given a list of priorities and the
 * property to get.
 */var getDescriptor=function getDescriptor(priority,prop){var descriptor={};for(var i=0;i<priority.length;i++){descriptor=Object.getOwnPropertyDescriptor(priority[i],prop);if(descriptor&&descriptor.set&&descriptor.get){break;}}descriptor.enumerable=true;descriptor.configurable=true;return descriptor;};var getInnerHTMLDescriptor=function getInnerHTMLDescriptor(tech){return getDescriptor([tech.el(),(window_default()).HTMLMediaElement.prototype,(window_default()).Element.prototype,innerHTMLDescriptorPolyfill],'innerHTML');};/**
 * Patches browser internal functions so that we can tell synchronously
 * if a `<source>` was appended to the media element. For some reason this
 * causes a `sourceset` if the the media element is ready and has no source.
 * This happens when:
 * - The page has just loaded and the media element does not have a source.
 * - The media element was emptied of all sources, then `load()` was called.
 *
 * It does this by patching the following functions/properties when they are supported:
 *
 * - `append()` - can be used to add a `<source>` element to the media element
 * - `appendChild()` - can be used to add a `<source>` element to the media element
 * - `insertAdjacentHTML()` -  can be used to add a `<source>` element to the media element
 * - `innerHTML` -  can be used to add a `<source>` element to the media element
 *
 * @param {Html5} tech
 *        The tech object that sourceset is being setup on.
 */var firstSourceWatch=function firstSourceWatch(tech){var el=tech.el();// make sure firstSourceWatch isn't setup twice.
if(el.resetSourceWatch_){return;}var old={};var innerDescriptor=getInnerHTMLDescriptor(tech);var appendWrapper=function appendWrapper(appendFn){return function(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var retval=appendFn.apply(el,args);sourcesetLoad(tech);return retval;};};['append','appendChild','insertAdjacentHTML'].forEach(function(k){if(!el[k]){return;}// store the old function
old[k]=el[k];// call the old function with a sourceset if a source
// was loaded
el[k]=appendWrapper(old[k]);});Object.defineProperty(el,'innerHTML',mergeOptions$3(innerDescriptor,{set:appendWrapper(innerDescriptor.set)}));el.resetSourceWatch_=function(){el.resetSourceWatch_=null;Object.keys(old).forEach(function(k){el[k]=old[k];});Object.defineProperty(el,'innerHTML',innerDescriptor);};// on the first sourceset, we need to revert our changes
tech.one('sourceset',el.resetSourceWatch_);};/**
 * our implementation of a `src` descriptor for browsers
 * that do not have one.
 */var srcDescriptorPolyfill=Object.defineProperty({},'src',{get:function get(){if(this.hasAttribute('src')){return getAbsoluteURL(window_default().Element.prototype.getAttribute.call(this,'src'));}return'';},set:function set(v){window_default().Element.prototype.setAttribute.call(this,'src',v);return v;}});var getSrcDescriptor=function getSrcDescriptor(tech){return getDescriptor([tech.el(),(window_default()).HTMLMediaElement.prototype,srcDescriptorPolyfill],'src');};/**
 * setup `sourceset` handling on the `Html5` tech. This function
 * patches the following element properties/functions:
 *
 * - `src` - to determine when `src` is set
 * - `setAttribute()` - to determine when `src` is set
 * - `load()` - this re-triggers the source selection algorithm, and can
 *              cause a sourceset.
 *
 * If there is no source when we are adding `sourceset` support or during a `load()`
 * we also patch the functions listed in `firstSourceWatch`.
 *
 * @param {Html5} tech
 *        The tech to patch
 */var setupSourceset=function setupSourceset(tech){if(!tech.featuresSourceset){return;}var el=tech.el();// make sure sourceset isn't setup twice.
if(el.resetSourceset_){return;}var srcDescriptor=getSrcDescriptor(tech);var oldSetAttribute=el.setAttribute;var oldLoad=el.load;Object.defineProperty(el,'src',mergeOptions$3(srcDescriptor,{set:function set(v){var retval=srcDescriptor.set.call(el,v);// we use the getter here to get the actual value set on src
tech.triggerSourceset(el.src);return retval;}}));el.setAttribute=function(n,v){var retval=oldSetAttribute.call(el,n,v);if(/src/i.test(n)){tech.triggerSourceset(el.src);}return retval;};el.load=function(){var retval=oldLoad.call(el);// if load was called, but there was no source to fire
// sourceset on. We have to watch for a source append
// as that can trigger a `sourceset` when the media element
// has no source
if(!sourcesetLoad(tech)){tech.triggerSourceset('');firstSourceWatch(tech);}return retval;};if(el.currentSrc){tech.triggerSourceset(el.currentSrc);}else if(!sourcesetLoad(tech)){firstSourceWatch(tech);}el.resetSourceset_=function(){el.resetSourceset_=null;el.load=oldLoad;el.setAttribute=oldSetAttribute;Object.defineProperty(el,'src',srcDescriptor);if(el.resetSourceWatch_){el.resetSourceWatch_();}};};/**
 * Object.defineProperty but "lazy", which means that the value is only set after
 * it retrieved the first time, rather than being set right away.
 *
 * @param {Object} obj the object to set the property on
 * @param {string} key the key for the property to set
 * @param {Function} getValue the function used to get the value when it is needed.
 * @param {boolean} setter wether a setter shoould be allowed or not
 */var defineLazyProperty=function defineLazyProperty(obj,key,getValue,setter){if(setter===void 0){setter=true;}var set=function set(value){return Object.defineProperty(obj,key,{value:value,enumerable:true,writable:true});};var options={configurable:true,enumerable:true,get:function get(){var value=getValue();set(value);return value;}};if(setter){options.set=set;}return Object.defineProperty(obj,key,options);};/**
 * HTML5 Media Controller - Wrapper for HTML5 Media API
 *
 * @mixes Tech~SourceHandlerAdditions
 * @extends Tech
 */var Html5=/*#__PURE__*/function(_Tech){_inheritsLoose(Html5,_Tech);/**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Component~ReadyCallback} ready
  *        Callback function to call when the `HTML5` Tech is ready.
  */function Html5(options,ready){var _this;_this=_Tech.call(this,options,ready)||this;var source=options.source;var crossoriginTracks=false;_this.featuresVideoFrameCallback=_this.featuresVideoFrameCallback&&_this.el_.tagName==='VIDEO';// Set the source if one is provided
// 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
// 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
// anyway so the error gets fired.
if(source&&(_this.el_.currentSrc!==source.src||options.tag&&options.tag.initNetworkState_===3)){_this.setSource(source);}else{_this.handleLateInit_(_this.el_);}// setup sourceset after late sourceset/init
if(options.enableSourceset){_this.setupSourcesetHandling_();}_this.isScrubbing_=false;if(_this.el_.hasChildNodes()){var nodes=_this.el_.childNodes;var nodesLength=nodes.length;var removeNodes=[];while(nodesLength--){var node=nodes[nodesLength];var nodeName=node.nodeName.toLowerCase();if(nodeName==='track'){if(!_this.featuresNativeTextTracks){// Empty video tag tracks so the built-in player doesn't use them also.
// This may not be fast enough to stop HTML5 browsers from reading the tags
// so we'll need to turn off any default tracks if we're manually doing
// captions and subtitles. videoElement.textTracks
removeNodes.push(node);}else{// store HTMLTrackElement and TextTrack to remote list
_this.remoteTextTrackEls().addTrackElement_(node);_this.remoteTextTracks().addTrack(node.track);_this.textTracks().addTrack(node.track);if(!crossoriginTracks&&!_this.el_.hasAttribute('crossorigin')&&isCrossOrigin(node.src)){crossoriginTracks=true;}}}}for(var i=0;i<removeNodes.length;i++){_this.el_.removeChild(removeNodes[i]);}}_this.proxyNativeTracks_();if(_this.featuresNativeTextTracks&&crossoriginTracks){log$1.warn('Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n'+'This may prevent text tracks from loading.');}// prevent iOS Safari from disabling metadata text tracks during native playback
_this.restoreMetadataTracksInIOSNativePlayer_();// Determine if native controls should be used
// Our goal should be to get the custom controls on mobile solid everywhere
// so we can remove this all together. Right now this will block custom
// controls on touch enabled laptops like the Chrome Pixel
if((TOUCH_ENABLED||IS_IPHONE||IS_NATIVE_ANDROID)&&options.nativeControlsForTouch===true){_this.setControls(true);}// on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
// into a `fullscreenchange` event
_this.proxyWebkitFullscreen_();_this.triggerReady();return _this;}/**
   * Dispose of `HTML5` media element and remove all tracks.
   */var _proto=Html5.prototype;_proto.dispose=function dispose(){if(this.el_&&this.el_.resetSourceset_){this.el_.resetSourceset_();}Html5.disposeMediaElement(this.el_);this.options_=null;// tech will handle clearing of the emulated track list
_Tech.prototype.dispose.call(this);}/**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */;_proto.setupSourcesetHandling_=function setupSourcesetHandling_(){setupSourceset(this);}/**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */;_proto.restoreMetadataTracksInIOSNativePlayer_=function restoreMetadataTracksInIOSNativePlayer_(){var textTracks=this.textTracks();var metadataTracksPreFullscreenState;// captures a snapshot of every metadata track's current state
var takeMetadataTrackSnapshot=function takeMetadataTrackSnapshot(){metadataTracksPreFullscreenState=[];for(var i=0;i<textTracks.length;i++){var track=textTracks[i];if(track.kind==='metadata'){metadataTracksPreFullscreenState.push({track:track,storedMode:track.mode});}}};// snapshot each metadata track's initial state, and update the snapshot
// each time there is a track 'change' event
takeMetadataTrackSnapshot();textTracks.addEventListener('change',takeMetadataTrackSnapshot);this.on('dispose',function(){return textTracks.removeEventListener('change',takeMetadataTrackSnapshot);});var restoreTrackMode=function restoreTrackMode(){for(var i=0;i<metadataTracksPreFullscreenState.length;i++){var storedTrack=metadataTracksPreFullscreenState[i];if(storedTrack.track.mode==='disabled'&&storedTrack.track.mode!==storedTrack.storedMode){storedTrack.track.mode=storedTrack.storedMode;}}// we only want this handler to be executed on the first 'change' event
textTracks.removeEventListener('change',restoreTrackMode);};// when we enter fullscreen playback, stop updating the snapshot and
// restore all track modes to their pre-fullscreen state
this.on('webkitbeginfullscreen',function(){textTracks.removeEventListener('change',takeMetadataTrackSnapshot);// remove the listener before adding it just in case it wasn't previously removed
textTracks.removeEventListener('change',restoreTrackMode);textTracks.addEventListener('change',restoreTrackMode);});// start updating the snapshot again after leaving fullscreen
this.on('webkitendfullscreen',function(){// remove the listener before adding it just in case it wasn't previously removed
textTracks.removeEventListener('change',takeMetadataTrackSnapshot);textTracks.addEventListener('change',takeMetadataTrackSnapshot);// remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
textTracks.removeEventListener('change',restoreTrackMode);});}/**
   * Attempt to force override of tracks for the given type
   *
   * @param {string} type - Track type to override, possible values include 'Audio',
   * 'Video', and 'Text'.
   * @param {boolean} override - If set to true native audio/video will be overridden,
   * otherwise native audio/video will potentially be used.
   * @private
   */;_proto.overrideNative_=function overrideNative_(type,override){var _this2=this;// If there is no behavioral change don't add/remove listeners
if(override!==this["featuresNative"+type+"Tracks"]){return;}var lowerCaseType=type.toLowerCase();if(this[lowerCaseType+"TracksListeners_"]){Object.keys(this[lowerCaseType+"TracksListeners_"]).forEach(function(eventName){var elTracks=_this2.el()[lowerCaseType+"Tracks"];elTracks.removeEventListener(eventName,_this2[lowerCaseType+"TracksListeners_"][eventName]);});}this["featuresNative"+type+"Tracks"]=!override;this[lowerCaseType+"TracksListeners_"]=null;this.proxyNativeTracksForType_(lowerCaseType);}/**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   */;_proto.overrideNativeAudioTracks=function overrideNativeAudioTracks(override){this.overrideNative_('Audio',override);}/**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   */;_proto.overrideNativeVideoTracks=function overrideNativeVideoTracks(override){this.overrideNative_('Video',override);}/**
   * Proxy native track list events for the given type to our track
   * lists if the browser we are playing in supports that type of track list.
   *
   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
   * @private
   */;_proto.proxyNativeTracksForType_=function proxyNativeTracksForType_(name){var _this3=this;var props=NORMAL[name];var elTracks=this.el()[props.getterName];var techTracks=this[props.getterName]();if(!this["featuresNative"+props.capitalName+"Tracks"]||!elTracks||!elTracks.addEventListener){return;}var listeners={change:function change(e){var event={type:'change',target:techTracks,currentTarget:techTracks,srcElement:techTracks};techTracks.trigger(event);// if we are a text track change event, we should also notify the
// remote text track list. This can potentially cause a false positive
// if we were to get a change event on a non-remote track and
// we triggered the event on the remote text track list which doesn't
// contain that track. However, best practices mean looping through the
// list of tracks and searching for the appropriate mode value, so,
// this shouldn't pose an issue
if(name==='text'){_this3[REMOTE.remoteText.getterName]().trigger(event);}},addtrack:function addtrack(e){techTracks.addTrack(e.track);},removetrack:function removetrack(e){techTracks.removeTrack(e.track);}};var removeOldTracks=function removeOldTracks(){var removeTracks=[];for(var i=0;i<techTracks.length;i++){var found=false;for(var j=0;j<elTracks.length;j++){if(elTracks[j]===techTracks[i]){found=true;break;}}if(!found){removeTracks.push(techTracks[i]);}}while(removeTracks.length){techTracks.removeTrack(removeTracks.shift());}};this[props.getterName+'Listeners_']=listeners;Object.keys(listeners).forEach(function(eventName){var listener=listeners[eventName];elTracks.addEventListener(eventName,listener);_this3.on('dispose',function(e){return elTracks.removeEventListener(eventName,listener);});});// Remove (native) tracks that are not used anymore
this.on('loadstart',removeOldTracks);this.on('dispose',function(e){return _this3.off('loadstart',removeOldTracks);});}/**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */;_proto.proxyNativeTracks_=function proxyNativeTracks_(){var _this4=this;NORMAL.names.forEach(function(name){_this4.proxyNativeTracksForType_(name);});}/**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */;_proto.createEl=function createEl(){var el=this.options_.tag;// Check if this browser supports moving the element into the box.
// On the iPhone video will break if you move the element,
// So we have to create a brand new element.
// If we ingested the player div, we do not need to move the media element.
if(!el||!(this.options_.playerElIngest||this.movingMediaElementInDOM)){// If the original tag is still there, clone and remove it.
if(el){var clone=el.cloneNode(true);if(el.parentNode){el.parentNode.insertBefore(clone,el);}Html5.disposeMediaElement(el);el=clone;}else{el=document_default().createElement('video');// determine if native controls should be used
var tagAttributes=this.options_.tag&&getAttributes(this.options_.tag);var attributes=mergeOptions$3({},tagAttributes);if(!TOUCH_ENABLED||this.options_.nativeControlsForTouch!==true){delete attributes.controls;}setAttributes(el,video_es_assign(attributes,{id:this.options_.techId,"class":'vjs-tech'}));}el.playerId=this.options_.playerId;}if(typeof this.options_.preload!=='undefined'){setAttribute(el,'preload',this.options_.preload);}if(this.options_.disablePictureInPicture!==undefined){el.disablePictureInPicture=this.options_.disablePictureInPicture;}// Update specific tag settings, in case they were overridden
// `autoplay` has to be *last* so that `muted` and `playsinline` are present
// when iOS/Safari or other browsers attempt to autoplay.
var settingsAttrs=['loop','muted','playsinline','autoplay'];for(var i=0;i<settingsAttrs.length;i++){var attr=settingsAttrs[i];var value=this.options_[attr];if(typeof value!=='undefined'){if(value){setAttribute(el,attr,attr);}else{removeAttribute(el,attr);}el[attr]=value;}}return el;}/**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */;_proto.handleLateInit_=function handleLateInit_(el){if(el.networkState===0||el.networkState===3){// The video element hasn't started loading the source yet
// or didn't find a source
return;}if(el.readyState===0){// NetworkState is set synchronously BUT loadstart is fired at the
// end of the current stack, usually before setInterval(fn, 0).
// So at this point we know loadstart may have already fired or is
// about to fire, and either way the player hasn't seen it yet.
// We don't want to fire loadstart prematurely here and cause a
// double loadstart so we'll wait and see if it happens between now
// and the next loop, and fire it if not.
// HOWEVER, we also want to make sure it fires before loadedmetadata
// which could also happen between now and the next loop, so we'll
// watch for that also.
var loadstartFired=false;var setLoadstartFired=function setLoadstartFired(){loadstartFired=true;};this.on('loadstart',setLoadstartFired);var triggerLoadstart=function triggerLoadstart(){// We did miss the original loadstart. Make sure the player
// sees loadstart before loadedmetadata
if(!loadstartFired){this.trigger('loadstart');}};this.on('loadedmetadata',triggerLoadstart);this.ready(function(){this.off('loadstart',setLoadstartFired);this.off('loadedmetadata',triggerLoadstart);if(!loadstartFired){// We did miss the original native loadstart. Fire it now.
this.trigger('loadstart');}});return;}// From here on we know that loadstart already fired and we missed it.
// The other readyState events aren't as much of a problem if we double
// them, so not going to go to as much trouble as loadstart to prevent
// that unless we find reason to.
var eventsToTrigger=['loadstart'];// loadedmetadata: newly equal to HAVE_METADATA (1) or greater
eventsToTrigger.push('loadedmetadata');// loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
if(el.readyState>=2){eventsToTrigger.push('loadeddata');}// canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
if(el.readyState>=3){eventsToTrigger.push('canplay');}// canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
if(el.readyState>=4){eventsToTrigger.push('canplaythrough');}// We still need to give the player time to add event listeners
this.ready(function(){eventsToTrigger.forEach(function(type){this.trigger(type);},this);});}/**
   * Set whether we are scrubbing or not.
   * This is used to decide whether we should use `fastSeek` or not.
   * `fastSeek` is used to provide trick play on Safari browsers.
   *
   * @param {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */;_proto.setScrubbing=function setScrubbing(isScrubbing){this.isScrubbing_=isScrubbing;}/**
   * Get whether we are scrubbing or not.
   *
   * @return {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */;_proto.scrubbing=function scrubbing(){return this.isScrubbing_;}/**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */;_proto.setCurrentTime=function setCurrentTime(seconds){try{if(this.isScrubbing_&&this.el_.fastSeek&&IS_ANY_SAFARI){this.el_.fastSeek(seconds);}else{this.el_.currentTime=seconds;}}catch(e){log$1(e,'Video is not ready. (Video.js)');// this.warning(VideoJS.warnings.videoNotReady);
}}/**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */;_proto.duration=function duration(){var _this5=this;// Android Chrome will report duration as Infinity for VOD HLS until after
// playback has started, which triggers the live display erroneously.
// Return NaN if playback has not started and trigger a durationupdate once
// the duration can be reliably known.
if(this.el_.duration===Infinity&&IS_ANDROID&&IS_CHROME&&this.el_.currentTime===0){// Wait for the first `timeupdate` with currentTime > 0 - there may be
// several with 0
var checkProgress=function checkProgress(){if(_this5.el_.currentTime>0){// Trigger durationchange for genuinely live video
if(_this5.el_.duration===Infinity){_this5.trigger('durationchange');}_this5.off('timeupdate',checkProgress);}};this.on('timeupdate',checkProgress);return NaN;}return this.el_.duration||NaN;}/**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */;_proto.width=function width(){return this.el_.offsetWidth;}/**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The height of the HTML5 media element.
   */;_proto.height=function height(){return this.el_.offsetHeight;}/**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */;_proto.proxyWebkitFullscreen_=function proxyWebkitFullscreen_(){var _this6=this;if(!('webkitDisplayingFullscreen'in this.el_)){return;}var endFn=function endFn(){this.trigger('fullscreenchange',{isFullscreen:false});// Safari will sometimes set contols on the videoelement when existing fullscreen.
if(this.el_.controls&&!this.options_.nativeControlsForTouch&&this.controls()){this.el_.controls=false;}};var beginFn=function beginFn(){if('webkitPresentationMode'in this.el_&&this.el_.webkitPresentationMode!=='picture-in-picture'){this.one('webkitendfullscreen',endFn);this.trigger('fullscreenchange',{isFullscreen:true,// set a flag in case another tech triggers fullscreenchange
nativeIOSFullscreen:true});}};this.on('webkitbeginfullscreen',beginFn);this.on('dispose',function(){_this6.off('webkitbeginfullscreen',beginFn);_this6.off('webkitendfullscreen',endFn);});}/**
   * Check if fullscreen is supported on the current playback device.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */;_proto.supportsFullScreen=function supportsFullScreen(){if(typeof this.el_.webkitEnterFullScreen==='function'){var userAgent=(window_default()).navigator&&(window_default()).navigator.userAgent||'';// Seems to be broken in Chromium/Chrome && Safari in Leopard
if(/Android/.test(userAgent)||!/Chrome|Mac OS X 10.5/.test(userAgent)){return true;}}return false;}/**
   * Request that the `HTML5` Tech enter fullscreen.
   */;_proto.enterFullScreen=function enterFullScreen(){var video=this.el_;if(video.paused&&video.networkState<=video.HAVE_METADATA){// attempt to prime the video element for programmatic access
// this isn't necessary on the desktop but shouldn't hurt
silencePromise(this.el_.play());// playing and pausing synchronously during the transition to fullscreen
// can get iOS ~6.1 devices into a play/pause loop
this.setTimeout(function(){video.pause();try{video.webkitEnterFullScreen();}catch(e){this.trigger('fullscreenerror',e);}},0);}else{try{video.webkitEnterFullScreen();}catch(e){this.trigger('fullscreenerror',e);}}}/**
   * Request that the `HTML5` Tech exit fullscreen.
   */;_proto.exitFullScreen=function exitFullScreen(){if(!this.el_.webkitDisplayingFullscreen){this.trigger('fullscreenerror',new Error('The video is not fullscreen'));return;}this.el_.webkitExitFullScreen();}/**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */;_proto.requestPictureInPicture=function requestPictureInPicture(){return this.el_.requestPictureInPicture();}/**
   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
   * Needs to be checked later than the constructor
   * This will be a false positive for clear sources loaded after a Fairplay source
   *
   * @param {function} cb function to call
   * @return {number} id of request
   */;_proto.requestVideoFrameCallback=function requestVideoFrameCallback(cb){if(this.featuresVideoFrameCallback&&!this.el_.webkitKeys){return this.el_.requestVideoFrameCallback(cb);}return _Tech.prototype.requestVideoFrameCallback.call(this,cb);}/**
   * Native or fallback requestVideoFrameCallback
   *
   * @param {number} id request id to cancel
   */;_proto.cancelVideoFrameCallback=function cancelVideoFrameCallback(id){if(this.featuresVideoFrameCallback&&!this.el_.webkitKeys){this.el_.cancelVideoFrameCallback(id);}else{_Tech.prototype.cancelVideoFrameCallback.call(this,id);}}/**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */;_proto.src=function src(_src){if(_src===undefined){return this.el_.src;}// Setting src through `src` instead of `setSrc` will be deprecated
this.setSrc(_src);}/**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */;_proto.reset=function reset(){Html5.resetMediaElement(this.el_);}/**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */;_proto.currentSrc=function currentSrc(){if(this.currentSource_){return this.currentSource_.src;}return this.el_.currentSrc;}/**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */;_proto.setControls=function setControls(val){this.el_.controls=!!val;}/**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */;_proto.addTextTrack=function addTextTrack(kind,label,language){if(!this.featuresNativeTextTracks){return _Tech.prototype.addTextTrack.call(this,kind,label,language);}return this.el_.addTextTrack(kind,label,language);}/**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label]
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */;_proto.createRemoteTextTrack=function createRemoteTextTrack(options){if(!this.featuresNativeTextTracks){return _Tech.prototype.createRemoteTextTrack.call(this,options);}var htmlTrackElement=document_default().createElement('track');if(options.kind){htmlTrackElement.kind=options.kind;}if(options.label){htmlTrackElement.label=options.label;}if(options.language||options.srclang){htmlTrackElement.srclang=options.language||options.srclang;}if(options["default"]){htmlTrackElement["default"]=options["default"];}if(options.id){htmlTrackElement.id=options.id;}if(options.src){htmlTrackElement.src=options.src;}return htmlTrackElement;}/**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
   * automatically removed from the video element whenever the source changes
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   * @deprecated The default value of the "manualCleanup" parameter will default
   * to "false" in upcoming versions of Video.js
   */;_proto.addRemoteTextTrack=function addRemoteTextTrack(options,manualCleanup){var htmlTrackElement=_Tech.prototype.addRemoteTextTrack.call(this,options,manualCleanup);if(this.featuresNativeTextTracks){this.el().appendChild(htmlTrackElement);}return htmlTrackElement;}/**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */;_proto.removeRemoteTextTrack=function removeRemoteTextTrack(track){_Tech.prototype.removeRemoteTextTrack.call(this,track);if(this.featuresNativeTextTracks){var tracks=this.$$('track');var i=tracks.length;while(i--){if(track===tracks[i]||track===tracks[i].track){this.el().removeChild(tracks[i]);}}}}/**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */;_proto.getVideoPlaybackQuality=function getVideoPlaybackQuality(){if(typeof this.el().getVideoPlaybackQuality==='function'){return this.el().getVideoPlaybackQuality();}var videoPlaybackQuality={};if(typeof this.el().webkitDroppedFrameCount!=='undefined'&&typeof this.el().webkitDecodedFrameCount!=='undefined'){videoPlaybackQuality.droppedVideoFrames=this.el().webkitDroppedFrameCount;videoPlaybackQuality.totalVideoFrames=this.el().webkitDecodedFrameCount;}if((window_default()).performance&&typeof (window_default()).performance.now==='function'){videoPlaybackQuality.creationTime=window_default().performance.now();}else if((window_default()).performance&&(window_default()).performance.timing&&typeof (window_default()).performance.timing.navigationStart==='number'){videoPlaybackQuality.creationTime=window_default().Date.now()-(window_default()).performance.timing.navigationStart;}return videoPlaybackQuality;};return Html5;}(Tech);/* HTML5 Support Testing ---------------------------------------------------- */ /**
 * Element for testing browser HTML5 media capabilities
 *
 * @type {Element}
 * @constant
 * @private
 */defineLazyProperty(Html5,'TEST_VID',function(){if(!isReal()){return;}var video=document_default().createElement('video');var track=document_default().createElement('track');track.kind='captions';track.srclang='en';track.label='English';video.appendChild(track);return video;});/**
 * Check if HTML5 media is supported by this browser/device.
 *
 * @return {boolean}
 *         - True if HTML5 media is supported.
 *         - False if HTML5 media is not supported.
 */Html5.isSupported=function(){// IE with no Media Player is a LIAR! (#984)
try{Html5.TEST_VID.volume=0.5;}catch(e){return false;}return!!(Html5.TEST_VID&&Html5.TEST_VID.canPlayType);};/**
 * Check if the tech can support the given type
 *
 * @param {string} type
 *        The mimetype to check
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */Html5.canPlayType=function(type){return Html5.TEST_VID.canPlayType(type);};/**
 * Check if the tech can support the given source
 *
 * @param {Object} srcObj
 *        The source object
 * @param {Object} options
 *        The options passed to the tech
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */Html5.canPlaySource=function(srcObj,options){return Html5.canPlayType(srcObj.type);};/**
 * Check if the volume can be changed in this browser/device.
 * Volume cannot be changed in a lot of mobile devices.
 * Specifically, it can't be changed from 1 on iOS.
 *
 * @return {boolean}
 *         - True if volume can be controlled
 *         - False otherwise
 */Html5.canControlVolume=function(){// IE will error if Windows Media Player not installed #3315
try{var volume=Html5.TEST_VID.volume;Html5.TEST_VID.volume=volume/2+0.1;var canControl=volume!==Html5.TEST_VID.volume;// With the introduction of iOS 15, there are cases where the volume is read as
// changed but reverts back to its original state at the start of the next tick.
// To determine whether volume can be controlled on iOS,
// a timeout is set and the volume is checked asynchronously.
// Since `features` doesn't currently work asynchronously, the value is manually set.
if(canControl&&IS_IOS){window_default().setTimeout(function(){if(Html5&&Html5.prototype){Html5.prototype.featuresVolumeControl=volume!==Html5.TEST_VID.volume;}});// default iOS to false, which will be updated in the timeout above.
return false;}return canControl;}catch(e){return false;}};/**
 * Check if the volume can be muted in this browser/device.
 * Some devices, e.g. iOS, don't allow changing volume
 * but permits muting/unmuting.
 *
 * @return {bolean}
 *      - True if volume can be muted
 *      - False otherwise
 */Html5.canMuteVolume=function(){try{var muted=Html5.TEST_VID.muted;// in some versions of iOS muted property doesn't always
// work, so we want to set both property and attribute
Html5.TEST_VID.muted=!muted;if(Html5.TEST_VID.muted){setAttribute(Html5.TEST_VID,'muted','muted');}else{removeAttribute(Html5.TEST_VID,'muted','muted');}return muted!==Html5.TEST_VID.muted;}catch(e){return false;}};/**
 * Check if the playback rate can be changed in this browser/device.
 *
 * @return {boolean}
 *         - True if playback rate can be controlled
 *         - False otherwise
 */Html5.canControlPlaybackRate=function(){// Playback rate API is implemented in Android Chrome, but doesn't do anything
// https://github.com/videojs/video.js/issues/3180
if(IS_ANDROID&&IS_CHROME&&CHROME_VERSION<58){return false;}// IE will error if Windows Media Player not installed #3315
try{var playbackRate=Html5.TEST_VID.playbackRate;Html5.TEST_VID.playbackRate=playbackRate/2+0.1;return playbackRate!==Html5.TEST_VID.playbackRate;}catch(e){return false;}};/**
 * Check if we can override a video/audio elements attributes, with
 * Object.defineProperty.
 *
 * @return {boolean}
 *         - True if builtin attributes can be overridden
 *         - False otherwise
 */Html5.canOverrideAttributes=function(){// if we cannot overwrite the src/innerHTML property, there is no support
// iOS 7 safari for instance cannot do this.
try{var noop=function noop(){};Object.defineProperty(document_default().createElement('video'),'src',{get:noop,set:noop});Object.defineProperty(document_default().createElement('audio'),'src',{get:noop,set:noop});Object.defineProperty(document_default().createElement('video'),'innerHTML',{get:noop,set:noop});Object.defineProperty(document_default().createElement('audio'),'innerHTML',{get:noop,set:noop});}catch(e){return false;}return true;};/**
 * Check to see if native `TextTrack`s are supported by this browser/device.
 *
 * @return {boolean}
 *         - True if native `TextTrack`s are supported.
 *         - False otherwise
 */Html5.supportsNativeTextTracks=function(){return IS_ANY_SAFARI||IS_IOS&&IS_CHROME;};/**
 * Check to see if native `VideoTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `VideoTrack`s are supported.
 *        - False otherwise
 */Html5.supportsNativeVideoTracks=function(){return!!(Html5.TEST_VID&&Html5.TEST_VID.videoTracks);};/**
 * Check to see if native `AudioTrack`s are supported by this browser/device
 *
 * @return {boolean}
 *        - True if native `AudioTrack`s are supported.
 *        - False otherwise
 */Html5.supportsNativeAudioTracks=function(){return!!(Html5.TEST_VID&&Html5.TEST_VID.audioTracks);};/**
 * An array of events available on the Html5 tech.
 *
 * @private
 * @type {Array}
 */Html5.Events=['loadstart','suspend','abort','error','emptied','stalled','loadedmetadata','loadeddata','canplay','canplaythrough','playing','waiting','seeking','seeked','ended','durationchange','timeupdate','progress','play','pause','ratechange','resize','volumechange'];/**
 * Boolean indicating whether the `Tech` supports volume control.
 *
 * @type {boolean}
 * @default {@link Html5.canControlVolume}
 */ /**
 * Boolean indicating whether the `Tech` supports muting volume.
 *
 * @type {bolean}
 * @default {@link Html5.canMuteVolume}
 */ /**
 * Boolean indicating whether the `Tech` supports changing the speed at which the media
 * plays. Examples:
 *   - Set player to play 2x (twice) as fast
 *   - Set player to play 0.5x (half) as fast
 *
 * @type {boolean}
 * @default {@link Html5.canControlPlaybackRate}
 */ /**
 * Boolean indicating whether the `Tech` supports the `sourceset` event.
 *
 * @type {boolean}
 * @default
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeTextTracks}
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeVideoTracks}
 */ /**
 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
 *
 * @type {boolean}
 * @default {@link Html5.supportsNativeAudioTracks}
 */[['featuresMuteControl','canMuteVolume'],['featuresPlaybackRate','canControlPlaybackRate'],['featuresSourceset','canOverrideAttributes'],['featuresNativeTextTracks','supportsNativeTextTracks'],['featuresNativeVideoTracks','supportsNativeVideoTracks'],['featuresNativeAudioTracks','supportsNativeAudioTracks']].forEach(function(_ref){var key=_ref[0],fn=_ref[1];defineLazyProperty(Html5.prototype,key,function(){return Html5[fn]();},true);});Html5.prototype.featuresVolumeControl=Html5.canControlVolume();/**
 * Boolean indicating whether the `HTML5` tech currently supports the media element
 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
 * false there. Everywhere else this should be true.
 *
 * @type {boolean}
 * @default
 */Html5.prototype.movingMediaElementInDOM=!IS_IOS;// TODO: Previous comment: No longer appears to be used. Can probably be removed.
//       Is this true?
/**
 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
 * when going into fullscreen.
 *
 * @type {boolean}
 * @default
 */Html5.prototype.featuresFullscreenResize=true;/**
 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
 * If this is false, manual `progress` events will be triggered instead.
 *
 * @type {boolean}
 * @default
 */Html5.prototype.featuresProgressEvents=true;/**
 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
 * If this is false, manual `timeupdate` events will be triggered instead.
 *
 * @default
 */Html5.prototype.featuresTimeupdateEvents=true;/**
 * Whether the HTML5 el supports `requestVideoFrameCallback`
 *
 * @type {boolean}
 */Html5.prototype.featuresVideoFrameCallback=!!(Html5.TEST_VID&&Html5.TEST_VID.requestVideoFrameCallback);// HTML5 Feature detection and Device Fixes --------------------------------- //
var canPlayType;Html5.patchCanPlayType=function(){// Android 4.0 and above can play HLS to some extent but it reports being unable to do so
// Firefox and Chrome report correctly
if(ANDROID_VERSION>=4.0&&!IS_FIREFOX&&!IS_CHROME){canPlayType=Html5.TEST_VID&&Html5.TEST_VID.constructor.prototype.canPlayType;Html5.TEST_VID.constructor.prototype.canPlayType=function(type){var mpegurlRE=/^application\/(?:x-|vnd\.apple\.)mpegurl/i;if(type&&mpegurlRE.test(type)){return'maybe';}return canPlayType.call(this,type);};}};Html5.unpatchCanPlayType=function(){var r=Html5.TEST_VID.constructor.prototype.canPlayType;if(canPlayType){Html5.TEST_VID.constructor.prototype.canPlayType=canPlayType;}return r;};// by default, patch the media element
Html5.patchCanPlayType();Html5.disposeMediaElement=function(el){if(!el){return;}if(el.parentNode){el.parentNode.removeChild(el);}// remove any child track or source nodes to prevent their loading
while(el.hasChildNodes()){el.removeChild(el.firstChild);}// remove any src reference. not setting `src=''` because that causes a warning
// in firefox
el.removeAttribute('src');// force the media element to update its loading state by calling load()
// however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
if(typeof el.load==='function'){// wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
(function(){try{el.load();}catch(e){// not supported
}})();}};Html5.resetMediaElement=function(el){if(!el){return;}var sources=el.querySelectorAll('source');var i=sources.length;while(i--){el.removeChild(sources[i]);}// remove any src reference.
// not setting `src=''` because that throws an error
el.removeAttribute('src');if(typeof el.load==='function'){// wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
(function(){try{el.load();}catch(e){// satisfy linter
}})();}};/* Native HTML5 element property wrapping ----------------------------------- */ // Wrap native boolean attributes with getters that check both property and attribute
// The list is as followed:
// muted, defaultMuted, autoplay, controls, loop, playsinline
[/**
 * Get the value of `muted` from the media element. `muted` indicates
 * that the volume for the media should be set to silent. This does not actually change
 * the `volume` attribute.
 *
 * @method Html5#muted
 * @return {boolean}
 *         - True if the value of `volume` should be ignored and the audio set to silent.
 *         - False if the value of `volume` should be used.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */'muted',/**
 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
 * whether the media should start muted or not. Only changes the default state of the
 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
 * current state.
 *
 * @method Html5#defaultMuted
 * @return {boolean}
 *         - The value of `defaultMuted` from the media element.
 *         - True indicates that the media should start muted.
 *         - False indicates that the media should not start muted
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */'defaultMuted',/**
 * Get the value of `autoplay` from the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#autoplay
 * @return {boolean}
 *         - The value of `autoplay` from the media element.
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */'autoplay',/**
 * Get the value of `controls` from the media element. `controls` indicates
 * whether the native media controls should be shown or hidden.
 *
 * @method Html5#controls
 * @return {boolean}
 *         - The value of `controls` from the media element.
 *         - True indicates that native controls should be showing.
 *         - False indicates that native controls should be hidden.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
 */'controls',/**
 * Get the value of `loop` from the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#loop
 * @return {boolean}
 *         - The value of `loop` from the media element.
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */'loop',/**
 * Get the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#playsinline
 * @return {boolean}
 *         - The value of `playsinline` from the media element.
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */'playsinline'].forEach(function(prop){Html5.prototype[prop]=function(){return this.el_[prop]||this.el_.hasAttribute(prop);};});// Wrap native boolean attributes with setters that set both property and attribute
// The list is as followed:
// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
// setControls is special-cased above
[/**
 * Set the value of `muted` on the media element. `muted` indicates that the current
 * audio level should be silent.
 *
 * @method Html5#setMuted
 * @param {boolean} muted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
 */'muted',/**
 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
 * audio level should be silent, but will only effect the muted level on initial playback..
 *
 * @method Html5.prototype.setDefaultMuted
 * @param {boolean} defaultMuted
 *        - True if the audio should be set to silent
 *        - False otherwise
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
 */'defaultMuted',/**
 * Set the value of `autoplay` on the media element. `autoplay` indicates
 * that the media should start to play as soon as the page is ready.
 *
 * @method Html5#setAutoplay
 * @param {boolean} autoplay
 *         - True indicates that the media should start as soon as the page loads.
 *         - False indicates that the media should not start as soon as the page loads.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
 */'autoplay',/**
 * Set the value of `loop` on the media element. `loop` indicates
 * that the media should return to the start of the media and continue playing once
 * it reaches the end.
 *
 * @method Html5#setLoop
 * @param {boolean} loop
 *         - True indicates that playback should seek back to start once
 *           the end of a media is reached.
 *         - False indicates that playback should not loop back to the start when the
 *           end of the media is reached.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
 */'loop',/**
 * Set the value of `playsinline` from the media element. `playsinline` indicates
 * to the browser that non-fullscreen playback is preferred when fullscreen
 * playback is the native default, such as in iOS Safari.
 *
 * @method Html5#setPlaysinline
 * @param {boolean} playsinline
 *         - True indicates that the media should play inline.
 *         - False indicates that the media should not play inline.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
 */'playsinline'].forEach(function(prop){Html5.prototype['set'+toTitleCase$1(prop)]=function(v){this.el_[prop]=v;if(v){this.el_.setAttribute(prop,prop);}else{this.el_.removeAttribute(prop);}};});// Wrap native properties with a getter
// The list is as followed
// paused, currentTime, buffered, volume, poster, preload, error, seeking
// seekable, ended, playbackRate, defaultPlaybackRate, disablePictureInPicture
// played, networkState, readyState, videoWidth, videoHeight, crossOrigin
[/**
 * Get the value of `paused` from the media element. `paused` indicates whether the media element
 * is currently paused or not.
 *
 * @method Html5#paused
 * @return {boolean}
 *         The value of `paused` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
 */'paused',/**
 * Get the value of `currentTime` from the media element. `currentTime` indicates
 * the current second that the media is at in playback.
 *
 * @method Html5#currentTime
 * @return {number}
 *         The value of `currentTime` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
 */'currentTime',/**
 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
 * object that represents the parts of the media that are already downloaded and
 * available for playback.
 *
 * @method Html5#buffered
 * @return {TimeRange}
 *         The value of `buffered` from the media element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
 */'buffered',/**
 * Get the value of `volume` from the media element. `volume` indicates
 * the current playback volume of audio for a media. `volume` will be a value from 0
 * (silent) to 1 (loudest and default).
 *
 * @method Html5#volume
 * @return {number}
 *         The value of `volume` from the media element. Value will be between 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */'volume',/**
 * Get the value of `poster` from the media element. `poster` indicates
 * that the url of an image file that can/will be shown when no media data is available.
 *
 * @method Html5#poster
 * @return {string}
 *         The value of `poster` from the media element. Value will be a url to an
 *         image.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
 */'poster',/**
 * Get the value of `preload` from the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#preload
 * @return {string}
 *         The value of `preload` from the media element. Will be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */'preload',/**
 * Get the value of the `error` from the media element. `error` indicates any
 * MediaError that may have occurred during playback. If error returns null there is no
 * current error.
 *
 * @method Html5#error
 * @return {MediaError|null}
 *         The value of `error` from the media element. Will be `MediaError` if there
 *         is a current error and null otherwise.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
 */'error',/**
 * Get the value of `seeking` from the media element. `seeking` indicates whether the
 * media is currently seeking to a new position or not.
 *
 * @method Html5#seeking
 * @return {boolean}
 *         - The value of `seeking` from the media element.
 *         - True indicates that the media is currently seeking to a new position.
 *         - False indicates that the media is not seeking to a new position at this time.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
 */'seeking',/**
 * Get the value of `seekable` from the media element. `seekable` returns a
 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
 *
 * @method Html5#seekable
 * @return {TimeRange}
 *         The value of `seekable` from the media element. A `TimeRange` object
 *         indicating the current ranges of time that can be seeked to.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
 */'seekable',/**
 * Get the value of `ended` from the media element. `ended` indicates whether
 * the media has reached the end or not.
 *
 * @method Html5#ended
 * @return {boolean}
 *         - The value of `ended` from the media element.
 *         - True indicates that the media has ended.
 *         - False indicates that the media has not ended.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
 */'ended',/**
 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
 * the rate at which the media is currently playing back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#playbackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */'playbackRate',/**
 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
 * the rate at which the media is currently playing back. This value will not indicate the current
 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
 *
 * Examples:
 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.defaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */'defaultPlaybackRate',/**
 * Get the value of 'disablePictureInPicture' from the video element.
 *
 * @method Html5#disablePictureInPicture
 * @return {boolean} value
 *         - The value of `disablePictureInPicture` from the video element.
 *         - True indicates that the video can't be played in Picture-In-Picture mode
 *         - False indicates that the video can be played in Picture-In-Picture mode
 *
 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
 */'disablePictureInPicture',/**
 * Get the value of `played` from the media element. `played` returns a `TimeRange`
 * object representing points in the media timeline that have been played.
 *
 * @method Html5#played
 * @return {TimeRange}
 *         The value of `played` from the media element. A `TimeRange` object indicating
 *         the ranges of time that have been played.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
 */'played',/**
 * Get the value of `networkState` from the media element. `networkState` indicates
 * the current network state. It returns an enumeration from the following list:
 * - 0: NETWORK_EMPTY
 * - 1: NETWORK_IDLE
 * - 2: NETWORK_LOADING
 * - 3: NETWORK_NO_SOURCE
 *
 * @method Html5#networkState
 * @return {number}
 *         The value of `networkState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
 */'networkState',/**
 * Get the value of `readyState` from the media element. `readyState` indicates
 * the current state of the media element. It returns an enumeration from the
 * following list:
 * - 0: HAVE_NOTHING
 * - 1: HAVE_METADATA
 * - 2: HAVE_CURRENT_DATA
 * - 3: HAVE_FUTURE_DATA
 * - 4: HAVE_ENOUGH_DATA
 *
 * @method Html5#readyState
 * @return {number}
 *         The value of `readyState` from the media element. This will be a number
 *         from the list in the description.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
 */'readyState',/**
 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
 * the current width of the video in css pixels.
 *
 * @method Html5#videoWidth
 * @return {number}
 *         The value of `videoWidth` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */'videoWidth',/**
 * Get the value of `videoHeight` from the video element. `videoHeight` indicates
 * the current height of the video in css pixels.
 *
 * @method Html5#videoHeight
 * @return {number}
 *         The value of `videoHeight` from the video element. This will be a number
 *         in css pixels.
 *
 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
 */'videoHeight',/**
 * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
 * to the browser that should sent the cookies along with the requests for the
 * different assets/playlists
 *
 * @method Html5#crossOrigin
 * @return {string}
 *         - anonymous indicates that the media should not sent cookies.
 *         - use-credentials indicates that the media should sent cookies along the requests.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
 */'crossOrigin'].forEach(function(prop){Html5.prototype[prop]=function(){return this.el_[prop];};});// Wrap native properties with a setter in this format:
// set + toTitleCase(name)
// The list is as follows:
// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate,
// setDisablePictureInPicture, setCrossOrigin
[/**
 * Set the value of `volume` on the media element. `volume` indicates the current
 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
 * so on.
 *
 * @method Html5#setVolume
 * @param {number} percentAsDecimal
 *        The volume percent as a decimal. Valid range is from 0-1.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
 */'volume',/**
 * Set the value of `src` on the media element. `src` indicates the current
 * {@link Tech~SourceObject} for the media.
 *
 * @method Html5#setSrc
 * @param {Tech~SourceObject} src
 *        The source object to set as the current source.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
 */'src',/**
 * Set the value of `poster` on the media element. `poster` is the url to
 * an image file that can/will be shown when no media data is available.
 *
 * @method Html5#setPoster
 * @param {string} poster
 *        The url to an image that should be used as the `poster` for the media
 *        element.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
 */'poster',/**
 * Set the value of `preload` on the media element. `preload` indicates
 * what should download before the media is interacted with. It can have the following
 * values:
 * - none: nothing should be downloaded
 * - metadata: poster and the first few frames of the media may be downloaded to get
 *   media dimensions and other metadata
 * - auto: allow the media and metadata for the media to be downloaded before
 *    interaction
 *
 * @method Html5#setPreload
 * @param {string} preload
 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
 *         or 'auto'.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
 */'preload',/**
 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
 * the rate at which the media should play back. Examples:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5#setPlaybackRate
 * @return {number}
 *         The value of `playbackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
 */'playbackRate',/**
 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
 * the rate at which the media should play back upon initial startup. Changing this value
 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
 *
 * Example Values:
 *   - if playbackRate is set to 2, media will play twice as fast.
 *   - if playbackRate is set to 0.5, media will play half as fast.
 *
 * @method Html5.prototype.setDefaultPlaybackRate
 * @return {number}
 *         The value of `defaultPlaybackRate` from the media element. A number indicating
 *         the current playback speed of the media, where 1 is normal speed.
 *
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
 */'defaultPlaybackRate',/**
 * Prevents the browser from suggesting a Picture-in-Picture context menu
 * or to request Picture-in-Picture automatically in some cases.
 *
 * @method Html5#setDisablePictureInPicture
 * @param {boolean} value
 *         The true value will disable Picture-in-Picture mode.
 *
 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
 */'disablePictureInPicture',/**
 * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
 * to the browser that should sent the cookies along with the requests for the
 * different assets/playlists
 *
 * @method Html5#setCrossOrigin
 * @param {string} crossOrigin
 *         - anonymous indicates that the media should not sent cookies.
 *         - use-credentials indicates that the media should sent cookies along the requests.
 *
 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
 */'crossOrigin'].forEach(function(prop){Html5.prototype['set'+toTitleCase$1(prop)]=function(v){this.el_[prop]=v;};});// wrap native functions with a function
// The list is as follows:
// pause, load, play
[/**
 * A wrapper around the media elements `pause` function. This will call the `HTML5`
 * media elements `pause` function.
 *
 * @method Html5#pause
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
 */'pause',/**
 * A wrapper around the media elements `load` function. This will call the `HTML5`s
 * media element `load` function.
 *
 * @method Html5#load
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
 */'load',/**
 * A wrapper around the media elements `play` function. This will call the `HTML5`s
 * media element `play` function.
 *
 * @method Html5#play
 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
 */'play'].forEach(function(prop){Html5.prototype[prop]=function(){return this.el_[prop]();};});Tech.withSourceHandlers(Html5);/**
 * Native source handler for Html5, simply passes the source to the media element.
 *
 * @property {Tech~SourceObject} source
 *        The source object
 *
 * @property {Html5} tech
 *        The instance of the HTML5 tech.
 */Html5.nativeSourceHandler={};/**
 * Check if the media element can play the given mime type.
 *
 * @param {string} type
 *        The mimetype to check
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string)
 */Html5.nativeSourceHandler.canPlayType=function(type){// IE without MediaPlayer throws an error (#519)
try{return Html5.TEST_VID.canPlayType(type);}catch(e){return'';}};/**
 * Check if the media element can handle a source natively.
 *
 * @param {Tech~SourceObject} source
 *         The source object
 *
 * @param {Object} [options]
 *         Options to be passed to the tech.
 *
 * @return {string}
 *         'probably', 'maybe', or '' (empty string).
 */Html5.nativeSourceHandler.canHandleSource=function(source,options){// If a type was provided we should rely on that
if(source.type){return Html5.nativeSourceHandler.canPlayType(source.type);// If no type, fall back to checking 'video/[EXTENSION]'
}else if(source.src){var ext=getFileExtension(source.src);return Html5.nativeSourceHandler.canPlayType("video/"+ext);}return'';};/**
 * Pass the source to the native media element.
 *
 * @param {Tech~SourceObject} source
 *        The source object
 *
 * @param {Html5} tech
 *        The instance of the Html5 tech
 *
 * @param {Object} [options]
 *        The options to pass to the source
 */Html5.nativeSourceHandler.handleSource=function(source,tech,options){tech.setSrc(source.src);};/**
 * A noop for the native dispose function, as cleanup is not needed.
 */Html5.nativeSourceHandler.dispose=function(){};// Register the native source handler
Html5.registerSourceHandler(Html5.nativeSourceHandler);Tech.registerTech('Html5',Html5);// on the player when they happen
var TECH_EVENTS_RETRIGGER=[/**
 * Fired while the user agent is downloading media data.
 *
 * @event Player#progress
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `progress` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechProgress_
 * @fires Player#progress
 * @listens Tech#progress
 */'progress',/**
 * Fires when the loading of an audio/video is aborted.
 *
 * @event Player#abort
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `abort` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechAbort_
 * @fires Player#abort
 * @listens Tech#abort
 */'abort',/**
 * Fires when the browser is intentionally not getting media data.
 *
 * @event Player#suspend
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechSuspend_
 * @fires Player#suspend
 * @listens Tech#suspend
 */'suspend',/**
 * Fires when the current playlist is empty.
 *
 * @event Player#emptied
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechEmptied_
 * @fires Player#emptied
 * @listens Tech#emptied
 */'emptied',/**
 * Fires when the browser is trying to get media data, but data is not available.
 *
 * @event Player#stalled
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechStalled_
 * @fires Player#stalled
 * @listens Tech#stalled
 */'stalled',/**
 * Fires when the browser has loaded meta data for the audio/video.
 *
 * @event Player#loadedmetadata
 * @type {EventTarget~Event}
 */ /**
 * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoadedmetadata_
 * @fires Player#loadedmetadata
 * @listens Tech#loadedmetadata
 */'loadedmetadata',/**
 * Fires when the browser has loaded the current frame of the audio/video.
 *
 * @event Player#loadeddata
 * @type {event}
 */ /**
 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechLoaddeddata_
 * @fires Player#loadeddata
 * @listens Tech#loadeddata
 */'loadeddata',/**
 * Fires when the current playback position has changed.
 *
 * @event Player#timeupdate
 * @type {event}
 */ /**
 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTimeUpdate_
 * @fires Player#timeupdate
 * @listens Tech#timeupdate
 */'timeupdate',/**
 * Fires when the video's intrinsic dimensions change
 *
 * @event Player#resize
 * @type {event}
 */ /**
 * Retrigger the `resize` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechResize_
 * @fires Player#resize
 * @listens Tech#resize
 */'resize',/**
 * Fires when the volume has been changed
 *
 * @event Player#volumechange
 * @type {event}
 */ /**
 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechVolumechange_
 * @fires Player#volumechange
 * @listens Tech#volumechange
 */'volumechange',/**
 * Fires when the text track has been changed
 *
 * @event Player#texttrackchange
 * @type {event}
 */ /**
 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
 *
 * @private
 * @method Player#handleTechTexttrackchange_
 * @fires Player#texttrackchange
 * @listens Tech#texttrackchange
 */'texttrackchange'];// events to queue when playback rate is zero
// this is a hash for the sole purpose of mapping non-camel-cased event names
// to camel-cased function names
var TECH_EVENTS_QUEUE={canplay:'CanPlay',canplaythrough:'CanPlayThrough',playing:'Playing',seeked:'Seeked'};var BREAKPOINT_ORDER=['tiny','xsmall','small','medium','large','xlarge','huge'];var BREAKPOINT_CLASSES={};// grep: vjs-layout-tiny
// grep: vjs-layout-x-small
// grep: vjs-layout-small
// grep: vjs-layout-medium
// grep: vjs-layout-large
// grep: vjs-layout-x-large
// grep: vjs-layout-huge
BREAKPOINT_ORDER.forEach(function(k){var v=k.charAt(0)==='x'?"x-"+k.substring(1):k;BREAKPOINT_CLASSES[k]="vjs-layout-"+v;});var DEFAULT_BREAKPOINTS={tiny:210,xsmall:320,small:425,medium:768,large:1440,xlarge:2560,huge:Infinity};/**
 * An instance of the `Player` class is created when any of the Video.js setup methods
 * are used to initialize a video.
 *
 * After an instance has been created it can be accessed globally in two ways:
 * 1. By calling `videojs('example_video_1');`
 * 2. By using it directly via  `videojs.players.example_video_1;`
 *
 * @extends Component
 */var Player=/*#__PURE__*/function(_Component){_inheritsLoose(Player,_Component);/**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {Component~ReadyCallback} [ready]
   *        Ready callback function.
   */function Player(tag,options,ready){var _this;// Make sure tag ID exists
tag.id=tag.id||options.id||"vjs_video_"+newGUID();// Set Options
// The options argument overrides options set in the video tag
// which overrides globally set options.
// This latter part coincides with the load order
// (tag must exist before Player)
options=video_es_assign(Player.getTagSettings(tag),options);// Delay the initialization of children because we need to set up
// player properties first, and can't use `this` before `super()`
options.initChildren=false;// Same with creating the element
options.createEl=false;// don't auto mixin the evented mixin
options.evented=false;// we don't want the player to report touch activity on itself
// see enableTouchActivity in Component
options.reportTouchActivity=false;// If language is not set, get the closest lang attribute
if(!options.language){if(typeof tag.closest==='function'){var closest=tag.closest('[lang]');if(closest&&closest.getAttribute){options.language=closest.getAttribute('lang');}}else{var element=tag;while(element&&element.nodeType===1){if(getAttributes(element).hasOwnProperty('lang')){options.language=element.getAttribute('lang');break;}element=element.parentNode;}}}// Run base component initializing with new options
_this=_Component.call(this,null,options,ready)||this;// Create bound methods for document listeners.
_this.boundDocumentFullscreenChange_=function(e){return _this.documentFullscreenChange_(e);};_this.boundFullWindowOnEscKey_=function(e){return _this.fullWindowOnEscKey(e);};_this.boundUpdateStyleEl_=function(e){return _this.updateStyleEl_(e);};_this.boundApplyInitTime_=function(e){return _this.applyInitTime_(e);};_this.boundUpdateCurrentBreakpoint_=function(e){return _this.updateCurrentBreakpoint_(e);};_this.boundHandleTechClick_=function(e){return _this.handleTechClick_(e);};_this.boundHandleTechDoubleClick_=function(e){return _this.handleTechDoubleClick_(e);};_this.boundHandleTechTouchStart_=function(e){return _this.handleTechTouchStart_(e);};_this.boundHandleTechTouchMove_=function(e){return _this.handleTechTouchMove_(e);};_this.boundHandleTechTouchEnd_=function(e){return _this.handleTechTouchEnd_(e);};_this.boundHandleTechTap_=function(e){return _this.handleTechTap_(e);};// default isFullscreen_ to false
_this.isFullscreen_=false;// create logger
_this.log=createLogger(_this.id_);// Hold our own reference to fullscreen api so it can be mocked in tests
_this.fsApi_=FullscreenApi;// Tracks when a tech changes the poster
_this.isPosterFromTech_=false;// Holds callback info that gets queued when playback rate is zero
// and a seek is happening
_this.queuedCallbacks_=[];// Turn off API access because we're loading a new tech that might load asynchronously
_this.isReady_=false;// Init state hasStarted_
_this.hasStarted_=false;// Init state userActive_
_this.userActive_=false;// Init debugEnabled_
_this.debugEnabled_=false;// Init state audioOnlyMode_
_this.audioOnlyMode_=false;// Init state audioPosterMode_
_this.audioPosterMode_=false;// Init state audioOnlyCache_
_this.audioOnlyCache_={playerHeight:null,hiddenChildren:[]};// if the global option object was accidentally blown away by
// someone, bail early with an informative error
if(!_this.options_||!_this.options_.techOrder||!_this.options_.techOrder.length){throw new Error('No techOrder specified. Did you overwrite '+'videojs.options instead of just changing the '+'properties you want to override?');}// Store the original tag used to set options
_this.tag=tag;// Store the tag attributes used to restore html5 element
_this.tagAttributes=tag&&getAttributes(tag);// Update current language
_this.language(_this.options_.language);// Update Supported Languages
if(options.languages){// Normalise player option languages to lowercase
var languagesToLower={};Object.getOwnPropertyNames(options.languages).forEach(function(name){languagesToLower[name.toLowerCase()]=options.languages[name];});_this.languages_=languagesToLower;}else{_this.languages_=Player.prototype.options_.languages;}_this.resetCache_();// Set poster
_this.poster_=options.poster||'';// Set controls
_this.controls_=!!options.controls;// Original tag settings stored in options
// now remove immediately so native controls don't flash.
// May be turned back on by HTML5 tech if nativeControlsForTouch is true
tag.controls=false;tag.removeAttribute('controls');_this.changingSrc_=false;_this.playCallbacks_=[];_this.playTerminatedQueue_=[];// the attribute overrides the option
if(tag.hasAttribute('autoplay')){_this.autoplay(true);}else{// otherwise use the setter to validate and
// set the correct value.
_this.autoplay(_this.options_.autoplay);}// check plugins
if(options.plugins){Object.keys(options.plugins).forEach(function(name){if(typeof _this[name]!=='function'){throw new Error("plugin \""+name+"\" does not exist");}});}/*
     * Store the internal state of scrubbing
     *
     * @private
     * @return {Boolean} True if the user is scrubbing
     */_this.scrubbing_=false;_this.el_=_this.createEl();// Make this an evented object and use `el_` as its event bus.
evented(_assertThisInitialized(_this),{eventBusKey:'el_'});// listen to document and player fullscreenchange handlers so we receive those events
// before a user can receive them so we can update isFullscreen appropriately.
// make sure that we listen to fullscreenchange events before everything else to make sure that
// our isFullscreen method is updated properly for internal components as well as external.
if(_this.fsApi_.requestFullscreen){on((document_default()),_this.fsApi_.fullscreenchange,_this.boundDocumentFullscreenChange_);_this.on(_this.fsApi_.fullscreenchange,_this.boundDocumentFullscreenChange_);}if(_this.fluid_){_this.on(['playerreset','resize'],_this.boundUpdateStyleEl_);}// We also want to pass the original player options to each component and plugin
// as well so they don't need to reach back into the player for options later.
// We also need to do another copy of this.options_ so we don't end up with
// an infinite loop.
var playerOptionsCopy=mergeOptions$3(_this.options_);// Load plugins
if(options.plugins){Object.keys(options.plugins).forEach(function(name){_this[name](options.plugins[name]);});}// Enable debug mode to fire debugon event for all plugins.
if(options.debug){_this.debug(true);}_this.options_.playerOptions=playerOptionsCopy;_this.middleware_=[];_this.playbackRates(options.playbackRates);_this.initChildren();// Set isAudio based on whether or not an audio tag was used
_this.isAudio(tag.nodeName.toLowerCase()==='audio');// Update controls className. Can't do this when the controls are initially
// set because the element doesn't exist yet.
if(_this.controls()){_this.addClass('vjs-controls-enabled');}else{_this.addClass('vjs-controls-disabled');}// Set ARIA label and region role depending on player type
_this.el_.setAttribute('role','region');if(_this.isAudio()){_this.el_.setAttribute('aria-label',_this.localize('Audio Player'));}else{_this.el_.setAttribute('aria-label',_this.localize('Video Player'));}if(_this.isAudio()){_this.addClass('vjs-audio');}if(_this.flexNotSupported_()){_this.addClass('vjs-no-flex');}// TODO: Make this smarter. Toggle user state between touching/mousing
// using events, since devices can have both touch and mouse events.
// TODO: Make this check be performed again when the window switches between monitors
// (See https://github.com/videojs/video.js/issues/5683)
if(TOUCH_ENABLED){_this.addClass('vjs-touch-enabled');}// iOS Safari has broken hover handling
if(!IS_IOS){_this.addClass('vjs-workinghover');}// Make player easily findable by ID
Player.players[_this.id_]=_assertThisInitialized(_this);// Add a major version class to aid css in plugins
var majorVersion=version$5.split('.')[0];_this.addClass("vjs-v"+majorVersion);// When the player is first initialized, trigger activity so components
// like the control bar show themselves if needed
_this.userActive(true);_this.reportUserActivity();_this.one('play',function(e){return _this.listenForUserActivity_(e);});_this.on('stageclick',function(e){return _this.handleStageClick_(e);});_this.on('keydown',function(e){return _this.handleKeyDown(e);});_this.on('languagechange',function(e){return _this.handleLanguagechange(e);});_this.breakpoints(_this.options_.breakpoints);_this.responsive(_this.options_.responsive);// Calling both the audio mode methods after the player is fully
// setup to be able to listen to the events triggered by them
_this.on('ready',function(){// Calling the audioPosterMode method first so that
// the audioOnlyMode can take precedence when both options are set to true
_this.audioPosterMode(_this.options_.audioPosterMode);_this.audioOnlyMode(_this.options_.audioOnlyMode);});return _this;}/**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */var _proto=Player.prototype;_proto.dispose=function dispose(){var _this2=this;/**
     * Called when the player is being disposed of.
     *
     * @event Player#dispose
     * @type {EventTarget~Event}
     */this.trigger('dispose');// prevent dispose from being called twice
this.off('dispose');// Make sure all player-specific document listeners are unbound. This is
off((document_default()),this.fsApi_.fullscreenchange,this.boundDocumentFullscreenChange_);off((document_default()),'keydown',this.boundFullWindowOnEscKey_);if(this.styleEl_&&this.styleEl_.parentNode){this.styleEl_.parentNode.removeChild(this.styleEl_);this.styleEl_=null;}// Kill reference to this player
Player.players[this.id_]=null;if(this.tag&&this.tag.player){this.tag.player=null;}if(this.el_&&this.el_.player){this.el_.player=null;}if(this.tech_){this.tech_.dispose();this.isPosterFromTech_=false;this.poster_='';}if(this.playerElIngest_){this.playerElIngest_=null;}if(this.tag){this.tag=null;}clearCacheForPlayer(this);// remove all event handlers for track lists
// all tracks and track listeners are removed on
// tech dispose
ALL.names.forEach(function(name){var props=ALL[name];var list=_this2[props.getterName]();// if it is not a native list
// we have to manually remove event listeners
if(list&&list.off){list.off();}});// the actual .el_ is removed here, or replaced if
_Component.prototype.dispose.call(this,{restoreEl:this.options_.restoreEl});}/**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */;_proto.createEl=function createEl(){var tag=this.tag;var el;var playerElIngest=this.playerElIngest_=tag.parentNode&&tag.parentNode.hasAttribute&&tag.parentNode.hasAttribute('data-vjs-player');var divEmbed=this.tag.tagName.toLowerCase()==='video-js';if(playerElIngest){el=this.el_=tag.parentNode;}else if(!divEmbed){el=this.el_=_Component.prototype.createEl.call(this,'div');}// Copy over all the attributes from the tag, including ID and class
// ID will now reference player box, not the video tag
var attrs=getAttributes(tag);if(divEmbed){el=this.el_=tag;tag=this.tag=document_default().createElement('video');while(el.children.length){tag.appendChild(el.firstChild);}if(!hasClass(el,'video-js')){addClass(el,'video-js');}el.appendChild(tag);playerElIngest=this.playerElIngest_=el;// move properties over from our custom `video-js` element
// to our new `video` element. This will move things like
// `src` or `controls` that were set via js before the player
// was initialized.
Object.keys(el).forEach(function(k){try{tag[k]=el[k];}catch(e){// we got a a property like outerHTML which we can't actually copy, ignore it
}});}// set tabindex to -1 to remove the video element from the focus order
tag.setAttribute('tabindex','-1');attrs.tabindex='-1';// Workaround for #4583 (JAWS+IE doesn't announce BPB or play button), and
// for the same issue with Chrome (on Windows) with JAWS.
// See https://github.com/FreedomScientific/VFO-standards-support/issues/78
// Note that we can't detect if JAWS is being used, but this ARIA attribute
//  doesn't change behavior of IE11 or Chrome if JAWS is not being used
if(IE_VERSION||IS_CHROME&&IS_WINDOWS){tag.setAttribute('role','application');attrs.role='application';}// Remove width/height attrs from tag so CSS can make it 100% width/height
tag.removeAttribute('width');tag.removeAttribute('height');if('width'in attrs){delete attrs.width;}if('height'in attrs){delete attrs.height;}Object.getOwnPropertyNames(attrs).forEach(function(attr){// don't copy over the class attribute to the player element when we're in a div embed
// the class is already set up properly in the divEmbed case
// and we want to make sure that the `video-js` class doesn't get lost
if(!(divEmbed&&attr==='class')){el.setAttribute(attr,attrs[attr]);}if(divEmbed){tag.setAttribute(attr,attrs[attr]);}});// Update tag id/class for use as HTML5 playback tech
// Might think we should do this after embedding in container so .vjs-tech class
// doesn't flash 100% width/height, but class only applies with .video-js parent
tag.playerId=tag.id;tag.id+='_html5_api';tag.className='vjs-tech';// Make player findable on elements
tag.player=el.player=this;// Default state of video is paused
this.addClass('vjs-paused');// Add a style element in the player that we'll use to set the width/height
// of the player in a way that's still overrideable by CSS, just like the
// video element
if((window_default()).VIDEOJS_NO_DYNAMIC_STYLE!==true){this.styleEl_=createStyleElement('vjs-styles-dimensions');var defaultsStyleEl=$('.vjs-styles-defaults');var head=$('head');head.insertBefore(this.styleEl_,defaultsStyleEl?defaultsStyleEl.nextSibling:head.firstChild);}this.fill_=false;this.fluid_=false;// Pass in the width/height/aspectRatio options which will update the style el
this.width(this.options_.width);this.height(this.options_.height);this.fill(this.options_.fill);this.fluid(this.options_.fluid);this.aspectRatio(this.options_.aspectRatio);// support both crossOrigin and crossorigin to reduce confusion and issues around the name
this.crossOrigin(this.options_.crossOrigin||this.options_.crossorigin);// Hide any links within the video/audio tag,
// because IE doesn't hide them completely from screen readers.
var links=tag.getElementsByTagName('a');for(var i=0;i<links.length;i++){var linkEl=links.item(i);addClass(linkEl,'vjs-hidden');linkEl.setAttribute('hidden','hidden');}// insertElFirst seems to cause the networkState to flicker from 3 to 2, so
// keep track of the original for later so we can know if the source originally failed
tag.initNetworkState_=tag.networkState;// Wrap video tag in div (el/box) container
if(tag.parentNode&&!playerElIngest){tag.parentNode.insertBefore(el,tag);}// insert the tag as the first child of the player element
// then manually add it to the children array so that this.addChild
// will work properly for other components
//
// Breaks iPhone, fixed in HTML5 setup.
prependTo(tag,el);this.children_.unshift(tag);// Set lang attr on player to ensure CSS :lang() in consistent with player
// if it's been set to something different to the doc
this.el_.setAttribute('lang',this.language_);this.el_.setAttribute('translate','no');this.el_=el;return el;}/**
   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
   * behavior.
   *
   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
   *
   * @param {string} [value]
   *        The value to set the `Player`'s crossOrigin to. If an argument is
   *        given, must be one of `anonymous` or `use-credentials`.
   *
   * @return {string|undefined}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */;_proto.crossOrigin=function crossOrigin(value){if(!value){return this.techGet_('crossOrigin');}if(value!=='anonymous'&&value!=='use-credentials'){log$1.warn("crossOrigin must be \"anonymous\" or \"use-credentials\", given \""+value+"\"");return;}this.techCall_('setCrossOrigin',value);return;}/**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number} [value]
   *        The value to set the `Player`'s width to.
   *
   * @return {number}
   *         The current width of the `Player` when getting.
   */;_proto.width=function width(value){return this.dimension('width',value);}/**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number} [value]
   *        The value to set the `Player`'s heigth to.
   *
   * @return {number}
   *         The current height of the `Player` when getting.
   */;_proto.height=function height(value){return this.dimension('height',value);}/**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */;_proto.dimension=function dimension(_dimension,value){var privDimension=_dimension+'_';if(value===undefined){return this[privDimension]||0;}if(value===''||value==='auto'){// If an empty string is given, reset the dimension to be automatic
this[privDimension]=undefined;this.updateStyleEl_();return;}var parsedVal=parseFloat(value);if(isNaN(parsedVal)){log$1.error("Improper value \""+value+"\" supplied for for "+_dimension);return;}this[privDimension]=parsedVal;this.updateStyleEl_();}/**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * Turning this on will turn off fill mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */;_proto.fluid=function fluid(bool){var _this3=this;if(bool===undefined){return!!this.fluid_;}this.fluid_=!!bool;if(isEvented(this)){this.off(['playerreset','resize'],this.boundUpdateStyleEl_);}if(bool){this.addClass('vjs-fluid');this.fill(false);addEventedCallback(this,function(){_this3.on(['playerreset','resize'],_this3.boundUpdateStyleEl_);});}else{this.removeClass('vjs-fluid');}this.updateStyleEl_();}/**
   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
   *
   * Turning this on will turn off fluid mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */;_proto.fill=function fill(bool){if(bool===undefined){return!!this.fill_;}this.fill_=!!bool;if(bool){this.addClass('vjs-fill');this.fluid(false);}else{this.removeClass('vjs-fill');}}/**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */ /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player`'s aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */;_proto.aspectRatio=function aspectRatio(ratio){if(ratio===undefined){return this.aspectRatio_;}// Check for width:height format
if(!/^\d+\:\d+$/.test(ratio)){throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');}this.aspectRatio_=ratio;// We're assuming if you set an aspect ratio you want fluid mode,
// because in fixed mode you could calculate width and height yourself.
this.fluid(true);this.updateStyleEl_();}/**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */;_proto.updateStyleEl_=function updateStyleEl_(){if((window_default()).VIDEOJS_NO_DYNAMIC_STYLE===true){var _width=typeof this.width_==='number'?this.width_:this.options_.width;var _height=typeof this.height_==='number'?this.height_:this.options_.height;var techEl=this.tech_&&this.tech_.el();if(techEl){if(_width>=0){techEl.width=_width;}if(_height>=0){techEl.height=_height;}}return;}var width;var height;var aspectRatio;var idClass;// The aspect ratio is either used directly or to calculate width and height.
if(this.aspectRatio_!==undefined&&this.aspectRatio_!=='auto'){// Use any aspectRatio that's been specifically set
aspectRatio=this.aspectRatio_;}else if(this.videoWidth()>0){// Otherwise try to get the aspect ratio from the video metadata
aspectRatio=this.videoWidth()+':'+this.videoHeight();}else{// Or use a default. The video element's is 2:1, but 16:9 is more common.
aspectRatio='16:9';}// Get the ratio as a decimal we can use to calculate dimensions
var ratioParts=aspectRatio.split(':');var ratioMultiplier=ratioParts[1]/ratioParts[0];if(this.width_!==undefined){// Use any width that's been specifically set
width=this.width_;}else if(this.height_!==undefined){// Or calulate the width from the aspect ratio if a height has been set
width=this.height_/ratioMultiplier;}else{// Or use the video's metadata, or use the video el's default of 300
width=this.videoWidth()||300;}if(this.height_!==undefined){// Use any height that's been specifically set
height=this.height_;}else{// Otherwise calculate the height from the ratio and the width
height=width*ratioMultiplier;}// Ensure the CSS class is valid by starting with an alpha character
if(/^[^a-zA-Z]/.test(this.id())){idClass='dimensions-'+this.id();}else{idClass=this.id()+'-dimensions';}// Ensure the right class is still on the player for the style element
this.addClass(idClass);setTextContent(this.styleEl_,"\n      ."+idClass+" {\n        width: "+width+"px;\n        height: "+height+"px;\n      }\n\n      ."+idClass+".vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: "+ratioMultiplier*100+"%;\n      }\n    ");}/**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */;_proto.loadTech_=function loadTech_(techName,source){var _this4=this;// Pause and remove current playback technology
if(this.tech_){this.unloadTech_();}var titleTechName=toTitleCase$1(techName);var camelTechName=techName.charAt(0).toLowerCase()+techName.slice(1);// get rid of the HTML5 video tag as soon as we are using another tech
if(titleTechName!=='Html5'&&this.tag){Tech.getTech('Html5').disposeMediaElement(this.tag);this.tag.player=null;this.tag=null;}this.techName_=titleTechName;// Turn off API access because we're loading a new tech that might load asynchronously
this.isReady_=false;var autoplay=this.autoplay();// if autoplay is a string (or `true` with normalizeAutoplay: true) we pass false to the tech
// because the player is going to handle autoplay on `loadstart`
if(typeof this.autoplay()==='string'||this.autoplay()===true&&this.options_.normalizeAutoplay){autoplay=false;}// Grab tech-specific options from player options and add source and parent element to use.
var techOptions={source:source,autoplay:autoplay,'nativeControlsForTouch':this.options_.nativeControlsForTouch,'playerId':this.id(),'techId':this.id()+"_"+camelTechName+"_api",'playsinline':this.options_.playsinline,'preload':this.options_.preload,'loop':this.options_.loop,'disablePictureInPicture':this.options_.disablePictureInPicture,'muted':this.options_.muted,'poster':this.poster(),'language':this.language(),'playerElIngest':this.playerElIngest_||false,'vtt.js':this.options_['vtt.js'],'canOverridePoster':!!this.options_.techCanOverridePoster,'enableSourceset':this.options_.enableSourceset,'Promise':this.options_.Promise};ALL.names.forEach(function(name){var props=ALL[name];techOptions[props.getterName]=_this4[props.privateName];});video_es_assign(techOptions,this.options_[titleTechName]);video_es_assign(techOptions,this.options_[camelTechName]);video_es_assign(techOptions,this.options_[techName.toLowerCase()]);if(this.tag){techOptions.tag=this.tag;}if(source&&source.src===this.cache_.src&&this.cache_.currentTime>0){techOptions.startTime=this.cache_.currentTime;}// Initialize tech instance
var TechClass=Tech.getTech(techName);if(!TechClass){throw new Error("No Tech named '"+titleTechName+"' exists! '"+titleTechName+"' should be registered using videojs.registerTech()'");}this.tech_=new TechClass(techOptions);// player.triggerReady is always async, so don't need this to be async
this.tech_.ready(bind(this,this.handleTechReady_),true);textTrackConverter.jsonToTextTracks(this.textTracksJson_||[],this.tech_);// Listen to all HTML5-defined events and trigger them on the player
TECH_EVENTS_RETRIGGER.forEach(function(event){_this4.on(_this4.tech_,event,function(e){return _this4["handleTech"+toTitleCase$1(event)+"_"](e);});});Object.keys(TECH_EVENTS_QUEUE).forEach(function(event){_this4.on(_this4.tech_,event,function(eventObj){if(_this4.tech_.playbackRate()===0&&_this4.tech_.seeking()){_this4.queuedCallbacks_.push({callback:_this4["handleTech"+TECH_EVENTS_QUEUE[event]+"_"].bind(_this4),event:eventObj});return;}_this4["handleTech"+TECH_EVENTS_QUEUE[event]+"_"](eventObj);});});this.on(this.tech_,'loadstart',function(e){return _this4.handleTechLoadStart_(e);});this.on(this.tech_,'sourceset',function(e){return _this4.handleTechSourceset_(e);});this.on(this.tech_,'waiting',function(e){return _this4.handleTechWaiting_(e);});this.on(this.tech_,'ended',function(e){return _this4.handleTechEnded_(e);});this.on(this.tech_,'seeking',function(e){return _this4.handleTechSeeking_(e);});this.on(this.tech_,'play',function(e){return _this4.handleTechPlay_(e);});this.on(this.tech_,'firstplay',function(e){return _this4.handleTechFirstPlay_(e);});this.on(this.tech_,'pause',function(e){return _this4.handleTechPause_(e);});this.on(this.tech_,'durationchange',function(e){return _this4.handleTechDurationChange_(e);});this.on(this.tech_,'fullscreenchange',function(e,data){return _this4.handleTechFullscreenChange_(e,data);});this.on(this.tech_,'fullscreenerror',function(e,err){return _this4.handleTechFullscreenError_(e,err);});this.on(this.tech_,'enterpictureinpicture',function(e){return _this4.handleTechEnterPictureInPicture_(e);});this.on(this.tech_,'leavepictureinpicture',function(e){return _this4.handleTechLeavePictureInPicture_(e);});this.on(this.tech_,'error',function(e){return _this4.handleTechError_(e);});this.on(this.tech_,'posterchange',function(e){return _this4.handleTechPosterChange_(e);});this.on(this.tech_,'textdata',function(e){return _this4.handleTechTextData_(e);});this.on(this.tech_,'ratechange',function(e){return _this4.handleTechRateChange_(e);});this.on(this.tech_,'loadedmetadata',this.boundUpdateStyleEl_);this.usingNativeControls(this.techGet_('controls'));if(this.controls()&&!this.usingNativeControls()){this.addTechControlsListeners_();}// Add the tech element in the DOM if it was not already there
// Make sure to not insert the original video element if using Html5
if(this.tech_.el().parentNode!==this.el()&&(titleTechName!=='Html5'||!this.tag)){prependTo(this.tech_.el(),this.el());}// Get rid of the original video tag reference after the first tech is loaded
if(this.tag){this.tag.player=null;this.tag=null;}}/**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */;_proto.unloadTech_=function unloadTech_(){var _this5=this;// Save the current text tracks so that we can reuse the same text tracks with the next tech
ALL.names.forEach(function(name){var props=ALL[name];_this5[props.privateName]=_this5[props.getterName]();});this.textTracksJson_=textTrackConverter.textTracksToJson(this.tech_);this.isReady_=false;this.tech_.dispose();this.tech_=false;if(this.isPosterFromTech_){this.poster_='';this.trigger('posterchange');}this.isPosterFromTech_=false;}/**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */;_proto.tech=function tech(safety){if(safety===undefined){log$1.warn('Using the tech directly can be dangerous. I hope you know what you\'re doing.\n'+'See https://github.com/videojs/video.js/issues/2617 for more info.\n');}return this.tech_;}/**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */;_proto.addTechControlsListeners_=function addTechControlsListeners_(){// Make sure to remove all the previous listeners in case we are called multiple times.
this.removeTechControlsListeners_();this.on(this.tech_,'click',this.boundHandleTechClick_);this.on(this.tech_,'dblclick',this.boundHandleTechDoubleClick_);// If the controls were hidden we don't want that to change without a tap event
// so we'll check if the controls were already showing before reporting user
// activity
this.on(this.tech_,'touchstart',this.boundHandleTechTouchStart_);this.on(this.tech_,'touchmove',this.boundHandleTechTouchMove_);this.on(this.tech_,'touchend',this.boundHandleTechTouchEnd_);// The tap listener needs to come after the touchend listener because the tap
// listener cancels out any reportedUserActivity when setting userActive(false)
this.on(this.tech_,'tap',this.boundHandleTechTap_);}/**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */;_proto.removeTechControlsListeners_=function removeTechControlsListeners_(){// We don't want to just use `this.off()` because there might be other needed
// listeners added by techs that extend this.
this.off(this.tech_,'tap',this.boundHandleTechTap_);this.off(this.tech_,'touchstart',this.boundHandleTechTouchStart_);this.off(this.tech_,'touchmove',this.boundHandleTechTouchMove_);this.off(this.tech_,'touchend',this.boundHandleTechTouchEnd_);this.off(this.tech_,'click',this.boundHandleTechClick_);this.off(this.tech_,'dblclick',this.boundHandleTechDoubleClick_);}/**
   * Player waits for the tech to be ready
   *
   * @private
   */;_proto.handleTechReady_=function handleTechReady_(){this.triggerReady();// Keep the same volume as before
if(this.cache_.volume){this.techCall_('setVolume',this.cache_.volume);}// Look if the tech found a higher resolution poster while loading
this.handleTechPosterChange_();// Update the duration if available
this.handleTechDurationChange_();}/**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}. This
   * function will also trigger {@link Player#firstplay} if it is the first loadstart
   * for a video.
   *
   * @fires Player#loadstart
   * @fires Player#firstplay
   * @listens Tech#loadstart
   * @private
   */;_proto.handleTechLoadStart_=function handleTechLoadStart_(){// TODO: Update to use `emptied` event instead. See #1277.
this.removeClass('vjs-ended');this.removeClass('vjs-seeking');// reset the error state
this.error(null);// Update the duration
this.handleTechDurationChange_();// If it's already playing we want to trigger a firstplay event now.
// The firstplay event relies on both the play and loadstart events
// which can happen in any order for a new source
if(!this.paused()){/**
       * Fired when the user agent begins looking for media data
       *
       * @event Player#loadstart
       * @type {EventTarget~Event}
       */this.trigger('loadstart');this.trigger('firstplay');}else{// reset the hasStarted state
this.hasStarted(false);this.trigger('loadstart');}// autoplay happens after loadstart for the browser,
// so we mimic that behavior
this.manualAutoplay_(this.autoplay()===true&&this.options_.normalizeAutoplay?'play':this.autoplay());}/**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */;_proto.manualAutoplay_=function manualAutoplay_(type){var _this6=this;if(!this.tech_||typeof type!=='string'){return;}// Save original muted() value, set muted to true, and attempt to play().
// On promise rejection, restore muted from saved value
var resolveMuted=function resolveMuted(){var previouslyMuted=_this6.muted();_this6.muted(true);var restoreMuted=function restoreMuted(){_this6.muted(previouslyMuted);};// restore muted on play terminatation
_this6.playTerminatedQueue_.push(restoreMuted);var mutedPromise=_this6.play();if(!isPromise(mutedPromise)){return;}return mutedPromise["catch"](function(err){restoreMuted();throw new Error("Rejection at manualAutoplay. Restoring muted value. "+(err?err:''));});};var promise;// if muted defaults to true
// the only thing we can do is call play
if(type==='any'&&!this.muted()){promise=this.play();if(isPromise(promise)){promise=promise["catch"](resolveMuted);}}else if(type==='muted'&&!this.muted()){promise=resolveMuted();}else{promise=this.play();}if(!isPromise(promise)){return;}return promise.then(function(){_this6.trigger({type:'autoplay-success',autoplay:type});})["catch"](function(){_this6.trigger({type:'autoplay-failure',autoplay:type});});}/**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */;_proto.updateSourceCaches_=function updateSourceCaches_(srcObj){if(srcObj===void 0){srcObj='';}var src=srcObj;var type='';if(typeof src!=='string'){src=srcObj.src;type=srcObj.type;}// make sure all the caches are set to default values
// to prevent null checking
this.cache_.source=this.cache_.source||{};this.cache_.sources=this.cache_.sources||[];// try to get the type of the src that was passed in
if(src&&!type){type=findMimetype(this,src);}// update `currentSource` cache always
this.cache_.source=mergeOptions$3({},srcObj,{src:src,type:type});var matchingSources=this.cache_.sources.filter(function(s){return s.src&&s.src===src;});var sourceElSources=[];var sourceEls=this.$$('source');var matchingSourceEls=[];for(var i=0;i<sourceEls.length;i++){var sourceObj=getAttributes(sourceEls[i]);sourceElSources.push(sourceObj);if(sourceObj.src&&sourceObj.src===src){matchingSourceEls.push(sourceObj.src);}}// if we have matching source els but not matching sources
// the current source cache is not up to date
if(matchingSourceEls.length&&!matchingSources.length){this.cache_.sources=sourceElSources;// if we don't have matching source or source els set the
// sources cache to the `currentSource` cache
}else if(!matchingSources.length){this.cache_.sources=[this.cache_.source];}// update the tech `src` cache
this.cache_.src=src;}/**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {EventTarget~Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */ /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */;_proto.handleTechSourceset_=function handleTechSourceset_(event){var _this7=this;// only update the source cache when the source
// was not updated using the player api
if(!this.changingSrc_){var updateSourceCaches=function updateSourceCaches(src){return _this7.updateSourceCaches_(src);};var playerSrc=this.currentSource().src;var eventSrc=event.src;// if we have a playerSrc that is not a blob, and a tech src that is a blob
if(playerSrc&&!/^blob:/.test(playerSrc)&&/^blob:/.test(eventSrc)){// if both the tech source and the player source were updated we assume
// something like @videojs/http-streaming did the sourceset and skip updating the source cache.
if(!this.lastSource_||this.lastSource_.tech!==eventSrc&&this.lastSource_.player!==playerSrc){updateSourceCaches=function updateSourceCaches(){};}}// update the source to the initial source right away
// in some cases this will be empty string
updateSourceCaches(eventSrc);// if the `sourceset` `src` was an empty string
// wait for a `loadstart` to update the cache to `currentSrc`.
// If a sourceset happens before a `loadstart`, we reset the state
if(!event.src){this.tech_.any(['sourceset','loadstart'],function(e){// if a sourceset happens before a `loadstart` there
// is nothing to do as this `handleTechSourceset_`
// will be called again and this will be handled there.
if(e.type==='sourceset'){return;}var techSrc=_this7.techGet('currentSrc');_this7.lastSource_.tech=techSrc;_this7.updateSourceCaches_(techSrc);});}}this.lastSource_={player:this.currentSource().src,tech:event.src};this.trigger({src:event.src,type:'sourceset'});}/**
   * Add/remove the vjs-has-started class
   *
   * @fires Player#firstplay
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */;_proto.hasStarted=function hasStarted(request){if(request===undefined){// act as getter, if we have no request to change
return this.hasStarted_;}if(request===this.hasStarted_){return;}this.hasStarted_=request;if(this.hasStarted_){this.addClass('vjs-has-started');this.trigger('firstplay');}else{this.removeClass('vjs-has-started');}}/**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */;_proto.handleTechPlay_=function handleTechPlay_(){this.removeClass('vjs-ended');this.removeClass('vjs-paused');this.addClass('vjs-playing');// hide the poster when the user hits play
this.hasStarted(true);/**
     * Triggered whenever an {@link Tech#play} event happens. Indicates that
     * playback has started or resumed.
     *
     * @event Player#play
     * @type {EventTarget~Event}
     */this.trigger('play');}/**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */;_proto.handleTechRateChange_=function handleTechRateChange_(){if(this.tech_.playbackRate()>0&&this.cache_.lastPlaybackRate===0){this.queuedCallbacks_.forEach(function(queued){return queued.callback(queued.event);});this.queuedCallbacks_=[];}this.cache_.lastPlaybackRate=this.tech_.playbackRate();/**
     * Fires when the playing speed of the audio/video is changed
     *
     * @event Player#ratechange
     * @type {event}
     */this.trigger('ratechange');}/**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */;_proto.handleTechWaiting_=function handleTechWaiting_(){var _this8=this;this.addClass('vjs-waiting');/**
     * A readyState change on the DOM element has caused playback to stop.
     *
     * @event Player#waiting
     * @type {EventTarget~Event}
     */this.trigger('waiting');// Browsers may emit a timeupdate event after a waiting event. In order to prevent
// premature removal of the waiting class, wait for the time to change.
var timeWhenWaiting=this.currentTime();var timeUpdateListener=function timeUpdateListener(){if(timeWhenWaiting!==_this8.currentTime()){_this8.removeClass('vjs-waiting');_this8.off('timeupdate',timeUpdateListener);}};this.on('timeupdate',timeUpdateListener);}/**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */;_proto.handleTechCanPlay_=function handleTechCanPlay_(){this.removeClass('vjs-waiting');/**
     * The media has a readyState of HAVE_FUTURE_DATA or greater.
     *
     * @event Player#canplay
     * @type {EventTarget~Event}
     */this.trigger('canplay');}/**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */;_proto.handleTechCanPlayThrough_=function handleTechCanPlayThrough_(){this.removeClass('vjs-waiting');/**
     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
     * entire media file can be played without buffering.
     *
     * @event Player#canplaythrough
     * @type {EventTarget~Event}
     */this.trigger('canplaythrough');}/**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */;_proto.handleTechPlaying_=function handleTechPlaying_(){this.removeClass('vjs-waiting');/**
     * The media is no longer blocked from playback, and has started playing.
     *
     * @event Player#playing
     * @type {EventTarget~Event}
     */this.trigger('playing');}/**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */;_proto.handleTechSeeking_=function handleTechSeeking_(){this.addClass('vjs-seeking');/**
     * Fired whenever the player is jumping to a new time
     *
     * @event Player#seeking
     * @type {EventTarget~Event}
     */this.trigger('seeking');}/**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */;_proto.handleTechSeeked_=function handleTechSeeked_(){this.removeClass('vjs-seeking');this.removeClass('vjs-ended');/**
     * Fired when the player has finished jumping to a new time
     *
     * @event Player#seeked
     * @type {EventTarget~Event}
     */this.trigger('seeked');}/**
   * Retrigger the `firstplay` event that was triggered by the {@link Tech}.
   *
   * @fires Player#firstplay
   * @listens Tech#firstplay
   * @deprecated As of 6.0 firstplay event is deprecated.
   *             As of 6.0 passing the `starttime` option to the player and the firstplay event are deprecated.
   * @private
   */;_proto.handleTechFirstPlay_=function handleTechFirstPlay_(){// If the first starttime attribute is specified
// then we will start at the given offset in seconds
if(this.options_.starttime){log$1.warn('Passing the `starttime` option to the player will be deprecated in 6.0');this.currentTime(this.options_.starttime);}this.addClass('vjs-has-started');/**
     * Fired the first time a video is played. Not part of the HLS spec, and this is
     * probably not the best implementation yet, so use sparingly. If you don't have a
     * reason to prevent playback, use `myPlayer.one('play');` instead.
     *
     * @event Player#firstplay
     * @deprecated As of 6.0 firstplay event is deprecated.
     * @type {EventTarget~Event}
     */this.trigger('firstplay');}/**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */;_proto.handleTechPause_=function handleTechPause_(){this.removeClass('vjs-playing');this.addClass('vjs-paused');/**
     * Fired whenever the media has been paused
     *
     * @event Player#pause
     * @type {EventTarget~Event}
     */this.trigger('pause');}/**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */;_proto.handleTechEnded_=function handleTechEnded_(){this.addClass('vjs-ended');this.removeClass('vjs-waiting');if(this.options_.loop){this.currentTime(0);this.play();}else if(!this.paused()){this.pause();}/**
     * Fired when the end of the media resource is reached (currentTime == duration)
     *
     * @event Player#ended
     * @type {EventTarget~Event}
     */this.trigger('ended');}/**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */;_proto.handleTechDurationChange_=function handleTechDurationChange_(){this.duration(this.techGet_('duration'));}/**
   * Handle a click on the media element to play/pause
   *
   * @param {EventTarget~Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#click
   * @private
   */;_proto.handleTechClick_=function handleTechClick_(event){// When controls are disabled a click should not toggle playback because
// the click is considered a control
if(!this.controls_){return;}if(this.options_===undefined||this.options_.userActions===undefined||this.options_.userActions.click===undefined||this.options_.userActions.click!==false){if(this.options_!==undefined&&this.options_.userActions!==undefined&&typeof this.options_.userActions.click==='function'){this.options_.userActions.click.call(this,event);}else if(this.paused()){silencePromise(this.play());}else{this.pause();}}}/**
   * Handle a double-click on the media element to enter/exit fullscreen
   *
   * @param {EventTarget~Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#dblclick
   * @private
   */;_proto.handleTechDoubleClick_=function handleTechDoubleClick_(event){if(!this.controls_){return;}// we do not want to toggle fullscreen state
// when double-clicking inside a control bar or a modal
var inAllowedEls=Array.prototype.some.call(this.$$('.vjs-control-bar, .vjs-modal-dialog'),function(el){return el.contains(event.target);});if(!inAllowedEls){/*
       * options.userActions.doubleClick
       *
       * If `undefined` or `true`, double-click toggles fullscreen if controls are present
       * Set to `false` to disable double-click handling
       * Set to a function to substitute an external double-click handler
       */if(this.options_===undefined||this.options_.userActions===undefined||this.options_.userActions.doubleClick===undefined||this.options_.userActions.doubleClick!==false){if(this.options_!==undefined&&this.options_.userActions!==undefined&&typeof this.options_.userActions.doubleClick==='function'){this.options_.userActions.doubleClick.call(this,event);}else if(this.isFullscreen()){this.exitFullscreen();}else{this.requestFullscreen();}}}}/**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */;_proto.handleTechTap_=function handleTechTap_(){this.userActive(!this.userActive());}/**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */;_proto.handleTechTouchStart_=function handleTechTouchStart_(){this.userWasActive=this.userActive();}/**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */;_proto.handleTechTouchMove_=function handleTechTouchMove_(){if(this.userWasActive){this.reportUserActivity();}}/**
   * Handle touch to end
   *
   * @param {EventTarget~Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */;_proto.handleTechTouchEnd_=function handleTechTouchEnd_(event){// Stop the mouse events from also happening
if(event.cancelable){event.preventDefault();}}/**
   * native click events on the SWF aren't triggered on IE11, Win8.1RT
   * use stageclick events triggered from inside the SWF instead
   *
   * @private
   * @listens stageclick
   */;_proto.handleStageClick_=function handleStageClick_(){this.reportUserActivity();}/**
   * @private
   */;_proto.toggleFullscreenClass_=function toggleFullscreenClass_(){if(this.isFullscreen()){this.addClass('vjs-fullscreen');}else{this.removeClass('vjs-fullscreen');}}/**
   * when the document fschange event triggers it calls this
   */;_proto.documentFullscreenChange_=function documentFullscreenChange_(e){var targetPlayer=e.target.player;// if another player was fullscreen
// do a null check for targetPlayer because older firefox's would put document as e.target
if(targetPlayer&&targetPlayer!==this){return;}var el=this.el();var isFs=(document_default())[this.fsApi_.fullscreenElement]===el;if(!isFs&&el.matches){isFs=el.matches(':'+this.fsApi_.fullscreen);}else if(!isFs&&el.msMatchesSelector){isFs=el.msMatchesSelector(':'+this.fsApi_.fullscreen);}this.isFullscreen(isFs);}/**
   * Handle Tech Fullscreen Change
   *
   * @param {EventTarget~Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */;_proto.handleTechFullscreenChange_=function handleTechFullscreenChange_(event,data){var _this9=this;if(data){if(data.nativeIOSFullscreen){this.addClass('vjs-ios-native-fs');this.tech_.one('webkitendfullscreen',function(){_this9.removeClass('vjs-ios-native-fs');});}this.isFullscreen(data.isFullscreen);}};_proto.handleTechFullscreenError_=function handleTechFullscreenError_(event,err){this.trigger('fullscreenerror',err);}/**
   * @private
   */;_proto.togglePictureInPictureClass_=function togglePictureInPictureClass_(){if(this.isInPictureInPicture()){this.addClass('vjs-picture-in-picture');}else{this.removeClass('vjs-picture-in-picture');}}/**
   * Handle Tech Enter Picture-in-Picture.
   *
   * @param {EventTarget~Event} event
   *        the enterpictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#enterpictureinpicture
   */;_proto.handleTechEnterPictureInPicture_=function handleTechEnterPictureInPicture_(event){this.isInPictureInPicture(true);}/**
   * Handle Tech Leave Picture-in-Picture.
   *
   * @param {EventTarget~Event} event
   *        the leavepictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#leavepictureinpicture
   */;_proto.handleTechLeavePictureInPicture_=function handleTechLeavePictureInPicture_(event){this.isInPictureInPicture(false);}/**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */;_proto.handleTechError_=function handleTechError_(){var error=this.tech_.error();this.error(error);}/**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */;_proto.handleTechTextData_=function handleTechTextData_(){var data=null;if(arguments.length>1){data=arguments[1];}/**
     * Fires when we get a textdata event from tech
     *
     * @event Player#textdata
     * @type {EventTarget~Event}
     */this.trigger('textdata',data);}/**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */;_proto.getCache=function getCache(){return this.cache_;}/**
   * Resets the internal cache object.
   *
   * Using this function outside the player constructor or reset method may
   * have unintended side-effects.
   *
   * @private
   */;_proto.resetCache_=function resetCache_(){this.cache_={// Right now, the currentTime is not _really_ cached because it is always
// retrieved from the tech (see: currentTime). However, for completeness,
// we set it to zero here to ensure that if we do start actually caching
// it, we reset it along with everything else.
currentTime:0,initTime:0,inactivityTimeout:this.options_.inactivityTimeout,duration:NaN,lastVolume:1,lastPlaybackRate:this.defaultPlaybackRate(),media:null,src:'',source:{},sources:[],playbackRates:[],volume:1};}/**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} arg
   *        the argument to pass
   *
   * @private
   */;_proto.techCall_=function techCall_(method,arg){// If it's not ready yet, call method when it is
this.ready(function(){if(method in allowedSetters){return set(this.middleware_,this.tech_,method,arg);}else if(method in allowedMediators){return mediate(this.middleware_,this.tech_,method,arg);}try{if(this.tech_){this.tech_[method](arg);}}catch(e){log$1(e);throw e;}},true);}/**
   * Get calls can't wait for the tech, and sometimes don't need to.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {Function|undefined}
   *         the method or undefined
   *
   * @private
   */;_proto.techGet_=function techGet_(method){if(!this.tech_||!this.tech_.isReady_){return;}if(method in allowedGetters){return get(this.middleware_,this.tech_,method);}else if(method in allowedMediators){return mediate(this.middleware_,this.tech_,method);}// Flash likes to die and reload when you hide or reposition it.
// In these cases the object methods go away and we get errors.
// TODO: Is this needed for techs other than Flash?
// When that happens we'll catch the errors and inform tech that it's not ready any more.
try{return this.tech_[method]();}catch(e){// When building additional tech libs, an expected method may not be defined yet
if(this.tech_[method]===undefined){log$1("Video.js: "+method+" method not defined for "+this.techName_+" playback technology.",e);throw e;}// When a method isn't available on the object it throws a TypeError
if(e.name==='TypeError'){log$1("Video.js: "+method+" unavailable on "+this.techName_+" playback technology element.",e);this.tech_.isReady_=false;throw e;}// If error unknown, just log and throw
log$1(e);throw e;}}/**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */;_proto.play=function play(){var _this10=this;var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){return new PromiseClass(function(resolve){_this10.play_(resolve);});}return this.play_();}/**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */;_proto.play_=function play_(callback){var _this11=this;if(callback===void 0){callback=silencePromise;}this.playCallbacks_.push(callback);var isSrcReady=Boolean(!this.changingSrc_&&(this.src()||this.currentSrc()));var isSafariOrIOS=Boolean(IS_ANY_SAFARI||IS_IOS);// treat calls to play_ somewhat like the `one` event function
if(this.waitToPlay_){this.off(['ready','loadstart'],this.waitToPlay_);this.waitToPlay_=null;}// if the player/tech is not ready or the src itself is not ready
// queue up a call to play on `ready` or `loadstart`
if(!this.isReady_||!isSrcReady){this.waitToPlay_=function(e){_this11.play_();};this.one(['ready','loadstart'],this.waitToPlay_);// if we are in Safari, there is a high chance that loadstart will trigger after the gesture timeperiod
// in that case, we need to prime the video element by calling load so it'll be ready in time
if(!isSrcReady&&isSafariOrIOS){this.load();}return;}// If the player/tech is ready and we have a source, we can attempt playback.
var val=this.techGet_('play');// For native playback, reset the progress bar if we get a play call from a replay.
var isNativeReplay=isSafariOrIOS&&this.hasClass('vjs-ended');if(isNativeReplay){this.resetProgressBar_();}// play was terminated if the returned value is null
if(val===null){this.runPlayTerminatedQueue_();}else{this.runPlayCallbacks_(val);}}/**
   * These functions will be run when if play is terminated. If play
   * runPlayCallbacks_ is run these function will not be run. This allows us
   * to differenciate between a terminated play and an actual call to play.
   */;_proto.runPlayTerminatedQueue_=function runPlayTerminatedQueue_(){var queue=this.playTerminatedQueue_.slice(0);this.playTerminatedQueue_=[];queue.forEach(function(q){q();});}/**
   * When a callback to play is delayed we have to run these
   * callbacks when play is actually called on the tech. This function
   * runs the callbacks that were delayed and accepts the return value
   * from the tech.
   *
   * @param {undefined|Promise} val
   *        The return value from the tech.
   */;_proto.runPlayCallbacks_=function runPlayCallbacks_(val){var callbacks=this.playCallbacks_.slice(0);this.playCallbacks_=[];// clear play terminatedQueue since we finished a real play
this.playTerminatedQueue_=[];callbacks.forEach(function(cb){cb(val);});}/**
   * Pause the video playback
   *
   * @return {Player}
   *         A reference to the player object this function was called on
   */;_proto.pause=function pause(){this.techCall_('pause');}/**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */;_proto.paused=function paused(){// The initial state of paused should be true (in Safari it's actually false)
return this.techGet_('paused')===false?false:true;}/**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return {TimeRange}
   *         A time range object that represents all the increments of time that have
   *         been played.
   */;_proto.played=function played(){return this.techGet_('played')||createTimeRanges(0,0);}/**
   * Returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        whether the user is or is not scrubbing
   *
   * @return {boolean}
   *         The value of scrubbing when getting
   */;_proto.scrubbing=function scrubbing(isScrubbing){if(typeof isScrubbing==='undefined'){return this.scrubbing_;}this.scrubbing_=!!isScrubbing;this.techCall_('setScrubbing',this.scrubbing_);if(isScrubbing){this.addClass('vjs-scrubbing');}else{this.removeClass('vjs-scrubbing');}}/**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number}
   *         - the current time in seconds when getting
   */;_proto.currentTime=function currentTime(seconds){if(typeof seconds!=='undefined'){if(seconds<0){seconds=0;}if(!this.isReady_||this.changingSrc_||!this.tech_||!this.tech_.isReady_){this.cache_.initTime=seconds;this.off('canplay',this.boundApplyInitTime_);this.one('canplay',this.boundApplyInitTime_);return;}this.techCall_('setCurrentTime',seconds);this.cache_.initTime=0;return;}// cache last currentTime and return. default to 0 seconds
//
// Caching the currentTime is meant to prevent a massive amount of reads on the tech's
// currentTime when scrubbing, but may not provide much performance benefit afterall.
// Should be tested. Also something has to read the actual current time or the cache will
// never get updated.
this.cache_.currentTime=this.techGet_('currentTime')||0;return this.cache_.currentTime;}/**
   * Apply the value of initTime stored in cache as currentTime.
   *
   * @private
   */;_proto.applyInitTime_=function applyInitTime_(){this.currentTime(this.cache_.initTime);}/**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and depending on preload behaviour may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number}
   *         - The duration of the video in seconds when getting
   */;_proto.duration=function duration(seconds){if(seconds===undefined){// return NaN if the duration is not known
return this.cache_.duration!==undefined?this.cache_.duration:NaN;}seconds=parseFloat(seconds);// Standardize on Infinity for signaling video is live
if(seconds<0){seconds=Infinity;}if(seconds!==this.cache_.duration){// Cache the last set value for optimized scrubbing (esp. Flash)
// TODO: Required for techs other than Flash?
this.cache_.duration=seconds;if(seconds===Infinity){this.addClass('vjs-live');}else{this.removeClass('vjs-live');}if(!isNaN(seconds)){// Do not fire durationchange unless the duration value is known.
// @see [Spec]{@link https://www.w3.org/TR/2011/WD-html5-20110113/video.html#media-element-load-algorithm}
/**
         * @event Player#durationchange
         * @type {EventTarget~Event}
         */this.trigger('durationchange');}}}/**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */;_proto.remainingTime=function remainingTime(){return this.duration()-this.currentTime();}/**
   * A remaining time function that is intented to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */;_proto.remainingTimeDisplay=function remainingTimeDisplay(){return Math.floor(this.duration())-Math.floor(this.currentTime());}//
// Kind of like an array of portions of the video that have been downloaded.
/**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return {TimeRange}
   *         A mock TimeRange object (following HTML spec)
   */;_proto.buffered=function buffered(){var buffered=this.techGet_('buffered');if(!buffered||!buffered.length){buffered=createTimeRanges(0,0);}return buffered;}/**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is buffered 0 being 0% and 1 being 100%
   */;_proto.bufferedPercent=function bufferedPercent$1(){return bufferedPercent(this.buffered(),this.duration());}/**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */;_proto.bufferedEnd=function bufferedEnd(){var buffered=this.buffered();var duration=this.duration();var end=buffered.end(buffered.length-1);if(end>duration){end=duration;}return end;}/**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number}
   *         The current volume as a percent when getting
   */;_proto.volume=function volume(percentAsDecimal){var vol;if(percentAsDecimal!==undefined){// Force value to between 0 and 1
vol=Math.max(0,Math.min(1,parseFloat(percentAsDecimal)));this.cache_.volume=vol;this.techCall_('setVolume',vol);if(vol>0){this.lastVolume_(vol);}return;}// Default to 1 when returning current volume.
vol=parseFloat(this.techGet_('volume'));return isNaN(vol)?1:vol;}/**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   */;_proto.muted=function muted(_muted){if(_muted!==undefined){this.techCall_('setMuted',_muted);return;}return this.techGet_('muted')||false;}/**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on initial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|Player}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - A reference to the current player when setting
   */;_proto.defaultMuted=function defaultMuted(_defaultMuted){if(_defaultMuted!==undefined){return this.techCall_('setDefaultMuted',_defaultMuted);}return this.techGet_('defaultMuted')||false;}/**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number}
   *         the current value of lastVolume as a percent when getting
   *
   * @private
   */;_proto.lastVolume_=function lastVolume_(percentAsDecimal){if(percentAsDecimal!==undefined&&percentAsDecimal!==0){this.cache_.lastVolume=percentAsDecimal;return;}return this.cache_.lastVolume;}/**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */;_proto.supportsFullScreen=function supportsFullScreen(){return this.techGet_('supportsFullScreen')||false;}/**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   */;_proto.isFullscreen=function isFullscreen(isFS){if(isFS!==undefined){var oldValue=this.isFullscreen_;this.isFullscreen_=Boolean(isFS);// if we changed fullscreen state and we're in prefixed mode, trigger fullscreenchange
// this is the only place where we trigger fullscreenchange events for older browsers
// fullWindow mode is treated as a prefixed event and will get a fullscreenchange event as well
if(this.isFullscreen_!==oldValue&&this.fsApi_.prefixed){/**
           * @event Player#fullscreenchange
           * @type {EventTarget~Event}
           */this.trigger('fullscreenchange');}this.toggleFullscreenClass_();return;}return this.isFullscreen_;}/**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @param  {Object} [fullscreenOptions]
   *         Override the player fullscreen options
   *
   * @fires Player#fullscreenchange
   */;_proto.requestFullscreen=function requestFullscreen(fullscreenOptions){var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){var self=this;return new PromiseClass(function(resolve,reject){function offHandler(){self.off('fullscreenerror',errorHandler);self.off('fullscreenchange',changeHandler);}function changeHandler(){offHandler();resolve();}function errorHandler(e,err){offHandler();reject(err);}self.one('fullscreenchange',changeHandler);self.one('fullscreenerror',errorHandler);var promise=self.requestFullscreenHelper_(fullscreenOptions);if(promise){promise.then(offHandler,offHandler);promise.then(resolve,reject);}});}return this.requestFullscreenHelper_();};_proto.requestFullscreenHelper_=function requestFullscreenHelper_(fullscreenOptions){var _this12=this;var fsOptions;// Only pass fullscreen options to requestFullscreen in spec-compliant browsers.
// Use defaults or player configured option unless passed directly to this method.
if(!this.fsApi_.prefixed){fsOptions=this.options_.fullscreen&&this.options_.fullscreen.options||{};if(fullscreenOptions!==undefined){fsOptions=fullscreenOptions;}}// This method works as follows:
// 1. if a fullscreen api is available, use it
//   1. call requestFullscreen with potential options
//   2. if we got a promise from above, use it to update isFullscreen()
// 2. otherwise, if the tech supports fullscreen, call `enterFullScreen` on it.
//   This is particularly used for iPhone, older iPads, and non-safari browser on iOS.
// 3. otherwise, use "fullWindow" mode
if(this.fsApi_.requestFullscreen){var promise=this.el_[this.fsApi_.requestFullscreen](fsOptions);if(promise){promise.then(function(){return _this12.isFullscreen(true);},function(){return _this12.isFullscreen(false);});}return promise;}else if(this.tech_.supportsFullScreen()&&!this.options_.preferFullWindow===true){// we can't take the video.js controls fullscreen but we can go fullscreen
// with native controls
this.techCall_('enterFullScreen');}else{// fullscreen isn't supported so we'll just stretch the video element to
// fill the viewport
this.enterFullWindow();}}/**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */;_proto.exitFullscreen=function exitFullscreen(){var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){var self=this;return new PromiseClass(function(resolve,reject){function offHandler(){self.off('fullscreenerror',errorHandler);self.off('fullscreenchange',changeHandler);}function changeHandler(){offHandler();resolve();}function errorHandler(e,err){offHandler();reject(err);}self.one('fullscreenchange',changeHandler);self.one('fullscreenerror',errorHandler);var promise=self.exitFullscreenHelper_();if(promise){promise.then(offHandler,offHandler);// map the promise to our resolve/reject methods
promise.then(resolve,reject);}});}return this.exitFullscreenHelper_();};_proto.exitFullscreenHelper_=function exitFullscreenHelper_(){var _this13=this;if(this.fsApi_.requestFullscreen){var promise=(document_default())[this.fsApi_.exitFullscreen]();if(promise){// we're splitting the promise here, so, we want to catch the
// potential error so that this chain doesn't have unhandled errors
silencePromise(promise.then(function(){return _this13.isFullscreen(false);}));}return promise;}else if(this.tech_.supportsFullScreen()&&!this.options_.preferFullWindow===true){this.techCall_('exitFullScreen');}else{this.exitFullWindow();}}/**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */;_proto.enterFullWindow=function enterFullWindow(){this.isFullscreen(true);this.isFullWindow=true;// Storing original doc overflow value to return to when fullscreen is off
this.docOrigOverflow=(document_default()).documentElement.style.overflow;// Add listener for esc key to exit fullscreen
on((document_default()),'keydown',this.boundFullWindowOnEscKey_);// Hide any scroll bars
(document_default()).documentElement.style.overflow='hidden';// Apply fullscreen styles
addClass((document_default()).body,'vjs-full-window');/**
     * @event Player#enterFullWindow
     * @type {EventTarget~Event}
     */this.trigger('enterFullWindow');}/**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */;_proto.fullWindowOnEscKey=function fullWindowOnEscKey(event){if(keycode_default().isEventKey(event,'Esc')){if(this.isFullscreen()===true){if(!this.isFullWindow){this.exitFullscreen();}else{this.exitFullWindow();}}}}/**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */;_proto.exitFullWindow=function exitFullWindow(){this.isFullscreen(false);this.isFullWindow=false;off((document_default()),'keydown',this.boundFullWindowOnEscKey_);// Unhide scroll bars.
(document_default()).documentElement.style.overflow=this.docOrigOverflow;// Remove fullscreen styles
removeClass((document_default()).body,'vjs-full-window');// Resize the box, controller, and poster to original sizes
// this.positionAll();
/**
     * @event Player#exitFullWindow
     * @type {EventTarget~Event}
     */this.trigger('exitFullWindow');}/**
   * Disable Picture-in-Picture mode.
   *
   * @param {boolean} value
   *                  - true will disable Picture-in-Picture mode
   *                  - false will enable Picture-in-Picture mode
   */;_proto.disablePictureInPicture=function disablePictureInPicture(value){if(value===undefined){return this.techGet_('disablePictureInPicture');}this.techCall_('setDisablePictureInPicture',value);this.options_.disablePictureInPicture=value;this.trigger('disablepictureinpicturechanged');}/**
   * Check if the player is in Picture-in-Picture mode or tell the player that it
   * is or is not in Picture-in-Picture mode.
   *
   * @param  {boolean} [isPiP]
   *         Set the players current Picture-in-Picture state
   *
   * @return {boolean}
   *         - true if Picture-in-Picture is on and getting
   *         - false if Picture-in-Picture is off and getting
   */;_proto.isInPictureInPicture=function isInPictureInPicture(isPiP){if(isPiP!==undefined){this.isInPictureInPicture_=!!isPiP;this.togglePictureInPictureClass_();return;}return!!this.isInPictureInPicture_;}/**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#enterpictureinpicture
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */;_proto.requestPictureInPicture=function requestPictureInPicture(){if('pictureInPictureEnabled'in (document_default())&&this.disablePictureInPicture()===false){/**
       * This event fires when the player enters picture in picture mode
       *
       * @event Player#enterpictureinpicture
       * @type {EventTarget~Event}
       */return this.techGet_('requestPictureInPicture');}}/**
   * Exit Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#leavepictureinpicture
   *
   * @return {Promise}
   *         A promise.
   */;_proto.exitPictureInPicture=function exitPictureInPicture(){if('pictureInPictureEnabled'in (document_default())){/**
       * This event fires when the player leaves picture in picture mode
       *
       * @event Player#leavepictureinpicture
       * @type {EventTarget~Event}
       */return document_default().exitPictureInPicture();}}/**
   * Called when this Player has focus and a key gets pressed down, or when
   * any Component of this player receives a key press that it doesn't handle.
   * This allows player-wide hotkeys (either as defined below, or optionally
   * by an external function).
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */;_proto.handleKeyDown=function handleKeyDown(event){var userActions=this.options_.userActions;// Bail out if hotkeys are not configured.
if(!userActions||!userActions.hotkeys){return;}// Function that determines whether or not to exclude an element from
// hotkeys handling.
var excludeElement=function excludeElement(el){var tagName=el.tagName.toLowerCase();// The first and easiest test is for `contenteditable` elements.
if(el.isContentEditable){return true;}// Inputs matching these types will still trigger hotkey handling as
// they are not text inputs.
var allowedInputTypes=['button','checkbox','hidden','radio','reset','submit'];if(tagName==='input'){return allowedInputTypes.indexOf(el.type)===-1;}// The final test is by tag name. These tags will be excluded entirely.
var excludedTags=['textarea'];return excludedTags.indexOf(tagName)!==-1;};// Bail out if the user is focused on an interactive form element.
if(excludeElement(this.el_.ownerDocument.activeElement)){return;}if(typeof userActions.hotkeys==='function'){userActions.hotkeys.call(this,event);}else{this.handleHotkeys(event);}}/**
   * Called when this Player receives a hotkey keydown event.
   * Supported player-wide hotkeys are:
   *
   *   f          - toggle fullscreen
   *   m          - toggle mute
   *   k or Space - toggle play/pause
   *
   * @param {EventTarget~Event} event
   *        The `keydown` event that caused this function to be called.
   */;_proto.handleHotkeys=function handleHotkeys(event){var hotkeys=this.options_.userActions?this.options_.userActions.hotkeys:{};// set fullscreenKey, muteKey, playPauseKey from `hotkeys`, use defaults if not set
var _hotkeys$fullscreenKe=hotkeys.fullscreenKey,fullscreenKey=_hotkeys$fullscreenKe===void 0?function(keydownEvent){return keycode_default().isEventKey(keydownEvent,'f');}:_hotkeys$fullscreenKe,_hotkeys$muteKey=hotkeys.muteKey,muteKey=_hotkeys$muteKey===void 0?function(keydownEvent){return keycode_default().isEventKey(keydownEvent,'m');}:_hotkeys$muteKey,_hotkeys$playPauseKey=hotkeys.playPauseKey,playPauseKey=_hotkeys$playPauseKey===void 0?function(keydownEvent){return keycode_default().isEventKey(keydownEvent,'k')||keycode_default().isEventKey(keydownEvent,'Space');}:_hotkeys$playPauseKey;if(fullscreenKey.call(this,event)){event.preventDefault();event.stopPropagation();var FSToggle=Component$1.getComponent('FullscreenToggle');if((document_default())[this.fsApi_.fullscreenEnabled]!==false){FSToggle.prototype.handleClick.call(this,event);}}else if(muteKey.call(this,event)){event.preventDefault();event.stopPropagation();var MuteToggle=Component$1.getComponent('MuteToggle');MuteToggle.prototype.handleClick.call(this,event);}else if(playPauseKey.call(this,event)){event.preventDefault();event.stopPropagation();var PlayToggle=Component$1.getComponent('PlayToggle');PlayToggle.prototype.handleClick.call(this,event);}}/**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */;_proto.canPlayType=function canPlayType(type){var can;// Loop through each playback technology in the options order
for(var i=0,j=this.options_.techOrder;i<j.length;i++){var techName=j[i];var tech=Tech.getTech(techName);// Support old behavior of techs being registered as components.
// Remove once that deprecated behavior is removed.
if(!tech){tech=Component$1.getComponent(techName);}// Check if the current tech is defined before continuing
if(!tech){log$1.error("The \""+techName+"\" tech is undefined. Skipped browser support check for that tech.");continue;}// Check if the browser supports this technology
if(tech.isSupported()){can=tech.canPlayType(type);if(can){return can;}}}return'';}/**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */;_proto.selectSource=function selectSource(sources){var _this14=this;// Get only the techs specified in `techOrder` that exist and are supported by the
// current platform
var techs=this.options_.techOrder.map(function(techName){return[techName,Tech.getTech(techName)];}).filter(function(_ref){var techName=_ref[0],tech=_ref[1];// Check if the current tech is defined before continuing
if(tech){// Check if the browser supports this technology
return tech.isSupported();}log$1.error("The \""+techName+"\" tech is undefined. Skipped browser support check for that tech.");return false;});// Iterate over each `innerArray` element once per `outerArray` element and execute
// `tester` with both. If `tester` returns a non-falsy value, exit early and return
// that value.
var findFirstPassingTechSourcePair=function findFirstPassingTechSourcePair(outerArray,innerArray,tester){var found;outerArray.some(function(outerChoice){return innerArray.some(function(innerChoice){found=tester(outerChoice,innerChoice);if(found){return true;}});});return found;};var foundSourceAndTech;var flip=function flip(fn){return function(a,b){return fn(b,a);};};var finder=function finder(_ref2,source){var techName=_ref2[0],tech=_ref2[1];if(tech.canPlaySource(source,_this14.options_[techName.toLowerCase()])){return{source:source,tech:techName};}};// Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
// to select from them based on their priority.
if(this.options_.sourceOrder){// Source-first ordering
foundSourceAndTech=findFirstPassingTechSourcePair(sources,techs,flip(finder));}else{// Tech-first ordering
foundSourceAndTech=findFirstPassingTechSourcePair(techs,sources,finder);}return foundSourceAndTech||false;}/**
   * Executes source setting and getting logic
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   * @param {boolean} isRetry
   *        Indicates whether this is being called internally as a result of a retry
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */;_proto.handleSrc_=function handleSrc_(source,isRetry){var _this15=this;// getter usage
if(typeof source==='undefined'){return this.cache_.src||'';}// Reset retry behavior for new source
if(this.resetRetryOnError_){this.resetRetryOnError_();}// filter out invalid sources and turn our source into
// an array of source objects
var sources=filterSource(source);// if a source was passed in then it is invalid because
// it was filtered to a zero length Array. So we have to
// show an error
if(!sources.length){this.setTimeout(function(){this.error({code:4,message:this.options_.notSupportedMessage});},0);return;}// initial sources
this.changingSrc_=true;// Only update the cached source list if we are not retrying a new source after error,
// since in that case we want to include the failed source(s) in the cache
if(!isRetry){this.cache_.sources=sources;}this.updateSourceCaches_(sources[0]);// middlewareSource is the source after it has been changed by middleware
setSource(this,sources[0],function(middlewareSource,mws){_this15.middleware_=mws;// since sourceSet is async we have to update the cache again after we select a source since
// the source that is selected could be out of order from the cache update above this callback.
if(!isRetry){_this15.cache_.sources=sources;}_this15.updateSourceCaches_(middlewareSource);var err=_this15.src_(middlewareSource);if(err){if(sources.length>1){return _this15.handleSrc_(sources.slice(1));}_this15.changingSrc_=false;// We need to wrap this in a timeout to give folks a chance to add error event handlers
_this15.setTimeout(function(){this.error({code:4,message:this.options_.notSupportedMessage});},0);// we could not find an appropriate tech, but let's still notify the delegate that this is it
// this needs a better comment about why this is needed
_this15.triggerReady();return;}setTech(mws,_this15.tech_);});// Try another available source if this one fails before playback.
if(this.options_.retryOnError&&sources.length>1){var retry=function retry(){// Remove the error modal
_this15.error(null);_this15.handleSrc_(sources.slice(1),true);};var stopListeningForErrors=function stopListeningForErrors(){_this15.off('error',retry);};this.one('error',retry);this.one('playing',stopListeningForErrors);this.resetRetryOnError_=function(){_this15.off('error',retry);_this15.off('playing',stopListeningForErrors);};}}/**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */;_proto.src=function src(source){return this.handleSrc_(source,false);}/**
   * Set the source object on the tech, returns a boolean that indicates whether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */;_proto.src_=function src_(source){var _this16=this;var sourceTech=this.selectSource([source]);if(!sourceTech){return true;}if(!titleCaseEquals(sourceTech.tech,this.techName_)){this.changingSrc_=true;// load this technology with the chosen source
this.loadTech_(sourceTech.tech,sourceTech.source);this.tech_.ready(function(){_this16.changingSrc_=false;});return false;}// wait until the tech is ready to set the source
// and set it synchronously if possible (#2326)
this.ready(function(){// The setSource tech method was added with source handlers
// so older techs won't support it
// We need to check the direct prototype for the case where subclasses
// of the tech do not support source handlers
if(this.tech_.constructor.prototype.hasOwnProperty('setSource')){this.techCall_('setSource',source);}else{this.techCall_('src',source.src);}this.changingSrc_=false;},true);return false;}/**
   * Begin loading the src data.
   */;_proto.load=function load(){this.techCall_('load');}/**
   * Reset the player. Loads the first tech in the techOrder,
   * removes all the text tracks in the existing `tech`,
   * and calls `reset` on the `tech`.
   */;_proto.reset=function reset(){var _this17=this;var PromiseClass=this.options_.Promise||(window_default()).Promise;if(this.paused()||!PromiseClass){this.doReset_();}else{var playPromise=this.play();silencePromise(playPromise.then(function(){return _this17.doReset_();}));}};_proto.doReset_=function doReset_(){if(this.tech_){this.tech_.clearTracks('text');}this.resetCache_();this.poster('');this.loadTech_(this.options_.techOrder[0],null);this.techCall_('reset');this.resetControlBarUI_();if(isEvented(this)){this.trigger('playerreset');}}/**
   * Reset Control Bar's UI by calling sub-methods that reset
   * all of Control Bar's components
   */;_proto.resetControlBarUI_=function resetControlBarUI_(){this.resetProgressBar_();this.resetPlaybackRate_();this.resetVolumeBar_();}/**
   * Reset tech's progress so progress bar is reset in the UI
   */;_proto.resetProgressBar_=function resetProgressBar_(){this.currentTime(0);var _ref3=this.controlBar||{},durationDisplay=_ref3.durationDisplay,remainingTimeDisplay=_ref3.remainingTimeDisplay;if(durationDisplay){durationDisplay.updateContent();}if(remainingTimeDisplay){remainingTimeDisplay.updateContent();}}/**
   * Reset Playback ratio
   */;_proto.resetPlaybackRate_=function resetPlaybackRate_(){this.playbackRate(this.defaultPlaybackRate());this.handleTechRateChange_();}/**
   * Reset Volume bar
   */;_proto.resetVolumeBar_=function resetVolumeBar_(){this.volume(1.0);this.trigger('volumechange');}/**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */;_proto.currentSources=function currentSources(){var source=this.currentSource();var sources=[];// assume `{}` or `{ src }`
if(Object.keys(source).length!==0){sources.push(source);}return this.cache_.sources||sources;}/**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */;_proto.currentSource=function currentSource(){return this.cache_.source||{};}/**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */;_proto.currentSrc=function currentSrc(){return this.currentSource()&&this.currentSource().src||'';}/**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */;_proto.currentType=function currentType(){return this.currentSource()&&this.currentSource().type||'';}/**
   * Get or set the preload attribute
   *
   * @param {boolean} [value]
   *        - true means that we should preload
   *        - false means that we should not preload
   *
   * @return {string}
   *         The preload attribute value when getting
   */;_proto.preload=function preload(value){if(value!==undefined){this.techCall_('setPreload',value);this.options_.preload=value;return;}return this.techGet_('preload');}/**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|string} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string}
   *         The current value of autoplay when getting
   */;_proto.autoplay=function autoplay(value){// getter usage
if(value===undefined){return this.options_.autoplay||false;}var techAutoplay;// if the value is a valid string set it to that, or normalize `true` to 'play', if need be
if(typeof value==='string'&&/(any|play|muted)/.test(value)||value===true&&this.options_.normalizeAutoplay){this.options_.autoplay=value;this.manualAutoplay_(typeof value==='string'?value:'play');techAutoplay=false;// any falsy value sets autoplay to false in the browser,
// lets do the same
}else if(!value){this.options_.autoplay=false;// any other value (ie truthy) sets autoplay to true
}else{this.options_.autoplay=true;}techAutoplay=typeof techAutoplay==='undefined'?this.options_.autoplay:techAutoplay;// if we don't have a tech then we do not queue up
// a setAutoplay call on tech ready. We do this because the
// autoplay option will be passed in the constructor and we
// do not need to set it twice
if(this.tech_){this.techCall_('setAutoplay',techAutoplay);}}/**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|Player}
   *         - the current value of playsinline
   *         - the player when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */;_proto.playsinline=function playsinline(value){if(value!==undefined){this.techCall_('setPlaysinline',value);this.options_.playsinline=value;return this;}return this.techGet_('playsinline');}/**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {boolean}
   *         The current value of loop when getting
   */;_proto.loop=function loop(value){if(value!==undefined){this.techCall_('setLoop',value);this.options_.loop=value;return;}return this.techGet_('loop');}/**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string}
   *         The current value of poster when getting
   */;_proto.poster=function poster(src){if(src===undefined){return this.poster_;}// The correct way to remove a poster is to set as an empty string
// other falsey values will throw errors
if(!src){src='';}if(src===this.poster_){return;}// update the internal poster variable
this.poster_=src;// update the tech's poster
this.techCall_('setPoster',src);this.isPosterFromTech_=false;// alert components that the poster has been set
/**
     * This event fires when the poster image is changed on the player.
     *
     * @event Player#posterchange
     * @type {EventTarget~Event}
     */this.trigger('posterchange');}/**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */;_proto.handleTechPosterChange_=function handleTechPosterChange_(){if((!this.poster_||this.options_.techCanOverridePoster)&&this.tech_&&this.tech_.poster){var newPoster=this.tech_.poster()||'';if(newPoster!==this.poster_){this.poster_=newPoster;this.isPosterFromTech_=true;// Let components know the poster has changed
this.trigger('posterchange');}}}/**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean}
   *         The current value of controls when getting
   */;_proto.controls=function controls(bool){if(bool===undefined){return!!this.controls_;}bool=!!bool;// Don't trigger a change event unless it actually changed
if(this.controls_===bool){return;}this.controls_=bool;if(this.usingNativeControls()){this.techCall_('setControls',bool);}if(this.controls_){this.removeClass('vjs-controls-disabled');this.addClass('vjs-controls-enabled');/**
       * @event Player#controlsenabled
       * @type {EventTarget~Event}
       */this.trigger('controlsenabled');if(!this.usingNativeControls()){this.addTechControlsListeners_();}}else{this.removeClass('vjs-controls-enabled');this.addClass('vjs-controls-disabled');/**
       * @event Player#controlsdisabled
       * @type {EventTarget~Event}
       */this.trigger('controlsdisabled');if(!this.usingNativeControls()){this.removeTechControlsListeners_();}}}/**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls) or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean}
   *         The current value of native controls when getting
   */;_proto.usingNativeControls=function usingNativeControls(bool){if(bool===undefined){return!!this.usingNativeControls_;}bool=!!bool;// Don't trigger a change event unless it actually changed
if(this.usingNativeControls_===bool){return;}this.usingNativeControls_=bool;if(this.usingNativeControls_){this.addClass('vjs-using-native-controls');/**
       * player is using the native device controls
       *
       * @event Player#usingnativecontrols
       * @type {EventTarget~Event}
       */this.trigger('usingnativecontrols');}else{this.removeClass('vjs-using-native-controls');/**
       * player is using the custom HTML controls
       *
       * @event Player#usingcustomcontrols
       * @type {EventTarget~Event}
       */this.trigger('usingcustomcontrols');}}/**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null}
   *         The current MediaError when getting (or null)
   */;_proto.error=function error(err){var _this18=this;if(err===undefined){return this.error_||null;}// allow hooks to modify error object
hooks('beforeerror').forEach(function(hookFunction){var newErr=hookFunction(_this18,err);if(!(video_es_isObject(newErr)&&!Array.isArray(newErr)||typeof newErr==='string'||typeof newErr==='number'||newErr===null)){_this18.log.error('please return a value that MediaError expects in beforeerror hooks');return;}err=newErr;});// Suppress the first error message for no compatible source until
// user interaction
if(this.options_.suppressNotSupportedError&&err&&err.code===4){var triggerSuppressedError=function triggerSuppressedError(){this.error(err);};this.options_.suppressNotSupportedError=false;this.any(['click','touchstart'],triggerSuppressedError);this.one('loadstart',function(){this.off(['click','touchstart'],triggerSuppressedError);});return;}// restoring to default
if(err===null){this.error_=err;this.removeClass('vjs-error');if(this.errorDisplay){this.errorDisplay.close();}return;}this.error_=new MediaError(err);// add the vjs-error classname to the player
this.addClass('vjs-error');// log the name of the error type and any message
// IE11 logs "[object object]" and required you to expand message to see error object
log$1.error("(CODE:"+this.error_.code+" "+MediaError.errorTypes[this.error_.code]+")",this.error_.message,this.error_);/**
     * @event Player#error
     * @type {EventTarget~Event}
     */this.trigger('error');// notify hooks of the per player error
hooks('error').forEach(function(hookFunction){return hookFunction(_this18,_this18.error_);});return;}/**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */;_proto.reportUserActivity=function reportUserActivity(event){this.userActivity_=true;}/**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean}
   *         The current value of userActive when getting
   */;_proto.userActive=function userActive(bool){if(bool===undefined){return this.userActive_;}bool=!!bool;if(bool===this.userActive_){return;}this.userActive_=bool;if(this.userActive_){this.userActivity_=true;this.removeClass('vjs-user-inactive');this.addClass('vjs-user-active');/**
       * @event Player#useractive
       * @type {EventTarget~Event}
       */this.trigger('useractive');return;}// Chrome/Safari/IE have bugs where when you change the cursor it can
// trigger a mousemove event. This causes an issue when you're hiding
// the cursor when the user is inactive, and a mousemove signals user
// activity. Making it impossible to go into inactive mode. Specifically
// this happens in fullscreen when we really need to hide the cursor.
//
// When this gets resolved in ALL browsers it can be removed
// https://code.google.com/p/chromium/issues/detail?id=103041
if(this.tech_){this.tech_.one('mousemove',function(e){e.stopPropagation();e.preventDefault();});}this.userActivity_=false;this.removeClass('vjs-user-active');this.addClass('vjs-user-inactive');/**
     * @event Player#userinactive
     * @type {EventTarget~Event}
     */this.trigger('userinactive');}/**
   * Listen for user activity based on timeout value
   *
   * @private
   */;_proto.listenForUserActivity_=function listenForUserActivity_(){var mouseInProgress;var lastMoveX;var lastMoveY;var handleActivity=bind(this,this.reportUserActivity);var handleMouseMove=function handleMouseMove(e){// #1068 - Prevent mousemove spamming
// Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
if(e.screenX!==lastMoveX||e.screenY!==lastMoveY){lastMoveX=e.screenX;lastMoveY=e.screenY;handleActivity();}};var handleMouseDown=function handleMouseDown(){handleActivity();// For as long as the they are touching the device or have their mouse down,
// we consider them active even if they're not moving their finger or mouse.
// So we want to continue to update that they are active
this.clearInterval(mouseInProgress);// Setting userActivity=true now and setting the interval to the same time
// as the activityCheck interval (250) should ensure we never miss the
// next activityCheck
mouseInProgress=this.setInterval(handleActivity,250);};var handleMouseUpAndMouseLeave=function handleMouseUpAndMouseLeave(event){handleActivity();// Stop the interval that maintains activity if the mouse/touch is down
this.clearInterval(mouseInProgress);};// Any mouse movement will be considered user activity
this.on('mousedown',handleMouseDown);this.on('mousemove',handleMouseMove);this.on('mouseup',handleMouseUpAndMouseLeave);this.on('mouseleave',handleMouseUpAndMouseLeave);var controlBar=this.getChild('controlBar');// Fixes bug on Android & iOS where when tapping progressBar (when control bar is displayed)
// controlBar would no longer be hidden by default timeout.
if(controlBar&&!IS_IOS&&!IS_ANDROID){controlBar.on('mouseenter',function(event){if(this.player().options_.inactivityTimeout!==0){this.player().cache_.inactivityTimeout=this.player().options_.inactivityTimeout;}this.player().options_.inactivityTimeout=0;});controlBar.on('mouseleave',function(event){this.player().options_.inactivityTimeout=this.player().cache_.inactivityTimeout;});}// Listen for keyboard navigation
// Shouldn't need to use inProgress interval because of key repeat
this.on('keydown',handleActivity);this.on('keyup',handleActivity);// Run an interval every 250 milliseconds instead of stuffing everything into
// the mousemove/touchmove function itself, to prevent performance degradation.
// `this.reportUserActivity` simply sets this.userActivity_ to true, which
// then gets picked up by this loop
// http://ejohn.org/blog/learning-from-twitter/
var inactivityTimeout;this.setInterval(function(){// Check to see if mouse/touch activity has happened
if(!this.userActivity_){return;}// Reset the activity tracker
this.userActivity_=false;// If the user state was inactive, set the state to active
this.userActive(true);// Clear any existing inactivity timeout to start the timer over
this.clearTimeout(inactivityTimeout);var timeout=this.options_.inactivityTimeout;if(timeout<=0){return;}// In <timeout> milliseconds, if no more activity has occurred the
// user will be considered inactive
inactivityTimeout=this.setTimeout(function(){// Protect against the case where the inactivityTimeout can trigger just
// before the next user activity is picked up by the activity check loop
// causing a flicker
if(!this.userActivity_){this.userActive(false);}},timeout);},250);}/**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number}
   *         The current playback rate when getting or 1.0
   */;_proto.playbackRate=function playbackRate(rate){if(rate!==undefined){// NOTE: this.cache_.lastPlaybackRate is set from the tech handler
// that is registered above
this.techCall_('setPlaybackRate',rate);return;}if(this.tech_&&this.tech_.featuresPlaybackRate){return this.cache_.lastPlaybackRate||this.techGet_('playbackRate');}return 1.0;}/**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|Player}
   *         - The default playback rate when getting or 1.0
   *         - the player when setting
   */;_proto.defaultPlaybackRate=function defaultPlaybackRate(rate){if(rate!==undefined){return this.techCall_('setDefaultPlaybackRate',rate);}if(this.tech_&&this.tech_.featuresPlaybackRate){return this.techGet_('defaultPlaybackRate');}return 1.0;}/**
   * Gets or sets the audio flag
   *
   * @param {boolean} bool
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean}
   *         The current value of isAudio when getting
   */;_proto.isAudio=function isAudio(bool){if(bool!==undefined){this.isAudio_=!!bool;return;}return!!this.isAudio_;};_proto.enableAudioOnlyUI_=function enableAudioOnlyUI_(){var _this19=this;// Update styling immediately to show the control bar so we can get its height
this.addClass('vjs-audio-only-mode');var playerChildren=this.children();var controlBar=this.getChild('ControlBar');var controlBarHeight=controlBar&&controlBar.currentHeight();// Hide all player components except the control bar. Control bar components
// needed only for video are hidden with CSS
playerChildren.forEach(function(child){if(child===controlBar){return;}if(child.el_&&!child.hasClass('vjs-hidden')){child.hide();_this19.audioOnlyCache_.hiddenChildren.push(child);}});this.audioOnlyCache_.playerHeight=this.currentHeight();// Set the player height the same as the control bar
this.height(controlBarHeight);this.trigger('audioonlymodechange');};_proto.disableAudioOnlyUI_=function disableAudioOnlyUI_(){this.removeClass('vjs-audio-only-mode');// Show player components that were previously hidden
this.audioOnlyCache_.hiddenChildren.forEach(function(child){return child.show();});// Reset player height
this.height(this.audioOnlyCache_.playerHeight);this.trigger('audioonlymodechange');}/**
   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
   *
   * Setting this to `true` will hide all player components except the control bar,
   * as well as control bar components needed only for video.
   *
   * @param {boolean} [value]
   *         The value to set audioOnlyMode to.
   *
   * @return {Promise|boolean}
   *        A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */;_proto.audioOnlyMode=function audioOnlyMode(value){var _this20=this;if(typeof value!=='boolean'||value===this.audioOnlyMode_){return this.audioOnlyMode_;}this.audioOnlyMode_=value;var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){// Enable Audio Only Mode
if(value){var exitPromises=[];// Fullscreen and PiP are not supported in audioOnlyMode, so exit if we need to.
if(this.isInPictureInPicture()){exitPromises.push(this.exitPictureInPicture());}if(this.isFullscreen()){exitPromises.push(this.exitFullscreen());}if(this.audioPosterMode()){exitPromises.push(this.audioPosterMode(false));}return PromiseClass.all(exitPromises).then(function(){return _this20.enableAudioOnlyUI_();});}// Disable Audio Only Mode
return PromiseClass.resolve().then(function(){return _this20.disableAudioOnlyUI_();});}if(value){if(this.isInPictureInPicture()){this.exitPictureInPicture();}if(this.isFullscreen()){this.exitFullscreen();}this.enableAudioOnlyUI_();}else{this.disableAudioOnlyUI_();}};_proto.enablePosterModeUI_=function enablePosterModeUI_(){// Hide the video element and show the poster image to enable posterModeUI
var tech=this.tech_&&this.tech_;tech.hide();this.addClass('vjs-audio-poster-mode');this.trigger('audiopostermodechange');};_proto.disablePosterModeUI_=function disablePosterModeUI_(){// Show the video element and hide the poster image to disable posterModeUI
var tech=this.tech_&&this.tech_;tech.show();this.removeClass('vjs-audio-poster-mode');this.trigger('audiopostermodechange');}/**
   * Get the current audioPosterMode state or set audioPosterMode to true or false
   *
   * @param {boolean} [value]
   *         The value to set audioPosterMode to.
   *
   * @return {Promise|boolean}
   *         A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */;_proto.audioPosterMode=function audioPosterMode(value){var _this21=this;if(typeof value!=='boolean'||value===this.audioPosterMode_){return this.audioPosterMode_;}this.audioPosterMode_=value;var PromiseClass=this.options_.Promise||(window_default()).Promise;if(PromiseClass){if(value){if(this.audioOnlyMode()){var audioOnlyModePromise=this.audioOnlyMode(false);return audioOnlyModePromise.then(function(){// enable audio poster mode after audio only mode is disabled
_this21.enablePosterModeUI_();});}return PromiseClass.resolve().then(function(){// enable audio poster mode
_this21.enablePosterModeUI_();});}return PromiseClass.resolve().then(function(){// disable audio poster mode
_this21.disablePosterModeUI_();});}if(value){if(this.audioOnlyMode()){this.audioOnlyMode(false);}this.enablePosterModeUI_();return;}this.disablePosterModeUI_();}/**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */;_proto.addTextTrack=function addTextTrack(kind,label,language){if(this.tech_){return this.tech_.addTextTrack(kind,label,language);}}/**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
   * When manualCleanup is set to false, the track will be automatically removed
   * on source changes.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
   *                                       removed on a source change
   *
   * @return {HtmlTrackElement}
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   * @deprecated The default value of the "manualCleanup" parameter will default
   *             to "false" in upcoming versions of Video.js
   */;_proto.addRemoteTextTrack=function addRemoteTextTrack(options,manualCleanup){if(this.tech_){return this.tech_.addRemoteTextTrack(options,manualCleanup);}}/**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */;_proto.removeRemoteTextTrack=function removeRemoteTextTrack(obj){if(obj===void 0){obj={};}var _obj=obj,track=_obj.track;if(!track){track=obj;}// destructure the input into an object with a track argument, defaulting to arguments[0]
// default the whole argument to an empty object if nothing was passed in
if(this.tech_){return this.tech_.removeRemoteTextTrack(track);}}/**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */;_proto.getVideoPlaybackQuality=function getVideoPlaybackQuality(){return this.techGet_('getVideoPlaybackQuality');}/**
   * Get video width
   *
   * @return {number}
   *         current video width
   */;_proto.videoWidth=function videoWidth(){return this.tech_&&this.tech_.videoWidth&&this.tech_.videoWidth()||0;}/**
   * Get video height
   *
   * @return {number}
   *         current video height
   */;_proto.videoHeight=function videoHeight(){return this.tech_&&this.tech_.videoHeight&&this.tech_.videoHeight()||0;}/**
   * The player's language code.
   *
   * Changing the language will trigger
   * [languagechange]{@link Player#event:languagechange}
   * which Components can use to update control text.
   * ClickableComponent will update its control text by default on
   * [languagechange]{@link Player#event:languagechange}.
   *
   * @fires Player#languagechange
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string}
   *         The current language code when getting
   */;_proto.language=function language(code){if(code===undefined){return this.language_;}if(this.language_!==String(code).toLowerCase()){this.language_=String(code).toLowerCase();// during first init, it's possible some things won't be evented
if(isEvented(this)){/**
        * fires when the player language change
        *
        * @event Player#languagechange
        * @type {EventTarget~Event}
        */this.trigger('languagechange');}}}/**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */;_proto.languages=function languages(){return mergeOptions$3(Player.prototype.options_.languages,this.languages_);}/**
   * returns a JavaScript object reperesenting the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */;_proto.toJSON=function toJSON(){var options=mergeOptions$3(this.options_);var tracks=options.tracks;options.tracks=[];for(var i=0;i<tracks.length;i++){var track=tracks[i];// deep merge tracks and null out player so no circular references
track=mergeOptions$3(track);track.player=undefined;options.tracks[i]=track;}return options;}/**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */;_proto.createModal=function createModal(content,options){var _this22=this;options=options||{};options.content=content||'';var modal=new ModalDialog(this,options);this.addChild(modal);modal.on('dispose',function(){_this22.removeChild(modal);});modal.open();return modal;}/**
   * Change breakpoint classes when the player resizes.
   *
   * @private
   */;_proto.updateCurrentBreakpoint_=function updateCurrentBreakpoint_(){if(!this.responsive()){return;}var currentBreakpoint=this.currentBreakpoint();var currentWidth=this.currentWidth();for(var i=0;i<BREAKPOINT_ORDER.length;i++){var candidateBreakpoint=BREAKPOINT_ORDER[i];var maxWidth=this.breakpoints_[candidateBreakpoint];if(currentWidth<=maxWidth){// The current breakpoint did not change, nothing to do.
if(currentBreakpoint===candidateBreakpoint){return;}// Only remove a class if there is a current breakpoint.
if(currentBreakpoint){this.removeClass(BREAKPOINT_CLASSES[currentBreakpoint]);}this.addClass(BREAKPOINT_CLASSES[candidateBreakpoint]);this.breakpoint_=candidateBreakpoint;break;}}}/**
   * Removes the current breakpoint.
   *
   * @private
   */;_proto.removeCurrentBreakpoint_=function removeCurrentBreakpoint_(){var className=this.currentBreakpointClass();this.breakpoint_='';if(className){this.removeClass(className);}}/**
   * Get or set breakpoints on the player.
   *
   * Calling this method with an object or `true` will remove any previous
   * custom breakpoints and start from the defaults again.
   *
   * @param  {Object|boolean} [breakpoints]
   *         If an object is given, it can be used to provide custom
   *         breakpoints. If `true` is given, will set default breakpoints.
   *         If this argument is not given, will simply return the current
   *         breakpoints.
   *
   * @param  {number} [breakpoints.tiny]
   *         The maximum width for the "vjs-layout-tiny" class.
   *
   * @param  {number} [breakpoints.xsmall]
   *         The maximum width for the "vjs-layout-x-small" class.
   *
   * @param  {number} [breakpoints.small]
   *         The maximum width for the "vjs-layout-small" class.
   *
   * @param  {number} [breakpoints.medium]
   *         The maximum width for the "vjs-layout-medium" class.
   *
   * @param  {number} [breakpoints.large]
   *         The maximum width for the "vjs-layout-large" class.
   *
   * @param  {number} [breakpoints.xlarge]
   *         The maximum width for the "vjs-layout-x-large" class.
   *
   * @param  {number} [breakpoints.huge]
   *         The maximum width for the "vjs-layout-huge" class.
   *
   * @return {Object}
   *         An object mapping breakpoint names to maximum width values.
   */;_proto.breakpoints=function breakpoints(_breakpoints){// Used as a getter.
if(_breakpoints===undefined){return video_es_assign(this.breakpoints_);}this.breakpoint_='';this.breakpoints_=video_es_assign({},DEFAULT_BREAKPOINTS,_breakpoints);// When breakpoint definitions change, we need to update the currently
// selected breakpoint.
this.updateCurrentBreakpoint_();// Clone the breakpoints before returning.
return video_es_assign(this.breakpoints_);}/**
   * Get or set a flag indicating whether or not this player should adjust
   * its UI based on its dimensions.
   *
   * @param  {boolean} value
   *         Should be `true` if the player should adjust its UI based on its
   *         dimensions; otherwise, should be `false`.
   *
   * @return {boolean}
   *         Will be `true` if this player should adjust its UI based on its
   *         dimensions; otherwise, will be `false`.
   */;_proto.responsive=function responsive(value){// Used as a getter.
if(value===undefined){return this.responsive_;}value=Boolean(value);var current=this.responsive_;// Nothing changed.
if(value===current){return;}// The value actually changed, set it.
this.responsive_=value;// Start listening for breakpoints and set the initial breakpoint if the
// player is now responsive.
if(value){this.on('playerresize',this.boundUpdateCurrentBreakpoint_);this.updateCurrentBreakpoint_();// Stop listening for breakpoints if the player is no longer responsive.
}else{this.off('playerresize',this.boundUpdateCurrentBreakpoint_);this.removeCurrentBreakpoint_();}return value;}/**
   * Get current breakpoint name, if any.
   *
   * @return {string}
   *         If there is currently a breakpoint set, returns a the key from the
   *         breakpoints object matching it. Otherwise, returns an empty string.
   */;_proto.currentBreakpoint=function currentBreakpoint(){return this.breakpoint_;}/**
   * Get the current breakpoint class name.
   *
   * @return {string}
   *         The matching class name (e.g. `"vjs-layout-tiny"` or
   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
   *         there is no current breakpoint.
   */;_proto.currentBreakpointClass=function currentBreakpointClass(){return BREAKPOINT_CLASSES[this.breakpoint_]||'';}/**
   * An object that describes a single piece of media.
   *
   * Properties that are not part of this type description will be retained; so,
   * this can be viewed as a generic metadata storage mechanism as well.
   *
   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
   * @typedef  {Object} Player~MediaObject
   *
   * @property {string} [album]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {string} [artist]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [artwork]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API. If not specified, will be populated via the `poster`, if
   *           available.
   *
   * @property {string} [poster]
   *           URL to an image that will display before playback.
   *
   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
   *           A single source object, an array of source objects, or a string
   *           referencing a URL to a media source. It is _highly recommended_
   *           that an object or array of objects is used here, so that source
   *           selection algorithms can take the `type` into account.
   *
   * @property {string} [title]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [textTracks]
   *           An array of objects to be used to create text tracks, following
   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
   *           For ease of removal, these will be created as "remote" text
   *           tracks and set to automatically clean up on source changes.
   *
   *           These objects may have properties like `src`, `kind`, `label`,
   *           and `language`, see {@link Tech#createRemoteTextTrack}.
   */ /**
   * Populate the player using a {@link Player~MediaObject|MediaObject}.
   *
   * @param  {Player~MediaObject} media
   *         A media object.
   *
   * @param  {Function} ready
   *         A callback to be called when the player is ready.
   */;_proto.loadMedia=function loadMedia(media,ready){var _this23=this;if(!media||video_es_typeof(media)!=='object'){return;}this.reset();// Clone the media object so it cannot be mutated from outside.
this.cache_.media=mergeOptions$3(media);var _this$cache_$media=this.cache_.media,artwork=_this$cache_$media.artwork,poster=_this$cache_$media.poster,src=_this$cache_$media.src,textTracks=_this$cache_$media.textTracks;// If `artwork` is not given, create it using `poster`.
if(!artwork&&poster){this.cache_.media.artwork=[{src:poster,type:getMimetype(poster)}];}if(src){this.src(src);}if(poster){this.poster(poster);}if(Array.isArray(textTracks)){textTracks.forEach(function(tt){return _this23.addRemoteTextTrack(tt,false);});}this.ready(ready);}/**
   * Get a clone of the current {@link Player~MediaObject} for this player.
   *
   * If the `loadMedia` method has not been used, will attempt to return a
   * {@link Player~MediaObject} based on the current state of the player.
   *
   * @return {Player~MediaObject}
   */;_proto.getMedia=function getMedia(){if(!this.cache_.media){var poster=this.poster();var src=this.currentSources();var textTracks=Array.prototype.map.call(this.remoteTextTracks(),function(tt){return{kind:tt.kind,label:tt.label,language:tt.language,src:tt.src};});var media={src:src,textTracks:textTracks};if(poster){media.poster=poster;media.artwork=[{src:media.poster,type:getMimetype(media.poster)}];}return media;}return mergeOptions$3(this.cache_.media);}/**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */;Player.getTagSettings=function getTagSettings(tag){var baseOptions={sources:[],tracks:[]};var tagOptions=getAttributes(tag);var dataSetup=tagOptions['data-setup'];if(hasClass(tag,'vjs-fill')){tagOptions.fill=true;}if(hasClass(tag,'vjs-fluid')){tagOptions.fluid=true;}// Check if data-setup attr exists.
if(dataSetup!==null){// Parse options JSON
// If empty string, make it a parsable json object.
var _safeParseTuple=tuple_default()(dataSetup||'{}'),err=_safeParseTuple[0],data=_safeParseTuple[1];if(err){log$1.error(err);}video_es_assign(tagOptions,data);}video_es_assign(baseOptions,tagOptions);// Get tag children settings
if(tag.hasChildNodes()){var children=tag.childNodes;for(var i=0,j=children.length;i<j;i++){var child=children[i];// Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
var childName=child.nodeName.toLowerCase();if(childName==='source'){baseOptions.sources.push(getAttributes(child));}else if(childName==='track'){baseOptions.tracks.push(getAttributes(child));}}}return baseOptions;}/**
   * Determine whether or not flexbox is supported
   *
   * @return {boolean}
   *         - true if flexbox is supported
   *         - false if flexbox is not supported
   */;_proto.flexNotSupported_=function flexNotSupported_(){var elem=document_default().createElement('i');// Note: We don't actually use flexBasis (or flexOrder), but it's one of the more
// common flex features that we can rely on when checking for flex support.
return!('flexBasis'in elem.style||'webkitFlexBasis'in elem.style||'mozFlexBasis'in elem.style||'msFlexBasis'in elem.style||// IE10-specific (2012 flex spec), available for completeness
'msFlexOrder'in elem.style);}/**
   * Set debug mode to enable/disable logs at info level.
   *
   * @param {boolean} enabled
   * @fires Player#debugon
   * @fires Player#debugoff
   */;_proto.debug=function debug(enabled){if(enabled===undefined){return this.debugEnabled_;}if(enabled){this.trigger('debugon');this.previousLogLevel_=this.log.level;this.log.level('debug');this.debugEnabled_=true;}else{this.trigger('debugoff');this.log.level(this.previousLogLevel_);this.previousLogLevel_=undefined;this.debugEnabled_=false;}}/**
   * Set or get current playback rates.
   * Takes an array and updates the playback rates menu with the new items.
   * Pass in an empty array to hide the menu.
   * Values other than arrays are ignored.
   *
   * @fires Player#playbackrateschange
   * @param {number[]} newRates
   *                   The new rates that the playback rates menu should update to.
   *                   An empty array will hide the menu
   * @return {number[]} When used as a getter will return the current playback rates
   */;_proto.playbackRates=function playbackRates(newRates){if(newRates===undefined){return this.cache_.playbackRates;}// ignore any value that isn't an array
if(!Array.isArray(newRates)){return;}// ignore any arrays that don't only contain numbers
if(!newRates.every(function(rate){return typeof rate==='number';})){return;}this.cache_.playbackRates=newRates;/**
    * fires when the playback rates in a player are changed
    *
    * @event Player#playbackrateschange
    * @type {EventTarget~Event}
    */this.trigger('playbackrateschange');};return Player;}(Component$1);/**
 * Get the {@link VideoTrackList}
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
 *
 * @return {VideoTrackList}
 *         the current video track list
 *
 * @method Player.prototype.videoTracks
 */ /**
 * Get the {@link AudioTrackList}
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
 *
 * @return {AudioTrackList}
 *         the current audio track list
 *
 * @method Player.prototype.audioTracks
 */ /**
 * Get the {@link TextTrackList}
 *
 * @link http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
 *
 * @return {TextTrackList}
 *         the current text track list
 *
 * @method Player.prototype.textTracks
 */ /**
 * Get the remote {@link TextTrackList}
 *
 * @return {TextTrackList}
 *         The current remote text track list
 *
 * @method Player.prototype.remoteTextTracks
 */ /**
 * Get the remote {@link HtmlTrackElementList} tracks.
 *
 * @return {HtmlTrackElementList}
 *         The current remote text track element list
 *
 * @method Player.prototype.remoteTextTrackEls
 */ALL.names.forEach(function(name){var props=ALL[name];Player.prototype[props.getterName]=function(){if(this.tech_){return this.tech_[props.getterName]();}// if we have not yet loadTech_, we create {video,audio,text}Tracks_
// these will be passed to the tech during loading
this[props.privateName]=this[props.privateName]||new props.ListClass();return this[props.privateName];};});/**
 * Get or set the `Player`'s crossorigin option. For the HTML5 player, this
 * sets the `crossOrigin` property on the `<video>` tag to control the CORS
 * behavior.
 *
 * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
 *
 * @param {string} [value]
 *        The value to set the `Player`'s crossorigin to. If an argument is
 *        given, must be one of `anonymous` or `use-credentials`.
 *
 * @return {string|undefined}
 *         - The current crossorigin value of the `Player` when getting.
 *         - undefined when setting
 */Player.prototype.crossorigin=Player.prototype.crossOrigin;/**
 * Global enumeration of players.
 *
 * The keys are the player IDs and the values are either the {@link Player}
 * instance or `null` for disposed players.
 *
 * @type {Object}
 */Player.players={};var video_es_navigator=(window_default()).navigator;/*
 * Player instance options, surfaced using options
 * options = Player.prototype.options_
 * Make changes in options, not here.
 *
 * @type {Object}
 * @private
 */Player.prototype.options_={// Default order of fallback technology
techOrder:Tech.defaultTechOrder_,html5:{},// default inactivity timeout
inactivityTimeout:2000,// default playback rates
playbackRates:[],// Add playback rate selection by adding rates
// 'playbackRates': [0.5, 1, 1.5, 2],
liveui:false,// Included control sets
children:['mediaLoader','posterImage','textTrackDisplay','loadingSpinner','bigPlayButton','liveTracker','controlBar','errorDisplay','textTrackSettings','resizeManager'],language:video_es_navigator&&(video_es_navigator.languages&&video_es_navigator.languages[0]||video_es_navigator.userLanguage||video_es_navigator.language)||'en',// locales and their language translations
languages:{},// Default message to show when a video cannot be played.
notSupportedMessage:'No compatible source was found for this media.',normalizeAutoplay:false,fullscreen:{options:{navigationUI:'hide'}},breakpoints:{},responsive:false,audioOnlyMode:false,audioPosterMode:false};[/**
 * Returns whether or not the player is in the "ended" state.
 *
 * @return {Boolean} True if the player is in the ended state, false if not.
 * @method Player#ended
 */'ended',/**
 * Returns whether or not the player is in the "seeking" state.
 *
 * @return {Boolean} True if the player is in the seeking state, false if not.
 * @method Player#seeking
 */'seeking',/**
 * Returns the TimeRanges of the media that are currently available
 * for seeking to.
 *
 * @return {TimeRanges} the seekable intervals of the media timeline
 * @method Player#seekable
 */'seekable',/**
 * Returns the current state of network activity for the element, from
 * the codes in the list below.
 * - NETWORK_EMPTY (numeric value 0)
 *   The element has not yet been initialised. All attributes are in
 *   their initial states.
 * - NETWORK_IDLE (numeric value 1)
 *   The element's resource selection algorithm is active and has
 *   selected a resource, but it is not actually using the network at
 *   this time.
 * - NETWORK_LOADING (numeric value 2)
 *   The user agent is actively trying to download data.
 * - NETWORK_NO_SOURCE (numeric value 3)
 *   The element's resource selection algorithm is active, but it has
 *   not yet found a resource to use.
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
 * @return {number} the current network activity state
 * @method Player#networkState
 */'networkState',/**
 * Returns a value that expresses the current state of the element
 * with respect to rendering the current playback position, from the
 * codes in the list below.
 * - HAVE_NOTHING (numeric value 0)
 *   No information regarding the media resource is available.
 * - HAVE_METADATA (numeric value 1)
 *   Enough of the resource has been obtained that the duration of the
 *   resource is available.
 * - HAVE_CURRENT_DATA (numeric value 2)
 *   Data for the immediate current playback position is available.
 * - HAVE_FUTURE_DATA (numeric value 3)
 *   Data for the immediate current playback position is available, as
 *   well as enough data for the user agent to advance the current
 *   playback position in the direction of playback.
 * - HAVE_ENOUGH_DATA (numeric value 4)
 *   The user agent estimates that enough data is available for
 *   playback to proceed uninterrupted.
 *
 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
 * @return {number} the current playback rendering state
 * @method Player#readyState
 */'readyState'].forEach(function(fn){Player.prototype[fn]=function(){return this.techGet_(fn);};});TECH_EVENTS_RETRIGGER.forEach(function(event){Player.prototype["handleTech"+toTitleCase$1(event)+"_"]=function(){return this.trigger(event);};});/**
 * Fired when the player has initial duration and dimension information
 *
 * @event Player#loadedmetadata
 * @type {EventTarget~Event}
 */ /**
 * Fired when the player has downloaded data at the current playback position
 *
 * @event Player#loadeddata
 * @type {EventTarget~Event}
 */ /**
 * Fired when the current playback position has changed *
 * During playback this is fired every 15-250 milliseconds, depending on the
 * playback technology in use.
 *
 * @event Player#timeupdate
 * @type {EventTarget~Event}
 */ /**
 * Fired when the volume changes
 *
 * @event Player#volumechange
 * @type {EventTarget~Event}
 */ /**
 * Reports whether or not a player has a plugin available.
 *
 * This does not report whether or not the plugin has ever been initialized
 * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
 *
 * @method Player#hasPlugin
 * @param  {string}  name
 *         The name of a plugin.
 *
 * @return {boolean}
 *         Whether or not this player has the requested plugin available.
 */ /**
 * Reports whether or not a player is using a plugin by name.
 *
 * For basic plugins, this only reports whether the plugin has _ever_ been
 * initialized on this player.
 *
 * @method Player#usingPlugin
 * @param  {string} name
 *         The name of a plugin.
 *
 * @return {boolean}
 *         Whether or not this player is using the requested plugin.
 */Component$1.registerComponent('Player',Player);/**
 * The base plugin name.
 *
 * @private
 * @constant
 * @type {string}
 */var BASE_PLUGIN_NAME='plugin';/**
 * The key on which a player's active plugins cache is stored.
 *
 * @private
 * @constant
 * @type     {string}
 */var PLUGIN_CACHE_KEY='activePlugins_';/**
 * Stores registered plugins in a private space.
 *
 * @private
 * @type    {Object}
 */var pluginStorage={};/**
 * Reports whether or not a plugin has been registered.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @return {boolean}
 *          Whether or not the plugin has been registered.
 */var pluginExists=function pluginExists(name){return pluginStorage.hasOwnProperty(name);};/**
 * Get a single registered plugin by name.
 *
 * @private
 * @param   {string} name
 *          The name of a plugin.
 *
 * @return {Function|undefined}
 *          The plugin (or undefined).
 */var getPlugin=function getPlugin(name){return pluginExists(name)?pluginStorage[name]:undefined;};/**
 * Marks a plugin as "active" on a player.
 *
 * Also, ensures that the player has an object for tracking active plugins.
 *
 * @private
 * @param   {Player} player
 *          A Video.js player instance.
 *
 * @param   {string} name
 *          The name of a plugin.
 */var markPluginAsActive=function markPluginAsActive(player,name){player[PLUGIN_CACHE_KEY]=player[PLUGIN_CACHE_KEY]||{};player[PLUGIN_CACHE_KEY][name]=true;};/**
 * Triggers a pair of plugin setup events.
 *
 * @private
 * @param  {Player} player
 *         A Video.js player instance.
 *
 * @param  {Plugin~PluginEventHash} hash
 *         A plugin event hash.
 *
 * @param  {boolean} [before]
 *         If true, prefixes the event name with "before". In other words,
 *         use this to trigger "beforepluginsetup" instead of "pluginsetup".
 */var triggerSetupEvent=function triggerSetupEvent(player,hash,before){var eventName=(before?'before':'')+'pluginsetup';player.trigger(eventName,hash);player.trigger(eventName+':'+hash.name,hash);};/**
 * Takes a basic plugin function and returns a wrapper function which marks
 * on the player that the plugin has been activated.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Function} plugin
 *          The basic plugin.
 *
 * @return {Function}
 *          A wrapper function for the given plugin.
 */var createBasicPlugin=function createBasicPlugin(name,plugin){var basicPluginWrapper=function basicPluginWrapper(){// We trigger the "beforepluginsetup" and "pluginsetup" events on the player
// regardless, but we want the hash to be consistent with the hash provided
// for advanced plugins.
//
// The only potentially counter-intuitive thing here is the `instance` in
// the "pluginsetup" event is the value returned by the `plugin` function.
triggerSetupEvent(this,{name:name,plugin:plugin,instance:null},true);var instance=plugin.apply(this,arguments);markPluginAsActive(this,name);triggerSetupEvent(this,{name:name,plugin:plugin,instance:instance});return instance;};Object.keys(plugin).forEach(function(prop){basicPluginWrapper[prop]=plugin[prop];});return basicPluginWrapper;};/**
 * Takes a plugin sub-class and returns a factory function for generating
 * instances of it.
 *
 * This factory function will replace itself with an instance of the requested
 * sub-class of Plugin.
 *
 * @private
 * @param   {string} name
 *          The name of the plugin.
 *
 * @param   {Plugin} PluginSubClass
 *          The advanced plugin.
 *
 * @return {Function}
 */var createPluginFactory=function createPluginFactory(name,PluginSubClass){// Add a `name` property to the plugin prototype so that each plugin can
// refer to itself by name.
PluginSubClass.prototype.name=name;return function(){triggerSetupEvent(this,{name:name,plugin:PluginSubClass,instance:null},true);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}var instance=_construct(PluginSubClass,[this].concat(args));// The plugin is replaced by a function that returns the current instance.
this[name]=function(){return instance;};triggerSetupEvent(this,instance.getEventHash());return instance;};};/**
 * Parent class for all advanced plugins.
 *
 * @mixes   module:evented~EventedMixin
 * @mixes   module:stateful~StatefulMixin
 * @fires   Player#beforepluginsetup
 * @fires   Player#beforepluginsetup:$name
 * @fires   Player#pluginsetup
 * @fires   Player#pluginsetup:$name
 * @listens Player#dispose
 * @throws  {Error}
 *          If attempting to instantiate the base {@link Plugin} class
 *          directly instead of via a sub-class.
 */var Plugin=/*#__PURE__*/function(){/**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */function Plugin(player){if(this.constructor===Plugin){throw new Error('Plugin must be sub-classed; not directly instantiated.');}this.player=player;if(!this.log){this.log=this.player.log.createLogger(this.name);}// Make this object evented, but remove the added `trigger` method so we
// use the prototype version instead.
evented(this);delete this.trigger;stateful(this,this.constructor.defaultState);markPluginAsActive(player,this.name);// Auto-bind the dispose method so we can use it as a listener and unbind
// it later easily.
this.dispose=this.dispose.bind(this);// If the player is disposed, dispose the plugin.
player.on('dispose',this.dispose);}/**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */var _proto=Plugin.prototype;_proto.version=function version(){return this.constructor.VERSION;}/**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @return {Plugin~PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */;_proto.getEventHash=function getEventHash(hash){if(hash===void 0){hash={};}hash.name=this.name;hash.plugin=this.constructor;hash.instance=this;return hash;}/**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link Plugin~PluginEventHash|PluginEventHash}.
   *
   * @return {boolean}
   *          Whether or not default was prevented.
   */;_proto.trigger=function trigger$1(event,hash){if(hash===void 0){hash={};}return trigger(this.eventBusEl_,event,this.getEventHash(hash));}/**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */;_proto.handleStateChanged=function handleStateChanged(e){}/**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */;_proto.dispose=function dispose(){var name=this.name,player=this.player;/**
     * Signals that a advanced plugin is about to be disposed.
     *
     * @event Plugin#dispose
     * @type  {EventTarget~Event}
     */this.trigger('dispose');this.off();player.off('dispose',this.dispose);// Eliminate any possible sources of leaking memory by clearing up
// references between the player and the plugin instance and nulling out
// the plugin's state and replacing methods with a function that throws.
player[PLUGIN_CACHE_KEY][name]=false;this.player=this.state=null;// Finally, replace the plugin name on the player with a new factory
// function, so that the plugin is ready to be set up again.
player[name]=createPluginFactory(name,pluginStorage[name]);}/**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @return {boolean}
   *          Whether or not a plugin is a basic plugin.
   */;Plugin.isBasic=function isBasic(plugin){var p=typeof plugin==='string'?getPlugin(plugin):plugin;return typeof p==='function'&&!Plugin.prototype.isPrototypeOf(p.prototype);}/**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @return {Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */;Plugin.registerPlugin=function registerPlugin(name,plugin){if(typeof name!=='string'){throw new Error("Illegal plugin name, \""+name+"\", must be a string, was "+video_es_typeof(name)+".");}if(pluginExists(name)){log$1.warn("A plugin named \""+name+"\" already exists. You may want to avoid re-registering plugins!");}else if(Player.prototype.hasOwnProperty(name)){throw new Error("Illegal plugin name, \""+name+"\", cannot share a name with an existing player method!");}if(typeof plugin!=='function'){throw new Error("Illegal plugin for \""+name+"\", must be a function, was "+video_es_typeof(plugin)+".");}pluginStorage[name]=plugin;// Add a player prototype method for all sub-classed plugins (but not for
// the base Plugin class).
if(name!==BASE_PLUGIN_NAME){if(Plugin.isBasic(plugin)){Player.prototype[name]=createBasicPlugin(name,plugin);}else{Player.prototype[name]=createPluginFactory(name,plugin);}}return plugin;}/**
   * De-register a Video.js plugin.
   *
   * @param  {string} name
   *         The name of the plugin to be de-registered. Must be a string that
   *         matches an existing plugin.
   *
   * @throws {Error}
   *         If an attempt is made to de-register the base plugin.
   */;Plugin.deregisterPlugin=function deregisterPlugin(name){if(name===BASE_PLUGIN_NAME){throw new Error('Cannot de-register base plugin.');}if(pluginExists(name)){delete pluginStorage[name];delete Player.prototype[name];}}/**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @return {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */;Plugin.getPlugins=function getPlugins(names){if(names===void 0){names=Object.keys(pluginStorage);}var result;names.forEach(function(name){var plugin=getPlugin(name);if(plugin){result=result||{};result[name]=plugin;}});return result;}/**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @return {string}
   *          The plugin's version or an empty string.
   */;Plugin.getPluginVersion=function getPluginVersion(name){var plugin=getPlugin(name);return plugin&&plugin.VERSION||'';};return Plugin;}();/**
 * Gets a plugin by name if it exists.
 *
 * @static
 * @method   getPlugin
 * @memberOf Plugin
 * @param    {string} name
 *           The name of a plugin.
 *
 * @returns  {Function|undefined}
 *           The plugin (or `undefined`).
 */Plugin.getPlugin=getPlugin;/**
 * The name of the base plugin class as it is registered.
 *
 * @type {string}
 */Plugin.BASE_PLUGIN_NAME=BASE_PLUGIN_NAME;Plugin.registerPlugin(BASE_PLUGIN_NAME,Plugin);/**
 * Documented in player.js
 *
 * @ignore
 */Player.prototype.usingPlugin=function(name){return!!this[PLUGIN_CACHE_KEY]&&this[PLUGIN_CACHE_KEY][name]===true;};/**
 * Documented in player.js
 *
 * @ignore
 */Player.prototype.hasPlugin=function(name){return!!pluginExists(name);};/**
 * Signals that a plugin is about to be set up on a player.
 *
 * @event    Player#beforepluginsetup
 * @type     {Plugin~PluginEventHash}
 */ /**
 * Signals that a plugin is about to be set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#beforepluginsetup:$name
 * @type     {Plugin~PluginEventHash}
 */ /**
 * Signals that a plugin has just been set up on a player.
 *
 * @event    Player#pluginsetup
 * @type     {Plugin~PluginEventHash}
 */ /**
 * Signals that a plugin has just been set up on a player - by name. The name
 * is the name of the plugin.
 *
 * @event    Player#pluginsetup:$name
 * @type     {Plugin~PluginEventHash}
 */ /**
 * @typedef  {Object} Plugin~PluginEventHash
 *
 * @property {string} instance
 *           For basic plugins, the return value of the plugin function. For
 *           advanced plugins, the plugin instance on which the event is fired.
 *
 * @property {string} name
 *           The name of the plugin.
 *
 * @property {string} plugin
 *           For basic plugins, the plugin function. For advanced plugins, the
 *           plugin class/constructor.
 */ /**
 * @file extend.js
 * @module extend
 */var hasLogged=false;/**
 * Used to subclass an existing class by emulating ES subclassing using the
 * `extends` keyword.
 *
 * @function
 * @deprecated
 * @example
 * var MyComponent = videojs.extend(videojs.getComponent('Component'), {
 *   myCustomMethod: function() {
 *     // Do things in my method.
 *   }
 * });
 *
 * @param    {Function} superClass
 *           The class to inherit from
 *
 * @param    {Object}   [subClassMethods={}]
 *           Methods of the new class
 *
 * @return   {Function}
 *           The new class with subClassMethods that inherited superClass.
 */var extend=function extend(superClass,subClassMethods){if(subClassMethods===void 0){subClassMethods={};}// Log a warning the first time extend is called to note that it is deprecated
// It was previously deprecated in our documentation (guides, specifically),
// but was never formally deprecated in code.
if(!hasLogged){log$1.warn('videojs.extend is deprecated as of Video.js 7.22.0 and will be removed in Video.js 8.0.0');hasLogged=true;}var subClass=function subClass(){superClass.apply(this,arguments);};var methods={};if(video_es_typeof(subClassMethods)==='object'){if(subClassMethods.constructor!==Object.prototype.constructor){subClass=subClassMethods.constructor;}methods=subClassMethods;}else if(typeof subClassMethods==='function'){subClass=subClassMethods;}_inherits(subClass,superClass);// this is needed for backward-compatibility and node compatibility.
if(superClass){subClass.super_=superClass;}// Extend subObj's prototype with functions and other properties from props
for(var name in methods){if(methods.hasOwnProperty(name)){subClass.prototype[name]=methods[name];}}return subClass;};/**
 * @file video.js
 * @module videojs
 */ /**
 * Normalize an `id` value by trimming off a leading `#`
 *
 * @private
 * @param   {string} id
 *          A string, maybe with a leading `#`.
 *
 * @return {string}
 *          The string, without any leading `#`.
 */var normalizeId=function normalizeId(id){return id.indexOf('#')===0?id.slice(1):id;};/**
 * The `videojs()` function doubles as the main function for users to create a
 * {@link Player} instance as well as the main library namespace.
 *
 * It can also be used as a getter for a pre-existing {@link Player} instance.
 * However, we _strongly_ recommend using `videojs.getPlayer()` for this
 * purpose because it avoids any potential for unintended initialization.
 *
 * Due to [limitations](https://github.com/jsdoc3/jsdoc/issues/955#issuecomment-313829149)
 * of our JSDoc template, we cannot properly document this as both a function
 * and a namespace, so its function signature is documented here.
 *
 * #### Arguments
 * ##### id
 * string|Element, **required**
 *
 * Video element or video element ID.
 *
 * ##### options
 * Object, optional
 *
 * Options object for providing settings.
 * See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
 *
 * ##### ready
 * {@link Component~ReadyCallback}, optional
 *
 * A function to be called when the {@link Player} and {@link Tech} are ready.
 *
 * #### Return Value
 *
 * The `videojs()` function returns a {@link Player} instance.
 *
 * @namespace
 *
 * @borrows AudioTrack as AudioTrack
 * @borrows Component.getComponent as getComponent
 * @borrows module:computed-style~computedStyle as computedStyle
 * @borrows module:events.on as on
 * @borrows module:events.one as one
 * @borrows module:events.off as off
 * @borrows module:events.trigger as trigger
 * @borrows EventTarget as EventTarget
 * @borrows module:extend~extend as extend
 * @borrows module:fn.bind as bind
 * @borrows module:format-time.formatTime as formatTime
 * @borrows module:format-time.resetFormatTime as resetFormatTime
 * @borrows module:format-time.setFormatTime as setFormatTime
 * @borrows module:merge-options.mergeOptions as mergeOptions
 * @borrows module:middleware.use as use
 * @borrows Player.players as players
 * @borrows Plugin.registerPlugin as registerPlugin
 * @borrows Plugin.deregisterPlugin as deregisterPlugin
 * @borrows Plugin.getPlugins as getPlugins
 * @borrows Plugin.getPlugin as getPlugin
 * @borrows Plugin.getPluginVersion as getPluginVersion
 * @borrows Tech.getTech as getTech
 * @borrows Tech.registerTech as registerTech
 * @borrows TextTrack as TextTrack
 * @borrows module:time-ranges.createTimeRanges as createTimeRange
 * @borrows module:time-ranges.createTimeRanges as createTimeRanges
 * @borrows module:url.isCrossOrigin as isCrossOrigin
 * @borrows module:url.parseUrl as parseUrl
 * @borrows VideoTrack as VideoTrack
 *
 * @param  {string|Element} id
 *         Video element or video element ID.
 *
 * @param  {Object} [options]
 *         Options object for providing settings.
 *         See: [Options Guide](https://docs.videojs.com/tutorial-options.html).
 *
 * @param  {Component~ReadyCallback} [ready]
 *         A function to be called when the {@link Player} and {@link Tech} are
 *         ready.
 *
 * @return {Player}
 *         The `videojs()` function returns a {@link Player|Player} instance.
 */function videojs(id,options,ready){var player=videojs.getPlayer(id);if(player){if(options){log$1.warn("Player \""+id+"\" is already initialised. Options will not be applied.");}if(ready){player.ready(ready);}return player;}var el=typeof id==='string'?$('#'+normalizeId(id)):id;if(!isEl(el)){throw new TypeError('The element or ID supplied is not valid. (videojs)');}// document.body.contains(el) will only check if el is contained within that one document.
// This causes problems for elements in iframes.
// Instead, use the element's ownerDocument instead of the global document.
// This will make sure that the element is indeed in the dom of that document.
// Additionally, check that the document in question has a default view.
// If the document is no longer attached to the dom, the defaultView of the document will be null.
if(!el.ownerDocument.defaultView||!el.ownerDocument.body.contains(el)){log$1.warn('The element supplied is not included in the DOM');}options=options||{};// Store a copy of the el before modification, if it is to be restored in destroy()
// If div ingest, store the parent div
if(options.restoreEl===true){options.restoreEl=(el.parentNode&&el.parentNode.hasAttribute('data-vjs-player')?el.parentNode:el).cloneNode(true);}hooks('beforesetup').forEach(function(hookFunction){var opts=hookFunction(el,mergeOptions$3(options));if(!video_es_isObject(opts)||Array.isArray(opts)){log$1.error('please return an object in beforesetup hooks');return;}options=mergeOptions$3(options,opts);});// We get the current "Player" component here in case an integration has
// replaced it with a custom player.
var PlayerComponent=Component$1.getComponent('Player');player=new PlayerComponent(el,options,ready);hooks('setup').forEach(function(hookFunction){return hookFunction(player);});return player;}videojs.hooks_=hooks_;videojs.hooks=hooks;videojs.hook=hook;videojs.hookOnce=hookOnce;videojs.removeHook=removeHook;// Add default styles
if((window_default()).VIDEOJS_NO_DYNAMIC_STYLE!==true&&isReal()){var style=$('.vjs-styles-defaults');if(!style){style=createStyleElement('vjs-styles-defaults');var head=$('head');if(head){head.insertBefore(style,head.firstChild);}setTextContent(style,"\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: 56.25%\n      }\n    ");}}// Run Auto-load players
// You have to wait at least once in case this script is loaded after your
// video in the DOM (weird behavior only with minified version)
autoSetupTimeout(1,videojs);/**
 * Current Video.js version. Follows [semantic versioning](https://semver.org/).
 *
 * @type {string}
 */videojs.VERSION=version$5;/**
 * The global options object. These are the settings that take effect
 * if no overrides are specified when the player is created.
 *
 * @type {Object}
 */videojs.options=Player.prototype.options_;/**
 * Get an object with the currently created players, keyed by player ID
 *
 * @return {Object}
 *         The created players
 */videojs.getPlayers=function(){return Player.players;};/**
 * Get a single player based on an ID or DOM element.
 *
 * This is useful if you want to check if an element or ID has an associated
 * Video.js player, but not create one if it doesn't.
 *
 * @param   {string|Element} id
 *          An HTML element - `<video>`, `<audio>`, or `<video-js>` -
 *          or a string matching the `id` of such an element.
 *
 * @return {Player|undefined}
 *          A player instance or `undefined` if there is no player instance
 *          matching the argument.
 */videojs.getPlayer=function(id){var players=Player.players;var tag;if(typeof id==='string'){var nId=normalizeId(id);var player=players[nId];if(player){return player;}tag=$('#'+nId);}else{tag=id;}if(isEl(tag)){var _tag=tag,_player=_tag.player,playerId=_tag.playerId;// Element may have a `player` property referring to an already created
// player instance. If so, return that.
if(_player||players[playerId]){return _player||players[playerId];}}};/**
 * Returns an array of all current players.
 *
 * @return {Array}
 *         An array of all players. The array will be in the order that
 *         `Object.keys` provides, which could potentially vary between
 *         JavaScript engines.
 *
 */videojs.getAllPlayers=function(){return(// Disposed players leave a key with a `null` value, so we need to make sure
// we filter those out.
Object.keys(Player.players).map(function(k){return Player.players[k];}).filter(Boolean));};videojs.players=Player.players;videojs.getComponent=Component$1.getComponent;/**
 * Register a component so it can referred to by name. Used when adding to other
 * components, either through addChild `component.addChild('myComponent')` or through
 * default children options  `{ children: ['myComponent'] }`.
 *
 * > NOTE: You could also just initialize the component before adding.
 * `component.addChild(new MyComponent());`
 *
 * @param {string} name
 *        The class name of the component
 *
 * @param {Component} comp
 *        The component class
 *
 * @return {Component}
 *         The newly registered component
 */videojs.registerComponent=function(name,comp){if(Tech.isTech(comp)){log$1.warn("The "+name+" tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)");}Component$1.registerComponent.call(Component$1,name,comp);};videojs.getTech=Tech.getTech;videojs.registerTech=Tech.registerTech;videojs.use=use;/**
 * An object that can be returned by a middleware to signify
 * that the middleware is being terminated.
 *
 * @type {object}
 * @property {object} middleware.TERMINATOR
 */Object.defineProperty(videojs,'middleware',{value:{},writeable:false,enumerable:true});Object.defineProperty(videojs.middleware,'TERMINATOR',{value:TERMINATOR,writeable:false,enumerable:true});/**
 * A reference to the {@link module:browser|browser utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:browser|browser}
 */videojs.browser=video_es_browser;/**
 * Use {@link module:browser.TOUCH_ENABLED|browser.TOUCH_ENABLED} instead; only
 * included for backward-compatibility with 4.x.
 *
 * @deprecated Since version 5.0, use {@link module:browser.TOUCH_ENABLED|browser.TOUCH_ENABLED instead.
 * @type {boolean}
 */videojs.TOUCH_ENABLED=TOUCH_ENABLED;videojs.extend=extend;videojs.mergeOptions=mergeOptions$3;videojs.bind=bind;videojs.registerPlugin=Plugin.registerPlugin;videojs.deregisterPlugin=Plugin.deregisterPlugin;/**
 * Deprecated method to register a plugin with Video.js
 *
 * @deprecated videojs.plugin() is deprecated; use videojs.registerPlugin() instead
 *
 * @param {string} name
 *        The plugin name
 *
 * @param {Plugin|Function} plugin
 *         The plugin sub-class or function
 */videojs.plugin=function(name,plugin){log$1.warn('videojs.plugin() is deprecated; use videojs.registerPlugin() instead');return Plugin.registerPlugin(name,plugin);};videojs.getPlugins=Plugin.getPlugins;videojs.getPlugin=Plugin.getPlugin;videojs.getPluginVersion=Plugin.getPluginVersion;/**
 * Adding languages so that they're available to all players.
 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
 *
 * @param {string} code
 *        The language code or dictionary property
 *
 * @param {Object} data
 *        The data values to be translated
 *
 * @return {Object}
 *         The resulting language dictionary object
 */videojs.addLanguage=function(code,data){var _mergeOptions;code=(''+code).toLowerCase();videojs.options.languages=mergeOptions$3(videojs.options.languages,(_mergeOptions={},_mergeOptions[code]=data,_mergeOptions));return videojs.options.languages[code];};/**
 * A reference to the {@link module:log|log utility module} as an object.
 *
 * @type {Function}
 * @see  {@link module:log|log}
 */videojs.log=log$1;videojs.createLogger=createLogger;videojs.createTimeRange=videojs.createTimeRanges=createTimeRanges;videojs.formatTime=formatTime;videojs.setFormatTime=setFormatTime;videojs.resetFormatTime=resetFormatTime;videojs.parseUrl=parseUrl;videojs.isCrossOrigin=isCrossOrigin;videojs.EventTarget=EventTarget$2;videojs.on=on;videojs.one=one;videojs.off=off;videojs.trigger=trigger;/**
 * A cross-browser XMLHttpRequest wrapper.
 *
 * @function
 * @param    {Object} options
 *           Settings for the request.
 *
 * @return   {XMLHttpRequest|XDomainRequest}
 *           The request object.
 *
 * @see      https://github.com/Raynos/xhr
 */videojs.xhr=(lib_default());videojs.TextTrack=TextTrack;videojs.AudioTrack=AudioTrack;videojs.VideoTrack=VideoTrack;['isEl','isTextNode','createEl','hasClass','addClass','removeClass','toggleClass','setAttributes','getAttributes','emptyEl','appendContent','insertContent'].forEach(function(k){videojs[k]=function(){log$1.warn("videojs."+k+"() is deprecated; use videojs.dom."+k+"() instead");return Dom[k].apply(null,arguments);};});videojs.computedStyle=computedStyle;/**
 * A reference to the {@link module:dom|DOM utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:dom|dom}
 */videojs.dom=Dom;/**
 * A reference to the {@link module:url|URL utility module} as an object.
 *
 * @type {Object}
 * @see  {@link module:url|url}
 */videojs.url=Url;videojs.defineLazyProperty=defineLazyProperty;// Adding less ambiguous text for fullscreen button.
// In a major update this could become the default text and key.
videojs.addLanguage('en',{'Non-Fullscreen':'Exit Fullscreen'});/*! @name @videojs/http-streaming @version 2.16.3 @license Apache-2.0 */ /**
 * @file resolve-url.js - Handling how URLs are resolved and manipulated
 */var video_es_resolveUrl=resolve_url;/**
 * Checks whether xhr request was redirected and returns correct url depending
 * on `handleManifestRedirects` option
 *
 * @api private
 *
 * @param  {string} url - an url being requested
 * @param  {XMLHttpRequest} req - xhr request result
 *
 * @return {string}
 */var resolveManifestRedirect=function resolveManifestRedirect(handleManifestRedirect,url,req){// To understand how the responseURL below is set and generated:
// - https://fetch.spec.whatwg.org/#concept-response-url
// - https://fetch.spec.whatwg.org/#atomic-http-redirect-handling
if(handleManifestRedirect&&req&&req.responseURL&&url!==req.responseURL){return req.responseURL;}return url;};var logger=function logger(source){if(videojs.log.debug){return videojs.log.debug.bind(videojs,'VHS:',source+" >");}return function(){};};/**
 * ranges
 *
 * Utilities for working with TimeRanges.
 *
 */var TIME_FUDGE_FACTOR=1/30;// Comparisons between time values such as current time and the end of the buffered range
// can be misleading because of precision differences or when the current media has poorly
// aligned audio and video, which can cause values to be slightly off from what you would
// expect. This value is what we consider to be safe to use in such comparisons to account
// for these scenarios.
var SAFE_TIME_DELTA=TIME_FUDGE_FACTOR*3;var filterRanges=function filterRanges(timeRanges,predicate){var results=[];var i;if(timeRanges&&timeRanges.length){// Search for ranges that match the predicate
for(i=0;i<timeRanges.length;i++){if(predicate(timeRanges.start(i),timeRanges.end(i))){results.push([timeRanges.start(i),timeRanges.end(i)]);}}}return videojs.createTimeRanges(results);};/**
 * Attempts to find the buffered TimeRange that contains the specified
 * time.
 *
 * @param {TimeRanges} buffered - the TimeRanges object to query
 * @param {number} time  - the time to filter on.
 * @return {TimeRanges} a new TimeRanges object
 */var findRange=function findRange(buffered,time){return filterRanges(buffered,function(start,end){return start-SAFE_TIME_DELTA<=time&&end+SAFE_TIME_DELTA>=time;});};/**
 * Returns the TimeRanges that begin later than the specified time.
 *
 * @param {TimeRanges} timeRanges - the TimeRanges object to query
 * @param {number} time - the time to filter on.
 * @return {TimeRanges} a new TimeRanges object.
 */var findNextRange=function findNextRange(timeRanges,time){return filterRanges(timeRanges,function(start){return start-TIME_FUDGE_FACTOR>=time;});};/**
 * Returns gaps within a list of TimeRanges
 *
 * @param {TimeRanges} buffered - the TimeRanges object
 * @return {TimeRanges} a TimeRanges object of gaps
 */var findGaps=function findGaps(buffered){if(buffered.length<2){return videojs.createTimeRanges();}var ranges=[];for(var i=1;i<buffered.length;i++){var start=buffered.end(i-1);var end=buffered.start(i);ranges.push([start,end]);}return videojs.createTimeRanges(ranges);};/**
 * Calculate the intersection of two TimeRanges
 *
 * @param {TimeRanges} bufferA
 * @param {TimeRanges} bufferB
 * @return {TimeRanges} The interesection of `bufferA` with `bufferB`
 */var bufferIntersection=function bufferIntersection(bufferA,bufferB){var start=null;var end=null;var arity=0;var extents=[];var ranges=[];if(!bufferA||!bufferA.length||!bufferB||!bufferB.length){return videojs.createTimeRange();}// Handle the case where we have both buffers and create an
// intersection of the two
var count=bufferA.length;// A) Gather up all start and end times
while(count--){extents.push({time:bufferA.start(count),type:'start'});extents.push({time:bufferA.end(count),type:'end'});}count=bufferB.length;while(count--){extents.push({time:bufferB.start(count),type:'start'});extents.push({time:bufferB.end(count),type:'end'});}// B) Sort them by time
extents.sort(function(a,b){return a.time-b.time;});// C) Go along one by one incrementing arity for start and decrementing
//    arity for ends
for(count=0;count<extents.length;count++){if(extents[count].type==='start'){arity++;// D) If arity is ever incremented to 2 we are entering an
//    overlapping range
if(arity===2){start=extents[count].time;}}else if(extents[count].type==='end'){arity--;// E) If arity is ever decremented to 1 we leaving an
//    overlapping range
if(arity===1){end=extents[count].time;}}// F) Record overlapping ranges
if(start!==null&&end!==null){ranges.push([start,end]);start=null;end=null;}}return videojs.createTimeRanges(ranges);};/**
 * Gets a human readable string for a TimeRange
 *
 * @param {TimeRange} range
 * @return {string} a human readable string
 */var printableRange=function printableRange(range){var strArr=[];if(!range||!range.length){return'';}for(var i=0;i<range.length;i++){strArr.push(range.start(i)+' => '+range.end(i));}return strArr.join(', ');};/**
 * Calculates the amount of time left in seconds until the player hits the end of the
 * buffer and causes a rebuffer
 *
 * @param {TimeRange} buffered
 *        The state of the buffer
 * @param {Numnber} currentTime
 *        The current time of the player
 * @param {number} playbackRate
 *        The current playback rate of the player. Defaults to 1.
 * @return {number}
 *         Time until the player has to start rebuffering in seconds.
 * @function timeUntilRebuffer
 */var timeUntilRebuffer=function timeUntilRebuffer(buffered,currentTime,playbackRate){if(playbackRate===void 0){playbackRate=1;}var bufferedEnd=buffered.length?buffered.end(buffered.length-1):0;return(bufferedEnd-currentTime)/playbackRate;};/**
 * Converts a TimeRanges object into an array representation
 *
 * @param {TimeRanges} timeRanges
 * @return {Array}
 */var timeRangesToArray=function timeRangesToArray(timeRanges){var timeRangesList=[];for(var i=0;i<timeRanges.length;i++){timeRangesList.push({start:timeRanges.start(i),end:timeRanges.end(i)});}return timeRangesList;};/**
 * Determines if two time range objects are different.
 *
 * @param {TimeRange} a
 *        the first time range object to check
 *
 * @param {TimeRange} b
 *        the second time range object to check
 *
 * @return {Boolean}
 *         Whether the time range objects differ
 */var isRangeDifferent=function isRangeDifferent(a,b){// same object
if(a===b){return false;}// one or the other is undefined
if(!a&&b||!b&&a){return true;}// length is different
if(a.length!==b.length){return true;}// see if any start/end pair is different
for(var i=0;i<a.length;i++){if(a.start(i)!==b.start(i)||a.end(i)!==b.end(i)){return true;}}// if the length and every pair is the same
// this is the same time range
return false;};var lastBufferedEnd=function lastBufferedEnd(a){if(!a||!a.length||!a.end){return;}return a.end(a.length-1);};/**
 * A utility function to add up the amount of time in a timeRange
 * after a specified startTime.
 * ie:[[0, 10], [20, 40], [50, 60]] with a startTime 0
 *     would return 40 as there are 40s seconds after 0 in the timeRange
 *
 * @param {TimeRange} range
 *        The range to check against
 * @param {number} startTime
 *        The time in the time range that you should start counting from
 *
 * @return {number}
 *          The number of seconds in the buffer passed the specified time.
 */var timeAheadOf=function timeAheadOf(range,startTime){var time=0;if(!range||!range.length){return time;}for(var i=0;i<range.length;i++){var start=range.start(i);var end=range.end(i);// startTime is after this range entirely
if(startTime>end){continue;}// startTime is within this range
if(startTime>start&&startTime<=end){time+=end-startTime;continue;}// startTime is before this range.
time+=end-start;}return time;};/**
 * @file playlist.js
 *
 * Playlist related utilities.
 */var createTimeRange=videojs.createTimeRange;/**
 * Get the duration of a segment, with special cases for
 * llhls segments that do not have a duration yet.
 *
 * @param {Object} playlist
 *        the playlist that the segment belongs to.
 * @param {Object} segment
 *        the segment to get a duration for.
 *
 * @return {number}
 *          the segment duration
 */var segmentDurationWithParts=function segmentDurationWithParts(playlist,segment){// if this isn't a preload segment
// then we will have a segment duration that is accurate.
if(!segment.preload){return segment.duration;}// otherwise we have to add up parts and preload hints
// to get an up to date duration.
var result=0;(segment.parts||[]).forEach(function(p){result+=p.duration;});// for preload hints we have to use partTargetDuration
// as they won't even have a duration yet.
(segment.preloadHints||[]).forEach(function(p){if(p.type==='PART'){result+=playlist.partTargetDuration;}});return result;};/**
 * A function to get a combined list of parts and segments with durations
 * and indexes.
 *
 * @param {Playlist} playlist the playlist to get the list for.
 *
 * @return {Array} The part/segment list.
 */var getPartsAndSegments=function getPartsAndSegments(playlist){return(playlist.segments||[]).reduce(function(acc,segment,si){if(segment.parts){segment.parts.forEach(function(part,pi){acc.push({duration:part.duration,segmentIndex:si,partIndex:pi,part:part,segment:segment});});}else{acc.push({duration:segment.duration,segmentIndex:si,partIndex:null,segment:segment,part:null});}return acc;},[]);};var getLastParts=function getLastParts(media){var lastSegment=media.segments&&media.segments.length&&media.segments[media.segments.length-1];return lastSegment&&lastSegment.parts||[];};var getKnownPartCount=function getKnownPartCount(_ref){var preloadSegment=_ref.preloadSegment;if(!preloadSegment){return;}var parts=preloadSegment.parts,preloadHints=preloadSegment.preloadHints;var partCount=(preloadHints||[]).reduce(function(count,hint){return count+(hint.type==='PART'?1:0);},0);partCount+=parts&&parts.length?parts.length:0;return partCount;};/**
 * Get the number of seconds to delay from the end of a
 * live playlist.
 *
 * @param {Playlist} master the master playlist
 * @param {Playlist} media the media playlist
 * @return {number} the hold back in seconds.
 */var liveEdgeDelay=function liveEdgeDelay(master,media){if(media.endList){return 0;}// dash suggestedPresentationDelay trumps everything
if(master&&master.suggestedPresentationDelay){return master.suggestedPresentationDelay;}var hasParts=getLastParts(media).length>0;// look for "part" delays from ll-hls first
if(hasParts&&media.serverControl&&media.serverControl.partHoldBack){return media.serverControl.partHoldBack;}else if(hasParts&&media.partTargetDuration){return media.partTargetDuration*3;// finally look for full segment delays
}else if(media.serverControl&&media.serverControl.holdBack){return media.serverControl.holdBack;}else if(media.targetDuration){return media.targetDuration*3;}return 0;};/**
 * walk backward until we find a duration we can use
 * or return a failure
 *
 * @param {Playlist} playlist the playlist to walk through
 * @param {Number} endSequence the mediaSequence to stop walking on
 */var backwardDuration=function backwardDuration(playlist,endSequence){var result=0;var i=endSequence-playlist.mediaSequence;// if a start time is available for segment immediately following
// the interval, use it
var segment=playlist.segments[i];// Walk backward until we find the latest segment with timeline
// information that is earlier than endSequence
if(segment){if(typeof segment.start!=='undefined'){return{result:segment.start,precise:true};}if(typeof segment.end!=='undefined'){return{result:segment.end-segment.duration,precise:true};}}while(i--){segment=playlist.segments[i];if(typeof segment.end!=='undefined'){return{result:result+segment.end,precise:true};}result+=segmentDurationWithParts(playlist,segment);if(typeof segment.start!=='undefined'){return{result:result+segment.start,precise:true};}}return{result:result,precise:false};};/**
 * walk forward until we find a duration we can use
 * or return a failure
 *
 * @param {Playlist} playlist the playlist to walk through
 * @param {number} endSequence the mediaSequence to stop walking on
 */var forwardDuration=function forwardDuration(playlist,endSequence){var result=0;var segment;var i=endSequence-playlist.mediaSequence;// Walk forward until we find the earliest segment with timeline
// information
for(;i<playlist.segments.length;i++){segment=playlist.segments[i];if(typeof segment.start!=='undefined'){return{result:segment.start-result,precise:true};}result+=segmentDurationWithParts(playlist,segment);if(typeof segment.end!=='undefined'){return{result:segment.end-result,precise:true};}}// indicate we didn't find a useful duration estimate
return{result:-1,precise:false};};/**
  * Calculate the media duration from the segments associated with a
  * playlist. The duration of a subinterval of the available segments
  * may be calculated by specifying an end index.
  *
  * @param {Object} playlist a media playlist object
  * @param {number=} endSequence an exclusive upper boundary
  * for the playlist.  Defaults to playlist length.
  * @param {number} expired the amount of time that has dropped
  * off the front of the playlist in a live scenario
  * @return {number} the duration between the first available segment
  * and end index.
  */var intervalDuration=function intervalDuration(playlist,endSequence,expired){if(typeof endSequence==='undefined'){endSequence=playlist.mediaSequence+playlist.segments.length;}if(endSequence<playlist.mediaSequence){return 0;}// do a backward walk to estimate the duration
var backward=backwardDuration(playlist,endSequence);if(backward.precise){// if we were able to base our duration estimate on timing
// information provided directly from the Media Source, return
// it
return backward.result;}// walk forward to see if a precise duration estimate can be made
// that way
var forward=forwardDuration(playlist,endSequence);if(forward.precise){// we found a segment that has been buffered and so it's
// position is known precisely
return forward.result;}// return the less-precise, playlist-based duration estimate
return backward.result+expired;};/**
  * Calculates the duration of a playlist. If a start and end index
  * are specified, the duration will be for the subset of the media
  * timeline between those two indices. The total duration for live
  * playlists is always Infinity.
  *
  * @param {Object} playlist a media playlist object
  * @param {number=} endSequence an exclusive upper
  * boundary for the playlist. Defaults to the playlist media
  * sequence number plus its length.
  * @param {number=} expired the amount of time that has
  * dropped off the front of the playlist in a live scenario
  * @return {number} the duration between the start index and end
  * index.
  */var duration=function duration(playlist,endSequence,expired){if(!playlist){return 0;}if(typeof expired!=='number'){expired=0;}// if a slice of the total duration is not requested, use
// playlist-level duration indicators when they're present
if(typeof endSequence==='undefined'){// if present, use the duration specified in the playlist
if(playlist.totalDuration){return playlist.totalDuration;}// duration should be Infinity for live playlists
if(!playlist.endList){return (window_default())[Infinity];}}// calculate the total duration based on the segment durations
return intervalDuration(playlist,endSequence,expired);};/**
  * Calculate the time between two indexes in the current playlist
  * neight the start- nor the end-index need to be within the current
  * playlist in which case, the targetDuration of the playlist is used
  * to approximate the durations of the segments
  *
  * @param {Array} options.durationList list to iterate over for durations.
  * @param {number} options.defaultDuration duration to use for elements before or after the durationList
  * @param {number} options.startIndex partsAndSegments index to start
  * @param {number} options.endIndex partsAndSegments index to end.
  * @return {number} the number of seconds between startIndex and endIndex
  */var sumDurations=function sumDurations(_ref2){var defaultDuration=_ref2.defaultDuration,durationList=_ref2.durationList,startIndex=_ref2.startIndex,endIndex=_ref2.endIndex;var durations=0;if(startIndex>endIndex){var _ref3=[endIndex,startIndex];startIndex=_ref3[0];endIndex=_ref3[1];}if(startIndex<0){for(var i=startIndex;i<Math.min(0,endIndex);i++){durations+=defaultDuration;}startIndex=0;}for(var _i=startIndex;_i<endIndex;_i++){durations+=durationList[_i].duration;}return durations;};/**
 * Calculates the playlist end time
 *
 * @param {Object} playlist a media playlist object
 * @param {number=} expired the amount of time that has
 *                  dropped off the front of the playlist in a live scenario
 * @param {boolean|false} useSafeLiveEnd a boolean value indicating whether or not the
 *                        playlist end calculation should consider the safe live end
 *                        (truncate the playlist end by three segments). This is normally
 *                        used for calculating the end of the playlist's seekable range.
 *                        This takes into account the value of liveEdgePadding.
 *                        Setting liveEdgePadding to 0 is equivalent to setting this to false.
 * @param {number} liveEdgePadding a number indicating how far from the end of the playlist we should be in seconds.
 *                 If this is provided, it is used in the safe live end calculation.
 *                 Setting useSafeLiveEnd=false or liveEdgePadding=0 are equivalent.
 *                 Corresponds to suggestedPresentationDelay in DASH manifests.
 * @return {number} the end time of playlist
 * @function playlistEnd
 */var playlistEnd=function playlistEnd(playlist,expired,useSafeLiveEnd,liveEdgePadding){if(!playlist||!playlist.segments){return null;}if(playlist.endList){return duration(playlist);}if(expired===null){return null;}expired=expired||0;var lastSegmentEndTime=intervalDuration(playlist,playlist.mediaSequence+playlist.segments.length,expired);if(useSafeLiveEnd){liveEdgePadding=typeof liveEdgePadding==='number'?liveEdgePadding:liveEdgeDelay(null,playlist);lastSegmentEndTime-=liveEdgePadding;}// don't return a time less than zero
return Math.max(0,lastSegmentEndTime);};/**
  * Calculates the interval of time that is currently seekable in a
  * playlist. The returned time ranges are relative to the earliest
  * moment in the specified playlist that is still available. A full
  * seekable implementation for live streams would need to offset
  * these values by the duration of content that has expired from the
  * stream.
  *
  * @param {Object} playlist a media playlist object
  * dropped off the front of the playlist in a live scenario
  * @param {number=} expired the amount of time that has
  * dropped off the front of the playlist in a live scenario
  * @param {number} liveEdgePadding how far from the end of the playlist we should be in seconds.
  *        Corresponds to suggestedPresentationDelay in DASH manifests.
  * @return {TimeRanges} the periods of time that are valid targets
  * for seeking
  */var seekable=function seekable(playlist,expired,liveEdgePadding){var useSafeLiveEnd=true;var seekableStart=expired||0;var seekableEnd=playlistEnd(playlist,expired,useSafeLiveEnd,liveEdgePadding);if(seekableEnd===null){return createTimeRange();}return createTimeRange(seekableStart,seekableEnd);};/**
 * Determine the index and estimated starting time of the segment that
 * contains a specified playback position in a media playlist.
 *
 * @param {Object} options.playlist the media playlist to query
 * @param {number} options.currentTime The number of seconds since the earliest
 * possible position to determine the containing segment for
 * @param {number} options.startTime the time when the segment/part starts
 * @param {number} options.startingSegmentIndex the segment index to start looking at.
 * @param {number?} [options.startingPartIndex] the part index to look at within the segment.
 *
 * @return {Object} an object with partIndex, segmentIndex, and startTime.
 */var getMediaInfoForTime=function getMediaInfoForTime(_ref4){var playlist=_ref4.playlist,currentTime=_ref4.currentTime,startingSegmentIndex=_ref4.startingSegmentIndex,startingPartIndex=_ref4.startingPartIndex,startTime=_ref4.startTime,experimentalExactManifestTimings=_ref4.experimentalExactManifestTimings;var time=currentTime-startTime;var partsAndSegments=getPartsAndSegments(playlist);var startIndex=0;for(var i=0;i<partsAndSegments.length;i++){var partAndSegment=partsAndSegments[i];if(startingSegmentIndex!==partAndSegment.segmentIndex){continue;}// skip this if part index does not match.
if(typeof startingPartIndex==='number'&&typeof partAndSegment.partIndex==='number'&&startingPartIndex!==partAndSegment.partIndex){continue;}startIndex=i;break;}if(time<0){// Walk backward from startIndex in the playlist, adding durations
// until we find a segment that contains `time` and return it
if(startIndex>0){for(var _i2=startIndex-1;_i2>=0;_i2--){var _partAndSegment=partsAndSegments[_i2];time+=_partAndSegment.duration;if(experimentalExactManifestTimings){if(time<0){continue;}}else if(time+TIME_FUDGE_FACTOR<=0){continue;}return{partIndex:_partAndSegment.partIndex,segmentIndex:_partAndSegment.segmentIndex,startTime:startTime-sumDurations({defaultDuration:playlist.targetDuration,durationList:partsAndSegments,startIndex:startIndex,endIndex:_i2})};}}// We were unable to find a good segment within the playlist
// so select the first segment
return{partIndex:partsAndSegments[0]&&partsAndSegments[0].partIndex||null,segmentIndex:partsAndSegments[0]&&partsAndSegments[0].segmentIndex||0,startTime:currentTime};}// When startIndex is negative, we first walk forward to first segment
// adding target durations. If we "run out of time" before getting to
// the first segment, return the first segment
if(startIndex<0){for(var _i3=startIndex;_i3<0;_i3++){time-=playlist.targetDuration;if(time<0){return{partIndex:partsAndSegments[0]&&partsAndSegments[0].partIndex||null,segmentIndex:partsAndSegments[0]&&partsAndSegments[0].segmentIndex||0,startTime:currentTime};}}startIndex=0;}// Walk forward from startIndex in the playlist, subtracting durations
// until we find a segment that contains `time` and return it
for(var _i4=startIndex;_i4<partsAndSegments.length;_i4++){var _partAndSegment2=partsAndSegments[_i4];time-=_partAndSegment2.duration;if(experimentalExactManifestTimings){if(time>0){continue;}}else if(time-TIME_FUDGE_FACTOR>=0){continue;}return{partIndex:_partAndSegment2.partIndex,segmentIndex:_partAndSegment2.segmentIndex,startTime:startTime+sumDurations({defaultDuration:playlist.targetDuration,durationList:partsAndSegments,startIndex:startIndex,endIndex:_i4})};}// We are out of possible candidates so load the last one...
return{segmentIndex:partsAndSegments[partsAndSegments.length-1].segmentIndex,partIndex:partsAndSegments[partsAndSegments.length-1].partIndex,startTime:currentTime};};/**
 * Check whether the playlist is blacklisted or not.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is blacklisted or not
 * @function isBlacklisted
 */var isBlacklisted=function isBlacklisted(playlist){return playlist.excludeUntil&&playlist.excludeUntil>Date.now();};/**
 * Check whether the playlist is compatible with current playback configuration or has
 * been blacklisted permanently for being incompatible.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is incompatible or not
 * @function isIncompatible
 */var isIncompatible=function isIncompatible(playlist){return playlist.excludeUntil&&playlist.excludeUntil===Infinity;};/**
 * Check whether the playlist is enabled or not.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is enabled or not
 * @function isEnabled
 */var isEnabled=function isEnabled(playlist){var blacklisted=isBlacklisted(playlist);return!playlist.disabled&&!blacklisted;};/**
 * Check whether the playlist has been manually disabled through the representations api.
 *
 * @param {Object} playlist the media playlist object
 * @return {boolean} whether the playlist is disabled manually or not
 * @function isDisabled
 */var isDisabled=function isDisabled(playlist){return playlist.disabled;};/**
 * Returns whether the current playlist is an AES encrypted HLS stream
 *
 * @return {boolean} true if it's an AES encrypted HLS stream
 */var isAes=function isAes(media){for(var i=0;i<media.segments.length;i++){if(media.segments[i].key){return true;}}return false;};/**
 * Checks if the playlist has a value for the specified attribute
 *
 * @param {string} attr
 *        Attribute to check for
 * @param {Object} playlist
 *        The media playlist object
 * @return {boolean}
 *         Whether the playlist contains a value for the attribute or not
 * @function hasAttribute
 */var hasAttribute=function hasAttribute(attr,playlist){return playlist.attributes&&playlist.attributes[attr];};/**
 * Estimates the time required to complete a segment download from the specified playlist
 *
 * @param {number} segmentDuration
 *        Duration of requested segment
 * @param {number} bandwidth
 *        Current measured bandwidth of the player
 * @param {Object} playlist
 *        The media playlist object
 * @param {number=} bytesReceived
 *        Number of bytes already received for the request. Defaults to 0
 * @return {number|NaN}
 *         The estimated time to request the segment. NaN if bandwidth information for
 *         the given playlist is unavailable
 * @function estimateSegmentRequestTime
 */var estimateSegmentRequestTime=function estimateSegmentRequestTime(segmentDuration,bandwidth,playlist,bytesReceived){if(bytesReceived===void 0){bytesReceived=0;}if(!hasAttribute('BANDWIDTH',playlist)){return NaN;}var size=segmentDuration*playlist.attributes.BANDWIDTH;return(size-bytesReceived*8)/bandwidth;};/*
 * Returns whether the current playlist is the lowest rendition
 *
 * @return {Boolean} true if on lowest rendition
 */var isLowestEnabledRendition=function isLowestEnabledRendition(master,media){if(master.playlists.length===1){return true;}var currentBandwidth=media.attributes.BANDWIDTH||Number.MAX_VALUE;return master.playlists.filter(function(playlist){if(!isEnabled(playlist)){return false;}return(playlist.attributes.BANDWIDTH||0)<currentBandwidth;}).length===0;};var playlistMatch=function playlistMatch(a,b){// both playlits are null
// or only one playlist is non-null
// no match
if(!a&&!b||!a&&b||a&&!b){return false;}// playlist objects are the same, match
if(a===b){return true;}// first try to use id as it should be the most
// accurate
if(a.id&&b.id&&a.id===b.id){return true;}// next try to use reslovedUri as it should be the
// second most accurate.
if(a.resolvedUri&&b.resolvedUri&&a.resolvedUri===b.resolvedUri){return true;}// finally try to use uri as it should be accurate
// but might miss a few cases for relative uris
if(a.uri&&b.uri&&a.uri===b.uri){return true;}return false;};var someAudioVariant=function someAudioVariant(master,callback){var AUDIO=master&&master.mediaGroups&&master.mediaGroups.AUDIO||{};var found=false;for(var groupName in AUDIO){for(var label in AUDIO[groupName]){found=callback(AUDIO[groupName][label]);if(found){break;}}if(found){break;}}return!!found;};var isAudioOnly=function isAudioOnly(master){// we are audio only if we have no main playlists but do
// have media group playlists.
if(!master||!master.playlists||!master.playlists.length){// without audio variants or playlists this
// is not an audio only master.
var found=someAudioVariant(master,function(variant){return variant.playlists&&variant.playlists.length||variant.uri;});return found;}// if every playlist has only an audio codec it is audio only
var _loop=function _loop(i){var playlist=master.playlists[i];var CODECS=playlist.attributes&&playlist.attributes.CODECS;// all codecs are audio, this is an audio playlist.
if(CODECS&&CODECS.split(',').every(function(c){return isAudioCodec(c);})){return"continue";}// playlist is in an audio group it is audio only
var found=someAudioVariant(master,function(variant){return playlistMatch(playlist,variant);});if(found){return"continue";}// if we make it here this playlist isn't audio and we
// are not audio only
return{v:false};};for(var i=0;i<master.playlists.length;i++){var _ret=_loop(i);if(_ret==="continue")continue;if(video_es_typeof(_ret)==="object")return _ret.v;}// if we make it past every playlist without returning, then
// this is an audio only playlist.
return true;};// exports
var Playlist={liveEdgeDelay:liveEdgeDelay,duration:duration,seekable:seekable,getMediaInfoForTime:getMediaInfoForTime,isEnabled:isEnabled,isDisabled:isDisabled,isBlacklisted:isBlacklisted,isIncompatible:isIncompatible,playlistEnd:playlistEnd,isAes:isAes,hasAttribute:hasAttribute,estimateSegmentRequestTime:estimateSegmentRequestTime,isLowestEnabledRendition:isLowestEnabledRendition,isAudioOnly:isAudioOnly,playlistMatch:playlistMatch,segmentDurationWithParts:segmentDurationWithParts};var log=videojs.log;var createPlaylistID=function createPlaylistID(index,uri){return index+"-"+uri;};// default function for creating a group id
var groupID=function groupID(type,group,label){return"placeholder-uri-"+type+"-"+group+"-"+label;};/**
 * Parses a given m3u8 playlist
 *
 * @param {Function} [onwarn]
 *        a function to call when the parser triggers a warning event.
 * @param {Function} [oninfo]
 *        a function to call when the parser triggers an info event.
 * @param {string} manifestString
 *        The downloaded manifest string
 * @param {Object[]} [customTagParsers]
 *        An array of custom tag parsers for the m3u8-parser instance
 * @param {Object[]} [customTagMappers]
 *        An array of custom tag mappers for the m3u8-parser instance
 * @param {boolean} [experimentalLLHLS=false]
 *        Whether to keep ll-hls features in the manifest after parsing.
 * @return {Object}
 *         The manifest object
 */var parseManifest=function parseManifest(_ref){var onwarn=_ref.onwarn,oninfo=_ref.oninfo,manifestString=_ref.manifestString,_ref$customTagParsers=_ref.customTagParsers,customTagParsers=_ref$customTagParsers===void 0?[]:_ref$customTagParsers,_ref$customTagMappers=_ref.customTagMappers,customTagMappers=_ref$customTagMappers===void 0?[]:_ref$customTagMappers,experimentalLLHLS=_ref.experimentalLLHLS;var parser=new Parser();if(onwarn){parser.on('warn',onwarn);}if(oninfo){parser.on('info',oninfo);}customTagParsers.forEach(function(customParser){return parser.addParser(customParser);});customTagMappers.forEach(function(mapper){return parser.addTagMapper(mapper);});parser.push(manifestString);parser.end();var manifest=parser.manifest;// remove llhls features from the parsed manifest
// if we don't want llhls support.
if(!experimentalLLHLS){['preloadSegment','skip','serverControl','renditionReports','partInf','partTargetDuration'].forEach(function(k){if(manifest.hasOwnProperty(k)){delete manifest[k];}});if(manifest.segments){manifest.segments.forEach(function(segment){['parts','preloadHints'].forEach(function(k){if(segment.hasOwnProperty(k)){delete segment[k];}});});}}if(!manifest.targetDuration){var targetDuration=10;if(manifest.segments&&manifest.segments.length){targetDuration=manifest.segments.reduce(function(acc,s){return Math.max(acc,s.duration);},0);}if(onwarn){onwarn("manifest has no targetDuration defaulting to "+targetDuration);}manifest.targetDuration=targetDuration;}var parts=getLastParts(manifest);if(parts.length&&!manifest.partTargetDuration){var partTargetDuration=parts.reduce(function(acc,p){return Math.max(acc,p.duration);},0);if(onwarn){onwarn("manifest has no partTargetDuration defaulting to "+partTargetDuration);log.error('LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.');}manifest.partTargetDuration=partTargetDuration;}return manifest;};/**
 * Loops through all supported media groups in master and calls the provided
 * callback for each group
 *
 * @param {Object} master
 *        The parsed master manifest object
 * @param {Function} callback
 *        Callback to call for each media group
 */var video_es_forEachMediaGroup=function forEachMediaGroup(master,callback){if(!master.mediaGroups){return;}['AUDIO','SUBTITLES'].forEach(function(mediaType){if(!master.mediaGroups[mediaType]){return;}for(var groupKey in master.mediaGroups[mediaType]){for(var labelKey in master.mediaGroups[mediaType][groupKey]){var mediaProperties=master.mediaGroups[mediaType][groupKey][labelKey];callback(mediaProperties,mediaType,groupKey,labelKey);}}});};/**
 * Adds properties and attributes to the playlist to keep consistent functionality for
 * playlists throughout VHS.
 *
 * @param {Object} config
 *        Arguments object
 * @param {Object} config.playlist
 *        The media playlist
 * @param {string} [config.uri]
 *        The uri to the media playlist (if media playlist is not from within a master
 *        playlist)
 * @param {string} id
 *        ID to use for the playlist
 */var setupMediaPlaylist=function setupMediaPlaylist(_ref2){var playlist=_ref2.playlist,uri=_ref2.uri,id=_ref2.id;playlist.id=id;playlist.playlistErrors_=0;if(uri){// For media playlists, m3u8-parser does not have access to a URI, as HLS media
// playlists do not contain their own source URI, but one is needed for consistency in
// VHS.
playlist.uri=uri;}// For HLS master playlists, even though certain attributes MUST be defined, the
// stream may still be played without them.
// For HLS media playlists, m3u8-parser does not attach an attributes object to the
// manifest.
//
// To avoid undefined reference errors through the project, and make the code easier
// to write/read, add an empty attributes object for these cases.
playlist.attributes=playlist.attributes||{};};/**
 * Adds ID, resolvedUri, and attributes properties to each playlist of the master, where
 * necessary. In addition, creates playlist IDs for each playlist and adds playlist ID to
 * playlist references to the playlists array.
 *
 * @param {Object} master
 *        The master playlist
 */var setupMediaPlaylists=function setupMediaPlaylists(master){var i=master.playlists.length;while(i--){var playlist=master.playlists[i];setupMediaPlaylist({playlist:playlist,id:createPlaylistID(i,playlist.uri)});playlist.resolvedUri=video_es_resolveUrl(master.uri,playlist.uri);master.playlists[playlist.id]=playlist;// URI reference added for backwards compatibility
master.playlists[playlist.uri]=playlist;// Although the spec states an #EXT-X-STREAM-INF tag MUST have a BANDWIDTH attribute,
// the stream can be played without it. Although an attributes property may have been
// added to the playlist to prevent undefined references, issue a warning to fix the
// manifest.
if(!playlist.attributes.BANDWIDTH){log.warn('Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.');}}};/**
 * Adds resolvedUri properties to each media group.
 *
 * @param {Object} master
 *        The master playlist
 */var resolveMediaGroupUris=function resolveMediaGroupUris(master){video_es_forEachMediaGroup(master,function(properties){if(properties.uri){properties.resolvedUri=video_es_resolveUrl(master.uri,properties.uri);}});};/**
 * Creates a master playlist wrapper to insert a sole media playlist into.
 *
 * @param {Object} media
 *        Media playlist
 * @param {string} uri
 *        The media URI
 *
 * @return {Object}
 *         Master playlist
 */var masterForMedia=function masterForMedia(media,uri){var id=createPlaylistID(0,uri);var master={mediaGroups:{'AUDIO':{},'VIDEO':{},'CLOSED-CAPTIONS':{},'SUBTITLES':{}},uri:(window_default()).location.href,resolvedUri:(window_default()).location.href,playlists:[{uri:uri,id:id,resolvedUri:uri,// m3u8-parser does not attach an attributes property to media playlists so make
// sure that the property is attached to avoid undefined reference errors
attributes:{}}]};// set up ID reference
master.playlists[id]=master.playlists[0];// URI reference added for backwards compatibility
master.playlists[uri]=master.playlists[0];return master;};/**
 * Does an in-place update of the master manifest to add updated playlist URI references
 * as well as other properties needed by VHS that aren't included by the parser.
 *
 * @param {Object} master
 *        Master manifest object
 * @param {string} uri
 *        The source URI
 * @param {function} createGroupID
 *        A function to determine how to create the groupID for mediaGroups
 */var addPropertiesToMaster=function addPropertiesToMaster(master,uri,createGroupID){if(createGroupID===void 0){createGroupID=groupID;}master.uri=uri;for(var i=0;i<master.playlists.length;i++){if(!master.playlists[i].uri){// Set up phony URIs for the playlists since playlists are referenced by their URIs
// throughout VHS, but some formats (e.g., DASH) don't have external URIs
// TODO: consider adding dummy URIs in mpd-parser
var phonyUri="placeholder-uri-"+i;master.playlists[i].uri=phonyUri;}}var audioOnlyMaster=isAudioOnly(master);video_es_forEachMediaGroup(master,function(properties,mediaType,groupKey,labelKey){// add a playlist array under properties
if(!properties.playlists||!properties.playlists.length){// If the manifest is audio only and this media group does not have a uri, check
// if the media group is located in the main list of playlists. If it is, don't add
// placeholder properties as it shouldn't be considered an alternate audio track.
if(audioOnlyMaster&&mediaType==='AUDIO'&&!properties.uri){for(var _i=0;_i<master.playlists.length;_i++){var p=master.playlists[_i];if(p.attributes&&p.attributes.AUDIO&&p.attributes.AUDIO===groupKey){return;}}}properties.playlists=[_extends({},properties)];}properties.playlists.forEach(function(p,i){var groupId=createGroupID(mediaType,groupKey,labelKey,p);var id=createPlaylistID(i,groupId);if(p.uri){p.resolvedUri=p.resolvedUri||video_es_resolveUrl(master.uri,p.uri);}else{// DEPRECATED, this has been added to prevent a breaking change.
// previously we only ever had a single media group playlist, so
// we mark the first playlist uri without prepending the index as we used to
// ideally we would do all of the playlists the same way.
p.uri=i===0?groupId:id;// don't resolve a placeholder uri to an absolute url, just use
// the placeholder again
p.resolvedUri=p.uri;}p.id=p.id||id;// add an empty attributes object, all playlists are
// expected to have this.
p.attributes=p.attributes||{};// setup ID and URI references (URI for backwards compatibility)
master.playlists[p.id]=p;master.playlists[p.uri]=p;});});setupMediaPlaylists(master);resolveMediaGroupUris(master);};var mergeOptions$2=videojs.mergeOptions,EventTarget$1=videojs.EventTarget;var addLLHLSQueryDirectives=function addLLHLSQueryDirectives(uri,media){if(media.endList||!media.serverControl){return uri;}var parameters={};if(media.serverControl.canBlockReload){var preloadSegment=media.preloadSegment;// next msn is a zero based value, length is not.
var nextMSN=media.mediaSequence+media.segments.length;// If preload segment has parts then it is likely
// that we are going to request a part of that preload segment.
// the logic below is used to determine that.
if(preloadSegment){var parts=preloadSegment.parts||[];// _HLS_part is a zero based index
var nextPart=getKnownPartCount(media)-1;// if nextPart is > -1 and not equal to just the
// length of parts, then we know we had part preload hints
// and we need to add the _HLS_part= query
if(nextPart>-1&&nextPart!==parts.length-1){// add existing parts to our preload hints
// eslint-disable-next-line
parameters._HLS_part=nextPart;}// this if statement makes sure that we request the msn
// of the preload segment if:
// 1. the preload segment had parts (and was not yet a full segment)
//    but was added to our segments array
// 2. the preload segment had preload hints for parts that are not in
//    the manifest yet.
// in all other cases we want the segment after the preload segment
// which will be given by using media.segments.length because it is 1 based
// rather than 0 based.
if(nextPart>-1||parts.length){nextMSN--;}}// add _HLS_msn= in front of any _HLS_part query
// eslint-disable-next-line
parameters._HLS_msn=nextMSN;}if(media.serverControl&&media.serverControl.canSkipUntil){// add _HLS_skip= infront of all other queries.
// eslint-disable-next-line
parameters._HLS_skip=media.serverControl.canSkipDateranges?'v2':'YES';}if(Object.keys(parameters).length){var parsedUri=new (window_default()).URL(uri);['_HLS_skip','_HLS_msn','_HLS_part'].forEach(function(name){if(!parameters.hasOwnProperty(name)){return;}parsedUri.searchParams.set(name,parameters[name]);});uri=parsedUri.toString();}return uri;};/**
 * Returns a new segment object with properties and
 * the parts array merged.
 *
 * @param {Object} a the old segment
 * @param {Object} b the new segment
 *
 * @return {Object} the merged segment
 */var updateSegment=function updateSegment(a,b){if(!a){return b;}var result=mergeOptions$2(a,b);// if only the old segment has preload hints
// and the new one does not, remove preload hints.
if(a.preloadHints&&!b.preloadHints){delete result.preloadHints;}// if only the old segment has parts
// then the parts are no longer valid
if(a.parts&&!b.parts){delete result.parts;// if both segments have parts
// copy part propeties from the old segment
// to the new one.
}else if(a.parts&&b.parts){for(var i=0;i<b.parts.length;i++){if(a.parts&&a.parts[i]){result.parts[i]=mergeOptions$2(a.parts[i],b.parts[i]);}}}// set skipped to false for segments that have
// have had information merged from the old segment.
if(!a.skipped&&b.skipped){result.skipped=false;}// set preload to false for segments that have
// had information added in the new segment.
if(a.preload&&!b.preload){result.preload=false;}return result;};/**
 * Returns a new array of segments that is the result of merging
 * properties from an older list of segments onto an updated
 * list. No properties on the updated playlist will be ovewritten.
 *
 * @param {Array} original the outdated list of segments
 * @param {Array} update the updated list of segments
 * @param {number=} offset the index of the first update
 * segment in the original segment list. For non-live playlists,
 * this should always be zero and does not need to be
 * specified. For live playlists, it should be the difference
 * between the media sequence numbers in the original and updated
 * playlists.
 * @return {Array} a list of merged segment objects
 */var updateSegments=function updateSegments(original,update,offset){var oldSegments=original.slice();var newSegments=update.slice();offset=offset||0;var result=[];var currentMap;for(var newIndex=0;newIndex<newSegments.length;newIndex++){var oldSegment=oldSegments[newIndex+offset];var newSegment=newSegments[newIndex];if(oldSegment){currentMap=oldSegment.map||currentMap;result.push(updateSegment(oldSegment,newSegment));}else{// carry over map to new segment if it is missing
if(currentMap&&!newSegment.map){newSegment.map=currentMap;}result.push(newSegment);}}return result;};var resolveSegmentUris=function resolveSegmentUris(segment,baseUri){// preloadSegment will not have a uri at all
// as the segment isn't actually in the manifest yet, only parts
if(!segment.resolvedUri&&segment.uri){segment.resolvedUri=video_es_resolveUrl(baseUri,segment.uri);}if(segment.key&&!segment.key.resolvedUri){segment.key.resolvedUri=video_es_resolveUrl(baseUri,segment.key.uri);}if(segment.map&&!segment.map.resolvedUri){segment.map.resolvedUri=video_es_resolveUrl(baseUri,segment.map.uri);}if(segment.map&&segment.map.key&&!segment.map.key.resolvedUri){segment.map.key.resolvedUri=video_es_resolveUrl(baseUri,segment.map.key.uri);}if(segment.parts&&segment.parts.length){segment.parts.forEach(function(p){if(p.resolvedUri){return;}p.resolvedUri=video_es_resolveUrl(baseUri,p.uri);});}if(segment.preloadHints&&segment.preloadHints.length){segment.preloadHints.forEach(function(p){if(p.resolvedUri){return;}p.resolvedUri=video_es_resolveUrl(baseUri,p.uri);});}};var getAllSegments=function getAllSegments(media){var segments=media.segments||[];var preloadSegment=media.preloadSegment;// a preloadSegment with only preloadHints is not currently
// a usable segment, only include a preloadSegment that has
// parts.
if(preloadSegment&&preloadSegment.parts&&preloadSegment.parts.length){// if preloadHints has a MAP that means that the
// init segment is going to change. We cannot use any of the parts
// from this preload segment.
if(preloadSegment.preloadHints){for(var i=0;i<preloadSegment.preloadHints.length;i++){if(preloadSegment.preloadHints[i].type==='MAP'){return segments;}}}// set the duration for our preload segment to target duration.
preloadSegment.duration=media.targetDuration;preloadSegment.preload=true;segments.push(preloadSegment);}return segments;};// consider the playlist unchanged if the playlist object is the same or
// the number of segments is equal, the media sequence number is unchanged,
// and this playlist hasn't become the end of the playlist
var isPlaylistUnchanged=function isPlaylistUnchanged(a,b){return a===b||a.segments&&b.segments&&a.segments.length===b.segments.length&&a.endList===b.endList&&a.mediaSequence===b.mediaSequence&&a.preloadSegment===b.preloadSegment;};/**
  * Returns a new master playlist that is the result of merging an
  * updated media playlist into the original version. If the
  * updated media playlist does not match any of the playlist
  * entries in the original master playlist, null is returned.
  *
  * @param {Object} master a parsed master M3U8 object
  * @param {Object} media a parsed media M3U8 object
  * @return {Object} a new object that represents the original
  * master playlist with the updated media playlist merged in, or
  * null if the merge produced no change.
  */var updateMaster$1=function updateMaster(master,newMedia,unchangedCheck){if(unchangedCheck===void 0){unchangedCheck=isPlaylistUnchanged;}var result=mergeOptions$2(master,{});var oldMedia=result.playlists[newMedia.id];if(!oldMedia){return null;}if(unchangedCheck(oldMedia,newMedia)){return null;}newMedia.segments=getAllSegments(newMedia);var mergedPlaylist=mergeOptions$2(oldMedia,newMedia);// always use the new media's preload segment
if(mergedPlaylist.preloadSegment&&!newMedia.preloadSegment){delete mergedPlaylist.preloadSegment;}// if the update could overlap existing segment information, merge the two segment lists
if(oldMedia.segments){if(newMedia.skip){newMedia.segments=newMedia.segments||[];// add back in objects for skipped segments, so that we merge
// old properties into the new segments
for(var i=0;i<newMedia.skip.skippedSegments;i++){newMedia.segments.unshift({skipped:true});}}mergedPlaylist.segments=updateSegments(oldMedia.segments,newMedia.segments,newMedia.mediaSequence-oldMedia.mediaSequence);}// resolve any segment URIs to prevent us from having to do it later
mergedPlaylist.segments.forEach(function(segment){resolveSegmentUris(segment,mergedPlaylist.resolvedUri);});// TODO Right now in the playlists array there are two references to each playlist, one
// that is referenced by index, and one by URI. The index reference may no longer be
// necessary.
for(var _i=0;_i<result.playlists.length;_i++){if(result.playlists[_i].id===newMedia.id){result.playlists[_i]=mergedPlaylist;}}result.playlists[newMedia.id]=mergedPlaylist;// URI reference added for backwards compatibility
result.playlists[newMedia.uri]=mergedPlaylist;// update media group playlist references.
video_es_forEachMediaGroup(master,function(properties,mediaType,groupKey,labelKey){if(!properties.playlists){return;}for(var _i2=0;_i2<properties.playlists.length;_i2++){if(newMedia.id===properties.playlists[_i2].id){properties.playlists[_i2]=mergedPlaylist;}}});return result;};/**
 * Calculates the time to wait before refreshing a live playlist
 *
 * @param {Object} media
 *        The current media
 * @param {boolean} update
 *        True if there were any updates from the last refresh, false otherwise
 * @return {number}
 *         The time in ms to wait before refreshing the live playlist
 */var refreshDelay=function refreshDelay(media,update){var segments=media.segments||[];var lastSegment=segments[segments.length-1];var lastPart=lastSegment&&lastSegment.parts&&lastSegment.parts[lastSegment.parts.length-1];var lastDuration=lastPart&&lastPart.duration||lastSegment&&lastSegment.duration;if(update&&lastDuration){return lastDuration*1000;}// if the playlist is unchanged since the last reload or last segment duration
// cannot be determined, try again after half the target duration
return(media.partTargetDuration||media.targetDuration||10)*500;};/**
 * Load a playlist from a remote location
 *
 * @class PlaylistLoader
 * @extends Stream
 * @param {string|Object} src url or object of manifest
 * @param {boolean} withCredentials the withCredentials xhr option
 * @class
 */var PlaylistLoader=/*#__PURE__*/function(_EventTarget){_inheritsLoose(PlaylistLoader,_EventTarget);function PlaylistLoader(src,vhs,options){var _this;if(options===void 0){options={};}_this=_EventTarget.call(this)||this;if(!src){throw new Error('A non-empty playlist URL or object is required');}_this.logger_=logger('PlaylistLoader');var _options=options,_options$withCredenti=_options.withCredentials,withCredentials=_options$withCredenti===void 0?false:_options$withCredenti,_options$handleManife=_options.handleManifestRedirects,handleManifestRedirects=_options$handleManife===void 0?false:_options$handleManife;_this.src=src;_this.vhs_=vhs;_this.withCredentials=withCredentials;_this.handleManifestRedirects=handleManifestRedirects;var vhsOptions=vhs.options_;_this.customTagParsers=vhsOptions&&vhsOptions.customTagParsers||[];_this.customTagMappers=vhsOptions&&vhsOptions.customTagMappers||[];_this.experimentalLLHLS=vhsOptions&&vhsOptions.experimentalLLHLS||false;// force experimentalLLHLS for IE 11
if(videojs.browser.IE_VERSION){_this.experimentalLLHLS=false;}// initialize the loader state
_this.state='HAVE_NOTHING';// live playlist staleness timeout
_this.handleMediaupdatetimeout_=_this.handleMediaupdatetimeout_.bind(_assertThisInitialized(_this));_this.on('mediaupdatetimeout',_this.handleMediaupdatetimeout_);return _this;}var _proto=PlaylistLoader.prototype;_proto.handleMediaupdatetimeout_=function handleMediaupdatetimeout_(){var _this2=this;if(this.state!=='HAVE_METADATA'){// only refresh the media playlist if no other activity is going on
return;}var media=this.media();var uri=video_es_resolveUrl(this.master.uri,media.uri);if(this.experimentalLLHLS){uri=addLLHLSQueryDirectives(uri,media);}this.state='HAVE_CURRENT_METADATA';this.request=this.vhs_.xhr({uri:uri,withCredentials:this.withCredentials},function(error,req){// disposed
if(!_this2.request){return;}if(error){return _this2.playlistRequestError(_this2.request,_this2.media(),'HAVE_METADATA');}_this2.haveMetadata({playlistString:_this2.request.responseText,url:_this2.media().uri,id:_this2.media().id});});};_proto.playlistRequestError=function playlistRequestError(xhr,playlist,startingState){var uri=playlist.uri,id=playlist.id;// any in-flight request is now finished
this.request=null;if(startingState){this.state=startingState;}this.error={playlist:this.master.playlists[id],status:xhr.status,message:"HLS playlist request error at URL: "+uri+".",responseText:xhr.responseText,code:xhr.status>=500?4:2};this.trigger('error');};_proto.parseManifest_=function parseManifest_(_ref){var _this3=this;var url=_ref.url,manifestString=_ref.manifestString;return parseManifest({onwarn:function onwarn(_ref2){var message=_ref2.message;return _this3.logger_("m3u8-parser warn for "+url+": "+message);},oninfo:function oninfo(_ref3){var message=_ref3.message;return _this3.logger_("m3u8-parser info for "+url+": "+message);},manifestString:manifestString,customTagParsers:this.customTagParsers,customTagMappers:this.customTagMappers,experimentalLLHLS:this.experimentalLLHLS});}/**
   * Update the playlist loader's state in response to a new or updated playlist.
   *
   * @param {string} [playlistString]
   *        Playlist string (if playlistObject is not provided)
   * @param {Object} [playlistObject]
   *        Playlist object (if playlistString is not provided)
   * @param {string} url
   *        URL of playlist
   * @param {string} id
   *        ID to use for playlist
   */;_proto.haveMetadata=function haveMetadata(_ref4){var playlistString=_ref4.playlistString,playlistObject=_ref4.playlistObject,url=_ref4.url,id=_ref4.id;// any in-flight request is now finished
this.request=null;this.state='HAVE_METADATA';var playlist=playlistObject||this.parseManifest_({url:url,manifestString:playlistString});playlist.lastRequest=Date.now();setupMediaPlaylist({playlist:playlist,uri:url,id:id});// merge this playlist into the master
var update=updateMaster$1(this.master,playlist);this.targetDuration=playlist.partTargetDuration||playlist.targetDuration;this.pendingMedia_=null;if(update){this.master=update;this.media_=this.master.playlists[id];}else{this.trigger('playlistunchanged');}this.updateMediaUpdateTimeout_(refreshDelay(this.media(),!!update));this.trigger('loadedplaylist');}/**
    * Abort any outstanding work and clean up.
    */;_proto.dispose=function dispose(){this.trigger('dispose');this.stopRequest();window_default().clearTimeout(this.mediaUpdateTimeout);window_default().clearTimeout(this.finalRenditionTimeout);this.off();};_proto.stopRequest=function stopRequest(){if(this.request){var oldRequest=this.request;this.request=null;oldRequest.onreadystatechange=null;oldRequest.abort();}}/**
    * When called without any arguments, returns the currently
    * active media playlist. When called with a single argument,
    * triggers the playlist loader to asynchronously switch to the
    * specified media playlist. Calling this method while the
    * loader is in the HAVE_NOTHING causes an error to be emitted
    * but otherwise has no effect.
    *
    * @param {Object=} playlist the parsed media playlist
    * object to switch to
    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
    *
    * @return {Playlist} the current loaded media
    */;_proto.media=function media(playlist,shouldDelay){var _this4=this;// getter
if(!playlist){return this.media_;}// setter
if(this.state==='HAVE_NOTHING'){throw new Error('Cannot switch media playlist from '+this.state);}// find the playlist object if the target playlist has been
// specified by URI
if(typeof playlist==='string'){if(!this.master.playlists[playlist]){throw new Error('Unknown playlist URI: '+playlist);}playlist=this.master.playlists[playlist];}window_default().clearTimeout(this.finalRenditionTimeout);if(shouldDelay){var delay=(playlist.partTargetDuration||playlist.targetDuration)/2*1000||5*1000;this.finalRenditionTimeout=window_default().setTimeout(this.media.bind(this,playlist,false),delay);return;}var startingState=this.state;var mediaChange=!this.media_||playlist.id!==this.media_.id;var masterPlaylistRef=this.master.playlists[playlist.id];// switch to fully loaded playlists immediately
if(masterPlaylistRef&&masterPlaylistRef.endList||// handle the case of a playlist object (e.g., if using vhs-json with a resolved
// media playlist or, for the case of demuxed audio, a resolved audio media group)
playlist.endList&&playlist.segments.length){// abort outstanding playlist requests
if(this.request){this.request.onreadystatechange=null;this.request.abort();this.request=null;}this.state='HAVE_METADATA';this.media_=playlist;// trigger media change if the active media has been updated
if(mediaChange){this.trigger('mediachanging');if(startingState==='HAVE_MASTER'){// The initial playlist was a master manifest, and the first media selected was
// also provided (in the form of a resolved playlist object) as part of the
// source object (rather than just a URL). Therefore, since the media playlist
// doesn't need to be requested, loadedmetadata won't trigger as part of the
// normal flow, and needs an explicit trigger here.
this.trigger('loadedmetadata');}else{this.trigger('mediachange');}}return;}// We update/set the timeout here so that live playlists
// that are not a media change will "start" the loader as expected.
// We expect that this function will start the media update timeout
// cycle again. This also prevents a playlist switch failure from
// causing us to stall during live.
this.updateMediaUpdateTimeout_(refreshDelay(playlist,true));// switching to the active playlist is a no-op
if(!mediaChange){return;}this.state='SWITCHING_MEDIA';// there is already an outstanding playlist request
if(this.request){if(playlist.resolvedUri===this.request.url){// requesting to switch to the same playlist multiple times
// has no effect after the first
return;}this.request.onreadystatechange=null;this.request.abort();this.request=null;}// request the new playlist
if(this.media_){this.trigger('mediachanging');}this.pendingMedia_=playlist;this.request=this.vhs_.xhr({uri:playlist.resolvedUri,withCredentials:this.withCredentials},function(error,req){// disposed
if(!_this4.request){return;}playlist.lastRequest=Date.now();playlist.resolvedUri=resolveManifestRedirect(_this4.handleManifestRedirects,playlist.resolvedUri,req);if(error){return _this4.playlistRequestError(_this4.request,playlist,startingState);}_this4.haveMetadata({playlistString:req.responseText,url:playlist.uri,id:playlist.id});// fire loadedmetadata the first time a media playlist is loaded
if(startingState==='HAVE_MASTER'){_this4.trigger('loadedmetadata');}else{_this4.trigger('mediachange');}});}/**
   * pause loading of the playlist
   */;_proto.pause=function pause(){if(this.mediaUpdateTimeout){window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;}this.stopRequest();if(this.state==='HAVE_NOTHING'){// If we pause the loader before any data has been retrieved, its as if we never
// started, so reset to an unstarted state.
this.started=false;}// Need to restore state now that no activity is happening
if(this.state==='SWITCHING_MEDIA'){// if the loader was in the process of switching media, it should either return to
// HAVE_MASTER or HAVE_METADATA depending on if the loader has loaded a media
// playlist yet. This is determined by the existence of loader.media_
if(this.media_){this.state='HAVE_METADATA';}else{this.state='HAVE_MASTER';}}else if(this.state==='HAVE_CURRENT_METADATA'){this.state='HAVE_METADATA';}}/**
   * start loading of the playlist
   */;_proto.load=function load(shouldDelay){var _this5=this;if(this.mediaUpdateTimeout){window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;}var media=this.media();if(shouldDelay){var delay=media?(media.partTargetDuration||media.targetDuration)/2*1000:5*1000;this.mediaUpdateTimeout=window_default().setTimeout(function(){_this5.mediaUpdateTimeout=null;_this5.load();},delay);return;}if(!this.started){this.start();return;}if(media&&!media.endList){this.trigger('mediaupdatetimeout');}else{this.trigger('loadedplaylist');}};_proto.updateMediaUpdateTimeout_=function updateMediaUpdateTimeout_(delay){var _this6=this;if(this.mediaUpdateTimeout){window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;}// we only have use mediaupdatetimeout for live playlists.
if(!this.media()||this.media().endList){return;}this.mediaUpdateTimeout=window_default().setTimeout(function(){_this6.mediaUpdateTimeout=null;_this6.trigger('mediaupdatetimeout');_this6.updateMediaUpdateTimeout_(delay);},delay);}/**
   * start loading of the playlist
   */;_proto.start=function start(){var _this7=this;this.started=true;if(video_es_typeof(this.src)==='object'){// in the case of an entirely constructed manifest object (meaning there's no actual
// manifest on a server), default the uri to the page's href
if(!this.src.uri){this.src.uri=(window_default()).location.href;}// resolvedUri is added on internally after the initial request. Since there's no
// request for pre-resolved manifests, add on resolvedUri here.
this.src.resolvedUri=this.src.uri;// Since a manifest object was passed in as the source (instead of a URL), the first
// request can be skipped (since the top level of the manifest, at a minimum, is
// already available as a parsed manifest object). However, if the manifest object
// represents a master playlist, some media playlists may need to be resolved before
// the starting segment list is available. Therefore, go directly to setup of the
// initial playlist, and let the normal flow continue from there.
//
// Note that the call to setup is asynchronous, as other sections of VHS may assume
// that the first request is asynchronous.
setTimeout(function(){_this7.setupInitialPlaylist(_this7.src);},0);return;}// request the specified URL
this.request=this.vhs_.xhr({uri:this.src,withCredentials:this.withCredentials},function(error,req){// disposed
if(!_this7.request){return;}// clear the loader's request reference
_this7.request=null;if(error){_this7.error={status:req.status,message:"HLS playlist request error at URL: "+_this7.src+".",responseText:req.responseText,// MEDIA_ERR_NETWORK
code:2};if(_this7.state==='HAVE_NOTHING'){_this7.started=false;}return _this7.trigger('error');}_this7.src=resolveManifestRedirect(_this7.handleManifestRedirects,_this7.src,req);var manifest=_this7.parseManifest_({manifestString:req.responseText,url:_this7.src});_this7.setupInitialPlaylist(manifest);});};_proto.srcUri=function srcUri(){return typeof this.src==='string'?this.src:this.src.uri;}/**
   * Given a manifest object that's either a master or media playlist, trigger the proper
   * events and set the state of the playlist loader.
   *
   * If the manifest object represents a master playlist, `loadedplaylist` will be
   * triggered to allow listeners to select a playlist. If none is selected, the loader
   * will default to the first one in the playlists array.
   *
   * If the manifest object represents a media playlist, `loadedplaylist` will be
   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
   *
   * In the case of a media playlist, a master playlist object wrapper with one playlist
   * will be created so that all logic can handle playlists in the same fashion (as an
   * assumed manifest object schema).
   *
   * @param {Object} manifest
   *        The parsed manifest object
   */;_proto.setupInitialPlaylist=function setupInitialPlaylist(manifest){this.state='HAVE_MASTER';if(manifest.playlists){this.master=manifest;addPropertiesToMaster(this.master,this.srcUri());// If the initial master playlist has playlists wtih segments already resolved,
// then resolve URIs in advance, as they are usually done after a playlist request,
// which may not happen if the playlist is resolved.
manifest.playlists.forEach(function(playlist){playlist.segments=getAllSegments(playlist);playlist.segments.forEach(function(segment){resolveSegmentUris(segment,playlist.resolvedUri);});});this.trigger('loadedplaylist');if(!this.request){// no media playlist was specifically selected so start
// from the first listed one
this.media(this.master.playlists[0]);}return;}// In order to support media playlists passed in as vhs-json, the case where the uri
// is not provided as part of the manifest should be considered, and an appropriate
// default used.
var uri=this.srcUri()||(window_default()).location.href;this.master=masterForMedia(manifest,uri);this.haveMetadata({playlistObject:manifest,url:uri,id:this.master.playlists[0].id});this.trigger('loadedmetadata');};return PlaylistLoader;}(EventTarget$1);/**
 * @file xhr.js
 */var videojsXHR=videojs.xhr,mergeOptions$1=videojs.mergeOptions;var callbackWrapper=function callbackWrapper(request,error,response,callback){var reqResponse=request.responseType==='arraybuffer'?request.response:request.responseText;if(!error&&reqResponse){request.responseTime=Date.now();request.roundTripTime=request.responseTime-request.requestTime;request.bytesReceived=reqResponse.byteLength||reqResponse.length;if(!request.bandwidth){request.bandwidth=Math.floor(request.bytesReceived/request.roundTripTime*8*1000);}}if(response.headers){request.responseHeaders=response.headers;}// videojs.xhr now uses a specific code on the error
// object to signal that a request has timed out instead
// of setting a boolean on the request object
if(error&&error.code==='ETIMEDOUT'){request.timedout=true;}// videojs.xhr no longer considers status codes outside of 200 and 0
// (for file uris) to be errors, but the old XHR did, so emulate that
// behavior. Status 206 may be used in response to byterange requests.
if(!error&&!request.aborted&&response.statusCode!==200&&response.statusCode!==206&&response.statusCode!==0){error=new Error('XHR Failed with a response of: '+(request&&(reqResponse||request.responseText)));}callback(error,request);};var xhrFactory=function xhrFactory(){var xhr=function XhrFunction(options,callback){// Add a default timeout
options=mergeOptions$1({timeout:45e3},options);// Allow an optional user-specified function to modify the option
// object before we construct the xhr request
var beforeRequest=XhrFunction.beforeRequest||videojs.Vhs.xhr.beforeRequest;if(beforeRequest&&typeof beforeRequest==='function'){var newOptions=beforeRequest(options);if(newOptions){options=newOptions;}}// Use the standard videojs.xhr() method unless `videojs.Vhs.xhr` has been overriden
// TODO: switch back to videojs.Vhs.xhr.name === 'XhrFunction' when we drop IE11
var xhrMethod=videojs.Vhs.xhr.original===true?videojsXHR:videojs.Vhs.xhr;var request=xhrMethod(options,function(error,response){return callbackWrapper(request,error,response,callback);});var originalAbort=request.abort;request.abort=function(){request.aborted=true;return originalAbort.apply(request,arguments);};request.uri=options.uri;request.requestTime=Date.now();return request;};xhr.original=true;return xhr;};/**
 * Turns segment byterange into a string suitable for use in
 * HTTP Range requests
 *
 * @param {Object} byterange - an object with two values defining the start and end
 *                             of a byte-range
 */var byterangeStr=function byterangeStr(byterange){// `byterangeEnd` is one less than `offset + length` because the HTTP range
// header uses inclusive ranges
var byterangeEnd;var byterangeStart=byterange.offset;if(typeof byterange.offset==='bigint'||typeof byterange.length==='bigint'){byterangeEnd=window_default().BigInt(byterange.offset)+window_default().BigInt(byterange.length)-window_default().BigInt(1);}else{byterangeEnd=byterange.offset+byterange.length-1;}return'bytes='+byterangeStart+'-'+byterangeEnd;};/**
 * Defines headers for use in the xhr request for a particular segment.
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 */var segmentXhrHeaders=function segmentXhrHeaders(segment){var headers={};if(segment.byterange){headers.Range=byterangeStr(segment.byterange);}return headers;};/**
 * @file bin-utils.js
 */ /**
 * convert a TimeRange to text
 *
 * @param {TimeRange} range the timerange to use for conversion
 * @param {number} i the iterator on the range to convert
 * @return {string} the range in string format
 */var textRange=function textRange(range,i){return range.start(i)+'-'+range.end(i);};/**
 * format a number as hex string
 *
 * @param {number} e The number
 * @param {number} i the iterator
 * @return {string} the hex formatted number as a string
 */var formatHexString=function formatHexString(e,i){var value=e.toString(16);return'00'.substring(0,2-value.length)+value+(i%2?' ':'');};var formatAsciiString=function formatAsciiString(e){if(e>=0x20&&e<0x7e){return String.fromCharCode(e);}return'.';};/**
 * Creates an object for sending to a web worker modifying properties that are TypedArrays
 * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
 *
 * @param {Object} message
 *        Object of properties and values to send to the web worker
 * @return {Object}
 *         Modified message with TypedArray values expanded
 * @function createTransferableMessage
 */var createTransferableMessage=function createTransferableMessage(message){var transferable={};Object.keys(message).forEach(function(key){var value=message[key];if(isArrayBufferView(value)){transferable[key]={bytes:value.buffer,byteOffset:value.byteOffset,byteLength:value.byteLength};}else{transferable[key]=value;}});return transferable;};/**
 * Returns a unique string identifier for a media initialization
 * segment.
 *
 * @param {Object} initSegment
 *        the init segment object.
 *
 * @return {string} the generated init segment id
 */var initSegmentId=function initSegmentId(initSegment){var byterange=initSegment.byterange||{length:Infinity,offset:0};return[byterange.length,byterange.offset,initSegment.resolvedUri].join(',');};/**
 * Returns a unique string identifier for a media segment key.
 *
 * @param {Object} key the encryption key
 * @return {string} the unique id for the media segment key.
 */var segmentKeyId=function segmentKeyId(key){return key.resolvedUri;};/**
 * utils to help dump binary data to the console
 *
 * @param {Array|TypedArray} data
 *        data to dump to a string
 *
 * @return {string} the data as a hex string.
 */var hexDump=function hexDump(data){var bytes=Array.prototype.slice.call(data);var step=16;var result='';var hex;var ascii;for(var j=0;j<bytes.length/step;j++){hex=bytes.slice(j*step,j*step+step).map(formatHexString).join('');ascii=bytes.slice(j*step,j*step+step).map(formatAsciiString).join('');result+=hex+' '+ascii+'\n';}return result;};var tagDump=function tagDump(_ref){var bytes=_ref.bytes;return hexDump(bytes);};var textRanges=function textRanges(ranges){var result='';var i;for(i=0;i<ranges.length;i++){result+=textRange(ranges,i)+' ';}return result;};var utils=/*#__PURE__*/Object.freeze({__proto__:null,createTransferableMessage:createTransferableMessage,initSegmentId:initSegmentId,segmentKeyId:segmentKeyId,hexDump:hexDump,tagDump:tagDump,textRanges:textRanges});// TODO handle fmp4 case where the timing info is accurate and doesn't involve transmux
// 25% was arbitrarily chosen, and may need to be refined over time.
var SEGMENT_END_FUDGE_PERCENT=0.25;/**
 * Converts a player time (any time that can be gotten/set from player.currentTime(),
 * e.g., any time within player.seekable().start(0) to player.seekable().end(0)) to a
 * program time (any time referencing the real world (e.g., EXT-X-PROGRAM-DATE-TIME)).
 *
 * The containing segment is required as the EXT-X-PROGRAM-DATE-TIME serves as an "anchor
 * point" (a point where we have a mapping from program time to player time, with player
 * time being the post transmux start of the segment).
 *
 * For more details, see [this doc](../../docs/program-time-from-player-time.md).
 *
 * @param {number} playerTime the player time
 * @param {Object} segment the segment which contains the player time
 * @return {Date} program time
 */var playerTimeToProgramTime=function playerTimeToProgramTime(playerTime,segment){if(!segment.dateTimeObject){// Can't convert without an "anchor point" for the program time (i.e., a time that can
// be used to map the start of a segment with a real world time).
return null;}var transmuxerPrependedSeconds=segment.videoTimingInfo.transmuxerPrependedSeconds;var transmuxedStart=segment.videoTimingInfo.transmuxedPresentationStart;// get the start of the content from before old content is prepended
var startOfSegment=transmuxedStart+transmuxerPrependedSeconds;var offsetFromSegmentStart=playerTime-startOfSegment;return new Date(segment.dateTimeObject.getTime()+offsetFromSegmentStart*1000);};var originalSegmentVideoDuration=function originalSegmentVideoDuration(videoTimingInfo){return videoTimingInfo.transmuxedPresentationEnd-videoTimingInfo.transmuxedPresentationStart-videoTimingInfo.transmuxerPrependedSeconds;};/**
 * Finds a segment that contains the time requested given as an ISO-8601 string. The
 * returned segment might be an estimate or an accurate match.
 *
 * @param {string} programTime The ISO-8601 programTime to find a match for
 * @param {Object} playlist A playlist object to search within
 */var findSegmentForProgramTime=function findSegmentForProgramTime(programTime,playlist){// Assumptions:
//  - verifyProgramDateTimeTags has already been run
//  - live streams have been started
var dateTimeObject;try{dateTimeObject=new Date(programTime);}catch(e){return null;}if(!playlist||!playlist.segments||playlist.segments.length===0){return null;}var segment=playlist.segments[0];if(dateTimeObject<segment.dateTimeObject){// Requested time is before stream start.
return null;}for(var i=0;i<playlist.segments.length-1;i++){segment=playlist.segments[i];var nextSegmentStart=playlist.segments[i+1].dateTimeObject;if(dateTimeObject<nextSegmentStart){break;}}var lastSegment=playlist.segments[playlist.segments.length-1];var lastSegmentStart=lastSegment.dateTimeObject;var lastSegmentDuration=lastSegment.videoTimingInfo?originalSegmentVideoDuration(lastSegment.videoTimingInfo):lastSegment.duration+lastSegment.duration*SEGMENT_END_FUDGE_PERCENT;var lastSegmentEnd=new Date(lastSegmentStart.getTime()+lastSegmentDuration*1000);if(dateTimeObject>lastSegmentEnd){// Beyond the end of the stream, or our best guess of the end of the stream.
return null;}if(dateTimeObject>lastSegmentStart){segment=lastSegment;}return{segment:segment,estimatedStart:segment.videoTimingInfo?segment.videoTimingInfo.transmuxedPresentationStart:Playlist.duration(playlist,playlist.mediaSequence+playlist.segments.indexOf(segment)),// Although, given that all segments have accurate date time objects, the segment
// selected should be accurate, unless the video has been transmuxed at some point
// (determined by the presence of the videoTimingInfo object), the segment's "player
// time" (the start time in the player) can't be considered accurate.
type:segment.videoTimingInfo?'accurate':'estimate'};};/**
 * Finds a segment that contains the given player time(in seconds).
 *
 * @param {number} time The player time to find a match for
 * @param {Object} playlist A playlist object to search within
 */var findSegmentForPlayerTime=function findSegmentForPlayerTime(time,playlist){// Assumptions:
// - there will always be a segment.duration
// - we can start from zero
// - segments are in time order
if(!playlist||!playlist.segments||playlist.segments.length===0){return null;}var segmentEnd=0;var segment;for(var i=0;i<playlist.segments.length;i++){segment=playlist.segments[i];// videoTimingInfo is set after the segment is downloaded and transmuxed, and
// should contain the most accurate values we have for the segment's player times.
//
// Use the accurate transmuxedPresentationEnd value if it is available, otherwise fall
// back to an estimate based on the manifest derived (inaccurate) segment.duration, to
// calculate an end value.
segmentEnd=segment.videoTimingInfo?segment.videoTimingInfo.transmuxedPresentationEnd:segmentEnd+segment.duration;if(time<=segmentEnd){break;}}var lastSegment=playlist.segments[playlist.segments.length-1];if(lastSegment.videoTimingInfo&&lastSegment.videoTimingInfo.transmuxedPresentationEnd<time){// The time requested is beyond the stream end.
return null;}if(time>segmentEnd){// The time is within or beyond the last segment.
//
// Check to see if the time is beyond a reasonable guess of the end of the stream.
if(time>segmentEnd+lastSegment.duration*SEGMENT_END_FUDGE_PERCENT){// Technically, because the duration value is only an estimate, the time may still
// exist in the last segment, however, there isn't enough information to make even
// a reasonable estimate.
return null;}segment=lastSegment;}return{segment:segment,estimatedStart:segment.videoTimingInfo?segment.videoTimingInfo.transmuxedPresentationStart:segmentEnd-segment.duration,// Because videoTimingInfo is only set after transmux, it is the only way to get
// accurate timing values.
type:segment.videoTimingInfo?'accurate':'estimate'};};/**
 * Gives the offset of the comparisonTimestamp from the programTime timestamp in seconds.
 * If the offset returned is positive, the programTime occurs after the
 * comparisonTimestamp.
 * If the offset is negative, the programTime occurs before the comparisonTimestamp.
 *
 * @param {string} comparisonTimeStamp An ISO-8601 timestamp to compare against
 * @param {string} programTime The programTime as an ISO-8601 string
 * @return {number} offset
 */var getOffsetFromTimestamp=function getOffsetFromTimestamp(comparisonTimeStamp,programTime){var segmentDateTime;var programDateTime;try{segmentDateTime=new Date(comparisonTimeStamp);programDateTime=new Date(programTime);}catch(e){// TODO handle error
}var segmentTimeEpoch=segmentDateTime.getTime();var programTimeEpoch=programDateTime.getTime();return(programTimeEpoch-segmentTimeEpoch)/1000;};/**
 * Checks that all segments in this playlist have programDateTime tags.
 *
 * @param {Object} playlist A playlist object
 */var verifyProgramDateTimeTags=function verifyProgramDateTimeTags(playlist){if(!playlist.segments||playlist.segments.length===0){return false;}for(var i=0;i<playlist.segments.length;i++){var segment=playlist.segments[i];if(!segment.dateTimeObject){return false;}}return true;};/**
 * Returns the programTime of the media given a playlist and a playerTime.
 * The playlist must have programDateTime tags for a programDateTime tag to be returned.
 * If the segments containing the time requested have not been buffered yet, an estimate
 * may be returned to the callback.
 *
 * @param {Object} args
 * @param {Object} args.playlist A playlist object to search within
 * @param {number} time A playerTime in seconds
 * @param {Function} callback(err, programTime)
 * @return {string} err.message A detailed error message
 * @return {Object} programTime
 * @return {number} programTime.mediaSeconds The streamTime in seconds
 * @return {string} programTime.programDateTime The programTime as an ISO-8601 String
 */var getProgramTime=function getProgramTime(_ref){var playlist=_ref.playlist,_ref$time=_ref.time,time=_ref$time===void 0?undefined:_ref$time,callback=_ref.callback;if(!callback){throw new Error('getProgramTime: callback must be provided');}if(!playlist||time===undefined){return callback({message:'getProgramTime: playlist and time must be provided'});}var matchedSegment=findSegmentForPlayerTime(time,playlist);if(!matchedSegment){return callback({message:'valid programTime was not found'});}if(matchedSegment.type==='estimate'){return callback({message:'Accurate programTime could not be determined.'+' Please seek to e.seekTime and try again',seekTime:matchedSegment.estimatedStart});}var programTimeObject={mediaSeconds:time};var programTime=playerTimeToProgramTime(time,matchedSegment.segment);if(programTime){programTimeObject.programDateTime=programTime.toISOString();}return callback(null,programTimeObject);};/**
 * Seeks in the player to a time that matches the given programTime ISO-8601 string.
 *
 * @param {Object} args
 * @param {string} args.programTime A programTime to seek to as an ISO-8601 String
 * @param {Object} args.playlist A playlist to look within
 * @param {number} args.retryCount The number of times to try for an accurate seek. Default is 2.
 * @param {Function} args.seekTo A method to perform a seek
 * @param {boolean} args.pauseAfterSeek Whether to end in a paused state after seeking. Default is true.
 * @param {Object} args.tech The tech to seek on
 * @param {Function} args.callback(err, newTime) A callback to return the new time to
 * @return {string} err.message A detailed error message
 * @return {number} newTime The exact time that was seeked to in seconds
 */var seekToProgramTime=function seekToProgramTime(_ref2){var programTime=_ref2.programTime,playlist=_ref2.playlist,_ref2$retryCount=_ref2.retryCount,retryCount=_ref2$retryCount===void 0?2:_ref2$retryCount,seekTo=_ref2.seekTo,_ref2$pauseAfterSeek=_ref2.pauseAfterSeek,pauseAfterSeek=_ref2$pauseAfterSeek===void 0?true:_ref2$pauseAfterSeek,tech=_ref2.tech,callback=_ref2.callback;if(!callback){throw new Error('seekToProgramTime: callback must be provided');}if(typeof programTime==='undefined'||!playlist||!seekTo){return callback({message:'seekToProgramTime: programTime, seekTo and playlist must be provided'});}if(!playlist.endList&&!tech.hasStarted_){return callback({message:'player must be playing a live stream to start buffering'});}if(!verifyProgramDateTimeTags(playlist)){return callback({message:'programDateTime tags must be provided in the manifest '+playlist.resolvedUri});}var matchedSegment=findSegmentForProgramTime(programTime,playlist);// no match
if(!matchedSegment){return callback({message:programTime+" was not found in the stream"});}var segment=matchedSegment.segment;var mediaOffset=getOffsetFromTimestamp(segment.dateTimeObject,programTime);if(matchedSegment.type==='estimate'){// we've run out of retries
if(retryCount===0){return callback({message:programTime+" is not buffered yet. Try again"});}seekTo(matchedSegment.estimatedStart+mediaOffset);tech.one('seeked',function(){seekToProgramTime({programTime:programTime,playlist:playlist,retryCount:retryCount-1,seekTo:seekTo,pauseAfterSeek:pauseAfterSeek,tech:tech,callback:callback});});return;}// Since the segment.start value is determined from the buffered end or ending time
// of the prior segment, the seekToTime doesn't need to account for any transmuxer
// modifications.
var seekToTime=segment.start+mediaOffset;var seekedCallback=function seekedCallback(){return callback(null,tech.currentTime());};// listen for seeked event
tech.one('seeked',seekedCallback);// pause before seeking as video.js will restore this state
if(pauseAfterSeek){tech.pause();}seekTo(seekToTime);};// which will only happen if the request is complete.
var callbackOnCompleted=function callbackOnCompleted(request,cb){if(request.readyState===4){return cb();}return;};var containerRequest=function containerRequest(uri,xhr,cb){var bytes=[];var id3Offset;var finished=false;var endRequestAndCallback=function endRequestAndCallback(err,req,type,_bytes){req.abort();finished=true;return cb(err,req,type,_bytes);};var progressListener=function progressListener(error,request){if(finished){return;}if(error){return endRequestAndCallback(error,request,'',bytes);}// grap the new part of content that was just downloaded
var newPart=request.responseText.substring(bytes&&bytes.byteLength||0,request.responseText.length);// add that onto bytes
bytes=concatTypedArrays(bytes,stringToBytes(newPart,true));id3Offset=id3Offset||getId3Offset(bytes);// we need at least 10 bytes to determine a type
// or we need at least two bytes after an id3Offset
if(bytes.length<10||id3Offset&&bytes.length<id3Offset+2){return callbackOnCompleted(request,function(){return endRequestAndCallback(error,request,'',bytes);});}var type=detectContainerForBytes(bytes);// if this looks like a ts segment but we don't have enough data
// to see the second sync byte, wait until we have enough data
// before declaring it ts
if(type==='ts'&&bytes.length<188){return callbackOnCompleted(request,function(){return endRequestAndCallback(error,request,'',bytes);});}// this may be an unsynced ts segment
// wait for 376 bytes before detecting no container
if(!type&&bytes.length<376){return callbackOnCompleted(request,function(){return endRequestAndCallback(error,request,'',bytes);});}return endRequestAndCallback(null,request,type,bytes);};var options={uri:uri,beforeSend:function beforeSend(request){// this forces the browser to pass the bytes to us unprocessed
request.overrideMimeType('text/plain; charset=x-user-defined');request.addEventListener('progress',function(_ref){_ref.total;_ref.loaded;return callbackWrapper(request,null,{statusCode:request.status},progressListener);});}};var request=xhr(options,function(error,response){return callbackWrapper(request,error,response,progressListener);});return request;};var EventTarget=videojs.EventTarget,mergeOptions=videojs.mergeOptions;var dashPlaylistUnchanged=function dashPlaylistUnchanged(a,b){if(!isPlaylistUnchanged(a,b)){return false;}// for dash the above check will often return true in scenarios where
// the playlist actually has changed because mediaSequence isn't a
// dash thing, and we often set it to 1. So if the playlists have the same amount
// of segments we return true.
// So for dash we need to make sure that the underlying segments are different.
// if sidx changed then the playlists are different.
if(a.sidx&&b.sidx&&(a.sidx.offset!==b.sidx.offset||a.sidx.length!==b.sidx.length)){return false;}else if(!a.sidx&&b.sidx||a.sidx&&!b.sidx){return false;}// one or the other does not have segments
// there was a change.
if(a.segments&&!b.segments||!a.segments&&b.segments){return false;}// neither has segments nothing changed
if(!a.segments&&!b.segments){return true;}// check segments themselves
for(var i=0;i<a.segments.length;i++){var aSegment=a.segments[i];var bSegment=b.segments[i];// if uris are different between segments there was a change
if(aSegment.uri!==bSegment.uri){return false;}// neither segment has a byterange, there will be no byterange change.
if(!aSegment.byterange&&!bSegment.byterange){continue;}var aByterange=aSegment.byterange;var bByterange=bSegment.byterange;// if byterange only exists on one of the segments, there was a change.
if(aByterange&&!bByterange||!aByterange&&bByterange){return false;}// if both segments have byterange with different offsets, there was a change.
if(aByterange.offset!==bByterange.offset||aByterange.length!==bByterange.length){return false;}}// if everything was the same with segments, this is the same playlist.
return true;};/**
 * Use the representation IDs from the mpd object to create groupIDs, the NAME is set to mandatory representation
 * ID in the parser. This allows for continuous playout across periods with the same representation IDs
 * (continuous periods as defined in DASH-IF 3.2.12). This is assumed in the mpd-parser as well. If we want to support
 * periods without continuous playback this function may need modification as well as the parser.
 */var dashGroupId=function dashGroupId(type,group,label,playlist){// If the manifest somehow does not have an ID (non-dash compliant), use the label.
var playlistId=playlist.attributes.NAME||label;return"placeholder-uri-"+type+"-"+group+"-"+playlistId;};/**
 * Parses the master XML string and updates playlist URI references.
 *
 * @param {Object} config
 *        Object of arguments
 * @param {string} config.masterXml
 *        The mpd XML
 * @param {string} config.srcUrl
 *        The mpd URL
 * @param {Date} config.clientOffset
 *         A time difference between server and client
 * @param {Object} config.sidxMapping
 *        SIDX mappings for moof/mdat URIs and byte ranges
 * @return {Object}
 *         The parsed mpd manifest object
 */var parseMasterXml=function parseMasterXml(_ref){var masterXml=_ref.masterXml,srcUrl=_ref.srcUrl,clientOffset=_ref.clientOffset,sidxMapping=_ref.sidxMapping,previousManifest=_ref.previousManifest;var manifest=parse(masterXml,{manifestUri:srcUrl,clientOffset:clientOffset,sidxMapping:sidxMapping,previousManifest:previousManifest});addPropertiesToMaster(manifest,srcUrl,dashGroupId);return manifest;};/**
 * Removes any mediaGroup labels that no longer exist in the newMaster
 *
 * @param {Object} update
 *         The previous mpd object being updated
 * @param {Object} newMaster
 *         The new mpd object
 */var removeOldMediaGroupLabels=function removeOldMediaGroupLabels(update,newMaster){video_es_forEachMediaGroup(update,function(properties,type,group,label){if(!(label in newMaster.mediaGroups[type][group])){delete update.mediaGroups[type][group][label];}});};/**
 * Returns a new master manifest that is the result of merging an updated master manifest
 * into the original version.
 *
 * @param {Object} oldMaster
 *        The old parsed mpd object
 * @param {Object} newMaster
 *        The updated parsed mpd object
 * @return {Object}
 *         A new object representing the original master manifest with the updated media
 *         playlists merged in
 */var updateMaster=function updateMaster(oldMaster,newMaster,sidxMapping){var noChanges=true;var update=mergeOptions(oldMaster,{// These are top level properties that can be updated
duration:newMaster.duration,minimumUpdatePeriod:newMaster.minimumUpdatePeriod,timelineStarts:newMaster.timelineStarts});// First update the playlists in playlist list
for(var i=0;i<newMaster.playlists.length;i++){var playlist=newMaster.playlists[i];if(playlist.sidx){var sidxKey=generateSidxKey(playlist.sidx);// add sidx segments to the playlist if we have all the sidx info already
if(sidxMapping&&sidxMapping[sidxKey]&&sidxMapping[sidxKey].sidx){addSidxSegmentsToPlaylist$1(playlist,sidxMapping[sidxKey].sidx,playlist.sidx.resolvedUri);}}var playlistUpdate=updateMaster$1(update,playlist,dashPlaylistUnchanged);if(playlistUpdate){update=playlistUpdate;noChanges=false;}}// Then update media group playlists
video_es_forEachMediaGroup(newMaster,function(properties,type,group,label){if(properties.playlists&&properties.playlists.length){var id=properties.playlists[0].id;var _playlistUpdate=updateMaster$1(update,properties.playlists[0],dashPlaylistUnchanged);if(_playlistUpdate){update=_playlistUpdate;// add new mediaGroup label if it doesn't exist and assign the new mediaGroup.
if(!(label in update.mediaGroups[type][group])){update.mediaGroups[type][group][label]=properties;}// update the playlist reference within media groups
update.mediaGroups[type][group][label].playlists[0]=update.playlists[id];noChanges=false;}}});// remove mediaGroup labels and references that no longer exist in the newMaster
removeOldMediaGroupLabels(update,newMaster);if(newMaster.minimumUpdatePeriod!==oldMaster.minimumUpdatePeriod){noChanges=false;}if(noChanges){return null;}return update;};// SIDX should be equivalent if the URI and byteranges of the SIDX match.
// If the SIDXs have maps, the two maps should match,
// both `a` and `b` missing SIDXs is considered matching.
// If `a` or `b` but not both have a map, they aren't matching.
var equivalentSidx=function equivalentSidx(a,b){var neitherMap=Boolean(!a.map&&!b.map);var equivalentMap=neitherMap||Boolean(a.map&&b.map&&a.map.byterange.offset===b.map.byterange.offset&&a.map.byterange.length===b.map.byterange.length);return equivalentMap&&a.uri===b.uri&&a.byterange.offset===b.byterange.offset&&a.byterange.length===b.byterange.length;};// exported for testing
var compareSidxEntry=function compareSidxEntry(playlists,oldSidxMapping){var newSidxMapping={};for(var id in playlists){var playlist=playlists[id];var currentSidxInfo=playlist.sidx;if(currentSidxInfo){var key=generateSidxKey(currentSidxInfo);if(!oldSidxMapping[key]){break;}var savedSidxInfo=oldSidxMapping[key].sidxInfo;if(equivalentSidx(savedSidxInfo,currentSidxInfo)){newSidxMapping[key]=oldSidxMapping[key];}}}return newSidxMapping;};/**
 *  A function that filters out changed items as they need to be requested separately.
 *
 *  The method is exported for testing
 *
 *  @param {Object} master the parsed mpd XML returned via mpd-parser
 *  @param {Object} oldSidxMapping the SIDX to compare against
 */var filterChangedSidxMappings=function filterChangedSidxMappings(master,oldSidxMapping){var videoSidx=compareSidxEntry(master.playlists,oldSidxMapping);var mediaGroupSidx=videoSidx;video_es_forEachMediaGroup(master,function(properties,mediaType,groupKey,labelKey){if(properties.playlists&&properties.playlists.length){var playlists=properties.playlists;mediaGroupSidx=mergeOptions(mediaGroupSidx,compareSidxEntry(playlists,oldSidxMapping));}});return mediaGroupSidx;};var DashPlaylistLoader=/*#__PURE__*/function(_EventTarget){_inheritsLoose(DashPlaylistLoader,_EventTarget);// DashPlaylistLoader must accept either a src url or a playlist because subsequent
// playlist loader setups from media groups will expect to be able to pass a playlist
// (since there aren't external URLs to media playlists with DASH)
function DashPlaylistLoader(srcUrlOrPlaylist,vhs,options,masterPlaylistLoader){var _this;if(options===void 0){options={};}_this=_EventTarget.call(this)||this;_this.masterPlaylistLoader_=masterPlaylistLoader||_assertThisInitialized(_this);if(!masterPlaylistLoader){_this.isMaster_=true;}var _options=options,_options$withCredenti=_options.withCredentials,withCredentials=_options$withCredenti===void 0?false:_options$withCredenti,_options$handleManife=_options.handleManifestRedirects,handleManifestRedirects=_options$handleManife===void 0?false:_options$handleManife;_this.vhs_=vhs;_this.withCredentials=withCredentials;_this.handleManifestRedirects=handleManifestRedirects;if(!srcUrlOrPlaylist){throw new Error('A non-empty playlist URL or object is required');}// event naming?
_this.on('minimumUpdatePeriod',function(){_this.refreshXml_();});// live playlist staleness timeout
_this.on('mediaupdatetimeout',function(){_this.refreshMedia_(_this.media().id);});_this.state='HAVE_NOTHING';_this.loadedPlaylists_={};_this.logger_=logger('DashPlaylistLoader');// initialize the loader state
// The masterPlaylistLoader will be created with a string
if(_this.isMaster_){_this.masterPlaylistLoader_.srcUrl=srcUrlOrPlaylist;// TODO: reset sidxMapping between period changes
// once multi-period is refactored
_this.masterPlaylistLoader_.sidxMapping_={};}else{_this.childPlaylist_=srcUrlOrPlaylist;}return _this;}var _proto=DashPlaylistLoader.prototype;_proto.requestErrored_=function requestErrored_(err,request,startingState){// disposed
if(!this.request){return true;}// pending request is cleared
this.request=null;if(err){// use the provided error object or create one
// based on the request/response
this.error=video_es_typeof(err)==='object'&&!(err instanceof Error)?err:{status:request.status,message:'DASH request error at URL: '+request.uri,response:request.response,// MEDIA_ERR_NETWORK
code:2};if(startingState){this.state=startingState;}this.trigger('error');return true;}}/**
   * Verify that the container of the sidx segment can be parsed
   * and if it can, get and parse that segment.
   */;_proto.addSidxSegments_=function addSidxSegments_(playlist,startingState,cb){var _this2=this;var sidxKey=playlist.sidx&&generateSidxKey(playlist.sidx);// playlist lacks sidx or sidx segments were added to this playlist already.
if(!playlist.sidx||!sidxKey||this.masterPlaylistLoader_.sidxMapping_[sidxKey]){// keep this function async
this.mediaRequest_=window_default().setTimeout(function(){return cb(false);},0);return;}// resolve the segment URL relative to the playlist
var uri=resolveManifestRedirect(this.handleManifestRedirects,playlist.sidx.resolvedUri);var fin=function fin(err,request){if(_this2.requestErrored_(err,request,startingState)){return;}var sidxMapping=_this2.masterPlaylistLoader_.sidxMapping_;var sidx;try{sidx=parse_sidx_default()(byte_helpers_toUint8(request.response).subarray(8));}catch(e){// sidx parsing failed.
_this2.requestErrored_(e,request,startingState);return;}sidxMapping[sidxKey]={sidxInfo:playlist.sidx,sidx:sidx};addSidxSegmentsToPlaylist$1(playlist,sidx,playlist.sidx.resolvedUri);return cb(true);};this.request=containerRequest(uri,this.vhs_.xhr,function(err,request,container,bytes){if(err){return fin(err,request);}if(!container||container!=='mp4'){return fin({status:request.status,message:"Unsupported "+(container||'unknown')+" container type for sidx segment at URL: "+uri,// response is just bytes in this case
// but we really don't want to return that.
response:'',playlist:playlist,internal:true,blacklistDuration:Infinity,// MEDIA_ERR_NETWORK
code:2},request);}// if we already downloaded the sidx bytes in the container request, use them
var _playlist$sidx$bytera=playlist.sidx.byterange,offset=_playlist$sidx$bytera.offset,length=_playlist$sidx$bytera.length;if(bytes.length>=length+offset){return fin(err,{response:bytes.subarray(offset,offset+length),status:request.status,uri:request.uri});}// otherwise request sidx bytes
_this2.request=_this2.vhs_.xhr({uri:uri,responseType:'arraybuffer',headers:segmentXhrHeaders({byterange:playlist.sidx.byterange})},fin);});};_proto.dispose=function dispose(){this.trigger('dispose');this.stopRequest();this.loadedPlaylists_={};window_default().clearTimeout(this.minimumUpdatePeriodTimeout_);window_default().clearTimeout(this.mediaRequest_);window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;this.mediaRequest_=null;this.minimumUpdatePeriodTimeout_=null;if(this.masterPlaylistLoader_.createMupOnMedia_){this.off('loadedmetadata',this.masterPlaylistLoader_.createMupOnMedia_);this.masterPlaylistLoader_.createMupOnMedia_=null;}this.off();};_proto.hasPendingRequest=function hasPendingRequest(){return this.request||this.mediaRequest_;};_proto.stopRequest=function stopRequest(){if(this.request){var oldRequest=this.request;this.request=null;oldRequest.onreadystatechange=null;oldRequest.abort();}};_proto.media=function media(playlist){var _this3=this;// getter
if(!playlist){return this.media_;}// setter
if(this.state==='HAVE_NOTHING'){throw new Error('Cannot switch media playlist from '+this.state);}var startingState=this.state;// find the playlist object if the target playlist has been specified by URI
if(typeof playlist==='string'){if(!this.masterPlaylistLoader_.master.playlists[playlist]){throw new Error('Unknown playlist URI: '+playlist);}playlist=this.masterPlaylistLoader_.master.playlists[playlist];}var mediaChange=!this.media_||playlist.id!==this.media_.id;// switch to previously loaded playlists immediately
if(mediaChange&&this.loadedPlaylists_[playlist.id]&&this.loadedPlaylists_[playlist.id].endList){this.state='HAVE_METADATA';this.media_=playlist;// trigger media change if the active media has been updated
if(mediaChange){this.trigger('mediachanging');this.trigger('mediachange');}return;}// switching to the active playlist is a no-op
if(!mediaChange){return;}// switching from an already loaded playlist
if(this.media_){this.trigger('mediachanging');}this.addSidxSegments_(playlist,startingState,function(sidxChanged){// everything is ready just continue to haveMetadata
_this3.haveMetadata({startingState:startingState,playlist:playlist});});};_proto.haveMetadata=function haveMetadata(_ref2){var startingState=_ref2.startingState,playlist=_ref2.playlist;this.state='HAVE_METADATA';this.loadedPlaylists_[playlist.id]=playlist;this.mediaRequest_=null;// This will trigger loadedplaylist
this.refreshMedia_(playlist.id);// fire loadedmetadata the first time a media playlist is loaded
// to resolve setup of media groups
if(startingState==='HAVE_MASTER'){this.trigger('loadedmetadata');}else{// trigger media change if the active media has been updated
this.trigger('mediachange');}};_proto.pause=function pause(){if(this.masterPlaylistLoader_.createMupOnMedia_){this.off('loadedmetadata',this.masterPlaylistLoader_.createMupOnMedia_);this.masterPlaylistLoader_.createMupOnMedia_=null;}this.stopRequest();window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;if(this.isMaster_){window_default().clearTimeout(this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_);this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_=null;}if(this.state==='HAVE_NOTHING'){// If we pause the loader before any data has been retrieved, its as if we never
// started, so reset to an unstarted state.
this.started=false;}};_proto.load=function load(isFinalRendition){var _this4=this;window_default().clearTimeout(this.mediaUpdateTimeout);this.mediaUpdateTimeout=null;var media=this.media();if(isFinalRendition){var delay=media?media.targetDuration/2*1000:5*1000;this.mediaUpdateTimeout=window_default().setTimeout(function(){return _this4.load();},delay);return;}// because the playlists are internal to the manifest, load should either load the
// main manifest, or do nothing but trigger an event
if(!this.started){this.start();return;}if(media&&!media.endList){// Check to see if this is the master loader and the MUP was cleared (this happens
// when the loader was paused). `media` should be set at this point since one is always
// set during `start()`.
if(this.isMaster_&&!this.minimumUpdatePeriodTimeout_){// Trigger minimumUpdatePeriod to refresh the master manifest
this.trigger('minimumUpdatePeriod');// Since there was no prior minimumUpdatePeriodTimeout it should be recreated
this.updateMinimumUpdatePeriodTimeout_();}this.trigger('mediaupdatetimeout');}else{this.trigger('loadedplaylist');}};_proto.start=function start(){var _this5=this;this.started=true;// We don't need to request the master manifest again
// Call this asynchronously to match the xhr request behavior below
if(!this.isMaster_){this.mediaRequest_=window_default().setTimeout(function(){return _this5.haveMaster_();},0);return;}this.requestMaster_(function(req,masterChanged){_this5.haveMaster_();if(!_this5.hasPendingRequest()&&!_this5.media_){_this5.media(_this5.masterPlaylistLoader_.master.playlists[0]);}});};_proto.requestMaster_=function requestMaster_(cb){var _this6=this;this.request=this.vhs_.xhr({uri:this.masterPlaylistLoader_.srcUrl,withCredentials:this.withCredentials},function(error,req){if(_this6.requestErrored_(error,req)){if(_this6.state==='HAVE_NOTHING'){_this6.started=false;}return;}var masterChanged=req.responseText!==_this6.masterPlaylistLoader_.masterXml_;_this6.masterPlaylistLoader_.masterXml_=req.responseText;if(req.responseHeaders&&req.responseHeaders.date){_this6.masterLoaded_=Date.parse(req.responseHeaders.date);}else{_this6.masterLoaded_=Date.now();}_this6.masterPlaylistLoader_.srcUrl=resolveManifestRedirect(_this6.handleManifestRedirects,_this6.masterPlaylistLoader_.srcUrl,req);if(masterChanged){_this6.handleMaster_();_this6.syncClientServerClock_(function(){return cb(req,masterChanged);});return;}return cb(req,masterChanged);});}/**
   * Parses the master xml for UTCTiming node to sync the client clock to the server
   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
   *
   * @param {Function} done
   *        Function to call when clock sync has completed
   */;_proto.syncClientServerClock_=function syncClientServerClock_(done){var _this7=this;var utcTiming=parseUTCTiming(this.masterPlaylistLoader_.masterXml_);// No UTCTiming element found in the mpd. Use Date header from mpd request as the
// server clock
if(utcTiming===null){this.masterPlaylistLoader_.clientOffset_=this.masterLoaded_-Date.now();return done();}if(utcTiming.method==='DIRECT'){this.masterPlaylistLoader_.clientOffset_=utcTiming.value-Date.now();return done();}this.request=this.vhs_.xhr({uri:video_es_resolveUrl(this.masterPlaylistLoader_.srcUrl,utcTiming.value),method:utcTiming.method,withCredentials:this.withCredentials},function(error,req){// disposed
if(!_this7.request){return;}if(error){// sync request failed, fall back to using date header from mpd
// TODO: log warning
_this7.masterPlaylistLoader_.clientOffset_=_this7.masterLoaded_-Date.now();return done();}var serverTime;if(utcTiming.method==='HEAD'){if(!req.responseHeaders||!req.responseHeaders.date){// expected date header not preset, fall back to using date header from mpd
// TODO: log warning
serverTime=_this7.masterLoaded_;}else{serverTime=Date.parse(req.responseHeaders.date);}}else{serverTime=Date.parse(req.responseText);}_this7.masterPlaylistLoader_.clientOffset_=serverTime-Date.now();done();});};_proto.haveMaster_=function haveMaster_(){this.state='HAVE_MASTER';if(this.isMaster_){// We have the master playlist at this point, so
// trigger this to allow MasterPlaylistController
// to make an initial playlist selection
this.trigger('loadedplaylist');}else if(!this.media_){// no media playlist was specifically selected so select
// the one the child playlist loader was created with
this.media(this.childPlaylist_);}};_proto.handleMaster_=function handleMaster_(){// clear media request
this.mediaRequest_=null;var oldMaster=this.masterPlaylistLoader_.master;var newMaster=parseMasterXml({masterXml:this.masterPlaylistLoader_.masterXml_,srcUrl:this.masterPlaylistLoader_.srcUrl,clientOffset:this.masterPlaylistLoader_.clientOffset_,sidxMapping:this.masterPlaylistLoader_.sidxMapping_,previousManifest:oldMaster});// if we have an old master to compare the new master against
if(oldMaster){newMaster=updateMaster(oldMaster,newMaster,this.masterPlaylistLoader_.sidxMapping_);}// only update master if we have a new master
this.masterPlaylistLoader_.master=newMaster?newMaster:oldMaster;var location=this.masterPlaylistLoader_.master.locations&&this.masterPlaylistLoader_.master.locations[0];if(location&&location!==this.masterPlaylistLoader_.srcUrl){this.masterPlaylistLoader_.srcUrl=location;}if(!oldMaster||newMaster&&newMaster.minimumUpdatePeriod!==oldMaster.minimumUpdatePeriod){this.updateMinimumUpdatePeriodTimeout_();}return Boolean(newMaster);};_proto.updateMinimumUpdatePeriodTimeout_=function updateMinimumUpdatePeriodTimeout_(){var mpl=this.masterPlaylistLoader_;// cancel any pending creation of mup on media
// a new one will be added if needed.
if(mpl.createMupOnMedia_){mpl.off('loadedmetadata',mpl.createMupOnMedia_);mpl.createMupOnMedia_=null;}// clear any pending timeouts
if(mpl.minimumUpdatePeriodTimeout_){window_default().clearTimeout(mpl.minimumUpdatePeriodTimeout_);mpl.minimumUpdatePeriodTimeout_=null;}var mup=mpl.master&&mpl.master.minimumUpdatePeriod;// If the minimumUpdatePeriod has a value of 0, that indicates that the current
// MPD has no future validity, so a new one will need to be acquired when new
// media segments are to be made available. Thus, we use the target duration
// in this case
if(mup===0){if(mpl.media()){mup=mpl.media().targetDuration*1000;}else{mpl.createMupOnMedia_=mpl.updateMinimumUpdatePeriodTimeout_;mpl.one('loadedmetadata',mpl.createMupOnMedia_);}}// if minimumUpdatePeriod is invalid or <= zero, which
// can happen when a live video becomes VOD. skip timeout
// creation.
if(typeof mup!=='number'||mup<=0){if(mup<0){this.logger_("found invalid minimumUpdatePeriod of "+mup+", not setting a timeout");}return;}this.createMUPTimeout_(mup);};_proto.createMUPTimeout_=function createMUPTimeout_(mup){var mpl=this.masterPlaylistLoader_;mpl.minimumUpdatePeriodTimeout_=window_default().setTimeout(function(){mpl.minimumUpdatePeriodTimeout_=null;mpl.trigger('minimumUpdatePeriod');mpl.createMUPTimeout_(mup);},mup);}/**
   * Sends request to refresh the master xml and updates the parsed master manifest
   */;_proto.refreshXml_=function refreshXml_(){var _this8=this;this.requestMaster_(function(req,masterChanged){if(!masterChanged){return;}if(_this8.media_){_this8.media_=_this8.masterPlaylistLoader_.master.playlists[_this8.media_.id];}// This will filter out updated sidx info from the mapping
_this8.masterPlaylistLoader_.sidxMapping_=filterChangedSidxMappings(_this8.masterPlaylistLoader_.master,_this8.masterPlaylistLoader_.sidxMapping_);_this8.addSidxSegments_(_this8.media(),_this8.state,function(sidxChanged){// TODO: do we need to reload the current playlist?
_this8.refreshMedia_(_this8.media().id);});});}/**
   * Refreshes the media playlist by re-parsing the master xml and updating playlist
   * references. If this is an alternate loader, the updated parsed manifest is retrieved
   * from the master loader.
   */;_proto.refreshMedia_=function refreshMedia_(mediaID){var _this9=this;if(!mediaID){throw new Error('refreshMedia_ must take a media id');}// for master we have to reparse the master xml
// to re-create segments based on current timing values
// which may change media. We only skip updating master
// if this is the first time this.media_ is being set.
// as master was just parsed in that case.
if(this.media_&&this.isMaster_){this.handleMaster_();}var playlists=this.masterPlaylistLoader_.master.playlists;var mediaChanged=!this.media_||this.media_!==playlists[mediaID];if(mediaChanged){this.media_=playlists[mediaID];}else{this.trigger('playlistunchanged');}if(!this.mediaUpdateTimeout){var createMediaUpdateTimeout=function createMediaUpdateTimeout(){if(_this9.media().endList){return;}_this9.mediaUpdateTimeout=window_default().setTimeout(function(){_this9.trigger('mediaupdatetimeout');createMediaUpdateTimeout();},refreshDelay(_this9.media(),Boolean(mediaChanged)));};createMediaUpdateTimeout();}this.trigger('loadedplaylist');};return DashPlaylistLoader;}(EventTarget);var Config={GOAL_BUFFER_LENGTH:30,MAX_GOAL_BUFFER_LENGTH:60,BACK_BUFFER_LENGTH:30,GOAL_BUFFER_LENGTH_RATE:1,// 0.5 MB/s
INITIAL_BANDWIDTH:4194304,// A fudge factor to apply to advertised playlist bitrates to account for
// temporary flucations in client bandwidth
BANDWIDTH_VARIANCE:1.2,// How much of the buffer must be filled before we consider upswitching
BUFFER_LOW_WATER_LINE:0,MAX_BUFFER_LOW_WATER_LINE:30,// TODO: Remove this when experimentalBufferBasedABR is removed
EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE:16,BUFFER_LOW_WATER_LINE_RATE:1,// If the buffer is greater than the high water line, we won't switch down
BUFFER_HIGH_WATER_LINE:30};var stringToArrayBuffer=function stringToArrayBuffer(string){var view=new Uint8Array(new ArrayBuffer(string.length));for(var i=0;i<string.length;i++){view[i]=string.charCodeAt(i);}return view.buffer;};/* global Blob, BlobBuilder, Worker */ // unify worker interface
var browserWorkerPolyFill=function browserWorkerPolyFill(workerObj){// node only supports on/off
workerObj.on=workerObj.addEventListener;workerObj.off=workerObj.removeEventListener;return workerObj;};var createObjectURL=function createObjectURL(str){try{return URL.createObjectURL(new Blob([str],{type:'application/javascript'}));}catch(e){var blob=new BlobBuilder();blob.append(str);return URL.createObjectURL(blob.getBlob());}};var factory=function factory(code){return function(){var objectUrl=createObjectURL(code);var worker=browserWorkerPolyFill(new Worker(objectUrl));worker.objURL=objectUrl;var terminate=worker.terminate;worker.on=worker.addEventListener;worker.off=worker.removeEventListener;worker.terminate=function(){URL.revokeObjectURL(objectUrl);return terminate.call(this);};return worker;};};var transform=function transform(code){return"var browserWorkerPolyFill = "+browserWorkerPolyFill.toString()+";\n"+'browserWorkerPolyFill(self);\n'+code;};var getWorkerString=function getWorkerString(fn){return fn.toString().replace(/^function.+?{/,'').slice(0,-1);};/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */var workerCode$1=transform(getWorkerString(function(){/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * A lightweight readable stream implemention that handles event dispatching.
   * Objects that inherit from streams should call init in their constructors.
   */var Stream=function Stream(){this.init=function(){var listeners={};/**
       * Add a listener for a specified event type.
       * @param type {string} the event name
       * @param listener {function} the callback to be invoked when an event of
       * the specified type occurs
       */this.on=function(type,listener){if(!listeners[type]){listeners[type]=[];}listeners[type]=listeners[type].concat(listener);};/**
       * Remove a listener for a specified event type.
       * @param type {string} the event name
       * @param listener {function} a function previously registered for this
       * type of event through `on`
       */this.off=function(type,listener){var index;if(!listeners[type]){return false;}index=listeners[type].indexOf(listener);listeners[type]=listeners[type].slice();listeners[type].splice(index,1);return index>-1;};/**
       * Trigger an event of the specified type on this stream. Any additional
       * arguments to this function are passed as parameters to event listeners.
       * @param type {string} the event name
       */this.trigger=function(type){var callbacks,i,length,args;callbacks=listeners[type];if(!callbacks){return;}// Slicing the arguments on every invocation of this method
// can add a significant amount of overhead. Avoid the
// intermediate object creation for the common case of a
// single callback argument
if(arguments.length===2){length=callbacks.length;for(i=0;i<length;++i){callbacks[i].call(this,arguments[1]);}}else{args=[];i=arguments.length;for(i=1;i<arguments.length;++i){args.push(arguments[i]);}length=callbacks.length;for(i=0;i<length;++i){callbacks[i].apply(this,args);}}};/**
       * Destroys the stream and cleans up.
       */this.dispose=function(){listeners={};};};};/**
   * Forwards all `data` events on this stream to the destination stream. The
   * destination stream should provide a method `push` to receive the data
   * events as they arrive.
   * @param destination {stream} the stream that will receive all `data` events
   * @param autoFlush {boolean} if false, we will not call `flush` on the destination
   *                            when the current stream emits a 'done' event
   * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
   */Stream.prototype.pipe=function(destination){this.on('data',function(data){destination.push(data);});this.on('done',function(flushSource){destination.flush(flushSource);});this.on('partialdone',function(flushSource){destination.partialFlush(flushSource);});this.on('endedtimeline',function(flushSource){destination.endTimeline(flushSource);});this.on('reset',function(flushSource){destination.reset(flushSource);});return destination;};// Default stream functions that are expected to be overridden to perform
// actual work. These are provided by the prototype as a sort of no-op
// implementation so that we don't have to check for their existence in the
// `pipe` function above.
Stream.prototype.push=function(data){this.trigger('data',data);};Stream.prototype.flush=function(flushSource){this.trigger('done',flushSource);};Stream.prototype.partialFlush=function(flushSource){this.trigger('partialdone',flushSource);};Stream.prototype.endTimeline=function(flushSource){this.trigger('endedtimeline',flushSource);};Stream.prototype.reset=function(flushSource){this.trigger('reset',flushSource);};var stream=Stream;var MAX_UINT32$1=Math.pow(2,32);var getUint64$2=function getUint64(uint8){var dv=new DataView(uint8.buffer,uint8.byteOffset,uint8.byteLength);var value;if(dv.getBigUint64){value=dv.getBigUint64(0);if(value<Number.MAX_SAFE_INTEGER){return Number(value);}return value;}return dv.getUint32(0)*MAX_UINT32$1+dv.getUint32(4);};var numbers={getUint64:getUint64$2,MAX_UINT32:MAX_UINT32$1};var MAX_UINT32=numbers.MAX_UINT32;var box,dinf,esds,ftyp,mdat,mfhd,minf,moof,moov,mvex,mvhd,trak,tkhd,mdia,mdhd,hdlr,sdtp,stbl,stsd,traf,trex,trun$1,types,MAJOR_BRAND,MINOR_VERSION,AVC1_BRAND,VIDEO_HDLR,AUDIO_HDLR,HDLR_TYPES,VMHD,SMHD,DREF,STCO,STSC,STSZ,STTS;// pre-calculate constants
(function(){var i;types={avc1:[],// codingname
avcC:[],btrt:[],dinf:[],dref:[],esds:[],ftyp:[],hdlr:[],mdat:[],mdhd:[],mdia:[],mfhd:[],minf:[],moof:[],moov:[],mp4a:[],// codingname
mvex:[],mvhd:[],pasp:[],sdtp:[],smhd:[],stbl:[],stco:[],stsc:[],stsd:[],stsz:[],stts:[],styp:[],tfdt:[],tfhd:[],traf:[],trak:[],trun:[],trex:[],tkhd:[],vmhd:[]};// In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
// don't throw an error
if(typeof Uint8Array==='undefined'){return;}for(i in types){if(types.hasOwnProperty(i)){types[i]=[i.charCodeAt(0),i.charCodeAt(1),i.charCodeAt(2),i.charCodeAt(3)];}}MAJOR_BRAND=new Uint8Array(['i'.charCodeAt(0),'s'.charCodeAt(0),'o'.charCodeAt(0),'m'.charCodeAt(0)]);AVC1_BRAND=new Uint8Array(['a'.charCodeAt(0),'v'.charCodeAt(0),'c'.charCodeAt(0),'1'.charCodeAt(0)]);MINOR_VERSION=new Uint8Array([0,0,0,1]);VIDEO_HDLR=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,// pre_defined
0x76,0x69,0x64,0x65,// handler_type: 'vide'
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x56,0x69,0x64,0x65,0x6f,0x48,0x61,0x6e,0x64,0x6c,0x65,0x72,0x00// name: 'VideoHandler'
]);AUDIO_HDLR=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,// pre_defined
0x73,0x6f,0x75,0x6e,// handler_type: 'soun'
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x53,0x6f,0x75,0x6e,0x64,0x48,0x61,0x6e,0x64,0x6c,0x65,0x72,0x00// name: 'SoundHandler'
]);HDLR_TYPES={video:VIDEO_HDLR,audio:AUDIO_HDLR};DREF=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x01,// entry_count
0x00,0x00,0x00,0x0c,// entry_size
0x75,0x72,0x6c,0x20,// 'url' type
0x00,// version 0
0x00,0x00,0x01// entry_flags
]);SMHD=new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
0x00,0x00,// balance, 0 means centered
0x00,0x00// reserved
]);STCO=new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00// entry_count
]);STSC=STCO;STSZ=new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x00,// sample_size
0x00,0x00,0x00,0x00// sample_count
]);STTS=STCO;VMHD=new Uint8Array([0x00,// version
0x00,0x00,0x01,// flags
0x00,0x00,// graphicsmode
0x00,0x00,0x00,0x00,0x00,0x00// opcolor
]);})();box=function box(type){var payload=[],size=0,i,result,view;for(i=1;i<arguments.length;i++){payload.push(arguments[i]);}i=payload.length;// calculate the total size we need to allocate
while(i--){size+=payload[i].byteLength;}result=new Uint8Array(size+8);view=new DataView(result.buffer,result.byteOffset,result.byteLength);view.setUint32(0,result.byteLength);result.set(type,4);// copy the payload into the result
for(i=0,size=8;i<payload.length;i++){result.set(payload[i],size);size+=payload[i].byteLength;}return result;};dinf=function dinf(){return box(types.dinf,box(types.dref,DREF));};esds=function esds(track){return box(types.esds,new Uint8Array([0x00,// version
0x00,0x00,0x00,// flags
// ES_Descriptor
0x03,// tag, ES_DescrTag
0x19,// length
0x00,0x00,// ES_ID
0x00,// streamDependenceFlag, URL_flag, reserved, streamPriority
// DecoderConfigDescriptor
0x04,// tag, DecoderConfigDescrTag
0x11,// length
0x40,// object type
0x15,// streamType
0x00,0x06,0x00,// bufferSizeDB
0x00,0x00,0xda,0xc0,// maxBitrate
0x00,0x00,0xda,0xc0,// avgBitrate
// DecoderSpecificInfo
0x05,// tag, DecoderSpecificInfoTag
0x02,// length
// ISO/IEC 14496-3, AudioSpecificConfig
// for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
track.audioobjecttype<<3|track.samplingfrequencyindex>>>1,track.samplingfrequencyindex<<7|track.channelcount<<3,0x06,0x01,0x02// GASpecificConfig
]));};ftyp=function ftyp(){return box(types.ftyp,MAJOR_BRAND,MINOR_VERSION,MAJOR_BRAND,AVC1_BRAND);};hdlr=function hdlr(type){return box(types.hdlr,HDLR_TYPES[type]);};mdat=function mdat(data){return box(types.mdat,data);};mdhd=function mdhd(track){var result=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x02,// creation_time
0x00,0x00,0x00,0x03,// modification_time
0x00,0x01,0x5f,0x90,// timescale, 90,000 "ticks" per second
track.duration>>>24&0xFF,track.duration>>>16&0xFF,track.duration>>>8&0xFF,track.duration&0xFF,// duration
0x55,0xc4,// 'und' language (undetermined)
0x00,0x00]);// Use the sample rate from the track metadata, when it is
// defined. The sample rate can be parsed out of an ADTS header, for
// instance.
if(track.samplerate){result[12]=track.samplerate>>>24&0xFF;result[13]=track.samplerate>>>16&0xFF;result[14]=track.samplerate>>>8&0xFF;result[15]=track.samplerate&0xFF;}return box(types.mdhd,result);};mdia=function mdia(track){return box(types.mdia,mdhd(track),hdlr(track.type),minf(track));};mfhd=function mfhd(sequenceNumber){return box(types.mfhd,new Uint8Array([0x00,0x00,0x00,0x00,// flags
(sequenceNumber&0xFF000000)>>24,(sequenceNumber&0xFF0000)>>16,(sequenceNumber&0xFF00)>>8,sequenceNumber&0xFF// sequence_number
]));};minf=function minf(track){return box(types.minf,track.type==='video'?box(types.vmhd,VMHD):box(types.smhd,SMHD),dinf(),stbl(track));};moof=function moof(sequenceNumber,tracks){var trackFragments=[],i=tracks.length;// build traf boxes for each track fragment
while(i--){trackFragments[i]=traf(tracks[i]);}return box.apply(null,[types.moof,mfhd(sequenceNumber)].concat(trackFragments));};/**
   * Returns a movie box.
   * @param tracks {array} the tracks associated with this movie
   * @see ISO/IEC 14496-12:2012(E), section 8.2.1
   */moov=function moov(tracks){var i=tracks.length,boxes=[];while(i--){boxes[i]=trak(tracks[i]);}return box.apply(null,[types.moov,mvhd(0xffffffff)].concat(boxes).concat(mvex(tracks)));};mvex=function mvex(tracks){var i=tracks.length,boxes=[];while(i--){boxes[i]=trex(tracks[i]);}return box.apply(null,[types.mvex].concat(boxes));};mvhd=function mvhd(duration){var bytes=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x01,// creation_time
0x00,0x00,0x00,0x02,// modification_time
0x00,0x01,0x5f,0x90,// timescale, 90,000 "ticks" per second
(duration&0xFF000000)>>24,(duration&0xFF0000)>>16,(duration&0xFF00)>>8,duration&0xFF,// duration
0x00,0x01,0x00,0x00,// 1.0 rate
0x01,0x00,// 1.0 volume
0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x00,0x00,0x00,// transformation: unity matrix
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// pre_defined
0xff,0xff,0xff,0xff// next_track_ID
]);return box(types.mvhd,bytes);};sdtp=function sdtp(track){var samples=track.samples||[],bytes=new Uint8Array(4+samples.length),flags,i;// leave the full box header (4 bytes) all zero
// write the sample table
for(i=0;i<samples.length;i++){flags=samples[i].flags;bytes[i+4]=flags.dependsOn<<4|flags.isDependedOn<<2|flags.hasRedundancy;}return box(types.sdtp,bytes);};stbl=function stbl(track){return box(types.stbl,stsd(track),box(types.stts,STTS),box(types.stsc,STSC),box(types.stsz,STSZ),box(types.stco,STCO));};(function(){var videoSample,audioSample;stsd=function stsd(track){return box(types.stsd,new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
0x00,0x00,0x00,0x01]),track.type==='video'?videoSample(track):audioSample(track));};videoSample=function videoSample(track){var sps=track.sps||[],pps=track.pps||[],sequenceParameterSets=[],pictureParameterSets=[],i,avc1Box;// assemble the SPSs
for(i=0;i<sps.length;i++){sequenceParameterSets.push((sps[i].byteLength&0xFF00)>>>8);sequenceParameterSets.push(sps[i].byteLength&0xFF);// sequenceParameterSetLength
sequenceParameterSets=sequenceParameterSets.concat(Array.prototype.slice.call(sps[i]));// SPS
}// assemble the PPSs
for(i=0;i<pps.length;i++){pictureParameterSets.push((pps[i].byteLength&0xFF00)>>>8);pictureParameterSets.push(pps[i].byteLength&0xFF);pictureParameterSets=pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));}avc1Box=[types.avc1,new Uint8Array([0x00,0x00,0x00,0x00,0x00,0x00,// reserved
0x00,0x01,// data_reference_index
0x00,0x00,// pre_defined
0x00,0x00,// reserved
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// pre_defined
(track.width&0xff00)>>8,track.width&0xff,// width
(track.height&0xff00)>>8,track.height&0xff,// height
0x00,0x48,0x00,0x00,// horizresolution
0x00,0x48,0x00,0x00,// vertresolution
0x00,0x00,0x00,0x00,// reserved
0x00,0x01,// frame_count
0x13,0x76,0x69,0x64,0x65,0x6f,0x6a,0x73,0x2d,0x63,0x6f,0x6e,0x74,0x72,0x69,0x62,0x2d,0x68,0x6c,0x73,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// compressorname
0x00,0x18,// depth = 24
0x11,0x11// pre_defined = -1
]),box(types.avcC,new Uint8Array([0x01,// configurationVersion
track.profileIdc,// AVCProfileIndication
track.profileCompatibility,// profile_compatibility
track.levelIdc,// AVCLevelIndication
0xff// lengthSizeMinusOne, hard-coded to 4 bytes
].concat([sps.length],// numOfSequenceParameterSets
sequenceParameterSets,// "SPS"
[pps.length],// numOfPictureParameterSets
pictureParameterSets// "PPS"
))),box(types.btrt,new Uint8Array([0x00,0x1c,0x9c,0x80,// bufferSizeDB
0x00,0x2d,0xc6,0xc0,// maxBitrate
0x00,0x2d,0xc6,0xc0// avgBitrate
]))];if(track.sarRatio){var hSpacing=track.sarRatio[0],vSpacing=track.sarRatio[1];avc1Box.push(box(types.pasp,new Uint8Array([(hSpacing&0xFF000000)>>24,(hSpacing&0xFF0000)>>16,(hSpacing&0xFF00)>>8,hSpacing&0xFF,(vSpacing&0xFF000000)>>24,(vSpacing&0xFF0000)>>16,(vSpacing&0xFF00)>>8,vSpacing&0xFF])));}return box.apply(null,avc1Box);};audioSample=function audioSample(track){return box(types.mp4a,new Uint8Array([// SampleEntry, ISO/IEC 14496-12
0x00,0x00,0x00,0x00,0x00,0x00,// reserved
0x00,0x01,// data_reference_index
// AudioSampleEntry, ISO/IEC 14496-12
0x00,0x00,0x00,0x00,// reserved
0x00,0x00,0x00,0x00,// reserved
(track.channelcount&0xff00)>>8,track.channelcount&0xff,// channelcount
(track.samplesize&0xff00)>>8,track.samplesize&0xff,// samplesize
0x00,0x00,// pre_defined
0x00,0x00,// reserved
(track.samplerate&0xff00)>>8,track.samplerate&0xff,0x00,0x00// samplerate, 16.16
// MP4AudioSampleEntry, ISO/IEC 14496-14
]),esds(track));};})();tkhd=function tkhd(track){var result=new Uint8Array([0x00,// version 0
0x00,0x00,0x07,// flags
0x00,0x00,0x00,0x00,// creation_time
0x00,0x00,0x00,0x00,// modification_time
(track.id&0xFF000000)>>24,(track.id&0xFF0000)>>16,(track.id&0xFF00)>>8,track.id&0xFF,// track_ID
0x00,0x00,0x00,0x00,// reserved
(track.duration&0xFF000000)>>24,(track.duration&0xFF0000)>>16,(track.duration&0xFF00)>>8,track.duration&0xFF,// duration
0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,// reserved
0x00,0x00,// layer
0x00,0x00,// alternate_group
0x01,0x00,// non-audio track volume
0x00,0x00,// reserved
0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x01,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x00,0x40,0x00,0x00,0x00,// transformation: unity matrix
(track.width&0xFF00)>>8,track.width&0xFF,0x00,0x00,// width
(track.height&0xFF00)>>8,track.height&0xFF,0x00,0x00// height
]);return box(types.tkhd,result);};/**
   * Generate a track fragment (traf) box. A traf box collects metadata
   * about tracks in a movie fragment (moof) box.
   */traf=function traf(track){var trackFragmentHeader,trackFragmentDecodeTime,trackFragmentRun,sampleDependencyTable,dataOffset,upperWordBaseMediaDecodeTime,lowerWordBaseMediaDecodeTime;trackFragmentHeader=box(types.tfhd,new Uint8Array([0x00,// version 0
0x00,0x00,0x3a,// flags
(track.id&0xFF000000)>>24,(track.id&0xFF0000)>>16,(track.id&0xFF00)>>8,track.id&0xFF,// track_ID
0x00,0x00,0x00,0x01,// sample_description_index
0x00,0x00,0x00,0x00,// default_sample_duration
0x00,0x00,0x00,0x00,// default_sample_size
0x00,0x00,0x00,0x00// default_sample_flags
]));upperWordBaseMediaDecodeTime=Math.floor(track.baseMediaDecodeTime/MAX_UINT32);lowerWordBaseMediaDecodeTime=Math.floor(track.baseMediaDecodeTime%MAX_UINT32);trackFragmentDecodeTime=box(types.tfdt,new Uint8Array([0x01,// version 1
0x00,0x00,0x00,// flags
// baseMediaDecodeTime
upperWordBaseMediaDecodeTime>>>24&0xFF,upperWordBaseMediaDecodeTime>>>16&0xFF,upperWordBaseMediaDecodeTime>>>8&0xFF,upperWordBaseMediaDecodeTime&0xFF,lowerWordBaseMediaDecodeTime>>>24&0xFF,lowerWordBaseMediaDecodeTime>>>16&0xFF,lowerWordBaseMediaDecodeTime>>>8&0xFF,lowerWordBaseMediaDecodeTime&0xFF]));// the data offset specifies the number of bytes from the start of
// the containing moof to the first payload byte of the associated
// mdat
dataOffset=32+// tfhd
20+// tfdt
8+// traf header
16+// mfhd
8+// moof header
8;// mdat header
// audio tracks require less metadata
if(track.type==='audio'){trackFragmentRun=trun$1(track,dataOffset);return box(types.traf,trackFragmentHeader,trackFragmentDecodeTime,trackFragmentRun);}// video tracks should contain an independent and disposable samples
// box (sdtp)
// generate one and adjust offsets to match
sampleDependencyTable=sdtp(track);trackFragmentRun=trun$1(track,sampleDependencyTable.length+dataOffset);return box(types.traf,trackFragmentHeader,trackFragmentDecodeTime,trackFragmentRun,sampleDependencyTable);};/**
   * Generate a track box.
   * @param track {object} a track definition
   * @return {Uint8Array} the track box
   */trak=function trak(track){track.duration=track.duration||0xffffffff;return box(types.trak,tkhd(track),mdia(track));};trex=function trex(track){var result=new Uint8Array([0x00,// version 0
0x00,0x00,0x00,// flags
(track.id&0xFF000000)>>24,(track.id&0xFF0000)>>16,(track.id&0xFF00)>>8,track.id&0xFF,// track_ID
0x00,0x00,0x00,0x01,// default_sample_description_index
0x00,0x00,0x00,0x00,// default_sample_duration
0x00,0x00,0x00,0x00,// default_sample_size
0x00,0x01,0x00,0x01// default_sample_flags
]);// the last two bytes of default_sample_flags is the sample
// degradation priority, a hint about the importance of this sample
// relative to others. Lower the degradation priority for all sample
// types other than video.
if(track.type!=='video'){result[result.length-1]=0x00;}return box(types.trex,result);};(function(){var audioTrun,videoTrun,trunHeader;// This method assumes all samples are uniform. That is, if a
// duration is present for the first sample, it will be present for
// all subsequent samples.
// see ISO/IEC 14496-12:2012, Section 8.8.8.1
trunHeader=function trunHeader(samples,offset){var durationPresent=0,sizePresent=0,flagsPresent=0,compositionTimeOffset=0;// trun flag constants
if(samples.length){if(samples[0].duration!==undefined){durationPresent=0x1;}if(samples[0].size!==undefined){sizePresent=0x2;}if(samples[0].flags!==undefined){flagsPresent=0x4;}if(samples[0].compositionTimeOffset!==undefined){compositionTimeOffset=0x8;}}return[0x00,// version 0
0x00,durationPresent|sizePresent|flagsPresent|compositionTimeOffset,0x01,// flags
(samples.length&0xFF000000)>>>24,(samples.length&0xFF0000)>>>16,(samples.length&0xFF00)>>>8,samples.length&0xFF,// sample_count
(offset&0xFF000000)>>>24,(offset&0xFF0000)>>>16,(offset&0xFF00)>>>8,offset&0xFF// data_offset
];};videoTrun=function videoTrun(track,offset){var bytesOffest,bytes,header,samples,sample,i;samples=track.samples||[];offset+=8+12+16*samples.length;header=trunHeader(samples,offset);bytes=new Uint8Array(header.length+samples.length*16);bytes.set(header);bytesOffest=header.length;for(i=0;i<samples.length;i++){sample=samples[i];bytes[bytesOffest++]=(sample.duration&0xFF000000)>>>24;bytes[bytesOffest++]=(sample.duration&0xFF0000)>>>16;bytes[bytesOffest++]=(sample.duration&0xFF00)>>>8;bytes[bytesOffest++]=sample.duration&0xFF;// sample_duration
bytes[bytesOffest++]=(sample.size&0xFF000000)>>>24;bytes[bytesOffest++]=(sample.size&0xFF0000)>>>16;bytes[bytesOffest++]=(sample.size&0xFF00)>>>8;bytes[bytesOffest++]=sample.size&0xFF;// sample_size
bytes[bytesOffest++]=sample.flags.isLeading<<2|sample.flags.dependsOn;bytes[bytesOffest++]=sample.flags.isDependedOn<<6|sample.flags.hasRedundancy<<4|sample.flags.paddingValue<<1|sample.flags.isNonSyncSample;bytes[bytesOffest++]=sample.flags.degradationPriority&0xF0<<8;bytes[bytesOffest++]=sample.flags.degradationPriority&0x0F;// sample_flags
bytes[bytesOffest++]=(sample.compositionTimeOffset&0xFF000000)>>>24;bytes[bytesOffest++]=(sample.compositionTimeOffset&0xFF0000)>>>16;bytes[bytesOffest++]=(sample.compositionTimeOffset&0xFF00)>>>8;bytes[bytesOffest++]=sample.compositionTimeOffset&0xFF;// sample_composition_time_offset
}return box(types.trun,bytes);};audioTrun=function audioTrun(track,offset){var bytes,bytesOffest,header,samples,sample,i;samples=track.samples||[];offset+=8+12+8*samples.length;header=trunHeader(samples,offset);bytes=new Uint8Array(header.length+samples.length*8);bytes.set(header);bytesOffest=header.length;for(i=0;i<samples.length;i++){sample=samples[i];bytes[bytesOffest++]=(sample.duration&0xFF000000)>>>24;bytes[bytesOffest++]=(sample.duration&0xFF0000)>>>16;bytes[bytesOffest++]=(sample.duration&0xFF00)>>>8;bytes[bytesOffest++]=sample.duration&0xFF;// sample_duration
bytes[bytesOffest++]=(sample.size&0xFF000000)>>>24;bytes[bytesOffest++]=(sample.size&0xFF0000)>>>16;bytes[bytesOffest++]=(sample.size&0xFF00)>>>8;bytes[bytesOffest++]=sample.size&0xFF;// sample_size
}return box(types.trun,bytes);};trun$1=function trun(track,offset){if(track.type==='audio'){return audioTrun(track,offset);}return videoTrun(track,offset);};})();var mp4Generator={ftyp:ftyp,mdat:mdat,moof:moof,moov:moov,initSegment:function initSegment(tracks){var fileType=ftyp(),movie=moov(tracks),result;result=new Uint8Array(fileType.byteLength+movie.byteLength);result.set(fileType);result.set(movie,fileType.byteLength);return result;}};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ // Convert an array of nal units into an array of frames with each frame being
// composed of the nal units that make up that frame
// Also keep track of cummulative data about the frame from the nal units such
// as the frame duration, starting pts, etc.
var groupNalsIntoFrames=function groupNalsIntoFrames(nalUnits){var i,currentNal,currentFrame=[],frames=[];// TODO added for LHLS, make sure this is OK
frames.byteLength=0;frames.nalCount=0;frames.duration=0;currentFrame.byteLength=0;for(i=0;i<nalUnits.length;i++){currentNal=nalUnits[i];// Split on 'aud'-type nal units
if(currentNal.nalUnitType==='access_unit_delimiter_rbsp'){// Since the very first nal unit is expected to be an AUD
// only push to the frames array when currentFrame is not empty
if(currentFrame.length){currentFrame.duration=currentNal.dts-currentFrame.dts;// TODO added for LHLS, make sure this is OK
frames.byteLength+=currentFrame.byteLength;frames.nalCount+=currentFrame.length;frames.duration+=currentFrame.duration;frames.push(currentFrame);}currentFrame=[currentNal];currentFrame.byteLength=currentNal.data.byteLength;currentFrame.pts=currentNal.pts;currentFrame.dts=currentNal.dts;}else{// Specifically flag key frames for ease of use later
if(currentNal.nalUnitType==='slice_layer_without_partitioning_rbsp_idr'){currentFrame.keyFrame=true;}currentFrame.duration=currentNal.dts-currentFrame.dts;currentFrame.byteLength+=currentNal.data.byteLength;currentFrame.push(currentNal);}}// For the last frame, use the duration of the previous frame if we
// have nothing better to go on
if(frames.length&&(!currentFrame.duration||currentFrame.duration<=0)){currentFrame.duration=frames[frames.length-1].duration;}// Push the final frame
// TODO added for LHLS, make sure this is OK
frames.byteLength+=currentFrame.byteLength;frames.nalCount+=currentFrame.length;frames.duration+=currentFrame.duration;frames.push(currentFrame);return frames;};// Convert an array of frames into an array of Gop with each Gop being composed
// of the frames that make up that Gop
// Also keep track of cummulative data about the Gop from the frames such as the
// Gop duration, starting pts, etc.
var groupFramesIntoGops=function groupFramesIntoGops(frames){var i,currentFrame,currentGop=[],gops=[];// We must pre-set some of the values on the Gop since we
// keep running totals of these values
currentGop.byteLength=0;currentGop.nalCount=0;currentGop.duration=0;currentGop.pts=frames[0].pts;currentGop.dts=frames[0].dts;// store some metadata about all the Gops
gops.byteLength=0;gops.nalCount=0;gops.duration=0;gops.pts=frames[0].pts;gops.dts=frames[0].dts;for(i=0;i<frames.length;i++){currentFrame=frames[i];if(currentFrame.keyFrame){// Since the very first frame is expected to be an keyframe
// only push to the gops array when currentGop is not empty
if(currentGop.length){gops.push(currentGop);gops.byteLength+=currentGop.byteLength;gops.nalCount+=currentGop.nalCount;gops.duration+=currentGop.duration;}currentGop=[currentFrame];currentGop.nalCount=currentFrame.length;currentGop.byteLength=currentFrame.byteLength;currentGop.pts=currentFrame.pts;currentGop.dts=currentFrame.dts;currentGop.duration=currentFrame.duration;}else{currentGop.duration+=currentFrame.duration;currentGop.nalCount+=currentFrame.length;currentGop.byteLength+=currentFrame.byteLength;currentGop.push(currentFrame);}}if(gops.length&&currentGop.duration<=0){currentGop.duration=gops[gops.length-1].duration;}gops.byteLength+=currentGop.byteLength;gops.nalCount+=currentGop.nalCount;gops.duration+=currentGop.duration;// push the final Gop
gops.push(currentGop);return gops;};/*
   * Search for the first keyframe in the GOPs and throw away all frames
   * until that keyframe. Then extend the duration of the pulled keyframe
   * and pull the PTS and DTS of the keyframe so that it covers the time
   * range of the frames that were disposed.
   *
   * @param {Array} gops video GOPs
   * @returns {Array} modified video GOPs
   */var extendFirstKeyFrame=function extendFirstKeyFrame(gops){var currentGop;if(!gops[0][0].keyFrame&&gops.length>1){// Remove the first GOP
currentGop=gops.shift();gops.byteLength-=currentGop.byteLength;gops.nalCount-=currentGop.nalCount;// Extend the first frame of what is now the
// first gop to cover the time period of the
// frames we just removed
gops[0][0].dts=currentGop.dts;gops[0][0].pts=currentGop.pts;gops[0][0].duration+=currentGop.duration;}return gops;};/**
   * Default sample object
   * see ISO/IEC 14496-12:2012, section 8.6.4.3
   */var createDefaultSample=function createDefaultSample(){return{size:0,flags:{isLeading:0,dependsOn:1,isDependedOn:0,hasRedundancy:0,degradationPriority:0,isNonSyncSample:1}};};/*
   * Collates information from a video frame into an object for eventual
   * entry into an MP4 sample table.
   *
   * @param {Object} frame the video frame
   * @param {Number} dataOffset the byte offset to position the sample
   * @return {Object} object containing sample table info for a frame
   */var sampleForFrame=function sampleForFrame(frame,dataOffset){var sample=createDefaultSample();sample.dataOffset=dataOffset;sample.compositionTimeOffset=frame.pts-frame.dts;sample.duration=frame.duration;sample.size=4*frame.length;// Space for nal unit size
sample.size+=frame.byteLength;if(frame.keyFrame){sample.flags.dependsOn=2;sample.flags.isNonSyncSample=0;}return sample;};// generate the track's sample table from an array of gops
var generateSampleTable$1=function generateSampleTable(gops,baseDataOffset){var h,i,sample,currentGop,currentFrame,dataOffset=baseDataOffset||0,samples=[];for(h=0;h<gops.length;h++){currentGop=gops[h];for(i=0;i<currentGop.length;i++){currentFrame=currentGop[i];sample=sampleForFrame(currentFrame,dataOffset);dataOffset+=sample.size;samples.push(sample);}}return samples;};// generate the track's raw mdat data from an array of gops
var concatenateNalData=function concatenateNalData(gops){var h,i,j,currentGop,currentFrame,currentNal,dataOffset=0,nalsByteLength=gops.byteLength,numberOfNals=gops.nalCount,totalByteLength=nalsByteLength+4*numberOfNals,data=new Uint8Array(totalByteLength),view=new DataView(data.buffer);// For each Gop..
for(h=0;h<gops.length;h++){currentGop=gops[h];// For each Frame..
for(i=0;i<currentGop.length;i++){currentFrame=currentGop[i];// For each NAL..
for(j=0;j<currentFrame.length;j++){currentNal=currentFrame[j];view.setUint32(dataOffset,currentNal.data.byteLength);dataOffset+=4;data.set(currentNal.data,dataOffset);dataOffset+=currentNal.data.byteLength;}}}return data;};// generate the track's sample table from a frame
var generateSampleTableForFrame=function generateSampleTableForFrame(frame,baseDataOffset){var sample,dataOffset=baseDataOffset||0,samples=[];sample=sampleForFrame(frame,dataOffset);samples.push(sample);return samples;};// generate the track's raw mdat data from a frame
var concatenateNalDataForFrame=function concatenateNalDataForFrame(frame){var i,currentNal,dataOffset=0,nalsByteLength=frame.byteLength,numberOfNals=frame.length,totalByteLength=nalsByteLength+4*numberOfNals,data=new Uint8Array(totalByteLength),view=new DataView(data.buffer);// For each NAL..
for(i=0;i<frame.length;i++){currentNal=frame[i];view.setUint32(dataOffset,currentNal.data.byteLength);dataOffset+=4;data.set(currentNal.data,dataOffset);dataOffset+=currentNal.data.byteLength;}return data;};var frameUtils={groupNalsIntoFrames:groupNalsIntoFrames,groupFramesIntoGops:groupFramesIntoGops,extendFirstKeyFrame:extendFirstKeyFrame,generateSampleTable:generateSampleTable$1,concatenateNalData:concatenateNalData,generateSampleTableForFrame:generateSampleTableForFrame,concatenateNalDataForFrame:concatenateNalDataForFrame};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var highPrefix=[33,16,5,32,164,27];var lowPrefix=[33,65,108,84,1,2,4,8,168,2,4,8,17,191,252];var zeroFill=function zeroFill(count){var a=[];while(count--){a.push(0);}return a;};var makeTable=function makeTable(metaTable){return Object.keys(metaTable).reduce(function(obj,key){obj[key]=new Uint8Array(metaTable[key].reduce(function(arr,part){return arr.concat(part);},[]));return obj;},{});};var silence;var silence_1=function silence_1(){if(!silence){// Frames-of-silence to use for filling in missing AAC frames
var coneOfSilence={96000:[highPrefix,[227,64],zeroFill(154),[56]],88200:[highPrefix,[231],zeroFill(170),[56]],64000:[highPrefix,[248,192],zeroFill(240),[56]],48000:[highPrefix,[255,192],zeroFill(268),[55,148,128],zeroFill(54),[112]],44100:[highPrefix,[255,192],zeroFill(268),[55,163,128],zeroFill(84),[112]],32000:[highPrefix,[255,192],zeroFill(268),[55,234],zeroFill(226),[112]],24000:[highPrefix,[255,192],zeroFill(268),[55,255,128],zeroFill(268),[111,112],zeroFill(126),[224]],16000:[highPrefix,[255,192],zeroFill(268),[55,255,128],zeroFill(268),[111,255],zeroFill(269),[223,108],zeroFill(195),[1,192]],12000:[lowPrefix,zeroFill(268),[3,127,248],zeroFill(268),[6,255,240],zeroFill(268),[13,255,224],zeroFill(268),[27,253,128],zeroFill(259),[56]],11025:[lowPrefix,zeroFill(268),[3,127,248],zeroFill(268),[6,255,240],zeroFill(268),[13,255,224],zeroFill(268),[27,255,192],zeroFill(268),[55,175,128],zeroFill(108),[112]],8000:[lowPrefix,zeroFill(268),[3,121,16],zeroFill(47),[7]]};silence=makeTable(coneOfSilence);}return silence;};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var ONE_SECOND_IN_TS$4=90000,// 90kHz clock
secondsToVideoTs,secondsToAudioTs,videoTsToSeconds,audioTsToSeconds,audioTsToVideoTs,videoTsToAudioTs,metadataTsToSeconds;secondsToVideoTs=function secondsToVideoTs(seconds){return seconds*ONE_SECOND_IN_TS$4;};secondsToAudioTs=function secondsToAudioTs(seconds,sampleRate){return seconds*sampleRate;};videoTsToSeconds=function videoTsToSeconds(timestamp){return timestamp/ONE_SECOND_IN_TS$4;};audioTsToSeconds=function audioTsToSeconds(timestamp,sampleRate){return timestamp/sampleRate;};audioTsToVideoTs=function audioTsToVideoTs(timestamp,sampleRate){return secondsToVideoTs(audioTsToSeconds(timestamp,sampleRate));};videoTsToAudioTs=function videoTsToAudioTs(timestamp,sampleRate){return secondsToAudioTs(videoTsToSeconds(timestamp),sampleRate);};/**
   * Adjust ID3 tag or caption timing information by the timeline pts values
   * (if keepOriginalTimestamps is false) and convert to seconds
   */metadataTsToSeconds=function metadataTsToSeconds(timestamp,timelineStartPts,keepOriginalTimestamps){return videoTsToSeconds(keepOriginalTimestamps?timestamp:timestamp-timelineStartPts);};var clock={ONE_SECOND_IN_TS:ONE_SECOND_IN_TS$4,secondsToVideoTs:secondsToVideoTs,secondsToAudioTs:secondsToAudioTs,videoTsToSeconds:videoTsToSeconds,audioTsToSeconds:audioTsToSeconds,audioTsToVideoTs:audioTsToVideoTs,videoTsToAudioTs:videoTsToAudioTs,metadataTsToSeconds:metadataTsToSeconds};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */ /**
   * Sum the `byteLength` properties of the data in each AAC frame
   */var sumFrameByteLengths=function sumFrameByteLengths(array){var i,currentObj,sum=0;// sum the byteLength's all each nal unit in the frame
for(i=0;i<array.length;i++){currentObj=array[i];sum+=currentObj.data.byteLength;}return sum;};// Possibly pad (prefix) the audio track with silence if appending this track
// would lead to the introduction of a gap in the audio buffer
var prefixWithSilence=function prefixWithSilence(track,frames,audioAppendStartTs,videoBaseMediaDecodeTime){var baseMediaDecodeTimeTs,frameDuration=0,audioGapDuration=0,audioFillFrameCount=0,audioFillDuration=0,silentFrame,i,firstFrame;if(!frames.length){return;}baseMediaDecodeTimeTs=clock.audioTsToVideoTs(track.baseMediaDecodeTime,track.samplerate);// determine frame clock duration based on sample rate, round up to avoid overfills
frameDuration=Math.ceil(clock.ONE_SECOND_IN_TS/(track.samplerate/1024));if(audioAppendStartTs&&videoBaseMediaDecodeTime){// insert the shortest possible amount (audio gap or audio to video gap)
audioGapDuration=baseMediaDecodeTimeTs-Math.max(audioAppendStartTs,videoBaseMediaDecodeTime);// number of full frames in the audio gap
audioFillFrameCount=Math.floor(audioGapDuration/frameDuration);audioFillDuration=audioFillFrameCount*frameDuration;}// don't attempt to fill gaps smaller than a single frame or larger
// than a half second
if(audioFillFrameCount<1||audioFillDuration>clock.ONE_SECOND_IN_TS/2){return;}silentFrame=silence_1()[track.samplerate];if(!silentFrame){// we don't have a silent frame pregenerated for the sample rate, so use a frame
// from the content instead
silentFrame=frames[0].data;}for(i=0;i<audioFillFrameCount;i++){firstFrame=frames[0];frames.splice(0,0,{data:silentFrame,dts:firstFrame.dts-frameDuration,pts:firstFrame.pts-frameDuration});}track.baseMediaDecodeTime-=Math.floor(clock.videoTsToAudioTs(audioFillDuration,track.samplerate));return audioFillDuration;};// If the audio segment extends before the earliest allowed dts
// value, remove AAC frames until starts at or after the earliest
// allowed DTS so that we don't end up with a negative baseMedia-
// DecodeTime for the audio track
var trimAdtsFramesByEarliestDts=function trimAdtsFramesByEarliestDts(adtsFrames,track,earliestAllowedDts){if(track.minSegmentDts>=earliestAllowedDts){return adtsFrames;}// We will need to recalculate the earliest segment Dts
track.minSegmentDts=Infinity;return adtsFrames.filter(function(currentFrame){// If this is an allowed frame, keep it and record it's Dts
if(currentFrame.dts>=earliestAllowedDts){track.minSegmentDts=Math.min(track.minSegmentDts,currentFrame.dts);track.minSegmentPts=track.minSegmentDts;return true;}// Otherwise, discard it
return false;});};// generate the track's raw mdat data from an array of frames
var generateSampleTable=function generateSampleTable(frames){var i,currentFrame,samples=[];for(i=0;i<frames.length;i++){currentFrame=frames[i];samples.push({size:currentFrame.data.byteLength,duration:1024// For AAC audio, all samples contain 1024 samples
});}return samples;};// generate the track's sample table from an array of frames
var concatenateFrameData=function concatenateFrameData(frames){var i,currentFrame,dataOffset=0,data=new Uint8Array(sumFrameByteLengths(frames));for(i=0;i<frames.length;i++){currentFrame=frames[i];data.set(currentFrame.data,dataOffset);dataOffset+=currentFrame.data.byteLength;}return data;};var audioFrameUtils={prefixWithSilence:prefixWithSilence,trimAdtsFramesByEarliestDts:trimAdtsFramesByEarliestDts,generateSampleTable:generateSampleTable,concatenateFrameData:concatenateFrameData};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var ONE_SECOND_IN_TS$3=clock.ONE_SECOND_IN_TS;/**
   * Store information about the start and end of the track and the
   * duration for each frame/sample we process in order to calculate
   * the baseMediaDecodeTime
   */var collectDtsInfo=function collectDtsInfo(track,data){if(typeof data.pts==='number'){if(track.timelineStartInfo.pts===undefined){track.timelineStartInfo.pts=data.pts;}if(track.minSegmentPts===undefined){track.minSegmentPts=data.pts;}else{track.minSegmentPts=Math.min(track.minSegmentPts,data.pts);}if(track.maxSegmentPts===undefined){track.maxSegmentPts=data.pts;}else{track.maxSegmentPts=Math.max(track.maxSegmentPts,data.pts);}}if(typeof data.dts==='number'){if(track.timelineStartInfo.dts===undefined){track.timelineStartInfo.dts=data.dts;}if(track.minSegmentDts===undefined){track.minSegmentDts=data.dts;}else{track.minSegmentDts=Math.min(track.minSegmentDts,data.dts);}if(track.maxSegmentDts===undefined){track.maxSegmentDts=data.dts;}else{track.maxSegmentDts=Math.max(track.maxSegmentDts,data.dts);}}};/**
   * Clear values used to calculate the baseMediaDecodeTime between
   * tracks
   */var clearDtsInfo=function clearDtsInfo(track){delete track.minSegmentDts;delete track.maxSegmentDts;delete track.minSegmentPts;delete track.maxSegmentPts;};/**
   * Calculate the track's baseMediaDecodeTime based on the earliest
   * DTS the transmuxer has ever seen and the minimum DTS for the
   * current track
   * @param track {object} track metadata configuration
   * @param keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */var calculateTrackBaseMediaDecodeTime=function calculateTrackBaseMediaDecodeTime(track,keepOriginalTimestamps){var baseMediaDecodeTime,scale,minSegmentDts=track.minSegmentDts;// Optionally adjust the time so the first segment starts at zero.
if(!keepOriginalTimestamps){minSegmentDts-=track.timelineStartInfo.dts;}// track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
// we want the start of the first segment to be placed
baseMediaDecodeTime=track.timelineStartInfo.baseMediaDecodeTime;// Add to that the distance this segment is from the very first
baseMediaDecodeTime+=minSegmentDts;// baseMediaDecodeTime must not become negative
baseMediaDecodeTime=Math.max(0,baseMediaDecodeTime);if(track.type==='audio'){// Audio has a different clock equal to the sampling_rate so we need to
// scale the PTS values into the clock rate of the track
scale=track.samplerate/ONE_SECOND_IN_TS$3;baseMediaDecodeTime*=scale;baseMediaDecodeTime=Math.floor(baseMediaDecodeTime);}return baseMediaDecodeTime;};var trackDecodeInfo={clearDtsInfo:clearDtsInfo,calculateTrackBaseMediaDecodeTime:calculateTrackBaseMediaDecodeTime,collectDtsInfo:collectDtsInfo};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Reads in-band caption information from a video elementary
   * stream. Captions must follow the CEA-708 standard for injection
   * into an MPEG-2 transport streams.
   * @see https://en.wikipedia.org/wiki/CEA-708
   * @see https://www.gpo.gov/fdsys/pkg/CFR-2007-title47-vol1/pdf/CFR-2007-title47-vol1-sec15-119.pdf
   */ // payload type field to indicate how they are to be
// interpreted. CEAS-708 caption content is always transmitted with
// payload type 0x04.
var USER_DATA_REGISTERED_ITU_T_T35=4,RBSP_TRAILING_BITS=128;/**
    * Parse a supplemental enhancement information (SEI) NAL unit.
    * Stops parsing once a message of type ITU T T35 has been found.
    *
    * @param bytes {Uint8Array} the bytes of a SEI NAL unit
    * @return {object} the parsed SEI payload
    * @see Rec. ITU-T H.264, 7.3.2.3.1
    */var parseSei=function parseSei(bytes){var i=0,result={payloadType:-1,payloadSize:0},payloadType=0,payloadSize=0;// go through the sei_rbsp parsing each each individual sei_message
while(i<bytes.byteLength){// stop once we have hit the end of the sei_rbsp
if(bytes[i]===RBSP_TRAILING_BITS){break;}// Parse payload type
while(bytes[i]===0xFF){payloadType+=255;i++;}payloadType+=bytes[i++];// Parse payload size
while(bytes[i]===0xFF){payloadSize+=255;i++;}payloadSize+=bytes[i++];// this sei_message is a 608/708 caption so save it and break
// there can only ever be one caption message in a frame's sei
if(!result.payload&&payloadType===USER_DATA_REGISTERED_ITU_T_T35){var userIdentifier=String.fromCharCode(bytes[i+3],bytes[i+4],bytes[i+5],bytes[i+6]);if(userIdentifier==='GA94'){result.payloadType=payloadType;result.payloadSize=payloadSize;result.payload=bytes.subarray(i,i+payloadSize);break;}else{result.payload=void 0;}}// skip the payload and parse the next message
i+=payloadSize;payloadType=0;payloadSize=0;}return result;};// see ANSI/SCTE 128-1 (2013), section 8.1
var parseUserData=function parseUserData(sei){// itu_t_t35_contry_code must be 181 (United States) for
// captions
if(sei.payload[0]!==181){return null;}// itu_t_t35_provider_code should be 49 (ATSC) for captions
if((sei.payload[1]<<8|sei.payload[2])!==49){return null;}// the user_identifier should be "GA94" to indicate ATSC1 data
if(String.fromCharCode(sei.payload[3],sei.payload[4],sei.payload[5],sei.payload[6])!=='GA94'){return null;}// finally, user_data_type_code should be 0x03 for caption data
if(sei.payload[7]!==0x03){return null;}// return the user_data_type_structure and strip the trailing
// marker bits
return sei.payload.subarray(8,sei.payload.length-1);};// see CEA-708-D, section 4.4
var parseCaptionPackets=function parseCaptionPackets(pts,userData){var results=[],i,count,offset,data;// if this is just filler, return immediately
if(!(userData[0]&0x40)){return results;}// parse out the cc_data_1 and cc_data_2 fields
count=userData[0]&0x1f;for(i=0;i<count;i++){offset=i*3;data={type:userData[offset+2]&0x03,pts:pts};// capture cc data when cc_valid is 1
if(userData[offset+2]&0x04){data.ccData=userData[offset+3]<<8|userData[offset+4];results.push(data);}}return results;};var discardEmulationPreventionBytes$1=function discardEmulationPreventionBytes(data){var length=data.byteLength,emulationPreventionBytesPositions=[],i=1,newLength,newData;// Find all `Emulation Prevention Bytes`
while(i<length-2){if(data[i]===0&&data[i+1]===0&&data[i+2]===0x03){emulationPreventionBytesPositions.push(i+2);i+=2;}else{i++;}}// If no Emulation Prevention Bytes were found just return the original
// array
if(emulationPreventionBytesPositions.length===0){return data;}// Create a new array to hold the NAL unit data
newLength=length-emulationPreventionBytesPositions.length;newData=new Uint8Array(newLength);var sourceIndex=0;for(i=0;i<newLength;sourceIndex++,i++){if(sourceIndex===emulationPreventionBytesPositions[0]){// Skip this byte
sourceIndex++;// Remove this position index
emulationPreventionBytesPositions.shift();}newData[i]=data[sourceIndex];}return newData;};// exports
var captionPacketParser={parseSei:parseSei,parseUserData:parseUserData,parseCaptionPackets:parseCaptionPackets,discardEmulationPreventionBytes:discardEmulationPreventionBytes$1,USER_DATA_REGISTERED_ITU_T_T35:USER_DATA_REGISTERED_ITU_T_T35};// Link To Transport
// -----------------
var CaptionStream$1=function CaptionStream(options){options=options||{};CaptionStream.prototype.init.call(this);// parse708captions flag, default to true
this.parse708captions_=typeof options.parse708captions==='boolean'?options.parse708captions:true;this.captionPackets_=[];this.ccStreams_=[new Cea608Stream(0,0),// eslint-disable-line no-use-before-define
new Cea608Stream(0,1),// eslint-disable-line no-use-before-define
new Cea608Stream(1,0),// eslint-disable-line no-use-before-define
new Cea608Stream(1,1)// eslint-disable-line no-use-before-define
];if(this.parse708captions_){this.cc708Stream_=new Cea708Stream({captionServices:options.captionServices});// eslint-disable-line no-use-before-define
}this.reset();// forward data and done events from CCs to this CaptionStream
this.ccStreams_.forEach(function(cc){cc.on('data',this.trigger.bind(this,'data'));cc.on('partialdone',this.trigger.bind(this,'partialdone'));cc.on('done',this.trigger.bind(this,'done'));},this);if(this.parse708captions_){this.cc708Stream_.on('data',this.trigger.bind(this,'data'));this.cc708Stream_.on('partialdone',this.trigger.bind(this,'partialdone'));this.cc708Stream_.on('done',this.trigger.bind(this,'done'));}};CaptionStream$1.prototype=new stream();CaptionStream$1.prototype.push=function(event){var sei,userData,newCaptionPackets;// only examine SEI NALs
if(event.nalUnitType!=='sei_rbsp'){return;}// parse the sei
sei=captionPacketParser.parseSei(event.escapedRBSP);// no payload data, skip
if(!sei.payload){return;}// ignore everything but user_data_registered_itu_t_t35
if(sei.payloadType!==captionPacketParser.USER_DATA_REGISTERED_ITU_T_T35){return;}// parse out the user data payload
userData=captionPacketParser.parseUserData(sei);// ignore unrecognized userData
if(!userData){return;}// Sometimes, the same segment # will be downloaded twice. To stop the
// caption data from being processed twice, we track the latest dts we've
// received and ignore everything with a dts before that. However, since
// data for a specific dts can be split across packets on either side of
// a segment boundary, we need to make sure we *don't* ignore the packets
// from the *next* segment that have dts === this.latestDts_. By constantly
// tracking the number of packets received with dts === this.latestDts_, we
// know how many should be ignored once we start receiving duplicates.
if(event.dts<this.latestDts_){// We've started getting older data, so set the flag.
this.ignoreNextEqualDts_=true;return;}else if(event.dts===this.latestDts_&&this.ignoreNextEqualDts_){this.numSameDts_--;if(!this.numSameDts_){// We've received the last duplicate packet, time to start processing again
this.ignoreNextEqualDts_=false;}return;}// parse out CC data packets and save them for later
newCaptionPackets=captionPacketParser.parseCaptionPackets(event.pts,userData);this.captionPackets_=this.captionPackets_.concat(newCaptionPackets);if(this.latestDts_!==event.dts){this.numSameDts_=0;}this.numSameDts_++;this.latestDts_=event.dts;};CaptionStream$1.prototype.flushCCStreams=function(flushType){this.ccStreams_.forEach(function(cc){return flushType==='flush'?cc.flush():cc.partialFlush();},this);};CaptionStream$1.prototype.flushStream=function(flushType){// make sure we actually parsed captions before proceeding
if(!this.captionPackets_.length){this.flushCCStreams(flushType);return;}// In Chrome, the Array#sort function is not stable so add a
// presortIndex that we can use to ensure we get a stable-sort
this.captionPackets_.forEach(function(elem,idx){elem.presortIndex=idx;});// sort caption byte-pairs based on their PTS values
this.captionPackets_.sort(function(a,b){if(a.pts===b.pts){return a.presortIndex-b.presortIndex;}return a.pts-b.pts;});this.captionPackets_.forEach(function(packet){if(packet.type<2){// Dispatch packet to the right Cea608Stream
this.dispatchCea608Packet(packet);}else{// Dispatch packet to the Cea708Stream
this.dispatchCea708Packet(packet);}},this);this.captionPackets_.length=0;this.flushCCStreams(flushType);};CaptionStream$1.prototype.flush=function(){return this.flushStream('flush');};// Only called if handling partial data
CaptionStream$1.prototype.partialFlush=function(){return this.flushStream('partialFlush');};CaptionStream$1.prototype.reset=function(){this.latestDts_=null;this.ignoreNextEqualDts_=false;this.numSameDts_=0;this.activeCea608Channel_=[null,null];this.ccStreams_.forEach(function(ccStream){ccStream.reset();});};// From the CEA-608 spec:
/*
   * When XDS sub-packets are interleaved with other services, the end of each sub-packet shall be followed
   * by a control pair to change to a different service. When any of the control codes from 0x10 to 0x1F is
   * used to begin a control code pair, it indicates the return to captioning or Text data. The control code pair
   * and subsequent data should then be processed according to the FCC rules. It may be necessary for the
   * line 21 data encoder to automatically insert a control code pair (i.e. RCL, RU2, RU3, RU4, RDC, or RTD)
   * to switch to captioning or Text.
  */ // With that in mind, we ignore any data between an XDS control code and a
// subsequent closed-captioning control code.
CaptionStream$1.prototype.dispatchCea608Packet=function(packet){// NOTE: packet.type is the CEA608 field
if(this.setsTextOrXDSActive(packet)){this.activeCea608Channel_[packet.type]=null;}else if(this.setsChannel1Active(packet)){this.activeCea608Channel_[packet.type]=0;}else if(this.setsChannel2Active(packet)){this.activeCea608Channel_[packet.type]=1;}if(this.activeCea608Channel_[packet.type]===null){// If we haven't received anything to set the active channel, or the
// packets are Text/XDS data, discard the data; we don't want jumbled
// captions
return;}this.ccStreams_[(packet.type<<1)+this.activeCea608Channel_[packet.type]].push(packet);};CaptionStream$1.prototype.setsChannel1Active=function(packet){return(packet.ccData&0x7800)===0x1000;};CaptionStream$1.prototype.setsChannel2Active=function(packet){return(packet.ccData&0x7800)===0x1800;};CaptionStream$1.prototype.setsTextOrXDSActive=function(packet){return(packet.ccData&0x7100)===0x0100||(packet.ccData&0x78fe)===0x102a||(packet.ccData&0x78fe)===0x182a;};CaptionStream$1.prototype.dispatchCea708Packet=function(packet){if(this.parse708captions_){this.cc708Stream_.push(packet);}};// ----------------------
// Session to Application
// ----------------------
// This hash maps special and extended character codes to their
// proper Unicode equivalent. The first one-byte key is just a
// non-standard character code. The two-byte keys that follow are
// the extended CEA708 character codes, along with the preceding
// 0x10 extended character byte to distinguish these codes from
// non-extended character codes. Every CEA708 character code that
// is not in this object maps directly to a standard unicode
// character code.
// The transparent space and non-breaking transparent space are
// technically not fully supported since there is no code to
// make them transparent, so they have normal non-transparent
// stand-ins.
// The special closed caption (CC) character isn't a standard
// unicode character, so a fairly similar unicode character was
// chosen in it's place.
var CHARACTER_TRANSLATION_708={0x7f:0x266a,// ♪
0x1020:0x20,// Transparent Space
0x1021:0xa0,// Nob-breaking Transparent Space
0x1025:0x2026,// …
0x102a:0x0160,// Š
0x102c:0x0152,// Œ
0x1030:0x2588,// █
0x1031:0x2018,// ‘
0x1032:0x2019,// ’
0x1033:0x201c,// “
0x1034:0x201d,// ”
0x1035:0x2022,// •
0x1039:0x2122,// ™
0x103a:0x0161,// š
0x103c:0x0153,// œ
0x103d:0x2120,// ℠
0x103f:0x0178,// Ÿ
0x1076:0x215b,// ⅛
0x1077:0x215c,// ⅜
0x1078:0x215d,// ⅝
0x1079:0x215e,// ⅞
0x107a:0x23d0,// ⏐
0x107b:0x23a4,// ⎤
0x107c:0x23a3,// ⎣
0x107d:0x23af,// ⎯
0x107e:0x23a6,// ⎦
0x107f:0x23a1,// ⎡
0x10a0:0x3138// ㄸ (CC char)
};var get708CharFromCode=function get708CharFromCode(code){var newCode=CHARACTER_TRANSLATION_708[code]||code;if(code&0x1000&&code===newCode){// Invalid extended code
return'';}return String.fromCharCode(newCode);};var within708TextBlock=function within708TextBlock(b){return 0x20<=b&&b<=0x7f||0xa0<=b&&b<=0xff;};var Cea708Window=function Cea708Window(windowNum){this.windowNum=windowNum;this.reset();};Cea708Window.prototype.reset=function(){this.clearText();this.pendingNewLine=false;this.winAttr={};this.penAttr={};this.penLoc={};this.penColor={};// These default values are arbitrary,
// defineWindow will usually override them
this.visible=0;this.rowLock=0;this.columnLock=0;this.priority=0;this.relativePositioning=0;this.anchorVertical=0;this.anchorHorizontal=0;this.anchorPoint=0;this.rowCount=1;this.virtualRowCount=this.rowCount+1;this.columnCount=41;this.windowStyle=0;this.penStyle=0;};Cea708Window.prototype.getText=function(){return this.rows.join('\n');};Cea708Window.prototype.clearText=function(){this.rows=[''];this.rowIdx=0;};Cea708Window.prototype.newLine=function(pts){if(this.rows.length>=this.virtualRowCount&&typeof this.beforeRowOverflow==='function'){this.beforeRowOverflow(pts);}if(this.rows.length>0){this.rows.push('');this.rowIdx++;}// Show all virtual rows since there's no visible scrolling
while(this.rows.length>this.virtualRowCount){this.rows.shift();this.rowIdx--;}};Cea708Window.prototype.isEmpty=function(){if(this.rows.length===0){return true;}else if(this.rows.length===1){return this.rows[0]==='';}return false;};Cea708Window.prototype.addText=function(text){this.rows[this.rowIdx]+=text;};Cea708Window.prototype.backspace=function(){if(!this.isEmpty()){var row=this.rows[this.rowIdx];this.rows[this.rowIdx]=row.substr(0,row.length-1);}};var Cea708Service=function Cea708Service(serviceNum,encoding,stream){this.serviceNum=serviceNum;this.text='';this.currentWindow=new Cea708Window(-1);this.windows=[];this.stream=stream;// Try to setup a TextDecoder if an `encoding` value was provided
if(typeof encoding==='string'){this.createTextDecoder(encoding);}};/**
   * Initialize service windows
   * Must be run before service use
   *
   * @param  {Integer}  pts               PTS value
   * @param  {Function} beforeRowOverflow Function to execute before row overflow of a window
   */Cea708Service.prototype.init=function(pts,beforeRowOverflow){this.startPts=pts;for(var win=0;win<8;win++){this.windows[win]=new Cea708Window(win);if(typeof beforeRowOverflow==='function'){this.windows[win].beforeRowOverflow=beforeRowOverflow;}}};/**
   * Set current window of service to be affected by commands
   *
   * @param  {Integer} windowNum Window number
   */Cea708Service.prototype.setCurrentWindow=function(windowNum){this.currentWindow=this.windows[windowNum];};/**
   * Try to create a TextDecoder if it is natively supported
   */Cea708Service.prototype.createTextDecoder=function(encoding){if(typeof TextDecoder==='undefined'){this.stream.trigger('log',{level:'warn',message:'The `encoding` option is unsupported without TextDecoder support'});}else{try{this.textDecoder_=new TextDecoder(encoding);}catch(error){this.stream.trigger('log',{level:'warn',message:'TextDecoder could not be created with '+encoding+' encoding. '+error});}}};var Cea708Stream=function Cea708Stream(options){options=options||{};Cea708Stream.prototype.init.call(this);var self=this;var captionServices=options.captionServices||{};var captionServiceEncodings={};var serviceProps;// Get service encodings from captionServices option block
Object.keys(captionServices).forEach(function(serviceName){serviceProps=captionServices[serviceName];if(/^SERVICE/.test(serviceName)){captionServiceEncodings[serviceName]=serviceProps.encoding;}});this.serviceEncodings=captionServiceEncodings;this.current708Packet=null;this.services={};this.push=function(packet){if(packet.type===3){// 708 packet start
self.new708Packet();self.add708Bytes(packet);}else{if(self.current708Packet===null){// This should only happen at the start of a file if there's no packet start.
self.new708Packet();}self.add708Bytes(packet);}};};Cea708Stream.prototype=new stream();/**
   * Push current 708 packet, create new 708 packet.
   */Cea708Stream.prototype.new708Packet=function(){if(this.current708Packet!==null){this.push708Packet();}this.current708Packet={data:[],ptsVals:[]};};/**
   * Add pts and both bytes from packet into current 708 packet.
   */Cea708Stream.prototype.add708Bytes=function(packet){var data=packet.ccData;var byte0=data>>>8;var byte1=data&0xff;// I would just keep a list of packets instead of bytes, but it isn't clear in the spec
// that service blocks will always line up with byte pairs.
this.current708Packet.ptsVals.push(packet.pts);this.current708Packet.data.push(byte0);this.current708Packet.data.push(byte1);};/**
   * Parse completed 708 packet into service blocks and push each service block.
   */Cea708Stream.prototype.push708Packet=function(){var packet708=this.current708Packet;var packetData=packet708.data;var serviceNum=null;var blockSize=null;var i=0;var b=packetData[i++];packet708.seq=b>>6;packet708.sizeCode=b&0x3f;// 0b00111111;
for(;i<packetData.length;i++){b=packetData[i++];serviceNum=b>>5;blockSize=b&0x1f;// 0b00011111
if(serviceNum===7&&blockSize>0){// Extended service num
b=packetData[i++];serviceNum=b;}this.pushServiceBlock(serviceNum,i,blockSize);if(blockSize>0){i+=blockSize-1;}}};/**
   * Parse service block, execute commands, read text.
   *
   * Note: While many of these commands serve important purposes,
   * many others just parse out the parameters or attributes, but
   * nothing is done with them because this is not a full and complete
   * implementation of the entire 708 spec.
   *
   * @param  {Integer} serviceNum Service number
   * @param  {Integer} start      Start index of the 708 packet data
   * @param  {Integer} size       Block size
   */Cea708Stream.prototype.pushServiceBlock=function(serviceNum,start,size){var b;var i=start;var packetData=this.current708Packet.data;var service=this.services[serviceNum];if(!service){service=this.initService(serviceNum,i);}for(;i<start+size&&i<packetData.length;i++){b=packetData[i];if(within708TextBlock(b)){i=this.handleText(i,service);}else if(b===0x18){i=this.multiByteCharacter(i,service);}else if(b===0x10){i=this.extendedCommands(i,service);}else if(0x80<=b&&b<=0x87){i=this.setCurrentWindow(i,service);}else if(0x98<=b&&b<=0x9f){i=this.defineWindow(i,service);}else if(b===0x88){i=this.clearWindows(i,service);}else if(b===0x8c){i=this.deleteWindows(i,service);}else if(b===0x89){i=this.displayWindows(i,service);}else if(b===0x8a){i=this.hideWindows(i,service);}else if(b===0x8b){i=this.toggleWindows(i,service);}else if(b===0x97){i=this.setWindowAttributes(i,service);}else if(b===0x90){i=this.setPenAttributes(i,service);}else if(b===0x91){i=this.setPenColor(i,service);}else if(b===0x92){i=this.setPenLocation(i,service);}else if(b===0x8f){service=this.reset(i,service);}else if(b===0x08){// BS: Backspace
service.currentWindow.backspace();}else if(b===0x0c){// FF: Form feed
service.currentWindow.clearText();}else if(b===0x0d){// CR: Carriage return
service.currentWindow.pendingNewLine=true;}else if(b===0x0e){// HCR: Horizontal carriage return
service.currentWindow.clearText();}else if(b===0x8d){// DLY: Delay, nothing to do
i++;}else;}};/**
   * Execute an extended command
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.extendedCommands=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];if(within708TextBlock(b)){i=this.handleText(i,service,{isExtended:true});}return i;};/**
   * Get PTS value of a given byte index
   *
   * @param  {Integer} byteIndex  Index of the byte
   * @return {Integer}            PTS
   */Cea708Stream.prototype.getPts=function(byteIndex){// There's 1 pts value per 2 bytes
return this.current708Packet.ptsVals[Math.floor(byteIndex/2)];};/**
   * Initializes a service
   *
   * @param  {Integer} serviceNum Service number
   * @return {Service}            Initialized service object
   */Cea708Stream.prototype.initService=function(serviceNum,i){var serviceName='SERVICE'+serviceNum;var self=this;var serviceName;var encoding;if(serviceName in this.serviceEncodings){encoding=this.serviceEncodings[serviceName];}this.services[serviceNum]=new Cea708Service(serviceNum,encoding,self);this.services[serviceNum].init(this.getPts(i),function(pts){self.flushDisplayed(pts,self.services[serviceNum]);});return this.services[serviceNum];};/**
   * Execute text writing to current window
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.handleText=function(i,service,options){var isExtended=options&&options.isExtended;var isMultiByte=options&&options.isMultiByte;var packetData=this.current708Packet.data;var extended=isExtended?0x1000:0x0000;var currentByte=packetData[i];var nextByte=packetData[i+1];var win=service.currentWindow;var _char;var charCodeArray;// Use the TextDecoder if one was created for this service
if(service.textDecoder_&&!isExtended){if(isMultiByte){charCodeArray=[currentByte,nextByte];i++;}else{charCodeArray=[currentByte];}_char=service.textDecoder_.decode(new Uint8Array(charCodeArray));}else{_char=get708CharFromCode(extended|currentByte);}if(win.pendingNewLine&&!win.isEmpty()){win.newLine(this.getPts(i));}win.pendingNewLine=false;win.addText(_char);return i;};/**
   * Handle decoding of multibyte character
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.multiByteCharacter=function(i,service){var packetData=this.current708Packet.data;var firstByte=packetData[i+1];var secondByte=packetData[i+2];if(within708TextBlock(firstByte)&&within708TextBlock(secondByte)){i=this.handleText(++i,service,{isMultiByte:true});}return i;};/**
   * Parse and execute the CW# command.
   *
   * Set the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.setCurrentWindow=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var windowNum=b&0x07;service.setCurrentWindow(windowNum);return i;};/**
   * Parse and execute the DF# command.
   *
   * Define a window and set it as the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.defineWindow=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var windowNum=b&0x07;service.setCurrentWindow(windowNum);var win=service.currentWindow;b=packetData[++i];win.visible=(b&0x20)>>5;// v
win.rowLock=(b&0x10)>>4;// rl
win.columnLock=(b&0x08)>>3;// cl
win.priority=b&0x07;// p
b=packetData[++i];win.relativePositioning=(b&0x80)>>7;// rp
win.anchorVertical=b&0x7f;// av
b=packetData[++i];win.anchorHorizontal=b;// ah
b=packetData[++i];win.anchorPoint=(b&0xf0)>>4;// ap
win.rowCount=b&0x0f;// rc
b=packetData[++i];win.columnCount=b&0x3f;// cc
b=packetData[++i];win.windowStyle=(b&0x38)>>3;// ws
win.penStyle=b&0x07;// ps
// The spec says there are (rowCount+1) "virtual rows"
win.virtualRowCount=win.rowCount+1;return i;};/**
   * Parse and execute the SWA command.
   *
   * Set attributes of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.setWindowAttributes=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var winAttr=service.currentWindow.winAttr;b=packetData[++i];winAttr.fillOpacity=(b&0xc0)>>6;// fo
winAttr.fillRed=(b&0x30)>>4;// fr
winAttr.fillGreen=(b&0x0c)>>2;// fg
winAttr.fillBlue=b&0x03;// fb
b=packetData[++i];winAttr.borderType=(b&0xc0)>>6;// bt
winAttr.borderRed=(b&0x30)>>4;// br
winAttr.borderGreen=(b&0x0c)>>2;// bg
winAttr.borderBlue=b&0x03;// bb
b=packetData[++i];winAttr.borderType+=(b&0x80)>>5;// bt
winAttr.wordWrap=(b&0x40)>>6;// ww
winAttr.printDirection=(b&0x30)>>4;// pd
winAttr.scrollDirection=(b&0x0c)>>2;// sd
winAttr.justify=b&0x03;// j
b=packetData[++i];winAttr.effectSpeed=(b&0xf0)>>4;// es
winAttr.effectDirection=(b&0x0c)>>2;// ed
winAttr.displayEffect=b&0x03;// de
return i;};/**
   * Gather text from all displayed windows and push a caption to output.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   */Cea708Stream.prototype.flushDisplayed=function(pts,service){var displayedText=[];// TODO: Positioning not supported, displaying multiple windows will not necessarily
// display text in the correct order, but sample files so far have not shown any issue.
for(var winId=0;winId<8;winId++){if(service.windows[winId].visible&&!service.windows[winId].isEmpty()){displayedText.push(service.windows[winId].getText());}}service.endPts=pts;service.text=displayedText.join('\n\n');this.pushCaption(service);service.startPts=pts;};/**
   * Push a caption to output if the caption contains text.
   *
   * @param  {Service} service  The service object to be affected
   */Cea708Stream.prototype.pushCaption=function(service){if(service.text!==''){this.trigger('data',{startPts:service.startPts,endPts:service.endPts,text:service.text,stream:'cc708_'+service.serviceNum});service.text='';service.startPts=service.endPts;}};/**
   * Parse and execute the DSW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.displayWindows=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];var pts=this.getPts(i);this.flushDisplayed(pts,service);for(var winId=0;winId<8;winId++){if(b&0x01<<winId){service.windows[winId].visible=1;}}return i;};/**
   * Parse and execute the HDW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.hideWindows=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];var pts=this.getPts(i);this.flushDisplayed(pts,service);for(var winId=0;winId<8;winId++){if(b&0x01<<winId){service.windows[winId].visible=0;}}return i;};/**
   * Parse and execute the TGW command.
   *
   * Set visible property of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.toggleWindows=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];var pts=this.getPts(i);this.flushDisplayed(pts,service);for(var winId=0;winId<8;winId++){if(b&0x01<<winId){service.windows[winId].visible^=1;}}return i;};/**
   * Parse and execute the CLW command.
   *
   * Clear text of windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.clearWindows=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];var pts=this.getPts(i);this.flushDisplayed(pts,service);for(var winId=0;winId<8;winId++){if(b&0x01<<winId){service.windows[winId].clearText();}}return i;};/**
   * Parse and execute the DLW command.
   *
   * Re-initialize windows based on the parsed bitmask.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.deleteWindows=function(i,service){var packetData=this.current708Packet.data;var b=packetData[++i];var pts=this.getPts(i);this.flushDisplayed(pts,service);for(var winId=0;winId<8;winId++){if(b&0x01<<winId){service.windows[winId].reset();}}return i;};/**
   * Parse and execute the SPA command.
   *
   * Set pen attributes of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.setPenAttributes=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var penAttr=service.currentWindow.penAttr;b=packetData[++i];penAttr.textTag=(b&0xf0)>>4;// tt
penAttr.offset=(b&0x0c)>>2;// o
penAttr.penSize=b&0x03;// s
b=packetData[++i];penAttr.italics=(b&0x80)>>7;// i
penAttr.underline=(b&0x40)>>6;// u
penAttr.edgeType=(b&0x38)>>3;// et
penAttr.fontStyle=b&0x07;// fs
return i;};/**
   * Parse and execute the SPC command.
   *
   * Set pen color of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.setPenColor=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var penColor=service.currentWindow.penColor;b=packetData[++i];penColor.fgOpacity=(b&0xc0)>>6;// fo
penColor.fgRed=(b&0x30)>>4;// fr
penColor.fgGreen=(b&0x0c)>>2;// fg
penColor.fgBlue=b&0x03;// fb
b=packetData[++i];penColor.bgOpacity=(b&0xc0)>>6;// bo
penColor.bgRed=(b&0x30)>>4;// br
penColor.bgGreen=(b&0x0c)>>2;// bg
penColor.bgBlue=b&0x03;// bb
b=packetData[++i];penColor.edgeRed=(b&0x30)>>4;// er
penColor.edgeGreen=(b&0x0c)>>2;// eg
penColor.edgeBlue=b&0x03;// eb
return i;};/**
   * Parse and execute the SPL command.
   *
   * Set pen location of the current window.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Integer}          New index after parsing
   */Cea708Stream.prototype.setPenLocation=function(i,service){var packetData=this.current708Packet.data;var b=packetData[i];var penLoc=service.currentWindow.penLoc;// Positioning isn't really supported at the moment, so this essentially just inserts a linebreak
service.currentWindow.pendingNewLine=true;b=packetData[++i];penLoc.row=b&0x0f;// r
b=packetData[++i];penLoc.column=b&0x3f;// c
return i;};/**
   * Execute the RST command.
   *
   * Reset service to a clean slate. Re-initialize.
   *
   * @param  {Integer} i        Current index in the 708 packet
   * @param  {Service} service  The service object to be affected
   * @return {Service}          Re-initialized service
   */Cea708Stream.prototype.reset=function(i,service){var pts=this.getPts(i);this.flushDisplayed(pts,service);return this.initService(service.serviceNum,i);};// This hash maps non-ASCII, special, and extended character codes to their
// proper Unicode equivalent. The first keys that are only a single byte
// are the non-standard ASCII characters, which simply map the CEA608 byte
// to the standard ASCII/Unicode. The two-byte keys that follow are the CEA608
// character codes, but have their MSB bitmasked with 0x03 so that a lookup
// can be performed regardless of the field and data channel on which the
// character code was received.
var CHARACTER_TRANSLATION={0x2a:0xe1,// á
0x5c:0xe9,// é
0x5e:0xed,// í
0x5f:0xf3,// ó
0x60:0xfa,// ú
0x7b:0xe7,// ç
0x7c:0xf7,// ÷
0x7d:0xd1,// Ñ
0x7e:0xf1,// ñ
0x7f:0x2588,// █
0x0130:0xae,// ®
0x0131:0xb0,// °
0x0132:0xbd,// ½
0x0133:0xbf,// ¿
0x0134:0x2122,// ™
0x0135:0xa2,// ¢
0x0136:0xa3,// £
0x0137:0x266a,// ♪
0x0138:0xe0,// à
0x0139:0xa0,//
0x013a:0xe8,// è
0x013b:0xe2,// â
0x013c:0xea,// ê
0x013d:0xee,// î
0x013e:0xf4,// ô
0x013f:0xfb,// û
0x0220:0xc1,// Á
0x0221:0xc9,// É
0x0222:0xd3,// Ó
0x0223:0xda,// Ú
0x0224:0xdc,// Ü
0x0225:0xfc,// ü
0x0226:0x2018,// ‘
0x0227:0xa1,// ¡
0x0228:0x2a,// *
0x0229:0x27,// '
0x022a:0x2014,// —
0x022b:0xa9,// ©
0x022c:0x2120,// ℠
0x022d:0x2022,// •
0x022e:0x201c,// “
0x022f:0x201d,// ”
0x0230:0xc0,// À
0x0231:0xc2,// Â
0x0232:0xc7,// Ç
0x0233:0xc8,// È
0x0234:0xca,// Ê
0x0235:0xcb,// Ë
0x0236:0xeb,// ë
0x0237:0xce,// Î
0x0238:0xcf,// Ï
0x0239:0xef,// ï
0x023a:0xd4,// Ô
0x023b:0xd9,// Ù
0x023c:0xf9,// ù
0x023d:0xdb,// Û
0x023e:0xab,// «
0x023f:0xbb,// »
0x0320:0xc3,// Ã
0x0321:0xe3,// ã
0x0322:0xcd,// Í
0x0323:0xcc,// Ì
0x0324:0xec,// ì
0x0325:0xd2,// Ò
0x0326:0xf2,// ò
0x0327:0xd5,// Õ
0x0328:0xf5,// õ
0x0329:0x7b,// {
0x032a:0x7d,// }
0x032b:0x5c,// \
0x032c:0x5e,// ^
0x032d:0x5f,// _
0x032e:0x7c,// |
0x032f:0x7e,// ~
0x0330:0xc4,// Ä
0x0331:0xe4,// ä
0x0332:0xd6,// Ö
0x0333:0xf6,// ö
0x0334:0xdf,// ß
0x0335:0xa5,// ¥
0x0336:0xa4,// ¤
0x0337:0x2502,// │
0x0338:0xc5,// Å
0x0339:0xe5,// å
0x033a:0xd8,// Ø
0x033b:0xf8,// ø
0x033c:0x250c,// ┌
0x033d:0x2510,// ┐
0x033e:0x2514,// └
0x033f:0x2518// ┘
};var getCharFromCode=function getCharFromCode(code){if(code===null){return'';}code=CHARACTER_TRANSLATION[code]||code;return String.fromCharCode(code);};// the index of the last row in a CEA-608 display buffer
var BOTTOM_ROW=14;// This array is used for mapping PACs -> row #, since there's no way of
// getting it through bit logic.
var ROWS=[0x1100,0x1120,0x1200,0x1220,0x1500,0x1520,0x1600,0x1620,0x1700,0x1720,0x1000,0x1300,0x1320,0x1400,0x1420];// CEA-608 captions are rendered onto a 34x15 matrix of character
// cells. The "bottom" row is the last element in the outer array.
var createDisplayBuffer=function createDisplayBuffer(){var result=[],i=BOTTOM_ROW+1;while(i--){result.push('');}return result;};var Cea608Stream=function Cea608Stream(field,dataChannel){Cea608Stream.prototype.init.call(this);this.field_=field||0;this.dataChannel_=dataChannel||0;this.name_='CC'+((this.field_<<1|this.dataChannel_)+1);this.setConstants();this.reset();this.push=function(packet){var data,swap,char0,char1,text;// remove the parity bits
data=packet.ccData&0x7f7f;// ignore duplicate control codes; the spec demands they're sent twice
if(data===this.lastControlCode_){this.lastControlCode_=null;return;}// Store control codes
if((data&0xf000)===0x1000){this.lastControlCode_=data;}else if(data!==this.PADDING_){this.lastControlCode_=null;}char0=data>>>8;char1=data&0xff;if(data===this.PADDING_){return;}else if(data===this.RESUME_CAPTION_LOADING_){this.mode_='popOn';}else if(data===this.END_OF_CAPTION_){// If an EOC is received while in paint-on mode, the displayed caption
// text should be swapped to non-displayed memory as if it was a pop-on
// caption. Because of that, we should explicitly switch back to pop-on
// mode
this.mode_='popOn';this.clearFormatting(packet.pts);// if a caption was being displayed, it's gone now
this.flushDisplayed(packet.pts);// flip memory
swap=this.displayed_;this.displayed_=this.nonDisplayed_;this.nonDisplayed_=swap;// start measuring the time to display the caption
this.startPts_=packet.pts;}else if(data===this.ROLL_UP_2_ROWS_){this.rollUpRows_=2;this.setRollUp(packet.pts);}else if(data===this.ROLL_UP_3_ROWS_){this.rollUpRows_=3;this.setRollUp(packet.pts);}else if(data===this.ROLL_UP_4_ROWS_){this.rollUpRows_=4;this.setRollUp(packet.pts);}else if(data===this.CARRIAGE_RETURN_){this.clearFormatting(packet.pts);this.flushDisplayed(packet.pts);this.shiftRowsUp_();this.startPts_=packet.pts;}else if(data===this.BACKSPACE_){if(this.mode_==='popOn'){this.nonDisplayed_[this.row_]=this.nonDisplayed_[this.row_].slice(0,-1);}else{this.displayed_[this.row_]=this.displayed_[this.row_].slice(0,-1);}}else if(data===this.ERASE_DISPLAYED_MEMORY_){this.flushDisplayed(packet.pts);this.displayed_=createDisplayBuffer();}else if(data===this.ERASE_NON_DISPLAYED_MEMORY_){this.nonDisplayed_=createDisplayBuffer();}else if(data===this.RESUME_DIRECT_CAPTIONING_){if(this.mode_!=='paintOn'){// NOTE: This should be removed when proper caption positioning is
// implemented
this.flushDisplayed(packet.pts);this.displayed_=createDisplayBuffer();}this.mode_='paintOn';this.startPts_=packet.pts;// Append special characters to caption text
}else if(this.isSpecialCharacter(char0,char1)){// Bitmask char0 so that we can apply character transformations
// regardless of field and data channel.
// Then byte-shift to the left and OR with char1 so we can pass the
// entire character code to `getCharFromCode`.
char0=(char0&0x03)<<8;text=getCharFromCode(char0|char1);this[this.mode_](packet.pts,text);this.column_++;// Append extended characters to caption text
}else if(this.isExtCharacter(char0,char1)){// Extended characters always follow their "non-extended" equivalents.
// IE if a "è" is desired, you'll always receive "eè"; non-compliant
// decoders are supposed to drop the "è", while compliant decoders
// backspace the "e" and insert "è".
// Delete the previous character
if(this.mode_==='popOn'){this.nonDisplayed_[this.row_]=this.nonDisplayed_[this.row_].slice(0,-1);}else{this.displayed_[this.row_]=this.displayed_[this.row_].slice(0,-1);}// Bitmask char0 so that we can apply character transformations
// regardless of field and data channel.
// Then byte-shift to the left and OR with char1 so we can pass the
// entire character code to `getCharFromCode`.
char0=(char0&0x03)<<8;text=getCharFromCode(char0|char1);this[this.mode_](packet.pts,text);this.column_++;// Process mid-row codes
}else if(this.isMidRowCode(char0,char1)){// Attributes are not additive, so clear all formatting
this.clearFormatting(packet.pts);// According to the standard, mid-row codes
// should be replaced with spaces, so add one now
this[this.mode_](packet.pts,' ');this.column_++;if((char1&0xe)===0xe){this.addFormatting(packet.pts,['i']);}if((char1&0x1)===0x1){this.addFormatting(packet.pts,['u']);}// Detect offset control codes and adjust cursor
}else if(this.isOffsetControlCode(char0,char1)){// Cursor position is set by indent PAC (see below) in 4-column
// increments, with an additional offset code of 1-3 to reach any
// of the 32 columns specified by CEA-608. So all we need to do
// here is increment the column cursor by the given offset.
this.column_+=char1&0x03;// Detect PACs (Preamble Address Codes)
}else if(this.isPAC(char0,char1)){// There's no logic for PAC -> row mapping, so we have to just
// find the row code in an array and use its index :(
var row=ROWS.indexOf(data&0x1f20);// Configure the caption window if we're in roll-up mode
if(this.mode_==='rollUp'){// This implies that the base row is incorrectly set.
// As per the recommendation in CEA-608(Base Row Implementation), defer to the number
// of roll-up rows set.
if(row-this.rollUpRows_+1<0){row=this.rollUpRows_-1;}this.setRollUp(packet.pts,row);}if(row!==this.row_){// formatting is only persistent for current row
this.clearFormatting(packet.pts);this.row_=row;}// All PACs can apply underline, so detect and apply
// (All odd-numbered second bytes set underline)
if(char1&0x1&&this.formatting_.indexOf('u')===-1){this.addFormatting(packet.pts,['u']);}if((data&0x10)===0x10){// We've got an indent level code. Each successive even number
// increments the column cursor by 4, so we can get the desired
// column position by bit-shifting to the right (to get n/2)
// and multiplying by 4.
this.column_=((data&0xe)>>1)*4;}if(this.isColorPAC(char1)){// it's a color code, though we only support white, which
// can be either normal or italicized. white italics can be
// either 0x4e or 0x6e depending on the row, so we just
// bitwise-and with 0xe to see if italics should be turned on
if((char1&0xe)===0xe){this.addFormatting(packet.pts,['i']);}}// We have a normal character in char0, and possibly one in char1
}else if(this.isNormalChar(char0)){if(char1===0x00){char1=null;}text=getCharFromCode(char0);text+=getCharFromCode(char1);this[this.mode_](packet.pts,text);this.column_+=text.length;}// finish data processing
};};Cea608Stream.prototype=new stream();// Trigger a cue point that captures the current state of the
// display buffer
Cea608Stream.prototype.flushDisplayed=function(pts){var content=this.displayed_// remove spaces from the start and end of the string
.map(function(row,index){try{return row.trim();}catch(e){// Ordinarily, this shouldn't happen. However, caption
// parsing errors should not throw exceptions and
// break playback.
this.trigger('log',{level:'warn',message:'Skipping a malformed 608 caption at index '+index+'.'});return'';}},this)// combine all text rows to display in one cue
.join('\n')// and remove blank rows from the start and end, but not the middle
.replace(/^\n+|\n+$/g,'');if(content.length){this.trigger('data',{startPts:this.startPts_,endPts:pts,text:content,stream:this.name_});}};/**
   * Zero out the data, used for startup and on seek
   */Cea608Stream.prototype.reset=function(){this.mode_='popOn';// When in roll-up mode, the index of the last row that will
// actually display captions. If a caption is shifted to a row
// with a lower index than this, it is cleared from the display
// buffer
this.topRow_=0;this.startPts_=0;this.displayed_=createDisplayBuffer();this.nonDisplayed_=createDisplayBuffer();this.lastControlCode_=null;// Track row and column for proper line-breaking and spacing
this.column_=0;this.row_=BOTTOM_ROW;this.rollUpRows_=2;// This variable holds currently-applied formatting
this.formatting_=[];};/**
   * Sets up control code and related constants for this instance
   */Cea608Stream.prototype.setConstants=function(){// The following attributes have these uses:
// ext_ :    char0 for mid-row codes, and the base for extended
//           chars (ext_+0, ext_+1, and ext_+2 are char0s for
//           extended codes)
// control_: char0 for control codes, except byte-shifted to the
//           left so that we can do this.control_ | CONTROL_CODE
// offset_:  char0 for tab offset codes
//
// It's also worth noting that control codes, and _only_ control codes,
// differ between field 1 and field2. Field 2 control codes are always
// their field 1 value plus 1. That's why there's the "| field" on the
// control value.
if(this.dataChannel_===0){this.BASE_=0x10;this.EXT_=0x11;this.CONTROL_=(0x14|this.field_)<<8;this.OFFSET_=0x17;}else if(this.dataChannel_===1){this.BASE_=0x18;this.EXT_=0x19;this.CONTROL_=(0x1c|this.field_)<<8;this.OFFSET_=0x1f;}// Constants for the LSByte command codes recognized by Cea608Stream. This
// list is not exhaustive. For a more comprehensive listing and semantics see
// http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
// Padding
this.PADDING_=0x0000;// Pop-on Mode
this.RESUME_CAPTION_LOADING_=this.CONTROL_|0x20;this.END_OF_CAPTION_=this.CONTROL_|0x2f;// Roll-up Mode
this.ROLL_UP_2_ROWS_=this.CONTROL_|0x25;this.ROLL_UP_3_ROWS_=this.CONTROL_|0x26;this.ROLL_UP_4_ROWS_=this.CONTROL_|0x27;this.CARRIAGE_RETURN_=this.CONTROL_|0x2d;// paint-on mode
this.RESUME_DIRECT_CAPTIONING_=this.CONTROL_|0x29;// Erasure
this.BACKSPACE_=this.CONTROL_|0x21;this.ERASE_DISPLAYED_MEMORY_=this.CONTROL_|0x2c;this.ERASE_NON_DISPLAYED_MEMORY_=this.CONTROL_|0x2e;};/**
   * Detects if the 2-byte packet data is a special character
   *
   * Special characters have a second byte in the range 0x30 to 0x3f,
   * with the first byte being 0x11 (for data channel 1) or 0x19 (for
   * data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an special character
   */Cea608Stream.prototype.isSpecialCharacter=function(char0,char1){return char0===this.EXT_&&char1>=0x30&&char1<=0x3f;};/**
   * Detects if the 2-byte packet data is an extended character
   *
   * Extended characters have a second byte in the range 0x20 to 0x3f,
   * with the first byte being 0x12 or 0x13 (for data channel 1) or
   * 0x1a or 0x1b (for data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an extended character
   */Cea608Stream.prototype.isExtCharacter=function(char0,char1){return(char0===this.EXT_+1||char0===this.EXT_+2)&&char1>=0x20&&char1<=0x3f;};/**
   * Detects if the 2-byte packet is a mid-row code
   *
   * Mid-row codes have a second byte in the range 0x20 to 0x2f, with
   * the first byte being 0x11 (for data channel 1) or 0x19 (for data
   * channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are a mid-row code
   */Cea608Stream.prototype.isMidRowCode=function(char0,char1){return char0===this.EXT_&&char1>=0x20&&char1<=0x2f;};/**
   * Detects if the 2-byte packet is an offset control code
   *
   * Offset control codes have a second byte in the range 0x21 to 0x23,
   * with the first byte being 0x17 (for data channel 1) or 0x1f (for
   * data channel 2).
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are an offset control code
   */Cea608Stream.prototype.isOffsetControlCode=function(char0,char1){return char0===this.OFFSET_&&char1>=0x21&&char1<=0x23;};/**
   * Detects if the 2-byte packet is a Preamble Address Code
   *
   * PACs have a first byte in the range 0x10 to 0x17 (for data channel 1)
   * or 0x18 to 0x1f (for data channel 2), with the second byte in the
   * range 0x40 to 0x7f.
   *
   * @param  {Integer} char0 The first byte
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the 2 bytes are a PAC
   */Cea608Stream.prototype.isPAC=function(char0,char1){return char0>=this.BASE_&&char0<this.BASE_+8&&char1>=0x40&&char1<=0x7f;};/**
   * Detects if a packet's second byte is in the range of a PAC color code
   *
   * PAC color codes have the second byte be in the range 0x40 to 0x4f, or
   * 0x60 to 0x6f.
   *
   * @param  {Integer} char1 The second byte
   * @return {Boolean}       Whether the byte is a color PAC
   */Cea608Stream.prototype.isColorPAC=function(char1){return char1>=0x40&&char1<=0x4f||char1>=0x60&&char1<=0x7f;};/**
   * Detects if a single byte is in the range of a normal character
   *
   * Normal text bytes are in the range 0x20 to 0x7f.
   *
   * @param  {Integer} char  The byte
   * @return {Boolean}       Whether the byte is a normal character
   */Cea608Stream.prototype.isNormalChar=function(_char2){return _char2>=0x20&&_char2<=0x7f;};/**
   * Configures roll-up
   *
   * @param  {Integer} pts         Current PTS
   * @param  {Integer} newBaseRow  Used by PACs to slide the current window to
   *                               a new position
   */Cea608Stream.prototype.setRollUp=function(pts,newBaseRow){// Reset the base row to the bottom row when switching modes
if(this.mode_!=='rollUp'){this.row_=BOTTOM_ROW;this.mode_='rollUp';// Spec says to wipe memories when switching to roll-up
this.flushDisplayed(pts);this.nonDisplayed_=createDisplayBuffer();this.displayed_=createDisplayBuffer();}if(newBaseRow!==undefined&&newBaseRow!==this.row_){// move currently displayed captions (up or down) to the new base row
for(var i=0;i<this.rollUpRows_;i++){this.displayed_[newBaseRow-i]=this.displayed_[this.row_-i];this.displayed_[this.row_-i]='';}}if(newBaseRow===undefined){newBaseRow=this.row_;}this.topRow_=newBaseRow-this.rollUpRows_+1;};// Adds the opening HTML tag for the passed character to the caption text,
// and keeps track of it for later closing
Cea608Stream.prototype.addFormatting=function(pts,format){this.formatting_=this.formatting_.concat(format);var text=format.reduce(function(text,format){return text+'<'+format+'>';},'');this[this.mode_](pts,text);};// Adds HTML closing tags for current formatting to caption text and
// clears remembered formatting
Cea608Stream.prototype.clearFormatting=function(pts){if(!this.formatting_.length){return;}var text=this.formatting_.reverse().reduce(function(text,format){return text+'</'+format+'>';},'');this.formatting_=[];this[this.mode_](pts,text);};// Mode Implementations
Cea608Stream.prototype.popOn=function(pts,text){var baseRow=this.nonDisplayed_[this.row_];// buffer characters
baseRow+=text;this.nonDisplayed_[this.row_]=baseRow;};Cea608Stream.prototype.rollUp=function(pts,text){var baseRow=this.displayed_[this.row_];baseRow+=text;this.displayed_[this.row_]=baseRow;};Cea608Stream.prototype.shiftRowsUp_=function(){var i;// clear out inactive rows
for(i=0;i<this.topRow_;i++){this.displayed_[i]='';}for(i=this.row_+1;i<BOTTOM_ROW+1;i++){this.displayed_[i]='';}// shift displayed rows up
for(i=this.topRow_;i<this.row_;i++){this.displayed_[i]=this.displayed_[i+1];}// clear out the bottom row
this.displayed_[this.row_]='';};Cea608Stream.prototype.paintOn=function(pts,text){var baseRow=this.displayed_[this.row_];baseRow+=text;this.displayed_[this.row_]=baseRow;};// exports
var captionStream={CaptionStream:CaptionStream$1,Cea608Stream:Cea608Stream,Cea708Stream:Cea708Stream};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var streamTypes={H264_STREAM_TYPE:0x1B,ADTS_STREAM_TYPE:0x0F,METADATA_STREAM_TYPE:0x15};var MAX_TS=8589934592;var RO_THRESH=4294967296;var TYPE_SHARED='shared';var handleRollover$1=function handleRollover(value,reference){var direction=1;if(value>reference){// If the current timestamp value is greater than our reference timestamp and we detect a
// timestamp rollover, this means the roll over is happening in the opposite direction.
// Example scenario: Enter a long stream/video just after a rollover occurred. The reference
// point will be set to a small number, e.g. 1. The user then seeks backwards over the
// rollover point. In loading this segment, the timestamp values will be very large,
// e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
// the time stamp to be `value - 2^33`.
direction=-1;}// Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
// cause an incorrect adjustment.
while(Math.abs(reference-value)>RO_THRESH){value+=direction*MAX_TS;}return value;};var TimestampRolloverStream$1=function TimestampRolloverStream(type){var lastDTS,referenceDTS;TimestampRolloverStream.prototype.init.call(this);// The "shared" type is used in cases where a stream will contain muxed
// video and audio. We could use `undefined` here, but having a string
// makes debugging a little clearer.
this.type_=type||TYPE_SHARED;this.push=function(data){// Any "shared" rollover streams will accept _all_ data. Otherwise,
// streams will only accept data that matches their type.
if(this.type_!==TYPE_SHARED&&data.type!==this.type_){return;}if(referenceDTS===undefined){referenceDTS=data.dts;}data.dts=handleRollover$1(data.dts,referenceDTS);data.pts=handleRollover$1(data.pts,referenceDTS);lastDTS=data.dts;this.trigger('data',data);};this.flush=function(){referenceDTS=lastDTS;this.trigger('done');};this.endTimeline=function(){this.flush();this.trigger('endedtimeline');};this.discontinuity=function(){referenceDTS=void 0;lastDTS=void 0;};this.reset=function(){this.discontinuity();this.trigger('reset');};};TimestampRolloverStream$1.prototype=new stream();var timestampRolloverStream={TimestampRolloverStream:TimestampRolloverStream$1,handleRollover:handleRollover$1};var percentEncode$1=function percentEncode(bytes,start,end){var i,result='';for(i=start;i<end;i++){result+='%'+('00'+bytes[i].toString(16)).slice(-2);}return result;},// return the string representation of the specified byte range,
// interpreted as UTf-8.
parseUtf8=function parseUtf8(bytes,start,end){return decodeURIComponent(percentEncode$1(bytes,start,end));},// return the string representation of the specified byte range,
// interpreted as ISO-8859-1.
parseIso88591$1=function parseIso88591(bytes,start,end){return unescape(percentEncode$1(bytes,start,end));// jshint ignore:line
},parseSyncSafeInteger$1=function parseSyncSafeInteger(data){return data[0]<<21|data[1]<<14|data[2]<<7|data[3];},tagParsers={TXXX:function TXXX(tag){var i;if(tag.data[0]!==3){// ignore frames with unrecognized character encodings
return;}for(i=1;i<tag.data.length;i++){if(tag.data[i]===0){// parse the text fields
tag.description=parseUtf8(tag.data,1,i);// do not include the null terminator in the tag value
tag.value=parseUtf8(tag.data,i+1,tag.data.length).replace(/\0*$/,'');break;}}tag.data=tag.value;},WXXX:function WXXX(tag){var i;if(tag.data[0]!==3){// ignore frames with unrecognized character encodings
return;}for(i=1;i<tag.data.length;i++){if(tag.data[i]===0){// parse the description and URL fields
tag.description=parseUtf8(tag.data,1,i);tag.url=parseUtf8(tag.data,i+1,tag.data.length);break;}}},PRIV:function PRIV(tag){var i;for(i=0;i<tag.data.length;i++){if(tag.data[i]===0){// parse the description and URL fields
tag.owner=parseIso88591$1(tag.data,0,i);break;}}tag.privateData=tag.data.subarray(i+1);tag.data=tag.privateData;}},_MetadataStream;_MetadataStream=function MetadataStream(options){var settings={// the bytes of the program-level descriptor field in MP2T
// see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
// program element descriptors"
descriptor:options&&options.descriptor},// the total size in bytes of the ID3 tag being parsed
tagSize=0,// tag data that is not complete enough to be parsed
buffer=[],// the total number of bytes currently in the buffer
bufferSize=0,i;_MetadataStream.prototype.init.call(this);// calculate the text track in-band metadata track dispatch type
// https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
this.dispatchType=streamTypes.METADATA_STREAM_TYPE.toString(16);if(settings.descriptor){for(i=0;i<settings.descriptor.length;i++){this.dispatchType+=('00'+settings.descriptor[i].toString(16)).slice(-2);}}this.push=function(chunk){var tag,frameStart,frameSize,frame,i,frameHeader;if(chunk.type!=='timed-metadata'){return;}// if data_alignment_indicator is set in the PES header,
// we must have the start of a new ID3 tag. Assume anything
// remaining in the buffer was malformed and throw it out
if(chunk.dataAlignmentIndicator){bufferSize=0;buffer.length=0;}// ignore events that don't look like ID3 data
if(buffer.length===0&&(chunk.data.length<10||chunk.data[0]!=='I'.charCodeAt(0)||chunk.data[1]!=='D'.charCodeAt(0)||chunk.data[2]!=='3'.charCodeAt(0))){this.trigger('log',{level:'warn',message:'Skipping unrecognized metadata packet'});return;}// add this chunk to the data we've collected so far
buffer.push(chunk);bufferSize+=chunk.data.byteLength;// grab the size of the entire frame from the ID3 header
if(buffer.length===1){// the frame size is transmitted as a 28-bit integer in the
// last four bytes of the ID3 header.
// The most significant bit of each byte is dropped and the
// results concatenated to recover the actual value.
tagSize=parseSyncSafeInteger$1(chunk.data.subarray(6,10));// ID3 reports the tag size excluding the header but it's more
// convenient for our comparisons to include it
tagSize+=10;}// if the entire frame has not arrived, wait for more data
if(bufferSize<tagSize){return;}// collect the entire frame so it can be parsed
tag={data:new Uint8Array(tagSize),frames:[],pts:buffer[0].pts,dts:buffer[0].dts};for(i=0;i<tagSize;){tag.data.set(buffer[0].data.subarray(0,tagSize-i),i);i+=buffer[0].data.byteLength;bufferSize-=buffer[0].data.byteLength;buffer.shift();}// find the start of the first frame and the end of the tag
frameStart=10;if(tag.data[5]&0x40){// advance the frame start past the extended header
frameStart+=4;// header size field
frameStart+=parseSyncSafeInteger$1(tag.data.subarray(10,14));// clip any padding off the end
tagSize-=parseSyncSafeInteger$1(tag.data.subarray(16,20));}// parse one or more ID3 frames
// http://id3.org/id3v2.3.0#ID3v2_frame_overview
do{// determine the number of bytes in this frame
frameSize=parseSyncSafeInteger$1(tag.data.subarray(frameStart+4,frameStart+8));if(frameSize<1){this.trigger('log',{level:'warn',message:'Malformed ID3 frame encountered. Skipping metadata parsing.'});return;}frameHeader=String.fromCharCode(tag.data[frameStart],tag.data[frameStart+1],tag.data[frameStart+2],tag.data[frameStart+3]);frame={id:frameHeader,data:tag.data.subarray(frameStart+10,frameStart+frameSize+10)};frame.key=frame.id;if(tagParsers[frame.id]){tagParsers[frame.id](frame);// handle the special PRIV frame used to indicate the start
// time for raw AAC data
if(frame.owner==='com.apple.streaming.transportStreamTimestamp'){var d=frame.data,size=(d[3]&0x01)<<30|d[4]<<22|d[5]<<14|d[6]<<6|d[7]>>>2;size*=4;size+=d[7]&0x03;frame.timeStamp=size;// in raw AAC, all subsequent data will be timestamped based
// on the value of this frame
// we couldn't have known the appropriate pts and dts before
// parsing this ID3 tag so set those values now
if(tag.pts===undefined&&tag.dts===undefined){tag.pts=frame.timeStamp;tag.dts=frame.timeStamp;}this.trigger('timestamp',frame);}}tag.frames.push(frame);frameStart+=10;// advance past the frame header
frameStart+=frameSize;// advance past the frame body
}while(frameStart<tagSize);this.trigger('data',tag);};};_MetadataStream.prototype=new stream();var metadataStream=_MetadataStream;var TimestampRolloverStream=timestampRolloverStream.TimestampRolloverStream;// object types
var _TransportPacketStream,_TransportParseStream,_ElementaryStream;// constants
var MP2T_PACKET_LENGTH$1=188,// bytes
SYNC_BYTE$1=0x47;/**
   * Splits an incoming stream of binary data into MPEG-2 Transport
   * Stream packets.
   */_TransportPacketStream=function TransportPacketStream(){var buffer=new Uint8Array(MP2T_PACKET_LENGTH$1),bytesInBuffer=0;_TransportPacketStream.prototype.init.call(this);// Deliver new bytes to the stream.
/**
     * Split a stream of data into M2TS packets
    **/this.push=function(bytes){var startIndex=0,endIndex=MP2T_PACKET_LENGTH$1,everything;// If there are bytes remaining from the last segment, prepend them to the
// bytes that were pushed in
if(bytesInBuffer){everything=new Uint8Array(bytes.byteLength+bytesInBuffer);everything.set(buffer.subarray(0,bytesInBuffer));everything.set(bytes,bytesInBuffer);bytesInBuffer=0;}else{everything=bytes;}// While we have enough data for a packet
while(endIndex<everything.byteLength){// Look for a pair of start and end sync bytes in the data..
if(everything[startIndex]===SYNC_BYTE$1&&everything[endIndex]===SYNC_BYTE$1){// We found a packet so emit it and jump one whole packet forward in
// the stream
this.trigger('data',everything.subarray(startIndex,endIndex));startIndex+=MP2T_PACKET_LENGTH$1;endIndex+=MP2T_PACKET_LENGTH$1;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex++;endIndex++;}// If there was some data left over at the end of the segment that couldn't
// possibly be a whole packet, keep it because it might be the start of a packet
// that continues in the next segment
if(startIndex<everything.byteLength){buffer.set(everything.subarray(startIndex),0);bytesInBuffer=everything.byteLength-startIndex;}};/**
     * Passes identified M2TS packets to the TransportParseStream to be parsed
    **/this.flush=function(){// If the buffer contains a whole packet when we are being flushed, emit it
// and empty the buffer. Otherwise hold onto the data because it may be
// important for decoding the next segment
if(bytesInBuffer===MP2T_PACKET_LENGTH$1&&buffer[0]===SYNC_BYTE$1){this.trigger('data',buffer);bytesInBuffer=0;}this.trigger('done');};this.endTimeline=function(){this.flush();this.trigger('endedtimeline');};this.reset=function(){bytesInBuffer=0;this.trigger('reset');};};_TransportPacketStream.prototype=new stream();/**
   * Accepts an MP2T TransportPacketStream and emits data events with parsed
   * forms of the individual transport stream packets.
   */_TransportParseStream=function TransportParseStream(){var parsePsi,parsePat,parsePmt,self;_TransportParseStream.prototype.init.call(this);self=this;this.packetsWaitingForPmt=[];this.programMapTable=undefined;parsePsi=function parsePsi(payload,psi){var offset=0;// PSI packets may be split into multiple sections and those
// sections may be split into multiple packets. If a PSI
// section starts in this packet, the payload_unit_start_indicator
// will be true and the first byte of the payload will indicate
// the offset from the current position to the start of the
// section.
if(psi.payloadUnitStartIndicator){offset+=payload[offset]+1;}if(psi.type==='pat'){parsePat(payload.subarray(offset),psi);}else{parsePmt(payload.subarray(offset),psi);}};parsePat=function parsePat(payload,pat){pat.section_number=payload[7];// eslint-disable-line camelcase
pat.last_section_number=payload[8];// eslint-disable-line camelcase
// skip the PSI header and parse the first PMT entry
self.pmtPid=(payload[10]&0x1F)<<8|payload[11];pat.pmtPid=self.pmtPid;};/**
     * Parse out the relevant fields of a Program Map Table (PMT).
     * @param payload {Uint8Array} the PMT-specific portion of an MP2T
     * packet. The first byte in this array should be the table_id
     * field.
     * @param pmt {object} the object that should be decorated with
     * fields parsed from the PMT.
     */parsePmt=function parsePmt(payload,pmt){var sectionLength,tableEnd,programInfoLength,offset;// PMTs can be sent ahead of the time when they should actually
// take effect. We don't believe this should ever be the case
// for HLS but we'll ignore "forward" PMT declarations if we see
// them. Future PMT declarations have the current_next_indicator
// set to zero.
if(!(payload[5]&0x01)){return;}// overwrite any existing program map table
self.programMapTable={video:null,audio:null,'timed-metadata':{}};// the mapping table ends at the end of the current section
sectionLength=(payload[1]&0x0f)<<8|payload[2];tableEnd=3+sectionLength-4;// to determine where the table is, we have to figure out how
// long the program info descriptors are
programInfoLength=(payload[10]&0x0f)<<8|payload[11];// advance the offset to the first entry in the mapping table
offset=12+programInfoLength;while(offset<tableEnd){var streamType=payload[offset];var pid=(payload[offset+1]&0x1F)<<8|payload[offset+2];// only map a single elementary_pid for audio and video stream types
// TODO: should this be done for metadata too? for now maintain behavior of
//       multiple metadata streams
if(streamType===streamTypes.H264_STREAM_TYPE&&self.programMapTable.video===null){self.programMapTable.video=pid;}else if(streamType===streamTypes.ADTS_STREAM_TYPE&&self.programMapTable.audio===null){self.programMapTable.audio=pid;}else if(streamType===streamTypes.METADATA_STREAM_TYPE){// map pid to stream type for metadata streams
self.programMapTable['timed-metadata'][pid]=streamType;}// move to the next table entry
// skip past the elementary stream descriptors, if present
offset+=((payload[offset+3]&0x0F)<<8|payload[offset+4])+5;}// record the map on the packet as well
pmt.programMapTable=self.programMapTable;};/**
     * Deliver a new MP2T packet to the next stream in the pipeline.
     */this.push=function(packet){var result={},offset=4;result.payloadUnitStartIndicator=!!(packet[1]&0x40);// pid is a 13-bit field starting at the last bit of packet[1]
result.pid=packet[1]&0x1f;result.pid<<=8;result.pid|=packet[2];// if an adaption field is present, its length is specified by the
// fifth byte of the TS packet header. The adaptation field is
// used to add stuffing to PES packets that don't fill a complete
// TS packet, and to specify some forms of timing and control data
// that we do not currently use.
if((packet[3]&0x30)>>>4>0x01){offset+=packet[offset]+1;}// parse the rest of the packet based on the type
if(result.pid===0){result.type='pat';parsePsi(packet.subarray(offset),result);this.trigger('data',result);}else if(result.pid===this.pmtPid){result.type='pmt';parsePsi(packet.subarray(offset),result);this.trigger('data',result);// if there are any packets waiting for a PMT to be found, process them now
while(this.packetsWaitingForPmt.length){this.processPes_.apply(this,this.packetsWaitingForPmt.shift());}}else if(this.programMapTable===undefined){// When we have not seen a PMT yet, defer further processing of
// PES packets until one has been parsed
this.packetsWaitingForPmt.push([packet,offset,result]);}else{this.processPes_(packet,offset,result);}};this.processPes_=function(packet,offset,result){// set the appropriate stream type
if(result.pid===this.programMapTable.video){result.streamType=streamTypes.H264_STREAM_TYPE;}else if(result.pid===this.programMapTable.audio){result.streamType=streamTypes.ADTS_STREAM_TYPE;}else{// if not video or audio, it is timed-metadata or unknown
// if unknown, streamType will be undefined
result.streamType=this.programMapTable['timed-metadata'][result.pid];}result.type='pes';result.data=packet.subarray(offset);this.trigger('data',result);};};_TransportParseStream.prototype=new stream();_TransportParseStream.STREAM_TYPES={h264:0x1b,adts:0x0f};/**
   * Reconsistutes program elementary stream (PES) packets from parsed
   * transport stream packets. That is, if you pipe an
   * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
   * events will be events which capture the bytes for individual PES
   * packets plus relevant metadata that has been extracted from the
   * container.
   */_ElementaryStream=function ElementaryStream(){var self=this,segmentHadPmt=false,// PES packet fragments
video={data:[],size:0},audio={data:[],size:0},timedMetadata={data:[],size:0},programMapTable,parsePes=function parsePes(payload,pes){var ptsDtsFlags;var startPrefix=payload[0]<<16|payload[1]<<8|payload[2];// default to an empty array
pes.data=new Uint8Array();// In certain live streams, the start of a TS fragment has ts packets
// that are frame data that is continuing from the previous fragment. This
// is to check that the pes data is the start of a new pes payload
if(startPrefix!==1){return;}// get the packet length, this will be 0 for video
pes.packetLength=6+(payload[4]<<8|payload[5]);// find out if this packets starts a new keyframe
pes.dataAlignmentIndicator=(payload[6]&0x04)!==0;// PES packets may be annotated with a PTS value, or a PTS value
// and a DTS value. Determine what combination of values is
// available to work with.
ptsDtsFlags=payload[7];// PTS and DTS are normally stored as a 33-bit number.  Javascript
// performs all bitwise operations on 32-bit integers but javascript
// supports a much greater range (52-bits) of integer using standard
// mathematical operations.
// We construct a 31-bit value using bitwise operators over the 31
// most significant bits and then multiply by 4 (equal to a left-shift
// of 2) before we add the final 2 least significant bits of the
// timestamp (equal to an OR.)
if(ptsDtsFlags&0xC0){// the PTS and DTS are not written out directly. For information
// on how they are encoded, see
// http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
pes.pts=(payload[9]&0x0E)<<27|(payload[10]&0xFF)<<20|(payload[11]&0xFE)<<12|(payload[12]&0xFF)<<5|(payload[13]&0xFE)>>>3;pes.pts*=4;// Left shift by 2
pes.pts+=(payload[13]&0x06)>>>1;// OR by the two LSBs
pes.dts=pes.pts;if(ptsDtsFlags&0x40){pes.dts=(payload[14]&0x0E)<<27|(payload[15]&0xFF)<<20|(payload[16]&0xFE)<<12|(payload[17]&0xFF)<<5|(payload[18]&0xFE)>>>3;pes.dts*=4;// Left shift by 2
pes.dts+=(payload[18]&0x06)>>>1;// OR by the two LSBs
}}// the data section starts immediately after the PES header.
// pes_header_data_length specifies the number of header bytes
// that follow the last byte of the field.
pes.data=payload.subarray(9+payload[8]);},/**
      * Pass completely parsed PES packets to the next stream in the pipeline
     **/flushStream=function flushStream(stream,type,forceFlush){var packetData=new Uint8Array(stream.size),event={type:type},i=0,offset=0,packetFlushable=false,fragment;// do nothing if there is not enough buffered data for a complete
// PES header
if(!stream.data.length||stream.size<9){return;}event.trackId=stream.data[0].pid;// reassemble the packet
for(i=0;i<stream.data.length;i++){fragment=stream.data[i];packetData.set(fragment.data,offset);offset+=fragment.data.byteLength;}// parse assembled packet's PES header
parsePes(packetData,event);// non-video PES packets MUST have a non-zero PES_packet_length
// check that there is enough stream data to fill the packet
packetFlushable=type==='video'||event.packetLength<=stream.size;// flush pending packets if the conditions are right
if(forceFlush||packetFlushable){stream.size=0;stream.data.length=0;}// only emit packets that are complete. this is to avoid assembling
// incomplete PES packets due to poor segmentation
if(packetFlushable){self.trigger('data',event);}};_ElementaryStream.prototype.init.call(this);/**
     * Identifies M2TS packet types and parses PES packets using metadata
     * parsed from the PMT
     **/this.push=function(data){({pat:function pat(){// we have to wait for the PMT to arrive as well before we
// have any meaningful metadata
},pes:function pes(){var stream,streamType;switch(data.streamType){case streamTypes.H264_STREAM_TYPE:stream=video;streamType='video';break;case streamTypes.ADTS_STREAM_TYPE:stream=audio;streamType='audio';break;case streamTypes.METADATA_STREAM_TYPE:stream=timedMetadata;streamType='timed-metadata';break;default:// ignore unknown stream types
return;}// if a new packet is starting, we can flush the completed
// packet
if(data.payloadUnitStartIndicator){flushStream(stream,streamType,true);}// buffer this fragment until we are sure we've received the
// complete payload
stream.data.push(data);stream.size+=data.data.byteLength;},pmt:function pmt(){var event={type:'metadata',tracks:[]};programMapTable=data.programMapTable;// translate audio and video streams to tracks
if(programMapTable.video!==null){event.tracks.push({timelineStartInfo:{baseMediaDecodeTime:0},id:+programMapTable.video,codec:'avc',type:'video'});}if(programMapTable.audio!==null){event.tracks.push({timelineStartInfo:{baseMediaDecodeTime:0},id:+programMapTable.audio,codec:'adts',type:'audio'});}segmentHadPmt=true;self.trigger('data',event);}})[data.type]();};this.reset=function(){video.size=0;video.data.length=0;audio.size=0;audio.data.length=0;this.trigger('reset');};/**
     * Flush any remaining input. Video PES packets may be of variable
     * length. Normally, the start of a new video packet can trigger the
     * finalization of the previous packet. That is not possible if no
     * more video is forthcoming, however. In that case, some other
     * mechanism (like the end of the file) has to be employed. When it is
     * clear that no additional data is forthcoming, calling this method
     * will flush the buffered packets.
     */this.flushStreams_=function(){// !!THIS ORDER IS IMPORTANT!!
// video first then audio
flushStream(video,'video');flushStream(audio,'audio');flushStream(timedMetadata,'timed-metadata');};this.flush=function(){// if on flush we haven't had a pmt emitted
// and we have a pmt to emit. emit the pmt
// so that we trigger a trackinfo downstream.
if(!segmentHadPmt&&programMapTable){var pmt={type:'metadata',tracks:[]};// translate audio and video streams to tracks
if(programMapTable.video!==null){pmt.tracks.push({timelineStartInfo:{baseMediaDecodeTime:0},id:+programMapTable.video,codec:'avc',type:'video'});}if(programMapTable.audio!==null){pmt.tracks.push({timelineStartInfo:{baseMediaDecodeTime:0},id:+programMapTable.audio,codec:'adts',type:'audio'});}self.trigger('data',pmt);}segmentHadPmt=false;this.flushStreams_();this.trigger('done');};};_ElementaryStream.prototype=new stream();var m2ts={PAT_PID:0x0000,MP2T_PACKET_LENGTH:MP2T_PACKET_LENGTH$1,TransportPacketStream:_TransportPacketStream,TransportParseStream:_TransportParseStream,ElementaryStream:_ElementaryStream,TimestampRolloverStream:TimestampRolloverStream,CaptionStream:captionStream.CaptionStream,Cea608Stream:captionStream.Cea608Stream,Cea708Stream:captionStream.Cea708Stream,MetadataStream:metadataStream};for(var type in streamTypes){if(streamTypes.hasOwnProperty(type)){m2ts[type]=streamTypes[type];}}var m2ts_1=m2ts;var ONE_SECOND_IN_TS$2=clock.ONE_SECOND_IN_TS;var _AdtsStream;var ADTS_SAMPLING_FREQUENCIES$1=[96000,88200,64000,48000,44100,32000,24000,22050,16000,12000,11025,8000,7350];/*
   * Accepts a ElementaryStream and emits data events with parsed
   * AAC Audio Frames of the individual packets. Input audio in ADTS
   * format is unpacked and re-emitted as AAC frames.
   *
   * @see http://wiki.multimedia.cx/index.php?title=ADTS
   * @see http://wiki.multimedia.cx/?title=Understanding_AAC
   */_AdtsStream=function AdtsStream(handlePartialSegments){var buffer,frameNum=0;_AdtsStream.prototype.init.call(this);this.skipWarn_=function(start,end){this.trigger('log',{level:'warn',message:"adts skiping bytes "+start+" to "+end+" in frame "+frameNum+" outside syncword"});};this.push=function(packet){var i=0,frameLength,protectionSkipBytes,oldBuffer,sampleCount,adtsFrameDuration;if(!handlePartialSegments){frameNum=0;}if(packet.type!=='audio'){// ignore non-audio data
return;}// Prepend any data in the buffer to the input data so that we can parse
// aac frames the cross a PES packet boundary
if(buffer&&buffer.length){oldBuffer=buffer;buffer=new Uint8Array(oldBuffer.byteLength+packet.data.byteLength);buffer.set(oldBuffer);buffer.set(packet.data,oldBuffer.byteLength);}else{buffer=packet.data;}// unpack any ADTS frames which have been fully received
// for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
var skip;// We use i + 7 here because we want to be able to parse the entire header.
// If we don't have enough bytes to do that, then we definitely won't have a full frame.
while(i+7<buffer.length){// Look for the start of an ADTS header..
if(buffer[i]!==0xFF||(buffer[i+1]&0xF6)!==0xF0){if(typeof skip!=='number'){skip=i;}// If a valid header was not found,  jump one forward and attempt to
// find a valid ADTS header starting at the next byte
i++;continue;}if(typeof skip==='number'){this.skipWarn_(skip,i);skip=null;}// The protection skip bit tells us if we have 2 bytes of CRC data at the
// end of the ADTS header
protectionSkipBytes=(~buffer[i+1]&0x01)*2;// Frame length is a 13 bit integer starting 16 bits from the
// end of the sync sequence
// NOTE: frame length includes the size of the header
frameLength=(buffer[i+3]&0x03)<<11|buffer[i+4]<<3|(buffer[i+5]&0xe0)>>5;sampleCount=((buffer[i+6]&0x03)+1)*1024;adtsFrameDuration=sampleCount*ONE_SECOND_IN_TS$2/ADTS_SAMPLING_FREQUENCIES$1[(buffer[i+2]&0x3c)>>>2];// If we don't have enough data to actually finish this ADTS frame,
// then we have to wait for more data
if(buffer.byteLength-i<frameLength){break;}// Otherwise, deliver the complete AAC frame
this.trigger('data',{pts:packet.pts+frameNum*adtsFrameDuration,dts:packet.dts+frameNum*adtsFrameDuration,sampleCount:sampleCount,audioobjecttype:(buffer[i+2]>>>6&0x03)+1,channelcount:(buffer[i+2]&1)<<2|(buffer[i+3]&0xc0)>>>6,samplerate:ADTS_SAMPLING_FREQUENCIES$1[(buffer[i+2]&0x3c)>>>2],samplingfrequencyindex:(buffer[i+2]&0x3c)>>>2,// assume ISO/IEC 14496-12 AudioSampleEntry default of 16
samplesize:16,// data is the frame without it's header
data:buffer.subarray(i+7+protectionSkipBytes,i+frameLength)});frameNum++;i+=frameLength;}if(typeof skip==='number'){this.skipWarn_(skip,i);skip=null;}// remove processed bytes from the buffer.
buffer=buffer.subarray(i);};this.flush=function(){frameNum=0;this.trigger('done');};this.reset=function(){buffer=void 0;this.trigger('reset');};this.endTimeline=function(){buffer=void 0;this.trigger('endedtimeline');};};_AdtsStream.prototype=new stream();var adts=_AdtsStream;/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var ExpGolomb;/**
   * Parser for exponential Golomb codes, a variable-bitwidth number encoding
   * scheme used by h264.
   */ExpGolomb=function ExpGolomb(workingData){var// the number of bytes left to examine in workingData
workingBytesAvailable=workingData.byteLength,// the current word being examined
workingWord=0,// :uint
// the number of bits left to examine in the current word
workingBitsAvailable=0;// :uint;
// ():uint
this.length=function(){return 8*workingBytesAvailable;};// ():uint
this.bitsAvailable=function(){return 8*workingBytesAvailable+workingBitsAvailable;};// ():void
this.loadWord=function(){var position=workingData.byteLength-workingBytesAvailable,workingBytes=new Uint8Array(4),availableBytes=Math.min(4,workingBytesAvailable);if(availableBytes===0){throw new Error('no bytes available');}workingBytes.set(workingData.subarray(position,position+availableBytes));workingWord=new DataView(workingBytes.buffer).getUint32(0);// track the amount of workingData that has been processed
workingBitsAvailable=availableBytes*8;workingBytesAvailable-=availableBytes;};// (count:int):void
this.skipBits=function(count){var skipBytes;// :int
if(workingBitsAvailable>count){workingWord<<=count;workingBitsAvailable-=count;}else{count-=workingBitsAvailable;skipBytes=Math.floor(count/8);count-=skipBytes*8;workingBytesAvailable-=skipBytes;this.loadWord();workingWord<<=count;workingBitsAvailable-=count;}};// (size:int):uint
this.readBits=function(size){var bits=Math.min(workingBitsAvailable,size),// :uint
valu=workingWord>>>32-bits;// :uint
// if size > 31, handle error
workingBitsAvailable-=bits;if(workingBitsAvailable>0){workingWord<<=bits;}else if(workingBytesAvailable>0){this.loadWord();}bits=size-bits;if(bits>0){return valu<<bits|this.readBits(bits);}return valu;};// ():uint
this.skipLeadingZeros=function(){var leadingZeroCount;// :uint
for(leadingZeroCount=0;leadingZeroCount<workingBitsAvailable;++leadingZeroCount){if((workingWord&0x80000000>>>leadingZeroCount)!==0){// the first bit of working word is 1
workingWord<<=leadingZeroCount;workingBitsAvailable-=leadingZeroCount;return leadingZeroCount;}}// we exhausted workingWord and still have not found a 1
this.loadWord();return leadingZeroCount+this.skipLeadingZeros();};// ():void
this.skipUnsignedExpGolomb=function(){this.skipBits(1+this.skipLeadingZeros());};// ():void
this.skipExpGolomb=function(){this.skipBits(1+this.skipLeadingZeros());};// ():uint
this.readUnsignedExpGolomb=function(){var clz=this.skipLeadingZeros();// :uint
return this.readBits(clz+1)-1;};// ():int
this.readExpGolomb=function(){var valu=this.readUnsignedExpGolomb();// :int
if(0x01&valu){// the number is odd if the low order bit is set
return 1+valu>>>1;// add 1 to make it even, and divide by 2
}return-1*(valu>>>1);// divide by two then make it negative
};// Some convenience functions
// :Boolean
this.readBoolean=function(){return this.readBits(1)===1;};// ():int
this.readUnsignedByte=function(){return this.readBits(8);};this.loadWord();};var expGolomb=ExpGolomb;var _H264Stream,_NalByteStream;var PROFILES_WITH_OPTIONAL_SPS_DATA;/**
   * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
   */_NalByteStream=function NalByteStream(){var syncPoint=0,i,buffer;_NalByteStream.prototype.init.call(this);/*
     * Scans a byte stream and triggers a data event with the NAL units found.
     * @param {Object} data Event received from H264Stream
     * @param {Uint8Array} data.data The h264 byte stream to be scanned
     *
     * @see H264Stream.push
     */this.push=function(data){var swapBuffer;if(!buffer){buffer=data.data;}else{swapBuffer=new Uint8Array(buffer.byteLength+data.data.byteLength);swapBuffer.set(buffer);swapBuffer.set(data.data,buffer.byteLength);buffer=swapBuffer;}var len=buffer.byteLength;// Rec. ITU-T H.264, Annex B
// scan for NAL unit boundaries
// a match looks like this:
// 0 0 1 .. NAL .. 0 0 1
// ^ sync point        ^ i
// or this:
// 0 0 1 .. NAL .. 0 0 0
// ^ sync point        ^ i
// advance the sync point to a NAL start, if necessary
for(;syncPoint<len-3;syncPoint++){if(buffer[syncPoint+2]===1){// the sync point is properly aligned
i=syncPoint+5;break;}}while(i<len){// look at the current byte to determine if we've hit the end of
// a NAL unit boundary
switch(buffer[i]){case 0:// skip past non-sync sequences
if(buffer[i-1]!==0){i+=2;break;}else if(buffer[i-2]!==0){i++;break;}// deliver the NAL unit if it isn't empty
if(syncPoint+3!==i-2){this.trigger('data',buffer.subarray(syncPoint+3,i-2));}// drop trailing zeroes
do{i++;}while(buffer[i]!==1&&i<len);syncPoint=i-2;i+=3;break;case 1:// skip past non-sync sequences
if(buffer[i-1]!==0||buffer[i-2]!==0){i+=3;break;}// deliver the NAL unit
this.trigger('data',buffer.subarray(syncPoint+3,i-2));syncPoint=i-2;i+=3;break;default:// the current byte isn't a one or zero, so it cannot be part
// of a sync sequence
i+=3;break;}}// filter out the NAL units that were delivered
buffer=buffer.subarray(syncPoint);i-=syncPoint;syncPoint=0;};this.reset=function(){buffer=null;syncPoint=0;this.trigger('reset');};this.flush=function(){// deliver the last buffered NAL unit
if(buffer&&buffer.byteLength>3){this.trigger('data',buffer.subarray(syncPoint+3));}// reset the stream state
buffer=null;syncPoint=0;this.trigger('done');};this.endTimeline=function(){this.flush();this.trigger('endedtimeline');};};_NalByteStream.prototype=new stream();// values of profile_idc that indicate additional fields are included in the SPS
// see Recommendation ITU-T H.264 (4/2013),
// 7.3.2.1.1 Sequence parameter set data syntax
PROFILES_WITH_OPTIONAL_SPS_DATA={100:true,110:true,122:true,244:true,44:true,83:true,86:true,118:true,128:true,// TODO: the three profiles below don't
// appear to have sps data in the specificiation anymore?
138:true,139:true,134:true};/**
   * Accepts input from a ElementaryStream and produces H.264 NAL unit data
   * events.
   */_H264Stream=function H264Stream(){var nalByteStream=new _NalByteStream(),self,trackId,currentPts,currentDts,discardEmulationPreventionBytes,readSequenceParameterSet,skipScalingList;_H264Stream.prototype.init.call(this);self=this;/*
     * Pushes a packet from a stream onto the NalByteStream
     *
     * @param {Object} packet - A packet received from a stream
     * @param {Uint8Array} packet.data - The raw bytes of the packet
     * @param {Number} packet.dts - Decode timestamp of the packet
     * @param {Number} packet.pts - Presentation timestamp of the packet
     * @param {Number} packet.trackId - The id of the h264 track this packet came from
     * @param {('video'|'audio')} packet.type - The type of packet
     *
     */this.push=function(packet){if(packet.type!=='video'){return;}trackId=packet.trackId;currentPts=packet.pts;currentDts=packet.dts;nalByteStream.push(packet);};/*
     * Identify NAL unit types and pass on the NALU, trackId, presentation and decode timestamps
     * for the NALUs to the next stream component.
     * Also, preprocess caption and sequence parameter NALUs.
     *
     * @param {Uint8Array} data - A NAL unit identified by `NalByteStream.push`
     * @see NalByteStream.push
     */nalByteStream.on('data',function(data){var event={trackId:trackId,pts:currentPts,dts:currentDts,data:data,nalUnitTypeCode:data[0]&0x1f};switch(event.nalUnitTypeCode){case 0x05:event.nalUnitType='slice_layer_without_partitioning_rbsp_idr';break;case 0x06:event.nalUnitType='sei_rbsp';event.escapedRBSP=discardEmulationPreventionBytes(data.subarray(1));break;case 0x07:event.nalUnitType='seq_parameter_set_rbsp';event.escapedRBSP=discardEmulationPreventionBytes(data.subarray(1));event.config=readSequenceParameterSet(event.escapedRBSP);break;case 0x08:event.nalUnitType='pic_parameter_set_rbsp';break;case 0x09:event.nalUnitType='access_unit_delimiter_rbsp';break;}// This triggers data on the H264Stream
self.trigger('data',event);});nalByteStream.on('done',function(){self.trigger('done');});nalByteStream.on('partialdone',function(){self.trigger('partialdone');});nalByteStream.on('reset',function(){self.trigger('reset');});nalByteStream.on('endedtimeline',function(){self.trigger('endedtimeline');});this.flush=function(){nalByteStream.flush();};this.partialFlush=function(){nalByteStream.partialFlush();};this.reset=function(){nalByteStream.reset();};this.endTimeline=function(){nalByteStream.endTimeline();};/**
     * Advance the ExpGolomb decoder past a scaling list. The scaling
     * list is optionally transmitted as part of a sequence parameter
     * set and is not relevant to transmuxing.
     * @param count {number} the number of entries in this scaling list
     * @param expGolombDecoder {object} an ExpGolomb pointed to the
     * start of a scaling list
     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
     */skipScalingList=function skipScalingList(count,expGolombDecoder){var lastScale=8,nextScale=8,j,deltaScale;for(j=0;j<count;j++){if(nextScale!==0){deltaScale=expGolombDecoder.readExpGolomb();nextScale=(lastScale+deltaScale+256)%256;}lastScale=nextScale===0?lastScale:nextScale;}};/**
     * Expunge any "Emulation Prevention" bytes from a "Raw Byte
     * Sequence Payload"
     * @param data {Uint8Array} the bytes of a RBSP from a NAL
     * unit
     * @return {Uint8Array} the RBSP without any Emulation
     * Prevention Bytes
     */discardEmulationPreventionBytes=function discardEmulationPreventionBytes(data){var length=data.byteLength,emulationPreventionBytesPositions=[],i=1,newLength,newData;// Find all `Emulation Prevention Bytes`
while(i<length-2){if(data[i]===0&&data[i+1]===0&&data[i+2]===0x03){emulationPreventionBytesPositions.push(i+2);i+=2;}else{i++;}}// If no Emulation Prevention Bytes were found just return the original
// array
if(emulationPreventionBytesPositions.length===0){return data;}// Create a new array to hold the NAL unit data
newLength=length-emulationPreventionBytesPositions.length;newData=new Uint8Array(newLength);var sourceIndex=0;for(i=0;i<newLength;sourceIndex++,i++){if(sourceIndex===emulationPreventionBytesPositions[0]){// Skip this byte
sourceIndex++;// Remove this position index
emulationPreventionBytesPositions.shift();}newData[i]=data[sourceIndex];}return newData;};/**
     * Read a sequence parameter set and return some interesting video
     * properties. A sequence parameter set is the H264 metadata that
     * describes the properties of upcoming video frames.
     * @param data {Uint8Array} the bytes of a sequence parameter set
     * @return {object} an object with configuration parsed from the
     * sequence parameter set, including the dimensions of the
     * associated video frames.
     */readSequenceParameterSet=function readSequenceParameterSet(data){var frameCropLeftOffset=0,frameCropRightOffset=0,frameCropTopOffset=0,frameCropBottomOffset=0,expGolombDecoder,profileIdc,levelIdc,profileCompatibility,chromaFormatIdc,picOrderCntType,numRefFramesInPicOrderCntCycle,picWidthInMbsMinus1,picHeightInMapUnitsMinus1,frameMbsOnlyFlag,scalingListCount,sarRatio=[1,1],aspectRatioIdc,i;expGolombDecoder=new expGolomb(data);profileIdc=expGolombDecoder.readUnsignedByte();// profile_idc
profileCompatibility=expGolombDecoder.readUnsignedByte();// constraint_set[0-5]_flag
levelIdc=expGolombDecoder.readUnsignedByte();// level_idc u(8)
expGolombDecoder.skipUnsignedExpGolomb();// seq_parameter_set_id
// some profiles have more optional data we don't need
if(PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]){chromaFormatIdc=expGolombDecoder.readUnsignedExpGolomb();if(chromaFormatIdc===3){expGolombDecoder.skipBits(1);// separate_colour_plane_flag
}expGolombDecoder.skipUnsignedExpGolomb();// bit_depth_luma_minus8
expGolombDecoder.skipUnsignedExpGolomb();// bit_depth_chroma_minus8
expGolombDecoder.skipBits(1);// qpprime_y_zero_transform_bypass_flag
if(expGolombDecoder.readBoolean()){// seq_scaling_matrix_present_flag
scalingListCount=chromaFormatIdc!==3?8:12;for(i=0;i<scalingListCount;i++){if(expGolombDecoder.readBoolean()){// seq_scaling_list_present_flag[ i ]
if(i<6){skipScalingList(16,expGolombDecoder);}else{skipScalingList(64,expGolombDecoder);}}}}}expGolombDecoder.skipUnsignedExpGolomb();// log2_max_frame_num_minus4
picOrderCntType=expGolombDecoder.readUnsignedExpGolomb();if(picOrderCntType===0){expGolombDecoder.readUnsignedExpGolomb();// log2_max_pic_order_cnt_lsb_minus4
}else if(picOrderCntType===1){expGolombDecoder.skipBits(1);// delta_pic_order_always_zero_flag
expGolombDecoder.skipExpGolomb();// offset_for_non_ref_pic
expGolombDecoder.skipExpGolomb();// offset_for_top_to_bottom_field
numRefFramesInPicOrderCntCycle=expGolombDecoder.readUnsignedExpGolomb();for(i=0;i<numRefFramesInPicOrderCntCycle;i++){expGolombDecoder.skipExpGolomb();// offset_for_ref_frame[ i ]
}}expGolombDecoder.skipUnsignedExpGolomb();// max_num_ref_frames
expGolombDecoder.skipBits(1);// gaps_in_frame_num_value_allowed_flag
picWidthInMbsMinus1=expGolombDecoder.readUnsignedExpGolomb();picHeightInMapUnitsMinus1=expGolombDecoder.readUnsignedExpGolomb();frameMbsOnlyFlag=expGolombDecoder.readBits(1);if(frameMbsOnlyFlag===0){expGolombDecoder.skipBits(1);// mb_adaptive_frame_field_flag
}expGolombDecoder.skipBits(1);// direct_8x8_inference_flag
if(expGolombDecoder.readBoolean()){// frame_cropping_flag
frameCropLeftOffset=expGolombDecoder.readUnsignedExpGolomb();frameCropRightOffset=expGolombDecoder.readUnsignedExpGolomb();frameCropTopOffset=expGolombDecoder.readUnsignedExpGolomb();frameCropBottomOffset=expGolombDecoder.readUnsignedExpGolomb();}if(expGolombDecoder.readBoolean()){// vui_parameters_present_flag
if(expGolombDecoder.readBoolean()){// aspect_ratio_info_present_flag
aspectRatioIdc=expGolombDecoder.readUnsignedByte();switch(aspectRatioIdc){case 1:sarRatio=[1,1];break;case 2:sarRatio=[12,11];break;case 3:sarRatio=[10,11];break;case 4:sarRatio=[16,11];break;case 5:sarRatio=[40,33];break;case 6:sarRatio=[24,11];break;case 7:sarRatio=[20,11];break;case 8:sarRatio=[32,11];break;case 9:sarRatio=[80,33];break;case 10:sarRatio=[18,11];break;case 11:sarRatio=[15,11];break;case 12:sarRatio=[64,33];break;case 13:sarRatio=[160,99];break;case 14:sarRatio=[4,3];break;case 15:sarRatio=[3,2];break;case 16:sarRatio=[2,1];break;case 255:{sarRatio=[expGolombDecoder.readUnsignedByte()<<8|expGolombDecoder.readUnsignedByte(),expGolombDecoder.readUnsignedByte()<<8|expGolombDecoder.readUnsignedByte()];break;}}if(sarRatio){sarRatio[0]/sarRatio[1];}}}return{profileIdc:profileIdc,levelIdc:levelIdc,profileCompatibility:profileCompatibility,width:(picWidthInMbsMinus1+1)*16-frameCropLeftOffset*2-frameCropRightOffset*2,height:(2-frameMbsOnlyFlag)*(picHeightInMapUnitsMinus1+1)*16-frameCropTopOffset*2-frameCropBottomOffset*2,// sar is sample aspect ratio
sarRatio:sarRatio};};};_H264Stream.prototype=new stream();var h264={H264Stream:_H264Stream,NalByteStream:_NalByteStream};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   *
   * Utilities to detect basic properties and metadata about Aac data.
   */var ADTS_SAMPLING_FREQUENCIES=[96000,88200,64000,48000,44100,32000,24000,22050,16000,12000,11025,8000,7350];var parseId3TagSize=function parseId3TagSize(header,byteIndex){var returnSize=header[byteIndex+6]<<21|header[byteIndex+7]<<14|header[byteIndex+8]<<7|header[byteIndex+9],flags=header[byteIndex+5],footerPresent=(flags&16)>>4;// if we get a negative returnSize clamp it to 0
returnSize=returnSize>=0?returnSize:0;if(footerPresent){return returnSize+20;}return returnSize+10;};var getId3Offset=function getId3Offset(data,offset){if(data.length-offset<10||data[offset]!=='I'.charCodeAt(0)||data[offset+1]!=='D'.charCodeAt(0)||data[offset+2]!=='3'.charCodeAt(0)){return offset;}offset+=parseId3TagSize(data,offset);return getId3Offset(data,offset);};// TODO: use vhs-utils
var isLikelyAacData$1=function isLikelyAacData(data){var offset=getId3Offset(data,0);return data.length>=offset+2&&(data[offset]&0xFF)===0xFF&&(data[offset+1]&0xF0)===0xF0&&// verify that the 2 layer bits are 0, aka this
// is not mp3 data but aac data.
(data[offset+1]&0x16)===0x10;};var parseSyncSafeInteger=function parseSyncSafeInteger(data){return data[0]<<21|data[1]<<14|data[2]<<7|data[3];};// return a percent-encoded representation of the specified byte range
// @see http://en.wikipedia.org/wiki/Percent-encoding
var percentEncode=function percentEncode(bytes,start,end){var i,result='';for(i=start;i<end;i++){result+='%'+('00'+bytes[i].toString(16)).slice(-2);}return result;};// return the string representation of the specified byte range,
// interpreted as ISO-8859-1.
var parseIso88591=function parseIso88591(bytes,start,end){return unescape(percentEncode(bytes,start,end));// jshint ignore:line
};var parseAdtsSize=function parseAdtsSize(header,byteIndex){var lowThree=(header[byteIndex+5]&0xE0)>>5,middle=header[byteIndex+4]<<3,highTwo=header[byteIndex+3]&0x3<<11;return highTwo|middle|lowThree;};var parseType$2=function parseType(header,byteIndex){if(header[byteIndex]==='I'.charCodeAt(0)&&header[byteIndex+1]==='D'.charCodeAt(0)&&header[byteIndex+2]==='3'.charCodeAt(0)){return'timed-metadata';}else if(header[byteIndex]&0xff===0xff&&(header[byteIndex+1]&0xf0)===0xf0){return'audio';}return null;};var parseSampleRate=function parseSampleRate(packet){var i=0;while(i+5<packet.length){if(packet[i]!==0xFF||(packet[i+1]&0xF6)!==0xF0){// If a valid header was not found,  jump one forward and attempt to
// find a valid ADTS header starting at the next byte
i++;continue;}return ADTS_SAMPLING_FREQUENCIES[(packet[i+2]&0x3c)>>>2];}return null;};var parseAacTimestamp=function parseAacTimestamp(packet){var frameStart,frameSize,frame,frameHeader;// find the start of the first frame and the end of the tag
frameStart=10;if(packet[5]&0x40){// advance the frame start past the extended header
frameStart+=4;// header size field
frameStart+=parseSyncSafeInteger(packet.subarray(10,14));}// parse one or more ID3 frames
// http://id3.org/id3v2.3.0#ID3v2_frame_overview
do{// determine the number of bytes in this frame
frameSize=parseSyncSafeInteger(packet.subarray(frameStart+4,frameStart+8));if(frameSize<1){return null;}frameHeader=String.fromCharCode(packet[frameStart],packet[frameStart+1],packet[frameStart+2],packet[frameStart+3]);if(frameHeader==='PRIV'){frame=packet.subarray(frameStart+10,frameStart+frameSize+10);for(var i=0;i<frame.byteLength;i++){if(frame[i]===0){var owner=parseIso88591(frame,0,i);if(owner==='com.apple.streaming.transportStreamTimestamp'){var d=frame.subarray(i+1);var size=(d[3]&0x01)<<30|d[4]<<22|d[5]<<14|d[6]<<6|d[7]>>>2;size*=4;size+=d[7]&0x03;return size;}break;}}}frameStart+=10;// advance past the frame header
frameStart+=frameSize;// advance past the frame body
}while(frameStart<packet.byteLength);return null;};var utils={isLikelyAacData:isLikelyAacData$1,parseId3TagSize:parseId3TagSize,parseAdtsSize:parseAdtsSize,parseType:parseType$2,parseSampleRate:parseSampleRate,parseAacTimestamp:parseAacTimestamp};var _AacStream;/**
   * Splits an incoming stream of binary data into ADTS and ID3 Frames.
   */_AacStream=function AacStream(){var everything=new Uint8Array(),timeStamp=0;_AacStream.prototype.init.call(this);this.setTimestamp=function(timestamp){timeStamp=timestamp;};this.push=function(bytes){var frameSize=0,byteIndex=0,bytesLeft,chunk,packet,tempLength;// If there are bytes remaining from the last segment, prepend them to the
// bytes that were pushed in
if(everything.length){tempLength=everything.length;everything=new Uint8Array(bytes.byteLength+tempLength);everything.set(everything.subarray(0,tempLength));everything.set(bytes,tempLength);}else{everything=bytes;}while(everything.length-byteIndex>=3){if(everything[byteIndex]==='I'.charCodeAt(0)&&everything[byteIndex+1]==='D'.charCodeAt(0)&&everything[byteIndex+2]==='3'.charCodeAt(0)){// Exit early because we don't have enough to parse
// the ID3 tag header
if(everything.length-byteIndex<10){break;}// check framesize
frameSize=utils.parseId3TagSize(everything,byteIndex);// Exit early if we don't have enough in the buffer
// to emit a full packet
// Add to byteIndex to support multiple ID3 tags in sequence
if(byteIndex+frameSize>everything.length){break;}chunk={type:'timed-metadata',data:everything.subarray(byteIndex,byteIndex+frameSize)};this.trigger('data',chunk);byteIndex+=frameSize;continue;}else if((everything[byteIndex]&0xff)===0xff&&(everything[byteIndex+1]&0xf0)===0xf0){// Exit early because we don't have enough to parse
// the ADTS frame header
if(everything.length-byteIndex<7){break;}frameSize=utils.parseAdtsSize(everything,byteIndex);// Exit early if we don't have enough in the buffer
// to emit a full packet
if(byteIndex+frameSize>everything.length){break;}packet={type:'audio',data:everything.subarray(byteIndex,byteIndex+frameSize),pts:timeStamp,dts:timeStamp};this.trigger('data',packet);byteIndex+=frameSize;continue;}byteIndex++;}bytesLeft=everything.length-byteIndex;if(bytesLeft>0){everything=everything.subarray(byteIndex);}else{everything=new Uint8Array();}};this.reset=function(){everything=new Uint8Array();this.trigger('reset');};this.endTimeline=function(){everything=new Uint8Array();this.trigger('endedtimeline');};};_AacStream.prototype=new stream();var aac=_AacStream;// constants
var AUDIO_PROPERTIES=['audioobjecttype','channelcount','samplerate','samplingfrequencyindex','samplesize'];var audioProperties=AUDIO_PROPERTIES;var VIDEO_PROPERTIES=['width','height','profileIdc','levelIdc','profileCompatibility','sarRatio'];var videoProperties=VIDEO_PROPERTIES;var H264Stream=h264.H264Stream;var isLikelyAacData=utils.isLikelyAacData;var ONE_SECOND_IN_TS$1=clock.ONE_SECOND_IN_TS;// object types
var _VideoSegmentStream,_AudioSegmentStream,_Transmuxer,_CoalesceStream;var retriggerForStream=function retriggerForStream(key,event){event.stream=key;this.trigger('log',event);};var addPipelineLogRetriggers=function addPipelineLogRetriggers(transmuxer,pipeline){var keys=Object.keys(pipeline);for(var i=0;i<keys.length;i++){var key=keys[i];// skip non-stream keys and headOfPipeline
// which is just a duplicate
if(key==='headOfPipeline'||!pipeline[key].on){continue;}pipeline[key].on('log',retriggerForStream.bind(transmuxer,key));}};/**
   * Compare two arrays (even typed) for same-ness
   */var arrayEquals=function arrayEquals(a,b){var i;if(a.length!==b.length){return false;}// compare the value of each element in the array
for(i=0;i<a.length;i++){if(a[i]!==b[i]){return false;}}return true;};var generateSegmentTimingInfo=function generateSegmentTimingInfo(baseMediaDecodeTime,startDts,startPts,endDts,endPts,prependedContentDuration){var ptsOffsetFromDts=startPts-startDts,decodeDuration=endDts-startDts,presentationDuration=endPts-startPts;// The PTS and DTS values are based on the actual stream times from the segment,
// however, the player time values will reflect a start from the baseMediaDecodeTime.
// In order to provide relevant values for the player times, base timing info on the
// baseMediaDecodeTime and the DTS and PTS durations of the segment.
return{start:{dts:baseMediaDecodeTime,pts:baseMediaDecodeTime+ptsOffsetFromDts},end:{dts:baseMediaDecodeTime+decodeDuration,pts:baseMediaDecodeTime+presentationDuration},prependedContentDuration:prependedContentDuration,baseMediaDecodeTime:baseMediaDecodeTime};};/**
   * Constructs a single-track, ISO BMFF media segment from AAC data
   * events. The output of this stream can be fed to a SourceBuffer
   * configured with a suitable initialization segment.
   * @param track {object} track metadata configuration
   * @param options {object} transmuxer options object
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */_AudioSegmentStream=function AudioSegmentStream(track,options){var adtsFrames=[],sequenceNumber,earliestAllowedDts=0,audioAppendStartTs=0,videoBaseMediaDecodeTime=Infinity;options=options||{};sequenceNumber=options.firstSequenceNumber||0;_AudioSegmentStream.prototype.init.call(this);this.push=function(data){trackDecodeInfo.collectDtsInfo(track,data);if(track){audioProperties.forEach(function(prop){track[prop]=data[prop];});}// buffer audio data until end() is called
adtsFrames.push(data);};this.setEarliestDts=function(earliestDts){earliestAllowedDts=earliestDts;};this.setVideoBaseMediaDecodeTime=function(baseMediaDecodeTime){videoBaseMediaDecodeTime=baseMediaDecodeTime;};this.setAudioAppendStart=function(timestamp){audioAppendStartTs=timestamp;};this.flush=function(){var frames,moof,mdat,boxes,frameDuration,segmentDuration,videoClockCyclesOfSilencePrefixed;// return early if no audio data has been observed
if(adtsFrames.length===0){this.trigger('done','AudioSegmentStream');return;}frames=audioFrameUtils.trimAdtsFramesByEarliestDts(adtsFrames,track,earliestAllowedDts);track.baseMediaDecodeTime=trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track,options.keepOriginalTimestamps);// amount of audio filled but the value is in video clock rather than audio clock
videoClockCyclesOfSilencePrefixed=audioFrameUtils.prefixWithSilence(track,frames,audioAppendStartTs,videoBaseMediaDecodeTime);// we have to build the index from byte locations to
// samples (that is, adts frames) in the audio data
track.samples=audioFrameUtils.generateSampleTable(frames);// concatenate the audio data to constuct the mdat
mdat=mp4Generator.mdat(audioFrameUtils.concatenateFrameData(frames));adtsFrames=[];moof=mp4Generator.moof(sequenceNumber,[track]);boxes=new Uint8Array(moof.byteLength+mdat.byteLength);// bump the sequence number for next time
sequenceNumber++;boxes.set(moof);boxes.set(mdat,moof.byteLength);trackDecodeInfo.clearDtsInfo(track);frameDuration=Math.ceil(ONE_SECOND_IN_TS$1*1024/track.samplerate);// TODO this check was added to maintain backwards compatibility (particularly with
// tests) on adding the timingInfo event. However, it seems unlikely that there's a
// valid use-case where an init segment/data should be triggered without associated
// frames. Leaving for now, but should be looked into.
if(frames.length){segmentDuration=frames.length*frameDuration;this.trigger('segmentTimingInfo',generateSegmentTimingInfo(// The audio track's baseMediaDecodeTime is in audio clock cycles, but the
// frame info is in video clock cycles. Convert to match expectation of
// listeners (that all timestamps will be based on video clock cycles).
clock.audioTsToVideoTs(track.baseMediaDecodeTime,track.samplerate),// frame times are already in video clock, as is segment duration
frames[0].dts,frames[0].pts,frames[0].dts+segmentDuration,frames[0].pts+segmentDuration,videoClockCyclesOfSilencePrefixed||0));this.trigger('timingInfo',{start:frames[0].pts,end:frames[0].pts+segmentDuration});}this.trigger('data',{track:track,boxes:boxes});this.trigger('done','AudioSegmentStream');};this.reset=function(){trackDecodeInfo.clearDtsInfo(track);adtsFrames=[];this.trigger('reset');};};_AudioSegmentStream.prototype=new stream();/**
   * Constructs a single-track, ISO BMFF media segment from H264 data
   * events. The output of this stream can be fed to a SourceBuffer
   * configured with a suitable initialization segment.
   * @param track {object} track metadata configuration
   * @param options {object} transmuxer options object
   * @param options.alignGopsAtEnd {boolean} If true, start from the end of the
   *        gopsToAlignWith list when attempting to align gop pts
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at 0.
   */_VideoSegmentStream=function VideoSegmentStream(track,options){var sequenceNumber,nalUnits=[],gopsToAlignWith=[],config,pps;options=options||{};sequenceNumber=options.firstSequenceNumber||0;_VideoSegmentStream.prototype.init.call(this);delete track.minPTS;this.gopCache_=[];/**
      * Constructs a ISO BMFF segment given H264 nalUnits
      * @param {Object} nalUnit A data event representing a nalUnit
      * @param {String} nalUnit.nalUnitType
      * @param {Object} nalUnit.config Properties for a mp4 track
      * @param {Uint8Array} nalUnit.data The nalUnit bytes
      * @see lib/codecs/h264.js
     **/this.push=function(nalUnit){trackDecodeInfo.collectDtsInfo(track,nalUnit);// record the track config
if(nalUnit.nalUnitType==='seq_parameter_set_rbsp'&&!config){config=nalUnit.config;track.sps=[nalUnit.data];videoProperties.forEach(function(prop){track[prop]=config[prop];},this);}if(nalUnit.nalUnitType==='pic_parameter_set_rbsp'&&!pps){pps=nalUnit.data;track.pps=[nalUnit.data];}// buffer video until flush() is called
nalUnits.push(nalUnit);};/**
      * Pass constructed ISO BMFF track and boxes on to the
      * next stream in the pipeline
     **/this.flush=function(){var frames,gopForFusion,gops,moof,mdat,boxes,prependedContentDuration=0,firstGop,lastGop;// Throw away nalUnits at the start of the byte stream until
// we find the first AUD
while(nalUnits.length){if(nalUnits[0].nalUnitType==='access_unit_delimiter_rbsp'){break;}nalUnits.shift();}// Return early if no video data has been observed
if(nalUnits.length===0){this.resetStream_();this.trigger('done','VideoSegmentStream');return;}// Organize the raw nal-units into arrays that represent
// higher-level constructs such as frames and gops
// (group-of-pictures)
frames=frameUtils.groupNalsIntoFrames(nalUnits);gops=frameUtils.groupFramesIntoGops(frames);// If the first frame of this fragment is not a keyframe we have
// a problem since MSE (on Chrome) requires a leading keyframe.
//
// We have two approaches to repairing this situation:
// 1) GOP-FUSION:
//    This is where we keep track of the GOPS (group-of-pictures)
//    from previous fragments and attempt to find one that we can
//    prepend to the current fragment in order to create a valid
//    fragment.
// 2) KEYFRAME-PULLING:
//    Here we search for the first keyframe in the fragment and
//    throw away all the frames between the start of the fragment
//    and that keyframe. We then extend the duration and pull the
//    PTS of the keyframe forward so that it covers the time range
//    of the frames that were disposed of.
//
// #1 is far prefereable over #2 which can cause "stuttering" but
// requires more things to be just right.
if(!gops[0][0].keyFrame){// Search for a gop for fusion from our gopCache
gopForFusion=this.getGopForFusion_(nalUnits[0],track);if(gopForFusion){// in order to provide more accurate timing information about the segment, save
// the number of seconds prepended to the original segment due to GOP fusion
prependedContentDuration=gopForFusion.duration;gops.unshift(gopForFusion);// Adjust Gops' metadata to account for the inclusion of the
// new gop at the beginning
gops.byteLength+=gopForFusion.byteLength;gops.nalCount+=gopForFusion.nalCount;gops.pts=gopForFusion.pts;gops.dts=gopForFusion.dts;gops.duration+=gopForFusion.duration;}else{// If we didn't find a candidate gop fall back to keyframe-pulling
gops=frameUtils.extendFirstKeyFrame(gops);}}// Trim gops to align with gopsToAlignWith
if(gopsToAlignWith.length){var alignedGops;if(options.alignGopsAtEnd){alignedGops=this.alignGopsAtEnd_(gops);}else{alignedGops=this.alignGopsAtStart_(gops);}if(!alignedGops){// save all the nals in the last GOP into the gop cache
this.gopCache_.unshift({gop:gops.pop(),pps:track.pps,sps:track.sps});// Keep a maximum of 6 GOPs in the cache
this.gopCache_.length=Math.min(6,this.gopCache_.length);// Clear nalUnits
nalUnits=[];// return early no gops can be aligned with desired gopsToAlignWith
this.resetStream_();this.trigger('done','VideoSegmentStream');return;}// Some gops were trimmed. clear dts info so minSegmentDts and pts are correct
// when recalculated before sending off to CoalesceStream
trackDecodeInfo.clearDtsInfo(track);gops=alignedGops;}trackDecodeInfo.collectDtsInfo(track,gops);// First, we have to build the index from byte locations to
// samples (that is, frames) in the video data
track.samples=frameUtils.generateSampleTable(gops);// Concatenate the video data and construct the mdat
mdat=mp4Generator.mdat(frameUtils.concatenateNalData(gops));track.baseMediaDecodeTime=trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track,options.keepOriginalTimestamps);this.trigger('processedGopsInfo',gops.map(function(gop){return{pts:gop.pts,dts:gop.dts,byteLength:gop.byteLength};}));firstGop=gops[0];lastGop=gops[gops.length-1];this.trigger('segmentTimingInfo',generateSegmentTimingInfo(track.baseMediaDecodeTime,firstGop.dts,firstGop.pts,lastGop.dts+lastGop.duration,lastGop.pts+lastGop.duration,prependedContentDuration));this.trigger('timingInfo',{start:gops[0].pts,end:gops[gops.length-1].pts+gops[gops.length-1].duration});// save all the nals in the last GOP into the gop cache
this.gopCache_.unshift({gop:gops.pop(),pps:track.pps,sps:track.sps});// Keep a maximum of 6 GOPs in the cache
this.gopCache_.length=Math.min(6,this.gopCache_.length);// Clear nalUnits
nalUnits=[];this.trigger('baseMediaDecodeTime',track.baseMediaDecodeTime);this.trigger('timelineStartInfo',track.timelineStartInfo);moof=mp4Generator.moof(sequenceNumber,[track]);// it would be great to allocate this array up front instead of
// throwing away hundreds of media segment fragments
boxes=new Uint8Array(moof.byteLength+mdat.byteLength);// Bump the sequence number for next time
sequenceNumber++;boxes.set(moof);boxes.set(mdat,moof.byteLength);this.trigger('data',{track:track,boxes:boxes});this.resetStream_();// Continue with the flush process now
this.trigger('done','VideoSegmentStream');};this.reset=function(){this.resetStream_();nalUnits=[];this.gopCache_.length=0;gopsToAlignWith.length=0;this.trigger('reset');};this.resetStream_=function(){trackDecodeInfo.clearDtsInfo(track);// reset config and pps because they may differ across segments
// for instance, when we are rendition switching
config=undefined;pps=undefined;};// Search for a candidate Gop for gop-fusion from the gop cache and
// return it or return null if no good candidate was found
this.getGopForFusion_=function(nalUnit){var halfSecond=45000,// Half-a-second in a 90khz clock
allowableOverlap=10000,// About 3 frames @ 30fps
nearestDistance=Infinity,dtsDistance,nearestGopObj,currentGop,currentGopObj,i;// Search for the GOP nearest to the beginning of this nal unit
for(i=0;i<this.gopCache_.length;i++){currentGopObj=this.gopCache_[i];currentGop=currentGopObj.gop;// Reject Gops with different SPS or PPS
if(!(track.pps&&arrayEquals(track.pps[0],currentGopObj.pps[0]))||!(track.sps&&arrayEquals(track.sps[0],currentGopObj.sps[0]))){continue;}// Reject Gops that would require a negative baseMediaDecodeTime
if(currentGop.dts<track.timelineStartInfo.dts){continue;}// The distance between the end of the gop and the start of the nalUnit
dtsDistance=nalUnit.dts-currentGop.dts-currentGop.duration;// Only consider GOPS that start before the nal unit and end within
// a half-second of the nal unit
if(dtsDistance>=-allowableOverlap&&dtsDistance<=halfSecond){// Always use the closest GOP we found if there is more than
// one candidate
if(!nearestGopObj||nearestDistance>dtsDistance){nearestGopObj=currentGopObj;nearestDistance=dtsDistance;}}}if(nearestGopObj){return nearestGopObj.gop;}return null;};// trim gop list to the first gop found that has a matching pts with a gop in the list
// of gopsToAlignWith starting from the START of the list
this.alignGopsAtStart_=function(gops){var alignIndex,gopIndex,align,gop,byteLength,nalCount,duration,alignedGops;byteLength=gops.byteLength;nalCount=gops.nalCount;duration=gops.duration;alignIndex=gopIndex=0;while(alignIndex<gopsToAlignWith.length&&gopIndex<gops.length){align=gopsToAlignWith[alignIndex];gop=gops[gopIndex];if(align.pts===gop.pts){break;}if(gop.pts>align.pts){// this current gop starts after the current gop we want to align on, so increment
// align index
alignIndex++;continue;}// current gop starts before the current gop we want to align on. so increment gop
// index
gopIndex++;byteLength-=gop.byteLength;nalCount-=gop.nalCount;duration-=gop.duration;}if(gopIndex===0){// no gops to trim
return gops;}if(gopIndex===gops.length){// all gops trimmed, skip appending all gops
return null;}alignedGops=gops.slice(gopIndex);alignedGops.byteLength=byteLength;alignedGops.duration=duration;alignedGops.nalCount=nalCount;alignedGops.pts=alignedGops[0].pts;alignedGops.dts=alignedGops[0].dts;return alignedGops;};// trim gop list to the first gop found that has a matching pts with a gop in the list
// of gopsToAlignWith starting from the END of the list
this.alignGopsAtEnd_=function(gops){var alignIndex,gopIndex,align,gop,alignEndIndex,matchFound;alignIndex=gopsToAlignWith.length-1;gopIndex=gops.length-1;alignEndIndex=null;matchFound=false;while(alignIndex>=0&&gopIndex>=0){align=gopsToAlignWith[alignIndex];gop=gops[gopIndex];if(align.pts===gop.pts){matchFound=true;break;}if(align.pts>gop.pts){alignIndex--;continue;}if(alignIndex===gopsToAlignWith.length-1){// gop.pts is greater than the last alignment candidate. If no match is found
// by the end of this loop, we still want to append gops that come after this
// point
alignEndIndex=gopIndex;}gopIndex--;}if(!matchFound&&alignEndIndex===null){return null;}var trimIndex;if(matchFound){trimIndex=gopIndex;}else{trimIndex=alignEndIndex;}if(trimIndex===0){return gops;}var alignedGops=gops.slice(trimIndex);var metadata=alignedGops.reduce(function(total,gop){total.byteLength+=gop.byteLength;total.duration+=gop.duration;total.nalCount+=gop.nalCount;return total;},{byteLength:0,duration:0,nalCount:0});alignedGops.byteLength=metadata.byteLength;alignedGops.duration=metadata.duration;alignedGops.nalCount=metadata.nalCount;alignedGops.pts=alignedGops[0].pts;alignedGops.dts=alignedGops[0].dts;return alignedGops;};this.alignGopsWith=function(newGopsToAlignWith){gopsToAlignWith=newGopsToAlignWith;};};_VideoSegmentStream.prototype=new stream();/**
   * A Stream that can combine multiple streams (ie. audio & video)
   * into a single output segment for MSE. Also supports audio-only
   * and video-only streams.
   * @param options {object} transmuxer options object
   * @param options.keepOriginalTimestamps {boolean} If true, keep the timestamps
   *        in the source; false to adjust the first segment to start at media timeline start.
   */_CoalesceStream=function CoalesceStream(options,metadataStream){// Number of Tracks per output segment
// If greater than 1, we combine multiple
// tracks into a single segment
this.numberOfTracks=0;this.metadataStream=metadataStream;options=options||{};if(typeof options.remux!=='undefined'){this.remuxTracks=!!options.remux;}else{this.remuxTracks=true;}if(typeof options.keepOriginalTimestamps==='boolean'){this.keepOriginalTimestamps=options.keepOriginalTimestamps;}else{this.keepOriginalTimestamps=false;}this.pendingTracks=[];this.videoTrack=null;this.pendingBoxes=[];this.pendingCaptions=[];this.pendingMetadata=[];this.pendingBytes=0;this.emittedTracks=0;_CoalesceStream.prototype.init.call(this);// Take output from multiple
this.push=function(output){// buffer incoming captions until the associated video segment
// finishes
if(output.text){return this.pendingCaptions.push(output);}// buffer incoming id3 tags until the final flush
if(output.frames){return this.pendingMetadata.push(output);}// Add this track to the list of pending tracks and store
// important information required for the construction of
// the final segment
this.pendingTracks.push(output.track);this.pendingBytes+=output.boxes.byteLength;// TODO: is there an issue for this against chrome?
// We unshift audio and push video because
// as of Chrome 75 when switching from
// one init segment to another if the video
// mdat does not appear after the audio mdat
// only audio will play for the duration of our transmux.
if(output.track.type==='video'){this.videoTrack=output.track;this.pendingBoxes.push(output.boxes);}if(output.track.type==='audio'){this.audioTrack=output.track;this.pendingBoxes.unshift(output.boxes);}};};_CoalesceStream.prototype=new stream();_CoalesceStream.prototype.flush=function(flushSource){var offset=0,event={captions:[],captionStreams:{},metadata:[],info:{}},caption,id3,initSegment,timelineStartPts=0,i;if(this.pendingTracks.length<this.numberOfTracks){if(flushSource!=='VideoSegmentStream'&&flushSource!=='AudioSegmentStream'){// Return because we haven't received a flush from a data-generating
// portion of the segment (meaning that we have only recieved meta-data
// or captions.)
return;}else if(this.remuxTracks){// Return until we have enough tracks from the pipeline to remux (if we
// are remuxing audio and video into a single MP4)
return;}else if(this.pendingTracks.length===0){// In the case where we receive a flush without any data having been
// received we consider it an emitted track for the purposes of coalescing
// `done` events.
// We do this for the case where there is an audio and video track in the
// segment but no audio data. (seen in several playlists with alternate
// audio tracks and no audio present in the main TS segments.)
this.emittedTracks++;if(this.emittedTracks>=this.numberOfTracks){this.trigger('done');this.emittedTracks=0;}return;}}if(this.videoTrack){timelineStartPts=this.videoTrack.timelineStartInfo.pts;videoProperties.forEach(function(prop){event.info[prop]=this.videoTrack[prop];},this);}else if(this.audioTrack){timelineStartPts=this.audioTrack.timelineStartInfo.pts;audioProperties.forEach(function(prop){event.info[prop]=this.audioTrack[prop];},this);}if(this.videoTrack||this.audioTrack){if(this.pendingTracks.length===1){event.type=this.pendingTracks[0].type;}else{event.type='combined';}this.emittedTracks+=this.pendingTracks.length;initSegment=mp4Generator.initSegment(this.pendingTracks);// Create a new typed array to hold the init segment
event.initSegment=new Uint8Array(initSegment.byteLength);// Create an init segment containing a moov
// and track definitions
event.initSegment.set(initSegment);// Create a new typed array to hold the moof+mdats
event.data=new Uint8Array(this.pendingBytes);// Append each moof+mdat (one per track) together
for(i=0;i<this.pendingBoxes.length;i++){event.data.set(this.pendingBoxes[i],offset);offset+=this.pendingBoxes[i].byteLength;}// Translate caption PTS times into second offsets to match the
// video timeline for the segment, and add track info
for(i=0;i<this.pendingCaptions.length;i++){caption=this.pendingCaptions[i];caption.startTime=clock.metadataTsToSeconds(caption.startPts,timelineStartPts,this.keepOriginalTimestamps);caption.endTime=clock.metadataTsToSeconds(caption.endPts,timelineStartPts,this.keepOriginalTimestamps);event.captionStreams[caption.stream]=true;event.captions.push(caption);}// Translate ID3 frame PTS times into second offsets to match the
// video timeline for the segment
for(i=0;i<this.pendingMetadata.length;i++){id3=this.pendingMetadata[i];id3.cueTime=clock.metadataTsToSeconds(id3.pts,timelineStartPts,this.keepOriginalTimestamps);event.metadata.push(id3);}// We add this to every single emitted segment even though we only need
// it for the first
event.metadata.dispatchType=this.metadataStream.dispatchType;// Reset stream state
this.pendingTracks.length=0;this.videoTrack=null;this.pendingBoxes.length=0;this.pendingCaptions.length=0;this.pendingBytes=0;this.pendingMetadata.length=0;// Emit the built segment
// We include captions and ID3 tags for backwards compatibility,
// ideally we should send only video and audio in the data event
this.trigger('data',event);// Emit each caption to the outside world
// Ideally, this would happen immediately on parsing captions,
// but we need to ensure that video data is sent back first
// so that caption timing can be adjusted to match video timing
for(i=0;i<event.captions.length;i++){caption=event.captions[i];this.trigger('caption',caption);}// Emit each id3 tag to the outside world
// Ideally, this would happen immediately on parsing the tag,
// but we need to ensure that video data is sent back first
// so that ID3 frame timing can be adjusted to match video timing
for(i=0;i<event.metadata.length;i++){id3=event.metadata[i];this.trigger('id3Frame',id3);}}// Only emit `done` if all tracks have been flushed and emitted
if(this.emittedTracks>=this.numberOfTracks){this.trigger('done');this.emittedTracks=0;}};_CoalesceStream.prototype.setRemux=function(val){this.remuxTracks=val;};/**
   * A Stream that expects MP2T binary data as input and produces
   * corresponding media segments, suitable for use with Media Source
   * Extension (MSE) implementations that support the ISO BMFF byte
   * stream format, like Chrome.
   */_Transmuxer=function Transmuxer(options){var self=this,hasFlushed=true,videoTrack,audioTrack;_Transmuxer.prototype.init.call(this);options=options||{};this.baseMediaDecodeTime=options.baseMediaDecodeTime||0;this.transmuxPipeline_={};this.setupAacPipeline=function(){var pipeline={};this.transmuxPipeline_=pipeline;pipeline.type='aac';pipeline.metadataStream=new m2ts_1.MetadataStream();// set up the parsing pipeline
pipeline.aacStream=new aac();pipeline.audioTimestampRolloverStream=new m2ts_1.TimestampRolloverStream('audio');pipeline.timedMetadataTimestampRolloverStream=new m2ts_1.TimestampRolloverStream('timed-metadata');pipeline.adtsStream=new adts();pipeline.coalesceStream=new _CoalesceStream(options,pipeline.metadataStream);pipeline.headOfPipeline=pipeline.aacStream;pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);pipeline.metadataStream.on('timestamp',function(frame){pipeline.aacStream.setTimestamp(frame.timeStamp);});pipeline.aacStream.on('data',function(data){if(data.type!=='timed-metadata'&&data.type!=='audio'||pipeline.audioSegmentStream){return;}audioTrack=audioTrack||{timelineStartInfo:{baseMediaDecodeTime:self.baseMediaDecodeTime},codec:'adts',type:'audio'};// hook up the audio segment stream to the first track with aac data
pipeline.coalesceStream.numberOfTracks++;pipeline.audioSegmentStream=new _AudioSegmentStream(audioTrack,options);pipeline.audioSegmentStream.on('log',self.getLogTrigger_('audioSegmentStream'));pipeline.audioSegmentStream.on('timingInfo',self.trigger.bind(self,'audioTimingInfo'));// Set up the final part of the audio pipeline
pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);// emit pmt info
self.trigger('trackinfo',{hasAudio:!!audioTrack,hasVideo:!!videoTrack});});// Re-emit any data coming from the coalesce stream to the outside world
pipeline.coalesceStream.on('data',this.trigger.bind(this,'data'));// Let the consumer know we have finished flushing the entire pipeline
pipeline.coalesceStream.on('done',this.trigger.bind(this,'done'));addPipelineLogRetriggers(this,pipeline);};this.setupTsPipeline=function(){var pipeline={};this.transmuxPipeline_=pipeline;pipeline.type='ts';pipeline.metadataStream=new m2ts_1.MetadataStream();// set up the parsing pipeline
pipeline.packetStream=new m2ts_1.TransportPacketStream();pipeline.parseStream=new m2ts_1.TransportParseStream();pipeline.elementaryStream=new m2ts_1.ElementaryStream();pipeline.timestampRolloverStream=new m2ts_1.TimestampRolloverStream();pipeline.adtsStream=new adts();pipeline.h264Stream=new H264Stream();pipeline.captionStream=new m2ts_1.CaptionStream(options);pipeline.coalesceStream=new _CoalesceStream(options,pipeline.metadataStream);pipeline.headOfPipeline=pipeline.packetStream;// disassemble MPEG2-TS packets into elementary streams
pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream).pipe(pipeline.timestampRolloverStream);// !!THIS ORDER IS IMPORTANT!!
// demux the streams
pipeline.timestampRolloverStream.pipe(pipeline.h264Stream);pipeline.timestampRolloverStream.pipe(pipeline.adtsStream);pipeline.timestampRolloverStream.pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);// Hook up CEA-608/708 caption stream
pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);pipeline.elementaryStream.on('data',function(data){var i;if(data.type==='metadata'){i=data.tracks.length;// scan the tracks listed in the metadata
while(i--){if(!videoTrack&&data.tracks[i].type==='video'){videoTrack=data.tracks[i];videoTrack.timelineStartInfo.baseMediaDecodeTime=self.baseMediaDecodeTime;}else if(!audioTrack&&data.tracks[i].type==='audio'){audioTrack=data.tracks[i];audioTrack.timelineStartInfo.baseMediaDecodeTime=self.baseMediaDecodeTime;}}// hook up the video segment stream to the first track with h264 data
if(videoTrack&&!pipeline.videoSegmentStream){pipeline.coalesceStream.numberOfTracks++;pipeline.videoSegmentStream=new _VideoSegmentStream(videoTrack,options);pipeline.videoSegmentStream.on('log',self.getLogTrigger_('videoSegmentStream'));pipeline.videoSegmentStream.on('timelineStartInfo',function(timelineStartInfo){// When video emits timelineStartInfo data after a flush, we forward that
// info to the AudioSegmentStream, if it exists, because video timeline
// data takes precedence.  Do not do this if keepOriginalTimestamps is set,
// because this is a particularly subtle form of timestamp alteration.
if(audioTrack&&!options.keepOriginalTimestamps){audioTrack.timelineStartInfo=timelineStartInfo;// On the first segment we trim AAC frames that exist before the
// very earliest DTS we have seen in video because Chrome will
// interpret any video track with a baseMediaDecodeTime that is
// non-zero as a gap.
pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts-self.baseMediaDecodeTime);}});pipeline.videoSegmentStream.on('processedGopsInfo',self.trigger.bind(self,'gopInfo'));pipeline.videoSegmentStream.on('segmentTimingInfo',self.trigger.bind(self,'videoSegmentTimingInfo'));pipeline.videoSegmentStream.on('baseMediaDecodeTime',function(baseMediaDecodeTime){if(audioTrack){pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);}});pipeline.videoSegmentStream.on('timingInfo',self.trigger.bind(self,'videoTimingInfo'));// Set up the final part of the video pipeline
pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);}if(audioTrack&&!pipeline.audioSegmentStream){// hook up the audio segment stream to the first track with aac data
pipeline.coalesceStream.numberOfTracks++;pipeline.audioSegmentStream=new _AudioSegmentStream(audioTrack,options);pipeline.audioSegmentStream.on('log',self.getLogTrigger_('audioSegmentStream'));pipeline.audioSegmentStream.on('timingInfo',self.trigger.bind(self,'audioTimingInfo'));pipeline.audioSegmentStream.on('segmentTimingInfo',self.trigger.bind(self,'audioSegmentTimingInfo'));// Set up the final part of the audio pipeline
pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);}// emit pmt info
self.trigger('trackinfo',{hasAudio:!!audioTrack,hasVideo:!!videoTrack});}});// Re-emit any data coming from the coalesce stream to the outside world
pipeline.coalesceStream.on('data',this.trigger.bind(this,'data'));pipeline.coalesceStream.on('id3Frame',function(id3Frame){id3Frame.dispatchType=pipeline.metadataStream.dispatchType;self.trigger('id3Frame',id3Frame);});pipeline.coalesceStream.on('caption',this.trigger.bind(this,'caption'));// Let the consumer know we have finished flushing the entire pipeline
pipeline.coalesceStream.on('done',this.trigger.bind(this,'done'));addPipelineLogRetriggers(this,pipeline);};// hook up the segment streams once track metadata is delivered
this.setBaseMediaDecodeTime=function(baseMediaDecodeTime){var pipeline=this.transmuxPipeline_;if(!options.keepOriginalTimestamps){this.baseMediaDecodeTime=baseMediaDecodeTime;}if(audioTrack){audioTrack.timelineStartInfo.dts=undefined;audioTrack.timelineStartInfo.pts=undefined;trackDecodeInfo.clearDtsInfo(audioTrack);if(pipeline.audioTimestampRolloverStream){pipeline.audioTimestampRolloverStream.discontinuity();}}if(videoTrack){if(pipeline.videoSegmentStream){pipeline.videoSegmentStream.gopCache_=[];}videoTrack.timelineStartInfo.dts=undefined;videoTrack.timelineStartInfo.pts=undefined;trackDecodeInfo.clearDtsInfo(videoTrack);pipeline.captionStream.reset();}if(pipeline.timestampRolloverStream){pipeline.timestampRolloverStream.discontinuity();}};this.setAudioAppendStart=function(timestamp){if(audioTrack){this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);}};this.setRemux=function(val){var pipeline=this.transmuxPipeline_;options.remux=val;if(pipeline&&pipeline.coalesceStream){pipeline.coalesceStream.setRemux(val);}};this.alignGopsWith=function(gopsToAlignWith){if(videoTrack&&this.transmuxPipeline_.videoSegmentStream){this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);}};this.getLogTrigger_=function(key){var self=this;return function(event){event.stream=key;self.trigger('log',event);};};// feed incoming data to the front of the parsing pipeline
this.push=function(data){if(hasFlushed){var isAac=isLikelyAacData(data);if(isAac&&this.transmuxPipeline_.type!=='aac'){this.setupAacPipeline();}else if(!isAac&&this.transmuxPipeline_.type!=='ts'){this.setupTsPipeline();}hasFlushed=false;}this.transmuxPipeline_.headOfPipeline.push(data);};// flush any buffered data
this.flush=function(){hasFlushed=true;// Start at the top of the pipeline and flush all pending work
this.transmuxPipeline_.headOfPipeline.flush();};this.endTimeline=function(){this.transmuxPipeline_.headOfPipeline.endTimeline();};this.reset=function(){if(this.transmuxPipeline_.headOfPipeline){this.transmuxPipeline_.headOfPipeline.reset();}};// Caption data has to be reset when seeking outside buffered range
this.resetCaptions=function(){if(this.transmuxPipeline_.captionStream){this.transmuxPipeline_.captionStream.reset();}};};_Transmuxer.prototype=new stream();var transmuxer={Transmuxer:_Transmuxer,VideoSegmentStream:_VideoSegmentStream,AudioSegmentStream:_AudioSegmentStream,AUDIO_PROPERTIES:audioProperties,VIDEO_PROPERTIES:videoProperties,// exported for testing
generateSegmentTimingInfo:generateSegmentTimingInfo};/**
   * mux.js
   *
   * Copyright (c) Brightcove
   * Licensed Apache-2.0 https://github.com/videojs/mux.js/blob/master/LICENSE
   */var toUnsigned$3=function toUnsigned(value){return value>>>0;};var toHexString$1=function toHexString(value){return('00'+value.toString(16)).slice(-2);};var bin={toUnsigned:toUnsigned$3,toHexString:toHexString$1};var parseType$1=function parseType(buffer){var result='';result+=String.fromCharCode(buffer[0]);result+=String.fromCharCode(buffer[1]);result+=String.fromCharCode(buffer[2]);result+=String.fromCharCode(buffer[3]);return result;};var parseType_1=parseType$1;var toUnsigned$2=bin.toUnsigned;var findBox=function findBox(data,path){var results=[],i,size,type,end,subresults;if(!path.length){// short-circuit the search for empty paths
return null;}for(i=0;i<data.byteLength;){size=toUnsigned$2(data[i]<<24|data[i+1]<<16|data[i+2]<<8|data[i+3]);type=parseType_1(data.subarray(i+4,i+8));end=size>1?i+size:data.byteLength;if(type===path[0]){if(path.length===1){// this is the end of the path and we've found the box we were
// looking for
results.push(data.subarray(i+8,end));}else{// recursively search for the next box along the path
subresults=findBox(data.subarray(i+8,end),path.slice(1));if(subresults.length){results=results.concat(subresults);}}}i=end;}// we've finished searching all of data
return results;};var findBox_1=findBox;var toUnsigned$1=bin.toUnsigned;var getUint64$1=numbers.getUint64;var tfdt=function tfdt(data){var result={version:data[0],flags:new Uint8Array(data.subarray(1,4))};if(result.version===1){result.baseMediaDecodeTime=getUint64$1(data.subarray(4));}else{result.baseMediaDecodeTime=toUnsigned$1(data[4]<<24|data[5]<<16|data[6]<<8|data[7]);}return result;};var parseTfdt=tfdt;var parseSampleFlags=function parseSampleFlags(flags){return{isLeading:(flags[0]&0x0c)>>>2,dependsOn:flags[0]&0x03,isDependedOn:(flags[1]&0xc0)>>>6,hasRedundancy:(flags[1]&0x30)>>>4,paddingValue:(flags[1]&0x0e)>>>1,isNonSyncSample:flags[1]&0x01,degradationPriority:flags[2]<<8|flags[3]};};var parseSampleFlags_1=parseSampleFlags;var trun=function trun(data){var result={version:data[0],flags:new Uint8Array(data.subarray(1,4)),samples:[]},view=new DataView(data.buffer,data.byteOffset,data.byteLength),// Flag interpretation
dataOffsetPresent=result.flags[2]&0x01,// compare with 2nd byte of 0x1
firstSampleFlagsPresent=result.flags[2]&0x04,// compare with 2nd byte of 0x4
sampleDurationPresent=result.flags[1]&0x01,// compare with 2nd byte of 0x100
sampleSizePresent=result.flags[1]&0x02,// compare with 2nd byte of 0x200
sampleFlagsPresent=result.flags[1]&0x04,// compare with 2nd byte of 0x400
sampleCompositionTimeOffsetPresent=result.flags[1]&0x08,// compare with 2nd byte of 0x800
sampleCount=view.getUint32(4),offset=8,sample;if(dataOffsetPresent){// 32 bit signed integer
result.dataOffset=view.getInt32(offset);offset+=4;}// Overrides the flags for the first sample only. The order of
// optional values will be: duration, size, compositionTimeOffset
if(firstSampleFlagsPresent&&sampleCount){sample={flags:parseSampleFlags_1(data.subarray(offset,offset+4))};offset+=4;if(sampleDurationPresent){sample.duration=view.getUint32(offset);offset+=4;}if(sampleSizePresent){sample.size=view.getUint32(offset);offset+=4;}if(sampleCompositionTimeOffsetPresent){if(result.version===1){sample.compositionTimeOffset=view.getInt32(offset);}else{sample.compositionTimeOffset=view.getUint32(offset);}offset+=4;}result.samples.push(sample);sampleCount--;}while(sampleCount--){sample={};if(sampleDurationPresent){sample.duration=view.getUint32(offset);offset+=4;}if(sampleSizePresent){sample.size=view.getUint32(offset);offset+=4;}if(sampleFlagsPresent){sample.flags=parseSampleFlags_1(data.subarray(offset,offset+4));offset+=4;}if(sampleCompositionTimeOffsetPresent){if(result.version===1){sample.compositionTimeOffset=view.getInt32(offset);}else{sample.compositionTimeOffset=view.getUint32(offset);}offset+=4;}result.samples.push(sample);}return result;};var parseTrun=trun;var tfhd=function tfhd(data){var view=new DataView(data.buffer,data.byteOffset,data.byteLength),result={version:data[0],flags:new Uint8Array(data.subarray(1,4)),trackId:view.getUint32(4)},baseDataOffsetPresent=result.flags[2]&0x01,sampleDescriptionIndexPresent=result.flags[2]&0x02,defaultSampleDurationPresent=result.flags[2]&0x08,defaultSampleSizePresent=result.flags[2]&0x10,defaultSampleFlagsPresent=result.flags[2]&0x20,durationIsEmpty=result.flags[0]&0x010000,defaultBaseIsMoof=result.flags[0]&0x020000,i;i=8;if(baseDataOffsetPresent){i+=4;// truncate top 4 bytes
// FIXME: should we read the full 64 bits?
result.baseDataOffset=view.getUint32(12);i+=4;}if(sampleDescriptionIndexPresent){result.sampleDescriptionIndex=view.getUint32(i);i+=4;}if(defaultSampleDurationPresent){result.defaultSampleDuration=view.getUint32(i);i+=4;}if(defaultSampleSizePresent){result.defaultSampleSize=view.getUint32(i);i+=4;}if(defaultSampleFlagsPresent){result.defaultSampleFlags=view.getUint32(i);}if(durationIsEmpty){result.durationIsEmpty=true;}if(!baseDataOffsetPresent&&defaultBaseIsMoof){result.baseDataOffsetIsMoof=true;}return result;};var parseTfhd=tfhd;var commonjsGlobal=typeof globalThis!=='undefined'?globalThis:typeof window!=='undefined'?window:typeof __webpack_require__.g!=='undefined'?__webpack_require__.g:typeof self!=='undefined'?self:{};var win;if(typeof window!=="undefined"){win=window;}else if(typeof commonjsGlobal!=="undefined"){win=commonjsGlobal;}else if(typeof self!=="undefined"){win=self;}else{win={};}var window_1=win;var discardEmulationPreventionBytes=captionPacketParser.discardEmulationPreventionBytes;var CaptionStream=captionStream.CaptionStream;/**
    * Maps an offset in the mdat to a sample based on the the size of the samples.
    * Assumes that `parseSamples` has been called first.
    *
    * @param {Number} offset - The offset into the mdat
    * @param {Object[]} samples - An array of samples, parsed using `parseSamples`
    * @return {?Object} The matching sample, or null if no match was found.
    *
    * @see ISO-BMFF-12/2015, Section 8.8.8
   **/var mapToSample=function mapToSample(offset,samples){var approximateOffset=offset;for(var i=0;i<samples.length;i++){var sample=samples[i];if(approximateOffset<sample.size){return sample;}approximateOffset-=sample.size;}return null;};/**
    * Finds SEI nal units contained in a Media Data Box.
    * Assumes that `parseSamples` has been called first.
    *
    * @param {Uint8Array} avcStream - The bytes of the mdat
    * @param {Object[]} samples - The samples parsed out by `parseSamples`
    * @param {Number} trackId - The trackId of this video track
    * @return {Object[]} seiNals - the parsed SEI NALUs found.
    *   The contents of the seiNal should match what is expected by
    *   CaptionStream.push (nalUnitType, size, data, escapedRBSP, pts, dts)
    *
    * @see ISO-BMFF-12/2015, Section 8.1.1
    * @see Rec. ITU-T H.264, 7.3.2.3.1
   **/var findSeiNals=function findSeiNals(avcStream,samples,trackId){var avcView=new DataView(avcStream.buffer,avcStream.byteOffset,avcStream.byteLength),result={logs:[],seiNals:[]},seiNal,i,length,lastMatchedSample;for(i=0;i+4<avcStream.length;i+=length){length=avcView.getUint32(i);i+=4;// Bail if this doesn't appear to be an H264 stream
if(length<=0){continue;}switch(avcStream[i]&0x1F){case 0x06:var data=avcStream.subarray(i+1,i+1+length);var matchingSample=mapToSample(i,samples);seiNal={nalUnitType:'sei_rbsp',size:length,data:data,escapedRBSP:discardEmulationPreventionBytes(data),trackId:trackId};if(matchingSample){seiNal.pts=matchingSample.pts;seiNal.dts=matchingSample.dts;lastMatchedSample=matchingSample;}else if(lastMatchedSample){// If a matching sample cannot be found, use the last
// sample's values as they should be as close as possible
seiNal.pts=lastMatchedSample.pts;seiNal.dts=lastMatchedSample.dts;}else{result.logs.push({level:'warn',message:'We\'ve encountered a nal unit without data at '+i+' for trackId '+trackId+'. See mux.js#223.'});break;}result.seiNals.push(seiNal);break;}}return result;};/**
    * Parses sample information out of Track Run Boxes and calculates
    * the absolute presentation and decode timestamps of each sample.
    *
    * @param {Array<Uint8Array>} truns - The Trun Run boxes to be parsed
    * @param {Number|BigInt} baseMediaDecodeTime - base media decode time from tfdt
        @see ISO-BMFF-12/2015, Section 8.8.12
    * @param {Object} tfhd - The parsed Track Fragment Header
    *   @see inspect.parseTfhd
    * @return {Object[]} the parsed samples
    *
    * @see ISO-BMFF-12/2015, Section 8.8.8
   **/var parseSamples=function parseSamples(truns,baseMediaDecodeTime,tfhd){var currentDts=baseMediaDecodeTime;var defaultSampleDuration=tfhd.defaultSampleDuration||0;var defaultSampleSize=tfhd.defaultSampleSize||0;var trackId=tfhd.trackId;var allSamples=[];truns.forEach(function(trun){// Note: We currently do not parse the sample table as well
// as the trun. It's possible some sources will require this.
// moov > trak > mdia > minf > stbl
var trackRun=parseTrun(trun);var samples=trackRun.samples;samples.forEach(function(sample){if(sample.duration===undefined){sample.duration=defaultSampleDuration;}if(sample.size===undefined){sample.size=defaultSampleSize;}sample.trackId=trackId;sample.dts=currentDts;if(sample.compositionTimeOffset===undefined){sample.compositionTimeOffset=0;}if(typeof currentDts==='bigint'){sample.pts=currentDts+window_1.BigInt(sample.compositionTimeOffset);currentDts+=window_1.BigInt(sample.duration);}else{sample.pts=currentDts+sample.compositionTimeOffset;currentDts+=sample.duration;}});allSamples=allSamples.concat(samples);});return allSamples;};/**
    * Parses out caption nals from an FMP4 segment's video tracks.
    *
    * @param {Uint8Array} segment - The bytes of a single segment
    * @param {Number} videoTrackId - The trackId of a video track in the segment
    * @return {Object.<Number, Object[]>} A mapping of video trackId to
    *   a list of seiNals found in that track
   **/var parseCaptionNals=function parseCaptionNals(segment,videoTrackId){// To get the samples
var trafs=findBox_1(segment,['moof','traf']);// To get SEI NAL units
var mdats=findBox_1(segment,['mdat']);var captionNals={};var mdatTrafPairs=[];// Pair up each traf with a mdat as moofs and mdats are in pairs
mdats.forEach(function(mdat,index){var matchingTraf=trafs[index];mdatTrafPairs.push({mdat:mdat,traf:matchingTraf});});mdatTrafPairs.forEach(function(pair){var mdat=pair.mdat;var traf=pair.traf;var tfhd=findBox_1(traf,['tfhd']);// Exactly 1 tfhd per traf
var headerInfo=parseTfhd(tfhd[0]);var trackId=headerInfo.trackId;var tfdt=findBox_1(traf,['tfdt']);// Either 0 or 1 tfdt per traf
var baseMediaDecodeTime=tfdt.length>0?parseTfdt(tfdt[0]).baseMediaDecodeTime:0;var truns=findBox_1(traf,['trun']);var samples;var result;// Only parse video data for the chosen video track
if(videoTrackId===trackId&&truns.length>0){samples=parseSamples(truns,baseMediaDecodeTime,headerInfo);result=findSeiNals(mdat,samples,trackId);if(!captionNals[trackId]){captionNals[trackId]={seiNals:[],logs:[]};}captionNals[trackId].seiNals=captionNals[trackId].seiNals.concat(result.seiNals);captionNals[trackId].logs=captionNals[trackId].logs.concat(result.logs);}});return captionNals;};/**
    * Parses out inband captions from an MP4 container and returns
    * caption objects that can be used by WebVTT and the TextTrack API.
    * @see https://developer.mozilla.org/en-US/docs/Web/API/VTTCue
    * @see https://developer.mozilla.org/en-US/docs/Web/API/TextTrack
    * Assumes that `probe.getVideoTrackIds` and `probe.timescale` have been called first
    *
    * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
    * @param {Number} trackId - The id of the video track to parse
    * @param {Number} timescale - The timescale for the video track from the init segment
    *
    * @return {?Object[]} parsedCaptions - A list of captions or null if no video tracks
    * @return {Number} parsedCaptions[].startTime - The time to show the caption in seconds
    * @return {Number} parsedCaptions[].endTime - The time to stop showing the caption in seconds
    * @return {String} parsedCaptions[].text - The visible content of the caption
   **/var parseEmbeddedCaptions=function parseEmbeddedCaptions(segment,trackId,timescale){var captionNals;// the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
if(trackId===null){return null;}captionNals=parseCaptionNals(segment,trackId);var trackNals=captionNals[trackId]||{};return{seiNals:trackNals.seiNals,logs:trackNals.logs,timescale:timescale};};/**
    * Converts SEI NALUs into captions that can be used by video.js
   **/var CaptionParser=function CaptionParser(){var isInitialized=false;var captionStream;// Stores segments seen before trackId and timescale are set
var segmentCache;// Stores video track ID of the track being parsed
var trackId;// Stores the timescale of the track being parsed
var timescale;// Stores captions parsed so far
var parsedCaptions;// Stores whether we are receiving partial data or not
var parsingPartial;/**
      * A method to indicate whether a CaptionParser has been initalized
      * @returns {Boolean}
     **/this.isInitialized=function(){return isInitialized;};/**
      * Initializes the underlying CaptionStream, SEI NAL parsing
      * and management, and caption collection
     **/this.init=function(options){captionStream=new CaptionStream();isInitialized=true;parsingPartial=options?options.isPartial:false;// Collect dispatched captions
captionStream.on('data',function(event){// Convert to seconds in the source's timescale
event.startTime=event.startPts/timescale;event.endTime=event.endPts/timescale;parsedCaptions.captions.push(event);parsedCaptions.captionStreams[event.stream]=true;});captionStream.on('log',function(log){parsedCaptions.logs.push(log);});};/**
      * Determines if a new video track will be selected
      * or if the timescale changed
      * @return {Boolean}
     **/this.isNewInit=function(videoTrackIds,timescales){if(videoTrackIds&&videoTrackIds.length===0||timescales&&video_es_typeof(timescales)==='object'&&Object.keys(timescales).length===0){return false;}return trackId!==videoTrackIds[0]||timescale!==timescales[trackId];};/**
      * Parses out SEI captions and interacts with underlying
      * CaptionStream to return dispatched captions
      *
      * @param {Uint8Array} segment - The fmp4 segment containing embedded captions
      * @param {Number[]} videoTrackIds - A list of video tracks found in the init segment
      * @param {Object.<Number, Number>} timescales - The timescales found in the init segment
      * @see parseEmbeddedCaptions
      * @see m2ts/caption-stream.js
     **/this.parse=function(segment,videoTrackIds,timescales){var parsedData;if(!this.isInitialized()){return null;// This is not likely to be a video segment
}else if(!videoTrackIds||!timescales){return null;}else if(this.isNewInit(videoTrackIds,timescales)){// Use the first video track only as there is no
// mechanism to switch to other video tracks
trackId=videoTrackIds[0];timescale=timescales[trackId];// If an init segment has not been seen yet, hold onto segment
// data until we have one.
// the ISO-BMFF spec says that trackId can't be zero, but there's some broken content out there
}else if(trackId===null||!timescale){segmentCache.push(segment);return null;}// Now that a timescale and trackId is set, parse cached segments
while(segmentCache.length>0){var cachedSegment=segmentCache.shift();this.parse(cachedSegment,videoTrackIds,timescales);}parsedData=parseEmbeddedCaptions(segment,trackId,timescale);if(parsedData&&parsedData.logs){parsedCaptions.logs=parsedCaptions.logs.concat(parsedData.logs);}if(parsedData===null||!parsedData.seiNals){if(parsedCaptions.logs.length){return{logs:parsedCaptions.logs,captions:[],captionStreams:[]};}return null;}this.pushNals(parsedData.seiNals);// Force the parsed captions to be dispatched
this.flushStream();return parsedCaptions;};/**
      * Pushes SEI NALUs onto CaptionStream
      * @param {Object[]} nals - A list of SEI nals parsed using `parseCaptionNals`
      * Assumes that `parseCaptionNals` has been called first
      * @see m2ts/caption-stream.js
      **/this.pushNals=function(nals){if(!this.isInitialized()||!nals||nals.length===0){return null;}nals.forEach(function(nal){captionStream.push(nal);});};/**
      * Flushes underlying CaptionStream to dispatch processed, displayable captions
      * @see m2ts/caption-stream.js
     **/this.flushStream=function(){if(!this.isInitialized()){return null;}if(!parsingPartial){captionStream.flush();}else{captionStream.partialFlush();}};/**
      * Reset caption buckets for new data
     **/this.clearParsedCaptions=function(){parsedCaptions.captions=[];parsedCaptions.captionStreams={};parsedCaptions.logs=[];};/**
      * Resets underlying CaptionStream
      * @see m2ts/caption-stream.js
     **/this.resetCaptionStream=function(){if(!this.isInitialized()){return null;}captionStream.reset();};/**
      * Convenience method to clear all captions flushed from the
      * CaptionStream and still being parsed
      * @see m2ts/caption-stream.js
     **/this.clearAllCaptions=function(){this.clearParsedCaptions();this.resetCaptionStream();};/**
      * Reset caption parser
     **/this.reset=function(){segmentCache=[];trackId=null;timescale=null;if(!parsedCaptions){parsedCaptions={captions:[],// CC1, CC2, CC3, CC4
captionStreams:{},logs:[]};}else{this.clearParsedCaptions();}this.resetCaptionStream();};this.reset();};var captionParser=CaptionParser;var toUnsigned=bin.toUnsigned;var toHexString=bin.toHexString;var getUint64=numbers.getUint64;var timescale,startTime,compositionStartTime,getVideoTrackIds,getTracks,getTimescaleFromMediaHeader;/**
   * Parses an MP4 initialization segment and extracts the timescale
   * values for any declared tracks. Timescale values indicate the
   * number of clock ticks per second to assume for time-based values
   * elsewhere in the MP4.
   *
   * To determine the start time of an MP4, you need two pieces of
   * information: the timescale unit and the earliest base media decode
   * time. Multiple timescales can be specified within an MP4 but the
   * base media decode time is always expressed in the timescale from
   * the media header box for the track:
   * ```
   * moov > trak > mdia > mdhd.timescale
   * ```
   * @param init {Uint8Array} the bytes of the init segment
   * @return {object} a hash of track ids to timescale values or null if
   * the init segment is malformed.
   */timescale=function timescale(init){var result={},traks=findBox_1(init,['moov','trak']);// mdhd timescale
return traks.reduce(function(result,trak){var tkhd,version,index,id,mdhd;tkhd=findBox_1(trak,['tkhd'])[0];if(!tkhd){return null;}version=tkhd[0];index=version===0?12:20;id=toUnsigned(tkhd[index]<<24|tkhd[index+1]<<16|tkhd[index+2]<<8|tkhd[index+3]);mdhd=findBox_1(trak,['mdia','mdhd'])[0];if(!mdhd){return null;}version=mdhd[0];index=version===0?12:20;result[id]=toUnsigned(mdhd[index]<<24|mdhd[index+1]<<16|mdhd[index+2]<<8|mdhd[index+3]);return result;},result);};/**
   * Determine the base media decode start time, in seconds, for an MP4
   * fragment. If multiple fragments are specified, the earliest time is
   * returned.
   *
   * The base media decode time can be parsed from track fragment
   * metadata:
   * ```
   * moof > traf > tfdt.baseMediaDecodeTime
   * ```
   * It requires the timescale value from the mdhd to interpret.
   *
   * @param timescale {object} a hash of track ids to timescale values.
   * @return {number} the earliest base media decode start time for the
   * fragment, in seconds
   */startTime=function startTime(timescale,fragment){var trafs;// we need info from two childrend of each track fragment box
trafs=findBox_1(fragment,['moof','traf']);// determine the start times for each track
var lowestTime=trafs.reduce(function(acc,traf){var tfhd=findBox_1(traf,['tfhd'])[0];// get the track id from the tfhd
var id=toUnsigned(tfhd[4]<<24|tfhd[5]<<16|tfhd[6]<<8|tfhd[7]);// assume a 90kHz clock if no timescale was specified
var scale=timescale[id]||90e3;// get the base media decode time from the tfdt
var tfdt=findBox_1(traf,['tfdt'])[0];var dv=new DataView(tfdt.buffer,tfdt.byteOffset,tfdt.byteLength);var baseTime;// version 1 is 64 bit
if(tfdt[0]===1){baseTime=getUint64(tfdt.subarray(4,12));}else{baseTime=dv.getUint32(4);}// convert base time to seconds if it is a valid number.
var seconds;if(typeof baseTime==='bigint'){seconds=baseTime/window_1.BigInt(scale);}else if(typeof baseTime==='number'&&!isNaN(baseTime)){seconds=baseTime/scale;}if(seconds<Number.MAX_SAFE_INTEGER){seconds=Number(seconds);}if(seconds<acc){acc=seconds;}return acc;},Infinity);return typeof lowestTime==='bigint'||isFinite(lowestTime)?lowestTime:0;};/**
   * Determine the composition start, in seconds, for an MP4
   * fragment.
   *
   * The composition start time of a fragment can be calculated using the base
   * media decode time, composition time offset, and timescale, as follows:
   *
   * compositionStartTime = (baseMediaDecodeTime + compositionTimeOffset) / timescale
   *
   * All of the aforementioned information is contained within a media fragment's
   * `traf` box, except for timescale info, which comes from the initialization
   * segment, so a track id (also contained within a `traf`) is also necessary to
   * associate it with a timescale
   *
   *
   * @param timescales {object} - a hash of track ids to timescale values.
   * @param fragment {Unit8Array} - the bytes of a media segment
   * @return {number} the composition start time for the fragment, in seconds
   **/compositionStartTime=function compositionStartTime(timescales,fragment){var trafBoxes=findBox_1(fragment,['moof','traf']);var baseMediaDecodeTime=0;var compositionTimeOffset=0;var trackId;if(trafBoxes&&trafBoxes.length){// The spec states that track run samples contained within a `traf` box are contiguous, but
// it does not explicitly state whether the `traf` boxes themselves are contiguous.
// We will assume that they are, so we only need the first to calculate start time.
var tfhd=findBox_1(trafBoxes[0],['tfhd'])[0];var trun=findBox_1(trafBoxes[0],['trun'])[0];var tfdt=findBox_1(trafBoxes[0],['tfdt'])[0];if(tfhd){var parsedTfhd=parseTfhd(tfhd);trackId=parsedTfhd.trackId;}if(tfdt){var parsedTfdt=parseTfdt(tfdt);baseMediaDecodeTime=parsedTfdt.baseMediaDecodeTime;}if(trun){var parsedTrun=parseTrun(trun);if(parsedTrun.samples&&parsedTrun.samples.length){compositionTimeOffset=parsedTrun.samples[0].compositionTimeOffset||0;}}}// Get timescale for this specific track. Assume a 90kHz clock if no timescale was
// specified.
var timescale=timescales[trackId]||90e3;// return the composition start time, in seconds
if(typeof baseMediaDecodeTime==='bigint'){compositionTimeOffset=window_1.BigInt(compositionTimeOffset);timescale=window_1.BigInt(timescale);}var result=(baseMediaDecodeTime+compositionTimeOffset)/timescale;if(typeof result==='bigint'&&result<Number.MAX_SAFE_INTEGER){result=Number(result);}return result;};/**
    * Find the trackIds of the video tracks in this source.
    * Found by parsing the Handler Reference and Track Header Boxes:
    *   moov > trak > mdia > hdlr
    *   moov > trak > tkhd
    *
    * @param {Uint8Array} init - The bytes of the init segment for this source
    * @return {Number[]} A list of trackIds
    *
    * @see ISO-BMFF-12/2015, Section 8.4.3
   **/getVideoTrackIds=function getVideoTrackIds(init){var traks=findBox_1(init,['moov','trak']);var videoTrackIds=[];traks.forEach(function(trak){var hdlrs=findBox_1(trak,['mdia','hdlr']);var tkhds=findBox_1(trak,['tkhd']);hdlrs.forEach(function(hdlr,index){var handlerType=parseType_1(hdlr.subarray(8,12));var tkhd=tkhds[index];var view;var version;var trackId;if(handlerType==='vide'){view=new DataView(tkhd.buffer,tkhd.byteOffset,tkhd.byteLength);version=view.getUint8(0);trackId=version===0?view.getUint32(12):view.getUint32(20);videoTrackIds.push(trackId);}});});return videoTrackIds;};getTimescaleFromMediaHeader=function getTimescaleFromMediaHeader(mdhd){// mdhd is a FullBox, meaning it will have its own version as the first byte
var version=mdhd[0];var index=version===0?12:20;return toUnsigned(mdhd[index]<<24|mdhd[index+1]<<16|mdhd[index+2]<<8|mdhd[index+3]);};/**
   * Get all the video, audio, and hint tracks from a non fragmented
   * mp4 segment
   */getTracks=function getTracks(init){var traks=findBox_1(init,['moov','trak']);var tracks=[];traks.forEach(function(trak){var track={};var tkhd=findBox_1(trak,['tkhd'])[0];var view,tkhdVersion;// id
if(tkhd){view=new DataView(tkhd.buffer,tkhd.byteOffset,tkhd.byteLength);tkhdVersion=view.getUint8(0);track.id=tkhdVersion===0?view.getUint32(12):view.getUint32(20);}var hdlr=findBox_1(trak,['mdia','hdlr'])[0];// type
if(hdlr){var type=parseType_1(hdlr.subarray(8,12));if(type==='vide'){track.type='video';}else if(type==='soun'){track.type='audio';}else{track.type=type;}}// codec
var stsd=findBox_1(trak,['mdia','minf','stbl','stsd'])[0];if(stsd){var sampleDescriptions=stsd.subarray(8);// gives the codec type string
track.codec=parseType_1(sampleDescriptions.subarray(4,8));var codecBox=findBox_1(sampleDescriptions,[track.codec])[0];var codecConfig,codecConfigType;if(codecBox){// https://tools.ietf.org/html/rfc6381#section-3.3
if(/^[asm]vc[1-9]$/i.test(track.codec)){// we don't need anything but the "config" parameter of the
// avc1 codecBox
codecConfig=codecBox.subarray(78);codecConfigType=parseType_1(codecConfig.subarray(4,8));if(codecConfigType==='avcC'&&codecConfig.length>11){track.codec+='.';// left padded with zeroes for single digit hex
// profile idc
track.codec+=toHexString(codecConfig[9]);// the byte containing the constraint_set flags
track.codec+=toHexString(codecConfig[10]);// level idc
track.codec+=toHexString(codecConfig[11]);}else{// TODO: show a warning that we couldn't parse the codec
// and are using the default
track.codec='avc1.4d400d';}}else if(/^mp4[a,v]$/i.test(track.codec)){// we do not need anything but the streamDescriptor of the mp4a codecBox
codecConfig=codecBox.subarray(28);codecConfigType=parseType_1(codecConfig.subarray(4,8));if(codecConfigType==='esds'&&codecConfig.length>20&&codecConfig[19]!==0){track.codec+='.'+toHexString(codecConfig[19]);// this value is only a single digit
track.codec+='.'+toHexString(codecConfig[20]>>>2&0x3f).replace(/^0/,'');}else{// TODO: show a warning that we couldn't parse the codec
// and are using the default
track.codec='mp4a.40.2';}}else{// flac, opus, etc
track.codec=track.codec.toLowerCase();}}}var mdhd=findBox_1(trak,['mdia','mdhd'])[0];if(mdhd){track.timescale=getTimescaleFromMediaHeader(mdhd);}tracks.push(track);});return tracks;};var probe$2={// export mp4 inspector's findBox and parseType for backwards compatibility
findBox:findBox_1,parseType:parseType_1,timescale:timescale,startTime:startTime,compositionStartTime:compositionStartTime,videoTrackIds:getVideoTrackIds,tracks:getTracks,getTimescaleFromMediaHeader:getTimescaleFromMediaHeader};var parsePid=function parsePid(packet){var pid=packet[1]&0x1f;pid<<=8;pid|=packet[2];return pid;};var parsePayloadUnitStartIndicator=function parsePayloadUnitStartIndicator(packet){return!!(packet[1]&0x40);};var parseAdaptionField=function parseAdaptionField(packet){var offset=0;// if an adaption field is present, its length is specified by the
// fifth byte of the TS packet header. The adaptation field is
// used to add stuffing to PES packets that don't fill a complete
// TS packet, and to specify some forms of timing and control data
// that we do not currently use.
if((packet[3]&0x30)>>>4>0x01){offset+=packet[4]+1;}return offset;};var parseType=function parseType(packet,pmtPid){var pid=parsePid(packet);if(pid===0){return'pat';}else if(pid===pmtPid){return'pmt';}else if(pmtPid){return'pes';}return null;};var parsePat=function parsePat(packet){var pusi=parsePayloadUnitStartIndicator(packet);var offset=4+parseAdaptionField(packet);if(pusi){offset+=packet[offset]+1;}return(packet[offset+10]&0x1f)<<8|packet[offset+11];};var parsePmt=function parsePmt(packet){var programMapTable={};var pusi=parsePayloadUnitStartIndicator(packet);var payloadOffset=4+parseAdaptionField(packet);if(pusi){payloadOffset+=packet[payloadOffset]+1;}// PMTs can be sent ahead of the time when they should actually
// take effect. We don't believe this should ever be the case
// for HLS but we'll ignore "forward" PMT declarations if we see
// them. Future PMT declarations have the current_next_indicator
// set to zero.
if(!(packet[payloadOffset+5]&0x01)){return;}var sectionLength,tableEnd,programInfoLength;// the mapping table ends at the end of the current section
sectionLength=(packet[payloadOffset+1]&0x0f)<<8|packet[payloadOffset+2];tableEnd=3+sectionLength-4;// to determine where the table is, we have to figure out how
// long the program info descriptors are
programInfoLength=(packet[payloadOffset+10]&0x0f)<<8|packet[payloadOffset+11];// advance the offset to the first entry in the mapping table
var offset=12+programInfoLength;while(offset<tableEnd){var i=payloadOffset+offset;// add an entry that maps the elementary_pid to the stream_type
programMapTable[(packet[i+1]&0x1F)<<8|packet[i+2]]=packet[i];// move to the next table entry
// skip past the elementary stream descriptors, if present
offset+=((packet[i+3]&0x0F)<<8|packet[i+4])+5;}return programMapTable;};var parsePesType=function parsePesType(packet,programMapTable){var pid=parsePid(packet);var type=programMapTable[pid];switch(type){case streamTypes.H264_STREAM_TYPE:return'video';case streamTypes.ADTS_STREAM_TYPE:return'audio';case streamTypes.METADATA_STREAM_TYPE:return'timed-metadata';default:return null;}};var parsePesTime=function parsePesTime(packet){var pusi=parsePayloadUnitStartIndicator(packet);if(!pusi){return null;}var offset=4+parseAdaptionField(packet);if(offset>=packet.byteLength){// From the H 222.0 MPEG-TS spec
// "For transport stream packets carrying PES packets, stuffing is needed when there
//  is insufficient PES packet data to completely fill the transport stream packet
//  payload bytes. Stuffing is accomplished by defining an adaptation field longer than
//  the sum of the lengths of the data elements in it, so that the payload bytes
//  remaining after the adaptation field exactly accommodates the available PES packet
//  data."
//
// If the offset is >= the length of the packet, then the packet contains no data
// and instead is just adaption field stuffing bytes
return null;}var pes=null;var ptsDtsFlags;// PES packets may be annotated with a PTS value, or a PTS value
// and a DTS value. Determine what combination of values is
// available to work with.
ptsDtsFlags=packet[offset+7];// PTS and DTS are normally stored as a 33-bit number.  Javascript
// performs all bitwise operations on 32-bit integers but javascript
// supports a much greater range (52-bits) of integer using standard
// mathematical operations.
// We construct a 31-bit value using bitwise operators over the 31
// most significant bits and then multiply by 4 (equal to a left-shift
// of 2) before we add the final 2 least significant bits of the
// timestamp (equal to an OR.)
if(ptsDtsFlags&0xC0){pes={};// the PTS and DTS are not written out directly. For information
// on how they are encoded, see
// http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
pes.pts=(packet[offset+9]&0x0E)<<27|(packet[offset+10]&0xFF)<<20|(packet[offset+11]&0xFE)<<12|(packet[offset+12]&0xFF)<<5|(packet[offset+13]&0xFE)>>>3;pes.pts*=4;// Left shift by 2
pes.pts+=(packet[offset+13]&0x06)>>>1;// OR by the two LSBs
pes.dts=pes.pts;if(ptsDtsFlags&0x40){pes.dts=(packet[offset+14]&0x0E)<<27|(packet[offset+15]&0xFF)<<20|(packet[offset+16]&0xFE)<<12|(packet[offset+17]&0xFF)<<5|(packet[offset+18]&0xFE)>>>3;pes.dts*=4;// Left shift by 2
pes.dts+=(packet[offset+18]&0x06)>>>1;// OR by the two LSBs
}}return pes;};var parseNalUnitType=function parseNalUnitType(type){switch(type){case 0x05:return'slice_layer_without_partitioning_rbsp_idr';case 0x06:return'sei_rbsp';case 0x07:return'seq_parameter_set_rbsp';case 0x08:return'pic_parameter_set_rbsp';case 0x09:return'access_unit_delimiter_rbsp';default:return null;}};var videoPacketContainsKeyFrame=function videoPacketContainsKeyFrame(packet){var offset=4+parseAdaptionField(packet);var frameBuffer=packet.subarray(offset);var frameI=0;var frameSyncPoint=0;var foundKeyFrame=false;var nalType;// advance the sync point to a NAL start, if necessary
for(;frameSyncPoint<frameBuffer.byteLength-3;frameSyncPoint++){if(frameBuffer[frameSyncPoint+2]===1){// the sync point is properly aligned
frameI=frameSyncPoint+5;break;}}while(frameI<frameBuffer.byteLength){// look at the current byte to determine if we've hit the end of
// a NAL unit boundary
switch(frameBuffer[frameI]){case 0:// skip past non-sync sequences
if(frameBuffer[frameI-1]!==0){frameI+=2;break;}else if(frameBuffer[frameI-2]!==0){frameI++;break;}if(frameSyncPoint+3!==frameI-2){nalType=parseNalUnitType(frameBuffer[frameSyncPoint+3]&0x1f);if(nalType==='slice_layer_without_partitioning_rbsp_idr'){foundKeyFrame=true;}}// drop trailing zeroes
do{frameI++;}while(frameBuffer[frameI]!==1&&frameI<frameBuffer.length);frameSyncPoint=frameI-2;frameI+=3;break;case 1:// skip past non-sync sequences
if(frameBuffer[frameI-1]!==0||frameBuffer[frameI-2]!==0){frameI+=3;break;}nalType=parseNalUnitType(frameBuffer[frameSyncPoint+3]&0x1f);if(nalType==='slice_layer_without_partitioning_rbsp_idr'){foundKeyFrame=true;}frameSyncPoint=frameI-2;frameI+=3;break;default:// the current byte isn't a one or zero, so it cannot be part
// of a sync sequence
frameI+=3;break;}}frameBuffer=frameBuffer.subarray(frameSyncPoint);frameI-=frameSyncPoint;frameSyncPoint=0;// parse the final nal
if(frameBuffer&&frameBuffer.byteLength>3){nalType=parseNalUnitType(frameBuffer[frameSyncPoint+3]&0x1f);if(nalType==='slice_layer_without_partitioning_rbsp_idr'){foundKeyFrame=true;}}return foundKeyFrame;};var probe$1={parseType:parseType,parsePat:parsePat,parsePmt:parsePmt,parsePayloadUnitStartIndicator:parsePayloadUnitStartIndicator,parsePesType:parsePesType,parsePesTime:parsePesTime,videoPacketContainsKeyFrame:videoPacketContainsKeyFrame};var handleRollover=timestampRolloverStream.handleRollover;var probe={};probe.ts=probe$1;probe.aac=utils;var ONE_SECOND_IN_TS=clock.ONE_SECOND_IN_TS;var MP2T_PACKET_LENGTH=188,// bytes
SYNC_BYTE=0x47;/**
   * walks through segment data looking for pat and pmt packets to parse out
   * program map table information
   */var parsePsi_=function parsePsi_(bytes,pmt){var startIndex=0,endIndex=MP2T_PACKET_LENGTH,packet,type;while(endIndex<bytes.byteLength){// Look for a pair of start and end sync bytes in the data..
if(bytes[startIndex]===SYNC_BYTE&&bytes[endIndex]===SYNC_BYTE){// We found a packet
packet=bytes.subarray(startIndex,endIndex);type=probe.ts.parseType(packet,pmt.pid);switch(type){case'pat':pmt.pid=probe.ts.parsePat(packet);break;case'pmt':var table=probe.ts.parsePmt(packet);pmt.table=pmt.table||{};Object.keys(table).forEach(function(key){pmt.table[key]=table[key];});break;}startIndex+=MP2T_PACKET_LENGTH;endIndex+=MP2T_PACKET_LENGTH;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex++;endIndex++;}};/**
   * walks through the segment data from the start and end to get timing information
   * for the first and last audio pes packets
   */var parseAudioPes_=function parseAudioPes_(bytes,pmt,result){var startIndex=0,endIndex=MP2T_PACKET_LENGTH,packet,type,pesType,pusi,parsed;var endLoop=false;// Start walking from start of segment to get first audio packet
while(endIndex<=bytes.byteLength){// Look for a pair of start and end sync bytes in the data..
if(bytes[startIndex]===SYNC_BYTE&&(bytes[endIndex]===SYNC_BYTE||endIndex===bytes.byteLength)){// We found a packet
packet=bytes.subarray(startIndex,endIndex);type=probe.ts.parseType(packet,pmt.pid);switch(type){case'pes':pesType=probe.ts.parsePesType(packet,pmt.table);pusi=probe.ts.parsePayloadUnitStartIndicator(packet);if(pesType==='audio'&&pusi){parsed=probe.ts.parsePesTime(packet);if(parsed){parsed.type='audio';result.audio.push(parsed);endLoop=true;}}break;}if(endLoop){break;}startIndex+=MP2T_PACKET_LENGTH;endIndex+=MP2T_PACKET_LENGTH;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex++;endIndex++;}// Start walking from end of segment to get last audio packet
endIndex=bytes.byteLength;startIndex=endIndex-MP2T_PACKET_LENGTH;endLoop=false;while(startIndex>=0){// Look for a pair of start and end sync bytes in the data..
if(bytes[startIndex]===SYNC_BYTE&&(bytes[endIndex]===SYNC_BYTE||endIndex===bytes.byteLength)){// We found a packet
packet=bytes.subarray(startIndex,endIndex);type=probe.ts.parseType(packet,pmt.pid);switch(type){case'pes':pesType=probe.ts.parsePesType(packet,pmt.table);pusi=probe.ts.parsePayloadUnitStartIndicator(packet);if(pesType==='audio'&&pusi){parsed=probe.ts.parsePesTime(packet);if(parsed){parsed.type='audio';result.audio.push(parsed);endLoop=true;}}break;}if(endLoop){break;}startIndex-=MP2T_PACKET_LENGTH;endIndex-=MP2T_PACKET_LENGTH;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex--;endIndex--;}};/**
   * walks through the segment data from the start and end to get timing information
   * for the first and last video pes packets as well as timing information for the first
   * key frame.
   */var parseVideoPes_=function parseVideoPes_(bytes,pmt,result){var startIndex=0,endIndex=MP2T_PACKET_LENGTH,packet,type,pesType,pusi,parsed,frame,i,pes;var endLoop=false;var currentFrame={data:[],size:0};// Start walking from start of segment to get first video packet
while(endIndex<bytes.byteLength){// Look for a pair of start and end sync bytes in the data..
if(bytes[startIndex]===SYNC_BYTE&&bytes[endIndex]===SYNC_BYTE){// We found a packet
packet=bytes.subarray(startIndex,endIndex);type=probe.ts.parseType(packet,pmt.pid);switch(type){case'pes':pesType=probe.ts.parsePesType(packet,pmt.table);pusi=probe.ts.parsePayloadUnitStartIndicator(packet);if(pesType==='video'){if(pusi&&!endLoop){parsed=probe.ts.parsePesTime(packet);if(parsed){parsed.type='video';result.video.push(parsed);endLoop=true;}}if(!result.firstKeyFrame){if(pusi){if(currentFrame.size!==0){frame=new Uint8Array(currentFrame.size);i=0;while(currentFrame.data.length){pes=currentFrame.data.shift();frame.set(pes,i);i+=pes.byteLength;}if(probe.ts.videoPacketContainsKeyFrame(frame)){var firstKeyFrame=probe.ts.parsePesTime(frame);// PTS/DTS may not be available. Simply *not* setting
// the keyframe seems to work fine with HLS playback
// and definitely preferable to a crash with TypeError...
if(firstKeyFrame){result.firstKeyFrame=firstKeyFrame;result.firstKeyFrame.type='video';}else{// eslint-disable-next-line
console.warn('Failed to extract PTS/DTS from PES at first keyframe. '+'This could be an unusual TS segment, or else mux.js did not '+'parse your TS segment correctly. If you know your TS '+'segments do contain PTS/DTS on keyframes please file a bug '+'report! You can try ffprobe to double check for yourself.');}}currentFrame.size=0;}}currentFrame.data.push(packet);currentFrame.size+=packet.byteLength;}}break;}if(endLoop&&result.firstKeyFrame){break;}startIndex+=MP2T_PACKET_LENGTH;endIndex+=MP2T_PACKET_LENGTH;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex++;endIndex++;}// Start walking from end of segment to get last video packet
endIndex=bytes.byteLength;startIndex=endIndex-MP2T_PACKET_LENGTH;endLoop=false;while(startIndex>=0){// Look for a pair of start and end sync bytes in the data..
if(bytes[startIndex]===SYNC_BYTE&&bytes[endIndex]===SYNC_BYTE){// We found a packet
packet=bytes.subarray(startIndex,endIndex);type=probe.ts.parseType(packet,pmt.pid);switch(type){case'pes':pesType=probe.ts.parsePesType(packet,pmt.table);pusi=probe.ts.parsePayloadUnitStartIndicator(packet);if(pesType==='video'&&pusi){parsed=probe.ts.parsePesTime(packet);if(parsed){parsed.type='video';result.video.push(parsed);endLoop=true;}}break;}if(endLoop){break;}startIndex-=MP2T_PACKET_LENGTH;endIndex-=MP2T_PACKET_LENGTH;continue;}// If we get here, we have somehow become de-synchronized and we need to step
// forward one byte at a time until we find a pair of sync bytes that denote
// a packet
startIndex--;endIndex--;}};/**
   * Adjusts the timestamp information for the segment to account for
   * rollover and convert to seconds based on pes packet timescale (90khz clock)
   */var adjustTimestamp_=function adjustTimestamp_(segmentInfo,baseTimestamp){if(segmentInfo.audio&&segmentInfo.audio.length){var audioBaseTimestamp=baseTimestamp;if(typeof audioBaseTimestamp==='undefined'||isNaN(audioBaseTimestamp)){audioBaseTimestamp=segmentInfo.audio[0].dts;}segmentInfo.audio.forEach(function(info){info.dts=handleRollover(info.dts,audioBaseTimestamp);info.pts=handleRollover(info.pts,audioBaseTimestamp);// time in seconds
info.dtsTime=info.dts/ONE_SECOND_IN_TS;info.ptsTime=info.pts/ONE_SECOND_IN_TS;});}if(segmentInfo.video&&segmentInfo.video.length){var videoBaseTimestamp=baseTimestamp;if(typeof videoBaseTimestamp==='undefined'||isNaN(videoBaseTimestamp)){videoBaseTimestamp=segmentInfo.video[0].dts;}segmentInfo.video.forEach(function(info){info.dts=handleRollover(info.dts,videoBaseTimestamp);info.pts=handleRollover(info.pts,videoBaseTimestamp);// time in seconds
info.dtsTime=info.dts/ONE_SECOND_IN_TS;info.ptsTime=info.pts/ONE_SECOND_IN_TS;});if(segmentInfo.firstKeyFrame){var frame=segmentInfo.firstKeyFrame;frame.dts=handleRollover(frame.dts,videoBaseTimestamp);frame.pts=handleRollover(frame.pts,videoBaseTimestamp);// time in seconds
frame.dtsTime=frame.dts/ONE_SECOND_IN_TS;frame.ptsTime=frame.pts/ONE_SECOND_IN_TS;}}};/**
   * inspects the aac data stream for start and end time information
   */var inspectAac_=function inspectAac_(bytes){var endLoop=false,audioCount=0,sampleRate=null,timestamp=null,frameSize=0,byteIndex=0,packet;while(bytes.length-byteIndex>=3){var type=probe.aac.parseType(bytes,byteIndex);switch(type){case'timed-metadata':// Exit early because we don't have enough to parse
// the ID3 tag header
if(bytes.length-byteIndex<10){endLoop=true;break;}frameSize=probe.aac.parseId3TagSize(bytes,byteIndex);// Exit early if we don't have enough in the buffer
// to emit a full packet
if(frameSize>bytes.length){endLoop=true;break;}if(timestamp===null){packet=bytes.subarray(byteIndex,byteIndex+frameSize);timestamp=probe.aac.parseAacTimestamp(packet);}byteIndex+=frameSize;break;case'audio':// Exit early because we don't have enough to parse
// the ADTS frame header
if(bytes.length-byteIndex<7){endLoop=true;break;}frameSize=probe.aac.parseAdtsSize(bytes,byteIndex);// Exit early if we don't have enough in the buffer
// to emit a full packet
if(frameSize>bytes.length){endLoop=true;break;}if(sampleRate===null){packet=bytes.subarray(byteIndex,byteIndex+frameSize);sampleRate=probe.aac.parseSampleRate(packet);}audioCount++;byteIndex+=frameSize;break;default:byteIndex++;break;}if(endLoop){return null;}}if(sampleRate===null||timestamp===null){return null;}var audioTimescale=ONE_SECOND_IN_TS/sampleRate;var result={audio:[{type:'audio',dts:timestamp,pts:timestamp},{type:'audio',dts:timestamp+audioCount*1024*audioTimescale,pts:timestamp+audioCount*1024*audioTimescale}]};return result;};/**
   * inspects the transport stream segment data for start and end time information
   * of the audio and video tracks (when present) as well as the first key frame's
   * start time.
   */var inspectTs_=function inspectTs_(bytes){var pmt={pid:null,table:null};var result={};parsePsi_(bytes,pmt);for(var pid in pmt.table){if(pmt.table.hasOwnProperty(pid)){var type=pmt.table[pid];switch(type){case streamTypes.H264_STREAM_TYPE:result.video=[];parseVideoPes_(bytes,pmt,result);if(result.video.length===0){delete result.video;}break;case streamTypes.ADTS_STREAM_TYPE:result.audio=[];parseAudioPes_(bytes,pmt,result);if(result.audio.length===0){delete result.audio;}break;}}}return result;};/**
   * Inspects segment byte data and returns an object with start and end timing information
   *
   * @param {Uint8Array} bytes The segment byte data
   * @param {Number} baseTimestamp Relative reference timestamp used when adjusting frame
   *  timestamps for rollover. This value must be in 90khz clock.
   * @return {Object} Object containing start and end frame timing info of segment.
   */var inspect=function inspect(bytes,baseTimestamp){var isAacData=probe.aac.isLikelyAacData(bytes);var result;if(isAacData){result=inspectAac_(bytes);}else{result=inspectTs_(bytes);}if(!result||!result.audio&&!result.video){return null;}adjustTimestamp_(result,baseTimestamp);return result;};var tsInspector={inspect:inspect,parseAudioPes_:parseAudioPes_};/* global self */ /**
   * Re-emits transmuxer events by converting them into messages to the
   * world outside the worker.
   *
   * @param {Object} transmuxer the transmuxer to wire events on
   * @private
   */var wireTransmuxerEvents=function wireTransmuxerEvents(self,transmuxer){transmuxer.on('data',function(segment){// transfer ownership of the underlying ArrayBuffer
// instead of doing a copy to save memory
// ArrayBuffers are transferable but generic TypedArrays are not
// @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers#Passing_data_by_transferring_ownership_(transferable_objects)
var initArray=segment.initSegment;segment.initSegment={data:initArray.buffer,byteOffset:initArray.byteOffset,byteLength:initArray.byteLength};var typedArray=segment.data;segment.data=typedArray.buffer;self.postMessage({action:'data',segment:segment,byteOffset:typedArray.byteOffset,byteLength:typedArray.byteLength},[segment.data]);});transmuxer.on('done',function(data){self.postMessage({action:'done'});});transmuxer.on('gopInfo',function(gopInfo){self.postMessage({action:'gopInfo',gopInfo:gopInfo});});transmuxer.on('videoSegmentTimingInfo',function(timingInfo){var videoSegmentTimingInfo={start:{decode:clock.videoTsToSeconds(timingInfo.start.dts),presentation:clock.videoTsToSeconds(timingInfo.start.pts)},end:{decode:clock.videoTsToSeconds(timingInfo.end.dts),presentation:clock.videoTsToSeconds(timingInfo.end.pts)},baseMediaDecodeTime:clock.videoTsToSeconds(timingInfo.baseMediaDecodeTime)};if(timingInfo.prependedContentDuration){videoSegmentTimingInfo.prependedContentDuration=clock.videoTsToSeconds(timingInfo.prependedContentDuration);}self.postMessage({action:'videoSegmentTimingInfo',videoSegmentTimingInfo:videoSegmentTimingInfo});});transmuxer.on('audioSegmentTimingInfo',function(timingInfo){// Note that all times for [audio/video]SegmentTimingInfo events are in video clock
var audioSegmentTimingInfo={start:{decode:clock.videoTsToSeconds(timingInfo.start.dts),presentation:clock.videoTsToSeconds(timingInfo.start.pts)},end:{decode:clock.videoTsToSeconds(timingInfo.end.dts),presentation:clock.videoTsToSeconds(timingInfo.end.pts)},baseMediaDecodeTime:clock.videoTsToSeconds(timingInfo.baseMediaDecodeTime)};if(timingInfo.prependedContentDuration){audioSegmentTimingInfo.prependedContentDuration=clock.videoTsToSeconds(timingInfo.prependedContentDuration);}self.postMessage({action:'audioSegmentTimingInfo',audioSegmentTimingInfo:audioSegmentTimingInfo});});transmuxer.on('id3Frame',function(id3Frame){self.postMessage({action:'id3Frame',id3Frame:id3Frame});});transmuxer.on('caption',function(caption){self.postMessage({action:'caption',caption:caption});});transmuxer.on('trackinfo',function(trackInfo){self.postMessage({action:'trackinfo',trackInfo:trackInfo});});transmuxer.on('audioTimingInfo',function(audioTimingInfo){// convert to video TS since we prioritize video time over audio
self.postMessage({action:'audioTimingInfo',audioTimingInfo:{start:clock.videoTsToSeconds(audioTimingInfo.start),end:clock.videoTsToSeconds(audioTimingInfo.end)}});});transmuxer.on('videoTimingInfo',function(videoTimingInfo){self.postMessage({action:'videoTimingInfo',videoTimingInfo:{start:clock.videoTsToSeconds(videoTimingInfo.start),end:clock.videoTsToSeconds(videoTimingInfo.end)}});});transmuxer.on('log',function(log){self.postMessage({action:'log',log:log});});};/**
   * All incoming messages route through this hash. If no function exists
   * to handle an incoming message, then we ignore the message.
   *
   * @class MessageHandlers
   * @param {Object} options the options to initialize with
   */var MessageHandlers=/*#__PURE__*/function(){function MessageHandlers(self,options){this.options=options||{};this.self=self;this.init();}/**
     * initialize our web worker and wire all the events.
     */var _proto=MessageHandlers.prototype;_proto.init=function init(){if(this.transmuxer){this.transmuxer.dispose();}this.transmuxer=new transmuxer.Transmuxer(this.options);wireTransmuxerEvents(this.self,this.transmuxer);};_proto.pushMp4Captions=function pushMp4Captions(data){if(!this.captionParser){this.captionParser=new captionParser();this.captionParser.init();}var segment=new Uint8Array(data.data,data.byteOffset,data.byteLength);var parsed=this.captionParser.parse(segment,data.trackIds,data.timescales);this.self.postMessage({action:'mp4Captions',captions:parsed&&parsed.captions||[],logs:parsed&&parsed.logs||[],data:segment.buffer},[segment.buffer]);};_proto.probeMp4StartTime=function probeMp4StartTime(_ref){var timescales=_ref.timescales,data=_ref.data;var startTime=probe$2.startTime(timescales,data);this.self.postMessage({action:'probeMp4StartTime',startTime:startTime,data:data},[data.buffer]);};_proto.probeMp4Tracks=function probeMp4Tracks(_ref2){var data=_ref2.data;var tracks=probe$2.tracks(data);this.self.postMessage({action:'probeMp4Tracks',tracks:tracks,data:data},[data.buffer]);}/**
     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
     * internal "media time," as well as whether it contains video and/or audio.
     *
     * @private
     * @param {Uint8Array} bytes - segment bytes
     * @param {number} baseStartTime
     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
     *        This value should be in seconds, as it's converted to a 90khz clock within the
     *        function body.
     * @return {Object} The start time of the current segment in "media time" as well as
     *                  whether it contains video and/or audio
     */;_proto.probeTs=function probeTs(_ref3){var data=_ref3.data,baseStartTime=_ref3.baseStartTime;var tsStartTime=typeof baseStartTime==='number'&&!isNaN(baseStartTime)?baseStartTime*clock.ONE_SECOND_IN_TS:void 0;var timeInfo=tsInspector.inspect(data,tsStartTime);var result=null;if(timeInfo){result={// each type's time info comes back as an array of 2 times, start and end
hasVideo:timeInfo.video&&timeInfo.video.length===2||false,hasAudio:timeInfo.audio&&timeInfo.audio.length===2||false};if(result.hasVideo){result.videoStart=timeInfo.video[0].ptsTime;}if(result.hasAudio){result.audioStart=timeInfo.audio[0].ptsTime;}}this.self.postMessage({action:'probeTs',result:result,data:data},[data.buffer]);};_proto.clearAllMp4Captions=function clearAllMp4Captions(){if(this.captionParser){this.captionParser.clearAllCaptions();}};_proto.clearParsedMp4Captions=function clearParsedMp4Captions(){if(this.captionParser){this.captionParser.clearParsedCaptions();}}/**
     * Adds data (a ts segment) to the start of the transmuxer pipeline for
     * processing.
     *
     * @param {ArrayBuffer} data data to push into the muxer
     */;_proto.push=function push(data){// Cast array buffer to correct type for transmuxer
var segment=new Uint8Array(data.data,data.byteOffset,data.byteLength);this.transmuxer.push(segment);}/**
     * Recreate the transmuxer so that the next segment added via `push`
     * start with a fresh transmuxer.
     */;_proto.reset=function reset(){this.transmuxer.reset();}/**
     * Set the value that will be used as the `baseMediaDecodeTime` time for the
     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
     * set relative to the first based on the PTS values.
     *
     * @param {Object} data used to set the timestamp offset in the muxer
     */;_proto.setTimestampOffset=function setTimestampOffset(data){var timestampOffset=data.timestampOffset||0;this.transmuxer.setBaseMediaDecodeTime(Math.round(clock.secondsToVideoTs(timestampOffset)));};_proto.setAudioAppendStart=function setAudioAppendStart(data){this.transmuxer.setAudioAppendStart(Math.ceil(clock.secondsToVideoTs(data.appendStart)));};_proto.setRemux=function setRemux(data){this.transmuxer.setRemux(data.remux);}/**
     * Forces the pipeline to finish processing the last segment and emit it's
     * results.
     *
     * @param {Object} data event data, not really used
     */;_proto.flush=function flush(data){this.transmuxer.flush();// transmuxed done action is fired after both audio/video pipelines are flushed
self.postMessage({action:'done',type:'transmuxed'});};_proto.endTimeline=function endTimeline(){this.transmuxer.endTimeline();// transmuxed endedtimeline action is fired after both audio/video pipelines end their
// timelines
self.postMessage({action:'endedtimeline',type:'transmuxed'});};_proto.alignGopsWith=function alignGopsWith(data){this.transmuxer.alignGopsWith(data.gopsToAlignWith.slice());};return MessageHandlers;}();/**
   * Our web worker interface so that things can talk to mux.js
   * that will be running in a web worker. the scope is passed to this by
   * webworkify.
   *
   * @param {Object} self the scope for the web worker
   */self.onmessage=function(event){if(event.data.action==='init'&&event.data.options){this.messageHandlers=new MessageHandlers(self,event.data.options);return;}if(!this.messageHandlers){this.messageHandlers=new MessageHandlers(self);}if(event.data&&event.data.action&&event.data.action!=='init'){if(this.messageHandlers[event.data.action]){this.messageHandlers[event.data.action](event.data);}}};}));var TransmuxWorker=factory(workerCode$1);/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/transmuxer-worker.js */var handleData_=function handleData_(event,transmuxedData,callback){var _event$data$segment=event.data.segment,type=_event$data$segment.type,initSegment=_event$data$segment.initSegment,captions=_event$data$segment.captions,captionStreams=_event$data$segment.captionStreams,metadata=_event$data$segment.metadata,videoFrameDtsTime=_event$data$segment.videoFrameDtsTime,videoFramePtsTime=_event$data$segment.videoFramePtsTime;transmuxedData.buffer.push({captions:captions,captionStreams:captionStreams,metadata:metadata});var boxes=event.data.segment.boxes||{data:event.data.segment.data};var result={type:type,// cast ArrayBuffer to TypedArray
data:new Uint8Array(boxes.data,boxes.data.byteOffset,boxes.data.byteLength),initSegment:new Uint8Array(initSegment.data,initSegment.byteOffset,initSegment.byteLength)};if(typeof videoFrameDtsTime!=='undefined'){result.videoFrameDtsTime=videoFrameDtsTime;}if(typeof videoFramePtsTime!=='undefined'){result.videoFramePtsTime=videoFramePtsTime;}callback(result);};var handleDone_=function handleDone_(_ref){var transmuxedData=_ref.transmuxedData,callback=_ref.callback;// Previously we only returned data on data events,
// not on done events. Clear out the buffer to keep that consistent.
transmuxedData.buffer=[];// all buffers should have been flushed from the muxer, so start processing anything we
// have received
callback(transmuxedData);};var handleGopInfo_=function handleGopInfo_(event,transmuxedData){transmuxedData.gopInfo=event.data.gopInfo;};var processTransmux=function processTransmux(options){var transmuxer=options.transmuxer,bytes=options.bytes,audioAppendStart=options.audioAppendStart,gopsToAlignWith=options.gopsToAlignWith,remux=options.remux,onData=options.onData,onTrackInfo=options.onTrackInfo,onAudioTimingInfo=options.onAudioTimingInfo,onVideoTimingInfo=options.onVideoTimingInfo,onVideoSegmentTimingInfo=options.onVideoSegmentTimingInfo,onAudioSegmentTimingInfo=options.onAudioSegmentTimingInfo,onId3=options.onId3,onCaptions=options.onCaptions,onDone=options.onDone,onEndedTimeline=options.onEndedTimeline,onTransmuxerLog=options.onTransmuxerLog,isEndOfTimeline=options.isEndOfTimeline;var transmuxedData={buffer:[]};var waitForEndedTimelineEvent=isEndOfTimeline;var handleMessage=function handleMessage(event){if(transmuxer.currentTransmux!==options){// disposed
return;}if(event.data.action==='data'){handleData_(event,transmuxedData,onData);}if(event.data.action==='trackinfo'){onTrackInfo(event.data.trackInfo);}if(event.data.action==='gopInfo'){handleGopInfo_(event,transmuxedData);}if(event.data.action==='audioTimingInfo'){onAudioTimingInfo(event.data.audioTimingInfo);}if(event.data.action==='videoTimingInfo'){onVideoTimingInfo(event.data.videoTimingInfo);}if(event.data.action==='videoSegmentTimingInfo'){onVideoSegmentTimingInfo(event.data.videoSegmentTimingInfo);}if(event.data.action==='audioSegmentTimingInfo'){onAudioSegmentTimingInfo(event.data.audioSegmentTimingInfo);}if(event.data.action==='id3Frame'){onId3([event.data.id3Frame],event.data.id3Frame.dispatchType);}if(event.data.action==='caption'){onCaptions(event.data.caption);}if(event.data.action==='endedtimeline'){waitForEndedTimelineEvent=false;onEndedTimeline();}if(event.data.action==='log'){onTransmuxerLog(event.data.log);}// wait for the transmuxed event since we may have audio and video
if(event.data.type!=='transmuxed'){return;}// If the "endedtimeline" event has not yet fired, and this segment represents the end
// of a timeline, that means there may still be data events before the segment
// processing can be considerred complete. In that case, the final event should be
// an "endedtimeline" event with the type "transmuxed."
if(waitForEndedTimelineEvent){return;}transmuxer.onmessage=null;handleDone_({transmuxedData:transmuxedData,callback:onDone});/* eslint-disable no-use-before-define */dequeue(transmuxer);/* eslint-enable */};transmuxer.onmessage=handleMessage;if(audioAppendStart){transmuxer.postMessage({action:'setAudioAppendStart',appendStart:audioAppendStart});}// allow empty arrays to be passed to clear out GOPs
if(Array.isArray(gopsToAlignWith)){transmuxer.postMessage({action:'alignGopsWith',gopsToAlignWith:gopsToAlignWith});}if(typeof remux!=='undefined'){transmuxer.postMessage({action:'setRemux',remux:remux});}if(bytes.byteLength){var buffer=bytes instanceof ArrayBuffer?bytes:bytes.buffer;var byteOffset=bytes instanceof ArrayBuffer?0:bytes.byteOffset;transmuxer.postMessage({action:'push',// Send the typed-array of data as an ArrayBuffer so that
// it can be sent as a "Transferable" and avoid the costly
// memory copy
data:buffer,// To recreate the original typed-array, we need information
// about what portion of the ArrayBuffer it was a view into
byteOffset:byteOffset,byteLength:bytes.byteLength},[buffer]);}if(isEndOfTimeline){transmuxer.postMessage({action:'endTimeline'});}// even if we didn't push any bytes, we have to make sure we flush in case we reached
// the end of the segment
transmuxer.postMessage({action:'flush'});};var dequeue=function dequeue(transmuxer){transmuxer.currentTransmux=null;if(transmuxer.transmuxQueue.length){transmuxer.currentTransmux=transmuxer.transmuxQueue.shift();if(typeof transmuxer.currentTransmux==='function'){transmuxer.currentTransmux();}else{processTransmux(transmuxer.currentTransmux);}}};var processAction=function processAction(transmuxer,action){transmuxer.postMessage({action:action});dequeue(transmuxer);};var enqueueAction=function enqueueAction(action,transmuxer){if(!transmuxer.currentTransmux){transmuxer.currentTransmux=action;processAction(transmuxer,action);return;}transmuxer.transmuxQueue.push(processAction.bind(null,transmuxer,action));};var video_es_reset=function reset(transmuxer){enqueueAction('reset',transmuxer);};var endTimeline=function endTimeline(transmuxer){enqueueAction('endTimeline',transmuxer);};var transmux=function transmux(options){if(!options.transmuxer.currentTransmux){options.transmuxer.currentTransmux=options;processTransmux(options);return;}options.transmuxer.transmuxQueue.push(options);};var createTransmuxer=function createTransmuxer(options){var transmuxer=new TransmuxWorker();transmuxer.currentTransmux=null;transmuxer.transmuxQueue=[];var term=transmuxer.terminate;transmuxer.terminate=function(){transmuxer.currentTransmux=null;transmuxer.transmuxQueue.length=0;return term.call(transmuxer);};transmuxer.postMessage({action:'init',options:options});return transmuxer;};var segmentTransmuxer={reset:video_es_reset,endTimeline:endTimeline,transmux:transmux,createTransmuxer:createTransmuxer};var workerCallback=function workerCallback(options){var transmuxer=options.transmuxer;var endAction=options.endAction||options.action;var callback=options.callback;var message=_extends({},options,{endAction:null,transmuxer:null,callback:null});var listenForEndEvent=function listenForEndEvent(event){if(event.data.action!==endAction){return;}transmuxer.removeEventListener('message',listenForEndEvent);// transfer ownership of bytes back to us.
if(event.data.data){event.data.data=new Uint8Array(event.data.data,options.byteOffset||0,options.byteLength||event.data.data.byteLength);if(options.data){options.data=event.data.data;}}callback(event.data);};transmuxer.addEventListener('message',listenForEndEvent);if(options.data){var isArrayBuffer=options.data instanceof ArrayBuffer;message.byteOffset=isArrayBuffer?0:options.data.byteOffset;message.byteLength=options.data.byteLength;var transfers=[isArrayBuffer?options.data:options.data.buffer];transmuxer.postMessage(message,transfers);}else{transmuxer.postMessage(message);}};var REQUEST_ERRORS={FAILURE:2,TIMEOUT:-101,ABORTED:-102};/**
 * Abort all requests
 *
 * @param {Object} activeXhrs - an object that tracks all XHR requests
 */var abortAll=function abortAll(activeXhrs){activeXhrs.forEach(function(xhr){xhr.abort();});};/**
 * Gather important bandwidth stats once a request has completed
 *
 * @param {Object} request - the XHR request from which to gather stats
 */var getRequestStats=function getRequestStats(request){return{bandwidth:request.bandwidth,bytesReceived:request.bytesReceived||0,roundTripTime:request.roundTripTime||0};};/**
 * If possible gather bandwidth stats as a request is in
 * progress
 *
 * @param {Event} progressEvent - an event object from an XHR's progress event
 */var getProgressStats=function getProgressStats(progressEvent){var request=progressEvent.target;var roundTripTime=Date.now()-request.requestTime;var stats={bandwidth:Infinity,bytesReceived:0,roundTripTime:roundTripTime||0};stats.bytesReceived=progressEvent.loaded;// This can result in Infinity if stats.roundTripTime is 0 but that is ok
// because we should only use bandwidth stats on progress to determine when
// abort a request early due to insufficient bandwidth
stats.bandwidth=Math.floor(stats.bytesReceived/stats.roundTripTime*8*1000);return stats;};/**
 * Handle all error conditions in one place and return an object
 * with all the information
 *
 * @param {Error|null} error - if non-null signals an error occured with the XHR
 * @param {Object} request -  the XHR request that possibly generated the error
 */var handleErrors=function handleErrors(error,request){if(request.timedout){return{status:request.status,message:'HLS request timed-out at URL: '+request.uri,code:REQUEST_ERRORS.TIMEOUT,xhr:request};}if(request.aborted){return{status:request.status,message:'HLS request aborted at URL: '+request.uri,code:REQUEST_ERRORS.ABORTED,xhr:request};}if(error){return{status:request.status,message:'HLS request errored at URL: '+request.uri,code:REQUEST_ERRORS.FAILURE,xhr:request};}if(request.responseType==='arraybuffer'&&request.response.byteLength===0){return{status:request.status,message:'Empty HLS response at URL: '+request.uri,code:REQUEST_ERRORS.FAILURE,xhr:request};}return null;};/**
 * Handle responses for key data and convert the key data to the correct format
 * for the decryption step later
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Array} objects - objects to add the key bytes to.
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */var handleKeyResponse=function handleKeyResponse(segment,objects,finishProcessingFn){return function(error,request){var response=request.response;var errorObj=handleErrors(error,request);if(errorObj){return finishProcessingFn(errorObj,segment);}if(response.byteLength!==16){return finishProcessingFn({status:request.status,message:'Invalid HLS key at URL: '+request.uri,code:REQUEST_ERRORS.FAILURE,xhr:request},segment);}var view=new DataView(response);var bytes=new Uint32Array([view.getUint32(0),view.getUint32(4),view.getUint32(8),view.getUint32(12)]);for(var i=0;i<objects.length;i++){objects[i].bytes=bytes;}return finishProcessingFn(null,segment);};};var parseInitSegment=function parseInitSegment(segment,_callback){var type=detectContainerForBytes(segment.map.bytes);// TODO: We should also handle ts init segments here, but we
// only know how to parse mp4 init segments at the moment
if(type!=='mp4'){var uri=segment.map.resolvedUri||segment.map.uri;return _callback({internal:true,message:"Found unsupported "+(type||'unknown')+" container for initialization segment at URL: "+uri,code:REQUEST_ERRORS.FAILURE});}workerCallback({action:'probeMp4Tracks',data:segment.map.bytes,transmuxer:segment.transmuxer,callback:function callback(_ref){var tracks=_ref.tracks,data=_ref.data;// transfer bytes back to us
segment.map.bytes=data;tracks.forEach(function(track){segment.map.tracks=segment.map.tracks||{};// only support one track of each type for now
if(segment.map.tracks[track.type]){return;}segment.map.tracks[track.type]=track;if(typeof track.id==='number'&&track.timescale){segment.map.timescales=segment.map.timescales||{};segment.map.timescales[track.id]=track.timescale;}});return _callback(null);}});};/**
 * Handle init-segment responses
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */var handleInitSegmentResponse=function handleInitSegmentResponse(_ref2){var segment=_ref2.segment,finishProcessingFn=_ref2.finishProcessingFn;return function(error,request){var errorObj=handleErrors(error,request);if(errorObj){return finishProcessingFn(errorObj,segment);}var bytes=new Uint8Array(request.response);// init segment is encypted, we will have to wait
// until the key request is done to decrypt.
if(segment.map.key){segment.map.encryptedBytes=bytes;return finishProcessingFn(null,segment);}segment.map.bytes=bytes;parseInitSegment(segment,function(parseError){if(parseError){parseError.xhr=request;parseError.status=request.status;return finishProcessingFn(parseError,segment);}finishProcessingFn(null,segment);});};};/**
 * Response handler for segment-requests being sure to set the correct
 * property depending on whether the segment is encryped or not
 * Also records and keeps track of stats that are used for ABR purposes
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} finishProcessingFn - a callback to execute to continue processing
 *                                        this request
 */var handleSegmentResponse=function handleSegmentResponse(_ref3){var segment=_ref3.segment,finishProcessingFn=_ref3.finishProcessingFn,responseType=_ref3.responseType;return function(error,request){var errorObj=handleErrors(error,request);if(errorObj){return finishProcessingFn(errorObj,segment);}var newBytes=// although responseText "should" exist, this guard serves to prevent an error being
// thrown for two primary cases:
// 1. the mime type override stops working, or is not implemented for a specific
//    browser
// 2. when using mock XHR libraries like sinon that do not allow the override behavior
responseType==='arraybuffer'||!request.responseText?request.response:stringToArrayBuffer(request.responseText.substring(segment.lastReachedChar||0));segment.stats=getRequestStats(request);if(segment.key){segment.encryptedBytes=new Uint8Array(newBytes);}else{segment.bytes=new Uint8Array(newBytes);}return finishProcessingFn(null,segment);};};var transmuxAndNotify=function transmuxAndNotify(_ref4){var segment=_ref4.segment,bytes=_ref4.bytes,trackInfoFn=_ref4.trackInfoFn,timingInfoFn=_ref4.timingInfoFn,videoSegmentTimingInfoFn=_ref4.videoSegmentTimingInfoFn,audioSegmentTimingInfoFn=_ref4.audioSegmentTimingInfoFn,id3Fn=_ref4.id3Fn,captionsFn=_ref4.captionsFn,isEndOfTimeline=_ref4.isEndOfTimeline,endedTimelineFn=_ref4.endedTimelineFn,dataFn=_ref4.dataFn,doneFn=_ref4.doneFn,onTransmuxerLog=_ref4.onTransmuxerLog;var fmp4Tracks=segment.map&&segment.map.tracks||{};var isMuxed=Boolean(fmp4Tracks.audio&&fmp4Tracks.video);// Keep references to each function so we can null them out after we're done with them.
// One reason for this is that in the case of full segments, we want to trust start
// times from the probe, rather than the transmuxer.
var audioStartFn=timingInfoFn.bind(null,segment,'audio','start');var audioEndFn=timingInfoFn.bind(null,segment,'audio','end');var videoStartFn=timingInfoFn.bind(null,segment,'video','start');var videoEndFn=timingInfoFn.bind(null,segment,'video','end');var finish=function finish(){return transmux({bytes:bytes,transmuxer:segment.transmuxer,audioAppendStart:segment.audioAppendStart,gopsToAlignWith:segment.gopsToAlignWith,remux:isMuxed,onData:function onData(result){result.type=result.type==='combined'?'video':result.type;dataFn(segment,result);},onTrackInfo:function onTrackInfo(trackInfo){if(trackInfoFn){if(isMuxed){trackInfo.isMuxed=true;}trackInfoFn(segment,trackInfo);}},onAudioTimingInfo:function onAudioTimingInfo(audioTimingInfo){// we only want the first start value we encounter
if(audioStartFn&&typeof audioTimingInfo.start!=='undefined'){audioStartFn(audioTimingInfo.start);audioStartFn=null;}// we want to continually update the end time
if(audioEndFn&&typeof audioTimingInfo.end!=='undefined'){audioEndFn(audioTimingInfo.end);}},onVideoTimingInfo:function onVideoTimingInfo(videoTimingInfo){// we only want the first start value we encounter
if(videoStartFn&&typeof videoTimingInfo.start!=='undefined'){videoStartFn(videoTimingInfo.start);videoStartFn=null;}// we want to continually update the end time
if(videoEndFn&&typeof videoTimingInfo.end!=='undefined'){videoEndFn(videoTimingInfo.end);}},onVideoSegmentTimingInfo:function onVideoSegmentTimingInfo(videoSegmentTimingInfo){videoSegmentTimingInfoFn(videoSegmentTimingInfo);},onAudioSegmentTimingInfo:function onAudioSegmentTimingInfo(audioSegmentTimingInfo){audioSegmentTimingInfoFn(audioSegmentTimingInfo);},onId3:function onId3(id3Frames,dispatchType){id3Fn(segment,id3Frames,dispatchType);},onCaptions:function onCaptions(captions){captionsFn(segment,[captions]);},isEndOfTimeline:isEndOfTimeline,onEndedTimeline:function onEndedTimeline(){endedTimelineFn();},onTransmuxerLog:onTransmuxerLog,onDone:function onDone(result){if(!doneFn){return;}result.type=result.type==='combined'?'video':result.type;doneFn(null,segment,result);}});};// In the transmuxer, we don't yet have the ability to extract a "proper" start time.
// Meaning cached frame data may corrupt our notion of where this segment
// really starts. To get around this, probe for the info needed.
workerCallback({action:'probeTs',transmuxer:segment.transmuxer,data:bytes,baseStartTime:segment.baseStartTime,callback:function callback(data){segment.bytes=bytes=data.data;var probeResult=data.result;if(probeResult){trackInfoFn(segment,{hasAudio:probeResult.hasAudio,hasVideo:probeResult.hasVideo,isMuxed:isMuxed});trackInfoFn=null;if(probeResult.hasAudio&&!isMuxed){audioStartFn(probeResult.audioStart);}if(probeResult.hasVideo){videoStartFn(probeResult.videoStart);}audioStartFn=null;videoStartFn=null;}finish();}});};var handleSegmentBytes=function handleSegmentBytes(_ref5){var segment=_ref5.segment,bytes=_ref5.bytes,trackInfoFn=_ref5.trackInfoFn,timingInfoFn=_ref5.timingInfoFn,videoSegmentTimingInfoFn=_ref5.videoSegmentTimingInfoFn,audioSegmentTimingInfoFn=_ref5.audioSegmentTimingInfoFn,id3Fn=_ref5.id3Fn,captionsFn=_ref5.captionsFn,isEndOfTimeline=_ref5.isEndOfTimeline,endedTimelineFn=_ref5.endedTimelineFn,dataFn=_ref5.dataFn,doneFn=_ref5.doneFn,onTransmuxerLog=_ref5.onTransmuxerLog;var bytesAsUint8Array=new Uint8Array(bytes);// TODO:
// We should have a handler that fetches the number of bytes required
// to check if something is fmp4. This will allow us to save bandwidth
// because we can only blacklist a playlist and abort requests
// by codec after trackinfo triggers.
if(isLikelyFmp4MediaSegment(bytesAsUint8Array)){segment.isFmp4=true;var tracks=segment.map.tracks;var trackInfo={isFmp4:true,hasVideo:!!tracks.video,hasAudio:!!tracks.audio};// if we have a audio track, with a codec that is not set to
// encrypted audio
if(tracks.audio&&tracks.audio.codec&&tracks.audio.codec!=='enca'){trackInfo.audioCodec=tracks.audio.codec;}// if we have a video track, with a codec that is not set to
// encrypted video
if(tracks.video&&tracks.video.codec&&tracks.video.codec!=='encv'){trackInfo.videoCodec=tracks.video.codec;}if(tracks.video&&tracks.audio){trackInfo.isMuxed=true;}// since we don't support appending fmp4 data on progress, we know we have the full
// segment here
trackInfoFn(segment,trackInfo);// The probe doesn't provide the segment end time, so only callback with the start
// time. The end time can be roughly calculated by the receiver using the duration.
//
// Note that the start time returned by the probe reflects the baseMediaDecodeTime, as
// that is the true start of the segment (where the playback engine should begin
// decoding).
var finishLoading=function finishLoading(captions){// if the track still has audio at this point it is only possible
// for it to be audio only. See `tracks.video && tracks.audio` if statement
// above.
// we make sure to use segment.bytes here as that
dataFn(segment,{data:bytesAsUint8Array,type:trackInfo.hasAudio&&!trackInfo.isMuxed?'audio':'video'});if(captions&&captions.length){captionsFn(segment,captions);}doneFn(null,segment,{});};workerCallback({action:'probeMp4StartTime',timescales:segment.map.timescales,data:bytesAsUint8Array,transmuxer:segment.transmuxer,callback:function callback(_ref6){var data=_ref6.data,startTime=_ref6.startTime;// transfer bytes back to us
bytes=data.buffer;segment.bytes=bytesAsUint8Array=data;if(trackInfo.hasAudio&&!trackInfo.isMuxed){timingInfoFn(segment,'audio','start',startTime);}if(trackInfo.hasVideo){timingInfoFn(segment,'video','start',startTime);}// Run through the CaptionParser in case there are captions.
// Initialize CaptionParser if it hasn't been yet
if(!tracks.video||!data.byteLength||!segment.transmuxer){finishLoading();return;}workerCallback({action:'pushMp4Captions',endAction:'mp4Captions',transmuxer:segment.transmuxer,data:bytesAsUint8Array,timescales:segment.map.timescales,trackIds:[tracks.video.id],callback:function callback(message){// transfer bytes back to us
bytes=message.data.buffer;segment.bytes=bytesAsUint8Array=message.data;message.logs.forEach(function(log){onTransmuxerLog(videojs.mergeOptions(log,{stream:'mp4CaptionParser'}));});finishLoading(message.captions);}});}});return;}// VTT or other segments that don't need processing
if(!segment.transmuxer){doneFn(null,segment,{});return;}if(typeof segment.container==='undefined'){segment.container=detectContainerForBytes(bytesAsUint8Array);}if(segment.container!=='ts'&&segment.container!=='aac'){trackInfoFn(segment,{hasAudio:false,hasVideo:false});doneFn(null,segment,{});return;}// ts or aac
transmuxAndNotify({segment:segment,bytes:bytes,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn,doneFn:doneFn,onTransmuxerLog:onTransmuxerLog});};var decrypt=function decrypt(_ref7,callback){var id=_ref7.id,key=_ref7.key,encryptedBytes=_ref7.encryptedBytes,decryptionWorker=_ref7.decryptionWorker;var decryptionHandler=function decryptionHandler(event){if(event.data.source===id){decryptionWorker.removeEventListener('message',decryptionHandler);var decrypted=event.data.decrypted;callback(new Uint8Array(decrypted.bytes,decrypted.byteOffset,decrypted.byteLength));}};decryptionWorker.addEventListener('message',decryptionHandler);var keyBytes;if(key.bytes.slice){keyBytes=key.bytes.slice();}else{keyBytes=new Uint32Array(Array.prototype.slice.call(key.bytes));}// incrementally decrypt the bytes
decryptionWorker.postMessage(createTransferableMessage({source:id,encrypted:encryptedBytes,key:keyBytes,iv:key.iv}),[encryptedBytes.buffer,keyBytes.buffer]);};/**
 * Decrypt the segment via the decryption web worker
 *
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
 *                                       routines
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Function} doneFn - a callback that is executed after decryption has completed
 */var decryptSegment=function decryptSegment(_ref8){var decryptionWorker=_ref8.decryptionWorker,segment=_ref8.segment,trackInfoFn=_ref8.trackInfoFn,timingInfoFn=_ref8.timingInfoFn,videoSegmentTimingInfoFn=_ref8.videoSegmentTimingInfoFn,audioSegmentTimingInfoFn=_ref8.audioSegmentTimingInfoFn,id3Fn=_ref8.id3Fn,captionsFn=_ref8.captionsFn,isEndOfTimeline=_ref8.isEndOfTimeline,endedTimelineFn=_ref8.endedTimelineFn,dataFn=_ref8.dataFn,doneFn=_ref8.doneFn,onTransmuxerLog=_ref8.onTransmuxerLog;decrypt({id:segment.requestId,key:segment.key,encryptedBytes:segment.encryptedBytes,decryptionWorker:decryptionWorker},function(decryptedBytes){segment.bytes=decryptedBytes;handleSegmentBytes({segment:segment,bytes:segment.bytes,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn,doneFn:doneFn,onTransmuxerLog:onTransmuxerLog});});};/**
 * This function waits for all XHRs to finish (with either success or failure)
 * before continueing processing via it's callback. The function gathers errors
 * from each request into a single errors array so that the error status for
 * each request can be examined later.
 *
 * @param {Object} activeXhrs - an object that tracks all XHR requests
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128 decryption
 *                                       routines
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} id3Fn - a callback that receives ID3 metadata
 * @param {Function} captionsFn - a callback that receives captions
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Function} doneFn - a callback that is executed after all resources have been
 *                            downloaded and any decryption completed
 */var waitForCompletion=function waitForCompletion(_ref9){var activeXhrs=_ref9.activeXhrs,decryptionWorker=_ref9.decryptionWorker,trackInfoFn=_ref9.trackInfoFn,timingInfoFn=_ref9.timingInfoFn,videoSegmentTimingInfoFn=_ref9.videoSegmentTimingInfoFn,audioSegmentTimingInfoFn=_ref9.audioSegmentTimingInfoFn,id3Fn=_ref9.id3Fn,captionsFn=_ref9.captionsFn,isEndOfTimeline=_ref9.isEndOfTimeline,endedTimelineFn=_ref9.endedTimelineFn,dataFn=_ref9.dataFn,doneFn=_ref9.doneFn,onTransmuxerLog=_ref9.onTransmuxerLog;var count=0;var didError=false;return function(error,segment){if(didError){return;}if(error){didError=true;// If there are errors, we have to abort any outstanding requests
abortAll(activeXhrs);// Even though the requests above are aborted, and in theory we could wait until we
// handle the aborted events from those requests, there are some cases where we may
// never get an aborted event. For instance, if the network connection is lost and
// there were two requests, the first may have triggered an error immediately, while
// the second request remains unsent. In that case, the aborted algorithm will not
// trigger an abort: see https://xhr.spec.whatwg.org/#the-abort()-method
//
// We also can't rely on the ready state of the XHR, since the request that
// triggered the connection error may also show as a ready state of 0 (unsent).
// Therefore, we have to finish this group of requests immediately after the first
// seen error.
return doneFn(error,segment);}count+=1;if(count===activeXhrs.length){var segmentFinish=function segmentFinish(){if(segment.encryptedBytes){return decryptSegment({decryptionWorker:decryptionWorker,segment:segment,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn,doneFn:doneFn,onTransmuxerLog:onTransmuxerLog});}// Otherwise, everything is ready just continue
handleSegmentBytes({segment:segment,bytes:segment.bytes,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn,doneFn:doneFn,onTransmuxerLog:onTransmuxerLog});};// Keep track of when *all* of the requests have completed
segment.endOfAllRequests=Date.now();if(segment.map&&segment.map.encryptedBytes&&!segment.map.bytes){return decrypt({decryptionWorker:decryptionWorker,// add -init to the "id" to differentiate between segment
// and init segment decryption, just in case they happen
// at the same time at some point in the future.
id:segment.requestId+'-init',encryptedBytes:segment.map.encryptedBytes,key:segment.map.key},function(decryptedBytes){segment.map.bytes=decryptedBytes;parseInitSegment(segment,function(parseError){if(parseError){abortAll(activeXhrs);return doneFn(parseError,segment);}segmentFinish();});});}segmentFinish();}};};/**
 * Calls the abort callback if any request within the batch was aborted. Will only call
 * the callback once per batch of requests, even if multiple were aborted.
 *
 * @param {Object} loadendState - state to check to see if the abort function was called
 * @param {Function} abortFn - callback to call for abort
 */var handleLoadEnd=function handleLoadEnd(_ref10){var loadendState=_ref10.loadendState,abortFn=_ref10.abortFn;return function(event){var request=event.target;if(request.aborted&&abortFn&&!loadendState.calledAbortFn){abortFn();loadendState.calledAbortFn=true;}};};/**
 * Simple progress event callback handler that gathers some stats before
 * executing a provided callback with the `segment` object
 *
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} progressFn - a callback that is executed each time a progress event
 *                                is received
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that is executed when segment bytes are available
 *                            and ready to use
 * @param {Event} event - the progress event object from XMLHttpRequest
 */var handleProgress=function handleProgress(_ref11){var segment=_ref11.segment,progressFn=_ref11.progressFn;_ref11.trackInfoFn;_ref11.timingInfoFn;_ref11.videoSegmentTimingInfoFn;_ref11.audioSegmentTimingInfoFn;_ref11.id3Fn;_ref11.captionsFn;_ref11.isEndOfTimeline;_ref11.endedTimelineFn;_ref11.dataFn;return function(event){var request=event.target;if(request.aborted){return;}segment.stats=videojs.mergeOptions(segment.stats,getProgressStats(event));// record the time that we receive the first byte of data
if(!segment.stats.firstBytesReceivedAt&&segment.stats.bytesReceived){segment.stats.firstBytesReceivedAt=Date.now();}return progressFn(event,segment);};};/**
 * Load all resources and does any processing necessary for a media-segment
 *
 * Features:
 *   decrypts the media-segment if it has a key uri and an iv
 *   aborts *all* requests if *any* one request fails
 *
 * The segment object, at minimum, has the following format:
 * {
 *   resolvedUri: String,
 *   [transmuxer]: Object,
 *   [byterange]: {
 *     offset: Number,
 *     length: Number
 *   },
 *   [key]: {
 *     resolvedUri: String
 *     [byterange]: {
 *       offset: Number,
 *       length: Number
 *     },
 *     iv: {
 *       bytes: Uint32Array
 *     }
 *   },
 *   [map]: {
 *     resolvedUri: String,
 *     [byterange]: {
 *       offset: Number,
 *       length: Number
 *     },
 *     [bytes]: Uint8Array
 *   }
 * }
 * ...where [name] denotes optional properties
 *
 * @param {Function} xhr - an instance of the xhr wrapper in xhr.js
 * @param {Object} xhrOptions - the base options to provide to all xhr requests
 * @param {WebWorker} decryptionWorker - a WebWorker interface to AES-128
 *                                       decryption routines
 * @param {Object} segment - a simplified copy of the segmentInfo object
 *                           from SegmentLoader
 * @param {Function} abortFn - a callback called (only once) if any piece of a request was
 *                             aborted
 * @param {Function} progressFn - a callback that receives progress events from the main
 *                                segment's xhr request
 * @param {Function} trackInfoFn - a callback that receives track info
 * @param {Function} timingInfoFn - a callback that receives timing info
 * @param {Function} videoSegmentTimingInfoFn
 *                   a callback that receives video timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} audioSegmentTimingInfoFn
 *                   a callback that receives audio timing info based on media times and
 *                   any adjustments made by the transmuxer
 * @param {Function} id3Fn - a callback that receives ID3 metadata
 * @param {Function} captionsFn - a callback that receives captions
 * @param {boolean}  isEndOfTimeline
 *                   true if this segment represents the last segment in a timeline
 * @param {Function} endedTimelineFn
 *                   a callback made when a timeline is ended, will only be called if
 *                   isEndOfTimeline is true
 * @param {Function} dataFn - a callback that receives data from the main segment's xhr
 *                            request, transmuxed if needed
 * @param {Function} doneFn - a callback that is executed only once all requests have
 *                            succeeded or failed
 * @return {Function} a function that, when invoked, immediately aborts all
 *                     outstanding requests
 */var mediaSegmentRequest=function mediaSegmentRequest(_ref12){var xhr=_ref12.xhr,xhrOptions=_ref12.xhrOptions,decryptionWorker=_ref12.decryptionWorker,segment=_ref12.segment,abortFn=_ref12.abortFn,progressFn=_ref12.progressFn,trackInfoFn=_ref12.trackInfoFn,timingInfoFn=_ref12.timingInfoFn,videoSegmentTimingInfoFn=_ref12.videoSegmentTimingInfoFn,audioSegmentTimingInfoFn=_ref12.audioSegmentTimingInfoFn,id3Fn=_ref12.id3Fn,captionsFn=_ref12.captionsFn,isEndOfTimeline=_ref12.isEndOfTimeline,endedTimelineFn=_ref12.endedTimelineFn,dataFn=_ref12.dataFn,doneFn=_ref12.doneFn,onTransmuxerLog=_ref12.onTransmuxerLog;var activeXhrs=[];var finishProcessingFn=waitForCompletion({activeXhrs:activeXhrs,decryptionWorker:decryptionWorker,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn,doneFn:doneFn,onTransmuxerLog:onTransmuxerLog});// optionally, request the decryption key
if(segment.key&&!segment.key.bytes){var objects=[segment.key];if(segment.map&&!segment.map.bytes&&segment.map.key&&segment.map.key.resolvedUri===segment.key.resolvedUri){objects.push(segment.map.key);}var keyRequestOptions=videojs.mergeOptions(xhrOptions,{uri:segment.key.resolvedUri,responseType:'arraybuffer'});var keyRequestCallback=handleKeyResponse(segment,objects,finishProcessingFn);var keyXhr=xhr(keyRequestOptions,keyRequestCallback);activeXhrs.push(keyXhr);}// optionally, request the associated media init segment
if(segment.map&&!segment.map.bytes){var differentMapKey=segment.map.key&&(!segment.key||segment.key.resolvedUri!==segment.map.key.resolvedUri);if(differentMapKey){var mapKeyRequestOptions=videojs.mergeOptions(xhrOptions,{uri:segment.map.key.resolvedUri,responseType:'arraybuffer'});var mapKeyRequestCallback=handleKeyResponse(segment,[segment.map.key],finishProcessingFn);var mapKeyXhr=xhr(mapKeyRequestOptions,mapKeyRequestCallback);activeXhrs.push(mapKeyXhr);}var initSegmentOptions=videojs.mergeOptions(xhrOptions,{uri:segment.map.resolvedUri,responseType:'arraybuffer',headers:segmentXhrHeaders(segment.map)});var initSegmentRequestCallback=handleInitSegmentResponse({segment:segment,finishProcessingFn:finishProcessingFn});var initSegmentXhr=xhr(initSegmentOptions,initSegmentRequestCallback);activeXhrs.push(initSegmentXhr);}var segmentRequestOptions=videojs.mergeOptions(xhrOptions,{uri:segment.part&&segment.part.resolvedUri||segment.resolvedUri,responseType:'arraybuffer',headers:segmentXhrHeaders(segment)});var segmentRequestCallback=handleSegmentResponse({segment:segment,finishProcessingFn:finishProcessingFn,responseType:segmentRequestOptions.responseType});var segmentXhr=xhr(segmentRequestOptions,segmentRequestCallback);segmentXhr.addEventListener('progress',handleProgress({segment:segment,progressFn:progressFn,trackInfoFn:trackInfoFn,timingInfoFn:timingInfoFn,videoSegmentTimingInfoFn:videoSegmentTimingInfoFn,audioSegmentTimingInfoFn:audioSegmentTimingInfoFn,id3Fn:id3Fn,captionsFn:captionsFn,isEndOfTimeline:isEndOfTimeline,endedTimelineFn:endedTimelineFn,dataFn:dataFn}));activeXhrs.push(segmentXhr);// since all parts of the request must be considered, but should not make callbacks
// multiple times, provide a shared state object
var loadendState={};activeXhrs.forEach(function(activeXhr){activeXhr.addEventListener('loadend',handleLoadEnd({loadendState:loadendState,abortFn:abortFn}));});return function(){return abortAll(activeXhrs);};};/**
 * @file - codecs.js - Handles tasks regarding codec strings such as translating them to
 * codec strings, or translating codec strings into objects that can be examined.
 */var logFn$1=logger('CodecUtils');/**
 * Returns a set of codec strings parsed from the playlist or the default
 * codec strings if no codecs were specified in the playlist
 *
 * @param {Playlist} media the current media playlist
 * @return {Object} an object with the video and audio codecs
 */var getCodecs=function getCodecs(media){// if the codecs were explicitly specified, use them instead of the
// defaults
var mediaAttributes=media.attributes||{};if(mediaAttributes.CODECS){return parseCodecs(mediaAttributes.CODECS);}};var isMaat=function isMaat(master,media){var mediaAttributes=media.attributes||{};return master&&master.mediaGroups&&master.mediaGroups.AUDIO&&mediaAttributes.AUDIO&&master.mediaGroups.AUDIO[mediaAttributes.AUDIO];};var isMuxed=function isMuxed(master,media){if(!isMaat(master,media)){return true;}var mediaAttributes=media.attributes||{};var audioGroup=master.mediaGroups.AUDIO[mediaAttributes.AUDIO];for(var groupId in audioGroup){// If an audio group has a URI (the case for HLS, as HLS will use external playlists),
// or there are listed playlists (the case for DASH, as the manifest will have already
// provided all of the details necessary to generate the audio playlist, as opposed to
// HLS' externally requested playlists), then the content is demuxed.
if(!audioGroup[groupId].uri&&!audioGroup[groupId].playlists){return true;}}return false;};var unwrapCodecList=function unwrapCodecList(codecList){var codecs={};codecList.forEach(function(_ref){var mediaType=_ref.mediaType,type=_ref.type,details=_ref.details;codecs[mediaType]=codecs[mediaType]||[];codecs[mediaType].push(translateLegacyCodec(""+type+details));});Object.keys(codecs).forEach(function(mediaType){if(codecs[mediaType].length>1){logFn$1("multiple "+mediaType+" codecs found as attributes: "+codecs[mediaType].join(', ')+". Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.");codecs[mediaType]=null;return;}codecs[mediaType]=codecs[mediaType][0];});return codecs;};var codecCount=function codecCount(codecObj){var count=0;if(codecObj.audio){count++;}if(codecObj.video){count++;}return count;};/**
 * Calculates the codec strings for a working configuration of
 * SourceBuffers to play variant streams in a master playlist. If
 * there is no possible working configuration, an empty object will be
 * returned.
 *
 * @param master {Object} the m3u8 object for the master playlist
 * @param media {Object} the m3u8 object for the variant playlist
 * @return {Object} the codec strings.
 *
 * @private
 */var codecsForPlaylist=function codecsForPlaylist(master,media){var mediaAttributes=media.attributes||{};var codecInfo=unwrapCodecList(getCodecs(media)||[]);// HLS with multiple-audio tracks must always get an audio codec.
// Put another way, there is no way to have a video-only multiple-audio HLS!
if(isMaat(master,media)&&!codecInfo.audio){if(!isMuxed(master,media)){// It is possible for codecs to be specified on the audio media group playlist but
// not on the rendition playlist. This is mostly the case for DASH, where audio and
// video are always separate (and separately specified).
var defaultCodecs=unwrapCodecList(codecsFromDefault(master,mediaAttributes.AUDIO)||[]);if(defaultCodecs.audio){codecInfo.audio=defaultCodecs.audio;}}}return codecInfo;};var logFn=logger('PlaylistSelector');var representationToString=function representationToString(representation){if(!representation||!representation.playlist){return;}var playlist=representation.playlist;return JSON.stringify({id:playlist.id,bandwidth:representation.bandwidth,width:representation.width,height:representation.height,codecs:playlist.attributes&&playlist.attributes.CODECS||''});};// Utilities
/**
 * Returns the CSS value for the specified property on an element
 * using `getComputedStyle`. Firefox has a long-standing issue where
 * getComputedStyle() may return null when running in an iframe with
 * `display: none`.
 *
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 * @param {HTMLElement} el the htmlelement to work on
 * @param {string} the proprety to get the style for
 */var safeGetComputedStyle=function safeGetComputedStyle(el,property){if(!el){return'';}var result=window_default().getComputedStyle(el);if(!result){return'';}return result[property];};/**
 * Resuable stable sort function
 *
 * @param {Playlists} array
 * @param {Function} sortFn Different comparators
 * @function stableSort
 */var stableSort=function stableSort(array,sortFn){var newArray=array.slice();array.sort(function(left,right){var cmp=sortFn(left,right);if(cmp===0){return newArray.indexOf(left)-newArray.indexOf(right);}return cmp;});};/**
 * A comparator function to sort two playlist object by bandwidth.
 *
 * @param {Object} left a media playlist object
 * @param {Object} right a media playlist object
 * @return {number} Greater than zero if the bandwidth attribute of
 * left is greater than the corresponding attribute of right. Less
 * than zero if the bandwidth of right is greater than left and
 * exactly zero if the two are equal.
 */var comparePlaylistBandwidth=function comparePlaylistBandwidth(left,right){var leftBandwidth;var rightBandwidth;if(left.attributes.BANDWIDTH){leftBandwidth=left.attributes.BANDWIDTH;}leftBandwidth=leftBandwidth||(window_default()).Number.MAX_VALUE;if(right.attributes.BANDWIDTH){rightBandwidth=right.attributes.BANDWIDTH;}rightBandwidth=rightBandwidth||(window_default()).Number.MAX_VALUE;return leftBandwidth-rightBandwidth;};/**
 * A comparator function to sort two playlist object by resolution (width).
 *
 * @param {Object} left a media playlist object
 * @param {Object} right a media playlist object
 * @return {number} Greater than zero if the resolution.width attribute of
 * left is greater than the corresponding attribute of right. Less
 * than zero if the resolution.width of right is greater than left and
 * exactly zero if the two are equal.
 */var comparePlaylistResolution=function comparePlaylistResolution(left,right){var leftWidth;var rightWidth;if(left.attributes.RESOLUTION&&left.attributes.RESOLUTION.width){leftWidth=left.attributes.RESOLUTION.width;}leftWidth=leftWidth||(window_default()).Number.MAX_VALUE;if(right.attributes.RESOLUTION&&right.attributes.RESOLUTION.width){rightWidth=right.attributes.RESOLUTION.width;}rightWidth=rightWidth||(window_default()).Number.MAX_VALUE;// NOTE - Fallback to bandwidth sort as appropriate in cases where multiple renditions
// have the same media dimensions/ resolution
if(leftWidth===rightWidth&&left.attributes.BANDWIDTH&&right.attributes.BANDWIDTH){return left.attributes.BANDWIDTH-right.attributes.BANDWIDTH;}return leftWidth-rightWidth;};/**
 * Chooses the appropriate media playlist based on bandwidth and player size
 *
 * @param {Object} master
 *        Object representation of the master manifest
 * @param {number} playerBandwidth
 *        Current calculated bandwidth of the player
 * @param {number} playerWidth
 *        Current width of the player element (should account for the device pixel ratio)
 * @param {number} playerHeight
 *        Current height of the player element (should account for the device pixel ratio)
 * @param {boolean} limitRenditionByPlayerDimensions
 *        True if the player width and height should be used during the selection, false otherwise
 * @param {Object} masterPlaylistController
 *        the current masterPlaylistController object
 * @return {Playlist} the highest bitrate playlist less than the
 * currently detected bandwidth, accounting for some amount of
 * bandwidth variance
 */var simpleSelector=function simpleSelector(master,playerBandwidth,playerWidth,playerHeight,limitRenditionByPlayerDimensions,masterPlaylistController){// If we end up getting called before `master` is available, exit early
if(!master){return;}var options={bandwidth:playerBandwidth,width:playerWidth,height:playerHeight,limitRenditionByPlayerDimensions:limitRenditionByPlayerDimensions};var playlists=master.playlists;// if playlist is audio only, select between currently active audio group playlists.
if(Playlist.isAudioOnly(master)){playlists=masterPlaylistController.getAudioTrackPlaylists_();// add audioOnly to options so that we log audioOnly: true
// at the buttom of this function for debugging.
options.audioOnly=true;}// convert the playlists to an intermediary representation to make comparisons easier
var sortedPlaylistReps=playlists.map(function(playlist){var bandwidth;var width=playlist.attributes&&playlist.attributes.RESOLUTION&&playlist.attributes.RESOLUTION.width;var height=playlist.attributes&&playlist.attributes.RESOLUTION&&playlist.attributes.RESOLUTION.height;bandwidth=playlist.attributes&&playlist.attributes.BANDWIDTH;bandwidth=bandwidth||(window_default()).Number.MAX_VALUE;return{bandwidth:bandwidth,width:width,height:height,playlist:playlist};});stableSort(sortedPlaylistReps,function(left,right){return left.bandwidth-right.bandwidth;});// filter out any playlists that have been excluded due to
// incompatible configurations
sortedPlaylistReps=sortedPlaylistReps.filter(function(rep){return!Playlist.isIncompatible(rep.playlist);});// filter out any playlists that have been disabled manually through the representations
// api or blacklisted temporarily due to playback errors.
var enabledPlaylistReps=sortedPlaylistReps.filter(function(rep){return Playlist.isEnabled(rep.playlist);});if(!enabledPlaylistReps.length){// if there are no enabled playlists, then they have all been blacklisted or disabled
// by the user through the representations api. In this case, ignore blacklisting and
// fallback to what the user wants by using playlists the user has not disabled.
enabledPlaylistReps=sortedPlaylistReps.filter(function(rep){return!Playlist.isDisabled(rep.playlist);});}// filter out any variant that has greater effective bitrate
// than the current estimated bandwidth
var bandwidthPlaylistReps=enabledPlaylistReps.filter(function(rep){return rep.bandwidth*Config.BANDWIDTH_VARIANCE<playerBandwidth;});var highestRemainingBandwidthRep=bandwidthPlaylistReps[bandwidthPlaylistReps.length-1];// get all of the renditions with the same (highest) bandwidth
// and then taking the very first element
var bandwidthBestRep=bandwidthPlaylistReps.filter(function(rep){return rep.bandwidth===highestRemainingBandwidthRep.bandwidth;})[0];// if we're not going to limit renditions by player size, make an early decision.
if(limitRenditionByPlayerDimensions===false){var _chosenRep=bandwidthBestRep||enabledPlaylistReps[0]||sortedPlaylistReps[0];if(_chosenRep&&_chosenRep.playlist){var type='sortedPlaylistReps';if(bandwidthBestRep){type='bandwidthBestRep';}if(enabledPlaylistReps[0]){type='enabledPlaylistReps';}logFn("choosing "+representationToString(_chosenRep)+" using "+type+" with options",options);return _chosenRep.playlist;}logFn('could not choose a playlist with options',options);return null;}// filter out playlists without resolution information
var haveResolution=bandwidthPlaylistReps.filter(function(rep){return rep.width&&rep.height;});// sort variants by resolution
stableSort(haveResolution,function(left,right){return left.width-right.width;});// if we have the exact resolution as the player use it
var resolutionBestRepList=haveResolution.filter(function(rep){return rep.width===playerWidth&&rep.height===playerHeight;});highestRemainingBandwidthRep=resolutionBestRepList[resolutionBestRepList.length-1];// ensure that we pick the highest bandwidth variant that have exact resolution
var resolutionBestRep=resolutionBestRepList.filter(function(rep){return rep.bandwidth===highestRemainingBandwidthRep.bandwidth;})[0];var resolutionPlusOneList;var resolutionPlusOneSmallest;var resolutionPlusOneRep;// find the smallest variant that is larger than the player
// if there is no match of exact resolution
if(!resolutionBestRep){resolutionPlusOneList=haveResolution.filter(function(rep){return rep.width>playerWidth||rep.height>playerHeight;});// find all the variants have the same smallest resolution
resolutionPlusOneSmallest=resolutionPlusOneList.filter(function(rep){return rep.width===resolutionPlusOneList[0].width&&rep.height===resolutionPlusOneList[0].height;});// ensure that we also pick the highest bandwidth variant that
// is just-larger-than the video player
highestRemainingBandwidthRep=resolutionPlusOneSmallest[resolutionPlusOneSmallest.length-1];resolutionPlusOneRep=resolutionPlusOneSmallest.filter(function(rep){return rep.bandwidth===highestRemainingBandwidthRep.bandwidth;})[0];}var leastPixelDiffRep;// If this selector proves to be better than others,
// resolutionPlusOneRep and resolutionBestRep and all
// the code involving them should be removed.
if(masterPlaylistController.experimentalLeastPixelDiffSelector){// find the variant that is closest to the player's pixel size
var leastPixelDiffList=haveResolution.map(function(rep){rep.pixelDiff=Math.abs(rep.width-playerWidth)+Math.abs(rep.height-playerHeight);return rep;});// get the highest bandwidth, closest resolution playlist
stableSort(leastPixelDiffList,function(left,right){// sort by highest bandwidth if pixelDiff is the same
if(left.pixelDiff===right.pixelDiff){return right.bandwidth-left.bandwidth;}return left.pixelDiff-right.pixelDiff;});leastPixelDiffRep=leastPixelDiffList[0];}// fallback chain of variants
var chosenRep=leastPixelDiffRep||resolutionPlusOneRep||resolutionBestRep||bandwidthBestRep||enabledPlaylistReps[0]||sortedPlaylistReps[0];if(chosenRep&&chosenRep.playlist){var _type='sortedPlaylistReps';if(leastPixelDiffRep){_type='leastPixelDiffRep';}else if(resolutionPlusOneRep){_type='resolutionPlusOneRep';}else if(resolutionBestRep){_type='resolutionBestRep';}else if(bandwidthBestRep){_type='bandwidthBestRep';}else if(enabledPlaylistReps[0]){_type='enabledPlaylistReps';}logFn("choosing "+representationToString(chosenRep)+" using "+_type+" with options",options);return chosenRep.playlist;}logFn('could not choose a playlist with options',options);return null;};/**
 * Chooses the appropriate media playlist based on the most recent
 * bandwidth estimate and the player size.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @return {Playlist} the highest bitrate playlist less than the
 * currently detected bandwidth, accounting for some amount of
 * bandwidth variance
 */var lastBandwidthSelector=function lastBandwidthSelector(){var pixelRatio=this.useDevicePixelRatio?(window_default()).devicePixelRatio||1:1;return simpleSelector(this.playlists.master,this.systemBandwidth,parseInt(safeGetComputedStyle(this.tech_.el(),'width'),10)*pixelRatio,parseInt(safeGetComputedStyle(this.tech_.el(),'height'),10)*pixelRatio,this.limitRenditionByPlayerDimensions,this.masterPlaylistController_);};/**
 * Chooses the appropriate media playlist based on an
 * exponential-weighted moving average of the bandwidth after
 * filtering for player size.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @param {number} decay - a number between 0 and 1. Higher values of
 * this parameter will cause previous bandwidth estimates to lose
 * significance more quickly.
 * @return {Function} a function which can be invoked to create a new
 * playlist selector function.
 * @see https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 */var movingAverageBandwidthSelector=function movingAverageBandwidthSelector(decay){var average=-1;var lastSystemBandwidth=-1;if(decay<0||decay>1){throw new Error('Moving average bandwidth decay must be between 0 and 1.');}return function(){var pixelRatio=this.useDevicePixelRatio?(window_default()).devicePixelRatio||1:1;if(average<0){average=this.systemBandwidth;lastSystemBandwidth=this.systemBandwidth;}// stop the average value from decaying for every 250ms
// when the systemBandwidth is constant
// and
// stop average from setting to a very low value when the
// systemBandwidth becomes 0 in case of chunk cancellation
if(this.systemBandwidth>0&&this.systemBandwidth!==lastSystemBandwidth){average=decay*this.systemBandwidth+(1-decay)*average;lastSystemBandwidth=this.systemBandwidth;}return simpleSelector(this.playlists.master,average,parseInt(safeGetComputedStyle(this.tech_.el(),'width'),10)*pixelRatio,parseInt(safeGetComputedStyle(this.tech_.el(),'height'),10)*pixelRatio,this.limitRenditionByPlayerDimensions,this.masterPlaylistController_);};};/**
 * Chooses the appropriate media playlist based on the potential to rebuffer
 *
 * @param {Object} settings
 *        Object of information required to use this selector
 * @param {Object} settings.master
 *        Object representation of the master manifest
 * @param {number} settings.currentTime
 *        The current time of the player
 * @param {number} settings.bandwidth
 *        Current measured bandwidth
 * @param {number} settings.duration
 *        Duration of the media
 * @param {number} settings.segmentDuration
 *        Segment duration to be used in round trip time calculations
 * @param {number} settings.timeUntilRebuffer
 *        Time left in seconds until the player has to rebuffer
 * @param {number} settings.currentTimeline
 *        The current timeline segments are being loaded from
 * @param {SyncController} settings.syncController
 *        SyncController for determining if we have a sync point for a given playlist
 * @return {Object|null}
 *         {Object} return.playlist
 *         The highest bandwidth playlist with the least amount of rebuffering
 *         {Number} return.rebufferingImpact
 *         The amount of time in seconds switching to this playlist will rebuffer. A
 *         negative value means that switching will cause zero rebuffering.
 */var minRebufferMaxBandwidthSelector=function minRebufferMaxBandwidthSelector(settings){var master=settings.master,currentTime=settings.currentTime,bandwidth=settings.bandwidth,duration=settings.duration,segmentDuration=settings.segmentDuration,timeUntilRebuffer=settings.timeUntilRebuffer,currentTimeline=settings.currentTimeline,syncController=settings.syncController;// filter out any playlists that have been excluded due to
// incompatible configurations
var compatiblePlaylists=master.playlists.filter(function(playlist){return!Playlist.isIncompatible(playlist);});// filter out any playlists that have been disabled manually through the representations
// api or blacklisted temporarily due to playback errors.
var enabledPlaylists=compatiblePlaylists.filter(Playlist.isEnabled);if(!enabledPlaylists.length){// if there are no enabled playlists, then they have all been blacklisted or disabled
// by the user through the representations api. In this case, ignore blacklisting and
// fallback to what the user wants by using playlists the user has not disabled.
enabledPlaylists=compatiblePlaylists.filter(function(playlist){return!Playlist.isDisabled(playlist);});}var bandwidthPlaylists=enabledPlaylists.filter(Playlist.hasAttribute.bind(null,'BANDWIDTH'));var rebufferingEstimates=bandwidthPlaylists.map(function(playlist){var syncPoint=syncController.getSyncPoint(playlist,duration,currentTimeline,currentTime);// If there is no sync point for this playlist, switching to it will require a
// sync request first. This will double the request time
var numRequests=syncPoint?1:2;var requestTimeEstimate=Playlist.estimateSegmentRequestTime(segmentDuration,bandwidth,playlist);var rebufferingImpact=requestTimeEstimate*numRequests-timeUntilRebuffer;return{playlist:playlist,rebufferingImpact:rebufferingImpact};});var noRebufferingPlaylists=rebufferingEstimates.filter(function(estimate){return estimate.rebufferingImpact<=0;});// Sort by bandwidth DESC
stableSort(noRebufferingPlaylists,function(a,b){return comparePlaylistBandwidth(b.playlist,a.playlist);});if(noRebufferingPlaylists.length){return noRebufferingPlaylists[0];}stableSort(rebufferingEstimates,function(a,b){return a.rebufferingImpact-b.rebufferingImpact;});return rebufferingEstimates[0]||null;};/**
 * Chooses the appropriate media playlist, which in this case is the lowest bitrate
 * one with video.  If no renditions with video exist, return the lowest audio rendition.
 *
 * Expects to be called within the context of an instance of VhsHandler
 *
 * @return {Object|null}
 *         {Object} return.playlist
 *         The lowest bitrate playlist that contains a video codec.  If no such rendition
 *         exists pick the lowest audio rendition.
 */var lowestBitrateCompatibleVariantSelector=function lowestBitrateCompatibleVariantSelector(){var _this=this;// filter out any playlists that have been excluded due to
// incompatible configurations or playback errors
var playlists=this.playlists.master.playlists.filter(Playlist.isEnabled);// Sort ascending by bitrate
stableSort(playlists,function(a,b){return comparePlaylistBandwidth(a,b);});// Parse and assume that playlists with no video codec have no video
// (this is not necessarily true, although it is generally true).
//
// If an entire manifest has no valid videos everything will get filtered
// out.
var playlistsWithVideo=playlists.filter(function(playlist){return!!codecsForPlaylist(_this.playlists.master,playlist).video;});return playlistsWithVideo[0]||null;};/**
 * Combine all segments into a single Uint8Array
 *
 * @param {Object} segmentObj
 * @return {Uint8Array} concatenated bytes
 * @private
 */var concatSegments=function concatSegments(segmentObj){var offset=0;var tempBuffer;if(segmentObj.bytes){tempBuffer=new Uint8Array(segmentObj.bytes);// combine the individual segments into one large typed-array
segmentObj.segments.forEach(function(segment){tempBuffer.set(segment,offset);offset+=segment.byteLength;});}return tempBuffer;};/**
 * @file text-tracks.js
 */ /**
 * Create captions text tracks on video.js if they do not exist
 *
 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
 * @param {Object} tech the video.js tech
 * @param {Object} captionStream the caption stream to create
 * @private
 */var createCaptionsTrackIfNotExists=function createCaptionsTrackIfNotExists(inbandTextTracks,tech,captionStream){if(!inbandTextTracks[captionStream]){tech.trigger({type:'usage',name:'vhs-608'});tech.trigger({type:'usage',name:'hls-608'});var instreamId=captionStream;// we need to translate SERVICEn for 708 to how mux.js currently labels them
if(/^cc708_/.test(captionStream)){instreamId='SERVICE'+captionStream.split('_')[1];}var track=tech.textTracks().getTrackById(instreamId);if(track){// Resuse an existing track with a CC# id because this was
// very likely created by videojs-contrib-hls from information
// in the m3u8 for us to use
inbandTextTracks[captionStream]=track;}else{// This section gets called when we have caption services that aren't specified in the manifest.
// Manifest level caption services are handled in media-groups.js under CLOSED-CAPTIONS.
var captionServices=tech.options_.vhs&&tech.options_.vhs.captionServices||{};var label=captionStream;var language=captionStream;var def=false;var captionService=captionServices[instreamId];if(captionService){label=captionService.label;language=captionService.language;def=captionService["default"];}// Otherwise, create a track with the default `CC#` label and
// without a language
inbandTextTracks[captionStream]=tech.addRemoteTextTrack({kind:'captions',id:instreamId,// TODO: investigate why this doesn't seem to turn the caption on by default
"default":def,label:label,language:language},false).track;}}};/**
 * Add caption text track data to a source handler given an array of captions
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {number} timestampOffset the timestamp offset of the source buffer
 *   @param {Array} captionArray an array of caption data
 * @private
 */var addCaptionData=function addCaptionData(_ref){var inbandTextTracks=_ref.inbandTextTracks,captionArray=_ref.captionArray,timestampOffset=_ref.timestampOffset;if(!captionArray){return;}var Cue=(window_default()).WebKitDataCue||(window_default()).VTTCue;captionArray.forEach(function(caption){var track=caption.stream;inbandTextTracks[track].addCue(new Cue(caption.startTime+timestampOffset,caption.endTime+timestampOffset,caption.text));});};/**
 * Define properties on a cue for backwards compatability,
 * but warn the user that the way that they are using it
 * is depricated and will be removed at a later date.
 *
 * @param {Cue} cue the cue to add the properties on
 * @private
 */var deprecateOldCue=function deprecateOldCue(cue){Object.defineProperties(cue.frame,{id:{get:function get(){videojs.log.warn('cue.frame.id is deprecated. Use cue.value.key instead.');return cue.value.key;}},value:{get:function get(){videojs.log.warn('cue.frame.value is deprecated. Use cue.value.data instead.');return cue.value.data;}},privateData:{get:function get(){videojs.log.warn('cue.frame.privateData is deprecated. Use cue.value.data instead.');return cue.value.data;}}});};/**
 * Add metadata text track data to a source handler given an array of metadata
 *
 * @param {Object}
 *   @param {Object} inbandTextTracks the inband text tracks
 *   @param {Array} metadataArray an array of meta data
 *   @param {number} timestampOffset the timestamp offset of the source buffer
 *   @param {number} videoDuration the duration of the video
 * @private
 */var addMetadata=function addMetadata(_ref2){var inbandTextTracks=_ref2.inbandTextTracks,metadataArray=_ref2.metadataArray,timestampOffset=_ref2.timestampOffset,videoDuration=_ref2.videoDuration;if(!metadataArray){return;}var Cue=(window_default()).WebKitDataCue||(window_default()).VTTCue;var metadataTrack=inbandTextTracks.metadataTrack_;if(!metadataTrack){return;}metadataArray.forEach(function(metadata){var time=metadata.cueTime+timestampOffset;// if time isn't a finite number between 0 and Infinity, like NaN,
// ignore this bit of metadata.
// This likely occurs when you have an non-timed ID3 tag like TIT2,
// which is the "Title/Songname/Content description" frame
if(typeof time!=='number'||window_default().isNaN(time)||time<0||!(time<Infinity)){return;}metadata.frames.forEach(function(frame){var cue=new Cue(time,time,frame.value||frame.url||frame.data||'');cue.frame=frame;cue.value=frame;deprecateOldCue(cue);metadataTrack.addCue(cue);});});if(!metadataTrack.cues||!metadataTrack.cues.length){return;}// Updating the metadeta cues so that
// the endTime of each cue is the startTime of the next cue
// the endTime of last cue is the duration of the video
var cues=metadataTrack.cues;var cuesArray=[];// Create a copy of the TextTrackCueList...
// ...disregarding cues with a falsey value
for(var i=0;i<cues.length;i++){if(cues[i]){cuesArray.push(cues[i]);}}// Group cues by their startTime value
var cuesGroupedByStartTime=cuesArray.reduce(function(obj,cue){var timeSlot=obj[cue.startTime]||[];timeSlot.push(cue);obj[cue.startTime]=timeSlot;return obj;},{});// Sort startTimes by ascending order
var sortedStartTimes=Object.keys(cuesGroupedByStartTime).sort(function(a,b){return Number(a)-Number(b);});// Map each cue group's endTime to the next group's startTime
sortedStartTimes.forEach(function(startTime,idx){var cueGroup=cuesGroupedByStartTime[startTime];var nextTime=Number(sortedStartTimes[idx+1])||videoDuration;// Map each cue's endTime the next group's startTime
cueGroup.forEach(function(cue){cue.endTime=nextTime;});});};/**
 * Create metadata text track on video.js if it does not exist
 *
 * @param {Object} inbandTextTracks a reference to current inbandTextTracks
 * @param {string} dispatchType the inband metadata track dispatch type
 * @param {Object} tech the video.js tech
 * @private
 */var createMetadataTrackIfNotExists=function createMetadataTrackIfNotExists(inbandTextTracks,dispatchType,tech){if(inbandTextTracks.metadataTrack_){return;}inbandTextTracks.metadataTrack_=tech.addRemoteTextTrack({kind:'metadata',label:'Timed Metadata'},false).track;inbandTextTracks.metadataTrack_.inBandMetadataTrackDispatchType=dispatchType;};/**
 * Remove cues from a track on video.js.
 *
 * @param {Double} start start of where we should remove the cue
 * @param {Double} end end of where the we should remove the cue
 * @param {Object} track the text track to remove the cues from
 * @private
 */var removeCuesFromTrack=function removeCuesFromTrack(start,end,track){var i;var cue;if(!track){return;}if(!track.cues){return;}i=track.cues.length;while(i--){cue=track.cues[i];// Remove any cue within the provided start and end time
if(cue.startTime>=start&&cue.endTime<=end){track.removeCue(cue);}}};/**
 * Remove duplicate cues from a track on video.js (a cue is considered a
 * duplicate if it has the same time interval and text as another)
 *
 * @param {Object} track the text track to remove the duplicate cues from
 * @private
 */var removeDuplicateCuesFromTrack=function removeDuplicateCuesFromTrack(track){var cues=track.cues;if(!cues){return;}for(var i=0;i<cues.length;i++){var duplicates=[];var occurrences=0;for(var j=0;j<cues.length;j++){if(cues[i].startTime===cues[j].startTime&&cues[i].endTime===cues[j].endTime&&cues[i].text===cues[j].text){occurrences++;if(occurrences>1){duplicates.push(cues[j]);}}}if(duplicates.length){duplicates.forEach(function(dupe){return track.removeCue(dupe);});}}};/**
 * Returns a list of gops in the buffer that have a pts value of 3 seconds or more in
 * front of current time.
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {number} currentTime
 *        The current time
 * @param {Double} mapping
 *        Offset to map display time to stream presentation time
 * @return {Array}
 *         List of gops considered safe to append over
 */var gopsSafeToAlignWith=function gopsSafeToAlignWith(buffer,currentTime,mapping){if(typeof currentTime==='undefined'||currentTime===null||!buffer.length){return[];}// pts value for current time + 3 seconds to give a bit more wiggle room
var currentTimePts=Math.ceil((currentTime-mapping+3)*clock.ONE_SECOND_IN_TS);var i;for(i=0;i<buffer.length;i++){if(buffer[i].pts>currentTimePts){break;}}return buffer.slice(i);};/**
 * Appends gop information (timing and byteLength) received by the transmuxer for the
 * gops appended in the last call to appendBuffer
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {Array} gops
 *        List of new gop information
 * @param {boolean} replace
 *        If true, replace the buffer with the new gop information. If false, append the
 *        new gop information to the buffer in the right location of time.
 * @return {Array}
 *         Updated list of gop information
 */var updateGopBuffer=function updateGopBuffer(buffer,gops,replace){if(!gops.length){return buffer;}if(replace){// If we are in safe append mode, then completely overwrite the gop buffer
// with the most recent appeneded data. This will make sure that when appending
// future segments, we only try to align with gops that are both ahead of current
// time and in the last segment appended.
return gops.slice();}var start=gops[0].pts;var i=0;for(i;i<buffer.length;i++){if(buffer[i].pts>=start){break;}}return buffer.slice(0,i).concat(gops);};/**
 * Removes gop information in buffer that overlaps with provided start and end
 *
 * @param {Array} buffer
 *        The current buffer of gop information
 * @param {Double} start
 *        position to start the remove at
 * @param {Double} end
 *        position to end the remove at
 * @param {Double} mapping
 *        Offset to map display time to stream presentation time
 */var removeGopBuffer=function removeGopBuffer(buffer,start,end,mapping){var startPts=Math.ceil((start-mapping)*clock.ONE_SECOND_IN_TS);var endPts=Math.ceil((end-mapping)*clock.ONE_SECOND_IN_TS);var updatedBuffer=buffer.slice();var i=buffer.length;while(i--){if(buffer[i].pts<=endPts){break;}}if(i===-1){// no removal because end of remove range is before start of buffer
return updatedBuffer;}var j=i+1;while(j--){if(buffer[j].pts<=startPts){break;}}// clamp remove range start to 0 index
j=Math.max(j,0);updatedBuffer.splice(j,i-j+1);return updatedBuffer;};var shallowEqual=function shallowEqual(a,b){// if both are undefined
// or one or the other is undefined
// they are not equal
if(!a&&!b||!a&&b||a&&!b){return false;}// they are the same object and thus, equal
if(a===b){return true;}// sort keys so we can make sure they have
// all the same keys later.
var akeys=Object.keys(a).sort();var bkeys=Object.keys(b).sort();// different number of keys, not equal
if(akeys.length!==bkeys.length){return false;}for(var i=0;i<akeys.length;i++){var key=akeys[i];// different sorted keys, not equal
if(key!==bkeys[i]){return false;}// different values, not equal
if(a[key]!==b[key]){return false;}}return true;};// https://www.w3.org/TR/WebIDL-1/#quotaexceedederror
var QUOTA_EXCEEDED_ERR=22;/**
 * The segment loader has no recourse except to fetch a segment in the
 * current playlist and use the internal timestamps in that segment to
 * generate a syncPoint. This function returns a good candidate index
 * for that process.
 *
 * @param {Array} segments - the segments array from a playlist.
 * @return {number} An index of a segment from the playlist to load
 */var getSyncSegmentCandidate=function getSyncSegmentCandidate(currentTimeline,segments,targetTime){segments=segments||[];var timelineSegments=[];var time=0;for(var i=0;i<segments.length;i++){var segment=segments[i];if(currentTimeline===segment.timeline){timelineSegments.push(i);time+=segment.duration;if(time>targetTime){return i;}}}if(timelineSegments.length===0){return 0;}// default to the last timeline segment
return timelineSegments[timelineSegments.length-1];};// In the event of a quota exceeded error, keep at least one second of back buffer. This
// number was arbitrarily chosen and may be updated in the future, but seemed reasonable
// as a start to prevent any potential issues with removing content too close to the
// playhead.
var MIN_BACK_BUFFER=1;// in ms
var CHECK_BUFFER_DELAY=500;var finite=function finite(num){return typeof num==='number'&&isFinite(num);};// With most content hovering around 30fps, if a segment has a duration less than a half
// frame at 30fps or one frame at 60fps, the bandwidth and throughput calculations will
// not accurately reflect the rest of the content.
var MIN_SEGMENT_DURATION_TO_SAVE_STATS=1/60;var illegalMediaSwitch=function illegalMediaSwitch(loaderType,startingMedia,trackInfo){// Although these checks should most likely cover non 'main' types, for now it narrows
// the scope of our checks.
if(loaderType!=='main'||!startingMedia||!trackInfo){return null;}if(!trackInfo.hasAudio&&!trackInfo.hasVideo){return'Neither audio nor video found in segment.';}if(startingMedia.hasVideo&&!trackInfo.hasVideo){return'Only audio found in segment when we expected video.'+' We can\'t switch to audio only from a stream that had video.'+' To get rid of this message, please add codec information to the manifest.';}if(!startingMedia.hasVideo&&trackInfo.hasVideo){return'Video found in segment when we expected only audio.'+' We can\'t switch to a stream with video from an audio only stream.'+' To get rid of this message, please add codec information to the manifest.';}return null;};/**
 * Calculates a time value that is safe to remove from the back buffer without interrupting
 * playback.
 *
 * @param {TimeRange} seekable
 *        The current seekable range
 * @param {number} currentTime
 *        The current time of the player
 * @param {number} targetDuration
 *        The target duration of the current playlist
 * @return {number}
 *         Time that is safe to remove from the back buffer without interrupting playback
 */var safeBackBufferTrimTime=function safeBackBufferTrimTime(seekable,currentTime,targetDuration){// 30 seconds before the playhead provides a safe default for trimming.
//
// Choosing a reasonable default is particularly important for high bitrate content and
// VOD videos/live streams with large windows, as the buffer may end up overfilled and
// throw an APPEND_BUFFER_ERR.
var trimTime=currentTime-Config.BACK_BUFFER_LENGTH;if(seekable.length){// Some live playlists may have a shorter window of content than the full allowed back
// buffer. For these playlists, don't save content that's no longer within the window.
trimTime=Math.max(trimTime,seekable.start(0));}// Don't remove within target duration of the current time to avoid the possibility of
// removing the GOP currently being played, as removing it can cause playback stalls.
var maxTrimTime=currentTime-targetDuration;return Math.min(maxTrimTime,trimTime);};var segmentInfoString=function segmentInfoString(segmentInfo){var startOfSegment=segmentInfo.startOfSegment,duration=segmentInfo.duration,segment=segmentInfo.segment,part=segmentInfo.part,_segmentInfo$playlist=segmentInfo.playlist,seq=_segmentInfo$playlist.mediaSequence,id=_segmentInfo$playlist.id,_segmentInfo$playlist2=_segmentInfo$playlist.segments,segments=_segmentInfo$playlist2===void 0?[]:_segmentInfo$playlist2,index=segmentInfo.mediaIndex,partIndex=segmentInfo.partIndex,timeline=segmentInfo.timeline;var segmentLen=segments.length-1;var selection='mediaIndex/partIndex increment';if(segmentInfo.getMediaInfoForTime){selection="getMediaInfoForTime ("+segmentInfo.getMediaInfoForTime+")";}else if(segmentInfo.isSyncRequest){selection='getSyncSegmentCandidate (isSyncRequest)';}if(segmentInfo.independent){selection+=" with independent "+segmentInfo.independent;}var hasPartIndex=typeof partIndex==='number';var name=segmentInfo.segment.uri?'segment':'pre-segment';var zeroBasedPartCount=hasPartIndex?getKnownPartCount({preloadSegment:segment})-1:0;return name+" ["+(seq+index)+"/"+(seq+segmentLen)+"]"+(hasPartIndex?" part ["+partIndex+"/"+zeroBasedPartCount+"]":'')+(" segment start/end ["+segment.start+" => "+segment.end+"]")+(hasPartIndex?" part start/end ["+part.start+" => "+part.end+"]":'')+(" startOfSegment ["+startOfSegment+"]")+(" duration ["+duration+"]")+(" timeline ["+timeline+"]")+(" selected by ["+selection+"]")+(" playlist ["+id+"]");};var timingInfoPropertyForMedia=function timingInfoPropertyForMedia(mediaType){return mediaType+"TimingInfo";};/**
 * Returns the timestamp offset to use for the segment.
 *
 * @param {number} segmentTimeline
 *        The timeline of the segment
 * @param {number} currentTimeline
 *        The timeline currently being followed by the loader
 * @param {number} startOfSegment
 *        The estimated segment start
 * @param {TimeRange[]} buffered
 *        The loader's buffer
 * @param {boolean} overrideCheck
 *        If true, no checks are made to see if the timestamp offset value should be set,
 *        but sets it directly to a value.
 *
 * @return {number|null}
 *         Either a number representing a new timestamp offset, or null if the segment is
 *         part of the same timeline
 */var timestampOffsetForSegment=function timestampOffsetForSegment(_ref){var segmentTimeline=_ref.segmentTimeline,currentTimeline=_ref.currentTimeline,startOfSegment=_ref.startOfSegment,buffered=_ref.buffered,overrideCheck=_ref.overrideCheck;// Check to see if we are crossing a discontinuity to see if we need to set the
// timestamp offset on the transmuxer and source buffer.
//
// Previously, we changed the timestampOffset if the start of this segment was less than
// the currently set timestampOffset, but this isn't desirable as it can produce bad
// behavior, especially around long running live streams.
if(!overrideCheck&&segmentTimeline===currentTimeline){return null;}// When changing renditions, it's possible to request a segment on an older timeline. For
// instance, given two renditions with the following:
//
// #EXTINF:10
// segment1
// #EXT-X-DISCONTINUITY
// #EXTINF:10
// segment2
// #EXTINF:10
// segment3
//
// And the current player state:
//
// current time: 8
// buffer: 0 => 20
//
// The next segment on the current rendition would be segment3, filling the buffer from
// 20s onwards. However, if a rendition switch happens after segment2 was requested,
// then the next segment to be requested will be segment1 from the new rendition in
// order to fill time 8 and onwards. Using the buffered end would result in repeated
// content (since it would position segment1 of the new rendition starting at 20s). This
// case can be identified when the new segment's timeline is a prior value. Instead of
// using the buffered end, the startOfSegment can be used, which, hopefully, will be
// more accurate to the actual start time of the segment.
if(segmentTimeline<currentTimeline){return startOfSegment;}// segmentInfo.startOfSegment used to be used as the timestamp offset, however, that
// value uses the end of the last segment if it is available. While this value
// should often be correct, it's better to rely on the buffered end, as the new
// content post discontinuity should line up with the buffered end as if it were
// time 0 for the new content.
return buffered.length?buffered.end(buffered.length-1):startOfSegment;};/**
 * Returns whether or not the loader should wait for a timeline change from the timeline
 * change controller before processing the segment.
 *
 * Primary timing in VHS goes by video. This is different from most media players, as
 * audio is more often used as the primary timing source. For the foreseeable future, VHS
 * will continue to use video as the primary timing source, due to the current logic and
 * expectations built around it.

 * Since the timing follows video, in order to maintain sync, the video loader is
 * responsible for setting both audio and video source buffer timestamp offsets.
 *
 * Setting different values for audio and video source buffers could lead to
 * desyncing. The following examples demonstrate some of the situations where this
 * distinction is important. Note that all of these cases involve demuxed content. When
 * content is muxed, the audio and video are packaged together, therefore syncing
 * separate media playlists is not an issue.
 *
 * CASE 1: Audio prepares to load a new timeline before video:
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:                     ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader              ^
 *
 * In the above example, the audio loader is preparing to load the 6th segment, the first
 * after a discontinuity, while the video loader is still loading the 5th segment, before
 * the discontinuity.
 *
 * If the audio loader goes ahead and loads and appends the 6th segment before the video
 * loader crosses the discontinuity, then when appended, the 6th audio segment will use
 * the timestamp offset from timeline 0. This will likely lead to desyncing. In addition,
 * the audio loader must provide the audioAppendStart value to trim the content in the
 * transmuxer, and that value relies on the audio timestamp offset. Since the audio
 * timestamp offset is set by the video (main) loader, the audio loader shouldn't load the
 * segment until that value is provided.
 *
 * CASE 2: Video prepares to load a new timeline before audio:
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:             ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader                      ^
 *
 * In the above example, the video loader is preparing to load the 6th segment, the first
 * after a discontinuity, while the audio loader is still loading the 5th segment, before
 * the discontinuity.
 *
 * If the video loader goes ahead and loads and appends the 6th segment, then once the
 * segment is loaded and processed, both the video and audio timestamp offsets will be
 * set, since video is used as the primary timing source. This is to ensure content lines
 * up appropriately, as any modifications to the video timing are reflected by audio when
 * the video loader sets the audio and video timestamp offsets to the same value. However,
 * setting the timestamp offset for audio before audio has had a chance to change
 * timelines will likely lead to desyncing, as the audio loader will append segment 5 with
 * a timestamp intended to apply to segments from timeline 1 rather than timeline 0.
 *
 * CASE 3: When seeking, audio prepares to load a new timeline before video
 *
 * Timeline:       0                 1
 * Audio Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Audio Loader:           ^
 * Video Segments: 0 1 2 3 4 5 DISCO 6 7 8 9
 * Video Loader            ^
 *
 * In the above example, both audio and video loaders are loading segments from timeline
 * 0, but imagine that the seek originated from timeline 1.
 *
 * When seeking to a new timeline, the timestamp offset will be set based on the expected
 * segment start of the loaded video segment. In order to maintain sync, the audio loader
 * must wait for the video loader to load its segment and update both the audio and video
 * timestamp offsets before it may load and append its own segment. This is the case
 * whether the seek results in a mismatched segment request (e.g., the audio loader
 * chooses to load segment 3 and the video loader chooses to load segment 4) or the
 * loaders choose to load the same segment index from each playlist, as the segments may
 * not be aligned perfectly, even for matching segment indexes.
 *
 * @param {Object} timelinechangeController
 * @param {number} currentTimeline
 *        The timeline currently being followed by the loader
 * @param {number} segmentTimeline
 *        The timeline of the segment being loaded
 * @param {('main'|'audio')} loaderType
 *        The loader type
 * @param {boolean} audioDisabled
 *        Whether the audio is disabled for the loader. This should only be true when the
 *        loader may have muxed audio in its segment, but should not append it, e.g., for
 *        the main loader when an alternate audio playlist is active.
 *
 * @return {boolean}
 *         Whether the loader should wait for a timeline change from the timeline change
 *         controller before processing the segment
 */var shouldWaitForTimelineChange=function shouldWaitForTimelineChange(_ref2){var timelineChangeController=_ref2.timelineChangeController,currentTimeline=_ref2.currentTimeline,segmentTimeline=_ref2.segmentTimeline,loaderType=_ref2.loaderType,audioDisabled=_ref2.audioDisabled;if(currentTimeline===segmentTimeline){return false;}if(loaderType==='audio'){var lastMainTimelineChange=timelineChangeController.lastTimelineChange({type:'main'});// Audio loader should wait if:
//
// * main hasn't had a timeline change yet (thus has not loaded its first segment)
// * main hasn't yet changed to the timeline audio is looking to load
return!lastMainTimelineChange||lastMainTimelineChange.to!==segmentTimeline;}// The main loader only needs to wait for timeline changes if there's demuxed audio.
// Otherwise, there's nothing to wait for, since audio would be muxed into the main
// loader's segments (or the content is audio/video only and handled by the main
// loader).
if(loaderType==='main'&&audioDisabled){var pendingAudioTimelineChange=timelineChangeController.pendingTimelineChange({type:'audio'});// Main loader should wait for the audio loader if audio is not pending a timeline
// change to the current timeline.
//
// Since the main loader is responsible for setting the timestamp offset for both
// audio and video, the main loader must wait for audio to be about to change to its
// timeline before setting the offset, otherwise, if audio is behind in loading,
// segments from the previous timeline would be adjusted by the new timestamp offset.
//
// This requirement means that video will not cross a timeline until the audio is
// about to cross to it, so that way audio and video will always cross the timeline
// together.
//
// In addition to normal timeline changes, these rules also apply to the start of a
// stream (going from a non-existent timeline, -1, to timeline 0). It's important
// that these rules apply to the first timeline change because if they did not, it's
// possible that the main loader will cross two timelines before the audio loader has
// crossed one. Logic may be implemented to handle the startup as a special case, but
// it's easier to simply treat all timeline changes the same.
if(pendingAudioTimelineChange&&pendingAudioTimelineChange.to===segmentTimeline){return false;}return true;}return false;};var mediaDuration=function mediaDuration(timingInfos){var maxDuration=0;['video','audio'].forEach(function(type){var typeTimingInfo=timingInfos[type+"TimingInfo"];if(!typeTimingInfo){return;}var start=typeTimingInfo.start,end=typeTimingInfo.end;var duration;if(typeof start==='bigint'||typeof end==='bigint'){duration=window_default().BigInt(end)-window_default().BigInt(start);}else if(typeof start==='number'&&typeof end==='number'){duration=end-start;}if(typeof duration!=='undefined'&&duration>maxDuration){maxDuration=duration;}});// convert back to a number if it is lower than MAX_SAFE_INTEGER
// as we only need BigInt when we are above that.
if(typeof maxDuration==='bigint'&&maxDuration<Number.MAX_SAFE_INTEGER){maxDuration=Number(maxDuration);}return maxDuration;};var segmentTooLong=function segmentTooLong(_ref3){var segmentDuration=_ref3.segmentDuration,maxDuration=_ref3.maxDuration;// 0 duration segments are most likely due to metadata only segments or a lack of
// information.
if(!segmentDuration){return false;}// For HLS:
//
// https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1
// The EXTINF duration of each Media Segment in the Playlist
// file, when rounded to the nearest integer, MUST be less than or equal
// to the target duration; longer segments can trigger playback stalls
// or other errors.
//
// For DASH, the mpd-parser uses the largest reported segment duration as the target
// duration. Although that reported duration is occasionally approximate (i.e., not
// exact), a strict check may report that a segment is too long more often in DASH.
return Math.round(segmentDuration)>maxDuration+TIME_FUDGE_FACTOR;};var getTroublesomeSegmentDurationMessage=function getTroublesomeSegmentDurationMessage(segmentInfo,sourceType){// Right now we aren't following DASH's timing model exactly, so only perform
// this check for HLS content.
if(sourceType!=='hls'){return null;}var segmentDuration=mediaDuration({audioTimingInfo:segmentInfo.audioTimingInfo,videoTimingInfo:segmentInfo.videoTimingInfo});// Don't report if we lack information.
//
// If the segment has a duration of 0 it is either a lack of information or a
// metadata only segment and shouldn't be reported here.
if(!segmentDuration){return null;}var targetDuration=segmentInfo.playlist.targetDuration;var isSegmentWayTooLong=segmentTooLong({segmentDuration:segmentDuration,maxDuration:targetDuration*2});var isSegmentSlightlyTooLong=segmentTooLong({segmentDuration:segmentDuration,maxDuration:targetDuration});var segmentTooLongMessage="Segment with index "+segmentInfo.mediaIndex+" "+("from playlist "+segmentInfo.playlist.id+" ")+("has a duration of "+segmentDuration+" ")+("when the reported duration is "+segmentInfo.duration+" ")+("and the target duration is "+targetDuration+". ")+'For HLS content, a duration in excess of the target duration may result in '+'playback issues. See the HLS specification section on EXT-X-TARGETDURATION for '+'more details: '+'https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1';if(isSegmentWayTooLong||isSegmentSlightlyTooLong){return{severity:isSegmentWayTooLong?'warn':'info',message:segmentTooLongMessage};}return null;};/**
 * An object that manages segment loading and appending.
 *
 * @class SegmentLoader
 * @param {Object} options required and optional options
 * @extends videojs.EventTarget
 */var SegmentLoader=/*#__PURE__*/function(_videojs$EventTarget){_inheritsLoose(SegmentLoader,_videojs$EventTarget);function SegmentLoader(settings,options){var _this;_this=_videojs$EventTarget.call(this)||this;// check pre-conditions
if(!settings){throw new TypeError('Initialization settings are required');}if(typeof settings.currentTime!=='function'){throw new TypeError('No currentTime getter specified');}if(!settings.mediaSource){throw new TypeError('No MediaSource specified');}// public properties
_this.bandwidth=settings.bandwidth;_this.throughput={rate:0,count:0};_this.roundTrip=NaN;_this.resetStats_();_this.mediaIndex=null;_this.partIndex=null;// private settings
_this.hasPlayed_=settings.hasPlayed;_this.currentTime_=settings.currentTime;_this.seekable_=settings.seekable;_this.seeking_=settings.seeking;_this.duration_=settings.duration;_this.mediaSource_=settings.mediaSource;_this.vhs_=settings.vhs;_this.loaderType_=settings.loaderType;_this.currentMediaInfo_=void 0;_this.startingMediaInfo_=void 0;_this.segmentMetadataTrack_=settings.segmentMetadataTrack;_this.goalBufferLength_=settings.goalBufferLength;_this.sourceType_=settings.sourceType;_this.sourceUpdater_=settings.sourceUpdater;_this.inbandTextTracks_=settings.inbandTextTracks;_this.state_='INIT';_this.timelineChangeController_=settings.timelineChangeController;_this.shouldSaveSegmentTimingInfo_=true;_this.parse708captions_=settings.parse708captions;_this.useDtsForTimestampOffset_=settings.useDtsForTimestampOffset;_this.captionServices_=settings.captionServices;_this.experimentalExactManifestTimings=settings.experimentalExactManifestTimings;// private instance variables
_this.checkBufferTimeout_=null;_this.error_=void 0;_this.currentTimeline_=-1;_this.pendingSegment_=null;_this.xhrOptions_=null;_this.pendingSegments_=[];_this.audioDisabled_=false;_this.isPendingTimestampOffset_=false;// TODO possibly move gopBuffer and timeMapping info to a separate controller
_this.gopBuffer_=[];_this.timeMapping_=0;_this.safeAppend_=videojs.browser.IE_VERSION>=11;_this.appendInitSegment_={audio:true,video:true};_this.playlistOfLastInitSegment_={audio:null,video:null};_this.callQueue_=[];// If the segment loader prepares to load a segment, but does not have enough
// information yet to start the loading process (e.g., if the audio loader wants to
// load a segment from the next timeline but the main loader hasn't yet crossed that
// timeline), then the load call will be added to the queue until it is ready to be
// processed.
_this.loadQueue_=[];_this.metadataQueue_={id3:[],caption:[]};_this.waitingOnRemove_=false;_this.quotaExceededErrorRetryTimeout_=null;// Fragmented mp4 playback
_this.activeInitSegmentId_=null;_this.initSegments_={};// HLSe playback
_this.cacheEncryptionKeys_=settings.cacheEncryptionKeys;_this.keyCache_={};_this.decrypter_=settings.decrypter;// Manages the tracking and generation of sync-points, mappings
// between a time in the display time and a segment index within
// a playlist
_this.syncController_=settings.syncController;_this.syncPoint_={segmentIndex:0,time:0};_this.transmuxer_=_this.createTransmuxer_();_this.triggerSyncInfoUpdate_=function(){return _this.trigger('syncinfoupdate');};_this.syncController_.on('syncinfoupdate',_this.triggerSyncInfoUpdate_);_this.mediaSource_.addEventListener('sourceopen',function(){if(!_this.isEndOfStream_()){_this.ended_=false;}});// ...for determining the fetch location
_this.fetchAtBuffer_=false;_this.logger_=logger("SegmentLoader["+_this.loaderType_+"]");Object.defineProperty(_assertThisInitialized(_this),'state',{get:function get(){return this.state_;},set:function set(newState){if(newState!==this.state_){this.logger_(this.state_+" -> "+newState);this.state_=newState;this.trigger('statechange');}}});_this.sourceUpdater_.on('ready',function(){if(_this.hasEnoughInfoToAppend_()){_this.processCallQueue_();}});// Only the main loader needs to listen for pending timeline changes, as the main
// loader should wait for audio to be ready to change its timeline so that both main
// and audio timelines change together. For more details, see the
// shouldWaitForTimelineChange function.
if(_this.loaderType_==='main'){_this.timelineChangeController_.on('pendingtimelinechange',function(){if(_this.hasEnoughInfoToAppend_()){_this.processCallQueue_();}});}// The main loader only listens on pending timeline changes, but the audio loader,
// since its loads follow main, needs to listen on timeline changes. For more details,
// see the shouldWaitForTimelineChange function.
if(_this.loaderType_==='audio'){_this.timelineChangeController_.on('timelinechange',function(){if(_this.hasEnoughInfoToLoad_()){_this.processLoadQueue_();}if(_this.hasEnoughInfoToAppend_()){_this.processCallQueue_();}});}return _this;}var _proto=SegmentLoader.prototype;_proto.createTransmuxer_=function createTransmuxer_(){return segmentTransmuxer.createTransmuxer({remux:false,alignGopsAtEnd:this.safeAppend_,keepOriginalTimestamps:true,parse708captions:this.parse708captions_,captionServices:this.captionServices_});}/**
   * reset all of our media stats
   *
   * @private
   */;_proto.resetStats_=function resetStats_(){this.mediaBytesTransferred=0;this.mediaRequests=0;this.mediaRequestsAborted=0;this.mediaRequestsTimedout=0;this.mediaRequestsErrored=0;this.mediaTransferDuration=0;this.mediaSecondsLoaded=0;this.mediaAppends=0;}/**
   * dispose of the SegmentLoader and reset to the default state
   */;_proto.dispose=function dispose(){this.trigger('dispose');this.state='DISPOSED';this.pause();this.abort_();if(this.transmuxer_){this.transmuxer_.terminate();}this.resetStats_();if(this.checkBufferTimeout_){window_default().clearTimeout(this.checkBufferTimeout_);}if(this.syncController_&&this.triggerSyncInfoUpdate_){this.syncController_.off('syncinfoupdate',this.triggerSyncInfoUpdate_);}this.off();};_proto.setAudio=function setAudio(enable){this.audioDisabled_=!enable;if(enable){this.appendInitSegment_.audio=true;}else{// remove current track audio if it gets disabled
this.sourceUpdater_.removeAudio(0,this.duration_());}}/**
   * abort anything that is currently doing on with the SegmentLoader
   * and reset to a default state
   */;_proto.abort=function abort(){if(this.state!=='WAITING'){if(this.pendingSegment_){this.pendingSegment_=null;}return;}this.abort_();// We aborted the requests we were waiting on, so reset the loader's state to READY
// since we are no longer "waiting" on any requests. XHR callback is not always run
// when the request is aborted. This will prevent the loader from being stuck in the
// WAITING state indefinitely.
this.state='READY';// don't wait for buffer check timeouts to begin fetching the
// next segment
if(!this.paused()){this.monitorBuffer_();}}/**
   * abort all pending xhr requests and null any pending segements
   *
   * @private
   */;_proto.abort_=function abort_(){if(this.pendingSegment_&&this.pendingSegment_.abortRequests){this.pendingSegment_.abortRequests();}// clear out the segment being processed
this.pendingSegment_=null;this.callQueue_=[];this.loadQueue_=[];this.metadataQueue_.id3=[];this.metadataQueue_.caption=[];this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);this.waitingOnRemove_=false;window_default().clearTimeout(this.quotaExceededErrorRetryTimeout_);this.quotaExceededErrorRetryTimeout_=null;};_proto.checkForAbort_=function checkForAbort_(requestId){// If the state is APPENDING, then aborts will not modify the state, meaning the first
// callback that happens should reset the state to READY so that loading can continue.
if(this.state==='APPENDING'&&!this.pendingSegment_){this.state='READY';return true;}if(!this.pendingSegment_||this.pendingSegment_.requestId!==requestId){return true;}return false;}/**
   * set an error on the segment loader and null out any pending segements
   *
   * @param {Error} error the error to set on the SegmentLoader
   * @return {Error} the error that was set or that is currently set
   */;_proto.error=function error(_error){if(typeof _error!=='undefined'){this.logger_('error occurred:',_error);this.error_=_error;}this.pendingSegment_=null;return this.error_;};_proto.endOfStream=function endOfStream(){this.ended_=true;if(this.transmuxer_){// need to clear out any cached data to prepare for the new segment
segmentTransmuxer.reset(this.transmuxer_);}this.gopBuffer_.length=0;this.pause();this.trigger('ended');}/**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */;_proto.buffered_=function buffered_(){var trackInfo=this.getMediaInfo_();if(!this.sourceUpdater_||!trackInfo){return videojs.createTimeRanges();}if(this.loaderType_==='main'){var hasAudio=trackInfo.hasAudio,hasVideo=trackInfo.hasVideo,isMuxed=trackInfo.isMuxed;if(hasVideo&&hasAudio&&!this.audioDisabled_&&!isMuxed){return this.sourceUpdater_.buffered();}if(hasVideo){return this.sourceUpdater_.videoBuffered();}}// One case that can be ignored for now is audio only with alt audio,
// as we don't yet have proper support for that.
return this.sourceUpdater_.audioBuffered();}/**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */;_proto.initSegmentForMap=function initSegmentForMap(map,set){if(set===void 0){set=false;}if(!map){return null;}var id=initSegmentId(map);var storedMap=this.initSegments_[id];if(set&&!storedMap&&map.bytes){this.initSegments_[id]=storedMap={resolvedUri:map.resolvedUri,byterange:map.byterange,bytes:map.bytes,tracks:map.tracks,timescales:map.timescales};}return storedMap||map;}/**
   * Gets and sets key for the provided key
   *
   * @param {Object} key
   *        The key object representing the key to get or set
   * @param {boolean=} set
   *        If true, the key for the provided key should be saved
   * @return {Object}
   *         Key object for desired key
   */;_proto.segmentKey=function segmentKey(key,set){if(set===void 0){set=false;}if(!key){return null;}var id=segmentKeyId(key);var storedKey=this.keyCache_[id];// TODO: We should use the HTTP Expires header to invalidate our cache per
// https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-6.2.3
if(this.cacheEncryptionKeys_&&set&&!storedKey&&key.bytes){this.keyCache_[id]=storedKey={resolvedUri:key.resolvedUri,bytes:key.bytes};}var result={resolvedUri:(storedKey||key).resolvedUri};if(storedKey){result.bytes=storedKey.bytes;}return result;}/**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */;_proto.couldBeginLoading_=function couldBeginLoading_(){return this.playlist_&&!this.paused();}/**
   * load a playlist and start to fill the buffer
   */;_proto.load=function load(){// un-pause
this.monitorBuffer_();// if we don't have a playlist yet, keep waiting for one to be
// specified
if(!this.playlist_){return;}// if all the configuration is ready, initialize and begin loading
if(this.state==='INIT'&&this.couldBeginLoading_()){return this.init_();}// if we're in the middle of processing a segment already, don't
// kick off an additional segment request
if(!this.couldBeginLoading_()||this.state!=='READY'&&this.state!=='INIT'){return;}this.state='READY';}/**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */;_proto.init_=function init_(){this.state='READY';// if this is the audio segment loader, and it hasn't been inited before, then any old
// audio data from the muxed content should be removed
this.resetEverything();return this.monitorBuffer_();}/**
   * set a playlist on the segment loader
   *
   * @param {PlaylistLoader} media the playlist to set on the segment loader
   */;_proto.playlist=function playlist(newPlaylist,options){if(options===void 0){options={};}if(!newPlaylist){return;}var oldPlaylist=this.playlist_;var segmentInfo=this.pendingSegment_;this.playlist_=newPlaylist;this.xhrOptions_=options;// when we haven't started playing yet, the start of a live playlist
// is always our zero-time so force a sync update each time the playlist
// is refreshed from the server
//
// Use the INIT state to determine if playback has started, as the playlist sync info
// should be fixed once requests begin (as sync points are generated based on sync
// info), but not before then.
if(this.state==='INIT'){newPlaylist.syncInfo={mediaSequence:newPlaylist.mediaSequence,time:0};// Setting the date time mapping means mapping the program date time (if available)
// to time 0 on the player's timeline. The playlist's syncInfo serves a similar
// purpose, mapping the initial mediaSequence to time zero. Since the syncInfo can
// be updated as the playlist is refreshed before the loader starts loading, the
// program date time mapping needs to be updated as well.
//
// This mapping is only done for the main loader because a program date time should
// map equivalently between playlists.
if(this.loaderType_==='main'){this.syncController_.setDateTimeMappingForStart(newPlaylist);}}var oldId=null;if(oldPlaylist){if(oldPlaylist.id){oldId=oldPlaylist.id;}else if(oldPlaylist.uri){oldId=oldPlaylist.uri;}}this.logger_("playlist update ["+oldId+" => "+(newPlaylist.id||newPlaylist.uri)+"]");// in VOD, this is always a rendition switch (or we updated our syncInfo above)
// in LIVE, we always want to update with new playlists (including refreshes)
this.trigger('syncinfoupdate');// if we were unpaused but waiting for a playlist, start
// buffering now
if(this.state==='INIT'&&this.couldBeginLoading_()){return this.init_();}if(!oldPlaylist||oldPlaylist.uri!==newPlaylist.uri){if(this.mediaIndex!==null){// we must reset/resync the segment loader when we switch renditions and
// the segment loader is already synced to the previous rendition
// on playlist changes we want it to be possible to fetch
// at the buffer for vod but not for live. So we use resetLoader
// for live and resyncLoader for vod. We want this because
// if a playlist uses independent and non-independent segments/parts the
// buffer may not accurately reflect the next segment that we should try
// downloading.
if(!newPlaylist.endList){this.resetLoader();}else{this.resyncLoader();}}this.currentMediaInfo_=void 0;this.trigger('playlistupdate');// the rest of this function depends on `oldPlaylist` being defined
return;}// we reloaded the same playlist so we are in a live scenario
// and we will likely need to adjust the mediaIndex
var mediaSequenceDiff=newPlaylist.mediaSequence-oldPlaylist.mediaSequence;this.logger_("live window shift ["+mediaSequenceDiff+"]");// update the mediaIndex on the SegmentLoader
// this is important because we can abort a request and this value must be
// equal to the last appended mediaIndex
if(this.mediaIndex!==null){this.mediaIndex-=mediaSequenceDiff;// this can happen if we are going to load the first segment, but get a playlist
// update during that. mediaIndex would go from 0 to -1 if mediaSequence in the
// new playlist was incremented by 1.
if(this.mediaIndex<0){this.mediaIndex=null;this.partIndex=null;}else{var segment=this.playlist_.segments[this.mediaIndex];// partIndex should remain the same for the same segment
// unless parts fell off of the playlist for this segment.
// In that case we need to reset partIndex and resync
if(this.partIndex&&(!segment.parts||!segment.parts.length||!segment.parts[this.partIndex])){var mediaIndex=this.mediaIndex;this.logger_("currently processing part (index "+this.partIndex+") no longer exists.");this.resetLoader();// We want to throw away the partIndex and the data associated with it,
// as the part was dropped from our current playlists segment.
// The mediaIndex will still be valid so keep that around.
this.mediaIndex=mediaIndex;}}}// update the mediaIndex on the SegmentInfo object
// this is important because we will update this.mediaIndex with this value
// in `handleAppendsDone_` after the segment has been successfully appended
if(segmentInfo){segmentInfo.mediaIndex-=mediaSequenceDiff;if(segmentInfo.mediaIndex<0){segmentInfo.mediaIndex=null;segmentInfo.partIndex=null;}else{// we need to update the referenced segment so that timing information is
// saved for the new playlist's segment, however, if the segment fell off the
// playlist, we can leave the old reference and just lose the timing info
if(segmentInfo.mediaIndex>=0){segmentInfo.segment=newPlaylist.segments[segmentInfo.mediaIndex];}if(segmentInfo.partIndex>=0&&segmentInfo.segment.parts){segmentInfo.part=segmentInfo.segment.parts[segmentInfo.partIndex];}}}this.syncController_.saveExpiredSegmentInfo(oldPlaylist,newPlaylist);}/**
   * Prevent the loader from fetching additional segments. If there
   * is a segment request outstanding, it will finish processing
   * before the loader halts. A segment loader can be unpaused by
   * calling load().
   */;_proto.pause=function pause(){if(this.checkBufferTimeout_){window_default().clearTimeout(this.checkBufferTimeout_);this.checkBufferTimeout_=null;}}/**
   * Returns whether the segment loader is fetching additional
   * segments when given the opportunity. This property can be
   * modified through calls to pause() and load().
   */;_proto.paused=function paused(){return this.checkBufferTimeout_===null;}/**
   * Delete all the buffered data and reset the SegmentLoader
   *
   * @param {Function} [done] an optional callback to be executed when the remove
   * operation is complete
   */;_proto.resetEverything=function resetEverything(done){this.ended_=false;this.activeInitSegmentId_=null;this.appendInitSegment_={audio:true,video:true};this.resetLoader();// remove from 0, the earliest point, to Infinity, to signify removal of everything.
// VTT Segment Loader doesn't need to do anything but in the regular SegmentLoader,
// we then clamp the value to duration if necessary.
this.remove(0,Infinity,done);// clears fmp4 captions
if(this.transmuxer_){this.transmuxer_.postMessage({action:'clearAllMp4Captions'});// reset the cache in the transmuxer
this.transmuxer_.postMessage({action:'reset'});}}/**
   * Force the SegmentLoader to resync and start loading around the currentTime instead
   * of starting at the end of the buffer
   *
   * Useful for fast quality changes
   */;_proto.resetLoader=function resetLoader(){this.fetchAtBuffer_=false;this.resyncLoader();}/**
   * Force the SegmentLoader to restart synchronization and make a conservative guess
   * before returning to the simple walk-forward method
   */;_proto.resyncLoader=function resyncLoader(){if(this.transmuxer_){// need to clear out any cached data to prepare for the new segment
segmentTransmuxer.reset(this.transmuxer_);}this.mediaIndex=null;this.partIndex=null;this.syncPoint_=null;this.isPendingTimestampOffset_=false;this.callQueue_=[];this.loadQueue_=[];this.metadataQueue_.id3=[];this.metadataQueue_.caption=[];this.abort();if(this.transmuxer_){this.transmuxer_.postMessage({action:'clearParsedMp4Captions'});}}/**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   * @param {Function} [done] - an optional callback to be executed when the remove
   * @param {boolean} force - force all remove operations to happen
   * operation is complete
   */;_proto.remove=function remove(start,end,done,force){if(done===void 0){done=function done(){};}if(force===void 0){force=false;}// clamp end to duration if we need to remove everything.
// This is due to a browser bug that causes issues if we remove to Infinity.
// videojs/videojs-contrib-hls#1225
if(end===Infinity){end=this.duration_();}// skip removes that would throw an error
// commonly happens during a rendition switch at the start of a video
// from start 0 to end 0
if(end<=start){this.logger_('skipping remove because end ${end} is <= start ${start}');return;}if(!this.sourceUpdater_||!this.getMediaInfo_()){this.logger_('skipping remove because no source updater or starting media info');// nothing to remove if we haven't processed any media
return;}// set it to one to complete this function's removes
var removesRemaining=1;var removeFinished=function removeFinished(){removesRemaining--;if(removesRemaining===0){done();}};if(force||!this.audioDisabled_){removesRemaining++;this.sourceUpdater_.removeAudio(start,end,removeFinished);}// While it would be better to only remove video if the main loader has video, this
// should be safe with audio only as removeVideo will call back even if there's no
// video buffer.
//
// In theory we can check to see if there's video before calling the remove, but in
// the event that we're switching between renditions and from video to audio only
// (when we add support for that), we may need to clear the video contents despite
// what the new media will contain.
if(force||this.loaderType_==='main'){this.gopBuffer_=removeGopBuffer(this.gopBuffer_,start,end,this.timeMapping_);removesRemaining++;this.sourceUpdater_.removeVideo(start,end,removeFinished);}// remove any captions and ID3 tags
for(var track in this.inbandTextTracks_){removeCuesFromTrack(start,end,this.inbandTextTracks_[track]);}removeCuesFromTrack(start,end,this.segmentMetadataTrack_);// finished this function's removes
removeFinished();}/**
   * (re-)schedule monitorBufferTick_ to run as soon as possible
   *
   * @private
   */;_proto.monitorBuffer_=function monitorBuffer_(){if(this.checkBufferTimeout_){window_default().clearTimeout(this.checkBufferTimeout_);}this.checkBufferTimeout_=window_default().setTimeout(this.monitorBufferTick_.bind(this),1);}/**
   * As long as the SegmentLoader is in the READY state, periodically
   * invoke fillBuffer_().
   *
   * @private
   */;_proto.monitorBufferTick_=function monitorBufferTick_(){if(this.state==='READY'){this.fillBuffer_();}if(this.checkBufferTimeout_){window_default().clearTimeout(this.checkBufferTimeout_);}this.checkBufferTimeout_=window_default().setTimeout(this.monitorBufferTick_.bind(this),CHECK_BUFFER_DELAY);}/**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */;_proto.fillBuffer_=function fillBuffer_(){// TODO since the source buffer maintains a queue, and we shouldn't call this function
// except when we're ready for the next segment, this check can most likely be removed
if(this.sourceUpdater_.updating()){return;}// see if we need to begin loading immediately
var segmentInfo=this.chooseNextRequest_();if(!segmentInfo){return;}if(typeof segmentInfo.timestampOffset==='number'){this.isPendingTimestampOffset_=false;this.timelineChangeController_.pendingTimelineChange({type:this.loaderType_,from:this.currentTimeline_,to:segmentInfo.timeline});}this.loadSegment_(segmentInfo);}/**
   * Determines if we should call endOfStream on the media source based
   * on the state of the buffer or if appened segment was the final
   * segment in the playlist.
   *
   * @param {number} [mediaIndex] the media index of segment we last appended
   * @param {Object} [playlist] a media playlist object
   * @return {boolean} do we need to call endOfStream on the MediaSource
   */;_proto.isEndOfStream_=function isEndOfStream_(mediaIndex,playlist,partIndex){if(mediaIndex===void 0){mediaIndex=this.mediaIndex;}if(playlist===void 0){playlist=this.playlist_;}if(partIndex===void 0){partIndex=this.partIndex;}if(!playlist||!this.mediaSource_){return false;}var segment=typeof mediaIndex==='number'&&playlist.segments[mediaIndex];// mediaIndex is zero based but length is 1 based
var appendedLastSegment=mediaIndex+1===playlist.segments.length;// true if there are no parts, or this is the last part.
var appendedLastPart=!segment||!segment.parts||partIndex+1===segment.parts.length;// if we've buffered to the end of the video, we need to call endOfStream
// so that MediaSources can trigger the `ended` event when it runs out of
// buffered data instead of waiting for me
return playlist.endList&&this.mediaSource_.readyState==='open'&&appendedLastSegment&&appendedLastPart;}/**
   * Determines what request should be made given current segment loader state.
   *
   * @return {Object} a request object that describes the segment/part to load
   */;_proto.chooseNextRequest_=function chooseNextRequest_(){var buffered=this.buffered_();var bufferedEnd=lastBufferedEnd(buffered)||0;var bufferedTime=timeAheadOf(buffered,this.currentTime_());var preloaded=!this.hasPlayed_()&&bufferedTime>=1;var haveEnoughBuffer=bufferedTime>=this.goalBufferLength_();var segments=this.playlist_.segments;// return no segment if:
// 1. we don't have segments
// 2. The video has not yet played and we already downloaded a segment
// 3. we already have enough buffered time
if(!segments.length||preloaded||haveEnoughBuffer){return null;}this.syncPoint_=this.syncPoint_||this.syncController_.getSyncPoint(this.playlist_,this.duration_(),this.currentTimeline_,this.currentTime_());var next={partIndex:null,mediaIndex:null,startOfSegment:null,playlist:this.playlist_,isSyncRequest:Boolean(!this.syncPoint_)};if(next.isSyncRequest){next.mediaIndex=getSyncSegmentCandidate(this.currentTimeline_,segments,bufferedEnd);}else if(this.mediaIndex!==null){var segment=segments[this.mediaIndex];var partIndex=typeof this.partIndex==='number'?this.partIndex:-1;next.startOfSegment=segment.end?segment.end:bufferedEnd;if(segment.parts&&segment.parts[partIndex+1]){next.mediaIndex=this.mediaIndex;next.partIndex=partIndex+1;}else{next.mediaIndex=this.mediaIndex+1;}}else{// Find the segment containing the end of the buffer or current time.
var _Playlist$getMediaInf=Playlist.getMediaInfoForTime({experimentalExactManifestTimings:this.experimentalExactManifestTimings,playlist:this.playlist_,currentTime:this.fetchAtBuffer_?bufferedEnd:this.currentTime_(),startingPartIndex:this.syncPoint_.partIndex,startingSegmentIndex:this.syncPoint_.segmentIndex,startTime:this.syncPoint_.time}),segmentIndex=_Playlist$getMediaInf.segmentIndex,startTime=_Playlist$getMediaInf.startTime,_partIndex=_Playlist$getMediaInf.partIndex;next.getMediaInfoForTime=this.fetchAtBuffer_?"bufferedEnd "+bufferedEnd:"currentTime "+this.currentTime_();next.mediaIndex=segmentIndex;next.startOfSegment=startTime;next.partIndex=_partIndex;}var nextSegment=segments[next.mediaIndex];var nextPart=nextSegment&&typeof next.partIndex==='number'&&nextSegment.parts&&nextSegment.parts[next.partIndex];// if the next segment index is invalid or
// the next partIndex is invalid do not choose a next segment.
if(!nextSegment||typeof next.partIndex==='number'&&!nextPart){return null;}// if the next segment has parts, and we don't have a partIndex.
// Set partIndex to 0
if(typeof next.partIndex!=='number'&&nextSegment.parts){next.partIndex=0;nextPart=nextSegment.parts[0];}// if we have no buffered data then we need to make sure
// that the next part we append is "independent" if possible.
// So we check if the previous part is independent, and request
// it if it is.
if(!bufferedTime&&nextPart&&!nextPart.independent){if(next.partIndex===0){var lastSegment=segments[next.mediaIndex-1];var lastSegmentLastPart=lastSegment.parts&&lastSegment.parts.length&&lastSegment.parts[lastSegment.parts.length-1];if(lastSegmentLastPart&&lastSegmentLastPart.independent){next.mediaIndex-=1;next.partIndex=lastSegment.parts.length-1;next.independent='previous segment';}}else if(nextSegment.parts[next.partIndex-1].independent){next.partIndex-=1;next.independent='previous part';}}var ended=this.mediaSource_&&this.mediaSource_.readyState==='ended';// do not choose a next segment if all of the following:
// 1. this is the last segment in the playlist
// 2. end of stream has been called on the media source already
// 3. the player is not seeking
if(next.mediaIndex>=segments.length-1&&ended&&!this.seeking_()){return null;}return this.generateSegmentInfo_(next);};_proto.generateSegmentInfo_=function generateSegmentInfo_(options){var independent=options.independent,playlist=options.playlist,mediaIndex=options.mediaIndex,startOfSegment=options.startOfSegment,isSyncRequest=options.isSyncRequest,partIndex=options.partIndex,forceTimestampOffset=options.forceTimestampOffset,getMediaInfoForTime=options.getMediaInfoForTime;var segment=playlist.segments[mediaIndex];var part=typeof partIndex==='number'&&segment.parts[partIndex];var segmentInfo={requestId:'segment-loader-'+Math.random(),// resolve the segment URL relative to the playlist
uri:part&&part.resolvedUri||segment.resolvedUri,// the segment's mediaIndex at the time it was requested
mediaIndex:mediaIndex,partIndex:part?partIndex:null,// whether or not to update the SegmentLoader's state with this
// segment's mediaIndex
isSyncRequest:isSyncRequest,startOfSegment:startOfSegment,// the segment's playlist
playlist:playlist,// unencrypted bytes of the segment
bytes:null,// when a key is defined for this segment, the encrypted bytes
encryptedBytes:null,// The target timestampOffset for this segment when we append it
// to the source buffer
timestampOffset:null,// The timeline that the segment is in
timeline:segment.timeline,// The expected duration of the segment in seconds
duration:part&&part.duration||segment.duration,// retain the segment in case the playlist updates while doing an async process
segment:segment,part:part,byteLength:0,transmuxer:this.transmuxer_,// type of getMediaInfoForTime that was used to get this segment
getMediaInfoForTime:getMediaInfoForTime,independent:independent};var overrideCheck=typeof forceTimestampOffset!=='undefined'?forceTimestampOffset:this.isPendingTimestampOffset_;segmentInfo.timestampOffset=this.timestampOffsetForSegment_({segmentTimeline:segment.timeline,currentTimeline:this.currentTimeline_,startOfSegment:startOfSegment,buffered:this.buffered_(),overrideCheck:overrideCheck});var audioBufferedEnd=lastBufferedEnd(this.sourceUpdater_.audioBuffered());if(typeof audioBufferedEnd==='number'){// since the transmuxer is using the actual timing values, but the buffer is
// adjusted by the timestamp offset, we must adjust the value here
segmentInfo.audioAppendStart=audioBufferedEnd-this.sourceUpdater_.audioTimestampOffset();}if(this.sourceUpdater_.videoBuffered().length){segmentInfo.gopsToAlignWith=gopsSafeToAlignWith(this.gopBuffer_,// since the transmuxer is using the actual timing values, but the time is
// adjusted by the timestmap offset, we must adjust the value here
this.currentTime_()-this.sourceUpdater_.videoTimestampOffset(),this.timeMapping_);}return segmentInfo;}// get the timestampoffset for a segment,
// added so that vtt segment loader can override and prevent
// adding timestamp offsets.
;_proto.timestampOffsetForSegment_=function timestampOffsetForSegment_(options){return timestampOffsetForSegment(options);}/**
   * Determines if the network has enough bandwidth to complete the current segment
   * request in a timely manner. If not, the request will be aborted early and bandwidth
   * updated to trigger a playlist switch.
   *
   * @param {Object} stats
   *        Object containing stats about the request timing and size
   * @private
   */;_proto.earlyAbortWhenNeeded_=function earlyAbortWhenNeeded_(stats){if(this.vhs_.tech_.paused()||// Don't abort if the current playlist is on the lowestEnabledRendition
// TODO: Replace using timeout with a boolean indicating whether this playlist is
//       the lowestEnabledRendition.
!this.xhrOptions_.timeout||// Don't abort if we have no bandwidth information to estimate segment sizes
!this.playlist_.attributes.BANDWIDTH){return;}// Wait at least 1 second since the first byte of data has been received before
// using the calculated bandwidth from the progress event to allow the bitrate
// to stabilize
if(Date.now()-(stats.firstBytesReceivedAt||Date.now())<1000){return;}var currentTime=this.currentTime_();var measuredBandwidth=stats.bandwidth;var segmentDuration=this.pendingSegment_.duration;var requestTimeRemaining=Playlist.estimateSegmentRequestTime(segmentDuration,measuredBandwidth,this.playlist_,stats.bytesReceived);// Subtract 1 from the timeUntilRebuffer so we still consider an early abort
// if we are only left with less than 1 second when the request completes.
// A negative timeUntilRebuffering indicates we are already rebuffering
var timeUntilRebuffer$1=timeUntilRebuffer(this.buffered_(),currentTime,this.vhs_.tech_.playbackRate())-1;// Only consider aborting early if the estimated time to finish the download
// is larger than the estimated time until the player runs out of forward buffer
if(requestTimeRemaining<=timeUntilRebuffer$1){return;}var switchCandidate=minRebufferMaxBandwidthSelector({master:this.vhs_.playlists.master,currentTime:currentTime,bandwidth:measuredBandwidth,duration:this.duration_(),segmentDuration:segmentDuration,timeUntilRebuffer:timeUntilRebuffer$1,currentTimeline:this.currentTimeline_,syncController:this.syncController_});if(!switchCandidate){return;}var rebufferingImpact=requestTimeRemaining-timeUntilRebuffer$1;var timeSavedBySwitching=rebufferingImpact-switchCandidate.rebufferingImpact;var minimumTimeSaving=0.5;// If we are already rebuffering, increase the amount of variance we add to the
// potential round trip time of the new request so that we are not too aggressive
// with switching to a playlist that might save us a fraction of a second.
if(timeUntilRebuffer$1<=TIME_FUDGE_FACTOR){minimumTimeSaving=1;}if(!switchCandidate.playlist||switchCandidate.playlist.uri===this.playlist_.uri||timeSavedBySwitching<minimumTimeSaving){return;}// set the bandwidth to that of the desired playlist being sure to scale by
// BANDWIDTH_VARIANCE and add one so the playlist selector does not exclude it
// don't trigger a bandwidthupdate as the bandwidth is artifial
this.bandwidth=switchCandidate.playlist.attributes.BANDWIDTH*Config.BANDWIDTH_VARIANCE+1;this.trigger('earlyabort');};_proto.handleAbort_=function handleAbort_(segmentInfo){this.logger_("Aborting "+segmentInfoString(segmentInfo));this.mediaRequestsAborted+=1;}/**
   * XHR `progress` event handler
   *
   * @param {Event}
   *        The XHR `progress` event
   * @param {Object} simpleSegment
   *        A simplified segment object copy
   * @private
   */;_proto.handleProgress_=function handleProgress_(event,simpleSegment){this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}this.trigger('progress');};_proto.handleTrackInfo_=function handleTrackInfo_(simpleSegment,trackInfo){this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}if(this.checkForIllegalMediaSwitch(trackInfo)){return;}trackInfo=trackInfo||{};// When we have track info, determine what media types this loader is dealing with.
// Guard against cases where we're not getting track info at all until we are
// certain that all streams will provide it.
if(!shallowEqual(this.currentMediaInfo_,trackInfo)){this.appendInitSegment_={audio:true,video:true};this.startingMediaInfo_=trackInfo;this.currentMediaInfo_=trackInfo;this.logger_('trackinfo update',trackInfo);this.trigger('trackinfo');}// trackinfo may cause an abort if the trackinfo
// causes a codec change to an unsupported codec.
if(this.checkForAbort_(simpleSegment.requestId)){return;}// set trackinfo on the pending segment so that
// it can append.
this.pendingSegment_.trackInfo=trackInfo;// check if any calls were waiting on the track info
if(this.hasEnoughInfoToAppend_()){this.processCallQueue_();}};_proto.handleTimingInfo_=function handleTimingInfo_(simpleSegment,mediaType,timeType,time){this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}var segmentInfo=this.pendingSegment_;var timingInfoProperty=timingInfoPropertyForMedia(mediaType);segmentInfo[timingInfoProperty]=segmentInfo[timingInfoProperty]||{};segmentInfo[timingInfoProperty][timeType]=time;this.logger_("timinginfo: "+mediaType+" - "+timeType+" - "+time);// check if any calls were waiting on the timing info
if(this.hasEnoughInfoToAppend_()){this.processCallQueue_();}};_proto.handleCaptions_=function handleCaptions_(simpleSegment,captionData){var _this2=this;this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}// This could only happen with fmp4 segments, but
// should still not happen in general
if(captionData.length===0){this.logger_('SegmentLoader received no captions from a caption event');return;}var segmentInfo=this.pendingSegment_;// Wait until we have some video data so that caption timing
// can be adjusted by the timestamp offset
if(!segmentInfo.hasAppendedData_){this.metadataQueue_.caption.push(this.handleCaptions_.bind(this,simpleSegment,captionData));return;}var timestampOffset=this.sourceUpdater_.videoTimestampOffset()===null?this.sourceUpdater_.audioTimestampOffset():this.sourceUpdater_.videoTimestampOffset();var captionTracks={};// get total start/end and captions for each track/stream
captionData.forEach(function(caption){// caption.stream is actually a track name...
// set to the existing values in tracks or default values
captionTracks[caption.stream]=captionTracks[caption.stream]||{// Infinity, as any other value will be less than this
startTime:Infinity,captions:[],// 0 as an other value will be more than this
endTime:0};var captionTrack=captionTracks[caption.stream];captionTrack.startTime=Math.min(captionTrack.startTime,caption.startTime+timestampOffset);captionTrack.endTime=Math.max(captionTrack.endTime,caption.endTime+timestampOffset);captionTrack.captions.push(caption);});Object.keys(captionTracks).forEach(function(trackName){var _captionTracks$trackN=captionTracks[trackName],startTime=_captionTracks$trackN.startTime,endTime=_captionTracks$trackN.endTime,captions=_captionTracks$trackN.captions;var inbandTextTracks=_this2.inbandTextTracks_;_this2.logger_("adding cues from "+startTime+" -> "+endTime+" for "+trackName);createCaptionsTrackIfNotExists(inbandTextTracks,_this2.vhs_.tech_,trackName);// clear out any cues that start and end at the same time period for the same track.
// We do this because a rendition change that also changes the timescale for captions
// will result in captions being re-parsed for certain segments. If we add them again
// without clearing we will have two of the same captions visible.
removeCuesFromTrack(startTime,endTime,inbandTextTracks[trackName]);addCaptionData({captionArray:captions,inbandTextTracks:inbandTextTracks,timestampOffset:timestampOffset});});// Reset stored captions since we added parsed
// captions to a text track at this point
if(this.transmuxer_){this.transmuxer_.postMessage({action:'clearParsedMp4Captions'});}};_proto.handleId3_=function handleId3_(simpleSegment,id3Frames,dispatchType){this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}var segmentInfo=this.pendingSegment_;// we need to have appended data in order for the timestamp offset to be set
if(!segmentInfo.hasAppendedData_){this.metadataQueue_.id3.push(this.handleId3_.bind(this,simpleSegment,id3Frames,dispatchType));return;}var timestampOffset=this.sourceUpdater_.videoTimestampOffset()===null?this.sourceUpdater_.audioTimestampOffset():this.sourceUpdater_.videoTimestampOffset();// There's potentially an issue where we could double add metadata if there's a muxed
// audio/video source with a metadata track, and an alt audio with a metadata track.
// However, this probably won't happen, and if it does it can be handled then.
createMetadataTrackIfNotExists(this.inbandTextTracks_,dispatchType,this.vhs_.tech_);addMetadata({inbandTextTracks:this.inbandTextTracks_,metadataArray:id3Frames,timestampOffset:timestampOffset,videoDuration:this.duration_()});};_proto.processMetadataQueue_=function processMetadataQueue_(){this.metadataQueue_.id3.forEach(function(fn){return fn();});this.metadataQueue_.caption.forEach(function(fn){return fn();});this.metadataQueue_.id3=[];this.metadataQueue_.caption=[];};_proto.processCallQueue_=function processCallQueue_(){var callQueue=this.callQueue_;// Clear out the queue before the queued functions are run, since some of the
// functions may check the length of the load queue and default to pushing themselves
// back onto the queue.
this.callQueue_=[];callQueue.forEach(function(fun){return fun();});};_proto.processLoadQueue_=function processLoadQueue_(){var loadQueue=this.loadQueue_;// Clear out the queue before the queued functions are run, since some of the
// functions may check the length of the load queue and default to pushing themselves
// back onto the queue.
this.loadQueue_=[];loadQueue.forEach(function(fun){return fun();});}/**
   * Determines whether the loader has enough info to load the next segment.
   *
   * @return {boolean}
   *         Whether or not the loader has enough info to load the next segment
   */;_proto.hasEnoughInfoToLoad_=function hasEnoughInfoToLoad_(){// Since primary timing goes by video, only the audio loader potentially needs to wait
// to load.
if(this.loaderType_!=='audio'){return true;}var segmentInfo=this.pendingSegment_;// A fill buffer must have already run to establish a pending segment before there's
// enough info to load.
if(!segmentInfo){return false;}// The first segment can and should be loaded immediately so that source buffers are
// created together (before appending). Source buffer creation uses the presence of
// audio and video data to determine whether to create audio/video source buffers, and
// uses processed (transmuxed or parsed) media to determine the types required.
if(!this.getCurrentMediaInfo_()){return true;}if(// Technically, instead of waiting to load a segment on timeline changes, a segment
// can be requested and downloaded and only wait before it is transmuxed or parsed.
// But in practice, there are a few reasons why it is better to wait until a loader
// is ready to append that segment before requesting and downloading:
//
// 1. Because audio and main loaders cross discontinuities together, if this loader
//    is waiting for the other to catch up, then instead of requesting another
//    segment and using up more bandwidth, by not yet loading, more bandwidth is
//    allotted to the loader currently behind.
// 2. media-segment-request doesn't have to have logic to consider whether a segment
// is ready to be processed or not, isolating the queueing behavior to the loader.
// 3. The audio loader bases some of its segment properties on timing information
//    provided by the main loader, meaning that, if the logic for waiting on
//    processing was in media-segment-request, then it would also need to know how
//    to re-generate the segment information after the main loader caught up.
shouldWaitForTimelineChange({timelineChangeController:this.timelineChangeController_,currentTimeline:this.currentTimeline_,segmentTimeline:segmentInfo.timeline,loaderType:this.loaderType_,audioDisabled:this.audioDisabled_})){return false;}return true;};_proto.getCurrentMediaInfo_=function getCurrentMediaInfo_(segmentInfo){if(segmentInfo===void 0){segmentInfo=this.pendingSegment_;}return segmentInfo&&segmentInfo.trackInfo||this.currentMediaInfo_;};_proto.getMediaInfo_=function getMediaInfo_(segmentInfo){if(segmentInfo===void 0){segmentInfo=this.pendingSegment_;}return this.getCurrentMediaInfo_(segmentInfo)||this.startingMediaInfo_;};_proto.getPendingSegmentPlaylist=function getPendingSegmentPlaylist(){return this.pendingSegment_?this.pendingSegment_.playlist:null;};_proto.hasEnoughInfoToAppend_=function hasEnoughInfoToAppend_(){if(!this.sourceUpdater_.ready()){return false;}// If content needs to be removed or the loader is waiting on an append reattempt,
// then no additional content should be appended until the prior append is resolved.
if(this.waitingOnRemove_||this.quotaExceededErrorRetryTimeout_){return false;}var segmentInfo=this.pendingSegment_;var trackInfo=this.getCurrentMediaInfo_();// no segment to append any data for or
// we do not have information on this specific
// segment yet
if(!segmentInfo||!trackInfo){return false;}var hasAudio=trackInfo.hasAudio,hasVideo=trackInfo.hasVideo,isMuxed=trackInfo.isMuxed;if(hasVideo&&!segmentInfo.videoTimingInfo){return false;}// muxed content only relies on video timing information for now.
if(hasAudio&&!this.audioDisabled_&&!isMuxed&&!segmentInfo.audioTimingInfo){return false;}if(shouldWaitForTimelineChange({timelineChangeController:this.timelineChangeController_,currentTimeline:this.currentTimeline_,segmentTimeline:segmentInfo.timeline,loaderType:this.loaderType_,audioDisabled:this.audioDisabled_})){return false;}return true;};_proto.handleData_=function handleData_(simpleSegment,result){this.earlyAbortWhenNeeded_(simpleSegment.stats);if(this.checkForAbort_(simpleSegment.requestId)){return;}// If there's anything in the call queue, then this data came later and should be
// executed after the calls currently queued.
if(this.callQueue_.length||!this.hasEnoughInfoToAppend_()){this.callQueue_.push(this.handleData_.bind(this,simpleSegment,result));return;}var segmentInfo=this.pendingSegment_;// update the time mapping so we can translate from display time to media time
this.setTimeMapping_(segmentInfo.timeline);// for tracking overall stats
this.updateMediaSecondsLoaded_(segmentInfo.part||segmentInfo.segment);// Note that the state isn't changed from loading to appending. This is because abort
// logic may change behavior depending on the state, and changing state too early may
// inflate our estimates of bandwidth. In the future this should be re-examined to
// note more granular states.
// don't process and append data if the mediaSource is closed
if(this.mediaSource_.readyState==='closed'){return;}// if this request included an initialization segment, save that data
// to the initSegment cache
if(simpleSegment.map){simpleSegment.map=this.initSegmentForMap(simpleSegment.map,true);// move over init segment properties to media request
segmentInfo.segment.map=simpleSegment.map;}// if this request included a segment key, save that data in the cache
if(simpleSegment.key){this.segmentKey(simpleSegment.key,true);}segmentInfo.isFmp4=simpleSegment.isFmp4;segmentInfo.timingInfo=segmentInfo.timingInfo||{};if(segmentInfo.isFmp4){this.trigger('fmp4');segmentInfo.timingInfo.start=segmentInfo[timingInfoPropertyForMedia(result.type)].start;}else{var trackInfo=this.getCurrentMediaInfo_();var useVideoTimingInfo=this.loaderType_==='main'&&trackInfo&&trackInfo.hasVideo;var firstVideoFrameTimeForData;if(useVideoTimingInfo){firstVideoFrameTimeForData=segmentInfo.videoTimingInfo.start;}// Segment loader knows more about segment timing than the transmuxer (in certain
// aspects), so make any changes required for a more accurate start time.
// Don't set the end time yet, as the segment may not be finished processing.
segmentInfo.timingInfo.start=this.trueSegmentStart_({currentStart:segmentInfo.timingInfo.start,playlist:segmentInfo.playlist,mediaIndex:segmentInfo.mediaIndex,currentVideoTimestampOffset:this.sourceUpdater_.videoTimestampOffset(),useVideoTimingInfo:useVideoTimingInfo,firstVideoFrameTimeForData:firstVideoFrameTimeForData,videoTimingInfo:segmentInfo.videoTimingInfo,audioTimingInfo:segmentInfo.audioTimingInfo});}// Init segments for audio and video only need to be appended in certain cases. Now
// that data is about to be appended, we can check the final cases to determine
// whether we should append an init segment.
this.updateAppendInitSegmentStatus(segmentInfo,result.type);// Timestamp offset should be updated once we get new data and have its timing info,
// as we use the start of the segment to offset the best guess (playlist provided)
// timestamp offset.
this.updateSourceBufferTimestampOffset_(segmentInfo);// if this is a sync request we need to determine whether it should
// be appended or not.
if(segmentInfo.isSyncRequest){// first save/update our timing info for this segment.
// this is what allows us to choose an accurate segment
// and the main reason we make a sync request.
this.updateTimingInfoEnd_(segmentInfo);this.syncController_.saveSegmentTimingInfo({segmentInfo:segmentInfo,shouldSaveTimelineMapping:this.loaderType_==='main'});var next=this.chooseNextRequest_();// If the sync request isn't the segment that would be requested next
// after taking into account its timing info, do not append it.
if(next.mediaIndex!==segmentInfo.mediaIndex||next.partIndex!==segmentInfo.partIndex){this.logger_('sync segment was incorrect, not appending');return;}// otherwise append it like any other segment as our guess was correct.
this.logger_('sync segment was correct, appending');}// Save some state so that in the future anything waiting on first append (and/or
// timestamp offset(s)) can process immediately. While the extra state isn't optimal,
// we need some notion of whether the timestamp offset or other relevant information
// has had a chance to be set.
segmentInfo.hasAppendedData_=true;// Now that the timestamp offset should be set, we can append any waiting ID3 tags.
this.processMetadataQueue_();this.appendData_(segmentInfo,result);};_proto.updateAppendInitSegmentStatus=function updateAppendInitSegmentStatus(segmentInfo,type){// alt audio doesn't manage timestamp offset
if(this.loaderType_==='main'&&typeof segmentInfo.timestampOffset==='number'&&// in the case that we're handling partial data, we don't want to append an init
// segment for each chunk
!segmentInfo.changedTimestampOffset){// if the timestamp offset changed, the timeline may have changed, so we have to re-
// append init segments
this.appendInitSegment_={audio:true,video:true};}if(this.playlistOfLastInitSegment_[type]!==segmentInfo.playlist){// make sure we append init segment on playlist changes, in case the media config
// changed
this.appendInitSegment_[type]=true;}};_proto.getInitSegmentAndUpdateState_=function getInitSegmentAndUpdateState_(_ref4){var type=_ref4.type,initSegment=_ref4.initSegment,map=_ref4.map,playlist=_ref4.playlist;// "The EXT-X-MAP tag specifies how to obtain the Media Initialization Section
// (Section 3) required to parse the applicable Media Segments.  It applies to every
// Media Segment that appears after it in the Playlist until the next EXT-X-MAP tag
// or until the end of the playlist."
// https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.2.5
if(map){var id=initSegmentId(map);if(this.activeInitSegmentId_===id){// don't need to re-append the init segment if the ID matches
return null;}// a map-specified init segment takes priority over any transmuxed (or otherwise
// obtained) init segment
//
// this also caches the init segment for later use
initSegment=this.initSegmentForMap(map,true).bytes;this.activeInitSegmentId_=id;}// We used to always prepend init segments for video, however, that shouldn't be
// necessary. Instead, we should only append on changes, similar to what we've always
// done for audio. This is more important (though may not be that important) for
// frame-by-frame appending for LHLS, simply because of the increased quantity of
// appends.
if(initSegment&&this.appendInitSegment_[type]){// Make sure we track the playlist that we last used for the init segment, so that
// we can re-append the init segment in the event that we get data from a new
// playlist. Discontinuities and track changes are handled in other sections.
this.playlistOfLastInitSegment_[type]=playlist;// Disable future init segment appends for this type. Until a change is necessary.
this.appendInitSegment_[type]=false;// we need to clear out the fmp4 active init segment id, since
// we are appending the muxer init segment
this.activeInitSegmentId_=null;return initSegment;}return null;};_proto.handleQuotaExceededError_=function handleQuotaExceededError_(_ref5,error){var _this3=this;var segmentInfo=_ref5.segmentInfo,type=_ref5.type,bytes=_ref5.bytes;var audioBuffered=this.sourceUpdater_.audioBuffered();var videoBuffered=this.sourceUpdater_.videoBuffered();// For now we're ignoring any notion of gaps in the buffer, but they, in theory,
// should be cleared out during the buffer removals. However, log in case it helps
// debug.
if(audioBuffered.length>1){this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: '+timeRangesToArray(audioBuffered).join(', '));}if(videoBuffered.length>1){this.logger_('On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: '+timeRangesToArray(videoBuffered).join(', '));}var audioBufferStart=audioBuffered.length?audioBuffered.start(0):0;var audioBufferEnd=audioBuffered.length?audioBuffered.end(audioBuffered.length-1):0;var videoBufferStart=videoBuffered.length?videoBuffered.start(0):0;var videoBufferEnd=videoBuffered.length?videoBuffered.end(videoBuffered.length-1):0;if(audioBufferEnd-audioBufferStart<=MIN_BACK_BUFFER&&videoBufferEnd-videoBufferStart<=MIN_BACK_BUFFER){// Can't remove enough buffer to make room for new segment (or the browser doesn't
// allow for appends of segments this size). In the future, it may be possible to
// split up the segment and append in pieces, but for now, error out this playlist
// in an attempt to switch to a more manageable rendition.
this.logger_('On QUOTA_EXCEEDED_ERR, single segment too large to append to '+'buffer, triggering an error. '+("Appended byte length: "+bytes.byteLength+", ")+("audio buffer: "+timeRangesToArray(audioBuffered).join(', ')+", ")+("video buffer: "+timeRangesToArray(videoBuffered).join(', ')+", "));this.error({message:'Quota exceeded error with append of a single segment of content',excludeUntil:Infinity});this.trigger('error');return;}// To try to resolve the quota exceeded error, clear back buffer and retry. This means
// that the segment-loader should block on future events until this one is handled, so
// that it doesn't keep moving onto further segments. Adding the call to the call
// queue will prevent further appends until waitingOnRemove_ and
// quotaExceededErrorRetryTimeout_ are cleared.
//
// Note that this will only block the current loader. In the case of demuxed content,
// the other load may keep filling as fast as possible. In practice, this should be
// OK, as it is a rare case when either audio has a high enough bitrate to fill up a
// source buffer, or video fills without enough room for audio to append (and without
// the availability of clearing out seconds of back buffer to make room for audio).
// But it might still be good to handle this case in the future as a TODO.
this.waitingOnRemove_=true;this.callQueue_.push(this.appendToSourceBuffer_.bind(this,{segmentInfo:segmentInfo,type:type,bytes:bytes}));var currentTime=this.currentTime_();// Try to remove as much audio and video as possible to make room for new content
// before retrying.
var timeToRemoveUntil=currentTime-MIN_BACK_BUFFER;this.logger_("On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to "+timeToRemoveUntil);this.remove(0,timeToRemoveUntil,function(){_this3.logger_("On QUOTA_EXCEEDED_ERR, retrying append in "+MIN_BACK_BUFFER+"s");_this3.waitingOnRemove_=false;// wait the length of time alotted in the back buffer to prevent wasted
// attempts (since we can't clear less than the minimum)
_this3.quotaExceededErrorRetryTimeout_=window_default().setTimeout(function(){_this3.logger_('On QUOTA_EXCEEDED_ERR, re-processing call queue');_this3.quotaExceededErrorRetryTimeout_=null;_this3.processCallQueue_();},MIN_BACK_BUFFER*1000);},true);};_proto.handleAppendError_=function handleAppendError_(_ref6,error){var segmentInfo=_ref6.segmentInfo,type=_ref6.type,bytes=_ref6.bytes;// if there's no error, nothing to do
if(!error){return;}if(error.code===QUOTA_EXCEEDED_ERR){this.handleQuotaExceededError_({segmentInfo:segmentInfo,type:type,bytes:bytes});// A quota exceeded error should be recoverable with a future re-append, so no need
// to trigger an append error.
return;}this.logger_('Received non QUOTA_EXCEEDED_ERR on append',error);this.error(type+" append of "+bytes.length+"b failed for segment "+("#"+segmentInfo.mediaIndex+" in playlist "+segmentInfo.playlist.id));// If an append errors, we often can't recover.
// (see https://w3c.github.io/media-source/#sourcebuffer-append-error).
//
// Trigger a special error so that it can be handled separately from normal,
// recoverable errors.
this.trigger('appenderror');};_proto.appendToSourceBuffer_=function appendToSourceBuffer_(_ref7){var segmentInfo=_ref7.segmentInfo,type=_ref7.type,initSegment=_ref7.initSegment,data=_ref7.data,bytes=_ref7.bytes;// If this is a re-append, bytes were already created and don't need to be recreated
if(!bytes){var segments=[data];var byteLength=data.byteLength;if(initSegment){// if the media initialization segment is changing, append it before the content
// segment
segments.unshift(initSegment);byteLength+=initSegment.byteLength;}// Technically we should be OK appending the init segment separately, however, we
// haven't yet tested that, and prepending is how we have always done things.
bytes=concatSegments({bytes:byteLength,segments:segments});}this.sourceUpdater_.appendBuffer({segmentInfo:segmentInfo,type:type,bytes:bytes},this.handleAppendError_.bind(this,{segmentInfo:segmentInfo,type:type,bytes:bytes}));};_proto.handleSegmentTimingInfo_=function handleSegmentTimingInfo_(type,requestId,segmentTimingInfo){if(!this.pendingSegment_||requestId!==this.pendingSegment_.requestId){return;}var segment=this.pendingSegment_.segment;var timingInfoProperty=type+"TimingInfo";if(!segment[timingInfoProperty]){segment[timingInfoProperty]={};}segment[timingInfoProperty].transmuxerPrependedSeconds=segmentTimingInfo.prependedContentDuration||0;segment[timingInfoProperty].transmuxedPresentationStart=segmentTimingInfo.start.presentation;segment[timingInfoProperty].transmuxedDecodeStart=segmentTimingInfo.start.decode;segment[timingInfoProperty].transmuxedPresentationEnd=segmentTimingInfo.end.presentation;segment[timingInfoProperty].transmuxedDecodeEnd=segmentTimingInfo.end.decode;// mainly used as a reference for debugging
segment[timingInfoProperty].baseMediaDecodeTime=segmentTimingInfo.baseMediaDecodeTime;};_proto.appendData_=function appendData_(segmentInfo,result){var type=result.type,data=result.data;if(!data||!data.byteLength){return;}if(type==='audio'&&this.audioDisabled_){return;}var initSegment=this.getInitSegmentAndUpdateState_({type:type,initSegment:result.initSegment,playlist:segmentInfo.playlist,map:segmentInfo.isFmp4?segmentInfo.segment.map:null});this.appendToSourceBuffer_({segmentInfo:segmentInfo,type:type,initSegment:initSegment,data:data});}/**
   * load a specific segment from a request into the buffer
   *
   * @private
   */;_proto.loadSegment_=function loadSegment_(segmentInfo){var _this4=this;this.state='WAITING';this.pendingSegment_=segmentInfo;this.trimBackBuffer_(segmentInfo);if(typeof segmentInfo.timestampOffset==='number'){if(this.transmuxer_){this.transmuxer_.postMessage({action:'clearAllMp4Captions'});}}if(!this.hasEnoughInfoToLoad_()){this.loadQueue_.push(function(){// regenerate the audioAppendStart, timestampOffset, etc as they
// may have changed since this function was added to the queue.
var options=_extends({},segmentInfo,{forceTimestampOffset:true});_extends(segmentInfo,_this4.generateSegmentInfo_(options));_this4.isPendingTimestampOffset_=false;_this4.updateTransmuxerAndRequestSegment_(segmentInfo);});return;}this.updateTransmuxerAndRequestSegment_(segmentInfo);};_proto.updateTransmuxerAndRequestSegment_=function updateTransmuxerAndRequestSegment_(segmentInfo){var _this5=this;// We'll update the source buffer's timestamp offset once we have transmuxed data, but
// the transmuxer still needs to be updated before then.
//
// Even though keepOriginalTimestamps is set to true for the transmuxer, timestamp
// offset must be passed to the transmuxer for stream correcting adjustments.
if(this.shouldUpdateTransmuxerTimestampOffset_(segmentInfo.timestampOffset)){this.gopBuffer_.length=0;// gopsToAlignWith was set before the GOP buffer was cleared
segmentInfo.gopsToAlignWith=[];this.timeMapping_=0;// reset values in the transmuxer since a discontinuity should start fresh
this.transmuxer_.postMessage({action:'reset'});this.transmuxer_.postMessage({action:'setTimestampOffset',timestampOffset:segmentInfo.timestampOffset});}var simpleSegment=this.createSimplifiedSegmentObj_(segmentInfo);var isEndOfStream=this.isEndOfStream_(segmentInfo.mediaIndex,segmentInfo.playlist,segmentInfo.partIndex);var isWalkingForward=this.mediaIndex!==null;var isDiscontinuity=segmentInfo.timeline!==this.currentTimeline_&&// currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
// the first timeline
segmentInfo.timeline>0;var isEndOfTimeline=isEndOfStream||isWalkingForward&&isDiscontinuity;this.logger_("Requesting "+segmentInfoString(segmentInfo));// If there's an init segment associated with this segment, but it is not cached (identified by a lack of bytes),
// then this init segment has never been seen before and should be appended.
//
// At this point the content type (audio/video or both) is not yet known, but it should be safe to set
// both to true and leave the decision of whether to append the init segment to append time.
if(simpleSegment.map&&!simpleSegment.map.bytes){this.logger_('going to request init segment.');this.appendInitSegment_={video:true,audio:true};}segmentInfo.abortRequests=mediaSegmentRequest({xhr:this.vhs_.xhr,xhrOptions:this.xhrOptions_,decryptionWorker:this.decrypter_,segment:simpleSegment,abortFn:this.handleAbort_.bind(this,segmentInfo),progressFn:this.handleProgress_.bind(this),trackInfoFn:this.handleTrackInfo_.bind(this),timingInfoFn:this.handleTimingInfo_.bind(this),videoSegmentTimingInfoFn:this.handleSegmentTimingInfo_.bind(this,'video',segmentInfo.requestId),audioSegmentTimingInfoFn:this.handleSegmentTimingInfo_.bind(this,'audio',segmentInfo.requestId),captionsFn:this.handleCaptions_.bind(this),isEndOfTimeline:isEndOfTimeline,endedTimelineFn:function endedTimelineFn(){_this5.logger_('received endedtimeline callback');},id3Fn:this.handleId3_.bind(this),dataFn:this.handleData_.bind(this),doneFn:this.segmentRequestFinished_.bind(this),onTransmuxerLog:function onTransmuxerLog(_ref8){var message=_ref8.message,level=_ref8.level,stream=_ref8.stream;_this5.logger_(segmentInfoString(segmentInfo)+" logged from transmuxer stream "+stream+" as a "+level+": "+message);}});}/**
   * trim the back buffer so that we don't have too much data
   * in the source buffer
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   */;_proto.trimBackBuffer_=function trimBackBuffer_(segmentInfo){var removeToTime=safeBackBufferTrimTime(this.seekable_(),this.currentTime_(),this.playlist_.targetDuration||10);// Chrome has a hard limit of 150MB of
// buffer and a very conservative "garbage collector"
// We manually clear out the old buffer to ensure
// we don't trigger the QuotaExceeded error
// on the source buffer during subsequent appends
if(removeToTime>0){this.remove(0,removeToTime);}}/**
   * created a simplified copy of the segment object with just the
   * information necessary to perform the XHR and decryption
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   * @return {Object} a simplified segment object copy
   */;_proto.createSimplifiedSegmentObj_=function createSimplifiedSegmentObj_(segmentInfo){var segment=segmentInfo.segment;var part=segmentInfo.part;var simpleSegment={resolvedUri:part?part.resolvedUri:segment.resolvedUri,byterange:part?part.byterange:segment.byterange,requestId:segmentInfo.requestId,transmuxer:segmentInfo.transmuxer,audioAppendStart:segmentInfo.audioAppendStart,gopsToAlignWith:segmentInfo.gopsToAlignWith,part:segmentInfo.part};var previousSegment=segmentInfo.playlist.segments[segmentInfo.mediaIndex-1];if(previousSegment&&previousSegment.timeline===segment.timeline){// The baseStartTime of a segment is used to handle rollover when probing the TS
// segment to retrieve timing information. Since the probe only looks at the media's
// times (e.g., PTS and DTS values of the segment), and doesn't consider the
// player's time (e.g., player.currentTime()), baseStartTime should reflect the
// media time as well. transmuxedDecodeEnd represents the end time of a segment, in
// seconds of media time, so should be used here. The previous segment is used since
// the end of the previous segment should represent the beginning of the current
// segment, so long as they are on the same timeline.
if(previousSegment.videoTimingInfo){simpleSegment.baseStartTime=previousSegment.videoTimingInfo.transmuxedDecodeEnd;}else if(previousSegment.audioTimingInfo){simpleSegment.baseStartTime=previousSegment.audioTimingInfo.transmuxedDecodeEnd;}}if(segment.key){// if the media sequence is greater than 2^32, the IV will be incorrect
// assuming 10s segments, that would be about 1300 years
var iv=segment.key.iv||new Uint32Array([0,0,0,segmentInfo.mediaIndex+segmentInfo.playlist.mediaSequence]);simpleSegment.key=this.segmentKey(segment.key);simpleSegment.key.iv=iv;}if(segment.map){simpleSegment.map=this.initSegmentForMap(segment.map);}return simpleSegment;};_proto.saveTransferStats_=function saveTransferStats_(stats){// every request counts as a media request even if it has been aborted
// or canceled due to a timeout
this.mediaRequests+=1;if(stats){this.mediaBytesTransferred+=stats.bytesReceived;this.mediaTransferDuration+=stats.roundTripTime;}};_proto.saveBandwidthRelatedStats_=function saveBandwidthRelatedStats_(duration,stats){// byteLength will be used for throughput, and should be based on bytes receieved,
// which we only know at the end of the request and should reflect total bytes
// downloaded rather than just bytes processed from components of the segment
this.pendingSegment_.byteLength=stats.bytesReceived;if(duration<MIN_SEGMENT_DURATION_TO_SAVE_STATS){this.logger_("Ignoring segment's bandwidth because its duration of "+duration+(" is less than the min to record "+MIN_SEGMENT_DURATION_TO_SAVE_STATS));return;}this.bandwidth=stats.bandwidth;this.roundTrip=stats.roundTripTime;};_proto.handleTimeout_=function handleTimeout_(){// although the VTT segment loader bandwidth isn't really used, it's good to
// maintain functinality between segment loaders
this.mediaRequestsTimedout+=1;this.bandwidth=1;this.roundTrip=NaN;this.trigger('bandwidthupdate');this.trigger('timeout');}/**
   * Handle the callback from the segmentRequest function and set the
   * associated SegmentLoader state and errors if necessary
   *
   * @private
   */;_proto.segmentRequestFinished_=function segmentRequestFinished_(error,simpleSegment,result){// TODO handle special cases, e.g., muxed audio/video but only audio in the segment
// check the call queue directly since this function doesn't need to deal with any
// data, and can continue even if the source buffers are not set up and we didn't get
// any data from the segment
if(this.callQueue_.length){this.callQueue_.push(this.segmentRequestFinished_.bind(this,error,simpleSegment,result));return;}this.saveTransferStats_(simpleSegment.stats);// The request was aborted and the SegmentLoader has already been reset
if(!this.pendingSegment_){return;}// the request was aborted and the SegmentLoader has already started
// another request. this can happen when the timeout for an aborted
// request triggers due to a limitation in the XHR library
// do not count this as any sort of request or we risk double-counting
if(simpleSegment.requestId!==this.pendingSegment_.requestId){return;}// an error occurred from the active pendingSegment_ so reset everything
if(error){this.pendingSegment_=null;this.state='READY';// aborts are not a true error condition and nothing corrective needs to be done
if(error.code===REQUEST_ERRORS.ABORTED){return;}this.pause();// the error is really just that at least one of the requests timed-out
// set the bandwidth to a very low value and trigger an ABR switch to
// take emergency action
if(error.code===REQUEST_ERRORS.TIMEOUT){this.handleTimeout_();return;}// if control-flow has arrived here, then the error is real
// emit an error event to blacklist the current playlist
this.mediaRequestsErrored+=1;this.error(error);this.trigger('error');return;}var segmentInfo=this.pendingSegment_;// the response was a success so set any bandwidth stats the request
// generated for ABR purposes
this.saveBandwidthRelatedStats_(segmentInfo.duration,simpleSegment.stats);segmentInfo.endOfAllRequests=simpleSegment.endOfAllRequests;if(result.gopInfo){this.gopBuffer_=updateGopBuffer(this.gopBuffer_,result.gopInfo,this.safeAppend_);}// Although we may have already started appending on progress, we shouldn't switch the
// state away from loading until we are officially done loading the segment data.
this.state='APPENDING';// used for testing
this.trigger('appending');this.waitForAppendsToComplete_(segmentInfo);};_proto.setTimeMapping_=function setTimeMapping_(timeline){var timelineMapping=this.syncController_.mappingForTimeline(timeline);if(timelineMapping!==null){this.timeMapping_=timelineMapping;}};_proto.updateMediaSecondsLoaded_=function updateMediaSecondsLoaded_(segment){if(typeof segment.start==='number'&&typeof segment.end==='number'){this.mediaSecondsLoaded+=segment.end-segment.start;}else{this.mediaSecondsLoaded+=segment.duration;}};_proto.shouldUpdateTransmuxerTimestampOffset_=function shouldUpdateTransmuxerTimestampOffset_(timestampOffset){if(timestampOffset===null){return false;}// note that we're potentially using the same timestamp offset for both video and
// audio
if(this.loaderType_==='main'&&timestampOffset!==this.sourceUpdater_.videoTimestampOffset()){return true;}if(!this.audioDisabled_&&timestampOffset!==this.sourceUpdater_.audioTimestampOffset()){return true;}return false;};_proto.trueSegmentStart_=function trueSegmentStart_(_ref9){var currentStart=_ref9.currentStart,playlist=_ref9.playlist,mediaIndex=_ref9.mediaIndex,firstVideoFrameTimeForData=_ref9.firstVideoFrameTimeForData,currentVideoTimestampOffset=_ref9.currentVideoTimestampOffset,useVideoTimingInfo=_ref9.useVideoTimingInfo,videoTimingInfo=_ref9.videoTimingInfo,audioTimingInfo=_ref9.audioTimingInfo;if(typeof currentStart!=='undefined'){// if start was set once, keep using it
return currentStart;}if(!useVideoTimingInfo){return audioTimingInfo.start;}var previousSegment=playlist.segments[mediaIndex-1];// The start of a segment should be the start of the first full frame contained
// within that segment. Since the transmuxer maintains a cache of incomplete data
// from and/or the last frame seen, the start time may reflect a frame that starts
// in the previous segment. Check for that case and ensure the start time is
// accurate for the segment.
if(mediaIndex===0||!previousSegment||typeof previousSegment.start==='undefined'||previousSegment.end!==firstVideoFrameTimeForData+currentVideoTimestampOffset){return firstVideoFrameTimeForData;}return videoTimingInfo.start;};_proto.waitForAppendsToComplete_=function waitForAppendsToComplete_(segmentInfo){var trackInfo=this.getCurrentMediaInfo_(segmentInfo);if(!trackInfo){this.error({message:'No starting media returned, likely due to an unsupported media format.',blacklistDuration:Infinity});this.trigger('error');return;}// Although transmuxing is done, appends may not yet be finished. Throw a marker
// on each queue this loader is responsible for to ensure that the appends are
// complete.
var hasAudio=trackInfo.hasAudio,hasVideo=trackInfo.hasVideo,isMuxed=trackInfo.isMuxed;var waitForVideo=this.loaderType_==='main'&&hasVideo;var waitForAudio=!this.audioDisabled_&&hasAudio&&!isMuxed;segmentInfo.waitingOnAppends=0;// segments with no data
if(!segmentInfo.hasAppendedData_){if(!segmentInfo.timingInfo&&typeof segmentInfo.timestampOffset==='number'){// When there's no audio or video data in the segment, there's no audio or video
// timing information.
//
// If there's no audio or video timing information, then the timestamp offset
// can't be adjusted to the appropriate value for the transmuxer and source
// buffers.
//
// Therefore, the next segment should be used to set the timestamp offset.
this.isPendingTimestampOffset_=true;}// override settings for metadata only segments
segmentInfo.timingInfo={start:0};segmentInfo.waitingOnAppends++;if(!this.isPendingTimestampOffset_){// update the timestampoffset
this.updateSourceBufferTimestampOffset_(segmentInfo);// make sure the metadata queue is processed even though we have
// no video/audio data.
this.processMetadataQueue_();}// append is "done" instantly with no data.
this.checkAppendsDone_(segmentInfo);return;}// Since source updater could call back synchronously, do the increments first.
if(waitForVideo){segmentInfo.waitingOnAppends++;}if(waitForAudio){segmentInfo.waitingOnAppends++;}if(waitForVideo){this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this,segmentInfo));}if(waitForAudio){this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this,segmentInfo));}};_proto.checkAppendsDone_=function checkAppendsDone_(segmentInfo){if(this.checkForAbort_(segmentInfo.requestId)){return;}segmentInfo.waitingOnAppends--;if(segmentInfo.waitingOnAppends===0){this.handleAppendsDone_();}};_proto.checkForIllegalMediaSwitch=function checkForIllegalMediaSwitch(trackInfo){var illegalMediaSwitchError=illegalMediaSwitch(this.loaderType_,this.getCurrentMediaInfo_(),trackInfo);if(illegalMediaSwitchError){this.error({message:illegalMediaSwitchError,blacklistDuration:Infinity});this.trigger('error');return true;}return false;};_proto.updateSourceBufferTimestampOffset_=function updateSourceBufferTimestampOffset_(segmentInfo){if(segmentInfo.timestampOffset===null||// we don't yet have the start for whatever media type (video or audio) has
// priority, timing-wise, so we must wait
typeof segmentInfo.timingInfo.start!=='number'||// already updated the timestamp offset for this segment
segmentInfo.changedTimestampOffset||// the alt audio loader should not be responsible for setting the timestamp offset
this.loaderType_!=='main'){return;}var didChange=false;// Primary timing goes by video, and audio is trimmed in the transmuxer, meaning that
// the timing info here comes from video. In the event that the audio is longer than
// the video, this will trim the start of the audio.
// This also trims any offset from 0 at the beginning of the media
segmentInfo.timestampOffset-=this.getSegmentStartTimeForTimestampOffsetCalculation_({videoTimingInfo:segmentInfo.segment.videoTimingInfo,audioTimingInfo:segmentInfo.segment.audioTimingInfo,timingInfo:segmentInfo.timingInfo});// In the event that there are part segment downloads, each will try to update the
// timestamp offset. Retaining this bit of state prevents us from updating in the
// future (within the same segment), however, there may be a better way to handle it.
segmentInfo.changedTimestampOffset=true;if(segmentInfo.timestampOffset!==this.sourceUpdater_.videoTimestampOffset()){this.sourceUpdater_.videoTimestampOffset(segmentInfo.timestampOffset);didChange=true;}if(segmentInfo.timestampOffset!==this.sourceUpdater_.audioTimestampOffset()){this.sourceUpdater_.audioTimestampOffset(segmentInfo.timestampOffset);didChange=true;}if(didChange){this.trigger('timestampoffset');}};_proto.getSegmentStartTimeForTimestampOffsetCalculation_=function getSegmentStartTimeForTimestampOffsetCalculation_(_ref10){var videoTimingInfo=_ref10.videoTimingInfo,audioTimingInfo=_ref10.audioTimingInfo,timingInfo=_ref10.timingInfo;if(!this.useDtsForTimestampOffset_){return timingInfo.start;}if(videoTimingInfo&&typeof videoTimingInfo.transmuxedDecodeStart==='number'){return videoTimingInfo.transmuxedDecodeStart;}// handle audio only
if(audioTimingInfo&&typeof audioTimingInfo.transmuxedDecodeStart==='number'){return audioTimingInfo.transmuxedDecodeStart;}// handle content not transmuxed (e.g., MP4)
return timingInfo.start;};_proto.updateTimingInfoEnd_=function updateTimingInfoEnd_(segmentInfo){segmentInfo.timingInfo=segmentInfo.timingInfo||{};var trackInfo=this.getMediaInfo_();var useVideoTimingInfo=this.loaderType_==='main'&&trackInfo&&trackInfo.hasVideo;var prioritizedTimingInfo=useVideoTimingInfo&&segmentInfo.videoTimingInfo?segmentInfo.videoTimingInfo:segmentInfo.audioTimingInfo;if(!prioritizedTimingInfo){return;}segmentInfo.timingInfo.end=typeof prioritizedTimingInfo.end==='number'?// End time may not exist in a case where we aren't parsing the full segment (one
// current example is the case of fmp4), so use the rough duration to calculate an
// end time.
prioritizedTimingInfo.end:prioritizedTimingInfo.start+segmentInfo.duration;}/**
   * callback to run when appendBuffer is finished. detects if we are
   * in a good state to do things with the data we got, or if we need
   * to wait for more
   *
   * @private
   */;_proto.handleAppendsDone_=function handleAppendsDone_(){// appendsdone can cause an abort
if(this.pendingSegment_){this.trigger('appendsdone');}if(!this.pendingSegment_){this.state='READY';// TODO should this move into this.checkForAbort to speed up requests post abort in
// all appending cases?
if(!this.paused()){this.monitorBuffer_();}return;}var segmentInfo=this.pendingSegment_;// Now that the end of the segment has been reached, we can set the end time. It's
// best to wait until all appends are done so we're sure that the primary media is
// finished (and we have its end time).
this.updateTimingInfoEnd_(segmentInfo);if(this.shouldSaveSegmentTimingInfo_){// Timeline mappings should only be saved for the main loader. This is for multiple
// reasons:
//
// 1) Only one mapping is saved per timeline, meaning that if both the audio loader
//    and the main loader try to save the timeline mapping, whichever comes later
//    will overwrite the first. In theory this is OK, as the mappings should be the
//    same, however, it breaks for (2)
// 2) In the event of a live stream, the initial live point will make for a somewhat
//    arbitrary mapping. If audio and video streams are not perfectly in-sync, then
//    the mapping will be off for one of the streams, dependent on which one was
//    first saved (see (1)).
// 3) Primary timing goes by video in VHS, so the mapping should be video.
//
// Since the audio loader will wait for the main loader to load the first segment,
// the main loader will save the first timeline mapping, and ensure that there won't
// be a case where audio loads two segments without saving a mapping (thus leading
// to missing segment timing info).
this.syncController_.saveSegmentTimingInfo({segmentInfo:segmentInfo,shouldSaveTimelineMapping:this.loaderType_==='main'});}var segmentDurationMessage=getTroublesomeSegmentDurationMessage(segmentInfo,this.sourceType_);if(segmentDurationMessage){if(segmentDurationMessage.severity==='warn'){videojs.log.warn(segmentDurationMessage.message);}else{this.logger_(segmentDurationMessage.message);}}this.recordThroughput_(segmentInfo);this.pendingSegment_=null;this.state='READY';if(segmentInfo.isSyncRequest){this.trigger('syncinfoupdate');// if the sync request was not appended
// then it was not the correct segment.
// throw it away and use the data it gave us
// to get the correct one.
if(!segmentInfo.hasAppendedData_){this.logger_("Throwing away un-appended sync request "+segmentInfoString(segmentInfo));return;}}this.logger_("Appended "+segmentInfoString(segmentInfo));this.addSegmentMetadataCue_(segmentInfo);this.fetchAtBuffer_=true;if(this.currentTimeline_!==segmentInfo.timeline){this.timelineChangeController_.lastTimelineChange({type:this.loaderType_,from:this.currentTimeline_,to:segmentInfo.timeline});// If audio is not disabled, the main segment loader is responsible for updating
// the audio timeline as well. If the content is video only, this won't have any
// impact.
if(this.loaderType_==='main'&&!this.audioDisabled_){this.timelineChangeController_.lastTimelineChange({type:'audio',from:this.currentTimeline_,to:segmentInfo.timeline});}}this.currentTimeline_=segmentInfo.timeline;// We must update the syncinfo to recalculate the seekable range before
// the following conditional otherwise it may consider this a bad "guess"
// and attempt to resync when the post-update seekable window and live
// point would mean that this was the perfect segment to fetch
this.trigger('syncinfoupdate');var segment=segmentInfo.segment;var part=segmentInfo.part;var badSegmentGuess=segment.end&&this.currentTime_()-segment.end>segmentInfo.playlist.targetDuration*3;var badPartGuess=part&&part.end&&this.currentTime_()-part.end>segmentInfo.playlist.partTargetDuration*3;// If we previously appended a segment/part that ends more than 3 part/targetDurations before
// the currentTime_ that means that our conservative guess was too conservative.
// In that case, reset the loader state so that we try to use any information gained
// from the previous request to create a new, more accurate, sync-point.
if(badSegmentGuess||badPartGuess){this.logger_("bad "+(badSegmentGuess?'segment':'part')+" "+segmentInfoString(segmentInfo));this.resetEverything();return;}var isWalkingForward=this.mediaIndex!==null;// Don't do a rendition switch unless we have enough time to get a sync segment
// and conservatively guess
if(isWalkingForward){this.trigger('bandwidthupdate');}this.trigger('progress');this.mediaIndex=segmentInfo.mediaIndex;this.partIndex=segmentInfo.partIndex;// any time an update finishes and the last segment is in the
// buffer, end the stream. this ensures the "ended" event will
// fire if playback reaches that point.
if(this.isEndOfStream_(segmentInfo.mediaIndex,segmentInfo.playlist,segmentInfo.partIndex)){this.endOfStream();}// used for testing
this.trigger('appended');if(segmentInfo.hasAppendedData_){this.mediaAppends++;}if(!this.paused()){this.monitorBuffer_();}}/**
   * Records the current throughput of the decrypt, transmux, and append
   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
   * moving average of the throughput. `throughput.count` is the number of
   * data points in the average.
   *
   * @private
   * @param {Object} segmentInfo the object returned by loadSegment
   */;_proto.recordThroughput_=function recordThroughput_(segmentInfo){if(segmentInfo.duration<MIN_SEGMENT_DURATION_TO_SAVE_STATS){this.logger_("Ignoring segment's throughput because its duration of "+segmentInfo.duration+(" is less than the min to record "+MIN_SEGMENT_DURATION_TO_SAVE_STATS));return;}var rate=this.throughput.rate;// Add one to the time to ensure that we don't accidentally attempt to divide
// by zero in the case where the throughput is ridiculously high
var segmentProcessingTime=Date.now()-segmentInfo.endOfAllRequests+1;// Multiply by 8000 to convert from bytes/millisecond to bits/second
var segmentProcessingThroughput=Math.floor(segmentInfo.byteLength/segmentProcessingTime*8*1000);// This is just a cumulative moving average calculation:
//   newAvg = oldAvg + (sample - oldAvg) / (sampleCount + 1)
this.throughput.rate+=(segmentProcessingThroughput-rate)/++this.throughput.count;}/**
   * Adds a cue to the segment-metadata track with some metadata information about the
   * segment
   *
   * @private
   * @param {Object} segmentInfo
   *        the object returned by loadSegment
   * @method addSegmentMetadataCue_
   */;_proto.addSegmentMetadataCue_=function addSegmentMetadataCue_(segmentInfo){if(!this.segmentMetadataTrack_){return;}var segment=segmentInfo.segment;var start=segment.start;var end=segment.end;// Do not try adding the cue if the start and end times are invalid.
if(!finite(start)||!finite(end)){return;}removeCuesFromTrack(start,end,this.segmentMetadataTrack_);var Cue=(window_default()).WebKitDataCue||(window_default()).VTTCue;var value={custom:segment.custom,dateTimeObject:segment.dateTimeObject,dateTimeString:segment.dateTimeString,bandwidth:segmentInfo.playlist.attributes.BANDWIDTH,resolution:segmentInfo.playlist.attributes.RESOLUTION,codecs:segmentInfo.playlist.attributes.CODECS,byteLength:segmentInfo.byteLength,uri:segmentInfo.uri,timeline:segmentInfo.timeline,playlist:segmentInfo.playlist.id,start:start,end:end};var data=JSON.stringify(value);var cue=new Cue(start,end,data);// Attach the metadata to the value property of the cue to keep consistency between
// the differences of WebKitDataCue in safari and VTTCue in other browsers
cue.value=value;this.segmentMetadataTrack_.addCue(cue);};return SegmentLoader;}(videojs.EventTarget);function noop(){}var toTitleCase=function toTitleCase(string){if(typeof string!=='string'){return string;}return string.replace(/./,function(w){return w.toUpperCase();});};var bufferTypes=['video','audio'];var _updating=function updating(type,sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];return sourceBuffer&&sourceBuffer.updating||sourceUpdater.queuePending[type];};var nextQueueIndexOfType=function nextQueueIndexOfType(type,queue){for(var i=0;i<queue.length;i++){var queueEntry=queue[i];if(queueEntry.type==='mediaSource'){// If the next entry is a media source entry (uses multiple source buffers), block
// processing to allow it to go through first.
return null;}if(queueEntry.type===type){return i;}}return null;};var shiftQueue=function shiftQueue(type,sourceUpdater){if(sourceUpdater.queue.length===0){return;}var queueIndex=0;var queueEntry=sourceUpdater.queue[queueIndex];if(queueEntry.type==='mediaSource'){if(!sourceUpdater.updating()&&sourceUpdater.mediaSource.readyState!=='closed'){sourceUpdater.queue.shift();queueEntry.action(sourceUpdater);if(queueEntry.doneFn){queueEntry.doneFn();}// Only specific source buffer actions must wait for async updateend events. Media
// Source actions process synchronously. Therefore, both audio and video source
// buffers are now clear to process the next queue entries.
shiftQueue('audio',sourceUpdater);shiftQueue('video',sourceUpdater);}// Media Source actions require both source buffers, so if the media source action
// couldn't process yet (because one or both source buffers are busy), block other
// queue actions until both are available and the media source action can process.
return;}if(type==='mediaSource'){// If the queue was shifted by a media source action (this happens when pushing a
// media source action onto the queue), then it wasn't from an updateend event from an
// audio or video source buffer, so there's no change from previous state, and no
// processing should be done.
return;}// Media source queue entries don't need to consider whether the source updater is
// started (i.e., source buffers are created) as they don't need the source buffers, but
// source buffer queue entries do.
if(!sourceUpdater.ready()||sourceUpdater.mediaSource.readyState==='closed'||_updating(type,sourceUpdater)){return;}if(queueEntry.type!==type){queueIndex=nextQueueIndexOfType(type,sourceUpdater.queue);if(queueIndex===null){// Either there's no queue entry that uses this source buffer type in the queue, or
// there's a media source queue entry before the next entry of this type, in which
// case wait for that action to process first.
return;}queueEntry=sourceUpdater.queue[queueIndex];}sourceUpdater.queue.splice(queueIndex,1);// Keep a record that this source buffer type is in use.
//
// The queue pending operation must be set before the action is performed in the event
// that the action results in a synchronous event that is acted upon. For instance, if
// an exception is thrown that can be handled, it's possible that new actions will be
// appended to an empty queue and immediately executed, but would not have the correct
// pending information if this property was set after the action was performed.
sourceUpdater.queuePending[type]=queueEntry;queueEntry.action(type,sourceUpdater);if(!queueEntry.doneFn){// synchronous operation, process next entry
sourceUpdater.queuePending[type]=null;shiftQueue(type,sourceUpdater);return;}};var cleanupBuffer=function cleanupBuffer(type,sourceUpdater){var buffer=sourceUpdater[type+"Buffer"];var titleType=toTitleCase(type);if(!buffer){return;}buffer.removeEventListener('updateend',sourceUpdater["on"+titleType+"UpdateEnd_"]);buffer.removeEventListener('error',sourceUpdater["on"+titleType+"Error_"]);sourceUpdater.codecs[type]=null;sourceUpdater[type+"Buffer"]=null;};var inSourceBuffers=function inSourceBuffers(mediaSource,sourceBuffer){return mediaSource&&sourceBuffer&&Array.prototype.indexOf.call(mediaSource.sourceBuffers,sourceBuffer)!==-1;};var actions={appendBuffer:function appendBuffer(bytes,segmentInfo,onError){return function(type,sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}sourceUpdater.logger_("Appending segment "+segmentInfo.mediaIndex+"'s "+bytes.length+" bytes to "+type+"Buffer");try{sourceBuffer.appendBuffer(bytes);}catch(e){sourceUpdater.logger_("Error with code "+e.code+" "+(e.code===QUOTA_EXCEEDED_ERR?'(QUOTA_EXCEEDED_ERR) ':'')+("when appending segment "+segmentInfo.mediaIndex+" to "+type+"Buffer"));sourceUpdater.queuePending[type]=null;onError(e);}};},remove:function remove(start,end){return function(type,sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}sourceUpdater.logger_("Removing "+start+" to "+end+" from "+type+"Buffer");try{sourceBuffer.remove(start,end);}catch(e){sourceUpdater.logger_("Remove "+start+" to "+end+" from "+type+"Buffer failed");}};},timestampOffset:function timestampOffset(offset){return function(type,sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}sourceUpdater.logger_("Setting "+type+"timestampOffset to "+offset);sourceBuffer.timestampOffset=offset;};},callback:function callback(_callback){return function(type,sourceUpdater){_callback();};},endOfStream:function endOfStream(error){return function(sourceUpdater){if(sourceUpdater.mediaSource.readyState!=='open'){return;}sourceUpdater.logger_("Calling mediaSource endOfStream("+(error||'')+")");try{sourceUpdater.mediaSource.endOfStream(error);}catch(e){videojs.log.warn('Failed to call media source endOfStream',e);}};},duration:function duration(_duration){return function(sourceUpdater){sourceUpdater.logger_("Setting mediaSource duration to "+_duration);try{sourceUpdater.mediaSource.duration=_duration;}catch(e){videojs.log.warn('Failed to set media source duration',e);}};},abort:function abort(){return function(type,sourceUpdater){if(sourceUpdater.mediaSource.readyState!=='open'){return;}var sourceBuffer=sourceUpdater[type+"Buffer"];// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}sourceUpdater.logger_("calling abort on "+type+"Buffer");try{sourceBuffer.abort();}catch(e){videojs.log.warn("Failed to abort on "+type+"Buffer",e);}};},addSourceBuffer:function addSourceBuffer(type,codec){return function(sourceUpdater){var titleType=toTitleCase(type);var mime=getMimeForCodec(codec);sourceUpdater.logger_("Adding "+type+"Buffer with codec "+codec+" to mediaSource");var sourceBuffer=sourceUpdater.mediaSource.addSourceBuffer(mime);sourceBuffer.addEventListener('updateend',sourceUpdater["on"+titleType+"UpdateEnd_"]);sourceBuffer.addEventListener('error',sourceUpdater["on"+titleType+"Error_"]);sourceUpdater.codecs[type]=codec;sourceUpdater[type+"Buffer"]=sourceBuffer;};},removeSourceBuffer:function removeSourceBuffer(type){return function(sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];cleanupBuffer(type,sourceUpdater);// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}sourceUpdater.logger_("Removing "+type+"Buffer with codec "+sourceUpdater.codecs[type]+" from mediaSource");try{sourceUpdater.mediaSource.removeSourceBuffer(sourceBuffer);}catch(e){videojs.log.warn("Failed to removeSourceBuffer "+type+"Buffer",e);}};},changeType:function changeType(codec){return function(type,sourceUpdater){var sourceBuffer=sourceUpdater[type+"Buffer"];var mime=getMimeForCodec(codec);// can't do anything if the media source / source buffer is null
// or the media source does not contain this source buffer.
if(!inSourceBuffers(sourceUpdater.mediaSource,sourceBuffer)){return;}// do not update codec if we don't need to.
if(sourceUpdater.codecs[type]===codec){return;}sourceUpdater.logger_("changing "+type+"Buffer codec from "+sourceUpdater.codecs[type]+" to "+codec);// check if change to the provided type is supported
try{sourceBuffer.changeType(mime);sourceUpdater.codecs[type]=codec;}catch(e){videojs.log.warn("Failed to changeType on "+type+"Buffer",e);}};}};var pushQueue=function pushQueue(_ref){var type=_ref.type,sourceUpdater=_ref.sourceUpdater,action=_ref.action,doneFn=_ref.doneFn,name=_ref.name;sourceUpdater.queue.push({type:type,action:action,doneFn:doneFn,name:name});shiftQueue(type,sourceUpdater);};var onUpdateend=function onUpdateend(type,sourceUpdater){return function(e){// Although there should, in theory, be a pending action for any updateend receieved,
// there are some actions that may trigger updateend events without set definitions in
// the w3c spec. For instance, setting the duration on the media source may trigger
// updateend events on source buffers. This does not appear to be in the spec. As such,
// if we encounter an updateend without a corresponding pending action from our queue
// for that source buffer type, process the next action.
if(sourceUpdater.queuePending[type]){var doneFn=sourceUpdater.queuePending[type].doneFn;sourceUpdater.queuePending[type]=null;if(doneFn){// if there's an error, report it
doneFn(sourceUpdater[type+"Error_"]);}}shiftQueue(type,sourceUpdater);};};/**
 * A queue of callbacks to be serialized and applied when a
 * MediaSource and its associated SourceBuffers are not in the
 * updating state. It is used by the segment loader to update the
 * underlying SourceBuffers when new data is loaded, for instance.
 *
 * @class SourceUpdater
 * @param {MediaSource} mediaSource the MediaSource to create the SourceBuffer from
 * @param {string} mimeType the desired MIME type of the underlying SourceBuffer
 */var SourceUpdater=/*#__PURE__*/function(_videojs$EventTarget){_inheritsLoose(SourceUpdater,_videojs$EventTarget);function SourceUpdater(mediaSource){var _this;_this=_videojs$EventTarget.call(this)||this;_this.mediaSource=mediaSource;_this.sourceopenListener_=function(){return shiftQueue('mediaSource',_assertThisInitialized(_this));};_this.mediaSource.addEventListener('sourceopen',_this.sourceopenListener_);_this.logger_=logger('SourceUpdater');// initial timestamp offset is 0
_this.audioTimestampOffset_=0;_this.videoTimestampOffset_=0;_this.queue=[];_this.queuePending={audio:null,video:null};_this.delayedAudioAppendQueue_=[];_this.videoAppendQueued_=false;_this.codecs={};_this.onVideoUpdateEnd_=onUpdateend('video',_assertThisInitialized(_this));_this.onAudioUpdateEnd_=onUpdateend('audio',_assertThisInitialized(_this));_this.onVideoError_=function(e){// used for debugging
_this.videoError_=e;};_this.onAudioError_=function(e){// used for debugging
_this.audioError_=e;};_this.createdSourceBuffers_=false;_this.initializedEme_=false;_this.triggeredReady_=false;return _this;}var _proto=SourceUpdater.prototype;_proto.initializedEme=function initializedEme(){this.initializedEme_=true;this.triggerReady();};_proto.hasCreatedSourceBuffers=function hasCreatedSourceBuffers(){// if false, likely waiting on one of the segment loaders to get enough data to create
// source buffers
return this.createdSourceBuffers_;};_proto.hasInitializedAnyEme=function hasInitializedAnyEme(){return this.initializedEme_;};_proto.ready=function ready(){return this.hasCreatedSourceBuffers()&&this.hasInitializedAnyEme();};_proto.createSourceBuffers=function createSourceBuffers(codecs){if(this.hasCreatedSourceBuffers()){// already created them before
return;}// the intial addOrChangeSourceBuffers will always be
// two add buffers.
this.addOrChangeSourceBuffers(codecs);this.createdSourceBuffers_=true;this.trigger('createdsourcebuffers');this.triggerReady();};_proto.triggerReady=function triggerReady(){// only allow ready to be triggered once, this prevents the case
// where:
// 1. we trigger createdsourcebuffers
// 2. ie 11 synchronously initializates eme
// 3. the synchronous initialization causes us to trigger ready
// 4. We go back to the ready check in createSourceBuffers and ready is triggered again.
if(this.ready()&&!this.triggeredReady_){this.triggeredReady_=true;this.trigger('ready');}}/**
   * Add a type of source buffer to the media source.
   *
   * @param {string} type
   *        The type of source buffer to add.
   *
   * @param {string} codec
   *        The codec to add the source buffer with.
   */;_proto.addSourceBuffer=function addSourceBuffer(type,codec){pushQueue({type:'mediaSource',sourceUpdater:this,action:actions.addSourceBuffer(type,codec),name:'addSourceBuffer'});}/**
   * call abort on a source buffer.
   *
   * @param {string} type
   *        The type of source buffer to call abort on.
   */;_proto.abort=function abort(type){pushQueue({type:type,sourceUpdater:this,action:actions.abort(type),name:'abort'});}/**
   * Call removeSourceBuffer and remove a specific type
   * of source buffer on the mediaSource.
   *
   * @param {string} type
   *        The type of source buffer to remove.
   */;_proto.removeSourceBuffer=function removeSourceBuffer(type){if(!this.canRemoveSourceBuffer()){videojs.log.error('removeSourceBuffer is not supported!');return;}pushQueue({type:'mediaSource',sourceUpdater:this,action:actions.removeSourceBuffer(type),name:'removeSourceBuffer'});}/**
   * Whether or not the removeSourceBuffer function is supported
   * on the mediaSource.
   *
   * @return {boolean}
   *          if removeSourceBuffer can be called.
   */;_proto.canRemoveSourceBuffer=function canRemoveSourceBuffer(){// IE reports that it supports removeSourceBuffer, but often throws
// errors when attempting to use the function. So we report that it
// does not support removeSourceBuffer. As of Firefox 83 removeSourceBuffer
// throws errors, so we report that it does not support this as well.
return!videojs.browser.IE_VERSION&&!videojs.browser.IS_FIREFOX&&(window_default()).MediaSource&&(window_default()).MediaSource.prototype&&typeof (window_default()).MediaSource.prototype.removeSourceBuffer==='function';}/**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */;SourceUpdater.canChangeType=function canChangeType(){return (window_default()).SourceBuffer&&(window_default()).SourceBuffer.prototype&&typeof (window_default()).SourceBuffer.prototype.changeType==='function';}/**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */;_proto.canChangeType=function canChangeType(){return this.constructor.canChangeType();}/**
   * Call the changeType function on a source buffer, given the code and type.
   *
   * @param {string} type
   *        The type of source buffer to call changeType on.
   *
   * @param {string} codec
   *        The codec string to change type with on the source buffer.
   */;_proto.changeType=function changeType(type,codec){if(!this.canChangeType()){videojs.log.error('changeType is not supported!');return;}pushQueue({type:type,sourceUpdater:this,action:actions.changeType(codec),name:'changeType'});}/**
   * Add source buffers with a codec or, if they are already created,
   * call changeType on source buffers using changeType.
   *
   * @param {Object} codecs
   *        Codecs to switch to
   */;_proto.addOrChangeSourceBuffers=function addOrChangeSourceBuffers(codecs){var _this2=this;if(!codecs||video_es_typeof(codecs)!=='object'||Object.keys(codecs).length===0){throw new Error('Cannot addOrChangeSourceBuffers to undefined codecs');}Object.keys(codecs).forEach(function(type){var codec=codecs[type];if(!_this2.hasCreatedSourceBuffers()){return _this2.addSourceBuffer(type,codec);}if(_this2.canChangeType()){_this2.changeType(type,codec);}});}/**
   * Queue an update to append an ArrayBuffer.
   *
   * @param {MediaObject} object containing audioBytes and/or videoBytes
   * @param {Function} done the function to call when done
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
   */;_proto.appendBuffer=function appendBuffer(options,doneFn){var _this3=this;var segmentInfo=options.segmentInfo,type=options.type,bytes=options.bytes;this.processedAppend_=true;if(type==='audio'&&this.videoBuffer&&!this.videoAppendQueued_){this.delayedAudioAppendQueue_.push([options,doneFn]);this.logger_("delayed audio append of "+bytes.length+" until video append");return;}// In the case of certain errors, for instance, QUOTA_EXCEEDED_ERR, updateend will
// not be fired. This means that the queue will be blocked until the next action
// taken by the segment-loader. Provide a mechanism for segment-loader to handle
// these errors by calling the doneFn with the specific error.
var onError=doneFn;pushQueue({type:type,sourceUpdater:this,action:actions.appendBuffer(bytes,segmentInfo||{mediaIndex:-1},onError),doneFn:doneFn,name:'appendBuffer'});if(type==='video'){this.videoAppendQueued_=true;if(!this.delayedAudioAppendQueue_.length){return;}var queue=this.delayedAudioAppendQueue_.slice();this.logger_("queuing delayed audio "+queue.length+" appendBuffers");this.delayedAudioAppendQueue_.length=0;queue.forEach(function(que){_this3.appendBuffer.apply(_this3,que);});}}/**
   * Get the audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The audio buffer's buffered time range
   */;_proto.audioBuffered=function audioBuffered(){// no media source/source buffer or it isn't in the media sources
// source buffer list
if(!inSourceBuffers(this.mediaSource,this.audioBuffer)){return videojs.createTimeRange();}return this.audioBuffer.buffered?this.audioBuffer.buffered:videojs.createTimeRange();}/**
   * Get the video buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The video buffer's buffered time range
   */;_proto.videoBuffered=function videoBuffered(){// no media source/source buffer or it isn't in the media sources
// source buffer list
if(!inSourceBuffers(this.mediaSource,this.videoBuffer)){return videojs.createTimeRange();}return this.videoBuffer.buffered?this.videoBuffer.buffered:videojs.createTimeRange();}/**
   * Get a combined video/audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         the combined time range
   */;_proto.buffered=function buffered(){var video=inSourceBuffers(this.mediaSource,this.videoBuffer)?this.videoBuffer:null;var audio=inSourceBuffers(this.mediaSource,this.audioBuffer)?this.audioBuffer:null;if(audio&&!video){return this.audioBuffered();}if(video&&!audio){return this.videoBuffered();}return bufferIntersection(this.audioBuffered(),this.videoBuffered());}/**
   * Add a callback to the queue that will set duration on the mediaSource.
   *
   * @param {number} duration
   *        The duration to set
   *
   * @param {Function} [doneFn]
   *        function to run after duration has been set.
   */;_proto.setDuration=function setDuration(duration,doneFn){if(doneFn===void 0){doneFn=noop;}// In order to set the duration on the media source, it's necessary to wait for all
// source buffers to no longer be updating. "If the updating attribute equals true on
// any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
// abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
pushQueue({type:'mediaSource',sourceUpdater:this,action:actions.duration(duration),name:'duration',doneFn:doneFn});}/**
   * Add a mediaSource endOfStream call to the queue
   *
   * @param {Error} [error]
   *        Call endOfStream with an error
   *
   * @param {Function} [doneFn]
   *        A function that should be called when the
   *        endOfStream call has finished.
   */;_proto.endOfStream=function endOfStream(error,doneFn){if(error===void 0){error=null;}if(doneFn===void 0){doneFn=noop;}if(typeof error!=='string'){error=undefined;}// In order to set the duration on the media source, it's necessary to wait for all
// source buffers to no longer be updating. "If the updating attribute equals true on
// any SourceBuffer in sourceBuffers, then throw an InvalidStateError exception and
// abort these steps." (source: https://www.w3.org/TR/media-source/#attributes).
pushQueue({type:'mediaSource',sourceUpdater:this,action:actions.endOfStream(error),name:'endOfStream',doneFn:doneFn});}/**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */;_proto.removeAudio=function removeAudio(start,end,done){if(done===void 0){done=noop;}if(!this.audioBuffered().length||this.audioBuffered().end(0)===0){done();return;}pushQueue({type:'audio',sourceUpdater:this,action:actions.remove(start,end),doneFn:done,name:'remove'});}/**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */;_proto.removeVideo=function removeVideo(start,end,done){if(done===void 0){done=noop;}if(!this.videoBuffered().length||this.videoBuffered().end(0)===0){done();return;}pushQueue({type:'video',sourceUpdater:this,action:actions.remove(start,end),doneFn:done,name:'remove'});}/**
   * Whether the underlying sourceBuffer is updating or not
   *
   * @return {boolean} the updating status of the SourceBuffer
   */;_proto.updating=function updating(){// the audio/video source buffer is updating
if(_updating('audio',this)||_updating('video',this)){return true;}return false;}/**
   * Set/get the timestampoffset on the audio SourceBuffer
   *
   * @return {number} the timestamp offset
   */;_proto.audioTimestampOffset=function audioTimestampOffset(offset){if(typeof offset!=='undefined'&&this.audioBuffer&&// no point in updating if it's the same
this.audioTimestampOffset_!==offset){pushQueue({type:'audio',sourceUpdater:this,action:actions.timestampOffset(offset),name:'timestampOffset'});this.audioTimestampOffset_=offset;}return this.audioTimestampOffset_;}/**
   * Set/get the timestampoffset on the video SourceBuffer
   *
   * @return {number} the timestamp offset
   */;_proto.videoTimestampOffset=function videoTimestampOffset(offset){if(typeof offset!=='undefined'&&this.videoBuffer&&// no point in updating if it's the same
this.videoTimestampOffset!==offset){pushQueue({type:'video',sourceUpdater:this,action:actions.timestampOffset(offset),name:'timestampOffset'});this.videoTimestampOffset_=offset;}return this.videoTimestampOffset_;}/**
   * Add a function to the queue that will be called
   * when it is its turn to run in the audio queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */;_proto.audioQueueCallback=function audioQueueCallback(callback){if(!this.audioBuffer){return;}pushQueue({type:'audio',sourceUpdater:this,action:actions.callback(callback),name:'callback'});}/**
   * Add a function to the queue that will be called
   * when it is its turn to run in the video queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */;_proto.videoQueueCallback=function videoQueueCallback(callback){if(!this.videoBuffer){return;}pushQueue({type:'video',sourceUpdater:this,action:actions.callback(callback),name:'callback'});}/**
   * dispose of the source updater and the underlying sourceBuffer
   */;_proto.dispose=function dispose(){var _this4=this;this.trigger('dispose');bufferTypes.forEach(function(type){_this4.abort(type);if(_this4.canRemoveSourceBuffer()){_this4.removeSourceBuffer(type);}else{_this4[type+"QueueCallback"](function(){return cleanupBuffer(type,_this4);});}});this.videoAppendQueued_=false;this.delayedAudioAppendQueue_.length=0;if(this.sourceopenListener_){this.mediaSource.removeEventListener('sourceopen',this.sourceopenListener_);}this.off();};return SourceUpdater;}(videojs.EventTarget);var uint8ToUtf8=function uint8ToUtf8(uintArray){return decodeURIComponent(escape(String.fromCharCode.apply(null,uintArray)));};var VTT_LINE_TERMINATORS=new Uint8Array('\n\n'.split('').map(function(_char3){return _char3.charCodeAt(0);}));var NoVttJsError=/*#__PURE__*/function(_Error){_inheritsLoose(NoVttJsError,_Error);function NoVttJsError(){return _Error.call(this,'Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.')||this;}return NoVttJsError;}(/*#__PURE__*/_wrapNativeSuper(Error));/**
 * An object that manages segment loading and appending.
 *
 * @class VTTSegmentLoader
 * @param {Object} options required and optional options
 * @extends videojs.EventTarget
 */var VTTSegmentLoader=/*#__PURE__*/function(_SegmentLoader){_inheritsLoose(VTTSegmentLoader,_SegmentLoader);function VTTSegmentLoader(settings,options){var _this;if(options===void 0){options={};}_this=_SegmentLoader.call(this,settings,options)||this;// SegmentLoader requires a MediaSource be specified or it will throw an error;
// however, VTTSegmentLoader has no need of a media source, so delete the reference
_this.mediaSource_=null;_this.subtitlesTrack_=null;_this.loaderType_='subtitle';_this.featuresNativeTextTracks_=settings.featuresNativeTextTracks;_this.loadVttJs=settings.loadVttJs;// The VTT segment will have its own time mappings. Saving VTT segment timing info in
// the sync controller leads to improper behavior.
_this.shouldSaveSegmentTimingInfo_=false;return _this;}var _proto=VTTSegmentLoader.prototype;_proto.createTransmuxer_=function createTransmuxer_(){// don't need to transmux any subtitles
return null;}/**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */;_proto.buffered_=function buffered_(){if(!this.subtitlesTrack_||!this.subtitlesTrack_.cues||!this.subtitlesTrack_.cues.length){return videojs.createTimeRanges();}var cues=this.subtitlesTrack_.cues;var start=cues[0].startTime;var end=cues[cues.length-1].startTime;return videojs.createTimeRanges([[start,end]]);}/**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */;_proto.initSegmentForMap=function initSegmentForMap(map,set){if(set===void 0){set=false;}if(!map){return null;}var id=initSegmentId(map);var storedMap=this.initSegments_[id];if(set&&!storedMap&&map.bytes){// append WebVTT line terminators to the media initialization segment if it exists
// to follow the WebVTT spec (https://w3c.github.io/webvtt/#file-structure) that
// requires two or more WebVTT line terminators between the WebVTT header and the
// rest of the file
var combinedByteLength=VTT_LINE_TERMINATORS.byteLength+map.bytes.byteLength;var combinedSegment=new Uint8Array(combinedByteLength);combinedSegment.set(map.bytes);combinedSegment.set(VTT_LINE_TERMINATORS,map.bytes.byteLength);this.initSegments_[id]=storedMap={resolvedUri:map.resolvedUri,byterange:map.byterange,bytes:combinedSegment};}return storedMap||map;}/**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */;_proto.couldBeginLoading_=function couldBeginLoading_(){return this.playlist_&&this.subtitlesTrack_&&!this.paused();}/**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */;_proto.init_=function init_(){this.state='READY';this.resetEverything();return this.monitorBuffer_();}/**
   * Set a subtitle track on the segment loader to add subtitles to
   *
   * @param {TextTrack=} track
   *        The text track to add loaded subtitles to
   * @return {TextTrack}
   *        Returns the subtitles track
   */;_proto.track=function track(_track){if(typeof _track==='undefined'){return this.subtitlesTrack_;}this.subtitlesTrack_=_track;// if we were unpaused but waiting for a sourceUpdater, start
// buffering now
if(this.state==='INIT'&&this.couldBeginLoading_()){this.init_();}return this.subtitlesTrack_;}/**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   */;_proto.remove=function remove(start,end){removeCuesFromTrack(start,end,this.subtitlesTrack_);}/**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */;_proto.fillBuffer_=function fillBuffer_(){var _this2=this;// see if we need to begin loading immediately
var segmentInfo=this.chooseNextRequest_();if(!segmentInfo){return;}if(this.syncController_.timestampOffsetForTimeline(segmentInfo.timeline)===null){// We don't have the timestamp offset that we need to sync subtitles.
// Rerun on a timestamp offset or user interaction.
var checkTimestampOffset=function checkTimestampOffset(){_this2.state='READY';if(!_this2.paused()){// if not paused, queue a buffer check as soon as possible
_this2.monitorBuffer_();}};this.syncController_.one('timestampoffset',checkTimestampOffset);this.state='WAITING_ON_TIMELINE';return;}this.loadSegment_(segmentInfo);}// never set a timestamp offset for vtt segments.
;_proto.timestampOffsetForSegment_=function timestampOffsetForSegment_(){return null;};_proto.chooseNextRequest_=function chooseNextRequest_(){return this.skipEmptySegments_(_SegmentLoader.prototype.chooseNextRequest_.call(this));}/**
   * Prevents the segment loader from requesting segments we know contain no subtitles
   * by walking forward until we find the next segment that we don't know whether it is
   * empty or not.
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @return {Object}
   *         a segment info object that describes the current segment
   */;_proto.skipEmptySegments_=function skipEmptySegments_(segmentInfo){while(segmentInfo&&segmentInfo.segment.empty){// stop at the last possible segmentInfo
if(segmentInfo.mediaIndex+1>=segmentInfo.playlist.segments.length){segmentInfo=null;break;}segmentInfo=this.generateSegmentInfo_({playlist:segmentInfo.playlist,mediaIndex:segmentInfo.mediaIndex+1,startOfSegment:segmentInfo.startOfSegment+segmentInfo.duration,isSyncRequest:segmentInfo.isSyncRequest});}return segmentInfo;};_proto.stopForError=function stopForError(error){this.error(error);this.state='READY';this.pause();this.trigger('error');}/**
   * append a decrypted segement to the SourceBuffer through a SourceUpdater
   *
   * @private
   */;_proto.segmentRequestFinished_=function segmentRequestFinished_(error,simpleSegment,result){var _this3=this;if(!this.subtitlesTrack_){this.state='READY';return;}this.saveTransferStats_(simpleSegment.stats);// the request was aborted
if(!this.pendingSegment_){this.state='READY';this.mediaRequestsAborted+=1;return;}if(error){if(error.code===REQUEST_ERRORS.TIMEOUT){this.handleTimeout_();}if(error.code===REQUEST_ERRORS.ABORTED){this.mediaRequestsAborted+=1;}else{this.mediaRequestsErrored+=1;}this.stopForError(error);return;}var segmentInfo=this.pendingSegment_;// although the VTT segment loader bandwidth isn't really used, it's good to
// maintain functionality between segment loaders
this.saveBandwidthRelatedStats_(segmentInfo.duration,simpleSegment.stats);// if this request included a segment key, save that data in the cache
if(simpleSegment.key){this.segmentKey(simpleSegment.key,true);}this.state='APPENDING';// used for tests
this.trigger('appending');var segment=segmentInfo.segment;if(segment.map){segment.map.bytes=simpleSegment.map.bytes;}segmentInfo.bytes=simpleSegment.bytes;// Make sure that vttjs has loaded, otherwise, load it and wait till it finished loading
if(typeof (window_default()).WebVTT!=='function'&&typeof this.loadVttJs==='function'){this.state='WAITING_ON_VTTJS';// should be fine to call multiple times
// script will be loaded once but multiple listeners will be added to the queue, which is expected.
this.loadVttJs().then(function(){return _this3.segmentRequestFinished_(error,simpleSegment,result);},function(){return _this3.stopForError({message:'Error loading vtt.js'});});return;}segment.requested=true;try{this.parseVTTCues_(segmentInfo);}catch(e){this.stopForError({message:e.message});return;}this.updateTimeMapping_(segmentInfo,this.syncController_.timelines[segmentInfo.timeline],this.playlist_);if(segmentInfo.cues.length){segmentInfo.timingInfo={start:segmentInfo.cues[0].startTime,end:segmentInfo.cues[segmentInfo.cues.length-1].endTime};}else{segmentInfo.timingInfo={start:segmentInfo.startOfSegment,end:segmentInfo.startOfSegment+segmentInfo.duration};}if(segmentInfo.isSyncRequest){this.trigger('syncinfoupdate');this.pendingSegment_=null;this.state='READY';return;}segmentInfo.byteLength=segmentInfo.bytes.byteLength;this.mediaSecondsLoaded+=segment.duration;// Create VTTCue instances for each cue in the new segment and add them to
// the subtitle track
segmentInfo.cues.forEach(function(cue){_this3.subtitlesTrack_.addCue(_this3.featuresNativeTextTracks_?new (window_default()).VTTCue(cue.startTime,cue.endTime,cue.text):cue);});// Remove any duplicate cues from the subtitle track. The WebVTT spec allows
// cues to have identical time-intervals, but if the text is also identical
// we can safely assume it is a duplicate that can be removed (ex. when a cue
// "overlaps" VTT segments)
removeDuplicateCuesFromTrack(this.subtitlesTrack_);this.handleAppendsDone_();};_proto.handleData_=function handleData_(){// noop as we shouldn't be getting video/audio data captions
// that we do not support here.
};_proto.updateTimingInfoEnd_=function updateTimingInfoEnd_(){// noop
}/**
   * Uses the WebVTT parser to parse the segment response
   *
   * @throws NoVttJsError
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @private
   */;_proto.parseVTTCues_=function parseVTTCues_(segmentInfo){var decoder;var decodeBytesToString=false;if(typeof (window_default()).WebVTT!=='function'){// caller is responsible for exception handling.
throw new NoVttJsError();}if(typeof (window_default()).TextDecoder==='function'){decoder=new (window_default()).TextDecoder('utf8');}else{decoder=window_default().WebVTT.StringDecoder();decodeBytesToString=true;}var parser=new (window_default()).WebVTT.Parser((window_default()),(window_default()).vttjs,decoder);segmentInfo.cues=[];segmentInfo.timestampmap={MPEGTS:0,LOCAL:0};parser.oncue=segmentInfo.cues.push.bind(segmentInfo.cues);parser.ontimestampmap=function(map){segmentInfo.timestampmap=map;};parser.onparsingerror=function(error){videojs.log.warn('Error encountered when parsing cues: '+error.message);};if(segmentInfo.segment.map){var mapData=segmentInfo.segment.map.bytes;if(decodeBytesToString){mapData=uint8ToUtf8(mapData);}parser.parse(mapData);}var segmentData=segmentInfo.bytes;if(decodeBytesToString){segmentData=uint8ToUtf8(segmentData);}parser.parse(segmentData);parser.flush();}/**
   * Updates the start and end times of any cues parsed by the WebVTT parser using
   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
   * from the SyncController
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @param {Object} mappingObj
   *        object containing a mapping from TS to media time
   * @param {Object} playlist
   *        the playlist object containing the segment
   * @private
   */;_proto.updateTimeMapping_=function updateTimeMapping_(segmentInfo,mappingObj,playlist){var segment=segmentInfo.segment;if(!mappingObj){// If the sync controller does not have a mapping of TS to Media Time for the
// timeline, then we don't have enough information to update the cue
// start/end times
return;}if(!segmentInfo.cues.length){// If there are no cues, we also do not have enough information to figure out
// segment timing. Mark that the segment contains no cues so we don't re-request
// an empty segment.
segment.empty=true;return;}var timestampmap=segmentInfo.timestampmap;var diff=timestampmap.MPEGTS/clock.ONE_SECOND_IN_TS-timestampmap.LOCAL+mappingObj.mapping;segmentInfo.cues.forEach(function(cue){// First convert cue time to TS time using the timestamp-map provided within the vtt
cue.startTime+=diff;cue.endTime+=diff;});if(!playlist.syncInfo){var firstStart=segmentInfo.cues[0].startTime;var lastStart=segmentInfo.cues[segmentInfo.cues.length-1].startTime;playlist.syncInfo={mediaSequence:playlist.mediaSequence+segmentInfo.mediaIndex,time:Math.min(firstStart,lastStart-segment.duration)};}};return VTTSegmentLoader;}(SegmentLoader);/**
 * @file ad-cue-tags.js
 */ /**
 * Searches for an ad cue that overlaps with the given mediaTime
 *
 * @param {Object} track
 *        the track to find the cue for
 *
 * @param {number} mediaTime
 *        the time to find the cue at
 *
 * @return {Object|null}
 *         the found cue or null
 */var findAdCue=function findAdCue(track,mediaTime){var cues=track.cues;for(var i=0;i<cues.length;i++){var cue=cues[i];if(mediaTime>=cue.adStartTime&&mediaTime<=cue.adEndTime){return cue;}}return null;};var updateAdCues=function updateAdCues(media,track,offset){if(offset===void 0){offset=0;}if(!media.segments){return;}var mediaTime=offset;var cue;for(var i=0;i<media.segments.length;i++){var segment=media.segments[i];if(!cue){// Since the cues will span for at least the segment duration, adding a fudge
// factor of half segment duration will prevent duplicate cues from being
// created when timing info is not exact (e.g. cue start time initialized
// at 10.006677, but next call mediaTime is 10.003332 )
cue=findAdCue(track,mediaTime+segment.duration/2);}if(cue){if('cueIn'in segment){// Found a CUE-IN so end the cue
cue.endTime=mediaTime;cue.adEndTime=mediaTime;mediaTime+=segment.duration;cue=null;continue;}if(mediaTime<cue.endTime){// Already processed this mediaTime for this cue
mediaTime+=segment.duration;continue;}// otherwise extend cue until a CUE-IN is found
cue.endTime+=segment.duration;}else{if('cueOut'in segment){cue=new (window_default()).VTTCue(mediaTime,mediaTime+segment.duration,segment.cueOut);cue.adStartTime=mediaTime;// Assumes tag format to be
// #EXT-X-CUE-OUT:30
cue.adEndTime=mediaTime+parseFloat(segment.cueOut);track.addCue(cue);}if('cueOutCont'in segment){// Entered into the middle of an ad cue
// Assumes tag formate to be
// #EXT-X-CUE-OUT-CONT:10/30
var _segment$cueOutCont$s=segment.cueOutCont.split('/').map(parseFloat),adOffset=_segment$cueOutCont$s[0],adTotal=_segment$cueOutCont$s[1];cue=new (window_default()).VTTCue(mediaTime,mediaTime+segment.duration,'');cue.adStartTime=mediaTime-adOffset;cue.adEndTime=cue.adStartTime+adTotal;track.addCue(cue);}}mediaTime+=segment.duration;}};// synchronize expired playlist segments.
// the max media sequence diff is 48 hours of live stream
// content with two second segments. Anything larger than that
// will likely be invalid.
var MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC=86400;var syncPointStrategies=[// Stategy "VOD": Handle the VOD-case where the sync-point is *always*
//                the equivalence display-time 0 === segment-index 0
{name:'VOD',run:function run(syncController,playlist,duration,currentTimeline,currentTime){if(duration!==Infinity){var syncPoint={time:0,segmentIndex:0,partIndex:null};return syncPoint;}return null;}},// Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
{name:'ProgramDateTime',run:function run(syncController,playlist,duration,currentTimeline,currentTime){if(!Object.keys(syncController.timelineToDatetimeMappings).length){return null;}var syncPoint=null;var lastDistance=null;var partsAndSegments=getPartsAndSegments(playlist);currentTime=currentTime||0;for(var i=0;i<partsAndSegments.length;i++){// start from the end and loop backwards for live
// or start from the front and loop forwards for non-live
var index=playlist.endList||currentTime===0?i:partsAndSegments.length-(i+1);var partAndSegment=partsAndSegments[index];var segment=partAndSegment.segment;var datetimeMapping=syncController.timelineToDatetimeMappings[segment.timeline];if(!datetimeMapping||!segment.dateTimeObject){continue;}var segmentTime=segment.dateTimeObject.getTime()/1000;var start=segmentTime+datetimeMapping;// take part duration into account.
if(segment.parts&&typeof partAndSegment.partIndex==='number'){for(var z=0;z<partAndSegment.partIndex;z++){start+=segment.parts[z].duration;}}var distance=Math.abs(currentTime-start);// Once the distance begins to increase, or if distance is 0, we have passed
// currentTime and can stop looking for better candidates
if(lastDistance!==null&&(distance===0||lastDistance<distance)){break;}lastDistance=distance;syncPoint={time:start,segmentIndex:partAndSegment.segmentIndex,partIndex:partAndSegment.partIndex};}return syncPoint;}},// Stategy "Segment": We have a known time mapping for a timeline and a
//                    segment in the current timeline with timing data
{name:'Segment',run:function run(syncController,playlist,duration,currentTimeline,currentTime){var syncPoint=null;var lastDistance=null;currentTime=currentTime||0;var partsAndSegments=getPartsAndSegments(playlist);for(var i=0;i<partsAndSegments.length;i++){// start from the end and loop backwards for live
// or start from the front and loop forwards for non-live
var index=playlist.endList||currentTime===0?i:partsAndSegments.length-(i+1);var partAndSegment=partsAndSegments[index];var segment=partAndSegment.segment;var start=partAndSegment.part&&partAndSegment.part.start||segment&&segment.start;if(segment.timeline===currentTimeline&&typeof start!=='undefined'){var distance=Math.abs(currentTime-start);// Once the distance begins to increase, we have passed
// currentTime and can stop looking for better candidates
if(lastDistance!==null&&lastDistance<distance){break;}if(!syncPoint||lastDistance===null||lastDistance>=distance){lastDistance=distance;syncPoint={time:start,segmentIndex:partAndSegment.segmentIndex,partIndex:partAndSegment.partIndex};}}}return syncPoint;}},// Stategy "Discontinuity": We have a discontinuity with a known
//                          display-time
{name:'Discontinuity',run:function run(syncController,playlist,duration,currentTimeline,currentTime){var syncPoint=null;currentTime=currentTime||0;if(playlist.discontinuityStarts&&playlist.discontinuityStarts.length){var lastDistance=null;for(var i=0;i<playlist.discontinuityStarts.length;i++){var segmentIndex=playlist.discontinuityStarts[i];var discontinuity=playlist.discontinuitySequence+i+1;var discontinuitySync=syncController.discontinuities[discontinuity];if(discontinuitySync){var distance=Math.abs(currentTime-discontinuitySync.time);// Once the distance begins to increase, we have passed
// currentTime and can stop looking for better candidates
if(lastDistance!==null&&lastDistance<distance){break;}if(!syncPoint||lastDistance===null||lastDistance>=distance){lastDistance=distance;syncPoint={time:discontinuitySync.time,segmentIndex:segmentIndex,partIndex:null};}}}}return syncPoint;}},// Stategy "Playlist": We have a playlist with a known mapping of
//                     segment index to display time
{name:'Playlist',run:function run(syncController,playlist,duration,currentTimeline,currentTime){if(playlist.syncInfo){var syncPoint={time:playlist.syncInfo.time,segmentIndex:playlist.syncInfo.mediaSequence-playlist.mediaSequence,partIndex:null};return syncPoint;}return null;}}];var SyncController=/*#__PURE__*/function(_videojs$EventTarget){_inheritsLoose(SyncController,_videojs$EventTarget);function SyncController(options){var _this;_this=_videojs$EventTarget.call(this)||this;// ...for synching across variants
_this.timelines=[];_this.discontinuities=[];_this.timelineToDatetimeMappings={};_this.logger_=logger('SyncController');return _this;}/**
   * Find a sync-point for the playlist specified
   *
   * A sync-point is defined as a known mapping from display-time to
   * a segment-index in the current playlist.
   *
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinite if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @return {Object}
   *          A sync-point object
   */var _proto=SyncController.prototype;_proto.getSyncPoint=function getSyncPoint(playlist,duration,currentTimeline,currentTime){var syncPoints=this.runStrategies_(playlist,duration,currentTimeline,currentTime);if(!syncPoints.length){// Signal that we need to attempt to get a sync-point manually
// by fetching a segment in the playlist and constructing
// a sync-point from that information
return null;}// Now find the sync-point that is closest to the currentTime because
// that should result in the most accurate guess about which segment
// to fetch
return this.selectSyncPoint_(syncPoints,{key:'time',value:currentTime});}/**
   * Calculate the amount of time that has expired off the playlist during playback
   *
   * @param {Playlist} playlist
   *        Playlist object to calculate expired from
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playling a live source)
   * @return {number|null}
   *          The amount of time that has expired off the playlist during playback. Null
   *          if no sync-points for the playlist can be found.
   */;_proto.getExpiredTime=function getExpiredTime(playlist,duration){if(!playlist||!playlist.segments){return null;}var syncPoints=this.runStrategies_(playlist,duration,playlist.discontinuitySequence,0);// Without sync-points, there is not enough information to determine the expired time
if(!syncPoints.length){return null;}var syncPoint=this.selectSyncPoint_(syncPoints,{key:'segmentIndex',value:0});// If the sync-point is beyond the start of the playlist, we want to subtract the
// duration from index 0 to syncPoint.segmentIndex instead of adding.
if(syncPoint.segmentIndex>0){syncPoint.time*=-1;}return Math.abs(syncPoint.time+sumDurations({defaultDuration:playlist.targetDuration,durationList:playlist.segments,startIndex:syncPoint.segmentIndex,endIndex:0}));}/**
   * Runs each sync-point strategy and returns a list of sync-points returned by the
   * strategies
   *
   * @private
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @return {Array}
   *          A list of sync-point objects
   */;_proto.runStrategies_=function runStrategies_(playlist,duration,currentTimeline,currentTime){var syncPoints=[];// Try to find a sync-point in by utilizing various strategies...
for(var i=0;i<syncPointStrategies.length;i++){var strategy=syncPointStrategies[i];var syncPoint=strategy.run(this,playlist,duration,currentTimeline,currentTime);if(syncPoint){syncPoint.strategy=strategy.name;syncPoints.push({strategy:strategy.name,syncPoint:syncPoint});}}return syncPoints;}/**
   * Selects the sync-point nearest the specified target
   *
   * @private
   * @param {Array} syncPoints
   *        List of sync-points to select from
   * @param {Object} target
   *        Object specifying the property and value we are targeting
   * @param {string} target.key
   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
   * @param {number} target.value
   *        The value to target for the specified key.
   * @return {Object}
   *          The sync-point nearest the target
   */;_proto.selectSyncPoint_=function selectSyncPoint_(syncPoints,target){var bestSyncPoint=syncPoints[0].syncPoint;var bestDistance=Math.abs(syncPoints[0].syncPoint[target.key]-target.value);var bestStrategy=syncPoints[0].strategy;for(var i=1;i<syncPoints.length;i++){var newDistance=Math.abs(syncPoints[i].syncPoint[target.key]-target.value);if(newDistance<bestDistance){bestDistance=newDistance;bestSyncPoint=syncPoints[i].syncPoint;bestStrategy=syncPoints[i].strategy;}}this.logger_("syncPoint for ["+target.key+": "+target.value+"] chosen with strategy"+(" ["+bestStrategy+"]: [time:"+bestSyncPoint.time+",")+(" segmentIndex:"+bestSyncPoint.segmentIndex)+(typeof bestSyncPoint.partIndex==='number'?",partIndex:"+bestSyncPoint.partIndex:'')+']');return bestSyncPoint;}/**
   * Save any meta-data present on the segments when segments leave
   * the live window to the playlist to allow for synchronization at the
   * playlist level later.
   *
   * @param {Playlist} oldPlaylist - The previous active playlist
   * @param {Playlist} newPlaylist - The updated and most current playlist
   */;_proto.saveExpiredSegmentInfo=function saveExpiredSegmentInfo(oldPlaylist,newPlaylist){var mediaSequenceDiff=newPlaylist.mediaSequence-oldPlaylist.mediaSequence;// Ignore large media sequence gaps
if(mediaSequenceDiff>MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC){videojs.log.warn("Not saving expired segment info. Media sequence gap "+mediaSequenceDiff+" is too large.");return;}// When a segment expires from the playlist and it has a start time
// save that information as a possible sync-point reference in future
for(var i=mediaSequenceDiff-1;i>=0;i--){var lastRemovedSegment=oldPlaylist.segments[i];if(lastRemovedSegment&&typeof lastRemovedSegment.start!=='undefined'){newPlaylist.syncInfo={mediaSequence:oldPlaylist.mediaSequence+i,time:lastRemovedSegment.start};this.logger_("playlist refresh sync: [time:"+newPlaylist.syncInfo.time+","+(" mediaSequence: "+newPlaylist.syncInfo.mediaSequence+"]"));this.trigger('syncinfoupdate');break;}}}/**
   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
   * before segments start to load.
   *
   * @param {Playlist} playlist - The currently active playlist
   */;_proto.setDateTimeMappingForStart=function setDateTimeMappingForStart(playlist){// It's possible for the playlist to be updated before playback starts, meaning time
// zero is not yet set. If, during these playlist refreshes, a discontinuity is
// crossed, then the old time zero mapping (for the prior timeline) would be retained
// unless the mappings are cleared.
this.timelineToDatetimeMappings={};if(playlist.segments&&playlist.segments.length&&playlist.segments[0].dateTimeObject){var firstSegment=playlist.segments[0];var playlistTimestamp=firstSegment.dateTimeObject.getTime()/1000;this.timelineToDatetimeMappings[firstSegment.timeline]=-playlistTimestamp;}}/**
   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
   * based on the latest timing information.
   *
   * @param {Object} options
   *        Options object
   * @param {SegmentInfo} options.segmentInfo
   *        The current active request information
   * @param {boolean} options.shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved for timeline mapping and program date time mappings.
   */;_proto.saveSegmentTimingInfo=function saveSegmentTimingInfo(_ref){var segmentInfo=_ref.segmentInfo,shouldSaveTimelineMapping=_ref.shouldSaveTimelineMapping;var didCalculateSegmentTimeMapping=this.calculateSegmentTimeMapping_(segmentInfo,segmentInfo.timingInfo,shouldSaveTimelineMapping);var segment=segmentInfo.segment;if(didCalculateSegmentTimeMapping){this.saveDiscontinuitySyncInfo_(segmentInfo);// If the playlist does not have sync information yet, record that information
// now with segment timing information
if(!segmentInfo.playlist.syncInfo){segmentInfo.playlist.syncInfo={mediaSequence:segmentInfo.playlist.mediaSequence+segmentInfo.mediaIndex,time:segment.start};}}var dateTime=segment.dateTimeObject;if(segment.discontinuity&&shouldSaveTimelineMapping&&dateTime){this.timelineToDatetimeMappings[segment.timeline]=-(dateTime.getTime()/1000);}};_proto.timestampOffsetForTimeline=function timestampOffsetForTimeline(timeline){if(typeof this.timelines[timeline]==='undefined'){return null;}return this.timelines[timeline].time;};_proto.mappingForTimeline=function mappingForTimeline(timeline){if(typeof this.timelines[timeline]==='undefined'){return null;}return this.timelines[timeline].mapping;}/**
   * Use the "media time" for a segment to generate a mapping to "display time" and
   * save that display time to the segment.
   *
   * @private
   * @param {SegmentInfo} segmentInfo
   *        The current active request information
   * @param {Object} timingInfo
   *        The start and end time of the current segment in "media time"
   * @param {boolean} shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved in timelines.
   * @return {boolean}
   *          Returns false if segment time mapping could not be calculated
   */;_proto.calculateSegmentTimeMapping_=function calculateSegmentTimeMapping_(segmentInfo,timingInfo,shouldSaveTimelineMapping){// TODO: remove side effects
var segment=segmentInfo.segment;var part=segmentInfo.part;var mappingObj=this.timelines[segmentInfo.timeline];var start;var end;if(typeof segmentInfo.timestampOffset==='number'){mappingObj={time:segmentInfo.startOfSegment,mapping:segmentInfo.startOfSegment-timingInfo.start};if(shouldSaveTimelineMapping){this.timelines[segmentInfo.timeline]=mappingObj;this.trigger('timestampoffset');this.logger_("time mapping for timeline "+segmentInfo.timeline+": "+("[time: "+mappingObj.time+"] [mapping: "+mappingObj.mapping+"]"));}start=segmentInfo.startOfSegment;end=timingInfo.end+mappingObj.mapping;}else if(mappingObj){start=timingInfo.start+mappingObj.mapping;end=timingInfo.end+mappingObj.mapping;}else{return false;}if(part){part.start=start;part.end=end;}// If we don't have a segment start yet or the start value we got
// is less than our current segment.start value, save a new start value.
// We have to do this because parts will have segment timing info saved
// multiple times and we want segment start to be the earliest part start
// value for that segment.
if(!segment.start||start<segment.start){segment.start=start;}segment.end=end;return true;}/**
   * Each time we have discontinuity in the playlist, attempt to calculate the location
   * in display of the start of the discontinuity and save that. We also save an accuracy
   * value so that we save values with the most accuracy (closest to 0.)
   *
   * @private
   * @param {SegmentInfo} segmentInfo - The current active request information
   */;_proto.saveDiscontinuitySyncInfo_=function saveDiscontinuitySyncInfo_(segmentInfo){var playlist=segmentInfo.playlist;var segment=segmentInfo.segment;// If the current segment is a discontinuity then we know exactly where
// the start of the range and it's accuracy is 0 (greater accuracy values
// mean more approximation)
if(segment.discontinuity){this.discontinuities[segment.timeline]={time:segment.start,accuracy:0};}else if(playlist.discontinuityStarts&&playlist.discontinuityStarts.length){// Search for future discontinuities that we can provide better timing
// information for and save that information for sync purposes
for(var i=0;i<playlist.discontinuityStarts.length;i++){var segmentIndex=playlist.discontinuityStarts[i];var discontinuity=playlist.discontinuitySequence+i+1;var mediaIndexDiff=segmentIndex-segmentInfo.mediaIndex;var accuracy=Math.abs(mediaIndexDiff);if(!this.discontinuities[discontinuity]||this.discontinuities[discontinuity].accuracy>accuracy){var time=void 0;if(mediaIndexDiff<0){time=segment.start-sumDurations({defaultDuration:playlist.targetDuration,durationList:playlist.segments,startIndex:segmentInfo.mediaIndex,endIndex:segmentIndex});}else{time=segment.end+sumDurations({defaultDuration:playlist.targetDuration,durationList:playlist.segments,startIndex:segmentInfo.mediaIndex+1,endIndex:segmentIndex});}this.discontinuities[discontinuity]={time:time,accuracy:accuracy};}}}};_proto.dispose=function dispose(){this.trigger('dispose');this.off();};return SyncController;}(videojs.EventTarget);/**
 * The TimelineChangeController acts as a source for segment loaders to listen for and
 * keep track of latest and pending timeline changes. This is useful to ensure proper
 * sync, as each loader may need to make a consideration for what timeline the other
 * loader is on before making changes which could impact the other loader's media.
 *
 * @class TimelineChangeController
 * @extends videojs.EventTarget
 */var TimelineChangeController=/*#__PURE__*/function(_videojs$EventTarget){_inheritsLoose(TimelineChangeController,_videojs$EventTarget);function TimelineChangeController(){var _this;_this=_videojs$EventTarget.call(this)||this;_this.pendingTimelineChanges_={};_this.lastTimelineChanges_={};return _this;}var _proto=TimelineChangeController.prototype;_proto.clearPendingTimelineChange=function clearPendingTimelineChange(type){this.pendingTimelineChanges_[type]=null;this.trigger('pendingtimelinechange');};_proto.pendingTimelineChange=function pendingTimelineChange(_ref){var type=_ref.type,from=_ref.from,to=_ref.to;if(typeof from==='number'&&typeof to==='number'){this.pendingTimelineChanges_[type]={type:type,from:from,to:to};this.trigger('pendingtimelinechange');}return this.pendingTimelineChanges_[type];};_proto.lastTimelineChange=function lastTimelineChange(_ref2){var type=_ref2.type,from=_ref2.from,to=_ref2.to;if(typeof from==='number'&&typeof to==='number'){this.lastTimelineChanges_[type]={type:type,from:from,to:to};delete this.pendingTimelineChanges_[type];this.trigger('timelinechange');}return this.lastTimelineChanges_[type];};_proto.dispose=function dispose(){this.trigger('dispose');this.pendingTimelineChanges_={};this.lastTimelineChanges_={};this.off();};return TimelineChangeController;}(videojs.EventTarget);/* rollup-plugin-worker-factory start for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */var workerCode=transform(getWorkerString(function(){var commonjsGlobal=typeof globalThis!=='undefined'?globalThis:typeof window!=='undefined'?window:typeof __webpack_require__.g!=='undefined'?__webpack_require__.g:typeof self!=='undefined'?self:{};function createCommonjsModule(fn,basedir,module){return module={path:basedir,exports:{},require:function require(path,base){return commonjsRequire(path,base===undefined||base===null?module.path:base);}},fn(module,module.exports),module.exports;}function commonjsRequire(){throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');}var createClass=createCommonjsModule(function(module){function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}module.exports=_createClass;module.exports["default"]=module.exports,module.exports.__esModule=true;});var setPrototypeOf=createCommonjsModule(function(module){function _setPrototypeOf(o,p){module.exports=_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};module.exports["default"]=module.exports,module.exports.__esModule=true;return _setPrototypeOf(o,p);}module.exports=_setPrototypeOf;module.exports["default"]=module.exports,module.exports.__esModule=true;});var inheritsLoose=createCommonjsModule(function(module){function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;setPrototypeOf(subClass,superClass);}module.exports=_inheritsLoose;module.exports["default"]=module.exports,module.exports.__esModule=true;});/**
   * @file stream.js
   */ /**
   * A lightweight readable stream implemention that handles event dispatching.
   *
   * @class Stream
   */var Stream=/*#__PURE__*/function(){function Stream(){this.listeners={};}/**
     * Add a listener for a specified event type.
     *
     * @param {string} type the event name
     * @param {Function} listener the callback to be invoked when an event of
     * the specified type occurs
     */var _proto=Stream.prototype;_proto.on=function on(type,listener){if(!this.listeners[type]){this.listeners[type]=[];}this.listeners[type].push(listener);}/**
     * Remove a listener for a specified event type.
     *
     * @param {string} type the event name
     * @param {Function} listener  a function previously registered for this
     * type of event through `on`
     * @return {boolean} if we could turn it off or not
     */;_proto.off=function off(type,listener){if(!this.listeners[type]){return false;}var index=this.listeners[type].indexOf(listener);// TODO: which is better?
// In Video.js we slice listener functions
// on trigger so that it does not mess up the order
// while we loop through.
//
// Here we slice on off so that the loop in trigger
// can continue using it's old reference to loop without
// messing up the order.
this.listeners[type]=this.listeners[type].slice(0);this.listeners[type].splice(index,1);return index>-1;}/**
     * Trigger an event of the specified type on this stream. Any additional
     * arguments to this function are passed as parameters to event listeners.
     *
     * @param {string} type the event name
     */;_proto.trigger=function trigger(type){var callbacks=this.listeners[type];if(!callbacks){return;}// Slicing the arguments on every invocation of this method
// can add a significant amount of overhead. Avoid the
// intermediate object creation for the common case of a
// single callback argument
if(arguments.length===2){var length=callbacks.length;for(var i=0;i<length;++i){callbacks[i].call(this,arguments[1]);}}else{var args=Array.prototype.slice.call(arguments,1);var _length=callbacks.length;for(var _i=0;_i<_length;++_i){callbacks[_i].apply(this,args);}}}/**
     * Destroys the stream and cleans up.
     */;_proto.dispose=function dispose(){this.listeners={};}/**
     * Forwards all `data` events on this stream to the destination stream. The
     * destination stream should provide a method `push` to receive the data
     * events as they arrive.
     *
     * @param {Stream} destination the stream that will receive all `data` events
     * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
     */;_proto.pipe=function pipe(destination){this.on('data',function(data){destination.push(data);});};return Stream;}();/*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */ /**
   * Returns the subarray of a Uint8Array without PKCS#7 padding.
   *
   * @param padded {Uint8Array} unencrypted bytes that have been padded
   * @return {Uint8Array} the unpadded bytes
   * @see http://tools.ietf.org/html/rfc5652
   */function unpad(padded){return padded.subarray(0,padded.byteLength-padded[padded.byteLength-1]);}/*! @name aes-decrypter @version 3.1.3 @license Apache-2.0 */ /**
   * @file aes.js
   *
   * This file contains an adaptation of the AES decryption algorithm
   * from the Standford Javascript Cryptography Library. That work is
   * covered by the following copyright and permissions notice:
   *
   * Copyright 2009-2010 Emily Stark, Mike Hamburg, Dan Boneh.
   * All rights reserved.
   *
   * Redistribution and use in source and binary forms, with or without
   * modification, are permitted provided that the following conditions are
   * met:
   *
   * 1. Redistributions of source code must retain the above copyright
   *    notice, this list of conditions and the following disclaimer.
   *
   * 2. Redistributions in binary form must reproduce the above
   *    copyright notice, this list of conditions and the following
   *    disclaimer in the documentation and/or other materials provided
   *    with the distribution.
   *
   * THIS SOFTWARE IS PROVIDED BY THE AUTHORS ``AS IS'' AND ANY EXPRESS OR
   * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
   * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
   * DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> OR CONTRIBUTORS BE
   * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
   * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
   * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
   * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
   * WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
   * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
   * IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   *
   * The views and conclusions contained in the software and documentation
   * are those of the authors and should not be interpreted as representing
   * official policies, either expressed or implied, of the authors.
   */ /**
   * Expand the S-box tables.
   *
   * @private
   */var precompute=function precompute(){var tables=[[[],[],[],[],[]],[[],[],[],[],[]]];var encTable=tables[0];var decTable=tables[1];var sbox=encTable[4];var sboxInv=decTable[4];var i;var x;var xInv;var d=[];var th=[];var x2;var x4;var x8;var s;var tEnc;var tDec;// Compute double and third tables
for(i=0;i<256;i++){th[(d[i]=i<<1^(i>>7)*283)^i]=i;}for(x=xInv=0;!sbox[x];x^=x2||1,xInv=th[xInv]||1){// Compute sbox
s=xInv^xInv<<1^xInv<<2^xInv<<3^xInv<<4;s=s>>8^s&255^99;sbox[x]=s;sboxInv[s]=x;// Compute MixColumns
x8=d[x4=d[x2=d[x]]];tDec=x8*0x1010101^x4*0x10001^x2*0x101^x*0x1010100;tEnc=d[s]*0x101^s*0x1010100;for(i=0;i<4;i++){encTable[i][x]=tEnc=tEnc<<24^tEnc>>>8;decTable[i][s]=tDec=tDec<<24^tDec>>>8;}}// Compactify. Considerable speedup on Firefox.
for(i=0;i<5;i++){encTable[i]=encTable[i].slice(0);decTable[i]=decTable[i].slice(0);}return tables;};var aesTables=null;/**
   * Schedule out an AES key for both encryption and decryption. This
   * is a low-level class. Use a cipher mode to do bulk encryption.
   *
   * @class AES
   * @param key {Array} The key as an array of 4, 6 or 8 words.
   */var AES=/*#__PURE__*/function(){function AES(key){/**
      * The expanded S-box and inverse S-box tables. These will be computed
      * on the client so that we don't have to send them down the wire.
      *
      * There are two tables, _tables[0] is for encryption and
      * _tables[1] is for decryption.
      *
      * The first 4 sub-tables are the expanded S-box with MixColumns. The
      * last (_tables[01][4]) is the S-box itself.
      *
      * @private
      */ // if we have yet to precompute the S-box tables
// do so now
if(!aesTables){aesTables=precompute();}// then make a copy of that object for use
this._tables=[[aesTables[0][0].slice(),aesTables[0][1].slice(),aesTables[0][2].slice(),aesTables[0][3].slice(),aesTables[0][4].slice()],[aesTables[1][0].slice(),aesTables[1][1].slice(),aesTables[1][2].slice(),aesTables[1][3].slice(),aesTables[1][4].slice()]];var i;var j;var tmp;var sbox=this._tables[0][4];var decTable=this._tables[1];var keyLen=key.length;var rcon=1;if(keyLen!==4&&keyLen!==6&&keyLen!==8){throw new Error('Invalid aes key size');}var encKey=key.slice(0);var decKey=[];this._key=[encKey,decKey];// schedule encryption keys
for(i=keyLen;i<4*keyLen+28;i++){tmp=encKey[i-1];// apply sbox
if(i%keyLen===0||keyLen===8&&i%keyLen===4){tmp=sbox[tmp>>>24]<<24^sbox[tmp>>16&255]<<16^sbox[tmp>>8&255]<<8^sbox[tmp&255];// shift rows and add rcon
if(i%keyLen===0){tmp=tmp<<8^tmp>>>24^rcon<<24;rcon=rcon<<1^(rcon>>7)*283;}}encKey[i]=encKey[i-keyLen]^tmp;}// schedule decryption keys
for(j=0;i;j++,i--){tmp=encKey[j&3?i:i-4];if(i<=4||j<4){decKey[j]=tmp;}else{decKey[j]=decTable[0][sbox[tmp>>>24]]^decTable[1][sbox[tmp>>16&255]]^decTable[2][sbox[tmp>>8&255]]^decTable[3][sbox[tmp&255]];}}}/**
     * Decrypt 16 bytes, specified as four 32-bit words.
     *
     * @param {number} encrypted0 the first word to decrypt
     * @param {number} encrypted1 the second word to decrypt
     * @param {number} encrypted2 the third word to decrypt
     * @param {number} encrypted3 the fourth word to decrypt
     * @param {Int32Array} out the array to write the decrypted words
     * into
     * @param {number} offset the offset into the output array to start
     * writing results
     * @return {Array} The plaintext.
     */var _proto=AES.prototype;_proto.decrypt=function decrypt(encrypted0,encrypted1,encrypted2,encrypted3,out,offset){var key=this._key[1];// state variables a,b,c,d are loaded with pre-whitened data
var a=encrypted0^key[0];var b=encrypted3^key[1];var c=encrypted2^key[2];var d=encrypted1^key[3];var a2;var b2;var c2;// key.length === 2 ?
var nInnerRounds=key.length/4-2;var i;var kIndex=4;var table=this._tables[1];// load up the tables
var table0=table[0];var table1=table[1];var table2=table[2];var table3=table[3];var sbox=table[4];// Inner rounds. Cribbed from OpenSSL.
for(i=0;i<nInnerRounds;i++){a2=table0[a>>>24]^table1[b>>16&255]^table2[c>>8&255]^table3[d&255]^key[kIndex];b2=table0[b>>>24]^table1[c>>16&255]^table2[d>>8&255]^table3[a&255]^key[kIndex+1];c2=table0[c>>>24]^table1[d>>16&255]^table2[a>>8&255]^table3[b&255]^key[kIndex+2];d=table0[d>>>24]^table1[a>>16&255]^table2[b>>8&255]^table3[c&255]^key[kIndex+3];kIndex+=4;a=a2;b=b2;c=c2;}// Last round.
for(i=0;i<4;i++){out[(3&-i)+offset]=sbox[a>>>24]<<24^sbox[b>>16&255]<<16^sbox[c>>8&255]<<8^sbox[d&255]^key[kIndex++];a2=a;a=b;b=c;c=d;d=a2;}};return AES;}();/**
   * A wrapper around the Stream class to use setTimeout
   * and run stream "jobs" Asynchronously
   *
   * @class AsyncStream
   * @extends Stream
   */var AsyncStream=/*#__PURE__*/function(_Stream){inheritsLoose(AsyncStream,_Stream);function AsyncStream(){var _this;_this=_Stream.call(this,Stream)||this;_this.jobs=[];_this.delay=1;_this.timeout_=null;return _this;}/**
     * process an async job
     *
     * @private
     */var _proto=AsyncStream.prototype;_proto.processJob_=function processJob_(){this.jobs.shift()();if(this.jobs.length){this.timeout_=setTimeout(this.processJob_.bind(this),this.delay);}else{this.timeout_=null;}}/**
     * push a job into the stream
     *
     * @param {Function} job the job to push into the stream
     */;_proto.push=function push(job){this.jobs.push(job);if(!this.timeout_){this.timeout_=setTimeout(this.processJob_.bind(this),this.delay);}};return AsyncStream;}(Stream);/**
   * Convert network-order (big-endian) bytes into their little-endian
   * representation.
   */var ntoh=function ntoh(word){return word<<24|(word&0xff00)<<8|(word&0xff0000)>>8|word>>>24;};/**
   * Decrypt bytes using AES-128 with CBC and PKCS#7 padding.
   *
   * @param {Uint8Array} encrypted the encrypted bytes
   * @param {Uint32Array} key the bytes of the decryption key
   * @param {Uint32Array} initVector the initialization vector (IV) to
   * use for the first round of CBC.
   * @return {Uint8Array} the decrypted bytes
   *
   * @see http://en.wikipedia.org/wiki/Advanced_Encryption_Standard
   * @see http://en.wikipedia.org/wiki/Block_cipher_mode_of_operation#Cipher_Block_Chaining_.28CBC.29
   * @see https://tools.ietf.org/html/rfc2315
   */var decrypt=function decrypt(encrypted,key,initVector){// word-level access to the encrypted bytes
var encrypted32=new Int32Array(encrypted.buffer,encrypted.byteOffset,encrypted.byteLength>>2);var decipher=new AES(Array.prototype.slice.call(key));// byte and word-level access for the decrypted output
var decrypted=new Uint8Array(encrypted.byteLength);var decrypted32=new Int32Array(decrypted.buffer);// temporary variables for working with the IV, encrypted, and
// decrypted data
var init0;var init1;var init2;var init3;var encrypted0;var encrypted1;var encrypted2;var encrypted3;// iteration variable
var wordIx;// pull out the words of the IV to ensure we don't modify the
// passed-in reference and easier access
init0=initVector[0];init1=initVector[1];init2=initVector[2];init3=initVector[3];// decrypt four word sequences, applying cipher-block chaining (CBC)
// to each decrypted block
for(wordIx=0;wordIx<encrypted32.length;wordIx+=4){// convert big-endian (network order) words into little-endian
// (javascript order)
encrypted0=ntoh(encrypted32[wordIx]);encrypted1=ntoh(encrypted32[wordIx+1]);encrypted2=ntoh(encrypted32[wordIx+2]);encrypted3=ntoh(encrypted32[wordIx+3]);// decrypt the block
decipher.decrypt(encrypted0,encrypted1,encrypted2,encrypted3,decrypted32,wordIx);// XOR with the IV, and restore network byte-order to obtain the
// plaintext
decrypted32[wordIx]=ntoh(decrypted32[wordIx]^init0);decrypted32[wordIx+1]=ntoh(decrypted32[wordIx+1]^init1);decrypted32[wordIx+2]=ntoh(decrypted32[wordIx+2]^init2);decrypted32[wordIx+3]=ntoh(decrypted32[wordIx+3]^init3);// setup the IV for the next round
init0=encrypted0;init1=encrypted1;init2=encrypted2;init3=encrypted3;}return decrypted;};/**
   * The `Decrypter` class that manages decryption of AES
   * data through `AsyncStream` objects and the `decrypt`
   * function
   *
   * @param {Uint8Array} encrypted the encrypted bytes
   * @param {Uint32Array} key the bytes of the decryption key
   * @param {Uint32Array} initVector the initialization vector (IV) to
   * @param {Function} done the function to run when done
   * @class Decrypter
   */var Decrypter=/*#__PURE__*/function(){function Decrypter(encrypted,key,initVector,done){var step=Decrypter.STEP;var encrypted32=new Int32Array(encrypted.buffer);var decrypted=new Uint8Array(encrypted.byteLength);var i=0;this.asyncStream_=new AsyncStream();// split up the encryption job and do the individual chunks asynchronously
this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i,i+step),key,initVector,decrypted));for(i=step;i<encrypted32.length;i+=step){initVector=new Uint32Array([ntoh(encrypted32[i-4]),ntoh(encrypted32[i-3]),ntoh(encrypted32[i-2]),ntoh(encrypted32[i-1])]);this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i,i+step),key,initVector,decrypted));}// invoke the done() callback when everything is finished
this.asyncStream_.push(function(){// remove pkcs#7 padding from the decrypted bytes
done(null,unpad(decrypted));});}/**
     * a getter for step the maximum number of bytes to process at one time
     *
     * @return {number} the value of step 32000
     */var _proto=Decrypter.prototype;/**
     * @private
     */_proto.decryptChunk_=function decryptChunk_(encrypted,key,initVector,decrypted){return function(){var bytes=decrypt(encrypted,key,initVector);decrypted.set(bytes,encrypted.byteOffset);};};createClass(Decrypter,null,[{key:"STEP",get:function get(){// 4 * 8000;
return 32000;}}]);return Decrypter;}();var win;if(typeof window!=="undefined"){win=window;}else if(typeof commonjsGlobal!=="undefined"){win=commonjsGlobal;}else if(typeof self!=="undefined"){win=self;}else{win={};}var window_1=win;var isArrayBufferView=function isArrayBufferView(obj){if(ArrayBuffer.isView==='function'){return ArrayBuffer.isView(obj);}return obj&&obj.buffer instanceof ArrayBuffer;};var BigInt=window_1.BigInt||Number;[BigInt('0x1'),BigInt('0x100'),BigInt('0x10000'),BigInt('0x1000000'),BigInt('0x100000000'),BigInt('0x10000000000'),BigInt('0x1000000000000'),BigInt('0x100000000000000'),BigInt('0x10000000000000000')];/**
   * Creates an object for sending to a web worker modifying properties that are TypedArrays
   * into a new object with seperated properties for the buffer, byteOffset, and byteLength.
   *
   * @param {Object} message
   *        Object of properties and values to send to the web worker
   * @return {Object}
   *         Modified message with TypedArray values expanded
   * @function createTransferableMessage
   */var createTransferableMessage=function createTransferableMessage(message){var transferable={};Object.keys(message).forEach(function(key){var value=message[key];if(isArrayBufferView(value)){transferable[key]={bytes:value.buffer,byteOffset:value.byteOffset,byteLength:value.byteLength};}else{transferable[key]=value;}});return transferable;};/* global self */ /**
   * Our web worker interface so that things can talk to aes-decrypter
   * that will be running in a web worker. the scope is passed to this by
   * webworkify.
   */self.onmessage=function(event){var data=event.data;var encrypted=new Uint8Array(data.encrypted.bytes,data.encrypted.byteOffset,data.encrypted.byteLength);var key=new Uint32Array(data.key.bytes,data.key.byteOffset,data.key.byteLength/4);var iv=new Uint32Array(data.iv.bytes,data.iv.byteOffset,data.iv.byteLength/4);/* eslint-disable no-new, handle-callback-err */new Decrypter(encrypted,key,iv,function(err,bytes){self.postMessage(createTransferableMessage({source:data.source,decrypted:bytes}),[bytes.buffer]);});/* eslint-enable */};}));var Decrypter=factory(workerCode);/* rollup-plugin-worker-factory end for worker!/home/runner/work/http-streaming/http-streaming/src/decrypter-worker.js */ /**
 * Convert the properties of an HLS track into an audioTrackKind.
 *
 * @private
 */var audioTrackKind_=function audioTrackKind_(properties){var kind=properties["default"]?'main':'alternative';if(properties.characteristics&&properties.characteristics.indexOf('public.accessibility.describes-video')>=0){kind='main-desc';}return kind;};/**
 * Pause provided segment loader and playlist loader if active
 *
 * @param {SegmentLoader} segmentLoader
 *        SegmentLoader to pause
 * @param {Object} mediaType
 *        Active media type
 * @function stopLoaders
 */var stopLoaders=function stopLoaders(segmentLoader,mediaType){segmentLoader.abort();segmentLoader.pause();if(mediaType&&mediaType.activePlaylistLoader){mediaType.activePlaylistLoader.pause();mediaType.activePlaylistLoader=null;}};/**
 * Start loading provided segment loader and playlist loader
 *
 * @param {PlaylistLoader} playlistLoader
 *        PlaylistLoader to start loading
 * @param {Object} mediaType
 *        Active media type
 * @function startLoaders
 */var startLoaders=function startLoaders(playlistLoader,mediaType){// Segment loader will be started after `loadedmetadata` or `loadedplaylist` from the
// playlist loader
mediaType.activePlaylistLoader=playlistLoader;playlistLoader.load();};/**
 * Returns a function to be called when the media group changes. It performs a
 * non-destructive (preserve the buffer) resync of the SegmentLoader. This is because a
 * change of group is merely a rendition switch of the same content at another encoding,
 * rather than a change of content, such as switching audio from English to Spanish.
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Handler for a non-destructive resync of SegmentLoader when the active media
 *         group changes.
 * @function onGroupChanged
 */var onGroupChanged=function onGroupChanged(type,settings){return function(){var _settings$segmentLoad=settings.segmentLoaders,segmentLoader=_settings$segmentLoad[type],mainSegmentLoader=_settings$segmentLoad.main,mediaType=settings.mediaTypes[type];var activeTrack=mediaType.activeTrack();var activeGroup=mediaType.getActiveGroup();var previousActiveLoader=mediaType.activePlaylistLoader;var lastGroup=mediaType.lastGroup_;// the group did not change do nothing
if(activeGroup&&lastGroup&&activeGroup.id===lastGroup.id){return;}mediaType.lastGroup_=activeGroup;mediaType.lastTrack_=activeTrack;stopLoaders(segmentLoader,mediaType);if(!activeGroup||activeGroup.isMasterPlaylist){// there is no group active or active group is a main playlist and won't change
return;}if(!activeGroup.playlistLoader){if(previousActiveLoader){// The previous group had a playlist loader but the new active group does not
// this means we are switching from demuxed to muxed audio. In this case we want to
// do a destructive reset of the main segment loader and not restart the audio
// loaders.
mainSegmentLoader.resetEverything();}return;}// Non-destructive resync
segmentLoader.resyncLoader();startLoaders(activeGroup.playlistLoader,mediaType);};};var onGroupChanging=function onGroupChanging(type,settings){return function(){var segmentLoader=settings.segmentLoaders[type],mediaType=settings.mediaTypes[type];mediaType.lastGroup_=null;segmentLoader.abort();segmentLoader.pause();};};/**
 * Returns a function to be called when the media track changes. It performs a
 * destructive reset of the SegmentLoader to ensure we start loading as close to
 * currentTime as possible.
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Handler for a destructive reset of SegmentLoader when the active media
 *         track changes.
 * @function onTrackChanged
 */var onTrackChanged=function onTrackChanged(type,settings){return function(){var masterPlaylistLoader=settings.masterPlaylistLoader,_settings$segmentLoad2=settings.segmentLoaders,segmentLoader=_settings$segmentLoad2[type],mainSegmentLoader=_settings$segmentLoad2.main,mediaType=settings.mediaTypes[type];var activeTrack=mediaType.activeTrack();var activeGroup=mediaType.getActiveGroup();var previousActiveLoader=mediaType.activePlaylistLoader;var lastTrack=mediaType.lastTrack_;// track did not change, do nothing
if(lastTrack&&activeTrack&&lastTrack.id===activeTrack.id){return;}mediaType.lastGroup_=activeGroup;mediaType.lastTrack_=activeTrack;stopLoaders(segmentLoader,mediaType);if(!activeGroup){// there is no group active so we do not want to restart loaders
return;}if(activeGroup.isMasterPlaylist){// track did not change, do nothing
if(!activeTrack||!lastTrack||activeTrack.id===lastTrack.id){return;}var mpc=settings.vhs.masterPlaylistController_;var newPlaylist=mpc.selectPlaylist();// media will not change do nothing
if(mpc.media()===newPlaylist){return;}mediaType.logger_("track change. Switching master audio from "+lastTrack.id+" to "+activeTrack.id);masterPlaylistLoader.pause();mainSegmentLoader.resetEverything();mpc.fastQualityChange_(newPlaylist);return;}if(type==='AUDIO'){if(!activeGroup.playlistLoader){// when switching from demuxed audio/video to muxed audio/video (noted by no
// playlist loader for the audio group), we want to do a destructive reset of the
// main segment loader and not restart the audio loaders
mainSegmentLoader.setAudio(true);// don't have to worry about disabling the audio of the audio segment loader since
// it should be stopped
mainSegmentLoader.resetEverything();return;}// although the segment loader is an audio segment loader, call the setAudio
// function to ensure it is prepared to re-append the init segment (or handle other
// config changes)
segmentLoader.setAudio(true);mainSegmentLoader.setAudio(false);}if(previousActiveLoader===activeGroup.playlistLoader){// Nothing has actually changed. This can happen because track change events can fire
// multiple times for a "single" change. One for enabling the new active track, and
// one for disabling the track that was active
startLoaders(activeGroup.playlistLoader,mediaType);return;}if(segmentLoader.track){// For WebVTT, set the new text track in the segmentloader
segmentLoader.track(activeTrack);}// destructive reset
segmentLoader.resetEverything();startLoaders(activeGroup.playlistLoader,mediaType);};};var onError={/**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is blacklisted) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */AUDIO:function AUDIO(type,settings){return function(){var segmentLoader=settings.segmentLoaders[type],mediaType=settings.mediaTypes[type],blacklistCurrentPlaylist=settings.blacklistCurrentPlaylist;stopLoaders(segmentLoader,mediaType);// switch back to default audio track
var activeTrack=mediaType.activeTrack();var activeGroup=mediaType.activeGroup();var id=(activeGroup.filter(function(group){return group["default"];})[0]||activeGroup[0]).id;var defaultTrack=mediaType.tracks[id];if(activeTrack===defaultTrack){// Default track encountered an error. All we can do now is blacklist the current
// rendition and hope another will switch audio groups
blacklistCurrentPlaylist({message:'Problem encountered loading the default audio track.'});return;}videojs.log.warn('Problem encountered loading the alternate audio track.'+'Switching back to default.');for(var trackId in mediaType.tracks){mediaType.tracks[trackId].enabled=mediaType.tracks[trackId]===defaultTrack;}mediaType.onTrackChanged();};},/**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */SUBTITLES:function SUBTITLES(type,settings){return function(){var segmentLoader=settings.segmentLoaders[type],mediaType=settings.mediaTypes[type];videojs.log.warn('Problem encountered loading the subtitle track.'+'Disabling subtitle track.');stopLoaders(segmentLoader,mediaType);var track=mediaType.activeTrack();if(track){track.mode='disabled';}mediaType.onTrackChanged();};}};var setupListeners={/**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */AUDIO:function AUDIO(type,playlistLoader,settings){if(!playlistLoader){// no playlist loader means audio will be muxed with the video
return;}var tech=settings.tech,requestOptions=settings.requestOptions,segmentLoader=settings.segmentLoaders[type];playlistLoader.on('loadedmetadata',function(){var media=playlistLoader.media();segmentLoader.playlist(media,requestOptions);// if the video is already playing, or if this isn't a live video and preload
// permits, start downloading segments
if(!tech.paused()||media.endList&&tech.preload()!=='none'){segmentLoader.load();}});playlistLoader.on('loadedplaylist',function(){segmentLoader.playlist(playlistLoader.media(),requestOptions);// If the player isn't paused, ensure that the segment loader is running
if(!tech.paused()){segmentLoader.load();}});playlistLoader.on('error',onError[type](type,settings));},/**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */SUBTITLES:function SUBTITLES(type,playlistLoader,settings){var tech=settings.tech,requestOptions=settings.requestOptions,segmentLoader=settings.segmentLoaders[type],mediaType=settings.mediaTypes[type];playlistLoader.on('loadedmetadata',function(){var media=playlistLoader.media();segmentLoader.playlist(media,requestOptions);segmentLoader.track(mediaType.activeTrack());// if the video is already playing, or if this isn't a live video and preload
// permits, start downloading segments
if(!tech.paused()||media.endList&&tech.preload()!=='none'){segmentLoader.load();}});playlistLoader.on('loadedplaylist',function(){segmentLoader.playlist(playlistLoader.media(),requestOptions);// If the player isn't paused, ensure that the segment loader is running
if(!tech.paused()){segmentLoader.load();}});playlistLoader.on('error',onError[type](type,settings));}};var initialize={/**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */'AUDIO':function AUDIO(type,settings){var vhs=settings.vhs,sourceType=settings.sourceType,segmentLoader=settings.segmentLoaders[type],requestOptions=settings.requestOptions,mediaGroups=settings.master.mediaGroups,_settings$mediaTypes$=settings.mediaTypes[type],groups=_settings$mediaTypes$.groups,tracks=_settings$mediaTypes$.tracks,logger_=_settings$mediaTypes$.logger_,masterPlaylistLoader=settings.masterPlaylistLoader;var audioOnlyMaster=isAudioOnly(masterPlaylistLoader.master);// force a default if we have none
if(!mediaGroups[type]||Object.keys(mediaGroups[type]).length===0){mediaGroups[type]={main:{"default":{"default":true}}};if(audioOnlyMaster){mediaGroups[type].main["default"].playlists=masterPlaylistLoader.master.playlists;}}for(var groupId in mediaGroups[type]){if(!groups[groupId]){groups[groupId]=[];}for(var variantLabel in mediaGroups[type][groupId]){var properties=mediaGroups[type][groupId][variantLabel];var playlistLoader=void 0;if(audioOnlyMaster){logger_("AUDIO group '"+groupId+"' label '"+variantLabel+"' is a master playlist");properties.isMasterPlaylist=true;playlistLoader=null;// if vhs-json was provided as the source, and the media playlist was resolved,
// use the resolved media playlist object
}else if(sourceType==='vhs-json'&&properties.playlists){playlistLoader=new PlaylistLoader(properties.playlists[0],vhs,requestOptions);}else if(properties.resolvedUri){playlistLoader=new PlaylistLoader(properties.resolvedUri,vhs,requestOptions);// TODO: dash isn't the only type with properties.playlists
// should we even have properties.playlists in this check.
}else if(properties.playlists&&sourceType==='dash'){playlistLoader=new DashPlaylistLoader(properties.playlists[0],vhs,requestOptions,masterPlaylistLoader);}else{// no resolvedUri means the audio is muxed with the video when using this
// audio track
playlistLoader=null;}properties=videojs.mergeOptions({id:variantLabel,playlistLoader:playlistLoader},properties);setupListeners[type](type,properties.playlistLoader,settings);groups[groupId].push(properties);if(typeof tracks[variantLabel]==='undefined'){var track=new videojs.AudioTrack({id:variantLabel,kind:audioTrackKind_(properties),enabled:false,language:properties.language,"default":properties["default"],label:variantLabel});tracks[variantLabel]=track;}}}// setup single error event handler for the segment loader
segmentLoader.on('error',onError[type](type,settings));},/**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */'SUBTITLES':function SUBTITLES(type,settings){var tech=settings.tech,vhs=settings.vhs,sourceType=settings.sourceType,segmentLoader=settings.segmentLoaders[type],requestOptions=settings.requestOptions,mediaGroups=settings.master.mediaGroups,_settings$mediaTypes$2=settings.mediaTypes[type],groups=_settings$mediaTypes$2.groups,tracks=_settings$mediaTypes$2.tracks,masterPlaylistLoader=settings.masterPlaylistLoader;for(var groupId in mediaGroups[type]){if(!groups[groupId]){groups[groupId]=[];}for(var variantLabel in mediaGroups[type][groupId]){if(mediaGroups[type][groupId][variantLabel].forced){// Subtitle playlists with the forced attribute are not selectable in Safari.
// According to Apple's HLS Authoring Specification:
//   If content has forced subtitles and regular subtitles in a given language,
//   the regular subtitles track in that language MUST contain both the forced
//   subtitles and the regular subtitles for that language.
// Because of this requirement and that Safari does not add forced subtitles,
// forced subtitles are skipped here to maintain consistent experience across
// all platforms
continue;}var properties=mediaGroups[type][groupId][variantLabel];var playlistLoader=void 0;if(sourceType==='hls'){playlistLoader=new PlaylistLoader(properties.resolvedUri,vhs,requestOptions);}else if(sourceType==='dash'){var playlists=properties.playlists.filter(function(p){return p.excludeUntil!==Infinity;});if(!playlists.length){return;}playlistLoader=new DashPlaylistLoader(properties.playlists[0],vhs,requestOptions,masterPlaylistLoader);}else if(sourceType==='vhs-json'){playlistLoader=new PlaylistLoader(// if the vhs-json object included the media playlist, use the media playlist
// as provided, otherwise use the resolved URI to load the playlist
properties.playlists?properties.playlists[0]:properties.resolvedUri,vhs,requestOptions);}properties=videojs.mergeOptions({id:variantLabel,playlistLoader:playlistLoader},properties);setupListeners[type](type,properties.playlistLoader,settings);groups[groupId].push(properties);if(typeof tracks[variantLabel]==='undefined'){var track=tech.addRemoteTextTrack({id:variantLabel,kind:'subtitles',"default":properties["default"]&&properties.autoselect,language:properties.language,label:variantLabel},false).track;tracks[variantLabel]=track;}}}// setup single error event handler for the segment loader
segmentLoader.on('error',onError[type](type,settings));},/**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */'CLOSED-CAPTIONS':function CLOSEDCAPTIONS(type,settings){var tech=settings.tech,mediaGroups=settings.master.mediaGroups,_settings$mediaTypes$3=settings.mediaTypes[type],groups=_settings$mediaTypes$3.groups,tracks=_settings$mediaTypes$3.tracks;for(var groupId in mediaGroups[type]){if(!groups[groupId]){groups[groupId]=[];}for(var variantLabel in mediaGroups[type][groupId]){var properties=mediaGroups[type][groupId][variantLabel];// Look for either 608 (CCn) or 708 (SERVICEn) caption services
if(!/^(?:CC|SERVICE)/.test(properties.instreamId)){continue;}var captionServices=tech.options_.vhs&&tech.options_.vhs.captionServices||{};var newProps={label:variantLabel,language:properties.language,instreamId:properties.instreamId,"default":properties["default"]&&properties.autoselect};if(captionServices[newProps.instreamId]){newProps=videojs.mergeOptions(newProps,captionServices[newProps.instreamId]);}if(newProps["default"]===undefined){delete newProps["default"];}// No PlaylistLoader is required for Closed-Captions because the captions are
// embedded within the video stream
groups[groupId].push(videojs.mergeOptions({id:variantLabel},properties));if(typeof tracks[variantLabel]==='undefined'){var track=tech.addRemoteTextTrack({id:newProps.instreamId,kind:'captions',"default":newProps["default"],language:newProps.language,label:newProps.label},false).track;tracks[variantLabel]=track;}}}}};var groupMatch=function groupMatch(list,media){for(var i=0;i<list.length;i++){if(playlistMatch(media,list[i])){return true;}if(list[i].playlists&&groupMatch(list[i].playlists,media)){return true;}}return false;};/**
 * Returns a function used to get the active group of the provided type
 *
 * @param {string} type
 *        MediaGroup type
 * @param {Object} settings
 *        Object containing required information for media groups
 * @return {Function}
 *         Function that returns the active media group for the provided type. Takes an
 *         optional parameter {TextTrack} track. If no track is provided, a list of all
 *         variants in the group, otherwise the variant corresponding to the provided
 *         track is returned.
 * @function activeGroup
 */var activeGroup=function activeGroup(type,settings){return function(track){var masterPlaylistLoader=settings.masterPlaylistLoader,groups=settings.mediaTypes[type].groups;var media=masterPlaylistLoader.media();if(!media){return null;}var variants=null;// set to variants to main media active group
if(media.attributes[type]){variants=groups[media.attributes[type]];}var groupKeys=Object.keys(groups);if(!variants){// find the masterPlaylistLoader media
// that is in a media group if we are dealing
// with audio only
if(type==='AUDIO'&&groupKeys.length>1&&isAudioOnly(settings.master)){for(var i=0;i<groupKeys.length;i++){var groupPropertyList=groups[groupKeys[i]];if(groupMatch(groupPropertyList,media)){variants=groupPropertyList;break;}}// use the main group if it exists
}else if(groups.main){variants=groups.main;// only one group, use that one
}else if(groupKeys.length===1){variants=groups[groupKeys[0]];}}if(typeof track==='undefined'){return variants;}if(track===null||!variants){// An active track was specified so a corresponding group is expected. track === null
// means no track is currently active so there is no corresponding group
return null;}return variants.filter(function(props){return props.id===track.id;})[0]||null;};};var activeTrack={/**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */AUDIO:function AUDIO(type,settings){return function(){var tracks=settings.mediaTypes[type].tracks;for(var id in tracks){if(tracks[id].enabled){return tracks[id];}}return null;};},/**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */SUBTITLES:function SUBTITLES(type,settings){return function(){var tracks=settings.mediaTypes[type].tracks;for(var id in tracks){if(tracks[id].mode==='showing'||tracks[id].mode==='hidden'){return tracks[id];}}return null;};}};var getActiveGroup=function getActiveGroup(type,_ref){var mediaTypes=_ref.mediaTypes;return function(){var activeTrack_=mediaTypes[type].activeTrack();if(!activeTrack_){return null;}return mediaTypes[type].activeGroup(activeTrack_);};};/**
 * Setup PlaylistLoaders and Tracks for media groups (Audio, Subtitles,
 * Closed-Captions) specified in the master manifest.
 *
 * @param {Object} settings
 *        Object containing required information for setting up the media groups
 * @param {Tech} settings.tech
 *        The tech of the player
 * @param {Object} settings.requestOptions
 *        XHR request options used by the segment loaders
 * @param {PlaylistLoader} settings.masterPlaylistLoader
 *        PlaylistLoader for the master source
 * @param {VhsHandler} settings.vhs
 *        VHS SourceHandler
 * @param {Object} settings.master
 *        The parsed master manifest
 * @param {Object} settings.mediaTypes
 *        Object to store the loaders, tracks, and utility methods for each media type
 * @param {Function} settings.blacklistCurrentPlaylist
 *        Blacklists the current rendition and forces a rendition switch.
 * @function setupMediaGroups
 */var setupMediaGroups=function setupMediaGroups(settings){['AUDIO','SUBTITLES','CLOSED-CAPTIONS'].forEach(function(type){initialize[type](type,settings);});var mediaTypes=settings.mediaTypes,masterPlaylistLoader=settings.masterPlaylistLoader,tech=settings.tech,vhs=settings.vhs,_settings$segmentLoad3=settings.segmentLoaders,audioSegmentLoader=_settings$segmentLoad3['AUDIO'],mainSegmentLoader=_settings$segmentLoad3.main;// setup active group and track getters and change event handlers
['AUDIO','SUBTITLES'].forEach(function(type){mediaTypes[type].activeGroup=activeGroup(type,settings);mediaTypes[type].activeTrack=activeTrack[type](type,settings);mediaTypes[type].onGroupChanged=onGroupChanged(type,settings);mediaTypes[type].onGroupChanging=onGroupChanging(type,settings);mediaTypes[type].onTrackChanged=onTrackChanged(type,settings);mediaTypes[type].getActiveGroup=getActiveGroup(type,settings);});// DO NOT enable the default subtitle or caption track.
// DO enable the default audio track
var audioGroup=mediaTypes.AUDIO.activeGroup();if(audioGroup){var groupId=(audioGroup.filter(function(group){return group["default"];})[0]||audioGroup[0]).id;mediaTypes.AUDIO.tracks[groupId].enabled=true;mediaTypes.AUDIO.onGroupChanged();mediaTypes.AUDIO.onTrackChanged();var activeAudioGroup=mediaTypes.AUDIO.getActiveGroup();// a similar check for handling setAudio on each loader is run again each time the
// track is changed, but needs to be handled here since the track may not be considered
// changed on the first call to onTrackChanged
if(!activeAudioGroup.playlistLoader){// either audio is muxed with video or the stream is audio only
mainSegmentLoader.setAudio(true);}else{// audio is demuxed
mainSegmentLoader.setAudio(false);audioSegmentLoader.setAudio(true);}}masterPlaylistLoader.on('mediachange',function(){['AUDIO','SUBTITLES'].forEach(function(type){return mediaTypes[type].onGroupChanged();});});masterPlaylistLoader.on('mediachanging',function(){['AUDIO','SUBTITLES'].forEach(function(type){return mediaTypes[type].onGroupChanging();});});// custom audio track change event handler for usage event
var onAudioTrackChanged=function onAudioTrackChanged(){mediaTypes.AUDIO.onTrackChanged();tech.trigger({type:'usage',name:'vhs-audio-change'});tech.trigger({type:'usage',name:'hls-audio-change'});};tech.audioTracks().addEventListener('change',onAudioTrackChanged);tech.remoteTextTracks().addEventListener('change',mediaTypes.SUBTITLES.onTrackChanged);vhs.on('dispose',function(){tech.audioTracks().removeEventListener('change',onAudioTrackChanged);tech.remoteTextTracks().removeEventListener('change',mediaTypes.SUBTITLES.onTrackChanged);});// clear existing audio tracks and add the ones we just created
tech.clearTracks('audio');for(var id in mediaTypes.AUDIO.tracks){tech.audioTracks().addTrack(mediaTypes.AUDIO.tracks[id]);}};/**
 * Creates skeleton object used to store the loaders, tracks, and utility methods for each
 * media type
 *
 * @return {Object}
 *         Object to store the loaders, tracks, and utility methods for each media type
 * @function createMediaTypes
 */var createMediaTypes=function createMediaTypes(){var mediaTypes={};['AUDIO','SUBTITLES','CLOSED-CAPTIONS'].forEach(function(type){mediaTypes[type]={groups:{},tracks:{},activePlaylistLoader:null,activeGroup:noop,activeTrack:noop,getActiveGroup:noop,onGroupChanged:noop,onTrackChanged:noop,lastTrack_:null,logger_:logger("MediaGroups["+type+"]")};});return mediaTypes;};var ABORT_EARLY_BLACKLIST_SECONDS=60*2;var Vhs$1;// SegmentLoader stats that need to have each loader's
// values summed to calculate the final value
var loaderStats=['mediaRequests','mediaRequestsAborted','mediaRequestsTimedout','mediaRequestsErrored','mediaTransferDuration','mediaBytesTransferred','mediaAppends'];var sumLoaderStat=function sumLoaderStat(stat){return this.audioSegmentLoader_[stat]+this.mainSegmentLoader_[stat];};var shouldSwitchToMedia=function shouldSwitchToMedia(_ref){var currentPlaylist=_ref.currentPlaylist,buffered=_ref.buffered,currentTime=_ref.currentTime,nextPlaylist=_ref.nextPlaylist,bufferLowWaterLine=_ref.bufferLowWaterLine,bufferHighWaterLine=_ref.bufferHighWaterLine,duration=_ref.duration,experimentalBufferBasedABR=_ref.experimentalBufferBasedABR,log=_ref.log;// we have no other playlist to switch to
if(!nextPlaylist){videojs.log.warn('We received no playlist to switch to. Please check your stream.');return false;}var sharedLogLine="allowing switch "+(currentPlaylist&&currentPlaylist.id||'null')+" -> "+nextPlaylist.id;if(!currentPlaylist){log(sharedLogLine+" as current playlist is not set");return true;}// no need to switch if playlist is the same
if(nextPlaylist.id===currentPlaylist.id){return false;}// determine if current time is in a buffered range.
var isBuffered=Boolean(findRange(buffered,currentTime).length);// If the playlist is live, then we want to not take low water line into account.
// This is because in LIVE, the player plays 3 segments from the end of the
// playlist, and if `BUFFER_LOW_WATER_LINE` is greater than the duration availble
// in those segments, a viewer will never experience a rendition upswitch.
if(!currentPlaylist.endList){// For LLHLS live streams, don't switch renditions before playback has started, as it almost
// doubles the time to first playback.
if(!isBuffered&&typeof currentPlaylist.partTargetDuration==='number'){log("not "+sharedLogLine+" as current playlist is live llhls, but currentTime isn't in buffered.");return false;}log(sharedLogLine+" as current playlist is live");return true;}var forwardBuffer=timeAheadOf(buffered,currentTime);var maxBufferLowWaterLine=experimentalBufferBasedABR?Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE:Config.MAX_BUFFER_LOW_WATER_LINE;// For the same reason as LIVE, we ignore the low water line when the VOD
// duration is below the max potential low water line
if(duration<maxBufferLowWaterLine){log(sharedLogLine+" as duration < max low water line ("+duration+" < "+maxBufferLowWaterLine+")");return true;}var nextBandwidth=nextPlaylist.attributes.BANDWIDTH;var currBandwidth=currentPlaylist.attributes.BANDWIDTH;// when switching down, if our buffer is lower than the high water line,
// we can switch down
if(nextBandwidth<currBandwidth&&(!experimentalBufferBasedABR||forwardBuffer<bufferHighWaterLine)){var logLine=sharedLogLine+" as next bandwidth < current bandwidth ("+nextBandwidth+" < "+currBandwidth+")";if(experimentalBufferBasedABR){logLine+=" and forwardBuffer < bufferHighWaterLine ("+forwardBuffer+" < "+bufferHighWaterLine+")";}log(logLine);return true;}// and if our buffer is higher than the low water line,
// we can switch up
if((!experimentalBufferBasedABR||nextBandwidth>currBandwidth)&&forwardBuffer>=bufferLowWaterLine){var _logLine=sharedLogLine+" as forwardBuffer >= bufferLowWaterLine ("+forwardBuffer+" >= "+bufferLowWaterLine+")";if(experimentalBufferBasedABR){_logLine+=" and next bandwidth > current bandwidth ("+nextBandwidth+" > "+currBandwidth+")";}log(_logLine);return true;}log("not "+sharedLogLine+" as no switching criteria met");return false;};/**
 * the master playlist controller controller all interactons
 * between playlists and segmentloaders. At this time this mainly
 * involves a master playlist and a series of audio playlists
 * if they are available
 *
 * @class MasterPlaylistController
 * @extends videojs.EventTarget
 */var MasterPlaylistController=/*#__PURE__*/function(_videojs$EventTarget){_inheritsLoose(MasterPlaylistController,_videojs$EventTarget);function MasterPlaylistController(options){var _this;_this=_videojs$EventTarget.call(this)||this;var src=options.src,handleManifestRedirects=options.handleManifestRedirects,withCredentials=options.withCredentials,tech=options.tech,bandwidth=options.bandwidth,externVhs=options.externVhs,useCueTags=options.useCueTags,blacklistDuration=options.blacklistDuration,enableLowInitialPlaylist=options.enableLowInitialPlaylist,sourceType=options.sourceType,cacheEncryptionKeys=options.cacheEncryptionKeys,experimentalBufferBasedABR=options.experimentalBufferBasedABR,experimentalLeastPixelDiffSelector=options.experimentalLeastPixelDiffSelector,captionServices=options.captionServices;if(!src){throw new Error('A non-empty playlist URL or JSON manifest string is required');}var maxPlaylistRetries=options.maxPlaylistRetries;if(maxPlaylistRetries===null||typeof maxPlaylistRetries==='undefined'){maxPlaylistRetries=Infinity;}Vhs$1=externVhs;_this.experimentalBufferBasedABR=Boolean(experimentalBufferBasedABR);_this.experimentalLeastPixelDiffSelector=Boolean(experimentalLeastPixelDiffSelector);_this.withCredentials=withCredentials;_this.tech_=tech;_this.vhs_=tech.vhs;_this.sourceType_=sourceType;_this.useCueTags_=useCueTags;_this.blacklistDuration=blacklistDuration;_this.maxPlaylistRetries=maxPlaylistRetries;_this.enableLowInitialPlaylist=enableLowInitialPlaylist;if(_this.useCueTags_){_this.cueTagsTrack_=_this.tech_.addTextTrack('metadata','ad-cues');_this.cueTagsTrack_.inBandMetadataTrackDispatchType='';}_this.requestOptions_={withCredentials:withCredentials,handleManifestRedirects:handleManifestRedirects,maxPlaylistRetries:maxPlaylistRetries,timeout:null};_this.on('error',_this.pauseLoading);_this.mediaTypes_=createMediaTypes();_this.mediaSource=new (window_default()).MediaSource();_this.handleDurationChange_=_this.handleDurationChange_.bind(_assertThisInitialized(_this));_this.handleSourceOpen_=_this.handleSourceOpen_.bind(_assertThisInitialized(_this));_this.handleSourceEnded_=_this.handleSourceEnded_.bind(_assertThisInitialized(_this));_this.mediaSource.addEventListener('durationchange',_this.handleDurationChange_);// load the media source into the player
_this.mediaSource.addEventListener('sourceopen',_this.handleSourceOpen_);_this.mediaSource.addEventListener('sourceended',_this.handleSourceEnded_);// we don't have to handle sourceclose since dispose will handle termination of
// everything, and the MediaSource should not be detached without a proper disposal
_this.seekable_=videojs.createTimeRanges();_this.hasPlayed_=false;_this.syncController_=new SyncController(options);_this.segmentMetadataTrack_=tech.addRemoteTextTrack({kind:'metadata',label:'segment-metadata'},false).track;_this.decrypter_=new Decrypter();_this.sourceUpdater_=new SourceUpdater(_this.mediaSource);_this.inbandTextTracks_={};_this.timelineChangeController_=new TimelineChangeController();var segmentLoaderSettings={vhs:_this.vhs_,parse708captions:options.parse708captions,useDtsForTimestampOffset:options.useDtsForTimestampOffset,captionServices:captionServices,mediaSource:_this.mediaSource,currentTime:_this.tech_.currentTime.bind(_this.tech_),seekable:function seekable(){return _this.seekable();},seeking:function seeking(){return _this.tech_.seeking();},duration:function duration(){return _this.duration();},hasPlayed:function hasPlayed(){return _this.hasPlayed_;},goalBufferLength:function goalBufferLength(){return _this.goalBufferLength();},bandwidth:bandwidth,syncController:_this.syncController_,decrypter:_this.decrypter_,sourceType:_this.sourceType_,inbandTextTracks:_this.inbandTextTracks_,cacheEncryptionKeys:cacheEncryptionKeys,sourceUpdater:_this.sourceUpdater_,timelineChangeController:_this.timelineChangeController_,experimentalExactManifestTimings:options.experimentalExactManifestTimings};// The source type check not only determines whether a special DASH playlist loader
// should be used, but also covers the case where the provided src is a vhs-json
// manifest object (instead of a URL). In the case of vhs-json, the default
// PlaylistLoader should be used.
_this.masterPlaylistLoader_=_this.sourceType_==='dash'?new DashPlaylistLoader(src,_this.vhs_,_this.requestOptions_):new PlaylistLoader(src,_this.vhs_,_this.requestOptions_);_this.setupMasterPlaylistLoaderListeners_();// setup segment loaders
// combined audio/video or just video when alternate audio track is selected
_this.mainSegmentLoader_=new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings,{segmentMetadataTrack:_this.segmentMetadataTrack_,loaderType:'main'}),options);// alternate audio track
_this.audioSegmentLoader_=new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings,{loaderType:'audio'}),options);_this.subtitleSegmentLoader_=new VTTSegmentLoader(videojs.mergeOptions(segmentLoaderSettings,{loaderType:'vtt',featuresNativeTextTracks:_this.tech_.featuresNativeTextTracks,loadVttJs:function loadVttJs(){return new Promise(function(resolve,reject){function onLoad(){tech.off('vttjserror',onError);resolve();}function onError(){tech.off('vttjsloaded',onLoad);reject();}tech.one('vttjsloaded',onLoad);tech.one('vttjserror',onError);// safe to call multiple times, script will be loaded only once:
tech.addWebVttScript_();});}}),options);_this.setupSegmentLoaderListeners_();if(_this.experimentalBufferBasedABR){_this.masterPlaylistLoader_.one('loadedplaylist',function(){return _this.startABRTimer_();});_this.tech_.on('pause',function(){return _this.stopABRTimer_();});_this.tech_.on('play',function(){return _this.startABRTimer_();});}// Create SegmentLoader stat-getters
// mediaRequests_
// mediaRequestsAborted_
// mediaRequestsTimedout_
// mediaRequestsErrored_
// mediaTransferDuration_
// mediaBytesTransferred_
// mediaAppends_
loaderStats.forEach(function(stat){_this[stat+'_']=sumLoaderStat.bind(_assertThisInitialized(_this),stat);});_this.logger_=logger('MPC');_this.triggeredFmp4Usage=false;if(_this.tech_.preload()==='none'){_this.loadOnPlay_=function(){_this.loadOnPlay_=null;_this.masterPlaylistLoader_.load();};_this.tech_.one('play',_this.loadOnPlay_);}else{_this.masterPlaylistLoader_.load();}_this.timeToLoadedData__=-1;_this.mainAppendsToLoadedData__=-1;_this.audioAppendsToLoadedData__=-1;var event=_this.tech_.preload()==='none'?'play':'loadstart';// start the first frame timer on loadstart or play (for preload none)
_this.tech_.one(event,function(){var timeToLoadedDataStart=Date.now();_this.tech_.one('loadeddata',function(){_this.timeToLoadedData__=Date.now()-timeToLoadedDataStart;_this.mainAppendsToLoadedData__=_this.mainSegmentLoader_.mediaAppends;_this.audioAppendsToLoadedData__=_this.audioSegmentLoader_.mediaAppends;});});return _this;}var _proto=MasterPlaylistController.prototype;_proto.mainAppendsToLoadedData_=function mainAppendsToLoadedData_(){return this.mainAppendsToLoadedData__;};_proto.audioAppendsToLoadedData_=function audioAppendsToLoadedData_(){return this.audioAppendsToLoadedData__;};_proto.appendsToLoadedData_=function appendsToLoadedData_(){var main=this.mainAppendsToLoadedData_();var audio=this.audioAppendsToLoadedData_();if(main===-1||audio===-1){return-1;}return main+audio;};_proto.timeToLoadedData_=function timeToLoadedData_(){return this.timeToLoadedData__;}/**
   * Run selectPlaylist and switch to the new playlist if we should
   *
   * @param {string} [reason=abr] a reason for why the ABR check is made
   * @private
   */;_proto.checkABR_=function checkABR_(reason){if(reason===void 0){reason='abr';}var nextPlaylist=this.selectPlaylist();if(nextPlaylist&&this.shouldSwitchToMedia_(nextPlaylist)){this.switchMedia_(nextPlaylist,reason);}};_proto.switchMedia_=function switchMedia_(playlist,cause,delay){var oldMedia=this.media();var oldId=oldMedia&&(oldMedia.id||oldMedia.uri);var newId=playlist.id||playlist.uri;if(oldId&&oldId!==newId){this.logger_("switch media "+oldId+" -> "+newId+" from "+cause);this.tech_.trigger({type:'usage',name:"vhs-rendition-change-"+cause});}this.masterPlaylistLoader_.media(playlist,delay);}/**
   * Start a timer that periodically calls checkABR_
   *
   * @private
   */;_proto.startABRTimer_=function startABRTimer_(){var _this2=this;this.stopABRTimer_();this.abrTimer_=window_default().setInterval(function(){return _this2.checkABR_();},250);}/**
   * Stop the timer that periodically calls checkABR_
   *
   * @private
   */;_proto.stopABRTimer_=function stopABRTimer_(){// if we're scrubbing, we don't need to pause.
// This getter will be added to Video.js in version 7.11.
if(this.tech_.scrubbing&&this.tech_.scrubbing()){return;}window_default().clearInterval(this.abrTimer_);this.abrTimer_=null;}/**
   * Get a list of playlists for the currently selected audio playlist
   *
   * @return {Array} the array of audio playlists
   */;_proto.getAudioTrackPlaylists_=function getAudioTrackPlaylists_(){var master=this.master();var defaultPlaylists=master&&master.playlists||[];// if we don't have any audio groups then we can only
// assume that the audio tracks are contained in masters
// playlist array, use that or an empty array.
if(!master||!master.mediaGroups||!master.mediaGroups.AUDIO){return defaultPlaylists;}var AUDIO=master.mediaGroups.AUDIO;var groupKeys=Object.keys(AUDIO);var track;// get the current active track
if(Object.keys(this.mediaTypes_.AUDIO.groups).length){track=this.mediaTypes_.AUDIO.activeTrack();// or get the default track from master if mediaTypes_ isn't setup yet
}else{// default group is `main` or just the first group.
var defaultGroup=AUDIO.main||groupKeys.length&&AUDIO[groupKeys[0]];for(var label in defaultGroup){if(defaultGroup[label]["default"]){track={label:label};break;}}}// no active track no playlists.
if(!track){return defaultPlaylists;}var playlists=[];// get all of the playlists that are possible for the
// active track.
for(var group in AUDIO){if(AUDIO[group][track.label]){var properties=AUDIO[group][track.label];if(properties.playlists&&properties.playlists.length){playlists.push.apply(playlists,properties.playlists);}else if(properties.uri){playlists.push(properties);}else if(master.playlists.length){// if an audio group does not have a uri
// see if we have main playlists that use it as a group.
// if we do then add those to the playlists list.
for(var i=0;i<master.playlists.length;i++){var playlist=master.playlists[i];if(playlist.attributes&&playlist.attributes.AUDIO&&playlist.attributes.AUDIO===group){playlists.push(playlist);}}}}}if(!playlists.length){return defaultPlaylists;}return playlists;}/**
   * Register event handlers on the master playlist loader. A helper
   * function for construction time.
   *
   * @private
   */;_proto.setupMasterPlaylistLoaderListeners_=function setupMasterPlaylistLoaderListeners_(){var _this3=this;this.masterPlaylistLoader_.on('loadedmetadata',function(){var media=_this3.masterPlaylistLoader_.media();var requestTimeout=media.targetDuration*1.5*1000;// If we don't have any more available playlists, we don't want to
// timeout the request.
if(isLowestEnabledRendition(_this3.masterPlaylistLoader_.master,_this3.masterPlaylistLoader_.media())){_this3.requestOptions_.timeout=0;}else{_this3.requestOptions_.timeout=requestTimeout;}// if this isn't a live video and preload permits, start
// downloading segments
if(media.endList&&_this3.tech_.preload()!=='none'){_this3.mainSegmentLoader_.playlist(media,_this3.requestOptions_);_this3.mainSegmentLoader_.load();}setupMediaGroups({sourceType:_this3.sourceType_,segmentLoaders:{AUDIO:_this3.audioSegmentLoader_,SUBTITLES:_this3.subtitleSegmentLoader_,main:_this3.mainSegmentLoader_},tech:_this3.tech_,requestOptions:_this3.requestOptions_,masterPlaylistLoader:_this3.masterPlaylistLoader_,vhs:_this3.vhs_,master:_this3.master(),mediaTypes:_this3.mediaTypes_,blacklistCurrentPlaylist:_this3.blacklistCurrentPlaylist.bind(_this3)});_this3.triggerPresenceUsage_(_this3.master(),media);_this3.setupFirstPlay();if(!_this3.mediaTypes_.AUDIO.activePlaylistLoader||_this3.mediaTypes_.AUDIO.activePlaylistLoader.media()){_this3.trigger('selectedinitialmedia');}else{// We must wait for the active audio playlist loader to
// finish setting up before triggering this event so the
// representations API and EME setup is correct
_this3.mediaTypes_.AUDIO.activePlaylistLoader.one('loadedmetadata',function(){_this3.trigger('selectedinitialmedia');});}});this.masterPlaylistLoader_.on('loadedplaylist',function(){if(_this3.loadOnPlay_){_this3.tech_.off('play',_this3.loadOnPlay_);}var updatedPlaylist=_this3.masterPlaylistLoader_.media();if(!updatedPlaylist){// exclude any variants that are not supported by the browser before selecting
// an initial media as the playlist selectors do not consider browser support
_this3.excludeUnsupportedVariants_();var selectedMedia;if(_this3.enableLowInitialPlaylist){selectedMedia=_this3.selectInitialPlaylist();}if(!selectedMedia){selectedMedia=_this3.selectPlaylist();}if(!selectedMedia||!_this3.shouldSwitchToMedia_(selectedMedia)){return;}_this3.initialMedia_=selectedMedia;_this3.switchMedia_(_this3.initialMedia_,'initial');// Under the standard case where a source URL is provided, loadedplaylist will
// fire again since the playlist will be requested. In the case of vhs-json
// (where the manifest object is provided as the source), when the media
// playlist's `segments` list is already available, a media playlist won't be
// requested, and loadedplaylist won't fire again, so the playlist handler must be
// called on its own here.
var haveJsonSource=_this3.sourceType_==='vhs-json'&&_this3.initialMedia_.segments;if(!haveJsonSource){return;}updatedPlaylist=_this3.initialMedia_;}_this3.handleUpdatedMediaPlaylist(updatedPlaylist);});this.masterPlaylistLoader_.on('error',function(){_this3.blacklistCurrentPlaylist(_this3.masterPlaylistLoader_.error);});this.masterPlaylistLoader_.on('mediachanging',function(){_this3.mainSegmentLoader_.abort();_this3.mainSegmentLoader_.pause();});this.masterPlaylistLoader_.on('mediachange',function(){var media=_this3.masterPlaylistLoader_.media();var requestTimeout=media.targetDuration*1.5*1000;// If we don't have any more available playlists, we don't want to
// timeout the request.
if(isLowestEnabledRendition(_this3.masterPlaylistLoader_.master,_this3.masterPlaylistLoader_.media())){_this3.requestOptions_.timeout=0;}else{_this3.requestOptions_.timeout=requestTimeout;}_this3.masterPlaylistLoader_.load();// TODO: Create a new event on the PlaylistLoader that signals
// that the segments have changed in some way and use that to
// update the SegmentLoader instead of doing it twice here and
// on `loadedplaylist`
_this3.mainSegmentLoader_.playlist(media,_this3.requestOptions_);_this3.mainSegmentLoader_.load();_this3.tech_.trigger({type:'mediachange',bubbles:true});});this.masterPlaylistLoader_.on('playlistunchanged',function(){var updatedPlaylist=_this3.masterPlaylistLoader_.media();// ignore unchanged playlists that have already been
// excluded for not-changing. We likely just have a really slowly updating
// playlist.
if(updatedPlaylist.lastExcludeReason_==='playlist-unchanged'){return;}var playlistOutdated=_this3.stuckAtPlaylistEnd_(updatedPlaylist);if(playlistOutdated){// Playlist has stopped updating and we're stuck at its end. Try to
// blacklist it and switch to another playlist in the hope that that
// one is updating (and give the player a chance to re-adjust to the
// safe live point).
_this3.blacklistCurrentPlaylist({message:'Playlist no longer updating.',reason:'playlist-unchanged'});// useful for monitoring QoS
_this3.tech_.trigger('playliststuck');}});this.masterPlaylistLoader_.on('renditiondisabled',function(){_this3.tech_.trigger({type:'usage',name:'vhs-rendition-disabled'});_this3.tech_.trigger({type:'usage',name:'hls-rendition-disabled'});});this.masterPlaylistLoader_.on('renditionenabled',function(){_this3.tech_.trigger({type:'usage',name:'vhs-rendition-enabled'});_this3.tech_.trigger({type:'usage',name:'hls-rendition-enabled'});});}/**
   * Given an updated media playlist (whether it was loaded for the first time, or
   * refreshed for live playlists), update any relevant properties and state to reflect
   * changes in the media that should be accounted for (e.g., cues and duration).
   *
   * @param {Object} updatedPlaylist the updated media playlist object
   *
   * @private
   */;_proto.handleUpdatedMediaPlaylist=function handleUpdatedMediaPlaylist(updatedPlaylist){if(this.useCueTags_){this.updateAdCues_(updatedPlaylist);}// TODO: Create a new event on the PlaylistLoader that signals
// that the segments have changed in some way and use that to
// update the SegmentLoader instead of doing it twice here and
// on `mediachange`
this.mainSegmentLoader_.playlist(updatedPlaylist,this.requestOptions_);this.updateDuration(!updatedPlaylist.endList);// If the player isn't paused, ensure that the segment loader is running,
// as it is possible that it was temporarily stopped while waiting for
// a playlist (e.g., in case the playlist errored and we re-requested it).
if(!this.tech_.paused()){this.mainSegmentLoader_.load();if(this.audioSegmentLoader_){this.audioSegmentLoader_.load();}}}/**
   * A helper function for triggerring presence usage events once per source
   *
   * @private
   */;_proto.triggerPresenceUsage_=function triggerPresenceUsage_(master,media){var mediaGroups=master.mediaGroups||{};var defaultDemuxed=true;var audioGroupKeys=Object.keys(mediaGroups.AUDIO);for(var mediaGroup in mediaGroups.AUDIO){for(var label in mediaGroups.AUDIO[mediaGroup]){var properties=mediaGroups.AUDIO[mediaGroup][label];if(!properties.uri){defaultDemuxed=false;}}}if(defaultDemuxed){this.tech_.trigger({type:'usage',name:'vhs-demuxed'});this.tech_.trigger({type:'usage',name:'hls-demuxed'});}if(Object.keys(mediaGroups.SUBTITLES).length){this.tech_.trigger({type:'usage',name:'vhs-webvtt'});this.tech_.trigger({type:'usage',name:'hls-webvtt'});}if(Vhs$1.Playlist.isAes(media)){this.tech_.trigger({type:'usage',name:'vhs-aes'});this.tech_.trigger({type:'usage',name:'hls-aes'});}if(audioGroupKeys.length&&Object.keys(mediaGroups.AUDIO[audioGroupKeys[0]]).length>1){this.tech_.trigger({type:'usage',name:'vhs-alternate-audio'});this.tech_.trigger({type:'usage',name:'hls-alternate-audio'});}if(this.useCueTags_){this.tech_.trigger({type:'usage',name:'vhs-playlist-cue-tags'});this.tech_.trigger({type:'usage',name:'hls-playlist-cue-tags'});}};_proto.shouldSwitchToMedia_=function shouldSwitchToMedia_(nextPlaylist){var currentPlaylist=this.masterPlaylistLoader_.media()||this.masterPlaylistLoader_.pendingMedia_;var currentTime=this.tech_.currentTime();var bufferLowWaterLine=this.bufferLowWaterLine();var bufferHighWaterLine=this.bufferHighWaterLine();var buffered=this.tech_.buffered();return shouldSwitchToMedia({buffered:buffered,currentTime:currentTime,currentPlaylist:currentPlaylist,nextPlaylist:nextPlaylist,bufferLowWaterLine:bufferLowWaterLine,bufferHighWaterLine:bufferHighWaterLine,duration:this.duration(),experimentalBufferBasedABR:this.experimentalBufferBasedABR,log:this.logger_});}/**
   * Register event handlers on the segment loaders. A helper function
   * for construction time.
   *
   * @private
   */;_proto.setupSegmentLoaderListeners_=function setupSegmentLoaderListeners_(){var _this4=this;this.mainSegmentLoader_.on('bandwidthupdate',function(){// Whether or not buffer based ABR or another ABR is used, on a bandwidth change it's
// useful to check to see if a rendition switch should be made.
_this4.checkABR_('bandwidthupdate');_this4.tech_.trigger('bandwidthupdate');});this.mainSegmentLoader_.on('timeout',function(){if(_this4.experimentalBufferBasedABR){// If a rendition change is needed, then it would've be done on `bandwidthupdate`.
// Here the only consideration is that for buffer based ABR there's no guarantee
// of an immediate switch (since the bandwidth is averaged with a timeout
// bandwidth value of 1), so force a load on the segment loader to keep it going.
_this4.mainSegmentLoader_.load();}});// `progress` events are not reliable enough of a bandwidth measure to trigger buffer
// based ABR.
if(!this.experimentalBufferBasedABR){this.mainSegmentLoader_.on('progress',function(){_this4.trigger('progress');});}this.mainSegmentLoader_.on('error',function(){_this4.blacklistCurrentPlaylist(_this4.mainSegmentLoader_.error());});this.mainSegmentLoader_.on('appenderror',function(){_this4.error=_this4.mainSegmentLoader_.error_;_this4.trigger('error');});this.mainSegmentLoader_.on('syncinfoupdate',function(){_this4.onSyncInfoUpdate_();});this.mainSegmentLoader_.on('timestampoffset',function(){_this4.tech_.trigger({type:'usage',name:'vhs-timestamp-offset'});_this4.tech_.trigger({type:'usage',name:'hls-timestamp-offset'});});this.audioSegmentLoader_.on('syncinfoupdate',function(){_this4.onSyncInfoUpdate_();});this.audioSegmentLoader_.on('appenderror',function(){_this4.error=_this4.audioSegmentLoader_.error_;_this4.trigger('error');});this.mainSegmentLoader_.on('ended',function(){_this4.logger_('main segment loader ended');_this4.onEndOfStream();});this.mainSegmentLoader_.on('earlyabort',function(event){// never try to early abort with the new ABR algorithm
if(_this4.experimentalBufferBasedABR){return;}_this4.delegateLoaders_('all',['abort']);_this4.blacklistCurrentPlaylist({message:'Aborted early because there isn\'t enough bandwidth to complete the '+'request without rebuffering.'},ABORT_EARLY_BLACKLIST_SECONDS);});var updateCodecs=function updateCodecs(){if(!_this4.sourceUpdater_.hasCreatedSourceBuffers()){return _this4.tryToCreateSourceBuffers_();}var codecs=_this4.getCodecsOrExclude_();// no codecs means that the playlist was excluded
if(!codecs){return;}_this4.sourceUpdater_.addOrChangeSourceBuffers(codecs);};this.mainSegmentLoader_.on('trackinfo',updateCodecs);this.audioSegmentLoader_.on('trackinfo',updateCodecs);this.mainSegmentLoader_.on('fmp4',function(){if(!_this4.triggeredFmp4Usage){_this4.tech_.trigger({type:'usage',name:'vhs-fmp4'});_this4.tech_.trigger({type:'usage',name:'hls-fmp4'});_this4.triggeredFmp4Usage=true;}});this.audioSegmentLoader_.on('fmp4',function(){if(!_this4.triggeredFmp4Usage){_this4.tech_.trigger({type:'usage',name:'vhs-fmp4'});_this4.tech_.trigger({type:'usage',name:'hls-fmp4'});_this4.triggeredFmp4Usage=true;}});this.audioSegmentLoader_.on('ended',function(){_this4.logger_('audioSegmentLoader ended');_this4.onEndOfStream();});};_proto.mediaSecondsLoaded_=function mediaSecondsLoaded_(){return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded+this.mainSegmentLoader_.mediaSecondsLoaded);}/**
   * Call load on our SegmentLoaders
   */;_proto.load=function load(){this.mainSegmentLoader_.load();if(this.mediaTypes_.AUDIO.activePlaylistLoader){this.audioSegmentLoader_.load();}if(this.mediaTypes_.SUBTITLES.activePlaylistLoader){this.subtitleSegmentLoader_.load();}}/**
   * Re-tune playback quality level for the current player
   * conditions without performing destructive actions, like
   * removing already buffered content
   *
   * @private
   * @deprecated
   */;_proto.smoothQualityChange_=function smoothQualityChange_(media){if(media===void 0){media=this.selectPlaylist();}this.fastQualityChange_(media);}/**
   * Re-tune playback quality level for the current player
   * conditions. This method will perform destructive actions like removing
   * already buffered content in order to readjust the currently active
   * playlist quickly. This is good for manual quality changes
   *
   * @private
   */;_proto.fastQualityChange_=function fastQualityChange_(media){var _this5=this;if(media===void 0){media=this.selectPlaylist();}if(media===this.masterPlaylistLoader_.media()){this.logger_('skipping fastQualityChange because new media is same as old');return;}this.switchMedia_(media,'fast-quality');// Delete all buffered data to allow an immediate quality switch, then seek to give
// the browser a kick to remove any cached frames from the previous rendtion (.04 seconds
// ahead is roughly the minimum that will accomplish this across a variety of content
// in IE and Edge, but seeking in place is sufficient on all other browsers)
// Edge/IE bug: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/14600375/
// Chrome bug: https://bugs.chromium.org/p/chromium/issues/detail?id=651904
this.mainSegmentLoader_.resetEverything(function(){// Since this is not a typical seek, we avoid the seekTo method which can cause segments
// from the previously enabled rendition to load before the new playlist has finished loading
if(videojs.browser.IE_VERSION||videojs.browser.IS_EDGE){_this5.tech_.setCurrentTime(_this5.tech_.currentTime()+0.04);}else{_this5.tech_.setCurrentTime(_this5.tech_.currentTime());}});// don't need to reset audio as it is reset when media changes
}/**
   * Begin playback.
   */;_proto.play=function play(){if(this.setupFirstPlay()){return;}if(this.tech_.ended()){this.tech_.setCurrentTime(0);}if(this.hasPlayed_){this.load();}var seekable=this.tech_.seekable();// if the viewer has paused and we fell out of the live window,
// seek forward to the live point
if(this.tech_.duration()===Infinity){if(this.tech_.currentTime()<seekable.start(0)){return this.tech_.setCurrentTime(seekable.end(seekable.length-1));}}}/**
   * Seek to the latest media position if this is a live video and the
   * player and video are loaded and initialized.
   */;_proto.setupFirstPlay=function setupFirstPlay(){var _this6=this;var media=this.masterPlaylistLoader_.media();// Check that everything is ready to begin buffering for the first call to play
//  If 1) there is no active media
//     2) the player is paused
//     3) the first play has already been setup
// then exit early
if(!media||this.tech_.paused()||this.hasPlayed_){return false;}// when the video is a live stream
if(!media.endList){var seekable=this.seekable();if(!seekable.length){// without a seekable range, the player cannot seek to begin buffering at the live
// point
return false;}if(videojs.browser.IE_VERSION&&this.tech_.readyState()===0){// IE11 throws an InvalidStateError if you try to set currentTime while the
// readyState is 0, so it must be delayed until the tech fires loadedmetadata.
this.tech_.one('loadedmetadata',function(){_this6.trigger('firstplay');_this6.tech_.setCurrentTime(seekable.end(0));_this6.hasPlayed_=true;});return false;}// trigger firstplay to inform the source handler to ignore the next seek event
this.trigger('firstplay');// seek to the live point
this.tech_.setCurrentTime(seekable.end(0));}this.hasPlayed_=true;// we can begin loading now that everything is ready
this.load();return true;}/**
   * handle the sourceopen event on the MediaSource
   *
   * @private
   */;_proto.handleSourceOpen_=function handleSourceOpen_(){// Only attempt to create the source buffer if none already exist.
// handleSourceOpen is also called when we are "re-opening" a source buffer
// after `endOfStream` has been called (in response to a seek for instance)
this.tryToCreateSourceBuffers_();// if autoplay is enabled, begin playback. This is duplicative of
// code in video.js but is required because play() must be invoked
// *after* the media source has opened.
if(this.tech_.autoplay()){var playPromise=this.tech_.play();// Catch/silence error when a pause interrupts a play request
// on browsers which return a promise
if(typeof playPromise!=='undefined'&&typeof playPromise.then==='function'){playPromise.then(null,function(e){});}}this.trigger('sourceopen');}/**
   * handle the sourceended event on the MediaSource
   *
   * @private
   */;_proto.handleSourceEnded_=function handleSourceEnded_(){if(!this.inbandTextTracks_.metadataTrack_){return;}var cues=this.inbandTextTracks_.metadataTrack_.cues;if(!cues||!cues.length){return;}var duration=this.duration();cues[cues.length-1].endTime=isNaN(duration)||Math.abs(duration)===Infinity?Number.MAX_VALUE:duration;}/**
   * handle the durationchange event on the MediaSource
   *
   * @private
   */;_proto.handleDurationChange_=function handleDurationChange_(){this.tech_.trigger('durationchange');}/**
   * Calls endOfStream on the media source when all active stream types have called
   * endOfStream
   *
   * @param {string} streamType
   *        Stream type of the segment loader that called endOfStream
   * @private
   */;_proto.onEndOfStream=function onEndOfStream(){var isEndOfStream=this.mainSegmentLoader_.ended_;if(this.mediaTypes_.AUDIO.activePlaylistLoader){var mainMediaInfo=this.mainSegmentLoader_.getCurrentMediaInfo_();// if the audio playlist loader exists, then alternate audio is active
if(!mainMediaInfo||mainMediaInfo.hasVideo){// if we do not know if the main segment loader contains video yet or if we
// definitively know the main segment loader contains video, then we need to wait
// for both main and audio segment loaders to call endOfStream
isEndOfStream=isEndOfStream&&this.audioSegmentLoader_.ended_;}else{// otherwise just rely on the audio loader
isEndOfStream=this.audioSegmentLoader_.ended_;}}if(!isEndOfStream){return;}this.stopABRTimer_();this.sourceUpdater_.endOfStream();}/**
   * Check if a playlist has stopped being updated
   *
   * @param {Object} playlist the media playlist object
   * @return {boolean} whether the playlist has stopped being updated or not
   */;_proto.stuckAtPlaylistEnd_=function stuckAtPlaylistEnd_(playlist){var seekable=this.seekable();if(!seekable.length){// playlist doesn't have enough information to determine whether we are stuck
return false;}var expired=this.syncController_.getExpiredTime(playlist,this.duration());if(expired===null){return false;}// does not use the safe live end to calculate playlist end, since we
// don't want to say we are stuck while there is still content
var absolutePlaylistEnd=Vhs$1.Playlist.playlistEnd(playlist,expired);var currentTime=this.tech_.currentTime();var buffered=this.tech_.buffered();if(!buffered.length){// return true if the playhead reached the absolute end of the playlist
return absolutePlaylistEnd-currentTime<=SAFE_TIME_DELTA;}var bufferedEnd=buffered.end(buffered.length-1);// return true if there is too little buffer left and buffer has reached absolute
// end of playlist
return bufferedEnd-currentTime<=SAFE_TIME_DELTA&&absolutePlaylistEnd-bufferedEnd<=SAFE_TIME_DELTA;}/**
   * Blacklists a playlist when an error occurs for a set amount of time
   * making it unavailable for selection by the rendition selection algorithm
   * and then forces a new playlist (rendition) selection.
   *
   * @param {Object=} error an optional error that may include the playlist
   * to blacklist
   * @param {number=} blacklistDuration an optional number of seconds to blacklist the
   * playlist
   */;_proto.blacklistCurrentPlaylist=function blacklistCurrentPlaylist(error,blacklistDuration){if(error===void 0){error={};}// If the `error` was generated by the playlist loader, it will contain
// the playlist we were trying to load (but failed) and that should be
// blacklisted instead of the currently selected playlist which is likely
// out-of-date in this scenario
var currentPlaylist=error.playlist||this.masterPlaylistLoader_.media();blacklistDuration=blacklistDuration||error.blacklistDuration||this.blacklistDuration;// If there is no current playlist, then an error occurred while we were
// trying to load the master OR while we were disposing of the tech
if(!currentPlaylist){this.error=error;if(this.mediaSource.readyState!=='open'){this.trigger('error');}else{this.sourceUpdater_.endOfStream('network');}return;}currentPlaylist.playlistErrors_++;var playlists=this.masterPlaylistLoader_.master.playlists;var enabledPlaylists=playlists.filter(isEnabled);var isFinalRendition=enabledPlaylists.length===1&&enabledPlaylists[0]===currentPlaylist;// Don't blacklist the only playlist unless it was blacklisted
// forever
if(playlists.length===1&&blacklistDuration!==Infinity){videojs.log.warn("Problem encountered with playlist "+currentPlaylist.id+". "+'Trying again since it is the only playlist.');this.tech_.trigger('retryplaylist');// if this is a final rendition, we should delay
return this.masterPlaylistLoader_.load(isFinalRendition);}if(isFinalRendition){// Since we're on the final non-blacklisted playlist, and we're about to blacklist
// it, instead of erring the player or retrying this playlist, clear out the current
// blacklist. This allows other playlists to be attempted in case any have been
// fixed.
var reincluded=false;playlists.forEach(function(playlist){// skip current playlist which is about to be blacklisted
if(playlist===currentPlaylist){return;}var excludeUntil=playlist.excludeUntil;// a playlist cannot be reincluded if it wasn't excluded to begin with.
if(typeof excludeUntil!=='undefined'&&excludeUntil!==Infinity){reincluded=true;delete playlist.excludeUntil;}});if(reincluded){videojs.log.warn('Removing other playlists from the exclusion list because the last '+'rendition is about to be excluded.');// Technically we are retrying a playlist, in that we are simply retrying a previous
// playlist. This is needed for users relying on the retryplaylist event to catch a
// case where the player might be stuck and looping through "dead" playlists.
this.tech_.trigger('retryplaylist');}}// Blacklist this playlist
var excludeUntil;if(currentPlaylist.playlistErrors_>this.maxPlaylistRetries){excludeUntil=Infinity;}else{excludeUntil=Date.now()+blacklistDuration*1000;}currentPlaylist.excludeUntil=excludeUntil;if(error.reason){currentPlaylist.lastExcludeReason_=error.reason;}this.tech_.trigger('blacklistplaylist');this.tech_.trigger({type:'usage',name:'vhs-rendition-blacklisted'});this.tech_.trigger({type:'usage',name:'hls-rendition-blacklisted'});// TODO: should we select a new playlist if this blacklist wasn't for the currentPlaylist?
// Would be something like media().id !=== currentPlaylist.id and we  would need something
// like `pendingMedia` in playlist loaders to check against that too. This will prevent us
// from loading a new playlist on any blacklist.
// Select a new playlist
var nextPlaylist=this.selectPlaylist();if(!nextPlaylist){this.error='Playback cannot continue. No available working or supported playlists.';this.trigger('error');return;}var logFn=error.internal?this.logger_:videojs.log.warn;var errorMessage=error.message?' '+error.message:'';logFn((error.internal?'Internal problem':'Problem')+" encountered with playlist "+currentPlaylist.id+"."+(errorMessage+" Switching to playlist "+nextPlaylist.id+"."));// if audio group changed reset audio loaders
if(nextPlaylist.attributes.AUDIO!==currentPlaylist.attributes.AUDIO){this.delegateLoaders_('audio',['abort','pause']);}// if subtitle group changed reset subtitle loaders
if(nextPlaylist.attributes.SUBTITLES!==currentPlaylist.attributes.SUBTITLES){this.delegateLoaders_('subtitle',['abort','pause']);}this.delegateLoaders_('main',['abort','pause']);var delayDuration=nextPlaylist.targetDuration/2*1000||5*1000;var shouldDelay=typeof nextPlaylist.lastRequest==='number'&&Date.now()-nextPlaylist.lastRequest<=delayDuration;// delay if it's a final rendition or if the last refresh is sooner than half targetDuration
return this.switchMedia_(nextPlaylist,'exclude',isFinalRendition||shouldDelay);}/**
   * Pause all segment/playlist loaders
   */;_proto.pauseLoading=function pauseLoading(){this.delegateLoaders_('all',['abort','pause']);this.stopABRTimer_();}/**
   * Call a set of functions in order on playlist loaders, segment loaders,
   * or both types of loaders.
   *
   * @param {string} filter
   *        Filter loaders that should call fnNames using a string. Can be:
   *        * all - run on all loaders
   *        * audio - run on all audio loaders
   *        * subtitle - run on all subtitle loaders
   *        * main - run on the main/master loaders
   *
   * @param {Array|string} fnNames
   *        A string or array of function names to call.
   */;_proto.delegateLoaders_=function delegateLoaders_(filter,fnNames){var _this7=this;var loaders=[];var dontFilterPlaylist=filter==='all';if(dontFilterPlaylist||filter==='main'){loaders.push(this.masterPlaylistLoader_);}var mediaTypes=[];if(dontFilterPlaylist||filter==='audio'){mediaTypes.push('AUDIO');}if(dontFilterPlaylist||filter==='subtitle'){mediaTypes.push('CLOSED-CAPTIONS');mediaTypes.push('SUBTITLES');}mediaTypes.forEach(function(mediaType){var loader=_this7.mediaTypes_[mediaType]&&_this7.mediaTypes_[mediaType].activePlaylistLoader;if(loader){loaders.push(loader);}});['main','audio','subtitle'].forEach(function(name){var loader=_this7[name+"SegmentLoader_"];if(loader&&(filter===name||filter==='all')){loaders.push(loader);}});loaders.forEach(function(loader){return fnNames.forEach(function(fnName){if(typeof loader[fnName]==='function'){loader[fnName]();}});});}/**
   * set the current time on all segment loaders
   *
   * @param {TimeRange} currentTime the current time to set
   * @return {TimeRange} the current time
   */;_proto.setCurrentTime=function setCurrentTime(currentTime){var buffered=findRange(this.tech_.buffered(),currentTime);if(!(this.masterPlaylistLoader_&&this.masterPlaylistLoader_.media())){// return immediately if the metadata is not ready yet
return 0;}// it's clearly an edge-case but don't thrown an error if asked to
// seek within an empty playlist
if(!this.masterPlaylistLoader_.media().segments){return 0;}// if the seek location is already buffered, continue buffering as usual
if(buffered&&buffered.length){return currentTime;}// cancel outstanding requests so we begin buffering at the new
// location
this.mainSegmentLoader_.resetEverything();this.mainSegmentLoader_.abort();if(this.mediaTypes_.AUDIO.activePlaylistLoader){this.audioSegmentLoader_.resetEverything();this.audioSegmentLoader_.abort();}if(this.mediaTypes_.SUBTITLES.activePlaylistLoader){this.subtitleSegmentLoader_.resetEverything();this.subtitleSegmentLoader_.abort();}// start segment loader loading in case they are paused
this.load();}/**
   * get the current duration
   *
   * @return {TimeRange} the duration
   */;_proto.duration=function duration(){if(!this.masterPlaylistLoader_){return 0;}var media=this.masterPlaylistLoader_.media();if(!media){// no playlists loaded yet, so can't determine a duration
return 0;}// Don't rely on the media source for duration in the case of a live playlist since
// setting the native MediaSource's duration to infinity ends up with consequences to
// seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
//
// This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
// however, few browsers have support for setLiveSeekableRange()
// https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
//
// Until a time when the duration of the media source can be set to infinity, and a
// seekable range specified across browsers, just return Infinity.
if(!media.endList){return Infinity;}// Since this is a VOD video, it is safe to rely on the media source's duration (if
// available). If it's not available, fall back to a playlist-calculated estimate.
if(this.mediaSource){return this.mediaSource.duration;}return Vhs$1.Playlist.duration(media);}/**
   * check the seekable range
   *
   * @return {TimeRange} the seekable range
   */;_proto.seekable=function seekable(){return this.seekable_;};_proto.onSyncInfoUpdate_=function onSyncInfoUpdate_(){var audioSeekable;// TODO check for creation of both source buffers before updating seekable
//
// A fix was made to this function where a check for
// this.sourceUpdater_.hasCreatedSourceBuffers
// was added to ensure that both source buffers were created before seekable was
// updated. However, it originally had a bug where it was checking for a true and
// returning early instead of checking for false. Setting it to check for false to
// return early though created other issues. A call to play() would check for seekable
// end without verifying that a seekable range was present. In addition, even checking
// for that didn't solve some issues, as handleFirstPlay is sometimes worked around
// due to a media update calling load on the segment loaders, skipping a seek to live,
// thereby starting live streams at the beginning of the stream rather than at the end.
//
// This conditional should be fixed to wait for the creation of two source buffers at
// the same time as the other sections of code are fixed to properly seek to live and
// not throw an error due to checking for a seekable end when no seekable range exists.
//
// For now, fall back to the older behavior, with the understanding that the seekable
// range may not be completely correct, leading to a suboptimal initial live point.
if(!this.masterPlaylistLoader_){return;}var media=this.masterPlaylistLoader_.media();if(!media){return;}var expired=this.syncController_.getExpiredTime(media,this.duration());if(expired===null){// not enough information to update seekable
return;}var master=this.masterPlaylistLoader_.master;var mainSeekable=Vhs$1.Playlist.seekable(media,expired,Vhs$1.Playlist.liveEdgeDelay(master,media));if(mainSeekable.length===0){return;}if(this.mediaTypes_.AUDIO.activePlaylistLoader){media=this.mediaTypes_.AUDIO.activePlaylistLoader.media();expired=this.syncController_.getExpiredTime(media,this.duration());if(expired===null){return;}audioSeekable=Vhs$1.Playlist.seekable(media,expired,Vhs$1.Playlist.liveEdgeDelay(master,media));if(audioSeekable.length===0){return;}}var oldEnd;var oldStart;if(this.seekable_&&this.seekable_.length){oldEnd=this.seekable_.end(0);oldStart=this.seekable_.start(0);}if(!audioSeekable){// seekable has been calculated based on buffering video data so it
// can be returned directly
this.seekable_=mainSeekable;}else if(audioSeekable.start(0)>mainSeekable.end(0)||mainSeekable.start(0)>audioSeekable.end(0)){// seekables are pretty far off, rely on main
this.seekable_=mainSeekable;}else{this.seekable_=videojs.createTimeRanges([[audioSeekable.start(0)>mainSeekable.start(0)?audioSeekable.start(0):mainSeekable.start(0),audioSeekable.end(0)<mainSeekable.end(0)?audioSeekable.end(0):mainSeekable.end(0)]]);}// seekable is the same as last time
if(this.seekable_&&this.seekable_.length){if(this.seekable_.end(0)===oldEnd&&this.seekable_.start(0)===oldStart){return;}}this.logger_("seekable updated ["+printableRange(this.seekable_)+"]");this.tech_.trigger('seekablechanged');}/**
   * Update the player duration
   */;_proto.updateDuration=function updateDuration(isLive){if(this.updateDuration_){this.mediaSource.removeEventListener('sourceopen',this.updateDuration_);this.updateDuration_=null;}if(this.mediaSource.readyState!=='open'){this.updateDuration_=this.updateDuration.bind(this,isLive);this.mediaSource.addEventListener('sourceopen',this.updateDuration_);return;}if(isLive){var seekable=this.seekable();if(!seekable.length){return;}// Even in the case of a live playlist, the native MediaSource's duration should not
// be set to Infinity (even though this would be expected for a live playlist), since
// setting the native MediaSource's duration to infinity ends up with consequences to
// seekable behavior. See https://github.com/w3c/media-source/issues/5 for details.
//
// This is resolved in the spec by https://github.com/w3c/media-source/pull/92,
// however, few browsers have support for setLiveSeekableRange()
// https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/setLiveSeekableRange
//
// Until a time when the duration of the media source can be set to infinity, and a
// seekable range specified across browsers, the duration should be greater than or
// equal to the last possible seekable value.
// MediaSource duration starts as NaN
// It is possible (and probable) that this case will never be reached for many
// sources, since the MediaSource reports duration as the highest value without
// accounting for timestamp offset. For example, if the timestamp offset is -100 and
// we buffered times 0 to 100 with real times of 100 to 200, even though current
// time will be between 0 and 100, the native media source may report the duration
// as 200. However, since we report duration separate from the media source (as
// Infinity), and as long as the native media source duration value is greater than
// our reported seekable range, seeks will work as expected. The large number as
// duration for live is actually a strategy used by some players to work around the
// issue of live seekable ranges cited above.
if(isNaN(this.mediaSource.duration)||this.mediaSource.duration<seekable.end(seekable.length-1)){this.sourceUpdater_.setDuration(seekable.end(seekable.length-1));}return;}var buffered=this.tech_.buffered();var duration=Vhs$1.Playlist.duration(this.masterPlaylistLoader_.media());if(buffered.length>0){duration=Math.max(duration,buffered.end(buffered.length-1));}if(this.mediaSource.duration!==duration){this.sourceUpdater_.setDuration(duration);}}/**
   * dispose of the MasterPlaylistController and everything
   * that it controls
   */;_proto.dispose=function dispose(){var _this8=this;this.trigger('dispose');this.decrypter_.terminate();this.masterPlaylistLoader_.dispose();this.mainSegmentLoader_.dispose();if(this.loadOnPlay_){this.tech_.off('play',this.loadOnPlay_);}['AUDIO','SUBTITLES'].forEach(function(type){var groups=_this8.mediaTypes_[type].groups;for(var id in groups){groups[id].forEach(function(group){if(group.playlistLoader){group.playlistLoader.dispose();}});}});this.audioSegmentLoader_.dispose();this.subtitleSegmentLoader_.dispose();this.sourceUpdater_.dispose();this.timelineChangeController_.dispose();this.stopABRTimer_();if(this.updateDuration_){this.mediaSource.removeEventListener('sourceopen',this.updateDuration_);}this.mediaSource.removeEventListener('durationchange',this.handleDurationChange_);// load the media source into the player
this.mediaSource.removeEventListener('sourceopen',this.handleSourceOpen_);this.mediaSource.removeEventListener('sourceended',this.handleSourceEnded_);this.off();}/**
   * return the master playlist object if we have one
   *
   * @return {Object} the master playlist object that we parsed
   */;_proto.master=function master(){return this.masterPlaylistLoader_.master;}/**
   * return the currently selected playlist
   *
   * @return {Object} the currently selected playlist object that we parsed
   */;_proto.media=function media(){// playlist loader will not return media if it has not been fully loaded
return this.masterPlaylistLoader_.media()||this.initialMedia_;};_proto.areMediaTypesKnown_=function areMediaTypesKnown_(){var usingAudioLoader=!!this.mediaTypes_.AUDIO.activePlaylistLoader;var hasMainMediaInfo=!!this.mainSegmentLoader_.getCurrentMediaInfo_();// if we are not using an audio loader, then we have audio media info
// otherwise check on the segment loader.
var hasAudioMediaInfo=!usingAudioLoader?true:!!this.audioSegmentLoader_.getCurrentMediaInfo_();// one or both loaders has not loaded sufficently to get codecs
if(!hasMainMediaInfo||!hasAudioMediaInfo){return false;}return true;};_proto.getCodecsOrExclude_=function getCodecsOrExclude_(){var _this9=this;var media={main:this.mainSegmentLoader_.getCurrentMediaInfo_()||{},audio:this.audioSegmentLoader_.getCurrentMediaInfo_()||{}};var playlist=this.mainSegmentLoader_.getPendingSegmentPlaylist()||this.media();// set "main" media equal to video
media.video=media.main;var playlistCodecs=codecsForPlaylist(this.master(),playlist);var codecs={};var usingAudioLoader=!!this.mediaTypes_.AUDIO.activePlaylistLoader;if(media.main.hasVideo){codecs.video=playlistCodecs.video||media.main.videoCodec||DEFAULT_VIDEO_CODEC;}if(media.main.isMuxed){codecs.video+=","+(playlistCodecs.audio||media.main.audioCodec||DEFAULT_AUDIO_CODEC);}if(media.main.hasAudio&&!media.main.isMuxed||media.audio.hasAudio||usingAudioLoader){codecs.audio=playlistCodecs.audio||media.main.audioCodec||media.audio.audioCodec||DEFAULT_AUDIO_CODEC;// set audio isFmp4 so we use the correct "supports" function below
media.audio.isFmp4=media.main.hasAudio&&!media.main.isMuxed?media.main.isFmp4:media.audio.isFmp4;}// no codecs, no playback.
if(!codecs.audio&&!codecs.video){this.blacklistCurrentPlaylist({playlist:playlist,message:'Could not determine codecs for playlist.',blacklistDuration:Infinity});return;}// fmp4 relies on browser support, while ts relies on muxer support
var supportFunction=function supportFunction(isFmp4,codec){return isFmp4?browserSupportsCodec(codec):muxerSupportsCodec(codec);};var unsupportedCodecs={};var unsupportedAudio;['video','audio'].forEach(function(type){if(codecs.hasOwnProperty(type)&&!supportFunction(media[type].isFmp4,codecs[type])){var supporter=media[type].isFmp4?'browser':'muxer';unsupportedCodecs[supporter]=unsupportedCodecs[supporter]||[];unsupportedCodecs[supporter].push(codecs[type]);if(type==='audio'){unsupportedAudio=supporter;}}});if(usingAudioLoader&&unsupportedAudio&&playlist.attributes.AUDIO){var audioGroup=playlist.attributes.AUDIO;this.master().playlists.forEach(function(variant){var variantAudioGroup=variant.attributes&&variant.attributes.AUDIO;if(variantAudioGroup===audioGroup&&variant!==playlist){variant.excludeUntil=Infinity;}});this.logger_("excluding audio group "+audioGroup+" as "+unsupportedAudio+" does not support codec(s): \""+codecs.audio+"\"");}// if we have any unsupported codecs blacklist this playlist.
if(Object.keys(unsupportedCodecs).length){var message=Object.keys(unsupportedCodecs).reduce(function(acc,supporter){if(acc){acc+=', ';}acc+=supporter+" does not support codec(s): \""+unsupportedCodecs[supporter].join(',')+"\"";return acc;},'')+'.';this.blacklistCurrentPlaylist({playlist:playlist,internal:true,message:message,blacklistDuration:Infinity});return;}// check if codec switching is happening
if(this.sourceUpdater_.hasCreatedSourceBuffers()&&!this.sourceUpdater_.canChangeType()){var switchMessages=[];['video','audio'].forEach(function(type){var newCodec=(parseCodecs(_this9.sourceUpdater_.codecs[type]||'')[0]||{}).type;var oldCodec=(parseCodecs(codecs[type]||'')[0]||{}).type;if(newCodec&&oldCodec&&newCodec.toLowerCase()!==oldCodec.toLowerCase()){switchMessages.push("\""+_this9.sourceUpdater_.codecs[type]+"\" -> \""+codecs[type]+"\"");}});if(switchMessages.length){this.blacklistCurrentPlaylist({playlist:playlist,message:"Codec switching not supported: "+switchMessages.join(', ')+".",blacklistDuration:Infinity,internal:true});return;}}// TODO: when using the muxer shouldn't we just return
// the codecs that the muxer outputs?
return codecs;}/**
   * Create source buffers and exlude any incompatible renditions.
   *
   * @private
   */;_proto.tryToCreateSourceBuffers_=function tryToCreateSourceBuffers_(){// media source is not ready yet or sourceBuffers are already
// created.
if(this.mediaSource.readyState!=='open'||this.sourceUpdater_.hasCreatedSourceBuffers()){return;}if(!this.areMediaTypesKnown_()){return;}var codecs=this.getCodecsOrExclude_();// no codecs means that the playlist was excluded
if(!codecs){return;}this.sourceUpdater_.createSourceBuffers(codecs);var codecString=[codecs.video,codecs.audio].filter(Boolean).join(',');this.excludeIncompatibleVariants_(codecString);}/**
   * Excludes playlists with codecs that are unsupported by the muxer and browser.
   */;_proto.excludeUnsupportedVariants_=function excludeUnsupportedVariants_(){var _this10=this;var playlists=this.master().playlists;var ids=[];// TODO: why don't we have a property to loop through all
// playlist? Why did we ever mix indexes and keys?
Object.keys(playlists).forEach(function(key){var variant=playlists[key];// check if we already processed this playlist.
if(ids.indexOf(variant.id)!==-1){return;}ids.push(variant.id);var codecs=codecsForPlaylist(_this10.master,variant);var unsupported=[];if(codecs.audio&&!muxerSupportsCodec(codecs.audio)&&!browserSupportsCodec(codecs.audio)){unsupported.push("audio codec "+codecs.audio);}if(codecs.video&&!muxerSupportsCodec(codecs.video)&&!browserSupportsCodec(codecs.video)){unsupported.push("video codec "+codecs.video);}if(codecs.text&&codecs.text==='stpp.ttml.im1t'){unsupported.push("text codec "+codecs.text);}if(unsupported.length){variant.excludeUntil=Infinity;_this10.logger_("excluding "+variant.id+" for unsupported: "+unsupported.join(', '));}});}/**
   * Blacklist playlists that are known to be codec or
   * stream-incompatible with the SourceBuffer configuration. For
   * instance, Media Source Extensions would cause the video element to
   * stall waiting for video data if you switched from a variant with
   * video and audio to an audio-only one.
   *
   * @param {Object} media a media playlist compatible with the current
   * set of SourceBuffers. Variants in the current master playlist that
   * do not appear to have compatible codec or stream configurations
   * will be excluded from the default playlist selection algorithm
   * indefinitely.
   * @private
   */;_proto.excludeIncompatibleVariants_=function excludeIncompatibleVariants_(codecString){var _this11=this;var ids=[];var playlists=this.master().playlists;var codecs=unwrapCodecList(parseCodecs(codecString));var codecCount_=codecCount(codecs);var videoDetails=codecs.video&&parseCodecs(codecs.video)[0]||null;var audioDetails=codecs.audio&&parseCodecs(codecs.audio)[0]||null;Object.keys(playlists).forEach(function(key){var variant=playlists[key];// check if we already processed this playlist.
// or it if it is already excluded forever.
if(ids.indexOf(variant.id)!==-1||variant.excludeUntil===Infinity){return;}ids.push(variant.id);var blacklistReasons=[];// get codecs from the playlist for this variant
var variantCodecs=codecsForPlaylist(_this11.masterPlaylistLoader_.master,variant);var variantCodecCount=codecCount(variantCodecs);// if no codecs are listed, we cannot determine that this
// variant is incompatible. Wait for mux.js to probe
if(!variantCodecs.audio&&!variantCodecs.video){return;}// TODO: we can support this by removing the
// old media source and creating a new one, but it will take some work.
// The number of streams cannot change
if(variantCodecCount!==codecCount_){blacklistReasons.push("codec count \""+variantCodecCount+"\" !== \""+codecCount_+"\"");}// only exclude playlists by codec change, if codecs cannot switch
// during playback.
if(!_this11.sourceUpdater_.canChangeType()){var variantVideoDetails=variantCodecs.video&&parseCodecs(variantCodecs.video)[0]||null;var variantAudioDetails=variantCodecs.audio&&parseCodecs(variantCodecs.audio)[0]||null;// the video codec cannot change
if(variantVideoDetails&&videoDetails&&variantVideoDetails.type.toLowerCase()!==videoDetails.type.toLowerCase()){blacklistReasons.push("video codec \""+variantVideoDetails.type+"\" !== \""+videoDetails.type+"\"");}// the audio codec cannot change
if(variantAudioDetails&&audioDetails&&variantAudioDetails.type.toLowerCase()!==audioDetails.type.toLowerCase()){blacklistReasons.push("audio codec \""+variantAudioDetails.type+"\" !== \""+audioDetails.type+"\"");}}if(blacklistReasons.length){variant.excludeUntil=Infinity;_this11.logger_("blacklisting "+variant.id+": "+blacklistReasons.join(' && '));}});};_proto.updateAdCues_=function updateAdCues_(media){var offset=0;var seekable=this.seekable();if(seekable.length){offset=seekable.start(0);}updateAdCues(media,this.cueTagsTrack_,offset);}/**
   * Calculates the desired forward buffer length based on current time
   *
   * @return {number} Desired forward buffer length in seconds
   */;_proto.goalBufferLength=function goalBufferLength(){var currentTime=this.tech_.currentTime();var initial=Config.GOAL_BUFFER_LENGTH;var rate=Config.GOAL_BUFFER_LENGTH_RATE;var max=Math.max(initial,Config.MAX_GOAL_BUFFER_LENGTH);return Math.min(initial+currentTime*rate,max);}/**
   * Calculates the desired buffer low water line based on current time
   *
   * @return {number} Desired buffer low water line in seconds
   */;_proto.bufferLowWaterLine=function bufferLowWaterLine(){var currentTime=this.tech_.currentTime();var initial=Config.BUFFER_LOW_WATER_LINE;var rate=Config.BUFFER_LOW_WATER_LINE_RATE;var max=Math.max(initial,Config.MAX_BUFFER_LOW_WATER_LINE);var newMax=Math.max(initial,Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);return Math.min(initial+currentTime*rate,this.experimentalBufferBasedABR?newMax:max);};_proto.bufferHighWaterLine=function bufferHighWaterLine(){return Config.BUFFER_HIGH_WATER_LINE;};return MasterPlaylistController;}(videojs.EventTarget);/**
 * Returns a function that acts as the Enable/disable playlist function.
 *
 * @param {PlaylistLoader} loader - The master playlist loader
 * @param {string} playlistID - id of the playlist
 * @param {Function} changePlaylistFn - A function to be called after a
 * playlist's enabled-state has been changed. Will NOT be called if a
 * playlist's enabled-state is unchanged
 * @param {boolean=} enable - Value to set the playlist enabled-state to
 * or if undefined returns the current enabled-state for the playlist
 * @return {Function} Function for setting/getting enabled
 */var enableFunction=function enableFunction(loader,playlistID,changePlaylistFn){return function(enable){var playlist=loader.master.playlists[playlistID];var incompatible=isIncompatible(playlist);var currentlyEnabled=isEnabled(playlist);if(typeof enable==='undefined'){return currentlyEnabled;}if(enable){delete playlist.disabled;}else{playlist.disabled=true;}if(enable!==currentlyEnabled&&!incompatible){// Ensure the outside world knows about our changes
changePlaylistFn();if(enable){loader.trigger('renditionenabled');}else{loader.trigger('renditiondisabled');}}return enable;};};/**
 * The representation object encapsulates the publicly visible information
 * in a media playlist along with a setter/getter-type function (enabled)
 * for changing the enabled-state of a particular playlist entry
 *
 * @class Representation
 */var Representation=function Representation(vhsHandler,playlist,id){var mpc=vhsHandler.masterPlaylistController_,smoothQualityChange=vhsHandler.options_.smoothQualityChange;// Get a reference to a bound version of the quality change function
var changeType=smoothQualityChange?'smooth':'fast';var qualityChangeFunction=mpc[changeType+"QualityChange_"].bind(mpc);// some playlist attributes are optional
if(playlist.attributes){var resolution=playlist.attributes.RESOLUTION;this.width=resolution&&resolution.width;this.height=resolution&&resolution.height;this.bandwidth=playlist.attributes.BANDWIDTH;this.frameRate=playlist.attributes['FRAME-RATE'];}this.codecs=codecsForPlaylist(mpc.master(),playlist);this.playlist=playlist;// The id is simply the ordinality of the media playlist
// within the master playlist
this.id=id;// Partially-apply the enableFunction to create a playlist-
// specific variant
this.enabled=enableFunction(vhsHandler.playlists,playlist.id,qualityChangeFunction);};/**
 * A mixin function that adds the `representations` api to an instance
 * of the VhsHandler class
 *
 * @param {VhsHandler} vhsHandler - An instance of VhsHandler to add the
 * representation API into
 */var renditionSelectionMixin=function renditionSelectionMixin(vhsHandler){// Add a single API-specific function to the VhsHandler instance
vhsHandler.representations=function(){var master=vhsHandler.masterPlaylistController_.master();var playlists=isAudioOnly(master)?vhsHandler.masterPlaylistController_.getAudioTrackPlaylists_():master.playlists;if(!playlists){return[];}return playlists.filter(function(media){return!isIncompatible(media);}).map(function(e,i){return new Representation(vhsHandler,e,e.id);});};};/**
 * @file playback-watcher.js
 *
 * Playback starts, and now my watch begins. It shall not end until my death. I shall
 * take no wait, hold no uncleared timeouts, father no bad seeks. I shall wear no crowns
 * and win no glory. I shall live and die at my post. I am the corrector of the underflow.
 * I am the watcher of gaps. I am the shield that guards the realms of seekable. I pledge
 * my life and honor to the Playback Watch, for this Player and all the Players to come.
 */var timerCancelEvents=['seeking','seeked','pause','playing','error'];/**
 * @class PlaybackWatcher
 */var PlaybackWatcher=/*#__PURE__*/function(){/**
   * Represents an PlaybackWatcher object.
   *
   * @class
   * @param {Object} options an object that includes the tech and settings
   */function PlaybackWatcher(options){var _this=this;this.masterPlaylistController_=options.masterPlaylistController;this.tech_=options.tech;this.seekable=options.seekable;this.allowSeeksWithinUnsafeLiveWindow=options.allowSeeksWithinUnsafeLiveWindow;this.liveRangeSafeTimeDelta=options.liveRangeSafeTimeDelta;this.media=options.media;this.consecutiveUpdates=0;this.lastRecordedTime=null;this.timer_=null;this.checkCurrentTimeTimeout_=null;this.logger_=logger('PlaybackWatcher');this.logger_('initialize');var playHandler=function playHandler(){return _this.monitorCurrentTime_();};var canPlayHandler=function canPlayHandler(){return _this.monitorCurrentTime_();};var waitingHandler=function waitingHandler(){return _this.techWaiting_();};var cancelTimerHandler=function cancelTimerHandler(){return _this.cancelTimer_();};var mpc=this.masterPlaylistController_;var loaderTypes=['main','subtitle','audio'];var loaderChecks={};loaderTypes.forEach(function(type){loaderChecks[type]={reset:function reset(){return _this.resetSegmentDownloads_(type);},updateend:function updateend(){return _this.checkSegmentDownloads_(type);}};mpc[type+"SegmentLoader_"].on('appendsdone',loaderChecks[type].updateend);// If a rendition switch happens during a playback stall where the buffer
// isn't changing we want to reset. We cannot assume that the new rendition
// will also be stalled, until after new appends.
mpc[type+"SegmentLoader_"].on('playlistupdate',loaderChecks[type].reset);// Playback stalls should not be detected right after seeking.
// This prevents one segment playlists (single vtt or single segment content)
// from being detected as stalling. As the buffer will not change in those cases, since
// the buffer is the entire video duration.
_this.tech_.on(['seeked','seeking'],loaderChecks[type].reset);});/**
     * We check if a seek was into a gap through the following steps:
     * 1. We get a seeking event and we do not get a seeked event. This means that
     *    a seek was attempted but not completed.
     * 2. We run `fixesBadSeeks_` on segment loader appends. This means that we already
     *    removed everything from our buffer and appended a segment, and should be ready
     *    to check for gaps.
     */var setSeekingHandlers=function setSeekingHandlers(fn){['main','audio'].forEach(function(type){mpc[type+"SegmentLoader_"][fn]('appended',_this.seekingAppendCheck_);});};this.seekingAppendCheck_=function(){if(_this.fixesBadSeeks_()){_this.consecutiveUpdates=0;_this.lastRecordedTime=_this.tech_.currentTime();setSeekingHandlers('off');}};this.clearSeekingAppendCheck_=function(){return setSeekingHandlers('off');};this.watchForBadSeeking_=function(){_this.clearSeekingAppendCheck_();setSeekingHandlers('on');};this.tech_.on('seeked',this.clearSeekingAppendCheck_);this.tech_.on('seeking',this.watchForBadSeeking_);this.tech_.on('waiting',waitingHandler);this.tech_.on(timerCancelEvents,cancelTimerHandler);this.tech_.on('canplay',canPlayHandler);/*
      An edge case exists that results in gaps not being skipped when they exist at the beginning of a stream. This case
      is surfaced in one of two ways:
       1)  The `waiting` event is fired before the player has buffered content, making it impossible
          to find or skip the gap. The `waiting` event is followed by a `play` event. On first play
          we can check if playback is stalled due to a gap, and skip the gap if necessary.
      2)  A source with a gap at the beginning of the stream is loaded programatically while the player
          is in a playing state. To catch this case, it's important that our one-time play listener is setup
          even if the player is in a playing state
    */this.tech_.one('play',playHandler);// Define the dispose function to clean up our events
this.dispose=function(){_this.clearSeekingAppendCheck_();_this.logger_('dispose');_this.tech_.off('waiting',waitingHandler);_this.tech_.off(timerCancelEvents,cancelTimerHandler);_this.tech_.off('canplay',canPlayHandler);_this.tech_.off('play',playHandler);_this.tech_.off('seeking',_this.watchForBadSeeking_);_this.tech_.off('seeked',_this.clearSeekingAppendCheck_);loaderTypes.forEach(function(type){mpc[type+"SegmentLoader_"].off('appendsdone',loaderChecks[type].updateend);mpc[type+"SegmentLoader_"].off('playlistupdate',loaderChecks[type].reset);_this.tech_.off(['seeked','seeking'],loaderChecks[type].reset);});if(_this.checkCurrentTimeTimeout_){window_default().clearTimeout(_this.checkCurrentTimeTimeout_);}_this.cancelTimer_();};}/**
   * Periodically check current time to see if playback stopped
   *
   * @private
   */var _proto=PlaybackWatcher.prototype;_proto.monitorCurrentTime_=function monitorCurrentTime_(){this.checkCurrentTime_();if(this.checkCurrentTimeTimeout_){window_default().clearTimeout(this.checkCurrentTimeTimeout_);}// 42 = 24 fps // 250 is what Webkit uses // FF uses 15
this.checkCurrentTimeTimeout_=window_default().setTimeout(this.monitorCurrentTime_.bind(this),250);}/**
   * Reset stalled download stats for a specific type of loader
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#playlistupdate
   * @listens Tech#seeking
   * @listens Tech#seeked
   */;_proto.resetSegmentDownloads_=function resetSegmentDownloads_(type){var loader=this.masterPlaylistController_[type+"SegmentLoader_"];if(this[type+"StalledDownloads_"]>0){this.logger_("resetting possible stalled download count for "+type+" loader");}this[type+"StalledDownloads_"]=0;this[type+"Buffered_"]=loader.buffered_();}/**
   * Checks on every segment `appendsdone` to see
   * if segment appends are making progress. If they are not
   * and we are still downloading bytes. We blacklist the playlist.
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#appendsdone
   */;_proto.checkSegmentDownloads_=function checkSegmentDownloads_(type){var mpc=this.masterPlaylistController_;var loader=mpc[type+"SegmentLoader_"];var buffered=loader.buffered_();var isBufferedDifferent=isRangeDifferent(this[type+"Buffered_"],buffered);this[type+"Buffered_"]=buffered;// if another watcher is going to fix the issue or
// the buffered value for this loader changed
// appends are working
if(isBufferedDifferent){this.resetSegmentDownloads_(type);return;}this[type+"StalledDownloads_"]++;this.logger_("found #"+this[type+"StalledDownloads_"]+" "+type+" appends that did not increase buffer (possible stalled download)",{playlistId:loader.playlist_&&loader.playlist_.id,buffered:timeRangesToArray(buffered)});// after 10 possibly stalled appends with no reset, exclude
if(this[type+"StalledDownloads_"]<10){return;}this.logger_(type+" loader stalled download exclusion");this.resetSegmentDownloads_(type);this.tech_.trigger({type:'usage',name:"vhs-"+type+"-download-exclusion"});if(type==='subtitle'){return;}// TODO: should we exclude audio tracks rather than main tracks
// when type is audio?
mpc.blacklistCurrentPlaylist({message:"Excessive "+type+" segment downloading detected."},Infinity);}/**
   * The purpose of this function is to emulate the "waiting" event on
   * browsers that do not emit it when they are waiting for more
   * data to continue playback
   *
   * @private
   */;_proto.checkCurrentTime_=function checkCurrentTime_(){if(this.tech_.paused()||this.tech_.seeking()){return;}var currentTime=this.tech_.currentTime();var buffered=this.tech_.buffered();if(this.lastRecordedTime===currentTime&&(!buffered.length||currentTime+SAFE_TIME_DELTA>=buffered.end(buffered.length-1))){// If current time is at the end of the final buffered region, then any playback
// stall is most likely caused by buffering in a low bandwidth environment. The tech
// should fire a `waiting` event in this scenario, but due to browser and tech
// inconsistencies. Calling `techWaiting_` here allows us to simulate
// responding to a native `waiting` event when the tech fails to emit one.
return this.techWaiting_();}if(this.consecutiveUpdates>=5&&currentTime===this.lastRecordedTime){this.consecutiveUpdates++;this.waiting_();}else if(currentTime===this.lastRecordedTime){this.consecutiveUpdates++;}else{this.consecutiveUpdates=0;this.lastRecordedTime=currentTime;}}/**
   * Cancels any pending timers and resets the 'timeupdate' mechanism
   * designed to detect that we are stalled
   *
   * @private
   */;_proto.cancelTimer_=function cancelTimer_(){this.consecutiveUpdates=0;if(this.timer_){this.logger_('cancelTimer_');clearTimeout(this.timer_);}this.timer_=null;}/**
   * Fixes situations where there's a bad seek
   *
   * @return {boolean} whether an action was taken to fix the seek
   * @private
   */;_proto.fixesBadSeeks_=function fixesBadSeeks_(){var seeking=this.tech_.seeking();if(!seeking){return false;}// TODO: It's possible that these seekable checks should be moved out of this function
// and into a function that runs on seekablechange. It's also possible that we only need
// afterSeekableWindow as the buffered check at the bottom is good enough to handle before
// seekable range.
var seekable=this.seekable();var currentTime=this.tech_.currentTime();var isAfterSeekableRange=this.afterSeekableWindow_(seekable,currentTime,this.media(),this.allowSeeksWithinUnsafeLiveWindow);var seekTo;if(isAfterSeekableRange){var seekableEnd=seekable.end(seekable.length-1);// sync to live point (if VOD, our seekable was updated and we're simply adjusting)
seekTo=seekableEnd;}if(this.beforeSeekableWindow_(seekable,currentTime)){var seekableStart=seekable.start(0);// sync to the beginning of the live window
// provide a buffer of .1 seconds to handle rounding/imprecise numbers
seekTo=seekableStart+(// if the playlist is too short and the seekable range is an exact time (can
// happen in live with a 3 segment playlist), then don't use a time delta
seekableStart===seekable.end(0)?0:SAFE_TIME_DELTA);}if(typeof seekTo!=='undefined'){this.logger_("Trying to seek outside of seekable at time "+currentTime+" with "+("seekable range "+printableRange(seekable)+". Seeking to ")+(seekTo+"."));this.tech_.setCurrentTime(seekTo);return true;}var sourceUpdater=this.masterPlaylistController_.sourceUpdater_;var buffered=this.tech_.buffered();var audioBuffered=sourceUpdater.audioBuffer?sourceUpdater.audioBuffered():null;var videoBuffered=sourceUpdater.videoBuffer?sourceUpdater.videoBuffered():null;var media=this.media();// verify that at least two segment durations or one part duration have been
// appended before checking for a gap.
var minAppendedDuration=media.partTargetDuration?media.partTargetDuration:(media.targetDuration-TIME_FUDGE_FACTOR)*2;// verify that at least two segment durations have been
// appended before checking for a gap.
var bufferedToCheck=[audioBuffered,videoBuffered];for(var i=0;i<bufferedToCheck.length;i++){// skip null buffered
if(!bufferedToCheck[i]){continue;}var timeAhead=timeAheadOf(bufferedToCheck[i],currentTime);// if we are less than two video/audio segment durations or one part
// duration behind we haven't appended enough to call this a bad seek.
if(timeAhead<minAppendedDuration){return false;}}var nextRange=findNextRange(buffered,currentTime);// we have appended enough content, but we don't have anything buffered
// to seek over the gap
if(nextRange.length===0){return false;}seekTo=nextRange.start(0)+SAFE_TIME_DELTA;this.logger_("Buffered region starts ("+nextRange.start(0)+") "+(" just beyond seek point ("+currentTime+"). Seeking to "+seekTo+"."));this.tech_.setCurrentTime(seekTo);return true;}/**
   * Handler for situations when we determine the player is waiting.
   *
   * @private
   */;_proto.waiting_=function waiting_(){if(this.techWaiting_()){return;}// All tech waiting checks failed. Use last resort correction
var currentTime=this.tech_.currentTime();var buffered=this.tech_.buffered();var currentRange=findRange(buffered,currentTime);// Sometimes the player can stall for unknown reasons within a contiguous buffered
// region with no indication that anything is amiss (seen in Firefox). Seeking to
// currentTime is usually enough to kickstart the player. This checks that the player
// is currently within a buffered region before attempting a corrective seek.
// Chrome does not appear to continue `timeupdate` events after a `waiting` event
// until there is ~ 3 seconds of forward buffer available. PlaybackWatcher should also
// make sure there is ~3 seconds of forward buffer before taking any corrective action
// to avoid triggering an `unknownwaiting` event when the network is slow.
if(currentRange.length&&currentTime+3<=currentRange.end(0)){this.cancelTimer_();this.tech_.setCurrentTime(currentTime);this.logger_("Stopped at "+currentTime+" while inside a buffered region "+("["+currentRange.start(0)+" -> "+currentRange.end(0)+"]. Attempting to resume ")+'playback by seeking to the current time.');// unknown waiting corrections may be useful for monitoring QoS
this.tech_.trigger({type:'usage',name:'vhs-unknown-waiting'});this.tech_.trigger({type:'usage',name:'hls-unknown-waiting'});return;}}/**
   * Handler for situations when the tech fires a `waiting` event
   *
   * @return {boolean}
   *         True if an action (or none) was needed to correct the waiting. False if no
   *         checks passed
   * @private
   */;_proto.techWaiting_=function techWaiting_(){var seekable=this.seekable();var currentTime=this.tech_.currentTime();if(this.tech_.seeking()||this.timer_!==null){// Tech is seeking or already waiting on another action, no action needed
return true;}if(this.beforeSeekableWindow_(seekable,currentTime)){var livePoint=seekable.end(seekable.length-1);this.logger_("Fell out of live window at time "+currentTime+". Seeking to "+("live point (seekable end) "+livePoint));this.cancelTimer_();this.tech_.setCurrentTime(livePoint);// live window resyncs may be useful for monitoring QoS
this.tech_.trigger({type:'usage',name:'vhs-live-resync'});this.tech_.trigger({type:'usage',name:'hls-live-resync'});return true;}var sourceUpdater=this.tech_.vhs.masterPlaylistController_.sourceUpdater_;var buffered=this.tech_.buffered();var videoUnderflow=this.videoUnderflow_({audioBuffered:sourceUpdater.audioBuffered(),videoBuffered:sourceUpdater.videoBuffered(),currentTime:currentTime});if(videoUnderflow){// Even though the video underflowed and was stuck in a gap, the audio overplayed
// the gap, leading currentTime into a buffered range. Seeking to currentTime
// allows the video to catch up to the audio position without losing any audio
// (only suffering ~3 seconds of frozen video and a pause in audio playback).
this.cancelTimer_();this.tech_.setCurrentTime(currentTime);// video underflow may be useful for monitoring QoS
this.tech_.trigger({type:'usage',name:'vhs-video-underflow'});this.tech_.trigger({type:'usage',name:'hls-video-underflow'});return true;}var nextRange=findNextRange(buffered,currentTime);// check for gap
if(nextRange.length>0){var difference=nextRange.start(0)-currentTime;this.logger_("Stopped at "+currentTime+", setting timer for "+difference+", seeking "+("to "+nextRange.start(0)));this.cancelTimer_();this.timer_=setTimeout(this.skipTheGap_.bind(this),difference*1000,currentTime);return true;}// All checks failed. Returning false to indicate failure to correct waiting
return false;};_proto.afterSeekableWindow_=function afterSeekableWindow_(seekable,currentTime,playlist,allowSeeksWithinUnsafeLiveWindow){if(allowSeeksWithinUnsafeLiveWindow===void 0){allowSeeksWithinUnsafeLiveWindow=false;}if(!seekable.length){// we can't make a solid case if there's no seekable, default to false
return false;}var allowedEnd=seekable.end(seekable.length-1)+SAFE_TIME_DELTA;var isLive=!playlist.endList;if(isLive&&allowSeeksWithinUnsafeLiveWindow){allowedEnd=seekable.end(seekable.length-1)+playlist.targetDuration*3;}if(currentTime>allowedEnd){return true;}return false;};_proto.beforeSeekableWindow_=function beforeSeekableWindow_(seekable,currentTime){if(seekable.length&&// can't fall before 0 and 0 seekable start identifies VOD stream
seekable.start(0)>0&&currentTime<seekable.start(0)-this.liveRangeSafeTimeDelta){return true;}return false;};_proto.videoUnderflow_=function videoUnderflow_(_ref){var videoBuffered=_ref.videoBuffered,audioBuffered=_ref.audioBuffered,currentTime=_ref.currentTime;// audio only content will not have video underflow :)
if(!videoBuffered){return;}var gap;// find a gap in demuxed content.
if(videoBuffered.length&&audioBuffered.length){// in Chrome audio will continue to play for ~3s when we run out of video
// so we have to check that the video buffer did have some buffer in the
// past.
var lastVideoRange=findRange(videoBuffered,currentTime-3);var videoRange=findRange(videoBuffered,currentTime);var audioRange=findRange(audioBuffered,currentTime);if(audioRange.length&&!videoRange.length&&lastVideoRange.length){gap={start:lastVideoRange.end(0),end:audioRange.end(0)};}// find a gap in muxed content.
}else{var nextRange=findNextRange(videoBuffered,currentTime);// Even if there is no available next range, there is still a possibility we are
// stuck in a gap due to video underflow.
if(!nextRange.length){gap=this.gapFromVideoUnderflow_(videoBuffered,currentTime);}}if(gap){this.logger_("Encountered a gap in video from "+gap.start+" to "+gap.end+". "+("Seeking to current time "+currentTime));return true;}return false;}/**
   * Timer callback. If playback still has not proceeded, then we seek
   * to the start of the next buffered region.
   *
   * @private
   */;_proto.skipTheGap_=function skipTheGap_(scheduledCurrentTime){var buffered=this.tech_.buffered();var currentTime=this.tech_.currentTime();var nextRange=findNextRange(buffered,currentTime);this.cancelTimer_();if(nextRange.length===0||currentTime!==scheduledCurrentTime){return;}this.logger_('skipTheGap_:','currentTime:',currentTime,'scheduled currentTime:',scheduledCurrentTime,'nextRange start:',nextRange.start(0));// only seek if we still have not played
this.tech_.setCurrentTime(nextRange.start(0)+TIME_FUDGE_FACTOR);this.tech_.trigger({type:'usage',name:'vhs-gap-skip'});this.tech_.trigger({type:'usage',name:'hls-gap-skip'});};_proto.gapFromVideoUnderflow_=function gapFromVideoUnderflow_(buffered,currentTime){// At least in Chrome, if there is a gap in the video buffer, the audio will continue
// playing for ~3 seconds after the video gap starts. This is done to account for
// video buffer underflow/underrun (note that this is not done when there is audio
// buffer underflow/underrun -- in that case the video will stop as soon as it
// encounters the gap, as audio stalls are more noticeable/jarring to a user than
// video stalls). The player's time will reflect the playthrough of audio, so the
// time will appear as if we are in a buffered region, even if we are stuck in a
// "gap."
//
// Example:
// video buffer:   0 => 10.1, 10.2 => 20
// audio buffer:   0 => 20
// overall buffer: 0 => 10.1, 10.2 => 20
// current time: 13
//
// Chrome's video froze at 10 seconds, where the video buffer encountered the gap,
// however, the audio continued playing until it reached ~3 seconds past the gap
// (13 seconds), at which point it stops as well. Since current time is past the
// gap, findNextRange will return no ranges.
//
// To check for this issue, we see if there is a gap that starts somewhere within
// a 3 second range (3 seconds +/- 1 second) back from our current time.
var gaps=findGaps(buffered);for(var i=0;i<gaps.length;i++){var start=gaps.start(i);var end=gaps.end(i);// gap is starts no more than 4 seconds back
if(currentTime-start<4&&currentTime-start>2){return{start:start,end:end};}}return null;};return PlaybackWatcher;}();var defaultOptions={errorInterval:30,getSource:function getSource(next){var tech=this.tech({IWillNotUseThisInPlugins:true});var sourceObj=tech.currentSource_||this.currentSource();return next(sourceObj);}};/**
 * Main entry point for the plugin
 *
 * @param {Player} player a reference to a videojs Player instance
 * @param {Object} [options] an object with plugin options
 * @private
 */var initPlugin=function initPlugin(player,options){var lastCalled=0;var seekTo=0;var localOptions=videojs.mergeOptions(defaultOptions,options);player.ready(function(){player.trigger({type:'usage',name:'vhs-error-reload-initialized'});player.trigger({type:'usage',name:'hls-error-reload-initialized'});});/**
   * Player modifications to perform that must wait until `loadedmetadata`
   * has been triggered
   *
   * @private
   */var loadedMetadataHandler=function loadedMetadataHandler(){if(seekTo){player.currentTime(seekTo);}};/**
   * Set the source on the player element, play, and seek if necessary
   *
   * @param {Object} sourceObj An object specifying the source url and mime-type to play
   * @private
   */var setSource=function setSource(sourceObj){if(sourceObj===null||sourceObj===undefined){return;}seekTo=player.duration()!==Infinity&&player.currentTime()||0;player.one('loadedmetadata',loadedMetadataHandler);player.src(sourceObj);player.trigger({type:'usage',name:'vhs-error-reload'});player.trigger({type:'usage',name:'hls-error-reload'});player.play();};/**
   * Attempt to get a source from either the built-in getSource function
   * or a custom function provided via the options
   *
   * @private
   */var errorHandler=function errorHandler(){// Do not attempt to reload the source if a source-reload occurred before
// 'errorInterval' time has elapsed since the last source-reload
if(Date.now()-lastCalled<localOptions.errorInterval*1000){player.trigger({type:'usage',name:'vhs-error-reload-canceled'});player.trigger({type:'usage',name:'hls-error-reload-canceled'});return;}if(!localOptions.getSource||typeof localOptions.getSource!=='function'){videojs.log.error('ERROR: reloadSourceOnError - The option getSource must be a function!');return;}lastCalled=Date.now();return localOptions.getSource.call(player,setSource);};/**
   * Unbind any event handlers that were bound by the plugin
   *
   * @private
   */var cleanupEvents=function cleanupEvents(){player.off('loadedmetadata',loadedMetadataHandler);player.off('error',errorHandler);player.off('dispose',cleanupEvents);};/**
   * Cleanup before re-initializing the plugin
   *
   * @param {Object} [newOptions] an object with plugin options
   * @private
   */var reinitPlugin=function reinitPlugin(newOptions){cleanupEvents();initPlugin(player,newOptions);};player.on('error',errorHandler);player.on('dispose',cleanupEvents);// Overwrite the plugin function so that we can correctly cleanup before
// initializing the plugin
player.reloadSourceOnError=reinitPlugin;};/**
 * Reload the source when an error is detected as long as there
 * wasn't an error previously within the last 30 seconds
 *
 * @param {Object} [options] an object with plugin options
 */var reloadSourceOnError=function reloadSourceOnError(options){initPlugin(this,options);};var version$4="2.16.3";var version$3="6.0.1";var version$2="0.22.1";var version$1="4.8.0";var video_es_version="3.1.3";var Vhs={PlaylistLoader:PlaylistLoader,Playlist:Playlist,utils:utils,STANDARD_PLAYLIST_SELECTOR:lastBandwidthSelector,INITIAL_PLAYLIST_SELECTOR:lowestBitrateCompatibleVariantSelector,lastBandwidthSelector:lastBandwidthSelector,movingAverageBandwidthSelector:movingAverageBandwidthSelector,comparePlaylistBandwidth:comparePlaylistBandwidth,comparePlaylistResolution:comparePlaylistResolution,xhr:xhrFactory()};// Define getter/setters for config properties
Object.keys(Config).forEach(function(prop){Object.defineProperty(Vhs,prop,{get:function get(){videojs.log.warn("using Vhs."+prop+" is UNSAFE be sure you know what you are doing");return Config[prop];},set:function set(value){videojs.log.warn("using Vhs."+prop+" is UNSAFE be sure you know what you are doing");if(typeof value!=='number'||value<0){videojs.log.warn("value of Vhs."+prop+" must be greater than or equal to 0");return;}Config[prop]=value;}});});var LOCAL_STORAGE_KEY='videojs-vhs';/**
 * Updates the selectedIndex of the QualityLevelList when a mediachange happens in vhs.
 *
 * @param {QualityLevelList} qualityLevels The QualityLevelList to update.
 * @param {PlaylistLoader} playlistLoader PlaylistLoader containing the new media info.
 * @function handleVhsMediaChange
 */var handleVhsMediaChange=function handleVhsMediaChange(qualityLevels,playlistLoader){var newPlaylist=playlistLoader.media();var selectedIndex=-1;for(var i=0;i<qualityLevels.length;i++){if(qualityLevels[i].id===newPlaylist.id){selectedIndex=i;break;}}qualityLevels.selectedIndex_=selectedIndex;qualityLevels.trigger({selectedIndex:selectedIndex,type:'change'});};/**
 * Adds quality levels to list once playlist metadata is available
 *
 * @param {QualityLevelList} qualityLevels The QualityLevelList to attach events to.
 * @param {Object} vhs Vhs object to listen to for media events.
 * @function handleVhsLoadedMetadata
 */var handleVhsLoadedMetadata=function handleVhsLoadedMetadata(qualityLevels,vhs){vhs.representations().forEach(function(rep){qualityLevels.addQualityLevel(rep);});handleVhsMediaChange(qualityLevels,vhs.playlists);};// HLS is a source handler, not a tech. Make sure attempts to use it
// as one do not cause exceptions.
Vhs.canPlaySource=function(){return videojs.log.warn('HLS is no longer a tech. Please remove it from '+'your player\'s techOrder.');};var emeKeySystems=function emeKeySystems(keySystemOptions,mainPlaylist,audioPlaylist){if(!keySystemOptions){return keySystemOptions;}var codecs={};if(mainPlaylist&&mainPlaylist.attributes&&mainPlaylist.attributes.CODECS){codecs=unwrapCodecList(parseCodecs(mainPlaylist.attributes.CODECS));}if(audioPlaylist&&audioPlaylist.attributes&&audioPlaylist.attributes.CODECS){codecs.audio=audioPlaylist.attributes.CODECS;}var videoContentType=getMimeForCodec(codecs.video);var audioContentType=getMimeForCodec(codecs.audio);// upsert the content types based on the selected playlist
var keySystemContentTypes={};for(var keySystem in keySystemOptions){keySystemContentTypes[keySystem]={};if(audioContentType){keySystemContentTypes[keySystem].audioContentType=audioContentType;}if(videoContentType){keySystemContentTypes[keySystem].videoContentType=videoContentType;}// Default to using the video playlist's PSSH even though they may be different, as
// videojs-contrib-eme will only accept one in the options.
//
// This shouldn't be an issue for most cases as early intialization will handle all
// unique PSSH values, and if they aren't, then encrypted events should have the
// specific information needed for the unique license.
if(mainPlaylist.contentProtection&&mainPlaylist.contentProtection[keySystem]&&mainPlaylist.contentProtection[keySystem].pssh){keySystemContentTypes[keySystem].pssh=mainPlaylist.contentProtection[keySystem].pssh;}// videojs-contrib-eme accepts the option of specifying: 'com.some.cdm': 'url'
// so we need to prevent overwriting the URL entirely
if(typeof keySystemOptions[keySystem]==='string'){keySystemContentTypes[keySystem].url=keySystemOptions[keySystem];}}return videojs.mergeOptions(keySystemOptions,keySystemContentTypes);};/**
 * @typedef {Object} KeySystems
 *
 * keySystems configuration for https://github.com/videojs/videojs-contrib-eme
 * Note: not all options are listed here.
 *
 * @property {Uint8Array} [pssh]
 *           Protection System Specific Header
 */ /**
 * Goes through all the playlists and collects an array of KeySystems options objects
 * containing each playlist's keySystems and their pssh values, if available.
 *
 * @param {Object[]} playlists
 *        The playlists to look through
 * @param {string[]} keySystems
 *        The keySystems to collect pssh values for
 *
 * @return {KeySystems[]}
 *         An array of KeySystems objects containing available key systems and their
 *         pssh values
 */var getAllPsshKeySystemsOptions=function getAllPsshKeySystemsOptions(playlists,keySystems){return playlists.reduce(function(keySystemsArr,playlist){if(!playlist.contentProtection){return keySystemsArr;}var keySystemsOptions=keySystems.reduce(function(keySystemsObj,keySystem){var keySystemOptions=playlist.contentProtection[keySystem];if(keySystemOptions&&keySystemOptions.pssh){keySystemsObj[keySystem]={pssh:keySystemOptions.pssh};}return keySystemsObj;},{});if(Object.keys(keySystemsOptions).length){keySystemsArr.push(keySystemsOptions);}return keySystemsArr;},[]);};/**
 * Returns a promise that waits for the
 * [eme plugin](https://github.com/videojs/videojs-contrib-eme) to create a key session.
 *
 * Works around https://bugs.chromium.org/p/chromium/issues/detail?id=895449 in non-IE11
 * browsers.
 *
 * As per the above ticket, this is particularly important for Chrome, where, if
 * unencrypted content is appended before encrypted content and the key session has not
 * been created, a MEDIA_ERR_DECODE will be thrown once the encrypted content is reached
 * during playback.
 *
 * @param {Object} player
 *        The player instance
 * @param {Object[]} sourceKeySystems
 *        The key systems options from the player source
 * @param {Object} [audioMedia]
 *        The active audio media playlist (optional)
 * @param {Object[]} mainPlaylists
 *        The playlists found on the master playlist object
 *
 * @return {Object}
 *         Promise that resolves when the key session has been created
 */var waitForKeySessionCreation=function waitForKeySessionCreation(_ref){var player=_ref.player,sourceKeySystems=_ref.sourceKeySystems,audioMedia=_ref.audioMedia,mainPlaylists=_ref.mainPlaylists;if(!player.eme.initializeMediaKeys){return Promise.resolve();}// TODO should all audio PSSH values be initialized for DRM?
//
// All unique video rendition pssh values are initialized for DRM, but here only
// the initial audio playlist license is initialized. In theory, an encrypted
// event should be fired if the user switches to an alternative audio playlist
// where a license is required, but this case hasn't yet been tested. In addition, there
// may be many alternate audio playlists unlikely to be used (e.g., multiple different
// languages).
var playlists=audioMedia?mainPlaylists.concat([audioMedia]):mainPlaylists;var keySystemsOptionsArr=getAllPsshKeySystemsOptions(playlists,Object.keys(sourceKeySystems));var initializationFinishedPromises=[];var keySessionCreatedPromises=[];// Since PSSH values are interpreted as initData, EME will dedupe any duplicates. The
// only place where it should not be deduped is for ms-prefixed APIs, but the early
// return for IE11 above, and the existence of modern EME APIs in addition to
// ms-prefixed APIs on Edge should prevent this from being a concern.
// initializeMediaKeys also won't use the webkit-prefixed APIs.
keySystemsOptionsArr.forEach(function(keySystemsOptions){keySessionCreatedPromises.push(new Promise(function(resolve,reject){player.tech_.one('keysessioncreated',resolve);}));initializationFinishedPromises.push(new Promise(function(resolve,reject){player.eme.initializeMediaKeys({keySystems:keySystemsOptions},function(err){if(err){reject(err);return;}resolve();});}));});// The reasons Promise.race is chosen over Promise.any:
//
// * Promise.any is only available in Safari 14+.
// * None of these promises are expected to reject. If they do reject, it might be
//   better here for the race to surface the rejection, rather than mask it by using
//   Promise.any.
return Promise.race([// If a session was previously created, these will all finish resolving without
// creating a new session, otherwise it will take until the end of all license
// requests, which is why the key session check is used (to make setup much faster).
Promise.all(initializationFinishedPromises),// Once a single session is created, the browser knows DRM will be used.
Promise.race(keySessionCreatedPromises)]);};/**
 * If the [eme](https://github.com/videojs/videojs-contrib-eme) plugin is available, and
 * there are keySystems on the source, sets up source options to prepare the source for
 * eme.
 *
 * @param {Object} player
 *        The player instance
 * @param {Object[]} sourceKeySystems
 *        The key systems options from the player source
 * @param {Object} media
 *        The active media playlist
 * @param {Object} [audioMedia]
 *        The active audio media playlist (optional)
 *
 * @return {boolean}
 *         Whether or not options were configured and EME is available
 */var setupEmeOptions=function setupEmeOptions(_ref2){var player=_ref2.player,sourceKeySystems=_ref2.sourceKeySystems,media=_ref2.media,audioMedia=_ref2.audioMedia;var sourceOptions=emeKeySystems(sourceKeySystems,media,audioMedia);if(!sourceOptions){return false;}player.currentSource().keySystems=sourceOptions;// eme handles the rest of the setup, so if it is missing
// do nothing.
if(sourceOptions&&!player.eme){videojs.log.warn('DRM encrypted source cannot be decrypted without a DRM plugin');return false;}return true;};var getVhsLocalStorage=function getVhsLocalStorage(){if(!(window_default()).localStorage){return null;}var storedObject=window_default().localStorage.getItem(LOCAL_STORAGE_KEY);if(!storedObject){return null;}try{return JSON.parse(storedObject);}catch(e){// someone may have tampered with the value
return null;}};var updateVhsLocalStorage=function updateVhsLocalStorage(options){if(!(window_default()).localStorage){return false;}var objectToStore=getVhsLocalStorage();objectToStore=objectToStore?videojs.mergeOptions(objectToStore,options):options;try{window_default().localStorage.setItem(LOCAL_STORAGE_KEY,JSON.stringify(objectToStore));}catch(e){// Throws if storage is full (e.g., always on iOS 5+ Safari private mode, where
// storage is set to 0).
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem#Exceptions
// No need to perform any operation.
return false;}return objectToStore;};/**
 * Parses VHS-supported media types from data URIs. See
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
 * for information on data URIs.
 *
 * @param {string} dataUri
 *        The data URI
 *
 * @return {string|Object}
 *         The parsed object/string, or the original string if no supported media type
 *         was found
 */var expandDataUri=function expandDataUri(dataUri){if(dataUri.toLowerCase().indexOf('data:application/vnd.videojs.vhs+json,')===0){return JSON.parse(dataUri.substring(dataUri.indexOf(',')+1));}// no known case for this data URI, return the string as-is
return dataUri;};/**
 * Whether the browser has built-in HLS support.
 */Vhs.supportsNativeHls=function(){if(!(document_default())||!(document_default()).createElement){return false;}var video=document_default().createElement('video');// native HLS is definitely not supported if HTML5 video isn't
if(!videojs.getTech('Html5').isSupported()){return false;}// HLS manifests can go by many mime-types
var canPlay=[// Apple santioned
'application/vnd.apple.mpegurl',// Apple sanctioned for backwards compatibility
'audio/mpegurl',// Very common
'audio/x-mpegurl',// Very common
'application/x-mpegurl',// Included for completeness
'video/x-mpegurl','video/mpegurl','application/mpegurl'];return canPlay.some(function(canItPlay){return /maybe|probably/i.test(video.canPlayType(canItPlay));});}();Vhs.supportsNativeDash=function(){if(!(document_default())||!(document_default()).createElement||!videojs.getTech('Html5').isSupported()){return false;}return /maybe|probably/i.test(document_default().createElement('video').canPlayType('application/dash+xml'));}();Vhs.supportsTypeNatively=function(type){if(type==='hls'){return Vhs.supportsNativeHls;}if(type==='dash'){return Vhs.supportsNativeDash;}return false;};/**
 * HLS is a source handler, not a tech. Make sure attempts to use it
 * as one do not cause exceptions.
 */Vhs.isSupported=function(){return videojs.log.warn('HLS is no longer a tech. Please remove it from '+'your player\'s techOrder.');};var Component=videojs.getComponent('Component');/**
 * The Vhs Handler object, where we orchestrate all of the parts
 * of HLS to interact with video.js
 *
 * @class VhsHandler
 * @extends videojs.Component
 * @param {Object} source the soruce object
 * @param {Tech} tech the parent tech object
 * @param {Object} options optional and required options
 */var VhsHandler=/*#__PURE__*/function(_Component){_inheritsLoose(VhsHandler,_Component);function VhsHandler(source,tech,options){var _this;_this=_Component.call(this,tech,videojs.mergeOptions(options.hls,options.vhs))||this;if(options.hls&&Object.keys(options.hls).length){videojs.log.warn('Using hls options is deprecated. Please rename `hls` to `vhs` in your options object.');}// if a tech level `initialBandwidth` option was passed
// use that over the VHS level `bandwidth` option
if(typeof options.initialBandwidth==='number'){_this.options_.bandwidth=options.initialBandwidth;}_this.logger_=logger('VhsHandler');// tech.player() is deprecated but setup a reference to HLS for
// backwards-compatibility
if(tech.options_&&tech.options_.playerId){var _player=videojs(tech.options_.playerId);if(!_player.hasOwnProperty('hls')){Object.defineProperty(_player,'hls',{get:function get(){videojs.log.warn('player.hls is deprecated. Use player.tech().vhs instead.');tech.trigger({type:'usage',name:'hls-player-access'});return _assertThisInitialized(_this);},configurable:true});}if(!_player.hasOwnProperty('vhs')){Object.defineProperty(_player,'vhs',{get:function get(){videojs.log.warn('player.vhs is deprecated. Use player.tech().vhs instead.');tech.trigger({type:'usage',name:'vhs-player-access'});return _assertThisInitialized(_this);},configurable:true});}if(!_player.hasOwnProperty('dash')){Object.defineProperty(_player,'dash',{get:function get(){videojs.log.warn('player.dash is deprecated. Use player.tech().vhs instead.');return _assertThisInitialized(_this);},configurable:true});}_this.player_=_player;}_this.tech_=tech;_this.source_=source;_this.stats={};_this.ignoreNextSeekingEvent_=false;_this.setOptions_();if(_this.options_.overrideNative&&tech.overrideNativeAudioTracks&&tech.overrideNativeVideoTracks){tech.overrideNativeAudioTracks(true);tech.overrideNativeVideoTracks(true);}else if(_this.options_.overrideNative&&(tech.featuresNativeVideoTracks||tech.featuresNativeAudioTracks)){// overriding native HLS only works if audio tracks have been emulated
// error early if we're misconfigured
throw new Error('Overriding native HLS requires emulated tracks. '+'See https://git.io/vMpjB');}// listen for fullscreenchange events for this player so that we
// can adjust our quality selection quickly
_this.on((document_default()),['fullscreenchange','webkitfullscreenchange','mozfullscreenchange','MSFullscreenChange'],function(event){var fullscreenElement=(document_default()).fullscreenElement||(document_default()).webkitFullscreenElement||(document_default()).mozFullScreenElement||(document_default()).msFullscreenElement;if(fullscreenElement&&fullscreenElement.contains(_this.tech_.el())){_this.masterPlaylistController_.fastQualityChange_();}else{// When leaving fullscreen, since the in page pixel dimensions should be smaller
// than full screen, see if there should be a rendition switch down to preserve
// bandwidth.
_this.masterPlaylistController_.checkABR_();}});_this.on(_this.tech_,'seeking',function(){if(this.ignoreNextSeekingEvent_){this.ignoreNextSeekingEvent_=false;return;}this.setCurrentTime(this.tech_.currentTime());});_this.on(_this.tech_,'error',function(){// verify that the error was real and we are loaded
// enough to have mpc loaded.
if(this.tech_.error()&&this.masterPlaylistController_){this.masterPlaylistController_.pauseLoading();}});_this.on(_this.tech_,'play',_this.play);return _this;}var _proto=VhsHandler.prototype;_proto.setOptions_=function setOptions_(){var _this2=this;// defaults
this.options_.withCredentials=this.options_.withCredentials||false;this.options_.handleManifestRedirects=this.options_.handleManifestRedirects===false?false:true;this.options_.limitRenditionByPlayerDimensions=this.options_.limitRenditionByPlayerDimensions===false?false:true;this.options_.useDevicePixelRatio=this.options_.useDevicePixelRatio||false;this.options_.smoothQualityChange=this.options_.smoothQualityChange||false;this.options_.useBandwidthFromLocalStorage=typeof this.source_.useBandwidthFromLocalStorage!=='undefined'?this.source_.useBandwidthFromLocalStorage:this.options_.useBandwidthFromLocalStorage||false;this.options_.useNetworkInformationApi=this.options_.useNetworkInformationApi||false;this.options_.useDtsForTimestampOffset=this.options_.useDtsForTimestampOffset||false;this.options_.customTagParsers=this.options_.customTagParsers||[];this.options_.customTagMappers=this.options_.customTagMappers||[];this.options_.cacheEncryptionKeys=this.options_.cacheEncryptionKeys||false;if(typeof this.options_.blacklistDuration!=='number'){this.options_.blacklistDuration=5*60;}if(typeof this.options_.bandwidth!=='number'){if(this.options_.useBandwidthFromLocalStorage){var storedObject=getVhsLocalStorage();if(storedObject&&storedObject.bandwidth){this.options_.bandwidth=storedObject.bandwidth;this.tech_.trigger({type:'usage',name:'vhs-bandwidth-from-local-storage'});this.tech_.trigger({type:'usage',name:'hls-bandwidth-from-local-storage'});}if(storedObject&&storedObject.throughput){this.options_.throughput=storedObject.throughput;this.tech_.trigger({type:'usage',name:'vhs-throughput-from-local-storage'});this.tech_.trigger({type:'usage',name:'hls-throughput-from-local-storage'});}}}// if bandwidth was not set by options or pulled from local storage, start playlist
// selection at a reasonable bandwidth
if(typeof this.options_.bandwidth!=='number'){this.options_.bandwidth=Config.INITIAL_BANDWIDTH;}// If the bandwidth number is unchanged from the initial setting
// then this takes precedence over the enableLowInitialPlaylist option
this.options_.enableLowInitialPlaylist=this.options_.enableLowInitialPlaylist&&this.options_.bandwidth===Config.INITIAL_BANDWIDTH;// grab options passed to player.src
['withCredentials','useDevicePixelRatio','limitRenditionByPlayerDimensions','bandwidth','smoothQualityChange','customTagParsers','customTagMappers','handleManifestRedirects','cacheEncryptionKeys','playlistSelector','initialPlaylistSelector','experimentalBufferBasedABR','liveRangeSafeTimeDelta','experimentalLLHLS','useNetworkInformationApi','useDtsForTimestampOffset','experimentalExactManifestTimings','experimentalLeastPixelDiffSelector'].forEach(function(option){if(typeof _this2.source_[option]!=='undefined'){_this2.options_[option]=_this2.source_[option];}});this.limitRenditionByPlayerDimensions=this.options_.limitRenditionByPlayerDimensions;this.useDevicePixelRatio=this.options_.useDevicePixelRatio;}/**
   * called when player.src gets called, handle a new source
   *
   * @param {Object} src the source object to handle
   */;_proto.src=function src(_src,type){var _this3=this;// do nothing if the src is falsey
if(!_src){return;}this.setOptions_();// add master playlist controller options
this.options_.src=expandDataUri(this.source_.src);this.options_.tech=this.tech_;this.options_.externVhs=Vhs;this.options_.sourceType=simpleTypeFromSourceType(type);// Whenever we seek internally, we should update the tech
this.options_.seekTo=function(time){_this3.tech_.setCurrentTime(time);};if(this.options_.smoothQualityChange){videojs.log.warn('smoothQualityChange is deprecated and will be removed in the next major version');}this.masterPlaylistController_=new MasterPlaylistController(this.options_);var playbackWatcherOptions=videojs.mergeOptions({liveRangeSafeTimeDelta:SAFE_TIME_DELTA},this.options_,{seekable:function seekable(){return _this3.seekable();},media:function media(){return _this3.masterPlaylistController_.media();},masterPlaylistController:this.masterPlaylistController_});this.playbackWatcher_=new PlaybackWatcher(playbackWatcherOptions);this.masterPlaylistController_.on('error',function(){var player=videojs.players[_this3.tech_.options_.playerId];var error=_this3.masterPlaylistController_.error;if(video_es_typeof(error)==='object'&&!error.code){error.code=3;}else if(typeof error==='string'){error={message:error,code:3};}player.error(error);});var defaultSelector=this.options_.experimentalBufferBasedABR?Vhs.movingAverageBandwidthSelector(0.55):Vhs.STANDARD_PLAYLIST_SELECTOR;// `this` in selectPlaylist should be the VhsHandler for backwards
// compatibility with < v2
this.masterPlaylistController_.selectPlaylist=this.selectPlaylist?this.selectPlaylist.bind(this):defaultSelector.bind(this);this.masterPlaylistController_.selectInitialPlaylist=Vhs.INITIAL_PLAYLIST_SELECTOR.bind(this);// re-expose some internal objects for backwards compatibility with < v2
this.playlists=this.masterPlaylistController_.masterPlaylistLoader_;this.mediaSource=this.masterPlaylistController_.mediaSource;// Proxy assignment of some properties to the master playlist
// controller. Using a custom property for backwards compatibility
// with < v2
Object.defineProperties(this,{selectPlaylist:{get:function get(){return this.masterPlaylistController_.selectPlaylist;},set:function set(selectPlaylist){this.masterPlaylistController_.selectPlaylist=selectPlaylist.bind(this);}},throughput:{get:function get(){return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;},set:function set(throughput){this.masterPlaylistController_.mainSegmentLoader_.throughput.rate=throughput;// By setting `count` to 1 the throughput value becomes the starting value
// for the cumulative average
this.masterPlaylistController_.mainSegmentLoader_.throughput.count=1;}},bandwidth:{get:function get(){var playerBandwidthEst=this.masterPlaylistController_.mainSegmentLoader_.bandwidth;var networkInformation=(window_default()).navigator.connection||(window_default()).navigator.mozConnection||(window_default()).navigator.webkitConnection;var tenMbpsAsBitsPerSecond=10e6;if(this.options_.useNetworkInformationApi&&networkInformation){// downlink returns Mbps
// https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/downlink
var networkInfoBandwidthEstBitsPerSec=networkInformation.downlink*1000*1000;// downlink maxes out at 10 Mbps. In the event that both networkInformationApi and the player
// estimate a bandwidth greater than 10 Mbps, use the larger of the two estimates to ensure that
// high quality streams are not filtered out.
if(networkInfoBandwidthEstBitsPerSec>=tenMbpsAsBitsPerSecond&&playerBandwidthEst>=tenMbpsAsBitsPerSecond){playerBandwidthEst=Math.max(playerBandwidthEst,networkInfoBandwidthEstBitsPerSec);}else{playerBandwidthEst=networkInfoBandwidthEstBitsPerSec;}}return playerBandwidthEst;},set:function set(bandwidth){this.masterPlaylistController_.mainSegmentLoader_.bandwidth=bandwidth;// setting the bandwidth manually resets the throughput counter
// `count` is set to zero that current value of `rate` isn't included
// in the cumulative average
this.masterPlaylistController_.mainSegmentLoader_.throughput={rate:0,count:0};}},/**
       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
       * the entire process after that - decryption, transmuxing, and appending - provided
       * by `throughput`.
       *
       * Since the two process are serial, the overall system bandwidth is given by:
       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
       */systemBandwidth:{get:function get(){var invBandwidth=1/(this.bandwidth||1);var invThroughput;if(this.throughput>0){invThroughput=1/this.throughput;}else{invThroughput=0;}var systemBitrate=Math.floor(1/(invBandwidth+invThroughput));return systemBitrate;},set:function set(){videojs.log.error('The "systemBandwidth" property is read-only');}}});if(this.options_.bandwidth){this.bandwidth=this.options_.bandwidth;}if(this.options_.throughput){this.throughput=this.options_.throughput;}Object.defineProperties(this.stats,{bandwidth:{get:function get(){return _this3.bandwidth||0;},enumerable:true},mediaRequests:{get:function get(){return _this3.masterPlaylistController_.mediaRequests_()||0;},enumerable:true},mediaRequestsAborted:{get:function get(){return _this3.masterPlaylistController_.mediaRequestsAborted_()||0;},enumerable:true},mediaRequestsTimedout:{get:function get(){return _this3.masterPlaylistController_.mediaRequestsTimedout_()||0;},enumerable:true},mediaRequestsErrored:{get:function get(){return _this3.masterPlaylistController_.mediaRequestsErrored_()||0;},enumerable:true},mediaTransferDuration:{get:function get(){return _this3.masterPlaylistController_.mediaTransferDuration_()||0;},enumerable:true},mediaBytesTransferred:{get:function get(){return _this3.masterPlaylistController_.mediaBytesTransferred_()||0;},enumerable:true},mediaSecondsLoaded:{get:function get(){return _this3.masterPlaylistController_.mediaSecondsLoaded_()||0;},enumerable:true},mediaAppends:{get:function get(){return _this3.masterPlaylistController_.mediaAppends_()||0;},enumerable:true},mainAppendsToLoadedData:{get:function get(){return _this3.masterPlaylistController_.mainAppendsToLoadedData_()||0;},enumerable:true},audioAppendsToLoadedData:{get:function get(){return _this3.masterPlaylistController_.audioAppendsToLoadedData_()||0;},enumerable:true},appendsToLoadedData:{get:function get(){return _this3.masterPlaylistController_.appendsToLoadedData_()||0;},enumerable:true},timeToLoadedData:{get:function get(){return _this3.masterPlaylistController_.timeToLoadedData_()||0;},enumerable:true},buffered:{get:function get(){return timeRangesToArray(_this3.tech_.buffered());},enumerable:true},currentTime:{get:function get(){return _this3.tech_.currentTime();},enumerable:true},currentSource:{get:function get(){return _this3.tech_.currentSource_;},enumerable:true},currentTech:{get:function get(){return _this3.tech_.name_;},enumerable:true},duration:{get:function get(){return _this3.tech_.duration();},enumerable:true},master:{get:function get(){return _this3.playlists.master;},enumerable:true},playerDimensions:{get:function get(){return _this3.tech_.currentDimensions();},enumerable:true},seekable:{get:function get(){return timeRangesToArray(_this3.tech_.seekable());},enumerable:true},timestamp:{get:function get(){return Date.now();},enumerable:true},videoPlaybackQuality:{get:function get(){return _this3.tech_.getVideoPlaybackQuality();},enumerable:true}});this.tech_.one('canplay',this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_));this.tech_.on('bandwidthupdate',function(){if(_this3.options_.useBandwidthFromLocalStorage){updateVhsLocalStorage({bandwidth:_this3.bandwidth,throughput:Math.round(_this3.throughput)});}});this.masterPlaylistController_.on('selectedinitialmedia',function(){// Add the manual rendition mix-in to VhsHandler
renditionSelectionMixin(_this3);});this.masterPlaylistController_.sourceUpdater_.on('createdsourcebuffers',function(){_this3.setupEme_();});// the bandwidth of the primary segment loader is our best
// estimate of overall bandwidth
this.on(this.masterPlaylistController_,'progress',function(){this.tech_.trigger('progress');});// In the live case, we need to ignore the very first `seeking` event since
// that will be the result of the seek-to-live behavior
this.on(this.masterPlaylistController_,'firstplay',function(){this.ignoreNextSeekingEvent_=true;});this.setupQualityLevels_();// do nothing if the tech has been disposed already
// this can occur if someone sets the src in player.ready(), for instance
if(!this.tech_.el()){return;}this.mediaSourceUrl_=window_default().URL.createObjectURL(this.masterPlaylistController_.mediaSource);this.tech_.src(this.mediaSourceUrl_);};_proto.createKeySessions_=function createKeySessions_(){var _this4=this;var audioPlaylistLoader=this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;this.logger_('waiting for EME key session creation');waitForKeySessionCreation({player:this.player_,sourceKeySystems:this.source_.keySystems,audioMedia:audioPlaylistLoader&&audioPlaylistLoader.media(),mainPlaylists:this.playlists.master.playlists}).then(function(){_this4.logger_('created EME key session');_this4.masterPlaylistController_.sourceUpdater_.initializedEme();})["catch"](function(err){_this4.logger_('error while creating EME key session',err);_this4.player_.error({message:'Failed to initialize media keys for EME',code:3});});};_proto.handleWaitingForKey_=function handleWaitingForKey_(){// If waitingforkey is fired, it's possible that the data that's necessary to retrieve
// the key is in the manifest. While this should've happened on initial source load, it
// may happen again in live streams where the keys change, and the manifest info
// reflects the update.
//
// Because videojs-contrib-eme compares the PSSH data we send to that of PSSH data it's
// already requested keys for, we don't have to worry about this generating extraneous
// requests.
this.logger_('waitingforkey fired, attempting to create any new key sessions');this.createKeySessions_();}/**
   * If necessary and EME is available, sets up EME options and waits for key session
   * creation.
   *
   * This function also updates the source updater so taht it can be used, as for some
   * browsers, EME must be configured before content is appended (if appending unencrypted
   * content before encrypted content).
   */;_proto.setupEme_=function setupEme_(){var _this5=this;var audioPlaylistLoader=this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;var didSetupEmeOptions=setupEmeOptions({player:this.player_,sourceKeySystems:this.source_.keySystems,media:this.playlists.media(),audioMedia:audioPlaylistLoader&&audioPlaylistLoader.media()});this.player_.tech_.on('keystatuschange',function(e){if(e.status!=='output-restricted'){return;}var masterPlaylist=_this5.masterPlaylistController_.master();if(!masterPlaylist||!masterPlaylist.playlists){return;}var excludedHDPlaylists=[];// Assume all HD streams are unplayable and exclude them from ABR selection
masterPlaylist.playlists.forEach(function(playlist){if(playlist&&playlist.attributes&&playlist.attributes.RESOLUTION&&playlist.attributes.RESOLUTION.height>=720){if(!playlist.excludeUntil||playlist.excludeUntil<Infinity){playlist.excludeUntil=Infinity;excludedHDPlaylists.push(playlist);}}});if(excludedHDPlaylists.length){var _videojs$log;(_videojs$log=videojs.log).warn.apply(_videojs$log,['DRM keystatus changed to "output-restricted." Removing the following HD playlists '+'that will most likely fail to play and clearing the buffer. '+'This may be due to HDCP restrictions on the stream and the capabilities of the current device.'].concat(excludedHDPlaylists));// Clear the buffer before switching playlists, since it may already contain unplayable segments
_this5.masterPlaylistController_.fastQualityChange_();}});this.handleWaitingForKey_=this.handleWaitingForKey_.bind(this);this.player_.tech_.on('waitingforkey',this.handleWaitingForKey_);// In IE11 this is too early to initialize media keys, and IE11 does not support
// promises.
if(videojs.browser.IE_VERSION===11||!didSetupEmeOptions){// If EME options were not set up, we've done all we could to initialize EME.
this.masterPlaylistController_.sourceUpdater_.initializedEme();return;}this.createKeySessions_();}/**
   * Initializes the quality levels and sets listeners to update them.
   *
   * @method setupQualityLevels_
   * @private
   */;_proto.setupQualityLevels_=function setupQualityLevels_(){var _this6=this;var player=videojs.players[this.tech_.options_.playerId];// if there isn't a player or there isn't a qualityLevels plugin
// or qualityLevels_ listeners have already been setup, do nothing.
if(!player||!player.qualityLevels||this.qualityLevels_){return;}this.qualityLevels_=player.qualityLevels();this.masterPlaylistController_.on('selectedinitialmedia',function(){handleVhsLoadedMetadata(_this6.qualityLevels_,_this6);});this.playlists.on('mediachange',function(){handleVhsMediaChange(_this6.qualityLevels_,_this6.playlists);});}/**
   * return the version
   */;VhsHandler.version=function version$5(){return{'@videojs/http-streaming':version$4,'mux.js':version$3,'mpd-parser':version$2,'m3u8-parser':version$1,'aes-decrypter':video_es_version};}/**
   * return the version
   */;_proto.version=function version(){return this.constructor.version();};_proto.canChangeType=function canChangeType(){return SourceUpdater.canChangeType();}/**
   * Begin playing the video.
   */;_proto.play=function play(){this.masterPlaylistController_.play();}/**
   * a wrapper around the function in MasterPlaylistController
   */;_proto.setCurrentTime=function setCurrentTime(currentTime){this.masterPlaylistController_.setCurrentTime(currentTime);}/**
   * a wrapper around the function in MasterPlaylistController
   */;_proto.duration=function duration(){return this.masterPlaylistController_.duration();}/**
   * a wrapper around the function in MasterPlaylistController
   */;_proto.seekable=function seekable(){return this.masterPlaylistController_.seekable();}/**
   * Abort all outstanding work and cleanup.
   */;_proto.dispose=function dispose(){if(this.playbackWatcher_){this.playbackWatcher_.dispose();}if(this.masterPlaylistController_){this.masterPlaylistController_.dispose();}if(this.qualityLevels_){this.qualityLevels_.dispose();}if(this.player_){delete this.player_.vhs;delete this.player_.dash;delete this.player_.hls;}if(this.tech_&&this.tech_.vhs){delete this.tech_.vhs;}// don't check this.tech_.hls as it will log a deprecated warning
if(this.tech_){delete this.tech_.hls;}if(this.mediaSourceUrl_&&(window_default()).URL.revokeObjectURL){window_default().URL.revokeObjectURL(this.mediaSourceUrl_);this.mediaSourceUrl_=null;}if(this.tech_){this.tech_.off('waitingforkey',this.handleWaitingForKey_);}_Component.prototype.dispose.call(this);};_proto.convertToProgramTime=function convertToProgramTime(time,callback){return getProgramTime({playlist:this.masterPlaylistController_.media(),time:time,callback:callback});}// the player must be playing before calling this
;_proto.seekToProgramTime=function seekToProgramTime$1(programTime,callback,pauseAfterSeek,retryCount){if(pauseAfterSeek===void 0){pauseAfterSeek=true;}if(retryCount===void 0){retryCount=2;}return seekToProgramTime({programTime:programTime,playlist:this.masterPlaylistController_.media(),retryCount:retryCount,pauseAfterSeek:pauseAfterSeek,seekTo:this.options_.seekTo,tech:this.options_.tech,callback:callback});};return VhsHandler;}(Component);/**
 * The Source Handler object, which informs video.js what additional
 * MIME types are supported and sets up playback. It is registered
 * automatically to the appropriate tech based on the capabilities of
 * the browser it is running in. It is not necessary to use or modify
 * this object in normal usage.
 */var VhsSourceHandler={name:'videojs-http-streaming',VERSION:version$4,canHandleSource:function canHandleSource(srcObj,options){if(options===void 0){options={};}var localOptions=videojs.mergeOptions(videojs.options,options);return VhsSourceHandler.canPlayType(srcObj.type,localOptions);},handleSource:function handleSource(source,tech,options){if(options===void 0){options={};}var localOptions=videojs.mergeOptions(videojs.options,options);tech.vhs=new VhsHandler(source,tech,localOptions);if(!videojs.hasOwnProperty('hls')){Object.defineProperty(tech,'hls',{get:function get(){videojs.log.warn('player.tech().hls is deprecated. Use player.tech().vhs instead.');return tech.vhs;},configurable:true});}tech.vhs.xhr=xhrFactory();tech.vhs.src(source.src,source.type);return tech.vhs;},canPlayType:function canPlayType(type,options){var simpleType=simpleTypeFromSourceType(type);if(!simpleType){return'';}var overrideNative=VhsSourceHandler.getOverrideNative(options);var supportsTypeNatively=Vhs.supportsTypeNatively(simpleType);var canUseMsePlayback=!supportsTypeNatively||overrideNative;return canUseMsePlayback?'maybe':'';},getOverrideNative:function getOverrideNative(options){if(options===void 0){options={};}var _options=options,_options$vhs=_options.vhs,vhs=_options$vhs===void 0?{}:_options$vhs,_options$hls=_options.hls,hls=_options$hls===void 0?{}:_options$hls;var defaultOverrideNative=!(videojs.browser.IS_ANY_SAFARI||videojs.browser.IS_IOS);var _vhs$overrideNative=vhs.overrideNative,overrideNative=_vhs$overrideNative===void 0?defaultOverrideNative:_vhs$overrideNative;var _hls$overrideNative=hls.overrideNative,legacyOverrideNative=_hls$overrideNative===void 0?false:_hls$overrideNative;return legacyOverrideNative||overrideNative;}};/**
 * Check to see if the native MediaSource object exists and supports
 * an MP4 container with both H.264 video and AAC-LC audio.
 *
 * @return {boolean} if  native media sources are supported
 */var supportsNativeMediaSources=function supportsNativeMediaSources(){return browserSupportsCodec('avc1.4d400d,mp4a.40.2');};// register source handlers with the appropriate techs
if(supportsNativeMediaSources()){videojs.getTech('Html5').registerSourceHandler(VhsSourceHandler,0);}videojs.VhsHandler=VhsHandler;Object.defineProperty(videojs,'HlsHandler',{get:function get(){videojs.log.warn('videojs.HlsHandler is deprecated. Use videojs.VhsHandler instead.');return VhsHandler;},configurable:true});videojs.VhsSourceHandler=VhsSourceHandler;Object.defineProperty(videojs,'HlsSourceHandler',{get:function get(){videojs.log.warn('videojs.HlsSourceHandler is deprecated. '+'Use videojs.VhsSourceHandler instead.');return VhsSourceHandler;},configurable:true});videojs.Vhs=Vhs;Object.defineProperty(videojs,'Hls',{get:function get(){videojs.log.warn('videojs.Hls is deprecated. Use videojs.Vhs instead.');return Vhs;},configurable:true});if(!videojs.use){videojs.registerComponent('Hls',Vhs);videojs.registerComponent('Vhs',Vhs);}videojs.options.vhs=videojs.options.vhs||{};videojs.options.hls=videojs.options.hls||{};if(!videojs.getPlugin||!videojs.getPlugin('reloadSourceOnError')){var registerPlugin=videojs.registerPlugin||videojs.plugin;registerPlugin('reloadSourceOnError',reloadSourceOnError);}/* harmony default export */ const video_es = (videojs);
// EXTERNAL MODULE: ./node_modules/video.js/dist/video-js.css
var video_js = __webpack_require__(82102);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/style.scss
var video_style = __webpack_require__(10962);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.get.js
var es_reflect_get = __webpack_require__(74819);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/forwardButton/forwardButton.js
function forwardButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { forwardButton_typeof = function _typeof(obj) { return typeof obj; }; } else { forwardButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return forwardButton_typeof(obj); }











function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = forwardButton_getPrototypeOf(object); if (object === null) break; } return object; }
function forwardButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) forwardButton_setPrototypeOf(subClass, superClass); }
function forwardButton_setPrototypeOf(o, p) { forwardButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return forwardButton_setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = forwardButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = forwardButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = forwardButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (forwardButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return forwardButton_assertThisInitialized(self); }
function forwardButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function forwardButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function forwardButton_getPrototypeOf(o) { forwardButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return forwardButton_getPrototypeOf(o); }

var forwardButton_Button = video_es.getComponent('Button');
var ForwardButton = /*#__PURE__*/function (_Button) {
  forwardButton_inherits(ForwardButton, _Button);
  var _super = _createSuper(ForwardButton);
  function ForwardButton(player, options) {
    var _this;
    _classCallCheck(this, ForwardButton);
    _this = _super.call(this, player, options);
    _this.secs = options.seconds || 5;
    return _this;
  }
  _createClass(ForwardButton, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-forward-control ".concat(_get(forwardButton_getPrototypeOf(ForwardButton.prototype), "buildCSSClass", this).call(this));
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var time = this.player().currentTime() + this.secs;
      if (time < 0) {
        time = 0;
      }
      this.player().currentTime(time);
    }
  }]);
  return ForwardButton;
}(forwardButton_Button);
ForwardButton.prototype.controlText_ = 'Forward';
/* harmony default export */ const forwardButton = (ForwardButton);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/forwardButton/style.scss
var forwardButton_style = __webpack_require__(83473);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/forwardButton/index.js
function plugins_forwardButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_forwardButton_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_forwardButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_forwardButton_typeof(obj); }









function forwardButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_forwardButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_forwardButton_setPrototypeOf(subClass, superClass); }
function plugins_forwardButton_setPrototypeOf(o, p) { plugins_forwardButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_forwardButton_setPrototypeOf(o, p); }
function forwardButton_createSuper(Derived) { var hasNativeReflectConstruct = plugins_forwardButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_forwardButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_forwardButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return forwardButton_possibleConstructorReturn(this, result); }; }
function forwardButton_possibleConstructorReturn(self, call) { if (call && (plugins_forwardButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_forwardButton_assertThisInitialized(self); }
function plugins_forwardButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_forwardButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_forwardButton_getPrototypeOf(o) { plugins_forwardButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_forwardButton_getPrototypeOf(o); }



var forwardButton_Plugin = video_es.getPlugin('plugin');
var forwardButton_Component = video_es.getComponent('Component');
forwardButton_Component.registerComponent('forwardButton', forwardButton);
var ForwardButtonPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_forwardButton_inherits(ForwardButtonPlugin, _Plugin);
  var _super = forwardButton_createSuper(ForwardButtonPlugin);
  function ForwardButtonPlugin(player, options) {
    var _this;
    forwardButton_classCallCheck(this, ForwardButtonPlugin);
    _this = _super.call(this, player);
    player.ready(function () {
      player.controlBar.forwardButton = player.controlBar.addChild('forwardButton', {
        seconds: options.seconds
      }, options.index);
    });
    return _this;
  }
  return ForwardButtonPlugin;
}(forwardButton_Plugin);

// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(27266);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/downloadButton/downloadButton.js
function downloadButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { downloadButton_typeof = function _typeof(obj) { return typeof obj; }; } else { downloadButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return downloadButton_typeof(obj); }











function downloadButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function downloadButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function downloadButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) downloadButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) downloadButton_defineProperties(Constructor, staticProps); return Constructor; }
function downloadButton_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { downloadButton_get = Reflect.get; } else { downloadButton_get = function _get(target, property, receiver) { var base = downloadButton_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return downloadButton_get(target, property, receiver || target); }
function downloadButton_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = downloadButton_getPrototypeOf(object); if (object === null) break; } return object; }
function downloadButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) downloadButton_setPrototypeOf(subClass, superClass); }
function downloadButton_setPrototypeOf(o, p) { downloadButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return downloadButton_setPrototypeOf(o, p); }
function downloadButton_createSuper(Derived) { var hasNativeReflectConstruct = downloadButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = downloadButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = downloadButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return downloadButton_possibleConstructorReturn(this, result); }; }
function downloadButton_possibleConstructorReturn(self, call) { if (call && (downloadButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return downloadButton_assertThisInitialized(self); }
function downloadButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function downloadButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function downloadButton_getPrototypeOf(o) { downloadButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return downloadButton_getPrototypeOf(o); }


var downloadButton_Button = video_es.getComponent('Button');
var DownloadButton = /*#__PURE__*/function (_Button) {
  downloadButton_inherits(DownloadButton, _Button);
  var _super = downloadButton_createSuper(DownloadButton);
  function DownloadButton(player, options) {
    downloadButton_classCallCheck(this, DownloadButton);
    return _super.call(this, player, options);
  }
  downloadButton_createClass(DownloadButton, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-download-button ".concat(downloadButton_get(downloadButton_getPrototypeOf(DownloadButton.prototype), "buildCSSClass", this).call(this));
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (!this.options().downloadFn || !this.options().downloadFn(this.options().attachment)) {
        download_default()(this.options().attachment.url);
      }
    }
  }]);
  return DownloadButton;
}(downloadButton_Button);
DownloadButton.prototype.controlText_ = 'Download';
/* harmony default export */ const downloadButton = (DownloadButton);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/downloadButton/style.scss
var downloadButton_style = __webpack_require__(42742);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/downloadButton/index.js
function plugins_downloadButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_downloadButton_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_downloadButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_downloadButton_typeof(obj); }









function plugins_downloadButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_downloadButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_downloadButton_setPrototypeOf(subClass, superClass); }
function plugins_downloadButton_setPrototypeOf(o, p) { plugins_downloadButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_downloadButton_setPrototypeOf(o, p); }
function plugins_downloadButton_createSuper(Derived) { var hasNativeReflectConstruct = plugins_downloadButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_downloadButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_downloadButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_downloadButton_possibleConstructorReturn(this, result); }; }
function plugins_downloadButton_possibleConstructorReturn(self, call) { if (call && (plugins_downloadButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_downloadButton_assertThisInitialized(self); }
function plugins_downloadButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_downloadButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_downloadButton_getPrototypeOf(o) { plugins_downloadButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_downloadButton_getPrototypeOf(o); }



var downloadButton_Plugin = video_es.getPlugin('plugin');
var downloadButton_Component = video_es.getComponent('Component');
downloadButton_Component.registerComponent('downloadButton', downloadButton);
var DownloadButtonPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_downloadButton_inherits(DownloadButtonPlugin, _Plugin);
  var _super = plugins_downloadButton_createSuper(DownloadButtonPlugin);
  function DownloadButtonPlugin(player, options) {
    var _this;
    plugins_downloadButton_classCallCheck(this, DownloadButtonPlugin);
    _this = _super.call(this, player);
    player.ready(function () {
      player.controlBar.downloadButton = player.controlBar.addChild('downloadButton', {
        downloadFn: options.downloadFn,
        attachment: options.attachment
      }, options.index);
    });
    return _this;
  }
  return DownloadButtonPlugin;
}(downloadButton_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/controlShadow/controlShadow.js
function controlShadow_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { controlShadow_typeof = function _typeof(obj) { return typeof obj; }; } else { controlShadow_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return controlShadow_typeof(obj); }











function controlShadow_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function controlShadow_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function controlShadow_createClass(Constructor, protoProps, staticProps) { if (protoProps) controlShadow_defineProperties(Constructor.prototype, protoProps); if (staticProps) controlShadow_defineProperties(Constructor, staticProps); return Constructor; }
function controlShadow_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { controlShadow_get = Reflect.get; } else { controlShadow_get = function _get(target, property, receiver) { var base = controlShadow_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return controlShadow_get(target, property, receiver || target); }
function controlShadow_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = controlShadow_getPrototypeOf(object); if (object === null) break; } return object; }
function controlShadow_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) controlShadow_setPrototypeOf(subClass, superClass); }
function controlShadow_setPrototypeOf(o, p) { controlShadow_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return controlShadow_setPrototypeOf(o, p); }
function controlShadow_createSuper(Derived) { var hasNativeReflectConstruct = controlShadow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = controlShadow_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = controlShadow_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return controlShadow_possibleConstructorReturn(this, result); }; }
function controlShadow_possibleConstructorReturn(self, call) { if (call && (controlShadow_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return controlShadow_assertThisInitialized(self); }
function controlShadow_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function controlShadow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function controlShadow_getPrototypeOf(o) { controlShadow_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return controlShadow_getPrototypeOf(o); }

var controlShadow_Spacer = video_es.getComponent('Spacer');
var ControlShadow = /*#__PURE__*/function (_Spacer) {
  controlShadow_inherits(ControlShadow, _Spacer);
  var _super = controlShadow_createSuper(ControlShadow);
  function ControlShadow(player, options) {
    controlShadow_classCallCheck(this, ControlShadow);
    return _super.call(this, player, options);
  }
  controlShadow_createClass(ControlShadow, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-shadow";
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!props.className) {
        props.className = this.buildCSSClass();
      }
      var node = controlShadow_get(controlShadow_getPrototypeOf(ControlShadow.prototype), "createEl", this).call(this, tag, props, attributes);
      var controlShadow = document.createElement('div');
      controlShadow.classList.add('vjs-control-shadow');
      var videoName = document.createElement('div');
      videoName.classList.add('vjs-video-name');
      videoName.innerText = this.options().videoName;
      node.appendChild(videoName);
      node.appendChild(controlShadow);
      return node;
    }
  }]);
  return ControlShadow;
}(controlShadow_Spacer);
ControlShadow.prototype.controlText_ = 'Shadow';
/* harmony default export */ const controlShadow = (ControlShadow);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/controlShadow/style.scss
var controlShadow_style = __webpack_require__(95306);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/controlShadow/index.js
function plugins_controlShadow_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_controlShadow_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_controlShadow_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_controlShadow_typeof(obj); }














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function plugins_controlShadow_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_controlShadow_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_controlShadow_setPrototypeOf(subClass, superClass); }
function plugins_controlShadow_setPrototypeOf(o, p) { plugins_controlShadow_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_controlShadow_setPrototypeOf(o, p); }
function plugins_controlShadow_createSuper(Derived) { var hasNativeReflectConstruct = plugins_controlShadow_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_controlShadow_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_controlShadow_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_controlShadow_possibleConstructorReturn(this, result); }; }
function plugins_controlShadow_possibleConstructorReturn(self, call) { if (call && (plugins_controlShadow_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_controlShadow_assertThisInitialized(self); }
function plugins_controlShadow_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_controlShadow_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_controlShadow_getPrototypeOf(o) { plugins_controlShadow_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_controlShadow_getPrototypeOf(o); }



var controlShadow_Plugin = video_es.getPlugin('plugin');
var controlShadow_Component = video_es.getComponent('Component');
controlShadow_Component.registerComponent('controlShadow', controlShadow);
var ControlShadowPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_controlShadow_inherits(ControlShadowPlugin, _Plugin);
  var _super = plugins_controlShadow_createSuper(ControlShadowPlugin);
  function ControlShadowPlugin(player, options) {
    var _this;
    plugins_controlShadow_classCallCheck(this, ControlShadowPlugin);
    _this = _super.call(this, player);
    player.controlShadow = player.addChild('controlShadow', _objectSpread({}, options), 3);
    return _this;
  }
  return ControlShadowPlugin;
}(controlShadow_Plugin);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/preact/hooks/dist/hooks.module.js
var hooks_module = __webpack_require__(8065);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/callToAction/style.scss
var callToAction_style = __webpack_require__(8523);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/callToAction/ctaComponent.js
function ctaComponent_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
















var buttonPadding = parseInt(callToAction_style.ctaButtonPadding.replace('px', ''));
var PlayAgainButton = function PlayAgainButton(_ref) {
  var onPlayAgain = _ref.onPlayAgain,
    type = _ref.type,
    description = _ref.description,
    i18n = _ref.i18n;
  var className = ['video-player-cta__play-again-button'];
  if (type === 'button' && !description || type === 'image') {
    className.push('video-player-cta__play-again-button_style_button');
  }
  return (0,preact_module.h)("div", {
    className: "video-player-cta__play-again-wrap"
  }, (0,preact_module.h)("button", {
    onClick: onPlayAgain,
    className: className.join(' ')
  }, (0,preact_module.h)("span", null, i18n.get('video.player.watch_again'))));
};
var CtaButton = function CtaButton(props) {
  var description = props.description,
    title = props.title,
    address = props.address,
    buttonSize = props.buttonSize,
    background = props.background,
    buttonShape = props.buttonShape,
    buttonId = props.buttonId,
    playAgainBtn = props.playAgainBtn;
  var wrapCls = ['button-single'];
  if (description) {
    wrapCls.push('video-player-cta__button');
  }
  return (0,preact_module.h)("div", {
    className: "video-player-cta__button-wrapper"
  }, (0,preact_module.h)("div", {
    className: wrapCls.join(' ')
  }, (0,preact_module.h)("div", {
    className: "video-player-cta__nimbus-button-wrap"
  }, (0,preact_module.h)("nimbus-button", {
    id: buttonId,
    "data-size": buttonSize,
    "data-background": background,
    "data-shape": buttonShape,
    "data-type": "default",
    className: "single-button",
    onClick: function onClick() {
      return window.open(address, '_blank');
    }
  }, (0,preact_module.h)("span", {
    className: "button-content"
  }, (0,preact_module.h)("b", null, title)))), description ? (0,preact_module.h)("div", {
    className: "video-payer-cta__description"
  }, description) : null, props.whenToShow === 'end' && props.showPlayAgain ? (0,preact_module.h)(PlayAgainButton, props) : null), playAgainBtn);
};
var CtaImageLink = function CtaImageLink(_ref2) {
  var address = _ref2.address,
    children = _ref2.children;
  if (address) {
    return (0,preact_module.h)("a", {
      href: address,
      target: "_blank",
      className: "video-payer-cta__image-link"
    }, children);
  }
  return children;
};
var CtaImage = function CtaImage(props) {
  var address = props.address,
    imageUrl = props.imageUrl;
  return (0,preact_module.h)("div", {
    className: "video-player-cta__image-wrapper"
  }, (0,preact_module.h)(CtaImageLink, {
    address: address
  }, (0,preact_module.h)("img", {
    src: imageUrl,
    className: "video-player-cta__image"
  })), props.whenToShow === 'end' && props.showPlayAgain ? (0,preact_module.h)(PlayAgainButton, props) : null);
};
var recalculateSize = function recalculateSize(wrapRef, ctaRef, params) {
  if (!(ctaRef !== null && ctaRef !== void 0 && ctaRef.current) || !(wrapRef !== null && wrapRef !== void 0 && wrapRef.current)) return false;
  var setHeight = params.setHeight,
    setWidth = params.setWidth,
    setButtonOversize = params.setButtonOversize,
    setCtaOversize = params.setCtaOversize,
    setIsPanel = params.setIsPanel,
    hideControls = params.hideControls;
  var ctaRect = ctaRef.current.getBoundingClientRect();
  var _wrapRef$current$clos = wrapRef.current.closest('.video-js').querySelector('video').getBoundingClientRect(),
    width = _wrapRef$current$clos.width,
    height = _wrapRef$current$clos.height;
  if (height) {
    var hasPanel = width >= 350 && !hideControls;
    var oversize = ctaRect.height >= height - 30;
    var buttonOversize = ctaRect.width >= width - 2 * buttonPadding;
    setHeight(height);
    setWidth(width);
    setButtonOversize(buttonOversize);
    setCtaOversize(oversize);
    setIsPanel(hasPanel);
  }
};
var CtaComponent = function CtaComponent(props) {
  var _ref3;
  var hideControls = props.hideControls,
    type = props.type,
    description = props.description,
    title = props.title;
  var ref = (0,hooks_module/* useRef */.sO)(null);
  var ctaRef = (0,hooks_module/* useRef */.sO)(null);
  var _useState = (0,hooks_module/* useState */.eJ)(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var _useState3 = (0,hooks_module/* useState */.eJ)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var _useState5 = (0,hooks_module/* useState */.eJ)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    buttonOversize = _useState6[0],
    setButtonOversize = _useState6[1];
  var _useState7 = (0,hooks_module/* useState */.eJ)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    ctaOversize = _useState8[0],
    setCtaOversize = _useState8[1];
  var _useState9 = (0,hooks_module/* useState */.eJ)(true),
    _useState10 = _slicedToArray(_useState9, 2),
    isPanel = _useState10[0],
    setIsPanel = _useState10[1];
  (0,hooks_module/* useEffect */.d4)(function () {
    setCtaOversize(false);
  }, [description, title]);
  (0,hooks_module/* useEffect */.d4)(function () {
    if (!(ref !== null && ref !== void 0 && ref.current)) return;
    var ro = new ResizeObserver(function () {
      recalculateSize(ref, ctaRef, {
        setWidth: setWidth,
        setHeight: setHeight,
        setButtonOversize: setButtonOversize,
        setCtaOversize: setCtaOversize,
        setIsPanel: setIsPanel,
        hideControls: hideControls
      });
    });
    ro.observe(ref.current);
    return function () {
      ro.disconnect(ref.current);
    };
  }, [ctaRef === null || ctaRef === void 0 ? void 0 : ctaRef.current]);
  var cls = ['video-player-cta'];
  if (props.showPlayAgain && props.whenToShow === 'end') {
    cls.push('video-player-cta_play-again');
  }
  if (props.type === 'button') {
    cls.push('video-player-cta_button');
  }
  if (buttonOversize) {
    cls.push('video-player-cta_button-oversize');
  }
  if (ctaOversize) {
    cls.push('video-player-cta_oversize');
  }
  if (isPanel) {
    cls.push('video-player-cta_panel');
  }
  var ctaItemCls = ['video-player-cta__cta'];
  if (type === 'image') {
    ctaItemCls.push('video-player-cta__cta_type_image');
  }
  if (type === 'button') {
    ctaItemCls.push('video-player-cta__cta_type_button');
  }
  var playAgainBtn = props.whenToShow === 'end' && props.showPlayAgain && type !== 'button' ? (0,preact_module.h)(PlayAgainButton, props) : null;
  return (0,preact_module.h)("div", {
    className: cls.join(' '),
    ref: ref,
    style: (_ref3 = {}, ctaComponent_defineProperty(_ref3, '--height', height + 'px'), ctaComponent_defineProperty(_ref3, '--width', width + 'px'), _ref3)
  }, (0,preact_module.h)("div", {
    className: ctaItemCls.join(' '),
    ref: ctaRef
  }, type === 'button' ? (0,preact_module.h)(CtaButton, props) : null, type === 'image' ? (0,preact_module.h)(CtaImage, props) : null));
};
/* harmony default export */ const ctaComponent = (CtaComponent);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/callToAction/cta.js
function cta_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { cta_typeof = function _typeof(obj) { return typeof obj; }; } else { cta_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return cta_typeof(obj); }












function cta_extends() { cta_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cta_extends.apply(this, arguments); }
function cta_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function cta_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function cta_createClass(Constructor, protoProps, staticProps) { if (protoProps) cta_defineProperties(Constructor.prototype, protoProps); if (staticProps) cta_defineProperties(Constructor, staticProps); return Constructor; }
function cta_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { cta_get = Reflect.get; } else { cta_get = function _get(target, property, receiver) { var base = cta_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return cta_get(target, property, receiver || target); }
function cta_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = cta_getPrototypeOf(object); if (object === null) break; } return object; }
function cta_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) cta_setPrototypeOf(subClass, superClass); }
function cta_setPrototypeOf(o, p) { cta_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return cta_setPrototypeOf(o, p); }
function cta_createSuper(Derived) { var hasNativeReflectConstruct = cta_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = cta_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = cta_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return cta_possibleConstructorReturn(this, result); }; }
function cta_possibleConstructorReturn(self, call) { if (call && (cta_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return cta_assertThisInitialized(self); }
function cta_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function cta_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function cta_getPrototypeOf(o) { cta_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return cta_getPrototypeOf(o); }
function cta_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var cta_Spacer = video_es.getComponent('Spacer');
var CTA = /*#__PURE__*/function (_Spacer) {
  cta_inherits(CTA, _Spacer);
  var _super = cta_createSuper(CTA);
  function CTA(player, options) {
    var _this;
    cta_classCallCheck(this, CTA);
    _this = _super.call(this, player, options);
    cta_defineProperty(cta_assertThisInitialized(_this), "onPlayerPause", function () {
      if (_this.player().ended()) return;
      var _this$options = _this.options(),
        whenToShow = _this$options.whenToShow;
      if (whenToShow !== 'pause') return;
      _this.renderCtaComponent();
    });
    cta_defineProperty(cta_assertThisInitialized(_this), "onPlayerEnded", function () {
      var _this$options2 = _this.options(),
        whenToShow = _this$options2.whenToShow;
      if (whenToShow !== 'end') return;
      _this.renderCtaComponent();
    });
    cta_defineProperty(cta_assertThisInitialized(_this), "onPlayerPlay", function () {
      _this.renderCtaComponent(false);
    });
    cta_defineProperty(cta_assertThisInitialized(_this), "onPlayAgain", function () {
      _this.player().play();
    });
    player.on('pause', _this.onPlayerPause);
    player.on('ended', _this.onPlayerEnded);
    player.on('play', _this.onPlayerPlay);
    return _this;
  }
  cta_createClass(CTA, [{
    key: "renderCtaComponent",
    value: function renderCtaComponent() {
      var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var container = this.el();
      if (render) {
        (0,preact_module/* render */.sY)((0,preact_module.h)(ctaComponent, cta_extends({}, this.options(), {
          hideControls: !this.player().options().controls,
          onPlayAgain: this.onPlayAgain,
          i18n: this.options().editor.plugins.i18n
        })), container);
      } else if (container.childNodes.length) {
        (0,preact_module/* render */.sY)(null, container);
      }
    }
  }, {
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-cta";
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!props.className) {
        props.className = this.buildCSSClass();
      }
      return cta_get(cta_getPrototypeOf(CTA.prototype), "createEl", this).call(this, tag, props, attributes);
    }
  }]);
  return CTA;
}(cta_Spacer);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/callToAction/index.js
function callToAction_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { callToAction_typeof = function _typeof(obj) { return typeof obj; }; } else { callToAction_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return callToAction_typeof(obj); }














function callToAction_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function callToAction_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { callToAction_ownKeys(Object(source), true).forEach(function (key) { callToAction_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { callToAction_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function callToAction_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function callToAction_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function callToAction_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) callToAction_setPrototypeOf(subClass, superClass); }
function callToAction_setPrototypeOf(o, p) { callToAction_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return callToAction_setPrototypeOf(o, p); }
function callToAction_createSuper(Derived) { var hasNativeReflectConstruct = callToAction_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = callToAction_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = callToAction_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return callToAction_possibleConstructorReturn(this, result); }; }
function callToAction_possibleConstructorReturn(self, call) { if (call && (callToAction_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return callToAction_assertThisInitialized(self); }
function callToAction_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function callToAction_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function callToAction_getPrototypeOf(o) { callToAction_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return callToAction_getPrototypeOf(o); }



var callToAction_Plugin = video_es.getPlugin('plugin');
var callToAction_Component = video_es.getComponent('Component');
callToAction_Component.registerComponent('cta', CTA);
var CallToActionPlugin = /*#__PURE__*/function (_Plugin) {
  callToAction_inherits(CallToActionPlugin, _Plugin);
  var _super = callToAction_createSuper(CallToActionPlugin);
  function CallToActionPlugin(player, options) {
    var _this;
    callToAction_classCallCheck(this, CallToActionPlugin);
    _this = _super.call(this, player);
    player.cta = player.addChild('cta', callToAction_objectSpread({}, options), 2);
    return _this;
  }
  return CallToActionPlugin;
}(callToAction_Plugin);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/theme/icons.js
var icons = __webpack_require__(49190);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/nimbusAdv/nimbusAdv.js
function nimbusAdv_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { nimbusAdv_typeof = function _typeof(obj) { return typeof obj; }; } else { nimbusAdv_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return nimbusAdv_typeof(obj); }











function nimbusAdv_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function nimbusAdv_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function nimbusAdv_createClass(Constructor, protoProps, staticProps) { if (protoProps) nimbusAdv_defineProperties(Constructor.prototype, protoProps); if (staticProps) nimbusAdv_defineProperties(Constructor, staticProps); return Constructor; }
function nimbusAdv_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { nimbusAdv_get = Reflect.get; } else { nimbusAdv_get = function _get(target, property, receiver) { var base = nimbusAdv_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return nimbusAdv_get(target, property, receiver || target); }
function nimbusAdv_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = nimbusAdv_getPrototypeOf(object); if (object === null) break; } return object; }
function nimbusAdv_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) nimbusAdv_setPrototypeOf(subClass, superClass); }
function nimbusAdv_setPrototypeOf(o, p) { nimbusAdv_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return nimbusAdv_setPrototypeOf(o, p); }
function nimbusAdv_createSuper(Derived) { var hasNativeReflectConstruct = nimbusAdv_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = nimbusAdv_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = nimbusAdv_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return nimbusAdv_possibleConstructorReturn(this, result); }; }
function nimbusAdv_possibleConstructorReturn(self, call) { if (call && (nimbusAdv_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return nimbusAdv_assertThisInitialized(self); }
function nimbusAdv_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function nimbusAdv_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function nimbusAdv_getPrototypeOf(o) { nimbusAdv_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return nimbusAdv_getPrototypeOf(o); }
function nimbusAdv_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var nimbusAdv_Spacer = video_es.getComponent('Spacer');
var NimbusAdv = /*#__PURE__*/function (_Spacer) {
  nimbusAdv_inherits(NimbusAdv, _Spacer);
  var _super = nimbusAdv_createSuper(NimbusAdv);
  function NimbusAdv(player, options) {
    var _this;
    nimbusAdv_classCallCheck(this, NimbusAdv);
    _this = _super.call(this, player, options);
    nimbusAdv_defineProperty(nimbusAdv_assertThisInitialized(_this), "onPlayerEnded", function () {
      if (!_this.options().showAdv) return;
      _this.renderAdvComonent();
    });
    nimbusAdv_defineProperty(nimbusAdv_assertThisInitialized(_this), "onPlayerPlay", function () {
      if (!_this.options().showAdv) return;
      _this.renderAdvComonent(false);
    });
    nimbusAdv_defineProperty(nimbusAdv_assertThisInitialized(_this), "onPlayAgain", function () {
      _this.player().play();
    });
    player.on('ended', _this.onPlayerEnded);
    player.on('play', _this.onPlayerPlay);
    return _this;
  }
  nimbusAdv_createClass(NimbusAdv, [{
    key: "getAdvHTML",
    value: function getAdvHTML() {
      var _this$options = this.options(),
        blot = _this$options.blot;
      return blot && blot.blotConfig && blot.blotConfig.getAdvert() || null;
    }
  }, {
    key: "renderAdvComonent",
    value: function renderAdvComonent() {
      var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var advHTML = this.getAdvHTML();
      var container = this.el();
      if (advHTML && render) {
        var watchAgain = this.options().editor.plugins.i18n.get('video.player.watch_again');
        var component = (0,preact_module.h)("div", {
          className: 'video-player-popup'
        }, (0,preact_module.h)("div", {
          className: "video-player-popup-bg"
        }, (0,preact_module.h)("div", {
          className: "popup-content",
          dangerouslySetInnerHTML: {
            __html: advHTML
          }
        })), (0,preact_module.h)("div", {
          className: "watch-again",
          onClick: this.onPlayAgain
        }, (0,preact_module.h)(icons/* IconWatchAgain */._Ts, null), watchAgain));
        (0,preact_module/* render */.sY)(component, container);
      } else if (container.childNodes.length) {
        (0,preact_module/* render */.sY)(null, container);
      }
    }
  }, {
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-nimbus-adv";
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!props.className) {
        props.className = this.buildCSSClass();
      }
      return nimbusAdv_get(nimbusAdv_getPrototypeOf(NimbusAdv.prototype), "createEl", this).call(this, tag, props, attributes);
    }
  }]);
  return NimbusAdv;
}(nimbusAdv_Spacer);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/nimbusAdv/style.scss
var nimbusAdv_style = __webpack_require__(53893);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/nimbusAdv/index.js
function plugins_nimbusAdv_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_nimbusAdv_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_nimbusAdv_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_nimbusAdv_typeof(obj); }














function nimbusAdv_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function nimbusAdv_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { nimbusAdv_ownKeys(Object(source), true).forEach(function (key) { plugins_nimbusAdv_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { nimbusAdv_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function plugins_nimbusAdv_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function plugins_nimbusAdv_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_nimbusAdv_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_nimbusAdv_setPrototypeOf(subClass, superClass); }
function plugins_nimbusAdv_setPrototypeOf(o, p) { plugins_nimbusAdv_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_nimbusAdv_setPrototypeOf(o, p); }
function plugins_nimbusAdv_createSuper(Derived) { var hasNativeReflectConstruct = plugins_nimbusAdv_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_nimbusAdv_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_nimbusAdv_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_nimbusAdv_possibleConstructorReturn(this, result); }; }
function plugins_nimbusAdv_possibleConstructorReturn(self, call) { if (call && (plugins_nimbusAdv_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_nimbusAdv_assertThisInitialized(self); }
function plugins_nimbusAdv_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_nimbusAdv_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_nimbusAdv_getPrototypeOf(o) { plugins_nimbusAdv_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_nimbusAdv_getPrototypeOf(o); }



var nimbusAdv_Plugin = video_es.getPlugin('plugin');
var nimbusAdv_Component = video_es.getComponent('Component');
nimbusAdv_Component.registerComponent('nimbusAdv', NimbusAdv);
var NimbusAdvPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_nimbusAdv_inherits(NimbusAdvPlugin, _Plugin);
  var _super = plugins_nimbusAdv_createSuper(NimbusAdvPlugin);
  function NimbusAdvPlugin(player, options) {
    var _this;
    plugins_nimbusAdv_classCallCheck(this, NimbusAdvPlugin);
    _this = _super.call(this, player);
    player.nimbusAdv = player.addChild('nimbusAdv', nimbusAdv_objectSpread({}, options), 4);
    return _this;
  }
  return NimbusAdvPlugin;
}(nimbusAdv_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/togglePlay/togglePlay.js
function togglePlay_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { togglePlay_typeof = function _typeof(obj) { return typeof obj; }; } else { togglePlay_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return togglePlay_typeof(obj); }











function togglePlay_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function togglePlay_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function togglePlay_createClass(Constructor, protoProps, staticProps) { if (protoProps) togglePlay_defineProperties(Constructor.prototype, protoProps); if (staticProps) togglePlay_defineProperties(Constructor, staticProps); return Constructor; }
function togglePlay_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { togglePlay_get = Reflect.get; } else { togglePlay_get = function _get(target, property, receiver) { var base = togglePlay_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return togglePlay_get(target, property, receiver || target); }
function togglePlay_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = togglePlay_getPrototypeOf(object); if (object === null) break; } return object; }
function togglePlay_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) togglePlay_setPrototypeOf(subClass, superClass); }
function togglePlay_setPrototypeOf(o, p) { togglePlay_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return togglePlay_setPrototypeOf(o, p); }
function togglePlay_createSuper(Derived) { var hasNativeReflectConstruct = togglePlay_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = togglePlay_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = togglePlay_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return togglePlay_possibleConstructorReturn(this, result); }; }
function togglePlay_possibleConstructorReturn(self, call) { if (call && (togglePlay_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return togglePlay_assertThisInitialized(self); }
function togglePlay_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function togglePlay_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function togglePlay_getPrototypeOf(o) { togglePlay_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return togglePlay_getPrototypeOf(o); }

var togglePlay_Button = video_es.getComponent('Button');
var TogglePlay = /*#__PURE__*/function (_Button) {
  togglePlay_inherits(TogglePlay, _Button);
  var _super = togglePlay_createSuper(TogglePlay);
  function TogglePlay(player, options) {
    togglePlay_classCallCheck(this, TogglePlay);
    return _super.call(this, player, options);
  }
  togglePlay_createClass(TogglePlay, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-toggle-play";
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();
      if (this.player().paused()) {
        this.player().play();
      } else {
        this.player().pause();
      }
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!props.className) {
        props.className = this.buildCSSClass();
      }
      return togglePlay_get(togglePlay_getPrototypeOf(TogglePlay.prototype), "createEl", this).call(this, tag, props, attributes);
    }
  }]);
  return TogglePlay;
}(togglePlay_Button);
TogglePlay.prototype.controlText_ = 'Toggle Play';
/* harmony default export */ const togglePlay = (TogglePlay);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/togglePlay/style.scss
var togglePlay_style = __webpack_require__(80049);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/togglePlay/index.js
function plugins_togglePlay_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_togglePlay_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_togglePlay_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_togglePlay_typeof(obj); }









function plugins_togglePlay_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_togglePlay_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_togglePlay_setPrototypeOf(subClass, superClass); }
function plugins_togglePlay_setPrototypeOf(o, p) { plugins_togglePlay_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_togglePlay_setPrototypeOf(o, p); }
function plugins_togglePlay_createSuper(Derived) { var hasNativeReflectConstruct = plugins_togglePlay_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_togglePlay_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_togglePlay_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_togglePlay_possibleConstructorReturn(this, result); }; }
function plugins_togglePlay_possibleConstructorReturn(self, call) { if (call && (plugins_togglePlay_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_togglePlay_assertThisInitialized(self); }
function plugins_togglePlay_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_togglePlay_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_togglePlay_getPrototypeOf(o) { plugins_togglePlay_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_togglePlay_getPrototypeOf(o); }



var togglePlay_Plugin = video_es.getPlugin('plugin');
var togglePlay_Component = video_es.getComponent('Component');
togglePlay_Component.registerComponent('togglePlay', togglePlay);
var TogglePlayPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_togglePlay_inherits(TogglePlayPlugin, _Plugin);
  var _super = plugins_togglePlay_createSuper(TogglePlayPlugin);
  function TogglePlayPlugin(player) {
    var _this;
    plugins_togglePlay_classCallCheck(this, TogglePlayPlugin);
    _this = _super.call(this, player);
    player.togglePlay = player.addChild('togglePlay', {}, 5);
    return _this;
  }
  return TogglePlayPlugin;
}(togglePlay_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewVideo/previewVideo.js
function previewVideo_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { previewVideo_typeof = function _typeof(obj) { return typeof obj; }; } else { previewVideo_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return previewVideo_typeof(obj); }
















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function previewVideo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function previewVideo_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function previewVideo_createClass(Constructor, protoProps, staticProps) { if (protoProps) previewVideo_defineProperties(Constructor.prototype, protoProps); if (staticProps) previewVideo_defineProperties(Constructor, staticProps); return Constructor; }
function previewVideo_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { previewVideo_get = Reflect.get; } else { previewVideo_get = function _get(target, property, receiver) { var base = previewVideo_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return previewVideo_get(target, property, receiver || target); }
function previewVideo_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = previewVideo_getPrototypeOf(object); if (object === null) break; } return object; }
function previewVideo_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) previewVideo_setPrototypeOf(subClass, superClass); }
function previewVideo_setPrototypeOf(o, p) { previewVideo_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return previewVideo_setPrototypeOf(o, p); }
function previewVideo_createSuper(Derived) { var hasNativeReflectConstruct = previewVideo_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = previewVideo_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = previewVideo_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return previewVideo_possibleConstructorReturn(this, result); }; }
function previewVideo_possibleConstructorReturn(self, call) { if (call && (previewVideo_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return previewVideo_assertThisInitialized(self); }
function previewVideo_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function previewVideo_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function previewVideo_getPrototypeOf(o) { previewVideo_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return previewVideo_getPrototypeOf(o); }
function previewVideo_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var previewVideo_Spacer = video_es.getComponent('Spacer');
var PreviewVideo = /*#__PURE__*/function (_Spacer) {
  previewVideo_inherits(PreviewVideo, _Spacer);
  var _super = previewVideo_createSuper(PreviewVideo);
  function PreviewVideo(player, options) {
    var _this;
    previewVideo_classCallCheck(this, PreviewVideo);
    _this = _super.call(this, player, options);
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "reRender", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newSettings) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.previewSettings = newSettings;
                if (!_this.previewSettings) {
                  _context.next = 7;
                  break;
                }
                _context.next = 4;
                return _this.loadPreviewAttach();
              case 4:
                _this.setState({
                  textColor: _this.previewSettings ? _this.previewSettings.textOverlay ? _this.previewSettings.textOverlay.color : '#fff' : ''
                });
                _this.previewArea();
                _this.renderPreviewComponent();
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "onPlayerResize", function () {
      if (_this.previewSettings) {
        _this.previewArea();
        _this.renderPreviewComponent();
      }
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "loadPreviewAttach", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var attachId, attach;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              attachId = null;
              if (!_this.previewSettings) {
                _context2.next = 12;
                break;
              }
              if (!(_this.previewSettings.activePreviewType == 'first_frame')) {
                _context2.next = 6;
                break;
              }
              _this.setState({
                previewImage: null,
                previewBackground: 'none'
              });
              _context2.next = 12;
              break;
            case 6:
              attachId = _this.previewSettings.previews[_this.previewSettings.activePreviewType].attachmentGlobalId;
              if (!attachId) {
                _context2.next = 12;
                break;
              }
              _context2.next = 10;
              return _this.previewAttach(attachId);
            case 10:
              attach = _context2.sent;
              if (attach) {
                _this.setState({
                  previewImage: attach.url,
                  previewBackground: '#141414'
                });
              }
            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "onPlayerReady", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this.previewSettings) {
                _context3.next = 5;
                break;
              }
              _context3.next = 3;
              return _this.loadPreviewAttach();
            case 3:
              _this.previewArea();
              _this.renderPreviewComponent();
            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "onPlayerPlay", function () {
      _this.setState({
        playerIsPlayed: true
      });
      _this.renderPreviewComponent(false);
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "onPlayerPause", function () {
      _this.setState({
        playerIsPlayed: true
      });
      _this.renderPreviewComponent(false);
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "findFnt", function (ctx, textTemplate, widthOfVideo, fontSizes, lastI) {
      var lines = _this.wrapTextNew(ctx, textTemplate, widthOfVideo);
      if (lines.length > 2) {
        ctx.font = fontSizes[lastI++] + 'px Arial';
        return _this.findFnt(ctx, textTemplate, widthOfVideo, fontSizes, lastI);
      }
      return [lines, lastI];
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "findHeightFnt", function (ctx, lines, canvasHeight, fontSizes, lastI) {
      var fontHeight = 0;
      var height;
      var textDimensions;
      for (var $i = 0; $i < lines.length; $i++) {
        ctx.font = fontSizes[lastI] + 'pt Arial';
        textDimensions = ctx.measureText(lines[$i]);
        height = parseInt(ctx.font.match(/\d+/), 10);
        fontHeight = fontHeight + height;
      }
      if (fontHeight > canvasHeight) {
        return _this.findHeightFnt(ctx, lines, canvasHeight, fontSizes, ++lastI);
      }
      return fontSizes[lastI];
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "wrapTextNew", function (ctx, text, maxWidth) {
      var words = text.split(' ');
      var line = ''; // This will store the text of the current line
      var testLine = ''; // This will store the text when we add a word, to test if it's too long
      var lineArray = []; // This is an array of lines, which the function will return
      // Lets iterate over each word
      for (var n = 0; n < words.length; n++) {
        // Create a test line, and measure it..
        testLine += "".concat(words[n], " ");
        var metrics = ctx.measureText(testLine);
        var testWidth = metrics.width;
        // If the width of this test line is more than the max width
        if (testWidth > maxWidth && n > 0) {
          // Then the line is finished, push the current line into "lineArray"
          lineArray.push(line);
          line = "".concat(words[n], " ");
          testLine = "".concat(words[n], " ");
        } else {
          // If the test line is still less than the max width, then add the word to the current line
          line += "".concat(words[n], " ");
        }
        // If we never reach the full max width, then there is only one line.. so push it into the lineArray so we return something
        if (n === words.length - 1) {
          lineArray.push(line);
        }
      }
      // Return the line array
      return lineArray;
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "setTextDisplay", function (displayState) {
      _this.setState({
        display: displayState
      });
    });
    previewVideo_defineProperty(previewVideo_assertThisInitialized(_this), "previewArea", function () {
      if (_this.state.playerIsPlayed) {
        _this.setTextDisplay('none');
        return false;
      }
      var p = window.document.getElementById(_this.player.id_);
      if (!p) {
        _this.setTextDisplay('none');
        return false;
      }
      var heightOfVideo = p.clientHeight;
      var widthOfVideo = p.clientWidth;
      var widthOfCanvas = Math.floor(widthOfVideo);
      var heightOfCanvas = Math.floor(heightOfVideo) / 2 - 30;
      _this.setState({
        heightOfPreview: heightOfVideo
      });
      if (widthOfCanvas < 280) {
        //Disable text preview
        _this.setTextDisplay('none');
        return false;
      } else {
        //Enable text preview
        _this.setTextDisplay('flex');
      }
      if (!_this.previewSettings.textOverlay || !_this.previewSettings.textOverlay.enable) {
        _this.setState({
          previewText: null,
          display: 'none'
        });
        return false;
      }
      var textTemplate = _this.previewSettings.textOverlay.text;
      var canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d');
      canvas.width = widthOfVideo;
      canvas.height = heightOfCanvas;
      ctx.textAlign = "left";
      ctx.textBaseline = 'left';
      var textDimensions,
        i = 0;
      var fnt = 52;
      var $i;
      // var fontSizes = [52, 50, 48, 46, 44, 42, 40, 38, 36, 34, 32, 30, 28, 26, 24, 24];
      var fontSizes = [];
      for ($i = 8; $i <= 52; $i++) {
        if ($i % 2) {
          fontSizes.push($i + 1);
        }
      }
      fontSizes.reverse();
      ctx.font = fnt + 'px Arial';
      var linesFnt = _this.findFnt(ctx, textTemplate, widthOfVideo, fontSizes, 0);
      var lines = linesFnt[0];
      var maxFont = linesFnt[1];
      var text = lines.join('\n');
      fnt = maxFont;
      var maxHeight = 0,
        height;
      for ($i = 0; $i < lines.length; $i++) {
        i = 0;
        do {
          ctx.font = fontSizes[i++] + 'pt Arial';
          textDimensions = ctx.measureText(lines[$i]);
          if (fontSizes[i] >= maxFont) {
            fnt = fontSizes[i + 1];
          }
        } while (textDimensions.width >= canvas.width);
        height = parseInt(ctx.font.match(/\d+/), 10);
        maxHeight = maxHeight + height;
      }
      fnt = _this.findHeightFnt(ctx, lines, canvas.height, fontSizes, i);
      canvas.remove();
      text = text.split('\n').join('<br/>');
      _this.setState({
        previewText: text,
        fnt: fnt,
        height: heightOfCanvas
      });
    });
    _this.previewSettings = options.previewSettings;
    _this.previewAttach = options.previewAttach;
    _this.player = player;
    _this.state = {
      textColor: _this.previewSettings ? _this.previewSettings.textOverlay ? _this.previewSettings.textOverlay.color : '#fff' : '',
      previewImage: null,
      previewText: null,
      fnt: null,
      display: 'flex',
      height: '3em',
      heightOfPreview: '100%',
      previewBackground: 'none',
      playerIsPlayed: false
    };
    player.on('ready', _this.onPlayerReady);
    player.on('play', _this.onPlayerPlay);
    player.on('pause', _this.onPlayerPause);
    player.on('playerresize', _this.onPlayerResize);
    return _this;
  }
  previewVideo_createClass(PreviewVideo, [{
    key: "renderPreviewComponent",
    value: function renderPreviewComponent() {
      var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var container = this.el();
      if (render) {
        var component = (0,preact_module.h)("div", {
          class: "video-preview-wrapper",
          style: {
            background: !this.state.playerIsPlayed ? this.state.previewBackground : 'none',
            height: this.state.heightOfPreview
          }
        }, (0,preact_module.h)("div", {
          className: 'video-player-popup vjs-emre',
          style: {
            height: this.state.height,
            fontSize: this.state.fnt,
            color: this.state.textColor,
            display: this.state.display
          },
          dangerouslySetInnerHTML: {
            __html: this.state.previewText
          }
        }), (0,preact_module.h)("div", {
          class: "video-player-preview",
          style: {
            height: this.state.heightOfPreview - 41,
            background: this.state.previewImage && !this.state.playerIsPlayed ? 'url(\'' + this.state.previewImage + '\') no-repeat center / contain #141414' : 'none',
            backgroundSize: 'contain',
            display: this.state.previewImage && !this.state.playerIsPlayed ? 'block' : 'none'
          }
        }));
        (0,preact_module/* render */.sY)(component, container);
      } else if (container.childNodes.length) {
        (0,preact_module/* render */.sY)(null, container);
      }
    }
  }, {
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-nimbus-preview";
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!props.className) {
        props.className = this.buildCSSClass();
      }
      return previewVideo_get(previewVideo_getPrototypeOf(PreviewVideo.prototype), "createEl", this).call(this, tag, props, attributes);
    }
  }]);
  return PreviewVideo;
}(previewVideo_Spacer);

// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewVideo/style.scss
var previewVideo_style = __webpack_require__(39727);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewVideo/index.js
function plugins_previewVideo_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_previewVideo_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_previewVideo_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_previewVideo_typeof(obj); }














function previewVideo_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function previewVideo_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { previewVideo_ownKeys(Object(source), true).forEach(function (key) { plugins_previewVideo_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { previewVideo_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function plugins_previewVideo_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function plugins_previewVideo_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_previewVideo_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_previewVideo_setPrototypeOf(subClass, superClass); }
function plugins_previewVideo_setPrototypeOf(o, p) { plugins_previewVideo_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_previewVideo_setPrototypeOf(o, p); }
function plugins_previewVideo_createSuper(Derived) { var hasNativeReflectConstruct = plugins_previewVideo_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_previewVideo_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_previewVideo_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_previewVideo_possibleConstructorReturn(this, result); }; }
function plugins_previewVideo_possibleConstructorReturn(self, call) { if (call && (plugins_previewVideo_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_previewVideo_assertThisInitialized(self); }
function plugins_previewVideo_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_previewVideo_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_previewVideo_getPrototypeOf(o) { plugins_previewVideo_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_previewVideo_getPrototypeOf(o); }



var previewVideo_Plugin = video_es.getPlugin('plugin');
var previewVideo_Component = video_es.getComponent('Component');
previewVideo_Component.registerComponent('previewVideo', PreviewVideo);
var PreviewVideoPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_previewVideo_inherits(PreviewVideoPlugin, _Plugin);
  var _super = plugins_previewVideo_createSuper(PreviewVideoPlugin);
  function PreviewVideoPlugin(player, options) {
    var _this;
    plugins_previewVideo_classCallCheck(this, PreviewVideoPlugin);
    _this = _super.call(this, player);
    player.previewVideo = player.addChild('previewVideo', previewVideo_objectSpread({}, options), 4);
    return _this;
  }
  return PreviewVideoPlugin;
}(previewVideo_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewButton/previewButton.js
function previewButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { previewButton_typeof = function _typeof(obj) { return typeof obj; }; } else { previewButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return previewButton_typeof(obj); }











function previewButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function previewButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function previewButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) previewButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) previewButton_defineProperties(Constructor, staticProps); return Constructor; }
function previewButton_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { previewButton_get = Reflect.get; } else { previewButton_get = function _get(target, property, receiver) { var base = previewButton_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return previewButton_get(target, property, receiver || target); }
function previewButton_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = previewButton_getPrototypeOf(object); if (object === null) break; } return object; }
function previewButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) previewButton_setPrototypeOf(subClass, superClass); }
function previewButton_setPrototypeOf(o, p) { previewButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return previewButton_setPrototypeOf(o, p); }
function previewButton_createSuper(Derived) { var hasNativeReflectConstruct = previewButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = previewButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = previewButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return previewButton_possibleConstructorReturn(this, result); }; }
function previewButton_possibleConstructorReturn(self, call) { if (call && (previewButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return previewButton_assertThisInitialized(self); }
function previewButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function previewButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function previewButton_getPrototypeOf(o) { previewButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return previewButton_getPrototypeOf(o); }

// import download from 'downloadjs'

var previewButton_Button = video_es.getComponent('Button');
var PreviewButton = /*#__PURE__*/function (_Button) {
  previewButton_inherits(PreviewButton, _Button);
  var _super = previewButton_createSuper(PreviewButton);
  function PreviewButton(player, options) {
    var _this;
    previewButton_classCallCheck(this, PreviewButton);
    _this = _super.call(this, player, options);
    _this.controlTextEl_.innerHTML = window.gEditor ? window.gEditor.plugins.i18n.get('file.menu.preview_video_btn') : 'Preview';
    return _this;
  }
  previewButton_createClass(PreviewButton, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-preview-button ".concat(previewButton_get(previewButton_getPrototypeOf(PreviewButton.prototype), "buildCSSClass", this).call(this));
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (this.options().clickFn) {
        this.options().clickFn(this.options().attachment);
      }
    }
  }]);
  return PreviewButton;
}(previewButton_Button);
PreviewButton.prototype.controlText_ = 'Preview';
/* harmony default export */ const previewButton = (PreviewButton);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewButton/style.scss
var previewButton_style = __webpack_require__(57167);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/previewButton/index.js
function plugins_previewButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_previewButton_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_previewButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_previewButton_typeof(obj); }









function plugins_previewButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_previewButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function plugins_previewButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) plugins_previewButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) plugins_previewButton_defineProperties(Constructor, staticProps); return Constructor; }
function plugins_previewButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_previewButton_setPrototypeOf(subClass, superClass); }
function plugins_previewButton_setPrototypeOf(o, p) { plugins_previewButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_previewButton_setPrototypeOf(o, p); }
function plugins_previewButton_createSuper(Derived) { var hasNativeReflectConstruct = plugins_previewButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_previewButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_previewButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_previewButton_possibleConstructorReturn(this, result); }; }
function plugins_previewButton_possibleConstructorReturn(self, call) { if (call && (plugins_previewButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_previewButton_assertThisInitialized(self); }
function plugins_previewButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_previewButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_previewButton_getPrototypeOf(o) { plugins_previewButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_previewButton_getPrototypeOf(o); }



var previewButton_Plugin = video_es.getPlugin('plugin');
var previewButton_Component = video_es.getComponent('Component');
previewButton_Component.registerComponent('previewButton', previewButton);
var PreviewButtonPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_previewButton_inherits(PreviewButtonPlugin, _Plugin);
  var _super = plugins_previewButton_createSuper(PreviewButtonPlugin);
  function PreviewButtonPlugin(player, options) {
    var _this;
    plugins_previewButton_classCallCheck(this, PreviewButtonPlugin);
    _this = _super.call(this, player);
    if (!options) {
      return plugins_previewButton_possibleConstructorReturn(_this);
    }
    player.ready(function () {
      _this.previewButton = player.controlBar.addChild('previewButton', {
        clickFn: options.clickFn,
        attachment: options.attachment
      }, options.index);
      if (!options.show) {
        _this.previewButton.hide();
      }
      player.controlBar.previewButton = _this.previewButton;
    });
    return _this;
  }
  plugins_previewButton_createClass(PreviewButtonPlugin, [{
    key: "show",
    value: function show() {
      if (this.previewButton) {
        this.previewButton.show();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.previewButton) {
        this.previewButton.hide();
      }
    }
  }]);
  return PreviewButtonPlugin;
}(previewButton_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/transcriptButton/transcriptButton.js
function transcriptButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { transcriptButton_typeof = function _typeof(obj) { return typeof obj; }; } else { transcriptButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return transcriptButton_typeof(obj); }












function transcriptButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function transcriptButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function transcriptButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) transcriptButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) transcriptButton_defineProperties(Constructor, staticProps); return Constructor; }
function transcriptButton_get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { transcriptButton_get = Reflect.get; } else { transcriptButton_get = function _get(target, property, receiver) { var base = transcriptButton_superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return transcriptButton_get(target, property, receiver || target); }
function transcriptButton_superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = transcriptButton_getPrototypeOf(object); if (object === null) break; } return object; }
function transcriptButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) transcriptButton_setPrototypeOf(subClass, superClass); }
function transcriptButton_setPrototypeOf(o, p) { transcriptButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return transcriptButton_setPrototypeOf(o, p); }
function transcriptButton_createSuper(Derived) { var hasNativeReflectConstruct = transcriptButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = transcriptButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = transcriptButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return transcriptButton_possibleConstructorReturn(this, result); }; }
function transcriptButton_possibleConstructorReturn(self, call) { if (call && (transcriptButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return transcriptButton_assertThisInitialized(self); }
function transcriptButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function transcriptButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function transcriptButton_getPrototypeOf(o) { transcriptButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return transcriptButton_getPrototypeOf(o); }

var transcriptButton_Button = video_es.getComponent('Button');
var TranscriptButton = /*#__PURE__*/function (_Button) {
  transcriptButton_inherits(TranscriptButton, _Button);
  var _super = transcriptButton_createSuper(TranscriptButton);
  function TranscriptButton(player, options) {
    transcriptButton_classCallCheck(this, TranscriptButton);
    return _super.call(this, player, options);
  }
  transcriptButton_createClass(TranscriptButton, [{
    key: "buildCSSClass",
    value: function buildCSSClass() {
      return "vjs-transcript-button ".concat(transcriptButton_get(transcriptButton_getPrototypeOf(TranscriptButton.prototype), "buildCSSClass", this).call(this));
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var _this = this;
      if (this.options().clickFn) {
        var attachment = Object.assign({}, this.options().attachment);
        var video = document.createElement('video');
        video.src = attachment.url;
        video.onloadedmetadata = function () {
          attachment.duration = video.duration;
          _this.options().clickFn(attachment);
        };
      }
    }
  }]);
  return TranscriptButton;
}(transcriptButton_Button);
TranscriptButton.prototype.controlText_ = 'Transcript';
/* harmony default export */ const transcriptButton = (TranscriptButton);
// EXTERNAL MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/transcriptButton/style.scss
var transcriptButton_style = __webpack_require__(36663);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/plugins/transcriptButton/index.js
function plugins_transcriptButton_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { plugins_transcriptButton_typeof = function _typeof(obj) { return typeof obj; }; } else { plugins_transcriptButton_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return plugins_transcriptButton_typeof(obj); }









function plugins_transcriptButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function plugins_transcriptButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function plugins_transcriptButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) plugins_transcriptButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) plugins_transcriptButton_defineProperties(Constructor, staticProps); return Constructor; }
function plugins_transcriptButton_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) plugins_transcriptButton_setPrototypeOf(subClass, superClass); }
function plugins_transcriptButton_setPrototypeOf(o, p) { plugins_transcriptButton_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return plugins_transcriptButton_setPrototypeOf(o, p); }
function plugins_transcriptButton_createSuper(Derived) { var hasNativeReflectConstruct = plugins_transcriptButton_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = plugins_transcriptButton_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = plugins_transcriptButton_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return plugins_transcriptButton_possibleConstructorReturn(this, result); }; }
function plugins_transcriptButton_possibleConstructorReturn(self, call) { if (call && (plugins_transcriptButton_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return plugins_transcriptButton_assertThisInitialized(self); }
function plugins_transcriptButton_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function plugins_transcriptButton_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function plugins_transcriptButton_getPrototypeOf(o) { plugins_transcriptButton_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return plugins_transcriptButton_getPrototypeOf(o); }



var transcriptButton_Plugin = video_es.getPlugin('plugin');
var transcriptButton_Component = video_es.getComponent('Component');
transcriptButton_Component.registerComponent('transcriptButton', transcriptButton);
var TranscriptButtonPlugin = /*#__PURE__*/function (_Plugin) {
  plugins_transcriptButton_inherits(TranscriptButtonPlugin, _Plugin);
  var _super = plugins_transcriptButton_createSuper(TranscriptButtonPlugin);
  function TranscriptButtonPlugin(player, options) {
    var _this;
    plugins_transcriptButton_classCallCheck(this, TranscriptButtonPlugin);
    _this = _super.call(this, player);
    if (!options) {
      return plugins_transcriptButton_possibleConstructorReturn(_this);
    }
    player.ready(function () {
      _this.transcriptButton = player.controlBar.addChild('transcriptButton', {
        clickFn: options.clickFn,
        attachment: options.attachment
      }, options.index);
      if (!options.show) {
        _this.transcriptButton.hide();
      }
      player.controlBar.transcriptButton = _this.transcriptButton;
    });
    return _this;
  }
  plugins_transcriptButton_createClass(TranscriptButtonPlugin, [{
    key: "show",
    value: function show() {
      if (this.transcriptButton) {
        this.transcriptButton.show();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.transcriptButton) {
        this.transcriptButton.hide();
      }
    }
  }]);
  return TranscriptButtonPlugin;
}(transcriptButton_Plugin);

;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/videojs.js
function videojs_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { videojs_typeof = function _typeof(obj) { return typeof obj; }; } else { videojs_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return videojs_typeof(obj); }









function videojs_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function videojs_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function videojs_createClass(Constructor, protoProps, staticProps) { if (protoProps) videojs_defineProperties(Constructor.prototype, protoProps); if (staticProps) videojs_defineProperties(Constructor, staticProps); return Constructor; }
function videojs_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) videojs_setPrototypeOf(subClass, superClass); }
function videojs_setPrototypeOf(o, p) { videojs_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return videojs_setPrototypeOf(o, p); }
function videojs_createSuper(Derived) { var hasNativeReflectConstruct = videojs_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = videojs_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = videojs_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return videojs_possibleConstructorReturn(this, result); }; }
function videojs_possibleConstructorReturn(self, call) { if (call && (videojs_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return videojs_assertThisInitialized(self); }
function videojs_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function videojs_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function videojs_getPrototypeOf(o) { videojs_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return videojs_getPrototypeOf(o); }
function videojs_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// plugins










// register plugins
video_es.registerPlugin('forwardButtonPlugin', ForwardButtonPlugin);
video_es.registerPlugin('downloadButtonPlugin', DownloadButtonPlugin);
video_es.registerPlugin('controlShadowPlugin', ControlShadowPlugin);
video_es.registerPlugin('callToActionPlugin', CallToActionPlugin);
video_es.registerPlugin('nimbusAdvPlugin', NimbusAdvPlugin);
video_es.registerPlugin('togglePlayPlugin', TogglePlayPlugin);
video_es.registerPlugin('previewVideoPlugin', PreviewVideoPlugin);
video_es.registerPlugin('previewButtonPlugin', PreviewButtonPlugin);
video_es.registerPlugin('transcriptButtonPlugin', TranscriptButtonPlugin);
var VideoPlayer = /*#__PURE__*/function (_Component) {
  videojs_inherits(VideoPlayer, _Component);
  var _super = videojs_createSuper(VideoPlayer);
  function VideoPlayer(props) {
    var _this;
    videojs_classCallCheck(this, VideoPlayer);
    _this = _super.call(this, props);
    videojs_defineProperty(videojs_assertThisInitialized(_this), "onVideoRef", function (node) {
      _this.videoNode = node;
    });
    videojs_defineProperty(videojs_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
      if (_this.props.onDomRef) {
        _this.props.onDomRef(node);
      }
    });
    return _this;
  }
  videojs_createClass(VideoPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.player = video_es(this.videoNode, this.props);
      if (this.props.onPlayerRef) {
        this.props.onPlayerRef(this.player);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.player) {
        this.player.dispose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return (0,preact_module.h)("div", {
        "data-vjs-player": true,
        ref: this.onRef
      }, (0,preact_module.h)("video", {
        ref: this.onVideoRef,
        className: "video-js vjs-big-play-centered vjs-theme-nimbus"
      }));
    }
  }]);
  return VideoPlayer;
}(preact_module/* Component */.wA);

// EXTERNAL MODULE: ./node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(37733);
var lodash_isequal_default = /*#__PURE__*/__webpack_require__.n(lodash_isequal);
;// CONCATENATED MODULE: ./node_modules/videojs-errors/dist/videojs-errors.es.js



/*! @name videojs-errors @version 5.1.0 @license Apache-2.0 */


var videojs_errors_es_version = "5.1.0";
var FlashObj = video_es.getComponent('Flash');
var defaultDismiss = !video_es.browser.IS_IPHONE; // Video.js 5/6 cross-compatibility.

var videojs_errors_es_registerPlugin = video_es.registerPlugin || video_es.plugin; // Default options for the plugin.

var videojs_errors_es_defaults = {
  header: '',
  code: '',
  message: '',
  timeout: 45 * 1000,
  backgroundTimeout: 300 * 1000,
  dismiss: defaultDismiss,
  errors: {
    '1': {
      type: 'MEDIA_ERR_ABORTED',
      headline: 'The video download was cancelled'
    },
    '2': {
      type: 'MEDIA_ERR_NETWORK',
      headline: 'The video connection was lost, please confirm you are ' + 'connected to the internet'
    },
    '3': {
      type: 'MEDIA_ERR_DECODE',
      headline: 'The video is bad or in a format that cannot be played on your browser'
    },
    '4': {
      type: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
      headline: 'This video is either unavailable or not supported in this browser'
    },
    '5': {
      type: 'MEDIA_ERR_ENCRYPTED',
      headline: 'The video you are trying to watch is encrypted and we do not know how ' + 'to decrypt it'
    },
    'unknown': {
      type: 'MEDIA_ERR_UNKNOWN',
      headline: 'An unanticipated problem was encountered, check back soon and try again'
    },
    '-1': {
      type: 'PLAYER_ERR_NO_SRC',
      headline: 'No video has been loaded'
    },
    '-2': {
      type: 'PLAYER_ERR_TIMEOUT',
      headline: 'It looks like you\'re having playback issues. Reloading the video may help.'
    },
    'PLAYER_ERR_DOMAIN_RESTRICTED': {
      headline: 'This video is restricted from playing on your current domain'
    },
    'PLAYER_ERR_IP_RESTRICTED': {
      headline: 'This video is restricted at your current IP address'
    },
    'PLAYER_ERR_GEO_RESTRICTED': {
      headline: 'This video is restricted from playing in your current geographic region'
    },
    'FLASHLS_ERR_CROSS_DOMAIN': {
      headline: 'The video could not be loaded: crossdomain access denied.'
    }
  }
};
var videojs_errors_es_initPlugin = function initPlugin(player, options) {
  var monitor;
  var waiting;
  var isStalling;
  var listeners = [];
  var updateErrors = function updateErrors(updates) {
    options.errors = video_es.mergeOptions(options.errors, updates); // Create `code`s from errors which don't have them (based on their keys).

    Object.keys(options.errors).forEach(function (k) {
      var err = options.errors[k];
      if (!err.type) {
        err.type = k;
      }
    });
  }; // Make sure we flesh out initially-provided errors.

  updateErrors(); // clears the previous monitor timeout and sets up a new one

  var resetMonitor = function resetMonitor() {
    // clear out any existing player error now that playback has recovered
    if (player.error() && player.error().code === -2) {
      player.error(null);
    }
    player.clearTimeout(waiting);
    player.clearTimeout(monitor);
    if (isStalling) {
      isStalling = false;
      player.removeClass('vjs-waiting');
    } // Disable timeouts in the background altogether according to the backgroundTimeout
    // option, or if the player is muted, as browsers may throttle javascript timers to
    // 1 minute in that case

    var disableValues = [Infinity, -1];
    var disableValueMatch = function disableValueMatch(valArray, option) {
      return valArray.indexOf(option) !== -1;
    };
    if ((document_default()).visibilityState === 'hidden' && (player.muted() || disableValueMatch(disableValues, options.backgroundTimeout)) || (document_default()).visibilityState === 'visible' && disableValueMatch(disableValues, options.timeout)) {
      return;
    } // start the loading spinner if player has stalled

    waiting = player.setTimeout(function () {
      // player already has an error
      // or is not playing under normal conditions
      if (player.error() || player.paused() || player.ended()) {
        return;
      }
      isStalling = true;
      player.addClass('vjs-waiting');
    }, 1000);
    monitor = player.setTimeout(function () {
      // player already has an error
      // or is not playing under normal conditions
      if (player.error() || player.paused() || player.ended()) {
        return;
      }
      player.error({
        code: -2,
        type: 'PLAYER_ERR_TIMEOUT'
      });
    }, (document_default()).visibilityState === 'hidden' ? options.backgroundTimeout : options.timeout);
  }; // clear any previously registered listeners

  var cleanup = function cleanup() {
    var listener;
    while (listeners.length) {
      listener = listeners.shift();
      player.off(listener[0], listener[1]);
    }
    player.clearTimeout(monitor);
    player.clearTimeout(waiting);
  }; // creates and tracks a player listener if the player looks alive

  var healthcheck = function healthcheck(type, fn) {
    var check = function check() {
      // if there's an error do not reset the monitor and
      // clear the error unless time is progressing
      if (!player.error()) {
        // error if using Flash and its API is unavailable
        var tech = player.$('.vjs-tech');
        if (tech && tech.type === 'application/x-shockwave-flash' && !tech.vjs_getProperty) {
          player.error({
            code: -2,
            type: 'PLAYER_ERR_TIMEOUT'
          });
          return;
        } // playback isn't expected if the player is paused

        if (player.paused()) {
          return resetMonitor();
        } // playback isn't expected once the video has ended

        if (player.ended()) {
          return resetMonitor();
        }
      }
      fn.call(this);
    };
    player.on(type, check);
    listeners.push([type, check]);
  };
  var onPlayStartMonitor = function onPlayStartMonitor() {
    var lastTime = 0;
    cleanup(); // if no playback is detected for long enough, trigger a timeout error

    resetMonitor();
    healthcheck(['timeupdate', 'adtimeupdate'], function () {
      var currentTime = player.currentTime(); // playback is operating normally or has recovered

      if (currentTime !== lastTime) {
        lastTime = currentTime;
        resetMonitor();
      }
    }); // Restart timeout monitor when the document transitions between the
    // foreground and background

    player.off((document_default()), 'visibilitychange', onPlayStartMonitor);
    player.on((document_default()), 'visibilitychange', onPlayStartMonitor);
  };
  var onPlayNoSource = function onPlayNoSource() {
    if (!player.currentSrc()) {
      player.error({
        code: -1,
        type: 'PLAYER_ERR_NO_SRC'
      });
    }
  };
  var onErrorHandler = function onErrorHandler() {
    var details = '';
    var error = player.error();
    var content = document_default().createElement('div');
    var dialogContent = ''; // In the rare case when `error()` does not return an error object,
    // defensively escape the handler function.

    if (!error) {
      return;
    } // Stop restarting the monitor on visibilitychanges now that an error has occurred

    player.off((document_default()), 'visibilitychange', onPlayStartMonitor);
    error = video_es.mergeOptions(error, options.errors[error.code || error.type || 0]);
    if (error.message) {
      details = "<div class=\"vjs-errors-details\">".concat(player.localize('Technical details'), "\n        : <div class=\"vjs-errors-message\">").concat(player.localize(error.message), "</div>\n        </div>");
    }
    if (error.code === 4 && FlashObj && !FlashObj.isSupported()) {
      var flashMessage = player.localize('If you are using an older browser please try upgrading or installing Flash.');
      details += "<span class=\"vjs-errors-flashmessage\">".concat(flashMessage, "</span>");
    }
    var display = player.getChild('errorDisplay');
    content.className = 'vjs-errors-dialog';
    content.id = 'vjs-errors-dialog';
    var errorCode = "<div class=\"vjs-errors-code\"><b>".concat(this.localize('Error Code'), ":</b> ").concat(error.type || error.code, "</div>");
    var isTimeoutError = error.code === -2;
    dialogContent = "<div class=\"vjs-errors-content-container\">\n        <h2 class=\"vjs-errors-headline\">".concat(this.localize(error.headline), "</h2>\n        ").concat(isTimeoutError ? '' : errorCode, "\n        ").concat(isTimeoutError ? '' : details, "\n      </div>");
    var closeable = display.closeable(!('dismiss' in error) || error.dismiss);
    if (isTimeoutError) {
      dialogContent += "<div class=\"vjs-errors-timeout-button-container\">\n         <button>".concat(this.localize('Reload Video'), "</button>\n         <button>").concat(this.localize('Dismiss'), "</button>\n       </div>");
      content.innerHTML = dialogContent;
      display.fillWith(content);
      display.getChild('closeButton').hide();
      var reloadButton = display.el().querySelector('.vjs-errors-timeout-button-container > button:first-child');
      var dismissButton = display.el().querySelector('.vjs-errors-timeout-button-container > button:last-child');
      player.on(reloadButton, 'click', function () {
        var source = player.currentSource();
        player.reset();
        player.src(source);
      });
      player.on(dismissButton, 'click', function () {
        display.close();
      });
      display.one('modalclose', function () {
        player.off(reloadButton);
        player.off(dismissButton);
      });
    } else if (closeable) {
      // We should get a close button
      dialogContent += "<div class=\"vjs-errors-ok-button-container\">\n          <button class=\"vjs-errors-ok-button\">".concat(this.localize('OK'), "</button>\n        </div>");
      content.innerHTML = dialogContent;
      display.fillWith(content); // Get the close button inside the error display

      display.contentEl().firstChild.appendChild(display.getChild('closeButton').el());
      var okButton = display.el().querySelector('.vjs-errors-ok-button');
      player.on(okButton, 'click', function () {
        display.close();
      });
    } else {
      content.innerHTML = dialogContent;
      display.fillWith(content);
    }
    if (player.currentWidth() <= 600 || player.currentHeight() <= 250) {
      display.addClass('vjs-xs');
    }
    display.one('modalclose', function () {
      return player.error(null);
    });
  };
  var onDisposeHandler = function onDisposeHandler() {
    cleanup();
    player.removeClass('vjs-errors');
    player.off('play', onPlayStartMonitor);
    player.off((document_default()), 'visibilitychange', onPlayStartMonitor);
    player.off('play', onPlayNoSource);
    player.off('dispose', onDisposeHandler);
    player.off(['aderror', 'error'], onErrorHandler);
  };
  var reInitPlugin = function reInitPlugin(newOptions) {
    onDisposeHandler();
    initPlugin(player, video_es.mergeOptions(videojs_errors_es_defaults, newOptions));
  };
  reInitPlugin.extend = function (errors) {
    return updateErrors(errors);
  };
  reInitPlugin.getAll = function () {
    return video_es.mergeOptions(options.errors);
  }; // Get / set timeout value. Restart monitor if changed.

  reInitPlugin.timeout = function (timeout) {
    if (typeof timeout === 'undefined') {
      return options.timeout;
    }
    if (timeout !== options.timeout) {
      options.timeout = timeout;
      if (!player.paused()) {
        onPlayStartMonitor();
      }
    }
  }; // Get / set backgroundTimeout value. Restart monitor if changed.

  reInitPlugin.backgroundTimeout = function (timeout) {
    if (typeof timeout === 'undefined') {
      return options.backgroundTimeout;
    }
    if (timeout !== options.backgroundTimeout) {
      options.backgroundTimeout = timeout;
      if (!player.paused()) {
        onPlayStartMonitor();
      }
    }
  }; // no-op API
  // TODO: remove in a major version

  reInitPlugin.disableProgress = function () {};
  player.on('play', onPlayStartMonitor);
  player.on('play', onPlayNoSource);
  player.on('dispose', onDisposeHandler);
  player.on(['aderror', 'contenterror', 'error'], onErrorHandler);
  player.ready(function () {
    player.addClass('vjs-errors');
  }); // if the plugin is re-initialised during playback, start the timeout handler.

  if (!player.paused()) {
    onPlayStartMonitor();
  } // Include the version number.

  reInitPlugin.VERSION = videojs_errors_es_version;
  player.errors = reInitPlugin;
};
var videojs_errors_es_errors = function errors(options) {
  videojs_errors_es_initPlugin(this, video_es.mergeOptions(videojs_errors_es_defaults, options));
};
['extend', 'getAll'].forEach(function (k) {
  videojs_errors_es_errors[k] = function () {
    video_es.log.warn("The errors.".concat(k, "() method is not available until the plugin has been initialized!"));
  };
}); // Include the version number.

videojs_errors_es_errors.VERSION = videojs_errors_es_version; // Register the plugin with video.js.

videojs_errors_es_registerPlugin('errors', videojs_errors_es_errors);

// EXTERNAL MODULE: ./node_modules/is-hotkey/lib/index.js
var is_hotkey_lib = __webpack_require__(28199);
;// CONCATENATED MODULE: ./node_modules/@lib/editor/src/viewers/video/index.js
function video_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { video_typeof = function _typeof(obj) { return typeof obj; }; } else { video_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return video_typeof(obj); }
function video_extends() { video_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return video_extends.apply(this, arguments); }
























function video_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function video_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { video_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { video_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function video_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function video_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { video_ownKeys(Object(source), true).forEach(function (key) { video_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { video_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function video_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function video_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function video_createClass(Constructor, protoProps, staticProps) { if (protoProps) video_defineProperties(Constructor.prototype, protoProps); if (staticProps) video_defineProperties(Constructor, staticProps); return Constructor; }
function video_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) video_setPrototypeOf(subClass, superClass); }
function video_setPrototypeOf(o, p) { video_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return video_setPrototypeOf(o, p); }
function video_createSuper(Derived) { var hasNativeReflectConstruct = video_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = video_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = video_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return video_possibleConstructorReturn(this, result); }; }
function video_possibleConstructorReturn(self, call) { if (call && (video_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return video_assertThisInitialized(self); }
function video_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function video_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function video_getPrototypeOf(o) { video_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return video_getPrototypeOf(o); }
function video_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var isSpaceKey = (0,is_hotkey_lib/* default */.ZP)('space');
var video_defaults = {
  autoplay: false,
  loop: false,
  controls: true,
  responsive: true,
  fluid: true,
  inactivityTimeout: 3000,
  playbackRates: [1, 1.2, 1.5, 1.7, 2],
  aspectRatio: '16:9',
  controlBar: {
    pictureInPictureToggle: false,
    remainingTimeDisplay: false,
    liveDisplay: false,
    seekToLive: false,
    chaptersButton: false,
    descriptionsButton: false,
    subsCapsButton: false,
    audioTrackButton: false
  },
  plugins: {
    forwardButtonPlugin: {
      index: 1,
      seconds: 5
    },
    togglePlayPlugin: true
  }
};
var DEFAULT_PLAYER_VOLUME = 0.75;
var VideoViewer = /*#__PURE__*/function (_Component) {
  video_inherits(VideoViewer, _Component);
  var _super = video_createSuper(VideoViewer);
  function VideoViewer(props) {
    var _this;
    video_classCallCheck(this, VideoViewer);
    _this = _super.call(this, props);
    video_defineProperty(video_assertThisInitialized(_this), "onRef", function (node) {
      _this.domNode = node;
    });
    video_defineProperty(video_assertThisInitialized(_this), "onPlayerRef", function (player) {
      _this.player = player;
    });
    video_defineProperty(video_assertThisInitialized(_this), "onEditorScroll", function () {
      _this.setAutoplayIfAvailable();
    });
    video_defineProperty(video_assertThisInitialized(_this), "onPlayerReady", function () {
      _this.player.addClass('vjs-wait-metadata');
      var _this$props = _this.props,
        editor = _this$props.editor,
        blot = _this$props.blot;
      editor.getScrollingContainer().addEventListener('scroll', _this.onEditorScroll, false);
      // после того как плеер готов, сразу пробуем его поставить на паузу,
      // если вдруг он находится вне области видимости редактора и включена опция autoplay
      _this.setAutoplayIfAvailable();
      blot.props.videoPlayer = video_assertThisInitialized(_this);
      _this.setState(function () {
        return {
          isPlayerReady: true
        };
      });
    });
    video_defineProperty(video_assertThisInitialized(_this), "onPlayerPlay", function () {
      var _this$props2 = _this.props,
        editor = _this$props2.editor,
        blot = _this$props2.blot;
      editor.emitter.emit('video-play', blot.id);
    });
    video_defineProperty(video_assertThisInitialized(_this), "onEditorVideoPlay", function (blotId) {
      if (blotId === _this.props.blot.id || _this.props.attachment.motionVideo) return;
      _this.player.pause();
    });
    video_defineProperty(video_assertThisInitialized(_this), "onPlayerFullscreenChange", function (event) {
      if (_this.player.isFullscreen()) {
        if (_this.props.onViewerGoFullScreen && !_this.props.fullscreen) {
          _this.props.onViewerGoFullScreen();
        }
      } else {
        if (_this.props.onFullScreenClose && _this.props.fullscreen) {
          _this.props.onFullScreenClose();
        }
      }
    });
    video_defineProperty(video_assertThisInitialized(_this), "onVideoDownload", function (attachment) {
      return _this.props.editor.plugins.attachmentManager.download(attachment);
    });
    video_defineProperty(video_assertThisInitialized(_this), "onDocumentKeyDown", function (event) {
      if (!_this.props.editor.isEditable()) {
        // блок с видео в фокусе или видео воспроизводится
        if (_this.props.blot.scroll.focusedBlot === _this.props.blot || !_this.player.paused()) {
          _this.handleKeyDown(event);
        }
      }
    });
    video_defineProperty(video_assertThisInitialized(_this), "onDomNodeMouseDown", function (event) {
      if (!_this.props.editor.isEditable()) {
        _this.props.blot.selection.setRange({
          index: _this.props.blot.offset(_this.props.blot.scroll),
          length: 0
        });
      }
    });
    video_defineProperty(video_assertThisInitialized(_this), "updateCtaState", function () {
      var _this$props3 = _this.props,
        attachment = _this$props3.attachment,
        editor = _this$props3.editor,
        blot = _this$props3.blot;
      var cta = editor.plugins.ctaManager.getCta(blot.id, attachment.global_id);
      if (!lodash_isequal_default()(_this.state.cta, cta)) {
        _this.state.cta = cta;
        _this.player.cta.options(video_objectSpread({}, cta));
      }
      // тут так же выполняем обновление стейта рекламы
      _this.updateNimbusAdvState();
    });
    video_defineProperty(video_assertThisInitialized(_this), "getPreviewAttach", /*#__PURE__*/function () {
      var _ref = video_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(attachId) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.editor.plugins.attachmentManager.resolve(attachId);
              case 2:
                return _context.abrupt("return", _context.sent);
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    video_defineProperty(video_assertThisInitialized(_this), "updatePreviewState", /*#__PURE__*/video_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.player.previewVideo.reRender(_this.props.syncedState.videoPreview);
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    video_defineProperty(video_assertThisInitialized(_this), "onPreviewBtn", /*#__PURE__*/function () {
      var _ref3 = video_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(settings) {
        var newState;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.props.editor.plugins.videoPreview.onEditPreview(_this.props.syncedState.videoPreview || {
                  videoAttachmentId: _this.props.attachment.global_id,
                  textOverlay: null,
                  activePreviewType: "first_frame",
                  previews: {}
                });
              case 2:
                newState = _context3.sent;
                if (newState) {
                  newState.videoAttachmentId = _this.props.attachment.global_id;
                  console.log('setNewState', newState);
                  _this.props.setSyncedState({
                    videoPreview: newState
                  });
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    var _this$props4 = _this.props,
      _attachment = _this$props4.attachment,
      _editor = _this$props4.editor,
      _blot = _this$props4.blot;
    _this.state = {
      muted: typeof _attachment.soundDefault !== 'undefined' && _attachment.soundDefault || typeof _attachment.autoplay !== 'undefined' && _attachment.autoplay ? true : false,
      controls: typeof _attachment.hideControl !== 'undefined' ? !_attachment.hideControl : true,
      autoplay: typeof _attachment.autoplay !== 'undefined' ? _attachment.autoplay : false,
      loop: typeof _attachment.loop !== 'undefined' ? _attachment.loop : false,
      allowDownload: true,
      showNimbusAdv: false,
      isPlayerReady: false
    };
    var _cta = _editor.plugins.ctaManager.getCta(_blot.id, _attachment.global_id);
    if (!_this.state.loop && !_attachment.motionVideo) {
      _this.state.cta = _cta;
    } else {
      _this.state.cta = {};
    }
    return _this;
  }
  video_createClass(VideoViewer, [{
    key: "isPlayOnAutoplayAvailable",
    value: function isPlayOnAutoplayAvailable() {
      if (!this.domNode) return false;
      var editor = this.props.editor;
      var editorRect = editor.editorBody.getBoundingClientRect();
      var rect = this.domNode.getBoundingClientRect();
      // разрешаем воспроизведение, если хотя бы половина видео находится в области видимости редактора
      return rect.top >= editorRect.top - rect.height / 2 && rect.bottom <= editorRect.bottom + rect.height / 2;
    }
  }, {
    key: "setAutoplayIfAvailable",
    value:
    // Метод включает/выключает воспроизведение видео при включенной опции autoplay.
    // Если хотя бы 50% видео (по вертикали) находится в области видимости редактора,
    // видео начнет воспроизводиться.
    // Если видео находится вне области видимости редактора, или в области видимости редактора находится менее 50% видео,
    // оно поставится на паузу.
    function setAutoplayIfAvailable() {
      var attachment = this.props.attachment;
      var autoplay = attachment.autoplay,
        loop = attachment.loop;
      if (typeof autoplay !== 'undefined' && attachment.autoplay) {
        var available = this.isPlayOnAutoplayAvailable();
        if (typeof loop === 'undefined' || !loop) {
          if (this.player.ended()) {
            available = false;
          }
        }
        if (available) {
          if (this.player.paused()) {
            this.player.play();
          }
        } else if (!this.player.paused()) {
          this.player.pause();
        }
      }
    }
    // Метод выключает/включает (ставит дефолтный уровень) звук
  }, {
    key: "setMuted",
    value: function setMuted() {
      var muted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (muted) {
        this.player.volume(0);
      } else {
        if (this.player.muted()) {
          this.player.muted(false);
        }
        this.player.volume(DEFAULT_PLAYER_VOLUME);
      }
    }
    // Метод выключает/включает автоплей на инициированном плеере
  }, {
    key: "setAutoplay",
    value: function setAutoplay() {
      var autoplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (autoplay) {
        this.player.autoplay('muted');
        this.player.play();
      } else {
        this.player.autoplay(false);
        if (this.player.played().length && !this.player.paused()) {
          this.player.pause();
        }
      }
    }
    // Метод выключает/включает зацикливание на инициированном плеере
  }, {
    key: "setLoop",
    value: function setLoop() {
      var loop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.player.loop(loop);
    }
    // Метод выключает/включает панель управления видео на инициированном плеере
  }, {
    key: "setControls",
    value: function setControls() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.player.controls(show);
    }
    // Метод выключает/включает доступность кнопки загрузки
  }, {
    key: "setDownloadAvailable",
    value: function setDownloadAvailable() {
      var allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (allow) {
        this.player.controlBar.downloadButton.enable();
      } else {
        this.player.controlBar.downloadButton.disable();
      }
    }
    /* TODO */
    // Метод выключает/включает доступность кнопки превью
  }, {
    key: "setPreviewAvailable",
    value: function setPreviewAvailable() {
      var allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (allow) {
        this.player.controlBar.previewButton.enable();
      } else {
        this.player.controlBar.previewButton.disable();
      }
    }
  }, {
    key: "getCustomErrorMessage",
    value: function getCustomErrorMessage() {
      var videoCodec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var i18n = this.props.editor.plugins.i18n;
      var _this$props$attachmen = this.props.attachment,
        attachment = _this$props$attachmen === void 0 ? {} : _this$props$attachmen;
      var nbsp = videoCodec ? '' : ' '; // для того, чтобы не было пробела перед запятой если нет кодека
      var errorMessage = i18n.get('file.video_codec_error').replace("".concat(nbsp, "{codec}"), videoCodec);
      if ((0,browser/* detectBrowser */.Ao)() === 'Safari') {
        if (attachment.mime === 'video/webm') {
          errorMessage = i18n.get('file.safari_webm_not_support');
        }
      }
      return errorMessage;
    }
  }, {
    key: "updateNimbusAdvState",
    value: function updateNimbusAdvState() {
      var ctaState = typeof this.state.cta !== 'undefined' && this.state.cta && Boolean(Object.keys(this.state.cta).length);
      var blot = this.props.blot;
      var inGridCol = blot.getWrapper().parent.constructor.blotName === 'gridCol';
      var advert = this.options && this.options.advert;
      var isShare = blot.editor.options.isShare;
      if (advert && isShare && !inGridCol && !ctaState) {
        this.state.showNimbusAdv = true;
      } else {
        this.state.showNimbusAdv = false;
      }
      this.player.nimbusAdv.options({
        showAdv: this.state.showNimbusAdv
      });
    }
  }, {
    key: "updateFullScreenState",
    value: function updateFullScreenState() {
      if (this.props.fullscreen && !this.player.isFullscreen()) {
        this.player.requestFullscreen();
      } else if (!this.props.fullscreen && this.player.isFullscreen()) {
        this.player.exitFullscreen();
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (isSpaceKey(event) && this.player && this.player.played().length) {
        event.preventDefault();
        event.stopPropagation();
        if (this.player.paused()) {
          this.player.play();
        } else {
          this.player.pause();
        }
        return true;
      }
      return false;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.player.one('loadedmetadata', function () {
        _this2.player.removeClass('vjs-wait-metadata');
      });
      this.player.on('ready', this.onPlayerReady);
      this.player.on('play', this.onPlayerPlay);
      this.player.on('fullscreenchange', this.onPlayerFullscreenChange);
      this.props.editor.on('set-cta', this.updateCtaState);
      this.props.editor.on('video-play', this.onEditorVideoPlay);
      // Кастомные сообщения об ошибках. Плагин: videojs-errors
      // https://github.com/brightcove/videojs-errors
      var extendedType = getExtendedVideoType(this.props.attachment);
      this.player.errors({
        errors: {
          3: {
            // MEDIA_ERR_DECODE
            message: this.getCustomErrorMessage(extendedType.codec)
          },
          4: {
            // MEDIA_ERR_SRC_NOT_SUPPORTED
            message: this.getCustomErrorMessage(extendedType.codec)
          },
          5: {
            // MEDIA_ERR_ENCRYPTED
            message: this.getCustomErrorMessage(extendedType.codec)
          }
        }
      });
      document.addEventListener('keydown', this.onDocumentKeyDown, false);
      this.domNode.addEventListener('mousedown', this.onDomNodeMouseDown, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props5 = this.props,
        attachment = _this$props5.attachment,
        blot = _this$props5.blot;
      if (attachment && this.state.isPlayerReady) {
        var _this$state = this.state,
          muted = _this$state.muted,
          autoplay = _this$state.autoplay,
          loop = _this$state.loop,
          controls = _this$state.controls,
          allowDownload = _this$state.allowDownload;
        var soundDefault = typeof attachment.soundDefault === 'undefined' ? false : attachment.soundDefault;
        if (typeof attachment.autoplay !== 'undefined' && attachment.autoplay !== autoplay) {
          this.state.autoplay = attachment.autoplay;
          this.state.muted = true;
          this.setMuted(this.state.muted);
          this.setAutoplay(this.state.autoplay);
        } else if (muted !== soundDefault) {
          this.state.muted = soundDefault;
          this.setMuted(this.state.muted);
        }
        if (typeof attachment.loop !== 'undefined' && attachment.loop !== loop) {
          this.state.loop = attachment.loop;
          this.setLoop(this.state.loop);
        }
        if (typeof attachment.hideControl !== 'undefined' && !attachment.hideControl !== controls) {
          this.state.controls = !attachment.hideControl;
          this.setControls(this.state.controls);
        }
        if (!blot.disallowDownloading !== allowDownload) {
          this.state.allowDownload = !blot.disallowDownloading;
          this.setDownloadAvailable(this.state.allowDownload);
        }
        if (!this.props.disallowVideoPreview && !lodash_isequal_default()(prevProps.syncedState.videoPreview, this.props.syncedState.videoPreview)) {
          this.updatePreviewState();
        }
        this.updateNimbusAdvState();
        this.updateFullScreenState();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props6 = this.props,
        editor = _this$props6.editor,
        blot = _this$props6.blot;
      editor.getScrollingContainer().removeEventListener('scroll', this.onEditorScroll, false);
      this.props.editor.off('set-cta', this.updateCtaState);
      this.props.editor.off('video-play', this.onEditorVideoPlay);
      if (this.player) {
        this.player.off('ready', this.onPlayerReady);
        this.player.off('play', this.onPlayerPlay);
      }
      blot.props.videoPlayer = null;
      document.removeEventListener('keydown', this.onDocumentKeyDown, false);
      this.domNode.removeEventListener('mousedown', this.onDomNodeMouseDown, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        autoplay = _this$state2.autoplay,
        loop = _this$state2.loop,
        controls = _this$state2.controls,
        showNimbusAdv = _this$state2.showNimbusAdv;
      var _this$props7 = this.props,
        attachment = _this$props7.attachment,
        editor = _this$props7.editor,
        blot = _this$props7.blot,
        isBlotLocked = _this$props7.isBlotLocked;
      var _editor$plugins$attac = editor.plugins.attachmentManager.options,
        onTranscript = _editor$plugins$attac.onTranscript,
        isTranscriptEnabled = _editor$plugins$attac.isTranscriptEnabled;
      var extendedType = getExtendedVideoType(attachment);
      var plugins = {
        downloadButtonPlugin: {
          index: 9,
          attachment: attachment,
          downloadFn: this.onVideoDownload
        },
        callToActionPlugin: video_objectSpread(video_objectSpread({}, this.state.cta), {}, {
          editor: editor
        }),
        nimbusAdvPlugin: {
          showAdv: showNimbusAdv,
          editor: editor,
          blot: blot
        },
        controlShadowPlugin: {
          videoName: attachment.display_name.split('.').slice(0, -1).join('.')
        },
        transcriptButtonPlugin: {
          index: 8,
          attachment: attachment,
          clickFn: onTranscript,
          show: isTranscriptEnabled && attachment.global_id
        }
      };
      var isVideoPreviewEditAvailable = this.props.editor.plugins.videoPreview.isEditAvailable() && editor.mode === editor.constructor.MODE_EDIT && !this.props.disallowVideoPreview;
      var showPreviewButton = !isBlotLocked && isVideoPreviewEditAvailable;
      if (isVideoPreviewEditAvailable) {
        plugins.previewButtonPlugin = {
          index: 9,
          attachment: attachment,
          clickFn: this.onPreviewBtn,
          show: showPreviewButton
        };
        plugins.previewVideoPlugin = {
          previewSettings: this.props.syncedState.videoPreview,
          previewAttach: this.getPreviewAttach
        };
      }
      var props = Object.assign({}, video_defaults, {
        autoplay: autoplay ? 'muted' : video_defaults.autoplay,
        loop: loop,
        controls: controls,
        sources: [{
          src: attachment.url,
          type: extendedType.mime
        }],
        noUITitleAttributes: true,
        plugins: Object.assign({}, video_defaults.plugins, plugins)
      });
      if (this.player) {
        if (isVideoPreviewEditAvailable) {
          if (showPreviewButton) {
            this.player.previewButtonPlugin().show();
          } else {
            this.player.previewButtonPlugin().hide();
          }
        }
      }
      return (0,preact_module.h)(VideoPlayer, video_extends({}, props, {
        onPlayerRef: this.onPlayerRef,
        onDomRef: this.onRef
      }));
    }
  }]);
  return VideoViewer;
}(preact_module/* Component */.wA);

VideoViewer.supportsFullscreen = true;
VideoViewer.FullScreenAction = false;
VideoViewer.viewerName = 'VideoViewer';
var getExtendedVideoType = function getExtendedVideoType() {
  var attachment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prepareMimeForBrowser = function prepareMimeForBrowser(extendedType) {
    if (extendedType.mime === 'video/quicktime' && window.chrome) {
      return {
        mime: 'video/mp4',
        codec: extendedType.codec
      };
    }
    return extendedType;
  };
  var _attachment$extra = attachment.extra,
    extra = _attachment$extra === void 0 ? "{}" : _attachment$extra;
  var _ref4 = typeof extra === 'string' ? JSON.parse(extra) : extra,
    _ref4$mime = _ref4.mime,
    mime = _ref4$mime === void 0 ? null : _ref4$mime,
    _ref4$general = _ref4.general,
    general = _ref4$general === void 0 ? null : _ref4$general,
    _ref4$video = _ref4.video,
    video = _ref4$video === void 0 ? null : _ref4$video;
  var _navigator = navigator,
    appVersion = _navigator.appVersion;
  var isSafari = appVersion.indexOf('Safari') !== -1 && appVersion.indexOf('Chrome') === -1;
  if (mime) {
    var codec = mime.match(/codecs="(.*?)";/);
    return prepareMimeForBrowser({
      mime: attachment.mime || mime,
      codec: codec[1]
    });
  }
  if (general) {
    var format = general.format,
      _general$codec_id_com = general.codec_id_compatible,
      codec_id_compatible = _general$codec_id_com === void 0 ? '' : _general$codec_id_com,
      general_codec_id = general.codec_id;
    format = format.toLowerCase().replace('mpeg-4', 'mp4');
    codec_id_compatible = codec_id_compatible.toLowerCase().replace(/\//g, ',');
    if (video) {
      var codec_id = video.codec_id;
      codec_id = codec_id.toLowerCase().replace('v_vp8', 'vp8').replace('v_vp9', 'vp9').trim();
      return prepareMimeForBrowser({
        mime: "video/".concat(format),
        codec: codec_id.trim()
      });
    }
    if (isSafari && general_codec_id === 'mp42') {
      general_codec_id = 'hvc1';
    }
    return prepareMimeForBrowser({
      mime: "video/".concat(format),
      codec: general_codec_id.trim()
    });
  }
  if (attachment.mime) {
    return prepareMimeForBrowser({
      mime: attachment.mime,
      codec: ''
    });
  }
  return {
    mime: '',
    codec: ''
  };
};
function getVideoTypes() {
  var allTypes = ['video/mpeg', 'video/mp4', 'video/ogg', 'video/quicktime', 'video/webm', 'video/x-ms-wmv', 'video/x-msvideo', 'video/ms-asf', 'video/x-flv', 'video/3gpp', 'video/3gpp2', 'video/x-m4v'];
  var types = [];
  try {
    var video = document.createElement('video');
    for (var i in allTypes) {
      if (video.canPlayType(allTypes[i])) types.push(allTypes[i]);
    }
    if (['Chrome', 'Opera'].includes((0,browser/* detectBrowser */.Ao)()) && types.indexOf('video/quicktime') < 0) {
      types.push('video/quicktime');
    }
    if ((0,browser/* detectBrowser */.Ao)() === 'Safari') {
      types.push('video/webm');
    }
  } catch (ex) {
    console.warn(ex);
  }
  return types;
}
})();

module.exports = __webpack_exports__;
/******/ })()
;